/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(402);
	module.exports = __webpack_require__(735);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js
	//! version : 2.18.1
	//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
	//! license : MIT
	//! momentjs.com
	
	;(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? module.exports = factory() :  true ? !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : global.moment = factory();
	})(undefined, function () {
	    'use strict';
	
	    var hookCallback;
	
	    function hooks() {
	        return hookCallback.apply(null, arguments);
	    }
	
	    // This is done to register the method called with moment()
	    // without creating circular dependencies.
	    function setHookCallback(callback) {
	        hookCallback = callback;
	    }
	
	    function isArray(input) {
	        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
	    }
	
	    function isObject(input) {
	        // IE8 will treat undefined and null as object if it wasn't for
	        // input != null
	        return input != null && Object.prototype.toString.call(input) === '[object Object]';
	    }
	
	    function isObjectEmpty(obj) {
	        var k;
	        for (k in obj) {
	            // even if its not own property I'd still call it non-empty
	            return false;
	        }
	        return true;
	    }
	
	    function isUndefined(input) {
	        return input === void 0;
	    }
	
	    function isNumber(input) {
	        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
	    }
	
	    function isDate(input) {
	        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
	    }
	
	    function map(arr, fn) {
	        var res = [],
	            i;
	        for (i = 0; i < arr.length; ++i) {
	            res.push(fn(arr[i], i));
	        }
	        return res;
	    }
	
	    function hasOwnProp(a, b) {
	        return Object.prototype.hasOwnProperty.call(a, b);
	    }
	
	    function extend(a, b) {
	        for (var i in b) {
	            if (hasOwnProp(b, i)) {
	                a[i] = b[i];
	            }
	        }
	
	        if (hasOwnProp(b, 'toString')) {
	            a.toString = b.toString;
	        }
	
	        if (hasOwnProp(b, 'valueOf')) {
	            a.valueOf = b.valueOf;
	        }
	
	        return a;
	    }
	
	    function createUTC(input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, true).utc();
	    }
	
	    function defaultParsingFlags() {
	        // We need to deep clone this object.
	        return {
	            empty: false,
	            unusedTokens: [],
	            unusedInput: [],
	            overflow: -2,
	            charsLeftOver: 0,
	            nullInput: false,
	            invalidMonth: null,
	            invalidFormat: false,
	            userInvalidated: false,
	            iso: false,
	            parsedDateParts: [],
	            meridiem: null,
	            rfc2822: false,
	            weekdayMismatch: false
	        };
	    }
	
	    function getParsingFlags(m) {
	        if (m._pf == null) {
	            m._pf = defaultParsingFlags();
	        }
	        return m._pf;
	    }
	
	    var some;
	    if (Array.prototype.some) {
	        some = Array.prototype.some;
	    } else {
	        some = function some(fun) {
	            var t = Object(this);
	            var len = t.length >>> 0;
	
	            for (var i = 0; i < len; i++) {
	                if (i in t && fun.call(this, t[i], i, t)) {
	                    return true;
	                }
	            }
	
	            return false;
	        };
	    }
	
	    var some$1 = some;
	
	    function isValid(m) {
	        if (m._isValid == null) {
	            var flags = getParsingFlags(m);
	            var parsedParts = some$1.call(flags.parsedDateParts, function (i) {
	                return i != null;
	            });
	            var isNowValid = !isNaN(m._d.getTime()) && flags.overflow < 0 && !flags.empty && !flags.invalidMonth && !flags.invalidWeekday && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
	
	            if (m._strict) {
	                isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
	            }
	
	            if (Object.isFrozen == null || !Object.isFrozen(m)) {
	                m._isValid = isNowValid;
	            } else {
	                return isNowValid;
	            }
	        }
	        return m._isValid;
	    }
	
	    function createInvalid(flags) {
	        var m = createUTC(NaN);
	        if (flags != null) {
	            extend(getParsingFlags(m), flags);
	        } else {
	            getParsingFlags(m).userInvalidated = true;
	        }
	
	        return m;
	    }
	
	    // Plugins that add properties should also add the key here (null value),
	    // so we can properly clone ourselves.
	    var momentProperties = hooks.momentProperties = [];
	
	    function copyConfig(to, from) {
	        var i, prop, val;
	
	        if (!isUndefined(from._isAMomentObject)) {
	            to._isAMomentObject = from._isAMomentObject;
	        }
	        if (!isUndefined(from._i)) {
	            to._i = from._i;
	        }
	        if (!isUndefined(from._f)) {
	            to._f = from._f;
	        }
	        if (!isUndefined(from._l)) {
	            to._l = from._l;
	        }
	        if (!isUndefined(from._strict)) {
	            to._strict = from._strict;
	        }
	        if (!isUndefined(from._tzm)) {
	            to._tzm = from._tzm;
	        }
	        if (!isUndefined(from._isUTC)) {
	            to._isUTC = from._isUTC;
	        }
	        if (!isUndefined(from._offset)) {
	            to._offset = from._offset;
	        }
	        if (!isUndefined(from._pf)) {
	            to._pf = getParsingFlags(from);
	        }
	        if (!isUndefined(from._locale)) {
	            to._locale = from._locale;
	        }
	
	        if (momentProperties.length > 0) {
	            for (i = 0; i < momentProperties.length; i++) {
	                prop = momentProperties[i];
	                val = from[prop];
	                if (!isUndefined(val)) {
	                    to[prop] = val;
	                }
	            }
	        }
	
	        return to;
	    }
	
	    var updateInProgress = false;
	
	    // Moment prototype object
	    function Moment(config) {
	        copyConfig(this, config);
	        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	        if (!this.isValid()) {
	            this._d = new Date(NaN);
	        }
	        // Prevent infinite loop in case updateOffset creates new moment
	        // objects.
	        if (updateInProgress === false) {
	            updateInProgress = true;
	            hooks.updateOffset(this);
	            updateInProgress = false;
	        }
	    }
	
	    function isMoment(obj) {
	        return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
	    }
	
	    function absFloor(number) {
	        if (number < 0) {
	            // -0 -> 0
	            return Math.ceil(number) || 0;
	        } else {
	            return Math.floor(number);
	        }
	    }
	
	    function toInt(argumentForCoercion) {
	        var coercedNumber = +argumentForCoercion,
	            value = 0;
	
	        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	            value = absFloor(coercedNumber);
	        }
	
	        return value;
	    }
	
	    // compare two arrays, return the number of differences
	    function compareArrays(array1, array2, dontConvert) {
	        var len = Math.min(array1.length, array2.length),
	            lengthDiff = Math.abs(array1.length - array2.length),
	            diffs = 0,
	            i;
	        for (i = 0; i < len; i++) {
	            if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) {
	                diffs++;
	            }
	        }
	        return diffs + lengthDiff;
	    }
	
	    function warn(msg) {
	        if (hooks.suppressDeprecationWarnings === false && typeof console !== 'undefined' && console.warn) {
	            console.warn('Deprecation warning: ' + msg);
	        }
	    }
	
	    function deprecate(msg, fn) {
	        var firstTime = true;
	
	        return extend(function () {
	            if (hooks.deprecationHandler != null) {
	                hooks.deprecationHandler(null, msg);
	            }
	            if (firstTime) {
	                var args = [];
	                var arg;
	                for (var i = 0; i < arguments.length; i++) {
	                    arg = '';
	                    if (_typeof(arguments[i]) === 'object') {
	                        arg += '\n[' + i + '] ';
	                        for (var key in arguments[0]) {
	                            arg += key + ': ' + arguments[0][key] + ', ';
	                        }
	                        arg = arg.slice(0, -2); // Remove trailing comma and space
	                    } else {
	                        arg = arguments[i];
	                    }
	                    args.push(arg);
	                }
	                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + new Error().stack);
	                firstTime = false;
	            }
	            return fn.apply(this, arguments);
	        }, fn);
	    }
	
	    var deprecations = {};
	
	    function deprecateSimple(name, msg) {
	        if (hooks.deprecationHandler != null) {
	            hooks.deprecationHandler(name, msg);
	        }
	        if (!deprecations[name]) {
	            warn(msg);
	            deprecations[name] = true;
	        }
	    }
	
	    hooks.suppressDeprecationWarnings = false;
	    hooks.deprecationHandler = null;
	
	    function isFunction(input) {
	        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	    }
	
	    function set(config) {
	        var prop, i;
	        for (i in config) {
	            prop = config[i];
	            if (isFunction(prop)) {
	                this[i] = prop;
	            } else {
	                this['_' + i] = prop;
	            }
	        }
	        this._config = config;
	        // Lenient ordinal parsing accepts just a number in addition to
	        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + '|' + /\d{1,2}/.source);
	    }
	
	    function mergeConfigs(parentConfig, childConfig) {
	        var res = extend({}, parentConfig),
	            prop;
	        for (prop in childConfig) {
	            if (hasOwnProp(childConfig, prop)) {
	                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                    res[prop] = {};
	                    extend(res[prop], parentConfig[prop]);
	                    extend(res[prop], childConfig[prop]);
	                } else if (childConfig[prop] != null) {
	                    res[prop] = childConfig[prop];
	                } else {
	                    delete res[prop];
	                }
	            }
	        }
	        for (prop in parentConfig) {
	            if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) {
	                // make sure changes to properties don't modify parent config
	                res[prop] = extend({}, res[prop]);
	            }
	        }
	        return res;
	    }
	
	    function Locale(config) {
	        if (config != null) {
	            this.set(config);
	        }
	    }
	
	    var keys;
	
	    if (Object.keys) {
	        keys = Object.keys;
	    } else {
	        keys = function keys(obj) {
	            var i,
	                res = [];
	            for (i in obj) {
	                if (hasOwnProp(obj, i)) {
	                    res.push(i);
	                }
	            }
	            return res;
	        };
	    }
	
	    var keys$1 = keys;
	
	    var defaultCalendar = {
	        sameDay: '[Today at] LT',
	        nextDay: '[Tomorrow at] LT',
	        nextWeek: 'dddd [at] LT',
	        lastDay: '[Yesterday at] LT',
	        lastWeek: '[Last] dddd [at] LT',
	        sameElse: 'L'
	    };
	
	    function calendar(key, mom, now) {
	        var output = this._calendar[key] || this._calendar['sameElse'];
	        return isFunction(output) ? output.call(mom, now) : output;
	    }
	
	    var defaultLongDateFormat = {
	        LTS: 'h:mm:ss A',
	        LT: 'h:mm A',
	        L: 'MM/DD/YYYY',
	        LL: 'MMMM D, YYYY',
	        LLL: 'MMMM D, YYYY h:mm A',
	        LLLL: 'dddd, MMMM D, YYYY h:mm A'
	    };
	
	    function longDateFormat(key) {
	        var format = this._longDateFormat[key],
	            formatUpper = this._longDateFormat[key.toUpperCase()];
	
	        if (format || !formatUpper) {
	            return format;
	        }
	
	        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
	            return val.slice(1);
	        });
	
	        return this._longDateFormat[key];
	    }
	
	    var defaultInvalidDate = 'Invalid date';
	
	    function invalidDate() {
	        return this._invalidDate;
	    }
	
	    var defaultOrdinal = '%d';
	    var defaultDayOfMonthOrdinalParse = /\d{1,2}/;
	
	    function ordinal(number) {
	        return this._ordinal.replace('%d', number);
	    }
	
	    var defaultRelativeTime = {
	        future: 'in %s',
	        past: '%s ago',
	        s: 'a few seconds',
	        ss: '%d seconds',
	        m: 'a minute',
	        mm: '%d minutes',
	        h: 'an hour',
	        hh: '%d hours',
	        d: 'a day',
	        dd: '%d days',
	        M: 'a month',
	        MM: '%d months',
	        y: 'a year',
	        yy: '%d years'
	    };
	
	    function relativeTime(number, withoutSuffix, string, isFuture) {
	        var output = this._relativeTime[string];
	        return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
	    }
	
	    function pastFuture(diff, output) {
	        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	    }
	
	    var aliases = {};
	
	    function addUnitAlias(unit, shorthand) {
	        var lowerCase = unit.toLowerCase();
	        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	    }
	
	    function normalizeUnits(units) {
	        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
	    }
	
	    function normalizeObjectUnits(inputObject) {
	        var normalizedInput = {},
	            normalizedProp,
	            prop;
	
	        for (prop in inputObject) {
	            if (hasOwnProp(inputObject, prop)) {
	                normalizedProp = normalizeUnits(prop);
	                if (normalizedProp) {
	                    normalizedInput[normalizedProp] = inputObject[prop];
	                }
	            }
	        }
	
	        return normalizedInput;
	    }
	
	    var priorities = {};
	
	    function addUnitPriority(unit, priority) {
	        priorities[unit] = priority;
	    }
	
	    function getPrioritizedUnits(unitsObj) {
	        var units = [];
	        for (var u in unitsObj) {
	            units.push({ unit: u, priority: priorities[u] });
	        }
	        units.sort(function (a, b) {
	            return a.priority - b.priority;
	        });
	        return units;
	    }
	
	    function makeGetSet(unit, keepTime) {
	        return function (value) {
	            if (value != null) {
	                set$1(this, unit, value);
	                hooks.updateOffset(this, keepTime);
	                return this;
	            } else {
	                return get(this, unit);
	            }
	        };
	    }
	
	    function get(mom, unit) {
	        return mom.isValid() ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
	    }
	
	    function set$1(mom, unit, value) {
	        if (mom.isValid()) {
	            mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	        }
	    }
	
	    // MOMENTS
	
	    function stringGet(units) {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units]();
	        }
	        return this;
	    }
	
	    function stringSet(units, value) {
	        if ((typeof units === 'undefined' ? 'undefined' : _typeof(units)) === 'object') {
	            units = normalizeObjectUnits(units);
	            var prioritized = getPrioritizedUnits(units);
	            for (var i = 0; i < prioritized.length; i++) {
	                this[prioritized[i].unit](units[prioritized[i].unit]);
	            }
	        } else {
	            units = normalizeUnits(units);
	            if (isFunction(this[units])) {
	                return this[units](value);
	            }
	        }
	        return this;
	    }
	
	    function zeroFill(number, targetLength, forceSign) {
	        var absNumber = '' + Math.abs(number),
	            zerosToFill = targetLength - absNumber.length,
	            sign = number >= 0;
	        return (sign ? forceSign ? '+' : '' : '-') + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
	    }
	
	    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;
	
	    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;
	
	    var formatFunctions = {};
	
	    var formatTokenFunctions = {};
	
	    // token:    'M'
	    // padded:   ['MM', 2]
	    // ordinal:  'Mo'
	    // callback: function () { this.month() + 1 }
	    function addFormatToken(token, padded, ordinal, callback) {
	        var func = callback;
	        if (typeof callback === 'string') {
	            func = function func() {
	                return this[callback]();
	            };
	        }
	        if (token) {
	            formatTokenFunctions[token] = func;
	        }
	        if (padded) {
	            formatTokenFunctions[padded[0]] = function () {
	                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	            };
	        }
	        if (ordinal) {
	            formatTokenFunctions[ordinal] = function () {
	                return this.localeData().ordinal(func.apply(this, arguments), token);
	            };
	        }
	    }
	
	    function removeFormattingTokens(input) {
	        if (input.match(/\[[\s\S]/)) {
	            return input.replace(/^\[|\]$/g, '');
	        }
	        return input.replace(/\\/g, '');
	    }
	
	    function makeFormatFunction(format) {
	        var array = format.match(formattingTokens),
	            i,
	            length;
	
	        for (i = 0, length = array.length; i < length; i++) {
	            if (formatTokenFunctions[array[i]]) {
	                array[i] = formatTokenFunctions[array[i]];
	            } else {
	                array[i] = removeFormattingTokens(array[i]);
	            }
	        }
	
	        return function (mom) {
	            var output = '',
	                i;
	            for (i = 0; i < length; i++) {
	                output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
	            }
	            return output;
	        };
	    }
	
	    // format date using native date object
	    function formatMoment(m, format) {
	        if (!m.isValid()) {
	            return m.localeData().invalidDate();
	        }
	
	        format = expandFormat(format, m.localeData());
	        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
	
	        return formatFunctions[format](m);
	    }
	
	    function expandFormat(format, locale) {
	        var i = 5;
	
	        function replaceLongDateFormatTokens(input) {
	            return locale.longDateFormat(input) || input;
	        }
	
	        localFormattingTokens.lastIndex = 0;
	        while (i >= 0 && localFormattingTokens.test(format)) {
	            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
	            localFormattingTokens.lastIndex = 0;
	            i -= 1;
	        }
	
	        return format;
	    }
	
	    var match1 = /\d/; //       0 - 9
	    var match2 = /\d\d/; //      00 - 99
	    var match3 = /\d{3}/; //     000 - 999
	    var match4 = /\d{4}/; //    0000 - 9999
	    var match6 = /[+-]?\d{6}/; // -999999 - 999999
	    var match1to2 = /\d\d?/; //       0 - 99
	    var match3to4 = /\d\d\d\d?/; //     999 - 9999
	    var match5to6 = /\d\d\d\d\d\d?/; //   99999 - 999999
	    var match1to3 = /\d{1,3}/; //       0 - 999
	    var match1to4 = /\d{1,4}/; //       0 - 9999
	    var match1to6 = /[+-]?\d{1,6}/; // -999999 - 999999
	
	    var matchUnsigned = /\d+/; //       0 - inf
	    var matchSigned = /[+-]?\d+/; //    -inf - inf
	
	    var matchOffset = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
	    var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	
	    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123
	
	    // any word (or two) characters or numbers including two/three word month in arabic.
	    // includes scottish gaelic two word and hyphenated months
	    var matchWord = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF\/]+(\s*?[\u0600-\u06FF]+){1,2}/i;
	
	    var regexes = {};
	
	    function addRegexToken(token, regex, strictRegex) {
	        regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
	            return isStrict && strictRegex ? strictRegex : regex;
	        };
	    }
	
	    function getParseRegexForToken(token, config) {
	        if (!hasOwnProp(regexes, token)) {
	            return new RegExp(unescapeFormat(token));
	        }
	
	        return regexes[token](config._strict, config._locale);
	    }
	
	    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	    function unescapeFormat(s) {
	        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
	            return p1 || p2 || p3 || p4;
	        }));
	    }
	
	    function regexEscape(s) {
	        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	    }
	
	    var tokens = {};
	
	    function addParseToken(token, callback) {
	        var i,
	            func = callback;
	        if (typeof token === 'string') {
	            token = [token];
	        }
	        if (isNumber(callback)) {
	            func = function func(input, array) {
	                array[callback] = toInt(input);
	            };
	        }
	        for (i = 0; i < token.length; i++) {
	            tokens[token[i]] = func;
	        }
	    }
	
	    function addWeekParseToken(token, callback) {
	        addParseToken(token, function (input, array, config, token) {
	            config._w = config._w || {};
	            callback(input, config._w, config, token);
	        });
	    }
	
	    function addTimeToArrayFromToken(token, input, config) {
	        if (input != null && hasOwnProp(tokens, token)) {
	            tokens[token](input, config._a, config, token);
	        }
	    }
	
	    var YEAR = 0;
	    var MONTH = 1;
	    var DATE = 2;
	    var HOUR = 3;
	    var MINUTE = 4;
	    var SECOND = 5;
	    var MILLISECOND = 6;
	    var WEEK = 7;
	    var WEEKDAY = 8;
	
	    var indexOf;
	
	    if (Array.prototype.indexOf) {
	        indexOf = Array.prototype.indexOf;
	    } else {
	        indexOf = function indexOf(o) {
	            // I know
	            var i;
	            for (i = 0; i < this.length; ++i) {
	                if (this[i] === o) {
	                    return i;
	                }
	            }
	            return -1;
	        };
	    }
	
	    var indexOf$1 = indexOf;
	
	    function daysInMonth(year, month) {
	        return new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
	    }
	
	    // FORMATTING
	
	    addFormatToken('M', ['MM', 2], 'Mo', function () {
	        return this.month() + 1;
	    });
	
	    addFormatToken('MMM', 0, 0, function (format) {
	        return this.localeData().monthsShort(this, format);
	    });
	
	    addFormatToken('MMMM', 0, 0, function (format) {
	        return this.localeData().months(this, format);
	    });
	
	    // ALIASES
	
	    addUnitAlias('month', 'M');
	
	    // PRIORITY
	
	    addUnitPriority('month', 8);
	
	    // PARSING
	
	    addRegexToken('M', match1to2);
	    addRegexToken('MM', match1to2, match2);
	    addRegexToken('MMM', function (isStrict, locale) {
	        return locale.monthsShortRegex(isStrict);
	    });
	    addRegexToken('MMMM', function (isStrict, locale) {
	        return locale.monthsRegex(isStrict);
	    });
	
	    addParseToken(['M', 'MM'], function (input, array) {
	        array[MONTH] = toInt(input) - 1;
	    });
	
	    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	        var month = config._locale.monthsParse(input, token, config._strict);
	        // if we didn't find a month name, mark the date as invalid.
	        if (month != null) {
	            array[MONTH] = month;
	        } else {
	            getParsingFlags(config).invalidMonth = input;
	        }
	    });
	
	    // LOCALES
	
	    var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
	    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
	    function localeMonths(m, format) {
	        if (!m) {
	            return isArray(this._months) ? this._months : this._months['standalone'];
	        }
	        return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
	    }
	
	    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
	    function localeMonthsShort(m, format) {
	        if (!m) {
	            return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort['standalone'];
	        }
	        return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
	    }
	
	    function handleStrictParse(monthName, format, strict) {
	        var i,
	            ii,
	            mom,
	            llc = monthName.toLocaleLowerCase();
	        if (!this._monthsParse) {
	            // this is not used
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	            for (i = 0; i < 12; ++i) {
	                mom = createUTC([2000, i]);
	                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
	                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'MMM') {
	                ii = indexOf$1.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf$1.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'MMM') {
	                ii = indexOf$1.call(this._shortMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf$1.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf$1.call(this._longMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf$1.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeMonthsParse(monthName, format, strict) {
	        var i, mom, regex;
	
	        if (this._monthsParseExact) {
	            return handleStrictParse.call(this, monthName, format, strict);
	        }
	
	        if (!this._monthsParse) {
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	        }
	
	        // TODO: add sorting
	        // Sorting makes sure if one month (or abbr) is a prefix of another
	        // see sorting in computeMonthsParse
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            if (strict && !this._longMonthsParse[i]) {
	                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
	                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
	            }
	            if (!strict && !this._monthsParse[i]) {
	                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
	                return i;
	            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
	                return i;
	            } else if (!strict && this._monthsParse[i].test(monthName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function setMonth(mom, value) {
	        var dayOfMonth;
	
	        if (!mom.isValid()) {
	            // No op
	            return mom;
	        }
	
	        if (typeof value === 'string') {
	            if (/^\d+$/.test(value)) {
	                value = toInt(value);
	            } else {
	                value = mom.localeData().monthsParse(value);
	                // TODO: Another silent failure?
	                if (!isNumber(value)) {
	                    return mom;
	                }
	            }
	        }
	
	        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	        return mom;
	    }
	
	    function getSetMonth(value) {
	        if (value != null) {
	            setMonth(this, value);
	            hooks.updateOffset(this, true);
	            return this;
	        } else {
	            return get(this, 'Month');
	        }
	    }
	
	    function getDaysInMonth() {
	        return daysInMonth(this.year(), this.month());
	    }
	
	    var defaultMonthsShortRegex = matchWord;
	    function monthsShortRegex(isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsShortStrictRegex;
	            } else {
	                return this._monthsShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsShortRegex')) {
	                this._monthsShortRegex = defaultMonthsShortRegex;
	            }
	            return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
	        }
	    }
	
	    var defaultMonthsRegex = matchWord;
	    function monthsRegex(isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsStrictRegex;
	            } else {
	                return this._monthsRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                this._monthsRegex = defaultMonthsRegex;
	            }
	            return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
	        }
	    }
	
	    function computeMonthsParse() {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var shortPieces = [],
	            longPieces = [],
	            mixedPieces = [],
	            i,
	            mom;
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            shortPieces.push(this.monthsShort(mom, ''));
	            longPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.monthsShort(mom, ''));
	        }
	        // Sorting makes sure if one month (or abbr) is a prefix of another it
	        // will match the longer piece.
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 12; i++) {
	            shortPieces[i] = regexEscape(shortPieces[i]);
	            longPieces[i] = regexEscape(longPieces[i]);
	        }
	        for (i = 0; i < 24; i++) {
	            mixedPieces[i] = regexEscape(mixedPieces[i]);
	        }
	
	        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._monthsShortRegex = this._monthsRegex;
	        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	    }
	
	    // FORMATTING
	
	    addFormatToken('Y', 0, 0, function () {
	        var y = this.year();
	        return y <= 9999 ? '' + y : '+' + y;
	    });
	
	    addFormatToken(0, ['YY', 2], 0, function () {
	        return this.year() % 100;
	    });
	
	    addFormatToken(0, ['YYYY', 4], 0, 'year');
	    addFormatToken(0, ['YYYYY', 5], 0, 'year');
	    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	    // ALIASES
	
	    addUnitAlias('year', 'y');
	
	    // PRIORITIES
	
	    addUnitPriority('year', 1);
	
	    // PARSING
	
	    addRegexToken('Y', matchSigned);
	    addRegexToken('YY', match1to2, match2);
	    addRegexToken('YYYY', match1to4, match4);
	    addRegexToken('YYYYY', match1to6, match6);
	    addRegexToken('YYYYYY', match1to6, match6);
	
	    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	    addParseToken('YYYY', function (input, array) {
	        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
	    });
	    addParseToken('YY', function (input, array) {
	        array[YEAR] = hooks.parseTwoDigitYear(input);
	    });
	    addParseToken('Y', function (input, array) {
	        array[YEAR] = parseInt(input, 10);
	    });
	
	    // HELPERS
	
	    function daysInYear(year) {
	        return isLeapYear(year) ? 366 : 365;
	    }
	
	    function isLeapYear(year) {
	        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
	    }
	
	    // HOOKS
	
	    hooks.parseTwoDigitYear = function (input) {
	        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	    };
	
	    // MOMENTS
	
	    var getSetYear = makeGetSet('FullYear', true);
	
	    function getIsLeapYear() {
	        return isLeapYear(this.year());
	    }
	
	    function createDate(y, m, d, h, M, s, ms) {
	        // can't just apply() to create a date:
	        // https://stackoverflow.com/q/181348
	        var date = new Date(y, m, d, h, M, s, ms);
	
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
	            date.setFullYear(y);
	        }
	        return date;
	    }
	
	    function createUTCDate(y) {
	        var date = new Date(Date.UTC.apply(null, arguments));
	
	        // the Date.UTC function remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
	            date.setUTCFullYear(y);
	        }
	        return date;
	    }
	
	    // start-of-first-week - start-of-year
	    function firstWeekOffset(year, dow, doy) {
	        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	        fwd = 7 + dow - doy,
	
	        // first-week day local weekday -- which local weekday is fwd
	        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	        return -fwdlw + fwd - 1;
	    }
	
	    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	        var localWeekday = (7 + weekday - dow) % 7,
	            weekOffset = firstWeekOffset(year, dow, doy),
	            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	            resYear,
	            resDayOfYear;
	
	        if (dayOfYear <= 0) {
	            resYear = year - 1;
	            resDayOfYear = daysInYear(resYear) + dayOfYear;
	        } else if (dayOfYear > daysInYear(year)) {
	            resYear = year + 1;
	            resDayOfYear = dayOfYear - daysInYear(year);
	        } else {
	            resYear = year;
	            resDayOfYear = dayOfYear;
	        }
	
	        return {
	            year: resYear,
	            dayOfYear: resDayOfYear
	        };
	    }
	
	    function weekOfYear(mom, dow, doy) {
	        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	            resWeek,
	            resYear;
	
	        if (week < 1) {
	            resYear = mom.year() - 1;
	            resWeek = week + weeksInYear(resYear, dow, doy);
	        } else if (week > weeksInYear(mom.year(), dow, doy)) {
	            resWeek = week - weeksInYear(mom.year(), dow, doy);
	            resYear = mom.year() + 1;
	        } else {
	            resYear = mom.year();
	            resWeek = week;
	        }
	
	        return {
	            week: resWeek,
	            year: resYear
	        };
	    }
	
	    function weeksInYear(year, dow, doy) {
	        var weekOffset = firstWeekOffset(year, dow, doy),
	            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	    }
	
	    // FORMATTING
	
	    addFormatToken('w', ['ww', 2], 'wo', 'week');
	    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	    // ALIASES
	
	    addUnitAlias('week', 'w');
	    addUnitAlias('isoWeek', 'W');
	
	    // PRIORITIES
	
	    addUnitPriority('week', 5);
	    addUnitPriority('isoWeek', 5);
	
	    // PARSING
	
	    addRegexToken('w', match1to2);
	    addRegexToken('ww', match1to2, match2);
	    addRegexToken('W', match1to2);
	    addRegexToken('WW', match1to2, match2);
	
	    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
	        week[token.substr(0, 1)] = toInt(input);
	    });
	
	    // HELPERS
	
	    // LOCALES
	
	    function localeWeek(mom) {
	        return weekOfYear(mom, this._week.dow, this._week.doy).week;
	    }
	
	    var defaultLocaleWeek = {
	        dow: 0, // Sunday is the first day of the week.
	        doy: 6 // The week that contains Jan 1st is the first week of the year.
	    };
	
	    function localeFirstDayOfWeek() {
	        return this._week.dow;
	    }
	
	    function localeFirstDayOfYear() {
	        return this._week.doy;
	    }
	
	    // MOMENTS
	
	    function getSetWeek(input) {
	        var week = this.localeData().week(this);
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    function getSetISOWeek(input) {
	        var week = weekOfYear(this, 1, 4).week;
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('d', 0, 'do', 'day');
	
	    addFormatToken('dd', 0, 0, function (format) {
	        return this.localeData().weekdaysMin(this, format);
	    });
	
	    addFormatToken('ddd', 0, 0, function (format) {
	        return this.localeData().weekdaysShort(this, format);
	    });
	
	    addFormatToken('dddd', 0, 0, function (format) {
	        return this.localeData().weekdays(this, format);
	    });
	
	    addFormatToken('e', 0, 0, 'weekday');
	    addFormatToken('E', 0, 0, 'isoWeekday');
	
	    // ALIASES
	
	    addUnitAlias('day', 'd');
	    addUnitAlias('weekday', 'e');
	    addUnitAlias('isoWeekday', 'E');
	
	    // PRIORITY
	    addUnitPriority('day', 11);
	    addUnitPriority('weekday', 11);
	    addUnitPriority('isoWeekday', 11);
	
	    // PARSING
	
	    addRegexToken('d', match1to2);
	    addRegexToken('e', match1to2);
	    addRegexToken('E', match1to2);
	    addRegexToken('dd', function (isStrict, locale) {
	        return locale.weekdaysMinRegex(isStrict);
	    });
	    addRegexToken('ddd', function (isStrict, locale) {
	        return locale.weekdaysShortRegex(isStrict);
	    });
	    addRegexToken('dddd', function (isStrict, locale) {
	        return locale.weekdaysRegex(isStrict);
	    });
	
	    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	        var weekday = config._locale.weekdaysParse(input, token, config._strict);
	        // if we didn't get a weekday name, mark the date as invalid
	        if (weekday != null) {
	            week.d = weekday;
	        } else {
	            getParsingFlags(config).invalidWeekday = input;
	        }
	    });
	
	    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	        week[token] = toInt(input);
	    });
	
	    // HELPERS
	
	    function parseWeekday(input, locale) {
	        if (typeof input !== 'string') {
	            return input;
	        }
	
	        if (!isNaN(input)) {
	            return parseInt(input, 10);
	        }
	
	        input = locale.weekdaysParse(input);
	        if (typeof input === 'number') {
	            return input;
	        }
	
	        return null;
	    }
	
	    function parseIsoWeekday(input, locale) {
	        if (typeof input === 'string') {
	            return locale.weekdaysParse(input) % 7 || 7;
	        }
	        return isNaN(input) ? null : input;
	    }
	
	    // LOCALES
	
	    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
	    function localeWeekdays(m, format) {
	        if (!m) {
	            return isArray(this._weekdays) ? this._weekdays : this._weekdays['standalone'];
	        }
	        return isArray(this._weekdays) ? this._weekdays[m.day()] : this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
	    }
	
	    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
	    function localeWeekdaysShort(m) {
	        return m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
	    }
	
	    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
	    function localeWeekdaysMin(m) {
	        return m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
	    }
	
	    function handleStrictParse$1(weekdayName, format, strict) {
	        var i,
	            ii,
	            mom,
	            llc = weekdayName.toLocaleLowerCase();
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._minWeekdaysParse = [];
	
	            for (i = 0; i < 7; ++i) {
	                mom = createUTC([2000, 1]).day(i);
	                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
	                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
	                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'dddd') {
	                ii = indexOf$1.call(this._weekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf$1.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf$1.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'dddd') {
	                ii = indexOf$1.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf$1.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf$1.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf$1.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf$1.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf$1.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf$1.call(this._minWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf$1.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf$1.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeWeekdaysParse(weekdayName, format, strict) {
	        var i, mom, regex;
	
	        if (this._weekdaysParseExact) {
	            return handleStrictParse$1.call(this, weekdayName, format, strict);
	        }
	
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._minWeekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._fullWeekdaysParse = [];
	        }
	
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	
	            mom = createUTC([2000, 1]).day(i);
	            if (strict && !this._fullWeekdaysParse[i]) {
	                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\.?') + '$', 'i');
	                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\.?') + '$', 'i');
	                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\.?') + '$', 'i');
	            }
	            if (!this._weekdaysParse[i]) {
	                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
	                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function getSetDayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	        if (input != null) {
	            input = parseWeekday(input, this.localeData());
	            return this.add(input - day, 'd');
	        } else {
	            return day;
	        }
	    }
	
	    function getSetLocaleDayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	        return input == null ? weekday : this.add(input - weekday, 'd');
	    }
	
	    function getSetISODayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	
	        // behaves the same as moment#day except
	        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	        // as a setter, sunday should belong to the previous week.
	
	        if (input != null) {
	            var weekday = parseIsoWeekday(input, this.localeData());
	            return this.day(this.day() % 7 ? weekday : weekday - 7);
	        } else {
	            return this.day() || 7;
	        }
	    }
	
	    var defaultWeekdaysRegex = matchWord;
	    function weekdaysRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysStrictRegex;
	            } else {
	                return this._weekdaysRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                this._weekdaysRegex = defaultWeekdaysRegex;
	            }
	            return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
	        }
	    }
	
	    var defaultWeekdaysShortRegex = matchWord;
	    function weekdaysShortRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysShortStrictRegex;
	            } else {
	                return this._weekdaysShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	            }
	            return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
	        }
	    }
	
	    var defaultWeekdaysMinRegex = matchWord;
	    function weekdaysMinRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysMinStrictRegex;
	            } else {
	                return this._weekdaysMinRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	            }
	            return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
	        }
	    }
	
	    function computeWeekdaysParse() {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var minPieces = [],
	            shortPieces = [],
	            longPieces = [],
	            mixedPieces = [],
	            i,
	            mom,
	            minp,
	            shortp,
	            longp;
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, 1]).day(i);
	            minp = this.weekdaysMin(mom, '');
	            shortp = this.weekdaysShort(mom, '');
	            longp = this.weekdays(mom, '');
	            minPieces.push(minp);
	            shortPieces.push(shortp);
	            longPieces.push(longp);
	            mixedPieces.push(minp);
	            mixedPieces.push(shortp);
	            mixedPieces.push(longp);
	        }
	        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	        // will match the longer piece.
	        minPieces.sort(cmpLenRev);
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 7; i++) {
	            shortPieces[i] = regexEscape(shortPieces[i]);
	            longPieces[i] = regexEscape(longPieces[i]);
	            mixedPieces[i] = regexEscape(mixedPieces[i]);
	        }
	
	        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._weekdaysShortRegex = this._weekdaysRegex;
	        this._weekdaysMinRegex = this._weekdaysRegex;
	
	        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
	    }
	
	    // FORMATTING
	
	    function hFormat() {
	        return this.hours() % 12 || 12;
	    }
	
	    function kFormat() {
	        return this.hours() || 24;
	    }
	
	    addFormatToken('H', ['HH', 2], 0, 'hour');
	    addFormatToken('h', ['hh', 2], 0, hFormat);
	    addFormatToken('k', ['kk', 2], 0, kFormat);
	
	    addFormatToken('hmm', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('hmmss', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
	    });
	
	    addFormatToken('Hmm', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('Hmmss', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
	    });
	
	    function meridiem(token, lowercase) {
	        addFormatToken(token, 0, 0, function () {
	            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
	        });
	    }
	
	    meridiem('a', true);
	    meridiem('A', false);
	
	    // ALIASES
	
	    addUnitAlias('hour', 'h');
	
	    // PRIORITY
	    addUnitPriority('hour', 13);
	
	    // PARSING
	
	    function matchMeridiem(isStrict, locale) {
	        return locale._meridiemParse;
	    }
	
	    addRegexToken('a', matchMeridiem);
	    addRegexToken('A', matchMeridiem);
	    addRegexToken('H', match1to2);
	    addRegexToken('h', match1to2);
	    addRegexToken('k', match1to2);
	    addRegexToken('HH', match1to2, match2);
	    addRegexToken('hh', match1to2, match2);
	    addRegexToken('kk', match1to2, match2);
	
	    addRegexToken('hmm', match3to4);
	    addRegexToken('hmmss', match5to6);
	    addRegexToken('Hmm', match3to4);
	    addRegexToken('Hmmss', match5to6);
	
	    addParseToken(['H', 'HH'], HOUR);
	    addParseToken(['k', 'kk'], function (input, array, config) {
	        var kInput = toInt(input);
	        array[HOUR] = kInput === 24 ? 0 : kInput;
	    });
	    addParseToken(['a', 'A'], function (input, array, config) {
	        config._isPm = config._locale.isPM(input);
	        config._meridiem = input;
	    });
	    addParseToken(['h', 'hh'], function (input, array, config) {
	        array[HOUR] = toInt(input);
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmmss', function (input, array, config) {
	        var pos1 = input.length - 4;
	        var pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('Hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	    });
	    addParseToken('Hmmss', function (input, array, config) {
	        var pos1 = input.length - 4;
	        var pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	    });
	
	    // LOCALES
	
	    function localeIsPM(input) {
	        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	        // Using charAt should be more compatible.
	        return (input + '').toLowerCase().charAt(0) === 'p';
	    }
	
	    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
	    function localeMeridiem(hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'pm' : 'PM';
	        } else {
	            return isLower ? 'am' : 'AM';
	        }
	    }
	
	    // MOMENTS
	
	    // Setting the hour should keep the time, because the user explicitly
	    // specified which hour he wants. So trying to maintain the same hour (in
	    // a new timezone) makes sense. Adding/subtracting hours does not follow
	    // this rule.
	    var getSetHour = makeGetSet('Hours', true);
	
	    // months
	    // week
	    // weekdays
	    // meridiem
	    var baseConfig = {
	        calendar: defaultCalendar,
	        longDateFormat: defaultLongDateFormat,
	        invalidDate: defaultInvalidDate,
	        ordinal: defaultOrdinal,
	        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
	        relativeTime: defaultRelativeTime,
	
	        months: defaultLocaleMonths,
	        monthsShort: defaultLocaleMonthsShort,
	
	        week: defaultLocaleWeek,
	
	        weekdays: defaultLocaleWeekdays,
	        weekdaysMin: defaultLocaleWeekdaysMin,
	        weekdaysShort: defaultLocaleWeekdaysShort,
	
	        meridiemParse: defaultLocaleMeridiemParse
	    };
	
	    // internal storage for locale config files
	    var locales = {};
	    var localeFamilies = {};
	    var globalLocale;
	
	    function normalizeLocale(key) {
	        return key ? key.toLowerCase().replace('_', '-') : key;
	    }
	
	    // pick the locale from the array
	    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	    function chooseLocale(names) {
	        var i = 0,
	            j,
	            next,
	            locale,
	            split;
	
	        while (i < names.length) {
	            split = normalizeLocale(names[i]).split('-');
	            j = split.length;
	            next = normalizeLocale(names[i + 1]);
	            next = next ? next.split('-') : null;
	            while (j > 0) {
	                locale = loadLocale(split.slice(0, j).join('-'));
	                if (locale) {
	                    return locale;
	                }
	                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
	                    //the next array item is better than a shallower substring of this one
	                    break;
	                }
	                j--;
	            }
	            i++;
	        }
	        return null;
	    }
	
	    function loadLocale(name) {
	        var oldLocale = null;
	        // TODO: Find a better way to register and load all the locales in Node
	        if (!locales[name] && typeof module !== 'undefined' && module && module.exports) {
	            try {
	                oldLocale = globalLocale._abbr;
	                __webpack_require__(1004)("./" + name);
	                // because defineLocale currently also sets the global locale, we
	                // want to undo that for lazy loaded locales
	                getSetGlobalLocale(oldLocale);
	            } catch (e) {}
	        }
	        return locales[name];
	    }
	
	    // This function will load locale and then set the global locale.  If
	    // no arguments are passed in, it will simply return the current global
	    // locale key.
	    function getSetGlobalLocale(key, values) {
	        var data;
	        if (key) {
	            if (isUndefined(values)) {
	                data = getLocale(key);
	            } else {
	                data = defineLocale(key, values);
	            }
	
	            if (data) {
	                // moment.duration._locale = moment._locale = data;
	                globalLocale = data;
	            }
	        }
	
	        return globalLocale._abbr;
	    }
	
	    function defineLocale(name, config) {
	        if (config !== null) {
	            var parentConfig = baseConfig;
	            config.abbr = name;
	            if (locales[name] != null) {
	                deprecateSimple('defineLocaleOverride', 'use moment.updateLocale(localeName, config) to change ' + 'an existing locale. moment.defineLocale(localeName, ' + 'config) should only be used for creating a new locale ' + 'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
	                parentConfig = locales[name]._config;
	            } else if (config.parentLocale != null) {
	                if (locales[config.parentLocale] != null) {
	                    parentConfig = locales[config.parentLocale]._config;
	                } else {
	                    if (!localeFamilies[config.parentLocale]) {
	                        localeFamilies[config.parentLocale] = [];
	                    }
	                    localeFamilies[config.parentLocale].push({
	                        name: name,
	                        config: config
	                    });
	                    return null;
	                }
	            }
	            locales[name] = new Locale(mergeConfigs(parentConfig, config));
	
	            if (localeFamilies[name]) {
	                localeFamilies[name].forEach(function (x) {
	                    defineLocale(x.name, x.config);
	                });
	            }
	
	            // backwards compat for now: also set the locale
	            // make sure we set the locale AFTER all child locales have been
	            // created, so we won't end up with the child locale set.
	            getSetGlobalLocale(name);
	
	            return locales[name];
	        } else {
	            // useful for testing
	            delete locales[name];
	            return null;
	        }
	    }
	
	    function updateLocale(name, config) {
	        if (config != null) {
	            var locale,
	                parentConfig = baseConfig;
	            // MERGE
	            if (locales[name] != null) {
	                parentConfig = locales[name]._config;
	            }
	            config = mergeConfigs(parentConfig, config);
	            locale = new Locale(config);
	            locale.parentLocale = locales[name];
	            locales[name] = locale;
	
	            // backwards compat for now: also set the locale
	            getSetGlobalLocale(name);
	        } else {
	            // pass null for config to unupdate, useful for tests
	            if (locales[name] != null) {
	                if (locales[name].parentLocale != null) {
	                    locales[name] = locales[name].parentLocale;
	                } else if (locales[name] != null) {
	                    delete locales[name];
	                }
	            }
	        }
	        return locales[name];
	    }
	
	    // returns locale data
	    function getLocale(key) {
	        var locale;
	
	        if (key && key._locale && key._locale._abbr) {
	            key = key._locale._abbr;
	        }
	
	        if (!key) {
	            return globalLocale;
	        }
	
	        if (!isArray(key)) {
	            //short-circuit everything else
	            locale = loadLocale(key);
	            if (locale) {
	                return locale;
	            }
	            key = [key];
	        }
	
	        return chooseLocale(key);
	    }
	
	    function listLocales() {
	        return keys$1(locales);
	    }
	
	    function checkOverflow(m) {
	        var overflow;
	        var a = m._a;
	
	        if (a && getParsingFlags(m).overflow === -2) {
	            overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
	
	            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
	                overflow = DATE;
	            }
	            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	                overflow = WEEK;
	            }
	            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	                overflow = WEEKDAY;
	            }
	
	            getParsingFlags(m).overflow = overflow;
	        }
	
	        return m;
	    }
	
	    // iso 8601 regex
	    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	    var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	
	    var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;
	
	    var isoDates = [['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/], ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/], ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/], ['GGGG-[W]WW', /\d{4}-W\d\d/, false], ['YYYY-DDD', /\d{4}-\d{3}/], ['YYYY-MM', /\d{4}-\d\d/, false], ['YYYYYYMMDD', /[+-]\d{10}/], ['YYYYMMDD', /\d{8}/],
	    // YYYYMM is NOT allowed by the standard
	    ['GGGG[W]WWE', /\d{4}W\d{3}/], ['GGGG[W]WW', /\d{4}W\d{2}/, false], ['YYYYDDD', /\d{7}/]];
	
	    // iso time formats and regexes
	    var isoTimes = [['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/], ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/], ['HH:mm:ss', /\d\d:\d\d:\d\d/], ['HH:mm', /\d\d:\d\d/], ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/], ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/], ['HHmmss', /\d\d\d\d\d\d/], ['HHmm', /\d\d\d\d/], ['HH', /\d\d/]];
	
	    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;
	
	    // date from iso format
	    function configFromISO(config) {
	        var i,
	            l,
	            string = config._i,
	            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	            allowTime,
	            dateFormat,
	            timeFormat,
	            tzFormat;
	
	        if (match) {
	            getParsingFlags(config).iso = true;
	
	            for (i = 0, l = isoDates.length; i < l; i++) {
	                if (isoDates[i][1].exec(match[1])) {
	                    dateFormat = isoDates[i][0];
	                    allowTime = isoDates[i][2] !== false;
	                    break;
	                }
	            }
	            if (dateFormat == null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[3]) {
	                for (i = 0, l = isoTimes.length; i < l; i++) {
	                    if (isoTimes[i][1].exec(match[3])) {
	                        // match[2] should be 'T' or space
	                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                        break;
	                    }
	                }
	                if (timeFormat == null) {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            if (!allowTime && timeFormat != null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[4]) {
	                if (tzRegex.exec(match[4])) {
	                    tzFormat = 'Z';
	                } else {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	            configFromStringAndFormat(config);
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
	    var basicRfcRegex = /^((?:Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d?\d\s(?:Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(?:\d\d)?\d\d\s)(\d\d:\d\d)(\:\d\d)?(\s(?:UT|GMT|[ECMP][SD]T|[A-IK-Za-ik-z]|[+-]\d{4}))$/;
	
	    // date and time from ref 2822 format
	    function configFromRFC2822(config) {
	        var string, match, dayFormat, dateFormat, timeFormat, tzFormat;
	        var timezones = {
	            ' GMT': ' +0000',
	            ' EDT': ' -0400',
	            ' EST': ' -0500',
	            ' CDT': ' -0500',
	            ' CST': ' -0600',
	            ' MDT': ' -0600',
	            ' MST': ' -0700',
	            ' PDT': ' -0700',
	            ' PST': ' -0800'
	        };
	        var military = 'YXWVUTSRQPONZABCDEFGHIKLM';
	        var timezone, timezoneIndex;
	
	        string = config._i.replace(/\([^\)]*\)|[\n\t]/g, ' ') // Remove comments and folding whitespace
	        .replace(/(\s\s+)/g, ' ') // Replace multiple-spaces with a single space
	        .replace(/^\s|\s$/g, ''); // Remove leading and trailing spaces
	        match = basicRfcRegex.exec(string);
	
	        if (match) {
	            dayFormat = match[1] ? 'ddd' + (match[1].length === 5 ? ', ' : ' ') : '';
	            dateFormat = 'D MMM ' + (match[2].length > 10 ? 'YYYY ' : 'YY ');
	            timeFormat = 'HH:mm' + (match[4] ? ':ss' : '');
	
	            // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
	            if (match[1]) {
	                // day of week given
	                var momentDate = new Date(match[2]);
	                var momentDay = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'][momentDate.getDay()];
	
	                if (match[1].substr(0, 3) !== momentDay) {
	                    getParsingFlags(config).weekdayMismatch = true;
	                    config._isValid = false;
	                    return;
	                }
	            }
	
	            switch (match[5].length) {
	                case 2:
	                    // military
	                    if (timezoneIndex === 0) {
	                        timezone = ' +0000';
	                    } else {
	                        timezoneIndex = military.indexOf(match[5][1].toUpperCase()) - 12;
	                        timezone = (timezoneIndex < 0 ? ' -' : ' +') + ('' + timezoneIndex).replace(/^-?/, '0').match(/..$/)[0] + '00';
	                    }
	                    break;
	                case 4:
	                    // Zone
	                    timezone = timezones[match[5]];
	                    break;
	                default:
	                    // UT or +/-9999
	                    timezone = timezones[' GMT'];
	            }
	            match[5] = timezone;
	            config._i = match.splice(1).join('');
	            tzFormat = ' ZZ';
	            config._f = dayFormat + dateFormat + timeFormat + tzFormat;
	            configFromStringAndFormat(config);
	            getParsingFlags(config).rfc2822 = true;
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // date from iso format or fallback
	    function configFromString(config) {
	        var matched = aspNetJsonRegex.exec(config._i);
	
	        if (matched !== null) {
	            config._d = new Date(+matched[1]);
	            return;
	        }
	
	        configFromISO(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        configFromRFC2822(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        // Final attempt, use Input Fallback
	        hooks.createFromInputFallback(config);
	    }
	
	    hooks.createFromInputFallback = deprecate('value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' + 'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' + 'discouraged and will be removed in an upcoming major release. Please refer to ' + 'http://momentjs.com/guides/#/warnings/js-date/ for more info.', function (config) {
	        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	    });
	
	    // Pick the first defined of two or three arguments.
	    function defaults(a, b, c) {
	        if (a != null) {
	            return a;
	        }
	        if (b != null) {
	            return b;
	        }
	        return c;
	    }
	
	    function currentDateArray(config) {
	        // hooks is actually the exported moment object
	        var nowValue = new Date(hooks.now());
	        if (config._useUTC) {
	            return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
	        }
	        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	    }
	
	    // convert an array to a date.
	    // the array should mirror the parameters below
	    // note: all values past the year are optional and will default to the lowest possible value.
	    // [year, month, day , hour, minute, second, millisecond]
	    function configFromArray(config) {
	        var i,
	            date,
	            input = [],
	            currentDate,
	            yearToUse;
	
	        if (config._d) {
	            return;
	        }
	
	        currentDate = currentDateArray(config);
	
	        //compute day of the year from weeks and weekdays
	        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	            dayOfYearFromWeekInfo(config);
	        }
	
	        //if the day of the year is set, figure out what it is
	        if (config._dayOfYear != null) {
	            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
	                getParsingFlags(config)._overflowDayOfYear = true;
	            }
	
	            date = createUTCDate(yearToUse, 0, config._dayOfYear);
	            config._a[MONTH] = date.getUTCMonth();
	            config._a[DATE] = date.getUTCDate();
	        }
	
	        // Default to current date.
	        // * if no year, month, day of month are given, default to today
	        // * if day of month is given, default month and year
	        // * if month is given, default only year
	        // * if year is given, don't default anything
	        for (i = 0; i < 3 && config._a[i] == null; ++i) {
	            config._a[i] = input[i] = currentDate[i];
	        }
	
	        // Zero out whatever was not defaulted, including time
	        for (; i < 7; i++) {
	            config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
	        }
	
	        // Check for 24:00:00.000
	        if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
	            config._nextDay = true;
	            config._a[HOUR] = 0;
	        }
	
	        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
	        // Apply timezone offset from input. The actual utcOffset can be changed
	        // with parseZone.
	        if (config._tzm != null) {
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	        }
	
	        if (config._nextDay) {
	            config._a[HOUR] = 24;
	        }
	    }
	
	    function dayOfYearFromWeekInfo(config) {
	        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;
	
	        w = config._w;
	        if (w.GG != null || w.W != null || w.E != null) {
	            dow = 1;
	            doy = 4;
	
	            // TODO: We need to take the current isoWeekYear, but that depends on
	            // how we interpret now (local, utc, fixed offset). So create
	            // a now version of current config (take local/utc/offset flags, and
	            // create now).
	            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
	            week = defaults(w.W, 1);
	            weekday = defaults(w.E, 1);
	            if (weekday < 1 || weekday > 7) {
	                weekdayOverflow = true;
	            }
	        } else {
	            dow = config._locale._week.dow;
	            doy = config._locale._week.doy;
	
	            var curWeek = weekOfYear(createLocal(), dow, doy);
	
	            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
	
	            // Default to current week.
	            week = defaults(w.w, curWeek.week);
	
	            if (w.d != null) {
	                // weekday -- low day numbers are considered next week
	                weekday = w.d;
	                if (weekday < 0 || weekday > 6) {
	                    weekdayOverflow = true;
	                }
	            } else if (w.e != null) {
	                // local weekday -- counting starts from begining of week
	                weekday = w.e + dow;
	                if (w.e < 0 || w.e > 6) {
	                    weekdayOverflow = true;
	                }
	            } else {
	                // default to begining of week
	                weekday = dow;
	            }
	        }
	        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	            getParsingFlags(config)._overflowWeeks = true;
	        } else if (weekdayOverflow != null) {
	            getParsingFlags(config)._overflowWeekday = true;
	        } else {
	            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	            config._a[YEAR] = temp.year;
	            config._dayOfYear = temp.dayOfYear;
	        }
	    }
	
	    // constant that refers to the ISO standard
	    hooks.ISO_8601 = function () {};
	
	    // constant that refers to the RFC 2822 form
	    hooks.RFC_2822 = function () {};
	
	    // date from string and format string
	    function configFromStringAndFormat(config) {
	        // TODO: Move this to another part of the creation flow to prevent circular deps
	        if (config._f === hooks.ISO_8601) {
	            configFromISO(config);
	            return;
	        }
	        if (config._f === hooks.RFC_2822) {
	            configFromRFC2822(config);
	            return;
	        }
	        config._a = [];
	        getParsingFlags(config).empty = true;
	
	        // This array is used to make a Date, either with `new Date` or `Date.UTC`
	        var string = '' + config._i,
	            i,
	            parsedInput,
	            tokens,
	            token,
	            skipped,
	            stringLength = string.length,
	            totalParsedInputLength = 0;
	
	        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
	
	        for (i = 0; i < tokens.length; i++) {
	            token = tokens[i];
	            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
	            // console.log('token', token, 'parsedInput', parsedInput,
	            //         'regex', getParseRegexForToken(token, config));
	            if (parsedInput) {
	                skipped = string.substr(0, string.indexOf(parsedInput));
	                if (skipped.length > 0) {
	                    getParsingFlags(config).unusedInput.push(skipped);
	                }
	                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
	                totalParsedInputLength += parsedInput.length;
	            }
	            // don't parse if it's not a known token
	            if (formatTokenFunctions[token]) {
	                if (parsedInput) {
	                    getParsingFlags(config).empty = false;
	                } else {
	                    getParsingFlags(config).unusedTokens.push(token);
	                }
	                addTimeToArrayFromToken(token, parsedInput, config);
	            } else if (config._strict && !parsedInput) {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	        }
	
	        // add remaining unparsed input length to the string
	        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
	        if (string.length > 0) {
	            getParsingFlags(config).unusedInput.push(string);
	        }
	
	        // clear _12h flag if hour is <= 12
	        if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) {
	            getParsingFlags(config).bigHour = undefined;
	        }
	
	        getParsingFlags(config).parsedDateParts = config._a.slice(0);
	        getParsingFlags(config).meridiem = config._meridiem;
	        // handle meridiem
	        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
	
	        configFromArray(config);
	        checkOverflow(config);
	    }
	
	    function meridiemFixWrap(locale, hour, meridiem) {
	        var isPm;
	
	        if (meridiem == null) {
	            // nothing to do
	            return hour;
	        }
	        if (locale.meridiemHour != null) {
	            return locale.meridiemHour(hour, meridiem);
	        } else if (locale.isPM != null) {
	            // Fallback
	            isPm = locale.isPM(meridiem);
	            if (isPm && hour < 12) {
	                hour += 12;
	            }
	            if (!isPm && hour === 12) {
	                hour = 0;
	            }
	            return hour;
	        } else {
	            // this is not supposed to happen
	            return hour;
	        }
	    }
	
	    // date from string and array of format strings
	    function configFromStringAndArray(config) {
	        var tempConfig, bestMoment, scoreToBeat, i, currentScore;
	
	        if (config._f.length === 0) {
	            getParsingFlags(config).invalidFormat = true;
	            config._d = new Date(NaN);
	            return;
	        }
	
	        for (i = 0; i < config._f.length; i++) {
	            currentScore = 0;
	            tempConfig = copyConfig({}, config);
	            if (config._useUTC != null) {
	                tempConfig._useUTC = config._useUTC;
	            }
	            tempConfig._f = config._f[i];
	            configFromStringAndFormat(tempConfig);
	
	            if (!isValid(tempConfig)) {
	                continue;
	            }
	
	            // if there is any input that was not parsed add a penalty for that format
	            currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	            //or tokens
	            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	            getParsingFlags(tempConfig).score = currentScore;
	
	            if (scoreToBeat == null || currentScore < scoreToBeat) {
	                scoreToBeat = currentScore;
	                bestMoment = tempConfig;
	            }
	        }
	
	        extend(config, bestMoment || tempConfig);
	    }
	
	    function configFromObject(config) {
	        if (config._d) {
	            return;
	        }
	
	        var i = normalizeObjectUnits(config._i);
	        config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
	            return obj && parseInt(obj, 10);
	        });
	
	        configFromArray(config);
	    }
	
	    function createFromConfig(config) {
	        var res = new Moment(checkOverflow(prepareConfig(config)));
	        if (res._nextDay) {
	            // Adding is smart enough around DST
	            res.add(1, 'd');
	            res._nextDay = undefined;
	        }
	
	        return res;
	    }
	
	    function prepareConfig(config) {
	        var input = config._i,
	            format = config._f;
	
	        config._locale = config._locale || getLocale(config._l);
	
	        if (input === null || format === undefined && input === '') {
	            return createInvalid({ nullInput: true });
	        }
	
	        if (typeof input === 'string') {
	            config._i = input = config._locale.preparse(input);
	        }
	
	        if (isMoment(input)) {
	            return new Moment(checkOverflow(input));
	        } else if (isDate(input)) {
	            config._d = input;
	        } else if (isArray(format)) {
	            configFromStringAndArray(config);
	        } else if (format) {
	            configFromStringAndFormat(config);
	        } else {
	            configFromInput(config);
	        }
	
	        if (!isValid(config)) {
	            config._d = null;
	        }
	
	        return config;
	    }
	
	    function configFromInput(config) {
	        var input = config._i;
	        if (isUndefined(input)) {
	            config._d = new Date(hooks.now());
	        } else if (isDate(input)) {
	            config._d = new Date(input.valueOf());
	        } else if (typeof input === 'string') {
	            configFromString(config);
	        } else if (isArray(input)) {
	            config._a = map(input.slice(0), function (obj) {
	                return parseInt(obj, 10);
	            });
	            configFromArray(config);
	        } else if (isObject(input)) {
	            configFromObject(config);
	        } else if (isNumber(input)) {
	            // from milliseconds
	            config._d = new Date(input);
	        } else {
	            hooks.createFromInputFallback(config);
	        }
	    }
	
	    function createLocalOrUTC(input, format, locale, strict, isUTC) {
	        var c = {};
	
	        if (locale === true || locale === false) {
	            strict = locale;
	            locale = undefined;
	        }
	
	        if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) {
	            input = undefined;
	        }
	        // object construction must be done this way.
	        // https://github.com/moment/moment/issues/1423
	        c._isAMomentObject = true;
	        c._useUTC = c._isUTC = isUTC;
	        c._l = locale;
	        c._i = input;
	        c._f = format;
	        c._strict = strict;
	
	        return createFromConfig(c);
	    }
	
	    function createLocal(input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, false);
	    }
	
	    var prototypeMin = deprecate('moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/', function () {
	        var other = createLocal.apply(null, arguments);
	        if (this.isValid() && other.isValid()) {
	            return other < this ? this : other;
	        } else {
	            return createInvalid();
	        }
	    });
	
	    var prototypeMax = deprecate('moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/', function () {
	        var other = createLocal.apply(null, arguments);
	        if (this.isValid() && other.isValid()) {
	            return other > this ? this : other;
	        } else {
	            return createInvalid();
	        }
	    });
	
	    // Pick a moment m from moments so that m[fn](other) is true for all
	    // other. This relies on the function fn to be transitive.
	    //
	    // moments should either be an array of moment objects or an array, whose
	    // first element is an array of moment objects.
	    function pickBy(fn, moments) {
	        var res, i;
	        if (moments.length === 1 && isArray(moments[0])) {
	            moments = moments[0];
	        }
	        if (!moments.length) {
	            return createLocal();
	        }
	        res = moments[0];
	        for (i = 1; i < moments.length; ++i) {
	            if (!moments[i].isValid() || moments[i][fn](res)) {
	                res = moments[i];
	            }
	        }
	        return res;
	    }
	
	    // TODO: Use [].sort instead?
	    function min() {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isBefore', args);
	    }
	
	    function max() {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isAfter', args);
	    }
	
	    var now = function now() {
	        return Date.now ? Date.now() : +new Date();
	    };
	
	    var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];
	
	    function isDurationValid(m) {
	        for (var key in m) {
	            if (!(ordering.indexOf(key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
	                return false;
	            }
	        }
	
	        var unitHasDecimal = false;
	        for (var i = 0; i < ordering.length; ++i) {
	            if (m[ordering[i]]) {
	                if (unitHasDecimal) {
	                    return false; // only allow non-integers for smallest unit
	                }
	                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
	                    unitHasDecimal = true;
	                }
	            }
	        }
	
	        return true;
	    }
	
	    function isValid$1() {
	        return this._isValid;
	    }
	
	    function createInvalid$1() {
	        return createDuration(NaN);
	    }
	
	    function Duration(duration) {
	        var normalizedInput = normalizeObjectUnits(duration),
	            years = normalizedInput.year || 0,
	            quarters = normalizedInput.quarter || 0,
	            months = normalizedInput.month || 0,
	            weeks = normalizedInput.week || 0,
	            days = normalizedInput.day || 0,
	            hours = normalizedInput.hour || 0,
	            minutes = normalizedInput.minute || 0,
	            seconds = normalizedInput.second || 0,
	            milliseconds = normalizedInput.millisecond || 0;
	
	        this._isValid = isDurationValid(normalizedInput);
	
	        // representation for dateAddRemove
	        this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
	        minutes * 6e4 + // 1000 * 60
	        hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	        // Because of dateAddRemove treats 24 hours as different from a
	        // day when working around DST, we need to store them separately
	        this._days = +days + weeks * 7;
	        // It is impossible translate months into days without knowing
	        // which months you are are talking about, so we have to store
	        // it separately.
	        this._months = +months + quarters * 3 + years * 12;
	
	        this._data = {};
	
	        this._locale = getLocale();
	
	        this._bubble();
	    }
	
	    function isDuration(obj) {
	        return obj instanceof Duration;
	    }
	
	    function absRound(number) {
	        if (number < 0) {
	            return Math.round(-1 * number) * -1;
	        } else {
	            return Math.round(number);
	        }
	    }
	
	    // FORMATTING
	
	    function offset(token, separator) {
	        addFormatToken(token, 0, 0, function () {
	            var offset = this.utcOffset();
	            var sign = '+';
	            if (offset < 0) {
	                offset = -offset;
	                sign = '-';
	            }
	            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
	        });
	    }
	
	    offset('Z', ':');
	    offset('ZZ', '');
	
	    // PARSING
	
	    addRegexToken('Z', matchShortOffset);
	    addRegexToken('ZZ', matchShortOffset);
	    addParseToken(['Z', 'ZZ'], function (input, array, config) {
	        config._useUTC = true;
	        config._tzm = offsetFromString(matchShortOffset, input);
	    });
	
	    // HELPERS
	
	    // timezone chunker
	    // '+10:00' > ['10',  '00']
	    // '-1530'  > ['-15', '30']
	    var chunkOffset = /([\+\-]|\d\d)/gi;
	
	    function offsetFromString(matcher, string) {
	        var matches = (string || '').match(matcher);
	
	        if (matches === null) {
	            return null;
	        }
	
	        var chunk = matches[matches.length - 1] || [];
	        var parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	        var minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
	    }
	
	    // Return a moment from input, that is local/utc/zone equivalent to model.
	    function cloneWithOffset(input, model) {
	        var res, diff;
	        if (model._isUTC) {
	            res = model.clone();
	            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
	            // Use low-level api, because this fn is low-level api.
	            res._d.setTime(res._d.valueOf() + diff);
	            hooks.updateOffset(res, false);
	            return res;
	        } else {
	            return createLocal(input).local();
	        }
	    }
	
	    function getDateOffset(m) {
	        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	        // https://github.com/moment/moment/pull/1871
	        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
	    }
	
	    // HOOKS
	
	    // This function will be called whenever a moment is mutated.
	    // It is intended to keep the offset in sync with the timezone.
	    hooks.updateOffset = function () {};
	
	    // MOMENTS
	
	    // keepLocalTime = true means only change the timezone, without
	    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	    // +0200, so we adjust the time as needed, to be valid.
	    //
	    // Keeping the time actually adds/subtracts (one hour)
	    // from the actual represented time. That is why we call updateOffset
	    // a second time. In case it wants us to change the offset again
	    // _changeInProgress == true case, then we have to adjust, because
	    // there is no such time in the given timezone.
	    function getSetOffset(input, keepLocalTime, keepMinutes) {
	        var offset = this._offset || 0,
	            localAdjust;
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        if (input != null) {
	            if (typeof input === 'string') {
	                input = offsetFromString(matchShortOffset, input);
	                if (input === null) {
	                    return this;
	                }
	            } else if (Math.abs(input) < 16 && !keepMinutes) {
	                input = input * 60;
	            }
	            if (!this._isUTC && keepLocalTime) {
	                localAdjust = getDateOffset(this);
	            }
	            this._offset = input;
	            this._isUTC = true;
	            if (localAdjust != null) {
	                this.add(localAdjust, 'm');
	            }
	            if (offset !== input) {
	                if (!keepLocalTime || this._changeInProgress) {
	                    addSubtract(this, createDuration(input - offset, 'm'), 1, false);
	                } else if (!this._changeInProgress) {
	                    this._changeInProgress = true;
	                    hooks.updateOffset(this, true);
	                    this._changeInProgress = null;
	                }
	            }
	            return this;
	        } else {
	            return this._isUTC ? offset : getDateOffset(this);
	        }
	    }
	
	    function getSetZone(input, keepLocalTime) {
	        if (input != null) {
	            if (typeof input !== 'string') {
	                input = -input;
	            }
	
	            this.utcOffset(input, keepLocalTime);
	
	            return this;
	        } else {
	            return -this.utcOffset();
	        }
	    }
	
	    function setOffsetToUTC(keepLocalTime) {
	        return this.utcOffset(0, keepLocalTime);
	    }
	
	    function setOffsetToLocal(keepLocalTime) {
	        if (this._isUTC) {
	            this.utcOffset(0, keepLocalTime);
	            this._isUTC = false;
	
	            if (keepLocalTime) {
	                this.subtract(getDateOffset(this), 'm');
	            }
	        }
	        return this;
	    }
	
	    function setOffsetToParsedOffset() {
	        if (this._tzm != null) {
	            this.utcOffset(this._tzm, false, true);
	        } else if (typeof this._i === 'string') {
	            var tZone = offsetFromString(matchOffset, this._i);
	            if (tZone != null) {
	                this.utcOffset(tZone);
	            } else {
	                this.utcOffset(0, true);
	            }
	        }
	        return this;
	    }
	
	    function hasAlignedHourOffset(input) {
	        if (!this.isValid()) {
	            return false;
	        }
	        input = input ? createLocal(input).utcOffset() : 0;
	
	        return (this.utcOffset() - input) % 60 === 0;
	    }
	
	    function isDaylightSavingTime() {
	        return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
	    }
	
	    function isDaylightSavingTimeShifted() {
	        if (!isUndefined(this._isDSTShifted)) {
	            return this._isDSTShifted;
	        }
	
	        var c = {};
	
	        copyConfig(c, this);
	        c = prepareConfig(c);
	
	        if (c._a) {
	            var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	            this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
	        } else {
	            this._isDSTShifted = false;
	        }
	
	        return this._isDSTShifted;
	    }
	
	    function isLocal() {
	        return this.isValid() ? !this._isUTC : false;
	    }
	
	    function isUtcOffset() {
	        return this.isValid() ? this._isUTC : false;
	    }
	
	    function isUtc() {
	        return this.isValid() ? this._isUTC && this._offset === 0 : false;
	    }
	
	    // ASP.NET json date format regex
	    var aspNetRegex = /^(\-)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;
	
	    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	    // and further modified to allow for strings containing both week and day
	    var isoRegex = /^(-)?P(?:(-?[0-9,.]*)Y)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)W)?(?:(-?[0-9,.]*)D)?(?:T(?:(-?[0-9,.]*)H)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)S)?)?$/;
	
	    function createDuration(input, key) {
	        var duration = input,
	
	        // matching against regexp is expensive, do it on demand
	        match = null,
	            sign,
	            ret,
	            diffRes;
	
	        if (isDuration(input)) {
	            duration = {
	                ms: input._milliseconds,
	                d: input._days,
	                M: input._months
	            };
	        } else if (isNumber(input)) {
	            duration = {};
	            if (key) {
	                duration[key] = input;
	            } else {
	                duration.milliseconds = input;
	            }
	        } else if (!!(match = aspNetRegex.exec(input))) {
	            sign = match[1] === '-' ? -1 : 1;
	            duration = {
	                y: 0,
	                d: toInt(match[DATE]) * sign,
	                h: toInt(match[HOUR]) * sign,
	                m: toInt(match[MINUTE]) * sign,
	                s: toInt(match[SECOND]) * sign,
	                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
	            };
	        } else if (!!(match = isoRegex.exec(input))) {
	            sign = match[1] === '-' ? -1 : 1;
	            duration = {
	                y: parseIso(match[2], sign),
	                M: parseIso(match[3], sign),
	                w: parseIso(match[4], sign),
	                d: parseIso(match[5], sign),
	                h: parseIso(match[6], sign),
	                m: parseIso(match[7], sign),
	                s: parseIso(match[8], sign)
	            };
	        } else if (duration == null) {
	            // checks for null or undefined
	            duration = {};
	        } else if ((typeof duration === 'undefined' ? 'undefined' : _typeof(duration)) === 'object' && ('from' in duration || 'to' in duration)) {
	            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
	
	            duration = {};
	            duration.ms = diffRes.milliseconds;
	            duration.M = diffRes.months;
	        }
	
	        ret = new Duration(duration);
	
	        if (isDuration(input) && hasOwnProp(input, '_locale')) {
	            ret._locale = input._locale;
	        }
	
	        return ret;
	    }
	
	    createDuration.fn = Duration.prototype;
	    createDuration.invalid = createInvalid$1;
	
	    function parseIso(inp, sign) {
	        // We'd normally use ~~inp for this, but unfortunately it also
	        // converts floats to ints.
	        // inp may be undefined, so careful calling replace on it.
	        var res = inp && parseFloat(inp.replace(',', '.'));
	        // apply sign while we're at it
	        return (isNaN(res) ? 0 : res) * sign;
	    }
	
	    function positiveMomentsDifference(base, other) {
	        var res = { milliseconds: 0, months: 0 };
	
	        res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
	        if (base.clone().add(res.months, 'M').isAfter(other)) {
	            --res.months;
	        }
	
	        res.milliseconds = +other - +base.clone().add(res.months, 'M');
	
	        return res;
	    }
	
	    function momentsDifference(base, other) {
	        var res;
	        if (!(base.isValid() && other.isValid())) {
	            return { milliseconds: 0, months: 0 };
	        }
	
	        other = cloneWithOffset(other, base);
	        if (base.isBefore(other)) {
	            res = positiveMomentsDifference(base, other);
	        } else {
	            res = positiveMomentsDifference(other, base);
	            res.milliseconds = -res.milliseconds;
	            res.months = -res.months;
	        }
	
	        return res;
	    }
	
	    // TODO: remove 'name' arg after deprecation is removed
	    function createAdder(direction, name) {
	        return function (val, period) {
	            var dur, tmp;
	            //invert the arguments, but complain about it
	            if (period !== null && !isNaN(+period)) {
	                deprecateSimple(name, 'moment().' + name + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' + 'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
	                tmp = val;val = period;period = tmp;
	            }
	
	            val = typeof val === 'string' ? +val : val;
	            dur = createDuration(val, period);
	            addSubtract(this, dur, direction);
	            return this;
	        };
	    }
	
	    function addSubtract(mom, duration, isAdding, updateOffset) {
	        var milliseconds = duration._milliseconds,
	            days = absRound(duration._days),
	            months = absRound(duration._months);
	
	        if (!mom.isValid()) {
	            // No op
	            return;
	        }
	
	        updateOffset = updateOffset == null ? true : updateOffset;
	
	        if (milliseconds) {
	            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	        }
	        if (days) {
	            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	        }
	        if (months) {
	            setMonth(mom, get(mom, 'Month') + months * isAdding);
	        }
	        if (updateOffset) {
	            hooks.updateOffset(mom, days || months);
	        }
	    }
	
	    var add = createAdder(1, 'add');
	    var subtract = createAdder(-1, 'subtract');
	
	    function getCalendarFormat(myMoment, now) {
	        var diff = myMoment.diff(now, 'days', true);
	        return diff < -6 ? 'sameElse' : diff < -1 ? 'lastWeek' : diff < 0 ? 'lastDay' : diff < 1 ? 'sameDay' : diff < 2 ? 'nextDay' : diff < 7 ? 'nextWeek' : 'sameElse';
	    }
	
	    function calendar$1(time, formats) {
	        // We want to compare the start of today, vs this.
	        // Getting start-of-today depends on whether we're local/utc/offset or not.
	        var now = time || createLocal(),
	            sod = cloneWithOffset(now, this).startOf('day'),
	            format = hooks.calendarFormat(this, sod) || 'sameElse';
	
	        var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
	
	        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
	    }
	
	    function clone() {
	        return new Moment(this);
	    }
	
	    function isAfter(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
	        if (units === 'millisecond') {
	            return this.valueOf() > localInput.valueOf();
	        } else {
	            return localInput.valueOf() < this.clone().startOf(units).valueOf();
	        }
	    }
	
	    function isBefore(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
	        if (units === 'millisecond') {
	            return this.valueOf() < localInput.valueOf();
	        } else {
	            return this.clone().endOf(units).valueOf() < localInput.valueOf();
	        }
	    }
	
	    function isBetween(from, to, units, inclusivity) {
	        inclusivity = inclusivity || '()';
	        return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) && (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
	    }
	
	    function isSame(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input),
	            inputMs;
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units || 'millisecond');
	        if (units === 'millisecond') {
	            return this.valueOf() === localInput.valueOf();
	        } else {
	            inputMs = localInput.valueOf();
	            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
	        }
	    }
	
	    function isSameOrAfter(input, units) {
	        return this.isSame(input, units) || this.isAfter(input, units);
	    }
	
	    function isSameOrBefore(input, units) {
	        return this.isSame(input, units) || this.isBefore(input, units);
	    }
	
	    function diff(input, units, asFloat) {
	        var that, zoneDelta, delta, output;
	
	        if (!this.isValid()) {
	            return NaN;
	        }
	
	        that = cloneWithOffset(input, this);
	
	        if (!that.isValid()) {
	            return NaN;
	        }
	
	        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	        units = normalizeUnits(units);
	
	        if (units === 'year' || units === 'month' || units === 'quarter') {
	            output = monthDiff(this, that);
	            if (units === 'quarter') {
	                output = output / 3;
	            } else if (units === 'year') {
	                output = output / 12;
	            }
	        } else {
	            delta = this - that;
	            output = units === 'second' ? delta / 1e3 : // 1000
	            units === 'minute' ? delta / 6e4 : // 1000 * 60
	            units === 'hour' ? delta / 36e5 : // 1000 * 60 * 60
	            units === 'day' ? (delta - zoneDelta) / 864e5 : // 1000 * 60 * 60 * 24, negate dst
	            units === 'week' ? (delta - zoneDelta) / 6048e5 : // 1000 * 60 * 60 * 24 * 7, negate dst
	            delta;
	        }
	        return asFloat ? output : absFloor(output);
	    }
	
	    function monthDiff(a, b) {
	        // difference in months
	        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
	
	        // b is in (anchor - 1 month, anchor + 1 month)
	        anchor = a.clone().add(wholeMonthDiff, 'months'),
	            anchor2,
	            adjust;
	
	        if (b - anchor < 0) {
	            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor - anchor2);
	        } else {
	            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor2 - anchor);
	        }
	
	        //check for negative zero, return zero if negative zero
	        return -(wholeMonthDiff + adjust) || 0;
	    }
	
	    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	    function toString() {
	        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	    }
	
	    function toISOString() {
	        if (!this.isValid()) {
	            return null;
	        }
	        var m = this.clone().utc();
	        if (m.year() < 0 || m.year() > 9999) {
	            return formatMoment(m, 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
	        }
	        if (isFunction(Date.prototype.toISOString)) {
	            // native implementation is ~50x faster, use it when we can
	            return this.toDate().toISOString();
	        }
	        return formatMoment(m, 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
	    }
	
	    /**
	     * Return a human readable representation of a moment that can
	     * also be evaluated to get a new moment which is the same
	     *
	     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	     */
	    function inspect() {
	        if (!this.isValid()) {
	            return 'moment.invalid(/* ' + this._i + ' */)';
	        }
	        var func = 'moment';
	        var zone = '';
	        if (!this.isLocal()) {
	            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	            zone = 'Z';
	        }
	        var prefix = '[' + func + '("]';
	        var year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
	        var datetime = '-MM-DD[T]HH:mm:ss.SSS';
	        var suffix = zone + '[")]';
	
	        return this.format(prefix + year + datetime + suffix);
	    }
	
	    function format(inputString) {
	        if (!inputString) {
	            inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
	        }
	        var output = formatMoment(this, inputString);
	        return this.localeData().postformat(output);
	    }
	
	    function from(time, withoutSuffix) {
	        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) {
	            return createDuration({ to: this, from: time }).locale(this.locale()).humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function fromNow(withoutSuffix) {
	        return this.from(createLocal(), withoutSuffix);
	    }
	
	    function to(time, withoutSuffix) {
	        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) {
	            return createDuration({ from: this, to: time }).locale(this.locale()).humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function toNow(withoutSuffix) {
	        return this.to(createLocal(), withoutSuffix);
	    }
	
	    // If passed a locale key, it will set the locale for this
	    // instance.  Otherwise, it will return the locale configuration
	    // variables for this instance.
	    function locale(key) {
	        var newLocaleData;
	
	        if (key === undefined) {
	            return this._locale._abbr;
	        } else {
	            newLocaleData = getLocale(key);
	            if (newLocaleData != null) {
	                this._locale = newLocaleData;
	            }
	            return this;
	        }
	    }
	
	    var lang = deprecate('moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.', function (key) {
	        if (key === undefined) {
	            return this.localeData();
	        } else {
	            return this.locale(key);
	        }
	    });
	
	    function localeData() {
	        return this._locale;
	    }
	
	    function startOf(units) {
	        units = normalizeUnits(units);
	        // the following switch intentionally omits break keywords
	        // to utilize falling through the cases.
	        switch (units) {
	            case 'year':
	                this.month(0);
	            /* falls through */
	            case 'quarter':
	            case 'month':
	                this.date(1);
	            /* falls through */
	            case 'week':
	            case 'isoWeek':
	            case 'day':
	            case 'date':
	                this.hours(0);
	            /* falls through */
	            case 'hour':
	                this.minutes(0);
	            /* falls through */
	            case 'minute':
	                this.seconds(0);
	            /* falls through */
	            case 'second':
	                this.milliseconds(0);
	        }
	
	        // weeks are a special case
	        if (units === 'week') {
	            this.weekday(0);
	        }
	        if (units === 'isoWeek') {
	            this.isoWeekday(1);
	        }
	
	        // quarters are also special
	        if (units === 'quarter') {
	            this.month(Math.floor(this.month() / 3) * 3);
	        }
	
	        return this;
	    }
	
	    function endOf(units) {
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond') {
	            return this;
	        }
	
	        // 'date' is an alias for 'day', so it should be considered as such.
	        if (units === 'date') {
	            units = 'day';
	        }
	
	        return this.startOf(units).add(1, units === 'isoWeek' ? 'week' : units).subtract(1, 'ms');
	    }
	
	    function valueOf() {
	        return this._d.valueOf() - (this._offset || 0) * 60000;
	    }
	
	    function unix() {
	        return Math.floor(this.valueOf() / 1000);
	    }
	
	    function toDate() {
	        return new Date(this.valueOf());
	    }
	
	    function toArray() {
	        var m = this;
	        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
	    }
	
	    function toObject() {
	        var m = this;
	        return {
	            years: m.year(),
	            months: m.month(),
	            date: m.date(),
	            hours: m.hours(),
	            minutes: m.minutes(),
	            seconds: m.seconds(),
	            milliseconds: m.milliseconds()
	        };
	    }
	
	    function toJSON() {
	        // new Date(NaN).toJSON() === null
	        return this.isValid() ? this.toISOString() : null;
	    }
	
	    function isValid$2() {
	        return isValid(this);
	    }
	
	    function parsingFlags() {
	        return extend({}, getParsingFlags(this));
	    }
	
	    function invalidAt() {
	        return getParsingFlags(this).overflow;
	    }
	
	    function creationData() {
	        return {
	            input: this._i,
	            format: this._f,
	            locale: this._locale,
	            isUTC: this._isUTC,
	            strict: this._strict
	        };
	    }
	
	    // FORMATTING
	
	    addFormatToken(0, ['gg', 2], 0, function () {
	        return this.weekYear() % 100;
	    });
	
	    addFormatToken(0, ['GG', 2], 0, function () {
	        return this.isoWeekYear() % 100;
	    });
	
	    function addWeekYearFormatToken(token, getter) {
	        addFormatToken(0, [token, token.length], 0, getter);
	    }
	
	    addWeekYearFormatToken('gggg', 'weekYear');
	    addWeekYearFormatToken('ggggg', 'weekYear');
	    addWeekYearFormatToken('GGGG', 'isoWeekYear');
	    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	    // ALIASES
	
	    addUnitAlias('weekYear', 'gg');
	    addUnitAlias('isoWeekYear', 'GG');
	
	    // PRIORITY
	
	    addUnitPriority('weekYear', 1);
	    addUnitPriority('isoWeekYear', 1);
	
	    // PARSING
	
	    addRegexToken('G', matchSigned);
	    addRegexToken('g', matchSigned);
	    addRegexToken('GG', match1to2, match2);
	    addRegexToken('gg', match1to2, match2);
	    addRegexToken('GGGG', match1to4, match4);
	    addRegexToken('gggg', match1to4, match4);
	    addRegexToken('GGGGG', match1to6, match6);
	    addRegexToken('ggggg', match1to6, match6);
	
	    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
	        week[token.substr(0, 2)] = toInt(input);
	    });
	
	    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	        week[token] = hooks.parseTwoDigitYear(input);
	    });
	
	    // MOMENTS
	
	    function getSetWeekYear(input) {
	        return getSetWeekYearHelper.call(this, input, this.week(), this.weekday(), this.localeData()._week.dow, this.localeData()._week.doy);
	    }
	
	    function getSetISOWeekYear(input) {
	        return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
	    }
	
	    function getISOWeeksInYear() {
	        return weeksInYear(this.year(), 1, 4);
	    }
	
	    function getWeeksInYear() {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	        var weeksTarget;
	        if (input == null) {
	            return weekOfYear(this, dow, doy).year;
	        } else {
	            weeksTarget = weeksInYear(input, dow, doy);
	            if (week > weeksTarget) {
	                week = weeksTarget;
	            }
	            return setWeekAll.call(this, input, week, weekday, dow, doy);
	        }
	    }
	
	    function setWeekAll(weekYear, week, weekday, dow, doy) {
	        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	        this.year(date.getUTCFullYear());
	        this.month(date.getUTCMonth());
	        this.date(date.getUTCDate());
	        return this;
	    }
	
	    // FORMATTING
	
	    addFormatToken('Q', 0, 'Qo', 'quarter');
	
	    // ALIASES
	
	    addUnitAlias('quarter', 'Q');
	
	    // PRIORITY
	
	    addUnitPriority('quarter', 7);
	
	    // PARSING
	
	    addRegexToken('Q', match1);
	    addParseToken('Q', function (input, array) {
	        array[MONTH] = (toInt(input) - 1) * 3;
	    });
	
	    // MOMENTS
	
	    function getSetQuarter(input) {
	        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
	    }
	
	    // FORMATTING
	
	    addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	    // ALIASES
	
	    addUnitAlias('date', 'D');
	
	    // PRIOROITY
	    addUnitPriority('date', 9);
	
	    // PARSING
	
	    addRegexToken('D', match1to2);
	    addRegexToken('DD', match1to2, match2);
	    addRegexToken('Do', function (isStrict, locale) {
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
	    });
	
	    addParseToken(['D', 'DD'], DATE);
	    addParseToken('Do', function (input, array) {
	        array[DATE] = toInt(input.match(match1to2)[0], 10);
	    });
	
	    // MOMENTS
	
	    var getSetDayOfMonth = makeGetSet('Date', true);
	
	    // FORMATTING
	
	    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	    // ALIASES
	
	    addUnitAlias('dayOfYear', 'DDD');
	
	    // PRIORITY
	    addUnitPriority('dayOfYear', 4);
	
	    // PARSING
	
	    addRegexToken('DDD', match1to3);
	    addRegexToken('DDDD', match3);
	    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	        config._dayOfYear = toInt(input);
	    });
	
	    // HELPERS
	
	    // MOMENTS
	
	    function getSetDayOfYear(input) {
	        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
	        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('m', ['mm', 2], 0, 'minute');
	
	    // ALIASES
	
	    addUnitAlias('minute', 'm');
	
	    // PRIORITY
	
	    addUnitPriority('minute', 14);
	
	    // PARSING
	
	    addRegexToken('m', match1to2);
	    addRegexToken('mm', match1to2, match2);
	    addParseToken(['m', 'mm'], MINUTE);
	
	    // MOMENTS
	
	    var getSetMinute = makeGetSet('Minutes', false);
	
	    // FORMATTING
	
	    addFormatToken('s', ['ss', 2], 0, 'second');
	
	    // ALIASES
	
	    addUnitAlias('second', 's');
	
	    // PRIORITY
	
	    addUnitPriority('second', 15);
	
	    // PARSING
	
	    addRegexToken('s', match1to2);
	    addRegexToken('ss', match1to2, match2);
	    addParseToken(['s', 'ss'], SECOND);
	
	    // MOMENTS
	
	    var getSetSecond = makeGetSet('Seconds', false);
	
	    // FORMATTING
	
	    addFormatToken('S', 0, 0, function () {
	        return ~~(this.millisecond() / 100);
	    });
	
	    addFormatToken(0, ['SS', 2], 0, function () {
	        return ~~(this.millisecond() / 10);
	    });
	
	    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	    addFormatToken(0, ['SSSS', 4], 0, function () {
	        return this.millisecond() * 10;
	    });
	    addFormatToken(0, ['SSSSS', 5], 0, function () {
	        return this.millisecond() * 100;
	    });
	    addFormatToken(0, ['SSSSSS', 6], 0, function () {
	        return this.millisecond() * 1000;
	    });
	    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	        return this.millisecond() * 10000;
	    });
	    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	        return this.millisecond() * 100000;
	    });
	    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	        return this.millisecond() * 1000000;
	    });
	
	    // ALIASES
	
	    addUnitAlias('millisecond', 'ms');
	
	    // PRIORITY
	
	    addUnitPriority('millisecond', 16);
	
	    // PARSING
	
	    addRegexToken('S', match1to3, match1);
	    addRegexToken('SS', match1to3, match2);
	    addRegexToken('SSS', match1to3, match3);
	
	    var token;
	    for (token = 'SSSS'; token.length <= 9; token += 'S') {
	        addRegexToken(token, matchUnsigned);
	    }
	
	    function parseMs(input, array) {
	        array[MILLISECOND] = toInt(('0.' + input) * 1000);
	    }
	
	    for (token = 'S'; token.length <= 9; token += 'S') {
	        addParseToken(token, parseMs);
	    }
	    // MOMENTS
	
	    var getSetMillisecond = makeGetSet('Milliseconds', false);
	
	    // FORMATTING
	
	    addFormatToken('z', 0, 0, 'zoneAbbr');
	    addFormatToken('zz', 0, 0, 'zoneName');
	
	    // MOMENTS
	
	    function getZoneAbbr() {
	        return this._isUTC ? 'UTC' : '';
	    }
	
	    function getZoneName() {
	        return this._isUTC ? 'Coordinated Universal Time' : '';
	    }
	
	    var proto = Moment.prototype;
	
	    proto.add = add;
	    proto.calendar = calendar$1;
	    proto.clone = clone;
	    proto.diff = diff;
	    proto.endOf = endOf;
	    proto.format = format;
	    proto.from = from;
	    proto.fromNow = fromNow;
	    proto.to = to;
	    proto.toNow = toNow;
	    proto.get = stringGet;
	    proto.invalidAt = invalidAt;
	    proto.isAfter = isAfter;
	    proto.isBefore = isBefore;
	    proto.isBetween = isBetween;
	    proto.isSame = isSame;
	    proto.isSameOrAfter = isSameOrAfter;
	    proto.isSameOrBefore = isSameOrBefore;
	    proto.isValid = isValid$2;
	    proto.lang = lang;
	    proto.locale = locale;
	    proto.localeData = localeData;
	    proto.max = prototypeMax;
	    proto.min = prototypeMin;
	    proto.parsingFlags = parsingFlags;
	    proto.set = stringSet;
	    proto.startOf = startOf;
	    proto.subtract = subtract;
	    proto.toArray = toArray;
	    proto.toObject = toObject;
	    proto.toDate = toDate;
	    proto.toISOString = toISOString;
	    proto.inspect = inspect;
	    proto.toJSON = toJSON;
	    proto.toString = toString;
	    proto.unix = unix;
	    proto.valueOf = valueOf;
	    proto.creationData = creationData;
	
	    // Year
	    proto.year = getSetYear;
	    proto.isLeapYear = getIsLeapYear;
	
	    // Week Year
	    proto.weekYear = getSetWeekYear;
	    proto.isoWeekYear = getSetISOWeekYear;
	
	    // Quarter
	    proto.quarter = proto.quarters = getSetQuarter;
	
	    // Month
	    proto.month = getSetMonth;
	    proto.daysInMonth = getDaysInMonth;
	
	    // Week
	    proto.week = proto.weeks = getSetWeek;
	    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
	    proto.weeksInYear = getWeeksInYear;
	    proto.isoWeeksInYear = getISOWeeksInYear;
	
	    // Day
	    proto.date = getSetDayOfMonth;
	    proto.day = proto.days = getSetDayOfWeek;
	    proto.weekday = getSetLocaleDayOfWeek;
	    proto.isoWeekday = getSetISODayOfWeek;
	    proto.dayOfYear = getSetDayOfYear;
	
	    // Hour
	    proto.hour = proto.hours = getSetHour;
	
	    // Minute
	    proto.minute = proto.minutes = getSetMinute;
	
	    // Second
	    proto.second = proto.seconds = getSetSecond;
	
	    // Millisecond
	    proto.millisecond = proto.milliseconds = getSetMillisecond;
	
	    // Offset
	    proto.utcOffset = getSetOffset;
	    proto.utc = setOffsetToUTC;
	    proto.local = setOffsetToLocal;
	    proto.parseZone = setOffsetToParsedOffset;
	    proto.hasAlignedHourOffset = hasAlignedHourOffset;
	    proto.isDST = isDaylightSavingTime;
	    proto.isLocal = isLocal;
	    proto.isUtcOffset = isUtcOffset;
	    proto.isUtc = isUtc;
	    proto.isUTC = isUtc;
	
	    // Timezone
	    proto.zoneAbbr = getZoneAbbr;
	    proto.zoneName = getZoneName;
	
	    // Deprecations
	    proto.dates = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
	    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
	    proto.years = deprecate('years accessor is deprecated. Use year instead', getSetYear);
	    proto.zone = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
	    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
	
	    function createUnix(input) {
	        return createLocal(input * 1000);
	    }
	
	    function createInZone() {
	        return createLocal.apply(null, arguments).parseZone();
	    }
	
	    function preParsePostFormat(string) {
	        return string;
	    }
	
	    var proto$1 = Locale.prototype;
	
	    proto$1.calendar = calendar;
	    proto$1.longDateFormat = longDateFormat;
	    proto$1.invalidDate = invalidDate;
	    proto$1.ordinal = ordinal;
	    proto$1.preparse = preParsePostFormat;
	    proto$1.postformat = preParsePostFormat;
	    proto$1.relativeTime = relativeTime;
	    proto$1.pastFuture = pastFuture;
	    proto$1.set = set;
	
	    // Month
	    proto$1.months = localeMonths;
	    proto$1.monthsShort = localeMonthsShort;
	    proto$1.monthsParse = localeMonthsParse;
	    proto$1.monthsRegex = monthsRegex;
	    proto$1.monthsShortRegex = monthsShortRegex;
	
	    // Week
	    proto$1.week = localeWeek;
	    proto$1.firstDayOfYear = localeFirstDayOfYear;
	    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
	
	    // Day of Week
	    proto$1.weekdays = localeWeekdays;
	    proto$1.weekdaysMin = localeWeekdaysMin;
	    proto$1.weekdaysShort = localeWeekdaysShort;
	    proto$1.weekdaysParse = localeWeekdaysParse;
	
	    proto$1.weekdaysRegex = weekdaysRegex;
	    proto$1.weekdaysShortRegex = weekdaysShortRegex;
	    proto$1.weekdaysMinRegex = weekdaysMinRegex;
	
	    // Hours
	    proto$1.isPM = localeIsPM;
	    proto$1.meridiem = localeMeridiem;
	
	    function get$1(format, index, field, setter) {
	        var locale = getLocale();
	        var utc = createUTC().set(setter, index);
	        return locale[field](utc, format);
	    }
	
	    function listMonthsImpl(format, index, field) {
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	
	        if (index != null) {
	            return get$1(format, index, field, 'month');
	        }
	
	        var i;
	        var out = [];
	        for (i = 0; i < 12; i++) {
	            out[i] = get$1(format, i, field, 'month');
	        }
	        return out;
	    }
	
	    // ()
	    // (5)
	    // (fmt, 5)
	    // (fmt)
	    // (true)
	    // (true, 5)
	    // (true, fmt, 5)
	    // (true, fmt)
	    function listWeekdaysImpl(localeSorted, format, index, field) {
	        if (typeof localeSorted === 'boolean') {
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        } else {
	            format = localeSorted;
	            index = format;
	            localeSorted = false;
	
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        }
	
	        var locale = getLocale(),
	            shift = localeSorted ? locale._week.dow : 0;
	
	        if (index != null) {
	            return get$1(format, (index + shift) % 7, field, 'day');
	        }
	
	        var i;
	        var out = [];
	        for (i = 0; i < 7; i++) {
	            out[i] = get$1(format, (i + shift) % 7, field, 'day');
	        }
	        return out;
	    }
	
	    function listMonths(format, index) {
	        return listMonthsImpl(format, index, 'months');
	    }
	
	    function listMonthsShort(format, index) {
	        return listMonthsImpl(format, index, 'monthsShort');
	    }
	
	    function listWeekdays(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	    }
	
	    function listWeekdaysShort(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	    }
	
	    function listWeekdaysMin(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	    }
	
	    getSetGlobalLocale('en', {
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal: function ordinal(number) {
	            var b = number % 10,
	                output = toInt(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
	            return number + output;
	        }
	    });
	
	    // Side effect imports
	    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
	    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
	
	    var mathAbs = Math.abs;
	
	    function abs() {
	        var data = this._data;
	
	        this._milliseconds = mathAbs(this._milliseconds);
	        this._days = mathAbs(this._days);
	        this._months = mathAbs(this._months);
	
	        data.milliseconds = mathAbs(data.milliseconds);
	        data.seconds = mathAbs(data.seconds);
	        data.minutes = mathAbs(data.minutes);
	        data.hours = mathAbs(data.hours);
	        data.months = mathAbs(data.months);
	        data.years = mathAbs(data.years);
	
	        return this;
	    }
	
	    function addSubtract$1(duration, input, value, direction) {
	        var other = createDuration(input, value);
	
	        duration._milliseconds += direction * other._milliseconds;
	        duration._days += direction * other._days;
	        duration._months += direction * other._months;
	
	        return duration._bubble();
	    }
	
	    // supports only 2.0-style add(1, 's') or add(duration)
	    function add$1(input, value) {
	        return addSubtract$1(this, input, value, 1);
	    }
	
	    // supports only 2.0-style subtract(1, 's') or subtract(duration)
	    function subtract$1(input, value) {
	        return addSubtract$1(this, input, value, -1);
	    }
	
	    function absCeil(number) {
	        if (number < 0) {
	            return Math.floor(number);
	        } else {
	            return Math.ceil(number);
	        }
	    }
	
	    function bubble() {
	        var milliseconds = this._milliseconds;
	        var days = this._days;
	        var months = this._months;
	        var data = this._data;
	        var seconds, minutes, hours, years, monthsFromDays;
	
	        // if we have a mix of positive and negative values, bubble down first
	        // check: https://github.com/moment/moment/issues/2166
	        if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
	            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	            days = 0;
	            months = 0;
	        }
	
	        // The following code bubbles up values, see the tests for
	        // examples of what that means.
	        data.milliseconds = milliseconds % 1000;
	
	        seconds = absFloor(milliseconds / 1000);
	        data.seconds = seconds % 60;
	
	        minutes = absFloor(seconds / 60);
	        data.minutes = minutes % 60;
	
	        hours = absFloor(minutes / 60);
	        data.hours = hours % 24;
	
	        days += absFloor(hours / 24);
	
	        // convert days to months
	        monthsFromDays = absFloor(daysToMonths(days));
	        months += monthsFromDays;
	        days -= absCeil(monthsToDays(monthsFromDays));
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        data.days = days;
	        data.months = months;
	        data.years = years;
	
	        return this;
	    }
	
	    function daysToMonths(days) {
	        // 400 years have 146097 days (taking into account leap year rules)
	        // 400 years have 12 months === 4800
	        return days * 4800 / 146097;
	    }
	
	    function monthsToDays(months) {
	        // the reverse of daysToMonths
	        return months * 146097 / 4800;
	    }
	
	    function as(units) {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        var days;
	        var months;
	        var milliseconds = this._milliseconds;
	
	        units = normalizeUnits(units);
	
	        if (units === 'month' || units === 'year') {
	            days = this._days + milliseconds / 864e5;
	            months = this._months + daysToMonths(days);
	            return units === 'month' ? months : months / 12;
	        } else {
	            // handle milliseconds separately because of floating point math errors (issue #1867)
	            days = this._days + Math.round(monthsToDays(this._months));
	            switch (units) {
	                case 'week':
	                    return days / 7 + milliseconds / 6048e5;
	                case 'day':
	                    return days + milliseconds / 864e5;
	                case 'hour':
	                    return days * 24 + milliseconds / 36e5;
	                case 'minute':
	                    return days * 1440 + milliseconds / 6e4;
	                case 'second':
	                    return days * 86400 + milliseconds / 1000;
	                // Math.floor prevents floating point math errors here
	                case 'millisecond':
	                    return Math.floor(days * 864e5) + milliseconds;
	                default:
	                    throw new Error('Unknown unit ' + units);
	            }
	        }
	    }
	
	    // TODO: Use this.as('ms')?
	    function valueOf$1() {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        return this._milliseconds + this._days * 864e5 + this._months % 12 * 2592e6 + toInt(this._months / 12) * 31536e6;
	    }
	
	    function makeAs(alias) {
	        return function () {
	            return this.as(alias);
	        };
	    }
	
	    var asMilliseconds = makeAs('ms');
	    var asSeconds = makeAs('s');
	    var asMinutes = makeAs('m');
	    var asHours = makeAs('h');
	    var asDays = makeAs('d');
	    var asWeeks = makeAs('w');
	    var asMonths = makeAs('M');
	    var asYears = makeAs('y');
	
	    function get$2(units) {
	        units = normalizeUnits(units);
	        return this.isValid() ? this[units + 's']() : NaN;
	    }
	
	    function makeGetter(name) {
	        return function () {
	            return this.isValid() ? this._data[name] : NaN;
	        };
	    }
	
	    var milliseconds = makeGetter('milliseconds');
	    var seconds = makeGetter('seconds');
	    var minutes = makeGetter('minutes');
	    var hours = makeGetter('hours');
	    var days = makeGetter('days');
	    var months = makeGetter('months');
	    var years = makeGetter('years');
	
	    function weeks() {
	        return absFloor(this.days() / 7);
	    }
	
	    var round = Math.round;
	    var thresholds = {
	        ss: 44, // a few seconds to seconds
	        s: 45, // seconds to minute
	        m: 45, // minutes to hour
	        h: 22, // hours to day
	        d: 26, // days to month
	        M: 11 // months to year
	    };
	
	    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	    }
	
	    function relativeTime$1(posNegDuration, withoutSuffix, locale) {
	        var duration = createDuration(posNegDuration).abs();
	        var seconds = round(duration.as('s'));
	        var minutes = round(duration.as('m'));
	        var hours = round(duration.as('h'));
	        var days = round(duration.as('d'));
	        var months = round(duration.as('M'));
	        var years = round(duration.as('y'));
	
	        var a = seconds <= thresholds.ss && ['s', seconds] || seconds < thresholds.s && ['ss', seconds] || minutes <= 1 && ['m'] || minutes < thresholds.m && ['mm', minutes] || hours <= 1 && ['h'] || hours < thresholds.h && ['hh', hours] || days <= 1 && ['d'] || days < thresholds.d && ['dd', days] || months <= 1 && ['M'] || months < thresholds.M && ['MM', months] || years <= 1 && ['y'] || ['yy', years];
	
	        a[2] = withoutSuffix;
	        a[3] = +posNegDuration > 0;
	        a[4] = locale;
	        return substituteTimeAgo.apply(null, a);
	    }
	
	    // This function allows you to set the rounding function for relative time strings
	    function getSetRelativeTimeRounding(roundingFunction) {
	        if (roundingFunction === undefined) {
	            return round;
	        }
	        if (typeof roundingFunction === 'function') {
	            round = roundingFunction;
	            return true;
	        }
	        return false;
	    }
	
	    // This function allows you to set a threshold for relative time strings
	    function getSetRelativeTimeThreshold(threshold, limit) {
	        if (thresholds[threshold] === undefined) {
	            return false;
	        }
	        if (limit === undefined) {
	            return thresholds[threshold];
	        }
	        thresholds[threshold] = limit;
	        if (threshold === 's') {
	            thresholds.ss = limit - 1;
	        }
	        return true;
	    }
	
	    function humanize(withSuffix) {
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var locale = this.localeData();
	        var output = relativeTime$1(this, !withSuffix, locale);
	
	        if (withSuffix) {
	            output = locale.pastFuture(+this, output);
	        }
	
	        return locale.postformat(output);
	    }
	
	    var abs$1 = Math.abs;
	
	    function toISOString$1() {
	        // for ISO strings we do not use the normal bubbling rules:
	        //  * milliseconds bubble up until they become hours
	        //  * days do not bubble at all
	        //  * months bubble up until they become years
	        // This is because there is no context-free conversion between hours and days
	        // (think of clock changes)
	        // and also not between days and months (28-31 days per month)
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var seconds = abs$1(this._milliseconds) / 1000;
	        var days = abs$1(this._days);
	        var months = abs$1(this._months);
	        var minutes, hours, years;
	
	        // 3600 seconds -> 60 minutes -> 1 hour
	        minutes = absFloor(seconds / 60);
	        hours = absFloor(minutes / 60);
	        seconds %= 60;
	        minutes %= 60;
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	        var Y = years;
	        var M = months;
	        var D = days;
	        var h = hours;
	        var m = minutes;
	        var s = seconds;
	        var total = this.asSeconds();
	
	        if (!total) {
	            // this is the same as C#'s (Noda) and python (isodate)...
	            // but not other JS (goog.date)
	            return 'P0D';
	        }
	
	        return (total < 0 ? '-' : '') + 'P' + (Y ? Y + 'Y' : '') + (M ? M + 'M' : '') + (D ? D + 'D' : '') + (h || m || s ? 'T' : '') + (h ? h + 'H' : '') + (m ? m + 'M' : '') + (s ? s + 'S' : '');
	    }
	
	    var proto$2 = Duration.prototype;
	
	    proto$2.isValid = isValid$1;
	    proto$2.abs = abs;
	    proto$2.add = add$1;
	    proto$2.subtract = subtract$1;
	    proto$2.as = as;
	    proto$2.asMilliseconds = asMilliseconds;
	    proto$2.asSeconds = asSeconds;
	    proto$2.asMinutes = asMinutes;
	    proto$2.asHours = asHours;
	    proto$2.asDays = asDays;
	    proto$2.asWeeks = asWeeks;
	    proto$2.asMonths = asMonths;
	    proto$2.asYears = asYears;
	    proto$2.valueOf = valueOf$1;
	    proto$2._bubble = bubble;
	    proto$2.get = get$2;
	    proto$2.milliseconds = milliseconds;
	    proto$2.seconds = seconds;
	    proto$2.minutes = minutes;
	    proto$2.hours = hours;
	    proto$2.days = days;
	    proto$2.weeks = weeks;
	    proto$2.months = months;
	    proto$2.years = years;
	    proto$2.humanize = humanize;
	    proto$2.toISOString = toISOString$1;
	    proto$2.toString = toISOString$1;
	    proto$2.toJSON = toISOString$1;
	    proto$2.locale = locale;
	    proto$2.localeData = localeData;
	
	    // Deprecations
	    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
	    proto$2.lang = lang;
	
	    // Side effect imports
	
	    // FORMATTING
	
	    addFormatToken('X', 0, 0, 'unix');
	    addFormatToken('x', 0, 0, 'valueOf');
	
	    // PARSING
	
	    addRegexToken('x', matchSigned);
	    addRegexToken('X', matchTimestamp);
	    addParseToken('X', function (input, array, config) {
	        config._d = new Date(parseFloat(input, 10) * 1000);
	    });
	    addParseToken('x', function (input, array, config) {
	        config._d = new Date(toInt(input));
	    });
	
	    // Side effect imports
	
	
	    hooks.version = '2.18.1';
	
	    setHookCallback(createLocal);
	
	    hooks.fn = proto;
	    hooks.min = min;
	    hooks.max = max;
	    hooks.now = now;
	    hooks.utc = createUTC;
	    hooks.unix = createUnix;
	    hooks.months = listMonths;
	    hooks.isDate = isDate;
	    hooks.locale = getSetGlobalLocale;
	    hooks.invalid = createInvalid;
	    hooks.duration = createDuration;
	    hooks.isMoment = isMoment;
	    hooks.weekdays = listWeekdays;
	    hooks.parseZone = createInZone;
	    hooks.localeData = getLocale;
	    hooks.isDuration = isDuration;
	    hooks.monthsShort = listMonthsShort;
	    hooks.weekdaysMin = listWeekdaysMin;
	    hooks.defineLocale = defineLocale;
	    hooks.updateLocale = updateLocale;
	    hooks.locales = listLocales;
	    hooks.weekdaysShort = listWeekdaysShort;
	    hooks.normalizeUnits = normalizeUnits;
	    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
	    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
	    hooks.calendarFormat = getCalendarFormat;
	    hooks.prototype = proto;
	
	    return hooks;
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(88)(module)))

/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var global = __webpack_require__(8);
	var core = __webpack_require__(48);
	var hide = __webpack_require__(34);
	var redefine = __webpack_require__(35);
	var ctx = __webpack_require__(44);
	var PROTOTYPE = 'prototype';
	
	var $export = function $export(type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
	  var key, own, out, exp;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    // export native or passed
	    out = (own ? target : source)[key];
	    // bind timers to global for call from export context
	    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // extend global
	    if (target) redefine(target, key, out, type & $export.U);
	    // export
	    if (exports[key] != out) hide(exports, key, exp);
	    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
	  }
	};
	global.core = core;
	// type bitmap
	$export.F = 1; // forced
	$export.G = 2; // global
	$export.S = 4; // static
	$export.P = 8; // proto
	$export.B = 16; // bind
	$export.W = 32; // wrap
	$export.U = 64; // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(86);

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	Object.defineProperty(exports, '__esModule', { value: !0 });var _createComponentTheme = __webpack_require__(195);Object.defineProperty(exports, 'createComponentTheme', { enumerable: !0, get: function get() {
	    return _interopRequireDefault(_createComponentTheme).default;
	  } });var _createI18n = __webpack_require__(196);Object.defineProperty(exports, 'createI18n', { enumerable: !0, get: function get() {
	    return _interopRequireDefault(_createI18n).default;
	  } });var _createTheme = __webpack_require__(130);Object.defineProperty(exports, 'createTheme', { enumerable: !0, get: function get() {
	    return _interopRequireDefault(_createTheme).default;
	  } });var _createThemedComponent = __webpack_require__(506);Object.defineProperty(exports, 'createThemedComponent', { enumerable: !0, get: function get() {
	    return _interopRequireDefault(_createThemedComponent).default;
	  } });var _getStyle = __webpack_require__(510);Object.defineProperty(exports, 'getStyle', { enumerable: !0, get: function get() {
	    return _interopRequireDefault(_getStyle).default;
	  } });var _ThemeProvider = __webpack_require__(501);Object.defineProperty(exports, 'ThemeProvider', { enumerable: !0, get: function get() {
	    return _interopRequireDefault(_ThemeProvider).default;
	  } });var _withTheme = __webpack_require__(197);Object.defineProperty(exports, 'withTheme', { enumerable: !0, get: function get() {
	    return _interopRequireDefault(_withTheme).default;
	  } });function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ },
/* 6 */
[1042, 490],
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var isObject = __webpack_require__(14);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};

/***/ },
/* 8 */
/***/ function(module, exports) {

	'use strict';
	
	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self
	// eslint-disable-next-line no-new-func
	: Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(41);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (false) {
	  var printWarning = function printWarning(format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  warning = function warning(condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = warning;

/***/ },
/* 10 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};

/***/ },
/* 11 */
/***/ function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};

/***/ },
/* 12 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	/**
	 * WARNING: DO NOT manually require this module.
	 * This is a replacement for `invariant(...)` used by the error code system
	 * and will _only_ be required by the corresponding babel pass.
	 * It always throws.
	 */
	
	function reactProdInvariant(code) {
	  var argCount = arguments.length - 1;
	
	  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;
	
	  for (var argIdx = 0; argIdx < argCount; argIdx++) {
	    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
	  }
	
	  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';
	
	  var error = new Error(message);
	  error.name = 'Invariant Violation';
	  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
	
	  throw error;
	}
	
	module.exports = reactProdInvariant;

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	  };
	}();
	
	var _react = __webpack_require__(3);
	
	var _propTypes = __webpack_require__(29);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _utils = __webpack_require__(397);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var VstComponent = function (_Component) {
	  _inherits(VstComponent, _Component);
	
	  function VstComponent() {
	    _classCallCheck(this, VstComponent);
	
	    var _this = _possibleConstructorReturn(this, (VstComponent.__proto__ || Object.getPrototypeOf(VstComponent)).call(this));
	
	    _this._vstComponentUIUpdate = _this._vstComponentUIUpdate.bind(_this);
	    _this.state = {};
	    _this._oldComponentWillUnmount = _this.componentWillUnmount;
	    _this.parentWillUnmount = _this.parentWillUnmount.bind(_this);
	    _this.componentWillUnmount = function (e) {
	      _this.parentWillUnmount(e);
	      _this._oldComponentWillUnmount(e);
	    };
	    _this._oldComponentDidMount = _this.componentDidMount;
	    _this.parentDidMount = _this.parentDidMount.bind(_this);
	    _this.componentDidMount = function (e) {
	      _this.parentDidMount(e);
	      _this._oldComponentDidMount(e);
	    };
	    return _this;
	  }
	
	  _createClass(VstComponent, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {}
	  }, {
	    key: '_returnTheme',
	    value: function _returnTheme(index) {
	      if (this.props.accent) {
	        return _utils2.default.theme.getAccent(index);
	      } else if (this.props.primary) {
	        return _utils2.default.theme.getPrimary(index);
	      }
	      return _utils2.default.theme.getPrimary(index);
	    }
	  }, {
	    key: '_theme',
	    value: function _theme(index) {
	      if (this.props.theme) {
	        return _utils2.default.colors[this.props.theme][index];
	      } else if (this.props.themeMap) {
	        var keys = Object.keys(this.props.themeMap);
	        var i = 0;
	        for (i = 0; i < keys.length; i++) {
	          var key = keys[i];
	          if (this.props.primary && _utils2.default.theme.primaryKey === key || this.props.accent && _utils2.default.theme.accentKey === key) {
	            return _utils2.default.colors[this.props.themeMap[key]][index];
	          }
	        }
	      }
	      return this._returnTheme(index);
	    }
	  }, {
	    key: '_vstComponentUIUpdate',
	    value: function _vstComponentUIUpdate() {
	      this.forceUpdate();
	    }
	  }, {
	    key: 'parentDidMount',
	    value: function parentDidMount() {
	      document.addEventListener('_vstui_change_theme', this._vstComponentUIUpdate);
	    }
	  }, {
	    key: 'parentWillUnmount',
	    value: function parentWillUnmount() {
	      document.removeEventListener('_vstui_change_theme', this._vstComponentUIUpdate);
	    }
	  }]);
	
	  return VstComponent;
	}(_react.Component);
	
	VstComponent.propTypes = {
	  primary: _propTypes2.default.bool,
	  accent: _propTypes2.default.bool,
	  theme: _propTypes2.default.string,
	  themeMap: _propTypes2.default.object
	};
	
	VstComponent.defaultProps = {
	  primary: true,
	  accent: undefined,
	  theme: undefined,
	  themeMap: undefined
	};
	
	module.exports = VstComponent;

/***/ },
/* 14 */
/***/ function(module, exports) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	module.exports = function (it) {
	  return (typeof it === 'undefined' ? 'undefined' : _typeof(it)) === 'object' ? it !== null : typeof it === 'function';
	};

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process, module) {'use strict';
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault(ex) {
	  return ex && (typeof ex === 'undefined' ? 'undefined' : _typeof2(ex)) === 'object' && 'default' in ex ? ex['default'] : ex;
	}
	
	var hyphenate = _interopDefault(__webpack_require__(922));
	var React = __webpack_require__(3);
	var React__default = _interopDefault(React);
	var Stylis = _interopDefault(__webpack_require__(924));
	var _insertRulePlugin = _interopDefault(__webpack_require__(923));
	var PropTypes = _interopDefault(__webpack_require__(29));
	var hoistStatics = _interopDefault(__webpack_require__(791));
	var reactIs = __webpack_require__(887);
	
	var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
	  return typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
	} : function (obj) {
	  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
	};
	
	var classCallCheck = function classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	var createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	var inherits = function inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof2(superClass)));
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	};
	
	var objectWithoutProperties = function objectWithoutProperties(obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};
	
	var possibleConstructorReturn = function possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && ((typeof call === 'undefined' ? 'undefined' : _typeof2(call)) === "object" || typeof call === "function") ? call : self;
	};
	
	// 
	var isPlainObject = function isPlainObject(x) {
	  return (typeof x === 'undefined' ? 'undefined' : _typeof(x)) === 'object' && x.constructor === Object;
	};
	
	// 
	
	
	/**
	 * Parse errors.md and turn it into a simple hash of code: message
	 */
	var ERRORS =  false ? {
	  "1": "Cannot create styled-component for component: %s.\n\n",
	  "2": "Can't collect styles once you've consumed a `ServerStyleSheet`'s styles! `ServerStyleSheet` is a one off instance for each server-side render cycle.\n\n* Are you trying to reuse it across renders?\n* Are you accidentally calling collectStyles twice?\n\n",
	  "3": "Streaming SSR is only supported in a Node.js environment; Please do not try to call this method in the browser.\n\n",
	  "4": "The `StyleSheetManager` expects a valid target or sheet prop!\n\n* Does this error occur on the client and is your target falsy?\n* Does this error occur on the server and is the sheet falsy?\n\n",
	  "5": "The clone method cannot be used on the client!\n\n* Are you running in a client-like environment on the server?\n* Are you trying to run SSR on the client?\n\n",
	  "6": "Trying to insert a new style tag, but the given Node is unmounted!\n\n* Are you using a custom target that isn't mounted?\n* Does your document not have a valid head element?\n* Have you accidentally removed a style tag manually?\n\n",
	  "7": "ThemeProvider: Please return an object from your \"theme\" prop function, e.g.\n\n```js\ntheme={() => ({})}\n```\n\n",
	  "8": "ThemeProvider: Please make your \"theme\" prop an object.\n\n",
	  "9": "Missing document `<head>`\n\n",
	  "10": "Cannot find a StyleSheet instance. Usually this happens if there are multiple copies of styled-components loaded at once. Check out this issue for how to troubleshoot and fix the common cases where this situation can happen: https://github.com/styled-components/styled-components/issues/1941#issuecomment-417862021\n\n",
	  "11": "A plain React class (%s) has been interpolated into styles, probably as a component selector (https://www.styled-components.com/docs/advanced#referring-to-other-components). Only styled-component classes can be targeted in this fashion."
	} : {};
	
	/**
	 * super basic version of sprintf
	 */
	function format() {
	  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  var a = args[0];
	  var b = [];
	  var c = void 0;
	
	  for (c = 1; c < args.length; c += 1) {
	    b.push(args[c]);
	  }
	
	  b.forEach(function (d) {
	    a = a.replace(/%[a-z]/, d);
	  });
	
	  return a;
	}
	
	/**
	 * Create an error file out of errors.md for development and a simple web link to the full errors
	 * in production mode.
	 */
	
	var StyledComponentsError = function (_Error) {
	  inherits(StyledComponentsError, _Error);
	
	  function StyledComponentsError(code) {
	    classCallCheck(this, StyledComponentsError);
	
	    for (var _len2 = arguments.length, interpolations = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	      interpolations[_key2 - 1] = arguments[_key2];
	    }
	
	    if (true) {
	      var _this = possibleConstructorReturn(this, _Error.call(this, 'An error occurred. See https://github.com/styled-components/styled-components/blob/master/src/utils/errors.md#' + code + ' for more information. ' + (interpolations ? 'Additional arguments: ' + interpolations.join(', ') : '')));
	    } else {
	      var _this = possibleConstructorReturn(this, _Error.call(this, format.apply(undefined, [ERRORS[code]].concat(interpolations))));
	    }
	    return possibleConstructorReturn(_this);
	  }
	
	  return StyledComponentsError;
	}(Error);
	
	// 
	
	var objToCss = function objToCss(obj, prevKey) {
	  var css = Object.keys(obj).filter(function (key) {
	    var chunk = obj[key];
	    return chunk !== undefined && chunk !== null && chunk !== false && chunk !== '';
	  }).map(function (key) {
	    if (isPlainObject(obj[key])) return objToCss(obj[key], key);
	    return hyphenate(key) + ': ' + obj[key] + ';';
	  }).join(' ');
	  return prevKey ? prevKey + ' {\n  ' + css + '\n}' : css;
	};
	
	var flatten = function flatten(chunks, executionContext) {
	  return chunks.reduce(function (ruleSet, chunk) {
	    /* Remove falsey values */
	    if (chunk === undefined || chunk === null || chunk === false || chunk === '') {
	      return ruleSet;
	    }
	
	    /* Flatten ruleSet */
	    if (Array.isArray(chunk)) {
	      ruleSet.push.apply(ruleSet, flatten(chunk, executionContext));
	      return ruleSet;
	    }
	
	    /* Handle other components */
	    if (chunk.hasOwnProperty('styledComponentId')) {
	      // $FlowFixMe not sure how to make this pass
	      ruleSet.push('.' + chunk.styledComponentId);
	      return ruleSet;
	    }
	
	    /* Either execute or defer the function */
	    if (typeof chunk === 'function') {
	      if (executionContext) {
	        var nextChunk = chunk(executionContext);
	        /* Throw if a React Element was given styles */
	        if (React__default.isValidElement(nextChunk)) {
	          var elementName = chunk.displayName || chunk.name;
	          throw new StyledComponentsError(11, elementName);
	        }
	        ruleSet.push.apply(ruleSet, flatten([nextChunk], executionContext));
	      } else ruleSet.push(chunk);
	
	      return ruleSet;
	    }
	
	    /* Handle objects */
	    ruleSet.push(
	    // $FlowFixMe have to add %checks somehow to isPlainObject
	    isPlainObject(chunk) ? objToCss(chunk) : chunk.toString());
	
	    return ruleSet;
	  }, []);
	};
	
	// 
	
	var COMMENT_REGEX = /^\s*\/\/.*$/gm;
	
	// NOTE: This stylis instance is only used to split rules from SSR'd style tags
	var stylisSplitter = new Stylis({
	  global: false,
	  cascade: true,
	  keyframe: false,
	  prefix: false,
	  compress: false,
	  semicolon: true
	});
	
	var stylis = new Stylis({
	  global: false,
	  cascade: true,
	  keyframe: false,
	  prefix: true,
	  compress: false,
	  semicolon: false // NOTE: This means "autocomplete missing semicolons"
	});
	
	// Wrap `insertRulePlugin to build a list of rules,
	// and then make our own plugin to return the rules. This
	// makes it easier to hook into the existing SSR architecture
	
	var parsingRules = [];
	// eslint-disable-next-line consistent-return
	var returnRulesPlugin = function returnRulesPlugin(context) {
	  if (context === -2) {
	    var parsedRules = parsingRules;
	    parsingRules = [];
	    return parsedRules;
	  }
	};
	
	var parseRulesPlugin = _insertRulePlugin(function (rule) {
	  parsingRules.push(rule);
	});
	
	stylis.use([parseRulesPlugin, returnRulesPlugin]);
	stylisSplitter.use([parseRulesPlugin, returnRulesPlugin]);
	
	var stringifyRules = function stringifyRules(rules, selector, prefix) {
	  var flatCSS = rules.join('').replace(COMMENT_REGEX, ''); // replace JS comments
	
	  var cssStr = selector && prefix ? prefix + ' ' + selector + ' { ' + flatCSS + ' }' : flatCSS;
	
	  return stylis(prefix || !selector ? '' : selector, cssStr);
	};
	
	var splitByRules = function splitByRules(css) {
	  return stylisSplitter('', css);
	};
	
	// 
	
	function isStyledComponent(target) /* : %checks */{
	  return (
	    // $FlowFixMe TODO: flow for styledComponentId
	    typeof target === 'function' && typeof target.styledComponentId === 'string'
	  );
	}
	
	// 
	
	/* This function is DEPRECATED and will be removed on the next major version release.
	 * It was needed to rehydrate all style blocks prepended to chunks before React
	 * tries to rehydrate its HTML stream. Since the master StyleSheet will now detect
	 * the use of streamed style tags and will perform the rehydration earlier when needed
	 * this function will not be needed anymore */
	function consolidateStreamedStyles() {
	  if (false) {
	    // eslint-disable-next-line no-console
	    console.warn('styled-components automatically does streaming SSR rehydration now.\n' + 'Calling consolidateStreamedStyles manually is no longer necessary and a noop now.\n' + '- Please remove the consolidateStreamedStyles call from your client.');
	  }
	}
	
	// 
	/* eslint-disable no-bitwise */
	
	/* This is the "capacity" of our alphabet i.e. 2x26 for all letters plus their capitalised
	 * counterparts */
	var charsLength = 52;
	
	/* start at 75 for 'a' until 'z' (25) and then start at 65 for capitalised letters */
	var getAlphabeticChar = function getAlphabeticChar(code) {
	  return String.fromCharCode(code + (code > 25 ? 39 : 97));
	};
	
	/* input a number, usually a hash and convert it to base-52 */
	var generateAlphabeticName = function generateAlphabeticName(code) {
	  var name = '';
	  var x = void 0;
	
	  /* get a char and divide by alphabet-length */
	  for (x = code; x > charsLength; x = Math.floor(x / charsLength)) {
	    name = getAlphabeticChar(x % charsLength) + name;
	  }
	
	  return getAlphabeticChar(x % charsLength) + name;
	};
	
	// 
	
	var interleave = function interleave(strings, interpolations) {
	  var result = [strings[0]];
	
	  for (var i = 0, len = interpolations.length; i < len; i += 1) {
	    result.push(interpolations[i], strings[i + 1]);
	  }
	
	  return result;
	};
	
	// 
	var EMPTY_ARRAY = Object.freeze([]);
	var EMPTY_OBJECT = Object.freeze({});
	
	// 
	
	var css = function css(styles) {
	  for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    interpolations[_key - 1] = arguments[_key];
	  }
	
	  if (typeof styles === 'function' || isPlainObject(styles)) {
	    // $FlowFixMe
	    return flatten(interleave(EMPTY_ARRAY, [styles].concat(interpolations)));
	  }
	
	  // $FlowFixMe
	  return flatten(interleave(styles, interpolations));
	};
	
	// 
	
	
	var SC_ATTR = typeof process !== 'undefined' && process.env.SC_ATTR || 'data-styled-components';
	var SC_STREAM_ATTR = 'data-styled-streamed';
	var CONTEXT_KEY = '__styled-components-stylesheet__';
	
	var IS_BROWSER = typeof window !== 'undefined' && 'HTMLElement' in window;
	
	var DISABLE_SPEEDY = ("production") !== 'production';
	
	// 
	var SC_COMPONENT_ID = /^[^\S\n]*?\/\* sc-component-id:\s*(\S+)\s+\*\//gm;
	
	var extractComps = function extractComps(maybeCSS) {
	  var css = '' + (maybeCSS || ''); // Definitely a string, and a clone
	  var existingComponents = [];
	  css.replace(SC_COMPONENT_ID, function (match, componentId, matchIndex) {
	    existingComponents.push({ componentId: componentId, matchIndex: matchIndex });
	    return match;
	  });
	  return existingComponents.map(function (_ref, i) {
	    var componentId = _ref.componentId,
	        matchIndex = _ref.matchIndex;
	
	    var nextComp = existingComponents[i + 1];
	    var cssFromDOM = nextComp ? css.slice(matchIndex, nextComp.matchIndex) : css.slice(matchIndex);
	    return { componentId: componentId, cssFromDOM: cssFromDOM };
	  });
	};
	
	// 
	/* eslint-disable camelcase, no-undef */
	
	var getNonce = function getNonce() {
	  return typeof __webpack_nonce__ !== 'undefined' ? __webpack_nonce__ : null;
	};
	
	// 
	// Helper to call a given function, only once
	var once = function once(cb) {
	  var called = false;
	
	  return function () {
	    if (!called) {
	      called = true;
	      cb();
	    }
	  };
	};
	
	// 
	/* These are helpers for the StyleTags to keep track of the injected
	 * rule names for each (component) ID that they're keeping track of.
	 * They're crucial for detecting whether a name has already been
	 * injected.
	 * (This excludes rehydrated names) */
	
	/* adds a new ID:name pairing to a names dictionary */
	var addNameForId = function addNameForId(names, id, name) {
	  if (name) {
	    // eslint-disable-next-line no-param-reassign
	    var namesForId = names[id] || (names[id] = Object.create(null));
	    namesForId[name] = true;
	  }
	};
	
	/* resets an ID entirely by overwriting it in the dictionary */
	var resetIdNames = function resetIdNames(names, id) {
	  // eslint-disable-next-line no-param-reassign
	  names[id] = Object.create(null);
	};
	
	/* factory for a names dictionary checking the existance of an ID:name pairing */
	var hasNameForId = function hasNameForId(names) {
	  return function (id, name) {
	    return names[id] !== undefined && names[id][name];
	  };
	};
	
	/* stringifies names for the html/element output */
	var stringifyNames = function stringifyNames(names) {
	  var str = '';
	  // eslint-disable-next-line guard-for-in
	  for (var id in names) {
	    str += Object.keys(names[id]).join(' ') + ' ';
	  }
	  return str.trim();
	};
	
	/* clones the nested names dictionary */
	var cloneNames = function cloneNames(names) {
	  var clone = Object.create(null);
	  // eslint-disable-next-line guard-for-in
	  for (var id in names) {
	    clone[id] = _extends({}, names[id]);
	  }
	  return clone;
	};
	
	// 
	
	/* These are helpers that deal with the insertRule (aka speedy) API
	 * They are used in the StyleTags and specifically the speedy tag
	 */
	
	/* retrieve a sheet for a given style tag */
	var sheetForTag = function sheetForTag(tag) {
	  // $FlowFixMe
	  if (tag.sheet) return tag.sheet;
	
	  /* Firefox quirk requires us to step through all stylesheets to find one owned by the given tag */
	  var size = document.styleSheets.length;
	  for (var i = 0; i < size; i += 1) {
	    var sheet = document.styleSheets[i];
	    // $FlowFixMe
	    if (sheet.ownerNode === tag) return sheet;
	  }
	
	  /* we should always be able to find a tag */
	  throw new StyledComponentsError(10);
	};
	
	/* insert a rule safely and return whether it was actually injected */
	var safeInsertRule = function safeInsertRule(sheet, cssRule, index) {
	  /* abort early if cssRule string is falsy */
	  if (!cssRule) return false;
	
	  var maxIndex = sheet.cssRules.length;
	
	  try {
	    /* use insertRule and cap passed index with maxIndex (no of cssRules) */
	    sheet.insertRule(cssRule, index <= maxIndex ? index : maxIndex);
	  } catch (err) {
	    /* any error indicates an invalid rule */
	    return false;
	  }
	
	  return true;
	};
	
	/* deletes `size` rules starting from `removalIndex` */
	var deleteRules = function deleteRules(sheet, removalIndex, size) {
	  var lowerBound = removalIndex - size;
	  for (var i = removalIndex; i > lowerBound; i -= 1) {
	    sheet.deleteRule(i);
	  }
	};
	
	// 
	
	/* this marker separates component styles and is important for rehydration */
	var makeTextMarker = function makeTextMarker(id) {
	  return '\n/* sc-component-id: ' + id + ' */\n';
	};
	
	/* add up all numbers in array up until and including the index */
	var addUpUntilIndex = function addUpUntilIndex(sizes, index) {
	  var totalUpToIndex = 0;
	  for (var i = 0; i <= index; i += 1) {
	    totalUpToIndex += sizes[i];
	  }
	
	  return totalUpToIndex;
	};
	
	/* create a new style tag after lastEl */
	var makeStyleTag = function makeStyleTag(target, tagEl, insertBefore) {
	  var el = document.createElement('style');
	  el.setAttribute(SC_ATTR, '');
	
	  var nonce = getNonce();
	  if (nonce) {
	    el.setAttribute('nonce', nonce);
	  }
	
	  /* Work around insertRule quirk in EdgeHTML */
	  el.appendChild(document.createTextNode(''));
	
	  if (target && !tagEl) {
	    /* Append to target when no previous element was passed */
	    target.appendChild(el);
	  } else {
	    if (!tagEl || !target || !tagEl.parentNode) {
	      throw new StyledComponentsError(6);
	    }
	
	    /* Insert new style tag after the previous one */
	    tagEl.parentNode.insertBefore(el, insertBefore ? tagEl : tagEl.nextSibling);
	  }
	
	  return el;
	};
	
	/* takes a css factory function and outputs an html styled tag factory */
	var wrapAsHtmlTag = function wrapAsHtmlTag(css, names) {
	  return function (additionalAttrs) {
	    var nonce = getNonce();
	    var attrs = [nonce && 'nonce="' + nonce + '"', SC_ATTR + '="' + stringifyNames(names) + '"', additionalAttrs];
	
	    var htmlAttr = attrs.filter(Boolean).join(' ');
	    return '<style ' + htmlAttr + '>' + css() + '</style>';
	  };
	};
	
	/* takes a css factory function and outputs an element factory */
	var wrapAsElement = function wrapAsElement(css, names) {
	  return function () {
	    var _props;
	
	    var props = (_props = {}, _props[SC_ATTR] = stringifyNames(names), _props);
	
	    var nonce = getNonce();
	    if (nonce) {
	      // $FlowFixMe
	      props.nonce = nonce;
	    }
	
	    // eslint-disable-next-line react/no-danger
	    return React__default.createElement('style', _extends({}, props, { dangerouslySetInnerHTML: { __html: css() } }));
	  };
	};
	
	var getIdsFromMarkersFactory = function getIdsFromMarkersFactory(markers) {
	  return function () {
	    return Object.keys(markers);
	  };
	};
	
	/* speedy tags utilise insertRule */
	var makeSpeedyTag = function makeSpeedyTag(el, getImportRuleTag) {
	  var names = Object.create(null);
	  var markers = Object.create(null);
	  var sizes = [];
	
	  var extractImport = getImportRuleTag !== undefined;
	  /* indicates whther getImportRuleTag was called */
	  var usedImportRuleTag = false;
	
	  var insertMarker = function insertMarker(id) {
	    var prev = markers[id];
	    if (prev !== undefined) {
	      return prev;
	    }
	
	    markers[id] = sizes.length;
	    sizes.push(0);
	    resetIdNames(names, id);
	
	    return markers[id];
	  };
	
	  var insertRules = function insertRules(id, cssRules, name) {
	    var marker = insertMarker(id);
	    var sheet = sheetForTag(el);
	    var insertIndex = addUpUntilIndex(sizes, marker);
	
	    var injectedRules = 0;
	    var importRules = [];
	    var cssRulesSize = cssRules.length;
	
	    for (var i = 0; i < cssRulesSize; i += 1) {
	      var cssRule = cssRules[i];
	      var mayHaveImport = extractImport; /* @import rules are reordered to appear first */
	      if (mayHaveImport && cssRule.indexOf('@import') !== -1) {
	        importRules.push(cssRule);
	      } else if (safeInsertRule(sheet, cssRule, insertIndex + injectedRules)) {
	        mayHaveImport = false;
	        injectedRules += 1;
	      }
	    }
	
	    if (extractImport && importRules.length > 0) {
	      usedImportRuleTag = true;
	      // $FlowFixMe
	      getImportRuleTag().insertRules(id + '-import', importRules);
	    }
	
	    sizes[marker] += injectedRules; /* add up no of injected rules */
	    addNameForId(names, id, name);
	  };
	
	  var removeRules = function removeRules(id) {
	    var marker = markers[id];
	    if (marker === undefined) return;
	
	    var size = sizes[marker];
	    var sheet = sheetForTag(el);
	    var removalIndex = addUpUntilIndex(sizes, marker);
	    deleteRules(sheet, removalIndex, size);
	    sizes[marker] = 0;
	    resetIdNames(names, id);
	
	    if (extractImport && usedImportRuleTag) {
	      // $FlowFixMe
	      getImportRuleTag().removeRules(id + '-import');
	    }
	  };
	
	  var css = function css() {
	    var _sheetForTag = sheetForTag(el),
	        cssRules = _sheetForTag.cssRules;
	
	    var str = '';
	
	    // eslint-disable-next-line guard-for-in
	    for (var id in markers) {
	      str += makeTextMarker(id);
	      var marker = markers[id];
	      var end = addUpUntilIndex(sizes, marker);
	      var size = sizes[marker];
	      for (var i = end - size; i < end; i += 1) {
	        var rule = cssRules[i];
	        if (rule !== undefined) {
	          str += rule.cssText;
	        }
	      }
	    }
	
	    return str;
	  };
	
	  return {
	    clone: function clone() {
	      throw new StyledComponentsError(5);
	    },
	
	    css: css,
	    getIds: getIdsFromMarkersFactory(markers),
	    hasNameForId: hasNameForId(names),
	    insertMarker: insertMarker,
	    insertRules: insertRules,
	    removeRules: removeRules,
	    sealed: false,
	    styleTag: el,
	    toElement: wrapAsElement(css, names),
	    toHTML: wrapAsHtmlTag(css, names)
	  };
	};
	
	var makeTextNode = function makeTextNode(id) {
	  return document.createTextNode(makeTextMarker(id));
	};
	
	var makeBrowserTag = function makeBrowserTag(el, getImportRuleTag) {
	  var names = Object.create(null);
	  var markers = Object.create(null);
	
	  var extractImport = getImportRuleTag !== undefined;
	
	  /* indicates whther getImportRuleTag was called */
	  var usedImportRuleTag = false;
	
	  var insertMarker = function insertMarker(id) {
	    var prev = markers[id];
	    if (prev !== undefined) {
	      return prev;
	    }
	
	    markers[id] = makeTextNode(id);
	    el.appendChild(markers[id]);
	    names[id] = Object.create(null);
	
	    return markers[id];
	  };
	
	  var insertRules = function insertRules(id, cssRules, name) {
	    var marker = insertMarker(id);
	    var importRules = [];
	    var cssRulesSize = cssRules.length;
	
	    for (var i = 0; i < cssRulesSize; i += 1) {
	      var rule = cssRules[i];
	      var mayHaveImport = extractImport;
	      if (mayHaveImport && rule.indexOf('@import') !== -1) {
	        importRules.push(rule);
	      } else {
	        mayHaveImport = false;
	        var separator = i === cssRulesSize - 1 ? '' : ' ';
	        marker.appendData('' + rule + separator);
	      }
	    }
	
	    addNameForId(names, id, name);
	
	    if (extractImport && importRules.length > 0) {
	      usedImportRuleTag = true;
	      // $FlowFixMe
	      getImportRuleTag().insertRules(id + '-import', importRules);
	    }
	  };
	
	  var removeRules = function removeRules(id) {
	    var marker = markers[id];
	    if (marker === undefined) return;
	
	    /* create new empty text node and replace the current one */
	    var newMarker = makeTextNode(id);
	    el.replaceChild(newMarker, marker);
	    markers[id] = newMarker;
	    resetIdNames(names, id);
	
	    if (extractImport && usedImportRuleTag) {
	      // $FlowFixMe
	      getImportRuleTag().removeRules(id + '-import');
	    }
	  };
	
	  var css = function css() {
	    var str = '';
	    // eslint-disable-next-line guard-for-in
	    for (var id in markers) {
	      str += markers[id].data;
	    }
	    return str;
	  };
	
	  return {
	    clone: function clone() {
	      throw new StyledComponentsError(5);
	    },
	
	    css: css,
	    getIds: getIdsFromMarkersFactory(markers),
	    hasNameForId: hasNameForId(names),
	    insertMarker: insertMarker,
	    insertRules: insertRules,
	    removeRules: removeRules,
	    sealed: false,
	    styleTag: el,
	    toElement: wrapAsElement(css, names),
	    toHTML: wrapAsHtmlTag(css, names)
	  };
	};
	
	var makeServerTagInternal = function makeServerTagInternal(namesArg, markersArg) {
	  var names = namesArg === undefined ? Object.create(null) : namesArg;
	  var markers = markersArg === undefined ? Object.create(null) : markersArg;
	
	  var insertMarker = function insertMarker(id) {
	    var prev = markers[id];
	    if (prev !== undefined) {
	      return prev;
	    }
	
	    return markers[id] = [''];
	  };
	
	  var insertRules = function insertRules(id, cssRules, name) {
	    var marker = insertMarker(id);
	    marker[0] += cssRules.join(' ');
	    addNameForId(names, id, name);
	  };
	
	  var removeRules = function removeRules(id) {
	    var marker = markers[id];
	    if (marker === undefined) return;
	    marker[0] = '';
	    resetIdNames(names, id);
	  };
	
	  var css = function css() {
	    var str = '';
	    // eslint-disable-next-line guard-for-in
	    for (var id in markers) {
	      var cssForId = markers[id][0];
	      if (cssForId) {
	        str += makeTextMarker(id) + cssForId;
	      }
	    }
	    return str;
	  };
	
	  var clone = function clone() {
	    var namesClone = cloneNames(names);
	    var markersClone = Object.create(null);
	
	    // eslint-disable-next-line guard-for-in
	    for (var id in markers) {
	      markersClone[id] = [markers[id][0]];
	    }
	
	    return makeServerTagInternal(namesClone, markersClone);
	  };
	
	  var tag = {
	    clone: clone,
	    css: css,
	    getIds: getIdsFromMarkersFactory(markers),
	    hasNameForId: hasNameForId(names),
	    insertMarker: insertMarker,
	    insertRules: insertRules,
	    removeRules: removeRules,
	    sealed: false,
	    styleTag: null,
	    toElement: wrapAsElement(css, names),
	    toHTML: wrapAsHtmlTag(css, names)
	  };
	
	  return tag;
	};
	
	var makeServerTag = function makeServerTag() {
	  return makeServerTagInternal();
	};
	
	var makeTag = function makeTag(target, tagEl, forceServer, insertBefore, getImportRuleTag) {
	  if (IS_BROWSER && !forceServer) {
	    var el = makeStyleTag(target, tagEl, insertBefore);
	
	    if (DISABLE_SPEEDY) {
	      return makeBrowserTag(el, getImportRuleTag);
	    } else {
	      return makeSpeedyTag(el, getImportRuleTag);
	    }
	  }
	
	  return makeServerTag();
	};
	
	/* wraps a given tag so that rehydration is performed once when necessary */
	var makeRehydrationTag = function makeRehydrationTag(tag, els, extracted, immediateRehydration) {
	  /* rehydration function that adds all rules to the new tag */
	  var rehydrate = once(function () {
	    /* add all extracted components to the new tag */
	    for (var i = 0, len = extracted.length; i < len; i += 1) {
	      var _extracted$i = extracted[i],
	          componentId = _extracted$i.componentId,
	          cssFromDOM = _extracted$i.cssFromDOM;
	
	      var cssRules = splitByRules(cssFromDOM);
	      tag.insertRules(componentId, cssRules);
	    }
	
	    /* remove old HTMLStyleElements, since they have been rehydrated */
	    for (var _i = 0, _len = els.length; _i < _len; _i += 1) {
	      var el = els[_i];
	      if (el.parentNode) {
	        el.parentNode.removeChild(el);
	      }
	    }
	  });
	
	  if (immediateRehydration) rehydrate();
	
	  return _extends({}, tag, {
	    /* add rehydration hook to insertion methods */
	    insertMarker: function insertMarker(id) {
	      rehydrate();
	      return tag.insertMarker(id);
	    },
	    insertRules: function insertRules(id, cssRules, name) {
	      rehydrate();
	      return tag.insertRules(id, cssRules, name);
	    }
	  });
	};
	
	// 
	
	var SPLIT_REGEX = /\s+/;
	
	/* determine the maximum number of components before tags are sharded */
	var MAX_SIZE = void 0;
	if (IS_BROWSER) {
	  /* in speedy mode we can keep a lot more rules in a sheet before a slowdown can be expected */
	  MAX_SIZE = DISABLE_SPEEDY ? 40 : 1000;
	} else {
	  /* for servers we do not need to shard at all */
	  MAX_SIZE = -1;
	}
	
	var sheetRunningId = 0;
	var master = void 0;
	
	var StyleSheet = function () {
	  /* a map from ids to tags */
	  /* deferred rules for a given id */
	  /* this is used for not reinjecting rules via hasNameForId() */
	  /* when rules for an id are removed using remove() we have to ignore rehydratedNames for it */
	  /* a list of tags belonging to this StyleSheet */
	  /* a tag for import rules */
	  /* current capacity until a new tag must be created */
	  /* children (aka clones) of this StyleSheet inheriting all and future injections */
	
	  function StyleSheet() {
	    var _this = this;
	
	    var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : IS_BROWSER ? document.head : null;
	    var forceServer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	    classCallCheck(this, StyleSheet);
	
	    this.getImportRuleTag = function () {
	      var importRuleTag = _this.importRuleTag;
	
	      if (importRuleTag !== undefined) {
	        return importRuleTag;
	      }
	
	      var firstTag = _this.tags[0];
	      var insertBefore = true;
	
	      return _this.importRuleTag = makeTag(_this.target, firstTag ? firstTag.styleTag : null, _this.forceServer, insertBefore);
	    };
	
	    sheetRunningId += 1;
	    this.id = sheetRunningId;
	    this.forceServer = forceServer;
	    this.target = forceServer ? null : target;
	    this.tagMap = {};
	    this.deferred = {};
	    this.rehydratedNames = {};
	    this.ignoreRehydratedNames = {};
	    this.tags = [];
	    this.capacity = 1;
	    this.clones = [];
	  }
	
	  /* rehydrate all SSR'd style tags */
	
	  StyleSheet.prototype.rehydrate = function rehydrate() {
	    if (!IS_BROWSER || this.forceServer) {
	      return this;
	    }
	
	    var els = [];
	    var extracted = [];
	    var isStreamed = false;
	
	    /* retrieve all of our SSR style elements from the DOM */
	    var nodes = document.querySelectorAll('style[' + SC_ATTR + ']');
	    var nodesSize = nodes.length;
	
	    /* abort rehydration if no previous style tags were found */
	    if (nodesSize === 0) {
	      return this;
	    }
	
	    for (var i = 0; i < nodesSize; i += 1) {
	      // $FlowFixMe: We can trust that all elements in this query are style elements
	      var el = nodes[i];
	
	      /* check if style tag is a streamed tag */
	      if (!isStreamed) isStreamed = !!el.getAttribute(SC_STREAM_ATTR);
	
	      /* retrieve all component names */
	      var elNames = (el.getAttribute(SC_ATTR) || '').trim().split(SPLIT_REGEX);
	      var elNamesSize = elNames.length;
	      for (var j = 0; j < elNamesSize; j += 1) {
	        var name = elNames[j];
	        /* add rehydrated name to sheet to avoid readding styles */
	        this.rehydratedNames[name] = true;
	      }
	
	      /* extract all components and their CSS */
	      extracted.push.apply(extracted, extractComps(el.textContent));
	
	      /* store original HTMLStyleElement */
	      els.push(el);
	    }
	
	    /* abort rehydration if nothing was extracted */
	    var extractedSize = extracted.length;
	    if (extractedSize === 0) {
	      return this;
	    }
	
	    /* create a tag to be used for rehydration */
	    var tag = this.makeTag(null);
	    var rehydrationTag = makeRehydrationTag(tag, els, extracted, isStreamed);
	
	    /* reset capacity and adjust MAX_SIZE by the initial size of the rehydration */
	    this.capacity = Math.max(1, MAX_SIZE - extractedSize);
	    this.tags.push(rehydrationTag);
	
	    /* retrieve all component ids */
	    for (var _j = 0; _j < extractedSize; _j += 1) {
	      this.tagMap[extracted[_j].componentId] = rehydrationTag;
	    }
	
	    return this;
	  };
	
	  /* retrieve a "master" instance of StyleSheet which is typically used when no other is available
	   * The master StyleSheet is targeted by injectGlobal, keyframes, and components outside of any
	    * StyleSheetManager's context */
	
	  /* reset the internal "master" instance */
	  StyleSheet.reset = function reset() {
	    var forceServer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	    master = new StyleSheet(undefined, forceServer).rehydrate();
	  };
	
	  /* adds "children" to the StyleSheet that inherit all of the parents' rules
	   * while their own rules do not affect the parent */
	
	  StyleSheet.prototype.clone = function clone() {
	    var sheet = new StyleSheet(this.target, this.forceServer);
	
	    /* add to clone array */
	    this.clones.push(sheet);
	
	    /* clone all tags */
	    sheet.tags = this.tags.map(function (tag) {
	      var ids = tag.getIds();
	      var newTag = tag.clone();
	
	      /* reconstruct tagMap */
	      for (var i = 0; i < ids.length; i += 1) {
	        sheet.tagMap[ids[i]] = newTag;
	      }
	
	      return newTag;
	    });
	
	    /* clone other maps */
	    sheet.rehydratedNames = _extends({}, this.rehydratedNames);
	    sheet.deferred = _extends({}, this.deferred);
	
	    return sheet;
	  };
	
	  /* force StyleSheet to create a new tag on the next injection */
	
	  StyleSheet.prototype.sealAllTags = function sealAllTags() {
	    this.capacity = 1;
	
	    this.tags.forEach(function (tag) {
	      // eslint-disable-next-line no-param-reassign
	      tag.sealed = true;
	    });
	  };
	
	  StyleSheet.prototype.makeTag = function makeTag$$1(tag) {
	    var lastEl = tag ? tag.styleTag : null;
	    var insertBefore = false;
	
	    return makeTag(this.target, lastEl, this.forceServer, insertBefore, this.getImportRuleTag);
	  };
	
	  /* get a tag for a given componentId, assign the componentId to one, or shard */
	  StyleSheet.prototype.getTagForId = function getTagForId(id) {
	    /* simply return a tag, when the componentId was already assigned one */
	    var prev = this.tagMap[id];
	    if (prev !== undefined && !prev.sealed) {
	      return prev;
	    }
	
	    var tag = this.tags[this.tags.length - 1];
	
	    /* shard (create a new tag) if the tag is exhausted (See MAX_SIZE) */
	    this.capacity -= 1;
	
	    if (this.capacity === 0) {
	      this.capacity = MAX_SIZE;
	      tag = this.makeTag(tag);
	      this.tags.push(tag);
	    }
	
	    return this.tagMap[id] = tag;
	  };
	
	  /* mainly for injectGlobal to check for its id */
	
	  StyleSheet.prototype.hasId = function hasId(id) {
	    return this.tagMap[id] !== undefined;
	  };
	
	  /* caching layer checking id+name to already have a corresponding tag and injected rules */
	
	  StyleSheet.prototype.hasNameForId = function hasNameForId(id, name) {
	    /* exception for rehydrated names which are checked separately */
	    if (this.ignoreRehydratedNames[id] === undefined && this.rehydratedNames[name]) {
	      return true;
	    }
	
	    var tag = this.tagMap[id];
	    return tag !== undefined && tag.hasNameForId(id, name);
	  };
	
	  /* registers a componentId and registers it on its tag */
	
	  StyleSheet.prototype.deferredInject = function deferredInject(id, cssRules) {
	    /* don't inject when the id is already registered */
	    if (this.tagMap[id] !== undefined) return;
	
	    var clones = this.clones;
	
	    for (var i = 0; i < clones.length; i += 1) {
	      clones[i].deferredInject(id, cssRules);
	    }
	
	    this.getTagForId(id).insertMarker(id);
	    this.deferred[id] = cssRules;
	  };
	
	  /* injects rules for a given id with a name that will need to be cached */
	
	  StyleSheet.prototype.inject = function inject(id, cssRules, name) {
	    var clones = this.clones;
	
	    for (var i = 0; i < clones.length; i += 1) {
	      clones[i].inject(id, cssRules, name);
	    }
	
	    var tag = this.getTagForId(id);
	
	    /* add deferred rules for component */
	    if (this.deferred[id] !== undefined) {
	      // Combine passed cssRules with previously deferred CSS rules
	      // NOTE: We cannot mutate the deferred array itself as all clones
	      // do the same (see clones[i].inject)
	      var rules = this.deferred[id].concat(cssRules);
	      tag.insertRules(id, rules, name);
	
	      this.deferred[id] = undefined;
	    } else {
	      tag.insertRules(id, cssRules, name);
	    }
	  };
	
	  /* removes all rules for a given id, which doesn't remove its marker but resets it */
	
	  StyleSheet.prototype.remove = function remove(id) {
	    var tag = this.tagMap[id];
	    if (tag === undefined) return;
	
	    var clones = this.clones;
	
	    for (var i = 0; i < clones.length; i += 1) {
	      clones[i].remove(id);
	    }
	
	    /* remove all rules from the tag */
	    tag.removeRules(id);
	    /* ignore possible rehydrated names */
	    this.ignoreRehydratedNames[id] = true;
	    /* delete possible deferred rules */
	    this.deferred[id] = undefined;
	  };
	
	  StyleSheet.prototype.toHTML = function toHTML() {
	    return this.tags.map(function (tag) {
	      return tag.toHTML();
	    }).join('');
	  };
	
	  StyleSheet.prototype.toReactElements = function toReactElements() {
	    var id = this.id;
	
	    return this.tags.map(function (tag, i) {
	      var key = 'sc-' + id + '-' + i;
	      return React.cloneElement(tag.toElement(), { key: key });
	    });
	  };
	
	  createClass(StyleSheet, null, [{
	    key: 'master',
	    get: function get$$1() {
	      return master || (master = new StyleSheet().rehydrate());
	    }
	
	    /* NOTE: This is just for backwards-compatibility with jest-styled-components */
	
	  }, {
	    key: 'instance',
	    get: function get$$1() {
	      return StyleSheet.master;
	    }
	  }]);
	  return StyleSheet;
	}();
	
	var _StyleSheetManager$ch;
	
	var StyleSheetManager = function (_Component) {
	  inherits(StyleSheetManager, _Component);
	
	  function StyleSheetManager() {
	    classCallCheck(this, StyleSheetManager);
	    return possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  StyleSheetManager.prototype.getChildContext = function getChildContext() {
	    var _ref;
	
	    return _ref = {}, _ref[CONTEXT_KEY] = this.sheetInstance, _ref;
	  };
	
	  StyleSheetManager.prototype.componentWillMount = function componentWillMount() {
	    if (this.props.sheet) {
	      this.sheetInstance = this.props.sheet;
	    } else if (this.props.target) {
	      this.sheetInstance = new StyleSheet(this.props.target);
	    } else {
	      throw new StyledComponentsError(4);
	    }
	  };
	
	  StyleSheetManager.prototype.render = function render() {
	    /* eslint-disable react/prop-types */
	    // Flow v0.43.1 will report an error accessing the `children` property,
	    // but v0.47.0 will not. It is necessary to use a type cast instead of
	    // a "fixme" comment to satisfy both Flow versions.
	    return React__default.Children.only(this.props.children);
	  };
	
	  return StyleSheetManager;
	}(React.Component);
	
	StyleSheetManager.childContextTypes = (_StyleSheetManager$ch = {}, _StyleSheetManager$ch[CONTEXT_KEY] = PropTypes.oneOfType([PropTypes.instanceOf(StyleSheet), PropTypes.instanceOf(ServerStyleSheet)]).isRequired, _StyleSheetManager$ch);
	 false ? StyleSheetManager.propTypes = {
	  sheet: PropTypes.oneOfType([PropTypes.instanceOf(StyleSheet), PropTypes.instanceOf(ServerStyleSheet)]),
	  target: PropTypes.shape({
	    appendChild: PropTypes.func.isRequired
	  })
	} : void 0;
	
	// 
	
	var ServerStyleSheet = function () {
	  function ServerStyleSheet() {
	    classCallCheck(this, ServerStyleSheet);
	
	    /* The master sheet might be reset, so keep a reference here */
	    this.masterSheet = StyleSheet.master;
	    this.instance = this.masterSheet.clone();
	    this.closed = false;
	  }
	
	  ServerStyleSheet.prototype.complete = function complete() {
	    if (!this.closed) {
	      /* Remove closed StyleSheets from the master sheet */
	      var index = this.masterSheet.clones.indexOf(this.instance);
	      this.masterSheet.clones.splice(index, 1);
	      this.closed = true;
	    }
	  };
	
	  ServerStyleSheet.prototype.collectStyles = function collectStyles(children) {
	    if (this.closed) {
	      throw new StyledComponentsError(2);
	    }
	
	    return React__default.createElement(StyleSheetManager, { sheet: this.instance }, children);
	  };
	
	  ServerStyleSheet.prototype.getStyleTags = function getStyleTags() {
	    this.complete();
	    return this.instance.toHTML();
	  };
	
	  ServerStyleSheet.prototype.getStyleElement = function getStyleElement() {
	    this.complete();
	    return this.instance.toReactElements();
	  };
	
	  ServerStyleSheet.prototype.interleaveWithNodeStream = function interleaveWithNodeStream(readableStream) {
	    var _this = this;
	
	    {
	      throw new StyledComponentsError(3);
	    }
	
	    /* the tag index keeps track of which tags have already been emitted */
	    var instance = this.instance;
	
	    var instanceTagIndex = 0;
	
	    var streamAttr = SC_STREAM_ATTR + '="true"';
	
	    var transformer = new stream.Transform({
	      transform: function appendStyleChunks(chunk, /* encoding */_, callback) {
	        var tags = instance.tags;
	
	        var html = '';
	
	        /* retrieve html for each new style tag */
	        for (; instanceTagIndex < tags.length; instanceTagIndex += 1) {
	          var tag = tags[instanceTagIndex];
	          html += tag.toHTML(streamAttr);
	        }
	
	        /* force our StyleSheets to emit entirely new tags */
	        instance.sealAllTags();
	
	        /* prepend style html to chunk */
	        this.push(html + chunk);
	        callback();
	      }
	    });
	
	    readableStream.on('end', function () {
	      return _this.complete();
	    });
	    readableStream.on('error', function (err) {
	      _this.complete();
	
	      // forward the error to the transform stream
	      transformer.emit('error', err);
	    });
	
	    return readableStream.pipe(transformer);
	  };
	
	  return ServerStyleSheet;
	}();
	
	// 
	
	var LIMIT = 200;
	
	var createWarnTooManyClasses = function createWarnTooManyClasses(displayName) {
	  var generatedClasses = {};
	  var warningSeen = false;
	
	  return function (className) {
	    if (!warningSeen) {
	      generatedClasses[className] = true;
	      if (Object.keys(generatedClasses).length >= LIMIT) {
	        // Unable to find latestRule in test environment.
	        /* eslint-disable no-console, prefer-template */
	        console.warn('Over ' + LIMIT + ' classes were generated for component ' + displayName + '. \n' + 'Consider using the attrs method, together with a style object for frequently changed styles.\n' + 'Example:\n' + '  const Component = styled.div.attrs({\n' + '    style: ({ background }) => ({\n' + '      background,\n' + '    }),\n' + '  })`width: 100%;`\n\n' + '  <Component />');
	        warningSeen = true;
	        generatedClasses = {};
	      }
	    }
	  };
	};
	
	// 
	
	var determineTheme = function determineTheme(props, fallbackTheme, defaultProps) {
	  // Props should take precedence over ThemeProvider, which should take precedence over
	  // defaultProps, but React automatically puts defaultProps on props.
	
	  /* eslint-disable react/prop-types */
	  var isDefaultTheme = defaultProps && props.theme === defaultProps.theme;
	  var theme = props.theme && !isDefaultTheme ? props.theme : fallbackTheme;
	  /* eslint-enable */
	
	  return theme;
	};
	
	// 
	var escapeRegex = /[[\].#*$><+~=|^:(),"'`-]+/g;
	var dashesAtEnds = /(^-|-$)/g;
	
	/**
	 * TODO: Explore using CSS.escape when it becomes more available
	 * in evergreen browsers.
	 */
	function escape(str) {
	  return str
	  // Replace all possible CSS selectors
	  .replace(escapeRegex, '-')
	
	  // Remove extraneous hyphens at the start and end
	  .replace(dashesAtEnds, '');
	}
	
	// 
	
	function getComponentName(target) {
	  return target.displayName || target.name || 'Component';
	}
	
	// 
	
	function isTag(target) /* : %checks */{
	  return typeof target === 'string';
	}
	
	// 
	
	function generateDisplayName(target) {
	  return isTag(target) ? 'styled.' + target : 'Styled(' + getComponentName(target) + ')';
	}
	
	// 
	/* eslint-disable max-len */
	/**
	 * Trying to avoid the unknown-prop errors on styled components by filtering by
	 * React's attribute whitelist.
	 *
	 * To regenerate this regex:
	 *
	 * 1. `npm i -g regexgen` (https://github.com/devongovett/regexgen)
	 * 2. Run `regexgen` with the list of space-separated words below as input
	 * 3. Surround the emitted regex with this: `/^(GENERATED_REGEX)$/` -- this will ensure a full string match
	 *    and no false positives from partials
	 * */
	/*
	children dangerouslySetInnerHTML key ref autoFocus defaultValue valueLink defaultChecked checkedLink innerHTML suppressContentEditableWarning onFocusIn onFocusOut className onCopy onCut onPaste onCompositionEnd onCompositionStart onCompositionUpdate onKeyDown onKeyPress onKeyUp onFocus onBlur onChange onInput onInvalid onSubmit onReset onClick onContextMenu onDoubleClick onDrag onDragEnd onDragEnter onDragExit onDragLeave onDragOver onDragStart onDrop onMouseDown onMouseEnter onMouseLeave onMouseMove onMouseOut onMouseOver onMouseUp onSelect onTouchCancel onTouchEnd onTouchMove onTouchStart onScroll onWheel onAbort onCanPlay onCanPlayThrough onDurationChange onEmptied onEncrypted onEnded onError onLoadedData onLoadedMetadata onLoadStart onPause onPlay onPlaying onProgress onRateChange onSeeked onSeeking onStalled onSuspend onTimeUpdate onVolumeChange onWaiting onLoad onAnimationStart onAnimationEnd onAnimationIteration onTransitionEnd onCopyCapture onCutCapture onPasteCapture onCompositionEndCapture onCompositionStartCapture onCompositionUpdateCapture onKeyDownCapture onKeyPressCapture onKeyUpCapture onFocusCapture onBlurCapture onChangeCapture onInputCapture onSubmitCapture onResetCapture onClickCapture onContextMenuCapture onDoubleClickCapture onDragCapture onDragEndCapture onDragEnterCapture onDragExitCapture onDragLeaveCapture onDragOverCapture onDragStartCapture onDropCapture onMouseDownCapture onMouseEnterCapture onMouseLeaveCapture onMouseMoveCapture onMouseOutCapture onMouseOverCapture onMouseUpCapture onSelectCapture onTouchCancelCapture onTouchEndCapture onTouchMoveCapture onTouchStartCapture onScrollCapture onWheelCapture onAbortCapture onCanPlayCapture onCanPlayThroughCapture onDurationChangeCapture onEmptiedCapture onEncryptedCapture onEndedCapture onErrorCapture onLoadedDataCapture onLoadedMetadataCapture onLoadStartCapture onPauseCapture onPlayCapture onPlayingCapture onProgressCapture onRateChangeCapture onSeekedCapture onSeekingCapture onStalledCapture onSuspendCapture onTimeUpdateCapture onVolumeChangeCapture onWaitingCapture onLoadCapture onAnimationStartCapture onAnimationEndCapture onAnimationIterationCapture onTransitionEndCapture accept acceptCharset accessKey action allowFullScreen allowTransparency alt as async autoComplete autoPlay capture cellPadding cellSpacing charSet challenge checked cite classID className cols colSpan content contentEditable contextMenu controlsList controls coords crossOrigin data dateTime default defer dir disabled download draggable encType form formAction formEncType formMethod formNoValidate formTarget frameBorder headers height hidden high href hrefLang htmlFor httpEquiv icon id inputMode integrity is keyParams keyType kind label lang list loop low manifest marginHeight marginWidth max maxLength media mediaGroup method min minLength multiple muted name nonce noValidate open optimum pattern placeholder playsInline poster preload profile radioGroup readOnly referrerPolicy rel required reversed role rows rowSpan sandbox scope scoped scrolling seamless selected shape size sizes span spellCheck src srcDoc srcLang srcSet start step style summary tabIndex target title type useMap value width wmode wrap about datatype inlist prefix property resource typeof vocab autoCapitalize autoCorrect autoSave color itemProp itemScope itemType itemID itemRef results security unselectable accentHeight accumulate additive alignmentBaseline allowReorder alphabetic amplitude arabicForm ascent attributeName attributeType autoReverse azimuth baseFrequency baseProfile baselineShift bbox begin bias by calcMode capHeight clip clipPath clipRule clipPathUnits colorInterpolation colorInterpolationFilters colorProfile colorRendering contentScriptType contentStyleType cursor cx cy d decelerate descent diffuseConstant direction display divisor dominantBaseline dur dx dy edgeMode elevation enableBackground end exponent externalResourcesRequired fill fillOpacity fillRule filter filterRes filterUnits floodColor floodOpacity focusable fontFamily fontSize fontSizeAdjust fontStretch fontStyle fontVariant fontWeight format from fx fy g1 g2 glyphName glyphOrientationHorizontal glyphOrientationVertical glyphRef gradientTransform gradientUnits hanging horizAdvX horizOriginX ideographic imageRendering in in2 intercept k k1 k2 k3 k4 kernelMatrix kernelUnitLength kerning keyPoints keySplines keyTimes lengthAdjust letterSpacing lightingColor limitingConeAngle local markerEnd markerMid markerStart markerHeight markerUnits markerWidth mask maskContentUnits maskUnits mathematical mode numOctaves offset opacity operator order orient orientation origin overflow overlinePosition overlineThickness paintOrder panose1 pathLength patternContentUnits patternTransform patternUnits pointerEvents points pointsAtX pointsAtY pointsAtZ preserveAlpha preserveAspectRatio primitiveUnits r radius refX refY renderingIntent repeatCount repeatDur requiredExtensions requiredFeatures restart result rotate rx ry scale seed shapeRendering slope spacing specularConstant specularExponent speed spreadMethod startOffset stdDeviation stemh stemv stitchTiles stopColor stopOpacity strikethroughPosition strikethroughThickness string stroke strokeDasharray strokeDashoffset strokeLinecap strokeLinejoin strokeMiterlimit strokeOpacity strokeWidth surfaceScale systemLanguage tableValues targetX targetY textAnchor textDecoration textRendering textLength to transform u1 u2 underlinePosition underlineThickness unicode unicodeBidi unicodeRange unitsPerEm vAlphabetic vHanging vIdeographic vMathematical values vectorEffect version vertAdvY vertOriginX vertOriginY viewBox viewTarget visibility widths wordSpacing writingMode x xHeight x1 x2 xChannelSelector xlinkActuate xlinkArcrole xlinkHref xlinkRole xlinkShow xlinkTitle xlinkType xmlBase xmlns xmlnsXlink xmlLang xmlSpace y y1 y2 yChannelSelector z zoomAndPan onPointerDown onPointerMove onPointerUp onPointerCancel onGotPointerCapture onLostPointerCapture onPointerEnter onPointerLeave onPointerOver onPointerOut class for autofocus allow allowUserMedia allowPaymentRequest
	*/
	/* eslint-enable max-len */
	
	var ATTRIBUTE_REGEX = /^((?:s(?:uppressContentEditableWarn|croll|pac)|(?:shape|image|text)Render|(?:letter|word)Spac|vHang|hang)ing|(?:on(?:AnimationIteration|C(?:o(?:mposition(?:Update|Start|End)|ntextMenu|py)|anPlayThrough|anPlay|hange|lick|ut)|(?:Animation|Touch|Load|Drag)Start|(?:(?:Duration|Volume|Rate)Chang|(?:MouseLea|(?:Touch|Mouse)Mo|DragLea)v|Paus)e|Loaded(?:Metad|D)ata|(?:(?:T(?:ransition|ouch)|Animation)E|Suspe)nd|DoubleClick|(?:TouchCanc|Whe)el|Lo(?:stPointer|ad)|TimeUpdate|(?:Mouse(?:Ent|Ov)e|Drag(?:Ent|Ov)e|Erro)r|GotPointer|MouseDown|(?:E(?:n(?:crypt|d)|mpti)|S(?:tall|eek))ed|KeyPress|(?:MouseOu|DragExi|S(?:elec|ubmi)|Rese|Inpu)t|P(?:rogress|laying)|DragEnd|Key(?:Down|Up)|(?:MouseU|Dro)p|(?:Wait|Seek)ing|Scroll|Focus|Paste|Abort|Drag|Play|Blur)Captur|alignmentBaselin|(?:limitingConeAng|xlink(?:(?:Arcr|R)o|Tit)|s(?:urfaceSca|ty|ca)|unselectab|baseProfi|fontSty|(?:focus|dragg)ab|multip|profi|tit)l|d(?:ominantBaselin|efaultValu)|onPointerLeav|a(?:uto(?:Capitaliz|Revers|Sav)|dditiv)|(?:(?:formNoValid|xlinkActu|noValid|accumul|rot)a|autoComple|decelera)t|(?:(?:attribute|item)T|datat)yp|onPointerMov|(?:attribute|glyph)Nam|playsInlin|(?:writing|input|edge)Mod|(?:formE|e)ncTyp|(?:amplitu|mo)d|(?:xlinkTy|itemSco|keyTy|slo)p|(?:xmlSpa|non)c|fillRul|(?:dateTi|na)m|r(?:esourc|ol)|xmlBas|wmod)e|(?:glyphOrientationHorizont|loc)al|(?:externalResourcesRequir|select|revers|mut)ed|c(?:o(?:lorInterpolationFilter|ord)s|o(?:lor(?:Interpolation)?|nt(?:rols|ent))|(?:ontentS(?:cript|tyle)Typ|o(?:ntentEditab|lorProfi)l|l(?:assNam|ipRul)|a(?:lcMod|ptur)|it)e|olorRendering|l(?:ipPathUnits|assID)|(?:ontrolsLis|apHeigh)t|h(?:eckedLink|a(?:llenge|rSet)|ildren|ecked)|ell(?:Spac|Padd)ing|o(?:ntextMenu|ls)|(?:rossOrigi|olSpa)n|l(?:ip(?:Path)?|ass)|ursor|[xy])|glyphOrientationVertical|d(?:angerouslySetInnerHTML|efaultChecked|ownload|isabled|isplay|[xy])|(?:s(?:trikethroughThickn|eaml)es|(?:und|ov)erlineThicknes|r(?:equiredExtension|adiu)|(?:requiredFeatur|tableValu|stitchTil|numOctav|filterR)e|key(?:(?:Splin|Tim)e|Param)|auto[Ff]ocu|header|bia)s|(?:(?:st(?:rikethroughPosi|dDevia)|(?:und|ov)erlinePosi|(?:textDecor|elev)a|orienta)tio|(?:strokeLinejo|orig)i|on(?:PointerDow|FocusI)|formActio|zoomAndPa|directio|(?:vers|act)io|rowSpa|begi|ico)n|o(?:n(?:AnimationIteration|C(?:o(?:mposition(?:Update|Start|End)|ntextMenu|py)|anPlayThrough|anPlay|hange|lick|ut)|(?:(?:Duration|Volume|Rate)Chang|(?:MouseLea|(?:Touch|Mouse)Mo|DragLea)v|Paus)e|Loaded(?:Metad|D)ata|(?:Animation|Touch|Load|Drag)Start|(?:(?:T(?:ransition|ouch)|Animation)E|Suspe)nd|DoubleClick|(?:TouchCanc|Whe)el|(?:Mouse(?:Ent|Ov)e|Drag(?:Ent|Ov)e|Erro)r|TimeUpdate|(?:E(?:n(?:crypt|d)|mpti)|S(?:tall|eek))ed|MouseDown|P(?:rogress|laying)|(?:MouseOu|DragExi|S(?:elec|ubmi)|Rese|Inpu)t|KeyPress|DragEnd|Key(?:Down|Up)|(?:Wait|Seek)ing|(?:MouseU|Dro)p|Scroll|Paste|Focus|Abort|Drag|Play|Load|Blur)|rient)|p(?:reserveAspectRatio|ointsAt[X-Z]|anose1)|(?:(?:allowPaymentReque|(?:fontSize|length)Adju|manife)s|strokeMiterlimi|(?:(?:specularE|e)xpon|renderingInt|asc)en|(?:specularConsta|repeatCou|fontVaria)n|d(?:iffuseConsta|esce)n|baselineShif|vectorEffec|onPointerOu|(?:(?:mar(?:ker|gin)|x)H|accentH|fontW)eigh|markerStar|a(?:utoCorrec|bou)|onFocusOu|intercep|restar|forma|inlis|heigh|lis)t|(?:patternContent|ma(?:sk(?:Content)?|rker)|primitive|gradient|pattern|filter)Units|(?:(?:allowTranspar|baseFrequ)enc|re(?:ferrerPolic|adOnl)|(?:(?:st(?:roke|op)O|floodO|fillO|o)pac|integr|secur)it|visibilit|fontFamil|accessKe|propert|summar)y|(?:gradientT|patternT|t)ransform|(?:(?:st(?:rokeDasho|artO)|o)ffs|acceptChars|formTarg|viewTarg|srcS)et|(?:[xy]ChannelSelect|lightingCol|textAnch|floodCol|stopCol|operat|htmlF)or|(?:(?:enableBackgrou|markerE)n|s(?:p(?:readMetho|ee)|ee)|formMetho|(?:markerM|onInval)i|preloa|metho|kin)d|k(?:ernel(?:UnitLength|Matrix)|[1-4])|strokeDasharray|(?:onPointerCanc|lab)el|(?:allowFullScre|hidd)en|a(?:l(?:lowUserMedia|phabetic|t)|rabicForm|sync)|systemLanguage|(?:(?:o(?:nPointer(?:Ent|Ov)|rd)|allowReord|placehold|frameBord|paintOrd|post)e|repeatDu|d(?:efe|u))r|(?:pointerEve|keyPoi)nts|preserveAlpha|(?:strokeLineca|onPointerU|itemPro|useMa|wra|loo)p|v(?:Mathematical|ert(?:Origin[XY]|AdvY)|alues|ocab)|unicodeRange|h(?:oriz(?:Origin|Adv)X|ttpEquiv)|(?:vI|i)deographic|mathematical|u(?:nicodeBidi|[12])|(?:fontStretc|hig)h|vAlphabetic|(?:(?:mar(?:ker|gin)W|strokeW)id|azimu)th|(?:xmlnsXl|valueL)ink|mediaGroup|spellCheck|(?:text|m(?:in|ax))Length|(?:unitsPerE|optimu|fro)m|r(?:adioGroup|e(?:sults|f[XY]|l)|ows|[xy])|pathLength|(?:xlinkHr|glyphR)ef|innerHTML|xlinkShow|f(?:o(?:ntSize|rm?)|il(?:ter|l))|(?:tabInde|(?:sand|b)bo|viewBo)x|autoPlay|r(?:e(?:quired|sult|f))?|(?:(?:href|xml|src)La|kerni)ng|o(?:verflow|pen)|i(?:temRef|n2|s)|p(?:attern|oints)|unicode|d(?:efault|ata|ir)?|divisor|t(?:arget[XY]|o)|(?:stri|la)ng|(?:width|size)s|prefix|typeof|srcDoc|s(?:coped|te(?:m[hv]|p)|pan)|s(?:t(?:roke|art)|hape|cope|rc)|a(?:ccept|llow|s)|itemID|t(?:arget|ype)|m(?:edia|a(?:sk|x)|in)|value|width|x(?:mlns)?|size|href|k(?:ey)?|end|low|by|x[12]|y[12]|g[12]|i[dn]|f[xy]|[yz])$/;
	/* From DOMProperty */
	var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
	var ATTRIBUTE_NAME_CHAR = ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040';
	var isCustomAttribute = RegExp.prototype.test.bind(new RegExp('^(x|data|aria)-[' + ATTRIBUTE_NAME_CHAR + ']*$'));
	
	var validAttr = function validAttr(name) {
	  return ATTRIBUTE_REGEX.test(name) || isCustomAttribute(name.toLowerCase());
	};
	
	// 
	
	function hasInInheritanceChain(child, parent) {
	  var target = child;
	
	  while (target) {
	    target = Object.getPrototypeOf(target);
	
	    if (target && target === parent) {
	      return true;
	    }
	  }
	
	  return false;
	}
	
	// 
	/**
	 * Creates a broadcast that can be listened to, i.e. simple event emitter
	 *
	 * @see https://github.com/ReactTraining/react-broadcast
	 */
	
	var createBroadcast = function createBroadcast(initialState) {
	  var listeners = {};
	  var id = 0;
	  var state = initialState;
	
	  function publish(nextState) {
	    state = nextState;
	
	    // eslint-disable-next-line guard-for-in, no-restricted-syntax
	    for (var key in listeners) {
	      var listener = listeners[key];
	      if (listener === undefined) {
	        // eslint-disable-next-line no-continue
	        continue;
	      }
	
	      listener(state);
	    }
	  }
	
	  function subscribe(listener) {
	    var currentId = id;
	    listeners[currentId] = listener;
	    id += 1;
	    listener(state);
	    return currentId;
	  }
	
	  function unsubscribe(unsubID) {
	    listeners[unsubID] = undefined;
	  }
	
	  return { publish: publish, subscribe: subscribe, unsubscribe: unsubscribe };
	};
	
	var _contextShape, _ThemeProvider$contex;
	
	// NOTE: DO NOT CHANGE, changing this is a semver major change!
	var CHANNEL = '__styled-components__';
	var CHANNEL_NEXT = CHANNEL + 'next__';
	
	var CONTEXT_CHANNEL_SHAPE = PropTypes.shape({
	  getTheme: PropTypes.func,
	  subscribe: PropTypes.func,
	  unsubscribe: PropTypes.func
	});
	
	var contextShape = (_contextShape = {}, _contextShape[CHANNEL] = PropTypes.func, _contextShape[CHANNEL_NEXT] = CONTEXT_CHANNEL_SHAPE, _contextShape);
	
	var warnChannelDeprecated = void 0;
	if (false) {
	  warnChannelDeprecated = once(function () {
	    // eslint-disable-next-line no-console
	    console.warn('Warning: Usage of `context.' + CHANNEL + '` as a function is deprecated. It will be replaced with the object on `.context.' + CHANNEL_NEXT + '` in a future version.');
	  });
	}
	
	var isFunction = function isFunction(test) {
	  return typeof test === 'function';
	};
	
	/**
	 * Provide a theme to an entire react component tree via context and event listeners (have to do
	 * both context and event emitter as pure components block context updates)
	 */
	
	var ThemeProvider = function (_Component) {
	  inherits(ThemeProvider, _Component);
	
	  function ThemeProvider() {
	    classCallCheck(this, ThemeProvider);
	
	    var _this = possibleConstructorReturn(this, _Component.call(this));
	
	    _this.unsubscribeToOuterId = -1;
	
	    _this.getTheme = _this.getTheme.bind(_this);
	    return _this;
	  }
	
	  ThemeProvider.prototype.componentWillMount = function componentWillMount() {
	    var _this2 = this;
	
	    // If there is a ThemeProvider wrapper anywhere around this theme provider, merge this theme
	    // with the outer theme
	    var outerContext = this.context[CHANNEL_NEXT];
	    if (outerContext !== undefined) {
	      this.unsubscribeToOuterId = outerContext.subscribe(function (theme) {
	        _this2.outerTheme = theme;
	
	        if (_this2.broadcast !== undefined) {
	          _this2.publish(_this2.props.theme);
	        }
	      });
	    }
	
	    this.broadcast = createBroadcast(this.getTheme());
	  };
	
	  ThemeProvider.prototype.getChildContext = function getChildContext() {
	    var _this3 = this,
	        _babelHelpers$extends;
	
	    return _extends({}, this.context, (_babelHelpers$extends = {}, _babelHelpers$extends[CHANNEL_NEXT] = {
	      getTheme: this.getTheme,
	      subscribe: this.broadcast.subscribe,
	      unsubscribe: this.broadcast.unsubscribe
	    }, _babelHelpers$extends[CHANNEL] = function (subscriber) {
	      if (false) {
	        warnChannelDeprecated();
	      }
	
	      // Patch the old `subscribe` provide via `CHANNEL` for older clients.
	      var unsubscribeId = _this3.broadcast.subscribe(subscriber);
	      return function () {
	        return _this3.broadcast.unsubscribe(unsubscribeId);
	      };
	    }, _babelHelpers$extends));
	  };
	
	  ThemeProvider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (this.props.theme !== nextProps.theme) {
	      this.publish(nextProps.theme);
	    }
	  };
	
	  ThemeProvider.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this.unsubscribeToOuterId !== -1) {
	      this.context[CHANNEL_NEXT].unsubscribe(this.unsubscribeToOuterId);
	    }
	  };
	
	  // Get the theme from the props, supporting both (outerTheme) => {} as well as object notation
	
	
	  ThemeProvider.prototype.getTheme = function getTheme(passedTheme) {
	    var theme = passedTheme || this.props.theme;
	
	    if (isFunction(theme)) {
	      var mergedTheme = theme(this.outerTheme);
	
	      if (false) {
	        throw new StyledComponentsError(7);
	      }
	
	      return mergedTheme;
	    }
	
	    if (theme === null || Array.isArray(theme) || (typeof theme === 'undefined' ? 'undefined' : _typeof(theme)) !== 'object') {
	      throw new StyledComponentsError(8);
	    }
	
	    return _extends({}, this.outerTheme, theme);
	  };
	
	  ThemeProvider.prototype.publish = function publish(theme) {
	    this.broadcast.publish(this.getTheme(theme));
	  };
	
	  ThemeProvider.prototype.render = function render() {
	    if (!this.props.children) {
	      return null;
	    }
	
	    return React__default.Children.only(this.props.children);
	  };
	
	  return ThemeProvider;
	}(React.Component);
	
	ThemeProvider.childContextTypes = contextShape;
	ThemeProvider.contextTypes = (_ThemeProvider$contex = {}, _ThemeProvider$contex[CHANNEL_NEXT] = CONTEXT_CHANNEL_SHAPE, _ThemeProvider$contex);
	
	var _babelHelpers$extends;
	
	// HACK for generating all static styles without needing to allocate
	// an empty execution context every single time...
	var STATIC_EXECUTION_CONTEXT = {};
	
	var modifiedContextShape = _extends({}, contextShape, (_babelHelpers$extends = {}, _babelHelpers$extends[CONTEXT_KEY] = PropTypes.oneOfType([PropTypes.instanceOf(StyleSheet), PropTypes.instanceOf(ServerStyleSheet)]), _babelHelpers$extends));
	
	var identifiers = {};
	
	/* We depend on components having unique IDs */
	var generateId = function generateId(ComponentStyle, _displayName, parentComponentId) {
	  var displayName = typeof _displayName !== 'string' ? 'sc' : escape(_displayName);
	
	  /**
	   * This ensures uniqueness if two components happen to share
	   * the same displayName.
	   */
	  var nr = (identifiers[displayName] || 0) + 1;
	  identifiers[displayName] = nr;
	
	  var componentId = displayName + '-' + ComponentStyle.generateName(displayName + nr);
	
	  return parentComponentId !== undefined ? parentComponentId + '-' + componentId : componentId;
	};
	
	var warnExtendDeprecated = function warnExtendDeprecated() {};
	if (false) {
	  warnExtendDeprecated = once(function () {
	    // eslint-disable-next-line no-console
	    console.warn('Warning: The "extend" API will be removed in the upcoming v4.0 release. Use styled(StyledComponent) instead. You can find more information here: https://github.com/styled-components/styled-components/issues/1546');
	  });
	}
	
	// $FlowFixMe
	
	var BaseStyledComponent = function (_Component) {
	  inherits(BaseStyledComponent, _Component);
	
	  function BaseStyledComponent() {
	    var _temp, _this, _ret;
	
	    classCallCheck(this, BaseStyledComponent);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.attrs = {}, _this.state = {
	      theme: null,
	      generatedClassName: ''
	    }, _this.unsubscribeId = -1, _temp), possibleConstructorReturn(_this, _ret);
	  }
	
	  BaseStyledComponent.prototype.unsubscribeFromContext = function unsubscribeFromContext() {
	    if (this.unsubscribeId !== -1) {
	      this.context[CHANNEL_NEXT].unsubscribe(this.unsubscribeId);
	    }
	  };
	
	  BaseStyledComponent.prototype.buildExecutionContext = function buildExecutionContext(theme, props) {
	    var attrs = this.constructor.attrs;
	
	    var context = _extends({}, props, { theme: theme });
	    if (attrs === undefined) {
	      return context;
	    }
	
	    this.attrs = Object.keys(attrs).reduce(function (acc, key) {
	      var attr = attrs[key];
	
	      // eslint-disable-next-line no-param-reassign
	      acc[key] = typeof attr === 'function' && !hasInInheritanceChain(attr, React.Component) ? attr(context) : attr;
	      return acc;
	    }, {});
	
	    return _extends({}, context, this.attrs);
	  };
	
	  BaseStyledComponent.prototype.generateAndInjectStyles = function generateAndInjectStyles(theme, props) {
	    var _constructor = this.constructor,
	        attrs = _constructor.attrs,
	        componentStyle = _constructor.componentStyle,
	        warnTooManyClasses = _constructor.warnTooManyClasses;
	
	    var styleSheet = this.context[CONTEXT_KEY] || StyleSheet.master;
	
	    // statically styled-components don't need to build an execution context object,
	    // and shouldn't be increasing the number of class names
	    if (componentStyle.isStatic && attrs === undefined) {
	      return componentStyle.generateAndInjectStyles(STATIC_EXECUTION_CONTEXT, styleSheet);
	    } else {
	      var executionContext = this.buildExecutionContext(theme, props);
	      var className = componentStyle.generateAndInjectStyles(executionContext, styleSheet);
	
	      if (false) {
	        warnTooManyClasses(className);
	      }
	
	      return className;
	    }
	  };
	
	  BaseStyledComponent.prototype.componentWillMount = function componentWillMount() {
	    var _this2 = this;
	
	    var componentStyle = this.constructor.componentStyle;
	
	    var styledContext = this.context[CHANNEL_NEXT];
	
	    // If this is a statically-styled component, we don't need to the theme
	    // to generate or build styles.
	    if (componentStyle.isStatic) {
	      var generatedClassName = this.generateAndInjectStyles(STATIC_EXECUTION_CONTEXT, this.props);
	      this.setState({ generatedClassName: generatedClassName });
	      // If there is a theme in the context, subscribe to the event emitter. This
	      // is necessary due to pure components blocking context updates, this circumvents
	      // that by updating when an event is emitted
	    } else if (styledContext !== undefined) {
	      var subscribe = styledContext.subscribe;
	
	      this.unsubscribeId = subscribe(function (nextTheme) {
	        // This will be called once immediately
	        var theme = determineTheme(_this2.props, nextTheme, _this2.constructor.defaultProps);
	
	        var generatedClassName = _this2.generateAndInjectStyles(theme, _this2.props);
	
	        _this2.setState({ theme: theme, generatedClassName: generatedClassName });
	      });
	    } else {
	      // eslint-disable-next-line react/prop-types
	      var theme = this.props.theme || EMPTY_OBJECT;
	      var _generatedClassName = this.generateAndInjectStyles(theme, this.props);
	      this.setState({ theme: theme, generatedClassName: _generatedClassName });
	    }
	  };
	
	  BaseStyledComponent.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var _this3 = this;
	
	    // If this is a statically-styled component, we don't need to listen to
	    // props changes to update styles
	    var componentStyle = this.constructor.componentStyle;
	
	    if (componentStyle.isStatic) {
	      return;
	    }
	
	    this.setState(function (prevState) {
	      var theme = determineTheme(nextProps, prevState.theme, _this3.constructor.defaultProps);
	      var generatedClassName = _this3.generateAndInjectStyles(theme, nextProps);
	
	      return { theme: theme, generatedClassName: generatedClassName };
	    });
	  };
	
	  BaseStyledComponent.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.unsubscribeFromContext();
	  };
	
	  BaseStyledComponent.prototype.render = function render() {
	    // eslint-disable-next-line react/prop-types
	    var innerRef = this.props.innerRef;
	    var generatedClassName = this.state.generatedClassName;
	    var _constructor2 = this.constructor,
	        styledComponentId = _constructor2.styledComponentId,
	        target = _constructor2.target;
	
	    var isTargetTag = isTag(target);
	
	    var className = [
	    // eslint-disable-next-line react/prop-types
	    this.props.className, styledComponentId, this.attrs.className, generatedClassName].filter(Boolean).join(' ');
	
	    var baseProps = _extends({}, this.attrs, {
	      className: className
	    });
	
	    if (isStyledComponent(target)) {
	      baseProps.innerRef = innerRef;
	    } else {
	      baseProps.ref = innerRef;
	    }
	
	    var propsForElement = baseProps;
	    var key = void 0;
	
	    for (key in this.props) {
	      // Don't pass through non HTML tags through to HTML elements
	      // always omit innerRef
	      if (key !== 'innerRef' && key !== 'className' && (!isTargetTag || validAttr(key))) {
	        propsForElement[key] = key === 'style' && key in this.attrs ? _extends({}, this.attrs[key], this.props[key]) : this.props[key];
	      }
	    }
	
	    return React.createElement(target, propsForElement);
	  };
	
	  return BaseStyledComponent;
	}(React.Component);
	
	var _StyledComponent = function _StyledComponent(ComponentStyle, constructWithOptions) {
	  var createStyledComponent = function createStyledComponent(target, options, rules) {
	    var _options$isClass = options.isClass,
	        isClass = _options$isClass === undefined ? !isTag(target) : _options$isClass,
	        _options$displayName = options.displayName,
	        displayName = _options$displayName === undefined ? generateDisplayName(target) : _options$displayName,
	        _options$componentId = options.componentId,
	        componentId = _options$componentId === undefined ? generateId(ComponentStyle, options.displayName, options.parentComponentId) : _options$componentId,
	        _options$ParentCompon = options.ParentComponent,
	        ParentComponent = _options$ParentCompon === undefined ? BaseStyledComponent : _options$ParentCompon,
	        extendingRules = options.rules,
	        attrs = options.attrs;
	
	    var styledComponentId = options.displayName && options.componentId ? escape(options.displayName) + '-' + options.componentId : options.componentId || componentId;
	
	    var componentStyle = new ComponentStyle(extendingRules === undefined ? rules : extendingRules.concat(rules), attrs, styledComponentId);
	
	    var StyledComponent = function (_ParentComponent) {
	      inherits(StyledComponent, _ParentComponent);
	
	      function StyledComponent() {
	        classCallCheck(this, StyledComponent);
	        return possibleConstructorReturn(this, _ParentComponent.apply(this, arguments));
	      }
	
	      StyledComponent.withComponent = function withComponent(tag) {
	        var previousComponentId = options.componentId,
	            optionsToCopy = objectWithoutProperties(options, ['componentId']);
	
	        var newComponentId = previousComponentId && previousComponentId + '-' + (isTag(tag) ? tag : escape(getComponentName(tag)));
	
	        var newOptions = _extends({}, optionsToCopy, {
	          componentId: newComponentId,
	          ParentComponent: StyledComponent
	        });
	
	        return createStyledComponent(tag, newOptions, rules);
	      };
	
	      createClass(StyledComponent, null, [{
	        key: 'extend',
	        get: function get$$1() {
	          var rulesFromOptions = options.rules,
	              parentComponentId = options.componentId,
	              optionsToCopy = objectWithoutProperties(options, ['rules', 'componentId']);
	
	          var newRules = rulesFromOptions === undefined ? rules : rulesFromOptions.concat(rules);
	
	          var newOptions = _extends({}, optionsToCopy, {
	            rules: newRules,
	            parentComponentId: parentComponentId,
	            ParentComponent: StyledComponent
	          });
	
	          warnExtendDeprecated();
	
	          return constructWithOptions(createStyledComponent, target, newOptions);
	        }
	      }]);
	      return StyledComponent;
	    }(ParentComponent);
	
	    StyledComponent.attrs = attrs;
	    StyledComponent.componentStyle = componentStyle;
	    StyledComponent.contextTypes = modifiedContextShape;
	    StyledComponent.displayName = displayName;
	    StyledComponent.styledComponentId = styledComponentId;
	    StyledComponent.target = target;
	
	    if (false) {
	      StyledComponent.warnTooManyClasses = createWarnTooManyClasses(displayName);
	    }
	
	    if (isClass) {
	      hoistStatics(StyledComponent, target, {
	        // all SC-specific things should not be hoisted
	        attrs: true,
	        componentStyle: true,
	        displayName: true,
	        extend: true,
	        styledComponentId: true,
	        target: true,
	        warnTooManyClasses: true,
	        withComponent: true
	      });
	    }
	
	    return StyledComponent;
	  };
	
	  return createStyledComponent;
	};
	
	// Source: https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
	function murmurhash(str) {
	  var l = str.length | 0,
	      h = l | 0,
	      i = 0,
	      k;
	
	  while (l >= 4) {
	    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
	
	    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
	    k ^= k >>> 24;
	    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
	
	    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
	
	    l -= 4;
	    ++i;
	  }
	
	  switch (l) {
	    case 3:
	      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
	    case 2:
	      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
	    case 1:
	      h ^= str.charCodeAt(i) & 0xff;
	      h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
	  }
	
	  h ^= h >>> 13;
	  h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
	  h ^= h >>> 15;
	
	  return h >>> 0;
	}
	
	// 
	
	var areStylesCacheable = IS_BROWSER;
	
	var isStaticRules = function isStaticRules(rules, attrs) {
	  for (var i = 0, len = rules.length; i < len; i += 1) {
	    var rule = rules[i];
	
	    // recursive case
	    if (Array.isArray(rule) && !isStaticRules(rule)) {
	      return false;
	    } else if (typeof rule === 'function' && !isStyledComponent(rule)) {
	      // functions are allowed to be static if they're just being
	      // used to get the classname of a nested styled component
	      return false;
	    }
	  }
	
	  if (attrs !== undefined) {
	    // eslint-disable-next-line guard-for-in, no-restricted-syntax
	    for (var key in attrs) {
	      if (typeof attrs[key] === 'function') {
	        return false;
	      }
	    }
	  }
	
	  return true;
	};
	
	var isHMREnabled = typeof module !== 'undefined' && module.hot && ("production") !== 'production';
	
	/*
	 ComponentStyle is all the CSS-specific stuff, not
	 the React-specific stuff.
	 */
	var _ComponentStyle = function _ComponentStyle(nameGenerator, flatten, stringifyRules) {
	  /* combines hashStr (murmurhash) and nameGenerator for convenience */
	  var generateRuleHash = function generateRuleHash(str) {
	    return nameGenerator(murmurhash(str));
	  };
	
	  var ComponentStyle = function () {
	    function ComponentStyle(rules, attrs, componentId) {
	      classCallCheck(this, ComponentStyle);
	
	      this.rules = rules;
	      this.isStatic = !isHMREnabled && isStaticRules(rules, attrs);
	      this.componentId = componentId;
	
	      if (!StyleSheet.master.hasId(componentId)) {
	        var placeholder =  false ? ['.' + componentId + ' {}'] : [];
	
	        StyleSheet.master.deferredInject(componentId, placeholder);
	      }
	    }
	
	    /*
	     * Flattens a rule set into valid CSS
	     * Hashes it, wraps the whole chunk in a .hash1234 {}
	     * Returns the hash to be injected on render()
	     * */
	
	    ComponentStyle.prototype.generateAndInjectStyles = function generateAndInjectStyles(executionContext, styleSheet) {
	      var isStatic = this.isStatic,
	          componentId = this.componentId,
	          lastClassName = this.lastClassName;
	
	      if (areStylesCacheable && isStatic && lastClassName !== undefined && styleSheet.hasNameForId(componentId, lastClassName)) {
	        return lastClassName;
	      }
	
	      var flatCSS = flatten(this.rules, executionContext);
	      var name = generateRuleHash(this.componentId + flatCSS.join(''));
	
	      if (!styleSheet.hasNameForId(componentId, name)) {
	        styleSheet.inject(this.componentId, stringifyRules(flatCSS, '.' + name), name);
	      }
	
	      this.lastClassName = name;
	      return name;
	    };
	
	    ComponentStyle.generateName = function generateName(str) {
	      return generateRuleHash(str);
	    };
	
	    return ComponentStyle;
	  }();
	
	  return ComponentStyle;
	};
	
	// 
	// Thanks to ReactDOMFactories for this handy list!
	
	var domElements = ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'big', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meta', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'section', 'select', 'small', 'source', 'span', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr',
	
	// SVG
	'circle', 'clipPath', 'defs', 'ellipse', 'foreignObject', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'svg', 'text', 'tspan'];
	
	// 
	
	var _styled = function _styled(styledComponent, constructWithOptions) {
	  var styled = function styled(tag) {
	    return constructWithOptions(styledComponent, tag);
	  };
	
	  // Shorthands for all valid HTML Elements
	  domElements.forEach(function (domElement) {
	    styled[domElement] = styled(domElement);
	  });
	
	  return styled;
	};
	
	// 
	
	var replaceWhitespace = function replaceWhitespace(str) {
	  return str.replace(/\s|\\n/g, '');
	};
	
	var _keyframes = function _keyframes(nameGenerator, stringifyRules, css) {
	  return function () {
	    var styleSheet = StyleSheet.master;
	    var rules = css.apply(undefined, arguments);
	    var name = nameGenerator(murmurhash(replaceWhitespace(JSON.stringify(rules))));
	    var id = 'sc-keyframes-' + name;
	
	    if (!styleSheet.hasNameForId(id, name)) {
	      styleSheet.inject(id, stringifyRules(rules, name, '@keyframes'), name);
	    }
	
	    return name;
	  };
	};
	
	// 
	
	var _injectGlobal = function _injectGlobal(stringifyRules, css) {
	  var injectGlobal = function injectGlobal() {
	    var styleSheet = StyleSheet.master;
	    var rules = css.apply(undefined, arguments);
	    var hash = murmurhash(JSON.stringify(rules));
	    var id = 'sc-global-' + hash;
	
	    if (!styleSheet.hasId(id)) {
	      styleSheet.inject(id, stringifyRules(rules));
	    }
	  };
	
	  return injectGlobal;
	};
	
	// 
	
	var _constructWithOptions = function _constructWithOptions(css) {
	  var constructWithOptions = function constructWithOptions(componentConstructor, tag) {
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : EMPTY_OBJECT;
	
	    if (!reactIs.isValidElementType(tag)) {
	      throw new StyledComponentsError(1, String(tag));
	    }
	
	    /* This is callable directly as a template function */
	    // $FlowFixMe: Not typed to avoid destructuring arguments
	    var templateFunction = function templateFunction() {
	      return componentConstructor(tag, options, css.apply(undefined, arguments));
	    };
	
	    /* If config methods are called, wrap up a new template function and merge options */
	    templateFunction.withConfig = function (config) {
	      return constructWithOptions(componentConstructor, tag, _extends({}, options, config));
	    };
	    templateFunction.attrs = function (attrs) {
	      return constructWithOptions(componentConstructor, tag, _extends({}, options, {
	        attrs: _extends({}, options.attrs || EMPTY_OBJECT, attrs)
	      }));
	    };
	
	    return templateFunction;
	  };
	
	  return constructWithOptions;
	};
	
	// 
	
	var withTheme = function withTheme(Component) {
	  var isStatelessFunctionalComponent = typeof Component === 'function' &&
	  // $FlowFixMe TODO: flow for prototype
	  !(Component.prototype && 'isReactComponent' in Component.prototype);
	
	  // NOTE: We can't pass a ref to a stateless functional component
	  var shouldSetInnerRef = isStyledComponent(Component) || isStatelessFunctionalComponent;
	
	  var WithTheme = function (_React$Component) {
	    inherits(WithTheme, _React$Component);
	
	    function WithTheme() {
	      var _temp, _this, _ret;
	
	      classCallCheck(this, WithTheme);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = EMPTY_OBJECT, _this.unsubscribeId = -1, _temp), possibleConstructorReturn(_this, _ret);
	    }
	
	    // NOTE: This is so that isStyledComponent passes for the innerRef unwrapping
	
	
	    WithTheme.prototype.componentWillMount = function componentWillMount() {
	      var _this2 = this;
	
	      var defaultProps = this.constructor.defaultProps;
	
	      var styledContext = this.context[CHANNEL_NEXT];
	      var themeProp = determineTheme(this.props, undefined, defaultProps);
	      if (styledContext === undefined && themeProp === undefined && ("production") !== 'production') {
	        // eslint-disable-next-line no-console
	        console.warn('[withTheme] You are not using a ThemeProvider nor passing a theme prop or a theme in defaultProps');
	      } else if (styledContext === undefined && themeProp !== undefined) {
	        this.setState({ theme: themeProp });
	      } else {
	        var subscribe = styledContext.subscribe;
	
	        this.unsubscribeId = subscribe(function (nextTheme) {
	          var theme = determineTheme(_this2.props, nextTheme, defaultProps);
	          _this2.setState({ theme: theme });
	        });
	      }
	    };
	
	    WithTheme.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	      var defaultProps = this.constructor.defaultProps;
	
	      this.setState(function (oldState) {
	        var theme = determineTheme(nextProps, oldState.theme, defaultProps);
	
	        return { theme: theme };
	      });
	    };
	
	    WithTheme.prototype.componentWillUnmount = function componentWillUnmount() {
	      if (this.unsubscribeId !== -1) {
	        this.context[CHANNEL_NEXT].unsubscribe(this.unsubscribeId);
	      }
	    };
	
	    WithTheme.prototype.render = function render() {
	      var props = _extends({
	        theme: this.state.theme
	      }, this.props);
	
	      if (!shouldSetInnerRef) {
	        props.ref = props.innerRef;
	        delete props.innerRef;
	      }
	
	      return React__default.createElement(Component, props);
	    };
	
	    return WithTheme;
	  }(React__default.Component);
	
	  WithTheme.contextTypes = contextShape;
	  WithTheme.displayName = 'WithTheme(' + getComponentName(Component) + ')';
	  WithTheme.styledComponentId = 'withTheme';
	
	  return hoistStatics(WithTheme, Component);
	};
	
	// 
	
	/* eslint-disable */
	var __DO_NOT_USE_OR_YOU_WILL_BE_HAUNTED_BY_SPOOKY_GHOSTS = {
	  StyleSheet: StyleSheet
	};
	
	// 
	
	/* Warning if you've imported this file on React Native */
	if (false) {
	  // eslint-disable-next-line no-console
	  console.warn("It looks like you've imported 'styled-components' on React Native.\n" + "Perhaps you're looking to import 'styled-components/native'?\n" + 'Read more about this at https://www.styled-components.com/docs/basics#react-native');
	}
	
	/* Warning if there are several instances of styled-components */
	if (false) {
	  window['__styled-components-init__'] = window['__styled-components-init__'] || 0;
	
	  if (window['__styled-components-init__'] === 1) {
	    // eslint-disable-next-line no-console
	    console.warn("It looks like there are several instances of 'styled-components' initialized in this application. " + 'This may cause dynamic styles not rendering properly, errors happening during rehydration process ' + 'and makes your application bigger without a good reason.\n\n' + 'See https://s-c.sh/2BAXzed for more info.');
	  }
	
	  window['__styled-components-init__'] += 1;
	}
	
	/* Instantiate singletons */
	var ComponentStyle = _ComponentStyle(generateAlphabeticName, flatten, stringifyRules);
	var constructWithOptions = _constructWithOptions(css);
	var StyledComponent = _StyledComponent(ComponentStyle, constructWithOptions);
	
	/* Instantiate exported singletons */
	var keyframes = _keyframes(generateAlphabeticName, stringifyRules, css);
	var injectGlobal = _injectGlobal(stringifyRules, css);
	var styled = _styled(StyledComponent, constructWithOptions);
	
	exports.default = styled;
	exports.css = css;
	exports.keyframes = keyframes;
	exports.injectGlobal = injectGlobal;
	exports.isStyledComponent = isStyledComponent;
	exports.consolidateStreamedStyles = consolidateStreamedStyles;
	exports.ThemeProvider = ThemeProvider;
	exports.withTheme = withTheme;
	exports.ServerStyleSheet = ServerStyleSheet;
	exports.StyleSheetManager = StyleSheetManager;
	exports.__DO_NOT_USE_OR_YOU_WILL_BE_HAUNTED_BY_SPOOKY_GHOSTS = __DO_NOT_USE_OR_YOU_WILL_BE_HAUNTED_BY_SPOOKY_GHOSTS;
	//# sourceMappingURL=styled-components.browser.cjs.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(121), __webpack_require__(88)(module)))

/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	Object.defineProperty(exports, '__esModule', { value: !0 });var _commonPropsShape = __webpack_require__(495);Object.defineProperty(exports, 'commonPropsShape', { enumerable: !0, get: function get() {
	    return _interopRequireDefault(_commonPropsShape).default;
	  } });var _i18nShape = __webpack_require__(193);Object.defineProperty(exports, 'i18nShape', { enumerable: !0, get: function get() {
	    return _interopRequireDefault(_i18nShape).default;
	  } });var _themeShape = __webpack_require__(194);Object.defineProperty(exports, 'themeShape', { enumerable: !0, get: function get() {
	    return _interopRequireDefault(_themeShape).default;
	  } });function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var store = __webpack_require__(115)('wks');
	var uid = __webpack_require__(74);
	var _Symbol = __webpack_require__(8).Symbol;
	var USE_SYMBOL = typeof _Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] = USE_SYMBOL && _Symbol[name] || (USE_SYMBOL ? _Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _events = __webpack_require__(82);
	
	var _objectAssign = __webpack_require__(11);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Dispatcher = (0, _objectAssign2.default)({}, _events.EventEmitter.prototype, {
	
	  BRAND_CHANGE: 'Brand.change',
	
	  DEVICE_STORE_CHANGE: 'Device.storeChange',
	  DEVICE_DEACTIVATE_DEVICE: 'Device.deactiveDevice',
	
	  HEADER_HAMBURGER_CHANGE: 'Header.hamburgerChange',
	  HEADER_HAMBURGER_TOGGLE: 'Header.hamburgerToggle',
	  HEADER_HAMBURGER_OFF: 'Header.hamburgerOff',
	
	  RESOURCE_STORE_CHANGE: 'Resource.storeChange',
	
	  RESOURCE_DETAILS_STORE_CHANGE: 'ResourceDetails.storeChange',
	
	  TRANSACTION_STORE_CHANGE: 'Transaction.storeChange',
	  TRANSACTION_REQUEST_REFUND: 'Transaction.requestRefund',
	  TRANSACTION_REFUND_SUCCESS: 'Transaction.refundSuccess',
	  TRANSACTION_REFUND_FAILURE: 'Transaction.refundFailure',
	
	  USER_STORE_CHANGE: 'User.storeChange',
	  USER_CHANGE_PASSWORD: 'User.changePassword',
	  USER_CHANGE_PASSWORD_SUCCESS: 'User.changePasswordSuccess',
	  USER_CHANGE_PASSWORD_FAILURE: 'User.changePasswordFailure',
	  USER_LICENSE_UPDATED: 'User.licenseUpdated',
	  USER_SET_INFO: 'User.setInfosdfsdf',
	  USER_SIGN_OUT: 'User.signOut',
	  USER_UPDATE_NOTIFICATION: 'User.updateNotification',
	  USER_UPDATE_NOTIFICATION_SUCCESS: 'User.updateNotificationSuccess',
	  USER_UPDATE_NOTIFICATION_FAILURE: 'User.updateNotificationFailure',
	  USER_UPDATE_SECURITY_QUESTION: 'User.updateScurityQuestion',
	  USER_UPDATE_SECURITY_SUCCESS: 'User.updateScuritySuccess',
	  USER_UPDATE_SECURITY_FAILURE: 'User.updateScurityFailure',
	  USER_UPDATE_SUCCESS: 'User.updateSuccess',
	  USER_UPDATE_FAILURE: 'User.updateFailure',
	  USER_POD: 'User.pod',
	
	  LOCALE_CHANGE: 'Locale.Change'
	});
	
	exports.default = Dispatcher;

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	Object.defineProperty(exports, '__esModule', { value: !0 });var _getContrast = __webpack_require__(781),
	    _getContrast2 = _interopRequireDefault(_getContrast);function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}var getMainShadeIndex = function getMainShadeIndex(palette, backgroundColor) {
	  for (var colorIndex = 6, colorIsAccessible = _getContrast2.default.isAccessible(palette[colorIndex], backgroundColor); !colorIsAccessible;) {
	    colorIndex++, void 0 === palette[colorIndex] ? (console.warn('Shades #6 and higher in the color palette do not have a high enough contrast ratio against a background color of ' + backgroundColor + '.'), colorIsAccessible = !0) : colorIsAccessible = _getContrast2.default.isAccessible(palette[colorIndex], backgroundColor);
	  }return Math.min(colorIndex, Object.keys(palette).length - 1);
	},
	    createColorPalette = function createColorPalette(palette, name) {
	  return { get name() {
	      return name;
	    }, getShade: function getShade(index) {
	      return palette[index];
	    }, getMainShade: function getMainShade() {
	      var _ref = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {},
	          _ref$backgroundColor = _ref.backgroundColor,
	          backgroundColor = void 0 === _ref$backgroundColor ? '#ffffff' : _ref$backgroundColor,
	          _ref$offset = _ref.offset,
	          offset = void 0 === _ref$offset ? 0 : _ref$offset,
	          index = void 0;return index = '#ffffff' === backgroundColor ? (palette.inflection || getMainShadeIndex(palette, backgroundColor)) + offset : getMainShadeIndex(palette, backgroundColor) + offset, palette[Math.min(index, Object.keys(palette).length - 1)];
	    } };
	};exports.default = createColorPalette;

/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(10)(function () {
	  return Object.defineProperty({}, 'a', { get: function get() {
	      return 7;
	    } }).a != 7;
	});

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var anObject = __webpack_require__(7);
	var IE8_DOM_DEFINE = __webpack_require__(209);
	var toPrimitive = __webpack_require__(52);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(20) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) {/* empty */}
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// 7.1.15 ToLength
	var toInteger = __webpack_require__(51);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(12);
	
	var DOMProperty = __webpack_require__(84);
	var ReactDOMComponentFlags = __webpack_require__(368);
	
	var invariant = __webpack_require__(5);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var Flags = ReactDOMComponentFlags;
	
	var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);
	
	/**
	 * Check if a given node should be cached.
	 */
	function shouldPrecacheNode(node, nodeID) {
	  return node.nodeType === 1 && node.getAttribute(ATTR_NAME) === String(nodeID) || node.nodeType === 8 && node.nodeValue === ' react-text: ' + nodeID + ' ' || node.nodeType === 8 && node.nodeValue === ' react-empty: ' + nodeID + ' ';
	}
	
	/**
	 * Drill down (through composites and empty components) until we get a host or
	 * host text component.
	 *
	 * This is pretty polymorphic but unavoidable with the current structure we have
	 * for `_renderedChildren`.
	 */
	function getRenderedHostOrTextFromComponent(component) {
	  var rendered;
	  while (rendered = component._renderedComponent) {
	    component = rendered;
	  }
	  return component;
	}
	
	/**
	 * Populate `_hostNode` on the rendered host/text component with the given
	 * DOM node. The passed `inst` can be a composite.
	 */
	function precacheNode(inst, node) {
	  var hostInst = getRenderedHostOrTextFromComponent(inst);
	  hostInst._hostNode = node;
	  node[internalInstanceKey] = hostInst;
	}
	
	function uncacheNode(inst) {
	  var node = inst._hostNode;
	  if (node) {
	    delete node[internalInstanceKey];
	    inst._hostNode = null;
	  }
	}
	
	/**
	 * Populate `_hostNode` on each child of `inst`, assuming that the children
	 * match up with the DOM (element) children of `node`.
	 *
	 * We cache entire levels at once to avoid an n^2 problem where we access the
	 * children of a node sequentially and have to walk from the start to our target
	 * node every time.
	 *
	 * Since we update `_renderedChildren` and the actual DOM at (slightly)
	 * different times, we could race here and see a newer `_renderedChildren` than
	 * the DOM nodes we see. To avoid this, ReactMultiChild calls
	 * `prepareToManageChildren` before we change `_renderedChildren`, at which
	 * time the container's child nodes are always cached (until it unmounts).
	 */
	function precacheChildNodes(inst, node) {
	  if (inst._flags & Flags.hasCachedChildNodes) {
	    return;
	  }
	  var children = inst._renderedChildren;
	  var childNode = node.firstChild;
	  outer: for (var name in children) {
	    if (!children.hasOwnProperty(name)) {
	      continue;
	    }
	    var childInst = children[name];
	    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
	    if (childID === 0) {
	      // We're currently unmounting this child in ReactMultiChild; skip it.
	      continue;
	    }
	    // We assume the child nodes are in the same order as the child instances.
	    for (; childNode !== null; childNode = childNode.nextSibling) {
	      if (shouldPrecacheNode(childNode, childID)) {
	        precacheNode(childInst, childNode);
	        continue outer;
	      }
	    }
	    // We reached the end of the DOM children without finding an ID match.
	     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
	  }
	  inst._flags |= Flags.hasCachedChildNodes;
	}
	
	/**
	 * Given a DOM node, return the closest ReactDOMComponent or
	 * ReactDOMTextComponent instance ancestor.
	 */
	function getClosestInstanceFromNode(node) {
	  if (node[internalInstanceKey]) {
	    return node[internalInstanceKey];
	  }
	
	  // Walk up the tree until we find an ancestor whose instance we have cached.
	  var parents = [];
	  while (!node[internalInstanceKey]) {
	    parents.push(node);
	    if (node.parentNode) {
	      node = node.parentNode;
	    } else {
	      // Top of the tree. This node must not be part of a React tree (or is
	      // unmounted, potentially).
	      return null;
	    }
	  }
	
	  var closest;
	  var inst;
	  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
	    closest = inst;
	    if (parents.length) {
	      precacheChildNodes(inst, node);
	    }
	  }
	
	  return closest;
	}
	
	/**
	 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
	 * instance, or null if the node was not rendered by this React.
	 */
	function getInstanceFromNode(node) {
	  var inst = getClosestInstanceFromNode(node);
	  if (inst != null && inst._hostNode === node) {
	    return inst;
	  } else {
	    return null;
	  }
	}
	
	/**
	 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
	 * DOM node.
	 */
	function getNodeFromInstance(inst) {
	  // Without this first invariant, passing a non-DOM-component triggers the next
	  // invariant for a missing parent, which is super confusing.
	  !(inst._hostNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  if (inst._hostNode) {
	    return inst._hostNode;
	  }
	
	  // Walk up the tree until we find an ancestor whose DOM node we have cached.
	  var parents = [];
	  while (!inst._hostNode) {
	    parents.push(inst);
	    !inst._hostParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
	    inst = inst._hostParent;
	  }
	
	  // Now parents contains each ancestor that does *not* have a cached native
	  // node, and `inst` is the deepest ancestor that does.
	  for (; parents.length; inst = parents.pop()) {
	    precacheChildNodes(inst, inst._hostNode);
	  }
	
	  return inst._hostNode;
	}
	
	var ReactDOMComponentTree = {
	  getClosestInstanceFromNode: getClosestInstanceFromNode,
	  getInstanceFromNode: getInstanceFromNode,
	  getNodeFromInstance: getNodeFromInstance,
	  precacheChildNodes: precacheChildNodes,
	  precacheNode: precacheNode,
	  uncacheNode: uncacheNode
	};
	
	module.exports = ReactDOMComponentTree;

/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(49);
	module.exports = function (it) {
	  return Object(defined(it));
	};

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/*!
	  Copyright (c) 2016 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames() {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg === 'undefined' ? 'undefined' : _typeof(arg);
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					classes.push(classNames.apply(null, arg));
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			module.exports = classNames;
		} else if ("function" === 'function' && _typeof(__webpack_require__(401)) === 'object' && __webpack_require__(401)) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	})();

/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	Object.defineProperty(exports, '__esModule', { value: !0 });var _Icon = __webpack_require__(423);Object.defineProperty(exports, 'default', { enumerable: !0, get: function get() {
	    return _interopRequireDefault(_Icon).default;
	  } });function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}

/***/ },
/* 27 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};

/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _routes = __webpack_require__(163);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  toHTML: function toHTML(string) {
	    return _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: string } });
	  },
	  toDateString: function toDateString(string) {
	    var date = new Date(string);
	    return date.getMonth() + 1 + '/' + date.getDate() + '/' + (date.getFullYear() + "").substring(2, 4);
	  },
	  getCurrencySymbol: function getCurrencySymbol(currency) {
	    return {
	      "GBP": "£",
	      "ZAR": "R"
	    }[currency] || "$";
	  },
	  transactionSubtotal: function transactionSubtotal(transaction) {
	    return transaction.purchaseItems.map(function (item) {
	      return parseFloat(item.itemPrice) * item.quantity;
	    }).reduce(function (a, b) {
	      return a + b;
	    }, 0);
	  },
	  _itemPrice: function _itemPrice(item, currency, withTax) {
	    var price = Math.abs(parseFloat(item.itemPrice));
	
	    if (currency === 'GBP' || currency === 'AUD' || withTax) {
	      // the price has to include VAT
	      price += item.tax;
	    }
	
	    return price;
	  },
	  vat: function vat(currency) {
	    switch (currency) {
	      case 'GBP':
	        return 'VAT';
	      case 'AUD':
	        return 'GST';
	      default:
	        return false;
	    }
	  },
	  taxRate: function taxRate(floatString) {
	    var rate = 100 * parseFloat(floatString);
	    rate = rate.toFixed(3);
	    // Removes trailing zeros
	    return parseFloat(rate).toString();
	  },
	  getParameterByName: function getParameterByName(name) {
	    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
	    var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
	        results = regex.exec(location.search);
	    return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
	  },
	
	
	  // http://stackoverflow.com/questions/1634748/how-can-i-delete-a-query-string-parameter-in-javascript
	  removeParameter: function removeParameter(url, parameter) {
	    //prefer to use l.search if you have a location/link object
	    var urlparts = url.split('?');
	    if (urlparts.length >= 2) {
	
	      var prefix = encodeURIComponent(parameter) + '=';
	      var pars = urlparts[1].split(/[&;]/g);
	
	      //reverse iteration as may be destructive
	      for (var i = pars.length; i-- > 0;) {
	        //idiom for string.startsWith
	        if (pars[i].lastIndexOf(prefix, 0) !== -1) {
	          pars.splice(i, 1);
	        }
	      }
	
	      url = urlparts[0] + '?' + pars.join('&');
	      return url;
	    } else {
	      return url;
	    }
	  },
	  addParameter: function addParameter(url, parameter, value) {
	    parameter = encodeURIComponent(parameter);
	    value = encodeURIComponent(value);
	    if (url.indexOf('?') === -1) {
	      return url + "?" + parameter + "=" + value;
	    } else {
	      var parts = url.split('?');
	      return parts[0] + "?" + parameter + "=" + value + "&" + parts[1];
	    }
	  },
	  inlineSVG: function inlineSVG(path) {
	    return this.toHTML(__webpack_require__(399));
	  },
	  isValidEmail: function isValidEmail(email) {
	    var emailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
	    return email.match(emailformat);
	  },
	  redraw: function redraw() {
	    // This is how the cool kids redraw these days
	    Routes.init('/');
	  },
	  printReceipt: function printReceipt() {
	    var contentRightHeight = document.getElementById('content-right').scrollHeight;
	    document.getElementById("content-right").style.height = contentRightHeight + 'px';
	    window.print();
	    document.getElementById("content-right").style.height = "";
	  }
	};

/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	if (false) {
	  var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol.for && Symbol.for('react.element') || 0xeac7;
	
	  var isValidElement = function isValidElement(object) {
	    return (typeof object === 'undefined' ? 'undefined' : _typeof(object)) === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	  };
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(820)();
	}

/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _VstContainer = __webpack_require__(927);
	
	var _VstContainer2 = _interopRequireDefault(_VstContainer);
	
	var _VstCardList = __webpack_require__(926);
	
	var _VstCardList2 = _interopRequireDefault(_VstCardList);
	
	var _VstCard = __webpack_require__(925);
	
	var _VstCard2 = _interopRequireDefault(_VstCard);
	
	var _VstButton = __webpack_require__(181);
	
	var _VstButton2 = _interopRequireDefault(_VstButton);
	
	var _VstToggleButton = __webpack_require__(953);
	
	var _VstToggleButton2 = _interopRequireDefault(_VstToggleButton);
	
	var _VstHamburger = __webpack_require__(392);
	
	var _VstHamburger2 = _interopRequireDefault(_VstHamburger);
	
	var _VstHeader = __webpack_require__(928);
	
	var _VstHeader2 = _interopRequireDefault(_VstHeader);
	
	var _VstHeaderButton = __webpack_require__(929);
	
	var _VstHeaderButton2 = _interopRequireDefault(_VstHeaderButton);
	
	var _VstInput = __webpack_require__(182);
	
	var _VstInput2 = _interopRequireDefault(_VstInput);
	
	var _VstInputGroup = __webpack_require__(930);
	
	var _VstInputGroup2 = _interopRequireDefault(_VstInputGroup);
	
	var _VstLilHead = __webpack_require__(931);
	
	var _VstLilHead2 = _interopRequireDefault(_VstLilHead);
	
	var _VstLilHeadFooter = __webpack_require__(932);
	
	var _VstLilHeadFooter2 = _interopRequireDefault(_VstLilHeadFooter);
	
	var _VstLilHeadList = __webpack_require__(933);
	
	var _VstLilHeadList2 = _interopRequireDefault(_VstLilHeadList);
	
	var _VstLilHeadListLink = __webpack_require__(934);
	
	var _VstLilHeadListLink2 = _interopRequireDefault(_VstLilHeadListLink);
	
	var _VstLilHeadUser = __webpack_require__(935);
	
	var _VstLilHeadUser2 = _interopRequireDefault(_VstLilHeadUser);
	
	var _VstLoader = __webpack_require__(936);
	
	var _VstLoader2 = _interopRequireDefault(_VstLoader);
	
	var _VstMenu = __webpack_require__(394);
	
	var _VstMenu2 = _interopRequireDefault(_VstMenu);
	
	var _VstModal = __webpack_require__(938);
	
	var _VstModal2 = _interopRequireDefault(_VstModal);
	
	var _VstProgressButton = __webpack_require__(940);
	
	var _VstProgressButton2 = _interopRequireDefault(_VstProgressButton);
	
	var _VstTabs = __webpack_require__(951);
	
	var _VstTabs2 = _interopRequireDefault(_VstTabs);
	
	var _VstTable = __webpack_require__(946);
	
	var _VstTable2 = _interopRequireDefault(_VstTable);
	
	var _VstSelect = __webpack_require__(941);
	
	var _VstSelect2 = _interopRequireDefault(_VstSelect);
	
	var _VstToast = __webpack_require__(395);
	
	var _VstToast2 = _interopRequireDefault(_VstToast);
	
	var _VstToastUtils = __webpack_require__(952);
	
	var _VstToastUtils2 = _interopRequireDefault(_VstToastUtils);
	
	var _VstDropdown = __webpack_require__(391);
	
	var _VstDropdown2 = _interopRequireDefault(_VstDropdown);
	
	var _VstPopover = __webpack_require__(939);
	
	var _VstPopover2 = _interopRequireDefault(_VstPopover);
	
	var _VstLocales = __webpack_require__(937);
	
	var _VstLocales2 = _interopRequireDefault(_VstLocales);
	
	var _utils = __webpack_require__(397);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	module.exports = {
	  VSTUI: _utils2.default,
	  VstContainer: _VstContainer2.default,
	  VstCardList: _VstCardList2.default,
	  VstCard: _VstCard2.default,
	  VstButton: _VstButton2.default,
	  VstToggleButton: _VstToggleButton2.default,
	  VstHamburger: _VstHamburger2.default,
	  VstHeader: _VstHeader2.default,
	  VstHeaderButton: _VstHeaderButton2.default,
	  VstInput: _VstInput2.default,
	  VstInputGroup: _VstInputGroup2.default,
	  VstLilHead: _VstLilHead2.default,
	  VstLilHeadFooter: _VstLilHeadFooter2.default,
	  VstLilHeadList: _VstLilHeadList2.default,
	  VstLilHeadListLink: _VstLilHeadListLink2.default,
	  VstLilHeadUser: _VstLilHeadUser2.default,
	  VstLoader: _VstLoader2.default,
	  VstMenu: _VstMenu2.default,
	  VstModal: _VstModal2.default,
	  VstProgressButton: _VstProgressButton2.default,
	  VstTabs: _VstTabs2.default,
	  VstTable: _VstTable2.default,
	  VstSelect: _VstSelect2.default,
	  VstToast: _VstToast2.default,
	  VstToastUtils: _VstToastUtils2.default,
	  VstDropdown: _VstDropdown2.default,
	  VstLocales: _VstLocales2.default,
	  VstPopover: _VstPopover2.default
	};

/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	Object.defineProperty(exports, '__esModule', { value: !0 });var _createStyledComponent = __webpack_require__(496);Object.defineProperty(exports, 'createStyledComponent', { enumerable: !0, get: function get() {
	    return _interopRequireDefault(_createStyledComponent).default;
	  } });var _css = __webpack_require__(497);Object.defineProperty(exports, 'css', { enumerable: !0, get: function get() {
	    return _interopRequireDefault(_css).default;
	  } });var _filterLayoutStyles = __webpack_require__(498);Object.defineProperty(exports, 'filterLayoutStyles', { enumerable: !0, get: function get() {
	    return _interopRequireDefault(_filterLayoutStyles).default;
	  } });var _resetInheritedStyles = __webpack_require__(499);Object.defineProperty(exports, 'resetInheritedStyles', { enumerable: !0, get: function get() {
	    return _interopRequireDefault(_resetInheritedStyles).default;
	  } }), Object.defineProperty(exports, 'resetInheritedStylesObject', { enumerable: !0, get: function get() {
	    return _resetInheritedStyles.resetInheritedStylesObject;
	  } });var _visuallyHidden = __webpack_require__(500);Object.defineProperty(exports, 'visuallyHidden', { enumerable: !0, get: function get() {
	    return _interopRequireDefault(_visuallyHidden).default;
	  } });function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}

/***/ },
/* 32 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;

/***/ },
/* 33 */
/***/ function(module, exports) {

	"use strict";
	
	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};

/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var dP = __webpack_require__(21);
	var createDesc = __webpack_require__(70);
	module.exports = __webpack_require__(20) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};

/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var global = __webpack_require__(8);
	var hide = __webpack_require__(34);
	var has = __webpack_require__(33);
	var SRC = __webpack_require__(74)('src');
	var TO_STRING = 'toString';
	var $toString = Function[TO_STRING];
	var TPL = ('' + $toString).split(TO_STRING);
	
	__webpack_require__(48).inspectSource = function (it) {
	  return $toString.call(it);
	};
	
	(module.exports = function (O, key, val, safe) {
	  var isFunction = typeof val == 'function';
	  if (isFunction) has(val, 'name') || hide(val, 'name', key);
	  if (O[key] === val) return;
	  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
	  if (O === global) {
	    O[key] = val;
	  } else if (!safe) {
	    delete O[key];
	    hide(O, key, val);
	  } else if (O[key]) {
	    O[key] = val;
	  } else {
	    hide(O, key, val);
	  }
	  // add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	})(Function.prototype, TO_STRING, function toString() {
	  return typeof this == 'function' && this[SRC] || $toString.call(this);
	});

/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var $export = __webpack_require__(2);
	var fails = __webpack_require__(10);
	var defined = __webpack_require__(49);
	var quot = /"/g;
	// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
	var createHTML = function createHTML(string, tag, attribute, value) {
	  var S = String(defined(string));
	  var p1 = '<' + tag;
	  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
	  return p1 + '>' + S + '</' + tag + '>';
	};
	module.exports = function (NAME, exec) {
	  var O = {};
	  O[NAME] = exec(createHTML);
	  $export($export.P + $export.F * fails(function () {
	    var test = ''[NAME]('"');
	    return test !== test.toLowerCase() || test.split('"').length > 3;
	  }), 'String', O);
	};

/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(91);
	var defined = __webpack_require__(49);
	module.exports = function (it) {
	  return IObject(defined(it));
	};

/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	Object.defineProperty(exports, '__esModule', { value: !0 });var _withCommonProps = __webpack_require__(514);Object.defineProperty(exports, 'default', { enumerable: !0, get: function get() {
	    return _interopRequireDefault(_withCommonProps).default;
	  } });function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}

/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var pIE = __webpack_require__(92);
	var createDesc = __webpack_require__(70);
	var toIObject = __webpack_require__(37);
	var toPrimitive = __webpack_require__(52);
	var has = __webpack_require__(33);
	var IE8_DOM_DEFINE = __webpack_require__(209);
	var gOPD = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(20) ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) {/* empty */}
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};

/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(33);
	var toObject = __webpack_require__(24);
	var IE_PROTO = __webpack_require__(147)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  }return O instanceof Object ? ObjectProto : null;
	};

/***/ },
/* 41 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ },
/* 42 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = copyProps;
	function copyProps(inProps) {
	  var ignore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
	  // copys props into a new object
	  // ignore is an array of props you don't want copied
	  // ignore VSTComponent necessary props
	  ignore.push('primary');
	  ignore.push('accent');
	  ignore.push('theme');
	  ignore.push('themeMap');
	
	  var props = {};
	  var key = void 0;
	  for (key in inProps) {
	    if (inProps.hasOwnProperty(key) && !ignore.includes(key)) {
	      props[key] = inProps[key];
	    }
	  }
	  return props;
	}

/***/ },
/* 43 */
/***/ function(module, exports) {

	"use strict";
	
	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};

/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// optional / simple context binding
	var aFunction = __webpack_require__(27);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1:
	      return function (a) {
	        return fn.call(that, a);
	      };
	    case 2:
	      return function (a, b) {
	        return fn.call(that, a, b);
	      };
	    case 3:
	      return function (a, b, c) {
	        return fn.call(that, a, b, c);
	      };
	  }
	  return function () /* ...args */{
	    return fn.apply(that, arguments);
	  };
	};

/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var fails = __webpack_require__(10);
	
	module.exports = function (method, arg) {
	  return !!method && fails(function () {
	    // eslint-disable-next-line no-useless-call
	    arg ? method.call(null, function () {/* empty */}, 1) : method.call(null);
	  });
	};

/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	// Trust the developer to only use ReactInstrumentation with a __DEV__ check
	
	var debugTool = null;
	
	if (false) {
	  var ReactDebugTool = require('./ReactDebugTool');
	  debugTool = ReactDebugTool;
	}
	
	module.exports = { debugTool: debugTool };

/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// 0 -> Array#forEach
	// 1 -> Array#map
	// 2 -> Array#filter
	// 3 -> Array#some
	// 4 -> Array#every
	// 5 -> Array#find
	// 6 -> Array#findIndex
	var ctx = __webpack_require__(44);
	var IObject = __webpack_require__(91);
	var toObject = __webpack_require__(24);
	var toLength = __webpack_require__(22);
	var asc = __webpack_require__(132);
	module.exports = function (TYPE, $create) {
	  var IS_MAP = TYPE == 1;
	  var IS_FILTER = TYPE == 2;
	  var IS_SOME = TYPE == 3;
	  var IS_EVERY = TYPE == 4;
	  var IS_FIND_INDEX = TYPE == 6;
	  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
	  var create = $create || asc;
	  return function ($this, callbackfn, that) {
	    var O = toObject($this);
	    var self = IObject(O);
	    var f = ctx(callbackfn, that, 3);
	    var length = toLength(self.length);
	    var index = 0;
	    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
	    var val, res;
	    for (; length > index; index++) {
	      if (NO_HOLES || index in self) {
	        val = self[index];
	        res = f(val, index, O);
	        if (TYPE) {
	          if (IS_MAP) result[index] = res; // map
	          else if (res) switch (TYPE) {
	              case 3:
	                return true; // some
	              case 5:
	                return val; // find
	              case 6:
	                return index; // findIndex
	              case 2:
	                result.push(val); // filter
	            } else if (IS_EVERY) return false; // every
	        }
	      }
	    }return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
	  };
	};

/***/ },
/* 48 */
/***/ function(module, exports) {

	'use strict';
	
	var core = module.exports = { version: '2.5.0' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef

/***/ },
/* 49 */
/***/ function(module, exports) {

	"use strict";
	
	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};

/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(2);
	var core = __webpack_require__(48);
	var fails = __webpack_require__(10);
	module.exports = function (KEY, exec) {
	  var fn = (core.Object || {})[KEY] || Object[KEY];
	  var exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function () {
	    fn(1);
	  }), 'Object', exp);
	};

/***/ },
/* 51 */
/***/ function(module, exports) {

	"use strict";
	
	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};

/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(14);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};

/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(12),
	    _assign = __webpack_require__(11);
	
	var CallbackQueue = __webpack_require__(366);
	var PooledClass = __webpack_require__(75);
	var ReactFeatureFlags = __webpack_require__(371);
	var ReactReconciler = __webpack_require__(85);
	var Transaction = __webpack_require__(124);
	
	var invariant = __webpack_require__(5);
	
	var dirtyComponents = [];
	var updateBatchNumber = 0;
	var asapCallbackQueue = CallbackQueue.getPooled();
	var asapEnqueued = false;
	
	var batchingStrategy = null;
	
	function ensureInjected() {
	  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
	}
	
	var NESTED_UPDATES = {
	  initialize: function initialize() {
	    this.dirtyComponentsLength = dirtyComponents.length;
	  },
	  close: function close() {
	    if (this.dirtyComponentsLength !== dirtyComponents.length) {
	      // Additional updates were enqueued by componentDidUpdate handlers or
	      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
	      // these new updates so that if A's componentDidUpdate calls setState on
	      // B, B will update before the callback A's updater provided when calling
	      // setState.
	      dirtyComponents.splice(0, this.dirtyComponentsLength);
	      flushBatchedUpdates();
	    } else {
	      dirtyComponents.length = 0;
	    }
	  }
	};
	
	var UPDATE_QUEUEING = {
	  initialize: function initialize() {
	    this.callbackQueue.reset();
	  },
	  close: function close() {
	    this.callbackQueue.notifyAll();
	  }
	};
	
	var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];
	
	function ReactUpdatesFlushTransaction() {
	  this.reinitializeTransaction();
	  this.dirtyComponentsLength = null;
	  this.callbackQueue = CallbackQueue.getPooled();
	  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */true);
	}
	
	_assign(ReactUpdatesFlushTransaction.prototype, Transaction, {
	  getTransactionWrappers: function getTransactionWrappers() {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  destructor: function destructor() {
	    this.dirtyComponentsLength = null;
	    CallbackQueue.release(this.callbackQueue);
	    this.callbackQueue = null;
	    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
	    this.reconcileTransaction = null;
	  },
	
	  perform: function perform(method, scope, a) {
	    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
	    // with this transaction's wrappers around it.
	    return Transaction.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
	  }
	});
	
	PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);
	
	function batchedUpdates(callback, a, b, c, d, e) {
	  ensureInjected();
	  return batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
	}
	
	/**
	 * Array comparator for ReactComponents by mount ordering.
	 *
	 * @param {ReactComponent} c1 first component you're comparing
	 * @param {ReactComponent} c2 second component you're comparing
	 * @return {number} Return value usable by Array.prototype.sort().
	 */
	function mountOrderComparator(c1, c2) {
	  return c1._mountOrder - c2._mountOrder;
	}
	
	function runBatchedUpdates(transaction) {
	  var len = transaction.dirtyComponentsLength;
	  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;
	
	  // Since reconciling a component higher in the owner hierarchy usually (not
	  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
	  // them before their children by sorting the array.
	  dirtyComponents.sort(mountOrderComparator);
	
	  // Any updates enqueued while reconciling must be performed after this entire
	  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
	  // C, B could update twice in a single batch if C's render enqueues an update
	  // to B (since B would have already updated, we should skip it, and the only
	  // way we can know to do so is by checking the batch counter).
	  updateBatchNumber++;
	
	  for (var i = 0; i < len; i++) {
	    // If a component is unmounted before pending changes apply, it will still
	    // be here, but we assume that it has cleared its _pendingCallbacks and
	    // that performUpdateIfNecessary is a noop.
	    var component = dirtyComponents[i];
	
	    // If performUpdateIfNecessary happens to enqueue any new updates, we
	    // shouldn't execute the callbacks until the next render happens, so
	    // stash the callbacks first
	    var callbacks = component._pendingCallbacks;
	    component._pendingCallbacks = null;
	
	    var markerName;
	    if (ReactFeatureFlags.logTopLevelRenders) {
	      var namedComponent = component;
	      // Duck type TopLevelWrapper. This is probably always true.
	      if (component._currentElement.type.isReactTopLevelWrapper) {
	        namedComponent = component._renderedComponent;
	      }
	      markerName = 'React update: ' + namedComponent.getName();
	      console.time(markerName);
	    }
	
	    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);
	
	    if (markerName) {
	      console.timeEnd(markerName);
	    }
	
	    if (callbacks) {
	      for (var j = 0; j < callbacks.length; j++) {
	        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
	      }
	    }
	  }
	}
	
	var flushBatchedUpdates = function flushBatchedUpdates() {
	  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
	  // array and perform any updates enqueued by mount-ready handlers (i.e.,
	  // componentDidUpdate) but we need to check here too in order to catch
	  // updates enqueued by setState callbacks and asap calls.
	  while (dirtyComponents.length || asapEnqueued) {
	    if (dirtyComponents.length) {
	      var transaction = ReactUpdatesFlushTransaction.getPooled();
	      transaction.perform(runBatchedUpdates, null, transaction);
	      ReactUpdatesFlushTransaction.release(transaction);
	    }
	
	    if (asapEnqueued) {
	      asapEnqueued = false;
	      var queue = asapCallbackQueue;
	      asapCallbackQueue = CallbackQueue.getPooled();
	      queue.notifyAll();
	      CallbackQueue.release(queue);
	    }
	  }
	};
	
	/**
	 * Mark a component as needing a rerender, adding an optional callback to a
	 * list of functions which will be executed once the rerender occurs.
	 */
	function enqueueUpdate(component) {
	  ensureInjected();
	
	  // Various parts of our code (such as ReactCompositeComponent's
	  // _renderValidatedComponent) assume that calls to render aren't nested;
	  // verify that that's the case. (This is called by each top-level update
	  // function, like setState, forceUpdate, etc.; creation and
	  // destruction of top-level components is guarded in ReactMount.)
	
	  if (!batchingStrategy.isBatchingUpdates) {
	    batchingStrategy.batchedUpdates(enqueueUpdate, component);
	    return;
	  }
	
	  dirtyComponents.push(component);
	  if (component._updateBatchNumber == null) {
	    component._updateBatchNumber = updateBatchNumber + 1;
	  }
	}
	
	/**
	 * Enqueue a callback to be run at the end of the current batching cycle. Throws
	 * if no updates are currently being performed.
	 */
	function asap(callback, context) {
	  !batchingStrategy.isBatchingUpdates ?  false ? invariant(false, 'ReactUpdates.asap: Can\'t enqueue an asap callback in a context whereupdates are not being batched.') : _prodInvariant('125') : void 0;
	  asapCallbackQueue.enqueue(callback, context);
	  asapEnqueued = true;
	}
	
	var ReactUpdatesInjection = {
	  injectReconcileTransaction: function injectReconcileTransaction(ReconcileTransaction) {
	    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
	    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
	  },
	
	  injectBatchingStrategy: function injectBatchingStrategy(_batchingStrategy) {
	    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
	    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
	    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
	    batchingStrategy = _batchingStrategy;
	  }
	};
	
	var ReactUpdates = {
	  /**
	   * React references `ReactReconcileTransaction` using this property in order
	   * to allow dependency injection.
	   *
	   * @internal
	   */
	  ReactReconcileTransaction: null,
	
	  batchedUpdates: batchedUpdates,
	  enqueueUpdate: enqueueUpdate,
	  flushBatchedUpdates: flushBatchedUpdates,
	  injection: ReactUpdatesInjection,
	  asap: asap
	};
	
	module.exports = ReactUpdates;

/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var Map = __webpack_require__(229);
	var $export = __webpack_require__(2);
	var shared = __webpack_require__(115)('metadata');
	var store = shared.store || (shared.store = new (__webpack_require__(232))());
	
	var getOrCreateMetadataMap = function getOrCreateMetadataMap(target, targetKey, create) {
	  var targetMetadata = store.get(target);
	  if (!targetMetadata) {
	    if (!create) return undefined;
	    store.set(target, targetMetadata = new Map());
	  }
	  var keyMetadata = targetMetadata.get(targetKey);
	  if (!keyMetadata) {
	    if (!create) return undefined;
	    targetMetadata.set(targetKey, keyMetadata = new Map());
	  }return keyMetadata;
	};
	var ordinaryHasOwnMetadata = function ordinaryHasOwnMetadata(MetadataKey, O, P) {
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
	};
	var ordinaryGetOwnMetadata = function ordinaryGetOwnMetadata(MetadataKey, O, P) {
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
	};
	var ordinaryDefineOwnMetadata = function ordinaryDefineOwnMetadata(MetadataKey, MetadataValue, O, P) {
	  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
	};
	var ordinaryOwnMetadataKeys = function ordinaryOwnMetadataKeys(target, targetKey) {
	  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
	  var keys = [];
	  if (metadataMap) metadataMap.forEach(function (_, key) {
	    keys.push(key);
	  });
	  return keys;
	};
	var toMetaKey = function toMetaKey(it) {
	  return it === undefined || (typeof it === 'undefined' ? 'undefined' : _typeof(it)) == 'symbol' ? it : String(it);
	};
	var exp = function exp(O) {
	  $export($export.S, 'Reflect', O);
	};
	
	module.exports = {
	  store: store,
	  map: getOrCreateMetadataMap,
	  has: ordinaryHasOwnMetadata,
	  get: ordinaryGetOwnMetadata,
	  set: ordinaryDefineOwnMetadata,
	  keys: ordinaryOwnMetadataKeys,
	  key: toMetaKey,
	  exp: exp
	};

/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	if (__webpack_require__(20)) {
	  var LIBRARY = __webpack_require__(67);
	  var global = __webpack_require__(8);
	  var fails = __webpack_require__(10);
	  var $export = __webpack_require__(2);
	  var $typed = __webpack_require__(117);
	  var $buffer = __webpack_require__(153);
	  var ctx = __webpack_require__(44);
	  var anInstance = __webpack_require__(65);
	  var propertyDesc = __webpack_require__(70);
	  var hide = __webpack_require__(34);
	  var redefineAll = __webpack_require__(71);
	  var toInteger = __webpack_require__(51);
	  var toLength = __webpack_require__(22);
	  var toIndex = __webpack_require__(227);
	  var toAbsoluteIndex = __webpack_require__(73);
	  var toPrimitive = __webpack_require__(52);
	  var has = __webpack_require__(33);
	  var classof = __webpack_require__(90);
	  var isObject = __webpack_require__(14);
	  var toObject = __webpack_require__(24);
	  var isArrayIter = __webpack_require__(139);
	  var create = __webpack_require__(68);
	  var getPrototypeOf = __webpack_require__(40);
	  var gOPN = __webpack_require__(69).f;
	  var getIterFn = __webpack_require__(155);
	  var uid = __webpack_require__(74);
	  var wks = __webpack_require__(17);
	  var createArrayMethod = __webpack_require__(47);
	  var createArrayIncludes = __webpack_require__(103);
	  var speciesConstructor = __webpack_require__(116);
	  var ArrayIterators = __webpack_require__(156);
	  var Iterators = __webpack_require__(77);
	  var $iterDetect = __webpack_require__(110);
	  var setSpecies = __webpack_require__(72);
	  var arrayFill = __webpack_require__(131);
	  var arrayCopyWithin = __webpack_require__(201);
	  var $DP = __webpack_require__(21);
	  var $GOPD = __webpack_require__(39);
	  var dP = $DP.f;
	  var gOPD = $GOPD.f;
	  var RangeError = global.RangeError;
	  var TypeError = global.TypeError;
	  var Uint8Array = global.Uint8Array;
	  var ARRAY_BUFFER = 'ArrayBuffer';
	  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
	  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
	  var PROTOTYPE = 'prototype';
	  var ArrayProto = Array[PROTOTYPE];
	  var $ArrayBuffer = $buffer.ArrayBuffer;
	  var $DataView = $buffer.DataView;
	  var arrayForEach = createArrayMethod(0);
	  var arrayFilter = createArrayMethod(2);
	  var arraySome = createArrayMethod(3);
	  var arrayEvery = createArrayMethod(4);
	  var arrayFind = createArrayMethod(5);
	  var arrayFindIndex = createArrayMethod(6);
	  var arrayIncludes = createArrayIncludes(true);
	  var arrayIndexOf = createArrayIncludes(false);
	  var arrayValues = ArrayIterators.values;
	  var arrayKeys = ArrayIterators.keys;
	  var arrayEntries = ArrayIterators.entries;
	  var arrayLastIndexOf = ArrayProto.lastIndexOf;
	  var arrayReduce = ArrayProto.reduce;
	  var arrayReduceRight = ArrayProto.reduceRight;
	  var arrayJoin = ArrayProto.join;
	  var arraySort = ArrayProto.sort;
	  var arraySlice = ArrayProto.slice;
	  var arrayToString = ArrayProto.toString;
	  var arrayToLocaleString = ArrayProto.toLocaleString;
	  var ITERATOR = wks('iterator');
	  var TAG = wks('toStringTag');
	  var TYPED_CONSTRUCTOR = uid('typed_constructor');
	  var DEF_CONSTRUCTOR = uid('def_constructor');
	  var ALL_CONSTRUCTORS = $typed.CONSTR;
	  var TYPED_ARRAY = $typed.TYPED;
	  var VIEW = $typed.VIEW;
	  var WRONG_LENGTH = 'Wrong length!';
	
	  var $map = createArrayMethod(1, function (O, length) {
	    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
	  });
	
	  var LITTLE_ENDIAN = fails(function () {
	    // eslint-disable-next-line no-undef
	    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
	  });
	
	  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
	    new Uint8Array(1).set({});
	  });
	
	  var toOffset = function toOffset(it, BYTES) {
	    var offset = toInteger(it);
	    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
	    return offset;
	  };
	
	  var validate = function validate(it) {
	    if (isObject(it) && TYPED_ARRAY in it) return it;
	    throw TypeError(it + ' is not a typed array!');
	  };
	
	  var allocate = function allocate(C, length) {
	    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
	      throw TypeError('It is not a typed array constructor!');
	    }return new C(length);
	  };
	
	  var speciesFromList = function speciesFromList(O, list) {
	    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
	  };
	
	  var fromList = function fromList(C, list) {
	    var index = 0;
	    var length = list.length;
	    var result = allocate(C, length);
	    while (length > index) {
	      result[index] = list[index++];
	    }return result;
	  };
	
	  var addGetter = function addGetter(it, key, internal) {
	    dP(it, key, { get: function get() {
	        return this._d[internal];
	      } });
	  };
	
	  var $from = function from(source /* , mapfn, thisArg */) {
	    var O = toObject(source);
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var iterFn = getIterFn(O);
	    var i, length, values, result, step, iterator;
	    if (iterFn != undefined && !isArrayIter(iterFn)) {
	      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
	        values.push(step.value);
	      }O = values;
	    }
	    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
	    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
	      result[i] = mapping ? mapfn(O[i], i) : O[i];
	    }
	    return result;
	  };
	
	  var $of = function of() /* ...items */{
	    var index = 0;
	    var length = arguments.length;
	    var result = allocate(this, length);
	    while (length > index) {
	      result[index] = arguments[index++];
	    }return result;
	  };
	
	  // iOS Safari 6.x fails here
	  var TO_LOCALE_BUG = !!Uint8Array && fails(function () {
	    arrayToLocaleString.call(new Uint8Array(1));
	  });
	
	  var $toLocaleString = function toLocaleString() {
	    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
	  };
	
	  var proto = {
	    copyWithin: function copyWithin(target, start /* , end */) {
	      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
	    },
	    every: function every(callbackfn /* , thisArg */) {
	      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    fill: function fill(value /* , start, end */) {
	      // eslint-disable-line no-unused-vars
	      return arrayFill.apply(validate(this), arguments);
	    },
	    filter: function filter(callbackfn /* , thisArg */) {
	      return speciesFromList(this, arrayFilter(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined));
	    },
	    find: function find(predicate /* , thisArg */) {
	      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    findIndex: function findIndex(predicate /* , thisArg */) {
	      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    forEach: function forEach(callbackfn /* , thisArg */) {
	      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    indexOf: function indexOf(searchElement /* , fromIndex */) {
	      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    includes: function includes(searchElement /* , fromIndex */) {
	      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    join: function join(separator) {
	      // eslint-disable-line no-unused-vars
	      return arrayJoin.apply(validate(this), arguments);
	    },
	    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) {
	      // eslint-disable-line no-unused-vars
	      return arrayLastIndexOf.apply(validate(this), arguments);
	    },
	    map: function map(mapfn /* , thisArg */) {
	      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    reduce: function reduce(callbackfn /* , initialValue */) {
	      // eslint-disable-line no-unused-vars
	      return arrayReduce.apply(validate(this), arguments);
	    },
	    reduceRight: function reduceRight(callbackfn /* , initialValue */) {
	      // eslint-disable-line no-unused-vars
	      return arrayReduceRight.apply(validate(this), arguments);
	    },
	    reverse: function reverse() {
	      var that = this;
	      var length = validate(that).length;
	      var middle = Math.floor(length / 2);
	      var index = 0;
	      var value;
	      while (index < middle) {
	        value = that[index];
	        that[index++] = that[--length];
	        that[length] = value;
	      }return that;
	    },
	    some: function some(callbackfn /* , thisArg */) {
	      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    sort: function sort(comparefn) {
	      return arraySort.call(validate(this), comparefn);
	    },
	    subarray: function subarray(begin, end) {
	      var O = validate(this);
	      var length = O.length;
	      var $begin = toAbsoluteIndex(begin, length);
	      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(O.buffer, O.byteOffset + $begin * O.BYTES_PER_ELEMENT, toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin));
	    }
	  };
	
	  var $slice = function slice(start, end) {
	    return speciesFromList(this, arraySlice.call(validate(this), start, end));
	  };
	
	  var $set = function set(arrayLike /* , offset */) {
	    validate(this);
	    var offset = toOffset(arguments[1], 1);
	    var length = this.length;
	    var src = toObject(arrayLike);
	    var len = toLength(src.length);
	    var index = 0;
	    if (len + offset > length) throw RangeError(WRONG_LENGTH);
	    while (index < len) {
	      this[offset + index] = src[index++];
	    }
	  };
	
	  var $iterators = {
	    entries: function entries() {
	      return arrayEntries.call(validate(this));
	    },
	    keys: function keys() {
	      return arrayKeys.call(validate(this));
	    },
	    values: function values() {
	      return arrayValues.call(validate(this));
	    }
	  };
	
	  var isTAIndex = function isTAIndex(target, key) {
	    return isObject(target) && target[TYPED_ARRAY] && (typeof key === 'undefined' ? 'undefined' : _typeof(key)) != 'symbol' && key in target && String(+key) == String(key);
	  };
	  var $getDesc = function getOwnPropertyDescriptor(target, key) {
	    return isTAIndex(target, key = toPrimitive(key, true)) ? propertyDesc(2, target[key]) : gOPD(target, key);
	  };
	  var $setDesc = function defineProperty(target, key, desc) {
	    if (isTAIndex(target, key = toPrimitive(key, true)) && isObject(desc) && has(desc, 'value') && !has(desc, 'get') && !has(desc, 'set')
	    // TODO: add validation descriptor w/o calling accessors
	    && !desc.configurable && (!has(desc, 'writable') || desc.writable) && (!has(desc, 'enumerable') || desc.enumerable)) {
	      target[key] = desc.value;
	      return target;
	    }return dP(target, key, desc);
	  };
	
	  if (!ALL_CONSTRUCTORS) {
	    $GOPD.f = $getDesc;
	    $DP.f = $setDesc;
	  }
	
	  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
	    getOwnPropertyDescriptor: $getDesc,
	    defineProperty: $setDesc
	  });
	
	  if (fails(function () {
	    arrayToString.call({});
	  })) {
	    arrayToString = arrayToLocaleString = function toString() {
	      return arrayJoin.call(this);
	    };
	  }
	
	  var $TypedArrayPrototype$ = redefineAll({}, proto);
	  redefineAll($TypedArrayPrototype$, $iterators);
	  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
	  redefineAll($TypedArrayPrototype$, {
	    slice: $slice,
	    set: $set,
	    constructor: function constructor() {/* noop */},
	    toString: arrayToString,
	    toLocaleString: $toLocaleString
	  });
	  addGetter($TypedArrayPrototype$, 'buffer', 'b');
	  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
	  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
	  addGetter($TypedArrayPrototype$, 'length', 'e');
	  dP($TypedArrayPrototype$, TAG, {
	    get: function get() {
	      return this[TYPED_ARRAY];
	    }
	  });
	
	  // eslint-disable-next-line max-statements
	  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
	    CLAMPED = !!CLAMPED;
	    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
	    var GETTER = 'get' + KEY;
	    var SETTER = 'set' + KEY;
	    var TypedArray = global[NAME];
	    var Base = TypedArray || {};
	    var TAC = TypedArray && getPrototypeOf(TypedArray);
	    var FORCED = !TypedArray || !$typed.ABV;
	    var O = {};
	    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
	    var getter = function getter(that, index) {
	      var data = that._d;
	      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
	    };
	    var setter = function setter(that, index, value) {
	      var data = that._d;
	      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
	      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
	    };
	    var addElement = function addElement(that, index) {
	      dP(that, index, {
	        get: function get() {
	          return getter(this, index);
	        },
	        set: function set(value) {
	          return setter(this, index, value);
	        },
	        enumerable: true
	      });
	    };
	    if (FORCED) {
	      TypedArray = wrapper(function (that, data, $offset, $length) {
	        anInstance(that, TypedArray, NAME, '_d');
	        var index = 0;
	        var offset = 0;
	        var buffer, byteLength, length, klass;
	        if (!isObject(data)) {
	          length = toIndex(data);
	          byteLength = length * BYTES;
	          buffer = new $ArrayBuffer(byteLength);
	        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
	          buffer = data;
	          offset = toOffset($offset, BYTES);
	          var $len = data.byteLength;
	          if ($length === undefined) {
	            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
	            byteLength = $len - offset;
	            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
	          } else {
	            byteLength = toLength($length) * BYTES;
	            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
	          }
	          length = byteLength / BYTES;
	        } else if (TYPED_ARRAY in data) {
	          return fromList(TypedArray, data);
	        } else {
	          return $from.call(TypedArray, data);
	        }
	        hide(that, '_d', {
	          b: buffer,
	          o: offset,
	          l: byteLength,
	          e: length,
	          v: new $DataView(buffer)
	        });
	        while (index < length) {
	          addElement(that, index++);
	        }
	      });
	      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
	      hide(TypedArrayPrototype, 'constructor', TypedArray);
	    } else if (!fails(function () {
	      TypedArray(1);
	    }) || !fails(function () {
	      new TypedArray(-1); // eslint-disable-line no-new
	    }) || !$iterDetect(function (iter) {
	      new TypedArray(); // eslint-disable-line no-new
	      new TypedArray(null); // eslint-disable-line no-new
	      new TypedArray(1.5); // eslint-disable-line no-new
	      new TypedArray(iter); // eslint-disable-line no-new
	    }, true)) {
	      TypedArray = wrapper(function (that, data, $offset, $length) {
	        anInstance(that, TypedArray, NAME);
	        var klass;
	        // `ws` module bug, temporarily remove validation length for Uint8Array
	        // https://github.com/websockets/ws/pull/645
	        if (!isObject(data)) return new Base(toIndex(data));
	        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
	          return $length !== undefined ? new Base(data, toOffset($offset, BYTES), $length) : $offset !== undefined ? new Base(data, toOffset($offset, BYTES)) : new Base(data);
	        }
	        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
	        return $from.call(TypedArray, data);
	      });
	      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
	        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
	      });
	      TypedArray[PROTOTYPE] = TypedArrayPrototype;
	      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
	    }
	    var $nativeIterator = TypedArrayPrototype[ITERATOR];
	    var CORRECT_ITER_NAME = !!$nativeIterator && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
	    var $iterator = $iterators.values;
	    hide(TypedArray, TYPED_CONSTRUCTOR, true);
	    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
	    hide(TypedArrayPrototype, VIEW, true);
	    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);
	
	    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
	      dP(TypedArrayPrototype, TAG, {
	        get: function get() {
	          return NAME;
	        }
	      });
	    }
	
	    O[NAME] = TypedArray;
	
	    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);
	
	    $export($export.S, NAME, {
	      BYTES_PER_ELEMENT: BYTES
	    });
	
	    $export($export.S + $export.F * fails(function () {
	      Base.of.call(TypedArray, 1);
	    }), NAME, {
	      from: $from,
	      of: $of
	    });
	
	    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);
	
	    $export($export.P, NAME, proto);
	
	    setSpecies(NAME);
	
	    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });
	
	    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);
	
	    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;
	
	    $export($export.P + $export.F * fails(function () {
	      new TypedArray(1).slice();
	    }), NAME, { slice: $slice });
	
	    $export($export.P + $export.F * (fails(function () {
	      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
	    }) || !fails(function () {
	      TypedArrayPrototype.toLocaleString.call([1, 2]);
	    })), NAME, { toLocaleString: $toLocaleString });
	
	    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
	    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
	  };
	} else module.exports = function () {/* empty */};

/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(11);
	
	var PooledClass = __webpack_require__(75);
	
	var emptyFunction = __webpack_require__(41);
	var warning = __webpack_require__(9);
	
	var didWarnForAddedNewProperty = false;
	var isProxySupported = typeof Proxy === 'function';
	
	var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var EventInterface = {
	  type: null,
	  target: null,
	  // currentTarget is set when dispatching; no use in copying it here
	  currentTarget: emptyFunction.thatReturnsNull,
	  eventPhase: null,
	  bubbles: null,
	  cancelable: null,
	  timeStamp: function timeStamp(event) {
	    return event.timeStamp || Date.now();
	  },
	  defaultPrevented: null,
	  isTrusted: null
	};
	
	/**
	 * Synthetic events are dispatched by event plugins, typically in response to a
	 * top-level event delegation handler.
	 *
	 * These systems should generally use pooling to reduce the frequency of garbage
	 * collection. The system should check `isPersistent` to determine whether the
	 * event should be released into the pool after being dispatched. Users that
	 * need a persisted event should invoke `persist`.
	 *
	 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
	 * normalizing browser quirks. Subclasses do not necessarily have to implement a
	 * DOM interface; custom application-specific events can also subclass this.
	 *
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {*} targetInst Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @param {DOMEventTarget} nativeEventTarget Target node.
	 */
	function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
	  if (false) {
	    // these have a getter/setter for warnings
	    delete this.nativeEvent;
	    delete this.preventDefault;
	    delete this.stopPropagation;
	  }
	
	  this.dispatchConfig = dispatchConfig;
	  this._targetInst = targetInst;
	  this.nativeEvent = nativeEvent;
	
	  var Interface = this.constructor.Interface;
	  for (var propName in Interface) {
	    if (!Interface.hasOwnProperty(propName)) {
	      continue;
	    }
	    if (false) {
	      delete this[propName]; // this has a getter/setter for warnings
	    }
	    var normalize = Interface[propName];
	    if (normalize) {
	      this[propName] = normalize(nativeEvent);
	    } else {
	      if (propName === 'target') {
	        this.target = nativeEventTarget;
	      } else {
	        this[propName] = nativeEvent[propName];
	      }
	    }
	  }
	
	  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
	  if (defaultPrevented) {
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  } else {
	    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
	  }
	  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
	  return this;
	}
	
	_assign(SyntheticEvent.prototype, {
	  preventDefault: function preventDefault() {
	    this.defaultPrevented = true;
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.preventDefault) {
	      event.preventDefault();
	      // eslint-disable-next-line valid-typeof
	    } else if (typeof event.returnValue !== 'unknown') {
	      event.returnValue = false;
	    }
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  },
	
	  stopPropagation: function stopPropagation() {
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.stopPropagation) {
	      event.stopPropagation();
	      // eslint-disable-next-line valid-typeof
	    } else if (typeof event.cancelBubble !== 'unknown') {
	      // The ChangeEventPlugin registers a "propertychange" event for
	      // IE. This event does not support bubbling or cancelling, and
	      // any references to cancelBubble throw "Member not found".  A
	      // typeof check of "unknown" circumvents this issue (and is also
	      // IE specific).
	      event.cancelBubble = true;
	    }
	
	    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * We release all dispatched `SyntheticEvent`s after each event loop, adding
	   * them back into the pool. This allows a way to hold onto a reference that
	   * won't be added back into the pool.
	   */
	  persist: function persist() {
	    this.isPersistent = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * Checks if this event should be released back into the pool.
	   *
	   * @return {boolean} True if this should not be released, false otherwise.
	   */
	  isPersistent: emptyFunction.thatReturnsFalse,
	
	  /**
	   * `PooledClass` looks for `destructor` on each instance it releases.
	   */
	  destructor: function destructor() {
	    var Interface = this.constructor.Interface;
	    for (var propName in Interface) {
	      if (false) {
	        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
	      } else {
	        this[propName] = null;
	      }
	    }
	    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
	      this[shouldBeReleasedProperties[i]] = null;
	    }
	    if (false) {
	      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
	      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
	      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
	    }
	  }
	});
	
	SyntheticEvent.Interface = EventInterface;
	
	if (false) {
	  if (isProxySupported) {
	    /*eslint-disable no-func-assign */
	    SyntheticEvent = new Proxy(SyntheticEvent, {
	      construct: function construct(target, args) {
	        return this.apply(target, Object.create(target.prototype), args);
	      },
	      apply: function apply(constructor, that, args) {
	        return new Proxy(constructor.apply(that, args), {
	          set: function set(target, prop, value) {
	            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
	              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), "This synthetic event is reused for performance reasons. If you're " + "seeing this, you're adding a new property in the synthetic event object. " + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
	              didWarnForAddedNewProperty = true;
	            }
	            target[prop] = value;
	            return true;
	          }
	        });
	      }
	    });
	    /*eslint-enable no-func-assign */
	  }
	}
	/**
	 * Helper to reduce boilerplate when creating subclasses.
	 *
	 * @param {function} Class
	 * @param {?object} Interface
	 */
	SyntheticEvent.augmentClass = function (Class, Interface) {
	  var Super = this;
	
	  var E = function E() {};
	  E.prototype = Super.prototype;
	  var prototype = new E();
	
	  _assign(prototype, Class.prototype);
	  Class.prototype = prototype;
	  Class.prototype.constructor = Class;
	
	  Class.Interface = _assign({}, Super.Interface, Interface);
	  Class.augmentClass = Super.augmentClass;
	
	  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
	};
	
	PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);
	
	module.exports = SyntheticEvent;
	
	/**
	  * Helper to nullify syntheticEvent instance properties when destructing
	  *
	  * @param {object} SyntheticEvent
	  * @param {String} propName
	  * @return {object} defineProperty object
	  */
	function getPooledWarningPropertyDefinition(propName, getVal) {
	  var isFunction = typeof getVal === 'function';
	  return {
	    configurable: true,
	    set: set,
	    get: get
	  };
	
	  function set(val) {
	    var action = isFunction ? 'setting the method' : 'setting the property';
	    warn(action, 'This is effectively a no-op');
	    return val;
	  }
	
	  function get() {
	    var action = isFunction ? 'accessing the method' : 'accessing the property';
	    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
	    warn(action, result);
	    return getVal;
	  }
	
	  function warn(action, result) {
	    var warningCondition = false;
	     false ? warning(warningCondition, "This synthetic event is reused for performance reasons. If you're seeing this, " + "you're %s `%s` on a released/nullified synthetic event. %s. " + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
	  }
	}

/***/ },
/* 57 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Keeps track of the current owner.
	 *
	 * The current owner is the component who should own any components that are
	 * currently being constructed.
	 */
	
	var ReactCurrentOwner = {
	  /**
	   * @internal
	   * @type {ReactComponent}
	   */
	  current: null
	};
	
	module.exports = ReactCurrentOwner;

/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	Object.defineProperty(exports, '__esModule', { value: !0 });var _Button = __webpack_require__(403);Object.defineProperty(exports, 'default', { enumerable: !0, get: function get() {
	    return _interopRequireDefault(_Button).default;
	  } });function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}

/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	Object.defineProperty(exports, '__esModule', { value: !0 });var _createEvent = __webpack_require__(511);Object.defineProperty(exports, 'createEvent', { enumerable: !0, get: function get() {
	    return _interopRequireDefault(_createEvent).default;
	  } });var _entries = __webpack_require__(512);Object.defineProperty(exports, 'entries', { enumerable: !0, get: function get() {
	    return _interopRequireDefault(_entries).default;
	  } });var _generateUniqueId = __webpack_require__(513);Object.defineProperty(exports, 'generateUniqueId', { enumerable: !0, get: function get() {
	    return _interopRequireDefault(_generateUniqueId).default;
	  } });function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}

/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// 22.1.3.31 Array.prototype[@@unscopables]
	var UNSCOPABLES = __webpack_require__(17)('unscopables');
	var ArrayProto = Array.prototype;
	if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(34)(ArrayProto, UNSCOPABLES, {});
	module.exports = function (key) {
	  ArrayProto[UNSCOPABLES][key] = true;
	};

/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var META = __webpack_require__(74)('meta');
	var isObject = __webpack_require__(14);
	var has = __webpack_require__(33);
	var setDesc = __webpack_require__(21).f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__webpack_require__(10)(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function setMeta(it) {
	  setDesc(it, META, { value: {
	      i: 'O' + ++id, // object ID
	      w: {} // weak collections IDs
	    } });
	};
	var fastKey = function fastKey(it, create) {
	  // return primitive with prefix
	  if (!isObject(it)) return (typeof it === 'undefined' ? 'undefined' : _typeof(it)) == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	    // return object ID
	  }return it[META].i;
	};
	var getWeak = function getWeak(it, create) {
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	    // return hash weak collections IDs
	  }return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function onFreeze(it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};

/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(219);
	var enumBugKeys = __webpack_require__(135);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};

/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(836);

/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addClassName;
	
	var _copyProps = __webpack_require__(42);
	
	var _copyProps2 = _interopRequireDefault(_copyProps);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function addClassName(inProps, klass) {
	  var props = (0, _copyProps2.default)(inProps);
	  props.className = props.className ? klass + ' ' + props.className : klass;
	
	  return props;
	}

/***/ },
/* 65 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function (it, Constructor, name, forbiddenField) {
	  if (!(it instanceof Constructor) || forbiddenField !== undefined && forbiddenField in it) {
	    throw TypeError(name + ': incorrect invocation!');
	  }return it;
	};

/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var ctx = __webpack_require__(44);
	var call = __webpack_require__(211);
	var isArrayIter = __webpack_require__(139);
	var anObject = __webpack_require__(7);
	var toLength = __webpack_require__(22);
	var getIterFn = __webpack_require__(155);
	var BREAK = {};
	var RETURN = {};
	var _exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
	  var iterFn = ITERATOR ? function () {
	    return iterable;
	  } : getIterFn(iterable);
	  var f = ctx(fn, that, entries ? 2 : 1);
	  var index = 0;
	  var length, step, iterator, result;
	  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
	    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if (result === BREAK || result === RETURN) return result;
	  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
	    result = call(iterator, f, step.value, entries);
	    if (result === BREAK || result === RETURN) return result;
	  }
	};
	_exports.BREAK = BREAK;
	_exports.RETURN = RETURN;

/***/ },
/* 67 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = false;

/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(7);
	var dPs = __webpack_require__(217);
	var enumBugKeys = __webpack_require__(135);
	var IE_PROTO = __webpack_require__(147)('IE_PROTO');
	var Empty = function Empty() {/* empty */};
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var _createDict = function createDict() {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(134)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(137).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  _createDict = iframeDocument.F;
	  while (i--) {
	    delete _createDict[PROTOTYPE][enumBugKeys[i]];
	  }return _createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = _createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};

/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = __webpack_require__(219);
	var hiddenKeys = __webpack_require__(135).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};

/***/ },
/* 70 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};

/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var redefine = __webpack_require__(35);
	module.exports = function (target, src, safe) {
	  for (var key in src) {
	    redefine(target, key, src[key], safe);
	  }return target;
	};

/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var global = __webpack_require__(8);
	var dP = __webpack_require__(21);
	var DESCRIPTORS = __webpack_require__(20);
	var SPECIES = __webpack_require__(17)('species');
	
	module.exports = function (KEY) {
	  var C = global[KEY];
	  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
	    configurable: true,
	    get: function get() {
	      return this;
	    }
	  });
	};

/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var toInteger = __webpack_require__(51);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};

/***/ },
/* 74 */
/***/ function(module, exports) {

	'use strict';
	
	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};

/***/ },
/* 75 */
[1043, 12],
/* 76 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function namespaceOptions(prefix, options) {
	  // adds vst- to all options (since they get added as classes)
	  if (!options) {
	    return [];
	  }
	  return options.split(' ').map(function (option) {
	    if (option.indexOf(prefix + '-') === 0) {
	      return option;
	    }
	    return prefix + '-' + option;
	  });
	}
	
	exports.default = namespaceOptions;

/***/ },
/* 77 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = {};

/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var def = __webpack_require__(21).f;
	var has = __webpack_require__(33);
	var TAG = __webpack_require__(17)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};

/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var $export = __webpack_require__(2);
	var defined = __webpack_require__(49);
	var fails = __webpack_require__(10);
	var spaces = __webpack_require__(151);
	var space = '[' + spaces + ']';
	var non = '\u200B\x85';
	var ltrim = RegExp('^' + space + space + '*');
	var rtrim = RegExp(space + space + '*$');
	
	var exporter = function exporter(KEY, exec, ALIAS) {
	  var exp = {};
	  var FORCE = fails(function () {
	    return !!spaces[KEY]() || non[KEY]() != non;
	  });
	  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
	  if (ALIAS) exp[ALIAS] = fn;
	  $export($export.P + $export.F * FORCE, 'String', exp);
	};
	
	// 1 -> String#trimLeft
	// 2 -> String#trimRight
	// 3 -> String#trim
	var trim = exporter.trim = function (string, TYPE) {
	  string = String(defined(string));
	  if (TYPE & 1) string = string.replace(ltrim, '');
	  if (TYPE & 2) string = string.replace(rtrim, '');
	  return string;
	};
	
	module.exports = exporter;

/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var isObject = __webpack_require__(14);
	module.exports = function (it, TYPE) {
	  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
	  return it;
	};

/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _dispatcher = __webpack_require__(18);
	
	var _dispatcher2 = _interopRequireDefault(_dispatcher);
	
	var _honeybadgerJs = __webpack_require__(245);
	
	var _honeybadgerJs2 = _interopRequireDefault(_honeybadgerJs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UserStore = {
	
	  _state: undefined,
	
	  isLoading: false,
	
	  get: function get() {
	    this._load();
	    return this._state;
	  },
	  _updateState: function _updateState(state) {
	    this._state = state;
	    _dispatcher2.default.emit(_dispatcher2.default.USER_STORE_CHANGE);
	  },
	  _load: function _load(update) {
	    if (!this.isLoading && (update || this._state === undefined)) {
	      this.isLoading = true;
	      Jigsaw.User.getInfo(function (response) {
	        if (response.isSuccess()) {
	          var user = response.data.user;
	          this._updateState(user);
	          if (user.needsBookListUpdate) {
	            this._updateBookList();
	          }
	          _honeybadgerJs2.default.setContext({
	            user_id: user.identifier || ""
	          });
	        } else if (response.code === 401) {
	          _dispatcher2.default.emit(_dispatcher2.default.USER_SIGN_OUT);
	          if (!Routes.getRoute()[0].match(/login|redirect|logout/)) {
	            Routes.setRoute('/login');
	          }
	          _honeybadgerJs2.default.setContext({
	            user_id: ""
	          });
	        }
	        this.isLoading = false;
	      }.bind(this));
	    }
	  },
	  _updateBookList: function _updateBookList() {
	    var _this = this;
	
	    if (this._state) {
	      this._state.licenseUpdating = true;
	    }
	    this._updateState(this._state);
	    Jigsaw.User.updateLicense(function (response) {
	      if (response.isSuccess()) {
	        _dispatcher2.default.emit(_dispatcher2.default.USER_LICENSE_UPDATED);
	        if (_this._state) {
	          _this._state.needsBookListUpdate = false;
	          _this._state.licenseUpdating = false;
	          _this._updateState(_this._state);
	        }
	      }
	    });
	  },
	  _setInfoRouter: function _setInfoRouter(info, success, failure) {
	    var _this2 = this;
	
	    Jigsaw.User.setInfo(info, function (response) {
	      if (response.isSuccess()) {
	        _dispatcher2.default.emit(success);
	        _this2._updateState(response.data);
	      } else {
	        _dispatcher2.default.emit(failure, response.data);
	      }
	    });
	  },
	  init: function init() {
	    var _this3 = this;
	
	    _dispatcher2.default.on(_dispatcher2.default.USER_SET_INFO, function (info) {
	      _this3._setInfoRouter(info, _dispatcher2.default.USER_UPDATE_SUCCESS, _dispatcher2.default.USER_UPDATE_FAILURE);
	    });
	    _dispatcher2.default.on(_dispatcher2.default.USER_CHANGE_PASSWORD, function (info) {
	      _this3._setInfoRouter(info, _dispatcher2.default.USER_CHANGE_PASSWORD_SUCCESS, _dispatcher2.default.USER_CHANGE_PASSWORD_FAILURE);
	    });
	    _dispatcher2.default.on(_dispatcher2.default.USER_UPDATE_SECURITY_QUESTION, function (info) {
	      _this3._setInfoRouter(info, _dispatcher2.default.USER_UPDATE_SECURITY_SUCCESS, _dispatcher2.default.USER_UPDATE_SECURITY_FAILURE);
	    });
	    _dispatcher2.default.on(_dispatcher2.default.USER_UPDATE_NOTIFICATION, function (info) {
	      _this3._setInfoRouter(info, _dispatcher2.default.USER_UPDATE_NOTIFICATION_SUCCESS, _dispatcher2.default.USER_UPDATE_NOTIFICATION_FAILURE);
	    });
	    _dispatcher2.default.on(_dispatcher2.default.USER_SIGN_OUT, function (info) {
	      _this3._updateState(undefined);
	    });
	  }
	};
	
	UserStore.init();
	
	exports.default = UserStore;

/***/ },
/* 82 */
/***/ function(module, exports) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	function EventEmitter() {
	  this._events = this._events || {};
	  this._maxListeners = this._maxListeners || undefined;
	}
	module.exports = EventEmitter;
	
	// Backwards-compat with node 0.10.x
	EventEmitter.EventEmitter = EventEmitter;
	
	EventEmitter.prototype._events = undefined;
	EventEmitter.prototype._maxListeners = undefined;
	
	// By default EventEmitters will print a warning if more than 10 listeners are
	// added to it. This is a useful default which helps finding memory leaks.
	EventEmitter.defaultMaxListeners = 10;
	
	// Obviously not all Emitters should be limited to 10. This function allows
	// that to be increased. Set to zero for unlimited.
	EventEmitter.prototype.setMaxListeners = function (n) {
	  if (!isNumber(n) || n < 0 || isNaN(n)) throw TypeError('n must be a positive number');
	  this._maxListeners = n;
	  return this;
	};
	
	EventEmitter.prototype.emit = function (type) {
	  var er, handler, len, args, i, listeners;
	
	  if (!this._events) this._events = {};
	
	  // If there is no 'error' event listener then throw.
	  if (type === 'error') {
	    if (!this._events.error || isObject(this._events.error) && !this._events.error.length) {
	      er = arguments[1];
	      if (er instanceof Error) {
	        throw er; // Unhandled 'error' event
	      } else {
	        // At least give some kind of context to the user
	        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
	        err.context = er;
	        throw err;
	      }
	    }
	  }
	
	  handler = this._events[type];
	
	  if (isUndefined(handler)) return false;
	
	  if (isFunction(handler)) {
	    switch (arguments.length) {
	      // fast cases
	      case 1:
	        handler.call(this);
	        break;
	      case 2:
	        handler.call(this, arguments[1]);
	        break;
	      case 3:
	        handler.call(this, arguments[1], arguments[2]);
	        break;
	      // slower
	      default:
	        args = Array.prototype.slice.call(arguments, 1);
	        handler.apply(this, args);
	    }
	  } else if (isObject(handler)) {
	    args = Array.prototype.slice.call(arguments, 1);
	    listeners = handler.slice();
	    len = listeners.length;
	    for (i = 0; i < len; i++) {
	      listeners[i].apply(this, args);
	    }
	  }
	
	  return true;
	};
	
	EventEmitter.prototype.addListener = function (type, listener) {
	  var m;
	
	  if (!isFunction(listener)) throw TypeError('listener must be a function');
	
	  if (!this._events) this._events = {};
	
	  // To avoid recursion in the case that type === "newListener"! Before
	  // adding it to the listeners, first emit "newListener".
	  if (this._events.newListener) this.emit('newListener', type, isFunction(listener.listener) ? listener.listener : listener);
	
	  if (!this._events[type])
	    // Optimize the case of one listener. Don't need the extra array object.
	    this._events[type] = listener;else if (isObject(this._events[type]))
	    // If we've already got an array, just append.
	    this._events[type].push(listener);else
	    // Adding the second element, need to change to array.
	    this._events[type] = [this._events[type], listener];
	
	  // Check for listener leak
	  if (isObject(this._events[type]) && !this._events[type].warned) {
	    if (!isUndefined(this._maxListeners)) {
	      m = this._maxListeners;
	    } else {
	      m = EventEmitter.defaultMaxListeners;
	    }
	
	    if (m && m > 0 && this._events[type].length > m) {
	      this._events[type].warned = true;
	      console.error('(node) warning: possible EventEmitter memory ' + 'leak detected. %d listeners added. ' + 'Use emitter.setMaxListeners() to increase limit.', this._events[type].length);
	      if (typeof console.trace === 'function') {
	        // not supported in IE 10
	        console.trace();
	      }
	    }
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.on = EventEmitter.prototype.addListener;
	
	EventEmitter.prototype.once = function (type, listener) {
	  if (!isFunction(listener)) throw TypeError('listener must be a function');
	
	  var fired = false;
	
	  function g() {
	    this.removeListener(type, g);
	
	    if (!fired) {
	      fired = true;
	      listener.apply(this, arguments);
	    }
	  }
	
	  g.listener = listener;
	  this.on(type, g);
	
	  return this;
	};
	
	// emits a 'removeListener' event iff the listener was removed
	EventEmitter.prototype.removeListener = function (type, listener) {
	  var list, position, length, i;
	
	  if (!isFunction(listener)) throw TypeError('listener must be a function');
	
	  if (!this._events || !this._events[type]) return this;
	
	  list = this._events[type];
	  length = list.length;
	  position = -1;
	
	  if (list === listener || isFunction(list.listener) && list.listener === listener) {
	    delete this._events[type];
	    if (this._events.removeListener) this.emit('removeListener', type, listener);
	  } else if (isObject(list)) {
	    for (i = length; i-- > 0;) {
	      if (list[i] === listener || list[i].listener && list[i].listener === listener) {
	        position = i;
	        break;
	      }
	    }
	
	    if (position < 0) return this;
	
	    if (list.length === 1) {
	      list.length = 0;
	      delete this._events[type];
	    } else {
	      list.splice(position, 1);
	    }
	
	    if (this._events.removeListener) this.emit('removeListener', type, listener);
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.removeAllListeners = function (type) {
	  var key, listeners;
	
	  if (!this._events) return this;
	
	  // not listening for removeListener, no need to emit
	  if (!this._events.removeListener) {
	    if (arguments.length === 0) this._events = {};else if (this._events[type]) delete this._events[type];
	    return this;
	  }
	
	  // emit removeListener for all listeners on all events
	  if (arguments.length === 0) {
	    for (key in this._events) {
	      if (key === 'removeListener') continue;
	      this.removeAllListeners(key);
	    }
	    this.removeAllListeners('removeListener');
	    this._events = {};
	    return this;
	  }
	
	  listeners = this._events[type];
	
	  if (isFunction(listeners)) {
	    this.removeListener(type, listeners);
	  } else if (listeners) {
	    // LIFO order
	    while (listeners.length) {
	      this.removeListener(type, listeners[listeners.length - 1]);
	    }
	  }
	  delete this._events[type];
	
	  return this;
	};
	
	EventEmitter.prototype.listeners = function (type) {
	  var ret;
	  if (!this._events || !this._events[type]) ret = [];else if (isFunction(this._events[type])) ret = [this._events[type]];else ret = this._events[type].slice();
	  return ret;
	};
	
	EventEmitter.prototype.listenerCount = function (type) {
	  if (this._events) {
	    var evlistener = this._events[type];
	
	    if (isFunction(evlistener)) return 1;else if (evlistener) return evlistener.length;
	  }
	  return 0;
	};
	
	EventEmitter.listenerCount = function (emitter, type) {
	  return emitter.listenerCount(type);
	};
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	
	function isObject(arg) {
	  return (typeof arg === 'undefined' ? 'undefined' : _typeof(arg)) === 'object' && arg !== null;
	}
	
	function isUndefined(arg) {
	  return arg === void 0;
	}

/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = __webpack_require__(166);
	var setInnerHTML = __webpack_require__(126);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(174);
	var setTextContent = __webpack_require__(384);
	
	var ELEMENT_NODE_TYPE = 1;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	/**
	 * In IE (8-11) and Edge, appending nodes with no children is dramatically
	 * faster than appending a full subtree, so we essentially queue up the
	 * .appendChild calls here and apply them so each node is added to its parent
	 * before any children are added.
	 *
	 * In other browsers, doing so is slower or neutral compared to the other order
	 * (in Firefox, twice as slow) so we only do this inversion in IE.
	 *
	 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
	 */
	var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);
	
	function insertTreeChildren(tree) {
	  if (!enableLazy) {
	    return;
	  }
	  var node = tree.node;
	  var children = tree.children;
	  if (children.length) {
	    for (var i = 0; i < children.length; i++) {
	      insertTreeBefore(node, children[i], null);
	    }
	  } else if (tree.html != null) {
	    setInnerHTML(node, tree.html);
	  } else if (tree.text != null) {
	    setTextContent(node, tree.text);
	  }
	}
	
	var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
	  // DocumentFragments aren't actually part of the DOM after insertion so
	  // appending children won't update the DOM. We need to ensure the fragment
	  // is properly populated first, breaking out of our lazy approach for just
	  // this level. Also, some <object> plugins (like Flash Player) will read
	  // <param> nodes immediately upon insertion into the DOM, so <object>
	  // must also be populated prior to insertion into the DOM.
	  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
	    insertTreeChildren(tree);
	    parentNode.insertBefore(tree.node, referenceNode);
	  } else {
	    parentNode.insertBefore(tree.node, referenceNode);
	    insertTreeChildren(tree);
	  }
	});
	
	function replaceChildWithTree(oldNode, newTree) {
	  oldNode.parentNode.replaceChild(newTree.node, oldNode);
	  insertTreeChildren(newTree);
	}
	
	function queueChild(parentTree, childTree) {
	  if (enableLazy) {
	    parentTree.children.push(childTree);
	  } else {
	    parentTree.node.appendChild(childTree.node);
	  }
	}
	
	function queueHTML(tree, html) {
	  if (enableLazy) {
	    tree.html = html;
	  } else {
	    setInnerHTML(tree.node, html);
	  }
	}
	
	function queueText(tree, text) {
	  if (enableLazy) {
	    tree.text = text;
	  } else {
	    setTextContent(tree.node, text);
	  }
	}
	
	function toString() {
	  return this.node.nodeName;
	}
	
	function DOMLazyTree(node) {
	  return {
	    node: node,
	    children: [],
	    html: null,
	    text: null,
	    toString: toString
	  };
	}
	
	DOMLazyTree.insertTreeBefore = insertTreeBefore;
	DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
	DOMLazyTree.queueChild = queueChild;
	DOMLazyTree.queueHTML = queueHTML;
	DOMLazyTree.queueText = queueText;
	
	module.exports = DOMLazyTree;

/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(12);
	
	var invariant = __webpack_require__(5);
	
	function checkMask(value, bitmask) {
	  return (value & bitmask) === bitmask;
	}
	
	var DOMPropertyInjection = {
	  /**
	   * Mapping from normalized, camelcased property names to a configuration that
	   * specifies how the associated DOM property should be accessed or rendered.
	   */
	  MUST_USE_PROPERTY: 0x1,
	  HAS_BOOLEAN_VALUE: 0x4,
	  HAS_NUMERIC_VALUE: 0x8,
	  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
	  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,
	
	  /**
	   * Inject some specialized knowledge about the DOM. This takes a config object
	   * with the following properties:
	   *
	   * isCustomAttribute: function that given an attribute name will return true
	   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
	   * attributes where it's impossible to enumerate all of the possible
	   * attribute names,
	   *
	   * Properties: object mapping DOM property name to one of the
	   * DOMPropertyInjection constants or null. If your attribute isn't in here,
	   * it won't get written to the DOM.
	   *
	   * DOMAttributeNames: object mapping React attribute name to the DOM
	   * attribute name. Attribute names not specified use the **lowercase**
	   * normalized name.
	   *
	   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
	   * attribute namespace URL. (Attribute names not specified use no namespace.)
	   *
	   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
	   * Property names not specified use the normalized name.
	   *
	   * DOMMutationMethods: Properties that require special mutation methods. If
	   * `value` is undefined, the mutation method should unset the property.
	   *
	   * @param {object} domPropertyConfig the config as described above.
	   */
	  injectDOMPropertyConfig: function injectDOMPropertyConfig(domPropertyConfig) {
	    var Injection = DOMPropertyInjection;
	    var Properties = domPropertyConfig.Properties || {};
	    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
	    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
	    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
	    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};
	
	    if (domPropertyConfig.isCustomAttribute) {
	      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
	    }
	
	    for (var propName in Properties) {
	      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;
	
	      var lowerCased = propName.toLowerCase();
	      var propConfig = Properties[propName];
	
	      var propertyInfo = {
	        attributeName: lowerCased,
	        attributeNamespace: null,
	        propertyName: propName,
	        mutationMethod: null,
	
	        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
	        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
	        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
	        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
	        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
	      };
	      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;
	
	      if (false) {
	        DOMProperty.getPossibleStandardName[lowerCased] = propName;
	      }
	
	      if (DOMAttributeNames.hasOwnProperty(propName)) {
	        var attributeName = DOMAttributeNames[propName];
	        propertyInfo.attributeName = attributeName;
	        if (false) {
	          DOMProperty.getPossibleStandardName[attributeName] = propName;
	        }
	      }
	
	      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
	        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
	      }
	
	      if (DOMPropertyNames.hasOwnProperty(propName)) {
	        propertyInfo.propertyName = DOMPropertyNames[propName];
	      }
	
	      if (DOMMutationMethods.hasOwnProperty(propName)) {
	        propertyInfo.mutationMethod = DOMMutationMethods[propName];
	      }
	
	      DOMProperty.properties[propName] = propertyInfo;
	    }
	  }
	};
	
	/* eslint-disable max-len */
	var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
	/* eslint-enable max-len */
	
	/**
	 * DOMProperty exports lookup objects that can be used like functions:
	 *
	 *   > DOMProperty.isValid['id']
	 *   true
	 *   > DOMProperty.isValid['foobar']
	 *   undefined
	 *
	 * Although this may be confusing, it performs better in general.
	 *
	 * @see http://jsperf.com/key-exists
	 * @see http://jsperf.com/key-missing
	 */
	var DOMProperty = {
	  ID_ATTRIBUTE_NAME: 'data-reactid',
	  ROOT_ATTRIBUTE_NAME: 'data-reactroot',
	
	  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
	  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',
	
	  /**
	   * Map from property "standard name" to an object with info about how to set
	   * the property in the DOM. Each object contains:
	   *
	   * attributeName:
	   *   Used when rendering markup or with `*Attribute()`.
	   * attributeNamespace
	   * propertyName:
	   *   Used on DOM node instances. (This includes properties that mutate due to
	   *   external factors.)
	   * mutationMethod:
	   *   If non-null, used instead of the property or `setAttribute()` after
	   *   initial render.
	   * mustUseProperty:
	   *   Whether the property must be accessed and mutated as an object property.
	   * hasBooleanValue:
	   *   Whether the property should be removed when set to a falsey value.
	   * hasNumericValue:
	   *   Whether the property must be numeric or parse as a numeric and should be
	   *   removed when set to a falsey value.
	   * hasPositiveNumericValue:
	   *   Whether the property must be positive numeric or parse as a positive
	   *   numeric and should be removed when set to a falsey value.
	   * hasOverloadedBooleanValue:
	   *   Whether the property can be used as a flag as well as with a value.
	   *   Removed when strictly equal to false; present without a value when
	   *   strictly equal to true; present with a value otherwise.
	   */
	  properties: {},
	
	  /**
	   * Mapping from lowercase property names to the properly cased version, used
	   * to warn in the case of missing properties. Available only in __DEV__.
	   *
	   * autofocus is predefined, because adding it to the property whitelist
	   * causes unintended side effects.
	   *
	   * @type {Object}
	   */
	  getPossibleStandardName:  false ? { autofocus: 'autoFocus' } : null,
	
	  /**
	   * All of the isCustomAttribute() functions that have been injected.
	   */
	  _isCustomAttributeFunctions: [],
	
	  /**
	   * Checks whether a property name is a custom attribute.
	   * @method
	   */
	  isCustomAttribute: function isCustomAttribute(attributeName) {
	    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
	      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
	      if (isCustomAttributeFn(attributeName)) {
	        return true;
	      }
	    }
	    return false;
	  },
	
	  injection: DOMPropertyInjection
	};
	
	module.exports = DOMProperty;

/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactRef = __webpack_require__(859);
	var ReactInstrumentation = __webpack_require__(46);
	
	var warning = __webpack_require__(9);
	
	/**
	 * Helper to call ReactRef.attachRefs with this composite component, split out
	 * to avoid allocations in the transaction mount-ready queue.
	 */
	function attachRefs() {
	  ReactRef.attachRefs(this, this._currentElement);
	}
	
	var ReactReconciler = {
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} the containing host component instance
	   * @param {?object} info about the host container
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function mountComponent(internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID) // 0 in production and for roots
	  {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
	      }
	    }
	    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
	    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
	      }
	    }
	    return markup;
	  },
	
	  /**
	   * Returns a value that can be passed to
	   * ReactComponentEnvironment.replaceNodeWithMarkup.
	   */
	  getHostNode: function getHostNode(internalInstance) {
	    return internalInstance.getHostNode();
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function unmountComponent(internalInstance, safely) {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
	      }
	    }
	    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
	    internalInstance.unmountComponent(safely);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Update a component using a new element.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @internal
	   */
	  receiveComponent: function receiveComponent(internalInstance, nextElement, transaction, context) {
	    var prevElement = internalInstance._currentElement;
	
	    if (nextElement === prevElement && context === internalInstance._context) {
	      // Since elements are immutable after the owner is rendered,
	      // we can do a cheap identity compare here to determine if this is a
	      // superfluous reconcile. It's possible for state to be mutable but such
	      // change should trigger an update of the owner which would recreate
	      // the element. We explicitly check for the existence of an owner since
	      // it's possible for an element created outside a composite to be
	      // deeply mutated and reused.
	
	      // TODO: Bailing out early is just a perf optimization right?
	      // TODO: Removing the return statement should affect correctness?
	      return;
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
	      }
	    }
	
	    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);
	
	    if (refsChanged) {
	      ReactRef.detachRefs(internalInstance, prevElement);
	    }
	
	    internalInstance.receiveComponent(nextElement, transaction, context);
	
	    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Flush any dirty changes in a component.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function performUpdateIfNecessary(internalInstance, transaction, updateBatchNumber) {
	    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
	      // The component's enqueued batch number should always be the current
	      // batch or the following one.
	       false ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
	      return;
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
	      }
	    }
	    internalInstance.performUpdateIfNecessary(transaction);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  }
	};
	
	module.exports = ReactReconciler;

/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(11);
	
	var ReactBaseClasses = __webpack_require__(386);
	var ReactChildren = __webpack_require__(899);
	var ReactDOMFactories = __webpack_require__(900);
	var ReactElement = __webpack_require__(87);
	var ReactPropTypes = __webpack_require__(901);
	var ReactVersion = __webpack_require__(902);
	
	var createReactClass = __webpack_require__(903);
	var onlyChild = __webpack_require__(907);
	
	var createElement = ReactElement.createElement;
	var createFactory = ReactElement.createFactory;
	var cloneElement = ReactElement.cloneElement;
	
	if (false) {
	  var lowPriorityWarning = require('./lowPriorityWarning');
	  var canDefineProperty = require('./canDefineProperty');
	  var ReactElementValidator = require('./ReactElementValidator');
	  var didWarnPropTypesDeprecated = false;
	  createElement = ReactElementValidator.createElement;
	  createFactory = ReactElementValidator.createFactory;
	  cloneElement = ReactElementValidator.cloneElement;
	}
	
	var __spread = _assign;
	var createMixin = function createMixin(mixin) {
	  return mixin;
	};
	
	if (false) {
	  var warnedForSpread = false;
	  var warnedForCreateMixin = false;
	  __spread = function __spread() {
	    lowPriorityWarning(warnedForSpread, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.');
	    warnedForSpread = true;
	    return _assign.apply(null, arguments);
	  };
	
	  createMixin = function createMixin(mixin) {
	    lowPriorityWarning(warnedForCreateMixin, 'React.createMixin is deprecated and should not be used. ' + 'In React v16.0, it will be removed. ' + 'You can use this mixin directly instead. ' + 'See https://fb.me/createmixin-was-never-implemented for more info.');
	    warnedForCreateMixin = true;
	    return mixin;
	  };
	}
	
	var React = {
	  // Modern
	
	  Children: {
	    map: ReactChildren.map,
	    forEach: ReactChildren.forEach,
	    count: ReactChildren.count,
	    toArray: ReactChildren.toArray,
	    only: onlyChild
	  },
	
	  Component: ReactBaseClasses.Component,
	  PureComponent: ReactBaseClasses.PureComponent,
	
	  createElement: createElement,
	  cloneElement: cloneElement,
	  isValidElement: ReactElement.isValidElement,
	
	  // Classic
	
	  PropTypes: ReactPropTypes,
	  createClass: createReactClass,
	  createFactory: createFactory,
	  createMixin: createMixin,
	
	  // This looks DOM specific but these are actually isomorphic helpers
	  // since they are just generating DOM strings.
	  DOM: ReactDOMFactories,
	
	  version: ReactVersion,
	
	  // Deprecated hook for JSX spread, don't use this for anything.
	  __spread: __spread
	};
	
	if (false) {
	  var warnedForCreateClass = false;
	  if (canDefineProperty) {
	    Object.defineProperty(React, 'PropTypes', {
	      get: function get() {
	        lowPriorityWarning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated,' + ' and will be removed in  React v16.0.' + ' Use the latest available v15.* prop-types package from npm instead.' + ' For info on usage, compatibility, migration and more, see ' + 'https://fb.me/prop-types-docs');
	        didWarnPropTypesDeprecated = true;
	        return ReactPropTypes;
	      }
	    });
	
	    Object.defineProperty(React, 'createClass', {
	      get: function get() {
	        lowPriorityWarning(warnedForCreateClass, 'Accessing createClass via the main React package is deprecated,' + ' and will be removed in React v16.0.' + " Use a plain JavaScript class instead. If you're not yet " + 'ready to migrate, create-react-class v15.* is available ' + 'on npm as a temporary, drop-in replacement. ' + 'For more info see https://fb.me/react-create-class');
	        warnedForCreateClass = true;
	        return createReactClass;
	      }
	    });
	  }
	
	  // React.DOM factories are deprecated. Wrap these methods so that
	  // invocations of the React.DOM namespace and alert users to switch
	  // to the `react-dom-factories` package.
	  React.DOM = {};
	  var warnedForFactories = false;
	  Object.keys(ReactDOMFactories).forEach(function (factory) {
	    React.DOM[factory] = function () {
	      if (!warnedForFactories) {
	        lowPriorityWarning(false, 'Accessing factories like React.DOM.%s has been deprecated ' + 'and will be removed in v16.0+. Use the ' + 'react-dom-factories package instead. ' + ' Version 1.0 provides a drop-in replacement.' + ' For more info, see https://fb.me/react-dom-factories', factory);
	        warnedForFactories = true;
	      }
	      return ReactDOMFactories[factory].apply(ReactDOMFactories, arguments);
	    };
	  });
	}
	
	module.exports = React;

/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _assign = __webpack_require__(11);
	
	var ReactCurrentOwner = __webpack_require__(57);
	
	var warning = __webpack_require__(9);
	var canDefineProperty = __webpack_require__(390);
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	var REACT_ELEMENT_TYPE = __webpack_require__(388);
	
	var RESERVED_PROPS = {
	  key: true,
	  ref: true,
	  __self: true,
	  __source: true
	};
	
	var specialPropKeyWarningShown, specialPropRefWarningShown;
	
	function hasValidRef(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'ref')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.ref !== undefined;
	}
	
	function hasValidKey(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'key')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.key !== undefined;
	}
	
	function defineKeyPropWarningGetter(props, displayName) {
	  var warnAboutAccessingKey = function warnAboutAccessingKey() {
	    if (!specialPropKeyWarningShown) {
	      specialPropKeyWarningShown = true;
	       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingKey.isReactWarning = true;
	  Object.defineProperty(props, 'key', {
	    get: warnAboutAccessingKey,
	    configurable: true
	  });
	}
	
	function defineRefPropWarningGetter(props, displayName) {
	  var warnAboutAccessingRef = function warnAboutAccessingRef() {
	    if (!specialPropRefWarningShown) {
	      specialPropRefWarningShown = true;
	       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingRef.isReactWarning = true;
	  Object.defineProperty(props, 'ref', {
	    get: warnAboutAccessingRef,
	    configurable: true
	  });
	}
	
	/**
	 * Factory method to create a new React element. This no longer adheres to
	 * the class pattern, so do not use new to call it. Also, no instanceof check
	 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
	 * if something is a React Element.
	 *
	 * @param {*} type
	 * @param {*} key
	 * @param {string|object} ref
	 * @param {*} self A *temporary* helper to detect places where `this` is
	 * different from the `owner` when React.createElement is called, so that we
	 * can warn. We want to get rid of owner and replace string `ref`s with arrow
	 * functions, and as long as `this` and owner are the same, there will be no
	 * change in behavior.
	 * @param {*} source An annotation object (added by a transpiler or otherwise)
	 * indicating filename, line number, and/or other information.
	 * @param {*} owner
	 * @param {*} props
	 * @internal
	 */
	var ReactElement = function ReactElement(type, key, ref, self, source, owner, props) {
	  var element = {
	    // This tag allow us to uniquely identify this as a React Element
	    $$typeof: REACT_ELEMENT_TYPE,
	
	    // Built-in properties that belong on the element
	    type: type,
	    key: key,
	    ref: ref,
	    props: props,
	
	    // Record the component responsible for creating this element.
	    _owner: owner
	  };
	
	  if (false) {
	    // The validation flag is currently mutative. We put it on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    element._store = {};
	
	    // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.
	    if (canDefineProperty) {
	      Object.defineProperty(element._store, 'validated', {
	        configurable: false,
	        enumerable: false,
	        writable: true,
	        value: false
	      });
	      // self and source are DEV only properties.
	      Object.defineProperty(element, '_self', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: self
	      });
	      // Two elements created in two different places should be considered
	      // equal for testing purposes and therefore we hide it from enumeration.
	      Object.defineProperty(element, '_source', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: source
	      });
	    } else {
	      element._store.validated = false;
	      element._self = self;
	      element._source = source;
	    }
	    if (Object.freeze) {
	      Object.freeze(element.props);
	      Object.freeze(element);
	    }
	  }
	
	  return element;
	};
	
	/**
	 * Create and return a new ReactElement of the given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
	 */
	ReactElement.createElement = function (type, config, children) {
	  var propName;
	
	  // Reserved names are extracted
	  var props = {};
	
	  var key = null;
	  var ref = null;
	  var self = null;
	  var source = null;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      ref = config.ref;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    self = config.__self === undefined ? null : config.__self;
	    source = config.__source === undefined ? null : config.__source;
	    // Remaining properties are added to a new props object
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    if (false) {
	      if (Object.freeze) {
	        Object.freeze(childArray);
	      }
	    }
	    props.children = childArray;
	  }
	
	  // Resolve default props
	  if (type && type.defaultProps) {
	    var defaultProps = type.defaultProps;
	    for (propName in defaultProps) {
	      if (props[propName] === undefined) {
	        props[propName] = defaultProps[propName];
	      }
	    }
	  }
	  if (false) {
	    if (key || ref) {
	      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
	        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
	        if (key) {
	          defineKeyPropWarningGetter(props, displayName);
	        }
	        if (ref) {
	          defineRefPropWarningGetter(props, displayName);
	        }
	      }
	    }
	  }
	  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
	};
	
	/**
	 * Return a function that produces ReactElements of a given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
	 */
	ReactElement.createFactory = function (type) {
	  var factory = ReactElement.createElement.bind(null, type);
	  // Expose the type on the factory and the prototype so that it can be
	  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
	  // This should not be named `constructor` since this may not be the function
	  // that created the element, and it may not even be a constructor.
	  // Legacy hook TODO: Warn if this is accessed
	  factory.type = type;
	  return factory;
	};
	
	ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
	  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
	
	  return newElement;
	};
	
	/**
	 * Clone and return a new ReactElement using element as the starting point.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
	 */
	ReactElement.cloneElement = function (element, config, children) {
	  var propName;
	
	  // Original props are copied
	  var props = _assign({}, element.props);
	
	  // Reserved names are extracted
	  var key = element.key;
	  var ref = element.ref;
	  // Self is preserved since the owner is preserved.
	  var self = element._self;
	  // Source is preserved since cloneElement is unlikely to be targeted by a
	  // transpiler, and the original source is probably a better indicator of the
	  // true owner.
	  var source = element._source;
	
	  // Owner will be preserved, unless ref is overridden
	  var owner = element._owner;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      // Silently steal the ref from the parent.
	      ref = config.ref;
	      owner = ReactCurrentOwner.current;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    // Remaining properties override existing props
	    var defaultProps;
	    if (element.type && element.type.defaultProps) {
	      defaultProps = element.type.defaultProps;
	    }
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        if (config[propName] === undefined && defaultProps !== undefined) {
	          // Resolve default props
	          props[propName] = defaultProps[propName];
	        } else {
	          props[propName] = config[propName];
	        }
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  return ReactElement(element.type, key, ref, self, source, owner, props);
	};
	
	/**
	 * Verifies the object is a ReactElement.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid component.
	 * @final
	 */
	ReactElement.isValidElement = function (object) {
	  return (typeof object === 'undefined' ? 'undefined' : _typeof(object)) === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	};
	
	module.exports = ReactElement;

/***/ },
/* 88 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = function (module) {
		if (!module.webpackPolyfill) {
			module.deprecate = function () {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	};

/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	Object.defineProperty(exports, '__esModule', { value: !0 });var _Button = __webpack_require__(58);Object.defineProperty(exports, 'Button', { enumerable: !0, get: function get() {
	    return _interopRequireDefault(_Button).default;
	  } });var _Card = __webpack_require__(183);Object.defineProperty(exports, 'Card', { enumerable: !0, get: function get() {
	    return _interopRequireDefault(_Card).default;
	  } });var _Checkbox = __webpack_require__(408);Object.defineProperty(exports, 'Checkbox', { enumerable: !0, get: function get() {
	    return _interopRequireDefault(_Checkbox).default;
	  } });var _Dialog = __webpack_require__(416);Object.defineProperty(exports, 'Dialog', { enumerable: !0, get: function get() {
	    return _interopRequireDefault(_Dialog).default;
	  } });var _Form = __webpack_require__(128);Object.defineProperty(exports, 'Form', { enumerable: !0, get: function get() {
	    return _interopRequireDefault(_Form).default;
	  } });var _Icon = __webpack_require__(26);Object.defineProperty(exports, 'Icon', { enumerable: !0, get: function get() {
	    return _interopRequireDefault(_Icon).default;
	  } });var _Link = __webpack_require__(430);Object.defineProperty(exports, 'Link', { enumerable: !0, get: function get() {
	    return _interopRequireDefault(_Link).default;
	  } });var _SearchForm = __webpack_require__(433);Object.defineProperty(exports, 'SearchForm', { enumerable: !0, get: function get() {
	    return _interopRequireDefault(_SearchForm).default;
	  } });var _Select = __webpack_require__(435);Object.defineProperty(exports, 'Select', { enumerable: !0, get: function get() {
	    return _interopRequireDefault(_Select).default;
	  } });var _Switch = __webpack_require__(441);Object.defineProperty(exports, 'Switch', { enumerable: !0, get: function get() {
	    return _interopRequireDefault(_Switch).default;
	  } });var _Table = __webpack_require__(445);Object.defineProperty(exports, 'Table', { enumerable: !0, get: function get() {
	    return _interopRequireDefault(_Table).default;
	  } });var _TextField = __webpack_require__(191);Object.defineProperty(exports, 'TextField', { enumerable: !0, get: function get() {
	    return _interopRequireDefault(_TextField).default;
	  } });function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}

/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(43);
	var TAG = __webpack_require__(17)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () {
	  return arguments;
	}()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function tryGet(it, key) {
	  try {
	    return it[key];
	  } catch (e) {/* empty */}
	};
	
	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	  // @@toStringTag case
	  : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	  // builtinTag case
	  : ARG ? cof(O)
	  // ES3 arguments fallback
	  : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};

/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(43);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};

/***/ },
/* 92 */
/***/ function(module, exports) {

	"use strict";
	
	exports.f = {}.propertyIsEnumerable;

/***/ },
/* 93 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isPrefixedValue;
	var regex = /-webkit-|-moz-|-ms-/;
	
	function isPrefixedValue(value) {
	  return typeof value === 'string' && regex.test(value);
	}
	module.exports = exports['default'];

/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.compose = exports.merge = exports.$ = exports.style = exports.presets = exports.keyframes = exports.fontFace = exports.insertGlobal = exports.insertRule = exports.plugins = exports.styleSheet = undefined;
	exports.speedy = speedy;
	exports.simulations = simulations;
	exports.simulate = simulate;
	exports.cssLabels = cssLabels;
	exports.isLikeRule = isLikeRule;
	exports.idFor = idFor;
	exports.css = css;
	exports.rehydrate = rehydrate;
	exports.flush = flush;
	exports.select = select;
	exports.parent = parent;
	exports.media = media;
	exports.pseudo = pseudo;
	exports.active = active;
	exports.any = any;
	exports.checked = checked;
	exports.disabled = disabled;
	exports.empty = empty;
	exports.enabled = enabled;
	exports._default = _default;
	exports.first = first;
	exports.firstChild = firstChild;
	exports.firstOfType = firstOfType;
	exports.fullscreen = fullscreen;
	exports.focus = focus;
	exports.hover = hover;
	exports.indeterminate = indeterminate;
	exports.inRange = inRange;
	exports.invalid = invalid;
	exports.lastChild = lastChild;
	exports.lastOfType = lastOfType;
	exports.left = left;
	exports.link = link;
	exports.onlyChild = onlyChild;
	exports.onlyOfType = onlyOfType;
	exports.optional = optional;
	exports.outOfRange = outOfRange;
	exports.readOnly = readOnly;
	exports.readWrite = readWrite;
	exports.required = required;
	exports.right = right;
	exports.root = root;
	exports.scope = scope;
	exports.target = target;
	exports.valid = valid;
	exports.visited = visited;
	exports.dir = dir;
	exports.lang = lang;
	exports.not = not;
	exports.nthChild = nthChild;
	exports.nthLastChild = nthLastChild;
	exports.nthLastOfType = nthLastOfType;
	exports.nthOfType = nthOfType;
	exports.after = after;
	exports.before = before;
	exports.firstLetter = firstLetter;
	exports.firstLine = firstLine;
	exports.selection = selection;
	exports.backdrop = backdrop;
	exports.placeholder = placeholder;
	exports.cssFor = cssFor;
	exports.attribsFor = attribsFor;
	
	var _objectAssign = __webpack_require__(11);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _sheet = __webpack_require__(788);
	
	var _CSSPropertyOperations = __webpack_require__(244);
	
	var _clean = __webpack_require__(784);
	
	var _clean2 = _interopRequireDefault(_clean);
	
	var _plugins = __webpack_require__(786);
	
	var _hash = __webpack_require__(785);
	
	var _hash2 = _interopRequireDefault(_hash);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _toConsumableArray(arr) {
	  if (Array.isArray(arr)) {
	    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
	      arr2[i] = arr[i];
	    }return arr2;
	  } else {
	    return Array.from(arr);
	  }
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	/* stylesheet */
	
	var styleSheet = exports.styleSheet = new _sheet.StyleSheet();
	// an isomorphic StyleSheet shim. hides all the nitty gritty.
	
	// /**************** LIFTOFF IN 3... 2... 1... ****************/
	styleSheet.inject(); //eslint-disable-line indent
	// /****************      TO THE MOOOOOOON     ****************/
	
	// convenience function to toggle speedy
	function speedy(bool) {
	  return styleSheet.speedy(bool);
	}
	
	// plugins
	// we include these by default
	var plugins = exports.plugins = styleSheet.plugins = new _plugins.PluginSet([_plugins.prefixes, _plugins.contentWrap, _plugins.fallbacks]);
	plugins.media = new _plugins.PluginSet(); // neat! media, font-face, keyframes
	plugins.fontFace = new _plugins.PluginSet();
	plugins.keyframes = new _plugins.PluginSet([_plugins.prefixes, _plugins.fallbacks]);
	
	// define some constants
	
	var isDev = ("production") === 'development' || !("production");
	var isTest = ("production") === 'test';
	var isBrowser = typeof window !== 'undefined';
	
	/**** simulations  ****/
	
	// a flag to enable simulation meta tags on dom nodes
	// defaults to true in dev mode. recommend *not* to
	// toggle often.
	var canSimulate = isDev;
	
	// we use these flags for issuing warnings when simulate is called
	// in prod / in incorrect order
	var warned1 = false,
	    warned2 = false;
	
	// toggles simulation activity. shouldn't be needed in most cases
	function simulations() {
	  var bool = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	  canSimulate = !!bool;
	}
	
	// use this on dom nodes to 'simulate' pseudoclasses
	// <div {...hover({ color: 'red' })} {...simulate('hover', 'visited')}>...</div>
	// you can even send in some weird ones, as long as it's in simple format
	// and matches an existing rule on the element
	// eg simulate('nthChild2', ':hover:active') etc
	function simulate() {
	  for (var _len = arguments.length, pseudos = Array(_len), _key = 0; _key < _len; _key++) {
	    pseudos[_key] = arguments[_key];
	  }
	
	  pseudos = (0, _clean2.default)(pseudos);
	  if (!pseudos) return {};
	  if (!canSimulate) {
	    if (!warned1) {
	      console.warn('can\'t simulate without once calling simulations(true)'); //eslint-disable-line no-console
	      warned1 = true;
	    }
	    if (!isDev && !isTest && !warned2) {
	      console.warn('don\'t use simulation outside dev'); //eslint-disable-line no-console
	      warned2 = true;
	    }
	    return {};
	  }
	  return pseudos.reduce(function (o, p) {
	    return o['data-simulate-' + simple(p)] = '', o;
	  }, {});
	}
	
	/**** labels ****/
	// toggle for debug labels.
	// *shouldn't* have to mess with this manually
	var hasLabels = isDev;
	
	function cssLabels(bool) {
	  hasLabels = !!bool;
	}
	
	// takes a string, converts to lowercase, strips out nonalphanumeric.
	function simple(str) {
	  var char = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	  return str.toLowerCase().replace(/[^a-z0-9]/g, char);
	}
	
	// hashes a string to something 'unique'
	// we use this to generate ids for styles
	
	
	function hashify(obj) {
	  var str = JSON.stringify(obj);
	  var toRet = (0, _hash2.default)(str).toString(36);
	  if (obj.label && obj.label.length > 0 && isDev) {
	    return simple(obj.label.join('.'), '-') + '-' + toRet;
	  }
	  return toRet;
	}
	
	// of shape { 'data-css-<id>': '' }
	function isLikeRule(rule) {
	  var keys = Object.keys(rule).filter(function (x) {
	    return x !== 'toString';
	  });
	  if (keys.length !== 1) {
	    return false;
	  }
	  return !!/data\-css\-([a-zA-Z0-9\-_]+)/.exec(keys[0]);
	}
	
	// extracts id from a { 'data-css-<id>': ''} like object
	function idFor(rule) {
	  var keys = Object.keys(rule).filter(function (x) {
	    return x !== 'toString';
	  });
	  if (keys.length !== 1) throw new Error('not a rule');
	  var regex = /data\-css\-([a-zA-Z0-9\-_]+)/;
	  var match = regex.exec(keys[0]);
	  if (!match) throw new Error('not a rule');
	  return match[1];
	}
	
	// from https://github.com/j2css/j2c/blob/5d381c2d721d04b54fabe6a165d587247c3087cb/src/helpers.js#L28-L61
	
	// "Tokenizes" the selectors into parts relevant for the next function.
	// Strings and comments are matched, but ignored afterwards.
	// This is not a full tokenizers. It only recognizes comas, parentheses,
	// strings and comments.
	// regexp generated by scripts/regexps.js then trimmed by hand
	var selectorTokenizer = /[(),]|"(?:\\.|[^"\n])*"|'(?:\\.|[^'\n])*'|\/\*[\s\S]*?\*\//g;
	
	/**
	 * This will split a coma-separated selector list into individual selectors,
	 * ignoring comas in strings, comments and in :pseudo-selectors(parameter, lists).
	 *
	 * @param {string} selector
	 * @return {string[]}
	 */
	
	function splitSelector(selector) {
	  if (selector.indexOf(',') === -1) {
	    return [selector];
	  }
	
	  var indices = [],
	      res = [],
	      inParen = 0,
	      o;
	  /*eslint-disable no-cond-assign*/
	  while (o = selectorTokenizer.exec(selector)) {
	    /*eslint-enable no-cond-assign*/
	    switch (o[0]) {
	      case '(':
	        inParen++;break;
	      case ')':
	        inParen--;break;
	      case ',':
	        if (inParen) break;indices.push(o.index);
	    }
	  }
	  for (o = indices.length; o--;) {
	    res.unshift(selector.slice(indices[o] + 1));
	    selector = selector.slice(0, indices[o]);
	  }
	  res.unshift(selector);
	  return res;
	}
	
	function selector(id, path) {
	  if (!id) {
	    return path.replace(/\&/g, '');
	  }
	  if (!path) return '.css-' + id + ',[data-css-' + id + ']';
	
	  var x = splitSelector(path).map(function (x) {
	    return x.indexOf('&') >= 0 ? [x.replace(/\&/mg, '.css-' + id), x.replace(/\&/mg, '[data-css-' + id + ']')].join(',') // todo - make sure each sub selector has an &
	    : '.css-' + id + x + ',[data-css-' + id + ']' + x;
	  }).join(',');
	
	  if (canSimulate && /^\&\:/.exec(path) && !/\s/.exec(path)) {
	    x += ',.css-' + id + '[data-simulate-' + simple(path) + '],[data-css-' + id + '][data-simulate-' + simple(path) + ']';
	  }
	  return x;
	}
	
	// end https://github.com/j2css/j2c/blob/5d381c2d721d04b54fabe6a165d587247c3087cb/src/helpers.js#L28-L61
	
	
	function toCSS(_ref) {
	  var selector = _ref.selector,
	      style = _ref.style;
	
	  var result = plugins.transform({ selector: selector, style: style });
	  return result.selector + '{' + (0, _CSSPropertyOperations.createMarkupForStyles)(result.style) + '}';
	}
	
	function deconstruct(style) {
	  // we can be sure it's not infinitely nested here
	  var plain = void 0,
	      selects = void 0,
	      medias = void 0,
	      supports = void 0;
	  Object.keys(style).forEach(function (key) {
	    if (key.indexOf('&') >= 0) {
	      selects = selects || {};
	      selects[key] = style[key];
	    } else if (key.indexOf('@media') === 0) {
	      medias = medias || {};
	      medias[key] = deconstruct(style[key]);
	    } else if (key.indexOf('@supports') === 0) {
	      supports = supports || {};
	      supports[key] = deconstruct(style[key]);
	    } else if (key === 'label') {
	      if (style.label.length > 0) {
	        plain = plain || {};
	        plain.label = hasLabels ? style.label.join('.') : '';
	      }
	    } else {
	      plain = plain || {};
	      plain[key] = style[key];
	    }
	  });
	  return { plain: plain, selects: selects, medias: medias, supports: supports };
	}
	
	function deconstructedStyleToCSS(id, style) {
	  var css = [];
	
	  // plugins here
	  var plain = style.plain,
	      selects = style.selects,
	      medias = style.medias,
	      supports = style.supports;
	
	  if (plain) {
	    css.push(toCSS({ style: plain, selector: selector(id) }));
	  }
	  if (selects) {
	    Object.keys(selects).forEach(function (key) {
	      return css.push(toCSS({ style: selects[key], selector: selector(id, key) }));
	    });
	  }
	  if (medias) {
	    Object.keys(medias).forEach(function (key) {
	      return css.push(key + '{' + deconstructedStyleToCSS(id, medias[key]).join('') + '}');
	    });
	  }
	  if (supports) {
	    Object.keys(supports).forEach(function (key) {
	      return css.push(key + '{' + deconstructedStyleToCSS(id, supports[key]).join('') + '}');
	    });
	  }
	  return css;
	}
	
	// this cache to track which rules have
	// been inserted into the stylesheet
	var inserted = styleSheet.inserted = {};
	
	// and helpers to insert rules into said styleSheet
	function insert(spec) {
	  if (!inserted[spec.id]) {
	    inserted[spec.id] = true;
	    var deconstructed = deconstruct(spec.style);
	    var rules = deconstructedStyleToCSS(spec.id, deconstructed);
	    inserted[spec.id] = isBrowser ? true : rules;
	    rules.forEach(function (cssRule) {
	      return styleSheet.insert(cssRule);
	    });
	  }
	}
	
	// a simple cache to store generated rules
	var registered = styleSheet.registered = {};
	function register(spec) {
	  if (!registered[spec.id]) {
	    registered[spec.id] = spec;
	  }
	}
	
	function _getRegistered(rule) {
	  if (isLikeRule(rule)) {
	    var ret = registered[idFor(rule)];
	    if (ret == null) {
	      throw new Error('[glamor] an unexpected rule cache miss occurred. This is probably a sign of multiple glamor instances in your app. See https://github.com/threepointone/glamor/issues/79');
	    }
	    return ret;
	  }
	  return rule;
	}
	
	// todo - perf
	var ruleCache = {};
	function toRule(spec) {
	  register(spec);
	  insert(spec);
	
	  if (ruleCache[spec.id]) {
	    return ruleCache[spec.id];
	  }
	
	  var ret = _defineProperty({}, 'data-css-' + spec.id, hasLabels ? spec.label || '' : '');
	  Object.defineProperty(ret, 'toString', {
	    enumerable: false, value: function value() {
	      return 'css-' + spec.id;
	    }
	  });
	  ruleCache[spec.id] = ret;
	  return ret;
	}
	
	function log() {
	  //eslint-disable-line no-unused-vars
	  console.log(this); //eslint-disable-line no-console
	  return this;
	}
	
	function isSelector(key) {
	  var possibles = [':', '.', '[', '>', ' '],
	      found = false,
	      ch = key.charAt(0);
	  for (var i = 0; i < possibles.length; i++) {
	    if (ch === possibles[i]) {
	      found = true;
	      break;
	    }
	  }
	  return found || key.indexOf('&') >= 0;
	}
	
	function joinSelectors(a, b) {
	  var as = splitSelector(a).map(function (a) {
	    return !(a.indexOf('&') >= 0) ? '&' + a : a;
	  });
	  var bs = splitSelector(b).map(function (b) {
	    return !(b.indexOf('&') >= 0) ? '&' + b : b;
	  });
	
	  return bs.reduce(function (arr, b) {
	    return arr.concat(as.map(function (a) {
	      return b.replace(/\&/g, a);
	    }));
	  }, []).join(',');
	}
	
	function joinMediaQueries(a, b) {
	  return a ? '@media ' + a.substring(6) + ' and ' + b.substring(6) : b;
	}
	
	function isMediaQuery(key) {
	  return key.indexOf('@media') === 0;
	}
	
	function isSupports(key) {
	  return key.indexOf('@supports') === 0;
	}
	
	function joinSupports(a, b) {
	  return a ? '@supports ' + a.substring(9) + ' and ' + b.substring(9) : b;
	}
	
	// flatten a nested array
	function flatten(inArr) {
	  var arr = [];
	  for (var i = 0; i < inArr.length; i++) {
	    if (Array.isArray(inArr[i])) arr = arr.concat(flatten(inArr[i]));else arr = arr.concat(inArr[i]);
	  }
	  return arr;
	}
	
	var prefixedPseudoSelectors = {
	  '::placeholder': ['::-webkit-input-placeholder', '::-moz-placeholder', '::-ms-input-placeholder'],
	  ':fullscreen': [':-webkit-full-screen', ':-moz-full-screen', ':-ms-fullscreen']
	
	  // mutable! modifies dest.
	};function build(dest, _ref2) {
	  var _ref2$selector = _ref2.selector,
	      selector = _ref2$selector === undefined ? '' : _ref2$selector,
	      _ref2$mq = _ref2.mq,
	      mq = _ref2$mq === undefined ? '' : _ref2$mq,
	      _ref2$supp = _ref2.supp,
	      supp = _ref2$supp === undefined ? '' : _ref2$supp,
	      _ref2$src = _ref2.src,
	      src = _ref2$src === undefined ? {} : _ref2$src;
	
	  if (!Array.isArray(src)) {
	    src = [src];
	  }
	  src = flatten(src);
	
	  src.forEach(function (_src) {
	    if (isLikeRule(_src)) {
	      var reg = _getRegistered(_src);
	      if (reg.type !== 'css') {
	        throw new Error('cannot merge this rule');
	      }
	      _src = reg.style;
	    }
	    _src = (0, _clean2.default)(_src);
	    if (_src && _src.composes) {
	      build(dest, { selector: selector, mq: mq, supp: supp, src: _src.composes });
	    }
	    Object.keys(_src || {}).forEach(function (key) {
	      if (isSelector(key)) {
	
	        if (prefixedPseudoSelectors[key]) {
	          prefixedPseudoSelectors[key].forEach(function (p) {
	            return build(dest, { selector: joinSelectors(selector, p), mq: mq, supp: supp, src: _src[key] });
	          });
	        }
	
	        build(dest, { selector: joinSelectors(selector, key), mq: mq, supp: supp, src: _src[key] });
	      } else if (isMediaQuery(key)) {
	        build(dest, { selector: selector, mq: joinMediaQueries(mq, key), supp: supp, src: _src[key] });
	      } else if (isSupports(key)) {
	        build(dest, { selector: selector, mq: mq, supp: joinSupports(supp, key), src: _src[key] });
	      } else if (key === 'composes') {
	        // ignore, we already dealth with it
	      } else {
	        var _dest = dest;
	        if (supp) {
	          _dest[supp] = _dest[supp] || {};
	          _dest = _dest[supp];
	        }
	        if (mq) {
	          _dest[mq] = _dest[mq] || {};
	          _dest = _dest[mq];
	        }
	        if (selector) {
	          _dest[selector] = _dest[selector] || {};
	          _dest = _dest[selector];
	        }
	
	        if (key === 'label') {
	          if (hasLabels) {
	            dest.label = dest.label.concat(_src.label);
	          }
	        } else {
	          _dest[key] = _src[key];
	        }
	      }
	    });
	  });
	}
	
	function _css(rules) {
	  var style = { label: [] };
	  build(style, { src: rules }); // mutative! but worth it.
	
	  var spec = {
	    id: hashify(style),
	    style: style, label: hasLabels ? style.label.join('.') : '',
	    type: 'css'
	  };
	  return toRule(spec);
	}
	
	var nullrule = {
	  // 'data-css-nil': ''
	};
	Object.defineProperty(nullrule, 'toString', {
	  enumerable: false, value: function value() {
	    return 'css-nil';
	  }
	});
	
	var inputCaches = typeof WeakMap !== 'undefined' ? [nullrule, new WeakMap(), new WeakMap(), new WeakMap()] : [nullrule];
	
	var warnedWeakMapError = false;
	function multiIndexCache(fn) {
	  return function (args) {
	    if (inputCaches[args.length]) {
	      var coi = inputCaches[args.length];
	      var ctr = 0;
	      while (ctr < args.length - 1) {
	        if (!coi.has(args[ctr])) {
	          coi.set(args[ctr], new WeakMap());
	        }
	        coi = coi.get(args[ctr]);
	        ctr++;
	      }
	      if (coi.has(args[args.length - 1])) {
	        var ret = coi.get(args[ctr]);
	
	        if (registered[ret.toString().substring(4)]) {
	          // make sure it hasn't been flushed
	          return ret;
	        }
	      }
	    }
	    var value = fn(args);
	    if (inputCaches[args.length]) {
	      var _ctr = 0,
	          _coi = inputCaches[args.length];
	      while (_ctr < args.length - 1) {
	        _coi = _coi.get(args[_ctr]);
	        _ctr++;
	      }
	      try {
	        _coi.set(args[_ctr], value);
	      } catch (err) {
	        if (isDev && !warnedWeakMapError) {
	          var _console;
	
	          warnedWeakMapError = true;
	          (_console = console).warn.apply(_console, ['failed setting the WeakMap cache for args:'].concat(_toConsumableArray(args))); // eslint-disable-line no-console
	          console.warn('this should NOT happen, please file a bug on the github repo.'); // eslint-disable-line no-console
	        }
	      }
	    }
	    return value;
	  };
	}
	
	var cachedCss = typeof WeakMap !== 'undefined' ? multiIndexCache(_css) : _css;
	
	function css() {
	  for (var _len2 = arguments.length, rules = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	    rules[_key2] = arguments[_key2];
	  }
	
	  if (rules[0] && rules[0].length && rules[0].raw) {
	    throw new Error('you forgot to include glamor/babel in your babel plugins.');
	  }
	
	  rules = (0, _clean2.default)(rules);
	  if (!rules) {
	    return nullrule;
	  }
	
	  return cachedCss(rules);
	}
	
	css.insert = function (css) {
	  var spec = {
	    id: hashify(css),
	    css: css,
	    type: 'raw'
	  };
	  register(spec);
	  if (!inserted[spec.id]) {
	    styleSheet.insert(spec.css);
	    inserted[spec.id] = isBrowser ? true : [spec.css];
	  }
	};
	
	var insertRule = exports.insertRule = css.insert;
	
	css.global = function (selector, style) {
	  style = (0, _clean2.default)(style);
	  if (style) {
	    return css.insert(toCSS({ selector: selector, style: style }));
	  }
	};
	
	var insertGlobal = exports.insertGlobal = css.global;
	
	function insertKeyframe(spec) {
	  if (!inserted[spec.id]) {
	    var inner = Object.keys(spec.keyframes).map(function (kf) {
	      var result = plugins.keyframes.transform({ id: spec.id, name: kf, style: spec.keyframes[kf] });
	      return result.name + '{' + (0, _CSSPropertyOperations.createMarkupForStyles)(result.style) + '}';
	    }).join('');
	
	    var rules = ['-webkit-', '-moz-', '-o-', ''].map(function (prefix) {
	      return '@' + prefix + 'keyframes ' + (spec.name + '_' + spec.id) + '{' + inner + '}';
	    });
	    rules.forEach(function (rule) {
	      return styleSheet.insert(rule);
	    });
	
	    inserted[spec.id] = isBrowser ? true : rules;
	  }
	}
	css.keyframes = function (name, kfs) {
	  if (!kfs) {
	    kfs = name, name = 'animation';
	  }
	
	  // do not ignore empty keyframe definitions for now.
	  kfs = (0, _clean2.default)(kfs) || {};
	  var spec = {
	    id: hashify({ name: name, kfs: kfs }),
	    type: 'keyframes',
	    name: name,
	    keyframes: kfs
	  };
	  register(spec);
	  insertKeyframe(spec);
	  return name + '_' + spec.id;
	};
	
	// we don't go all out for fonts as much, giving a simple font loading strategy
	// use a fancier lib if you need moar power
	css.fontFace = function (font) {
	  font = (0, _clean2.default)(font);
	  var spec = {
	    id: hashify(font),
	    type: 'font-face',
	    font: font
	  };
	  register(spec);
	  insertFontFace(spec);
	
	  return font.fontFamily;
	};
	
	var fontFace = exports.fontFace = css.fontFace;
	var keyframes = exports.keyframes = css.keyframes;
	
	function insertFontFace(spec) {
	  if (!inserted[spec.id]) {
	    var rule = '@font-face{' + (0, _CSSPropertyOperations.createMarkupForStyles)(spec.font) + '}';
	    styleSheet.insert(rule);
	    inserted[spec.id] = isBrowser ? true : [rule];
	  }
	}
	
	// rehydrate the insertion cache with ids sent from
	// renderStatic / renderStaticOptimized
	function rehydrate(ids) {
	  // load up ids
	  (0, _objectAssign2.default)(inserted, ids.reduce(function (o, i) {
	    return o[i] = true, o;
	  }, {}));
	  // assume css loaded separately
	}
	
	// clears out the cache and empties the stylesheet
	// best for tests, though there might be some value for SSR.
	
	function flush() {
	  inserted = styleSheet.inserted = {};
	  registered = styleSheet.registered = {};
	  ruleCache = {};
	  styleSheet.flush();
	  styleSheet.inject();
	}
	
	var presets = exports.presets = {
	  mobile: '(min-width: 400px)',
	  Mobile: '@media (min-width: 400px)',
	  phablet: '(min-width: 550px)',
	  Phablet: '@media (min-width: 550px)',
	  tablet: '(min-width: 750px)',
	  Tablet: '@media (min-width: 750px)',
	  desktop: '(min-width: 1000px)',
	  Desktop: '@media (min-width: 1000px)',
	  hd: '(min-width: 1200px)',
	  Hd: '@media (min-width: 1200px)'
	};
	
	var style = exports.style = css;
	
	function select(selector) {
	  for (var _len3 = arguments.length, styles = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
	    styles[_key3 - 1] = arguments[_key3];
	  }
	
	  if (!selector) {
	    return style(styles);
	  }
	  return css(_defineProperty({}, selector, styles));
	}
	var $ = exports.$ = select;
	
	function parent(selector) {
	  for (var _len4 = arguments.length, styles = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
	    styles[_key4 - 1] = arguments[_key4];
	  }
	
	  return css(_defineProperty({}, selector + ' &', styles));
	}
	
	var merge = exports.merge = css;
	var compose = exports.compose = css;
	
	function media(query) {
	  for (var _len5 = arguments.length, rules = Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
	    rules[_key5 - 1] = arguments[_key5];
	  }
	
	  return css(_defineProperty({}, '@media ' + query, rules));
	}
	
	function pseudo(selector) {
	  for (var _len6 = arguments.length, styles = Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
	    styles[_key6 - 1] = arguments[_key6];
	  }
	
	  return css(_defineProperty({}, selector, styles));
	}
	
	// allllll the pseudoclasses
	
	function active(x) {
	  return pseudo(':active', x);
	}
	
	function any(x) {
	  return pseudo(':any', x);
	}
	
	function checked(x) {
	  return pseudo(':checked', x);
	}
	
	function disabled(x) {
	  return pseudo(':disabled', x);
	}
	
	function empty(x) {
	  return pseudo(':empty', x);
	}
	
	function enabled(x) {
	  return pseudo(':enabled', x);
	}
	
	function _default(x) {
	  return pseudo(':default', x); // note '_default' name
	}
	
	function first(x) {
	  return pseudo(':first', x);
	}
	
	function firstChild(x) {
	  return pseudo(':first-child', x);
	}
	
	function firstOfType(x) {
	  return pseudo(':first-of-type', x);
	}
	
	function fullscreen(x) {
	  return pseudo(':fullscreen', x);
	}
	
	function focus(x) {
	  return pseudo(':focus', x);
	}
	
	function hover(x) {
	  return pseudo(':hover', x);
	}
	
	function indeterminate(x) {
	  return pseudo(':indeterminate', x);
	}
	
	function inRange(x) {
	  return pseudo(':in-range', x);
	}
	
	function invalid(x) {
	  return pseudo(':invalid', x);
	}
	
	function lastChild(x) {
	  return pseudo(':last-child', x);
	}
	
	function lastOfType(x) {
	  return pseudo(':last-of-type', x);
	}
	
	function left(x) {
	  return pseudo(':left', x);
	}
	
	function link(x) {
	  return pseudo(':link', x);
	}
	
	function onlyChild(x) {
	  return pseudo(':only-child', x);
	}
	
	function onlyOfType(x) {
	  return pseudo(':only-of-type', x);
	}
	
	function optional(x) {
	  return pseudo(':optional', x);
	}
	
	function outOfRange(x) {
	  return pseudo(':out-of-range', x);
	}
	
	function readOnly(x) {
	  return pseudo(':read-only', x);
	}
	
	function readWrite(x) {
	  return pseudo(':read-write', x);
	}
	
	function required(x) {
	  return pseudo(':required', x);
	}
	
	function right(x) {
	  return pseudo(':right', x);
	}
	
	function root(x) {
	  return pseudo(':root', x);
	}
	
	function scope(x) {
	  return pseudo(':scope', x);
	}
	
	function target(x) {
	  return pseudo(':target', x);
	}
	
	function valid(x) {
	  return pseudo(':valid', x);
	}
	
	function visited(x) {
	  return pseudo(':visited', x);
	}
	
	// parameterized pseudoclasses
	function dir(p, x) {
	  return pseudo(':dir(' + p + ')', x);
	}
	function lang(p, x) {
	  return pseudo(':lang(' + p + ')', x);
	}
	function not(p, x) {
	  // should this be a plugin?
	  var selector = p.split(',').map(function (x) {
	    return x.trim();
	  }).map(function (x) {
	    return ':not(' + x + ')';
	  });
	  if (selector.length === 1) {
	    return pseudo(':not(' + p + ')', x);
	  }
	  return select(selector.join(''), x);
	}
	function nthChild(p, x) {
	  return pseudo(':nth-child(' + p + ')', x);
	}
	function nthLastChild(p, x) {
	  return pseudo(':nth-last-child(' + p + ')', x);
	}
	function nthLastOfType(p, x) {
	  return pseudo(':nth-last-of-type(' + p + ')', x);
	}
	function nthOfType(p, x) {
	  return pseudo(':nth-of-type(' + p + ')', x);
	}
	
	// pseudoelements
	function after(x) {
	  return pseudo('::after', x);
	}
	function before(x) {
	  return pseudo('::before', x);
	}
	function firstLetter(x) {
	  return pseudo('::first-letter', x);
	}
	function firstLine(x) {
	  return pseudo('::first-line', x);
	}
	function selection(x) {
	  return pseudo('::selection', x);
	}
	function backdrop(x) {
	  return pseudo('::backdrop', x);
	}
	function placeholder(x) {
	  // https://github.com/threepointone/glamor/issues/14
	  return css({ '::placeholder': x });
	}
	
	/*** helpers for web components ***/
	// https://github.com/threepointone/glamor/issues/16
	
	function cssFor() {
	  for (var _len7 = arguments.length, rules = Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
	    rules[_key7] = arguments[_key7];
	  }
	
	  rules = (0, _clean2.default)(rules);
	  return rules ? rules.map(function (r) {
	    var style = { label: [] };
	    build(style, { src: r }); // mutative! but worth it.
	    return deconstructedStyleToCSS(hashify(style), deconstruct(style)).join('');
	  }).join('') : '';
	}
	
	function attribsFor() {
	  for (var _len8 = arguments.length, rules = Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
	    rules[_key8] = arguments[_key8];
	  }
	
	  rules = (0, _clean2.default)(rules);
	  var htmlAttributes = rules ? rules.map(function (rule) {
	    idFor(rule); // throwaway check for rule
	    var key = Object.keys(rule)[0],
	        value = rule[key];
	    return key + '="' + (value || '') + '"';
	  }).join(' ') : '';
	
	  return htmlAttributes;
	}

/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _prodInvariant = __webpack_require__(12);
	
	var EventPluginRegistry = __webpack_require__(167);
	var EventPluginUtils = __webpack_require__(168);
	var ReactErrorUtils = __webpack_require__(172);
	
	var accumulateInto = __webpack_require__(377);
	var forEachAccumulated = __webpack_require__(378);
	var invariant = __webpack_require__(5);
	
	/**
	 * Internal store for event listeners
	 */
	var listenerBank = {};
	
	/**
	 * Internal queue of events that have accumulated their dispatches and are
	 * waiting to have their dispatches executed.
	 */
	var eventQueue = null;
	
	/**
	 * Dispatches an event and releases it back into the pool, unless persistent.
	 *
	 * @param {?object} event Synthetic event to be dispatched.
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @private
	 */
	var executeDispatchesAndRelease = function executeDispatchesAndRelease(event, simulated) {
	  if (event) {
	    EventPluginUtils.executeDispatchesInOrder(event, simulated);
	
	    if (!event.isPersistent()) {
	      event.constructor.release(event);
	    }
	  }
	};
	var executeDispatchesAndReleaseSimulated = function executeDispatchesAndReleaseSimulated(e) {
	  return executeDispatchesAndRelease(e, true);
	};
	var executeDispatchesAndReleaseTopLevel = function executeDispatchesAndReleaseTopLevel(e) {
	  return executeDispatchesAndRelease(e, false);
	};
	
	var getDictionaryKey = function getDictionaryKey(inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	};
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	function shouldPreventMouseEvent(name, type, props) {
	  switch (name) {
	    case 'onClick':
	    case 'onClickCapture':
	    case 'onDoubleClick':
	    case 'onDoubleClickCapture':
	    case 'onMouseDown':
	    case 'onMouseDownCapture':
	    case 'onMouseMove':
	    case 'onMouseMoveCapture':
	    case 'onMouseUp':
	    case 'onMouseUpCapture':
	      return !!(props.disabled && isInteractive(type));
	    default:
	      return false;
	  }
	}
	
	/**
	 * This is a unified interface for event plugins to be installed and configured.
	 *
	 * Event plugins can implement the following properties:
	 *
	 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
	 *     Required. When a top-level event is fired, this method is expected to
	 *     extract synthetic events that will in turn be queued and dispatched.
	 *
	 *   `eventTypes` {object}
	 *     Optional, plugins that fire events must publish a mapping of registration
	 *     names that are used to register listeners. Values of this mapping must
	 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
	 *
	 *   `executeDispatch` {function(object, function, string)}
	 *     Optional, allows plugins to override how an event gets dispatched. By
	 *     default, the listener is simply invoked.
	 *
	 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
	 *
	 * @public
	 */
	var EventPluginHub = {
	  /**
	   * Methods for injecting dependencies.
	   */
	  injection: {
	    /**
	     * @param {array} InjectedEventPluginOrder
	     * @public
	     */
	    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,
	
	    /**
	     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	     */
	    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
	  },
	
	  /**
	   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {function} listener The callback to store.
	   */
	  putListener: function putListener(inst, registrationName, listener) {
	    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener === 'undefined' ? 'undefined' : _typeof(listener)) : _prodInvariant('94', registrationName, typeof listener === 'undefined' ? 'undefined' : _typeof(listener)) : void 0;
	
	    var key = getDictionaryKey(inst);
	    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
	    bankForRegistrationName[key] = listener;
	
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.didPutListener) {
	      PluginModule.didPutListener(inst, registrationName, listener);
	    }
	  },
	
	  /**
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @return {?function} The stored callback.
	   */
	  getListener: function getListener(inst, registrationName) {
	    // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
	    // live here; needs to be moved to a better place soon
	    var bankForRegistrationName = listenerBank[registrationName];
	    if (shouldPreventMouseEvent(registrationName, inst._currentElement.type, inst._currentElement.props)) {
	      return null;
	    }
	    var key = getDictionaryKey(inst);
	    return bankForRegistrationName && bankForRegistrationName[key];
	  },
	
	  /**
	   * Deletes a listener from the registration bank.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   */
	  deleteListener: function deleteListener(inst, registrationName) {
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.willDeleteListener) {
	      PluginModule.willDeleteListener(inst, registrationName);
	    }
	
	    var bankForRegistrationName = listenerBank[registrationName];
	    // TODO: This should never be null -- when is it?
	    if (bankForRegistrationName) {
	      var key = getDictionaryKey(inst);
	      delete bankForRegistrationName[key];
	    }
	  },
	
	  /**
	   * Deletes all listeners for the DOM element with the supplied ID.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   */
	  deleteAllListeners: function deleteAllListeners(inst) {
	    var key = getDictionaryKey(inst);
	    for (var registrationName in listenerBank) {
	      if (!listenerBank.hasOwnProperty(registrationName)) {
	        continue;
	      }
	
	      if (!listenerBank[registrationName][key]) {
	        continue;
	      }
	
	      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	      if (PluginModule && PluginModule.willDeleteListener) {
	        PluginModule.willDeleteListener(inst, registrationName);
	      }
	
	      delete listenerBank[registrationName][key];
	    }
	  },
	
	  /**
	   * Allows registered plugins an opportunity to extract events from top-level
	   * native browser events.
	   *
	   * @return {*} An accumulation of synthetic events.
	   * @internal
	   */
	  extractEvents: function extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events;
	    var plugins = EventPluginRegistry.plugins;
	    for (var i = 0; i < plugins.length; i++) {
	      // Not every plugin in the ordering may be loaded at runtime.
	      var possiblePlugin = plugins[i];
	      if (possiblePlugin) {
	        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	        if (extractedEvents) {
	          events = accumulateInto(events, extractedEvents);
	        }
	      }
	    }
	    return events;
	  },
	
	  /**
	   * Enqueues a synthetic event that should be dispatched when
	   * `processEventQueue` is invoked.
	   *
	   * @param {*} events An accumulation of synthetic events.
	   * @internal
	   */
	  enqueueEvents: function enqueueEvents(events) {
	    if (events) {
	      eventQueue = accumulateInto(eventQueue, events);
	    }
	  },
	
	  /**
	   * Dispatches all synthetic events on the event queue.
	   *
	   * @internal
	   */
	  processEventQueue: function processEventQueue(simulated) {
	    // Set `eventQueue` to null before processing it so that we can tell if more
	    // events get enqueued while processing.
	    var processingEventQueue = eventQueue;
	    eventQueue = null;
	    if (simulated) {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
	    } else {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
	    }
	    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
	    // This would be a good time to rethrow if any of the event handlers threw.
	    ReactErrorUtils.rethrowCaughtError();
	  },
	
	  /**
	   * These are needed for tests only. Do not use!
	   */
	  __purge: function __purge() {
	    listenerBank = {};
	  },
	
	  __getListenerBank: function __getListenerBank() {
	    return listenerBank;
	  }
	};
	
	module.exports = EventPluginHub;

/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(95);
	var EventPluginUtils = __webpack_require__(168);
	
	var accumulateInto = __webpack_require__(377);
	var forEachAccumulated = __webpack_require__(378);
	var warning = __webpack_require__(9);
	
	var getListener = EventPluginHub.getListener;
	
	/**
	 * Some event types have a notion of different registration names for different
	 * "phases" of propagation. This finds listeners by a given phase.
	 */
	function listenerAtPhase(inst, event, propagationPhase) {
	  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
	  return getListener(inst, registrationName);
	}
	
	/**
	 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
	 * here, allows us to not have to bind or create functions for each event.
	 * Mutating the event's members allows us to not have to create a wrapping
	 * "dispatch" object that pairs the event with the listener.
	 */
	function accumulateDirectionalDispatches(inst, phase, event) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
	  }
	  var listener = listenerAtPhase(inst, event, phase);
	  if (listener) {
	    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	  }
	}
	
	/**
	 * Collect dispatches (must be entirely collected before dispatching - see unit
	 * tests). Lazily allocate the array to conserve memory.  We must loop through
	 * each event and perform the traversal for each one. We cannot perform a
	 * single traversal for the entire collection of events because each event may
	 * have a different target.
	 */
	function accumulateTwoPhaseDispatchesSingle(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
	 */
	function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    var targetInst = event._targetInst;
	    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
	    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Accumulates without regard to direction, does not look for phased
	 * registration names. Same as `accumulateDirectDispatchesSingle` but without
	 * requiring that the `dispatchMarker` be the same as the dispatched ID.
	 */
	function accumulateDispatches(inst, ignoredDirection, event) {
	  if (event && event.dispatchConfig.registrationName) {
	    var registrationName = event.dispatchConfig.registrationName;
	    var listener = getListener(inst, registrationName);
	    if (listener) {
	      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	    }
	  }
	}
	
	/**
	 * Accumulates dispatches on an `SyntheticEvent`, but only for the
	 * `dispatchMarker`.
	 * @param {SyntheticEvent} event
	 */
	function accumulateDirectDispatchesSingle(event) {
	  if (event && event.dispatchConfig.registrationName) {
	    accumulateDispatches(event._targetInst, null, event);
	  }
	}
	
	function accumulateTwoPhaseDispatches(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
	}
	
	function accumulateTwoPhaseDispatchesSkipTarget(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
	}
	
	function accumulateEnterLeaveDispatches(leave, enter, from, to) {
	  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
	}
	
	function accumulateDirectDispatches(events) {
	  forEachAccumulated(events, accumulateDirectDispatchesSingle);
	}
	
	/**
	 * A small set of propagation patterns, each of which will accept a small amount
	 * of information, and generate a set of "dispatch ready event objects" - which
	 * are sets of events that have already been annotated with a set of dispatched
	 * listener functions/ids. The API is designed this way to discourage these
	 * propagation strategies from actually executing the dispatches, since we
	 * always want to collect the entire set of dispatches before executing event a
	 * single one.
	 *
	 * @constructor EventPropagators
	 */
	var EventPropagators = {
	  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
	  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
	  accumulateDirectDispatches: accumulateDirectDispatches,
	  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
	};
	
	module.exports = EventPropagators;

/***/ },
/* 97 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * `ReactInstanceMap` maintains a mapping from a public facing stateful
	 * instance (key) and the internal representation (value). This allows public
	 * methods to accept the user facing instance as an argument and map them back
	 * to internal methods.
	 */
	
	// TODO: Replace this with ES6: var ReactInstanceMap = new Map();
	
	var ReactInstanceMap = {
	  /**
	   * This API should be called `delete` but we'd have to make sure to always
	   * transform these to strings for IE support. When this transform is fully
	   * supported we can rename it.
	   */
	  remove: function remove(key) {
	    key._reactInternalInstance = undefined;
	  },
	
	  get: function get(key) {
	    return key._reactInternalInstance;
	  },
	
	  has: function has(key) {
	    return key._reactInternalInstance !== undefined;
	  },
	
	  set: function set(key, value) {
	    key._reactInternalInstance = value;
	  }
	};
	
	module.exports = ReactInstanceMap;

/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(56);
	
	var getEventTarget = __webpack_require__(177);
	
	/**
	 * @interface UIEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var UIEventInterface = {
	  view: function view(event) {
	    if (event.view) {
	      return event.view;
	    }
	
	    var target = getEventTarget(event);
	    if (target.window === target) {
	      // target is a window object
	      return target;
	    }
	
	    var doc = target.ownerDocument;
	    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	    if (doc) {
	      return doc.defaultView || doc.parentWindow;
	    } else {
	      return window;
	    }
	  },
	  detail: function detail(event) {
	    return event.detail || 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);
	
	module.exports = SyntheticUIEvent;

/***/ },
/* 99 */
12,
/* 100 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	Object.defineProperty(exports, '__esModule', { value: !0 });var _FormControl = __webpack_require__(418);Object.defineProperty(exports, 'default', { enumerable: !0, get: function get() {
	    return _interopRequireDefault(_FormControl).default;
	  } });function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}

/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	Object.defineProperty(exports, '__esModule', { value: !0 });var _blue = __webpack_require__(453);Object.defineProperty(exports, 'blue', { enumerable: !0, get: function get() {
	    return _interopRequireDefault(_blue).default;
	  } });var _brick = __webpack_require__(454);Object.defineProperty(exports, 'brick', { enumerable: !0, get: function get() {
	    return _interopRequireDefault(_brick).default;
	  } });var _cheddar = __webpack_require__(455);Object.defineProperty(exports, 'cheddar', { enumerable: !0, get: function get() {
	    return _interopRequireDefault(_cheddar).default;
	  } });var _cherry = __webpack_require__(456);Object.defineProperty(exports, 'cherry', { enumerable: !0, get: function get() {
	    return _interopRequireDefault(_cherry).default;
	  } });var _cloud = __webpack_require__(457);Object.defineProperty(exports, 'cloud', { enumerable: !0, get: function get() {
	    return _interopRequireDefault(_cloud).default;
	  } });var _eggplant = __webpack_require__(458);Object.defineProperty(exports, 'eggplant', { enumerable: !0, get: function get() {
	    return _interopRequireDefault(_eggplant).default;
	  } });var _frost = __webpack_require__(459);Object.defineProperty(exports, 'frost', { enumerable: !0, get: function get() {
	    return _interopRequireDefault(_frost).default;
	  } });var _gold = __webpack_require__(460);Object.defineProperty(exports, 'gold', { enumerable: !0, get: function get() {
	    return _interopRequireDefault(_gold).default;
	  } });var _grass = __webpack_require__(461);Object.defineProperty(exports, 'grass', { enumerable: !0, get: function get() {
	    return _interopRequireDefault(_grass).default;
	  } });var _green = __webpack_require__(462);Object.defineProperty(exports, 'green', { enumerable: !0, get: function get() {
	    return _interopRequireDefault(_green).default;
	  } });var _jungle = __webpack_require__(463);Object.defineProperty(exports, 'jungle', { enumerable: !0, get: function get() {
	    return _interopRequireDefault(_jungle).default;
	  } });var _magic = __webpack_require__(464);Object.defineProperty(exports, 'magic', { enumerable: !0, get: function get() {
	    return _interopRequireDefault(_magic).default;
	  } });var _mist = __webpack_require__(465);Object.defineProperty(exports, 'mist', { enumerable: !0, get: function get() {
	    return _interopRequireDefault(_mist).default;
	  } });var _ninja = __webpack_require__(466);Object.defineProperty(exports, 'ninja', { enumerable: !0, get: function get() {
	    return _interopRequireDefault(_ninja).default;
	  } });var _ocean = __webpack_require__(467);Object.defineProperty(exports, 'ocean', { enumerable: !0, get: function get() {
	    return _interopRequireDefault(_ocean).default;
	  } });var _orange = __webpack_require__(468);Object.defineProperty(exports, 'orange', { enumerable: !0, get: function get() {
	    return _interopRequireDefault(_orange).default;
	  } });var _pickle = __webpack_require__(469);Object.defineProperty(exports, 'pickle', { enumerable: !0, get: function get() {
	    return _interopRequireDefault(_pickle).default;
	  } });var _purple = __webpack_require__(470);Object.defineProperty(exports, 'purple', { enumerable: !0, get: function get() {
	    return _interopRequireDefault(_purple).default;
	  } });var _red = __webpack_require__(471);Object.defineProperty(exports, 'red', { enumerable: !0, get: function get() {
	    return _interopRequireDefault(_red).default;
	  } });var _sangria = __webpack_require__(472);Object.defineProperty(exports, 'sangria', { enumerable: !0, get: function get() {
	    return _interopRequireDefault(_sangria).default;
	  } });var _silver = __webpack_require__(473);Object.defineProperty(exports, 'silver', { enumerable: !0, get: function get() {
	    return _interopRequireDefault(_silver).default;
	  } });function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}

/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	Object.defineProperty(exports, '__esModule', { value: !0 });var _CaretDownSmall = __webpack_require__(476);Object.defineProperty(exports, 'CaretDownSmall', { enumerable: !0, get: function get() {
	    return _interopRequireDefault(_CaretDownSmall).default;
	  } });var _CaretLeftSmall = __webpack_require__(477);Object.defineProperty(exports, 'CaretLeftSmall', { enumerable: !0, get: function get() {
	    return _interopRequireDefault(_CaretLeftSmall).default;
	  } });var _CaretRightSmall = __webpack_require__(478);Object.defineProperty(exports, 'CaretRightSmall', { enumerable: !0, get: function get() {
	    return _interopRequireDefault(_CaretRightSmall).default;
	  } });var _Checkbox = __webpack_require__(479);Object.defineProperty(exports, 'Checkbox', { enumerable: !0, get: function get() {
	    return _interopRequireDefault(_Checkbox).default;
	  } });var _CheckboxChecked = __webpack_require__(480);Object.defineProperty(exports, 'CheckboxChecked', { enumerable: !0, get: function get() {
	    return _interopRequireDefault(_CheckboxChecked).default;
	  } });var _Checkmark = __webpack_require__(481);Object.defineProperty(exports, 'Checkmark', { enumerable: !0, get: function get() {
	    return _interopRequireDefault(_Checkmark).default;
	  } });var _CheckmarkCircle = __webpack_require__(482);Object.defineProperty(exports, 'CheckmarkCircle', { enumerable: !0, get: function get() {
	    return _interopRequireDefault(_CheckmarkCircle).default;
	  } });var _ExclamationCircle = __webpack_require__(483);Object.defineProperty(exports, 'ExclamationCircle', { enumerable: !0, get: function get() {
	    return _interopRequireDefault(_ExclamationCircle).default;
	  } });var _FormError = __webpack_require__(484);Object.defineProperty(exports, 'FormError', { enumerable: !0, get: function get() {
	    return _interopRequireDefault(_FormError).default;
	  } });var _ICircle = __webpack_require__(485);Object.defineProperty(exports, 'ICircle', { enumerable: !0, get: function get() {
	    return _interopRequireDefault(_ICircle).default;
	  } });var _RadioButton = __webpack_require__(486);Object.defineProperty(exports, 'RadioButton', { enumerable: !0, get: function get() {
	    return _interopRequireDefault(_RadioButton).default;
	  } });var _RadioButtonSelected = __webpack_require__(487);Object.defineProperty(exports, 'RadioButtonSelected', { enumerable: !0, get: function get() {
	    return _interopRequireDefault(_RadioButtonSelected).default;
	  } });var _Search = __webpack_require__(488);Object.defineProperty(exports, 'Search', { enumerable: !0, get: function get() {
	    return _interopRequireDefault(_Search).default;
	  } });var _XSmall = __webpack_require__(489);Object.defineProperty(exports, 'XSmall', { enumerable: !0, get: function get() {
	    return _interopRequireDefault(_XSmall).default;
	  } });function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}

/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(37);
	var toLength = __webpack_require__(22);
	var toAbsoluteIndex = __webpack_require__(73);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	      // Array#indexOf ignores holes, Array#includes - not
	    } else for (; length > index; index++) {
	      if (IS_INCLUDES || index in O) {
	        if (O[index] === el) return IS_INCLUDES || index || 0;
	      }
	    }return !IS_INCLUDES && -1;
	  };
	};

/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var global = __webpack_require__(8);
	var $export = __webpack_require__(2);
	var redefine = __webpack_require__(35);
	var redefineAll = __webpack_require__(71);
	var meta = __webpack_require__(61);
	var forOf = __webpack_require__(66);
	var anInstance = __webpack_require__(65);
	var isObject = __webpack_require__(14);
	var fails = __webpack_require__(10);
	var $iterDetect = __webpack_require__(110);
	var setToStringTag = __webpack_require__(78);
	var inheritIfRequired = __webpack_require__(138);
	
	module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
	  var Base = global[NAME];
	  var C = Base;
	  var ADDER = IS_MAP ? 'set' : 'add';
	  var proto = C && C.prototype;
	  var O = {};
	  var fixMethod = function fixMethod(KEY) {
	    var fn = proto[KEY];
	    redefine(proto, KEY, KEY == 'delete' ? function (a) {
	      return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	    } : KEY == 'has' ? function has(a) {
	      return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	    } : KEY == 'get' ? function get(a) {
	      return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
	    } : KEY == 'add' ? function add(a) {
	      fn.call(this, a === 0 ? 0 : a);return this;
	    } : function set(a, b) {
	      fn.call(this, a === 0 ? 0 : a, b);return this;
	    });
	  };
	  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
	    new C().entries().next();
	  }))) {
	    // create collection constructor
	    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
	    redefineAll(C.prototype, methods);
	    meta.NEED = true;
	  } else {
	    var instance = new C();
	    // early implementations not supports chaining
	    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
	    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
	    var THROWS_ON_PRIMITIVES = fails(function () {
	      instance.has(1);
	    });
	    // most early implementations doesn't supports iterables, most modern - not close it correctly
	    var ACCEPT_ITERABLES = $iterDetect(function (iter) {
	      new C(iter);
	    }); // eslint-disable-line no-new
	    // for early implementations -0 and +0 not the same
	    var BUGGY_ZERO = !IS_WEAK && fails(function () {
	      // V8 ~ Chromium 42- fails only with 5+ elements
	      var $instance = new C();
	      var index = 5;
	      while (index--) {
	        $instance[ADDER](index, index);
	      }return !$instance.has(-0);
	    });
	    if (!ACCEPT_ITERABLES) {
	      C = wrapper(function (target, iterable) {
	        anInstance(target, C, NAME);
	        var that = inheritIfRequired(new Base(), target, C);
	        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	        return that;
	      });
	      C.prototype = proto;
	      proto.constructor = C;
	    }
	    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
	      fixMethod('delete');
	      fixMethod('has');
	      IS_MAP && fixMethod('get');
	    }
	    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
	    // weak collections should not contains .clear method
	    if (IS_WEAK && proto.clear) delete proto.clear;
	  }
	
	  setToStringTag(C, NAME);
	
	  O[NAME] = C;
	  $export($export.G + $export.W + $export.F * (C != Base), O);
	
	  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);
	
	  return C;
	};

/***/ },
/* 105 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var hide = __webpack_require__(34);
	var redefine = __webpack_require__(35);
	var fails = __webpack_require__(10);
	var defined = __webpack_require__(49);
	var wks = __webpack_require__(17);
	
	module.exports = function (KEY, length, exec) {
	  var SYMBOL = wks(KEY);
	  var fns = exec(defined, SYMBOL, ''[KEY]);
	  var strfn = fns[0];
	  var rxfn = fns[1];
	  if (fails(function () {
	    var O = {};
	    O[SYMBOL] = function () {
	      return 7;
	    };
	    return ''[KEY](O) != 7;
	  })) {
	    redefine(String.prototype, KEY, strfn);
	    hide(RegExp.prototype, SYMBOL, length == 2
	    // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
	    // 21.2.5.11 RegExp.prototype[@@split](string, limit)
	    ? function (string, arg) {
	      return rxfn.call(string, this, arg);
	    }
	    // 21.2.5.6 RegExp.prototype[@@match](string)
	    // 21.2.5.9 RegExp.prototype[@@search](string)
	    : function (string) {
	      return rxfn.call(string, this);
	    });
	  }
	};

/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 21.2.5.3 get RegExp.prototype.flags
	
	var anObject = __webpack_require__(7);
	module.exports = function () {
	  var that = anObject(this);
	  var result = '';
	  if (that.global) result += 'g';
	  if (that.ignoreCase) result += 'i';
	  if (that.multiline) result += 'm';
	  if (that.unicode) result += 'u';
	  if (that.sticky) result += 'y';
	  return result;
	};

/***/ },
/* 107 */
/***/ function(module, exports) {

	"use strict";
	
	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.exports = function (fn, args, that) {
	                  var un = that === undefined;
	                  switch (args.length) {
	                                    case 0:
	                                                      return un ? fn() : fn.call(that);
	                                    case 1:
	                                                      return un ? fn(args[0]) : fn.call(that, args[0]);
	                                    case 2:
	                                                      return un ? fn(args[0], args[1]) : fn.call(that, args[0], args[1]);
	                                    case 3:
	                                                      return un ? fn(args[0], args[1], args[2]) : fn.call(that, args[0], args[1], args[2]);
	                                    case 4:
	                                                      return un ? fn(args[0], args[1], args[2], args[3]) : fn.call(that, args[0], args[1], args[2], args[3]);
	                  }return fn.apply(that, args);
	};

/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(43);
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};

/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// 7.2.8 IsRegExp(argument)
	var isObject = __webpack_require__(14);
	var cof = __webpack_require__(43);
	var MATCH = __webpack_require__(17)('match');
	module.exports = function (it) {
	  var isRegExp;
	  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
	};

/***/ },
/* 110 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var ITERATOR = __webpack_require__(17)('iterator');
	var SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () {
	    SAFE_CLOSING = true;
	  };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(riter, function () {
	    throw 2;
	  });
	} catch (e) {/* empty */}
	
	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () {
	      return { done: safe = true };
	    };
	    arr[ITERATOR] = function () {
	      return iter;
	    };
	    exec(arr);
	  } catch (e) {/* empty */}
	  return safe;
	};

/***/ },
/* 111 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// Forced replacement prototype accessors methods
	
	module.exports = __webpack_require__(67) || !__webpack_require__(10)(function () {
	  var K = Math.random();
	  // In FF throws only define methods
	  // eslint-disable-next-line no-undef, no-useless-call
	  __defineSetter__.call(null, K, function () {/* empty */});
	  delete __webpack_require__(8)[K];
	});

/***/ },
/* 112 */
/***/ function(module, exports) {

	"use strict";
	
	exports.f = Object.getOwnPropertySymbols;

/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	
	var $export = __webpack_require__(2);
	var aFunction = __webpack_require__(27);
	var ctx = __webpack_require__(44);
	var forOf = __webpack_require__(66);
	
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
	      var mapFn = arguments[1];
	      var mapping, A, n, cb;
	      aFunction(this);
	      mapping = mapFn !== undefined;
	      if (mapping) aFunction(mapFn);
	      if (source == undefined) return new this();
	      A = [];
	      if (mapping) {
	        n = 0;
	        cb = ctx(mapFn, arguments[2], 2);
	        forOf(source, false, function (nextItem) {
	          A.push(cb(nextItem, n++));
	        });
	      } else {
	        forOf(source, false, A.push, A);
	      }
	      return new this(A);
	    } });
	};

/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	
	var $export = __webpack_require__(2);
	
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { of: function of() {
	      var length = arguments.length;
	      var A = Array(length);
	      while (length--) {
	        A[length] = arguments[length];
	      }return new this(A);
	    } });
	};

/***/ },
/* 115 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var global = __webpack_require__(8);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	module.exports = function (key) {
	  return store[key] || (store[key] = {});
	};

/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject = __webpack_require__(7);
	var aFunction = __webpack_require__(27);
	var SPECIES = __webpack_require__(17)('species');
	module.exports = function (O, D) {
	  var C = anObject(O).constructor;
	  var S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};

/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var global = __webpack_require__(8);
	var hide = __webpack_require__(34);
	var uid = __webpack_require__(74);
	var TYPED = uid('typed_array');
	var VIEW = uid('view');
	var ABV = !!(global.ArrayBuffer && global.DataView);
	var CONSTR = ABV;
	var i = 0;
	var l = 9;
	var Typed;
	
	var TypedArrayConstructors = 'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'.split(',');
	
	while (i < l) {
	  if (Typed = global[TypedArrayConstructors[i++]]) {
	    hide(Typed.prototype, TYPED, true);
	    hide(Typed.prototype, VIEW, true);
	  } else CONSTR = false;
	}
	
	module.exports = {
	  ABV: ABV,
	  CONSTR: CONSTR,
	  TYPED: TYPED,
	  VIEW: VIEW
	};

/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(28);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Price = function (_React$Component) {
	  _inherits(Price, _React$Component);
	
	  function Price() {
	    _classCallCheck(this, Price);
	
	    return _possibleConstructorReturn(this, (Price.__proto__ || Object.getPrototypeOf(Price)).apply(this, arguments));
	  }
	
	  _createClass(Price, [{
	    key: '_itemTotal',
	    value: function _itemTotal() {
	      var total = parseFloat(this.props.price);
	      return Math.abs(total);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'span',
	        { className: 'price' },
	        _utils2.default.getCurrencySymbol(this.props.currency),
	        this._itemTotal().toFixed(2),
	        !this.props.skipCurrency && _react2.default.createElement(
	          'span',
	          { className: 'small currency' },
	          this.props.currency
	        )
	      );
	    }
	  }]);
	
	  return Price;
	}(_react2.default.Component);
	
	exports.default = Price;
	;

/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _dispatcher = __webpack_require__(18);
	
	var _dispatcher2 = _interopRequireDefault(_dispatcher);
	
	__webpack_require__(198);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TransactionStore = {
	
	  _state: undefined,
	  isLoading: false,
	  refunding: false,
	
	  init: function init() {
	    var _this = this;
	
	    _dispatcher2.default.on(_dispatcher2.default.TRANSACTION_REQUEST_REFUND, function (data) {
	      _this._requestRefund(data);
	    });
	  },
	
	  _requestRefund: function _requestRefund(details) {
	    var _this2 = this;
	
	    if (!this.refunding) {
	      this.refunding = true;
	      Jigsaw.User.requestRefund(details, function (response) {
	        var codes = details.codes;
	        if (response.isSuccess()) {
	          if (response.data) {
	            var _response$data = response.data,
	                refund = _response$data.refund,
	                purchase = _response$data.purchase;
	
	            var newState = _this2._state;
	
	            if (refund) {
	              newState.unshift(refund);
	            }
	
	            if (purchase) {
	              var oldTransaction = _this2._state.find(function (t) {
	                return t.number === purchase.number;
	              });
	              newState[newState.indexOf(oldTransaction)] = purchase;
	            }
	
	            _this2._updateState(newState);
	          } else {
	            _this2._load(true);
	          }
	          _dispatcher2.default.emit(_dispatcher2.default.TRANSACTION_REFUND_SUCCESS, { codes: codes });
	        } else {
	          var data = response.data;
	          data.itemCodes = details.codes;
	          _dispatcher2.default.emit(_dispatcher2.default.TRANSACTION_REFUND_FAILURE, data);
	        }
	        _this2.refunding = false;
	      });
	    }
	  },
	
	
	  _updateState: function _updateState(state) {
	    this._state = state;
	    _dispatcher2.default.emit(_dispatcher2.default.TRANSACTION_STORE_CHANGE);
	  },
	
	  _flatPurchaseItems: function _flatPurchaseItems() {
	    var items = this._state.map(function (t) {
	      return t.purchaseItems;
	    });
	
	    // flatten into a one-dimensional array
	    return [].concat.apply([], items);
	  },
	
	  get: function get(id) {
	    this._load();
	    if (!this._state) {
	      return undefined;
	    }
	
	    return this._state.find(function (t) {
	      return t.number === id;
	    }) || null;
	  },
	
	  getItem: function getItem(number, isbn) {
	    this._load();
	    if (this._state === undefined) {
	      return undefined;
	    }
	
	    return this._state.find(function (t) {
	      return t.number === number;
	    }).purchaseItems.find(function (i) {
	      return i.isbn === isbn;
	    });
	  },
	
	  getAll: function getAll() {
	    this._load();
	    // return this._state;
	    if (this._state) {
	      var purchases = [],
	          refunds = [];
	      this._state.forEach(function (t) {
	        (parseFloat(t.total) >= 0 ? purchases : refunds).push(t);
	      });
	      return { purchases: purchases, refunds: refunds };
	    }
	  },
	
	  getAllRefunds: function getAllRefunds() {
	    this._load();
	    if (this._state) {
	      return this._state.filter(function (t) {
	        return parseFloat(t.total) < 0;
	      });
	    }
	  },
	
	  getRefundedItems: function getRefundedItems() {
	    this._load();
	    if (this._state === undefined) {
	      return undefined;
	    }
	
	    return this._flatPurchaseItems().filter(function (i) {
	      return i.refunded === true;
	    });
	  },
	
	  _load: function _load(update) {
	    if (!this.isLoading && (update || !this._state)) {
	      this.isLoading = true;
	      Jigsaw.User.getAllTransactions(function (response) {
	        if (response.isSuccess()) {
	          this._updateState(response.data.transactions);
	          Jigsaw.addEvents([{
	            name: 'MulliganTransactionCount',
	            count: response.data.transactions.length
	          }]);
	        } else {
	          this._updateState([]);
	        }
	        this.isLoading = false;
	      }.bind(this));
	    }
	  }
	
	};
	
	TransactionStore.init();
	exports.default = TransactionStore;

/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ },
/* 121 */
/***/ function(module, exports) {

	'use strict';
	
	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout() {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	})();
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch (e) {
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch (e) {
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e) {
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e) {
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while (len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) {
	    return [];
	};
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () {
	    return '/';
	};
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function () {
	    return 0;
	};

/***/ },
/* 122 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(11);
	
	var EventPluginRegistry = __webpack_require__(167);
	var ReactEventEmitterMixin = __webpack_require__(851);
	var ViewportMetrics = __webpack_require__(376);
	
	var getVendorPrefixedEventName = __webpack_require__(883);
	var isEventSupported = __webpack_require__(178);
	
	/**
	 * Summary of `ReactBrowserEventEmitter` event handling:
	 *
	 *  - Top-level delegation is used to trap most native browser events. This
	 *    may only occur in the main thread and is the responsibility of
	 *    ReactEventListener, which is injected and can therefore support pluggable
	 *    event sources. This is the only work that occurs in the main thread.
	 *
	 *  - We normalize and de-duplicate events to account for browser quirks. This
	 *    may be done in the worker thread.
	 *
	 *  - Forward these native events (with the associated top-level type used to
	 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
	 *    to extract any synthetic events.
	 *
	 *  - The `EventPluginHub` will then process each event by annotating them with
	 *    "dispatches", a sequence of listeners and IDs that care about that event.
	 *
	 *  - The `EventPluginHub` then dispatches the events.
	 *
	 * Overview of React and the event system:
	 *
	 * +------------+    .
	 * |    DOM     |    .
	 * +------------+    .
	 *       |           .
	 *       v           .
	 * +------------+    .
	 * | ReactEvent |    .
	 * |  Listener  |    .
	 * +------------+    .                         +-----------+
	 *       |           .               +--------+|SimpleEvent|
	 *       |           .               |         |Plugin     |
	 * +-----|------+    .               v         +-----------+
	 * |     |      |    .    +--------------+                    +------------+
	 * |     +-----------.--->|EventPluginHub|                    |    Event   |
	 * |            |    .    |              |     +-----------+  | Propagators|
	 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
	 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
	 * |            |    .    |              |     +-----------+  |  utilities |
	 * |     +-----------.--->|              |                    +------------+
	 * |     |      |    .    +--------------+
	 * +-----|------+    .                ^        +-----------+
	 *       |           .                |        |Enter/Leave|
	 *       +           .                +-------+|Plugin     |
	 * +-------------+   .                         +-----------+
	 * | application |   .
	 * |-------------|   .
	 * |             |   .
	 * |             |   .
	 * +-------------+   .
	 *                   .
	 *    React Core     .  General Purpose Event Plugin System
	 */
	
	var hasEventPageXY;
	var alreadyListeningTo = {};
	var isMonitoringScrollValue = false;
	var reactTopListenersCounter = 0;
	
	// For events like 'submit' which don't consistently bubble (which we trap at a
	// lower node than `document`), binding at `document` would cause duplicate
	// events so we don't include them here
	var topEventMapping = {
	  topAbort: 'abort',
	  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
	  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
	  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
	  topBlur: 'blur',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topChange: 'change',
	  topClick: 'click',
	  topCompositionEnd: 'compositionend',
	  topCompositionStart: 'compositionstart',
	  topCompositionUpdate: 'compositionupdate',
	  topContextMenu: 'contextmenu',
	  topCopy: 'copy',
	  topCut: 'cut',
	  topDoubleClick: 'dblclick',
	  topDrag: 'drag',
	  topDragEnd: 'dragend',
	  topDragEnter: 'dragenter',
	  topDragExit: 'dragexit',
	  topDragLeave: 'dragleave',
	  topDragOver: 'dragover',
	  topDragStart: 'dragstart',
	  topDrop: 'drop',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topFocus: 'focus',
	  topInput: 'input',
	  topKeyDown: 'keydown',
	  topKeyPress: 'keypress',
	  topKeyUp: 'keyup',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topMouseDown: 'mousedown',
	  topMouseMove: 'mousemove',
	  topMouseOut: 'mouseout',
	  topMouseOver: 'mouseover',
	  topMouseUp: 'mouseup',
	  topPaste: 'paste',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topScroll: 'scroll',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topSelectionChange: 'selectionchange',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTextInput: 'textInput',
	  topTimeUpdate: 'timeupdate',
	  topTouchCancel: 'touchcancel',
	  topTouchEnd: 'touchend',
	  topTouchMove: 'touchmove',
	  topTouchStart: 'touchstart',
	  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting',
	  topWheel: 'wheel'
	};
	
	/**
	 * To ensure no conflicts with other potential React instances on the page
	 */
	var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);
	
	function getListeningForDocument(mountAt) {
	  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
	  // directly.
	  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
	    mountAt[topListenersIDKey] = reactTopListenersCounter++;
	    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
	  }
	  return alreadyListeningTo[mountAt[topListenersIDKey]];
	}
	
	/**
	 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
	 * example:
	 *
	 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
	 *
	 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
	 *
	 * @internal
	 */
	var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
	  /**
	   * Injectable event backend
	   */
	  ReactEventListener: null,
	
	  injection: {
	    /**
	     * @param {object} ReactEventListener
	     */
	    injectReactEventListener: function injectReactEventListener(ReactEventListener) {
	      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
	      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
	    }
	  },
	
	  /**
	   * Sets whether or not any created callbacks should be enabled.
	   *
	   * @param {boolean} enabled True if callbacks should be enabled.
	   */
	  setEnabled: function setEnabled(enabled) {
	    if (ReactBrowserEventEmitter.ReactEventListener) {
	      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
	    }
	  },
	
	  /**
	   * @return {boolean} True if callbacks are enabled.
	   */
	  isEnabled: function isEnabled() {
	    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
	  },
	
	  /**
	   * We listen for bubbled touch events on the document object.
	   *
	   * Firefox v8.01 (and possibly others) exhibited strange behavior when
	   * mounting `onmousemove` events at some node that was not the document
	   * element. The symptoms were that if your mouse is not moving over something
	   * contained within that mount point (for example on the background) the
	   * top-level listeners for `onmousemove` won't be called. However, if you
	   * register the `mousemove` on the document object, then it will of course
	   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
	   * top-level listeners to the document object only, at least for these
	   * movement types of events and possibly all events.
	   *
	   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	   *
	   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
	   * they bubble to document.
	   *
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {object} contentDocumentHandle Document which owns the container
	   */
	  listenTo: function listenTo(registrationName, contentDocumentHandle) {
	    var mountAt = contentDocumentHandle;
	    var isListening = getListeningForDocument(mountAt);
	    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];
	
	    for (var i = 0; i < dependencies.length; i++) {
	      var dependency = dependencies[i];
	      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
	        if (dependency === 'topWheel') {
	          if (isEventSupported('wheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'wheel', mountAt);
	          } else if (isEventSupported('mousewheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'mousewheel', mountAt);
	          } else {
	            // Firefox needs to capture a different mouse scroll event.
	            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'DOMMouseScroll', mountAt);
	          }
	        } else if (dependency === 'topScroll') {
	          if (isEventSupported('scroll', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topScroll', 'scroll', mountAt);
	          } else {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topScroll', 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
	          }
	        } else if (dependency === 'topFocus' || dependency === 'topBlur') {
	          if (isEventSupported('focus', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topFocus', 'focus', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topBlur', 'blur', mountAt);
	          } else if (isEventSupported('focusin')) {
	            // IE has `focusin` and `focusout` events which bubble.
	            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topFocus', 'focusin', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topBlur', 'focusout', mountAt);
	          }
	
	          // to make sure blur and focus event listeners are only attached once
	          isListening.topBlur = true;
	          isListening.topFocus = true;
	        } else if (topEventMapping.hasOwnProperty(dependency)) {
	          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
	        }
	
	        isListening[dependency] = true;
	      }
	    }
	  },
	
	  trapBubbledEvent: function trapBubbledEvent(topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  trapCapturedEvent: function trapCapturedEvent(topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  /**
	   * Protect against document.createEvent() returning null
	   * Some popup blocker extensions appear to do this:
	   * https://github.com/facebook/react/issues/6887
	   */
	  supportsEventPageXY: function supportsEventPageXY() {
	    if (!document.createEvent) {
	      return false;
	    }
	    var ev = document.createEvent('MouseEvent');
	    return ev != null && 'pageX' in ev;
	  },
	
	  /**
	   * Listens to window scroll and resize events. We cache scroll values so that
	   * application code can access them without triggering reflows.
	   *
	   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
	   * pageX/pageY isn't supported (legacy browsers).
	   *
	   * NOTE: Scroll events do not bubble.
	   *
	   * @see http://www.quirksmode.org/dom/events/scroll.html
	   */
	  ensureScrollValueMonitoring: function ensureScrollValueMonitoring() {
	    if (hasEventPageXY === undefined) {
	      hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
	    }
	    if (!hasEventPageXY && !isMonitoringScrollValue) {
	      var refresh = ViewportMetrics.refreshScrollValues;
	      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
	      isMonitoringScrollValue = true;
	    }
	  }
	});
	
	module.exports = ReactBrowserEventEmitter;

/***/ },
/* 123 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(98);
	var ViewportMetrics = __webpack_require__(376);
	
	var getEventModifierState = __webpack_require__(176);
	
	/**
	 * @interface MouseEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var MouseEventInterface = {
	  screenX: null,
	  screenY: null,
	  clientX: null,
	  clientY: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  getModifierState: getEventModifierState,
	  button: function button(event) {
	    // Webkit, Firefox, IE9+
	    // which:  1 2 3
	    // button: 0 1 2 (standard)
	    var button = event.button;
	    if ('which' in event) {
	      return button;
	    }
	    // IE<9
	    // which:  undefined
	    // button: 0 0 0
	    // button: 1 4 2 (onmouseup)
	    return button === 2 ? 2 : button === 4 ? 1 : 0;
	  },
	  buttons: null,
	  relatedTarget: function relatedTarget(event) {
	    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
	  },
	  // "Proprietary" Interface.
	  pageX: function pageX(event) {
	    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
	  },
	  pageY: function pageY(event) {
	    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);
	
	module.exports = SyntheticMouseEvent;

/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(12);
	
	var invariant = __webpack_require__(5);
	
	var OBSERVED_ERROR = {};
	
	/**
	 * `Transaction` creates a black box that is able to wrap any method such that
	 * certain invariants are maintained before and after the method is invoked
	 * (Even if an exception is thrown while invoking the wrapped method). Whoever
	 * instantiates a transaction can provide enforcers of the invariants at
	 * creation time. The `Transaction` class itself will supply one additional
	 * automatic invariant for you - the invariant that any transaction instance
	 * should not be run while it is already being run. You would typically create a
	 * single instance of a `Transaction` for reuse multiple times, that potentially
	 * is used to wrap several different methods. Wrappers are extremely simple -
	 * they only require implementing two methods.
	 *
	 * <pre>
	 *                       wrappers (injected at creation time)
	 *                                      +        +
	 *                                      |        |
	 *                    +-----------------|--------|--------------+
	 *                    |                 v        |              |
	 *                    |      +---------------+   |              |
	 *                    |   +--|    wrapper1   |---|----+         |
	 *                    |   |  +---------------+   v    |         |
	 *                    |   |          +-------------+  |         |
	 *                    |   |     +----|   wrapper2  |--------+   |
	 *                    |   |     |    +-------------+  |     |   |
	 *                    |   |     |                     |     |   |
	 *                    |   v     v                     v     v   | wrapper
	 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
	 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
	 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | +---+ +---+   +---------+   +---+ +---+ |
	 *                    |  initialize                    close    |
	 *                    +-----------------------------------------+
	 * </pre>
	 *
	 * Use cases:
	 * - Preserving the input selection ranges before/after reconciliation.
	 *   Restoring selection even in the event of an unexpected error.
	 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
	 *   while guaranteeing that afterwards, the event system is reactivated.
	 * - Flushing a queue of collected DOM mutations to the main UI thread after a
	 *   reconciliation takes place in a worker thread.
	 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
	 *   content.
	 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
	 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
	 * - (Future use case): Layout calculations before and after DOM updates.
	 *
	 * Transactional plugin API:
	 * - A module that has an `initialize` method that returns any precomputation.
	 * - and a `close` method that accepts the precomputation. `close` is invoked
	 *   when the wrapped process is completed, or has failed.
	 *
	 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
	 * that implement `initialize` and `close`.
	 * @return {Transaction} Single transaction for reuse in thread.
	 *
	 * @class Transaction
	 */
	var TransactionImpl = {
	  /**
	   * Sets up this instance so that it is prepared for collecting metrics. Does
	   * so such that this setup method may be used on an instance that is already
	   * initialized, in a way that does not consume additional memory upon reuse.
	   * That can be useful if you decide to make your subclass of this mixin a
	   * "PooledClass".
	   */
	  reinitializeTransaction: function reinitializeTransaction() {
	    this.transactionWrappers = this.getTransactionWrappers();
	    if (this.wrapperInitData) {
	      this.wrapperInitData.length = 0;
	    } else {
	      this.wrapperInitData = [];
	    }
	    this._isInTransaction = false;
	  },
	
	  _isInTransaction: false,
	
	  /**
	   * @abstract
	   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
	   */
	  getTransactionWrappers: null,
	
	  isInTransaction: function isInTransaction() {
	    return !!this._isInTransaction;
	  },
	
	  /* eslint-disable space-before-function-paren */
	
	  /**
	   * Executes the function within a safety window. Use this for the top level
	   * methods that result in large amounts of computation/mutations that would
	   * need to be safety checked. The optional arguments helps prevent the need
	   * to bind in many cases.
	   *
	   * @param {function} method Member of scope to call.
	   * @param {Object} scope Scope to invoke from.
	   * @param {Object?=} a Argument to pass to the method.
	   * @param {Object?=} b Argument to pass to the method.
	   * @param {Object?=} c Argument to pass to the method.
	   * @param {Object?=} d Argument to pass to the method.
	   * @param {Object?=} e Argument to pass to the method.
	   * @param {Object?=} f Argument to pass to the method.
	   *
	   * @return {*} Return value from `method`.
	   */
	  perform: function perform(method, scope, a, b, c, d, e, f) {
	    /* eslint-enable space-before-function-paren */
	    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
	    var errorThrown;
	    var ret;
	    try {
	      this._isInTransaction = true;
	      // Catching errors makes debugging more difficult, so we start with
	      // errorThrown set to true before setting it to false after calling
	      // close -- if it's still set to true in the finally block, it means
	      // one of these calls threw.
	      errorThrown = true;
	      this.initializeAll(0);
	      ret = method.call(scope, a, b, c, d, e, f);
	      errorThrown = false;
	    } finally {
	      try {
	        if (errorThrown) {
	          // If `method` throws, prefer to show that stack trace over any thrown
	          // by invoking `closeAll`.
	          try {
	            this.closeAll(0);
	          } catch (err) {}
	        } else {
	          // Since `method` didn't throw, we don't want to silence the exception
	          // here.
	          this.closeAll(0);
	        }
	      } finally {
	        this._isInTransaction = false;
	      }
	    }
	    return ret;
	  },
	
	  initializeAll: function initializeAll(startIndex) {
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      try {
	        // Catching errors makes debugging more difficult, so we start with the
	        // OBSERVED_ERROR state before overwriting it with the real return value
	        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
	        // block, it means wrapper.initialize threw.
	        this.wrapperInitData[i] = OBSERVED_ERROR;
	        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
	      } finally {
	        if (this.wrapperInitData[i] === OBSERVED_ERROR) {
	          // The initializer for wrapper i threw an error; initialize the
	          // remaining wrappers but silence any exceptions from them to ensure
	          // that the first error is the one to bubble up.
	          try {
	            this.initializeAll(i + 1);
	          } catch (err) {}
	        }
	      }
	    }
	  },
	
	  /**
	   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
	   * them the respective return values of `this.transactionWrappers.init[i]`
	   * (`close`rs that correspond to initializers that failed will not be
	   * invoked).
	   */
	  closeAll: function closeAll(startIndex) {
	    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      var initData = this.wrapperInitData[i];
	      var errorThrown;
	      try {
	        // Catching errors makes debugging more difficult, so we start with
	        // errorThrown set to true before setting it to false after calling
	        // close -- if it's still set to true in the finally block, it means
	        // wrapper.close threw.
	        errorThrown = true;
	        if (initData !== OBSERVED_ERROR && wrapper.close) {
	          wrapper.close.call(this, initData);
	        }
	        errorThrown = false;
	      } finally {
	        if (errorThrown) {
	          // The closer for wrapper i threw an error; close the remaining
	          // wrappers but silence any exceptions from them to ensure that the
	          // first error is the one to bubble up.
	          try {
	            this.closeAll(i + 1);
	          } catch (e) {}
	        }
	      }
	    }
	    this.wrapperInitData.length = 0;
	  }
	};
	
	module.exports = TransactionImpl;

/***/ },
/* 125 */
/***/ function(module, exports) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * Based on the escape-html library, which is used under the MIT License below:
	 *
	 * Copyright (c) 2012-2013 TJ Holowaychuk
	 * Copyright (c) 2015 Andreas Lubbe
	 * Copyright (c) 2015 Tiancheng "Timothy" Gu
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining
	 * a copy of this software and associated documentation files (the
	 * 'Software'), to deal in the Software without restriction, including
	 * without limitation the rights to use, copy, modify, merge, publish,
	 * distribute, sublicense, and/or sell copies of the Software, and to
	 * permit persons to whom the Software is furnished to do so, subject to
	 * the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be
	 * included in all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
	 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
	 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
	 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
	 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	 *
	 */
	
	'use strict';
	
	// code copied and modified from escape-html
	/**
	 * Module variables.
	 * @private
	 */
	
	var matchHtmlRegExp = /["'&<>]/;
	
	/**
	 * Escape special characters in the given string of html.
	 *
	 * @param  {string} string The string to escape for inserting into HTML
	 * @return {string}
	 * @public
	 */
	
	function escapeHtml(string) {
	  var str = '' + string;
	  var match = matchHtmlRegExp.exec(str);
	
	  if (!match) {
	    return str;
	  }
	
	  var escape;
	  var html = '';
	  var index = 0;
	  var lastIndex = 0;
	
	  for (index = match.index; index < str.length; index++) {
	    switch (str.charCodeAt(index)) {
	      case 34:
	        // "
	        escape = '&quot;';
	        break;
	      case 38:
	        // &
	        escape = '&amp;';
	        break;
	      case 39:
	        // '
	        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
	        break;
	      case 60:
	        // <
	        escape = '&lt;';
	        break;
	      case 62:
	        // >
	        escape = '&gt;';
	        break;
	      default:
	        continue;
	    }
	
	    if (lastIndex !== index) {
	      html += str.substring(lastIndex, index);
	    }
	
	    lastIndex = index + 1;
	    html += escape;
	  }
	
	  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
	}
	// end code copied and modified from escape-html
	
	/**
	 * Escapes text to prevent scripting attacks.
	 *
	 * @param {*} text Text value to escape.
	 * @return {string} An escaped string.
	 */
	function escapeTextContentForBrowser(text) {
	  if (typeof text === 'boolean' || typeof text === 'number') {
	    // this shortcircuit helps perf for types that we know will never have
	    // special characters, especially given that this function is used often
	    // for numeric dom ids.
	    return '' + text;
	  }
	  return escapeHtml(text);
	}
	
	module.exports = escapeTextContentForBrowser;

/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(32);
	var DOMNamespaces = __webpack_require__(166);
	
	var WHITESPACE_TEST = /^[ \r\n\t\f]/;
	var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(174);
	
	// SVG temp container for IE lacking innerHTML
	var reusableSVGContainer;
	
	/**
	 * Set the innerHTML property of a node, ensuring that whitespace is preserved
	 * even in IE8.
	 *
	 * @param {DOMElement} node
	 * @param {string} html
	 * @internal
	 */
	var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
	  // IE does not have innerHTML for SVG nodes, so instead we inject the
	  // new markup in a temp node and then move the child nodes across into
	  // the target node
	  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
	    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
	    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
	    var svgNode = reusableSVGContainer.firstChild;
	    while (svgNode.firstChild) {
	      node.appendChild(svgNode.firstChild);
	    }
	  } else {
	    node.innerHTML = html;
	  }
	});
	
	if (ExecutionEnvironment.canUseDOM) {
	  // IE8: When updating a just created node with innerHTML only leading
	  // whitespace is removed. When updating an existing node with innerHTML
	  // whitespace in root TextNodes is also collapsed.
	  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html
	
	  // Feature detection; only IE8 is known to behave improperly like this.
	  var testElement = document.createElement('div');
	  testElement.innerHTML = ' ';
	  if (testElement.innerHTML === '') {
	    setInnerHTML = function setInnerHTML(node, html) {
	      // Magic theory: IE8 supposedly differentiates between added and updated
	      // nodes when processing innerHTML, innerHTML on updated nodes suffers
	      // from worse whitespace behavior. Re-adding a node like this triggers
	      // the initial and more favorable whitespace behavior.
	      // TODO: What to do on a detached node?
	      if (node.parentNode) {
	        node.parentNode.replaceChild(node, node);
	      }
	
	      // We also implement a workaround for non-visible tags disappearing into
	      // thin air on IE8, this only happens if there is no visible text
	      // in-front of the non-visible tags. Piggyback on the whitespace fix
	      // and simply check if any non-visible tags appear in the source.
	      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
	        // Recover leading whitespace by temporarily prepending any character.
	        // \uFEFF has the potential advantage of being zero-width/invisible.
	        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
	        // in hopes that this is preserved even if "\uFEFF" is transformed to
	        // the actual Unicode character (by Babel, for example).
	        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
	        node.innerHTML = String.fromCharCode(0xfeff) + html;
	
	        // deleteData leaves an empty `TextNode` which offsets the index of all
	        // children. Definitely want to avoid this.
	        var textNode = node.firstChild;
	        if (textNode.data.length === 1) {
	          node.removeChild(textNode);
	        } else {
	          textNode.deleteData(0, 1);
	        }
	      } else {
	        node.innerHTML = html;
	      }
	    };
	  }
	  testElement = null;
	}
	
	module.exports = setInnerHTML;

/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var randomFromSeed = __webpack_require__(918);
	
	var ORIGINAL = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ_-';
	var alphabet;
	var previousSeed;
	
	var shuffled;
	
	function reset() {
	    shuffled = false;
	}
	
	function setCharacters(_alphabet_) {
	    if (!_alphabet_) {
	        if (alphabet !== ORIGINAL) {
	            alphabet = ORIGINAL;
	            reset();
	        }
	        return;
	    }
	
	    if (_alphabet_ === alphabet) {
	        return;
	    }
	
	    if (_alphabet_.length !== ORIGINAL.length) {
	        throw new Error('Custom alphabet for shortid must be ' + ORIGINAL.length + ' unique characters. You submitted ' + _alphabet_.length + ' characters: ' + _alphabet_);
	    }
	
	    var unique = _alphabet_.split('').filter(function (item, ind, arr) {
	        return ind !== arr.lastIndexOf(item);
	    });
	
	    if (unique.length) {
	        throw new Error('Custom alphabet for shortid must be ' + ORIGINAL.length + ' unique characters. These characters were not unique: ' + unique.join(', '));
	    }
	
	    alphabet = _alphabet_;
	    reset();
	}
	
	function characters(_alphabet_) {
	    setCharacters(_alphabet_);
	    return alphabet;
	}
	
	function setSeed(seed) {
	    randomFromSeed.seed(seed);
	    if (previousSeed !== seed) {
	        reset();
	        previousSeed = seed;
	    }
	}
	
	function shuffle() {
	    if (!alphabet) {
	        setCharacters(ORIGINAL);
	    }
	
	    var sourceArray = alphabet.split('');
	    var targetArray = [];
	    var r = randomFromSeed.nextValue();
	    var characterIndex;
	
	    while (sourceArray.length > 0) {
	        r = randomFromSeed.nextValue();
	        characterIndex = Math.floor(r * sourceArray.length);
	        targetArray.push(sourceArray.splice(characterIndex, 1)[0]);
	    }
	    return targetArray.join('');
	}
	
	function getShuffled() {
	    if (shuffled) {
	        return shuffled;
	    }
	    shuffled = shuffle();
	    return shuffled;
	}
	
	/**
	 * lookup shuffled letter
	 * @param index
	 * @returns {string}
	 */
	function lookup(index) {
	    var alphabetShuffled = getShuffled();
	    return alphabetShuffled[index];
	}
	
	function get() {
	    return alphabet || ORIGINAL;
	}
	
	module.exports = {
	    get: get,
	    characters: characters,
	    seed: setSeed,
	    lookup: lookup,
	    shuffled: getShuffled
	};

/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	Object.defineProperty(exports, '__esModule', { value: !0 });var _Form = __webpack_require__(417);Object.defineProperty(exports, 'default', { enumerable: !0, get: function get() {
	    return _interopRequireDefault(_Form).default;
	  } });function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}

/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	Object.defineProperty(exports, '__esModule', { value: !0 });var _FormGroup = __webpack_require__(422);Object.defineProperty(exports, 'default', { enumerable: !0, get: function get() {
	    return _interopRequireDefault(_FormGroup).default;
	  } });function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}

/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	Object.defineProperty(exports, '__esModule', { value: !0 });var _createColor = __webpack_require__(503),
	    _createColor2 = _interopRequireDefault(_createColor),
	    _createI18n = __webpack_require__(196),
	    _createI18n2 = _interopRequireDefault(_createI18n),
	    _createTypography = __webpack_require__(508),
	    _createTypography2 = _interopRequireDefault(_createTypography),
	    _createTransitions = __webpack_require__(507),
	    _createTransitions2 = _interopRequireDefault(_createTransitions),
	    _createShape = __webpack_require__(504),
	    _createShape2 = _interopRequireDefault(_createShape),
	    _createSizes = __webpack_require__(505),
	    _createSizes2 = _interopRequireDefault(_createSizes),
	    _createZIndex = __webpack_require__(509),
	    _createZIndex2 = _interopRequireDefault(_createZIndex),
	    _createBoxShadows = __webpack_require__(502),
	    _createBoxShadows2 = _interopRequireDefault(_createBoxShadows);function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}var createTheme = function createTheme() {
	  var options = 0 < arguments.length && arguments[0] !== void 0 ? arguments[0] : {},
	      _options$color = options.color,
	      colorInput = _options$color === void 0 ? {} : _options$color,
	      _options$i18n = options.i18n,
	      i18nInput = _options$i18n === void 0 ? void 0 : _options$i18n,
	      _options$shadow = options.shadow,
	      shadowInput = _options$shadow === void 0 ? {} : _options$shadow,
	      _options$shape = options.shape,
	      shapeInput = _options$shape === void 0 ? {} : _options$shape,
	      _options$size = options.size,
	      sizeInput = _options$size === void 0 ? {} : _options$size,
	      _options$transition = options.transition,
	      transitionInput = _options$transition === void 0 ? {} : _options$transition,
	      _options$typography = options.typography,
	      typographyInput = _options$typography === void 0 ? {} : _options$typography,
	      _options$zIndex = options.zIndex,
	      zIndexInput = _options$zIndex === void 0 ? {} : _options$zIndex,
	      color = (0, _createColor2.default)(colorInput),
	      i18n = (0, _createI18n2.default)(i18nInput),
	      shadow = (0, _createBoxShadows2.default)(shadowInput),
	      shape = (0, _createShape2.default)(shapeInput),
	      size = (0, _createSizes2.default)(sizeInput),
	      transition = (0, _createTransitions2.default)(transitionInput),
	      typography = (0, _createTypography2.default)(typographyInput),
	      zIndex = (0, _createZIndex2.default)(zIndexInput);return { vstui: { breakpoint: { xs: '(max-width: 375px)' }, color: color, i18n: i18n, rem: function rem(value) {
	        var remRegex = /rem$/,
	            pxRegex = /px$/;if ('inherit' === value) return value;if ('number' == typeof value) return typography.pxToRem(value);if ('string' == typeof value) {
	          if (value.match(remRegex)) return value;if (value.match(pxRegex)) {
	            var unitlessValue = value.split(pxRegex)[0],
	                number = parseInt(unitlessValue, 10);return typography.pxToRem(number);
	          }
	        }throw new Error('rem: invalid value');
	      }, shadow: shadow, shape: shape, size: size, typography: typography, transition: transition, zIndex: zIndex } };
	};exports.default = createTheme;

/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	'use strict';
	
	var toObject = __webpack_require__(24);
	var toAbsoluteIndex = __webpack_require__(73);
	var toLength = __webpack_require__(22);
	module.exports = function fill(value /* , start = 0, end = @length */) {
	  var O = toObject(this);
	  var length = toLength(O.length);
	  var aLen = arguments.length;
	  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
	  var end = aLen > 2 ? arguments[2] : undefined;
	  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
	  while (endPos > index) {
	    O[index++] = value;
	  }return O;
	};

/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
	var speciesConstructor = __webpack_require__(525);
	
	module.exports = function (original, length) {
	  return new (speciesConstructor(original))(length);
	};

/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var $defineProperty = __webpack_require__(21);
	var createDesc = __webpack_require__(70);
	
	module.exports = function (object, index, value) {
	  if (index in object) $defineProperty.f(object, index, createDesc(0, value));else object[index] = value;
	};

/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var isObject = __webpack_require__(14);
	var document = __webpack_require__(8).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};

/***/ },
/* 135 */
/***/ function(module, exports) {

	'use strict';
	
	// IE 8- don't enum bug keys
	module.exports = 'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'.split(',');

/***/ },
/* 136 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var MATCH = __webpack_require__(17)('match');
	module.exports = function (KEY) {
	  var re = /./;
	  try {
	    '/./'[KEY](re);
	  } catch (e) {
	    try {
	      re[MATCH] = false;
	      return !'/./'[KEY](re);
	    } catch (f) {/* empty */}
	  }return true;
	};

/***/ },
/* 137 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var document = __webpack_require__(8).document;
	module.exports = document && document.documentElement;

/***/ },
/* 138 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var isObject = __webpack_require__(14);
	var setPrototypeOf = __webpack_require__(146).set;
	module.exports = function (that, target, C) {
	  var S = target.constructor;
	  var P;
	  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
	    setPrototypeOf(that, P);
	  }return that;
	};

/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// check on default Array iterator
	var Iterators = __webpack_require__(77);
	var ITERATOR = __webpack_require__(17)('iterator');
	var ArrayProto = Array.prototype;
	
	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};

/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var create = __webpack_require__(68);
	var descriptor = __webpack_require__(70);
	var setToStringTag = __webpack_require__(78);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(34)(IteratorPrototype, __webpack_require__(17)('iterator'), function () {
	  return this;
	});
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};

/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var LIBRARY = __webpack_require__(67);
	var $export = __webpack_require__(2);
	var redefine = __webpack_require__(35);
	var hide = __webpack_require__(34);
	var has = __webpack_require__(33);
	var Iterators = __webpack_require__(77);
	var $iterCreate = __webpack_require__(140);
	var setToStringTag = __webpack_require__(78);
	var getPrototypeOf = __webpack_require__(40);
	var ITERATOR = __webpack_require__(17)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function returnThis() {
	  return this;
	};
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function getMethod(kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS:
	        return function keys() {
	          return new Constructor(this, kind);
	        };
	      case VALUES:
	        return function values() {
	          return new Constructor(this, kind);
	        };
	    }return function entries() {
	      return new Constructor(this, kind);
	    };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() {
	      return $native.call(this);
	    };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};

/***/ },
/* 142 */
/***/ function(module, exports) {

	"use strict";
	
	// 20.2.2.14 Math.expm1(x)
	var $expm1 = Math.expm1;
	module.exports = !$expm1
	// Old FF bug
	|| $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
	// Tor Browser bug
	|| $expm1(-2e-17) != -2e-17 ? function expm1(x) {
	  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
	} : $expm1;

/***/ },
/* 143 */
/***/ function(module, exports) {

	"use strict";
	
	// 20.2.2.28 Math.sign(x)
	module.exports = Math.sign || function sign(x) {
	  // eslint-disable-next-line no-self-compare
	  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
	};

/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var global = __webpack_require__(8);
	var macrotask = __webpack_require__(152).set;
	var Observer = global.MutationObserver || global.WebKitMutationObserver;
	var process = global.process;
	var Promise = global.Promise;
	var isNode = __webpack_require__(43)(process) == 'process';
	
	module.exports = function () {
	  var head, last, notify;
	
	  var flush = function flush() {
	    var parent, fn;
	    if (isNode && (parent = process.domain)) parent.exit();
	    while (head) {
	      fn = head.fn;
	      head = head.next;
	      try {
	        fn();
	      } catch (e) {
	        if (head) notify();else last = undefined;
	        throw e;
	      }
	    }last = undefined;
	    if (parent) parent.enter();
	  };
	
	  // Node.js
	  if (isNode) {
	    notify = function notify() {
	      process.nextTick(flush);
	    };
	    // browsers with MutationObserver
	  } else if (Observer) {
	    var toggle = true;
	    var node = document.createTextNode('');
	    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
	    notify = function notify() {
	      node.data = toggle = !toggle;
	    };
	    // environments with maybe non-completely correct, but existent Promise
	  } else if (Promise && Promise.resolve) {
	    var promise = Promise.resolve();
	    notify = function notify() {
	      promise.then(flush);
	    };
	    // for other environments - macrotask based on:
	    // - setImmediate
	    // - MessageChannel
	    // - window.postMessag
	    // - onreadystatechange
	    // - setTimeout
	  } else {
	    notify = function notify() {
	      // strange IE + webpack dev server bug - use .call(global)
	      macrotask.call(global, flush);
	    };
	  }
	
	  return function (fn) {
	    var task = { fn: fn, next: undefined };
	    if (last) last.next = task;
	    if (!head) {
	      head = task;
	      notify();
	    }last = task;
	  };
	};

/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 25.4.1.5 NewPromiseCapability(C)
	
	var aFunction = __webpack_require__(27);
	
	function PromiseCapability(C) {
	  var resolve, reject;
	  this.promise = new C(function ($$resolve, $$reject) {
	    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject = $$reject;
	  });
	  this.resolve = aFunction(resolve);
	  this.reject = aFunction(reject);
	}
	
	module.exports.f = function (C) {
	  return new PromiseCapability(C);
	};

/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(14);
	var anObject = __webpack_require__(7);
	var check = function check(O, proto) {
	  anObject(O);
	  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	  function (test, buggy, set) {
	    try {
	      set = __webpack_require__(44)(Function.call, __webpack_require__(39).f(Object.prototype, '__proto__').set, 2);
	      set(test, []);
	      buggy = !(test instanceof Array);
	    } catch (e) {
	      buggy = true;
	    }
	    return function setPrototypeOf(O, proto) {
	      check(O, proto);
	      if (buggy) O.__proto__ = proto;else set(O, proto);
	      return O;
	    };
	  }({}, false) : undefined),
	  check: check
	};

/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var shared = __webpack_require__(115)('keys');
	var uid = __webpack_require__(74);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};

/***/ },
/* 148 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var toInteger = __webpack_require__(51);
	var defined = __webpack_require__(49);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff ? TO_STRING ? s.charAt(i) : a : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};

/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// helper for String#{startsWith, endsWith, includes}
	var isRegExp = __webpack_require__(109);
	var defined = __webpack_require__(49);
	
	module.exports = function (that, searchString, NAME) {
	  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
	  return String(defined(that));
	};

/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var toInteger = __webpack_require__(51);
	var defined = __webpack_require__(49);
	
	module.exports = function repeat(count) {
	  var str = String(defined(this));
	  var res = '';
	  var n = toInteger(count);
	  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
	  for (; n > 0; (n >>>= 1) && (str += str)) {
	    if (n & 1) res += str;
	  }return res;
	};

/***/ },
/* 151 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = '\t\n\x0B\f\r \xA0\u1680\u180E\u2000\u2001\u2002\u2003' + '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';

/***/ },
/* 152 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var ctx = __webpack_require__(44);
	var invoke = __webpack_require__(107);
	var html = __webpack_require__(137);
	var cel = __webpack_require__(134);
	var global = __webpack_require__(8);
	var process = global.process;
	var setTask = global.setImmediate;
	var clearTask = global.clearImmediate;
	var MessageChannel = global.MessageChannel;
	var Dispatch = global.Dispatch;
	var counter = 0;
	var queue = {};
	var ONREADYSTATECHANGE = 'onreadystatechange';
	var defer, channel, port;
	var run = function run() {
	  var id = +this;
	  // eslint-disable-next-line no-prototype-builtins
	  if (queue.hasOwnProperty(id)) {
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listener = function listener(event) {
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if (!setTask || !clearTask) {
	  setTask = function setImmediate(fn) {
	    var args = [];
	    var i = 1;
	    while (arguments.length > i) {
	      args.push(arguments[i++]);
	    }queue[++counter] = function () {
	      // eslint-disable-next-line no-new-func
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id) {
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if (__webpack_require__(43)(process) == 'process') {
	    defer = function defer(id) {
	      process.nextTick(ctx(run, id, 1));
	    };
	    // Sphere (JS game engine) Dispatch API
	  } else if (Dispatch && Dispatch.now) {
	    defer = function defer(id) {
	      Dispatch.now(ctx(run, id, 1));
	    };
	    // Browsers with MessageChannel, includes WebWorkers
	  } else if (MessageChannel) {
	    channel = new MessageChannel();
	    port = channel.port2;
	    channel.port1.onmessage = listener;
	    defer = ctx(port.postMessage, port, 1);
	    // Browsers with postMessage, skip WebWorkers
	    // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
	    defer = function defer(id) {
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listener, false);
	    // IE8-
	  } else if (ONREADYSTATECHANGE in cel('script')) {
	    defer = function defer(id) {
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	    // Rest old browsers
	  } else {
	    defer = function defer(id) {
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set: setTask,
	  clear: clearTask
	};

/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var global = __webpack_require__(8);
	var DESCRIPTORS = __webpack_require__(20);
	var LIBRARY = __webpack_require__(67);
	var $typed = __webpack_require__(117);
	var hide = __webpack_require__(34);
	var redefineAll = __webpack_require__(71);
	var fails = __webpack_require__(10);
	var anInstance = __webpack_require__(65);
	var toInteger = __webpack_require__(51);
	var toLength = __webpack_require__(22);
	var toIndex = __webpack_require__(227);
	var gOPN = __webpack_require__(69).f;
	var dP = __webpack_require__(21).f;
	var arrayFill = __webpack_require__(131);
	var setToStringTag = __webpack_require__(78);
	var ARRAY_BUFFER = 'ArrayBuffer';
	var DATA_VIEW = 'DataView';
	var PROTOTYPE = 'prototype';
	var WRONG_LENGTH = 'Wrong length!';
	var WRONG_INDEX = 'Wrong index!';
	var $ArrayBuffer = global[ARRAY_BUFFER];
	var $DataView = global[DATA_VIEW];
	var Math = global.Math;
	var RangeError = global.RangeError;
	// eslint-disable-next-line no-shadow-restricted-names
	var Infinity = global.Infinity;
	var BaseBuffer = $ArrayBuffer;
	var abs = Math.abs;
	var pow = Math.pow;
	var floor = Math.floor;
	var log = Math.log;
	var LN2 = Math.LN2;
	var BUFFER = 'buffer';
	var BYTE_LENGTH = 'byteLength';
	var BYTE_OFFSET = 'byteOffset';
	var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
	var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
	var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;
	
	// IEEE754 conversions based on https://github.com/feross/ieee754
	function packIEEE754(value, mLen, nBytes) {
	  var buffer = Array(nBytes);
	  var eLen = nBytes * 8 - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
	  var i = 0;
	  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
	  var e, m, c;
	  value = abs(value);
	  // eslint-disable-next-line no-self-compare
	  if (value != value || value === Infinity) {
	    // eslint-disable-next-line no-self-compare
	    m = value != value ? 1 : 0;
	    e = eMax;
	  } else {
	    e = floor(log(value) / LN2);
	    if (value * (c = pow(2, -e)) < 1) {
	      e--;
	      c *= 2;
	    }
	    if (e + eBias >= 1) {
	      value += rt / c;
	    } else {
	      value += rt * pow(2, 1 - eBias);
	    }
	    if (value * c >= 2) {
	      e++;
	      c /= 2;
	    }
	    if (e + eBias >= eMax) {
	      m = 0;
	      e = eMax;
	    } else if (e + eBias >= 1) {
	      m = (value * c - 1) * pow(2, mLen);
	      e = e + eBias;
	    } else {
	      m = value * pow(2, eBias - 1) * pow(2, mLen);
	      e = 0;
	    }
	  }
	  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8) {}
	  e = e << mLen | m;
	  eLen += mLen;
	  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8) {}
	  buffer[--i] |= s * 128;
	  return buffer;
	}
	function unpackIEEE754(buffer, mLen, nBytes) {
	  var eLen = nBytes * 8 - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var nBits = eLen - 7;
	  var i = nBytes - 1;
	  var s = buffer[i--];
	  var e = s & 127;
	  var m;
	  s >>= 7;
	  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8) {}
	  m = e & (1 << -nBits) - 1;
	  e >>= -nBits;
	  nBits += mLen;
	  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8) {}
	  if (e === 0) {
	    e = 1 - eBias;
	  } else if (e === eMax) {
	    return m ? NaN : s ? -Infinity : Infinity;
	  } else {
	    m = m + pow(2, mLen);
	    e = e - eBias;
	  }return (s ? -1 : 1) * m * pow(2, e - mLen);
	}
	
	function unpackI32(bytes) {
	  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
	}
	function packI8(it) {
	  return [it & 0xff];
	}
	function packI16(it) {
	  return [it & 0xff, it >> 8 & 0xff];
	}
	function packI32(it) {
	  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
	}
	function packF64(it) {
	  return packIEEE754(it, 52, 8);
	}
	function packF32(it) {
	  return packIEEE754(it, 23, 4);
	}
	
	function addGetter(C, key, internal) {
	  dP(C[PROTOTYPE], key, { get: function get() {
	      return this[internal];
	    } });
	}
	
	function get(view, bytes, index, isLittleEndian) {
	  var numIndex = +index;
	  var intIndex = toIndex(numIndex);
	  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b;
	  var start = intIndex + view[$OFFSET];
	  var pack = store.slice(start, start + bytes);
	  return isLittleEndian ? pack : pack.reverse();
	}
	function set(view, bytes, index, conversion, value, isLittleEndian) {
	  var numIndex = +index;
	  var intIndex = toIndex(numIndex);
	  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b;
	  var start = intIndex + view[$OFFSET];
	  var pack = conversion(+value);
	  for (var i = 0; i < bytes; i++) {
	    store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
	  }
	}
	
	if (!$typed.ABV) {
	  $ArrayBuffer = function ArrayBuffer(length) {
	    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
	    var byteLength = toIndex(length);
	    this._b = arrayFill.call(Array(byteLength), 0);
	    this[$LENGTH] = byteLength;
	  };
	
	  $DataView = function DataView(buffer, byteOffset, byteLength) {
	    anInstance(this, $DataView, DATA_VIEW);
	    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
	    var bufferLength = buffer[$LENGTH];
	    var offset = toInteger(byteOffset);
	    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
	    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
	    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
	    this[$BUFFER] = buffer;
	    this[$OFFSET] = offset;
	    this[$LENGTH] = byteLength;
	  };
	
	  if (DESCRIPTORS) {
	    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
	    addGetter($DataView, BUFFER, '_b');
	    addGetter($DataView, BYTE_LENGTH, '_l');
	    addGetter($DataView, BYTE_OFFSET, '_o');
	  }
	
	  redefineAll($DataView[PROTOTYPE], {
	    getInt8: function getInt8(byteOffset) {
	      return get(this, 1, byteOffset)[0] << 24 >> 24;
	    },
	    getUint8: function getUint8(byteOffset) {
	      return get(this, 1, byteOffset)[0];
	    },
	    getInt16: function getInt16(byteOffset /* , littleEndian */) {
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
	    },
	    getUint16: function getUint16(byteOffset /* , littleEndian */) {
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return bytes[1] << 8 | bytes[0];
	    },
	    getInt32: function getInt32(byteOffset /* , littleEndian */) {
	      return unpackI32(get(this, 4, byteOffset, arguments[1]));
	    },
	    getUint32: function getUint32(byteOffset /* , littleEndian */) {
	      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
	    },
	    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
	      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
	    },
	    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
	      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
	    },
	    setInt8: function setInt8(byteOffset, value) {
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setUint8: function setUint8(byteOffset, value) {
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packF32, value, arguments[2]);
	    },
	    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
	      set(this, 8, byteOffset, packF64, value, arguments[2]);
	    }
	  });
	} else {
	  if (!fails(function () {
	    $ArrayBuffer(1);
	  }) || !fails(function () {
	    new $ArrayBuffer(-1); // eslint-disable-line no-new
	  }) || fails(function () {
	    new $ArrayBuffer(); // eslint-disable-line no-new
	    new $ArrayBuffer(1.5); // eslint-disable-line no-new
	    new $ArrayBuffer(NaN); // eslint-disable-line no-new
	    return $ArrayBuffer.name != ARRAY_BUFFER;
	  })) {
	    $ArrayBuffer = function ArrayBuffer(length) {
	      anInstance(this, $ArrayBuffer);
	      return new BaseBuffer(toIndex(length));
	    };
	    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
	    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
	      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
	    }
	    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
	  }
	  // iOS Safari 7.x bug
	  var view = new $DataView(new $ArrayBuffer(2));
	  var $setInt8 = $DataView[PROTOTYPE].setInt8;
	  view.setInt8(0, 2147483648);
	  view.setInt8(1, 2147483649);
	  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
	    setInt8: function setInt8(byteOffset, value) {
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    },
	    setUint8: function setUint8(byteOffset, value) {
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    }
	  }, true);
	}
	setToStringTag($ArrayBuffer, ARRAY_BUFFER);
	setToStringTag($DataView, DATA_VIEW);
	hide($DataView[PROTOTYPE], $typed.VIEW, true);
	exports[ARRAY_BUFFER] = $ArrayBuffer;
	exports[DATA_VIEW] = $DataView;

/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var global = __webpack_require__(8);
	var core = __webpack_require__(48);
	var LIBRARY = __webpack_require__(67);
	var wksExt = __webpack_require__(228);
	var defineProperty = __webpack_require__(21).f;
	module.exports = function (name) {
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
	};

/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var classof = __webpack_require__(90);
	var ITERATOR = __webpack_require__(17)('iterator');
	var Iterators = __webpack_require__(77);
	module.exports = __webpack_require__(48).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR] || it['@@iterator'] || Iterators[classof(it)];
	};

/***/ },
/* 156 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var addToUnscopables = __webpack_require__(60);
	var step = __webpack_require__(212);
	var Iterators = __webpack_require__(77);
	var toIObject = __webpack_require__(37);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(141)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0; // next index
	  this._k = kind; // kind
	  // 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');

/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _dispatcher = __webpack_require__(18);
	
	var _dispatcher2 = _interopRequireDefault(_dispatcher);
	
	var _routes = __webpack_require__(163);
	
	var _routes2 = _interopRequireDefault(_routes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  viewDetails: function viewDetails(code) {
	    _routes2.default.setRoute('/transactions/refunds/' + code);
	  },
	  requestRefund: function requestRefund(details) {
	    _dispatcher2.default.emit(_dispatcher2.default.TRANSACTION_REQUEST_REFUND, details);
	  },
	  showRefundRestrictions: function showRefundRestrictions(transId) {
	    _routes2.default.setRoute('/transactions/' + transId + '/refund-restrictions');
	  },
	  popRequestForm: function popRequestForm(transId, id) {
	    _routes2.default.setRoute('/transactions/' + transId + '/request-refund/' + id);
	  }
	};

/***/ },
/* 158 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  showDetails: function showDetails(orderId) {
	    Routes.setRoute('/transactions/' + orderId);
	  },
	  goToTransactions: function goToTransactions() {
	    Routes.setRoute('/transactions');
	  },
	  goToRefunds: function goToRefunds() {
	    Routes.setRoute('/transactions/refunds');
	  },
	  showRefundDetails: function showRefundDetails(number) {
	    Routes.setRoute('/transactions/refunds/' + number);
	  },
	  showRefundRestrictions: function showRefundRestrictions(number) {
	    Routes.setRoute('/transactions/' + number + '/refund-restrictions');
	  }
	};

/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _dispatcher = __webpack_require__(18);
	
	var _dispatcher2 = _interopRequireDefault(_dispatcher);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  setInfo: function setInfo(info) {
	    _dispatcher2.default.emit(_dispatcher2.default.USER_SET_INFO, info);
	  },
	  changePassword: function changePassword(info) {
	    _dispatcher2.default.emit(_dispatcher2.default.USER_CHANGE_PASSWORD, info);
	  },
	  updateSecurityQuestion: function updateSecurityQuestion(info) {
	    _dispatcher2.default.emit(_dispatcher2.default.USER_UPDATE_SECURITY_QUESTION, info);
	  },
	  updateNotificationSetting: function updateNotificationSetting(info) {
	    _dispatcher2.default.emit(_dispatcher2.default.USER_UPDATE_NOTIFICATION, info);
	  },
	  signOut: function signOut() {
	    Jigsaw.User.signOut(function () {
	      _dispatcher2.default.emit(_dispatcher2.default.USER_SIGN_OUT);
	      Routes.setRoute("logout");
	    });
	  }
	};

/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _refundAction = __webpack_require__(157);
	
	var _refundAction2 = _interopRequireDefault(_refundAction);
	
	var _price = __webpack_require__(118);
	
	var _price2 = _interopRequireDefault(_price);
	
	var _utils = __webpack_require__(28);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _vstui = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PurchaseItem = function PurchaseItem(_ref) {
	  var item = _ref.item,
	      _ref$transaction = _ref.transaction,
	      bulk = _ref$transaction.bulk,
	      currency = _ref$transaction.currency,
	      number = _ref$transaction.number,
	      orderDate = _ref$transaction.orderDate,
	      className = _ref.className,
	      hideDownloadCodes = _ref.hideDownloadCodes,
	      hideRefundButton = _ref.hideRefundButton,
	      hideRight = _ref.hideRight,
	      isRefund = _ref.isRefund;
	
	  var vat = _utils2.default.vat(currency);
	  var _nonRefundedCopies = item.codes.filter(function (obj) {
	    return !obj.refunded;
	  });
	  var _accessString = function _accessString() {
	    var duration = item.duration;
	
	    if (!duration) {
	      return null;
	    }
	    if (duration === 'perpetual') {
	      return i18n.t('transactions.license.perpetual');
	    } else {
	      var m = duration.match(/(\d+) day/i);
	      return i18n.t('transactions.license.days', { days: m[1] });
	    }
	  };
	
	  var _expirationDate = function _expirationDate() {
	    var duration = item.item;
	
	    if (duration === 'perpetual') {
	      return null;
	    }
	    // for some reason, the duration can be null sometimes...
	    if (!duration) {
	      return null;
	    }
	    var start = new Date(orderDate),
	        md = duration.match(/\d+/),
	        secondsLeft = parseInt(md[0], 10) * 24 * 60 * 60 * 1000;
	
	    return new Date(start.getTime() + secondsLeft);
	  };
	
	  var _requestRefund = function _requestRefund() {
	    _refundAction2.default.popRequestForm(number, item.isbn);
	  };
	
	  var _showRefundRestrictions = function _showRefundRestrictions(e) {
	    e.preventDefault();
	    _refundAction2.default.showRefundRestrictions(number);
	  };
	
	  var _renderRefundDetails = function _renderRefundDetails() {
	    var itemPrice = item.itemPrice,
	        codes = item.codes;
	
	    var partialRefund = null;
	    if (_nonRefundedCopies.length > 0 && _nonRefundedCopies.length < codes.length) {
	      partialRefund = _react2.default.createElement(
	        'span',
	        null,
	        i18n.t('refunds.bulk.partially-refunded')
	      );
	    }
	    if (_nonRefundedCopies.length === 0 || parseFloat(itemPrice) < 0) {
	      return i18n.t('refunds.states.refunded');
	    } else if (codes.some(function (obj) {
	      return obj.refundable;
	    })) {
	      return _react2.default.createElement(
	        'div',
	        null,
	        partialRefund,
	        _react2.default.createElement(
	          _vstui.VstButton,
	          { className: 'cloud', options: 'btn-36', onClick: _requestRefund },
	          i18n.t('transactions.request-refund')
	        )
	      );
	    } else {
	      return _react2.default.createElement(
	        'div',
	        null,
	        partialRefund,
	        _react2.default.createElement(
	          'a',
	          { href: '#', onClick: _showRefundRestrictions },
	          i18n.t('refunds.states.unavailable')
	        )
	      );
	    }
	  };
	
	  var _renderSubTaxes = function _renderSubTaxes(arg) {
	    if (currency === "AUD") {
	      return;
	    }
	    var subTaxes = item.taxes;
	    if (subTaxes.length) {
	      subTaxes = subTaxes.map(function (subTax) {
	        return Object.assign({}, subTax, { jurisdictionCode: subTax.jurisdictionCode.slice(2) });
	      });
	      var gst = subTaxes.findIndex(function (subTax) {
	        return subTax.jurisdictionCode == "GST";
	      });
	      var hst = subTaxes.findIndex(function (subTax) {
	        return subTax.jurisdictionCode == "HST";
	      });
	      if (hst > -1) {
	        gst = gst > -1 ? subTaxes.splice(gst, 1) : { tax: 0, taxRate: 0 };
	        hst = subTaxes.splice(hst, 1)[0];
	        subTaxes.push({ tax: gst.tax + hst.tax, taxRate: gst.taxRate + hst.taxRate, jurisdictionCode: "GST/HST" });
	      }
	      subTaxes = subTaxes.reduce(function (a, b) {
	        if (parseFloat(b.tax) === 0 && b.jurisdictionCode !== "PST") {
	          return a;
	        }
	        return a.concat(_react2.default.createElement(
	          'div',
	          { className: 'price-wrapper' },
	          _react2.default.createElement(
	            'span',
	            null,
	            i18n.t("transactions.portion", { subTax: b.jurisdictionCode, rate: _utils2.default.taxRate(b.taxRate) }),
	            ':'
	          ),
	          _react2.default.createElement(
	            'strong',
	            null,
	            _react2.default.createElement(_price2.default, { price: b.tax, currency: currency, skipCurrency: true })
	          )
	        ));
	      }, []);
	    }
	
	    return subTaxes;
	  };
	
	  var _downloadCodes = function _downloadCodes() {
	    var data = item.codes.sort(function (x, y) {
	      return y.refundable - x.refundable;
	    });
	    var csvContent = "data:text/csv;charset=utf-8,";
	    csvContent += ['Title', 'ISBN', 'Code', 'Expiration Date', 'Refundable?', 'Reason Non-refundable'] + "\r\n";
	    var title = item.title,
	        isbn = item.isbn,
	        quantity = item.quantity;
	
	    var expirationDate = new Date(orderDate);
	    expirationDate.setDate(expirationDate.getDate() + 30);
	    expirationDate = expirationDate.getMonth() + 1 + "/" + expirationDate.getDate() + "/" + expirationDate.getFullYear();
	    data.forEach(function (codesObj, index) {
	      var code = codesObj.code,
	          refundable = codesObj.refundable,
	          refundableReasonText = codesObj.refundableReasonText;
	
	      var reason = refundableReasonText || "N/A";
	      var dataString = [title, isbn, code, expirationDate, refundable, reason];
	      csvContent += dataString + "\r\n";
	    });
	    csvContent += "\r\n".repeat(5);
	    csvContent += ['Title', 'Quantity'] + "\r\n";
	    csvContent += [title, quantity] + "\r\n";
	    csvContent += ['Total', quantity];
	    return encodeURI(csvContent);
	  };
	
	  var expDate = _expirationDate(),
	      expString = void 0;
	
	  if (expDate && expDate.getTime() < new Date().getTime()) {
	    expString = i18n.t('transactions.expired');
	  } else {
	    expString = i18n.t('transactions.expires-in', { date: _utils2.default.toDateString(expDate) });
	  }
	  var klass = "clear card";
	  if (className) {
	    klass += " " + className;
	  }
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: klass },
	      _react2.default.createElement(
	        'div',
	        { className: 'left' },
	        _react2.default.createElement('img', { className: 'cover', src: item.imageUrl, alt: '' }),
	        _react2.default.createElement(
	          'div',
	          { className: 'details' },
	          _react2.default.createElement(
	            'h3',
	            { className: 'title' },
	            item.title
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'author' },
	            item.author
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'expiration-wrapper' },
	            _react2.default.createElement(
	              'span',
	              { className: 'duration' },
	              _accessString()
	            ),
	            expDate && _react2.default.createElement(
	              'span',
	              { className: 'expiration' },
	              expString
	            )
	          ),
	          bulk && !hideDownloadCodes && _react2.default.createElement(
	            'span',
	            { className: 'download-wrapper' },
	            _react2.default.createElement(
	              'span',
	              { className: 'available' },
	              i18n.t('refunds.bulk.available-codes'),
	              ': ',
	              _nonRefundedCopies.length
	            ),
	            _react2.default.createElement(
	              'a',
	              { className: 'download', download: 'bulk_purchase_codes.csv', href: _downloadCodes() },
	              i18n.t('refunds.bulk.download')
	            )
	          )
	        )
	      ),
	      !hideRight && _react2.default.createElement(
	        'div',
	        { className: 'right' },
	        _react2.default.createElement(
	          'div',
	          { className: 'price-wrapper' },
	          _react2.default.createElement(
	            'span',
	            null,
	            i18n.t('transactions.price'),
	            item.tax > 0 && _react2.default.createElement(
	              'span',
	              { className: 'small' },
	              ' ',
	              !vat && i18n.t('transactions.excluded')
	            ),
	            ':'
	          ),
	          _react2.default.createElement(
	            'strong',
	            null,
	            _react2.default.createElement(_price2.default, { price: _utils2.default._itemPrice(item, currency), currency: currency, skipCurrency: true })
	          )
	        ),
	        bulk && _react2.default.createElement(
	          'div',
	          { className: 'price-wrapper' },
	          _react2.default.createElement(
	            'span',
	            null,
	            i18n.t('transactions.quantity'),
	            ':'
	          ),
	          _react2.default.createElement(
	            'strong',
	            null,
	            ' ',
	            item.quantity
	          )
	        ),
	        isRefund && (_renderSubTaxes() || _react2.default.createElement(
	          'div',
	          { className: 'price-wrapper' },
	          _react2.default.createElement(
	            'span',
	            null,
	            vat || i18n.t('transactions.tax'),
	            ':'
	          ),
	          _react2.default.createElement(
	            'strong',
	            null,
	            _react2.default.createElement(_price2.default, { price: item.tax, currency: currency, skipCurrency: true })
	          )
	        )),
	        (bulk || isRefund) && _react2.default.createElement(
	          'div',
	          { className: 'price-wrapper' },
	          _react2.default.createElement(
	            'span',
	            null,
	            i18n.t('transactions.total'),
	            item.tax > 0 && !isRefund && _react2.default.createElement(
	              'span',
	              { className: 'small' },
	              ' ',
	              !vat && i18n.t('transactions.excluded')
	            ),
	            ':'
	          ),
	          _react2.default.createElement(
	            'strong',
	            null,
	            _react2.default.createElement(_price2.default, { price: _utils2.default._itemPrice(item, currency, isRefund) * item.quantity, currency: currency, skipCurrency: true })
	          )
	        ),
	        isRefund && vat && _react2.default.createElement(
	          'span',
	          { className: 'vat-disclosure light' },
	          i18n.t('transactions.vat-disclosure', { vat: vat })
	        ),
	        !hideRefundButton && _renderRefundDetails()
	      )
	    )
	  );
	};
	
	exports.default = PurchaseItem;

/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _events = __webpack_require__(82);
	
	var _dispatcher = __webpack_require__(18);
	
	var _dispatcher2 = _interopRequireDefault(_dispatcher);
	
	var _objectAssign = __webpack_require__(11);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UtilityStore = (0, _objectAssign2.default)({}, _events.EventEmitter.prototype, {
	
	  HAMBURGER_STATE: "hambruger.state",
	
	  _state: {},
	
	  _updateState: function _updateState(state) {
	    this._state = state;
	    _dispatcher2.default.emit(_dispatcher2.default.RESOURCE_STORE_CHANGE);
	  },
	
	  get: function get(utility) {
	    return this._state[utility];
	  },
	
	  init: function init() {
	    var _this = this;
	
	    _dispatcher2.default.on(_dispatcher2.default.HEADER_HAMBURGER_TOGGLE, function () {
	      _this._state[_this.HAMBURGER_STATE] = !_this._state[_this.HAMBURGER_STATE];
	      _dispatcher2.default.emit(_dispatcher2.default.HEADER_HAMBURGER_CHANGE);
	    });
	    _dispatcher2.default.on(_dispatcher2.default.HEADER_HAMBURGER_OFF, function () {
	      _this._state[_this.HAMBURGER_STATE] = false;
	      _dispatcher2.default.emit(_dispatcher2.default.HEADER_HAMBURGER_CHANGE);
	    });
	  }
	
	});
	
	UtilityStore.init();
	exports.default = UtilityStore;

/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var locales = {
	  "en-US": {
	    vstFormat: "en",
	    direction: "ltr",
	    rfc: "en-US"
	  },
	  "ar-SA": {
	    vstFormat: "ar",
	    direction: "rtl",
	    rfc: "ar-SA"
	  },
	  "bg-BG": {
	    vstFormat: "bg",
	    direction: "ltr",
	    rfc: "bg-BG"
	  },
	  "ca-ES": {
	    vstFormat: "ca",
	    direction: "ltr",
	    rfc: "ca-ES"
	  },
	  "cs-CZ": {
	    vstFormat: "cs",
	    direction: "ltr",
	    rfc: "cs-CZ"
	  },
	  "cy-GB": {
	    vstFormat: "cy",
	    direction: "ltr",
	    rfc: "cy-GB"
	  },
	  "da-DK": {
	    vstFormat: "da",
	    direction: "ltr",
	    rfc: "da-DK"
	  },
	  "de-DE": {
	    vstFormat: "de",
	    direction: "ltr",
	    rfc: "de-DE"
	  },
	  "el-GR": {
	    vstFormat: "el",
	    direction: "ltr",
	    rfc: "el-GR"
	  },
	  "en-GB": {
	    vstFormat: "en_GB",
	    direction: "ltr",
	    rfc: "en-GB"
	  },
	  "es-ES": {
	    vstFormat: "es",
	    direction: "ltr",
	    rfc: "es-ES"
	  },
	  "es-MX": {
	    vstFormat: "es_MX",
	    direction: "ltr",
	    rfc: "es-MX"
	  },
	  "es-419": {
	    vstFormat: "es_419",
	    direction: "ltr",
	    rfc: "es-419"
	  },
	  "fr-CA": {
	    vstFormat: "fr_CA",
	    direction: "ltr",
	    rfc: "fr-CA"
	  },
	  "fr-FR": {
	    vstFormat: "fr",
	    direction: "ltr",
	    rfc: "fr-FR"
	  },
	  "ga-IE": {
	    vstFormat: "ga",
	    direction: "ltr",
	    rfc: "ga-IE"
	  },
	  "he-IL": {
	    vstFormat: "he",
	    direction: "rtl",
	    rfc: "he-IL"
	  },
	  "hi-IN": {
	    vstFormat: "hi",
	    direction: "ltr",
	    rfc: "hi-IN"
	  },
	  "is-IS": {
	    vstFormat: "is",
	    direction: "ltr",
	    rfc: "is-IS"
	  },
	  "it-IT": {
	    vstFormat: "it",
	    direction: "ltr",
	    rfc: "it-IT"
	  },
	  "ja-JP": {
	    vstFormat: "ja",
	    direction: "ltr",
	    rfc: "ja-JP"
	  },
	  "ko-KR": {
	    vstFormat: "ko",
	    direction: "ltr",
	    rfc: "ko-KR"
	  },
	  "hu-HU": {
	    vstFormat: "hu",
	    direction: "ltr",
	    rfc: "hu-HU"
	  },
	  "nl-NL": {
	    vstFormat: "nl",
	    direction: "ltr",
	    rfc: "nl-NL"
	  },
	  "nb-NO": {
	    vstFormat: "no",
	    direction: "ltr",
	    rfc: "nb-NO"
	  },
	  "pl-PL": {
	    vstFormat: "pl",
	    direction: "ltr",
	    rfc: "pl-PL"
	  },
	  "pt-BR": {
	    vstFormat: "pt_BR",
	    direction: "ltr",
	    rfc: "pt-BR"
	  },
	  "pt-PT": {
	    vstFormat: "pt",
	    direction: "ltr",
	    rfc: "pt-PT"
	  },
	  "ru-RU": {
	    vstFormat: "ru",
	    direction: "ltr",
	    rfc: "ru-RU"
	  },
	  "ro-RO": {
	    vstFormat: "ro",
	    direction: "ltr",
	    rfc: "ro-RO"
	  },
	  "fi-FI": {
	    vstFormat: "fi",
	    direction: "ltr",
	    rfc: "fi-FI"
	  },
	  "sv-SE": {
	    vstFormat: "sv",
	    direction: "ltr",
	    rfc: "sv-SE"
	  },
	  "tl-PH": {
	    vstFormat: "fil",
	    direction: "ltr",
	    rfc: "tl-PH"
	  },
	  "th-TH": {
	    vstFormat: "th",
	    direction: "ltr",
	    rfc: "th-TH"
	  },
	  "vi-VN": {
	    vstFormat: "vi",
	    direction: "ltr",
	    rfc: "vi-VN"
	  },
	  "tr-TR": {
	    vstFormat: "tr",
	    direction: "ltr",
	    rfc: "tr-TR"
	  },
	  "zh-CN": {
	    vstFormat: "zh_CN",
	    direction: "ltr",
	    rfc: "zh-CN"
	  },
	  "zh-TW": {
	    vstFormat: "zh_TW",
	    direction: "ltr",
	    rfc: "zh-TW"
	  }
	};
	
	var languageToLocale = {
	  en: "en-US",
	  ar: "ar-SA",
	  bg: "bg-BG",
	  ca: "ca-ES",
	  cs: "cs-CZ",
	  cy: "cy-GB",
	  da: "da-DK",
	  de: "de-DE",
	  el: "el-GR",
	  es: "es-ES",
	  fr: "fr-FR",
	  ga: "ga-IE",
	  he: "he-IL",
	  hi: "hi-IN",
	  is: "is-IS",
	  it: "it-IT",
	  ja: "ja-JP",
	  ko: "ko-KR",
	  hu: "hu-HU",
	  nl: "nl-NL",
	  nb: "nb-NO",
	  pl: "pl-PL",
	  pt: "pt-PT",
	  ru: "ru-RU",
	  ro: "ro-RO",
	  fi: "fi-FI",
	  sv: "sv-SE",
	  tl: "tl-PH",
	  th: "th-TH",
	  vi: "vi-VN",
	  tr: "tr-TR",
	  zh: "zh-CN"
	};
	
	var localeMap = {
	  "es-LA": "es-419",
	  "es-AR": "es-419",
	  "es-BO": "es-419",
	  "es-CL": "es-419",
	  "es-CO": "es-419",
	  "es-CR": "es-419",
	  "es-CU": "es-419",
	  "es-DO": "es-419",
	  "es-EC": "es-419",
	  "es-SV": "es-419",
	  "es-GT": "es-419",
	  "es-HN": "es-419",
	  "es-NI": "es-419",
	  "es-PA": "es-419",
	  "es-PY": "es-419",
	  "es-PE": "es-419",
	  "es-PR": "es-419",
	  "es-US": "es-419",
	  "es-UY": "es-419",
	  "es-VE": "es-419"
	};
	
	var getLocale = function getLocale(localeString) {
	  if (!localeString) {
	    return undefined;
	  }
	
	  var _localeString$toLocal = localeString.toLocaleLowerCase().split(/-|_/gi),
	      _localeString$toLocal2 = _slicedToArray(_localeString$toLocal, 2),
	      language = _localeString$toLocal2[0],
	      region = _localeString$toLocal2[1];
	
	  var normalizedLocaleString = region ? language + "-" + region : "";
	
	  var findLocale = function findLocale(target) {
	    return Object.entries(target).find(function (_ref) {
	      var _ref2 = _slicedToArray(_ref, 1),
	          key = _ref2[0];
	
	      return key.toLocaleLowerCase() === normalizedLocaleString;
	    });
	  };
	
	  var fullLocaleKey = findLocale(locales);
	  if (fullLocaleKey) {
	    return fullLocaleKey[1];
	  }
	
	  var localeMapKey = findLocale(localeMap);
	  if (localeMapKey) {
	    return locales[localeMapKey[1]];
	  }
	
	  return locales[languageToLocale[language]] || locales[languageToLocale["en"]];
	};
	
	module.exports = {
	  // Extend the changeLocale function of i18n.js to allow overriding of
	  // strings whenever the language is changed.
	  changeLocale: function changeLocale(locale, callback) {
	    i18n.changeLocale(locale, function () {
	      // now this is the new part! override with branding texts!
	      var keys = [];
	      for (var k in Mulligan.Brand.Text) {
	        if (Mulligan.Brand.Text.hasOwnProperty(k)) {
	          keys.push(k);
	        }
	      }
	      for (var i = 0; i < keys.length; i++) {
	        var key = keys[i];
	        var value = Mulligan.Brand.Text[key];
	        var parts = key.split(".").reverse();
	        var current = value || false;
	        for (var j = 0; j < parts.length; j++) {
	          var part = parts[j];
	          var tmp = {};
	          tmp[part] = current;
	          current = tmp;
	        }
	        i18n.extendLocale(current);
	      }
	      if (callback) {
	        callback();
	      }
	    });
	  },
	
	  locales: {
	    en: __webpack_require__(977),
	    ar: __webpack_require__(968),
	    bg: __webpack_require__(969),
	    ca: __webpack_require__(970),
	    cs: __webpack_require__(971),
	    cy: __webpack_require__(972),
	    da: __webpack_require__(973),
	    de: __webpack_require__(974),
	    el: __webpack_require__(975),
	    en_GB: __webpack_require__(976),
	    es: __webpack_require__(979),
	    es_MX: __webpack_require__(978),
	    fi: __webpack_require__(980),
	    fil: __webpack_require__(981),
	    fr_CA: __webpack_require__(982),
	    fr: __webpack_require__(983),
	    ga: __webpack_require__(984),
	    he: __webpack_require__(985),
	    hi: __webpack_require__(986),
	    is: __webpack_require__(987),
	    it: __webpack_require__(988),
	    ja: __webpack_require__(989),
	    ko: __webpack_require__(990),
	    nl: __webpack_require__(991),
	    no: __webpack_require__(992),
	    pl: __webpack_require__(993),
	    pt_BR: __webpack_require__(994),
	    pt: __webpack_require__(995),
	    ro: __webpack_require__(996),
	    ru: __webpack_require__(997),
	    sv: __webpack_require__(998),
	    th: __webpack_require__(999),
	    tr: __webpack_require__(1000),
	    vi: __webpack_require__(1001),
	    zh_CN: __webpack_require__(1002),
	    zh_TW: __webpack_require__(1003)
	  },
	  getLocale: getLocale
	};

/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MulliganRouter = exports.MulliganController = undefined;
	
	var _honeybadgerJs = __webpack_require__(245);
	
	var _honeybadgerJs2 = _interopRequireDefault(_honeybadgerJs);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(63);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _vstui = __webpack_require__(30);
	
	var _devicesContainer = __webpack_require__(743);
	
	var _devicesContainer2 = _interopRequireDefault(_devicesContainer);
	
	var _layout = __webpack_require__(747);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _redirect = __webpack_require__(749);
	
	var _redirect2 = _interopRequireDefault(_redirect);
	
	var _refundDetail = __webpack_require__(750);
	
	var _refundDetail2 = _interopRequireDefault(_refundDetail);
	
	var _refundsContainer = __webpack_require__(755);
	
	var _refundsContainer2 = _interopRequireDefault(_refundsContainer);
	
	var _resource = __webpack_require__(756);
	
	var _resource2 = _interopRequireDefault(_resource);
	
	var _resourcesContainer = __webpack_require__(757);
	
	var _resourcesContainer2 = _interopRequireDefault(_resourcesContainer);
	
	var _transactionDetail = __webpack_require__(758);
	
	var _transactionDetail2 = _interopRequireDefault(_transactionDetail);
	
	var _user = __webpack_require__(759);
	
	var _user2 = _interopRequireDefault(_user);
	
	__webpack_require__(957);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_honeybadgerJs2.default.configure({
	  apiKey: 'caf208b8',
	  environment: ({"jigsawURL":"//jigsaw.vitalsource.com/assets/v1/jigsaw/box.js","jigsawRootURL":"//jigsaw.vitalsource.com/","alohomoraHost":"login.vitalsource.com","sslSignin":true,"storeOrderHistory":"https://www.vitalsource.com/order-history","environment":"production"}).environment,
	  revision: '' + ("")
	});
	
	var title = "VitalSource Account Center";
	
	var getAlohomoraUrl = function getAlohomoraUrl() {
	  var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
	
	  return 'https://' + ({"jigsawURL":"//jigsaw.vitalsource.com/assets/v1/jigsaw/box.js","jigsawRootURL":"//jigsaw.vitalsource.com/","alohomoraHost":"login.vitalsource.com","sslSignin":true,"storeOrderHistory":"https://www.vitalsource.com/order-history","environment":"production"}).alohomoraHost + path + '?redirect_uri=' + encodeURIComponent(window.location.href.replace(/(\/login)|(\/logout)|(\/redirect)/ig, "")) + '&brand=' + (Mulligan.brandParam || window.location.hostname);
	};
	
	var getStoreRedirectUrl = function getStoreRedirectUrl() {
	  return 'https://' + ({"jigsawURL":"//jigsaw.vitalsource.com/assets/v1/jigsaw/box.js","jigsawRootURL":"//jigsaw.vitalsource.com/","alohomoraHost":"login.vitalsource.com","sslSignin":true,"storeOrderHistory":"https://www.vitalsource.com/order-history","environment":"production"}).alohomoraHost + '?redirect_uri=' + encodeURIComponent(({"jigsawURL":"//jigsaw.vitalsource.com/assets/v1/jigsaw/box.js","jigsawRootURL":"//jigsaw.vitalsource.com/","alohomoraHost":"login.vitalsource.com","sslSignin":true,"storeOrderHistory":"https://www.vitalsource.com/order-history","environment":"production"}).storeOrderHistory) + '&method=jwt&brand=' + (Mulligan.brandParam || window.location.hostname);
	};
	
	var _ref = _react2.default.createElement(_layout2.default, { page: 'devices',
	  component: _react2.default.createElement(_devicesContainer2.default, null) });
	
	var _ref2 = _react2.default.createElement(_layout2.default, { page: 'transactions', component: _react2.default.createElement(_refundsContainer2.default, null) });
	
	var _ref3 = _react2.default.createElement(
	  'div',
	  { className: 'loading-app' },
	  _react2.default.createElement(_vstui.VstLoader, null)
	);
	
	var MulliganController = {
	  index: function index(modal) {
	    var page = ["user", "devices", "resources", "transactions"].find(function (page) {
	      return Mulligan.Brand.AccountCenter.Sidebar[page];
	    });
	    // redirect to first available if user info is not enabled for this brand
	    if (page && page !== "user") {
	      MulliganRouter.setRoute('/' + page);return;
	    }
	
	    document.title = title + ": " + i18n.t("base.user");
	    _reactDom2.default.render(_react2.default.createElement(_layout2.default, { page: 'user',
	      component: _react2.default.createElement(_user2.default, { modalOpen: modal }) }), document.getElementById('root'));
	  },
	  notFound: function notFound() {
	    // not sure the best way to handle this w/o switching the controller to an instance
	    // eslint-disable-next-line
	    MulliganRouter.setRoute('/');
	  },
	  login: function login() {
	    _reactDom2.default.render(_react2.default.createElement(_redirect2.default, { url: getAlohomoraUrl(), hideMessage: true }), document.getElementById('root'));
	  },
	
	
	  // The logout page is necessary for alohomora logout - it logs out of alohomora after any necessary Jigsaw session clearing.
	  logout: function logout() {
	    _reactDom2.default.render(_react2.default.createElement(_redirect2.default, { url: getAlohomoraUrl("/logout"), hideMessage: true }), document.getElementById('root'));
	  },
	  devices: function devices() {
	    document.title = title + ": " + i18n.t("base.devices");
	    _reactDom2.default.render(_ref, document.getElementById('root'));
	  },
	  resources: function resources(tab) {
	    document.title = title + ": " + i18n.t("base.resources");
	    _reactDom2.default.render(_react2.default.createElement(_layout2.default, { page: 'resources',
	      component: _react2.default.createElement(_resourcesContainer2.default, { tab: tab || "ancillaries" }) }), document.getElementById('root'));
	  },
	  resource: function resource(tab, isbn) {
	    document.title = title + ": " + i18n.t("base.resources");
	    _reactDom2.default.render(_react2.default.createElement(_layout2.default, { page: 'resources',
	      component: _react2.default.createElement(_resource2.default, { isbn: isbn }) }), document.getElementById('root'));
	  },
	  transactions: function transactions() {
	    _reactDom2.default.render(_react2.default.createElement(_redirect2.default, { url: getStoreRedirectUrl(), hideMessage: true }), document.getElementById('root'));
	  },
	  transactionDetail: function transactionDetail(number) {
	    /* console.log("details!");*/
	    document.title = title + ": " + i18n.t("base.transactions");
	    _reactDom2.default.render(_react2.default.createElement(_layout2.default, { page: 'transactions',
	      component: _react2.default.createElement(_transactionDetail2.default, { orderNumber: number }) }), document.getElementById('root'));
	  },
	  refunds: function refunds() {
	    document.title = title + ": " + i18n.t("base.refunds");
	    _reactDom2.default.render(_ref2, document.getElementById('root'));
	  },
	  refundRequest: function refundRequest(transactionId, itemNumber) {
	    document.title = title + ": " + i18n.t("base.transactions");
	    _reactDom2.default.render(_react2.default.createElement(_layout2.default, { page: 'transactions', component: _react2.default.createElement(_transactionDetail2.default, { orderNumber: transactionId, refundItemNumber: itemNumber }) }), document.getElementById('root'));
	  },
	  refundRestrictions: function refundRestrictions(transactionId) {
	    document.title = title + ": " + i18n.t("base.transactions");
	    _reactDom2.default.render(_react2.default.createElement(_layout2.default, { page: 'transactions', component: _react2.default.createElement(_transactionDetail2.default, { orderNumber: transactionId, refundRestrictions: true }) }), document.getElementById('root'));
	  },
	  refundDetail: function refundDetail(number) {
	    document.title = title + ": " + i18n.t("base.refunds");
	    _reactDom2.default.render(_react2.default.createElement(_layout2.default, { page: 'transactions', component: _react2.default.createElement(_refundDetail2.default, { number: number }) }), document.getElementById('root'));
	  },
	  redirect: function redirect(url) {
	    _reactDom2.default.render(_react2.default.createElement(_redirect2.default, { url: window.decodeURIComponent(url) }), document.getElementById('root'));
	  },
	  loader: function loader() {
	    _reactDom2.default.render(_ref3, document.getElementById('root'));
	  }
	};
	
	var MulliganRouter = new DirectorRouter({
	  '/': MulliganController.index,
	  '/user/profile': MulliganController.index,
	  '/user/profile/:modal': MulliganController.index,
	  '/devices': MulliganController.devices,
	  '/settings': MulliganController.devices,
	  '/resources': MulliganController.resources,
	  '/resources/:tab': MulliganController.resources,
	  '/resources/:tab/:isbn': MulliganController.resource,
	  '/transactions': MulliganController.transactions,
	  '/purchases': MulliganController.transactions,
	  '/transactions/refunds': MulliganController.refunds,
	  '/transactions/:id': MulliganController.transactionDetail,
	  '/transactions/:trans_id/request-refund/:id': MulliganController.refundRequest,
	  '/transactions/refunds/:id': MulliganController.refundDetail,
	  '/transactions/:id/refund-restrictions': MulliganController.refundRestrictions,
	  '/login': MulliganController.login,
	  '/login/:failure/:email': MulliganController.login,
	  '/redirect/:url': MulliganController.redirect,
	  '/logout': MulliganController.logout,
	  '.*': MulliganController.notFound
	});
	
	exports.default = MulliganRouter;
	exports.MulliganController = MulliganController;
	exports.MulliganRouter = MulliganRouter;

/***/ },
/* 164 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 * 
	 */
	
	/*eslint-disable no-self-compare */
	
	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    // Added the nonzero y check to make Flow happy, but it is redundant
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) {
	    return true;
	  }
	
	  if ((typeof objA === 'undefined' ? 'undefined' : _typeof(objA)) !== 'object' || objA === null || (typeof objB === 'undefined' ? 'undefined' : _typeof(objB)) !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ },
/* 165 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMLazyTree = __webpack_require__(83);
	var Danger = __webpack_require__(828);
	var ReactDOMComponentTree = __webpack_require__(23);
	var ReactInstrumentation = __webpack_require__(46);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(174);
	var setInnerHTML = __webpack_require__(126);
	var setTextContent = __webpack_require__(384);
	
	function getNodeAfter(parentNode, node) {
	  // Special case for text components, which return [open, close] comments
	  // from getHostNode.
	  if (Array.isArray(node)) {
	    node = node[1];
	  }
	  return node ? node.nextSibling : parentNode.firstChild;
	}
	
	/**
	 * Inserts `childNode` as a child of `parentNode` at the `index`.
	 *
	 * @param {DOMElement} parentNode Parent node in which to insert.
	 * @param {DOMElement} childNode Child node to insert.
	 * @param {number} index Index at which to insert the child.
	 * @internal
	 */
	var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
	  // We rely exclusively on `insertBefore(node, null)` instead of also using
	  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
	  // we are careful to use `null`.)
	  parentNode.insertBefore(childNode, referenceNode);
	});
	
	function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
	  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
	}
	
	function moveChild(parentNode, childNode, referenceNode) {
	  if (Array.isArray(childNode)) {
	    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
	  } else {
	    insertChildAt(parentNode, childNode, referenceNode);
	  }
	}
	
	function removeChild(parentNode, childNode) {
	  if (Array.isArray(childNode)) {
	    var closingComment = childNode[1];
	    childNode = childNode[0];
	    removeDelimitedText(parentNode, childNode, closingComment);
	    parentNode.removeChild(closingComment);
	  }
	  parentNode.removeChild(childNode);
	}
	
	function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
	  var node = openingComment;
	  while (true) {
	    var nextNode = node.nextSibling;
	    insertChildAt(parentNode, node, referenceNode);
	    if (node === closingComment) {
	      break;
	    }
	    node = nextNode;
	  }
	}
	
	function removeDelimitedText(parentNode, startNode, closingComment) {
	  while (true) {
	    var node = startNode.nextSibling;
	    if (node === closingComment) {
	      // The closing comment is removed by ReactMultiChild.
	      break;
	    } else {
	      parentNode.removeChild(node);
	    }
	  }
	}
	
	function replaceDelimitedText(openingComment, closingComment, stringText) {
	  var parentNode = openingComment.parentNode;
	  var nodeAfterComment = openingComment.nextSibling;
	  if (nodeAfterComment === closingComment) {
	    // There are no text nodes between the opening and closing comments; insert
	    // a new one if stringText isn't empty.
	    if (stringText) {
	      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
	    }
	  } else {
	    if (stringText) {
	      // Set the text content of the first node after the opening comment, and
	      // remove all following nodes up until the closing comment.
	      setTextContent(nodeAfterComment, stringText);
	      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
	    } else {
	      removeDelimitedText(parentNode, openingComment, closingComment);
	    }
	  }
	
	  if (false) {
	    ReactInstrumentation.debugTool.onHostOperation({
	      instanceID: ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID,
	      type: 'replace text',
	      payload: stringText
	    });
	  }
	}
	
	var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
	if (false) {
	  dangerouslyReplaceNodeWithMarkup = function dangerouslyReplaceNodeWithMarkup(oldChild, markup, prevInstance) {
	    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
	    if (prevInstance._debugID !== 0) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: prevInstance._debugID,
	        type: 'replace with',
	        payload: markup.toString()
	      });
	    } else {
	      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
	      if (nextInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: nextInstance._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  };
	}
	
	/**
	 * Operations for updating with DOM children.
	 */
	var DOMChildrenOperations = {
	  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,
	
	  replaceDelimitedText: replaceDelimitedText,
	
	  /**
	   * Updates a component's children by processing a series of updates. The
	   * update configurations are each expected to have a `parentNode` property.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  processUpdates: function processUpdates(parentNode, updates) {
	    if (false) {
	      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
	    }
	
	    for (var k = 0; k < updates.length; k++) {
	      var update = updates[k];
	      switch (update.type) {
	        case 'INSERT_MARKUP':
	          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'insert child',
	              payload: {
	                toIndex: update.toIndex,
	                content: update.content.toString()
	              }
	            });
	          }
	          break;
	        case 'MOVE_EXISTING':
	          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'move child',
	              payload: { fromIndex: update.fromIndex, toIndex: update.toIndex }
	            });
	          }
	          break;
	        case 'SET_MARKUP':
	          setInnerHTML(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace children',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'TEXT_CONTENT':
	          setTextContent(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace text',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'REMOVE_NODE':
	          removeChild(parentNode, update.fromNode);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'remove child',
	              payload: { fromIndex: update.fromIndex }
	            });
	          }
	          break;
	      }
	    }
	  }
	};
	
	module.exports = DOMChildrenOperations;

/***/ },
/* 166 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = {
	  html: 'http://www.w3.org/1999/xhtml',
	  mathml: 'http://www.w3.org/1998/Math/MathML',
	  svg: 'http://www.w3.org/2000/svg'
	};
	
	module.exports = DOMNamespaces;

/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(12);
	
	var invariant = __webpack_require__(5);
	
	/**
	 * Injectable ordering of event plugins.
	 */
	var eventPluginOrder = null;
	
	/**
	 * Injectable mapping from names to event plugin modules.
	 */
	var namesToPlugins = {};
	
	/**
	 * Recomputes the plugin list using the injected plugins and plugin ordering.
	 *
	 * @private
	 */
	function recomputePluginOrdering() {
	  if (!eventPluginOrder) {
	    // Wait until an `eventPluginOrder` is injected.
	    return;
	  }
	  for (var pluginName in namesToPlugins) {
	    var pluginModule = namesToPlugins[pluginName];
	    var pluginIndex = eventPluginOrder.indexOf(pluginName);
	    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
	    if (EventPluginRegistry.plugins[pluginIndex]) {
	      continue;
	    }
	    !pluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
	    EventPluginRegistry.plugins[pluginIndex] = pluginModule;
	    var publishedEvents = pluginModule.eventTypes;
	    for (var eventName in publishedEvents) {
	      !publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
	    }
	  }
	}
	
	/**
	 * Publishes an event so that it can be dispatched by the supplied plugin.
	 *
	 * @param {object} dispatchConfig Dispatch configuration for the event.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @return {boolean} True if the event was successfully published.
	 * @private
	 */
	function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
	  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
	  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;
	
	  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	  if (phasedRegistrationNames) {
	    for (var phaseName in phasedRegistrationNames) {
	      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
	        var phasedRegistrationName = phasedRegistrationNames[phaseName];
	        publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
	      }
	    }
	    return true;
	  } else if (dispatchConfig.registrationName) {
	    publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
	    return true;
	  }
	  return false;
	}
	
	/**
	 * Publishes a registration name that is used to identify dispatched events and
	 * can be used with `EventPluginHub.putListener` to register listeners.
	 *
	 * @param {string} registrationName Registration name to add.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @private
	 */
	function publishRegistrationName(registrationName, pluginModule, eventName) {
	  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
	  EventPluginRegistry.registrationNameModules[registrationName] = pluginModule;
	  EventPluginRegistry.registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;
	
	  if (false) {
	    var lowerCasedName = registrationName.toLowerCase();
	    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;
	
	    if (registrationName === 'onDoubleClick') {
	      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
	    }
	  }
	}
	
	/**
	 * Registers plugins so that they can extract and dispatch events.
	 *
	 * @see {EventPluginHub}
	 */
	var EventPluginRegistry = {
	  /**
	   * Ordered list of injected plugins.
	   */
	  plugins: [],
	
	  /**
	   * Mapping from event name to dispatch config
	   */
	  eventNameDispatchConfigs: {},
	
	  /**
	   * Mapping from registration name to plugin module
	   */
	  registrationNameModules: {},
	
	  /**
	   * Mapping from registration name to event name
	   */
	  registrationNameDependencies: {},
	
	  /**
	   * Mapping from lowercase registration names to the properly cased version,
	   * used to warn in the case of missing event handlers. Available
	   * only in __DEV__.
	   * @type {Object}
	   */
	  possibleRegistrationNames:  false ? {} : null,
	  // Trust the developer to only use possibleRegistrationNames in __DEV__
	
	  /**
	   * Injects an ordering of plugins (by plugin name). This allows the ordering
	   * to be decoupled from injection of the actual plugins so that ordering is
	   * always deterministic regardless of packaging, on-the-fly injection, etc.
	   *
	   * @param {array} InjectedEventPluginOrder
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginOrder}
	   */
	  injectEventPluginOrder: function injectEventPluginOrder(injectedEventPluginOrder) {
	    !!eventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
	    // Clone the ordering so it cannot be dynamically mutated.
	    eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
	    recomputePluginOrdering();
	  },
	
	  /**
	   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
	   * in the ordering injected by `injectEventPluginOrder`.
	   *
	   * Plugins can be injected as part of page initialization or on-the-fly.
	   *
	   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginsByName}
	   */
	  injectEventPluginsByName: function injectEventPluginsByName(injectedNamesToPlugins) {
	    var isOrderingDirty = false;
	    for (var pluginName in injectedNamesToPlugins) {
	      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
	        continue;
	      }
	      var pluginModule = injectedNamesToPlugins[pluginName];
	      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
	        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
	        namesToPlugins[pluginName] = pluginModule;
	        isOrderingDirty = true;
	      }
	    }
	    if (isOrderingDirty) {
	      recomputePluginOrdering();
	    }
	  },
	
	  /**
	   * Looks up the plugin for the supplied event.
	   *
	   * @param {object} event A synthetic event.
	   * @return {?object} The plugin that created the supplied event.
	   * @internal
	   */
	  getPluginModuleForEvent: function getPluginModuleForEvent(event) {
	    var dispatchConfig = event.dispatchConfig;
	    if (dispatchConfig.registrationName) {
	      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
	    }
	    if (dispatchConfig.phasedRegistrationNames !== undefined) {
	      // pulling phasedRegistrationNames out of dispatchConfig helps Flow see
	      // that it is not undefined.
	      var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	
	      for (var phase in phasedRegistrationNames) {
	        if (!phasedRegistrationNames.hasOwnProperty(phase)) {
	          continue;
	        }
	        var pluginModule = EventPluginRegistry.registrationNameModules[phasedRegistrationNames[phase]];
	        if (pluginModule) {
	          return pluginModule;
	        }
	      }
	    }
	    return null;
	  },
	
	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _resetEventPlugins: function _resetEventPlugins() {
	    eventPluginOrder = null;
	    for (var pluginName in namesToPlugins) {
	      if (namesToPlugins.hasOwnProperty(pluginName)) {
	        delete namesToPlugins[pluginName];
	      }
	    }
	    EventPluginRegistry.plugins.length = 0;
	
	    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
	    for (var eventName in eventNameDispatchConfigs) {
	      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
	        delete eventNameDispatchConfigs[eventName];
	      }
	    }
	
	    var registrationNameModules = EventPluginRegistry.registrationNameModules;
	    for (var registrationName in registrationNameModules) {
	      if (registrationNameModules.hasOwnProperty(registrationName)) {
	        delete registrationNameModules[registrationName];
	      }
	    }
	
	    if (false) {
	      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
	      for (var lowerCasedName in possibleRegistrationNames) {
	        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
	          delete possibleRegistrationNames[lowerCasedName];
	        }
	      }
	    }
	  }
	};
	
	module.exports = EventPluginRegistry;

/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(12);
	
	var ReactErrorUtils = __webpack_require__(172);
	
	var invariant = __webpack_require__(5);
	var warning = __webpack_require__(9);
	
	/**
	 * Injected dependencies:
	 */
	
	/**
	 * - `ComponentTree`: [required] Module that can convert between React instances
	 *   and actual node references.
	 */
	var ComponentTree;
	var TreeTraversal;
	var injection = {
	  injectComponentTree: function injectComponentTree(Injected) {
	    ComponentTree = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
	    }
	  },
	  injectTreeTraversal: function injectTreeTraversal(Injected) {
	    TreeTraversal = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
	    }
	  }
	};
	
	function isEndish(topLevelType) {
	  return topLevelType === 'topMouseUp' || topLevelType === 'topTouchEnd' || topLevelType === 'topTouchCancel';
	}
	
	function isMoveish(topLevelType) {
	  return topLevelType === 'topMouseMove' || topLevelType === 'topTouchMove';
	}
	function isStartish(topLevelType) {
	  return topLevelType === 'topMouseDown' || topLevelType === 'topTouchStart';
	}
	
	var validateEventDispatches;
	if (false) {
	  validateEventDispatches = function validateEventDispatches(event) {
	    var dispatchListeners = event._dispatchListeners;
	    var dispatchInstances = event._dispatchInstances;
	
	    var listenersIsArr = Array.isArray(dispatchListeners);
	    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;
	
	    var instancesIsArr = Array.isArray(dispatchInstances);
	    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;
	
	    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
	  };
	}
	
	/**
	 * Dispatch the event to the listener.
	 * @param {SyntheticEvent} event SyntheticEvent to handle
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @param {function} listener Application-level callback
	 * @param {*} inst Internal component instance
	 */
	function executeDispatch(event, simulated, listener, inst) {
	  var type = event.type || 'unknown-event';
	  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
	  if (simulated) {
	    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
	  } else {
	    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
	  }
	  event.currentTarget = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches.
	 */
	function executeDispatchesInOrder(event, simulated) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
	    }
	  } else if (dispatchListeners) {
	    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
	  }
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches, but stops
	 * at the first dispatch execution returning true, and returns that id.
	 *
	 * @return {?string} id of the first dispatch execution who's listener returns
	 * true, or null if no listener returned true.
	 */
	function executeDispatchesInOrderStopAtTrueImpl(event) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      if (dispatchListeners[i](event, dispatchInstances[i])) {
	        return dispatchInstances[i];
	      }
	    }
	  } else if (dispatchListeners) {
	    if (dispatchListeners(event, dispatchInstances)) {
	      return dispatchInstances;
	    }
	  }
	  return null;
	}
	
	/**
	 * @see executeDispatchesInOrderStopAtTrueImpl
	 */
	function executeDispatchesInOrderStopAtTrue(event) {
	  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
	  event._dispatchInstances = null;
	  event._dispatchListeners = null;
	  return ret;
	}
	
	/**
	 * Execution of a "direct" dispatch - there must be at most one dispatch
	 * accumulated on the event or it is considered an error. It doesn't really make
	 * sense for an event with multiple dispatches (bubbled) to keep track of the
	 * return values at each dispatch execution, but it does tend to make sense when
	 * dealing with "direct" dispatches.
	 *
	 * @return {*} The return value of executing the single dispatch.
	 */
	function executeDirectDispatch(event) {
	  if (false) {
	    validateEventDispatches(event);
	  }
	  var dispatchListener = event._dispatchListeners;
	  var dispatchInstance = event._dispatchInstances;
	  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
	  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
	  var res = dispatchListener ? dispatchListener(event) : null;
	  event.currentTarget = null;
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	  return res;
	}
	
	/**
	 * @param {SyntheticEvent} event
	 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
	 */
	function hasDispatches(event) {
	  return !!event._dispatchListeners;
	}
	
	/**
	 * General utilities that are useful in creating custom Event Plugins.
	 */
	var EventPluginUtils = {
	  isEndish: isEndish,
	  isMoveish: isMoveish,
	  isStartish: isStartish,
	
	  executeDirectDispatch: executeDirectDispatch,
	  executeDispatchesInOrder: executeDispatchesInOrder,
	  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
	  hasDispatches: hasDispatches,
	
	  getInstanceFromNode: function getInstanceFromNode(node) {
	    return ComponentTree.getInstanceFromNode(node);
	  },
	  getNodeFromInstance: function getNodeFromInstance(node) {
	    return ComponentTree.getNodeFromInstance(node);
	  },
	  isAncestor: function isAncestor(a, b) {
	    return TreeTraversal.isAncestor(a, b);
	  },
	  getLowestCommonAncestor: function getLowestCommonAncestor(a, b) {
	    return TreeTraversal.getLowestCommonAncestor(a, b);
	  },
	  getParentInstance: function getParentInstance(inst) {
	    return TreeTraversal.getParentInstance(inst);
	  },
	  traverseTwoPhase: function traverseTwoPhase(target, fn, arg) {
	    return TreeTraversal.traverseTwoPhase(target, fn, arg);
	  },
	  traverseEnterLeave: function traverseEnterLeave(from, to, fn, argFrom, argTo) {
	    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
	  },
	
	  injection: injection
	};
	
	module.exports = EventPluginUtils;

/***/ },
/* 169 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Escape and wrap key so it is safe to use as a reactid
	 *
	 * @param {string} key to be escaped.
	 * @return {string} the escaped key.
	 */
	
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function (match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	/**
	 * Unescape and unwrap key for human-readable display
	 *
	 * @param {string} key to unescape.
	 * @return {string} the unescaped key.
	 */
	function unescape(key) {
	  var unescapeRegex = /(=0|=2)/g;
	  var unescaperLookup = {
	    '=0': '=',
	    '=2': ':'
	  };
	  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);
	
	  return ('' + keySubstring).replace(unescapeRegex, function (match) {
	    return unescaperLookup[match];
	  });
	}
	
	var KeyEscapeUtils = {
	  escape: escape,
	  unescape: unescape
	};
	
	module.exports = KeyEscapeUtils;

/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(12);
	
	var ReactPropTypesSecret = __webpack_require__(857);
	var propTypesFactory = __webpack_require__(363);
	
	var React = __webpack_require__(86);
	var PropTypes = propTypesFactory(React.isValidElement);
	
	var invariant = __webpack_require__(5);
	var warning = __webpack_require__(9);
	
	var hasReadOnlyValue = {
	  button: true,
	  checkbox: true,
	  image: true,
	  hidden: true,
	  radio: true,
	  reset: true,
	  submit: true
	};
	
	function _assertSingleLink(inputProps) {
	  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
	}
	function _assertValueLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
	}
	
	function _assertCheckedLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
	}
	
	var propTypes = {
	  value: function value(props, propName, componentName) {
	    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  checked: function checked(props, propName, componentName) {
	    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  onChange: PropTypes.func
	};
	
	var loggedTypeFailures = {};
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Provide a linked `value` attribute for controlled forms. You should not use
	 * this outside of the ReactDOM controlled form components.
	 */
	var LinkedValueUtils = {
	  checkPropTypes: function checkPropTypes(tagName, props, owner) {
	    for (var propName in propTypes) {
	      if (propTypes.hasOwnProperty(propName)) {
	        var error = propTypes[propName](props, propName, tagName, 'prop', null, ReactPropTypesSecret);
	      }
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var addendum = getDeclarationErrorAddendum(owner);
	         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
	      }
	    }
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current value of the input either from value prop or link.
	   */
	  getValue: function getValue(inputProps) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.value;
	    }
	    return inputProps.value;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current checked status of the input either from checked prop
	   *             or link.
	   */
	  getChecked: function getChecked(inputProps) {
	    if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.value;
	    }
	    return inputProps.checked;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @param {SyntheticEvent} event change event to handle
	   */
	  executeOnChange: function executeOnChange(inputProps, event) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.requestChange(event.target.value);
	    } else if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.requestChange(event.target.checked);
	    } else if (inputProps.onChange) {
	      return inputProps.onChange.call(undefined, event);
	    }
	  }
	};
	
	module.exports = LinkedValueUtils;

/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(12);
	
	var invariant = __webpack_require__(5);
	
	var injected = false;
	
	var ReactComponentEnvironment = {
	  /**
	   * Optionally injectable hook for swapping out mount images in the middle of
	   * the tree.
	   */
	  replaceNodeWithMarkup: null,
	
	  /**
	   * Optionally injectable hook for processing a queue of child updates. Will
	   * later move into MultiChildComponents.
	   */
	  processChildrenUpdates: null,
	
	  injection: {
	    injectEnvironment: function injectEnvironment(environment) {
	      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
	      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
	      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
	      injected = true;
	    }
	  }
	};
	
	module.exports = ReactComponentEnvironment;

/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var caughtError = null;
	
	/**
	 * Call a function while guarding against errors that happens within it.
	 *
	 * @param {String} name of the guard to use for logging or debugging
	 * @param {Function} func The function to invoke
	 * @param {*} a First argument
	 * @param {*} b Second argument
	 */
	function invokeGuardedCallback(name, func, a) {
	  try {
	    func(a);
	  } catch (x) {
	    if (caughtError === null) {
	      caughtError = x;
	    }
	  }
	}
	
	var ReactErrorUtils = {
	  invokeGuardedCallback: invokeGuardedCallback,
	
	  /**
	   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
	   * handler are sure to be rethrown by rethrowCaughtError.
	   */
	  invokeGuardedCallbackWithCatch: invokeGuardedCallback,
	
	  /**
	   * During execution of guarded functions we will capture the first error which
	   * we will rethrow to be handled by the top level error handler.
	   */
	  rethrowCaughtError: function rethrowCaughtError() {
	    if (caughtError) {
	      var error = caughtError;
	      caughtError = null;
	      throw error;
	    }
	  }
	};
	
	if (false) {
	  /**
	   * To help development we can get better devtools integration by simulating a
	   * real browser event.
	   */
	  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
	    var fakeNode = document.createElement('react');
	    ReactErrorUtils.invokeGuardedCallback = function (name, func, a) {
	      var boundFunc = func.bind(null, a);
	      var evtType = 'react-' + name;
	      fakeNode.addEventListener(evtType, boundFunc, false);
	      var evt = document.createEvent('Event');
	      evt.initEvent(evtType, false, false);
	      fakeNode.dispatchEvent(evt);
	      fakeNode.removeEventListener(evtType, boundFunc, false);
	    };
	  }
	}
	
	module.exports = ReactErrorUtils;

/***/ },
/* 173 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _prodInvariant = __webpack_require__(12);
	
	var ReactCurrentOwner = __webpack_require__(57);
	var ReactInstanceMap = __webpack_require__(97);
	var ReactInstrumentation = __webpack_require__(46);
	var ReactUpdates = __webpack_require__(53);
	
	var invariant = __webpack_require__(5);
	var warning = __webpack_require__(9);
	
	function enqueueUpdate(internalInstance) {
	  ReactUpdates.enqueueUpdate(internalInstance);
	}
	
	function formatUnexpectedArgument(arg) {
	  var type = typeof arg === 'undefined' ? 'undefined' : _typeof(arg);
	  if (type !== 'object') {
	    return type;
	  }
	  var displayName = arg.constructor && arg.constructor.name || type;
	  var keys = Object.keys(arg);
	  if (keys.length > 0 && keys.length < 20) {
	    return displayName + ' (keys: ' + keys.join(', ') + ')';
	  }
	  return displayName;
	}
	
	function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
	  var internalInstance = ReactInstanceMap.get(publicInstance);
	  if (!internalInstance) {
	    if (false) {
	      var ctor = publicInstance.constructor;
	      // Only warn when we have a callerName. Otherwise we should be silent.
	      // We're probably calling from enqueueCallback. We don't want to warn
	      // there because we already warned for the corresponding lifecycle method.
	      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
	    }
	    return null;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + "within `render` or another component's constructor). Render methods " + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
	  }
	
	  return internalInstance;
	}
	
	/**
	 * ReactUpdateQueue allows for state updates to be scheduled into a later
	 * reconciliation step.
	 */
	var ReactUpdateQueue = {
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function isMounted(publicInstance) {
	    if (false) {
	      var owner = ReactCurrentOwner.current;
	      if (owner !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	        owner._warnedAboutRefsInRender = true;
	      }
	    }
	    var internalInstance = ReactInstanceMap.get(publicInstance);
	    if (internalInstance) {
	      // During componentWillMount and render this will still be null but after
	      // that will always render to something. At least for now. So we can use
	      // this hack.
	      return !!internalInstance._renderedComponent;
	    } else {
	      return false;
	    }
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @param {string} callerName Name of the calling function in the public API.
	   * @internal
	   */
	  enqueueCallback: function enqueueCallback(publicInstance, callback, callerName) {
	    ReactUpdateQueue.validateCallback(callback, callerName);
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);
	
	    // Previously we would throw an error if we didn't have an internal
	    // instance. Since we want to make it a no-op instead, we mirror the same
	    // behavior we have in other enqueue* methods.
	    // We also need to ignore callbacks in componentWillMount. See
	    // enqueueUpdates.
	    if (!internalInstance) {
	      return null;
	    }
	
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    // TODO: The callback here is ignored when setState is called from
	    // componentWillMount. Either fix it or disallow doing so completely in
	    // favor of getInitialState. Alternatively, we can disallow
	    // componentWillMount during server-side rendering.
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueCallbackInternal: function enqueueCallbackInternal(internalInstance, callback) {
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function enqueueForceUpdate(publicInstance) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingForceUpdate = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function enqueueReplaceState(publicInstance, completeState, callback) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingStateQueue = [completeState];
	    internalInstance._pendingReplaceState = true;
	
	    // Future-proof 15.5
	    if (callback !== undefined && callback !== null) {
	      ReactUpdateQueue.validateCallback(callback, 'replaceState');
	      if (internalInstance._pendingCallbacks) {
	        internalInstance._pendingCallbacks.push(callback);
	      } else {
	        internalInstance._pendingCallbacks = [callback];
	      }
	    }
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function enqueueSetState(publicInstance, partialState) {
	    if (false) {
	      ReactInstrumentation.debugTool.onSetState();
	      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
	    }
	
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
	    queue.push(partialState);
	
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueElementInternal: function enqueueElementInternal(internalInstance, nextElement, nextContext) {
	    internalInstance._pendingElement = nextElement;
	    // TODO: introduce _pendingContext instead of setting it directly.
	    internalInstance._context = nextContext;
	    enqueueUpdate(internalInstance);
	  },
	
	  validateCallback: function validateCallback(callback, callerName) {
	    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
	  }
	};
	
	module.exports = ReactUpdateQueue;

/***/ },
/* 174 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/* globals MSApp */
	
	'use strict';
	
	/**
	 * Create a function which has 'unsafe' privileges (required by windows8 apps)
	 */
	
	var createMicrosoftUnsafeLocalFunction = function createMicrosoftUnsafeLocalFunction(func) {
	  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
	    return function (arg0, arg1, arg2, arg3) {
	      MSApp.execUnsafeLocalFunction(function () {
	        return func(arg0, arg1, arg2, arg3);
	      });
	    };
	  } else {
	    return func;
	  }
	};
	
	module.exports = createMicrosoftUnsafeLocalFunction;

/***/ },
/* 175 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * `charCode` represents the actual "character code" and is safe to use with
	 * `String.fromCharCode`. As such, only keys that correspond to printable
	 * characters produce a valid `charCode`, the only exception to this is Enter.
	 * The Tab-key is considered non-printable and does not have a `charCode`,
	 * presumably because it does not produce a tab-character in browsers.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {number} Normalized `charCode` property.
	 */
	
	function getEventCharCode(nativeEvent) {
	  var charCode;
	  var keyCode = nativeEvent.keyCode;
	
	  if ('charCode' in nativeEvent) {
	    charCode = nativeEvent.charCode;
	
	    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
	    if (charCode === 0 && keyCode === 13) {
	      charCode = 13;
	    }
	  } else {
	    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
	    charCode = keyCode;
	  }
	
	  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
	  // Must not discard the (non-)printable Enter-key.
	  if (charCode >= 32 || charCode === 13) {
	    return charCode;
	  }
	
	  return 0;
	}
	
	module.exports = getEventCharCode;

/***/ },
/* 176 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Translation from modifier key to the associated property in the event.
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
	 */
	
	var modifierKeyToProp = {
	  Alt: 'altKey',
	  Control: 'ctrlKey',
	  Meta: 'metaKey',
	  Shift: 'shiftKey'
	};
	
	// IE8 does not implement getModifierState so we simply map it to the only
	// modifier keys exposed by the event itself, does not support Lock-keys.
	// Currently, all major browsers except Chrome seems to support Lock-keys.
	function modifierStateGetter(keyArg) {
	  var syntheticEvent = this;
	  var nativeEvent = syntheticEvent.nativeEvent;
	  if (nativeEvent.getModifierState) {
	    return nativeEvent.getModifierState(keyArg);
	  }
	  var keyProp = modifierKeyToProp[keyArg];
	  return keyProp ? !!nativeEvent[keyProp] : false;
	}
	
	function getEventModifierState(nativeEvent) {
	  return modifierStateGetter;
	}
	
	module.exports = getEventModifierState;

/***/ },
/* 177 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Gets the target node from a native browser event by accounting for
	 * inconsistencies in browser DOM APIs.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {DOMEventTarget} Target node.
	 */
	
	function getEventTarget(nativeEvent) {
	  var target = nativeEvent.target || nativeEvent.srcElement || window;
	
	  // Normalize SVG <use> element events #4963
	  if (target.correspondingUseElement) {
	    target = target.correspondingUseElement;
	  }
	
	  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
	  // @see http://www.quirksmode.org/js/events_properties.html
	  return target.nodeType === 3 ? target.parentNode : target;
	}
	
	module.exports = getEventTarget;

/***/ },
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(32);
	
	var useHasFeature;
	if (ExecutionEnvironment.canUseDOM) {
	  useHasFeature = document.implementation && document.implementation.hasFeature &&
	  // always returns true in newer browsers as per the standard.
	  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
	  document.implementation.hasFeature('', '') !== true;
	}
	
	/**
	 * Checks if an event is supported in the current execution environment.
	 *
	 * NOTE: This will not work correctly for non-generic events such as `change`,
	 * `reset`, `load`, `error`, and `select`.
	 *
	 * Borrows from Modernizr.
	 *
	 * @param {string} eventNameSuffix Event name, e.g. "click".
	 * @param {?boolean} capture Check if the capture phase is supported.
	 * @return {boolean} True if the event is supported.
	 * @internal
	 * @license Modernizr 3.0.0pre (Custom Build) | MIT
	 */
	function isEventSupported(eventNameSuffix, capture) {
	  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
	    return false;
	  }
	
	  var eventName = 'on' + eventNameSuffix;
	  var isSupported = eventName in document;
	
	  if (!isSupported) {
	    var element = document.createElement('div');
	    element.setAttribute(eventName, 'return;');
	    isSupported = typeof element[eventName] === 'function';
	  }
	
	  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
	    // This is the only way to test support for the `wheel` event in IE9+.
	    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
	  }
	
	  return isSupported;
	}
	
	module.exports = isEventSupported;

/***/ },
/* 179 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given a `prevElement` and `nextElement`, determines if the existing
	 * instance should be updated as opposed to being destroyed or replaced by a new
	 * instance. Both arguments are elements. This ensures that this logic can
	 * operate on stateless trees without any backing instance.
	 *
	 * @param {?object} prevElement
	 * @param {?object} nextElement
	 * @return {boolean} True if the existing instance should be updated.
	 * @protected
	 */
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function shouldUpdateReactComponent(prevElement, nextElement) {
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	  if (prevEmpty || nextEmpty) {
	    return prevEmpty === nextEmpty;
	  }
	
	  var prevType = typeof prevElement === 'undefined' ? 'undefined' : _typeof(prevElement);
	  var nextType = typeof nextElement === 'undefined' ? 'undefined' : _typeof(nextElement);
	  if (prevType === 'string' || prevType === 'number') {
	    return nextType === 'string' || nextType === 'number';
	  } else {
	    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
	  }
	}
	
	module.exports = shouldUpdateReactComponent;

/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(11);
	
	var emptyFunction = __webpack_require__(41);
	var warning = __webpack_require__(9);
	
	var validateDOMNesting = emptyFunction;
	
	if (false) {
	  // This validation code was written based on the HTML5 parsing spec:
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  //
	  // Note: this does not catch all invalid nesting, nor does it try to (as it's
	  // not clear what practical benefit doing so provides); instead, we warn only
	  // for cases where the parser will give a parse tree differing from what React
	  // intended. For example, <b><div></div></b> is invalid but we don't warn
	  // because it still parses correctly; we do warn for other cases like nested
	  // <p> tags where the beginning of the second element implicitly closes the
	  // first, causing a confusing mess.
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#special
	  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
	  // TODO: Distinguish by namespace here -- for <title>, including it here
	  // errs on the side of fewer warnings
	  'foreignObject', 'desc', 'title'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
	  var buttonScopeTags = inScopeTags.concat(['button']);
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
	  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];
	
	  var emptyAncestorInfo = {
	    current: null,
	
	    formTag: null,
	    aTagInScope: null,
	    buttonTagInScope: null,
	    nobrTagInScope: null,
	    pTagInButtonScope: null,
	
	    listItemTagAutoclosing: null,
	    dlItemTagAutoclosing: null
	  };
	
	  var updatedAncestorInfo = function updatedAncestorInfo(oldInfo, tag, instance) {
	    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
	    var info = { tag: tag, instance: instance };
	
	    if (inScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.aTagInScope = null;
	      ancestorInfo.buttonTagInScope = null;
	      ancestorInfo.nobrTagInScope = null;
	    }
	    if (buttonScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.pTagInButtonScope = null;
	    }
	
	    // See rules for 'li', 'dd', 'dt' start tags in
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
	      ancestorInfo.listItemTagAutoclosing = null;
	      ancestorInfo.dlItemTagAutoclosing = null;
	    }
	
	    ancestorInfo.current = info;
	
	    if (tag === 'form') {
	      ancestorInfo.formTag = info;
	    }
	    if (tag === 'a') {
	      ancestorInfo.aTagInScope = info;
	    }
	    if (tag === 'button') {
	      ancestorInfo.buttonTagInScope = info;
	    }
	    if (tag === 'nobr') {
	      ancestorInfo.nobrTagInScope = info;
	    }
	    if (tag === 'p') {
	      ancestorInfo.pTagInButtonScope = info;
	    }
	    if (tag === 'li') {
	      ancestorInfo.listItemTagAutoclosing = info;
	    }
	    if (tag === 'dd' || tag === 'dt') {
	      ancestorInfo.dlItemTagAutoclosing = info;
	    }
	
	    return ancestorInfo;
	  };
	
	  /**
	   * Returns whether
	   */
	  var isTagValidWithParent = function isTagValidWithParent(tag, parentTag) {
	    // First, let's check if we're in an unusual parsing mode...
	    switch (parentTag) {
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
	      case 'select':
	        return tag === 'option' || tag === 'optgroup' || tag === '#text';
	      case 'optgroup':
	        return tag === 'option' || tag === '#text';
	      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
	      // but
	      case 'option':
	        return tag === '#text';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
	      // No special behavior since these rules fall back to "in body" mode for
	      // all except special table nodes which cause bad parsing behavior anyway.
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
	      case 'tr':
	        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
	      case 'tbody':
	      case 'thead':
	      case 'tfoot':
	        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
	      case 'colgroup':
	        return tag === 'col' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
	      case 'table':
	        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
	      case 'head':
	        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
	      case 'html':
	        return tag === 'head' || tag === 'body';
	      case '#document':
	        return tag === 'html';
	    }
	
	    // Probably in the "in body" parsing mode, so we outlaw only tag combos
	    // where the parsing rules cause implicit opens or closes to be added.
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    switch (tag) {
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';
	
	      case 'rp':
	      case 'rt':
	        return impliedEndTags.indexOf(parentTag) === -1;
	
	      case 'body':
	      case 'caption':
	      case 'col':
	      case 'colgroup':
	      case 'frame':
	      case 'head':
	      case 'html':
	      case 'tbody':
	      case 'td':
	      case 'tfoot':
	      case 'th':
	      case 'thead':
	      case 'tr':
	        // These tags are only valid with a few parents that have special child
	        // parsing rules -- if we're down here, then none of those matched and
	        // so we allow it only if we don't know what the parent is, as all other
	        // cases are invalid.
	        return parentTag == null;
	    }
	
	    return true;
	  };
	
	  /**
	   * Returns whether
	   */
	  var findInvalidAncestorForTag = function findInvalidAncestorForTag(tag, ancestorInfo) {
	    switch (tag) {
	      case 'address':
	      case 'article':
	      case 'aside':
	      case 'blockquote':
	      case 'center':
	      case 'details':
	      case 'dialog':
	      case 'dir':
	      case 'div':
	      case 'dl':
	      case 'fieldset':
	      case 'figcaption':
	      case 'figure':
	      case 'footer':
	      case 'header':
	      case 'hgroup':
	      case 'main':
	      case 'menu':
	      case 'nav':
	      case 'ol':
	      case 'p':
	      case 'section':
	      case 'summary':
	      case 'ul':
	      case 'pre':
	      case 'listing':
	      case 'table':
	      case 'hr':
	      case 'xmp':
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return ancestorInfo.pTagInButtonScope;
	
	      case 'form':
	        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
	
	      case 'li':
	        return ancestorInfo.listItemTagAutoclosing;
	
	      case 'dd':
	      case 'dt':
	        return ancestorInfo.dlItemTagAutoclosing;
	
	      case 'button':
	        return ancestorInfo.buttonTagInScope;
	
	      case 'a':
	        // Spec says something about storing a list of markers, but it sounds
	        // equivalent to this check.
	        return ancestorInfo.aTagInScope;
	
	      case 'nobr':
	        return ancestorInfo.nobrTagInScope;
	    }
	
	    return null;
	  };
	
	  /**
	   * Given a ReactCompositeComponent instance, return a list of its recursive
	   * owners, starting at the root and ending with the instance itself.
	   */
	  var findOwnerStack = function findOwnerStack(instance) {
	    if (!instance) {
	      return [];
	    }
	
	    var stack = [];
	    do {
	      stack.push(instance);
	    } while (instance = instance._currentElement._owner);
	    stack.reverse();
	    return stack;
	  };
	
	  var didWarn = {};
	
	  validateDOMNesting = function validateDOMNesting(childTag, childText, childInstance, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	
	    if (childText != null) {
	      process.env.NODE_ENV !== 'production' ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
	      childTag = '#text';
	    }
	
	    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
	    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
	    var problematic = invalidParent || invalidAncestor;
	
	    if (problematic) {
	      var ancestorTag = problematic.tag;
	      var ancestorInstance = problematic.instance;
	
	      var childOwner = childInstance && childInstance._currentElement._owner;
	      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;
	
	      var childOwners = findOwnerStack(childOwner);
	      var ancestorOwners = findOwnerStack(ancestorOwner);
	
	      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
	      var i;
	
	      var deepestCommon = -1;
	      for (i = 0; i < minStackLen; i++) {
	        if (childOwners[i] === ancestorOwners[i]) {
	          deepestCommon = i;
	        } else {
	          break;
	        }
	      }
	
	      var UNKNOWN = '(unknown)';
	      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ownerInfo = [].concat(
	      // If the parent and child instances have a common owner ancestor, start
	      // with that -- otherwise we just start with the parent's owners.
	      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
	      // If we're warning about an invalid (non-parent) ancestry, add '...'
	      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');
	
	      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
	      if (didWarn[warnKey]) {
	        return;
	      }
	      didWarn[warnKey] = true;
	
	      var tagDisplayName = childTag;
	      var whitespaceInfo = '';
	      if (childTag === '#text') {
	        if (/\S/.test(childText)) {
	          tagDisplayName = 'Text nodes';
	        } else {
	          tagDisplayName = 'Whitespace text nodes';
	          whitespaceInfo = " Make sure you don't have any extra whitespace between tags on " + 'each line of your source code.';
	        }
	      } else {
	        tagDisplayName = '<' + childTag + '>';
	      }
	
	      if (invalidParent) {
	        var info = '';
	        if (ancestorTag === 'table' && childTag === 'tr') {
	          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
	        }
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
	      } else {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
	      }
	    }
	  };
	
	  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;
	
	  // For testing
	  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
	  };
	}
	
	module.exports = validateDOMNesting;

/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	  };
	}();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _VstComponent2 = __webpack_require__(13);
	
	var _VstComponent3 = _interopRequireDefault(_VstComponent2);
	
	var _addClassName = __webpack_require__(64);
	
	var _addClassName2 = _interopRequireDefault(_addClassName);
	
	var _copyProps = __webpack_require__(42);
	
	var _copyProps2 = _interopRequireDefault(_copyProps);
	
	var _classnames = __webpack_require__(25);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _namespaceOptions = __webpack_require__(76);
	
	var _namespaceOptions2 = _interopRequireDefault(_namespaceOptions);
	
	var _glamor = __webpack_require__(94);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var VstButton = function (_VstComponent) {
	  _inherits(VstButton, _VstComponent);
	
	  function VstButton() {
	    _classCallCheck(this, VstButton);
	
	    return _possibleConstructorReturn(this, (VstButton.__proto__ || Object.getPrototypeOf(VstButton)).apply(this, arguments));
	  }
	
	  _createClass(VstButton, [{
	    key: '_getCSS',
	    value: function _getCSS() {
	      return {
	        backgroundColor: this._theme(7),
	        borderColor: this._theme(7),
	        ':hover': {
	          backgroundColor: this._theme(8),
	          borderColor: this._theme(8)
	        }
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var rule = (0, _glamor.css)(this._getCSS());
	
	      var props = (0, _addClassName2.default)(this.props, (0, _classnames2.default)((0, _namespaceOptions2.default)('vst', this.props.options), 'vst-button', rule.toString()));
	      props = (0, _copyProps2.default)(props, ['options']);
	
	      return _react2.default.createElement('button', props, this.props.children);
	    }
	  }]);
	
	  return VstButton;
	}(_VstComponent3.default);
	
	module.exports = VstButton;

/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	  };
	}();
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }return target;
	};
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _VstComponent2 = __webpack_require__(13);
	
	var _VstComponent3 = _interopRequireDefault(_VstComponent2);
	
	var _propTypes = __webpack_require__(29);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(25);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _copyProps = __webpack_require__(42);
	
	var _copyProps2 = _interopRequireDefault(_copyProps);
	
	var _namespaceOptions = __webpack_require__(76);
	
	var _namespaceOptions2 = _interopRequireDefault(_namespaceOptions);
	
	var _addClassName = __webpack_require__(64);
	
	var _addClassName2 = _interopRequireDefault(_addClassName);
	
	var _glamor = __webpack_require__(94);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var iIcon = function iIcon(props) {
	  return _react2.default.createElement('svg', _extends({
	    xmlns: 'http://www.w3.org/2000/svg',
	    width: '12',
	    height: '12',
	    viewBox: '0 0 12 12'
	  }, props), _react2.default.createElement('path', {
	    fill: '#777',
	    className: 'st0',
	    d: 'M6 .9c2.8 0 5.1 2.3 5.1 5.1S8.8 11.1 6 11.1.9 8.8.9 6 3.2.9 6 .9M6 0C2.7 0 0 2.7 0 6s2.7 6 6 6 6-2.7 6-6-2.7-6-6-6z'
	  }), _react2.default.createElement('path', {
	    fill: '#777',
	    className: 'st0',
	    d: 'M4.8 9.3c.2 0 .3-.1.4-.1 0-.1.1-.2.1-.5V5.6c0-.2 0-.4-.1-.4-.1-.1-.2-.1-.4-.1v-.3h2v4c0 .2 0 .4.1.4.1.1.2.1.4.2v.2H4.8v-.3zm.7-6.7c.1-.1.3-.2.5-.2s.4.1.6.2c.1.2.2.4.2.6s-.1.4-.2.6c-.2.1-.4.2-.6.2-.2 0-.4-.1-.5-.2-.2-.2-.3-.4-.3-.6 0-.2.1-.4.3-.6z'
	  }));
	};
	
	var errorIcon = function errorIcon(props) {
	  return _react2.default.createElement('svg', _extends({
	    xmlns: 'http://www.w3.org/2000/svg',
	    width: '14',
	    height: '14',
	    viewBox: '0 0 14 14'
	  }, props), _react2.default.createElement('circle', {
	    className: 'st0',
	    cx: '7',
	    cy: '7',
	    r: '7',
	    fill: '#F54250'
	  }), _react2.default.createElement('path', {
	    fill: '#FFF',
	    d: 'M6 3h2v4H6zM6 9h2v2H6z'
	  }));
	};
	
	var VstInput = function (_VstComponent) {
	  _inherits(VstInput, _VstComponent);
	
	  function VstInput() {
	    _classCallCheck(this, VstInput);
	
	    return _possibleConstructorReturn(this, (VstInput.__proto__ || Object.getPrototypeOf(VstInput)).apply(this, arguments));
	  }
	
	  _createClass(VstInput, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.renderTooltip = this.renderTooltip.bind(this);
	      this._isCheckboxOrRadio = this._isCheckboxOrRadio.bind(this);
	    }
	  }, {
	    key: '_preventDefault',
	    value: function _preventDefault(e) {
	      e.preventDefault();
	    }
	  }, {
	    key: '_isCheckboxOrRadio',
	    value: function _isCheckboxOrRadio() {
	      return this.props.type === 'checkbox' || this.props.type === 'radio';
	    }
	  }, {
	    key: '_getCSS',
	    value: function _getCSS() {
	      return {
	        '&:focus': {
	          borderColor: this._theme(6)
	        },
	        '&[type="submit"]': {
	          backgroundColor: this._theme(7),
	          ':hover': {
	            backgroundColor: this._theme(8)
	          }
	        }
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var theme = (0, _glamor.css)(this._getCSS());
	      var failureId = this.props.id + '-failure';
	
	      var props = (0, _addClassName2.default)(this.props, (0, _classnames2.default)('vst-input', (0, _namespaceOptions2.default)('vst', this.props.options), { failure: this.props.failure }, theme.toString()));
	      props = (0, _copyProps2.default)(props, ['failure', 'tooltip', 'tooltipConf', 'options', 'label', 'ignoreLabel']);
	      return _react2.default.createElement('div', { className: (0, _classnames2.default)('vst-form-group', 'vst-form-group-' + this.props.type, (0, _namespaceOptions2.default)('vst-form-group', this.props.options)) }, !this._isCheckboxOrRadio() && this.renderLabel(), this.renderTooltip(), _react2.default.createElement('input', _extends({ 'aria-required': this.props.required, 'aria-describedby': failureId, 'aria-invalid': !!this.props.failure }, props)), this._isCheckboxOrRadio() && this.renderLabel(), this.renderFailure(failureId));
	    }
	  }, {
	    key: 'renderLabel',
	    value: function renderLabel() {
	      if (this.props.type !== 'submit' && !this.props.ignoreLabel) {
	        return _react2.default.createElement('label', { className: 'vst-label vst-label-' + this.props.type, htmlFor: this.props.id }, _react2.default.createElement('span', { style: this.props.hideLabel ? {
	            // https://webaim.org/techniques/css/invisiblecontent/#absolutepositioning
	            position: 'absolute',
	            left: '-10000px',
	            top: 'auto',
	            width: '1px',
	            height: '1px',
	            overflow: 'hidden'
	          } : {}
	        }, this.props.label), this.props.failure && this._isCheckboxOrRadio() && _react2.default.createElement('span', { className: 'vst-label-icon' }, errorIcon()));
	      }
	      return null;
	    }
	  }, {
	    key: 'renderFailure',
	    value: function renderFailure(failureId) {
	      if (this.props.failure) {
	        return _react2.default.createElement('div', { id: failureId, role: 'alert', className: (0, _classnames2.default)('vst-failure-message', { visible: this.props.failure }) }, this.props.failure);
	      }
	      return null;
	    }
	  }, {
	    key: 'renderTooltip',
	    value: function renderTooltip() {
	      if (this.props.tooltip) {
	        return _react2.default.createElement('span', { className: 'vst-label-icon',
	          onMouseOver: this._preventDefault,
	          'data-vst-tooltip-conf': this.props.tooltipConf,
	          'data-vst-tooltip': this.props.tooltip
	        }, iIcon());
	      }
	      return null;
	    }
	  }]);
	
	  return VstInput;
	}(_VstComponent3.default);
	
	exports.default = VstInput;
	
	VstInput.propTypes = {
	  id: _propTypes2.default.string.isRequired,
	  ignoreLabel: _propTypes2.default.bool,
	  label: _propTypes2.default.string,
	  tooltipConf: _propTypes2.default.string,
	  failure: _propTypes2.default.node,
	  type: _propTypes2.default.string,
	  checkLabel: function checkLabel(props) {
	    var isValid = props.ignoreLabel || props.label;
	    return !isValid && new Error('VstInput requires a label');
	  },
	  hideLabel: _propTypes2.default.bool
	};
	
	VstInput.defaultProps = {
	  tooltipConf: 'multiline',
	  type: 'text'
	};

/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	Object.defineProperty(exports, '__esModule', { value: !0 });var _Card = __webpack_require__(405);Object.defineProperty(exports, 'default', { enumerable: !0, get: function get() {
	    return _interopRequireDefault(_Card).default;
	  } });function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}

/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	Object.defineProperty(exports, '__esModule', { value: !0 });var _themes = __webpack_require__(4),
	    getBackgroundImage = function getBackgroundImage(color) {
	  var encodedColor = encodeURIComponent(color);return 'url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 14 14\'%3E%3Cpath fill=\'' + encodedColor + '\' d=\'M8 6a1 1 0 1 1-2 0V4a1 1 0 1 1 2 0v2zm-1 5a1 1 0 1 1 0-2 1 1 0 1 1 0 2zM7 0a7 7 0 1 0 0 14A7 7 0 0 0 7 0z\' /%3E%3C/svg%3E%0A")';
	},
	    componentTheme = function componentTheme(baseTheme) {
	  var _baseTheme$vstui = baseTheme.vstui,
	      color = _baseTheme$vstui.color,
	      shape = _baseTheme$vstui.shape,
	      size = _baseTheme$vstui.size,
	      typography = _baseTheme$vstui.typography,
	      primaryMain = color.primary.getMainShade(),
	      secondaryMain = color.secondary.getMainShade(),
	      primary3 = color.primary.getShade(3),
	      secondary3 = color.secondary.getShade(3),
	      black20 = 'rgba(0, 0, 0, 0.20)',
	      black43 = 'rgba(0, 0, 0, 0.43)',
	      backgroundImage = getBackgroundImage(color.transparent),
	      backgroundImage_invalid = getBackgroundImage(color.error),
	      backgroundImage_invalidFocus = getBackgroundImage(color.error),
	      highlight_invalid = '#ffb7bd';return (0, _themes.createComponentTheme)(baseTheme, { CheckboxControl_width: '270px', CheckboxControl_minHeight_small: size.small, CheckboxControl_minHeight_medium: size.medium, CheckboxControl_minHeight_large: size.large, CheckboxIcon_backgroundColor_primary: color.white, CheckboxIcon_backgroundColor_primary_invalid: color.white, CheckboxIcon_backgroundColor_primary_disabled: color.white, CheckboxIcon_backgroundColor_primary_focus: color.white, CheckboxIcon_backgroundColor_primary_invalidFocus: color.white, CheckboxIcon_backgroundColor_primary_checked: primaryMain, CheckboxIcon_backgroundColor_primary_checkedInvalid: color.error, CheckboxIcon_backgroundColor_primary_checkedDisabled: black20, CheckboxIcon_backgroundColor_primary_checkedFocus: primaryMain, CheckboxIcon_backgroundColor_primary_checkedInvalidFocus: color.error, CheckboxIcon_backgroundColor_secondary: color.white, CheckboxIcon_backgroundColor_secondary_invalid: color.white, CheckboxIcon_backgroundColor_secondary_disabled: color.white, CheckboxIcon_backgroundColor_secondary_focus: color.white, CheckboxIcon_backgroundColor_secondary_invalidFocus: color.white, CheckboxIcon_backgroundColor_secondary_checked: secondaryMain, CheckboxIcon_backgroundColor_secondary_checkedInvalid: color.error, CheckboxIcon_backgroundColor_secondary_checkedDisabled: black20, CheckboxIcon_backgroundColor_secondary_checkedFocus: secondaryMain, CheckboxIcon_backgroundColor_secondary_checkedInvalidFocus: color.error, CheckboxControl_backgroundImage: backgroundImage, CheckboxControl_backgroundImage_invalid: backgroundImage_invalid, CheckboxControl_backgroundImage_invalidFocus: backgroundImage_invalidFocus, CheckboxControl_backgroundPosition_small: 'right 12px top ' + (size.small - 2 - 14) / 2 + 'px', CheckboxControl_backgroundPosition_medium: 'right 12px top ' + (size.medium - 2 - 14) / 2 + 'px', CheckboxControl_backgroundPosition_large: 'right 14px top ' + (size.large - 2 - 14) / 2 + 'px', CheckboxControl_backgroundSize: '14px 14px', CheckboxIcon_borderColor_primary: black43, CheckboxIcon_borderColor_primary_invalid: color.error, CheckboxIcon_borderColor_primary_disabled: black20, CheckboxIcon_borderColor_primary_focus: color.onSurface, CheckboxIcon_borderColor_primary_invalidFocus: color.onSurface, CheckboxIcon_borderColor_primary_checked: primaryMain, CheckboxIcon_borderColor_primary_checkedInvalid: color.error, CheckboxIcon_borderColor_primary_checkedDisabled: black20, CheckboxIcon_borderColor_primary_checkedFocus: color.onSurface, CheckboxIcon_borderColor_primary_checkedInvalidFocus: color.onSurface, CheckboxIcon_borderColor_secondary: black43, CheckboxIcon_borderColor_secondary_invalid: color.error, CheckboxIcon_borderColor_secondary_disabled: black20, CheckboxIcon_borderColor_secondary_focus: color.onSurface, CheckboxIcon_borderColor_secondary_invalidFocus: color.onSurface, CheckboxIcon_borderColor_secondary_checked: secondaryMain, CheckboxIcon_borderColor_secondary_checkedInvalid: color.error, CheckboxIcon_borderColor_secondary_checkedDisabled: black20, CheckboxIcon_borderColor_secondary_checkedFocus: color.onSurface, CheckboxIcon_borderColor_secondary_checkedInvalidFocus: color.onSurface, CheckboxIcon_color_primary_checked: color.white, CheckboxIcon_color_primary_checkedInvalid: color.white, CheckboxIcon_color_primary_checkedDisabled: color.white, CheckboxIcon_color_primary_checkedFocus: color.white, CheckboxIcon_color_primary_checkedInvalidFocus: color.white, CheckboxIcon_color_secondary_checked: color.white, CheckboxIcon_color_secondary_checkedInvalid: color.white, CheckboxIcon_color_secondary_checkedDisabled: color.white, CheckboxIcon_color_secondary_checkedFocus: color.white, CheckboxIcon_color_secondary_checkedInvalidFocus: color.white, CheckboxControl_fontFamily: typography.fontFamily, CheckboxControl_fontSize_small: typography.fontSize, CheckboxControl_fontSize_medium: typography.fontSize, CheckboxControl_fontSize_large: typography.fontSize, CheckboxControl_fontWeight: typography.fontWeightRegular, CheckboxIconHighlight_backgroundColor_primary: color.transparent, CheckboxIconHighlight_backgroundColor_primary_invalid: color.transparent, CheckboxIconHighlight_backgroundColor_primary_disabled: color.transparent, CheckboxIconHighlight_backgroundColor_primary_focus: primary3, CheckboxIconHighlight_backgroundColor_primary_invalidFocus: highlight_invalid, CheckboxIconHighlight_backgroundColor_primary_checked: color.transparent, CheckboxIconHighlight_backgroundColor_primary_checkedInvalid: highlight_invalid, CheckboxIconHighlight_backgroundColor_primary_checkedDisabled: color.transparent, CheckboxIconHighlight_backgroundColor_primary_checkedFocus: primary3, CheckboxIconHighlight_backgroundColor_primary_checkedInvalidFocus: highlight_invalid, CheckboxIconHighlight_backgroundColor_secondary: color.transparent, CheckboxIconHighlight_backgroundColor_secondary_invalid: color.transparent, CheckboxIconHighlight_backgroundColor_secondary_disabled: color.transparent, CheckboxIconHighlight_backgroundColor_secondary_focus: secondary3, CheckboxIconHighlight_backgroundColor_secondary_invalidFocus: highlight_invalid, CheckboxIconHighlight_backgroundColor_secondary_checked: color.transparent, CheckboxIconHighlight_backgroundColor_secondary_checkedInvalid: color.transparent, CheckboxIconHighlight_backgroundColor_secondary_checkedDisabled: color.transparent, CheckboxIconHighlight_backgroundColor_secondary_checkedFocus: secondary3, CheckboxIconHighlight_backgroundColor_secondary_checkedInvalidFocus: highlight_invalid, CheckboxContainer_backgroundColor: color.white, CheckboxContainer_borderColor: black43, CheckboxContainer_borderStyle: shape.borderStyle, CheckboxContainer_borderWidth: shape.borderWidth, CheckboxContainer_borderRadius: shape.borderRadius });
	};exports.default = componentTheme;

/***/ },
/* 185 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	Object.defineProperty(exports, '__esModule', { value: !0 });var _Label = __webpack_require__(427);Object.defineProperty(exports, 'default', { enumerable: !0, get: function get() {
	    return _interopRequireDefault(_Label).default;
	  } });function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}

/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var descriptor, i = 0; i < props.length; i++) {
	      descriptor = props[i], descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, 'value' in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    return protoProps && defineProperties(Constructor.prototype, protoProps), staticProps && defineProperties(Constructor, staticProps), Constructor;
	  };
	}(),
	    _react = __webpack_require__(3),
	    _react2 = _interopRequireDefault(_react),
	    _propTypes = __webpack_require__(6),
	    _propTypes2 = _interopRequireDefault(_propTypes);Object.defineProperty(exports, '__esModule', { value: !0 });function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
	}function _possibleConstructorReturn(self, call) {
	  if (!self) throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');return call && ('object' == (typeof call === 'undefined' ? 'undefined' : _typeof(call)) || 'function' == typeof call) ? call : self;
	}function _inherits(subClass, superClass) {
	  if ('function' != typeof superClass && null !== superClass) throw new TypeError('Super expression must either be null or a function, not ' + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: !1, writable: !0, configurable: !0 } }), superClass && (Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass);
	}var TableBody = function (_PureComponent) {
	  function TableBody() {
	    return _classCallCheck(this, TableBody), _possibleConstructorReturn(this, (TableBody.__proto__ || Object.getPrototypeOf(TableBody)).apply(this, arguments));
	  }return _inherits(TableBody, _PureComponent), _createClass(TableBody, [{ key: 'render', value: function render() {
	      return _react2.default.createElement('tbody', null, this.props.children);
	    } }]), TableBody;
	}(_react.PureComponent);TableBody.propTypes = { children: _propTypes2.default.node }, TableBody.defaultProps = {}, TableBody.displayName = 'TableBody', exports.default = TableBody;

/***/ },
/* 187 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var descriptor, i = 0; i < props.length; i++) {
	      descriptor = props[i], descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, 'value' in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    return protoProps && defineProperties(Constructor.prototype, protoProps), staticProps && defineProperties(Constructor, staticProps), Constructor;
	  };
	}(),
	    _templateObject = _taggedTemplateLiteral(['\n  border-bottom: 1px solid;\n  border-bottom-color: ', ';\n  font-family: ', ';\n  font-weight: ', ';\n  text-align: ', ';\n\n  @media print {\n    border-bottom: 1px solid ', ';\n  }\n'], ['\n  border-bottom: 1px solid;\n  border-bottom-color: ', ';\n  font-family: ', ';\n  font-weight: ', ';\n  text-align: ', ';\n\n  @media print {\n    border-bottom: 1px solid ', ';\n  }\n']),
	    _react = __webpack_require__(3),
	    _react2 = _interopRequireDefault(_react),
	    _propTypes = __webpack_require__(6),
	    _propTypes2 = _interopRequireDefault(_propTypes),
	    _styledComponents = __webpack_require__(15),
	    _styledComponents2 = _interopRequireDefault(_styledComponents),
	    _styles = __webpack_require__(31),
	    _themes = __webpack_require__(4),
	    _propTypes3 = __webpack_require__(16);Object.defineProperty(exports, '__esModule', { value: !0 });function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
	}function _possibleConstructorReturn(self, call) {
	  if (!self) throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');return call && ('object' == (typeof call === 'undefined' ? 'undefined' : _typeof(call)) || 'function' == typeof call) ? call : self;
	}function _inherits(subClass, superClass) {
	  if ('function' != typeof superClass && null !== superClass) throw new TypeError('Super expression must either be null or a function, not ' + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: !1, writable: !0, configurable: !0 } }), superClass && (Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass);
	}function _taggedTemplateLiteral(strings, raw) {
	  return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } }));
	}var Styled = { div: {} },
	    cellStyles = (0, _styles.css)(_templateObject, (0, _themes.getStyle)('TableDataCell_borderColor'), (0, _themes.getStyle)('TableDataCell_fontFamily'), (0, _themes.getStyle)('TableDataCell_fontWeight'), function (props) {
	  return props.numeric ? 'right' : 'left';
	}, function (props) {
	  return props.theme.vstui.color.black;
	});Styled.td = _styledComponents2.default.td.withConfig({ displayName: 'TableDataCell__td' })(['', ';padding:13px 20px;background:', ';color:', ';font-size:', ';line-height:1.36;vertical-align:top;@media print{padding:0 5px;color:', ';font-size:', ';}'], cellStyles, function (props) {
	  return props.sc.rowHover ? props.sc.secondary ? (0, _themes.getStyle)('TableDataCell_backgroundColor_secondary_hover') : (0, _themes.getStyle)('TableDataCell_backgroundColor_primary_hover') : (0, _themes.getStyle)('TableDataCell_backgroundColor');
	}, (0, _themes.getStyle)('TableDataCell_color'), function (props) {
	  return props.theme.vstui.rem((0, _themes.getStyle)('TableDataCell_fontSize')(props));
	}, function (props) {
	  return props.theme.vstui.color.black;
	}, function (props) {
	  return props.theme.vstui.typography.pxToRem(props.theme.vstui.typography.fontSize - 1);
	});var TableDataCell = function (_Component) {
	  function TableDataCell() {
	    return _classCallCheck(this, TableDataCell), _possibleConstructorReturn(this, (TableDataCell.__proto__ || Object.getPrototypeOf(TableDataCell)).apply(this, arguments));
	  }return _inherits(TableDataCell, _Component), _createClass(TableDataCell, [{ key: 'render', value: function render() {
	      var _props = this.props,
	          numeric = _props.numeric,
	          rowHover = _props.rowHover,
	          secondary = _props.secondary,
	          theme = _props.theme;return _react2.default.createElement(Styled.td, { sc: { numeric: numeric, rowHover: rowHover, secondary: secondary }, theme: theme }, this.props.children);
	    } }]), TableDataCell;
	}(_react.Component);TableDataCell.propTypes = { children: _propTypes2.default.node, numeric: _propTypes2.default.bool, rowHover: _propTypes2.default.bool, secondary: _propTypes2.default.bool, theme: _propTypes3.themeShape }, TableDataCell.defaultProps = { theme: (0, _themes.createTheme)() }, TableDataCell.displayName = 'TableDataCell';var TableDataCellWithTheme = (0, _themes.withTheme)(TableDataCell);TableDataCellWithTheme.WrappedComponent = TableDataCell, exports.default = TableDataCellWithTheme;

/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var descriptor, i = 0; i < props.length; i++) {
	      descriptor = props[i], descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, 'value' in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    return protoProps && defineProperties(Constructor.prototype, protoProps), staticProps && defineProperties(Constructor, staticProps), Constructor;
	  };
	}(),
	    _react = __webpack_require__(3),
	    _react2 = _interopRequireDefault(_react),
	    _propTypes = __webpack_require__(6),
	    _propTypes2 = _interopRequireDefault(_propTypes);Object.defineProperty(exports, '__esModule', { value: !0 });function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
	}function _possibleConstructorReturn(self, call) {
	  if (!self) throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');return call && ('object' == (typeof call === 'undefined' ? 'undefined' : _typeof(call)) || 'function' == typeof call) ? call : self;
	}function _inherits(subClass, superClass) {
	  if ('function' != typeof superClass && null !== superClass) throw new TypeError('Super expression must either be null or a function, not ' + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: !1, writable: !0, configurable: !0 } }), superClass && (Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass);
	}var TableHeader = function (_PureComponent) {
	  function TableHeader() {
	    return _classCallCheck(this, TableHeader), _possibleConstructorReturn(this, (TableHeader.__proto__ || Object.getPrototypeOf(TableHeader)).apply(this, arguments));
	  }return _inherits(TableHeader, _PureComponent), _createClass(TableHeader, [{ key: 'render', value: function render() {
	      return _react2.default.createElement('thead', null, this.props.children);
	    } }]), TableHeader;
	}(_react.PureComponent);TableHeader.propTypes = { children: _propTypes2.default.node }, TableHeader.displayName = 'TableHeader', exports.default = TableHeader;

/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) {
	  for (var source, i = 1; i < arguments.length; i++) {
	    for (var key in source = arguments[i], source) {
	      Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
	    }
	  }return target;
	},
	    _createClass = function () {
	  function defineProperties(target, props) {
	    for (var descriptor, i = 0; i < props.length; i++) {
	      descriptor = props[i], descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, 'value' in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    return protoProps && defineProperties(Constructor.prototype, protoProps), staticProps && defineProperties(Constructor, staticProps), Constructor;
	  };
	}(),
	    _templateObject = _taggedTemplateLiteral(['\n  box-sizing: border-box;\n  & *,\n  & *::before,\n  & *::after {\n    box-sizing: inherit;\n  }\n\n  button {\n    cursor: pointer;\n  }\n  button[disabled] {\n    cursor: default;\n  }\n'], ['\n  box-sizing: border-box;\n  & *,\n  & *::before,\n  & *::after {\n    box-sizing: inherit;\n  }\n\n  button {\n    cursor: pointer;\n  }\n  button[disabled] {\n    cursor: default;\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  border-bottom: 1px solid;\n\n  /* This is purposely using the data cell color token. */\n  /* The header border color is used for dividers between cells. */\n  border-bottom-color: ', ';\n\n  font-family: ', ';\n  font-weight: ', ';\n  text-align: ', ';\n\n  /* Hides content, but will still be read by screen readers */\n  ', ';\n\n  /* This should hide the cell, retain dimensions, and still be read\n     by screen readers. */\n  opacity: ', ';\n\n  @media print {\n    border-bottom-color: ', ';\n    opacity: 1;\n  }\n'], ['\n  border-bottom: 1px solid;\n\n  /* This is purposely using the data cell color token. */\n  /* The header border color is used for dividers between cells. */\n  border-bottom-color: ', ';\n\n  font-family: ', ';\n  font-weight: ', ';\n  text-align: ', ';\n\n  /* Hides content, but will still be read by screen readers */\n  ', ';\n\n  /* This should hide the cell, retain dimensions, and still be read\n     by screen readers. */\n  opacity: ', ';\n\n  @media print {\n    border-bottom-color: ', ';\n    opacity: 1;\n  }\n']),
	    _react = __webpack_require__(3),
	    _react2 = _interopRequireDefault(_react),
	    _propTypes = __webpack_require__(6),
	    _propTypes2 = _interopRequireDefault(_propTypes),
	    _styledComponents = __webpack_require__(15),
	    _styledComponents2 = _interopRequireDefault(_styledComponents),
	    _SortIcon = __webpack_require__(442),
	    _SortIcon2 = _interopRequireDefault(_SortIcon),
	    _styles = __webpack_require__(31),
	    _themes = __webpack_require__(4),
	    _propTypes3 = __webpack_require__(16);Object.defineProperty(exports, '__esModule', { value: !0 });function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
	}function _possibleConstructorReturn(self, call) {
	  if (!self) throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');return call && ('object' == (typeof call === 'undefined' ? 'undefined' : _typeof(call)) || 'function' == typeof call) ? call : self;
	}function _inherits(subClass, superClass) {
	  if ('function' != typeof superClass && null !== superClass) throw new TypeError('Super expression must either be null or a function, not ' + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: !1, writable: !0, configurable: !0 } }), superClass && (Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass);
	}function _taggedTemplateLiteral(strings, raw) {
	  return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } }));
	}var Styled = { button: {}, div: {}, span: {} },
	    normalizeStyles = (0, _styles.css)(_templateObject),
	    cellStyles = (0, _styles.css)(_templateObject2, (0, _themes.getStyle)('TableDataCell_borderColor'), (0, _themes.getStyle)('TableHeaderCell_fontFamily'), (0, _themes.getStyle)('TableHeaderCell_fontWeight'), function (props) {
	  return props.sc.numeric ? 'right' : 'left';
	}, function (props) {
	  return props.sc.visuallyHidden ? (0, _styles.visuallyHidden)() : '';
	}, function (props) {
	  return props.sc.visuallyHiddenRetainDimensions ? 0 : 1;
	}, function (props) {
	  return props.theme.vstui.color.black;
	});Styled.th = _styledComponents2.default.th.withConfig({ displayName: 'TableHeaderCell__th' })(['', ';', ';padding:0;background-color:', ';border-left:1px solid;border-left-color:', ';color:', ';font-size:', ';line-height:1.23;&:first-child{border-left:none;}@media print{background:', ';border-left:none;color:', ';font-weight:', ';}'], normalizeStyles, cellStyles, (0, _themes.getStyle)('TableHeaderCell_backgroundColor'), (0, _themes.getStyle)('TableHeaderCell_borderColor'), (0, _themes.getStyle)('TableHeaderCell_color'), function (props) {
	  return props.theme.vstui.rem((0, _themes.getStyle)('TableHeaderCell_fontSize')(props));
	}, function (props) {
	  return props.theme.vstui.color.white;
	}, function (props) {
	  return props.theme.vstui.color.black;
	}, function (props) {
	  return props.theme.vstui.typography.fontWeightMedium;
	}), Styled.div.headerText = _styledComponents2.default.div.withConfig({ displayName: 'TableHeaderCell__headerText' })(['position:relative;width:100%;background:none;border:none;border-radius:0;@media print{padding:0 5px;}']), Styled.button.sort = _styledComponents2.default.button.withConfig({ displayName: 'TableHeaderCell__sort' })(['width:100%;padding:5px 20px;background:none;border:none;outline-offset:-4px;color:inherit;font-family:inherit;font-size:inherit;line-height:inherit;text-align:', ';', ';'], function (props) {
	  return props.sc.numeric ? 'right' : 'left';
	}, function (props) {
	  return props.sc.visuallyHidden ? (0, _styles.visuallyHidden)() : '';
	}), Styled.div.sortIconWrapper = _styledComponents2.default.div.withConfig({ displayName: 'TableHeaderCell__sortIconWrapper' })(['position:absolute;top:calc(50% - 2px);right:8px;@media print{display:none;}']), Styled.span.sortDirection = _styledComponents2.default.span.withConfig({ displayName: 'TableHeaderCell__sortDirection' })(['', ';'], function (props) {
	  return props.sc.visuallyHidden ? (0, _styles.visuallyHidden)() : '';
	});var TableHeaderCell = function (_Component) {
	  function TableHeaderCell(props) {
	    _classCallCheck(this, TableHeaderCell);var _this = _possibleConstructorReturn(this, (TableHeaderCell.__proto__ || Object.getPrototypeOf(TableHeaderCell)).call(this, props));return _this.handleClick = _this.handleClick.bind(_this), _this;
	  }return _inherits(TableHeaderCell, _Component), _createClass(TableHeaderCell, [{ key: 'handleClick', value: function handleClick(event) {
	      this.props.onClick(event, this.props.index);
	    } }, { key: 'renderSortIcon', value: function renderSortIcon() {
	      var _props = this.props,
	          index = _props.index,
	          sortIndex = _props.sortIndex,
	          sortOrder = _props.sortOrder,
	          tableType = _props.tableType;if (void 0 === sortIndex && void 0 === index) return null;if (sortIndex === index) {
	        var direction = 1 === sortOrder ? 'ascending' : 'descending';return _react2.default.createElement(Styled.div.sortIconWrapper, null, 'header' === tableType && _react2.default.createElement(_SortIcon2.default, { direction: direction }), _react2.default.createElement(Styled.span.sortDirection, { sc: { visuallyHidden: !0 } }, 'sorted ', direction));
	      }return null;
	    } }, { key: 'render', value: function render() {
	      var _props2 = this.props,
	          children = _props2.children,
	          hidden = _props2.hidden,
	          numeric = _props2.numeric,
	          tableType = _props2.tableType,
	          theme = _props2.theme,
	          conditionalButtonProps = {};return ('header' === tableType && hidden || 'body' === tableType) && (conditionalButtonProps.tabIndex = -1), _react2.default.createElement(Styled.th, { sc: { numeric: numeric, visuallyHiddenRetainDimensions: 'body' === tableType }, scope: 'col', theme: theme }, _react2.default.createElement(Styled.div.headerText, { sc: { numeric: numeric } }, _react2.default.createElement(Styled.button.sort, _extends({}, conditionalButtonProps, { onClick: this.handleClick, sc: { visuallyHidden: hidden } }), children, this.renderSortIcon())));
	    } }]), TableHeaderCell;
	}(_react.Component);TableHeaderCell.propTypes = { children: _propTypes2.default.node, hidden: _propTypes2.default.bool, index: _propTypes2.default.number, numeric: _propTypes2.default.bool, onClick: _propTypes2.default.func, sortIndex: _propTypes2.default.number, sortOrder: _propTypes2.default.number, tableType: _propTypes2.default.oneOf(['body', 'header']), theme: _propTypes3.themeShape }, TableHeaderCell.defaultProps = { theme: (0, _themes.createTheme)() }, TableHeaderCell.displayName = 'TableHeaderCell';var TableHeaderCellWithTheme = (0, _themes.withTheme)(TableHeaderCell);TableHeaderCellWithTheme.WrappedComponent = TableHeaderCell, exports.default = TableHeaderCellWithTheme;

/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var descriptor, i = 0; i < props.length; i++) {
	      descriptor = props[i], descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, 'value' in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    return protoProps && defineProperties(Constructor.prototype, protoProps), staticProps && defineProperties(Constructor, staticProps), Constructor;
	  };
	}(),
	    _react = __webpack_require__(3),
	    _react2 = _interopRequireDefault(_react),
	    _propTypes = __webpack_require__(6),
	    _propTypes2 = _interopRequireDefault(_propTypes),
	    _styledComponents = __webpack_require__(15),
	    _styledComponents2 = _interopRequireDefault(_styledComponents);Object.defineProperty(exports, '__esModule', { value: !0 });function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
	}function _possibleConstructorReturn(self, call) {
	  if (!self) throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');return call && ('object' == (typeof call === 'undefined' ? 'undefined' : _typeof(call)) || 'function' == typeof call) ? call : self;
	}function _inherits(subClass, superClass) {
	  if ('function' != typeof superClass && null !== superClass) throw new TypeError('Super expression must either be null or a function, not ' + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: !1, writable: !0, configurable: !0 } }), superClass && (Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass);
	}var Styled = { tr: _styledComponents2.default.tr.withConfig({ displayName: 'TableRow__tr' })(['@media print{page-break-inside:avoid;}']) },
	    TableRow = function (_Component) {
	  function TableRow(props) {
	    _classCallCheck(this, TableRow);var _this = _possibleConstructorReturn(this, (TableRow.__proto__ || Object.getPrototypeOf(TableRow)).call(this, props));return _this.state = { hover: !1 }, _this.handleMouseEnter = _this.handleMouseEnter.bind(_this), _this.handleMouseLeave = _this.handleMouseLeave.bind(_this), _this;
	  }return _inherits(TableRow, _Component), _createClass(TableRow, [{ key: 'handleMouseEnter', value: function handleMouseEnter() {
	      this.setState({ hover: !0 });
	    } }, { key: 'handleMouseLeave', value: function handleMouseLeave() {
	      this.setState({ hover: !1 });
	    } }, { key: 'render', value: function render() {
	      var _this2 = this,
	          children = _react2.default.Children.map(this.props.children, function (child) {
	        return _react2.default.cloneElement(child, { rowHover: _this2.state.hover });
	      });return _react2.default.createElement(Styled.tr, { onMouseEnter: this.handleMouseEnter, onMouseLeave: this.handleMouseLeave }, children);
	    } }]), TableRow;
	}(_react.Component);TableRow.propTypes = { children: _propTypes2.default.node }, TableRow.defaultProps = {}, TableRow.displayName = 'TableRow', exports.default = TableRow;

/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	Object.defineProperty(exports, '__esModule', { value: !0 });var _TextField = __webpack_require__(449);Object.defineProperty(exports, 'default', { enumerable: !0, get: function get() {
	    return _interopRequireDefault(_TextField).default;
	  } });function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}

/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	Object.defineProperty(exports, '__esModule', { value: !0 });var _createReactContext = __webpack_require__(729),
	    _createReactContext2 = _interopRequireDefault(_createReactContext);function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}var FormContext = (0, _createReactContext2.default)();exports.default = FormContext;

/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	Object.defineProperty(exports, '__esModule', { value: !0 });var _propTypes = __webpack_require__(6),
	    _propTypes2 = _interopRequireDefault(_propTypes);function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}var i18nShape = _propTypes2.default.shape({ direction: _propTypes2.default.oneOf(['ltr', 'rtl', 'auto']), language: _propTypes2.default.string, t: _propTypes2.default.func });exports.default = i18nShape;

/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	Object.defineProperty(exports, '__esModule', { value: !0 });var _propTypes = __webpack_require__(6),
	    _propTypes2 = _interopRequireDefault(_propTypes);function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}var themeShape = _propTypes2.default.shape({ vstui: _propTypes2.default.shape({ direction: _propTypes2.default.oneOf(['ltr', 'rtl', 'auto']), palette: _propTypes2.default.shape({ common: _propTypes2.default.shape({ black: _propTypes2.default.string, white: _propTypes2.default.string, transparent: _propTypes2.default.string }), primary: _propTypes2.default.shape({ getShade: _propTypes2.default.func, getMainShade: _propTypes2.default.func, name: _propTypes2.default.string }), secondary: _propTypes2.default.shape({ getShade: _propTypes2.default.func, getMainShade: _propTypes2.default.func, name: _propTypes2.default.string }), error: _propTypes2.default.shape({ getShade: _propTypes2.default.func, getMainShade: _propTypes2.default.func, name: _propTypes2.default.string }), success: _propTypes2.default.shape({ getShade: _propTypes2.default.func, getMainShade: _propTypes2.default.func, name: _propTypes2.default.string }) }), typography: _propTypes2.default.shape({ fontFamily: _propTypes2.default.string, fontSize: _propTypes2.default.number, fontWeightLight: _propTypes2.default.number, fontWeightRegular: _propTypes2.default.number, fontWeightMedium: _propTypes2.default.number, fontWeightBold: _propTypes2.default.number, fontWeightBlack: _propTypes2.default.number, htmlFontSize: _propTypes2.default.number, pxToRem: _propTypes2.default.func }), transitions: _propTypes2.default.shape({ easing: _propTypes2.default.shape({ easeIn: _propTypes2.default.string, easeOut: _propTypes2.default.string }), duration: _propTypes2.default.shape({ shortest: _propTypes2.default.string, short: _propTypes2.default.string, enteringScreen: _propTypes2.default.string, leavingScreen: _propTypes2.default.string }) }), sizes: _propTypes2.default.shape({ small: _propTypes2.default.number, medium: _propTypes2.default.number, large: _propTypes2.default.number }) }) });exports.default = themeShape;

/***/ },
/* 195 */
/***/ function(module, exports) {

	"use strict";
	var _extends = Object.assign || function (target) {
	  for (var source, i = 1; i < arguments.length; i++) {
	    for (var key in source = arguments[i], source) {
	      Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
	    }
	  }return target;
	};Object.defineProperty(exports, "__esModule", { value: !0 });function _objectWithoutProperties(obj, keys) {
	  var target = {};for (var i in obj) {
	    0 <= keys.indexOf(i) || Object.prototype.hasOwnProperty.call(obj, i) && (target[i] = obj[i]);
	  }return target;
	}var createComponentTheme = function createComponentTheme(theme, componentStyles) {
	  var vstui = theme.vstui,
	      other = _objectWithoutProperties(theme, ["vstui"]);return _extends({ vstui: _extends({}, componentStyles, vstui) }, other);
	};exports.default = createComponentTheme;

/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _typeof = 'function' == typeof Symbol && 'symbol' == _typeof2(Symbol.iterator) ? function (obj) {
	  return typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
	} : function (obj) {
	  return obj && 'function' == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? 'symbol' : typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
	},
	    _warning = __webpack_require__(494),
	    _warning2 = _interopRequireDefault(_warning),
	    _translate = __webpack_require__(474),
	    _translate2 = _interopRequireDefault(_translate),
	    _en = __webpack_require__(475),
	    _en2 = _interopRequireDefault(_en);Object.defineProperty(exports, '__esModule', { value: !0 });function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}var createI18n = function createI18n() {
	  var inputLocale = 0 < arguments.length && arguments[0] !== void 0 ? arguments[0] : _en2.default,
	      localeData = inputLocale;if ('object' === ('undefined' == typeof window ? 'undefined' : _typeof(window)) && window.vstuiLocaleData) {
	    var vstuiVersion = '1.1.0-3',
	        localeDataVersion = window.vstuiLocaleData.version,
	        localeDataValid = localeDataVersion === vstuiVersion;localeData = localeDataValid ? window.vstuiLocaleData : _en2.default,  true ? void 0 : (0, _warning2.default)(localeDataValid, 'Warning: locale data version (' + localeDataVersion + ') does not match vstui version (' + vstuiVersion + '). Using \'en\' locale as a fallback.');
	  }var _localeData = localeData,
	      locale = _localeData.locale,
	      direction = _localeData.direction,
	      messages = _localeData.messages;return { direction: direction, locale: locale, t: function t(id, values) {
	      return (0, _translate2.default)(id, values, messages);
	    } };
	};exports.default = createI18n;

/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	Object.defineProperty(exports, '__esModule', { value: !0 });var _styledComponents = __webpack_require__(15);Object.defineProperty(exports, 'default', { enumerable: !0, get: function get() {
	    return _styledComponents.withTheme;
	  } });

/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	__webpack_require__(726);
	
	__webpack_require__(517);
	
	__webpack_require__(524);
	
	if (global._babelPolyfill) {
	  throw new Error("only one instance of babel-polyfill is allowed");
	}
	global._babelPolyfill = true;
	
	var DEFINE_PROPERTY = "defineProperty";
	function define(O, key, value) {
	  O[key] || Object[DEFINE_PROPERTY](O, key, {
	    writable: true,
	    configurable: true,
	    value: value
	  });
	}
	
	define(String.prototype, "padLeft", "".padStart);
	define(String.prototype, "padRight", "".padEnd);
	
	"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
	  [][key] && define(Array, key, Function.call.bind([][key]));
	});
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 199 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer, global) {/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
	 * @license  MIT
	 */
	/* eslint-disable no-proto */
	
	'use strict';
	
	var base64 = __webpack_require__(521);
	var ieee754 = __webpack_require__(793);
	var isArray = __webpack_require__(812);
	
	exports.Buffer = Buffer;
	exports.SlowBuffer = SlowBuffer;
	exports.INSPECT_MAX_BYTES = 50;
	
	/**
	 * If `Buffer.TYPED_ARRAY_SUPPORT`:
	 *   === true    Use Uint8Array implementation (fastest)
	 *   === false   Use Object implementation (most compatible, even IE6)
	 *
	 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	 * Opera 11.6+, iOS 4.2+.
	 *
	 * Due to various browser bugs, sometimes the Object implementation will be used even
	 * when the browser supports typed arrays.
	 *
	 * Note:
	 *
	 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
	 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
	 *
	 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
	 *
	 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
	 *     incorrect length in some situations.
	
	 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
	 * get the Object implementation, which is slower but behaves correctly.
	 */
	Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined ? global.TYPED_ARRAY_SUPPORT : typedArraySupport();
	
	/*
	 * Export kMaxLength after typed array support is determined.
	 */
	exports.kMaxLength = kMaxLength();
	
	function typedArraySupport() {
	  try {
	    var arr = new Uint8Array(1);
	    arr.__proto__ = { __proto__: Uint8Array.prototype, foo: function foo() {
	        return 42;
	      } };
	    return arr.foo() === 42 && // typed array instances can be augmented
	    typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
	    arr.subarray(1, 1).byteLength === 0; // ie10 has broken `subarray`
	  } catch (e) {
	    return false;
	  }
	}
	
	function kMaxLength() {
	  return Buffer.TYPED_ARRAY_SUPPORT ? 0x7fffffff : 0x3fffffff;
	}
	
	function createBuffer(that, length) {
	  if (kMaxLength() < length) {
	    throw new RangeError('Invalid typed array length');
	  }
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = new Uint8Array(length);
	    that.__proto__ = Buffer.prototype;
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    if (that === null) {
	      that = new Buffer(length);
	    }
	    that.length = length;
	  }
	
	  return that;
	}
	
	/**
	 * The Buffer constructor returns instances of `Uint8Array` that have their
	 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
	 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
	 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
	 * returns a single octet.
	 *
	 * The `Uint8Array` prototype remains unmodified.
	 */
	
	function Buffer(arg, encodingOrOffset, length) {
	  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
	    return new Buffer(arg, encodingOrOffset, length);
	  }
	
	  // Common case.
	  if (typeof arg === 'number') {
	    if (typeof encodingOrOffset === 'string') {
	      throw new Error('If encoding is specified then the first argument must be a string');
	    }
	    return allocUnsafe(this, arg);
	  }
	  return from(this, arg, encodingOrOffset, length);
	}
	
	Buffer.poolSize = 8192; // not used by this implementation
	
	// TODO: Legacy, not needed anymore. Remove in next major version.
	Buffer._augment = function (arr) {
	  arr.__proto__ = Buffer.prototype;
	  return arr;
	};
	
	function from(that, value, encodingOrOffset, length) {
	  if (typeof value === 'number') {
	    throw new TypeError('"value" argument must not be a number');
	  }
	
	  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
	    return fromArrayBuffer(that, value, encodingOrOffset, length);
	  }
	
	  if (typeof value === 'string') {
	    return fromString(that, value, encodingOrOffset);
	  }
	
	  return fromObject(that, value);
	}
	
	/**
	 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
	 * if value is a number.
	 * Buffer.from(str[, encoding])
	 * Buffer.from(array)
	 * Buffer.from(buffer)
	 * Buffer.from(arrayBuffer[, byteOffset[, length]])
	 **/
	Buffer.from = function (value, encodingOrOffset, length) {
	  return from(null, value, encodingOrOffset, length);
	};
	
	if (Buffer.TYPED_ARRAY_SUPPORT) {
	  Buffer.prototype.__proto__ = Uint8Array.prototype;
	  Buffer.__proto__ = Uint8Array;
	  if (typeof Symbol !== 'undefined' && Symbol.species && Buffer[Symbol.species] === Buffer) {
	    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
	    Object.defineProperty(Buffer, Symbol.species, {
	      value: null,
	      configurable: true
	    });
	  }
	}
	
	function assertSize(size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('"size" argument must be a number');
	  } else if (size < 0) {
	    throw new RangeError('"size" argument must not be negative');
	  }
	}
	
	function alloc(that, size, fill, encoding) {
	  assertSize(size);
	  if (size <= 0) {
	    return createBuffer(that, size);
	  }
	  if (fill !== undefined) {
	    // Only pay attention to encoding if it's a string. This
	    // prevents accidentally sending in a number that would
	    // be interpretted as a start offset.
	    return typeof encoding === 'string' ? createBuffer(that, size).fill(fill, encoding) : createBuffer(that, size).fill(fill);
	  }
	  return createBuffer(that, size);
	}
	
	/**
	 * Creates a new filled Buffer instance.
	 * alloc(size[, fill[, encoding]])
	 **/
	Buffer.alloc = function (size, fill, encoding) {
	  return alloc(null, size, fill, encoding);
	};
	
	function allocUnsafe(that, size) {
	  assertSize(size);
	  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0);
	  if (!Buffer.TYPED_ARRAY_SUPPORT) {
	    for (var i = 0; i < size; ++i) {
	      that[i] = 0;
	    }
	  }
	  return that;
	}
	
	/**
	 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
	 * */
	Buffer.allocUnsafe = function (size) {
	  return allocUnsafe(null, size);
	};
	/**
	 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
	 */
	Buffer.allocUnsafeSlow = function (size) {
	  return allocUnsafe(null, size);
	};
	
	function fromString(that, string, encoding) {
	  if (typeof encoding !== 'string' || encoding === '') {
	    encoding = 'utf8';
	  }
	
	  if (!Buffer.isEncoding(encoding)) {
	    throw new TypeError('"encoding" must be a valid string encoding');
	  }
	
	  var length = byteLength(string, encoding) | 0;
	  that = createBuffer(that, length);
	
	  var actual = that.write(string, encoding);
	
	  if (actual !== length) {
	    // Writing a hex string, for example, that contains invalid characters will
	    // cause everything after the first invalid character to be ignored. (e.g.
	    // 'abxxcd' will be treated as 'ab')
	    that = that.slice(0, actual);
	  }
	
	  return that;
	}
	
	function fromArrayLike(that, array) {
	  var length = array.length < 0 ? 0 : checked(array.length) | 0;
	  that = createBuffer(that, length);
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255;
	  }
	  return that;
	}
	
	function fromArrayBuffer(that, array, byteOffset, length) {
	  array.byteLength; // this throws if `array` is not a valid ArrayBuffer
	
	  if (byteOffset < 0 || array.byteLength < byteOffset) {
	    throw new RangeError('\'offset\' is out of bounds');
	  }
	
	  if (array.byteLength < byteOffset + (length || 0)) {
	    throw new RangeError('\'length\' is out of bounds');
	  }
	
	  if (byteOffset === undefined && length === undefined) {
	    array = new Uint8Array(array);
	  } else if (length === undefined) {
	    array = new Uint8Array(array, byteOffset);
	  } else {
	    array = new Uint8Array(array, byteOffset, length);
	  }
	
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = array;
	    that.__proto__ = Buffer.prototype;
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    that = fromArrayLike(that, array);
	  }
	  return that;
	}
	
	function fromObject(that, obj) {
	  if (Buffer.isBuffer(obj)) {
	    var len = checked(obj.length) | 0;
	    that = createBuffer(that, len);
	
	    if (that.length === 0) {
	      return that;
	    }
	
	    obj.copy(that, 0, 0, len);
	    return that;
	  }
	
	  if (obj) {
	    if (typeof ArrayBuffer !== 'undefined' && obj.buffer instanceof ArrayBuffer || 'length' in obj) {
	      if (typeof obj.length !== 'number' || isnan(obj.length)) {
	        return createBuffer(that, 0);
	      }
	      return fromArrayLike(that, obj);
	    }
	
	    if (obj.type === 'Buffer' && isArray(obj.data)) {
	      return fromArrayLike(that, obj.data);
	    }
	  }
	
	  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.');
	}
	
	function checked(length) {
	  // Note: cannot use `length < kMaxLength()` here because that fails when
	  // length is NaN (which is otherwise coerced to zero.)
	  if (length >= kMaxLength()) {
	    throw new RangeError('Attempt to allocate Buffer larger than maximum ' + 'size: 0x' + kMaxLength().toString(16) + ' bytes');
	  }
	  return length | 0;
	}
	
	function SlowBuffer(length) {
	  if (+length != length) {
	    // eslint-disable-line eqeqeq
	    length = 0;
	  }
	  return Buffer.alloc(+length);
	}
	
	Buffer.isBuffer = function isBuffer(b) {
	  return !!(b != null && b._isBuffer);
	};
	
	Buffer.compare = function compare(a, b) {
	  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
	    throw new TypeError('Arguments must be Buffers');
	  }
	
	  if (a === b) return 0;
	
	  var x = a.length;
	  var y = b.length;
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i];
	      y = b[i];
	      break;
	    }
	  }
	
	  if (x < y) return -1;
	  if (y < x) return 1;
	  return 0;
	};
	
	Buffer.isEncoding = function isEncoding(encoding) {
	  switch (String(encoding).toLowerCase()) {
	    case 'hex':
	    case 'utf8':
	    case 'utf-8':
	    case 'ascii':
	    case 'latin1':
	    case 'binary':
	    case 'base64':
	    case 'ucs2':
	    case 'ucs-2':
	    case 'utf16le':
	    case 'utf-16le':
	      return true;
	    default:
	      return false;
	  }
	};
	
	Buffer.concat = function concat(list, length) {
	  if (!isArray(list)) {
	    throw new TypeError('"list" argument must be an Array of Buffers');
	  }
	
	  if (list.length === 0) {
	    return Buffer.alloc(0);
	  }
	
	  var i;
	  if (length === undefined) {
	    length = 0;
	    for (i = 0; i < list.length; ++i) {
	      length += list[i].length;
	    }
	  }
	
	  var buffer = Buffer.allocUnsafe(length);
	  var pos = 0;
	  for (i = 0; i < list.length; ++i) {
	    var buf = list[i];
	    if (!Buffer.isBuffer(buf)) {
	      throw new TypeError('"list" argument must be an Array of Buffers');
	    }
	    buf.copy(buffer, pos);
	    pos += buf.length;
	  }
	  return buffer;
	};
	
	function byteLength(string, encoding) {
	  if (Buffer.isBuffer(string)) {
	    return string.length;
	  }
	  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' && (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
	    return string.byteLength;
	  }
	  if (typeof string !== 'string') {
	    string = '' + string;
	  }
	
	  var len = string.length;
	  if (len === 0) return 0;
	
	  // Use a for loop to avoid recursion
	  var loweredCase = false;
	  for (;;) {
	    switch (encoding) {
	      case 'ascii':
	      case 'latin1':
	      case 'binary':
	        return len;
	      case 'utf8':
	      case 'utf-8':
	      case undefined:
	        return utf8ToBytes(string).length;
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return len * 2;
	      case 'hex':
	        return len >>> 1;
	      case 'base64':
	        return base64ToBytes(string).length;
	      default:
	        if (loweredCase) return utf8ToBytes(string).length; // assume utf8
	        encoding = ('' + encoding).toLowerCase();
	        loweredCase = true;
	    }
	  }
	}
	Buffer.byteLength = byteLength;
	
	function slowToString(encoding, start, end) {
	  var loweredCase = false;
	
	  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
	  // property of a typed array.
	
	  // This behaves neither like String nor Uint8Array in that we set start/end
	  // to their upper/lower bounds if the value passed is out of range.
	  // undefined is handled specially as per ECMA-262 6th Edition,
	  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
	  if (start === undefined || start < 0) {
	    start = 0;
	  }
	  // Return early if start > this.length. Done here to prevent potential uint32
	  // coercion fail below.
	  if (start > this.length) {
	    return '';
	  }
	
	  if (end === undefined || end > this.length) {
	    end = this.length;
	  }
	
	  if (end <= 0) {
	    return '';
	  }
	
	  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
	  end >>>= 0;
	  start >>>= 0;
	
	  if (end <= start) {
	    return '';
	  }
	
	  if (!encoding) encoding = 'utf8';
	
	  while (true) {
	    switch (encoding) {
	      case 'hex':
	        return hexSlice(this, start, end);
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Slice(this, start, end);
	
	      case 'ascii':
	        return asciiSlice(this, start, end);
	
	      case 'latin1':
	      case 'binary':
	        return latin1Slice(this, start, end);
	
	      case 'base64':
	        return base64Slice(this, start, end);
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return utf16leSlice(this, start, end);
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
	        encoding = (encoding + '').toLowerCase();
	        loweredCase = true;
	    }
	  }
	}
	
	// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
	// Buffer instances.
	Buffer.prototype._isBuffer = true;
	
	function swap(b, n, m) {
	  var i = b[n];
	  b[n] = b[m];
	  b[m] = i;
	}
	
	Buffer.prototype.swap16 = function swap16() {
	  var len = this.length;
	  if (len % 2 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 16-bits');
	  }
	  for (var i = 0; i < len; i += 2) {
	    swap(this, i, i + 1);
	  }
	  return this;
	};
	
	Buffer.prototype.swap32 = function swap32() {
	  var len = this.length;
	  if (len % 4 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 32-bits');
	  }
	  for (var i = 0; i < len; i += 4) {
	    swap(this, i, i + 3);
	    swap(this, i + 1, i + 2);
	  }
	  return this;
	};
	
	Buffer.prototype.swap64 = function swap64() {
	  var len = this.length;
	  if (len % 8 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 64-bits');
	  }
	  for (var i = 0; i < len; i += 8) {
	    swap(this, i, i + 7);
	    swap(this, i + 1, i + 6);
	    swap(this, i + 2, i + 5);
	    swap(this, i + 3, i + 4);
	  }
	  return this;
	};
	
	Buffer.prototype.toString = function toString() {
	  var length = this.length | 0;
	  if (length === 0) return '';
	  if (arguments.length === 0) return utf8Slice(this, 0, length);
	  return slowToString.apply(this, arguments);
	};
	
	Buffer.prototype.equals = function equals(b) {
	  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
	  if (this === b) return true;
	  return Buffer.compare(this, b) === 0;
	};
	
	Buffer.prototype.inspect = function inspect() {
	  var str = '';
	  var max = exports.INSPECT_MAX_BYTES;
	  if (this.length > 0) {
	    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ');
	    if (this.length > max) str += ' ... ';
	  }
	  return '<Buffer ' + str + '>';
	};
	
	Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
	  if (!Buffer.isBuffer(target)) {
	    throw new TypeError('Argument must be a Buffer');
	  }
	
	  if (start === undefined) {
	    start = 0;
	  }
	  if (end === undefined) {
	    end = target ? target.length : 0;
	  }
	  if (thisStart === undefined) {
	    thisStart = 0;
	  }
	  if (thisEnd === undefined) {
	    thisEnd = this.length;
	  }
	
	  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
	    throw new RangeError('out of range index');
	  }
	
	  if (thisStart >= thisEnd && start >= end) {
	    return 0;
	  }
	  if (thisStart >= thisEnd) {
	    return -1;
	  }
	  if (start >= end) {
	    return 1;
	  }
	
	  start >>>= 0;
	  end >>>= 0;
	  thisStart >>>= 0;
	  thisEnd >>>= 0;
	
	  if (this === target) return 0;
	
	  var x = thisEnd - thisStart;
	  var y = end - start;
	  var len = Math.min(x, y);
	
	  var thisCopy = this.slice(thisStart, thisEnd);
	  var targetCopy = target.slice(start, end);
	
	  for (var i = 0; i < len; ++i) {
	    if (thisCopy[i] !== targetCopy[i]) {
	      x = thisCopy[i];
	      y = targetCopy[i];
	      break;
	    }
	  }
	
	  if (x < y) return -1;
	  if (y < x) return 1;
	  return 0;
	};
	
	// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
	// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
	//
	// Arguments:
	// - buffer - a Buffer to search
	// - val - a string, Buffer, or number
	// - byteOffset - an index into `buffer`; will be clamped to an int32
	// - encoding - an optional encoding, relevant is val is a string
	// - dir - true for indexOf, false for lastIndexOf
	function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
	  // Empty buffer means no match
	  if (buffer.length === 0) return -1;
	
	  // Normalize byteOffset
	  if (typeof byteOffset === 'string') {
	    encoding = byteOffset;
	    byteOffset = 0;
	  } else if (byteOffset > 0x7fffffff) {
	    byteOffset = 0x7fffffff;
	  } else if (byteOffset < -0x80000000) {
	    byteOffset = -0x80000000;
	  }
	  byteOffset = +byteOffset; // Coerce to Number.
	  if (isNaN(byteOffset)) {
	    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
	    byteOffset = dir ? 0 : buffer.length - 1;
	  }
	
	  // Normalize byteOffset: negative offsets start from the end of the buffer
	  if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
	  if (byteOffset >= buffer.length) {
	    if (dir) return -1;else byteOffset = buffer.length - 1;
	  } else if (byteOffset < 0) {
	    if (dir) byteOffset = 0;else return -1;
	  }
	
	  // Normalize val
	  if (typeof val === 'string') {
	    val = Buffer.from(val, encoding);
	  }
	
	  // Finally, search either indexOf (if dir is true) or lastIndexOf
	  if (Buffer.isBuffer(val)) {
	    // Special case: looking for empty string/buffer always fails
	    if (val.length === 0) {
	      return -1;
	    }
	    return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
	  } else if (typeof val === 'number') {
	    val = val & 0xFF; // Search for a byte value [0-255]
	    if (Buffer.TYPED_ARRAY_SUPPORT && typeof Uint8Array.prototype.indexOf === 'function') {
	      if (dir) {
	        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
	      } else {
	        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
	      }
	    }
	    return arrayIndexOf(buffer, [val], byteOffset, encoding, dir);
	  }
	
	  throw new TypeError('val must be string, number or Buffer');
	}
	
	function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
	  var indexSize = 1;
	  var arrLength = arr.length;
	  var valLength = val.length;
	
	  if (encoding !== undefined) {
	    encoding = String(encoding).toLowerCase();
	    if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
	      if (arr.length < 2 || val.length < 2) {
	        return -1;
	      }
	      indexSize = 2;
	      arrLength /= 2;
	      valLength /= 2;
	      byteOffset /= 2;
	    }
	  }
	
	  function read(buf, i) {
	    if (indexSize === 1) {
	      return buf[i];
	    } else {
	      return buf.readUInt16BE(i * indexSize);
	    }
	  }
	
	  var i;
	  if (dir) {
	    var foundIndex = -1;
	    for (i = byteOffset; i < arrLength; i++) {
	      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
	        if (foundIndex === -1) foundIndex = i;
	        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
	      } else {
	        if (foundIndex !== -1) i -= i - foundIndex;
	        foundIndex = -1;
	      }
	    }
	  } else {
	    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
	    for (i = byteOffset; i >= 0; i--) {
	      var found = true;
	      for (var j = 0; j < valLength; j++) {
	        if (read(arr, i + j) !== read(val, j)) {
	          found = false;
	          break;
	        }
	      }
	      if (found) return i;
	    }
	  }
	
	  return -1;
	}
	
	Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
	  return this.indexOf(val, byteOffset, encoding) !== -1;
	};
	
	Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
	};
	
	Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
	};
	
	function hexWrite(buf, string, offset, length) {
	  offset = Number(offset) || 0;
	  var remaining = buf.length - offset;
	  if (!length) {
	    length = remaining;
	  } else {
	    length = Number(length);
	    if (length > remaining) {
	      length = remaining;
	    }
	  }
	
	  // must be an even number of digits
	  var strLen = string.length;
	  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string');
	
	  if (length > strLen / 2) {
	    length = strLen / 2;
	  }
	  for (var i = 0; i < length; ++i) {
	    var parsed = parseInt(string.substr(i * 2, 2), 16);
	    if (isNaN(parsed)) return i;
	    buf[offset + i] = parsed;
	  }
	  return i;
	}
	
	function utf8Write(buf, string, offset, length) {
	  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
	}
	
	function asciiWrite(buf, string, offset, length) {
	  return blitBuffer(asciiToBytes(string), buf, offset, length);
	}
	
	function latin1Write(buf, string, offset, length) {
	  return asciiWrite(buf, string, offset, length);
	}
	
	function base64Write(buf, string, offset, length) {
	  return blitBuffer(base64ToBytes(string), buf, offset, length);
	}
	
	function ucs2Write(buf, string, offset, length) {
	  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
	}
	
	Buffer.prototype.write = function write(string, offset, length, encoding) {
	  // Buffer#write(string)
	  if (offset === undefined) {
	    encoding = 'utf8';
	    length = this.length;
	    offset = 0;
	    // Buffer#write(string, encoding)
	  } else if (length === undefined && typeof offset === 'string') {
	    encoding = offset;
	    length = this.length;
	    offset = 0;
	    // Buffer#write(string, offset[, length][, encoding])
	  } else if (isFinite(offset)) {
	    offset = offset | 0;
	    if (isFinite(length)) {
	      length = length | 0;
	      if (encoding === undefined) encoding = 'utf8';
	    } else {
	      encoding = length;
	      length = undefined;
	    }
	    // legacy write(string, encoding, offset, length) - remove in v0.13
	  } else {
	    throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
	  }
	
	  var remaining = this.length - offset;
	  if (length === undefined || length > remaining) length = remaining;
	
	  if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) {
	    throw new RangeError('Attempt to write outside buffer bounds');
	  }
	
	  if (!encoding) encoding = 'utf8';
	
	  var loweredCase = false;
	  for (;;) {
	    switch (encoding) {
	      case 'hex':
	        return hexWrite(this, string, offset, length);
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Write(this, string, offset, length);
	
	      case 'ascii':
	        return asciiWrite(this, string, offset, length);
	
	      case 'latin1':
	      case 'binary':
	        return latin1Write(this, string, offset, length);
	
	      case 'base64':
	        // Warning: maxLength not taken into account in base64Write
	        return base64Write(this, string, offset, length);
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return ucs2Write(this, string, offset, length);
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
	        encoding = ('' + encoding).toLowerCase();
	        loweredCase = true;
	    }
	  }
	};
	
	Buffer.prototype.toJSON = function toJSON() {
	  return {
	    type: 'Buffer',
	    data: Array.prototype.slice.call(this._arr || this, 0)
	  };
	};
	
	function base64Slice(buf, start, end) {
	  if (start === 0 && end === buf.length) {
	    return base64.fromByteArray(buf);
	  } else {
	    return base64.fromByteArray(buf.slice(start, end));
	  }
	}
	
	function utf8Slice(buf, start, end) {
	  end = Math.min(buf.length, end);
	  var res = [];
	
	  var i = start;
	  while (i < end) {
	    var firstByte = buf[i];
	    var codePoint = null;
	    var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
	
	    if (i + bytesPerSequence <= end) {
	      var secondByte, thirdByte, fourthByte, tempCodePoint;
	
	      switch (bytesPerSequence) {
	        case 1:
	          if (firstByte < 0x80) {
	            codePoint = firstByte;
	          }
	          break;
	        case 2:
	          secondByte = buf[i + 1];
	          if ((secondByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
	            if (tempCodePoint > 0x7F) {
	              codePoint = tempCodePoint;
	            }
	          }
	          break;
	        case 3:
	          secondByte = buf[i + 1];
	          thirdByte = buf[i + 2];
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
	            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
	              codePoint = tempCodePoint;
	            }
	          }
	          break;
	        case 4:
	          secondByte = buf[i + 1];
	          thirdByte = buf[i + 2];
	          fourthByte = buf[i + 3];
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
	            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
	              codePoint = tempCodePoint;
	            }
	          }
	      }
	    }
	
	    if (codePoint === null) {
	      // we did not generate a valid codePoint so insert a
	      // replacement char (U+FFFD) and advance only 1 byte
	      codePoint = 0xFFFD;
	      bytesPerSequence = 1;
	    } else if (codePoint > 0xFFFF) {
	      // encode to utf16 (surrogate pair dance)
	      codePoint -= 0x10000;
	      res.push(codePoint >>> 10 & 0x3FF | 0xD800);
	      codePoint = 0xDC00 | codePoint & 0x3FF;
	    }
	
	    res.push(codePoint);
	    i += bytesPerSequence;
	  }
	
	  return decodeCodePointsArray(res);
	}
	
	// Based on http://stackoverflow.com/a/22747272/680742, the browser with
	// the lowest limit is Chrome, with 0x10000 args.
	// We go 1 magnitude less, for safety
	var MAX_ARGUMENTS_LENGTH = 0x1000;
	
	function decodeCodePointsArray(codePoints) {
	  var len = codePoints.length;
	  if (len <= MAX_ARGUMENTS_LENGTH) {
	    return String.fromCharCode.apply(String, codePoints); // avoid extra slice()
	  }
	
	  // Decode in chunks to avoid "call stack size exceeded".
	  var res = '';
	  var i = 0;
	  while (i < len) {
	    res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
	  }
	  return res;
	}
	
	function asciiSlice(buf, start, end) {
	  var ret = '';
	  end = Math.min(buf.length, end);
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i] & 0x7F);
	  }
	  return ret;
	}
	
	function latin1Slice(buf, start, end) {
	  var ret = '';
	  end = Math.min(buf.length, end);
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i]);
	  }
	  return ret;
	}
	
	function hexSlice(buf, start, end) {
	  var len = buf.length;
	
	  if (!start || start < 0) start = 0;
	  if (!end || end < 0 || end > len) end = len;
	
	  var out = '';
	  for (var i = start; i < end; ++i) {
	    out += toHex(buf[i]);
	  }
	  return out;
	}
	
	function utf16leSlice(buf, start, end) {
	  var bytes = buf.slice(start, end);
	  var res = '';
	  for (var i = 0; i < bytes.length; i += 2) {
	    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
	  }
	  return res;
	}
	
	Buffer.prototype.slice = function slice(start, end) {
	  var len = this.length;
	  start = ~~start;
	  end = end === undefined ? len : ~~end;
	
	  if (start < 0) {
	    start += len;
	    if (start < 0) start = 0;
	  } else if (start > len) {
	    start = len;
	  }
	
	  if (end < 0) {
	    end += len;
	    if (end < 0) end = 0;
	  } else if (end > len) {
	    end = len;
	  }
	
	  if (end < start) end = start;
	
	  var newBuf;
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    newBuf = this.subarray(start, end);
	    newBuf.__proto__ = Buffer.prototype;
	  } else {
	    var sliceLen = end - start;
	    newBuf = new Buffer(sliceLen, undefined);
	    for (var i = 0; i < sliceLen; ++i) {
	      newBuf[i] = this[i + start];
	    }
	  }
	
	  return newBuf;
	};
	
	/*
	 * Need to make sure that buffer isn't trying to write out of bounds.
	 */
	function checkOffset(offset, ext, length) {
	  if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
	  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
	}
	
	Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
	  offset = offset | 0;
	  byteLength = byteLength | 0;
	  if (!noAssert) checkOffset(offset, byteLength, this.length);
	
	  var val = this[offset];
	  var mul = 1;
	  var i = 0;
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul;
	  }
	
	  return val;
	};
	
	Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
	  offset = offset | 0;
	  byteLength = byteLength | 0;
	  if (!noAssert) {
	    checkOffset(offset, byteLength, this.length);
	  }
	
	  var val = this[offset + --byteLength];
	  var mul = 1;
	  while (byteLength > 0 && (mul *= 0x100)) {
	    val += this[offset + --byteLength] * mul;
	  }
	
	  return val;
	};
	
	Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length);
	  return this[offset];
	};
	
	Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length);
	  return this[offset] | this[offset + 1] << 8;
	};
	
	Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length);
	  return this[offset] << 8 | this[offset + 1];
	};
	
	Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length);
	
	  return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
	};
	
	Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length);
	
	  return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
	};
	
	Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
	  offset = offset | 0;
	  byteLength = byteLength | 0;
	  if (!noAssert) checkOffset(offset, byteLength, this.length);
	
	  var val = this[offset];
	  var mul = 1;
	  var i = 0;
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul;
	  }
	  mul *= 0x80;
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength);
	
	  return val;
	};
	
	Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
	  offset = offset | 0;
	  byteLength = byteLength | 0;
	  if (!noAssert) checkOffset(offset, byteLength, this.length);
	
	  var i = byteLength;
	  var mul = 1;
	  var val = this[offset + --i];
	  while (i > 0 && (mul *= 0x100)) {
	    val += this[offset + --i] * mul;
	  }
	  mul *= 0x80;
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength);
	
	  return val;
	};
	
	Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length);
	  if (!(this[offset] & 0x80)) return this[offset];
	  return (0xff - this[offset] + 1) * -1;
	};
	
	Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length);
	  var val = this[offset] | this[offset + 1] << 8;
	  return val & 0x8000 ? val | 0xFFFF0000 : val;
	};
	
	Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length);
	  var val = this[offset + 1] | this[offset] << 8;
	  return val & 0x8000 ? val | 0xFFFF0000 : val;
	};
	
	Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length);
	
	  return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
	};
	
	Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length);
	
	  return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
	};
	
	Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length);
	  return ieee754.read(this, offset, true, 23, 4);
	};
	
	Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length);
	  return ieee754.read(this, offset, false, 23, 4);
	};
	
	Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length);
	  return ieee754.read(this, offset, true, 52, 8);
	};
	
	Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length);
	  return ieee754.read(this, offset, false, 52, 8);
	};
	
	function checkInt(buf, value, offset, ext, max, min) {
	  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
	  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
	  if (offset + ext > buf.length) throw new RangeError('Index out of range');
	}
	
	Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
	  value = +value;
	  offset = offset | 0;
	  byteLength = byteLength | 0;
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1;
	    checkInt(this, value, offset, byteLength, maxBytes, 0);
	  }
	
	  var mul = 1;
	  var i = 0;
	  this[offset] = value & 0xFF;
	  while (++i < byteLength && (mul *= 0x100)) {
	    this[offset + i] = value / mul & 0xFF;
	  }
	
	  return offset + byteLength;
	};
	
	Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
	  value = +value;
	  offset = offset | 0;
	  byteLength = byteLength | 0;
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1;
	    checkInt(this, value, offset, byteLength, maxBytes, 0);
	  }
	
	  var i = byteLength - 1;
	  var mul = 1;
	  this[offset + i] = value & 0xFF;
	  while (--i >= 0 && (mul *= 0x100)) {
	    this[offset + i] = value / mul & 0xFF;
	  }
	
	  return offset + byteLength;
	};
	
	Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
	  value = +value;
	  offset = offset | 0;
	  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
	  this[offset] = value & 0xff;
	  return offset + 1;
	};
	
	function objectWriteUInt16(buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffff + value + 1;
	  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
	    buf[offset + i] = (value & 0xff << 8 * (littleEndian ? i : 1 - i)) >>> (littleEndian ? i : 1 - i) * 8;
	  }
	}
	
	Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
	  value = +value;
	  offset = offset | 0;
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = value & 0xff;
	    this[offset + 1] = value >>> 8;
	  } else {
	    objectWriteUInt16(this, value, offset, true);
	  }
	  return offset + 2;
	};
	
	Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
	  value = +value;
	  offset = offset | 0;
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = value >>> 8;
	    this[offset + 1] = value & 0xff;
	  } else {
	    objectWriteUInt16(this, value, offset, false);
	  }
	  return offset + 2;
	};
	
	function objectWriteUInt32(buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffffffff + value + 1;
	  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
	    buf[offset + i] = value >>> (littleEndian ? i : 3 - i) * 8 & 0xff;
	  }
	}
	
	Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
	  value = +value;
	  offset = offset | 0;
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset + 3] = value >>> 24;
	    this[offset + 2] = value >>> 16;
	    this[offset + 1] = value >>> 8;
	    this[offset] = value & 0xff;
	  } else {
	    objectWriteUInt32(this, value, offset, true);
	  }
	  return offset + 4;
	};
	
	Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
	  value = +value;
	  offset = offset | 0;
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = value >>> 24;
	    this[offset + 1] = value >>> 16;
	    this[offset + 2] = value >>> 8;
	    this[offset + 3] = value & 0xff;
	  } else {
	    objectWriteUInt32(this, value, offset, false);
	  }
	  return offset + 4;
	};
	
	Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
	  value = +value;
	  offset = offset | 0;
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1);
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit);
	  }
	
	  var i = 0;
	  var mul = 1;
	  var sub = 0;
	  this[offset] = value & 0xFF;
	  while (++i < byteLength && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
	      sub = 1;
	    }
	    this[offset + i] = (value / mul >> 0) - sub & 0xFF;
	  }
	
	  return offset + byteLength;
	};
	
	Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
	  value = +value;
	  offset = offset | 0;
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1);
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit);
	  }
	
	  var i = byteLength - 1;
	  var mul = 1;
	  var sub = 0;
	  this[offset + i] = value & 0xFF;
	  while (--i >= 0 && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
	      sub = 1;
	    }
	    this[offset + i] = (value / mul >> 0) - sub & 0xFF;
	  }
	
	  return offset + byteLength;
	};
	
	Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
	  value = +value;
	  offset = offset | 0;
	  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80);
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
	  if (value < 0) value = 0xff + value + 1;
	  this[offset] = value & 0xff;
	  return offset + 1;
	};
	
	Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
	  value = +value;
	  offset = offset | 0;
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000);
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = value & 0xff;
	    this[offset + 1] = value >>> 8;
	  } else {
	    objectWriteUInt16(this, value, offset, true);
	  }
	  return offset + 2;
	};
	
	Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
	  value = +value;
	  offset = offset | 0;
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000);
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = value >>> 8;
	    this[offset + 1] = value & 0xff;
	  } else {
	    objectWriteUInt16(this, value, offset, false);
	  }
	  return offset + 2;
	};
	
	Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
	  value = +value;
	  offset = offset | 0;
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000);
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = value & 0xff;
	    this[offset + 1] = value >>> 8;
	    this[offset + 2] = value >>> 16;
	    this[offset + 3] = value >>> 24;
	  } else {
	    objectWriteUInt32(this, value, offset, true);
	  }
	  return offset + 4;
	};
	
	Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
	  value = +value;
	  offset = offset | 0;
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000);
	  if (value < 0) value = 0xffffffff + value + 1;
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = value >>> 24;
	    this[offset + 1] = value >>> 16;
	    this[offset + 2] = value >>> 8;
	    this[offset + 3] = value & 0xff;
	  } else {
	    objectWriteUInt32(this, value, offset, false);
	  }
	  return offset + 4;
	};
	
	function checkIEEE754(buf, value, offset, ext, max, min) {
	  if (offset + ext > buf.length) throw new RangeError('Index out of range');
	  if (offset < 0) throw new RangeError('Index out of range');
	}
	
	function writeFloat(buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38);
	  }
	  ieee754.write(buf, value, offset, littleEndian, 23, 4);
	  return offset + 4;
	}
	
	Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
	  return writeFloat(this, value, offset, true, noAssert);
	};
	
	Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
	  return writeFloat(this, value, offset, false, noAssert);
	};
	
	function writeDouble(buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308);
	  }
	  ieee754.write(buf, value, offset, littleEndian, 52, 8);
	  return offset + 8;
	}
	
	Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
	  return writeDouble(this, value, offset, true, noAssert);
	};
	
	Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
	  return writeDouble(this, value, offset, false, noAssert);
	};
	
	// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
	Buffer.prototype.copy = function copy(target, targetStart, start, end) {
	  if (!start) start = 0;
	  if (!end && end !== 0) end = this.length;
	  if (targetStart >= target.length) targetStart = target.length;
	  if (!targetStart) targetStart = 0;
	  if (end > 0 && end < start) end = start;
	
	  // Copy 0 bytes; we're done
	  if (end === start) return 0;
	  if (target.length === 0 || this.length === 0) return 0;
	
	  // Fatal error conditions
	  if (targetStart < 0) {
	    throw new RangeError('targetStart out of bounds');
	  }
	  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds');
	  if (end < 0) throw new RangeError('sourceEnd out of bounds');
	
	  // Are we oob?
	  if (end > this.length) end = this.length;
	  if (target.length - targetStart < end - start) {
	    end = target.length - targetStart + start;
	  }
	
	  var len = end - start;
	  var i;
	
	  if (this === target && start < targetStart && targetStart < end) {
	    // descending copy from end
	    for (i = len - 1; i >= 0; --i) {
	      target[i + targetStart] = this[i + start];
	    }
	  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
	    // ascending copy from start
	    for (i = 0; i < len; ++i) {
	      target[i + targetStart] = this[i + start];
	    }
	  } else {
	    Uint8Array.prototype.set.call(target, this.subarray(start, start + len), targetStart);
	  }
	
	  return len;
	};
	
	// Usage:
	//    buffer.fill(number[, offset[, end]])
	//    buffer.fill(buffer[, offset[, end]])
	//    buffer.fill(string[, offset[, end]][, encoding])
	Buffer.prototype.fill = function fill(val, start, end, encoding) {
	  // Handle string cases:
	  if (typeof val === 'string') {
	    if (typeof start === 'string') {
	      encoding = start;
	      start = 0;
	      end = this.length;
	    } else if (typeof end === 'string') {
	      encoding = end;
	      end = this.length;
	    }
	    if (val.length === 1) {
	      var code = val.charCodeAt(0);
	      if (code < 256) {
	        val = code;
	      }
	    }
	    if (encoding !== undefined && typeof encoding !== 'string') {
	      throw new TypeError('encoding must be a string');
	    }
	    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
	      throw new TypeError('Unknown encoding: ' + encoding);
	    }
	  } else if (typeof val === 'number') {
	    val = val & 255;
	  }
	
	  // Invalid ranges are not set to a default, so can range check early.
	  if (start < 0 || this.length < start || this.length < end) {
	    throw new RangeError('Out of range index');
	  }
	
	  if (end <= start) {
	    return this;
	  }
	
	  start = start >>> 0;
	  end = end === undefined ? this.length : end >>> 0;
	
	  if (!val) val = 0;
	
	  var i;
	  if (typeof val === 'number') {
	    for (i = start; i < end; ++i) {
	      this[i] = val;
	    }
	  } else {
	    var bytes = Buffer.isBuffer(val) ? val : utf8ToBytes(new Buffer(val, encoding).toString());
	    var len = bytes.length;
	    for (i = 0; i < end - start; ++i) {
	      this[i + start] = bytes[i % len];
	    }
	  }
	
	  return this;
	};
	
	// HELPER FUNCTIONS
	// ================
	
	var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g;
	
	function base64clean(str) {
	  // Node strips out invalid characters like \n and \t from the string, base64-js does not
	  str = stringtrim(str).replace(INVALID_BASE64_RE, '');
	  // Node converts strings with length < 2 to ''
	  if (str.length < 2) return '';
	  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
	  while (str.length % 4 !== 0) {
	    str = str + '=';
	  }
	  return str;
	}
	
	function stringtrim(str) {
	  if (str.trim) return str.trim();
	  return str.replace(/^\s+|\s+$/g, '');
	}
	
	function toHex(n) {
	  if (n < 16) return '0' + n.toString(16);
	  return n.toString(16);
	}
	
	function utf8ToBytes(string, units) {
	  units = units || Infinity;
	  var codePoint;
	  var length = string.length;
	  var leadSurrogate = null;
	  var bytes = [];
	
	  for (var i = 0; i < length; ++i) {
	    codePoint = string.charCodeAt(i);
	
	    // is surrogate component
	    if (codePoint > 0xD7FF && codePoint < 0xE000) {
	      // last char was a lead
	      if (!leadSurrogate) {
	        // no lead yet
	        if (codePoint > 0xDBFF) {
	          // unexpected trail
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
	          continue;
	        } else if (i + 1 === length) {
	          // unpaired lead
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
	          continue;
	        }
	
	        // valid lead
	        leadSurrogate = codePoint;
	
	        continue;
	      }
	
	      // 2 leads in a row
	      if (codePoint < 0xDC00) {
	        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
	        leadSurrogate = codePoint;
	        continue;
	      }
	
	      // valid surrogate pair
	      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
	    } else if (leadSurrogate) {
	      // valid bmp char, but last char was a lead
	      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
	    }
	
	    leadSurrogate = null;
	
	    // encode utf8
	    if (codePoint < 0x80) {
	      if ((units -= 1) < 0) break;
	      bytes.push(codePoint);
	    } else if (codePoint < 0x800) {
	      if ((units -= 2) < 0) break;
	      bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
	    } else if (codePoint < 0x10000) {
	      if ((units -= 3) < 0) break;
	      bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
	    } else if (codePoint < 0x110000) {
	      if ((units -= 4) < 0) break;
	      bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
	    } else {
	      throw new Error('Invalid code point');
	    }
	  }
	
	  return bytes;
	}
	
	function asciiToBytes(str) {
	  var byteArray = [];
	  for (var i = 0; i < str.length; ++i) {
	    // Node's code seems to be doing this and not & 0x7F..
	    byteArray.push(str.charCodeAt(i) & 0xFF);
	  }
	  return byteArray;
	}
	
	function utf16leToBytes(str, units) {
	  var c, hi, lo;
	  var byteArray = [];
	  for (var i = 0; i < str.length; ++i) {
	    if ((units -= 2) < 0) break;
	
	    c = str.charCodeAt(i);
	    hi = c >> 8;
	    lo = c % 256;
	    byteArray.push(lo);
	    byteArray.push(hi);
	  }
	
	  return byteArray;
	}
	
	function base64ToBytes(str) {
	  return base64.toByteArray(base64clean(str));
	}
	
	function blitBuffer(src, dst, offset, length) {
	  for (var i = 0; i < length; ++i) {
	    if (i + offset >= dst.length || i >= src.length) break;
	    dst[i + offset] = src[i];
	  }
	  return i;
	}
	
	function isnan(val) {
	  return val !== val; // eslint-disable-line no-self-compare
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(199).Buffer, (function() { return this; }())))

/***/ },
/* 200 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var cof = __webpack_require__(43);
	module.exports = function (it, msg) {
	  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
	  return +it;
	};

/***/ },
/* 201 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	'use strict';
	
	var toObject = __webpack_require__(24);
	var toAbsoluteIndex = __webpack_require__(73);
	var toLength = __webpack_require__(22);
	
	module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
	  var O = toObject(this);
	  var len = toLength(O.length);
	  var to = toAbsoluteIndex(target, len);
	  var from = toAbsoluteIndex(start, len);
	  var end = arguments.length > 2 ? arguments[2] : undefined;
	  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
	  var inc = 1;
	  if (from < to && to < from + count) {
	    inc = -1;
	    from += count - 1;
	    to += count - 1;
	  }
	  while (count-- > 0) {
	    if (from in O) O[to] = O[from];else delete O[to];
	    to += inc;
	    from += inc;
	  }return O;
	};

/***/ },
/* 202 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var forOf = __webpack_require__(66);
	
	module.exports = function (iter, ITERATOR) {
	  var result = [];
	  forOf(iter, false, result.push, result, ITERATOR);
	  return result;
	};

/***/ },
/* 203 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var aFunction = __webpack_require__(27);
	var toObject = __webpack_require__(24);
	var IObject = __webpack_require__(91);
	var toLength = __webpack_require__(22);
	
	module.exports = function (that, callbackfn, aLen, memo, isRight) {
	  aFunction(callbackfn);
	  var O = toObject(that);
	  var self = IObject(O);
	  var length = toLength(O.length);
	  var index = isRight ? length - 1 : 0;
	  var i = isRight ? -1 : 1;
	  if (aLen < 2) for (;;) {
	    if (index in self) {
	      memo = self[index];
	      index += i;
	      break;
	    }
	    index += i;
	    if (isRight ? index < 0 : length <= index) {
	      throw TypeError('Reduce of empty array with no initial value');
	    }
	  }
	  for (; isRight ? index >= 0 : length > index; index += i) {
	    if (index in self) {
	      memo = callbackfn(memo, self[index], index, O);
	    }
	  }return memo;
	};

/***/ },
/* 204 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var aFunction = __webpack_require__(27);
	var isObject = __webpack_require__(14);
	var invoke = __webpack_require__(107);
	var arraySlice = [].slice;
	var factories = {};
	
	var construct = function construct(F, len, args) {
	  if (!(len in factories)) {
	    for (var n = [], i = 0; i < len; i++) {
	      n[i] = 'a[' + i + ']';
	    } // eslint-disable-next-line no-new-func
	    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
	  }return factories[len](F, args);
	};
	
	module.exports = Function.bind || function bind(that /* , ...args */) {
	  var fn = aFunction(this);
	  var partArgs = arraySlice.call(arguments, 1);
	  var bound = function bound() /* args... */{
	    var args = partArgs.concat(arraySlice.call(arguments));
	    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
	  };
	  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
	  return bound;
	};

/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var dP = __webpack_require__(21).f;
	var create = __webpack_require__(68);
	var redefineAll = __webpack_require__(71);
	var ctx = __webpack_require__(44);
	var anInstance = __webpack_require__(65);
	var forOf = __webpack_require__(66);
	var $iterDefine = __webpack_require__(141);
	var step = __webpack_require__(212);
	var setSpecies = __webpack_require__(72);
	var DESCRIPTORS = __webpack_require__(20);
	var fastKey = __webpack_require__(61).fastKey;
	var validate = __webpack_require__(80);
	var SIZE = DESCRIPTORS ? '_s' : 'size';
	
	var getEntry = function getEntry(that, key) {
	  // fast case
	  var index = fastKey(key);
	  var entry;
	  if (index !== 'F') return that._i[index];
	  // frozen object case
	  for (entry = that._f; entry; entry = entry.n) {
	    if (entry.k == key) return entry;
	  }
	};
	
	module.exports = {
	  getConstructor: function getConstructor(wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      anInstance(that, C, NAME, '_i');
	      that._t = NAME; // collection type
	      that._i = create(null); // index
	      that._f = undefined; // first entry
	      that._l = undefined; // last entry
	      that[SIZE] = 0; // size
	      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.1.3.1 Map.prototype.clear()
	      // 23.2.3.2 Set.prototype.clear()
	      clear: function clear() {
	        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
	          entry.r = true;
	          if (entry.p) entry.p = entry.p.n = undefined;
	          delete data[entry.i];
	        }
	        that._f = that._l = undefined;
	        that[SIZE] = 0;
	      },
	      // 23.1.3.3 Map.prototype.delete(key)
	      // 23.2.3.4 Set.prototype.delete(value)
	      'delete': function _delete(key) {
	        var that = validate(this, NAME);
	        var entry = getEntry(that, key);
	        if (entry) {
	          var next = entry.n;
	          var prev = entry.p;
	          delete that._i[entry.i];
	          entry.r = true;
	          if (prev) prev.n = next;
	          if (next) next.p = prev;
	          if (that._f == entry) that._f = next;
	          if (that._l == entry) that._l = prev;
	          that[SIZE]--;
	        }return !!entry;
	      },
	      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
	      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
	      forEach: function forEach(callbackfn /* , that = undefined */) {
	        validate(this, NAME);
	        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
	        var entry;
	        while (entry = entry ? entry.n : this._f) {
	          f(entry.v, entry.k, this);
	          // revert to the last existing entry
	          while (entry && entry.r) {
	            entry = entry.p;
	          }
	        }
	      },
	      // 23.1.3.7 Map.prototype.has(key)
	      // 23.2.3.7 Set.prototype.has(value)
	      has: function has(key) {
	        return !!getEntry(validate(this, NAME), key);
	      }
	    });
	    if (DESCRIPTORS) dP(C.prototype, 'size', {
	      get: function get() {
	        return validate(this, NAME)[SIZE];
	      }
	    });
	    return C;
	  },
	  def: function def(that, key, value) {
	    var entry = getEntry(that, key);
	    var prev, index;
	    // change existing entry
	    if (entry) {
	      entry.v = value;
	      // create new entry
	    } else {
	      that._l = entry = {
	        i: index = fastKey(key, true), // <- index
	        k: key, // <- key
	        v: value, // <- value
	        p: prev = that._l, // <- previous entry
	        n: undefined, // <- next entry
	        r: false // <- removed
	      };
	      if (!that._f) that._f = entry;
	      if (prev) prev.n = entry;
	      that[SIZE]++;
	      // add to index
	      if (index !== 'F') that._i[index] = entry;
	    }return that;
	  },
	  getEntry: getEntry,
	  setStrong: function setStrong(C, NAME, IS_MAP) {
	    // add .keys, .values, .entries, [@@iterator]
	    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
	    $iterDefine(C, NAME, function (iterated, kind) {
	      this._t = validate(iterated, NAME); // target
	      this._k = kind; // kind
	      this._l = undefined; // previous
	    }, function () {
	      var that = this;
	      var kind = that._k;
	      var entry = that._l;
	      // revert to the last existing entry
	      while (entry && entry.r) {
	        entry = entry.p;
	      } // get next entry
	      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
	        // or finish the iteration
	        that._t = undefined;
	        return step(1);
	      }
	      // return step by kind
	      if (kind == 'keys') return step(0, entry.k);
	      if (kind == 'values') return step(0, entry.v);
	      return step(0, [entry.k, entry.v]);
	    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);
	
	    // add [@@species], 23.1.2.2, 23.2.2.2
	    setSpecies(NAME);
	  }
	};

/***/ },
/* 206 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var classof = __webpack_require__(90);
	var from = __webpack_require__(202);
	module.exports = function (NAME) {
	  return function toJSON() {
	    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
	    return from(this);
	  };
	};

/***/ },
/* 207 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var redefineAll = __webpack_require__(71);
	var getWeak = __webpack_require__(61).getWeak;
	var anObject = __webpack_require__(7);
	var isObject = __webpack_require__(14);
	var anInstance = __webpack_require__(65);
	var forOf = __webpack_require__(66);
	var createArrayMethod = __webpack_require__(47);
	var $has = __webpack_require__(33);
	var validate = __webpack_require__(80);
	var arrayFind = createArrayMethod(5);
	var arrayFindIndex = createArrayMethod(6);
	var id = 0;
	
	// fallback for uncaught frozen keys
	var uncaughtFrozenStore = function uncaughtFrozenStore(that) {
	  return that._l || (that._l = new UncaughtFrozenStore());
	};
	var UncaughtFrozenStore = function UncaughtFrozenStore() {
	  this.a = [];
	};
	var findUncaughtFrozen = function findUncaughtFrozen(store, key) {
	  return arrayFind(store.a, function (it) {
	    return it[0] === key;
	  });
	};
	UncaughtFrozenStore.prototype = {
	  get: function get(key) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) return entry[1];
	  },
	  has: function has(key) {
	    return !!findUncaughtFrozen(this, key);
	  },
	  set: function set(key, value) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) entry[1] = value;else this.a.push([key, value]);
	  },
	  'delete': function _delete(key) {
	    var index = arrayFindIndex(this.a, function (it) {
	      return it[0] === key;
	    });
	    if (~index) this.a.splice(index, 1);
	    return !!~index;
	  }
	};
	
	module.exports = {
	  getConstructor: function getConstructor(wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      anInstance(that, C, NAME, '_i');
	      that._t = NAME; // collection type
	      that._i = id++; // collection id
	      that._l = undefined; // leak store for uncaught frozen objects
	      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.3.3.2 WeakMap.prototype.delete(key)
	      // 23.4.3.3 WeakSet.prototype.delete(value)
	      'delete': function _delete(key) {
	        if (!isObject(key)) return false;
	        var data = getWeak(key);
	        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
	        return data && $has(data, this._i) && delete data[this._i];
	      },
	      // 23.3.3.4 WeakMap.prototype.has(key)
	      // 23.4.3.4 WeakSet.prototype.has(value)
	      has: function has(key) {
	        if (!isObject(key)) return false;
	        var data = getWeak(key);
	        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
	        return data && $has(data, this._i);
	      }
	    });
	    return C;
	  },
	  def: function def(that, key, value) {
	    var data = getWeak(anObject(key), true);
	    if (data === true) uncaughtFrozenStore(that).set(key, value);else data[that._i] = value;
	    return that;
	  },
	  ufstore: uncaughtFrozenStore
	};

/***/ },
/* 208 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
	
	var isArray = __webpack_require__(108);
	var isObject = __webpack_require__(14);
	var toLength = __webpack_require__(22);
	var ctx = __webpack_require__(44);
	var IS_CONCAT_SPREADABLE = __webpack_require__(17)('isConcatSpreadable');
	
	function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
	  var targetIndex = start;
	  var sourceIndex = 0;
	  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
	  var element, spreadable;
	
	  while (sourceIndex < sourceLen) {
	    if (sourceIndex in source) {
	      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];
	
	      spreadable = false;
	      if (isObject(element)) {
	        spreadable = element[IS_CONCAT_SPREADABLE];
	        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
	      }
	
	      if (spreadable && depth > 0) {
	        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
	      } else {
	        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
	        target[targetIndex] = element;
	      }
	
	      targetIndex++;
	    }
	    sourceIndex++;
	  }
	  return targetIndex;
	}
	
	module.exports = flattenIntoArray;

/***/ },
/* 209 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = !__webpack_require__(20) && !__webpack_require__(10)(function () {
	  return Object.defineProperty(__webpack_require__(134)('div'), 'a', { get: function get() {
	      return 7;
	    } }).a != 7;
	});

/***/ },
/* 210 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// 20.1.2.3 Number.isInteger(number)
	var isObject = __webpack_require__(14);
	var floor = Math.floor;
	module.exports = function isInteger(it) {
	  return !isObject(it) && isFinite(it) && floor(it) === it;
	};

/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(7);
	module.exports = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	    // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) anObject(ret.call(iterator));
	    throw e;
	  }
	};

/***/ },
/* 212 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};

/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// 20.2.2.16 Math.fround(x)
	var sign = __webpack_require__(143);
	var pow = Math.pow;
	var EPSILON = pow(2, -52);
	var EPSILON32 = pow(2, -23);
	var MAX32 = pow(2, 127) * (2 - EPSILON32);
	var MIN32 = pow(2, -126);
	
	var roundTiesToEven = function roundTiesToEven(n) {
	  return n + 1 / EPSILON - 1 / EPSILON;
	};
	
	module.exports = Math.fround || function fround(x) {
	  var $abs = Math.abs(x);
	  var $sign = sign(x);
	  var a, result;
	  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
	  a = (1 + EPSILON32 / EPSILON) * $abs;
	  result = a - (a - $abs);
	  // eslint-disable-next-line no-self-compare
	  if (result > MAX32 || result != result) return $sign * Infinity;
	  return $sign * result;
	};

/***/ },
/* 214 */
/***/ function(module, exports) {

	"use strict";
	
	// 20.2.2.20 Math.log1p(x)
	module.exports = Math.log1p || function log1p(x) {
	  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
	};

/***/ },
/* 215 */
/***/ function(module, exports) {

	"use strict";
	
	// https://rwaldron.github.io/proposal-math-extensions/
	module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
	  if (arguments.length === 0
	  // eslint-disable-next-line no-self-compare
	  || x != x
	  // eslint-disable-next-line no-self-compare
	  || inLow != inLow
	  // eslint-disable-next-line no-self-compare
	  || inHigh != inHigh
	  // eslint-disable-next-line no-self-compare
	  || outLow != outLow
	  // eslint-disable-next-line no-self-compare
	  || outHigh != outHigh) return NaN;
	  if (x === Infinity || x === -Infinity) return x;
	  return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
	};

/***/ },
/* 216 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	
	var getKeys = __webpack_require__(62);
	var gOPS = __webpack_require__(112);
	var pIE = __webpack_require__(92);
	var toObject = __webpack_require__(24);
	var IObject = __webpack_require__(91);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(10)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) {
	    B[k] = k;
	  });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) {
	  // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) {
	      if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
	    }
	  }return T;
	} : $assign;

/***/ },
/* 217 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var dP = __webpack_require__(21);
	var anObject = __webpack_require__(7);
	var getKeys = __webpack_require__(62);
	
	module.exports = __webpack_require__(20) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) {
	    dP.f(O, P = keys[i++], Properties[P]);
	  }return O;
	};

/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(37);
	var gOPN = __webpack_require__(69).f;
	var toString = {}.toString;
	
	var windowNames = (typeof window === 'undefined' ? 'undefined' : _typeof(window)) == 'object' && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function getWindowNames(it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it) {
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};

/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var has = __webpack_require__(33);
	var toIObject = __webpack_require__(37);
	var arrayIndexOf = __webpack_require__(103)(false);
	var IE_PROTO = __webpack_require__(147)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) {
	    if (key != IE_PROTO) has(O, key) && result.push(key);
	  } // Don't enum bug & hidden keys
	  while (names.length > i) {
	    if (has(O, key = names[i++])) {
	      ~arrayIndexOf(result, key) || result.push(key);
	    }
	  }return result;
	};

/***/ },
/* 220 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var getKeys = __webpack_require__(62);
	var toIObject = __webpack_require__(37);
	var isEnum = __webpack_require__(92).f;
	module.exports = function (isEntries) {
	  return function (it) {
	    var O = toIObject(it);
	    var keys = getKeys(O);
	    var length = keys.length;
	    var i = 0;
	    var result = [];
	    var key;
	    while (length > i) {
	      if (isEnum.call(O, key = keys[i++])) {
	        result.push(isEntries ? [key, O[key]] : O[key]);
	      }
	    }return result;
	  };
	};

/***/ },
/* 221 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// all object keys, includes non-enumerable and symbols
	var gOPN = __webpack_require__(69);
	var gOPS = __webpack_require__(112);
	var anObject = __webpack_require__(7);
	var Reflect = __webpack_require__(8).Reflect;
	module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
	  var keys = gOPN.f(anObject(it));
	  var getSymbols = gOPS.f;
	  return getSymbols ? keys.concat(getSymbols(it)) : keys;
	};

/***/ },
/* 222 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var $parseFloat = __webpack_require__(8).parseFloat;
	var $trim = __webpack_require__(79).trim;
	
	module.exports = 1 / $parseFloat(__webpack_require__(151) + '-0') !== -Infinity ? function parseFloat(str) {
	  var string = $trim(String(str), 3);
	  var result = $parseFloat(string);
	  return result === 0 && string.charAt(0) == '-' ? -0 : result;
	} : $parseFloat;

/***/ },
/* 223 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var $parseInt = __webpack_require__(8).parseInt;
	var $trim = __webpack_require__(79).trim;
	var ws = __webpack_require__(151);
	var hex = /^[-+]?0[xX]/;
	
	module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
	  var string = $trim(String(str), 3);
	  return $parseInt(string, radix >>> 0 || (hex.test(string) ? 16 : 10));
	} : $parseInt;

/***/ },
/* 224 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = function (exec) {
	  try {
	    return { e: false, v: exec() };
	  } catch (e) {
	    return { e: true, v: e };
	  }
	};

/***/ },
/* 225 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var newPromiseCapability = __webpack_require__(145);
	
	module.exports = function (C, x) {
	  var promiseCapability = newPromiseCapability.f(C);
	  var resolve = promiseCapability.resolve;
	  resolve(x);
	  return promiseCapability.promise;
	};

/***/ },
/* 226 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// https://github.com/tc39/proposal-string-pad-start-end
	var toLength = __webpack_require__(22);
	var repeat = __webpack_require__(150);
	var defined = __webpack_require__(49);
	
	module.exports = function (that, maxLength, fillString, left) {
	  var S = String(defined(that));
	  var stringLength = S.length;
	  var fillStr = fillString === undefined ? ' ' : String(fillString);
	  var intMaxLength = toLength(maxLength);
	  if (intMaxLength <= stringLength || fillStr == '') return S;
	  var fillLen = intMaxLength - stringLength;
	  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
	  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
	  return left ? stringFiller + S : S + stringFiller;
	};

/***/ },
/* 227 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// https://tc39.github.io/ecma262/#sec-toindex
	var toInteger = __webpack_require__(51);
	var toLength = __webpack_require__(22);
	module.exports = function (it) {
	  if (it === undefined) return 0;
	  var number = toInteger(it);
	  var length = toLength(number);
	  if (number !== length) throw RangeError('Wrong length!');
	  return length;
	};

/***/ },
/* 228 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.f = __webpack_require__(17);

/***/ },
/* 229 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var strong = __webpack_require__(205);
	var validate = __webpack_require__(80);
	var MAP = 'Map';
	
	// 23.1 Map Objects
	module.exports = __webpack_require__(104)(MAP, function (get) {
	  return function Map() {
	    return get(this, arguments.length > 0 ? arguments[0] : undefined);
	  };
	}, {
	  // 23.1.3.6 Map.prototype.get(key)
	  get: function get(key) {
	    var entry = strong.getEntry(validate(this, MAP), key);
	    return entry && entry.v;
	  },
	  // 23.1.3.9 Map.prototype.set(key, value)
	  set: function set(key, value) {
	    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
	  }
	}, strong, true);

/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// 21.2.5.3 get RegExp.prototype.flags()
	if (__webpack_require__(20) && /./g.flags != 'g') __webpack_require__(21).f(RegExp.prototype, 'flags', {
	  configurable: true,
	  get: __webpack_require__(106)
	});

/***/ },
/* 231 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var strong = __webpack_require__(205);
	var validate = __webpack_require__(80);
	var SET = 'Set';
	
	// 23.2 Set Objects
	module.exports = __webpack_require__(104)(SET, function (get) {
	  return function Set() {
	    return get(this, arguments.length > 0 ? arguments[0] : undefined);
	  };
	}, {
	  // 23.2.3.1 Set.prototype.add(value)
	  add: function add(value) {
	    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
	  }
	}, strong);

/***/ },
/* 232 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var each = __webpack_require__(47)(0);
	var redefine = __webpack_require__(35);
	var meta = __webpack_require__(61);
	var assign = __webpack_require__(216);
	var weak = __webpack_require__(207);
	var isObject = __webpack_require__(14);
	var fails = __webpack_require__(10);
	var validate = __webpack_require__(80);
	var WEAK_MAP = 'WeakMap';
	var getWeak = meta.getWeak;
	var isExtensible = Object.isExtensible;
	var uncaughtFrozenStore = weak.ufstore;
	var tmp = {};
	var InternalMap;
	
	var wrapper = function wrapper(get) {
	  return function WeakMap() {
	    return get(this, arguments.length > 0 ? arguments[0] : undefined);
	  };
	};
	
	var methods = {
	  // 23.3.3.3 WeakMap.prototype.get(key)
	  get: function get(key) {
	    if (isObject(key)) {
	      var data = getWeak(key);
	      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
	      return data ? data[this._i] : undefined;
	    }
	  },
	  // 23.3.3.5 WeakMap.prototype.set(key, value)
	  set: function set(key, value) {
	    return weak.def(validate(this, WEAK_MAP), key, value);
	  }
	};
	
	// 23.3 WeakMap Objects
	var $WeakMap = module.exports = __webpack_require__(104)(WEAK_MAP, wrapper, methods, weak, true, true);
	
	// IE11 WeakMap frozen keys fix
	if (fails(function () {
	  return new $WeakMap().set((Object.freeze || Object)(tmp), 7).get(tmp) != 7;
	})) {
	  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
	  assign(InternalMap.prototype, methods);
	  meta.NEED = true;
	  each(['delete', 'has', 'get', 'set'], function (key) {
	    var proto = $WeakMap.prototype;
	    var method = proto[key];
	    redefine(proto, key, function (a, b) {
	      // store frozen objects on internal weakmap shim
	      if (isObject(a) && !isExtensible(a)) {
	        if (!this._f) this._f = new InternalMap();
	        var result = this._f[key](a, b);
	        return key == 'set' ? this : result;
	        // store all the rest on native weakmap
	      }return method.call(this, a, b);
	    });
	  });
	}

/***/ },
/* 233 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var NativeCustomEvent = global.CustomEvent;
	
	function useNative() {
	  try {
	    var p = new NativeCustomEvent('cat', { detail: { foo: 'bar' } });
	    return 'cat' === p.type && 'bar' === p.detail.foo;
	  } catch (e) {}
	  return false;
	}
	
	/**
	 * Cross-browser `CustomEvent` constructor.
	 *
	 * https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent.CustomEvent
	 *
	 * @public
	 */
	
	module.exports = useNative() ? NativeCustomEvent :
	
	// IE >= 9
	'undefined' !== typeof document && 'function' === typeof document.createEvent ? function CustomEvent(type, params) {
	  var e = document.createEvent('CustomEvent');
	  if (params) {
	    e.initCustomEvent(type, params.bubbles, params.cancelable, params.detail);
	  } else {
	    e.initCustomEvent(type, false, false, void 0);
	  }
	  return e;
	} :
	
	// IE <= 8
	function CustomEvent(type, params) {
	  var e = document.createEventObject();
	  e.type = type;
	  if (params) {
	    e.bubbles = Boolean(params.bubbles);
	    e.cancelable = Boolean(params.cancelable);
	    e.detail = params.detail;
	  } else {
	    e.bubbles = false;
	    e.cancelable = false;
	    e.detail = void 0;
	  }
	  return e;
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 234 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var ImageHash = {};
	function requireAll(r) {
	  r.keys().forEach(function (key) {
	    var hashKey = key.substring(2);
	    ImageHash[hashKey] = r('' + key);
	  });
	}
	requireAll(__webpack_require__(1039));
	
	exports.default = ImageHash;

/***/ },
/* 235 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(28);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var BackLinkHeader = function BackLinkHeader(_ref) {
	  var alt = _ref.alt,
	      href = _ref.href,
	      title = _ref.title,
	      props = _objectWithoutProperties(_ref, ['alt', 'href', 'title']);
	
	  return _react2.default.createElement(
	    'header',
	    { className: 'go-back' },
	    _react2.default.createElement(
	      'a',
	      { className: 'arrow-back-button', href: href },
	      _react2.default.createElement('img', { src: __webpack_require__(398), alt: alt })
	    ),
	    _react2.default.createElement(
	      'h1',
	      null,
	      title
	    ),
	    _react2.default.createElement(
	      'button',
	      { className: 'vst-href-text-button print-link', onClick: _utils2.default.printReceipt },
	      i18n.t('transactions.print-receipt')
	    )
	  );
	};
	
	exports.default = BackLinkHeader;

/***/ },
/* 236 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(28);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _price = __webpack_require__(118);
	
	var _price2 = _interopRequireDefault(_price);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TransactionDetailHeader = function TransactionDetailHeader(_ref) {
	  var total = _ref.total,
	      t = _ref.transaction,
	      transactionType = _ref.transactionType;
	
	  var vat = _utils2.default.vat(t.currency);
	
	  var _transactionTotal = function _transactionTotal() {
	    var p = parseFloat(total || t.total);
	    return Math.abs(p);
	  };
	
	  var _creditCard = function _creditCard() {
	    var cc = t.creditCardNumber;
	    return cc && cc.substr(cc.length - 8, 8);
	  };
	
	  var quantity = null,
	      subTotal = null;
	  if (t.bulk && transactionType === 'refund') {
	    quantity = _react2.default.createElement(
	      'span',
	      null,
	      i18n.t('transactions.quantity'),
	      ': ',
	      _react2.default.createElement(
	        'span',
	        { className: 'quantity' },
	        t.purchaseItems.reduce(function (a, b) {
	          return a + b.quantity;
	        }, 0)
	      )
	    );
	    if (!vat) {
	      subTotal = _react2.default.createElement(
	        'strong',
	        { className: 'sub-total' },
	        i18n.t('transactions.subtotal'),
	        ': ',
	        _react2.default.createElement(_price2.default, { price: _utils2.default.transactionSubtotal(t), currency: t.currency, skipCurrency: true })
	      );
	    }
	  }
	
	  var _renderSubTaxes = function _renderSubTaxes() {
	    if (t.currency === "AUD" || t.currency === "GBP") {
	      return;
	    }
	    var taxRates = {};
	    var subTaxes = t.purchaseItems.reduce(function (a, b, i) {
	      if (!b.taxes) {
	        return a;
	      }
	      b.taxes.forEach(function (obj) {
	        var jurisdictionCode = obj.jurisdictionCode,
	            tax = obj.tax,
	            taxRate = obj.taxRate;
	
	        if (jurisdictionCode) {
	          var js = jurisdictionCode.slice(2);
	          a[js] = a[js] ? a[js] + parseFloat(tax) : parseFloat(tax);
	          if (i === 0) {
	            taxRates[js] = taxRates[js] ? taxRates[js] + parseFloat(taxRate) : parseFloat(taxRate);
	          }
	        }
	      });
	      return a;
	    }, {});
	    if (subTaxes.HST) {
	      var HST = subTaxes.HST;
	      delete subTaxes.HST;
	      var GST = subTaxes.GST || 0;
	      delete subTaxes.GST;
	
	      subTaxes["GST/HST"] = GST + HST;
	      taxRates["GST/HST"] = (taxRates.GST || 0) + taxRates.HST;
	    }
	
	    var keys = Object.keys(subTaxes).sort();
	    if (keys.length) {
	      return keys.map(function (key) {
	        var tax = subTaxes[key];
	        var s = _utils2.default.transactionSubtotal(t);
	        if (tax || key === "PST") {
	          return _react2.default.createElement(
	            'span',
	            { key: key },
	            i18n.t("transactions.portion", { subTax: key, rate: _utils2.default.taxRate(taxRates[key]) }),
	            ': ',
	            _react2.default.createElement(_price2.default, { price: tax, currency: t.currency, skipCurrency: true })
	          );
	        }
	      });
	    }
	  };
	
	  var _renderPrice = function _renderPrice() {
	    if (vat) {
	      return '';
	    }
	    if (transactionType === 'refund') {
	      var price = t.purchaseItems.map(function (i) {
	        return parseFloat(i.itemPrice);
	      }).reduce(function (a, b) {
	        return a + b;
	      });
	      return _react2.default.createElement(
	        'span',
	        null,
	        i18n.t('transactions.price'),
	        ': ',
	        _react2.default.createElement(_price2.default, { price: price, currency: t.currency, skipCurrency: true })
	      );
	    } else {
	      return _react2.default.createElement(
	        'span',
	        null,
	        i18n.t('transactions.subtotal'),
	        ': ',
	        _react2.default.createElement(_price2.default, { price: _utils2.default.transactionSubtotal(t), currency: t.currency, skipCurrency: true })
	      );
	    }
	  };
	
	  var _renderTax = function _renderTax() {
	    var tax = parseFloat(t.total) - t.purchaseItems.reduce(function (a, b) {
	      return a + parseFloat(b.itemPrice) * b.quantity;
	    }, 0);
	    var subTaxes = _renderSubTaxes();
	    if (vat) {
	      if (subTaxes) {
	        return subTaxes;
	      }
	      return _react2.default.createElement(
	        'span',
	        null,
	        i18n.t('transactions.total-vat', { vat: vat }),
	        ': ',
	        _react2.default.createElement(_price2.default, { price: tax, currency: t.currency, skipCurrency: true })
	      );
	    } else {
	      if (subTaxes) {
	        return subTaxes;
	      }
	      return _react2.default.createElement(
	        'span',
	        null,
	        i18n.t('transactions.tax'),
	        ': ',
	        _react2.default.createElement(_price2.default, { price: tax, currency: t.currency, skipCurrency: true })
	      );
	    }
	  };
	
	  var _renderVATDisclosure = function _renderVATDisclosure() {
	    if (!vat) {
	      return '';
	    }
	    return _react2.default.createElement(
	      'span',
	      { className: 'vat-disclosure light' },
	      i18n.t('transactions.vat-disclosure', { vat: vat })
	    );
	  };
	
	  var _sellerVat = function _sellerVat() {
	    var sellerVat = void 0;
	    switch (vat) {
	      case "VAT":
	        sellerVat = i18n.t('transactions.seller-vat') + ': GB 792 2825 05';
	        break;
	      case "GST":
	        sellerVat = "Seller AU GST: ARN # 300009028961";
	        break;
	      default:
	        sellerVat = '';
	    }
	    return sellerVat;
	  };
	
	  var dateTitle = transactionType === 'refund' ? i18n.t('refunds.refunded') : i18n.t('transactions.purchased');
	  var cardType = t.creditCardType && t.creditCardType.toUpperCase();
	  return _react2.default.createElement(
	    'div',
	    { className: 'clear header' },
	    _react2.default.createElement(
	      'div',
	      { className: 'left' },
	      _react2.default.createElement(
	        'span',
	        null,
	        dateTitle,
	        ': ',
	        _utils2.default.toDateString(t.orderDate)
	      ),
	      _react2.default.createElement(
	        'span',
	        null,
	        i18n.t('transactions.confirmation#'),
	        ': ',
	        t.number
	      ),
	      _react2.default.createElement(
	        'span',
	        null,
	        i18n.t('transactions.payment'),
	        ': ',
	        cardType,
	        ' ',
	        _creditCard()
	      ),
	      vat && _react2.default.createElement(
	        'span',
	        null,
	        _sellerVat()
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'right' },
	      _renderPrice(),
	      quantity,
	      subTotal,
	      _renderTax(),
	      _react2.default.createElement(
	        'strong',
	        { className: 'total' },
	        i18n.t('transactions.total'),
	        ': ',
	        _react2.default.createElement(_price2.default, { price: _transactionTotal(), currency: t.currency })
	      ),
	      _renderVATDisclosure()
	    )
	  );
	};
	
	exports.default = TransactionDetailHeader;

/***/ },
/* 237 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _events = __webpack_require__(82);
	
	var _dispatcher = __webpack_require__(18);
	
	var _dispatcher2 = _interopRequireDefault(_dispatcher);
	
	var _objectAssign = __webpack_require__(11);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AccessCodesStore = (0, _objectAssign2.default)({}, _events.EventEmitter.prototype, {
	
	  _state: undefined,
	  isLoading: false,
	
	  _updateState: function _updateState(state) {
	    this._state = state;
	    _dispatcher2.default.emit(_dispatcher2.default.ACCESS_CODE_STORE_CHANGE);
	  },
	  get: function get(id) {
	    this._load();
	    return this._state ? this._state[id] : undefined;
	  },
	  getAll: function getAll(update) {
	    this._load(update);
	    return this._state || undefined;
	  },
	  _filterResponse: function _filterResponse(data) {
	
	    // Widths coming back in response, can use this if we don't feel like hard coding
	    var width = 60;
	
	    data.licenses.map(function (item) {
	      item.coverURL = data.coverURL.replace(":isbn", item.isbn).replace(":width", width);
	
	      return item;
	    });
	    return data;
	  },
	  _load: function _load(update) {
	    if (!this.isLoading && (update || this._state === undefined)) {
	      this.isLoading = true;
	      Jigsaw.getAllAccessCodes(function (response) {
	        if (response.isSuccess()) {
	          this._updateState(this._filterResponse(response.data));
	        } else {
	          this._updateState({ licenses: [] });
	        }
	        this.isLoading = false;
	      }.bind(this));
	    }
	  },
	  init: function init() {}
	});
	
	AccessCodesStore.init();
	exports.default = AccessCodesStore;

/***/ },
/* 238 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var emptyFunction = __webpack_require__(41);
	
	/**
	 * Upstream version of event listener. Does not take into account specific
	 * nature of platform.
	 */
	var EventListener = {
	  /**
	   * Listen to DOM events during the bubble phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  listen: function listen(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, false);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, false);
	        }
	      };
	    } else if (target.attachEvent) {
	      target.attachEvent('on' + eventType, callback);
	      return {
	        remove: function remove() {
	          target.detachEvent('on' + eventType, callback);
	        }
	      };
	    }
	  },
	
	  /**
	   * Listen to DOM events during the capture phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  capture: function capture(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, true);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, true);
	        }
	      };
	    } else {
	      if (false) {
	        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
	      }
	      return {
	        remove: emptyFunction
	      };
	    }
	  },
	
	  registerDefault: function registerDefault() {}
	};
	
	module.exports = EventListener;

/***/ },
/* 239 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var camelize = __webpack_require__(772);
	
	var msPattern = /^-ms-/;
	
	/**
	 * Camelcases a hyphenated CSS property name, for example:
	 *
	 *   > camelizeStyleName('background-color')
	 *   < "backgroundColor"
	 *   > camelizeStyleName('-moz-transition')
	 *   < "MozTransition"
	 *   > camelizeStyleName('-ms-transition')
	 *   < "msTransition"
	 *
	 * As Andi Smith suggests
	 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
	 * is converted to lowercase `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelizeStyleName(string) {
	  return camelize(string.replace(msPattern, 'ms-'));
	}
	
	module.exports = camelizeStyleName;

/***/ },
/* 240 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * @param {DOMElement} node input/textarea to focus
	 */
	
	function focusNode(node) {
	  // IE8 can throw "Can't move focus to the control because it is invisible,
	  // not enabled, or of a type that does not accept the focus." for all kinds of
	  // reasons that are too expensive and fragile to test.
	  try {
	    node.focus();
	  } catch (e) {}
	}
	
	module.exports = focusNode;

/***/ },
/* 241 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	/* eslint-disable fb-www/typeof-undefined */
	
	/**
	 * Same as document.activeElement but wraps in a try-catch block. In IE it is
	 * not safe to call document.activeElement if there is nothing focused.
	 *
	 * The activeElement will be null only if the document or document body is not
	 * yet defined.
	 *
	 * @param {?DOMDocument} doc Defaults to current document.
	 * @return {?DOMElement}
	 */
	
	function getActiveElement(doc) /*?DOMElement*/{
	  doc = doc || (typeof document !== 'undefined' ? document : undefined);
	  if (typeof doc === 'undefined') {
	    return null;
	  }
	  try {
	    return doc.activeElement || doc.body;
	  } catch (e) {
	    return doc.body;
	  }
	}
	
	module.exports = getActiveElement;

/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var hyphenate = __webpack_require__(778);
	
	var msPattern = /^ms-/;
	
	/**
	 * Hyphenates a camelcased CSS property name, for example:
	 *
	 *   > hyphenateStyleName('backgroundColor')
	 *   < "background-color"
	 *   > hyphenateStyleName('MozTransition')
	 *   < "-moz-transition"
	 *   > hyphenateStyleName('msTransition')
	 *   < "-ms-transition"
	 *
	 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
	 * is converted to `-ms-`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenateStyleName(string) {
	  return hyphenate(string).replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;

/***/ },
/* 243 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Memoizes the return value of a function that accepts one string argument.
	 */
	
	function memoizeStringOnly(callback) {
	  var cache = {};
	  return function (string) {
	    if (!cache.hasOwnProperty(string)) {
	      cache[string] = callback.call(this, string);
	    }
	    return cache[string];
	  };
	}
	
	module.exports = memoizeStringOnly;

/***/ },
/* 244 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.processStyleName = undefined;
	exports.createMarkupForStyles = createMarkupForStyles;
	
	var _camelizeStyleName = __webpack_require__(239);
	
	var _camelizeStyleName2 = _interopRequireDefault(_camelizeStyleName);
	
	var _dangerousStyleValue = __webpack_require__(783);
	
	var _dangerousStyleValue2 = _interopRequireDefault(_dangerousStyleValue);
	
	var _hyphenateStyleName = __webpack_require__(242);
	
	var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);
	
	var _memoizeStringOnly = __webpack_require__(243);
	
	var _memoizeStringOnly2 = _interopRequireDefault(_memoizeStringOnly);
	
	var _warning = __webpack_require__(9);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	var processStyleName = exports.processStyleName = (0, _memoizeStringOnly2.default)(_hyphenateStyleName2.default); /**
	                                                                                                                   * Copyright 2013-present, Facebook, Inc.
	                                                                                                                   * All rights reserved.
	                                                                                                                   *
	                                                                                                                   * This source code is licensed under the BSD-style license found in the
	                                                                                                                   * LICENSE file in the root directory of this source tree. An additional grant
	                                                                                                                   * of patent rights can be found in the PATENTS file in the same directory.
	                                                                                                                   *
	                                                                                                                   * @providesModule CSSPropertyOperations
	                                                                                                                   */
	
	if (false) {
	  // 'msTransform' is correct, but the other prefixes should be capitalized
	  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
	
	  // style values shouldn't contain a semicolon
	  var badStyleValueWithSemicolonPattern = /;\s*$/;
	
	  var warnedStyleNames = {};
	  var warnedStyleValues = {};
	  var warnedForNaNValue = false;
	
	  var warnHyphenatedStyleName = function warnHyphenatedStyleName(name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? (0, _warning2.default)(false, 'Unsupported style property %s. Did you mean %s?%s', name, (0, _camelizeStyleName2.default)(name), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnBadVendoredStyleName = function warnBadVendoredStyleName(name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? (0, _warning2.default)(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnStyleValueWithSemicolon = function warnStyleValueWithSemicolon(name, value, owner) {
	    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
	      return;
	    }
	
	    warnedStyleValues[value] = true;
	    process.env.NODE_ENV !== 'production' ? (0, _warning2.default)(false, 'Style property values shouldn\'t contain a semicolon.%s ' + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
	  };
	
	  var warnStyleValueIsNaN = function warnStyleValueIsNaN(name, value, owner) {
	    if (warnedForNaNValue) {
	      return;
	    }
	
	    warnedForNaNValue = true;
	    process.env.NODE_ENV !== 'production' ? (0, _warning2.default)(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
	  };
	
	  var checkRenderMessage = function checkRenderMessage(owner) {
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' Check the render method of `' + name + '`.';
	      }
	    }
	    return '';
	  };
	
	  /**
	   * @param {string} name
	   * @param {*} value
	   * @param {ReactDOMComponent} component
	   */
	  var warnValidStyle = function warnValidStyle(name, value, component) {
	    //eslint-disable-line no-var
	    var owner = void 0;
	    if (component) {
	      owner = component._currentElement._owner;
	    }
	    if (name.indexOf('-') > -1) {
	      warnHyphenatedStyleName(name, owner);
	    } else if (badVendoredStyleNamePattern.test(name)) {
	      warnBadVendoredStyleName(name, owner);
	    } else if (badStyleValueWithSemicolonPattern.test(value)) {
	      warnStyleValueWithSemicolon(name, value, owner);
	    }
	
	    if (typeof value === 'number' && isNaN(value)) {
	      warnStyleValueIsNaN(name, value, owner);
	    }
	  };
	}
	
	/**
	   * Serializes a mapping of style properties for use as inline styles:
	   *
	   *   > createMarkupForStyles({width: '200px', height: 0})
	   *   "width:200px;height:0;"
	   *
	   * Undefined values are ignored so that declarative programming is easier.
	   * The result should be HTML-escaped before insertion into the DOM.
	   *
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   * @return {?string}
	   */
	
	function createMarkupForStyles(styles, component) {
	  var serialized = '';
	  for (var styleName in styles) {
	    var isCustomProp = styleName.indexOf('--') === 0;
	    if (!styles.hasOwnProperty(styleName)) {
	      continue;
	    }
	    if (styleName === 'label') {
	      continue;
	    }
	    var styleValue = styles[styleName];
	    if (false) {
	      warnValidStyle(styleName, styleValue, component);
	    }
	    if (styleValue != null) {
	      if (isCustomProp) {
	        serialized += styleName + ':' + styleValue + ';';
	      } else {
	        serialized += processStyleName(styleName) + ':';
	        serialized += (0, _dangerousStyleValue2.default)(styleName, styleValue, component) + ';';
	      }
	    }
	  }
	  return serialized || null;
	}

/***/ },
/* 245 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	(function (global, factory) {
	  ( false ? 'undefined' : _typeof2(exports)) === 'object' && typeof module !== 'undefined' ? module.exports = factory() :  true ? !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : (global = global || self, global.Honeybadger = factory());
	})(undefined, function () {
	  'use strict';
	
	  function _typeof(obj) {
	    if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	      _typeof = function _typeof(obj) {
	        return typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
	      };
	    } else {
	      _typeof = function _typeof(obj) {
	        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
	      };
	    }
	
	    return _typeof(obj);
	  }
	
	  function builder() {
	    var VERSION = '2.0.0',
	        NOTIFIER = {
	      name: 'honeybadger.js',
	      url: 'https://github.com/honeybadger-io/honeybadger-js',
	      version: VERSION,
	      language: 'javascript'
	    }; // Used to control initial setup across clients.
	
	    var loaded = false,
	        installed = false; // Used to prevent reporting duplicate errors across instances.
	
	    var currentErr, currentPayload; // Utilities.
	
	    function merge(obj1, obj2) {
	      var obj3 = {};
	
	      for (var k in obj1) {
	        obj3[k] = obj1[k];
	      }
	
	      for (var k in obj2) {
	        obj3[k] = obj2[k];
	      }
	
	      return obj3;
	    }
	
	    function mergeErr(err1, err2) {
	      var ret = merge(err1, err2);
	
	      if (err1.context && err2.context) {
	        ret.context = merge(err1.context, err2.context);
	      }
	
	      return ret;
	    }
	
	    function currentErrIs(err) {
	      if (!currentErr) {
	        return false;
	      }
	
	      if (currentErr.name !== err.name) {
	        return false;
	      }
	
	      if (currentErr.message !== err.message) {
	        return false;
	      }
	
	      if (currentErr.stack !== err.stack) {
	        return false;
	      }
	
	      return true;
	    }
	
	    function isIgnored(err, patterns) {
	      var msg = err.message;
	
	      for (var p in patterns) {
	        if (msg.match(patterns[p])) {
	          return true;
	        }
	      }
	
	      return false;
	    }
	
	    function cgiData() {
	      var data = {};
	      data['HTTP_USER_AGENT'] = navigator.userAgent;
	
	      if (document.referrer.match(/\S/)) {
	        data['HTTP_REFERER'] = document.referrer;
	      }
	
	      return data;
	    }
	
	    function encodeCookie(object) {
	      if (_typeof(object) !== 'object') {
	        return undefined;
	      }
	
	      var cookies = [];
	
	      for (var k in object) {
	        cookies.push(k + '=' + object[k]);
	      }
	
	      return cookies.join(';');
	    }
	
	    function stackTrace(err) {
	      // From TraceKit: Opera 10 *destroys* its stacktrace property if you try to
	      // access the stack property first.
	      return err.stacktrace || err.stack || undefined;
	    }
	
	    function generateStackTrace(err) {
	      var stack;
	      var maxStackSize = 10;
	
	      if (err && (stack = stackTrace(err))) {
	        return {
	          stack: stack,
	          generator: undefined
	        };
	      }
	
	      try {
	        throw new Error('');
	      } catch (e) {
	        if (stack = stackTrace(e)) {
	          return {
	            stack: stack,
	            generator: 'throw'
	          };
	        }
	      }
	
	      stack = ['<call-stack>'];
	      var curr = arguments.callee;
	
	      while (curr && stack.length < maxStackSize) {
	        if (/function(?:\s+([\w$]+))+\s*\(/.test(curr.toString())) {
	          stack.push(RegExp.$1 || '<anonymous>');
	        } else {
	          stack.push('<anonymous>');
	        }
	
	        try {
	          curr = curr.caller;
	        } catch (e) {
	          break;
	        }
	      }
	
	      return {
	        stack: stack.join('\n'),
	        generator: 'walk'
	      };
	    }
	
	    function checkHandlers(handlers, err) {
	      var handler, i, len;
	
	      for (i = 0, len = handlers.length; i < len; i++) {
	        handler = handlers[i];
	
	        if (handler(err) === false) {
	          return true;
	        }
	      }
	
	      return false;
	    }
	
	    function objectIsEmpty(obj) {
	      for (var k in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, k)) {
	          return false;
	        }
	      }
	
	      return true;
	    }
	
	    function objectIsExtensible(obj) {
	      if (typeof Object.isExtensible !== 'function') {
	        return true;
	      }
	
	      return Object.isExtensible(obj);
	    } // Client factory.
	
	
	    var factory = function factory(opts) {
	      var notSingleton = installed;
	      var defaultProps = [];
	      var queue = [];
	      var self = {
	        context: {},
	        beforeNotifyHandlers: [],
	        errorsSent: 0
	      };
	
	      if (_typeof(opts) === 'object') {
	        for (var k in opts) {
	          self[k] = opts[k];
	        }
	      }
	
	      function log() {
	        var console = window.console;
	
	        if (console) {
	          var args = Array.prototype.slice.call(arguments);
	          args.unshift('[Honeybadger]');
	          console.log.apply(console, args);
	        }
	      }
	
	      function debug() {
	        if (config('debug')) {
	          return log.apply(this, arguments);
	        }
	      }
	
	      function config(key, fallback) {
	        var value = self[key];
	
	        if (value === undefined) {
	          value = self[key.toLowerCase()];
	        }
	
	        if (value === 'false') {
	          value = false;
	        }
	
	        if (value !== undefined) {
	          return value;
	        }
	
	        return fallback;
	      }
	
	      function onErrorEnabled() {
	        if (notSingleton) {
	          return false;
	        }
	
	        return config('onerror', true);
	      }
	
	      function onUnhandledRejectionEnabled() {
	        if (notSingleton) {
	          return false;
	        }
	
	        return config('onunhandledrejection', true);
	      }
	
	      function baseURL() {
	        return 'http' + (config('ssl', true) && 's' || '') + '://' + config('host', 'api.honeybadger.io');
	      }
	
	      function canSerialize(obj) {
	        // Functions are TMI and Symbols can't convert to strings.
	        if (/function|symbol/.test(_typeof(obj))) {
	          return false;
	        } // No prototype, likely created with `Object.create(null)`.
	
	
	        if (_typeof(obj) === 'object' && typeof obj.hasOwnProperty === 'undefined') {
	          return false;
	        }
	
	        return true;
	      }
	
	      function serialize(obj, depth) {
	        var k, v, ret;
	        ret = {};
	
	        if (!depth) {
	          depth = 0;
	        }
	
	        if (depth >= config('max_depth', 8)) {
	          return '[MAX DEPTH REACHED]';
	        }
	
	        for (k in obj) {
	          v = obj[k];
	
	          if (Object.prototype.hasOwnProperty.call(obj, k) && k != null && v != null) {
	            if (!canSerialize(v)) {
	              v = Object.prototype.toString.call(v);
	            }
	
	            ret[k] = _typeof(v) === 'object' ? serialize(v, depth + 1) : v;
	          }
	        }
	
	        return ret;
	      }
	
	      function request(apiKey, payload) {
	        try {
	          var x = new XMLHttpRequest();
	          x.open('POST', baseURL() + '/v1/notices/js', config('async', true));
	          x.setRequestHeader('X-API-Key', apiKey);
	          x.setRequestHeader('Content-Type', 'application/json');
	          x.setRequestHeader('Accept', 'text/json, application/json');
	          x.send(JSON.stringify(serialize(payload)));
	        } catch (err) {
	          log('Unable to send error report: error while initializing request', err, payload);
	        }
	      }
	
	      function send(payload) {
	        currentErr = currentPayload = null;
	
	        if (config('disabled', false)) {
	          debug('Dropping notice: honeybadger.js is disabled', payload);
	          return false;
	        }
	
	        var apiKey = config('apiKey', config('api_key'));
	
	        if (!apiKey) {
	          log('Unable to send error report: no API key has been configured');
	          return false;
	        }
	
	        if (exceedsMaxErrors()) {
	          debug('Dropping notice: max errors exceeded', payload);
	          return false;
	        }
	
	        incrementErrorsCount();
	        request(apiKey, payload);
	        return true;
	      }
	
	      function notify(err, generated) {
	        if (!err) {
	          err = {};
	        }
	
	        if (Object.prototype.toString.call(err) === '[object Error]') {
	          var e = err;
	          err = merge(err, {
	            name: e.name,
	            message: e.message,
	            stack: stackTrace(e)
	          });
	        }
	
	        if (!(_typeof(err) === 'object')) {
	          var m = String(err);
	          err = {
	            message: m
	          };
	        }
	
	        if (currentErrIs(err)) {
	          // Skip the duplicate error.
	          return false;
	        } else if (currentPayload && loaded) {
	          // This is a different error, send the old one now.
	          send(currentPayload);
	        }
	
	        if (objectIsEmpty(err)) {
	          return false;
	        }
	
	        var generator;
	
	        if (generated) {
	          err.stack = generated.stack;
	          generator = generated.generator;
	        }
	
	        err = merge(err, {
	          name: err.name || 'Error',
	          context: merge(self.context, err.context),
	          url: err.url || document.URL,
	          projectRoot: err.projectRoot || err.project_root || config('projectRoot', config('project_root', window.location.protocol + '//' + window.location.host)),
	          environment: err.environment || config('environment'),
	          component: err.component || config('component'),
	          action: err.action || config('action'),
	          revision: err.revision || config('revision')
	        });
	        var stack_before_handlers = err.stack;
	
	        if (checkHandlers(self.beforeNotifyHandlers, err)) {
	          return false;
	        }
	
	        if (err.stack != stack_before_handlers) {
	          // Stack changed, so it's not generated.
	          generator = undefined;
	        }
	
	        if (isIgnored(err, config('ignorePatterns'))) {
	          return false;
	        }
	
	        var data = cgiData();
	
	        if (typeof err.cookies === 'string') {
	          data['HTTP_COOKIE'] = err.cookies;
	        } else if (_typeof(err.cookies) === 'object') {
	          data['HTTP_COOKIE'] = encodeCookie(err.cookies);
	        }
	
	        var payload = {
	          'notifier': NOTIFIER,
	          'error': {
	            'class': err.name,
	            'message': err.message,
	            'backtrace': err.stack,
	            'generator': generator,
	            'fingerprint': err.fingerprint
	          },
	          'request': {
	            'url': err.url,
	            'component': err.component,
	            'action': err.action,
	            'context': err.context,
	            'cgi_data': data,
	            'params': err.params
	          },
	          'server': {
	            'project_root': err.projectRoot,
	            'environment_name': err.environment,
	            'revision': err.revision
	          }
	        };
	        currentPayload = payload;
	        currentErr = err;
	
	        if (loaded) {
	          debug('Deferring notice', err, payload);
	          window.setTimeout(function () {
	            if (currentErrIs(err)) {
	              send(payload);
	            }
	          });
	        } else {
	          debug('Queuing notice', err, payload);
	          queue.push(payload);
	        }
	
	        return err;
	      }
	
	      var preferCatch = true; // IE < 10
	
	      if (!window.atob) {
	        preferCatch = false;
	      } // See https://developer.mozilla.org/en-US/docs/Web/API/ErrorEvent
	
	
	      if (window.ErrorEvent) {
	        try {
	          if (new window.ErrorEvent('').colno === 0) {
	            preferCatch = false;
	          }
	        } catch (_e) {}
	      } // wrap always returns the same function so that callbacks can be removed via
	      // removeEventListener.
	
	
	      function wrap(fn, force) {
	        try {
	          if (typeof fn !== 'function') {
	            return fn;
	          }
	
	          if (!objectIsExtensible(fn)) {
	            return fn;
	          }
	
	          if (!fn.___hb) {
	            fn.___hb = function () {
	              var onerror = onErrorEnabled(); // Don't catch if the browser is old or supports the new error
	              // object and there is a window.onerror handler available instead.
	
	              if (preferCatch && (onerror || force) || force && !onerror) {
	                try {
	                  return fn.apply(this, arguments);
	                } catch (e) {
	                  notify(e);
	                  throw e;
	                }
	              } else {
	                return fn.apply(this, arguments);
	              }
	            };
	          }
	
	          fn.___hb.___hb = fn.___hb;
	          return fn.___hb;
	        } catch (_e) {
	          return fn;
	        }
	      } // Public API.
	
	
	      self.notify = function (err, name, extra) {
	        if (!err) {
	          err = {};
	        }
	
	        if (Object.prototype.toString.call(err) === '[object Error]') {
	          var e = err;
	          err = merge(err, {
	            name: e.name,
	            message: e.message,
	            stack: stackTrace(e)
	          });
	        }
	
	        if (!(_typeof(err) === 'object')) {
	          var m = String(err);
	          err = {
	            message: m
	          };
	        }
	
	        if (name && !(_typeof(name) === 'object')) {
	          var n = String(name);
	          name = {
	            name: n
	          };
	        }
	
	        if (name) {
	          err = mergeErr(err, name);
	        }
	
	        if (_typeof(extra) === 'object') {
	          err = mergeErr(err, extra);
	        }
	
	        return notify(err, generateStackTrace(err));
	      };
	
	      self.wrap = function (func) {
	        return wrap(func, true);
	      };
	
	      self.setContext = function (context) {
	        if (_typeof(context) === 'object') {
	          self.context = merge(self.context, context);
	        }
	
	        return self;
	      };
	
	      self.resetContext = function (context) {
	        if (_typeof(context) === 'object') {
	          self.context = merge({}, context);
	        } else {
	          self.context = {};
	        }
	
	        return self;
	      };
	
	      self.configure = function (opts) {
	        for (var k in opts) {
	          self[k] = opts[k];
	        }
	
	        return self;
	      };
	
	      self.beforeNotify = function (handler) {
	        self.beforeNotifyHandlers.push(handler);
	        return self;
	      };
	
	      var indexOf = [].indexOf || function (item) {
	        for (var i = 0, l = this.length; i < l; i++) {
	          if (i in this && this[i] === item) return i;
	        }
	
	        return -1;
	      };
	
	      self.reset = function () {
	        self.context = {};
	        self.beforeNotifyHandlers = [];
	
	        for (var k in self) {
	          if (indexOf.call(defaultProps, k) == -1) {
	            self[k] = undefined;
	          }
	        }
	
	        self.resetMaxErrors();
	        return self;
	      };
	
	      self.resetMaxErrors = function () {
	        return self.errorsSent = 0;
	      };
	
	      self.getVersion = function () {
	        return VERSION;
	      }; // Install instrumentation.
	      // This should happen once for the first factory call.
	
	
	      function instrument(object, name, replacement) {
	        if (notSingleton) {
	          return;
	        }
	
	        if (!object || !name || !replacement) {
	          return;
	        }
	
	        var original = object[name];
	        object[name] = replacement(original);
	      }
	
	      var instrumentTimer = function instrumentTimer(original) {
	        // See https://developer.mozilla.org/en-US/docs/Web/API/WindowTimers/setTimeout
	        return function (func, delay) {
	          if (typeof func === 'function') {
	            var args = Array.prototype.slice.call(arguments, 2);
	            func = wrap(func);
	            return original(function () {
	              func.apply(null, args);
	            }, delay);
	          } else {
	            return original(func, delay);
	          }
	        };
	      };
	
	      instrument(window, 'setTimeout', instrumentTimer);
	      instrument(window, 'setInterval', instrumentTimer); // Event targets borrowed from bugsnag-js:
	      // See https://github.com/bugsnag/bugsnag-js/blob/d55af916a4d3c7757f979d887f9533fe1a04cc93/src/bugsnag.js#L542
	
	      'EventTarget Window Node ApplicationCache AudioTrackList ChannelMergerNode CryptoOperation EventSource FileReader HTMLUnknownElement IDBDatabase IDBRequest IDBTransaction KeyOperation MediaController MessagePort ModalWindow Notification SVGElementInstance Screen TextTrack TextTrackCue TextTrackList WebSocket WebSocketWorker Worker XMLHttpRequest XMLHttpRequestEventTarget XMLHttpRequestUpload'.replace(/\w+/g, function (prop) {
	        var prototype = window[prop] && window[prop].prototype;
	
	        if (prototype && prototype.hasOwnProperty && prototype.hasOwnProperty('addEventListener')) {
	          instrument(prototype, 'addEventListener', function (original) {
	            // See https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener
	            return function (type, listener, useCapture, wantsUntrusted) {
	              try {
	                if (listener && listener.handleEvent != null) {
	                  listener.handleEvent = wrap(listener.handleEvent);
	                }
	              } catch (e) {
	                // Ignore 'Permission denied to access property "handleEvent"' errors.
	                log(e);
	              }
	
	              return original.call(this, type, wrap(listener), useCapture, wantsUntrusted);
	            };
	          });
	          instrument(prototype, 'removeEventListener', function (original) {
	            return function (type, listener, useCapture, wantsUntrusted) {
	              original.call(this, type, listener, useCapture, wantsUntrusted);
	              return original.call(this, type, wrap(listener), useCapture, wantsUntrusted);
	            };
	          });
	        }
	      });
	      instrument(window, 'onerror', function (original) {
	        function onerror(msg, url, line, col, err) {
	          debug('window.onerror callback invoked', arguments); // Skip if the error is already being sent.
	
	          if (currentErr) {
	            return;
	          }
	
	          if (!onErrorEnabled()) {
	            return;
	          }
	
	          if (line === 0 && /Script error\.?/.test(msg)) {
	            // See https://developer.mozilla.org/en/docs/Web/API/GlobalEventHandlers/onerror#Notes
	            log('Ignoring cross-domain script error: enable CORS to track these types of errors', arguments);
	            return;
	          } // simulate v8 stack
	
	
	          var stack = [msg, '\n    at ? (', url || 'unknown', ':', line || 0, ':', col || 0, ')'].join('');
	
	          if (err) {
	            var generated = {
	              stack: stackTrace(err)
	            };
	
	            if (!generated.stack) {
	              generated = {
	                stack: stack
	              };
	            }
	
	            notify(err, generated);
	            return;
	          }
	
	          notify({
	            name: 'window.onerror',
	            message: msg,
	            stack: stack
	          });
	        } // See https://developer.mozilla.org/en-US/docs/Web/API/GlobalEventHandlers/onerror
	
	
	        return function (msg, url, line, col, err) {
	          onerror(msg, url, line, col, err);
	
	          if (typeof original === 'function' && config('_onerror_call_orig', true)) {
	            return original.apply(this, arguments);
	          }
	
	          return false;
	        };
	      });
	      instrument(window, 'onunhandledrejection', function (original) {
	        // See https://developer.mozilla.org/en-US/docs/Web/API/Window/unhandledrejection_event
	        function onunhandledrejection(promiseRejectionEvent) {
	          debug('window.onunhandledrejection callback invoked', arguments); // Skip if the error is already being sent.
	
	          if (currentErr) {
	            return;
	          }
	
	          if (!onUnhandledRejectionEnabled()) {
	            return;
	          }
	
	          var reason = promiseRejectionEvent.reason;
	
	          if (reason instanceof Error) {
	            // simulate v8 stack
	            var fileName = reason.fileName || 'unknown';
	            var lineNumber = reason.lineNumber || 0;
	            var stackFallback = "".concat(reason.message, "\n    at ? (").concat(fileName, ":").concat(lineNumber, ")");
	            var stack = stackTrace(reason) || stackFallback;
	            notify({
	              name: reason.name,
	              message: "UnhandledPromiseRejectionWarning: ".concat(reason),
	              stack: stack
	            });
	            return;
	          }
	
	          var message = typeof reason === 'string' ? reason : JSON.stringify(reason);
	          notify({
	            name: 'window.onunhandledrejection',
	            message: "UnhandledPromiseRejectionWarning: ".concat(message)
	          });
	        }
	
	        return function (promiseRejectionEvent) {
	          onunhandledrejection(promiseRejectionEvent);
	
	          if (typeof original === 'function') {
	            original.apply(this, arguments);
	          }
	        };
	      });
	
	      function incrementErrorsCount() {
	        return self.errorsSent++;
	      }
	
	      function exceedsMaxErrors() {
	        var maxErrors = config('maxErrors');
	        return maxErrors && self.errorsSent >= maxErrors;
	      } // End of instrumentation.
	
	
	      installed = true; // Save original state for reset()
	
	      for (var k in self) {
	        defaultProps.push(k);
	      } // Initialization.
	
	
	      debug('Initializing honeybadger.js ' + VERSION); // See https://developer.mozilla.org/en-US/docs/Web/API/Document/readyState
	      // https://www.w3.org/TR/html5/dom.html#dom-document-readystate
	      // The 'loaded' state is for older versions of Safari.
	
	      if (/complete|interactive|loaded/.test(document.readyState)) {
	        loaded = true;
	        debug('honeybadger.js ' + VERSION + ' ready');
	      } else {
	        debug('Installing ready handler');
	
	        var domReady = function domReady() {
	          loaded = true;
	          debug('honeybadger.js ' + VERSION + ' ready');
	          var notice;
	
	          while (notice = queue.pop()) {
	            send(notice);
	          }
	        };
	
	        if (document.addEventListener) {
	          document.addEventListener('DOMContentLoaded', domReady, true);
	        } else {
	          window.attachEvent('onload', domReady);
	        }
	      }
	
	      return self;
	    };
	
	    return factory;
	  }
	
	  var factory = builder();
	  var singleton = factory();
	  singleton.factory = factory;
	
	  return singleton;
	});
	//# sourceMappingURL=honeybadger.js.map

/***/ },
/* 246 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = capitalizeString;
	function capitalizeString(str) {
	  return str.charAt(0).toUpperCase() + str.slice(1);
	}
	module.exports = exports["default"];

/***/ },
/* 247 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Afrikaans [af]
	//! author : Werner Mollentze : https://github.com/wernerm
	
	;(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var af = moment.defineLocale('af', {
	        months: 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split('_'),
	        monthsShort: 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
	        weekdays: 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split('_'),
	        weekdaysShort: 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
	        weekdaysMin: 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
	        meridiemParse: /vm|nm/i,
	        isPM: function isPM(input) {
	            return (/^nm$/i.test(input)
	            );
	        },
	        meridiem: function meridiem(hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'vm' : 'VM';
	            } else {
	                return isLower ? 'nm' : 'NM';
	            }
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[Vandag om] LT',
	            nextDay: '[Môre om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[Gister om] LT',
	            lastWeek: '[Laas] dddd [om] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'oor %s',
	            past: '%s gelede',
	            s: '\'n paar sekondes',
	            m: '\'n minuut',
	            mm: '%d minute',
	            h: '\'n uur',
	            hh: '%d ure',
	            d: '\'n dag',
	            dd: '%d dae',
	            M: '\'n maand',
	            MM: '%d maande',
	            y: '\'n jaar',
	            yy: '%d jaar'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function ordinal(number) {
	            return number + (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de'); // Thanks to Joris Röling : https://github.com/jjupiter
	        },
	        week: {
	            dow: 1, // Maandag is die eerste dag van die week.
	            doy: 4 // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
	        }
	    });
	
	    return af;
	});

/***/ },
/* 248 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Arabic (Algeria) [ar-dz]
	//! author : Noureddine LOUAHEDJ : https://github.com/noureddineme
	
	;(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var arDz = moment.defineLocale('ar-dz', {
	        months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'أح_إث_ثلا_أر_خم_جم_سب'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات'
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 4 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return arDz;
	});

/***/ },
/* 249 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Arabic (Kuwait) [ar-kw]
	//! author : Nusret Parlak: https://github.com/nusretparlak
	
	;(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var arKw = moment.defineLocale('ar-kw', {
	        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        monthsShort: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        weekdays: 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات'
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 12 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return arKw;
	});

/***/ },
/* 250 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Arabic (Lybia) [ar-ly]
	//! author : Ali Hmer: https://github.com/kikoanis
	
	;(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var symbolMap = {
	        '1': '1',
	        '2': '2',
	        '3': '3',
	        '4': '4',
	        '5': '5',
	        '6': '6',
	        '7': '7',
	        '8': '8',
	        '9': '9',
	        '0': '0'
	    };
	    var pluralForm = function pluralForm(n) {
	        return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	    };
	    var plurals = {
	        s: ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	        m: ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	        h: ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	        d: ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	        M: ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	        y: ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	    };
	    var pluralize = function pluralize(u) {
	        return function (number, withoutSuffix, string, isFuture) {
	            var f = pluralForm(number),
	                str = plurals[u][pluralForm(number)];
	            if (f === 2) {
	                str = str[withoutSuffix ? 0 : 1];
	            }
	            return str.replace(/%d/i, number);
	        };
	    };
	    var months = ['يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو', 'يوليو', 'أغسطس', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر'];
	
	    var arLy = moment.defineLocale('ar-ly', {
	        months: months,
	        monthsShort: months,
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/\u200FM/\u200FYYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ص|م/,
	        isPM: function isPM(input) {
	            return 'م' === input;
	        },
	        meridiem: function meridiem(hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'بعد %s',
	            past: 'منذ %s',
	            s: pluralize('s'),
	            m: pluralize('m'),
	            mm: pluralize('m'),
	            h: pluralize('h'),
	            hh: pluralize('h'),
	            d: pluralize('d'),
	            dd: pluralize('d'),
	            M: pluralize('M'),
	            MM: pluralize('M'),
	            y: pluralize('y'),
	            yy: pluralize('y')
	        },
	        preparse: function preparse(string) {
	            return string.replace(/\u200f/g, '').replace(/،/g, ',');
	        },
	        postformat: function postformat(string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return arLy;
	});

/***/ },
/* 251 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Arabic (Morocco) [ar-ma]
	//! author : ElFadili Yassine : https://github.com/ElFadiliY
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var arMa = moment.defineLocale('ar-ma', {
	        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        monthsShort: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        weekdays: 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات'
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return arMa;
	});

/***/ },
/* 252 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Arabic (Saudi Arabia) [ar-sa]
	//! author : Suhail Alkowaileet : https://github.com/xsoh
	
	;(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var symbolMap = {
	        '1': '١',
	        '2': '٢',
	        '3': '٣',
	        '4': '٤',
	        '5': '٥',
	        '6': '٦',
	        '7': '٧',
	        '8': '٨',
	        '9': '٩',
	        '0': '٠'
	    };
	    var numberMap = {
	        '١': '1',
	        '٢': '2',
	        '٣': '3',
	        '٤': '4',
	        '٥': '5',
	        '٦': '6',
	        '٧': '7',
	        '٨': '8',
	        '٩': '9',
	        '٠': '0'
	    };
	
	    var arSa = moment.defineLocale('ar-sa', {
	        months: 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        monthsShort: 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ص|م/,
	        isPM: function isPM(input) {
	            return 'م' === input;
	        },
	        meridiem: function meridiem(hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات'
	        },
	        preparse: function preparse(string) {
	            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function postformat(string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return arSa;
	});

/***/ },
/* 253 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale  :  Arabic (Tunisia) [ar-tn]
	//! author : Nader Toukabri : https://github.com/naderio
	
	;(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var arTn = moment.defineLocale('ar-tn', {
	        months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات'
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return arTn;
	});

/***/ },
/* 254 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Arabic [ar]
	//! author : Abdel Said: https://github.com/abdelsaid
	//! author : Ahmed Elkhatib
	//! author : forabi https://github.com/forabi
	
	;(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var symbolMap = {
	        '1': '١',
	        '2': '٢',
	        '3': '٣',
	        '4': '٤',
	        '5': '٥',
	        '6': '٦',
	        '7': '٧',
	        '8': '٨',
	        '9': '٩',
	        '0': '٠'
	    };
	    var numberMap = {
	        '١': '1',
	        '٢': '2',
	        '٣': '3',
	        '٤': '4',
	        '٥': '5',
	        '٦': '6',
	        '٧': '7',
	        '٨': '8',
	        '٩': '9',
	        '٠': '0'
	    };
	    var pluralForm = function pluralForm(n) {
	        return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	    };
	    var plurals = {
	        s: ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	        m: ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	        h: ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	        d: ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	        M: ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	        y: ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	    };
	    var pluralize = function pluralize(u) {
	        return function (number, withoutSuffix, string, isFuture) {
	            var f = pluralForm(number),
	                str = plurals[u][pluralForm(number)];
	            if (f === 2) {
	                str = str[withoutSuffix ? 0 : 1];
	            }
	            return str.replace(/%d/i, number);
	        };
	    };
	    var months = ['كانون الثاني يناير', 'شباط فبراير', 'آذار مارس', 'نيسان أبريل', 'أيار مايو', 'حزيران يونيو', 'تموز يوليو', 'آب أغسطس', 'أيلول سبتمبر', 'تشرين الأول أكتوبر', 'تشرين الثاني نوفمبر', 'كانون الأول ديسمبر'];
	
	    var ar = moment.defineLocale('ar', {
	        months: months,
	        monthsShort: months,
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/\u200FM/\u200FYYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ص|م/,
	        isPM: function isPM(input) {
	            return 'م' === input;
	        },
	        meridiem: function meridiem(hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'بعد %s',
	            past: 'منذ %s',
	            s: pluralize('s'),
	            m: pluralize('m'),
	            mm: pluralize('m'),
	            h: pluralize('h'),
	            hh: pluralize('h'),
	            d: pluralize('d'),
	            dd: pluralize('d'),
	            M: pluralize('M'),
	            MM: pluralize('M'),
	            y: pluralize('y'),
	            yy: pluralize('y')
	        },
	        preparse: function preparse(string) {
	            return string.replace(/\u200f/g, '').replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function postformat(string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ar;
	});

/***/ },
/* 255 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Azerbaijani [az]
	//! author : topchiyev : https://github.com/topchiyev
	
	;(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var suffixes = {
	        1: '-inci',
	        5: '-inci',
	        8: '-inci',
	        70: '-inci',
	        80: '-inci',
	        2: '-nci',
	        7: '-nci',
	        20: '-nci',
	        50: '-nci',
	        3: '-üncü',
	        4: '-üncü',
	        100: '-üncü',
	        6: '-ncı',
	        9: '-uncu',
	        10: '-uncu',
	        30: '-uncu',
	        60: '-ıncı',
	        90: '-ıncı'
	    };
	
	    var az = moment.defineLocale('az', {
	        months: 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split('_'),
	        monthsShort: 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
	        weekdays: 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split('_'),
	        weekdaysShort: 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
	        weekdaysMin: 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[bugün saat] LT',
	            nextDay: '[sabah saat] LT',
	            nextWeek: '[gələn həftə] dddd [saat] LT',
	            lastDay: '[dünən] LT',
	            lastWeek: '[keçən həftə] dddd [saat] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%s sonra',
	            past: '%s əvvəl',
	            s: 'birneçə saniyyə',
	            m: 'bir dəqiqə',
	            mm: '%d dəqiqə',
	            h: 'bir saat',
	            hh: '%d saat',
	            d: 'bir gün',
	            dd: '%d gün',
	            M: 'bir ay',
	            MM: '%d ay',
	            y: 'bir il',
	            yy: '%d il'
	        },
	        meridiemParse: /gecə|səhər|gündüz|axşam/,
	        isPM: function isPM(input) {
	            return (/^(gündüz|axşam)$/.test(input)
	            );
	        },
	        meridiem: function meridiem(hour, minute, isLower) {
	            if (hour < 4) {
	                return 'gecə';
	            } else if (hour < 12) {
	                return 'səhər';
	            } else if (hour < 17) {
	                return 'gündüz';
	            } else {
	                return 'axşam';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
	        ordinal: function ordinal(number) {
	            if (number === 0) {
	                // special case for zero
	                return number + '-ıncı';
	            }
	            var a = number % 10,
	                b = number % 100 - a,
	                c = number >= 100 ? 100 : null;
	            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return az;
	});

/***/ },
/* 256 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Belarusian [be]
	//! author : Dmitry Demidov : https://github.com/demidov91
	//! author: Praleska: http://praleska.pro/
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2];
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            'mm': withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
	            'hh': withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
	            'dd': 'дзень_дні_дзён',
	            'MM': 'месяц_месяцы_месяцаў',
	            'yy': 'год_гады_гадоў'
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвіліна' : 'хвіліну';
	        } else if (key === 'h') {
	            return withoutSuffix ? 'гадзіна' : 'гадзіну';
	        } else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	
	    var be = moment.defineLocale('be', {
	        months: {
	            format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split('_'),
	            standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split('_')
	        },
	        monthsShort: 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
	        weekdays: {
	            format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split('_'),
	            standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split('_'),
	            isFormat: /\[ ?[Вв] ?(?:мінулую|наступную)? ?\] ?dddd/
	        },
	        weekdaysShort: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        weekdaysMin: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY г.',
	            LLL: 'D MMMM YYYY г., HH:mm',
	            LLLL: 'dddd, D MMMM YYYY г., HH:mm'
	        },
	        calendar: {
	            sameDay: '[Сёння ў] LT',
	            nextDay: '[Заўтра ў] LT',
	            lastDay: '[Учора ў] LT',
	            nextWeek: function nextWeek() {
	                return '[У] dddd [ў] LT';
	            },
	            lastWeek: function lastWeek() {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[У мінулую] dddd [ў] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[У мінулы] dddd [ў] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'праз %s',
	            past: '%s таму',
	            s: 'некалькі секунд',
	            m: relativeTimeWithPlural,
	            mm: relativeTimeWithPlural,
	            h: relativeTimeWithPlural,
	            hh: relativeTimeWithPlural,
	            d: 'дзень',
	            dd: relativeTimeWithPlural,
	            M: 'месяц',
	            MM: relativeTimeWithPlural,
	            y: 'год',
	            yy: relativeTimeWithPlural
	        },
	        meridiemParse: /ночы|раніцы|дня|вечара/,
	        isPM: function isPM(input) {
	            return (/^(дня|вечара)$/.test(input)
	            );
	        },
	        meridiem: function meridiem(hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночы';
	            } else if (hour < 12) {
	                return 'раніцы';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечара';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
	        ordinal: function ordinal(number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return (number % 10 === 2 || number % 10 === 3) && number % 100 !== 12 && number % 100 !== 13 ? number + '-і' : number + '-ы';
	                case 'D':
	                    return number + '-га';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return be;
	});

/***/ },
/* 257 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Bulgarian [bg]
	//! author : Krasen Borisov : https://github.com/kraz
	
	;(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var bg = moment.defineLocale('bg', {
	        months: 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split('_'),
	        monthsShort: 'янр_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays: 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split('_'),
	        weekdaysShort: 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
	        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY H:mm',
	            LLLL: 'dddd, D MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[Днес в] LT',
	            nextDay: '[Утре в] LT',
	            nextWeek: 'dddd [в] LT',
	            lastDay: '[Вчера в] LT',
	            lastWeek: function lastWeek() {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[В изминалата] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[В изминалия] dddd [в] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'след %s',
	            past: 'преди %s',
	            s: 'няколко секунди',
	            m: 'минута',
	            mm: '%d минути',
	            h: 'час',
	            hh: '%d часа',
	            d: 'ден',
	            dd: '%d дни',
	            M: 'месец',
	            MM: '%d месеца',
	            y: 'година',
	            yy: '%d години'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal: function ordinal(number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return bg;
	});

/***/ },
/* 258 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Bengali [bn]
	//! author : Kaushik Gandhi : https://github.com/kaushikgandhi
	
	;(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var symbolMap = {
	        '1': '১',
	        '2': '২',
	        '3': '৩',
	        '4': '৪',
	        '5': '৫',
	        '6': '৬',
	        '7': '৭',
	        '8': '৮',
	        '9': '৯',
	        '0': '০'
	    };
	    var numberMap = {
	        '১': '1',
	        '২': '2',
	        '৩': '3',
	        '৪': '4',
	        '৫': '5',
	        '৬': '6',
	        '৭': '7',
	        '৮': '8',
	        '৯': '9',
	        '০': '0'
	    };
	
	    var bn = moment.defineLocale('bn', {
	        months: 'জানুয়ারী_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split('_'),
	        monthsShort: 'জানু_ফেব_মার্চ_এপ্র_মে_জুন_জুল_আগ_সেপ্ট_অক্টো_নভে_ডিসে'.split('_'),
	        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split('_'),
	        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	        weekdaysMin: 'রবি_সোম_মঙ্গ_বুধ_বৃহঃ_শুক্র_শনি'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm সময়',
	            LTS: 'A h:mm:ss সময়',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm সময়',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়'
	        },
	        calendar: {
	            sameDay: '[আজ] LT',
	            nextDay: '[আগামীকাল] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[গতকাল] LT',
	            lastWeek: '[গত] dddd, LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%s পরে',
	            past: '%s আগে',
	            s: 'কয়েক সেকেন্ড',
	            m: 'এক মিনিট',
	            mm: '%d মিনিট',
	            h: 'এক ঘন্টা',
	            hh: '%d ঘন্টা',
	            d: 'এক দিন',
	            dd: '%d দিন',
	            M: 'এক মাস',
	            MM: '%d মাস',
	            y: 'এক বছর',
	            yy: '%d বছর'
	        },
	        preparse: function preparse(string) {
	            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function postformat(string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
	        meridiemHour: function meridiemHour(hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'রাত' && hour >= 4 || meridiem === 'দুপুর' && hour < 5 || meridiem === 'বিকাল') {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem: function meridiem(hour, minute, isLower) {
	            if (hour < 4) {
	                return 'রাত';
	            } else if (hour < 10) {
	                return 'সকাল';
	            } else if (hour < 17) {
	                return 'দুপুর';
	            } else if (hour < 20) {
	                return 'বিকাল';
	            } else {
	                return 'রাত';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return bn;
	});

/***/ },
/* 259 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Tibetan [bo]
	//! author : Thupten N. Chakrishar : https://github.com/vajradog
	
	;(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var symbolMap = {
	        '1': '༡',
	        '2': '༢',
	        '3': '༣',
	        '4': '༤',
	        '5': '༥',
	        '6': '༦',
	        '7': '༧',
	        '8': '༨',
	        '9': '༩',
	        '0': '༠'
	    };
	    var numberMap = {
	        '༡': '1',
	        '༢': '2',
	        '༣': '3',
	        '༤': '4',
	        '༥': '5',
	        '༦': '6',
	        '༧': '7',
	        '༨': '8',
	        '༩': '9',
	        '༠': '0'
	    };
	
	    var bo = moment.defineLocale('bo', {
	        months: 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	        monthsShort: 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	        weekdays: 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split('_'),
	        weekdaysShort: 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	        weekdaysMin: 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm'
	        },
	        calendar: {
	            sameDay: '[དི་རིང] LT',
	            nextDay: '[སང་ཉིན] LT',
	            nextWeek: '[བདུན་ཕྲག་རྗེས་མ], LT',
	            lastDay: '[ཁ་སང] LT',
	            lastWeek: '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%s ལ་',
	            past: '%s སྔན་ལ',
	            s: 'ལམ་སང',
	            m: 'སྐར་མ་གཅིག',
	            mm: '%d སྐར་མ',
	            h: 'ཆུ་ཚོད་གཅིག',
	            hh: '%d ཆུ་ཚོད',
	            d: 'ཉིན་གཅིག',
	            dd: '%d ཉིན་',
	            M: 'ཟླ་བ་གཅིག',
	            MM: '%d ཟླ་བ',
	            y: 'ལོ་གཅིག',
	            yy: '%d ལོ'
	        },
	        preparse: function preparse(string) {
	            return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function postformat(string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
	        meridiemHour: function meridiemHour(hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'མཚན་མོ' && hour >= 4 || meridiem === 'ཉིན་གུང' && hour < 5 || meridiem === 'དགོང་དག') {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem: function meridiem(hour, minute, isLower) {
	            if (hour < 4) {
	                return 'མཚན་མོ';
	            } else if (hour < 10) {
	                return 'ཞོགས་ཀས';
	            } else if (hour < 17) {
	                return 'ཉིན་གུང';
	            } else if (hour < 20) {
	                return 'དགོང་དག';
	            } else {
	                return 'མཚན་མོ';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return bo;
	});

/***/ },
/* 260 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Breton [br]
	//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou
	
	;(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    function relativeTimeWithMutation(number, withoutSuffix, key) {
	        var format = {
	            'mm': 'munutenn',
	            'MM': 'miz',
	            'dd': 'devezh'
	        };
	        return number + ' ' + mutation(format[key], number);
	    }
	    function specialMutationForYears(number) {
	        switch (lastNumber(number)) {
	            case 1:
	            case 3:
	            case 4:
	            case 5:
	            case 9:
	                return number + ' bloaz';
	            default:
	                return number + ' vloaz';
	        }
	    }
	    function lastNumber(number) {
	        if (number > 9) {
	            return lastNumber(number % 10);
	        }
	        return number;
	    }
	    function mutation(text, number) {
	        if (number === 2) {
	            return softMutation(text);
	        }
	        return text;
	    }
	    function softMutation(text) {
	        var mutationTable = {
	            'm': 'v',
	            'b': 'v',
	            'd': 'z'
	        };
	        if (mutationTable[text.charAt(0)] === undefined) {
	            return text;
	        }
	        return mutationTable[text.charAt(0)] + text.substring(1);
	    }
	
	    var br = moment.defineLocale('br', {
	        months: 'Genver_C\'hwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split('_'),
	        monthsShort: 'Gen_C\'hwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
	        weekdays: 'Sul_Lun_Meurzh_Merc\'her_Yaou_Gwener_Sadorn'.split('_'),
	        weekdaysShort: 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
	        weekdaysMin: 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'h[e]mm A',
	            LTS: 'h[e]mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D [a viz] MMMM YYYY',
	            LLL: 'D [a viz] MMMM YYYY h[e]mm A',
	            LLLL: 'dddd, D [a viz] MMMM YYYY h[e]mm A'
	        },
	        calendar: {
	            sameDay: '[Hiziv da] LT',
	            nextDay: '[Warc\'hoazh da] LT',
	            nextWeek: 'dddd [da] LT',
	            lastDay: '[Dec\'h da] LT',
	            lastWeek: 'dddd [paset da] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'a-benn %s',
	            past: '%s \'zo',
	            s: 'un nebeud segondennoù',
	            m: 'ur vunutenn',
	            mm: relativeTimeWithMutation,
	            h: 'un eur',
	            hh: '%d eur',
	            d: 'un devezh',
	            dd: relativeTimeWithMutation,
	            M: 'ur miz',
	            MM: relativeTimeWithMutation,
	            y: 'ur bloaz',
	            yy: specialMutationForYears
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
	        ordinal: function ordinal(number) {
	            var output = number === 1 ? 'añ' : 'vet';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return br;
	});

/***/ },
/* 261 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Bosnian [bs]
	//! author : Nedim Cholich : https://github.com/frontyard
	//! based on (hr) translation by Bojan Marković
	
	;(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'm':
	                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jednog sata';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var bs = moment.defineLocale('bs', {
	        months: 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split('_'),
	        monthsShort: 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function nextWeek() {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[jučer u] LT',
	            lastWeek: function lastWeek() {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                        return '[prošlu] dddd [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'prije %s',
	            s: 'par sekundi',
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: 'dan',
	            dd: translate,
	            M: 'mjesec',
	            MM: translate,
	            y: 'godinu',
	            yy: translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return bs;
	});

/***/ },
/* 262 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Catalan [ca]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var ca = moment.defineLocale('ca', {
	        months: {
	            standalone: 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split('_'),
	            format: 'de gener_de febrer_de març_d\'abril_de maig_de juny_de juliol_d\'agost_de setembre_d\'octubre_de novembre_de desembre'.split('_'),
	            isFormat: /D[oD]?(\s)+MMMM/
	        },
	        monthsShort: 'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split('_'),
	        weekdaysShort: 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
	        weekdaysMin: 'Dg_Dl_Dt_Dc_Dj_Dv_Ds'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: '[el] D MMMM [de] YYYY',
	            ll: 'D MMM YYYY',
	            LLL: '[el] D MMMM [de] YYYY [a les] H:mm',
	            lll: 'D MMM YYYY, H:mm',
	            LLLL: '[el] dddd D MMMM [de] YYYY [a les] H:mm',
	            llll: 'ddd D MMM YYYY, H:mm'
	        },
	        calendar: {
	            sameDay: function sameDay() {
	                return '[avui a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            nextDay: function nextDay() {
	                return '[demà a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            nextWeek: function nextWeek() {
	                return 'dddd [a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            lastDay: function lastDay() {
	                return '[ahir a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            lastWeek: function lastWeek() {
	                return '[el] dddd [passat a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'd\'aquí %s',
	            past: 'fa %s',
	            s: 'uns segons',
	            m: 'un minut',
	            mm: '%d minuts',
	            h: 'una hora',
	            hh: '%d hores',
	            d: 'un dia',
	            dd: '%d dies',
	            M: 'un mes',
	            MM: '%d mesos',
	            y: 'un any',
	            yy: '%d anys'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
	        ordinal: function ordinal(number, period) {
	            var output = number === 1 ? 'r' : number === 2 ? 'n' : number === 3 ? 'r' : number === 4 ? 't' : 'è';
	            if (period === 'w' || period === 'W') {
	                output = 'a';
	            }
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ca;
	});

/***/ },
/* 263 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Czech [cs]
	//! author : petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split('_');
	    var monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_');
	    function plural(n) {
	        return n > 1 && n < 5 && ~~(n / 10) !== 1;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                // a few seconds / in a few seconds / a few seconds ago
	                return withoutSuffix || isFuture ? 'pár sekund' : 'pár sekundami';
	            case 'm':
	                // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minuta' : isFuture ? 'minutu' : 'minutou';
	            case 'mm':
	                // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minuty' : 'minut');
	                } else {
	                    return result + 'minutami';
	                }
	                break;
	            case 'h':
	                // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
	            case 'hh':
	                // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodin');
	                } else {
	                    return result + 'hodinami';
	                }
	                break;
	            case 'd':
	                // a day / in a day / a day ago
	                return withoutSuffix || isFuture ? 'den' : 'dnem';
	            case 'dd':
	                // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dny' : 'dní');
	                } else {
	                    return result + 'dny';
	                }
	                break;
	            case 'M':
	                // a month / in a month / a month ago
	                return withoutSuffix || isFuture ? 'měsíc' : 'měsícem';
	            case 'MM':
	                // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'měsíce' : 'měsíců');
	                } else {
	                    return result + 'měsíci';
	                }
	                break;
	            case 'y':
	                // a year / in a year / a year ago
	                return withoutSuffix || isFuture ? 'rok' : 'rokem';
	            case 'yy':
	                // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'let');
	                } else {
	                    return result + 'lety';
	                }
	                break;
	        }
	    }
	
	    var cs = moment.defineLocale('cs', {
	        months: months,
	        monthsShort: monthsShort,
	        monthsParse: function (months, monthsShort) {
	            var i,
	                _monthsParse = [];
	            for (i = 0; i < 12; i++) {
	                // use custom parser to solve problem with July (červenec)
	                _monthsParse[i] = new RegExp('^' + months[i] + '$|^' + monthsShort[i] + '$', 'i');
	            }
	            return _monthsParse;
	        }(months, monthsShort),
	        shortMonthsParse: function (monthsShort) {
	            var i,
	                _shortMonthsParse = [];
	            for (i = 0; i < 12; i++) {
	                _shortMonthsParse[i] = new RegExp('^' + monthsShort[i] + '$', 'i');
	            }
	            return _shortMonthsParse;
	        }(monthsShort),
	        longMonthsParse: function (months) {
	            var i,
	                _longMonthsParse = [];
	            for (i = 0; i < 12; i++) {
	                _longMonthsParse[i] = new RegExp('^' + months[i] + '$', 'i');
	            }
	            return _longMonthsParse;
	        }(months),
	        weekdays: 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
	        weekdaysShort: 'ne_po_út_st_čt_pá_so'.split('_'),
	        weekdaysMin: 'ne_po_út_st_čt_pá_so'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd D. MMMM YYYY H:mm',
	            l: 'D. M. YYYY'
	        },
	        calendar: {
	            sameDay: '[dnes v] LT',
	            nextDay: '[zítra v] LT',
	            nextWeek: function nextWeek() {
	                switch (this.day()) {
	                    case 0:
	                        return '[v neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [v] LT';
	                    case 3:
	                        return '[ve středu v] LT';
	                    case 4:
	                        return '[ve čtvrtek v] LT';
	                    case 5:
	                        return '[v pátek v] LT';
	                    case 6:
	                        return '[v sobotu v] LT';
	                }
	            },
	            lastDay: '[včera v] LT',
	            lastWeek: function lastWeek() {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulou neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[minulé] dddd [v] LT';
	                    case 3:
	                        return '[minulou středu v] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [v] LT';
	                    case 6:
	                        return '[minulou sobotu v] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'před %s',
	            s: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return cs;
	});

/***/ },
/* 264 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Chuvash [cv]
	//! author : Anatoly Mironov : https://github.com/mirontoli
	
	;(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var cv = moment.defineLocale('cv', {
	        months: 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split('_'),
	        monthsShort: 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
	        weekdays: 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split('_'),
	        weekdaysShort: 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
	        weekdaysMin: 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD-MM-YYYY',
	            LL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
	            LLL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	            LLLL: 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm'
	        },
	        calendar: {
	            sameDay: '[Паян] LT [сехетре]',
	            nextDay: '[Ыран] LT [сехетре]',
	            lastDay: '[Ӗнер] LT [сехетре]',
	            nextWeek: '[Ҫитес] dddd LT [сехетре]',
	            lastWeek: '[Иртнӗ] dddd LT [сехетре]',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: function future(output) {
	                var affix = /сехет$/i.exec(output) ? 'рен' : /ҫул$/i.exec(output) ? 'тан' : 'ран';
	                return output + affix;
	            },
	            past: '%s каялла',
	            s: 'пӗр-ик ҫеккунт',
	            m: 'пӗр минут',
	            mm: '%d минут',
	            h: 'пӗр сехет',
	            hh: '%d сехет',
	            d: 'пӗр кун',
	            dd: '%d кун',
	            M: 'пӗр уйӑх',
	            MM: '%d уйӑх',
	            y: 'пӗр ҫул',
	            yy: '%d ҫул'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
	        ordinal: '%d-мӗш',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return cv;
	});

/***/ },
/* 265 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Welsh [cy]
	//! author : Robert Allen : https://github.com/robgallen
	//! author : https://github.com/ryangreaves
	
	;(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var cy = moment.defineLocale('cy', {
	        months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split('_'),
	        monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split('_'),
	        weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split('_'),
	        weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
	        weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
	        weekdaysParseExact: true,
	        // time formats are the same as en-gb
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[Heddiw am] LT',
	            nextDay: '[Yfory am] LT',
	            nextWeek: 'dddd [am] LT',
	            lastDay: '[Ddoe am] LT',
	            lastWeek: 'dddd [diwethaf am] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'mewn %s',
	            past: '%s yn ôl',
	            s: 'ychydig eiliadau',
	            m: 'munud',
	            mm: '%d munud',
	            h: 'awr',
	            hh: '%d awr',
	            d: 'diwrnod',
	            dd: '%d diwrnod',
	            M: 'mis',
	            MM: '%d mis',
	            y: 'blwyddyn',
	            yy: '%d flynedd'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
	        // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
	        ordinal: function ordinal(number) {
	            var b = number,
	                output = '',
	                lookup = ['', 'af', 'il', 'ydd', 'ydd', 'ed', 'ed', 'ed', 'fed', 'fed', 'fed', // 1af to 10fed
	            'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'fed' // 11eg to 20fed
	            ];
	            if (b > 20) {
	                if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
	                    output = 'fed'; // not 30ain, 70ain or 90ain
	                } else {
	                    output = 'ain';
	                }
	            } else if (b > 0) {
	                output = lookup[b];
	            }
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return cy;
	});

/***/ },
/* 266 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Danish [da]
	//! author : Ulrik Nielsen : https://github.com/mrbase
	
	;(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var da = moment.defineLocale('da', {
	        months: 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split('_'),
	        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort: 'søn_man_tir_ons_tor_fre_lør'.split('_'),
	        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd [d.] D. MMMM YYYY [kl.] HH:mm'
	        },
	        calendar: {
	            sameDay: '[i dag kl.] LT',
	            nextDay: '[i morgen kl.] LT',
	            nextWeek: 'på dddd [kl.] LT',
	            lastDay: '[i går kl.] LT',
	            lastWeek: '[i] dddd[s kl.] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: '%s siden',
	            s: 'få sekunder',
	            m: 'et minut',
	            mm: '%d minutter',
	            h: 'en time',
	            hh: '%d timer',
	            d: 'en dag',
	            dd: '%d dage',
	            M: 'en måned',
	            MM: '%d måneder',
	            y: 'et år',
	            yy: '%d år'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return da;
	});

/***/ },
/* 267 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : German (Austria) [de-at]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Martin Groller : https://github.com/MadMG
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eine Minute', 'einer Minute'],
	            'h': ['eine Stunde', 'einer Stunde'],
	            'd': ['ein Tag', 'einem Tag'],
	            'dd': [number + ' Tage', number + ' Tagen'],
	            'M': ['ein Monat', 'einem Monat'],
	            'MM': [number + ' Monate', number + ' Monaten'],
	            'y': ['ein Jahr', 'einem Jahr'],
	            'yy': [number + ' Jahre', number + ' Jahren']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var deAt = moment.defineLocale('de-at', {
	        months: 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort: 'Jän._Febr._Mrz._Apr._Mai_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd, D. MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]'
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: 'vor %s',
	            s: 'ein paar Sekunden',
	            m: processRelativeTime,
	            mm: '%d Minuten',
	            h: processRelativeTime,
	            hh: '%d Stunden',
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return deAt;
	});

/***/ },
/* 268 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : German (Switzerland) [de-ch]
	//! author : sschueller : https://github.com/sschueller
	
	;(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    // based on: https://www.bk.admin.ch/dokumentation/sprachen/04915/05016/index.html?lang=de#
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eine Minute', 'einer Minute'],
	            'h': ['eine Stunde', 'einer Stunde'],
	            'd': ['ein Tag', 'einem Tag'],
	            'dd': [number + ' Tage', number + ' Tagen'],
	            'M': ['ein Monat', 'einem Monat'],
	            'MM': [number + ' Monate', number + ' Monaten'],
	            'y': ['ein Jahr', 'einem Jahr'],
	            'yy': [number + ' Jahre', number + ' Jahren']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var deCh = moment.defineLocale('de-ch', {
	        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort: 'Jan._Febr._März_April_Mai_Juni_Juli_Aug._Sept._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	        weekdaysShort: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH.mm',
	            LLLL: 'dddd, D. MMMM YYYY HH.mm'
	        },
	        calendar: {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]'
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: 'vor %s',
	            s: 'ein paar Sekunden',
	            m: processRelativeTime,
	            mm: '%d Minuten',
	            h: processRelativeTime,
	            hh: '%d Stunden',
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return deCh;
	});

/***/ },
/* 269 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : German [de]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eine Minute', 'einer Minute'],
	            'h': ['eine Stunde', 'einer Stunde'],
	            'd': ['ein Tag', 'einem Tag'],
	            'dd': [number + ' Tage', number + ' Tagen'],
	            'M': ['ein Monat', 'einem Monat'],
	            'MM': [number + ' Monate', number + ' Monaten'],
	            'y': ['ein Jahr', 'einem Jahr'],
	            'yy': [number + ' Jahre', number + ' Jahren']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var de = moment.defineLocale('de', {
	        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort: 'Jan._Febr._Mrz._Apr._Mai_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd, D. MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]'
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: 'vor %s',
	            s: 'ein paar Sekunden',
	            m: processRelativeTime,
	            mm: '%d Minuten',
	            h: processRelativeTime,
	            hh: '%d Stunden',
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return de;
	});

/***/ },
/* 270 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Maldivian [dv]
	//! author : Jawish Hameed : https://github.com/jawish
	
	;(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var months = ['ޖެނުއަރީ', 'ފެބްރުއަރީ', 'މާރިޗު', 'އޭޕްރީލު', 'މޭ', 'ޖޫން', 'ޖުލައި', 'އޯގަސްޓު', 'ސެޕްޓެމްބަރު', 'އޮކްޓޯބަރު', 'ނޮވެމްބަރު', 'ޑިސެމްބަރު'];
	    var weekdays = ['އާދިއްތަ', 'ހޯމަ', 'އަންގާރަ', 'ބުދަ', 'ބުރާސްފަތި', 'ހުކުރު', 'ހޮނިހިރު'];
	
	    var dv = moment.defineLocale('dv', {
	        months: months,
	        monthsShort: months,
	        weekdays: weekdays,
	        weekdaysShort: weekdays,
	        weekdaysMin: 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
	        longDateFormat: {
	
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/M/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /މކ|މފ/,
	        isPM: function isPM(input) {
	            return 'މފ' === input;
	        },
	        meridiem: function meridiem(hour, minute, isLower) {
	            if (hour < 12) {
	                return 'މކ';
	            } else {
	                return 'މފ';
	            }
	        },
	        calendar: {
	            sameDay: '[މިއަދު] LT',
	            nextDay: '[މާދަމާ] LT',
	            nextWeek: 'dddd LT',
	            lastDay: '[އިއްޔެ] LT',
	            lastWeek: '[ފާއިތުވި] dddd LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'ތެރޭގައި %s',
	            past: 'ކުރިން %s',
	            s: 'ސިކުންތުކޮޅެއް',
	            m: 'މިނިޓެއް',
	            mm: 'މިނިޓު %d',
	            h: 'ގަޑިއިރެއް',
	            hh: 'ގަޑިއިރު %d',
	            d: 'ދުވަހެއް',
	            dd: 'ދުވަސް %d',
	            M: 'މަހެއް',
	            MM: 'މަސް %d',
	            y: 'އަހަރެއް',
	            yy: 'އަހަރު %d'
	        },
	        preparse: function preparse(string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function postformat(string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 7, // Sunday is the first day of the week.
	            doy: 12 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return dv;
	});

/***/ },
/* 271 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Greek [el]
	//! author : Aggelos Karalias : https://github.com/mehiel
	
	;(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    function isFunction(input) {
	        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	    }
	
	    var el = moment.defineLocale('el', {
	        monthsNominativeEl: 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split('_'),
	        monthsGenitiveEl: 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split('_'),
	        months: function months(momentToFormat, format) {
	            if (!momentToFormat) {
	                return this._monthsNominativeEl;
	            } else if (/D/.test(format.substring(0, format.indexOf('MMMM')))) {
	                // if there is a day number before 'MMMM'
	                return this._monthsGenitiveEl[momentToFormat.month()];
	            } else {
	                return this._monthsNominativeEl[momentToFormat.month()];
	            }
	        },
	        monthsShort: 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
	        weekdays: 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split('_'),
	        weekdaysShort: 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
	        weekdaysMin: 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
	        meridiem: function meridiem(hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'μμ' : 'ΜΜ';
	            } else {
	                return isLower ? 'πμ' : 'ΠΜ';
	            }
	        },
	        isPM: function isPM(input) {
	            return (input + '').toLowerCase()[0] === 'μ';
	        },
	        meridiemParse: /[ΠΜ]\.?Μ?\.?/i,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendarEl: {
	            sameDay: '[Σήμερα {}] LT',
	            nextDay: '[Αύριο {}] LT',
	            nextWeek: 'dddd [{}] LT',
	            lastDay: '[Χθες {}] LT',
	            lastWeek: function lastWeek() {
	                switch (this.day()) {
	                    case 6:
	                        return '[το προηγούμενο] dddd [{}] LT';
	                    default:
	                        return '[την προηγούμενη] dddd [{}] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        calendar: function calendar(key, mom) {
	            var output = this._calendarEl[key],
	                hours = mom && mom.hours();
	            if (isFunction(output)) {
	                output = output.apply(mom);
	            }
	            return output.replace('{}', hours % 12 === 1 ? 'στη' : 'στις');
	        },
	        relativeTime: {
	            future: 'σε %s',
	            past: '%s πριν',
	            s: 'λίγα δευτερόλεπτα',
	            m: 'ένα λεπτό',
	            mm: '%d λεπτά',
	            h: 'μία ώρα',
	            hh: '%d ώρες',
	            d: 'μία μέρα',
	            dd: '%d μέρες',
	            M: 'ένας μήνας',
	            MM: '%d μήνες',
	            y: 'ένας χρόνος',
	            yy: '%d χρόνια'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}η/,
	        ordinal: '%dη',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4st is the first week of the year.
	        }
	    });
	
	    return el;
	});

/***/ },
/* 272 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : English (Australia) [en-au]
	//! author : Jared Morse : https://github.com/jarcoal
	
	;(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var enAu = moment.defineLocale('en-au', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function ordinal(number) {
	            var b = number % 10,
	                output = ~~(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return enAu;
	});

/***/ },
/* 273 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : English (Canada) [en-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var enCa = moment.defineLocale('en-ca', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'YYYY-MM-DD',
	            LL: 'MMMM D, YYYY',
	            LLL: 'MMMM D, YYYY h:mm A',
	            LLLL: 'dddd, MMMM D, YYYY h:mm A'
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function ordinal(number) {
	            var b = number % 10,
	                output = ~~(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
	            return number + output;
	        }
	    });
	
	    return enCa;
	});

/***/ },
/* 274 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : English (United Kingdom) [en-gb]
	//! author : Chris Gedrim : https://github.com/chrisgedrim
	
	;(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var enGb = moment.defineLocale('en-gb', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function ordinal(number) {
	            var b = number % 10,
	                output = ~~(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return enGb;
	});

/***/ },
/* 275 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : English (Ireland) [en-ie]
	//! author : Chris Cartlidge : https://github.com/chriscartlidge
	
	;(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var enIe = moment.defineLocale('en-ie', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function ordinal(number) {
	            var b = number % 10,
	                output = ~~(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return enIe;
	});

/***/ },
/* 276 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : English (New Zealand) [en-nz]
	//! author : Luke McGregor : https://github.com/lukemcgregor
	
	;(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var enNz = moment.defineLocale('en-nz', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function ordinal(number) {
	            var b = number % 10,
	                output = ~~(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return enNz;
	});

/***/ },
/* 277 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Esperanto [eo]
	//! author : Colin Dean : https://github.com/colindean
	//! author : Mia Nordentoft Imperatori : https://github.com/miestasmia
	//! comment : miestasmia corrected the translation by colindean
	
	;(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var eo = moment.defineLocale('eo', {
	        months: 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split('_'),
	        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aŭg_sep_okt_nov_dec'.split('_'),
	        weekdays: 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
	        weekdaysShort: 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'D[-a de] MMMM, YYYY',
	            LLL: 'D[-a de] MMMM, YYYY HH:mm',
	            LLLL: 'dddd, [la] D[-a de] MMMM, YYYY HH:mm'
	        },
	        meridiemParse: /[ap]\.t\.m/i,
	        isPM: function isPM(input) {
	            return input.charAt(0).toLowerCase() === 'p';
	        },
	        meridiem: function meridiem(hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'p.t.m.' : 'P.T.M.';
	            } else {
	                return isLower ? 'a.t.m.' : 'A.T.M.';
	            }
	        },
	        calendar: {
	            sameDay: '[Hodiaŭ je] LT',
	            nextDay: '[Morgaŭ je] LT',
	            nextWeek: 'dddd [je] LT',
	            lastDay: '[Hieraŭ je] LT',
	            lastWeek: '[pasinta] dddd [je] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'post %s',
	            past: 'antaŭ %s',
	            s: 'sekundoj',
	            m: 'minuto',
	            mm: '%d minutoj',
	            h: 'horo',
	            hh: '%d horoj',
	            d: 'tago', //ne 'diurno', ĉar estas uzita por proksimumo
	            dd: '%d tagoj',
	            M: 'monato',
	            MM: '%d monatoj',
	            y: 'jaro',
	            yy: '%d jaroj'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}a/,
	        ordinal: '%da',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return eo;
	});

/***/ },
/* 278 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Spanish (Dominican Republic) [es-do]
	
	;(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
	    var _monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	    var esDo = moment.defineLocale('es-do', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	        monthsShort: function monthsShort(m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return _monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsParseExact: true,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY h:mm A',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A'
	        },
	        calendar: {
	            sameDay: function sameDay() {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function nextDay() {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function nextWeek() {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function lastDay() {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function lastWeek() {
	                return '[el] dddd [pasado a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return esDo;
	});

/***/ },
/* 279 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Spanish [es]
	//! author : Julio Napurí : https://github.com/julionc
	
	;(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
	    var _monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	    var es = moment.defineLocale('es', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	        monthsShort: function monthsShort(m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return _monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsParseExact: true,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY H:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm'
	        },
	        calendar: {
	            sameDay: function sameDay() {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function nextDay() {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function nextWeek() {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function lastDay() {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function lastWeek() {
	                return '[el] dddd [pasado a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return es;
	});

/***/ },
/* 280 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Estonian [et]
	//! author : Henry Kehlmann : https://github.com/madhenry
	//! improvements : Illimar Tambek : https://github.com/ragulka
	
	;(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            's': ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
	            'm': ['ühe minuti', 'üks minut'],
	            'mm': [number + ' minuti', number + ' minutit'],
	            'h': ['ühe tunni', 'tund aega', 'üks tund'],
	            'hh': [number + ' tunni', number + ' tundi'],
	            'd': ['ühe päeva', 'üks päev'],
	            'M': ['kuu aja', 'kuu aega', 'üks kuu'],
	            'MM': [number + ' kuu', number + ' kuud'],
	            'y': ['ühe aasta', 'aasta', 'üks aasta'],
	            'yy': [number + ' aasta', number + ' aastat']
	        };
	        if (withoutSuffix) {
	            return format[key][2] ? format[key][2] : format[key][1];
	        }
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var et = moment.defineLocale('et', {
	        months: 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split('_'),
	        monthsShort: 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
	        weekdays: 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split('_'),
	        weekdaysShort: 'P_E_T_K_N_R_L'.split('_'),
	        weekdaysMin: 'P_E_T_K_N_R_L'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[Täna,] LT',
	            nextDay: '[Homme,] LT',
	            nextWeek: '[Järgmine] dddd LT',
	            lastDay: '[Eile,] LT',
	            lastWeek: '[Eelmine] dddd LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%s pärast',
	            past: '%s tagasi',
	            s: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: '%d päeva',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return et;
	});

/***/ },
/* 281 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Basque [eu]
	//! author : Eneko Illarramendi : https://github.com/eillarra
	
	;(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var eu = moment.defineLocale('eu', {
	        months: 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split('_'),
	        monthsShort: 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split('_'),
	        weekdaysShort: 'ig._al._ar._az._og._ol._lr.'.split('_'),
	        weekdaysMin: 'ig_al_ar_az_og_ol_lr'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY[ko] MMMM[ren] D[a]',
	            LLL: 'YYYY[ko] MMMM[ren] D[a] HH:mm',
	            LLLL: 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
	            l: 'YYYY-M-D',
	            ll: 'YYYY[ko] MMM D[a]',
	            lll: 'YYYY[ko] MMM D[a] HH:mm',
	            llll: 'ddd, YYYY[ko] MMM D[a] HH:mm'
	        },
	        calendar: {
	            sameDay: '[gaur] LT[etan]',
	            nextDay: '[bihar] LT[etan]',
	            nextWeek: 'dddd LT[etan]',
	            lastDay: '[atzo] LT[etan]',
	            lastWeek: '[aurreko] dddd LT[etan]',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%s barru',
	            past: 'duela %s',
	            s: 'segundo batzuk',
	            m: 'minutu bat',
	            mm: '%d minutu',
	            h: 'ordu bat',
	            hh: '%d ordu',
	            d: 'egun bat',
	            dd: '%d egun',
	            M: 'hilabete bat',
	            MM: '%d hilabete',
	            y: 'urte bat',
	            yy: '%d urte'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return eu;
	});

/***/ },
/* 282 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Persian [fa]
	//! author : Ebrahim Byagowi : https://github.com/ebraminio
	
	;(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var symbolMap = {
	        '1': '۱',
	        '2': '۲',
	        '3': '۳',
	        '4': '۴',
	        '5': '۵',
	        '6': '۶',
	        '7': '۷',
	        '8': '۸',
	        '9': '۹',
	        '0': '۰'
	    };
	    var numberMap = {
	        '۱': '1',
	        '۲': '2',
	        '۳': '3',
	        '۴': '4',
	        '۵': '5',
	        '۶': '6',
	        '۷': '7',
	        '۸': '8',
	        '۹': '9',
	        '۰': '0'
	    };
	
	    var fa = moment.defineLocale('fa', {
	        months: 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	        monthsShort: 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	        weekdays: '\u06CC\u06A9\u200C\u0634\u0646\u0628\u0647_\u062F\u0648\u0634\u0646\u0628\u0647_\u0633\u0647\u200C\u0634\u0646\u0628\u0647_\u0686\u0647\u0627\u0631\u0634\u0646\u0628\u0647_\u067E\u0646\u062C\u200C\u0634\u0646\u0628\u0647_\u062C\u0645\u0639\u0647_\u0634\u0646\u0628\u0647'.split('_'),
	        weekdaysShort: '\u06CC\u06A9\u200C\u0634\u0646\u0628\u0647_\u062F\u0648\u0634\u0646\u0628\u0647_\u0633\u0647\u200C\u0634\u0646\u0628\u0647_\u0686\u0647\u0627\u0631\u0634\u0646\u0628\u0647_\u067E\u0646\u062C\u200C\u0634\u0646\u0628\u0647_\u062C\u0645\u0639\u0647_\u0634\u0646\u0628\u0647'.split('_'),
	        weekdaysMin: 'ی_د_س_چ_پ_ج_ش'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /قبل از ظهر|بعد از ظهر/,
	        isPM: function isPM(input) {
	            return (/بعد از ظهر/.test(input)
	            );
	        },
	        meridiem: function meridiem(hour, minute, isLower) {
	            if (hour < 12) {
	                return 'قبل از ظهر';
	            } else {
	                return 'بعد از ظهر';
	            }
	        },
	        calendar: {
	            sameDay: '[امروز ساعت] LT',
	            nextDay: '[فردا ساعت] LT',
	            nextWeek: 'dddd [ساعت] LT',
	            lastDay: '[دیروز ساعت] LT',
	            lastWeek: 'dddd [پیش] [ساعت] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'در %s',
	            past: '%s پیش',
	            s: 'چند ثانیه',
	            m: 'یک دقیقه',
	            mm: '%d دقیقه',
	            h: 'یک ساعت',
	            hh: '%d ساعت',
	            d: 'یک روز',
	            dd: '%d روز',
	            M: 'یک ماه',
	            MM: '%d ماه',
	            y: 'یک سال',
	            yy: '%d سال'
	        },
	        preparse: function preparse(string) {
	            return string.replace(/[۰-۹]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function postformat(string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}م/,
	        ordinal: '%dم',
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return fa;
	});

/***/ },
/* 283 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Finnish [fi]
	//! author : Tarmo Aidantausta : https://github.com/bleadof
	
	;(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(' ');
	    var numbersFuture = ['nolla', 'yhden', 'kahden', 'kolmen', 'neljän', 'viiden', 'kuuden', numbersPast[7], numbersPast[8], numbersPast[9]];
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = '';
	        switch (key) {
	            case 's':
	                return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
	            case 'm':
	                return isFuture ? 'minuutin' : 'minuutti';
	            case 'mm':
	                result = isFuture ? 'minuutin' : 'minuuttia';
	                break;
	            case 'h':
	                return isFuture ? 'tunnin' : 'tunti';
	            case 'hh':
	                result = isFuture ? 'tunnin' : 'tuntia';
	                break;
	            case 'd':
	                return isFuture ? 'päivän' : 'päivä';
	            case 'dd':
	                result = isFuture ? 'päivän' : 'päivää';
	                break;
	            case 'M':
	                return isFuture ? 'kuukauden' : 'kuukausi';
	            case 'MM':
	                result = isFuture ? 'kuukauden' : 'kuukautta';
	                break;
	            case 'y':
	                return isFuture ? 'vuoden' : 'vuosi';
	            case 'yy':
	                result = isFuture ? 'vuoden' : 'vuotta';
	                break;
	        }
	        result = verbalNumber(number, isFuture) + ' ' + result;
	        return result;
	    }
	    function verbalNumber(number, isFuture) {
	        return number < 10 ? isFuture ? numbersFuture[number] : numbersPast[number] : number;
	    }
	
	    var fi = moment.defineLocale('fi', {
	        months: 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split('_'),
	        monthsShort: 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split('_'),
	        weekdays: 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split('_'),
	        weekdaysShort: 'su_ma_ti_ke_to_pe_la'.split('_'),
	        weekdaysMin: 'su_ma_ti_ke_to_pe_la'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD.MM.YYYY',
	            LL: 'Do MMMM[ta] YYYY',
	            LLL: 'Do MMMM[ta] YYYY, [klo] HH.mm',
	            LLLL: 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
	            l: 'D.M.YYYY',
	            ll: 'Do MMM YYYY',
	            lll: 'Do MMM YYYY, [klo] HH.mm',
	            llll: 'ddd, Do MMM YYYY, [klo] HH.mm'
	        },
	        calendar: {
	            sameDay: '[tänään] [klo] LT',
	            nextDay: '[huomenna] [klo] LT',
	            nextWeek: 'dddd [klo] LT',
	            lastDay: '[eilen] [klo] LT',
	            lastWeek: '[viime] dddd[na] [klo] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%s päästä',
	            past: '%s sitten',
	            s: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fi;
	});

/***/ },
/* 284 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Faroese [fo]
	//! author : Ragnar Johannesen : https://github.com/ragnar123
	
	;(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var fo = moment.defineLocale('fo', {
	        months: 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	        monthsShort: 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	        weekdays: 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split('_'),
	        weekdaysShort: 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
	        weekdaysMin: 'su_má_tý_mi_hó_fr_le'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D. MMMM, YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[Í dag kl.] LT',
	            nextDay: '[Í morgin kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[Í gjár kl.] LT',
	            lastWeek: '[síðstu] dddd [kl] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'um %s',
	            past: '%s síðani',
	            s: 'fá sekund',
	            m: 'ein minutt',
	            mm: '%d minuttir',
	            h: 'ein tími',
	            hh: '%d tímar',
	            d: 'ein dagur',
	            dd: '%d dagar',
	            M: 'ein mánaði',
	            MM: '%d mánaðir',
	            y: 'eitt ár',
	            yy: '%d ár'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fo;
	});

/***/ },
/* 285 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : French (Canada) [fr-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var frCa = moment.defineLocale('fr-ca', {
	        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	        monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin: 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[Aujourd’hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'dans %s',
	            past: 'il y a %s',
	            s: 'quelques secondes',
	            m: 'une minute',
	            mm: '%d minutes',
	            h: 'une heure',
	            hh: '%d heures',
	            d: 'un jour',
	            dd: '%d jours',
	            M: 'un mois',
	            MM: '%d mois',
	            y: 'un an',
	            yy: '%d ans'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	        ordinal: function ordinal(number, period) {
	            switch (period) {
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'D':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        }
	    });
	
	    return frCa;
	});

/***/ },
/* 286 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : French (Switzerland) [fr-ch]
	//! author : Gaspard Bucher : https://github.com/gaspard
	
	;(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var frCh = moment.defineLocale('fr-ch', {
	        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	        monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin: 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[Aujourd’hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'dans %s',
	            past: 'il y a %s',
	            s: 'quelques secondes',
	            m: 'une minute',
	            mm: '%d minutes',
	            h: 'une heure',
	            hh: '%d heures',
	            d: 'un jour',
	            dd: '%d jours',
	            M: 'un mois',
	            MM: '%d mois',
	            y: 'un an',
	            yy: '%d ans'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	        ordinal: function ordinal(number, period) {
	            switch (period) {
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'D':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return frCh;
	});

/***/ },
/* 287 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : French [fr]
	//! author : John Fischer : https://github.com/jfroffice
	
	;(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var fr = moment.defineLocale('fr', {
	        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	        monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin: 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[Aujourd’hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'dans %s',
	            past: 'il y a %s',
	            s: 'quelques secondes',
	            m: 'une minute',
	            mm: '%d minutes',
	            h: 'une heure',
	            hh: '%d heures',
	            d: 'un jour',
	            dd: '%d jours',
	            M: 'un mois',
	            MM: '%d mois',
	            y: 'un an',
	            yy: '%d ans'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
	        ordinal: function ordinal(number, period) {
	            switch (period) {
	                // TODO: Return 'e' when day of month > 1. Move this case inside
	                // block for masculine words below.
	                // See https://github.com/moment/moment/issues/3375
	                case 'D':
	                    return number + (number === 1 ? 'er' : '');
	
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fr;
	});

/***/ },
/* 288 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Frisian [fy]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	
	;(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_');
	    var monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');
	
	    var fy = moment.defineLocale('fy', {
	        months: 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split('_'),
	        monthsShort: function monthsShort(m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	        monthsParseExact: true,
	        weekdays: 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split('_'),
	        weekdaysShort: 'si._mo._ti._wo._to._fr._so.'.split('_'),
	        weekdaysMin: 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[hjoed om] LT',
	            nextDay: '[moarn om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[juster om] LT',
	            lastWeek: '[ôfrûne] dddd [om] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'oer %s',
	            past: '%s lyn',
	            s: 'in pear sekonden',
	            m: 'ien minút',
	            mm: '%d minuten',
	            h: 'ien oere',
	            hh: '%d oeren',
	            d: 'ien dei',
	            dd: '%d dagen',
	            M: 'ien moanne',
	            MM: '%d moannen',
	            y: 'ien jier',
	            yy: '%d jierren'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function ordinal(number) {
	            return number + (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de');
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fy;
	});

/***/ },
/* 289 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Scottish Gaelic [gd]
	//! author : Jon Ashdown : https://github.com/jonashdown
	
	;(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var months = ['Am Faoilleach', 'An Gearran', 'Am Màrt', 'An Giblean', 'An Cèitean', 'An t-Ògmhios', 'An t-Iuchar', 'An Lùnastal', 'An t-Sultain', 'An Dàmhair', 'An t-Samhain', 'An Dùbhlachd'];
	
	    var monthsShort = ['Faoi', 'Gear', 'Màrt', 'Gibl', 'Cèit', 'Ògmh', 'Iuch', 'Lùn', 'Sult', 'Dàmh', 'Samh', 'Dùbh'];
	
	    var weekdays = ['Didòmhnaich', 'Diluain', 'Dimàirt', 'Diciadain', 'Diardaoin', 'Dihaoine', 'Disathairne'];
	
	    var weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'];
	
	    var weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];
	
	    var gd = moment.defineLocale('gd', {
	        months: months,
	        monthsShort: monthsShort,
	        monthsParseExact: true,
	        weekdays: weekdays,
	        weekdaysShort: weekdaysShort,
	        weekdaysMin: weekdaysMin,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[An-diugh aig] LT',
	            nextDay: '[A-màireach aig] LT',
	            nextWeek: 'dddd [aig] LT',
	            lastDay: '[An-dè aig] LT',
	            lastWeek: 'dddd [seo chaidh] [aig] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'ann an %s',
	            past: 'bho chionn %s',
	            s: 'beagan diogan',
	            m: 'mionaid',
	            mm: '%d mionaidean',
	            h: 'uair',
	            hh: '%d uairean',
	            d: 'latha',
	            dd: '%d latha',
	            M: 'mìos',
	            MM: '%d mìosan',
	            y: 'bliadhna',
	            yy: '%d bliadhna'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
	        ordinal: function ordinal(number) {
	            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return gd;
	});

/***/ },
/* 290 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Galician [gl]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var gl = moment.defineLocale('gl', {
	        months: 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split('_'),
	        monthsShort: 'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mé_xo_ve_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY H:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm'
	        },
	        calendar: {
	            sameDay: function sameDay() {
	                return '[hoxe ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
	            },
	            nextDay: function nextDay() {
	                return '[mañá ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
	            },
	            nextWeek: function nextWeek() {
	                return 'dddd [' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT';
	            },
	            lastDay: function lastDay() {
	                return '[onte ' + (this.hours() !== 1 ? 'á' : 'a') + '] LT';
	            },
	            lastWeek: function lastWeek() {
	                return '[o] dddd [pasado ' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT';
	            },
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: function future(str) {
	                if (str.indexOf('un') === 0) {
	                    return 'n' + str;
	                }
	                return 'en ' + str;
	            },
	            past: 'hai %s',
	            s: 'uns segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'unha hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un ano',
	            yy: '%d anos'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return gl;
	});

/***/ },
/* 291 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Konkani Latin script [gom-latn]
	//! author : The Discoverer : https://github.com/WikiDiscoverer
	
	;(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            's': ['thodde secondanim', 'thodde second'],
	            'm': ['eka mintan', 'ek minute'],
	            'mm': [number + ' mintanim', number + ' mintam'],
	            'h': ['eka horan', 'ek hor'],
	            'hh': [number + ' horanim', number + ' hor'],
	            'd': ['eka disan', 'ek dis'],
	            'dd': [number + ' disanim', number + ' dis'],
	            'M': ['eka mhoinean', 'ek mhoino'],
	            'MM': [number + ' mhoineanim', number + ' mhoine'],
	            'y': ['eka vorsan', 'ek voros'],
	            'yy': [number + ' vorsanim', number + ' vorsam']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var gomLatn = moment.defineLocale('gom-latn', {
	        months: 'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split('_'),
	        monthsShort: 'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'Aitar_Somar_Mongllar_Budvar_Brestar_Sukrar_Son\'var'.split('_'),
	        weekdaysShort: 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
	        weekdaysMin: 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'A h:mm [vazta]',
	            LTS: 'A h:mm:ss [vazta]',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY A h:mm [vazta]',
	            LLLL: 'dddd, MMMM[achea] Do, YYYY, A h:mm [vazta]',
	            llll: 'ddd, D MMM YYYY, A h:mm [vazta]'
	        },
	        calendar: {
	            sameDay: '[Aiz] LT',
	            nextDay: '[Faleam] LT',
	            nextWeek: '[Ieta to] dddd[,] LT',
	            lastDay: '[Kal] LT',
	            lastWeek: '[Fatlo] dddd[,] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%s',
	            past: '%s adim',
	            s: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er)/,
	        ordinal: function ordinal(number, period) {
	            switch (period) {
	                // the ordinal 'er' only applies to day of the month
	                case 'D':
	                    return number + 'er';
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                case 'w':
	                case 'W':
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        },
	        meridiemParse: /rati|sokalli|donparam|sanje/,
	        meridiemHour: function meridiemHour(hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'rati') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'sokalli') {
	                return hour;
	            } else if (meridiem === 'donparam') {
	                return hour > 12 ? hour : hour + 12;
	            } else if (meridiem === 'sanje') {
	                return hour + 12;
	            }
	        },
	        meridiem: function meridiem(hour, minute, isLower) {
	            if (hour < 4) {
	                return 'rati';
	            } else if (hour < 12) {
	                return 'sokalli';
	            } else if (hour < 16) {
	                return 'donparam';
	            } else if (hour < 20) {
	                return 'sanje';
	            } else {
	                return 'rati';
	            }
	        }
	    });
	
	    return gomLatn;
	});

/***/ },
/* 292 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Hebrew [he]
	//! author : Tomer Cohen : https://github.com/tomer
	//! author : Moshe Simantov : https://github.com/DevelopmentIL
	//! author : Tal Ater : https://github.com/TalAter
	
	;(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var he = moment.defineLocale('he', {
	        months: 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split('_'),
	        monthsShort: 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
	        weekdays: 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
	        weekdaysShort: 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
	        weekdaysMin: 'א_ב_ג_ד_ה_ו_ש'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [ב]MMMM YYYY',
	            LLL: 'D [ב]MMMM YYYY HH:mm',
	            LLLL: 'dddd, D [ב]MMMM YYYY HH:mm',
	            l: 'D/M/YYYY',
	            ll: 'D MMM YYYY',
	            lll: 'D MMM YYYY HH:mm',
	            llll: 'ddd, D MMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[היום ב־]LT',
	            nextDay: '[מחר ב־]LT',
	            nextWeek: 'dddd [בשעה] LT',
	            lastDay: '[אתמול ב־]LT',
	            lastWeek: '[ביום] dddd [האחרון בשעה] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'בעוד %s',
	            past: 'לפני %s',
	            s: 'מספר שניות',
	            m: 'דקה',
	            mm: '%d דקות',
	            h: 'שעה',
	            hh: function hh(number) {
	                if (number === 2) {
	                    return 'שעתיים';
	                }
	                return number + ' שעות';
	            },
	            d: 'יום',
	            dd: function dd(number) {
	                if (number === 2) {
	                    return 'יומיים';
	                }
	                return number + ' ימים';
	            },
	            M: 'חודש',
	            MM: function MM(number) {
	                if (number === 2) {
	                    return 'חודשיים';
	                }
	                return number + ' חודשים';
	            },
	            y: 'שנה',
	            yy: function yy(number) {
	                if (number === 2) {
	                    return 'שנתיים';
	                } else if (number % 10 === 0 && number !== 10) {
	                    return number + ' שנה';
	                }
	                return number + ' שנים';
	            }
	        },
	        meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
	        isPM: function isPM(input) {
	            return (/^(אחה"צ|אחרי הצהריים|בערב)$/.test(input)
	            );
	        },
	        meridiem: function meridiem(hour, minute, isLower) {
	            if (hour < 5) {
	                return 'לפנות בוקר';
	            } else if (hour < 10) {
	                return 'בבוקר';
	            } else if (hour < 12) {
	                return isLower ? 'לפנה"צ' : 'לפני הצהריים';
	            } else if (hour < 18) {
	                return isLower ? 'אחה"צ' : 'אחרי הצהריים';
	            } else {
	                return 'בערב';
	            }
	        }
	    });
	
	    return he;
	});

/***/ },
/* 293 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Hindi [hi]
	//! author : Mayank Singhal : https://github.com/mayanksinghal
	
	;(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var symbolMap = {
	        '1': '१',
	        '2': '२',
	        '3': '३',
	        '4': '४',
	        '5': '५',
	        '6': '६',
	        '7': '७',
	        '8': '८',
	        '9': '९',
	        '0': '०'
	    };
	    var numberMap = {
	        '१': '1',
	        '२': '2',
	        '३': '3',
	        '४': '4',
	        '५': '5',
	        '६': '6',
	        '७': '7',
	        '८': '8',
	        '९': '9',
	        '०': '0'
	    };
	
	    var hi = moment.defineLocale('hi', {
	        months: 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split('_'),
	        monthsShort: 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort: 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm बजे',
	            LTS: 'A h:mm:ss बजे',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm बजे',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm बजे'
	        },
	        calendar: {
	            sameDay: '[आज] LT',
	            nextDay: '[कल] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[कल] LT',
	            lastWeek: '[पिछले] dddd, LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%s में',
	            past: '%s पहले',
	            s: 'कुछ ही क्षण',
	            m: 'एक मिनट',
	            mm: '%d मिनट',
	            h: 'एक घंटा',
	            hh: '%d घंटे',
	            d: 'एक दिन',
	            dd: '%d दिन',
	            M: 'एक महीने',
	            MM: '%d महीने',
	            y: 'एक वर्ष',
	            yy: '%d वर्ष'
	        },
	        preparse: function preparse(string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function postformat(string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Hindi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
	        meridiemParse: /रात|सुबह|दोपहर|शाम/,
	        meridiemHour: function meridiemHour(hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'रात') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सुबह') {
	                return hour;
	            } else if (meridiem === 'दोपहर') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'शाम') {
	                return hour + 12;
	            }
	        },
	        meridiem: function meridiem(hour, minute, isLower) {
	            if (hour < 4) {
	                return 'रात';
	            } else if (hour < 10) {
	                return 'सुबह';
	            } else if (hour < 17) {
	                return 'दोपहर';
	            } else if (hour < 20) {
	                return 'शाम';
	            } else {
	                return 'रात';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return hi;
	});

/***/ },
/* 294 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Croatian [hr]
	//! author : Bojan Marković : https://github.com/bmarkovic
	
	;(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'm':
	                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jednog sata';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var hr = moment.defineLocale('hr', {
	        months: {
	            format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split('_'),
	            standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split('_')
	        },
	        monthsShort: 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function nextWeek() {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[jučer u] LT',
	            lastWeek: function lastWeek() {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                        return '[prošlu] dddd [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'prije %s',
	            s: 'par sekundi',
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: 'dan',
	            dd: translate,
	            M: 'mjesec',
	            MM: translate,
	            y: 'godinu',
	            yy: translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return hr;
	});

/***/ },
/* 295 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Hungarian [hu]
	//! author : Adam Brunner : https://github.com/adambrunner
	
	;(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
	    function translate(number, withoutSuffix, key, isFuture) {
	        var num = number,
	            suffix;
	        switch (key) {
	            case 's':
	                return isFuture || withoutSuffix ? 'néhány másodperc' : 'néhány másodperce';
	            case 'm':
	                return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'mm':
	                return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'h':
	                return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'hh':
	                return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'd':
	                return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'dd':
	                return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'M':
	                return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'MM':
	                return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'y':
	                return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
	            case 'yy':
	                return num + (isFuture || withoutSuffix ? ' év' : ' éve');
	        }
	        return '';
	    }
	    function week(isFuture) {
	        return (isFuture ? '' : '[múlt] ') + '[' + weekEndings[this.day()] + '] LT[-kor]';
	    }
	
	    var hu = moment.defineLocale('hu', {
	        months: 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split('_'),
	        monthsShort: 'jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec'.split('_'),
	        weekdays: 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
	        weekdaysShort: 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
	        weekdaysMin: 'v_h_k_sze_cs_p_szo'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'YYYY.MM.DD.',
	            LL: 'YYYY. MMMM D.',
	            LLL: 'YYYY. MMMM D. H:mm',
	            LLLL: 'YYYY. MMMM D., dddd H:mm'
	        },
	        meridiemParse: /de|du/i,
	        isPM: function isPM(input) {
	            return input.charAt(1).toLowerCase() === 'u';
	        },
	        meridiem: function meridiem(hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower === true ? 'de' : 'DE';
	            } else {
	                return isLower === true ? 'du' : 'DU';
	            }
	        },
	        calendar: {
	            sameDay: '[ma] LT[-kor]',
	            nextDay: '[holnap] LT[-kor]',
	            nextWeek: function nextWeek() {
	                return week.call(this, true);
	            },
	            lastDay: '[tegnap] LT[-kor]',
	            lastWeek: function lastWeek() {
	                return week.call(this, false);
	            },
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%s múlva',
	            past: '%s',
	            s: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return hu;
	});

/***/ },
/* 296 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Armenian [hy-am]
	//! author : Armendarabyan : https://github.com/armendarabyan
	
	;(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var hyAm = moment.defineLocale('hy-am', {
	        months: {
	            format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split('_'),
	            standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split('_')
	        },
	        monthsShort: 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
	        weekdays: 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split('_'),
	        weekdaysShort: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        weekdaysMin: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY թ.',
	            LLL: 'D MMMM YYYY թ., HH:mm',
	            LLLL: 'dddd, D MMMM YYYY թ., HH:mm'
	        },
	        calendar: {
	            sameDay: '[այսօր] LT',
	            nextDay: '[վաղը] LT',
	            lastDay: '[երեկ] LT',
	            nextWeek: function nextWeek() {
	                return 'dddd [օրը ժամը] LT';
	            },
	            lastWeek: function lastWeek() {
	                return '[անցած] dddd [օրը ժամը] LT';
	            },
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%s հետո',
	            past: '%s առաջ',
	            s: 'մի քանի վայրկյան',
	            m: 'րոպե',
	            mm: '%d րոպե',
	            h: 'ժամ',
	            hh: '%d ժամ',
	            d: 'օր',
	            dd: '%d օր',
	            M: 'ամիս',
	            MM: '%d ամիս',
	            y: 'տարի',
	            yy: '%d տարի'
	        },
	        meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
	        isPM: function isPM(input) {
	            return (/^(ցերեկվա|երեկոյան)$/.test(input)
	            );
	        },
	        meridiem: function meridiem(hour) {
	            if (hour < 4) {
	                return 'գիշերվա';
	            } else if (hour < 12) {
	                return 'առավոտվա';
	            } else if (hour < 17) {
	                return 'ցերեկվա';
	            } else {
	                return 'երեկոյան';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
	        ordinal: function ordinal(number, period) {
	            switch (period) {
	                case 'DDD':
	                case 'w':
	                case 'W':
	                case 'DDDo':
	                    if (number === 1) {
	                        return number + '-ին';
	                    }
	                    return number + '-րդ';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return hyAm;
	});

/***/ },
/* 297 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Indonesian [id]
	//! author : Mohammad Satrio Utomo : https://github.com/tyok
	//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan
	
	;(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var id = moment.defineLocale('id', {
	        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split('_'),
	        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nov_Des'.split('_'),
	        weekdays: 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
	        weekdaysShort: 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
	        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /pagi|siang|sore|malam/,
	        meridiemHour: function meridiemHour(hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'siang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sore' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem: function meridiem(hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'siang';
	            } else if (hours < 19) {
	                return 'sore';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar: {
	            sameDay: '[Hari ini pukul] LT',
	            nextDay: '[Besok pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kemarin pukul] LT',
	            lastWeek: 'dddd [lalu pukul] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'dalam %s',
	            past: '%s yang lalu',
	            s: 'beberapa detik',
	            m: 'semenit',
	            mm: '%d menit',
	            h: 'sejam',
	            hh: '%d jam',
	            d: 'sehari',
	            dd: '%d hari',
	            M: 'sebulan',
	            MM: '%d bulan',
	            y: 'setahun',
	            yy: '%d tahun'
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return id;
	});

/***/ },
/* 298 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Icelandic [is]
	//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik
	
	;(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    function plural(n) {
	        if (n % 100 === 11) {
	            return true;
	        } else if (n % 10 === 1) {
	            return false;
	        }
	        return true;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture ? 'nokkrar sekúndur' : 'nokkrum sekúndum';
	            case 'm':
	                return withoutSuffix ? 'mínúta' : 'mínútu';
	            case 'mm':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum');
	                } else if (withoutSuffix) {
	                    return result + 'mínúta';
	                }
	                return result + 'mínútu';
	            case 'hh':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'klukkustundir' : 'klukkustundum');
	                }
	                return result + 'klukkustund';
	            case 'd':
	                if (withoutSuffix) {
	                    return 'dagur';
	                }
	                return isFuture ? 'dag' : 'degi';
	            case 'dd':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'dagar';
	                    }
	                    return result + (isFuture ? 'daga' : 'dögum');
	                } else if (withoutSuffix) {
	                    return result + 'dagur';
	                }
	                return result + (isFuture ? 'dag' : 'degi');
	            case 'M':
	                if (withoutSuffix) {
	                    return 'mánuður';
	                }
	                return isFuture ? 'mánuð' : 'mánuði';
	            case 'MM':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'mánuðir';
	                    }
	                    return result + (isFuture ? 'mánuði' : 'mánuðum');
	                } else if (withoutSuffix) {
	                    return result + 'mánuður';
	                }
	                return result + (isFuture ? 'mánuð' : 'mánuði');
	            case 'y':
	                return withoutSuffix || isFuture ? 'ár' : 'ári';
	            case 'yy':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
	                }
	                return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
	        }
	    }
	
	    var is = moment.defineLocale('is', {
	        months: 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split('_'),
	        monthsShort: 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
	        weekdays: 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split('_'),
	        weekdaysShort: 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
	        weekdaysMin: 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY [kl.] H:mm',
	            LLLL: 'dddd, D. MMMM YYYY [kl.] H:mm'
	        },
	        calendar: {
	            sameDay: '[í dag kl.] LT',
	            nextDay: '[á morgun kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[í gær kl.] LT',
	            lastWeek: '[síðasta] dddd [kl.] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'eftir %s',
	            past: 'fyrir %s síðan',
	            s: translate,
	            m: translate,
	            mm: translate,
	            h: 'klukkustund',
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return is;
	});

/***/ },
/* 299 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Italian [it]
	//! author : Lorenzo : https://github.com/aliem
	//! author: Mattia Larentis: https://github.com/nostalgiaz
	
	;(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var it = moment.defineLocale('it', {
	        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
	        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
	        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[Oggi alle] LT',
	            nextDay: '[Domani alle] LT',
	            nextWeek: 'dddd [alle] LT',
	            lastDay: '[Ieri alle] LT',
	            lastWeek: function lastWeek() {
	                switch (this.day()) {
	                    case 0:
	                        return '[la scorsa] dddd [alle] LT';
	                    default:
	                        return '[lo scorso] dddd [alle] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: function future(s) {
	                return (/^[0-9].+$/.test(s) ? 'tra' : 'in') + ' ' + s;
	            },
	            past: '%s fa',
	            s: 'alcuni secondi',
	            m: 'un minuto',
	            mm: '%d minuti',
	            h: 'un\'ora',
	            hh: '%d ore',
	            d: 'un giorno',
	            dd: '%d giorni',
	            M: 'un mese',
	            MM: '%d mesi',
	            y: 'un anno',
	            yy: '%d anni'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return it;
	});

/***/ },
/* 300 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Japanese [ja]
	//! author : LI Long : https://github.com/baryon
	
	;(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var ja = moment.defineLocale('ja', {
	        months: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays: '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
	        weekdaysShort: '日_月_火_水_木_金_土'.split('_'),
	        weekdaysMin: '日_月_火_水_木_金_土'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日 HH:mm dddd',
	            l: 'YYYY/MM/DD',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日 HH:mm dddd'
	        },
	        meridiemParse: /午前|午後/i,
	        isPM: function isPM(input) {
	            return input === '午後';
	        },
	        meridiem: function meridiem(hour, minute, isLower) {
	            if (hour < 12) {
	                return '午前';
	            } else {
	                return '午後';
	            }
	        },
	        calendar: {
	            sameDay: '[今日] LT',
	            nextDay: '[明日] LT',
	            nextWeek: '[来週]dddd LT',
	            lastDay: '[昨日] LT',
	            lastWeek: '[前週]dddd LT',
	            sameElse: 'L'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}日/,
	        ordinal: function ordinal(number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s後',
	            past: '%s前',
	            s: '数秒',
	            m: '1分',
	            mm: '%d分',
	            h: '1時間',
	            hh: '%d時間',
	            d: '1日',
	            dd: '%d日',
	            M: '1ヶ月',
	            MM: '%dヶ月',
	            y: '1年',
	            yy: '%d年'
	        }
	    });
	
	    return ja;
	});

/***/ },
/* 301 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Javanese [jv]
	//! author : Rony Lantip : https://github.com/lantip
	//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa
	
	;(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var jv = moment.defineLocale('jv', {
	        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split('_'),
	        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
	        weekdays: 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
	        weekdaysShort: 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
	        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /enjing|siyang|sonten|ndalu/,
	        meridiemHour: function meridiemHour(hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'enjing') {
	                return hour;
	            } else if (meridiem === 'siyang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
	                return hour + 12;
	            }
	        },
	        meridiem: function meridiem(hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'enjing';
	            } else if (hours < 15) {
	                return 'siyang';
	            } else if (hours < 19) {
	                return 'sonten';
	            } else {
	                return 'ndalu';
	            }
	        },
	        calendar: {
	            sameDay: '[Dinten puniko pukul] LT',
	            nextDay: '[Mbenjang pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kala wingi pukul] LT',
	            lastWeek: 'dddd [kepengker pukul] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'wonten ing %s',
	            past: '%s ingkang kepengker',
	            s: 'sawetawis detik',
	            m: 'setunggal menit',
	            mm: '%d menit',
	            h: 'setunggal jam',
	            hh: '%d jam',
	            d: 'sedinten',
	            dd: '%d dinten',
	            M: 'sewulan',
	            MM: '%d wulan',
	            y: 'setaun',
	            yy: '%d taun'
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return jv;
	});

/***/ },
/* 302 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Georgian [ka]
	//! author : Irakli Janiashvili : https://github.com/irakli-janiashvili
	
	;(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var ka = moment.defineLocale('ka', {
	        months: {
	            standalone: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split('_'),
	            format: 'იანვარს_თებერვალს_მარტს_აპრილის_მაისს_ივნისს_ივლისს_აგვისტს_სექტემბერს_ოქტომბერს_ნოემბერს_დეკემბერს'.split('_')
	        },
	        monthsShort: 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
	        weekdays: {
	            standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split('_'),
	            format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split('_'),
	            isFormat: /(წინა|შემდეგ)/
	        },
	        weekdaysShort: 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
	        weekdaysMin: 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar: {
	            sameDay: '[დღეს] LT[-ზე]',
	            nextDay: '[ხვალ] LT[-ზე]',
	            lastDay: '[გუშინ] LT[-ზე]',
	            nextWeek: '[შემდეგ] dddd LT[-ზე]',
	            lastWeek: '[წინა] dddd LT-ზე',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: function future(s) {
	                return (/(წამი|წუთი|საათი|წელი)/.test(s) ? s.replace(/ი$/, 'ში') : s + 'ში'
	                );
	            },
	            past: function past(s) {
	                if (/(წამი|წუთი|საათი|დღე|თვე)/.test(s)) {
	                    return s.replace(/(ი|ე)$/, 'ის უკან');
	                }
	                if (/წელი/.test(s)) {
	                    return s.replace(/წელი$/, 'წლის უკან');
	                }
	            },
	            s: 'რამდენიმე წამი',
	            m: 'წუთი',
	            mm: '%d წუთი',
	            h: 'საათი',
	            hh: '%d საათი',
	            d: 'დღე',
	            dd: '%d დღე',
	            M: 'თვე',
	            MM: '%d თვე',
	            y: 'წელი',
	            yy: '%d წელი'
	        },
	        dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
	        ordinal: function ordinal(number) {
	            if (number === 0) {
	                return number;
	            }
	            if (number === 1) {
	                return number + '-ლი';
	            }
	            if (number < 20 || number <= 100 && number % 20 === 0 || number % 100 === 0) {
	                return 'მე-' + number;
	            }
	            return number + '-ე';
	        },
	        week: {
	            dow: 1,
	            doy: 7
	        }
	    });
	
	    return ka;
	});

/***/ },
/* 303 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Kazakh [kk]
	//! authors : Nurlan Rakhimzhanov : https://github.com/nurlan
	
	;(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var suffixes = {
	        0: '-ші',
	        1: '-ші',
	        2: '-ші',
	        3: '-ші',
	        4: '-ші',
	        5: '-ші',
	        6: '-шы',
	        7: '-ші',
	        8: '-ші',
	        9: '-шы',
	        10: '-шы',
	        20: '-шы',
	        30: '-шы',
	        40: '-шы',
	        50: '-ші',
	        60: '-шы',
	        70: '-ші',
	        80: '-ші',
	        90: '-шы',
	        100: '-ші'
	    };
	
	    var kk = moment.defineLocale('kk', {
	        months: 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split('_'),
	        monthsShort: 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
	        weekdays: 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split('_'),
	        weekdaysShort: 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
	        weekdaysMin: 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[Бүгін сағат] LT',
	            nextDay: '[Ертең сағат] LT',
	            nextWeek: 'dddd [сағат] LT',
	            lastDay: '[Кеше сағат] LT',
	            lastWeek: '[Өткен аптаның] dddd [сағат] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%s ішінде',
	            past: '%s бұрын',
	            s: 'бірнеше секунд',
	            m: 'бір минут',
	            mm: '%d минут',
	            h: 'бір сағат',
	            hh: '%d сағат',
	            d: 'бір күн',
	            dd: '%d күн',
	            M: 'бір ай',
	            MM: '%d ай',
	            y: 'бір жыл',
	            yy: '%d жыл'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
	        ordinal: function ordinal(number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return kk;
	});

/***/ },
/* 304 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Cambodian [km]
	//! author : Kruy Vanna : https://github.com/kruyvanna
	
	;(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var km = moment.defineLocale('km', {
	        months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
	        monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
	        weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	        weekdaysShort: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	        weekdaysMin: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
	            nextDay: '[ស្អែក ម៉ោង] LT',
	            nextWeek: 'dddd [ម៉ោង] LT',
	            lastDay: '[ម្សិលមិញ ម៉ោង] LT',
	            lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%sទៀត',
	            past: '%sមុន',
	            s: 'ប៉ុន្មានវិនាទី',
	            m: 'មួយនាទី',
	            mm: '%d នាទី',
	            h: 'មួយម៉ោង',
	            hh: '%d ម៉ោង',
	            d: 'មួយថ្ងៃ',
	            dd: '%d ថ្ងៃ',
	            M: 'មួយខែ',
	            MM: '%d ខែ',
	            y: 'មួយឆ្នាំ',
	            yy: '%d ឆ្នាំ'
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return km;
	});

/***/ },
/* 305 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Kannada [kn]
	//! author : Rajeev Naik : https://github.com/rajeevnaikte
	
	;(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var symbolMap = {
	        '1': '೧',
	        '2': '೨',
	        '3': '೩',
	        '4': '೪',
	        '5': '೫',
	        '6': '೬',
	        '7': '೭',
	        '8': '೮',
	        '9': '೯',
	        '0': '೦'
	    };
	    var numberMap = {
	        '೧': '1',
	        '೨': '2',
	        '೩': '3',
	        '೪': '4',
	        '೫': '5',
	        '೬': '6',
	        '೭': '7',
	        '೮': '8',
	        '೯': '9',
	        '೦': '0'
	    };
	
	    var kn = moment.defineLocale('kn', {
	        months: 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split('_'),
	        monthsShort: 'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬ_ಅಕ್ಟೋಬ_ನವೆಂಬ_ಡಿಸೆಂಬ'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split('_'),
	        weekdaysShort: 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
	        weekdaysMin: 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm'
	        },
	        calendar: {
	            sameDay: '[ಇಂದು] LT',
	            nextDay: '[ನಾಳೆ] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ನಿನ್ನೆ] LT',
	            lastWeek: '[ಕೊನೆಯ] dddd, LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%s ನಂತರ',
	            past: '%s ಹಿಂದೆ',
	            s: 'ಕೆಲವು ಕ್ಷಣಗಳು',
	            m: 'ಒಂದು ನಿಮಿಷ',
	            mm: '%d ನಿಮಿಷ',
	            h: 'ಒಂದು ಗಂಟೆ',
	            hh: '%d ಗಂಟೆ',
	            d: 'ಒಂದು ದಿನ',
	            dd: '%d ದಿನ',
	            M: 'ಒಂದು ತಿಂಗಳು',
	            MM: '%d ತಿಂಗಳು',
	            y: 'ಒಂದು ವರ್ಷ',
	            yy: '%d ವರ್ಷ'
	        },
	        preparse: function preparse(string) {
	            return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function postformat(string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
	        meridiemHour: function meridiemHour(hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ರಾತ್ರಿ') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
	                return hour;
	            } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'ಸಂಜೆ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function meridiem(hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ರಾತ್ರಿ';
	            } else if (hour < 10) {
	                return 'ಬೆಳಿಗ್ಗೆ';
	            } else if (hour < 17) {
	                return 'ಮಧ್ಯಾಹ್ನ';
	            } else if (hour < 20) {
	                return 'ಸಂಜೆ';
	            } else {
	                return 'ರಾತ್ರಿ';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
	        ordinal: function ordinal(number) {
	            return number + 'ನೇ';
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return kn;
	});

/***/ },
/* 306 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Korean [ko]
	//! author : Kyungwook, Park : https://github.com/kyungw00k
	//! author : Jeeeyul Lee <jeeeyul@gmail.com>
	
	;(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var ko = moment.defineLocale('ko', {
	        months: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	        monthsShort: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	        weekdays: '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
	        weekdaysShort: '일_월_화_수_목_금_토'.split('_'),
	        weekdaysMin: '일_월_화_수_목_금_토'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'YYYY.MM.DD',
	            LL: 'YYYY년 MMMM D일',
	            LLL: 'YYYY년 MMMM D일 A h:mm',
	            LLLL: 'YYYY년 MMMM D일 dddd A h:mm',
	            l: 'YYYY.MM.DD',
	            ll: 'YYYY년 MMMM D일',
	            lll: 'YYYY년 MMMM D일 A h:mm',
	            llll: 'YYYY년 MMMM D일 dddd A h:mm'
	        },
	        calendar: {
	            sameDay: '오늘 LT',
	            nextDay: '내일 LT',
	            nextWeek: 'dddd LT',
	            lastDay: '어제 LT',
	            lastWeek: '지난주 dddd LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%s 후',
	            past: '%s 전',
	            s: '몇 초',
	            ss: '%d초',
	            m: '1분',
	            mm: '%d분',
	            h: '한 시간',
	            hh: '%d시간',
	            d: '하루',
	            dd: '%d일',
	            M: '한 달',
	            MM: '%d달',
	            y: '일 년',
	            yy: '%d년'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}일/,
	        ordinal: '%d일',
	        meridiemParse: /오전|오후/,
	        isPM: function isPM(token) {
	            return token === '오후';
	        },
	        meridiem: function meridiem(hour, minute, isUpper) {
	            return hour < 12 ? '오전' : '오후';
	        }
	    });
	
	    return ko;
	});

/***/ },
/* 307 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Kyrgyz [ky]
	//! author : Chyngyz Arystan uulu : https://github.com/chyngyz
	
	;(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var suffixes = {
	        0: '-чү',
	        1: '-чи',
	        2: '-чи',
	        3: '-чү',
	        4: '-чү',
	        5: '-чи',
	        6: '-чы',
	        7: '-чи',
	        8: '-чи',
	        9: '-чу',
	        10: '-чу',
	        20: '-чы',
	        30: '-чу',
	        40: '-чы',
	        50: '-чү',
	        60: '-чы',
	        70: '-чи',
	        80: '-чи',
	        90: '-чу',
	        100: '-чү'
	    };
	
	    var ky = moment.defineLocale('ky', {
	        months: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_'),
	        monthsShort: 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays: 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split('_'),
	        weekdaysShort: 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
	        weekdaysMin: 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[Бүгүн саат] LT',
	            nextDay: '[Эртең саат] LT',
	            nextWeek: 'dddd [саат] LT',
	            lastDay: '[Кече саат] LT',
	            lastWeek: '[Өткен аптанын] dddd [күнү] [саат] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%s ичинде',
	            past: '%s мурун',
	            s: 'бирнече секунд',
	            m: 'бир мүнөт',
	            mm: '%d мүнөт',
	            h: 'бир саат',
	            hh: '%d саат',
	            d: 'бир күн',
	            dd: '%d күн',
	            M: 'бир ай',
	            MM: '%d ай',
	            y: 'бир жыл',
	            yy: '%d жыл'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
	        ordinal: function ordinal(number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ky;
	});

/***/ },
/* 308 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Luxembourgish [lb]
	//! author : mweimerskirch : https://github.com/mweimerskirch
	//! author : David Raison : https://github.com/kwisatz
	
	;(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eng Minutt', 'enger Minutt'],
	            'h': ['eng Stonn', 'enger Stonn'],
	            'd': ['een Dag', 'engem Dag'],
	            'M': ['ee Mount', 'engem Mount'],
	            'y': ['ee Joer', 'engem Joer']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	    function processFutureTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'a ' + string;
	        }
	        return 'an ' + string;
	    }
	    function processPastTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'viru ' + string;
	        }
	        return 'virun ' + string;
	    }
	    /**
	     * Returns true if the word before the given number loses the '-n' ending.
	     * e.g. 'an 10 Deeg' but 'a 5 Deeg'
	     *
	     * @param number {integer}
	     * @returns {boolean}
	     */
	    function eifelerRegelAppliesToNumber(number) {
	        number = parseInt(number, 10);
	        if (isNaN(number)) {
	            return false;
	        }
	        if (number < 0) {
	            // Negative Number --> always true
	            return true;
	        } else if (number < 10) {
	            // Only 1 digit
	            if (4 <= number && number <= 7) {
	                return true;
	            }
	            return false;
	        } else if (number < 100) {
	            // 2 digits
	            var lastDigit = number % 10,
	                firstDigit = number / 10;
	            if (lastDigit === 0) {
	                return eifelerRegelAppliesToNumber(firstDigit);
	            }
	            return eifelerRegelAppliesToNumber(lastDigit);
	        } else if (number < 10000) {
	            // 3 or 4 digits --> recursively check first digit
	            while (number >= 10) {
	                number = number / 10;
	            }
	            return eifelerRegelAppliesToNumber(number);
	        } else {
	            // Anything larger than 4 digits: recursively check first n-3 digits
	            number = number / 1000;
	            return eifelerRegelAppliesToNumber(number);
	        }
	    }
	
	    var lb = moment.defineLocale('lb', {
	        months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split('_'),
	        weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm [Auer]',
	            LTS: 'H:mm:ss [Auer]',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm [Auer]',
	            LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]'
	        },
	        calendar: {
	            sameDay: '[Haut um] LT',
	            sameElse: 'L',
	            nextDay: '[Muer um] LT',
	            nextWeek: 'dddd [um] LT',
	            lastDay: '[Gëschter um] LT',
	            lastWeek: function lastWeek() {
	                // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
	                switch (this.day()) {
	                    case 2:
	                    case 4:
	                        return '[Leschten] dddd [um] LT';
	                    default:
	                        return '[Leschte] dddd [um] LT';
	                }
	            }
	        },
	        relativeTime: {
	            future: processFutureTime,
	            past: processPastTime,
	            s: 'e puer Sekonnen',
	            m: processRelativeTime,
	            mm: '%d Minutten',
	            h: processRelativeTime,
	            hh: '%d Stonnen',
	            d: processRelativeTime,
	            dd: '%d Deeg',
	            M: processRelativeTime,
	            MM: '%d Méint',
	            y: processRelativeTime,
	            yy: '%d Joer'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return lb;
	});

/***/ },
/* 309 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Lao [lo]
	//! author : Ryan Hart : https://github.com/ryanhart2
	
	;(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var lo = moment.defineLocale('lo', {
	        months: 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	        monthsShort: 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	        weekdays: 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysShort: 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysMin: 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'ວັນdddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
	        isPM: function isPM(input) {
	            return input === 'ຕອນແລງ';
	        },
	        meridiem: function meridiem(hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ຕອນເຊົ້າ';
	            } else {
	                return 'ຕອນແລງ';
	            }
	        },
	        calendar: {
	            sameDay: '[ມື້ນີ້ເວລາ] LT',
	            nextDay: '[ມື້ອື່ນເວລາ] LT',
	            nextWeek: '[ວັນ]dddd[ໜ້າເວລາ] LT',
	            lastDay: '[ມື້ວານນີ້ເວລາ] LT',
	            lastWeek: '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'ອີກ %s',
	            past: '%sຜ່ານມາ',
	            s: 'ບໍ່ເທົ່າໃດວິນາທີ',
	            m: '1 ນາທີ',
	            mm: '%d ນາທີ',
	            h: '1 ຊົ່ວໂມງ',
	            hh: '%d ຊົ່ວໂມງ',
	            d: '1 ມື້',
	            dd: '%d ມື້',
	            M: '1 ເດືອນ',
	            MM: '%d ເດືອນ',
	            y: '1 ປີ',
	            yy: '%d ປີ'
	        },
	        dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
	        ordinal: function ordinal(number) {
	            return 'ທີ່' + number;
	        }
	    });
	
	    return lo;
	});

/***/ },
/* 310 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Lithuanian [lt]
	//! author : Mindaugas Mozūras : https://github.com/mmozuras
	
	;(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var units = {
	        'm': 'minutė_minutės_minutę',
	        'mm': 'minutės_minučių_minutes',
	        'h': 'valanda_valandos_valandą',
	        'hh': 'valandos_valandų_valandas',
	        'd': 'diena_dienos_dieną',
	        'dd': 'dienos_dienų_dienas',
	        'M': 'mėnuo_mėnesio_mėnesį',
	        'MM': 'mėnesiai_mėnesių_mėnesius',
	        'y': 'metai_metų_metus',
	        'yy': 'metai_metų_metus'
	    };
	    function translateSeconds(number, withoutSuffix, key, isFuture) {
	        if (withoutSuffix) {
	            return 'kelios sekundės';
	        } else {
	            return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
	        }
	    }
	    function translateSingular(number, withoutSuffix, key, isFuture) {
	        return withoutSuffix ? forms(key)[0] : isFuture ? forms(key)[1] : forms(key)[2];
	    }
	    function special(number) {
	        return number % 10 === 0 || number > 10 && number < 20;
	    }
	    function forms(key) {
	        return units[key].split('_');
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        if (number === 1) {
	            return result + translateSingular(number, withoutSuffix, key[0], isFuture);
	        } else if (withoutSuffix) {
	            return result + (special(number) ? forms(key)[1] : forms(key)[0]);
	        } else {
	            if (isFuture) {
	                return result + forms(key)[1];
	            } else {
	                return result + (special(number) ? forms(key)[1] : forms(key)[2]);
	            }
	        }
	    }
	    var lt = moment.defineLocale('lt', {
	        months: {
	            format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split('_'),
	            standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split('_'),
	            isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/
	        },
	        monthsShort: 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
	        weekdays: {
	            format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split('_'),
	            standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split('_'),
	            isFormat: /dddd HH:mm/
	        },
	        weekdaysShort: 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
	        weekdaysMin: 'S_P_A_T_K_Pn_Š'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY [m.] MMMM D [d.]',
	            LLL: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            LLLL: 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
	            l: 'YYYY-MM-DD',
	            ll: 'YYYY [m.] MMMM D [d.]',
	            lll: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            llll: 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]'
	        },
	        calendar: {
	            sameDay: '[Šiandien] LT',
	            nextDay: '[Rytoj] LT',
	            nextWeek: 'dddd LT',
	            lastDay: '[Vakar] LT',
	            lastWeek: '[Praėjusį] dddd LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'po %s',
	            past: 'prieš %s',
	            s: translateSeconds,
	            m: translateSingular,
	            mm: translate,
	            h: translateSingular,
	            hh: translate,
	            d: translateSingular,
	            dd: translate,
	            M: translateSingular,
	            MM: translate,
	            y: translateSingular,
	            yy: translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-oji/,
	        ordinal: function ordinal(number) {
	            return number + '-oji';
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return lt;
	});

/***/ },
/* 311 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Latvian [lv]
	//! author : Kristaps Karlsons : https://github.com/skakri
	//! author : Jānis Elmeris : https://github.com/JanisE
	
	;(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var units = {
	        'm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        'mm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        'h': 'stundas_stundām_stunda_stundas'.split('_'),
	        'hh': 'stundas_stundām_stunda_stundas'.split('_'),
	        'd': 'dienas_dienām_diena_dienas'.split('_'),
	        'dd': 'dienas_dienām_diena_dienas'.split('_'),
	        'M': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        'MM': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        'y': 'gada_gadiem_gads_gadi'.split('_'),
	        'yy': 'gada_gadiem_gads_gadi'.split('_')
	    };
	    /**
	     * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
	     */
	    function format(forms, number, withoutSuffix) {
	        if (withoutSuffix) {
	            // E.g. "21 minūte", "3 minūtes".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
	        } else {
	            // E.g. "21 minūtes" as in "pēc 21 minūtes".
	            // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
	        }
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        return number + ' ' + format(units[key], number, withoutSuffix);
	    }
	    function relativeTimeWithSingular(number, withoutSuffix, key) {
	        return format(units[key], number, withoutSuffix);
	    }
	    function relativeSeconds(number, withoutSuffix) {
	        return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
	    }
	
	    var lv = moment.defineLocale('lv', {
	        months: 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split('_'),
	        monthsShort: 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
	        weekdays: 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split('_'),
	        weekdaysShort: 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysMin: 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY.',
	            LL: 'YYYY. [gada] D. MMMM',
	            LLL: 'YYYY. [gada] D. MMMM, HH:mm',
	            LLLL: 'YYYY. [gada] D. MMMM, dddd, HH:mm'
	        },
	        calendar: {
	            sameDay: '[Šodien pulksten] LT',
	            nextDay: '[Rīt pulksten] LT',
	            nextWeek: 'dddd [pulksten] LT',
	            lastDay: '[Vakar pulksten] LT',
	            lastWeek: '[Pagājušā] dddd [pulksten] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'pēc %s',
	            past: 'pirms %s',
	            s: relativeSeconds,
	            m: relativeTimeWithSingular,
	            mm: relativeTimeWithPlural,
	            h: relativeTimeWithSingular,
	            hh: relativeTimeWithPlural,
	            d: relativeTimeWithSingular,
	            dd: relativeTimeWithPlural,
	            M: relativeTimeWithSingular,
	            MM: relativeTimeWithPlural,
	            y: relativeTimeWithSingular,
	            yy: relativeTimeWithPlural
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return lv;
	});

/***/ },
/* 312 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Montenegrin [me]
	//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac
	
	;(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var translator = {
	        words: { //Different grammatical cases
	            m: ['jedan minut', 'jednog minuta'],
	            mm: ['minut', 'minuta', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            dd: ['dan', 'dana', 'dana'],
	            MM: ['mjesec', 'mjeseca', 'mjeseci'],
	            yy: ['godina', 'godine', 'godina']
	        },
	        correctGrammaticalCase: function correctGrammaticalCase(number, wordKey) {
	            return number === 1 ? wordKey[0] : number >= 2 && number <= 4 ? wordKey[1] : wordKey[2];
	        },
	        translate: function translate(number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	            }
	        }
	    };
	
	    var me = moment.defineLocale('me', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sjutra u] LT',
	
	            nextWeek: function nextWeek() {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[juče u] LT',
	            lastWeek: function lastWeek() {
	                var lastWeekDays = ['[prošle] [nedjelje] [u] LT', '[prošlog] [ponedjeljka] [u] LT', '[prošlog] [utorka] [u] LT', '[prošle] [srijede] [u] LT', '[prošlog] [četvrtka] [u] LT', '[prošlog] [petka] [u] LT', '[prošle] [subote] [u] LT'];
	                return lastWeekDays[this.day()];
	            },
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'prije %s',
	            s: 'nekoliko sekundi',
	            m: translator.translate,
	            mm: translator.translate,
	            h: translator.translate,
	            hh: translator.translate,
	            d: 'dan',
	            dd: translator.translate,
	            M: 'mjesec',
	            MM: translator.translate,
	            y: 'godinu',
	            yy: translator.translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return me;
	});

/***/ },
/* 313 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Maori [mi]
	//! author : John Corrigan <robbiecloset@gmail.com> : https://github.com/johnideal
	
	;(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var mi = moment.defineLocale('mi', {
	        months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split('_'),
	        monthsShort: 'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split('_'),
	        monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
	        weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
	        weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	        weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [i] HH:mm',
	            LLLL: 'dddd, D MMMM YYYY [i] HH:mm'
	        },
	        calendar: {
	            sameDay: '[i teie mahana, i] LT',
	            nextDay: '[apopo i] LT',
	            nextWeek: 'dddd [i] LT',
	            lastDay: '[inanahi i] LT',
	            lastWeek: 'dddd [whakamutunga i] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'i roto i %s',
	            past: '%s i mua',
	            s: 'te hēkona ruarua',
	            m: 'he meneti',
	            mm: '%d meneti',
	            h: 'te haora',
	            hh: '%d haora',
	            d: 'he ra',
	            dd: '%d ra',
	            M: 'he marama',
	            MM: '%d marama',
	            y: 'he tau',
	            yy: '%d tau'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return mi;
	});

/***/ },
/* 314 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Macedonian [mk]
	//! author : Borislav Mickov : https://github.com/B0k0
	
	;(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var mk = moment.defineLocale('mk', {
	        months: 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split('_'),
	        monthsShort: 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays: 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split('_'),
	        weekdaysShort: 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
	        weekdaysMin: 'нe_пo_вт_ср_че_пе_сa'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY H:mm',
	            LLLL: 'dddd, D MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[Денес во] LT',
	            nextDay: '[Утре во] LT',
	            nextWeek: '[Во] dddd [во] LT',
	            lastDay: '[Вчера во] LT',
	            lastWeek: function lastWeek() {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[Изминатата] dddd [во] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[Изминатиот] dddd [во] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'после %s',
	            past: 'пред %s',
	            s: 'неколку секунди',
	            m: 'минута',
	            mm: '%d минути',
	            h: 'час',
	            hh: '%d часа',
	            d: 'ден',
	            dd: '%d дена',
	            M: 'месец',
	            MM: '%d месеци',
	            y: 'година',
	            yy: '%d години'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal: function ordinal(number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return mk;
	});

/***/ },
/* 315 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Malayalam [ml]
	//! author : Floyd Pink : https://github.com/floydpink
	
	;(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var ml = moment.defineLocale('ml', {
	        months: 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split('_'),
	        monthsShort: 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split('_'),
	        weekdaysShort: 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
	        weekdaysMin: 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm -നു',
	            LTS: 'A h:mm:ss -നു',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm -നു',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm -നു'
	        },
	        calendar: {
	            sameDay: '[ഇന്ന്] LT',
	            nextDay: '[നാളെ] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ഇന്നലെ] LT',
	            lastWeek: '[കഴിഞ്ഞ] dddd, LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%s കഴിഞ്ഞ്',
	            past: '%s മുൻപ്',
	            s: 'അൽപ നിമിഷങ്ങൾ',
	            m: 'ഒരു മിനിറ്റ്',
	            mm: '%d മിനിറ്റ്',
	            h: 'ഒരു മണിക്കൂർ',
	            hh: '%d മണിക്കൂർ',
	            d: 'ഒരു ദിവസം',
	            dd: '%d ദിവസം',
	            M: 'ഒരു മാസം',
	            MM: '%d മാസം',
	            y: 'ഒരു വർഷം',
	            yy: '%d വർഷം'
	        },
	        meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
	        meridiemHour: function meridiemHour(hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'രാത്രി' && hour >= 4 || meridiem === 'ഉച്ച കഴിഞ്ഞ്' || meridiem === 'വൈകുന്നേരം') {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem: function meridiem(hour, minute, isLower) {
	            if (hour < 4) {
	                return 'രാത്രി';
	            } else if (hour < 12) {
	                return 'രാവിലെ';
	            } else if (hour < 17) {
	                return 'ഉച്ച കഴിഞ്ഞ്';
	            } else if (hour < 20) {
	                return 'വൈകുന്നേരം';
	            } else {
	                return 'രാത്രി';
	            }
	        }
	    });
	
	    return ml;
	});

/***/ },
/* 316 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Marathi [mr]
	//! author : Harshad Kale : https://github.com/kalehv
	//! author : Vivek Athalye : https://github.com/vnathalye
	
	;(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var symbolMap = {
	        '1': '१',
	        '2': '२',
	        '3': '३',
	        '4': '४',
	        '5': '५',
	        '6': '६',
	        '7': '७',
	        '8': '८',
	        '9': '९',
	        '0': '०'
	    };
	    var numberMap = {
	        '१': '1',
	        '२': '2',
	        '३': '3',
	        '४': '4',
	        '५': '5',
	        '६': '6',
	        '७': '7',
	        '८': '8',
	        '९': '9',
	        '०': '0'
	    };
	
	    function relativeTimeMr(number, withoutSuffix, string, isFuture) {
	        var output = '';
	        if (withoutSuffix) {
	            switch (string) {
	                case 's':
	                    output = 'काही सेकंद';break;
	                case 'm':
	                    output = 'एक मिनिट';break;
	                case 'mm':
	                    output = '%d मिनिटे';break;
	                case 'h':
	                    output = 'एक तास';break;
	                case 'hh':
	                    output = '%d तास';break;
	                case 'd':
	                    output = 'एक दिवस';break;
	                case 'dd':
	                    output = '%d दिवस';break;
	                case 'M':
	                    output = 'एक महिना';break;
	                case 'MM':
	                    output = '%d महिने';break;
	                case 'y':
	                    output = 'एक वर्ष';break;
	                case 'yy':
	                    output = '%d वर्षे';break;
	            }
	        } else {
	            switch (string) {
	                case 's':
	                    output = 'काही सेकंदां';break;
	                case 'm':
	                    output = 'एका मिनिटा';break;
	                case 'mm':
	                    output = '%d मिनिटां';break;
	                case 'h':
	                    output = 'एका तासा';break;
	                case 'hh':
	                    output = '%d तासां';break;
	                case 'd':
	                    output = 'एका दिवसा';break;
	                case 'dd':
	                    output = '%d दिवसां';break;
	                case 'M':
	                    output = 'एका महिन्या';break;
	                case 'MM':
	                    output = '%d महिन्यां';break;
	                case 'y':
	                    output = 'एका वर्षा';break;
	                case 'yy':
	                    output = '%d वर्षां';break;
	            }
	        }
	        return output.replace(/%d/i, number);
	    }
	
	    var mr = moment.defineLocale('mr', {
	        months: 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split('_'),
	        monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort: 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm वाजता',
	            LTS: 'A h:mm:ss वाजता',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm वाजता',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm वाजता'
	        },
	        calendar: {
	            sameDay: '[आज] LT',
	            nextDay: '[उद्या] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[काल] LT',
	            lastWeek: '[मागील] dddd, LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%sमध्ये',
	            past: '%sपूर्वी',
	            s: relativeTimeMr,
	            m: relativeTimeMr,
	            mm: relativeTimeMr,
	            h: relativeTimeMr,
	            hh: relativeTimeMr,
	            d: relativeTimeMr,
	            dd: relativeTimeMr,
	            M: relativeTimeMr,
	            MM: relativeTimeMr,
	            y: relativeTimeMr,
	            yy: relativeTimeMr
	        },
	        preparse: function preparse(string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function postformat(string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /रात्री|सकाळी|दुपारी|सायंकाळी/,
	        meridiemHour: function meridiemHour(hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'रात्री') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सकाळी') {
	                return hour;
	            } else if (meridiem === 'दुपारी') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'सायंकाळी') {
	                return hour + 12;
	            }
	        },
	        meridiem: function meridiem(hour, minute, isLower) {
	            if (hour < 4) {
	                return 'रात्री';
	            } else if (hour < 10) {
	                return 'सकाळी';
	            } else if (hour < 17) {
	                return 'दुपारी';
	            } else if (hour < 20) {
	                return 'सायंकाळी';
	            } else {
	                return 'रात्री';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return mr;
	});

/***/ },
/* 317 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Malay [ms-my]
	//! note : DEPRECATED, the correct one is [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var msMy = moment.defineLocale('ms-my', {
	        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function meridiemHour(hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem: function meridiem(hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar: {
	            sameDay: '[Hari ini pukul] LT',
	            nextDay: '[Esok pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kelmarin pukul] LT',
	            lastWeek: 'dddd [lepas pukul] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'dalam %s',
	            past: '%s yang lepas',
	            s: 'beberapa saat',
	            m: 'seminit',
	            mm: '%d minit',
	            h: 'sejam',
	            hh: '%d jam',
	            d: 'sehari',
	            dd: '%d hari',
	            M: 'sebulan',
	            MM: '%d bulan',
	            y: 'setahun',
	            yy: '%d tahun'
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return msMy;
	});

/***/ },
/* 318 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Malay [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var ms = moment.defineLocale('ms', {
	        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function meridiemHour(hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem: function meridiem(hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar: {
	            sameDay: '[Hari ini pukul] LT',
	            nextDay: '[Esok pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kelmarin pukul] LT',
	            lastWeek: 'dddd [lepas pukul] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'dalam %s',
	            past: '%s yang lepas',
	            s: 'beberapa saat',
	            m: 'seminit',
	            mm: '%d minit',
	            h: 'sejam',
	            hh: '%d jam',
	            d: 'sehari',
	            dd: '%d hari',
	            M: 'sebulan',
	            MM: '%d bulan',
	            y: 'setahun',
	            yy: '%d tahun'
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ms;
	});

/***/ },
/* 319 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Burmese [my]
	//! author : Squar team, mysquar.com
	//! author : David Rossellat : https://github.com/gholadr
	//! author : Tin Aung Lin : https://github.com/thanyawzinmin
	
	;(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var symbolMap = {
	        '1': '၁',
	        '2': '၂',
	        '3': '၃',
	        '4': '၄',
	        '5': '၅',
	        '6': '၆',
	        '7': '၇',
	        '8': '၈',
	        '9': '၉',
	        '0': '၀'
	    };
	    var numberMap = {
	        '၁': '1',
	        '၂': '2',
	        '၃': '3',
	        '၄': '4',
	        '၅': '5',
	        '၆': '6',
	        '၇': '7',
	        '၈': '8',
	        '၉': '9',
	        '၀': '0'
	    };
	
	    var my = moment.defineLocale('my', {
	        months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split('_'),
	        monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
	        weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split('_'),
	        weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	        weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[ယနေ.] LT [မှာ]',
	            nextDay: '[မနက်ဖြန်] LT [မှာ]',
	            nextWeek: 'dddd LT [မှာ]',
	            lastDay: '[မနေ.က] LT [မှာ]',
	            lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'လာမည့် %s မှာ',
	            past: 'လွန်ခဲ့သော %s က',
	            s: 'စက္ကန်.အနည်းငယ်',
	            m: 'တစ်မိနစ်',
	            mm: '%d မိနစ်',
	            h: 'တစ်နာရီ',
	            hh: '%d နာရီ',
	            d: 'တစ်ရက်',
	            dd: '%d ရက်',
	            M: 'တစ်လ',
	            MM: '%d လ',
	            y: 'တစ်နှစ်',
	            yy: '%d နှစ်'
	        },
	        preparse: function preparse(string) {
	            return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function postformat(string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return my;
	});

/***/ },
/* 320 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Norwegian Bokmål [nb]
	//! authors : Espen Hovlandsdal : https://github.com/rexxars
	//!           Sigurd Gartmann : https://github.com/sigurdga
	
	;(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var nb = moment.defineLocale('nb', {
	        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	        monthsShort: 'jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort: 'sø._ma._ti._on._to._fr._lø.'.split('_'),
	        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY [kl.] HH:mm',
	            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm'
	        },
	        calendar: {
	            sameDay: '[i dag kl.] LT',
	            nextDay: '[i morgen kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[i går kl.] LT',
	            lastWeek: '[forrige] dddd [kl.] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: '%s siden',
	            s: 'noen sekunder',
	            m: 'ett minutt',
	            mm: '%d minutter',
	            h: 'en time',
	            hh: '%d timer',
	            d: 'en dag',
	            dd: '%d dager',
	            M: 'en måned',
	            MM: '%d måneder',
	            y: 'ett år',
	            yy: '%d år'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nb;
	});

/***/ },
/* 321 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Nepalese [ne]
	//! author : suvash : https://github.com/suvash
	
	;(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var symbolMap = {
	        '1': '१',
	        '2': '२',
	        '3': '३',
	        '4': '४',
	        '5': '५',
	        '6': '६',
	        '7': '७',
	        '8': '८',
	        '9': '९',
	        '0': '०'
	    };
	    var numberMap = {
	        '१': '1',
	        '२': '2',
	        '३': '3',
	        '४': '4',
	        '५': '5',
	        '६': '6',
	        '७': '7',
	        '८': '8',
	        '९': '9',
	        '०': '0'
	    };
	
	    var ne = moment.defineLocale('ne', {
	        months: 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split('_'),
	        monthsShort: 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split('_'),
	        weekdaysShort: 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
	        weekdaysMin: 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'Aको h:mm बजे',
	            LTS: 'Aको h:mm:ss बजे',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, Aको h:mm बजे',
	            LLLL: 'dddd, D MMMM YYYY, Aको h:mm बजे'
	        },
	        preparse: function preparse(string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function postformat(string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
	        meridiemHour: function meridiemHour(hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'राति') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'बिहान') {
	                return hour;
	            } else if (meridiem === 'दिउँसो') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'साँझ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function meridiem(hour, minute, isLower) {
	            if (hour < 3) {
	                return 'राति';
	            } else if (hour < 12) {
	                return 'बिहान';
	            } else if (hour < 16) {
	                return 'दिउँसो';
	            } else if (hour < 20) {
	                return 'साँझ';
	            } else {
	                return 'राति';
	            }
	        },
	        calendar: {
	            sameDay: '[आज] LT',
	            nextDay: '[भोलि] LT',
	            nextWeek: '[आउँदो] dddd[,] LT',
	            lastDay: '[हिजो] LT',
	            lastWeek: '[गएको] dddd[,] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%sमा',
	            past: '%s अगाडि',
	            s: 'केही क्षण',
	            m: 'एक मिनेट',
	            mm: '%d मिनेट',
	            h: 'एक घण्टा',
	            hh: '%d घण्टा',
	            d: 'एक दिन',
	            dd: '%d दिन',
	            M: 'एक महिना',
	            MM: '%d महिना',
	            y: 'एक बर्ष',
	            yy: '%d बर्ष'
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ne;
	});

/***/ },
/* 322 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Dutch (Belgium) [nl-be]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_');
	    var monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	    var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	    var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	    var nlBe = moment.defineLocale('nl-be', {
	        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	        monthsShort: function monthsShort(m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
	        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        weekdays: 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin: 'Zo_Ma_Di_Wo_Do_Vr_Za'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'over %s',
	            past: '%s geleden',
	            s: 'een paar seconden',
	            m: 'één minuut',
	            mm: '%d minuten',
	            h: 'één uur',
	            hh: '%d uur',
	            d: 'één dag',
	            dd: '%d dagen',
	            M: 'één maand',
	            MM: '%d maanden',
	            y: 'één jaar',
	            yy: '%d jaar'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function ordinal(number) {
	            return number + (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de');
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nlBe;
	});

/***/ },
/* 323 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Dutch [nl]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_');
	    var monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	    var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	    var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	    var nl = moment.defineLocale('nl', {
	        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	        monthsShort: function monthsShort(m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
	        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        weekdays: 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin: 'Zo_Ma_Di_Wo_Do_Vr_Za'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'over %s',
	            past: '%s geleden',
	            s: 'een paar seconden',
	            m: 'één minuut',
	            mm: '%d minuten',
	            h: 'één uur',
	            hh: '%d uur',
	            d: 'één dag',
	            dd: '%d dagen',
	            M: 'één maand',
	            MM: '%d maanden',
	            y: 'één jaar',
	            yy: '%d jaar'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function ordinal(number) {
	            return number + (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de');
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nl;
	});

/***/ },
/* 324 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Nynorsk [nn]
	//! author : https://github.com/mechuwind
	
	;(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var nn = moment.defineLocale('nn', {
	        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	        monthsShort: 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	        weekdays: 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
	        weekdaysShort: 'sun_mån_tys_ons_tor_fre_lau'.split('_'),
	        weekdaysMin: 'su_må_ty_on_to_fr_lø'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY [kl.] H:mm',
	            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm'
	        },
	        calendar: {
	            sameDay: '[I dag klokka] LT',
	            nextDay: '[I morgon klokka] LT',
	            nextWeek: 'dddd [klokka] LT',
	            lastDay: '[I går klokka] LT',
	            lastWeek: '[Føregåande] dddd [klokka] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: '%s sidan',
	            s: 'nokre sekund',
	            m: 'eit minutt',
	            mm: '%d minutt',
	            h: 'ein time',
	            hh: '%d timar',
	            d: 'ein dag',
	            dd: '%d dagar',
	            M: 'ein månad',
	            MM: '%d månader',
	            y: 'eit år',
	            yy: '%d år'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nn;
	});

/***/ },
/* 325 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Punjabi (India) [pa-in]
	//! author : Harpreet Singh : https://github.com/harpreetkhalsagtbit
	
	;(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var symbolMap = {
	        '1': '੧',
	        '2': '੨',
	        '3': '੩',
	        '4': '੪',
	        '5': '੫',
	        '6': '੬',
	        '7': '੭',
	        '8': '੮',
	        '9': '੯',
	        '0': '੦'
	    };
	    var numberMap = {
	        '੧': '1',
	        '੨': '2',
	        '੩': '3',
	        '੪': '4',
	        '੫': '5',
	        '੬': '6',
	        '੭': '7',
	        '੮': '8',
	        '੯': '9',
	        '੦': '0'
	    };
	
	    var paIn = moment.defineLocale('pa-in', {
	        // There are months name as per Nanakshahi Calender but they are not used as rigidly in modern Punjabi.
	        months: 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	        monthsShort: 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	        weekdays: 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split('_'),
	        weekdaysShort: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        weekdaysMin: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm ਵਜੇ',
	            LTS: 'A h:mm:ss ਵਜੇ',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm ਵਜੇ',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm ਵਜੇ'
	        },
	        calendar: {
	            sameDay: '[ਅਜ] LT',
	            nextDay: '[ਕਲ] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ਕਲ] LT',
	            lastWeek: '[ਪਿਛਲੇ] dddd, LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%s ਵਿੱਚ',
	            past: '%s ਪਿਛਲੇ',
	            s: 'ਕੁਝ ਸਕਿੰਟ',
	            m: 'ਇਕ ਮਿੰਟ',
	            mm: '%d ਮਿੰਟ',
	            h: 'ਇੱਕ ਘੰਟਾ',
	            hh: '%d ਘੰਟੇ',
	            d: 'ਇੱਕ ਦਿਨ',
	            dd: '%d ਦਿਨ',
	            M: 'ਇੱਕ ਮਹੀਨਾ',
	            MM: '%d ਮਹੀਨੇ',
	            y: 'ਇੱਕ ਸਾਲ',
	            yy: '%d ਸਾਲ'
	        },
	        preparse: function preparse(string) {
	            return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function postformat(string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
	        meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
	        meridiemHour: function meridiemHour(hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ਰਾਤ') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ਸਵੇਰ') {
	                return hour;
	            } else if (meridiem === 'ਦੁਪਹਿਰ') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'ਸ਼ਾਮ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function meridiem(hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ਰਾਤ';
	            } else if (hour < 10) {
	                return 'ਸਵੇਰ';
	            } else if (hour < 17) {
	                return 'ਦੁਪਹਿਰ';
	            } else if (hour < 20) {
	                return 'ਸ਼ਾਮ';
	            } else {
	                return 'ਰਾਤ';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return paIn;
	});

/***/ },
/* 326 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Polish [pl]
	//! author : Rafal Hirsz : https://github.com/evoL
	
	;(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split('_');
	    var monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split('_');
	    function plural(n) {
	        return n % 10 < 5 && n % 10 > 1 && ~~(n / 10) % 10 !== 1;
	    }
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'm':
	                return withoutSuffix ? 'minuta' : 'minutę';
	            case 'mm':
	                return result + (plural(number) ? 'minuty' : 'minut');
	            case 'h':
	                return withoutSuffix ? 'godzina' : 'godzinę';
	            case 'hh':
	                return result + (plural(number) ? 'godziny' : 'godzin');
	            case 'MM':
	                return result + (plural(number) ? 'miesiące' : 'miesięcy');
	            case 'yy':
	                return result + (plural(number) ? 'lata' : 'lat');
	        }
	    }
	
	    var pl = moment.defineLocale('pl', {
	        months: function months(momentToFormat, format) {
	            if (!momentToFormat) {
	                return monthsNominative;
	            } else if (format === '') {
	                // Hack: if format empty we know this is used to generate
	                // RegExp by moment. Give then back both valid forms of months
	                // in RegExp ready format.
	                return '(' + monthsSubjective[momentToFormat.month()] + '|' + monthsNominative[momentToFormat.month()] + ')';
	            } else if (/D MMMM/.test(format)) {
	                return monthsSubjective[momentToFormat.month()];
	            } else {
	                return monthsNominative[momentToFormat.month()];
	            }
	        },
	        monthsShort: 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
	        weekdays: 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
	        weekdaysShort: 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
	        weekdaysMin: 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[Dziś o] LT',
	            nextDay: '[Jutro o] LT',
	            nextWeek: '[W] dddd [o] LT',
	            lastDay: '[Wczoraj o] LT',
	            lastWeek: function lastWeek() {
	                switch (this.day()) {
	                    case 0:
	                        return '[W zeszłą niedzielę o] LT';
	                    case 3:
	                        return '[W zeszłą środę o] LT';
	                    case 6:
	                        return '[W zeszłą sobotę o] LT';
	                    default:
	                        return '[W zeszły] dddd [o] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: '%s temu',
	            s: 'kilka sekund',
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: '1 dzień',
	            dd: '%d dni',
	            M: 'miesiąc',
	            MM: translate,
	            y: 'rok',
	            yy: translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return pl;
	});

/***/ },
/* 327 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Portuguese (Brazil) [pt-br]
	//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira
	
	;(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var ptBr = moment.defineLocale('pt-br', {
	        months: 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
	        monthsShort: 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	        weekdays: 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
	        weekdaysShort: 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	        weekdaysMin: 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY [às] HH:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY [às] HH:mm'
	        },
	        calendar: {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function lastWeek() {
	                return this.day() === 0 || this.day() === 6 ? '[Último] dddd [às] LT' : // Saturday + Sunday
	                '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'em %s',
	            past: '%s atrás',
	            s: 'poucos segundos',
	            m: 'um minuto',
	            mm: '%d minutos',
	            h: 'uma hora',
	            hh: '%d horas',
	            d: 'um dia',
	            dd: '%d dias',
	            M: 'um mês',
	            MM: '%d meses',
	            y: 'um ano',
	            yy: '%d anos'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº'
	    });
	
	    return ptBr;
	});

/***/ },
/* 328 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Portuguese [pt]
	//! author : Jefferson : https://github.com/jalex79
	
	;(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var pt = moment.defineLocale('pt', {
	        months: 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
	        monthsShort: 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	        weekdays: 'Domingo_Segunda-Feira_Terça-Feira_Quarta-Feira_Quinta-Feira_Sexta-Feira_Sábado'.split('_'),
	        weekdaysShort: 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	        weekdaysMin: 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY HH:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function lastWeek() {
	                return this.day() === 0 || this.day() === 6 ? '[Último] dddd [às] LT' : // Saturday + Sunday
	                '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'em %s',
	            past: 'há %s',
	            s: 'segundos',
	            m: 'um minuto',
	            mm: '%d minutos',
	            h: 'uma hora',
	            hh: '%d horas',
	            d: 'um dia',
	            dd: '%d dias',
	            M: 'um mês',
	            MM: '%d meses',
	            y: 'um ano',
	            yy: '%d anos'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return pt;
	});

/***/ },
/* 329 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Romanian [ro]
	//! author : Vlad Gurdiga : https://github.com/gurdiga
	//! author : Valentin Agachi : https://github.com/avaly
	
	;(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            'mm': 'minute',
	            'hh': 'ore',
	            'dd': 'zile',
	            'MM': 'luni',
	            'yy': 'ani'
	        },
	            separator = ' ';
	        if (number % 100 >= 20 || number >= 100 && number % 100 === 0) {
	            separator = ' de ';
	        }
	        return number + separator + format[key];
	    }
	
	    var ro = moment.defineLocale('ro', {
	        months: 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split('_'),
	        monthsShort: 'ian._febr._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
	        weekdaysShort: 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
	        weekdaysMin: 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY H:mm',
	            LLLL: 'dddd, D MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[azi la] LT',
	            nextDay: '[mâine la] LT',
	            nextWeek: 'dddd [la] LT',
	            lastDay: '[ieri la] LT',
	            lastWeek: '[fosta] dddd [la] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'peste %s',
	            past: '%s în urmă',
	            s: 'câteva secunde',
	            m: 'un minut',
	            mm: relativeTimeWithPlural,
	            h: 'o oră',
	            hh: relativeTimeWithPlural,
	            d: 'o zi',
	            dd: relativeTimeWithPlural,
	            M: 'o lună',
	            MM: relativeTimeWithPlural,
	            y: 'un an',
	            yy: relativeTimeWithPlural
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ro;
	});

/***/ },
/* 330 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Russian [ru]
	//! author : Viktorminator : https://github.com/Viktorminator
	//! Author : Menelion Elensúle : https://github.com/Oire
	//! author : Коренберг Марк : https://github.com/socketpair
	
	;(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2];
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            'mm': withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
	            'hh': 'час_часа_часов',
	            'dd': 'день_дня_дней',
	            'MM': 'месяц_месяца_месяцев',
	            'yy': 'год_года_лет'
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'минута' : 'минуту';
	        } else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    var monthsParse = [/^янв/i, /^фев/i, /^мар/i, /^апр/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^авг/i, /^сен/i, /^окт/i, /^ноя/i, /^дек/i];
	
	    // http://new.gramota.ru/spravka/rules/139-prop : § 103
	    // Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
	    // CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
	    var ru = moment.defineLocale('ru', {
	        months: {
	            format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split('_'),
	            standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_')
	        },
	        monthsShort: {
	            // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку ?
	            format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split('_'),
	            standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split('_')
	        },
	        weekdays: {
	            standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
	            format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split('_'),
	            isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\] ?dddd/
	        },
	        weekdaysShort: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
	        monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // копия предыдущего
	        monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // полные названия с падежами
	        monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,
	
	        // Выражение, которое соотвествует только сокращённым формам
	        monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY г.',
	            LLL: 'D MMMM YYYY г., HH:mm',
	            LLLL: 'dddd, D MMMM YYYY г., HH:mm'
	        },
	        calendar: {
	            sameDay: '[Сегодня в] LT',
	            nextDay: '[Завтра в] LT',
	            lastDay: '[Вчера в] LT',
	            nextWeek: function nextWeek(now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В следующее] dddd [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В следующий] dddd [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В следующую] dddd [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd [в] LT';
	                    } else {
	                        return '[В] dddd [в] LT';
	                    }
	                }
	            },
	            lastWeek: function lastWeek(now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В прошлое] dddd [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В прошлый] dddd [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В прошлую] dddd [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd [в] LT';
	                    } else {
	                        return '[В] dddd [в] LT';
	                    }
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'через %s',
	            past: '%s назад',
	            s: 'несколько секунд',
	            m: relativeTimeWithPlural,
	            mm: relativeTimeWithPlural,
	            h: 'час',
	            hh: relativeTimeWithPlural,
	            d: 'день',
	            dd: relativeTimeWithPlural,
	            M: 'месяц',
	            MM: relativeTimeWithPlural,
	            y: 'год',
	            yy: relativeTimeWithPlural
	        },
	        meridiemParse: /ночи|утра|дня|вечера/i,
	        isPM: function isPM(input) {
	            return (/^(дня|вечера)$/.test(input)
	            );
	        },
	        meridiem: function meridiem(hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночи';
	            } else if (hour < 12) {
	                return 'утра';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечера';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
	        ordinal: function ordinal(number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                case 'w':
	                case 'W':
	                    return number + '-я';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ru;
	});

/***/ },
/* 331 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Sindhi [sd]
	//! author : Narain Sagar : https://github.com/narainsagar
	
	;(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var months = ['جنوري', 'فيبروري', 'مارچ', 'اپريل', 'مئي', 'جون', 'جولاءِ', 'آگسٽ', 'سيپٽمبر', 'آڪٽوبر', 'نومبر', 'ڊسمبر'];
	    var days = ['آچر', 'سومر', 'اڱارو', 'اربع', 'خميس', 'جمع', 'ڇنڇر'];
	
	    var sd = moment.defineLocale('sd', {
	        months: months,
	        monthsShort: months,
	        weekdays: days,
	        weekdaysShort: days,
	        weekdaysMin: days,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd، D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /صبح|شام/,
	        isPM: function isPM(input) {
	            return 'شام' === input;
	        },
	        meridiem: function meridiem(hour, minute, isLower) {
	            if (hour < 12) {
	                return 'صبح';
	            }
	            return 'شام';
	        },
	        calendar: {
	            sameDay: '[اڄ] LT',
	            nextDay: '[سڀاڻي] LT',
	            nextWeek: 'dddd [اڳين هفتي تي] LT',
	            lastDay: '[ڪالهه] LT',
	            lastWeek: '[گزريل هفتي] dddd [تي] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%s پوء',
	            past: '%s اڳ',
	            s: 'چند سيڪنڊ',
	            m: 'هڪ منٽ',
	            mm: '%d منٽ',
	            h: 'هڪ ڪلاڪ',
	            hh: '%d ڪلاڪ',
	            d: 'هڪ ڏينهن',
	            dd: '%d ڏينهن',
	            M: 'هڪ مهينو',
	            MM: '%d مهينا',
	            y: 'هڪ سال',
	            yy: '%d سال'
	        },
	        preparse: function preparse(string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function postformat(string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sd;
	});

/***/ },
/* 332 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Northern Sami [se]
	//! authors : Bård Rolstad Henriksen : https://github.com/karamell
	
	;(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var se = moment.defineLocale('se', {
	        months: 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split('_'),
	        monthsShort: 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
	        weekdays: 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split('_'),
	        weekdaysShort: 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
	        weekdaysMin: 's_v_m_g_d_b_L'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'MMMM D. [b.] YYYY',
	            LLL: 'MMMM D. [b.] YYYY [ti.] HH:mm',
	            LLLL: 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm'
	        },
	        calendar: {
	            sameDay: '[otne ti] LT',
	            nextDay: '[ihttin ti] LT',
	            nextWeek: 'dddd [ti] LT',
	            lastDay: '[ikte ti] LT',
	            lastWeek: '[ovddit] dddd [ti] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%s geažes',
	            past: 'maŋit %s',
	            s: 'moadde sekunddat',
	            m: 'okta minuhta',
	            mm: '%d minuhtat',
	            h: 'okta diimmu',
	            hh: '%d diimmut',
	            d: 'okta beaivi',
	            dd: '%d beaivvit',
	            M: 'okta mánnu',
	            MM: '%d mánut',
	            y: 'okta jahki',
	            yy: '%d jagit'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return se;
	});

/***/ },
/* 333 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Sinhalese [si]
	//! author : Sampath Sitinamaluwa : https://github.com/sampathsris
	
	;(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    /*jshint -W100*/
	
	    var si = moment.defineLocale('si', {
	        months: 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split('_'),
	        monthsShort: 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split('_'),
	        weekdays: 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split('_'),
	        weekdaysShort: 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
	        weekdaysMin: 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'a h:mm',
	            LTS: 'a h:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY MMMM D',
	            LLL: 'YYYY MMMM D, a h:mm',
	            LLLL: 'YYYY MMMM D [වැනි] dddd, a h:mm:ss'
	        },
	        calendar: {
	            sameDay: '[අද] LT[ට]',
	            nextDay: '[හෙට] LT[ට]',
	            nextWeek: 'dddd LT[ට]',
	            lastDay: '[ඊයේ] LT[ට]',
	            lastWeek: '[පසුගිය] dddd LT[ට]',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%sකින්',
	            past: '%sකට පෙර',
	            s: 'තත්පර කිහිපය',
	            m: 'මිනිත්තුව',
	            mm: 'මිනිත්තු %d',
	            h: 'පැය',
	            hh: 'පැය %d',
	            d: 'දිනය',
	            dd: 'දින %d',
	            M: 'මාසය',
	            MM: 'මාස %d',
	            y: 'වසර',
	            yy: 'වසර %d'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
	        ordinal: function ordinal(number) {
	            return number + ' වැනි';
	        },
	        meridiemParse: /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
	        isPM: function isPM(input) {
	            return input === 'ප.ව.' || input === 'පස් වරු';
	        },
	        meridiem: function meridiem(hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'ප.ව.' : 'පස් වරු';
	            } else {
	                return isLower ? 'පෙ.ව.' : 'පෙර වරු';
	            }
	        }
	    });
	
	    return si;
	});

/***/ },
/* 334 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Slovak [sk]
	//! author : Martin Minka : https://github.com/k2s
	//! based on work of petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split('_');
	    var monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
	    function plural(n) {
	        return n > 1 && n < 5;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                // a few seconds / in a few seconds / a few seconds ago
	                return withoutSuffix || isFuture ? 'pár sekúnd' : 'pár sekundami';
	            case 'm':
	                // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minúta' : isFuture ? 'minútu' : 'minútou';
	            case 'mm':
	                // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minúty' : 'minút');
	                } else {
	                    return result + 'minútami';
	                }
	                break;
	            case 'h':
	                // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
	            case 'hh':
	                // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodín');
	                } else {
	                    return result + 'hodinami';
	                }
	                break;
	            case 'd':
	                // a day / in a day / a day ago
	                return withoutSuffix || isFuture ? 'deň' : 'dňom';
	            case 'dd':
	                // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dni' : 'dní');
	                } else {
	                    return result + 'dňami';
	                }
	                break;
	            case 'M':
	                // a month / in a month / a month ago
	                return withoutSuffix || isFuture ? 'mesiac' : 'mesiacom';
	            case 'MM':
	                // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'mesiace' : 'mesiacov');
	                } else {
	                    return result + 'mesiacmi';
	                }
	                break;
	            case 'y':
	                // a year / in a year / a year ago
	                return withoutSuffix || isFuture ? 'rok' : 'rokom';
	            case 'yy':
	                // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'rokov');
	                } else {
	                    return result + 'rokmi';
	                }
	                break;
	        }
	    }
	
	    var sk = moment.defineLocale('sk', {
	        months: months,
	        monthsShort: monthsShort,
	        weekdays: 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
	        weekdaysShort: 'ne_po_ut_st_št_pi_so'.split('_'),
	        weekdaysMin: 'ne_po_ut_st_št_pi_so'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[dnes o] LT',
	            nextDay: '[zajtra o] LT',
	            nextWeek: function nextWeek() {
	                switch (this.day()) {
	                    case 0:
	                        return '[v nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [o] LT';
	                    case 3:
	                        return '[v stredu o] LT';
	                    case 4:
	                        return '[vo štvrtok o] LT';
	                    case 5:
	                        return '[v piatok o] LT';
	                    case 6:
	                        return '[v sobotu o] LT';
	                }
	            },
	            lastDay: '[včera o] LT',
	            lastWeek: function lastWeek() {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulú nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[minulý] dddd [o] LT';
	                    case 3:
	                        return '[minulú stredu o] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [o] LT';
	                    case 6:
	                        return '[minulú sobotu o] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'pred %s',
	            s: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sk;
	});

/***/ },
/* 335 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Slovenian [sl]
	//! author : Robert Sedovšek : https://github.com/sedovsek
	
	;(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture ? 'nekaj sekund' : 'nekaj sekundami';
	            case 'm':
	                return withoutSuffix ? 'ena minuta' : 'eno minuto';
	            case 'mm':
	                if (number === 1) {
	                    result += withoutSuffix ? 'minuta' : 'minuto';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'minute' : 'minutami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'minut' : 'minutami';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'ena ura' : 'eno uro';
	            case 'hh':
	                if (number === 1) {
	                    result += withoutSuffix ? 'ura' : 'uro';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'uri' : 'urama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'ure' : 'urami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'ur' : 'urami';
	                }
	                return result;
	            case 'd':
	                return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
	            case 'dd':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'dan' : 'dnem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
	                } else {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
	                }
	                return result;
	            case 'M':
	                return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
	            case 'MM':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
	                } else {
	                    result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
	                }
	                return result;
	            case 'y':
	                return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
	            case 'yy':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'leto' : 'letom';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'leti' : 'letoma';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'leta' : 'leti';
	                } else {
	                    result += withoutSuffix || isFuture ? 'let' : 'leti';
	                }
	                return result;
	        }
	    }
	
	    var sl = moment.defineLocale('sl', {
	        months: 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split('_'),
	        monthsShort: 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
	        weekdaysShort: 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
	        weekdaysMin: 'ne_po_to_sr_če_pe_so'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[danes ob] LT',
	            nextDay: '[jutri ob] LT',
	
	            nextWeek: function nextWeek() {
	                switch (this.day()) {
	                    case 0:
	                        return '[v] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[v] [sredo] [ob] LT';
	                    case 6:
	                        return '[v] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[v] dddd [ob] LT';
	                }
	            },
	            lastDay: '[včeraj ob] LT',
	            lastWeek: function lastWeek() {
	                switch (this.day()) {
	                    case 0:
	                        return '[prejšnjo] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[prejšnjo] [sredo] [ob] LT';
	                    case 6:
	                        return '[prejšnjo] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prejšnji] dddd [ob] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'čez %s',
	            past: 'pred %s',
	            s: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return sl;
	});

/***/ },
/* 336 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Albanian [sq]
	//! author : Flakërim Ismani : https://github.com/flakerimi
	//! author : Menelion Elensúle : https://github.com/Oire
	//! author : Oerd Cukalla : https://github.com/oerd
	
	;(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var sq = moment.defineLocale('sq', {
	        months: 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split('_'),
	        monthsShort: 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
	        weekdays: 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split('_'),
	        weekdaysShort: 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
	        weekdaysMin: 'D_H_Ma_Më_E_P_Sh'.split('_'),
	        weekdaysParseExact: true,
	        meridiemParse: /PD|MD/,
	        isPM: function isPM(input) {
	            return input.charAt(0) === 'M';
	        },
	        meridiem: function meridiem(hours, minutes, isLower) {
	            return hours < 12 ? 'PD' : 'MD';
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[Sot në] LT',
	            nextDay: '[Nesër në] LT',
	            nextWeek: 'dddd [në] LT',
	            lastDay: '[Dje në] LT',
	            lastWeek: 'dddd [e kaluar në] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'në %s',
	            past: '%s më parë',
	            s: 'disa sekonda',
	            m: 'një minutë',
	            mm: '%d minuta',
	            h: 'një orë',
	            hh: '%d orë',
	            d: 'një ditë',
	            dd: '%d ditë',
	            M: 'një muaj',
	            MM: '%d muaj',
	            y: 'një vit',
	            yy: '%d vite'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sq;
	});

/***/ },
/* 337 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Serbian Cyrillic [sr-cyrl]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	
	;(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var translator = {
	        words: { //Different grammatical cases
	            m: ['један минут', 'једне минуте'],
	            mm: ['минут', 'минуте', 'минута'],
	            h: ['један сат', 'једног сата'],
	            hh: ['сат', 'сата', 'сати'],
	            dd: ['дан', 'дана', 'дана'],
	            MM: ['месец', 'месеца', 'месеци'],
	            yy: ['година', 'године', 'година']
	        },
	        correctGrammaticalCase: function correctGrammaticalCase(number, wordKey) {
	            return number === 1 ? wordKey[0] : number >= 2 && number <= 4 ? wordKey[1] : wordKey[2];
	        },
	        translate: function translate(number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	            }
	        }
	    };
	
	    var srCyrl = moment.defineLocale('sr-cyrl', {
	        months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split('_'),
	        monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
	        weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
	        weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[данас у] LT',
	            nextDay: '[сутра у] LT',
	            nextWeek: function nextWeek() {
	                switch (this.day()) {
	                    case 0:
	                        return '[у] [недељу] [у] LT';
	                    case 3:
	                        return '[у] [среду] [у] LT';
	                    case 6:
	                        return '[у] [суботу] [у] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[у] dddd [у] LT';
	                }
	            },
	            lastDay: '[јуче у] LT',
	            lastWeek: function lastWeek() {
	                var lastWeekDays = ['[прошле] [недеље] [у] LT', '[прошлог] [понедељка] [у] LT', '[прошлог] [уторка] [у] LT', '[прошле] [среде] [у] LT', '[прошлог] [четвртка] [у] LT', '[прошлог] [петка] [у] LT', '[прошле] [суботе] [у] LT'];
	                return lastWeekDays[this.day()];
	            },
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'за %s',
	            past: 'пре %s',
	            s: 'неколико секунди',
	            m: translator.translate,
	            mm: translator.translate,
	            h: translator.translate,
	            hh: translator.translate,
	            d: 'дан',
	            dd: translator.translate,
	            M: 'месец',
	            MM: translator.translate,
	            y: 'годину',
	            yy: translator.translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return srCyrl;
	});

/***/ },
/* 338 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Serbian [sr]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	
	;(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var translator = {
	        words: { //Different grammatical cases
	            m: ['jedan minut', 'jedne minute'],
	            mm: ['minut', 'minute', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            dd: ['dan', 'dana', 'dana'],
	            MM: ['mesec', 'meseca', 'meseci'],
	            yy: ['godina', 'godine', 'godina']
	        },
	        correctGrammaticalCase: function correctGrammaticalCase(number, wordKey) {
	            return number === 1 ? wordKey[0] : number >= 2 && number <= 4 ? wordKey[1] : wordKey[2];
	        },
	        translate: function translate(number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	            }
	        }
	    };
	
	    var sr = moment.defineLocale('sr', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function nextWeek() {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedelju] [u] LT';
	                    case 3:
	                        return '[u] [sredu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[juče u] LT',
	            lastWeek: function lastWeek() {
	                var lastWeekDays = ['[prošle] [nedelje] [u] LT', '[prošlog] [ponedeljka] [u] LT', '[prošlog] [utorka] [u] LT', '[prošle] [srede] [u] LT', '[prošlog] [četvrtka] [u] LT', '[prošlog] [petka] [u] LT', '[prošle] [subote] [u] LT'];
	                return lastWeekDays[this.day()];
	            },
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'pre %s',
	            s: 'nekoliko sekundi',
	            m: translator.translate,
	            mm: translator.translate,
	            h: translator.translate,
	            hh: translator.translate,
	            d: 'dan',
	            dd: translator.translate,
	            M: 'mesec',
	            MM: translator.translate,
	            y: 'godinu',
	            yy: translator.translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return sr;
	});

/***/ },
/* 339 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : siSwati [ss]
	//! author : Nicolai Davies<mail@nicolai.io> : https://github.com/nicolaidavies
	
	;(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var ss = moment.defineLocale('ss', {
	        months: "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split('_'),
	        monthsShort: 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
	        weekdays: 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split('_'),
	        weekdaysShort: 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
	        weekdaysMin: 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar: {
	            sameDay: '[Namuhla nga] LT',
	            nextDay: '[Kusasa nga] LT',
	            nextWeek: 'dddd [nga] LT',
	            lastDay: '[Itolo nga] LT',
	            lastWeek: 'dddd [leliphelile] [nga] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'nga %s',
	            past: 'wenteka nga %s',
	            s: 'emizuzwana lomcane',
	            m: 'umzuzu',
	            mm: '%d emizuzu',
	            h: 'lihora',
	            hh: '%d emahora',
	            d: 'lilanga',
	            dd: '%d emalanga',
	            M: 'inyanga',
	            MM: '%d tinyanga',
	            y: 'umnyaka',
	            yy: '%d iminyaka'
	        },
	        meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
	        meridiem: function meridiem(hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'ekuseni';
	            } else if (hours < 15) {
	                return 'emini';
	            } else if (hours < 19) {
	                return 'entsambama';
	            } else {
	                return 'ebusuku';
	            }
	        },
	        meridiemHour: function meridiemHour(hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ekuseni') {
	                return hour;
	            } else if (meridiem === 'emini') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
	                if (hour === 0) {
	                    return 0;
	                }
	                return hour + 12;
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: '%d',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ss;
	});

/***/ },
/* 340 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Swedish [sv]
	//! author : Jens Alm : https://github.com/ulmus
	
	;(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var sv = moment.defineLocale('sv', {
	        months: 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
	        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays: 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
	        weekdaysShort: 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
	        weekdaysMin: 'sö_må_ti_on_to_fr_lö'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [kl.] HH:mm',
	            LLLL: 'dddd D MMMM YYYY [kl.] HH:mm',
	            lll: 'D MMM YYYY HH:mm',
	            llll: 'ddd D MMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[Idag] LT',
	            nextDay: '[Imorgon] LT',
	            lastDay: '[Igår] LT',
	            nextWeek: '[På] dddd LT',
	            lastWeek: '[I] dddd[s] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: 'för %s sedan',
	            s: 'några sekunder',
	            m: 'en minut',
	            mm: '%d minuter',
	            h: 'en timme',
	            hh: '%d timmar',
	            d: 'en dag',
	            dd: '%d dagar',
	            M: 'en månad',
	            MM: '%d månader',
	            y: 'ett år',
	            yy: '%d år'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(e|a)/,
	        ordinal: function ordinal(number) {
	            var b = number % 10,
	                output = ~~(number % 100 / 10) === 1 ? 'e' : b === 1 ? 'a' : b === 2 ? 'a' : b === 3 ? 'e' : 'e';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sv;
	});

/***/ },
/* 341 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Swahili [sw]
	//! author : Fahad Kassim : https://github.com/fadsel
	
	;(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var sw = moment.defineLocale('sw', {
	        months: 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split('_'),
	        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
	        weekdays: 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split('_'),
	        weekdaysShort: 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
	        weekdaysMin: 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[leo saa] LT',
	            nextDay: '[kesho saa] LT',
	            nextWeek: '[wiki ijayo] dddd [saat] LT',
	            lastDay: '[jana] LT',
	            lastWeek: '[wiki iliyopita] dddd [saat] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%s baadaye',
	            past: 'tokea %s',
	            s: 'hivi punde',
	            m: 'dakika moja',
	            mm: 'dakika %d',
	            h: 'saa limoja',
	            hh: 'masaa %d',
	            d: 'siku moja',
	            dd: 'masiku %d',
	            M: 'mwezi mmoja',
	            MM: 'miezi %d',
	            y: 'mwaka mmoja',
	            yy: 'miaka %d'
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return sw;
	});

/***/ },
/* 342 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Tamil [ta]
	//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404
	
	;(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var symbolMap = {
	        '1': '௧',
	        '2': '௨',
	        '3': '௩',
	        '4': '௪',
	        '5': '௫',
	        '6': '௬',
	        '7': '௭',
	        '8': '௮',
	        '9': '௯',
	        '0': '௦'
	    };
	    var numberMap = {
	        '௧': '1',
	        '௨': '2',
	        '௩': '3',
	        '௪': '4',
	        '௫': '5',
	        '௬': '6',
	        '௭': '7',
	        '௮': '8',
	        '௯': '9',
	        '௦': '0'
	    };
	
	    var ta = moment.defineLocale('ta', {
	        months: 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	        monthsShort: 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	        weekdays: 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split('_'),
	        weekdaysShort: 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split('_'),
	        weekdaysMin: 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, HH:mm',
	            LLLL: 'dddd, D MMMM YYYY, HH:mm'
	        },
	        calendar: {
	            sameDay: '[இன்று] LT',
	            nextDay: '[நாளை] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[நேற்று] LT',
	            lastWeek: '[கடந்த வாரம்] dddd, LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%s இல்',
	            past: '%s முன்',
	            s: 'ஒரு சில விநாடிகள்',
	            m: 'ஒரு நிமிடம்',
	            mm: '%d நிமிடங்கள்',
	            h: 'ஒரு மணி நேரம்',
	            hh: '%d மணி நேரம்',
	            d: 'ஒரு நாள்',
	            dd: '%d நாட்கள்',
	            M: 'ஒரு மாதம்',
	            MM: '%d மாதங்கள்',
	            y: 'ஒரு வருடம்',
	            yy: '%d ஆண்டுகள்'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}வது/,
	        ordinal: function ordinal(number) {
	            return number + 'வது';
	        },
	        preparse: function preparse(string) {
	            return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function postformat(string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // refer http://ta.wikipedia.org/s/1er1
	        meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
	        meridiem: function meridiem(hour, minute, isLower) {
	            if (hour < 2) {
	                return ' யாமம்';
	            } else if (hour < 6) {
	                return ' வைகறை'; // வைகறை
	            } else if (hour < 10) {
	                return ' காலை'; // காலை
	            } else if (hour < 14) {
	                return ' நண்பகல்'; // நண்பகல்
	            } else if (hour < 18) {
	                return ' எற்பாடு'; // எற்பாடு
	            } else if (hour < 22) {
	                return ' மாலை'; // மாலை
	            } else {
	                return ' யாமம்';
	            }
	        },
	        meridiemHour: function meridiemHour(hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'யாமம்') {
	                return hour < 2 ? hour : hour + 12;
	            } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
	                return hour;
	            } else if (meridiem === 'நண்பகல்') {
	                return hour >= 10 ? hour : hour + 12;
	            } else {
	                return hour + 12;
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ta;
	});

/***/ },
/* 343 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Telugu [te]
	//! author : Krishna Chaitanya Thota : https://github.com/kcthota
	
	;(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var te = moment.defineLocale('te', {
	        months: 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జూలై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split('_'),
	        monthsShort: 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జూలై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split('_'),
	        weekdaysShort: 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
	        weekdaysMin: 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm'
	        },
	        calendar: {
	            sameDay: '[నేడు] LT',
	            nextDay: '[రేపు] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[నిన్న] LT',
	            lastWeek: '[గత] dddd, LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%s లో',
	            past: '%s క్రితం',
	            s: 'కొన్ని క్షణాలు',
	            m: 'ఒక నిమిషం',
	            mm: '%d నిమిషాలు',
	            h: 'ఒక గంట',
	            hh: '%d గంటలు',
	            d: 'ఒక రోజు',
	            dd: '%d రోజులు',
	            M: 'ఒక నెల',
	            MM: '%d నెలలు',
	            y: 'ఒక సంవత్సరం',
	            yy: '%d సంవత్సరాలు'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}వ/,
	        ordinal: '%dవ',
	        meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
	        meridiemHour: function meridiemHour(hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'రాత్రి') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ఉదయం') {
	                return hour;
	            } else if (meridiem === 'మధ్యాహ్నం') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'సాయంత్రం') {
	                return hour + 12;
	            }
	        },
	        meridiem: function meridiem(hour, minute, isLower) {
	            if (hour < 4) {
	                return 'రాత్రి';
	            } else if (hour < 10) {
	                return 'ఉదయం';
	            } else if (hour < 17) {
	                return 'మధ్యాహ్నం';
	            } else if (hour < 20) {
	                return 'సాయంత్రం';
	            } else {
	                return 'రాత్రి';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return te;
	});

/***/ },
/* 344 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Tetun Dili (East Timor) [tet]
	//! author : Joshua Brooks : https://github.com/joshbrooks
	//! author : Onorio De J. Afonso : https://github.com/marobo
	
	;(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var tet = moment.defineLocale('tet', {
	        months: 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juniu_Juliu_Augustu_Setembru_Outubru_Novembru_Dezembru'.split('_'),
	        monthsShort: 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Aug_Set_Out_Nov_Dez'.split('_'),
	        weekdays: 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sexta_Sabadu'.split('_'),
	        weekdaysShort: 'Dom_Seg_Ters_Kua_Kint_Sext_Sab'.split('_'),
	        weekdaysMin: 'Do_Seg_Te_Ku_Ki_Sex_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[Ohin iha] LT',
	            nextDay: '[Aban iha] LT',
	            nextWeek: 'dddd [iha] LT',
	            lastDay: '[Horiseik iha] LT',
	            lastWeek: 'dddd [semana kotuk] [iha] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'iha %s',
	            past: '%s liuba',
	            s: 'minutu balun',
	            m: 'minutu ida',
	            mm: 'minutus %d',
	            h: 'horas ida',
	            hh: 'horas %d',
	            d: 'loron ida',
	            dd: 'loron %d',
	            M: 'fulan ida',
	            MM: 'fulan %d',
	            y: 'tinan ida',
	            yy: 'tinan %d'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function ordinal(number) {
	            var b = number % 10,
	                output = ~~(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return tet;
	});

/***/ },
/* 345 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Thai [th]
	//! author : Kridsada Thanabulpong : https://github.com/sirn
	
	;(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var th = moment.defineLocale('th', {
	        months: 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split('_'),
	        monthsShort: 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
	        weekdaysShort: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
	        weekdaysMin: 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY เวลา H:mm',
	            LLLL: 'วันddddที่ D MMMM YYYY เวลา H:mm'
	        },
	        meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
	        isPM: function isPM(input) {
	            return input === 'หลังเที่ยง';
	        },
	        meridiem: function meridiem(hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ก่อนเที่ยง';
	            } else {
	                return 'หลังเที่ยง';
	            }
	        },
	        calendar: {
	            sameDay: '[วันนี้ เวลา] LT',
	            nextDay: '[พรุ่งนี้ เวลา] LT',
	            nextWeek: 'dddd[หน้า เวลา] LT',
	            lastDay: '[เมื่อวานนี้ เวลา] LT',
	            lastWeek: '[วัน]dddd[ที่แล้ว เวลา] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'อีก %s',
	            past: '%sที่แล้ว',
	            s: 'ไม่กี่วินาที',
	            m: '1 นาที',
	            mm: '%d นาที',
	            h: '1 ชั่วโมง',
	            hh: '%d ชั่วโมง',
	            d: '1 วัน',
	            dd: '%d วัน',
	            M: '1 เดือน',
	            MM: '%d เดือน',
	            y: '1 ปี',
	            yy: '%d ปี'
	        }
	    });
	
	    return th;
	});

/***/ },
/* 346 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Tagalog (Philippines) [tl-ph]
	//! author : Dan Hagman : https://github.com/hagmandan
	
	;(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var tlPh = moment.defineLocale('tl-ph', {
	        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split('_'),
	        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split('_'),
	        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'MM/D/YYYY',
	            LL: 'MMMM D, YYYY',
	            LLL: 'MMMM D, YYYY HH:mm',
	            LLLL: 'dddd, MMMM DD, YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: 'LT [ngayong araw]',
	            nextDay: '[Bukas ng] LT',
	            nextWeek: 'LT [sa susunod na] dddd',
	            lastDay: 'LT [kahapon]',
	            lastWeek: 'LT [noong nakaraang] dddd',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'sa loob ng %s',
	            past: '%s ang nakalipas',
	            s: 'ilang segundo',
	            m: 'isang minuto',
	            mm: '%d minuto',
	            h: 'isang oras',
	            hh: '%d oras',
	            d: 'isang araw',
	            dd: '%d araw',
	            M: 'isang buwan',
	            MM: '%d buwan',
	            y: 'isang taon',
	            yy: '%d taon'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: function ordinal(number) {
	            return number;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return tlPh;
	});

/***/ },
/* 347 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Klingon [tlh]
	//! author : Dominika Kruk : https://github.com/amaranthrose
	
	;(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');
	
	    function translateFuture(output) {
	        var time = output;
	        time = output.indexOf('jaj') !== -1 ? time.slice(0, -3) + 'leS' : output.indexOf('jar') !== -1 ? time.slice(0, -3) + 'waQ' : output.indexOf('DIS') !== -1 ? time.slice(0, -3) + 'nem' : time + ' pIq';
	        return time;
	    }
	
	    function translatePast(output) {
	        var time = output;
	        time = output.indexOf('jaj') !== -1 ? time.slice(0, -3) + 'Hu’' : output.indexOf('jar') !== -1 ? time.slice(0, -3) + 'wen' : output.indexOf('DIS') !== -1 ? time.slice(0, -3) + 'ben' : time + ' ret';
	        return time;
	    }
	
	    function translate(number, withoutSuffix, string, isFuture) {
	        var numberNoun = numberAsNoun(number);
	        switch (string) {
	            case 'mm':
	                return numberNoun + ' tup';
	            case 'hh':
	                return numberNoun + ' rep';
	            case 'dd':
	                return numberNoun + ' jaj';
	            case 'MM':
	                return numberNoun + ' jar';
	            case 'yy':
	                return numberNoun + ' DIS';
	        }
	    }
	
	    function numberAsNoun(number) {
	        var hundred = Math.floor(number % 1000 / 100),
	            ten = Math.floor(number % 100 / 10),
	            one = number % 10,
	            word = '';
	        if (hundred > 0) {
	            word += numbersNouns[hundred] + 'vatlh';
	        }
	        if (ten > 0) {
	            word += (word !== '' ? ' ' : '') + numbersNouns[ten] + 'maH';
	        }
	        if (one > 0) {
	            word += (word !== '' ? ' ' : '') + numbersNouns[one];
	        }
	        return word === '' ? 'pagh' : word;
	    }
	
	    var tlh = moment.defineLocale('tlh', {
	        months: 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split('_'),
	        monthsShort: 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        weekdaysShort: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        weekdaysMin: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[DaHjaj] LT',
	            nextDay: '[wa’leS] LT',
	            nextWeek: 'LLL',
	            lastDay: '[wa’Hu’] LT',
	            lastWeek: 'LLL',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: translateFuture,
	            past: translatePast,
	            s: 'puS lup',
	            m: 'wa’ tup',
	            mm: translate,
	            h: 'wa’ rep',
	            hh: translate,
	            d: 'wa’ jaj',
	            dd: translate,
	            M: 'wa’ jar',
	            MM: translate,
	            y: 'wa’ DIS',
	            yy: translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return tlh;
	});

/***/ },
/* 348 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Turkish [tr]
	//! authors : Erhan Gundogan : https://github.com/erhangundogan,
	//!           Burak Yiğit Kaya: https://github.com/BYK
	
	;(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var suffixes = {
	        1: '\'inci',
	        5: '\'inci',
	        8: '\'inci',
	        70: '\'inci',
	        80: '\'inci',
	        2: '\'nci',
	        7: '\'nci',
	        20: '\'nci',
	        50: '\'nci',
	        3: '\'üncü',
	        4: '\'üncü',
	        100: '\'üncü',
	        6: '\'ncı',
	        9: '\'uncu',
	        10: '\'uncu',
	        30: '\'uncu',
	        60: '\'ıncı',
	        90: '\'ıncı'
	    };
	
	    var tr = moment.defineLocale('tr', {
	        months: 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split('_'),
	        monthsShort: 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
	        weekdays: 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split('_'),
	        weekdaysShort: 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
	        weekdaysMin: 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[bugün saat] LT',
	            nextDay: '[yarın saat] LT',
	            nextWeek: '[haftaya] dddd [saat] LT',
	            lastDay: '[dün] LT',
	            lastWeek: '[geçen hafta] dddd [saat] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%s sonra',
	            past: '%s önce',
	            s: 'birkaç saniye',
	            m: 'bir dakika',
	            mm: '%d dakika',
	            h: 'bir saat',
	            hh: '%d saat',
	            d: 'bir gün',
	            dd: '%d gün',
	            M: 'bir ay',
	            MM: '%d ay',
	            y: 'bir yıl',
	            yy: '%d yıl'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}'(inci|nci|üncü|ncı|uncu|ıncı)/,
	        ordinal: function ordinal(number) {
	            if (number === 0) {
	                // special case for zero
	                return number + '\'ıncı';
	            }
	            var a = number % 10,
	                b = number % 100 - a,
	                c = number >= 100 ? 100 : null;
	            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return tr;
	});

/***/ },
/* 349 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Talossan [tzl]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	//! author : Iustì Canun
	
	;(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    // After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
	    // This is currently too difficult (maybe even impossible) to add.
	
	    var tzl = moment.defineLocale('tzl', {
	        months: 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split('_'),
	        monthsShort: 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
	        weekdays: 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
	        weekdaysShort: 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
	        weekdaysMin: 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM [dallas] YYYY',
	            LLL: 'D. MMMM [dallas] YYYY HH.mm',
	            LLLL: 'dddd, [li] D. MMMM [dallas] YYYY HH.mm'
	        },
	        meridiemParse: /d\'o|d\'a/i,
	        isPM: function isPM(input) {
	            return 'd\'o' === input.toLowerCase();
	        },
	        meridiem: function meridiem(hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'd\'o' : 'D\'O';
	            } else {
	                return isLower ? 'd\'a' : 'D\'A';
	            }
	        },
	        calendar: {
	            sameDay: '[oxhi à] LT',
	            nextDay: '[demà à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[ieiri à] LT',
	            lastWeek: '[sür el] dddd [lasteu à] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'osprei %s',
	            past: 'ja%s',
	            s: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            's': ['viensas secunds', '\'iensas secunds'],
	            'm': ['\'n míut', '\'iens míut'],
	            'mm': [number + ' míuts', '' + number + ' míuts'],
	            'h': ['\'n þora', '\'iensa þora'],
	            'hh': [number + ' þoras', '' + number + ' þoras'],
	            'd': ['\'n ziua', '\'iensa ziua'],
	            'dd': [number + ' ziuas', '' + number + ' ziuas'],
	            'M': ['\'n mes', '\'iens mes'],
	            'MM': [number + ' mesen', '' + number + ' mesen'],
	            'y': ['\'n ar', '\'iens ar'],
	            'yy': [number + ' ars', '' + number + ' ars']
	        };
	        return isFuture ? format[key][0] : withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    return tzl;
	});

/***/ },
/* 350 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight Latin [tzm-latn]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var tzmLatn = moment.defineLocale('tzm-latn', {
	        months: 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	        monthsShort: 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	        weekdays: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysShort: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysMin: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[asdkh g] LT',
	            nextDay: '[aska g] LT',
	            nextWeek: 'dddd [g] LT',
	            lastDay: '[assant g] LT',
	            lastWeek: 'dddd [g] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'dadkh s yan %s',
	            past: 'yan %s',
	            s: 'imik',
	            m: 'minuḍ',
	            mm: '%d minuḍ',
	            h: 'saɛa',
	            hh: '%d tassaɛin',
	            d: 'ass',
	            dd: '%d ossan',
	            M: 'ayowr',
	            MM: '%d iyyirn',
	            y: 'asgas',
	            yy: '%d isgasn'
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return tzmLatn;
	});

/***/ },
/* 351 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight [tzm]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var tzm = moment.defineLocale('tzm', {
	        months: 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	        monthsShort: 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	        weekdays: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysShort: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysMin: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
	            nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
	            nextWeek: 'dddd [ⴴ] LT',
	            lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
	            lastWeek: 'dddd [ⴴ] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
	            past: 'ⵢⴰⵏ %s',
	            s: 'ⵉⵎⵉⴽ',
	            m: 'ⵎⵉⵏⵓⴺ',
	            mm: '%d ⵎⵉⵏⵓⴺ',
	            h: 'ⵙⴰⵄⴰ',
	            hh: '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
	            d: 'ⴰⵙⵙ',
	            dd: '%d oⵙⵙⴰⵏ',
	            M: 'ⴰⵢoⵓⵔ',
	            MM: '%d ⵉⵢⵢⵉⵔⵏ',
	            y: 'ⴰⵙⴳⴰⵙ',
	            yy: '%d ⵉⵙⴳⴰⵙⵏ'
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return tzm;
	});

/***/ },
/* 352 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Ukrainian [uk]
	//! author : zemlanin : https://github.com/zemlanin
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2];
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            'mm': withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
	            'hh': withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
	            'dd': 'день_дні_днів',
	            'MM': 'місяць_місяці_місяців',
	            'yy': 'рік_роки_років'
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвилина' : 'хвилину';
	        } else if (key === 'h') {
	            return withoutSuffix ? 'година' : 'годину';
	        } else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    function weekdaysCaseReplace(m, format) {
	        var weekdays = {
	            'nominative': 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split('_'),
	            'accusative': 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split('_'),
	            'genitive': 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split('_')
	        };
	
	        if (!m) {
	            return weekdays['nominative'];
	        }
	
	        var nounCase = /(\[[ВвУу]\]) ?dddd/.test(format) ? 'accusative' : /\[?(?:минулої|наступної)? ?\] ?dddd/.test(format) ? 'genitive' : 'nominative';
	        return weekdays[nounCase][m.day()];
	    }
	    function processHoursFunction(str) {
	        return function () {
	            return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
	        };
	    }
	
	    var uk = moment.defineLocale('uk', {
	        months: {
	            'format': 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split('_'),
	            'standalone': 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split('_')
	        },
	        monthsShort: 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split('_'),
	        weekdays: weekdaysCaseReplace,
	        weekdaysShort: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY р.',
	            LLL: 'D MMMM YYYY р., HH:mm',
	            LLLL: 'dddd, D MMMM YYYY р., HH:mm'
	        },
	        calendar: {
	            sameDay: processHoursFunction('[Сьогодні '),
	            nextDay: processHoursFunction('[Завтра '),
	            lastDay: processHoursFunction('[Вчора '),
	            nextWeek: processHoursFunction('[У] dddd ['),
	            lastWeek: function lastWeek() {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return processHoursFunction('[Минулої] dddd [').call(this);
	                    case 1:
	                    case 2:
	                    case 4:
	                        return processHoursFunction('[Минулого] dddd [').call(this);
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'за %s',
	            past: '%s тому',
	            s: 'декілька секунд',
	            m: relativeTimeWithPlural,
	            mm: relativeTimeWithPlural,
	            h: 'годину',
	            hh: relativeTimeWithPlural,
	            d: 'день',
	            dd: relativeTimeWithPlural,
	            M: 'місяць',
	            MM: relativeTimeWithPlural,
	            y: 'рік',
	            yy: relativeTimeWithPlural
	        },
	        // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
	        meridiemParse: /ночі|ранку|дня|вечора/,
	        isPM: function isPM(input) {
	            return (/^(дня|вечора)$/.test(input)
	            );
	        },
	        meridiem: function meridiem(hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночі';
	            } else if (hour < 12) {
	                return 'ранку';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечора';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
	        ordinal: function ordinal(number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return uk;
	});

/***/ },
/* 353 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Urdu [ur]
	//! author : Sawood Alam : https://github.com/ibnesayeed
	//! author : Zack : https://github.com/ZackVision
	
	;(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var months = ['جنوری', 'فروری', 'مارچ', 'اپریل', 'مئی', 'جون', 'جولائی', 'اگست', 'ستمبر', 'اکتوبر', 'نومبر', 'دسمبر'];
	    var days = ['اتوار', 'پیر', 'منگل', 'بدھ', 'جمعرات', 'جمعہ', 'ہفتہ'];
	
	    var ur = moment.defineLocale('ur', {
	        months: months,
	        monthsShort: months,
	        weekdays: days,
	        weekdaysShort: days,
	        weekdaysMin: days,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd، D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /صبح|شام/,
	        isPM: function isPM(input) {
	            return 'شام' === input;
	        },
	        meridiem: function meridiem(hour, minute, isLower) {
	            if (hour < 12) {
	                return 'صبح';
	            }
	            return 'شام';
	        },
	        calendar: {
	            sameDay: '[آج بوقت] LT',
	            nextDay: '[کل بوقت] LT',
	            nextWeek: 'dddd [بوقت] LT',
	            lastDay: '[گذشتہ روز بوقت] LT',
	            lastWeek: '[گذشتہ] dddd [بوقت] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%s بعد',
	            past: '%s قبل',
	            s: 'چند سیکنڈ',
	            m: 'ایک منٹ',
	            mm: '%d منٹ',
	            h: 'ایک گھنٹہ',
	            hh: '%d گھنٹے',
	            d: 'ایک دن',
	            dd: '%d دن',
	            M: 'ایک ماہ',
	            MM: '%d ماہ',
	            y: 'ایک سال',
	            yy: '%d سال'
	        },
	        preparse: function preparse(string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function postformat(string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ur;
	});

/***/ },
/* 354 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Uzbek Latin [uz-latn]
	//! author : Rasulbek Mirzayev : github.com/Rasulbeeek
	
	;(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var uzLatn = moment.defineLocale('uz-latn', {
	        months: 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split('_'),
	        monthsShort: 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
	        weekdays: 'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split('_'),
	        weekdaysShort: 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
	        weekdaysMin: 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'D MMMM YYYY, dddd HH:mm'
	        },
	        calendar: {
	            sameDay: '[Bugun soat] LT [da]',
	            nextDay: '[Ertaga] LT [da]',
	            nextWeek: 'dddd [kuni soat] LT [da]',
	            lastDay: '[Kecha soat] LT [da]',
	            lastWeek: '[O\'tgan] dddd [kuni soat] LT [da]',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'Yaqin %s ichida',
	            past: 'Bir necha %s oldin',
	            s: 'soniya',
	            m: 'bir daqiqa',
	            mm: '%d daqiqa',
	            h: 'bir soat',
	            hh: '%d soat',
	            d: 'bir kun',
	            dd: '%d kun',
	            M: 'bir oy',
	            MM: '%d oy',
	            y: 'bir yil',
	            yy: '%d yil'
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return uzLatn;
	});

/***/ },
/* 355 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Uzbek [uz]
	//! author : Sardor Muminov : https://github.com/muminoff
	
	;(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var uz = moment.defineLocale('uz', {
	        months: 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
	        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays: 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
	        weekdaysShort: 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
	        weekdaysMin: 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'D MMMM YYYY, dddd HH:mm'
	        },
	        calendar: {
	            sameDay: '[Бугун соат] LT [да]',
	            nextDay: '[Эртага] LT [да]',
	            nextWeek: 'dddd [куни соат] LT [да]',
	            lastDay: '[Кеча соат] LT [да]',
	            lastWeek: '[Утган] dddd [куни соат] LT [да]',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'Якин %s ичида',
	            past: 'Бир неча %s олдин',
	            s: 'фурсат',
	            m: 'бир дакика',
	            mm: '%d дакика',
	            h: 'бир соат',
	            hh: '%d соат',
	            d: 'бир кун',
	            dd: '%d кун',
	            M: 'бир ой',
	            MM: '%d ой',
	            y: 'бир йил',
	            yy: '%d йил'
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return uz;
	});

/***/ },
/* 356 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Vietnamese [vi]
	//! author : Bang Nguyen : https://github.com/bangnk
	
	;(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var vi = moment.defineLocale('vi', {
	        months: 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split('_'),
	        monthsShort: 'Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split('_'),
	        weekdaysShort: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysMin: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysParseExact: true,
	        meridiemParse: /sa|ch/i,
	        isPM: function isPM(input) {
	            return (/^ch$/i.test(input)
	            );
	        },
	        meridiem: function meridiem(hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'sa' : 'SA';
	            } else {
	                return isLower ? 'ch' : 'CH';
	            }
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM [năm] YYYY',
	            LLL: 'D MMMM [năm] YYYY HH:mm',
	            LLLL: 'dddd, D MMMM [năm] YYYY HH:mm',
	            l: 'DD/M/YYYY',
	            ll: 'D MMM YYYY',
	            lll: 'D MMM YYYY HH:mm',
	            llll: 'ddd, D MMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[Hôm nay lúc] LT',
	            nextDay: '[Ngày mai lúc] LT',
	            nextWeek: 'dddd [tuần tới lúc] LT',
	            lastDay: '[Hôm qua lúc] LT',
	            lastWeek: 'dddd [tuần rồi lúc] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%s tới',
	            past: '%s trước',
	            s: 'vài giây',
	            m: 'một phút',
	            mm: '%d phút',
	            h: 'một giờ',
	            hh: '%d giờ',
	            d: 'một ngày',
	            dd: '%d ngày',
	            M: 'một tháng',
	            MM: '%d tháng',
	            y: 'một năm',
	            yy: '%d năm'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: function ordinal(number) {
	            return number;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return vi;
	});

/***/ },
/* 357 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Pseudo [x-pseudo]
	//! author : Andrew Hood : https://github.com/andrewhood125
	
	;(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var xPseudo = moment.defineLocale('x-pseudo', {
	        months: 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split('_'),
	        monthsShort: 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split('_'),
	        weekdaysShort: 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
	        weekdaysMin: 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[T~ódá~ý át] LT',
	            nextDay: '[T~ómó~rró~w át] LT',
	            nextWeek: 'dddd [át] LT',
	            lastDay: '[Ý~ést~érdá~ý át] LT',
	            lastWeek: '[L~ást] dddd [át] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'í~ñ %s',
	            past: '%s á~gó',
	            s: 'á ~féw ~sécó~ñds',
	            m: 'á ~míñ~úté',
	            mm: '%d m~íñú~tés',
	            h: 'á~ñ hó~úr',
	            hh: '%d h~óúrs',
	            d: 'á ~dáý',
	            dd: '%d d~áýs',
	            M: 'á ~móñ~th',
	            MM: '%d m~óñt~hs',
	            y: 'á ~ýéár',
	            yy: '%d ý~éárs'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal: function ordinal(number) {
	            var b = number % 10,
	                output = ~~(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return xPseudo;
	});

/***/ },
/* 358 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Yoruba Nigeria [yo]
	//! author : Atolagbe Abisoye : https://github.com/andela-batolagbe
	
	;(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var yo = moment.defineLocale('yo', {
	        months: 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split('_'),
	        monthsShort: 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
	        weekdays: 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
	        weekdaysShort: 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
	        weekdaysMin: 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar: {
	            sameDay: '[Ònì ni] LT',
	            nextDay: '[Ọ̀la ni] LT',
	            nextWeek: 'dddd [Ọsẹ̀ tón\'bọ] [ni] LT',
	            lastDay: '[Àna ni] LT',
	            lastWeek: 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'ní %s',
	            past: '%s kọjá',
	            s: 'ìsẹjú aayá die',
	            m: 'ìsẹjú kan',
	            mm: 'ìsẹjú %d',
	            h: 'wákati kan',
	            hh: 'wákati %d',
	            d: 'ọjọ́ kan',
	            dd: 'ọjọ́ %d',
	            M: 'osù kan',
	            MM: 'osù %d',
	            y: 'ọdún kan',
	            yy: 'ọdún %d'
	        },
	        dayOfMonthOrdinalParse: /ọjọ́\s\d{1,2}/,
	        ordinal: 'ọjọ́ %d',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return yo;
	});

/***/ },
/* 359 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Chinese (China) [zh-cn]
	//! author : suupic : https://github.com/suupic
	//! author : Zeno Zeng : https://github.com/zenozeng
	
	;(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var zhCn = moment.defineLocale('zh-cn', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '周日_周一_周二_周三_周四_周五_周六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY年MMMD日',
	            LL: 'YYYY年MMMD日',
	            LLL: 'YYYY年MMMD日Ah点mm分',
	            LLLL: 'YYYY年MMMD日ddddAh点mm分',
	            l: 'YYYY年MMMD日',
	            ll: 'YYYY年MMMD日',
	            lll: 'YYYY年MMMD日 HH:mm',
	            llll: 'YYYY年MMMD日dddd HH:mm'
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function meridiemHour(hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            } else {
	                // '中午'
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem: function meridiem(hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天]LT',
	            nextDay: '[明天]LT',
	            nextWeek: '[下]ddddLT',
	            lastDay: '[昨天]LT',
	            lastWeek: '[上]ddddLT',
	            sameElse: 'L'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
	        ordinal: function ordinal(number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '周';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s内',
	            past: '%s前',
	            s: '几秒',
	            m: '1 分钟',
	            mm: '%d 分钟',
	            h: '1 小时',
	            hh: '%d 小时',
	            d: '1 天',
	            dd: '%d 天',
	            M: '1 个月',
	            MM: '%d 个月',
	            y: '1 年',
	            yy: '%d 年'
	        },
	        week: {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return zhCn;
	});

/***/ },
/* 360 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Chinese (Hong Kong) [zh-hk]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	//! author : Konstantin : https://github.com/skfd
	
	;(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var zhHk = moment.defineLocale('zh-hk', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY年MMMD日',
	            LL: 'YYYY年MMMD日',
	            LLL: 'YYYY年MMMD日 HH:mm',
	            LLLL: 'YYYY年MMMD日dddd HH:mm',
	            l: 'YYYY年MMMD日',
	            ll: 'YYYY年MMMD日',
	            lll: 'YYYY年MMMD日 HH:mm',
	            llll: 'YYYY年MMMD日dddd HH:mm'
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function meridiemHour(hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem: function meridiem(hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天]LT',
	            nextDay: '[明天]LT',
	            nextWeek: '[下]ddddLT',
	            lastDay: '[昨天]LT',
	            lastWeek: '[上]ddddLT',
	            sameElse: 'L'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal: function ordinal(number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '週';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s內',
	            past: '%s前',
	            s: '幾秒',
	            m: '1 分鐘',
	            mm: '%d 分鐘',
	            h: '1 小時',
	            hh: '%d 小時',
	            d: '1 天',
	            dd: '%d 天',
	            M: '1 個月',
	            MM: '%d 個月',
	            y: '1 年',
	            yy: '%d 年'
	        }
	    });
	
	    return zhHk;
	});

/***/ },
/* 361 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//! moment.js locale configuration
	//! locale : Chinese (Taiwan) [zh-tw]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	
	;(function (global, factory) {
	    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(1)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
	})(undefined, function (moment) {
	    'use strict';
	
	    var zhTw = moment.defineLocale('zh-tw', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY年MMMD日',
	            LL: 'YYYY年MMMD日',
	            LLL: 'YYYY年MMMD日 HH:mm',
	            LLLL: 'YYYY年MMMD日dddd HH:mm',
	            l: 'YYYY年MMMD日',
	            ll: 'YYYY年MMMD日',
	            lll: 'YYYY年MMMD日 HH:mm',
	            llll: 'YYYY年MMMD日dddd HH:mm'
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function meridiemHour(hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem: function meridiem(hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天]LT',
	            nextDay: '[明天]LT',
	            nextWeek: '[下]ddddLT',
	            lastDay: '[昨天]LT',
	            lastWeek: '[上]ddddLT',
	            sameElse: 'L'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal: function ordinal(number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '週';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s內',
	            past: '%s前',
	            s: '幾秒',
	            m: '1 分鐘',
	            mm: '%d 分鐘',
	            h: '1 小時',
	            hh: '%d 小時',
	            d: '1 天',
	            dd: '%d 天',
	            M: '1 個月',
	            MM: '%d 個月',
	            y: '1 年',
	            yy: '%d 年'
	        }
	    });
	
	    return zhTw;
	});

/***/ },
/* 362 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var asap = __webpack_require__(516);
	
	function noop() {}
	
	// States:
	//
	// 0 - pending
	// 1 - fulfilled with _value
	// 2 - rejected with _value
	// 3 - adopted the state of another promise, _value
	//
	// once the state is no longer pending (0) it is immutable
	
	// All `_` prefixed properties will be reduced to `_{random number}`
	// at build time to obfuscate them and discourage their use.
	// We don't use symbols or Object.defineProperty to fully hide them
	// because the performance isn't good enough.
	
	
	// to avoid using try/catch inside critical functions, we
	// extract them to here.
	var LAST_ERROR = null;
	var IS_ERROR = {};
	function getThen(obj) {
	  try {
	    return obj.then;
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	function tryCallOne(fn, a) {
	  try {
	    return fn(a);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	function tryCallTwo(fn, a, b) {
	  try {
	    fn(a, b);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	module.exports = Promise;
	
	function Promise(fn) {
	  if (_typeof(this) !== 'object') {
	    throw new TypeError('Promises must be constructed via new');
	  }
	  if (typeof fn !== 'function') {
	    throw new TypeError('not a function');
	  }
	  this._45 = 0;
	  this._81 = 0;
	  this._65 = null;
	  this._54 = null;
	  if (fn === noop) return;
	  doResolve(fn, this);
	}
	Promise._10 = null;
	Promise._97 = null;
	Promise._61 = noop;
	
	Promise.prototype.then = function (onFulfilled, onRejected) {
	  if (this.constructor !== Promise) {
	    return safeThen(this, onFulfilled, onRejected);
	  }
	  var res = new Promise(noop);
	  handle(this, new Handler(onFulfilled, onRejected, res));
	  return res;
	};
	
	function safeThen(self, onFulfilled, onRejected) {
	  return new self.constructor(function (resolve, reject) {
	    var res = new Promise(noop);
	    res.then(resolve, reject);
	    handle(self, new Handler(onFulfilled, onRejected, res));
	  });
	};
	function handle(self, deferred) {
	  while (self._81 === 3) {
	    self = self._65;
	  }
	  if (Promise._10) {
	    Promise._10(self);
	  }
	  if (self._81 === 0) {
	    if (self._45 === 0) {
	      self._45 = 1;
	      self._54 = deferred;
	      return;
	    }
	    if (self._45 === 1) {
	      self._45 = 2;
	      self._54 = [self._54, deferred];
	      return;
	    }
	    self._54.push(deferred);
	    return;
	  }
	  handleResolved(self, deferred);
	}
	
	function handleResolved(self, deferred) {
	  asap(function () {
	    var cb = self._81 === 1 ? deferred.onFulfilled : deferred.onRejected;
	    if (cb === null) {
	      if (self._81 === 1) {
	        resolve(deferred.promise, self._65);
	      } else {
	        reject(deferred.promise, self._65);
	      }
	      return;
	    }
	    var ret = tryCallOne(cb, self._65);
	    if (ret === IS_ERROR) {
	      reject(deferred.promise, LAST_ERROR);
	    } else {
	      resolve(deferred.promise, ret);
	    }
	  });
	}
	function resolve(self, newValue) {
	  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
	  if (newValue === self) {
	    return reject(self, new TypeError('A promise cannot be resolved with itself.'));
	  }
	  if (newValue && ((typeof newValue === 'undefined' ? 'undefined' : _typeof(newValue)) === 'object' || typeof newValue === 'function')) {
	    var then = getThen(newValue);
	    if (then === IS_ERROR) {
	      return reject(self, LAST_ERROR);
	    }
	    if (then === self.then && newValue instanceof Promise) {
	      self._81 = 3;
	      self._65 = newValue;
	      finale(self);
	      return;
	    } else if (typeof then === 'function') {
	      doResolve(then.bind(newValue), self);
	      return;
	    }
	  }
	  self._81 = 1;
	  self._65 = newValue;
	  finale(self);
	}
	
	function reject(self, newValue) {
	  self._81 = 2;
	  self._65 = newValue;
	  if (Promise._97) {
	    Promise._97(self, newValue);
	  }
	  finale(self);
	}
	function finale(self) {
	  if (self._45 === 1) {
	    handle(self, self._54);
	    self._54 = null;
	  }
	  if (self._45 === 2) {
	    for (var i = 0; i < self._54.length; i++) {
	      handle(self, self._54[i]);
	    }
	    self._54 = null;
	  }
	}
	
	function Handler(onFulfilled, onRejected, promise) {
	  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
	  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
	  this.promise = promise;
	}
	
	/**
	 * Take a potentially misbehaving resolver function and make sure
	 * onFulfilled and onRejected are only called once.
	 *
	 * Makes no guarantees about asynchrony.
	 */
	function doResolve(fn, promise) {
	  var done = false;
	  var res = tryCallTwo(fn, function (value) {
	    if (done) return;
	    done = true;
	    resolve(promise, value);
	  }, function (reason) {
	    if (done) return;
	    done = true;
	    reject(promise, reason);
	  });
	  if (!done && res === IS_ERROR) {
	    done = true;
	    reject(promise, LAST_ERROR);
	  }
	}

/***/ },
/* 363 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	// React 15.5 references this module, and assumes PropTypes are still callable in production.
	// Therefore we re-export development-only version with all the PropTypes checks here.
	// However if one is migrating to the `prop-types` npm library, they will go through the
	// `index.js` entry point, and it will branch depending on the environment.
	
	var factory = __webpack_require__(821);
	module.exports = function (isValidElement) {
	  // It is still allowed in 15.5.
	  var throwOnDirectAccess = false;
	  return factory(isValidElement, throwOnDirectAccess);
	};

/***/ },
/* 364 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;

/***/ },
/* 365 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * CSS properties which accept numbers but are not in units of "px".
	 */
	
	var isUnitlessNumber = {
	  animationIterationCount: true,
	  borderImageOutset: true,
	  borderImageSlice: true,
	  borderImageWidth: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  flexOrder: true,
	  gridRow: true,
	  gridRowEnd: true,
	  gridRowSpan: true,
	  gridRowStart: true,
	  gridColumn: true,
	  gridColumnEnd: true,
	  gridColumnSpan: true,
	  gridColumnStart: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	
	  // SVG-related properties
	  fillOpacity: true,
	  floodOpacity: true,
	  stopOpacity: true,
	  strokeDasharray: true,
	  strokeDashoffset: true,
	  strokeMiterlimit: true,
	  strokeOpacity: true,
	  strokeWidth: true
	};
	
	/**
	 * @param {string} prefix vendor-specific prefix, eg: Webkit
	 * @param {string} key style name, eg: transitionDuration
	 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
	 * WebkitTransitionDuration
	 */
	function prefixKey(prefix, key) {
	  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	}
	
	/**
	 * Support style names that may come passed in prefixed by adding permutations
	 * of vendor prefixes.
	 */
	var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
	
	// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
	// infinite loop, because it iterates over the newly added props too.
	Object.keys(isUnitlessNumber).forEach(function (prop) {
	  prefixes.forEach(function (prefix) {
	    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
	  });
	});
	
	/**
	 * Most style properties can be unset by doing .style[prop] = '' but IE8
	 * doesn't like doing that with shorthand properties so for the properties that
	 * IE8 breaks on, which are listed here, we instead unset each of the
	 * individual properties. See http://bugs.jquery.com/ticket/12385.
	 * The 4-value 'clock' properties like margin, padding, border-width seem to
	 * behave without any problems. Curiously, list-style works too without any
	 * special prodding.
	 */
	var shorthandPropertyExpansions = {
	  background: {
	    backgroundAttachment: true,
	    backgroundColor: true,
	    backgroundImage: true,
	    backgroundPositionX: true,
	    backgroundPositionY: true,
	    backgroundRepeat: true
	  },
	  backgroundPosition: {
	    backgroundPositionX: true,
	    backgroundPositionY: true
	  },
	  border: {
	    borderWidth: true,
	    borderStyle: true,
	    borderColor: true
	  },
	  borderBottom: {
	    borderBottomWidth: true,
	    borderBottomStyle: true,
	    borderBottomColor: true
	  },
	  borderLeft: {
	    borderLeftWidth: true,
	    borderLeftStyle: true,
	    borderLeftColor: true
	  },
	  borderRight: {
	    borderRightWidth: true,
	    borderRightStyle: true,
	    borderRightColor: true
	  },
	  borderTop: {
	    borderTopWidth: true,
	    borderTopStyle: true,
	    borderTopColor: true
	  },
	  font: {
	    fontStyle: true,
	    fontVariant: true,
	    fontWeight: true,
	    fontSize: true,
	    lineHeight: true,
	    fontFamily: true
	  },
	  outline: {
	    outlineWidth: true,
	    outlineStyle: true,
	    outlineColor: true
	  }
	};
	
	var CSSProperty = {
	  isUnitlessNumber: isUnitlessNumber,
	  shorthandPropertyExpansions: shorthandPropertyExpansions
	};
	
	module.exports = CSSProperty;

/***/ },
/* 366 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(12);
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	var PooledClass = __webpack_require__(75);
	
	var invariant = __webpack_require__(5);
	
	/**
	 * A specialized pseudo-event module to help keep track of components waiting to
	 * be notified when their DOM representations are available for use.
	 *
	 * This implements `PooledClass`, so you should never need to instantiate this.
	 * Instead, use `CallbackQueue.getPooled()`.
	 *
	 * @class ReactMountReady
	 * @implements PooledClass
	 * @internal
	 */
	
	var CallbackQueue = function () {
	  function CallbackQueue(arg) {
	    _classCallCheck(this, CallbackQueue);
	
	    this._callbacks = null;
	    this._contexts = null;
	    this._arg = arg;
	  }
	
	  /**
	   * Enqueues a callback to be invoked when `notifyAll` is invoked.
	   *
	   * @param {function} callback Invoked when `notifyAll` is invoked.
	   * @param {?object} context Context to call `callback` with.
	   * @internal
	   */
	
	  CallbackQueue.prototype.enqueue = function enqueue(callback, context) {
	    this._callbacks = this._callbacks || [];
	    this._callbacks.push(callback);
	    this._contexts = this._contexts || [];
	    this._contexts.push(context);
	  };
	
	  /**
	   * Invokes all enqueued callbacks and clears the queue. This is invoked after
	   * the DOM representation of a component has been created or updated.
	   *
	   * @internal
	   */
	
	  CallbackQueue.prototype.notifyAll = function notifyAll() {
	    var callbacks = this._callbacks;
	    var contexts = this._contexts;
	    var arg = this._arg;
	    if (callbacks && contexts) {
	      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
	      this._callbacks = null;
	      this._contexts = null;
	      for (var i = 0; i < callbacks.length; i++) {
	        callbacks[i].call(contexts[i], arg);
	      }
	      callbacks.length = 0;
	      contexts.length = 0;
	    }
	  };
	
	  CallbackQueue.prototype.checkpoint = function checkpoint() {
	    return this._callbacks ? this._callbacks.length : 0;
	  };
	
	  CallbackQueue.prototype.rollback = function rollback(len) {
	    if (this._callbacks && this._contexts) {
	      this._callbacks.length = len;
	      this._contexts.length = len;
	    }
	  };
	
	  /**
	   * Resets the internal queue.
	   *
	   * @internal
	   */
	
	  CallbackQueue.prototype.reset = function reset() {
	    this._callbacks = null;
	    this._contexts = null;
	  };
	
	  /**
	   * `PooledClass` looks for this.
	   */
	
	  CallbackQueue.prototype.destructor = function destructor() {
	    this.reset();
	  };
	
	  return CallbackQueue;
	}();
	
	module.exports = PooledClass.addPoolingTo(CallbackQueue);

/***/ },
/* 367 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(84);
	var ReactDOMComponentTree = __webpack_require__(23);
	var ReactInstrumentation = __webpack_require__(46);
	
	var quoteAttributeValueForBrowser = __webpack_require__(884);
	var warning = __webpack_require__(9);
	
	var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
	var illegalAttributeNameCache = {};
	var validatedAttributeNameCache = {};
	
	function isAttributeNameSafe(attributeName) {
	  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
	    return true;
	  }
	  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
	    return false;
	  }
	  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
	    validatedAttributeNameCache[attributeName] = true;
	    return true;
	  }
	  illegalAttributeNameCache[attributeName] = true;
	   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
	  return false;
	}
	
	function shouldIgnoreValue(propertyInfo, value) {
	  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
	}
	
	/**
	 * Operations for dealing with DOM properties.
	 */
	var DOMPropertyOperations = {
	  /**
	   * Creates markup for the ID property.
	   *
	   * @param {string} id Unescaped ID.
	   * @return {string} Markup string.
	   */
	  createMarkupForID: function createMarkupForID(id) {
	    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
	  },
	
	  setAttributeForID: function setAttributeForID(node, id) {
	    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
	  },
	
	  createMarkupForRoot: function createMarkupForRoot() {
	    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
	  },
	
	  setAttributeForRoot: function setAttributeForRoot(node) {
	    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
	  },
	
	  /**
	   * Creates markup for a property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {?string} Markup string, or null if the property was invalid.
	   */
	  createMarkupForProperty: function createMarkupForProperty(name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      if (shouldIgnoreValue(propertyInfo, value)) {
	        return '';
	      }
	      var attributeName = propertyInfo.attributeName;
	      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	        return attributeName + '=""';
	      }
	      return attributeName + '=' + quoteAttributeValueForBrowser(value);
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      if (value == null) {
	        return '';
	      }
	      return name + '=' + quoteAttributeValueForBrowser(value);
	    }
	    return null;
	  },
	
	  /**
	   * Creates markup for a custom property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {string} Markup string, or empty string if the property was invalid.
	   */
	  createMarkupForCustomAttribute: function createMarkupForCustomAttribute(name, value) {
	    if (!isAttributeNameSafe(name) || value == null) {
	      return '';
	    }
	    return name + '=' + quoteAttributeValueForBrowser(value);
	  },
	
	  /**
	   * Sets the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   * @param {*} value
	   */
	  setValueForProperty: function setValueForProperty(node, name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, value);
	      } else if (shouldIgnoreValue(propertyInfo, value)) {
	        this.deleteValueForProperty(node, name);
	        return;
	      } else if (propertyInfo.mustUseProperty) {
	        // Contrary to `setAttribute`, object properties are properly
	        // `toString`ed by IE8/9.
	        node[propertyInfo.propertyName] = value;
	      } else {
	        var attributeName = propertyInfo.attributeName;
	        var namespace = propertyInfo.attributeNamespace;
	        // `setAttribute` with objects becomes only `[object]` in IE8/9,
	        // ('' + value) makes it output the correct toString()-value.
	        if (namespace) {
	          node.setAttributeNS(namespace, attributeName, '' + value);
	        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	          node.setAttribute(attributeName, '');
	        } else {
	          node.setAttribute(attributeName, '' + value);
	        }
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      DOMPropertyOperations.setValueForAttribute(node, name, value);
	      return;
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  setValueForAttribute: function setValueForAttribute(node, name, value) {
	    if (!isAttributeNameSafe(name)) {
	      return;
	    }
	    if (value == null) {
	      node.removeAttribute(name);
	    } else {
	      node.setAttribute(name, '' + value);
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  /**
	   * Deletes an attributes from a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForAttribute: function deleteValueForAttribute(node, name) {
	    node.removeAttribute(name);
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  },
	
	  /**
	   * Deletes the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForProperty: function deleteValueForProperty(node, name) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, undefined);
	      } else if (propertyInfo.mustUseProperty) {
	        var propName = propertyInfo.propertyName;
	        if (propertyInfo.hasBooleanValue) {
	          node[propName] = false;
	        } else {
	          node[propName] = '';
	        }
	      } else {
	        node.removeAttribute(propertyInfo.attributeName);
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      node.removeAttribute(name);
	    }
	
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  }
	};
	
	module.exports = DOMPropertyOperations;

/***/ },
/* 368 */
/***/ function(module, exports) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentFlags = {
	  hasCachedChildNodes: 1 << 0
	};
	
	module.exports = ReactDOMComponentFlags;

/***/ },
/* 369 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(11);
	
	var LinkedValueUtils = __webpack_require__(170);
	var ReactDOMComponentTree = __webpack_require__(23);
	var ReactUpdates = __webpack_require__(53);
	
	var warning = __webpack_require__(9);
	
	var didWarnValueLink = false;
	var didWarnValueDefaultValue = false;
	
	function updateOptionsIfPendingUpdateAndMounted() {
	  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
	    this._wrapperState.pendingUpdate = false;
	
	    var props = this._currentElement.props;
	    var value = LinkedValueUtils.getValue(props);
	
	    if (value != null) {
	      updateOptions(this, Boolean(props.multiple), value);
	    }
	  }
	}
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	var valuePropNames = ['value', 'defaultValue'];
	
	/**
	 * Validation function for `value` and `defaultValue`.
	 * @private
	 */
	function checkSelectPropTypes(inst, props) {
	  var owner = inst._currentElement._owner;
	  LinkedValueUtils.checkPropTypes('select', props, owner);
	
	  if (props.valueLink !== undefined && !didWarnValueLink) {
	     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
	    didWarnValueLink = true;
	  }
	
	  for (var i = 0; i < valuePropNames.length; i++) {
	    var propName = valuePropNames[i];
	    if (props[propName] == null) {
	      continue;
	    }
	    var isArray = Array.isArray(props[propName]);
	    if (props.multiple && !isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    } else if (!props.multiple && isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    }
	  }
	}
	
	/**
	 * @param {ReactDOMComponent} inst
	 * @param {boolean} multiple
	 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
	 * @private
	 */
	function updateOptions(inst, multiple, propValue) {
	  var selectedValue, i;
	  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;
	
	  if (multiple) {
	    selectedValue = {};
	    for (i = 0; i < propValue.length; i++) {
	      selectedValue['' + propValue[i]] = true;
	    }
	    for (i = 0; i < options.length; i++) {
	      var selected = selectedValue.hasOwnProperty(options[i].value);
	      if (options[i].selected !== selected) {
	        options[i].selected = selected;
	      }
	    }
	  } else {
	    // Do not set `select.value` as exact behavior isn't consistent across all
	    // browsers for all cases.
	    selectedValue = '' + propValue;
	    for (i = 0; i < options.length; i++) {
	      if (options[i].value === selectedValue) {
	        options[i].selected = true;
	        return;
	      }
	    }
	    if (options.length) {
	      options[0].selected = true;
	    }
	  }
	}
	
	/**
	 * Implements a <select> host component that allows optionally setting the
	 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
	 * stringable. If `multiple` is true, the prop must be an array of stringables.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that change the
	 * selected option will trigger updates to the rendered options.
	 *
	 * If it is supplied (and not null/undefined), the rendered options will not
	 * update in response to user actions. Instead, the `value` prop must change in
	 * order for the rendered options to update.
	 *
	 * If `defaultValue` is provided, any options with the supplied values will be
	 * selected.
	 */
	var ReactDOMSelect = {
	  getHostProps: function getHostProps(inst, props) {
	    return _assign({}, props, {
	      onChange: inst._wrapperState.onChange,
	      value: undefined
	    });
	  },
	
	  mountWrapper: function mountWrapper(inst, props) {
	    if (false) {
	      checkSelectPropTypes(inst, props);
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    inst._wrapperState = {
	      pendingUpdate: false,
	      initialValue: value != null ? value : props.defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      wasMultiple: Boolean(props.multiple)
	    };
	
	    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	      didWarnValueDefaultValue = true;
	    }
	  },
	
	  getSelectValueContext: function getSelectValueContext(inst) {
	    // ReactDOMOption looks at this initial value so the initial generated
	    // markup has correct `selected` attributes
	    return inst._wrapperState.initialValue;
	  },
	
	  postUpdateWrapper: function postUpdateWrapper(inst) {
	    var props = inst._currentElement.props;
	
	    // After the initial mount, we control selected-ness manually so don't pass
	    // this value down
	    inst._wrapperState.initialValue = undefined;
	
	    var wasMultiple = inst._wrapperState.wasMultiple;
	    inst._wrapperState.wasMultiple = Boolean(props.multiple);
	
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      inst._wrapperState.pendingUpdate = false;
	      updateOptions(inst, Boolean(props.multiple), value);
	    } else if (wasMultiple !== Boolean(props.multiple)) {
	      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
	      if (props.defaultValue != null) {
	        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
	      } else {
	        // Revert the select back to its default unselected state.
	        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
	      }
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  if (this._rootNodeID) {
	    this._wrapperState.pendingUpdate = true;
	  }
	  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMSelect;

/***/ },
/* 370 */
/***/ function(module, exports) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var emptyComponentFactory;
	
	var ReactEmptyComponentInjection = {
	  injectEmptyComponentFactory: function injectEmptyComponentFactory(factory) {
	    emptyComponentFactory = factory;
	  }
	};
	
	var ReactEmptyComponent = {
	  create: function create(instantiate) {
	    return emptyComponentFactory(instantiate);
	  }
	};
	
	ReactEmptyComponent.injection = ReactEmptyComponentInjection;
	
	module.exports = ReactEmptyComponent;

/***/ },
/* 371 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactFeatureFlags = {
	  // When true, call console.time() before and .timeEnd() after each top-level
	  // render (both initial renders and updates). Useful when looking at prod-mode
	  // timeline profiles in Chrome, for example.
	  logTopLevelRenders: false
	};
	
	module.exports = ReactFeatureFlags;

/***/ },
/* 372 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(12);
	
	var invariant = __webpack_require__(5);
	
	var genericComponentClass = null;
	var textComponentClass = null;
	
	var ReactHostComponentInjection = {
	  // This accepts a class that receives the tag string. This is a catch all
	  // that can render any kind of tag.
	  injectGenericComponentClass: function injectGenericComponentClass(componentClass) {
	    genericComponentClass = componentClass;
	  },
	  // This accepts a text component class that takes the text string to be
	  // rendered as props.
	  injectTextComponentClass: function injectTextComponentClass(componentClass) {
	    textComponentClass = componentClass;
	  }
	};
	
	/**
	 * Get a host internal component class for a specific tag.
	 *
	 * @param {ReactElement} element The element to create.
	 * @return {function} The internal class constructor function.
	 */
	function createInternalComponent(element) {
	  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
	  return new genericComponentClass(element);
	}
	
	/**
	 * @param {ReactText} text
	 * @return {ReactComponent}
	 */
	function createInstanceForText(text) {
	  return new textComponentClass(text);
	}
	
	/**
	 * @param {ReactComponent} component
	 * @return {boolean}
	 */
	function isTextComponent(component) {
	  return component instanceof textComponentClass;
	}
	
	var ReactHostComponent = {
	  createInternalComponent: createInternalComponent,
	  createInstanceForText: createInstanceForText,
	  isTextComponent: isTextComponent,
	  injection: ReactHostComponentInjection
	};
	
	module.exports = ReactHostComponent;

/***/ },
/* 373 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMSelection = __webpack_require__(844);
	
	var containsNode = __webpack_require__(773);
	var focusNode = __webpack_require__(240);
	var getActiveElement = __webpack_require__(241);
	
	function isInDocument(node) {
	  return containsNode(document.documentElement, node);
	}
	
	/**
	 * @ReactInputSelection: React input selection module. Based on Selection.js,
	 * but modified to be suitable for react and has a couple of bug fixes (doesn't
	 * assume buttons have range selections allowed).
	 * Input selection module for React.
	 */
	var ReactInputSelection = {
	  hasSelectionCapabilities: function hasSelectionCapabilities(elem) {
	    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
	  },
	
	  getSelectionInformation: function getSelectionInformation() {
	    var focusedElem = getActiveElement();
	    return {
	      focusedElem: focusedElem,
	      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
	    };
	  },
	
	  /**
	   * @restoreSelection: If any selection information was potentially lost,
	   * restore it. This is useful when performing operations that could remove dom
	   * nodes and place them back in, resulting in focus being lost.
	   */
	  restoreSelection: function restoreSelection(priorSelectionInformation) {
	    var curFocusedElem = getActiveElement();
	    var priorFocusedElem = priorSelectionInformation.focusedElem;
	    var priorSelectionRange = priorSelectionInformation.selectionRange;
	    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
	      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
	        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
	      }
	      focusNode(priorFocusedElem);
	    }
	  },
	
	  /**
	   * @getSelection: Gets the selection bounds of a focused textarea, input or
	   * contentEditable node.
	   * -@input: Look up selection bounds of this input
	   * -@return {start: selectionStart, end: selectionEnd}
	   */
	  getSelection: function getSelection(input) {
	    var selection;
	
	    if ('selectionStart' in input) {
	      // Modern browser with input or textarea.
	      selection = {
	        start: input.selectionStart,
	        end: input.selectionEnd
	      };
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      // IE8 input.
	      var range = document.selection.createRange();
	      // There can only be one selection per document in IE, so it must
	      // be in our element.
	      if (range.parentElement() === input) {
	        selection = {
	          start: -range.moveStart('character', -input.value.length),
	          end: -range.moveEnd('character', -input.value.length)
	        };
	      }
	    } else {
	      // Content editable or old IE textarea.
	      selection = ReactDOMSelection.getOffsets(input);
	    }
	
	    return selection || { start: 0, end: 0 };
	  },
	
	  /**
	   * @setSelection: Sets the selection bounds of a textarea or input and focuses
	   * the input.
	   * -@input     Set selection bounds of this input or textarea
	   * -@offsets   Object of same form that is returned from get*
	   */
	  setSelection: function setSelection(input, offsets) {
	    var start = offsets.start;
	    var end = offsets.end;
	    if (end === undefined) {
	      end = start;
	    }
	
	    if ('selectionStart' in input) {
	      input.selectionStart = start;
	      input.selectionEnd = Math.min(end, input.value.length);
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      var range = input.createTextRange();
	      range.collapse(true);
	      range.moveStart('character', start);
	      range.moveEnd('character', end - start);
	      range.select();
	    } else {
	      ReactDOMSelection.setOffsets(input, offsets);
	    }
	  }
	};
	
	module.exports = ReactInputSelection;

/***/ },
/* 374 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(12);
	
	var DOMLazyTree = __webpack_require__(83);
	var DOMProperty = __webpack_require__(84);
	var React = __webpack_require__(86);
	var ReactBrowserEventEmitter = __webpack_require__(122);
	var ReactCurrentOwner = __webpack_require__(57);
	var ReactDOMComponentTree = __webpack_require__(23);
	var ReactDOMContainerInfo = __webpack_require__(838);
	var ReactDOMFeatureFlags = __webpack_require__(840);
	var ReactFeatureFlags = __webpack_require__(371);
	var ReactInstanceMap = __webpack_require__(97);
	var ReactInstrumentation = __webpack_require__(46);
	var ReactMarkupChecksum = __webpack_require__(854);
	var ReactReconciler = __webpack_require__(85);
	var ReactUpdateQueue = __webpack_require__(173);
	var ReactUpdates = __webpack_require__(53);
	
	var emptyObject = __webpack_require__(120);
	var instantiateReactComponent = __webpack_require__(382);
	var invariant = __webpack_require__(5);
	var setInnerHTML = __webpack_require__(126);
	var shouldUpdateReactComponent = __webpack_require__(179);
	var warning = __webpack_require__(9);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;
	
	var ELEMENT_NODE_TYPE = 1;
	var DOC_NODE_TYPE = 9;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	var instancesByReactRootID = {};
	
	/**
	 * Finds the index of the first character
	 * that's not common between the two given strings.
	 *
	 * @return {number} the index of the character where the strings diverge
	 */
	function firstDifferenceIndex(string1, string2) {
	  var minLen = Math.min(string1.length, string2.length);
	  for (var i = 0; i < minLen; i++) {
	    if (string1.charAt(i) !== string2.charAt(i)) {
	      return i;
	    }
	  }
	  return string1.length === string2.length ? -1 : minLen;
	}
	
	/**
	 * @param {DOMElement|DOMDocument} container DOM element that may contain
	 * a React component
	 * @return {?*} DOM element that may have the reactRoot ID, or null.
	 */
	function getReactRootElementInContainer(container) {
	  if (!container) {
	    return null;
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    return container.documentElement;
	  } else {
	    return container.firstChild;
	  }
	}
	
	function internalGetID(node) {
	  // If node is something like a window, document, or text node, none of
	  // which support attributes or a .getAttribute method, gracefully return
	  // the empty string, as if the attribute were missing.
	  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
	}
	
	/**
	 * Mounts this component and inserts it into the DOM.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {ReactReconcileTransaction} transaction
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
	  var markerName;
	  if (ReactFeatureFlags.logTopLevelRenders) {
	    var wrappedElement = wrapperInstance._currentElement.props.child;
	    var type = wrappedElement.type;
	    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
	    console.time(markerName);
	  }
	
	  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
	  );
	
	  if (markerName) {
	    console.timeEnd(markerName);
	  }
	
	  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
	  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
	}
	
	/**
	 * Batched mount.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
	  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */
	  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
	  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
	  ReactUpdates.ReactReconcileTransaction.release(transaction);
	}
	
	/**
	 * Unmounts a component and removes it from the DOM.
	 *
	 * @param {ReactComponent} instance React component instance.
	 * @param {DOMElement} container DOM element to unmount from.
	 * @final
	 * @internal
	 * @see {ReactMount.unmountComponentAtNode}
	 */
	function unmountComponentFromNode(instance, container, safely) {
	  if (false) {
	    ReactInstrumentation.debugTool.onBeginFlush();
	  }
	  ReactReconciler.unmountComponent(instance, safely);
	  if (false) {
	    ReactInstrumentation.debugTool.onEndFlush();
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    container = container.documentElement;
	  }
	
	  // http://jsperf.com/emptying-a-node
	  while (container.lastChild) {
	    container.removeChild(container.lastChild);
	  }
	}
	
	/**
	 * True if the supplied DOM node has a direct React-rendered child that is
	 * not a React root element. Useful for warning in `render`,
	 * `unmountComponentAtNode`, etc.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM element contains a direct child that was
	 * rendered by React but is not a root element.
	 * @internal
	 */
	function hasNonRootReactChild(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  if (rootEl) {
	    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
	    return !!(inst && inst._hostParent);
	  }
	}
	
	/**
	 * True if the supplied DOM node is a React DOM element and
	 * it has been rendered by another copy of React.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM has been rendered by another copy of React
	 * @internal
	 */
	function nodeIsRenderedByOtherInstance(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
	}
	
	/**
	 * True if the supplied DOM node is a valid node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid DOM node.
	 * @internal
	 */
	function isValidContainer(node) {
	  return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
	}
	
	/**
	 * True if the supplied DOM node is a valid React node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid React DOM node.
	 * @internal
	 */
	function isReactNode(node) {
	  return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
	}
	
	function getHostRootInstanceInContainer(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
	  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
	}
	
	function getTopLevelWrapperInContainer(container) {
	  var root = getHostRootInstanceInContainer(container);
	  return root ? root._hostContainerInfo._topLevelWrapper : null;
	}
	
	/**
	 * Temporary (?) hack so that we can store all top-level pending updates on
	 * composites instead of having to worry about different types of components
	 * here.
	 */
	var topLevelRootCounter = 1;
	var TopLevelWrapper = function TopLevelWrapper() {
	  this.rootID = topLevelRootCounter++;
	};
	TopLevelWrapper.prototype.isReactComponent = {};
	if (false) {
	  TopLevelWrapper.displayName = 'TopLevelWrapper';
	}
	TopLevelWrapper.prototype.render = function () {
	  return this.props.child;
	};
	TopLevelWrapper.isReactTopLevelWrapper = true;
	
	/**
	 * Mounting is the process of initializing a React component by creating its
	 * representative DOM elements and inserting them into a supplied `container`.
	 * Any prior content inside `container` is destroyed in the process.
	 *
	 *   ReactMount.render(
	 *     component,
	 *     document.getElementById('container')
	 *   );
	 *
	 *   <div id="container">                   <-- Supplied `container`.
	 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
	 *       // ...                                 component.
	 *     </div>
	 *   </div>
	 *
	 * Inside of `container`, the first element rendered is the "reactRoot".
	 */
	var ReactMount = {
	  TopLevelWrapper: TopLevelWrapper,
	
	  /**
	   * Used by devtools. The keys are not important.
	   */
	  _instancesByReactRootID: instancesByReactRootID,
	
	  /**
	   * This is a hook provided to support rendering React components while
	   * ensuring that the apparent scroll position of its `container` does not
	   * change.
	   *
	   * @param {DOMElement} container The `container` being rendered into.
	   * @param {function} renderCallback This must be called once to do the render.
	   */
	  scrollMonitor: function scrollMonitor(container, renderCallback) {
	    renderCallback();
	  },
	
	  /**
	   * Take a component that's already mounted into the DOM and replace its props
	   * @param {ReactComponent} prevComponent component instance already in the DOM
	   * @param {ReactElement} nextElement component instance to render
	   * @param {DOMElement} container container to render into
	   * @param {?function} callback function triggered on completion
	   */
	  _updateRootComponent: function _updateRootComponent(prevComponent, nextElement, nextContext, container, callback) {
	    ReactMount.scrollMonitor(container, function () {
	      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
	      if (callback) {
	        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
	      }
	    });
	
	    return prevComponent;
	  },
	
	  /**
	   * Render a new component into the DOM. Hooked by hooks!
	   *
	   * @param {ReactElement} nextElement element to render
	   * @param {DOMElement} container container to render into
	   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
	   * @return {ReactComponent} nextComponent
	   */
	  _renderNewRootComponent: function _renderNewRootComponent(nextElement, container, shouldReuseMarkup, context) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case.
	     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;
	
	    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
	    var componentInstance = instantiateReactComponent(nextElement, false);
	
	    // The initial render is synchronous but any updates that happen during
	    // rendering, in componentWillMount or componentDidMount, will be batched
	    // according to the current batching strategy.
	
	    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);
	
	    var wrapperID = componentInstance._instance.rootID;
	    instancesByReactRootID[wrapperID] = componentInstance;
	
	    return componentInstance;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  renderSubtreeIntoContainer: function renderSubtreeIntoContainer(parentComponent, nextElement, container, callback) {
	    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
	    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
	  },
	
	  _renderSubtreeIntoContainer: function _renderSubtreeIntoContainer(parentComponent, nextElement, container, callback) {
	    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
	    !React.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : // Check if it quacks like an element
	    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;
	
	     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;
	
	    var nextWrappedElement = React.createElement(TopLevelWrapper, {
	      child: nextElement
	    });
	
	    var nextContext;
	    if (parentComponent) {
	      var parentInst = ReactInstanceMap.get(parentComponent);
	      nextContext = parentInst._processChildContext(parentInst._context);
	    } else {
	      nextContext = emptyObject;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	
	    if (prevComponent) {
	      var prevWrappedElement = prevComponent._currentElement;
	      var prevElement = prevWrappedElement.props.child;
	      if (shouldUpdateReactComponent(prevElement, nextElement)) {
	        var publicInst = prevComponent._renderedComponent.getPublicInstance();
	        var updatedCallback = callback && function () {
	          callback.call(publicInst);
	        };
	        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
	        return publicInst;
	      } else {
	        ReactMount.unmountComponentAtNode(container);
	      }
	    }
	
	    var reactRootElement = getReactRootElementInContainer(container);
	    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
	    var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;
	
	      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
	        var rootElementSibling = reactRootElement;
	        while (rootElementSibling) {
	          if (internalGetID(rootElementSibling)) {
	            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
	            break;
	          }
	          rootElementSibling = rootElementSibling.nextSibling;
	        }
	      }
	    }
	
	    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
	    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
	    if (callback) {
	      callback.call(component);
	    }
	    return component;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  render: function render(nextElement, container, callback) {
	    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
	  },
	
	  /**
	   * Unmounts and destroys the React component rendered in the `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
	   *
	   * @param {DOMElement} container DOM element containing a React component.
	   * @return {boolean} True if a component was found in and unmounted from
	   *                   `container`
	   */
	  unmountComponentAtNode: function unmountComponentAtNode(container) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case. (Strictly speaking, unmounting won't cause a
	    // render but we still don't expect to be in a render call here.)
	     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!nodeIsRenderedByOtherInstance(container), "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by another copy of React.') : void 0;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	    if (!prevComponent) {
	      // Check if the node being unmounted was rendered by React, but isn't a
	      // root node.
	      var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	      // Check if the container itself is a React root node.
	      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
	      }
	
	      return false;
	    }
	    delete instancesByReactRootID[prevComponent._instance.rootID];
	    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
	    return true;
	  },
	
	  _mountImageIntoNode: function _mountImageIntoNode(markup, container, instance, shouldReuseMarkup, transaction) {
	    !isValidContainer(container) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;
	
	    if (shouldReuseMarkup) {
	      var rootElement = getReactRootElementInContainer(container);
	      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
	        ReactDOMComponentTree.precacheNode(instance, rootElement);
	        return;
	      } else {
	        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	
	        var rootMarkup = rootElement.outerHTML;
	        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);
	
	        var normalizedMarkup = markup;
	        if (false) {
	          // because rootMarkup is retrieved from the DOM, various normalizations
	          // will have occurred which will not be present in `markup`. Here,
	          // insert markup into a <div> or <iframe> depending on the container
	          // type to perform the same normalizations before comparing.
	          var normalizer;
	          if (container.nodeType === ELEMENT_NODE_TYPE) {
	            normalizer = document.createElement('div');
	            normalizer.innerHTML = markup;
	            normalizedMarkup = normalizer.innerHTML;
	          } else {
	            normalizer = document.createElement('iframe');
	            document.body.appendChild(normalizer);
	            normalizer.contentDocument.write(markup);
	            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
	            document.body.removeChild(normalizer);
	          }
	        }
	
	        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
	        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);
	
	        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;
	
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
	        }
	      }
	    }
	
	    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;
	
	    if (transaction.useCreateElement) {
	      while (container.lastChild) {
	        container.removeChild(container.lastChild);
	      }
	      DOMLazyTree.insertTreeBefore(container, markup, null);
	    } else {
	      setInnerHTML(container, markup);
	      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
	    }
	
	    if (false) {
	      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
	      if (hostNode._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: hostNode._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  }
	};
	
	module.exports = ReactMount;

/***/ },
/* 375 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(12);
	
	var React = __webpack_require__(86);
	
	var invariant = __webpack_require__(5);
	
	var ReactNodeTypes = {
	  HOST: 0,
	  COMPOSITE: 1,
	  EMPTY: 2,
	
	  getType: function getType(node) {
	    if (node === null || node === false) {
	      return ReactNodeTypes.EMPTY;
	    } else if (React.isValidElement(node)) {
	      if (typeof node.type === 'function') {
	        return ReactNodeTypes.COMPOSITE;
	      } else {
	        return ReactNodeTypes.HOST;
	      }
	    }
	     true ?  false ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
	  }
	};
	
	module.exports = ReactNodeTypes;

/***/ },
/* 376 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ViewportMetrics = {
	  currentScrollLeft: 0,
	
	  currentScrollTop: 0,
	
	  refreshScrollValues: function refreshScrollValues(scrollPosition) {
	    ViewportMetrics.currentScrollLeft = scrollPosition.x;
	    ViewportMetrics.currentScrollTop = scrollPosition.y;
	  }
	};
	
	module.exports = ViewportMetrics;

/***/ },
/* 377 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(12);
	
	var invariant = __webpack_require__(5);
	
	/**
	 * Accumulates items that must not be null or undefined into the first one. This
	 * is used to conserve memory by avoiding array allocations, and thus sacrifices
	 * API cleanness. Since `current` can be null before being passed in and not
	 * null after this function, make sure to assign it back to `current`:
	 *
	 * `a = accumulateInto(a, b);`
	 *
	 * This API should be sparingly used. Try `accumulate` for something cleaner.
	 *
	 * @return {*|array<*>} An accumulation of items.
	 */
	
	function accumulateInto(current, next) {
	  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;
	
	  if (current == null) {
	    return next;
	  }
	
	  // Both are not empty. Warning: Never call x.concat(y) when you are not
	  // certain that x is an Array (x could be a string with concat method).
	  if (Array.isArray(current)) {
	    if (Array.isArray(next)) {
	      current.push.apply(current, next);
	      return current;
	    }
	    current.push(next);
	    return current;
	  }
	
	  if (Array.isArray(next)) {
	    // A bit too dangerous to mutate `next`.
	    return [current].concat(next);
	  }
	
	  return [current, next];
	}
	
	module.exports = accumulateInto;

/***/ },
/* 378 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @param {array} arr an "accumulation" of items which is either an Array or
	 * a single item. Useful when paired with the `accumulate` module. This is a
	 * simple utility that allows us to reason about a collection of items, but
	 * handling the case when there is exactly one item (and we do not need to
	 * allocate an array).
	 */
	
	function forEachAccumulated(arr, cb, scope) {
	  if (Array.isArray(arr)) {
	    arr.forEach(cb, scope);
	  } else if (arr) {
	    cb.call(scope, arr);
	  }
	}
	
	module.exports = forEachAccumulated;

/***/ },
/* 379 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactNodeTypes = __webpack_require__(375);
	
	function getHostComponentFromComposite(inst) {
	  var type;
	
	  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
	    inst = inst._renderedComponent;
	  }
	
	  if (type === ReactNodeTypes.HOST) {
	    return inst._renderedComponent;
	  } else if (type === ReactNodeTypes.EMPTY) {
	    return null;
	  }
	}
	
	module.exports = getHostComponentFromComposite;

/***/ },
/* 380 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(32);
	
	var contentKey = null;
	
	/**
	 * Gets the key used to access text content on a DOM node.
	 *
	 * @return {?string} Key used to access text content.
	 * @internal
	 */
	function getTextContentAccessor() {
	  if (!contentKey && ExecutionEnvironment.canUseDOM) {
	    // Prefer textContent to innerText because many browsers support both but
	    // SVG <text> elements don't support innerText even when <div> does.
	    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
	  }
	  return contentKey;
	}
	
	module.exports = getTextContentAccessor;

/***/ },
/* 381 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(23);
	
	function isCheckable(elem) {
	  var type = elem.type;
	  var nodeName = elem.nodeName;
	  return nodeName && nodeName.toLowerCase() === 'input' && (type === 'checkbox' || type === 'radio');
	}
	
	function getTracker(inst) {
	  return inst._wrapperState.valueTracker;
	}
	
	function attachTracker(inst, tracker) {
	  inst._wrapperState.valueTracker = tracker;
	}
	
	function detachTracker(inst) {
	  delete inst._wrapperState.valueTracker;
	}
	
	function getValueFromNode(node) {
	  var value;
	  if (node) {
	    value = isCheckable(node) ? '' + node.checked : node.value;
	  }
	  return value;
	}
	
	var inputValueTracking = {
	  // exposed for testing
	  _getTrackerFromNode: function _getTrackerFromNode(node) {
	    return getTracker(ReactDOMComponentTree.getInstanceFromNode(node));
	  },
	
	  track: function track(inst) {
	    if (getTracker(inst)) {
	      return;
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var valueField = isCheckable(node) ? 'checked' : 'value';
	    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
	
	    var currentValue = '' + node[valueField];
	
	    // if someone has already defined a value or Safari, then bail
	    // and don't track value will cause over reporting of changes,
	    // but it's better then a hard failure
	    // (needed for certain tests that spyOn input values and Safari)
	    if (node.hasOwnProperty(valueField) || typeof descriptor.get !== 'function' || typeof descriptor.set !== 'function') {
	      return;
	    }
	
	    Object.defineProperty(node, valueField, {
	      enumerable: descriptor.enumerable,
	      configurable: true,
	      get: function get() {
	        return descriptor.get.call(this);
	      },
	      set: function set(value) {
	        currentValue = '' + value;
	        descriptor.set.call(this, value);
	      }
	    });
	
	    attachTracker(inst, {
	      getValue: function getValue() {
	        return currentValue;
	      },
	      setValue: function setValue(value) {
	        currentValue = '' + value;
	      },
	      stopTracking: function stopTracking() {
	        detachTracker(inst);
	        delete node[valueField];
	      }
	    });
	  },
	
	  updateValueIfChanged: function updateValueIfChanged(inst) {
	    if (!inst) {
	      return false;
	    }
	    var tracker = getTracker(inst);
	
	    if (!tracker) {
	      inputValueTracking.track(inst);
	      return true;
	    }
	
	    var lastValue = tracker.getValue();
	    var nextValue = getValueFromNode(ReactDOMComponentTree.getNodeFromInstance(inst));
	
	    if (nextValue !== lastValue) {
	      tracker.setValue(nextValue);
	      return true;
	    }
	
	    return false;
	  },
	  stopTracking: function stopTracking(inst) {
	    var tracker = getTracker(inst);
	    if (tracker) {
	      tracker.stopTracking();
	    }
	  }
	};
	
	module.exports = inputValueTracking;

/***/ },
/* 382 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _prodInvariant = __webpack_require__(12),
	    _assign = __webpack_require__(11);
	
	var ReactCompositeComponent = __webpack_require__(835);
	var ReactEmptyComponent = __webpack_require__(370);
	var ReactHostComponent = __webpack_require__(372);
	
	var getNextDebugID = __webpack_require__(905);
	var invariant = __webpack_require__(5);
	var warning = __webpack_require__(9);
	
	// To avoid a cyclic dependency, we create the final class in this module
	var ReactCompositeComponentWrapper = function ReactCompositeComponentWrapper(element) {
	  this.construct(element);
	};
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Check if the type reference is a known internal type. I.e. not a user
	 * provided composite type.
	 *
	 * @param {function} type
	 * @return {boolean} Returns true if this is a valid internal type.
	 */
	function isInternalComponentType(type) {
	  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
	}
	
	/**
	 * Given a ReactNode, create an instance that will actually be mounted.
	 *
	 * @param {ReactNode} node
	 * @param {boolean} shouldHaveDebugID
	 * @return {object} A new instance of the element's constructor.
	 * @protected
	 */
	function instantiateReactComponent(node, shouldHaveDebugID) {
	  var instance;
	
	  if (node === null || node === false) {
	    instance = ReactEmptyComponent.create(instantiateReactComponent);
	  } else if ((typeof node === 'undefined' ? 'undefined' : _typeof(node)) === 'object') {
	    var element = node;
	    var type = element.type;
	    if (typeof type !== 'function' && typeof type !== 'string') {
	      var info = '';
	      if (false) {
	        if (type === undefined || (typeof type === 'undefined' ? 'undefined' : _typeof(type)) === 'object' && type !== null && Object.keys(type).length === 0) {
	          info += ' You likely forgot to export your component from the file ' + "it's defined in.";
	        }
	      }
	      info += getDeclarationErrorAddendum(element._owner);
	       true ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', type == null ? type : typeof type === 'undefined' ? 'undefined' : _typeof(type), info) : _prodInvariant('130', type == null ? type : typeof type === 'undefined' ? 'undefined' : _typeof(type), info) : void 0;
	    }
	
	    // Special case string values
	    if (typeof element.type === 'string') {
	      instance = ReactHostComponent.createInternalComponent(element);
	    } else if (isInternalComponentType(element.type)) {
	      // This is temporarily available for custom components that are not string
	      // representations. I.e. ART. Once those are updated to use the string
	      // representation, we can drop this code path.
	      instance = new element.type(element);
	
	      // We renamed this. Allow the old name for compat. :(
	      if (!instance.getHostNode) {
	        instance.getHostNode = instance.getNativeNode;
	      }
	    } else {
	      instance = new ReactCompositeComponentWrapper(element);
	    }
	  } else if (typeof node === 'string' || typeof node === 'number') {
	    instance = ReactHostComponent.createInstanceForText(node);
	  } else {
	     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node === 'undefined' ? 'undefined' : _typeof(node)) : _prodInvariant('131', typeof node === 'undefined' ? 'undefined' : _typeof(node)) : void 0;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
	  }
	
	  // These two fields are used by the DOM and ART diffing algorithms
	  // respectively. Instead of using expandos on components, we should be
	  // storing the state needed by the diffing algorithms elsewhere.
	  instance._mountIndex = 0;
	  instance._mountImage = null;
	
	  if (false) {
	    instance._debugID = shouldHaveDebugID ? getNextDebugID() : 0;
	  }
	
	  // Internal instances should fully constructed at this point, so they should
	  // not get any new fields added to them at this point.
	  if (false) {
	    if (Object.preventExtensions) {
	      Object.preventExtensions(instance);
	    }
	  }
	
	  return instance;
	}
	
	_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent, {
	  _instantiateReactComponent: instantiateReactComponent
	});
	
	module.exports = instantiateReactComponent;

/***/ },
/* 383 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
	 */
	
	var supportedInputTypes = {
	  color: true,
	  date: true,
	  datetime: true,
	  'datetime-local': true,
	  email: true,
	  month: true,
	  number: true,
	  password: true,
	  range: true,
	  search: true,
	  tel: true,
	  text: true,
	  time: true,
	  url: true,
	  week: true
	};
	
	function isTextInputElement(elem) {
	  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	
	  if (nodeName === 'input') {
	    return !!supportedInputTypes[elem.type];
	  }
	
	  if (nodeName === 'textarea') {
	    return true;
	  }
	
	  return false;
	}
	
	module.exports = isTextInputElement;

/***/ },
/* 384 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(32);
	var escapeTextContentForBrowser = __webpack_require__(125);
	var setInnerHTML = __webpack_require__(126);
	
	/**
	 * Set the textContent property of a node, ensuring that whitespace is preserved
	 * even in IE8. innerText is a poor substitute for textContent and, among many
	 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
	 * as it should.
	 *
	 * @param {DOMElement} node
	 * @param {string} text
	 * @internal
	 */
	var setTextContent = function setTextContent(node, text) {
	  if (text) {
	    var firstChild = node.firstChild;
	
	    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
	      firstChild.nodeValue = text;
	      return;
	    }
	  }
	  node.textContent = text;
	};
	
	if (ExecutionEnvironment.canUseDOM) {
	  if (!('textContent' in document.documentElement)) {
	    setTextContent = function setTextContent(node, text) {
	      if (node.nodeType === 3) {
	        node.nodeValue = text;
	        return;
	      }
	      setInnerHTML(node, escapeTextContentForBrowser(text));
	    };
	  }
	}
	
	module.exports = setTextContent;

/***/ },
/* 385 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _prodInvariant = __webpack_require__(12);
	
	var ReactCurrentOwner = __webpack_require__(57);
	var REACT_ELEMENT_TYPE = __webpack_require__(850);
	
	var getIteratorFn = __webpack_require__(881);
	var invariant = __webpack_require__(5);
	var KeyEscapeUtils = __webpack_require__(169);
	var warning = __webpack_require__(9);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && (typeof component === 'undefined' ? 'undefined' : _typeof(component)) === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children === 'undefined' ? 'undefined' : _typeof(children);
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 386 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _prodInvariant = __webpack_require__(99),
	    _assign = __webpack_require__(11);
	
	var ReactNoopUpdateQueue = __webpack_require__(389);
	
	var canDefineProperty = __webpack_require__(390);
	var emptyObject = __webpack_require__(120);
	var invariant = __webpack_require__(5);
	var lowPriorityWarning = __webpack_require__(906);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactComponent(props, context, updater) {
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	ReactComponent.prototype.isReactComponent = {};
	
	/**
	 * Sets a subset of the state. Always use this to mutate
	 * state. You should treat `this.state` as immutable.
	 *
	 * There is no guarantee that `this.state` will be immediately updated, so
	 * accessing `this.state` after calling this method may return the old value.
	 *
	 * There is no guarantee that calls to `setState` will run synchronously,
	 * as they may eventually be batched together.  You can provide an optional
	 * callback that will be executed when the call to setState is actually
	 * completed.
	 *
	 * When a function is provided to setState, it will be called at some point in
	 * the future (not synchronously). It will be called with the up to date
	 * component arguments (state, props, context). These values can be different
	 * from this.* because your function may be called after receiveProps but before
	 * shouldComponentUpdate, and this new state, props, and context will not yet be
	 * assigned to this.
	 *
	 * @param {object|function} partialState Next partial state or function to
	 *        produce next partial state to be merged with current state.
	 * @param {?function} callback Called after state is updated.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.setState = function (partialState, callback) {
	  !((typeof partialState === 'undefined' ? 'undefined' : _typeof(partialState)) === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
	  this.updater.enqueueSetState(this, partialState);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'setState');
	  }
	};
	
	/**
	 * Forces an update. This should only be invoked when it is known with
	 * certainty that we are **not** in a DOM transaction.
	 *
	 * You may want to call this when you know that some deeper aspect of the
	 * component's state has changed but `setState` was not called.
	 *
	 * This will not invoke `shouldComponentUpdate`, but it will invoke
	 * `componentWillUpdate` and `componentDidUpdate`.
	 *
	 * @param {?function} callback Called after update is complete.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.forceUpdate = function (callback) {
	  this.updater.enqueueForceUpdate(this);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'forceUpdate');
	  }
	};
	
	/**
	 * Deprecated APIs. These APIs used to exist on classic React classes but since
	 * we would like to deprecate them, we're not going to move them over to this
	 * modern base class. Instead, we define a getter that warns if it's accessed.
	 */
	if (false) {
	  var deprecatedAPIs = {
	    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
	    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
	  };
	  var defineDeprecationWarning = function defineDeprecationWarning(methodName, info) {
	    if (canDefineProperty) {
	      Object.defineProperty(ReactComponent.prototype, methodName, {
	        get: function get() {
	          lowPriorityWarning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
	          return undefined;
	        }
	      });
	    }
	  };
	  for (var fnName in deprecatedAPIs) {
	    if (deprecatedAPIs.hasOwnProperty(fnName)) {
	      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
	    }
	  }
	}
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactPureComponent(props, context, updater) {
	  // Duplicated from ReactComponent.
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	function ComponentDummy() {}
	ComponentDummy.prototype = ReactComponent.prototype;
	ReactPureComponent.prototype = new ComponentDummy();
	ReactPureComponent.prototype.constructor = ReactPureComponent;
	// Avoid an extra prototype jump for these methods.
	_assign(ReactPureComponent.prototype, ReactComponent.prototype);
	ReactPureComponent.prototype.isPureReactComponent = true;
	
	module.exports = {
	  Component: ReactComponent,
	  PureComponent: ReactPureComponent
	};

/***/ },
/* 387 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _prodInvariant = __webpack_require__(99);
	
	var ReactCurrentOwner = __webpack_require__(57);
	
	var invariant = __webpack_require__(5);
	var warning = __webpack_require__(9);
	
	function isNative(fn) {
	  // Based on isNative() from Lodash
	  var funcToString = Function.prototype.toString;
	  var hasOwnProperty = Object.prototype.hasOwnProperty;
	  var reIsNative = RegExp('^' + funcToString
	  // Take an example native function source for comparison
	  .call(hasOwnProperty
	  // Strip regex characters so we can use it for regex
	  ).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&'
	  // Remove hasOwnProperty from the template to make it generic
	  ).replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
	  try {
	    var source = funcToString.call(fn);
	    return reIsNative.test(source);
	  } catch (err) {
	    return false;
	  }
	}
	
	var canUseCollections =
	// Array.from
	typeof Array.from === 'function' &&
	// Map
	typeof Map === 'function' && isNative(Map) &&
	// Map.prototype.keys
	Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
	// Set
	typeof Set === 'function' && isNative(Set) &&
	// Set.prototype.keys
	Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);
	
	var setItem;
	var getItem;
	var removeItem;
	var getItemIDs;
	var addRoot;
	var removeRoot;
	var getRootIDs;
	
	if (canUseCollections) {
	  var itemMap = new Map();
	  var rootIDSet = new Set();
	
	  setItem = function setItem(id, item) {
	    itemMap.set(id, item);
	  };
	  getItem = function getItem(id) {
	    return itemMap.get(id);
	  };
	  removeItem = function removeItem(id) {
	    itemMap['delete'](id);
	  };
	  getItemIDs = function getItemIDs() {
	    return Array.from(itemMap.keys());
	  };
	
	  addRoot = function addRoot(id) {
	    rootIDSet.add(id);
	  };
	  removeRoot = function removeRoot(id) {
	    rootIDSet['delete'](id);
	  };
	  getRootIDs = function getRootIDs() {
	    return Array.from(rootIDSet.keys());
	  };
	} else {
	  var itemByKey = {};
	  var rootByKey = {};
	
	  // Use non-numeric keys to prevent V8 performance issues:
	  // https://github.com/facebook/react/pull/7232
	  var getKeyFromID = function getKeyFromID(id) {
	    return '.' + id;
	  };
	  var getIDFromKey = function getIDFromKey(key) {
	    return parseInt(key.substr(1), 10);
	  };
	
	  setItem = function setItem(id, item) {
	    var key = getKeyFromID(id);
	    itemByKey[key] = item;
	  };
	  getItem = function getItem(id) {
	    var key = getKeyFromID(id);
	    return itemByKey[key];
	  };
	  removeItem = function removeItem(id) {
	    var key = getKeyFromID(id);
	    delete itemByKey[key];
	  };
	  getItemIDs = function getItemIDs() {
	    return Object.keys(itemByKey).map(getIDFromKey);
	  };
	
	  addRoot = function addRoot(id) {
	    var key = getKeyFromID(id);
	    rootByKey[key] = true;
	  };
	  removeRoot = function removeRoot(id) {
	    var key = getKeyFromID(id);
	    delete rootByKey[key];
	  };
	  getRootIDs = function getRootIDs() {
	    return Object.keys(rootByKey).map(getIDFromKey);
	  };
	}
	
	var unmountedIDs = [];
	
	function purgeDeep(id) {
	  var item = getItem(id);
	  if (item) {
	    var childIDs = item.childIDs;
	
	    removeItem(id);
	    childIDs.forEach(purgeDeep);
	  }
	}
	
	function describeComponentFrame(name, source, ownerName) {
	  return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
	}
	
	function _getDisplayName(element) {
	  if (element == null) {
	    return '#empty';
	  } else if (typeof element === 'string' || typeof element === 'number') {
	    return '#text';
	  } else if (typeof element.type === 'string') {
	    return element.type;
	  } else {
	    return element.type.displayName || element.type.name || 'Unknown';
	  }
	}
	
	function describeID(id) {
	  var name = ReactComponentTreeHook.getDisplayName(id);
	  var element = ReactComponentTreeHook.getElement(id);
	  var ownerID = ReactComponentTreeHook.getOwnerID(id);
	  var ownerName;
	  if (ownerID) {
	    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
	  }
	   false ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
	  return describeComponentFrame(name, element && element._source, ownerName);
	}
	
	var ReactComponentTreeHook = {
	  onSetChildren: function onSetChildren(id, nextChildIDs) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.childIDs = nextChildIDs;
	
	    for (var i = 0; i < nextChildIDs.length; i++) {
	      var nextChildID = nextChildIDs[i];
	      var nextChild = getItem(nextChildID);
	      !nextChild ?  false ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
	      !(nextChild.childIDs != null || _typeof(nextChild.element) !== 'object' || nextChild.element == null) ?  false ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
	      !nextChild.isMounted ?  false ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
	      if (nextChild.parentID == null) {
	        nextChild.parentID = id;
	        // TODO: This shouldn't be necessary but mounting a new root during in
	        // componentWillMount currently causes not-yet-mounted components to
	        // be purged from our tree data so their parent id is missing.
	      }
	      !(nextChild.parentID === id) ?  false ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
	    }
	  },
	  onBeforeMountComponent: function onBeforeMountComponent(id, element, parentID) {
	    var item = {
	      element: element,
	      parentID: parentID,
	      text: null,
	      childIDs: [],
	      isMounted: false,
	      updateCount: 0
	    };
	    setItem(id, item);
	  },
	  onBeforeUpdateComponent: function onBeforeUpdateComponent(id, element) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.element = element;
	  },
	  onMountComponent: function onMountComponent(id) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.isMounted = true;
	    var isRoot = item.parentID === 0;
	    if (isRoot) {
	      addRoot(id);
	    }
	  },
	  onUpdateComponent: function onUpdateComponent(id) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.updateCount++;
	  },
	  onUnmountComponent: function onUnmountComponent(id) {
	    var item = getItem(id);
	    if (item) {
	      // We need to check if it exists.
	      // `item` might not exist if it is inside an error boundary, and a sibling
	      // error boundary child threw while mounting. Then this instance never
	      // got a chance to mount, but it still gets an unmounting event during
	      // the error boundary cleanup.
	      item.isMounted = false;
	      var isRoot = item.parentID === 0;
	      if (isRoot) {
	        removeRoot(id);
	      }
	    }
	    unmountedIDs.push(id);
	  },
	  purgeUnmountedComponents: function purgeUnmountedComponents() {
	    if (ReactComponentTreeHook._preventPurging) {
	      // Should only be used for testing.
	      return;
	    }
	
	    for (var i = 0; i < unmountedIDs.length; i++) {
	      var id = unmountedIDs[i];
	      purgeDeep(id);
	    }
	    unmountedIDs.length = 0;
	  },
	  isMounted: function isMounted(id) {
	    var item = getItem(id);
	    return item ? item.isMounted : false;
	  },
	  getCurrentStackAddendum: function getCurrentStackAddendum(topElement) {
	    var info = '';
	    if (topElement) {
	      var name = _getDisplayName(topElement);
	      var owner = topElement._owner;
	      info += describeComponentFrame(name, topElement._source, owner && owner.getName());
	    }
	
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    info += ReactComponentTreeHook.getStackAddendumByID(id);
	    return info;
	  },
	  getStackAddendumByID: function getStackAddendumByID(id) {
	    var info = '';
	    while (id) {
	      info += describeID(id);
	      id = ReactComponentTreeHook.getParentID(id);
	    }
	    return info;
	  },
	  getChildIDs: function getChildIDs(id) {
	    var item = getItem(id);
	    return item ? item.childIDs : [];
	  },
	  getDisplayName: function getDisplayName(id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element) {
	      return null;
	    }
	    return _getDisplayName(element);
	  },
	  getElement: function getElement(id) {
	    var item = getItem(id);
	    return item ? item.element : null;
	  },
	  getOwnerID: function getOwnerID(id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element || !element._owner) {
	      return null;
	    }
	    return element._owner._debugID;
	  },
	  getParentID: function getParentID(id) {
	    var item = getItem(id);
	    return item ? item.parentID : null;
	  },
	  getSource: function getSource(id) {
	    var item = getItem(id);
	    var element = item ? item.element : null;
	    var source = element != null ? element._source : null;
	    return source;
	  },
	  getText: function getText(id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (typeof element === 'string') {
	      return element;
	    } else if (typeof element === 'number') {
	      return '' + element;
	    } else {
	      return null;
	    }
	  },
	  getUpdateCount: function getUpdateCount(id) {
	    var item = getItem(id);
	    return item ? item.updateCount : 0;
	  },
	
	  getRootIDs: getRootIDs,
	  getRegisteredIDs: getItemIDs,
	
	  pushNonStandardWarningStack: function pushNonStandardWarningStack(isCreatingElement, currentSource) {
	    if (typeof console.reactStack !== 'function') {
	      return;
	    }
	
	    var stack = [];
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    try {
	      if (isCreatingElement) {
	        stack.push({
	          name: id ? ReactComponentTreeHook.getDisplayName(id) : null,
	          fileName: currentSource ? currentSource.fileName : null,
	          lineNumber: currentSource ? currentSource.lineNumber : null
	        });
	      }
	
	      while (id) {
	        var element = ReactComponentTreeHook.getElement(id);
	        var parentID = ReactComponentTreeHook.getParentID(id);
	        var ownerID = ReactComponentTreeHook.getOwnerID(id);
	        var ownerName = ownerID ? ReactComponentTreeHook.getDisplayName(ownerID) : null;
	        var source = element && element._source;
	        stack.push({
	          name: ownerName,
	          fileName: source ? source.fileName : null,
	          lineNumber: source ? source.lineNumber : null
	        });
	        id = parentID;
	      }
	    } catch (err) {
	      // Internal state is messed up.
	      // Stop building the stack (it's just a nice to have).
	    }
	
	    console.reactStack(stack);
	  },
	  popNonStandardWarningStack: function popNonStandardWarningStack() {
	    if (typeof console.reactStackEnd !== 'function') {
	      return;
	    }
	    console.reactStackEnd();
	  }
	};
	
	module.exports = ReactComponentTreeHook;

/***/ },
/* 388 */
/***/ function(module, exports) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	module.exports = REACT_ELEMENT_TYPE;

/***/ },
/* 389 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var warning = __webpack_require__(9);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the abstract API for an update queue.
	 */
	var ReactNoopUpdateQueue = {
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function isMounted(publicInstance) {
	    return false;
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function enqueueCallback(publicInstance, callback) {},
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function enqueueForceUpdate(publicInstance) {
	    warnNoop(publicInstance, 'forceUpdate');
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function enqueueReplaceState(publicInstance, completeState) {
	    warnNoop(publicInstance, 'replaceState');
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function enqueueSetState(publicInstance, partialState) {
	    warnNoop(publicInstance, 'setState');
	  }
	};
	
	module.exports = ReactNoopUpdateQueue;

/***/ },
/* 390 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var canDefineProperty = false;
	if (false) {
	  try {
	    // $FlowFixMe https://github.com/facebook/flow/issues/285
	    Object.defineProperty({}, 'x', { get: function get() {} });
	    canDefineProperty = true;
	  } catch (x) {
	    // IE will fail on defineProperty
	  }
	}
	
	module.exports = canDefineProperty;

/***/ },
/* 391 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	  };
	}();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(63);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _propTypes = __webpack_require__(29);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(25);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _VstListItem = __webpack_require__(393);
	
	var _VstListItem2 = _interopRequireDefault(_VstListItem);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var KEYCODES = {
	  ENTER: 13,
	  ESCAPE: 27,
	  SPACE: 32,
	  UP: 38,
	  DOWN: 40
	};
	
	var VstDropdown = function (_React$Component) {
	  _inherits(VstDropdown, _React$Component);
	
	  function VstDropdown(props) {
	    _classCallCheck(this, VstDropdown);
	
	    var _this = _possibleConstructorReturn(this, (VstDropdown.__proto__ || Object.getPrototypeOf(VstDropdown)).call(this, props));
	
	    _this.state = {
	      open: false
	    };
	
	    _this.menu = null;
	    _this.portal = null;
	    _this.onDocumentKeydown = _this.onDocumentKeydown.bind(_this);
	    _this.onDocumentMouseUp = _this.onDocumentMouseUp.bind(_this);
	    _this.onTargetMouseUp = _this.onTargetMouseUp.bind(_this);
	    _this.onTargetKeydown = _this.onTargetKeydown.bind(_this);
	    _this.afterClose = _this.afterClose.bind(_this);
	    _this.closeMenu = _this.closeMenu.bind(_this);
	    _this.positionMenu = _this.positionMenu.bind(_this);
	    _this.onApplyClick = _this.onApplyClick.bind(_this);
	    _this.focusAtFirstChild = _this.focusAtFirstChild.bind(_this);
	    return _this;
	  }
	
	  _createClass(VstDropdown, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      (0, _reactDom.findDOMNode)(this).addEventListener('scroll', this.closeMenu);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(np) {
	      if (this.state.open) {
	        this.renderMenu(np);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.state.open) {
	        this.afterClose();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var target = this.props.target;
	      var className = target.props.className || '';
	
	      return (0, _react.cloneElement)(target, {
	        onClick: this.focusAtFirstChild,
	        onMouseUp: this.onTargetMouseUp,
	        onKeyDown: this.onTargetKeydown,
	        className: className + ' ' + (this.state.open ? 'open' : ''),
	        'aria-expanded': this.state.open,
	        'aria-haspopup': true
	      });
	    }
	  }, {
	    key: 'getWinSize',
	    value: function getWinSize() {
	      var body = document.body;
	      var elem = document.documentElement;
	      return {
	        innerWidth: window.innerWidth || Math.max(elem.clientWidth, body.clientWidth),
	        innerHeight: window.innerHeight || Math.max(elem.clientHeight, body.clientHeight),
	        scrollY: window.scrollY || elem.scrollTop || body.scrollTop || 0,
	        scrollX: window.scrollX || elem.scrollLeft || body.scrollLeft || 0
	      };
	    }
	  }, {
	    key: 'onDocumentKeydown',
	    value: function onDocumentKeydown(e) {
	      if (e.keyCode === KEYCODES.ESCAPE) {
	        this.closeMenu();
	      }
	    }
	  }, {
	    key: 'onDocumentMouseUp',
	    value: function onDocumentMouseUp(e) {
	      var portal = (0, _reactDom.findDOMNode)(this.portal);
	      if (portal && portal.contains(e.target) || e.button && e.button !== 0) return;
	      e.stopPropagation();
	      this.closeMenu();
	    }
	  }, {
	    key: 'onTargetMouseUp',
	    value: function onTargetMouseUp() {
	      this.openMenu(this.props);
	    }
	  }, {
	    key: 'onTargetKeydown',
	    value: function onTargetKeydown(e) {
	      if (e.keyCode === KEYCODES.ENTER || e.keyCode === KEYCODES.DOWN) {
	        this.openMenu();
	      }
	    }
	  }, {
	    key: 'focusMenu',
	    value: function focusMenu() {
	      var portal = (0, _reactDom.findDOMNode)(this.portal);
	      portal.firstChild.focus();
	    }
	  }, {
	    key: 'openMenu',
	    value: function openMenu(props) {
	      var _this2 = this;
	
	      if (!this.state.open) {
	        this.setState({ open: true }, function () {
	          _this2.renderMenu(props || _this2.props);
	          _this2.focusMenu();
	          if (_this2.props.onOpen) {
	            _this2.props.onOpen();
	          }
	        });
	      }
	    }
	  }, {
	    key: 'focusAtFirstChild',
	    value: function focusAtFirstChild() {
	      if (this.dropdown.firstChild.firstChild.focus) {
	        this.dropdown.firstChild.firstChild.focus();
	      } else {
	        this.dropdown.firstChild.focus();
	      }
	    }
	  }, {
	    key: 'afterClose',
	    value: function afterClose() {
	      document.removeEventListener('keydown', this.onDocumentKeydown);
	      document.removeEventListener('mouseup', this.onDocumentMouseUp);
	      document.removeEventListener('touchstart', this.onDocumentMouseUp);
	      document.removeEventListener('vst-dropdown.close', this.closeMenu);
	      window.removeEventListener('resize', this.closeMenu);
	      _reactDom2.default.unmountComponentAtNode(this.menu);
	      document.body.removeChild(this.menu);
	      document.body.removeChild(this.overlay);
	      this.portal = null;
	      this.menu = null;
	      if (this.props.onClose) {
	        this.props.onClose();
	      }
	    }
	  }, {
	    key: 'closeMenu',
	    value: function closeMenu() {
	      this.setState({ open: false }, this.afterClose);
	    }
	  }, {
	    key: 'positionMenu',
	    value: function positionMenu() {
	      var _this3 = this;
	
	      var _props = this.props,
	          horizontal = _props.horizontal,
	          vertical = _props.vertical,
	          customX = _props.customX,
	          customY = _props.customY;
	
	      var _getWinSize = this.getWinSize(),
	          innerHeight = _getWinSize.innerHeight,
	          innerWidth = _getWinSize.innerWidth,
	          scrollX = _getWinSize.scrollX,
	          scrollY = _getWinSize.scrollY;
	
	      var targetNode = (0, _reactDom.findDOMNode)(this);
	      var portalNode = (0, _reactDom.findDOMNode)(this.portal);
	      var target = targetNode.getBoundingClientRect();
	      var portal = portalNode.getBoundingClientRect();
	      var menuX = void 0;
	      var menuY = void 0;
	      var originX = void 0;
	      var originY = void 0;
	      // let maxHeight;
	
	      // calculate space above/below target
	      var above = target.top;
	      var below = innerHeight - target.bottom;
	      // maxHeight = portal.height;
	      if (horizontal === 'left') {
	        // align left
	        menuX = target.left + scrollX;
	        originX = 'left';
	        // out of bounds, move to right
	        if (menuX + portal.width > innerWidth + scrollX) {
	          menuX = target.right + scrollX - portal.width;
	          originX = 'right';
	        }
	      } else {
	        // align right
	        menuX = target.right + scrollX - portal.width;
	        originX = 'right';
	        // out of bounds, move to left
	        if (menuX < 0) {
	          menuX = target.left + scrollX;
	          originX = 'left';
	        }
	      }
	
	      if (vertical === 'top') {
	        // show at the top
	        menuY = target.top - portal.height + scrollY;
	        originY = 'bottom';
	        // out of bounds, move to bottom if there is more space
	        if (menuY < 0 && below > above) {
	          menuY = target.bottom + scrollY;
	          originY = 'top';
	        }
	      } else {
	        // show at the bottom
	        menuY = target.bottom + scrollY;
	        originY = 'top';
	        // out of bounds, move to top if there is more space
	        if (menuY + portal.height > innerHeight + scrollY && above > below) {
	          menuY = target.top - portal.height + scrollY;
	          originY = 'bottom';
	        }
	      }
	
	      if (originY === 'top') {
	        // originY is top, which means show menu at the bottom
	        if (portal.height > innerHeight - target.bottom) {
	          // maxHeight = innerHeight - target.bottom - 10;
	        }
	      } else {
	        // originY is top, which means show menu at the top
	        if (portal.height > target.top) {
	          // maxHeight = target.top - 10;
	          menuY = scrollY + 10;
	        }
	      }
	
	      if (customX && customY) {
	        menuX = customX;
	        menuY = target.top + customY;
	        originY = 'right';
	      }
	
	      if (!this.props.isMobile) {
	        // set initial style
	        // this.menu.style.height = '0px'; // Disabling scroll on main menu for now..
	        if (customX && customY) {
	          this.menu.style.right = menuX + 'px';
	        } else {
	          this.menu.style.left = menuX + 'px';
	        }
	        this.menu.style.position = customX && customY ? 'absolute' : '';
	        this.menu.style.top = menuY + 'px';
	        this.menu.style.transform = 'scale3d(0.01, 0.01, 1)';
	        this.menu.style.transformOrigin = originX + ' ' + originY;
	
	        // do the animation with a slight delay
	        setTimeout(function () {
	          // Menu may be gone by this point if it unmounts
	          if (_this3.menu) {
	            _this3.menu.style.opacity = '1';
	            // this.menu.style.height = `${maxHeight}px`;
	            _this3.menu.style.transform = 'scale3d(1, 1, 1)';
	            _this3.menu.style.transition = 'transform 0.2s ease';
	          }
	        }, 20);
	      }
	    }
	  }, {
	    key: 'onApplyClick',
	    value: function onApplyClick() {
	      if (this.props.onApplyClick) {
	        this.props.onApplyClick();
	        this.closeMenu();
	      }
	    }
	  }, {
	    key: 'renderMobileHeader',
	    value: function renderMobileHeader() {
	      return _react2.default.createElement('header', { className: this.props.headerClassName }, _react2.default.createElement('div', { className: 'back-title' }, this.props.showBackBtn && _react2.default.createElement('button', { onClick: this.closeMenu }, this.props.headerBackButton), _react2.default.createElement('h2', { tabIndex: 0 }, this.props.headerTitle)), this.props.showApplyBtn && _react2.default.createElement('button', { onClick: this.onApplyClick }, this.props.headerApplyButton));
	    }
	  }, {
	    key: 'renderMenu',
	    value: function renderMenu(props) {
	      var _this4 = this;
	
	      var className = props.className,
	          vertical = props.vertical,
	          scrollable = props.scrollable;
	
	      if (!this.menu) {
	        this.overlay = document.createElement('div');
	        this.overlay.setAttribute('class', 'vst-dropdown-overlay');
	        this.menu = document.createElement('div');
	        if (this.props.isMobile) {
	          this.menu.className = (0, _classnames2.default)('vst-dropdown-mobile vst-dropdown-' + vertical, className);
	        } else {
	          this.menu.className = (0, _classnames2.default)('vst-dropdown vst-dropdown-' + vertical, className);
	        }
	        document.body.appendChild(this.menu);
	        document.body.appendChild(this.overlay);
	        document.addEventListener('keydown', this.onDocumentKeydown);
	        document.addEventListener('mouseup', this.onDocumentMouseUp);
	        document.addEventListener('touchstart', this.onDocumentMouseUp);
	        document.addEventListener('vst-dropdown.close', this.closeMenu);
	        window.addEventListener('resize', this.closeMenu);
	      }
	
	      var closeMenu = this.closeMenu;
	      var list = _react2.default.createElement('div', { className: 'vst-list' }, this.renderMobileHeader(), _react2.default.createElement('ul', {
	        ref: function ref(dropdown) {
	          _this4.dropdown = dropdown;
	        },
	        style: {
	          height: this.props.height,
	          overflow: scrollable ? 'scroll' : 'visible'
	        }
	      }, _react.Children.map(props.children, function (child, index) {
	        if (!child.props.hidden) {
	          return (0, _react.cloneElement)(child, {
	            closeMenu: closeMenu,
	            key: index,
	            isMobile: _this4.props.isMobile,
	            header: _this4.renderMobileHeader()
	          });
	        }
	        return null;
	      }), _react2.default.createElement('li', null, _react2.default.createElement('div', {
	        role: 'button',
	        tabIndex: 0,
	        onFocus: this.focusAtFirstChild
	      }))));
	
	      this.portal = _reactDom2.default.unstable_renderSubtreeIntoContainer(this, list, this.menu);
	      this.positionMenu();
	    }
	  }]);
	
	  return VstDropdown;
	}(_react2.default.Component);
	
	VstDropdown.propTypes = {
	  children: _propTypes2.default.node.isRequired,
	  target: _propTypes2.default.element.isRequired,
	  onClose: _propTypes2.default.func,
	  onOpen: _propTypes2.default.func,
	  className: _propTypes2.default.string,
	  height: _propTypes2.default.string,
	  isMobile: _propTypes2.default.bool,
	  showBackBtn: _propTypes2.default.bool,
	  scrollable: _propTypes2.default.bool,
	  onApplyClick: _propTypes2.default.func,
	  showApplyBtn: _propTypes2.default.bool,
	  headerClassName: _propTypes2.default.node,
	  headerBackButton: _propTypes2.default.node,
	  headerApplyButton: _propTypes2.default.node,
	  headerTitle: _propTypes2.default.string,
	  customX: _propTypes2.default.number,
	  customY: _propTypes2.default.number,
	  horizontal: _propTypes2.default.oneOf(['left', 'right']),
	  vertical: _propTypes2.default.oneOf(['bottom', 'top'])
	};
	
	VstDropdown.defaultProps = {
	  height: null,
	  horizontal: 'left',
	  vertical: 'bottom',
	  customX: 0,
	  customY: 0,
	  headerTitle: 'Title',
	  scrollable: false,
	  showBackBtn: true,
	  showApplyBtn: true,
	  menuName: ''
	};
	
	VstDropdown.Item = _VstListItem2.default;
	
	exports.default = VstDropdown;

/***/ },
/* 392 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	  };
	}();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _VstComponent2 = __webpack_require__(13);
	
	var _VstComponent3 = _interopRequireDefault(_VstComponent2);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var VstHamburger = function (_VstComponent) {
	  _inherits(VstHamburger, _VstComponent);
	
	  function VstHamburger() {
	    _classCallCheck(this, VstHamburger);
	
	    var _this = _possibleConstructorReturn(this, (VstHamburger.__proto__ || Object.getPrototypeOf(VstHamburger)).call(this));
	
	    _this._clickHamburger = _this._clickHamburger.bind(_this);
	    return _this;
	  }
	
	  _createClass(VstHamburger, [{
	    key: '_clickHamburger',
	    value: function _clickHamburger(e) {
	      if (this.props.clickHamburger) {
	        this.props.clickHamburger(e);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement('button', { className: 'hamburger vst-no-button',
	        onClick: this._clickHamburger,
	        'aria-expanded': this.props.active
	      }, _react2.default.createElement('span', { className: 'vst-off-screen' }, 'Hambuggler'));
	    }
	  }]);
	
	  return VstHamburger;
	}(_VstComponent3.default);
	
	exports.default = VstHamburger;

/***/ },
/* 393 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	  };
	}();
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }return target;
	};
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(29);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _glamor = __webpack_require__(94);
	
	var _VstSubmenuItem = __webpack_require__(942);
	
	var _VstSubmenuItem2 = _interopRequireDefault(_VstSubmenuItem);
	
	var _VstComponent2 = __webpack_require__(13);
	
	var _VstComponent3 = _interopRequireDefault(_VstComponent2);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _objectWithoutProperties(obj, keys) {
	  var target = {};for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
	  }return target;
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var rightArrow = function rightArrow(props) {
	  return _react2.default.createElement('svg', _extends({
	    xmlns: 'http://www.w3.org/2000/svg',
	    width: '6.1',
	    height: '107',
	    viewBox: '0 0 6.1 10'
	  }, props), _react2.default.createElement('path', {
	    fill: '#1B1B26',
	    d: 'M.1 1.4L1.3 0l4.8 4.8v.4L1.3 10 0 8.6 3.6 5z'
	  }));
	};
	
	var VstListItem = function (_VstComponent) {
	  _inherits(VstListItem, _VstComponent);
	
	  function VstListItem(props) {
	    _classCallCheck(this, VstListItem);
	
	    var _this = _possibleConstructorReturn(this, (VstListItem.__proto__ || Object.getPrototypeOf(VstListItem)).call(this, props));
	
	    _this.state = {
	      visible: false
	    };
	
	    _this.onClick = _this.onClick.bind(_this);
	    return _this;
	  }
	
	  _createClass(VstListItem, [{
	    key: 'render',
	    value: function render() {
	      return {
	        text: this.text.bind(this),
	        header: this.header.bind(this),
	        subheader: this.subheader.bind(this),
	        divider: this.divider.bind(this),
	        element: this.element.bind(this),
	        select: this.select.bind(this)
	      }[this.props.role]();
	    }
	  }, {
	    key: 'onClick',
	    value: function onClick(e) {
	      var _props = this.props,
	          closeMenu = _props.closeMenu,
	          closeOnClick = _props.closeOnClick,
	          onClick = _props.onClick;
	
	      if (onClick) {
	        onClick(e);
	      }
	      if (closeMenu && closeOnClick) {
	        closeMenu();
	      }
	    }
	  }, {
	    key: '_getCSS',
	    value: function _getCSS() {
	      var rule = {
	        '&:hover, &:active, &:focus': {
	          outline: 'none',
	          backgroundColor: this._theme(1)
	        }
	      };
	      if (this.props.selected) {
	        rule.color = this._theme(8);
	      }
	      return (0, _glamor.css)(rule);
	    }
	  }, {
	    key: 'text',
	    value: function text() {
	      var _props2 = this.props,
	          className = _props2.className,
	          children = _props2.children,
	          style = _props2.style,
	          selected = _props2.selected;
	
	      return _react2.default.createElement('li', _extends({
	        className: 'vst-list-item text ' + className + ' ' + (selected ? 'selected' : '')
	      }, this._getCSS()), _react2.default.createElement('div', _extends({
	        className: 'libutton',
	        tabIndex: 0,
	        role: 'button',
	        style: style,
	        'aria-pressed': selected,
	        onClick: this.onClick
	      }, this._getCSS()), children));
	    }
	  }, {
	    key: 'header',
	    value: function header() {
	      var _props3 = this.props,
	          className = _props3.className,
	          children = _props3.children,
	          style = _props3.style;
	
	      return _react2.default.createElement('li', {
	        className: 'vst-list-item header ' + className,
	        style: style,
	        tabIndex: -1
	      }, children);
	    }
	  }, {
	    key: 'subheader',
	    value: function subheader() {
	      var _props4 = this.props,
	          className = _props4.className,
	          children = _props4.children,
	          style = _props4.style;
	
	      return _react2.default.createElement('li', {
	        className: 'vst-list-item subheader ' + className,
	        style: style,
	        tabIndex: -1
	      }, _react2.default.createElement('h3', null, children));
	    }
	  }, {
	    key: 'divider',
	    value: function divider() {
	      var _React$createElement;
	
	      return _react2.default.createElement('li', (_React$createElement = {
	        className: 'vst-list-item subheader',
	        tabIndex: this.props.tabIndex
	      }, _defineProperty(_React$createElement, 'tabIndex', -1), _defineProperty(_React$createElement, 'style', { padding: 0 }), _React$createElement));
	    }
	  }, {
	    key: 'element',
	    value: function element() {
	      var _props5 = this.props,
	          className = _props5.className,
	          children = _props5.children,
	          style = _props5.style,
	          selected = _props5.selected;
	
	      return _react2.default.createElement('li', _extends({
	        className: 'vst-list-item element ' + className + ' ' + (selected ? 'selected' : ''),
	        style: style,
	        'aria-pressed': selected
	      }, this._getCSS()), children);
	    }
	  }, {
	    key: 'select',
	    value: function select() {
	      var _this2 = this;
	
	      var _props6 = this.props,
	          className = _props6.className,
	          children = _props6.children,
	          style = _props6.style,
	          text = _props6.text,
	          selected = _props6.selected,
	          isList = _props6.isList,
	          restProps = _objectWithoutProperties(_props6, ['className', 'children', 'style', 'text', 'selected', 'isList']);
	
	      var openSubmenu = function openSubmenu() {
	        _this2.setState({ show: true });
	        // setTimeout(() => this.submenu.submenu.firstChild.firstChild.focus(), 1000);
	        // submenu.firstChild.focus();
	      };
	      return _react2.default.createElement('li', _extends({
	        className: 'vst-list-item select ' + className + ' ' + (selected ? 'selected' : ''),
	        onMouseEnter: openSubmenu,
	        onClick: openSubmenu,
	        onFocus: openSubmenu
	      }, restProps, this._getCSS()), _react2.default.createElement('div', _extends({
	        className: 'libutton',
	        tabIndex: 0,
	        role: 'button',
	        style: style,
	        onClick: openSubmenu,
	        onMouseEnter: openSubmenu,
	        onFocus: openSubmenu,
	        'aria-pressed': selected
	      }, this._getCSS()), text, _react2.default.createElement(_VstSubmenuItem2.default, {
	        ref: function ref(submenu) {
	          _this2.submenu = submenu;
	        },
	        closeMenu: this.props.closeMenu,
	        visible: this.state.show,
	        isMobile: this.props.isMobile,
	        isList: isList,
	        onBackButtonClick: function onBackButtonClick() {
	          return _this2.setState({ show: false });
	        },
	        headerTitle: this.props.headerTitle,
	        headerClassName: this.props.headerClassName,
	        headerApplyButton: this.props.headerApplyButton,
	        headerBackButton: this.props.headerBackButton
	      }, children), rightArrow()));
	    }
	  }]);
	
	  return VstListItem;
	}(_VstComponent3.default);
	
	VstListItem.propTypes = {
	  className: _propTypes2.default.string,
	  style: _propTypes2.default.object,
	  children: _propTypes2.default.node,
	  closeMenu: _propTypes2.default.func,
	  closeOnClick: _propTypes2.default.bool,
	  onClick: _propTypes2.default.func,
	  tabIndex: _propTypes2.default.number,
	  text: _propTypes2.default.string,
	  hidden: _propTypes2.default.bool,
	  isMobile: _propTypes2.default.bool,
	  maxHeight: _propTypes2.default.string,
	  selected: _propTypes2.default.bool,
	  role: _propTypes2.default.oneOf(['text', 'header', 'subheader', 'divider', 'element', 'select'])
	};
	
	VstListItem.defaultProps = {
	  role: 'text',
	  className: '',
	  style: {},
	  hidden: false,
	  maxHeight: undefined,
	  closeOnClick: true
	};
	
	exports.default = VstListItem;

/***/ },
/* 394 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	  };
	}();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _VstComponent2 = __webpack_require__(13);
	
	var _VstComponent3 = _interopRequireDefault(_VstComponent2);
	
	var _classnames = __webpack_require__(25);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var VstMenu = function (_VstComponent) {
	  _inherits(VstMenu, _VstComponent);
	
	  function VstMenu() {
	    _classCallCheck(this, VstMenu);
	
	    var _this = _possibleConstructorReturn(this, (VstMenu.__proto__ || Object.getPrototypeOf(VstMenu)).call(this));
	
	    _this._updatePosition = _this._updatePosition.bind(_this);
	    _this._clickMenuMask = _this._clickMenuMask.bind(_this);
	    _this.state = {
	      arrowRight: 15,
	      menuRight: 0,
	      top: 44
	    };
	    return _this;
	  }
	
	  _createClass(VstMenu, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.visible) {
	        this._updatePosition();
	      }
	    }
	  }, {
	    key: '_updatePosition',
	    value: function _updatePosition() {
	      var callee = this.refs.vstMenu.parentElement.parentElement;
	      var menuRight = document.body.offsetWidth - callee.offsetWidth - callee.offsetLeft;
	      var offsetRight = menuRight < 6 ? 6 - menuRight : 0;
	      this.setState({
	        arrowRight: callee.offsetWidth / 2 - 4 - offsetRight,
	        menuRight: menuRight + offsetRight,
	        arrowTop: callee.offsetTop + callee.offsetHeight + 8
	      });
	    }
	  }, {
	    key: '_clickMenuMask',
	    value: function _clickMenuMask() {
	      if (this.props.closeMenu) {
	        this.props.closeMenu();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement('span', null, _react2.default.createElement('div', { style: { right: this.state.menuRight, top: this.state.arrowTop },
	        ref: 'vstMenu',
	        className: (0, _classnames2.default)(this.props.className, 'vst-menu', { visible: this.props.visible })
	      }, _react2.default.createElement('div', { ref: 'pointer',
	        className: 'pointer up',
	        style: { right: this.state.arrowRight }
	      }), this.props.children), _react2.default.createElement('div', { className: (0, _classnames2.default)('vst-menu-mask', { visible: this.props.visible }), onClick: this._clickMenuMask }));
	    }
	  }]);
	
	  return VstMenu;
	}(_VstComponent3.default);
	
	exports.default = VstMenu;

/***/ },
/* 395 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	  };
	}();
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }return target;
	};
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _VstComponent2 = __webpack_require__(13);
	
	var _VstComponent3 = _interopRequireDefault(_VstComponent2);
	
	var _propTypes = __webpack_require__(29);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _VstButton = __webpack_require__(181);
	
	var _VstButton2 = _interopRequireDefault(_VstButton);
	
	var _VstInput = __webpack_require__(182);
	
	var _VstInput2 = _interopRequireDefault(_VstInput);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var info = function info(props) {
	  return _react2.default.createElement('svg', _extends({
	    xmlns: 'http://www.w3.org/2000/svg',
	    width: '12',
	    height: '12',
	    viewBox: '0 0 12 12'
	  }, props), _react2.default.createElement('path', {
	    fill: '#777',
	    className: 'st0',
	    d: 'M6 .9c2.8 0 5.1 2.3 5.1 5.1S8.8 11.1 6 11.1.9 8.8.9 6 3.2.9 6 .9M6 0C2.7 0 0 2.7 0 6s2.7 6 6 6 6-2.7 6-6-2.7-6-6-6z'
	  }), _react2.default.createElement('path', {
	    fill: '#777',
	    className: 'st0',
	    d: 'M4.8 9.3c.2 0 .3-.1.4-.1 0-.1.1-.2.1-.5V5.6c0-.2 0-.4-.1-.4-.1-.1-.2-.1-.4-.1v-.3h2v4c0 .2 0 .4.1.4.1.1.2.1.4.2v.2H4.8v-.3zm.7-6.7c.1-.1.3-.2.5-.2s.4.1.6.2c.1.2.2.4.2.6s-.1.4-.2.6c-.2.1-.4.2-.6.2-.2 0-.4-.1-.5-.2-.2-.2-.3-.4-.3-.6 0-.2.1-.4.3-.6z'
	  }));
	};
	
	var success = function success(props) {
	  return _react2.default.createElement('svg', _extends({
	    width: '94',
	    height: '94',
	    viewBox: '0 0 94 94',
	    xmlns: 'http://www.w3.org/2000/svg'
	  }, props), _react2.default.createElement('title', null, 'success_icon'), _react2.default.createElement('g', {
	    fill: '#21A921',
	    fillRule: 'evenodd'
	  }, _react2.default.createElement('path', {
	    d: 'M29.301 45.086a4.064 4.064 0 0 0-2.88-1.191 4.068 4.068 0 0 0-2.88 1.19 4.079 4.079 0 0 0 0 5.762l14.227 14.228a4.08 4.08 0 0 0 5.761 0L70.46 38.144a4.08 4.08 0 0 0 0-5.761 4.082 4.082 0 0 0-5.76 0l-24.05 24.05L29.3 45.087z'
	  }), _react2.default.createElement('path', {
	    d: 'M47 4C23.29 4 4 23.29 4 47s19.29 43 43 43 43-19.29 43-43S70.71 4 47 4m0 90C21.084 94 0 72.916 0 47S21.084 0 47 0s47 21.084 47 47-21.084 47-47 47'
	  })));
	};
	
	var error = function error(props) {
	  return _react2.default.createElement('svg', _extends({
	    width: '94',
	    height: '94',
	    viewBox: '0 0 94 94',
	    xmlns: 'http://www.w3.org/2000/svg'
	  }, props), _react2.default.createElement('title', null, 'error_icon'), _react2.default.createElement('g', {
	    fill: '#F64250',
	    fillRule: 'evenodd'
	  }, _react2.default.createElement('path', {
	    d: 'M47 71.313a5.758 5.758 0 1 1 0-11.517 5.758 5.758 0 0 1 0 11.517M50.996 51.505a2.065 2.065 0 0 1-2.058 1.892h-3.877a2.065 2.065 0 0 1-2.058-1.892l-2.215-26.582a2.064 2.064 0 0 1 2.057-2.235h8.308a2.064 2.064 0 0 1 2.058 2.236l-2.215 26.58z'
	  }), _react2.default.createElement('path', {
	    d: 'M47 4C23.29 4 4 23.29 4 47s19.29 43 43 43 43-19.29 43-43S70.71 4 47 4m0 90C21.084 94 0 72.916 0 47S21.084 0 47 0s47 21.084 47 47-21.084 47-47 47'
	  })));
	};
	
	var x = function x(props) {
	  return _react2.default.createElement('svg', _extends({
	    xmlns: 'http://www.w3.org/2000/svg',
	    width: '10',
	    height: '10',
	    viewBox: '0 0 10 10'
	  }, props), _react2.default.createElement('path', {
	    fill: '#757575',
	    d: 'M10 1.1L8.9 0 5 3.9 1.1 0 0 1.1 3.9 5 0 8.9 1.1 10 5 6.1 8.9 10 10 8.9 6.1 5z'
	  }));
	};
	
	var VstToast = function (_VstComponent) {
	  _inherits(VstToast, _VstComponent);
	
	  function VstToast(props) {
	    _classCallCheck(this, VstToast);
	
	    var _this = _possibleConstructorReturn(this, (VstToast.__proto__ || Object.getPrototypeOf(VstToast)).call(this, props));
	
	    _this.state = {
	      checked: false,
	      entering: false
	    };
	
	    _this._setReadingTime = _this._setReadingTime.bind(_this);
	    _this._estimateReadingTime = _this._estimateReadingTime.bind(_this);
	    _this._dismiss = _this._dismiss.bind(_this);
	    _this._handleCheckboxChange = _this._handleCheckboxChange.bind(_this);
	    _this._customBorder = _this._customBorder.bind(_this);
	    _this._customTextColor = _this._customTextColor.bind(_this);
	    _this._customBackground = _this._customBackground.bind(_this);
	    _this._customClosePosition = _this._customClosePosition.bind(_this);
	    return _this;
	  }
	
	  _createClass(VstToast, [{
	    key: 'componentWillEnter',
	    value: function componentWillEnter(callback) {
	      var _this2 = this;
	
	      setTimeout(function () {
	        _this2.setState({ entering: true });
	        callback();
	      }, 1);
	    }
	  }, {
	    key: 'componentWillLeave',
	    value: function componentWillLeave(callback) {
	      this.setState({ exiting: true });
	      setTimeout(function () {
	        callback();
	      }, 1000);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (!this.props.dismissible) {
	        this._setReadingTime();
	      }
	    }
	  }, {
	    key: '_setReadingTime',
	    value: function _setReadingTime() {
	      var _props = this.props,
	          _props$title = _props.title,
	          title = _props$title === undefined ? '' : _props$title,
	          _props$description = _props.description,
	          description = _props$description === undefined ? '' : _props$description,
	          delay = _props.delay;
	
	      var titleReadingTime = this._estimateReadingTime(title);
	      var descReadingTime = this._estimateReadingTime(description);
	      var totalEstimated = titleReadingTime + descReadingTime;
	      var readingTime = totalEstimated > delay ? totalEstimated : delay;
	      setTimeout(this._dismiss, readingTime);
	    }
	  }, {
	    key: '_estimateReadingTime',
	    value: function _estimateReadingTime(sentence) {
	      if (sentence) {
	        var wordsPerMinute = this.props.wordsPerMinute;
	        var totalWords = sentence.trim().split(/\s+/).length;
	        var readingTime = totalWords * 60 / wordsPerMinute;
	        var estimatedTime = Math.round(readingTime) * 1000;
	        return estimatedTime;
	      }
	      return this.props.delay;
	    }
	  }, {
	    key: '_dismiss',
	    value: function _dismiss() {
	      this.setState({ exiting: true });
	      if (this.props.onDismiss) {
	        this.props.onDismiss();
	      }
	    }
	  }, {
	    key: '_handleCheckboxChange',
	    value: function _handleCheckboxChange() {
	      var _this3 = this;
	
	      this.setState(function (state) {
	        return { checked: !state.checked };
	      }, function () {
	        if (_this3.props.onCheckboxChange) {
	          _this3.props.onCheckboxChange(_this3.state.checked);
	        }
	      });
	    }
	  }, {
	    key: '_customBorder',
	    value: function _customBorder() {
	      var _props2 = this.props,
	          borderColor = _props2.borderColor,
	          borderPosition = _props2.borderPosition;
	
	      if (borderColor) {
	        var borders = {
	          left: 'borderLeft',
	          right: 'borderRight',
	          top: 'borderTop',
	          bottom: 'borderBottom'
	        };
	        var border = borders[borderPosition];
	        return _defineProperty({}, border, '5px solid ' + borderColor);
	      }
	      return {};
	    }
	  }, {
	    key: '_customTextColor',
	    value: function _customTextColor() {
	      var color = this.props.titleColor;
	      if (color) {
	        return { color: color };
	      }
	      return {};
	    }
	  }, {
	    key: '_customBackground',
	    value: function _customBackground() {
	      var backgroundColor = this.props.backgroundColor;
	      if (backgroundColor) {
	        return { backgroundColor: backgroundColor };
	      }
	      return {};
	    }
	  }, {
	    key: '_customClosePosition',
	    value: function _customClosePosition() {
	      var verticalAlign = this.props.closeButtonPosition;
	      if (verticalAlign) {
	        return { verticalAlign: verticalAlign };
	      }
	      return {};
	    }
	  }, {
	    key: '_renderIcon',
	    value: function _renderIcon() {
	      var icons = { info: info, error: error, success: success };
	      var _props3 = this.props,
	          backgroundColor = _props3.backgroundColor,
	          imageUrl = _props3.imageUrl,
	          imgBtnFn = _props3.imgBtnFn,
	          imgCoverStyle = _props3.imgCoverStyle;
	
	      var toastIcon = imageUrl ? _react2.default.createElement('div', { className: 'vst-toast-cover-img ' + imgCoverStyle }, _react2.default.createElement('img', { src: imageUrl })) : icons[this.props.type]();
	      var verticallyCenteredIcon = void 0;
	      if (imgBtnFn) {
	        verticallyCenteredIcon = 'centered-icon';
	        toastIcon = _react2.default.createElement('div', { 'aria-hidden': 'true', className: 'vst-toast-button' }, _react2.default.createElement('button', { 'aria-hidden': 'true', id: 'toast-btn', onClick: imgBtnFn }, toastIcon));
	      }
	      return _react2.default.createElement('div', {
	        className: 'vst-toast-type vst-toast-type-' + this.props.type + ' ' + verticallyCenteredIcon,
	        style: backgroundColor && { backgroundColor: backgroundColor }
	      }, toastIcon);
	    }
	  }, {
	    key: '_renderDescription',
	    value: function _renderDescription() {
	      var style = {
	        maxWidth: this.props.maxWidth + 'px'
	      };
	      if (this.props.description || this.props.children) {
	        return _react2.default.createElement('div', { className: 'vst-toast-description', style: style }, this.props.description || this.props.children);
	      }
	      return null;
	    }
	  }, {
	    key: '_renderTitle',
	    value: function _renderTitle() {
	      var style = {
	        maxWidth: this.props.maxWidth + 'px',
	        color: this.props.titleColor || ''
	      };
	      return _react2.default.createElement('div', {
	        className: 'vst-toast-title vst-toast-title-' + this.props.type,
	        style: style
	      }, this.props.title);
	    }
	  }, {
	    key: '_renderCheckbox',
	    value: function _renderCheckbox() {
	      var _this4 = this;
	
	      if (this.props.checkboxText) {
	        return _react2.default.createElement('div', { className: 'vst-toast-checkbox' }, _react2.default.createElement(_VstInput2.default, {
	          id: Math.random().toString(),
	          type: 'checkbox',
	          name: 'checkbox',
	          label: this.props.checkboxText,
	          checked: this.state.checked,
	          onChange: function onChange() {
	            return _this4._handleCheckboxChange();
	          }
	        }));
	      }
	      return null;
	    }
	  }, {
	    key: '_renderCustomRightButton',
	    value: function _renderCustomRightButton() {
	      return _react2.default.createElement('div', { className: 'vst-toast-button', style: this._customClosePosition() }, _react2.default.createElement(_VstButton2.default, { onClick: this._dismiss }, this.props.rightButtonText));
	    }
	  }, {
	    key: '_renderRightButton',
	    value: function _renderRightButton() {
	      if (this.props.onDismiss && this.props.rightButtonText) {
	        return this._renderCustomRightButton();
	      }
	      if (this.props.dismissible) {
	        return _react2.default.createElement('div', { className: 'vst-toast-button', style: this._customClosePosition() }, _react2.default.createElement(_VstButton2.default, { onClick: this._dismiss }, this.props.rightButtonText || x()));
	      }
	      return null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var verticalPosition = {};
	      if (this.state.exiting) {
	        verticalPosition = { marginTop: '-' + document.getElementById('vst-toast-ref').offsetHeight + 'px' };
	      }
	      return _react2.default.createElement('div', {
	        className: 'vst-toast ' + (this.props.horizontalPosition || '') + ' ' + (this.props.multipleToast || '') + ' ' + (this.props.toastOpen ? 'slide-' + this.props.verticalPosition : 'slide') + '  ' + (this.state.exiting && 'exiting') + ' ' + (this.state.entering && 'entering'),
	        style: verticalPosition,
	        id: 'vst-toast-ref'
	      }, _react2.default.createElement('div', { className: 'vst-toast-container', style: this._customBorder() }, this._renderIcon(), _react2.default.createElement('div', { className: 'vst-toast-content' }, this._renderTitle(), this._renderDescription(), this._renderCheckbox()), this._renderRightButton()));
	    }
	  }]);
	
	  return VstToast;
	}(_VstComponent3.default);
	
	exports.default = VstToast;
	
	VstToast.propTypes = {
	  title: _propTypes2.default.string,
	  children: _propTypes2.default.node,
	  description: _propTypes2.default.string,
	  delay: _propTypes2.default.number,
	  fadeIn: _propTypes2.default.number,
	  fadeOut: _propTypes2.default.number,
	  maxWidth: _propTypes2.default.number,
	  wordsPerMinute: _propTypes2.default.number,
	  onDismiss: _propTypes2.default.func,
	  onCheckboxChange: _propTypes2.default.func,
	  rightButtonText: _propTypes2.default.string,
	  checkboxText: _propTypes2.default.string,
	  type: _propTypes2.default.oneOf(['info', 'success', 'error']),
	  titleColor: _propTypes2.default.string,
	  backgroundColor: _propTypes2.default.string,
	  borderColor: _propTypes2.default.string,
	  imageUrl: _propTypes2.default.string,
	  imgBtnFn: _propTypes2.default.func,
	  imgCoverStyle: _propTypes2.default.string,
	  borderPosition: _propTypes2.default.oneOf(['top', 'bottom', 'left', 'right']),
	  closeButtonPosition: _propTypes2.default.oneOf(['top', 'middle']),
	  multipleToast: _propTypes2.default.oneOf(['second', 'third'])
	};
	
	VstToast.defaultProps = {
	  dismissible: false,
	  delay: 5000,
	  fadeIn: 400,
	  fadeOut: 400,
	  maxWidth: 500,
	  wordsPerMinute: 120,
	  type: 'info',
	  imgBtnFn: null,
	  closeButtonPosition: 'top'
	};

/***/ },
/* 396 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// Product Colors
	// Cheddar
	var colors = {
	  CHEDDAR: ['', '#fef3e9', '#fedbbd', '#fec491', '#fead64', '#ff993f', '#f58525', '#eb710b', '#e06107', '#ca500f', '#b0430c'],
	  OCEAN: ['', '#eaf7fc', '#b0e3f4', '#75cfec', '#3bbbe3', '#00a7db', '#0093C4', '#007fad', '#006c94', '#005a75', '#00465c'],
	  MAGIC: ['', '#f2f4f9', '#D2D9ED', '#B2BEE0', '#91A3D4', '#7188C7', '#516DBB', '#425ba1', '#334a88', '#24386e', '#002244'],
	  SANGRIA: ['', '#fdf2f5', '#fbcada', '#f8a2bf', '#f57aa3', '#f35288', '#e53872', '#d81e5d', '#bf1b52', '#a61747', '#8c143c'],
	  JUNGLE: ['', '#e8f7f2', '#c0eadb', '#86e0c2', '#55d5a9', '#24c991', '#1fb380', '#1a9c6e', '#16825c', '#12694a', '#0d4f38'],
	  PICKLE: ['', '#f4f6ea', '#e0eab8', '#ccde87', '#b7d155', '#a3c523', '#91b215', '#7e9e06', '#698505', '#556b04', '#415203'],
	  BRICK: ['', '#FAE6E3', '#FAC3BB', '#FAA094', '#FA7D6D', '#F75F4B', '#EB4F3B', '#D24634', '#B83E2E', '#9E3528', '#852D21'],
	  MIST: ['', '#E6F4F7', '#C9E5EA', '#ACD5DD', '#8FC6CF', '#6EADBA', '#5F96A1', '#4F7E87', '#41666E', '#324E54', '#23373B'],
	  EGGPLANT: ['', '#F6F1F9', '#DDCBE9', '#C4A4D9', '#AB7EC9', '#9258B9', '#7A4C98', '#684182', '#543469', '#3F284F', '#2B1B36'],
	  CLOUD: ['', '#fafafa', '#f6f6f6', '#ececec', '#dadada', '#b3b3b3', '#949494', '#757575', '#646464', '#525252', '#3c3c3c'],
	  NINJA: ['', '#f1f1fa', '#e3e3f0', '#d5d5e2', '#cacad9', '#bbbbcc', '#9e9ead', '#7c7c89', '#595963', '#40404c', '#2f2f39', '#1b1b26'],
	  CHERRY: ['', '#f54250', '#cc313d'],
	  GRASS: ['', '#21a921', '#0a870a']
	};
	
	exports.default = colors;

/***/ },
/* 397 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
	  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	} : function (obj) {
	  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	};
	
	var _jsColors = __webpack_require__(396);
	
	var _jsColors2 = _interopRequireDefault(_jsColors);
	
	var _customEvent = __webpack_require__(233);
	
	var _customEvent2 = _interopRequireDefault(_customEvent);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	var VSTUI = { colors: _jsColors2.default };
	VSTUI.theme = {
	  primary: VSTUI.colors.OCEAN,
	  accent: VSTUI.colors.CHEDDAR,
	  primaryKey: 'OCEAN',
	  accentKey: 'CHEDDAR',
	  get: function get(index) {
	    return {
	      primary: VSTUI.theme.getPrimary(index),
	      accent: VSTUI.theme.getAccent(index)
	    };
	  },
	  getPrimary: function getPrimary(index) {
	    return VSTUI.theme.primary[index];
	  },
	  getAccent: function getAccent(index) {
	    return VSTUI.theme.accent[index];
	  }
	};
	
	VSTUI.changeTheme = function () {
	  var primary = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'OCEAN';
	  var accent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'CHEDDAR';
	  var customKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  if ((typeof primary === 'undefined' ? 'undefined' : _typeof(primary)) === 'object' && customKey) {
	    // this is a custom theme
	    if (primary.length === 11) {
	      VSTUI.theme.primary = primary;
	      VSTUI.theme.accent = accent && accent.length === 11 ? accent : primary;
	      VSTUI.theme.primaryKey = customKey + '_primary';
	      VSTUI.theme.accentKey = customKey + '_accent';
	    } else {
	      console.error('Invalid custom theme! Must be 11 elements in length.');
	    }
	  } else {
	    VSTUI.theme.primary = VSTUI.colors[primary];
	    VSTUI.theme.accent = VSTUI.colors[accent];
	    VSTUI.theme.primaryKey = primary;
	    VSTUI.theme.accentKey = accent;
	  }
	  var event = new _customEvent2.default('_vstui_change_theme', {});
	  document.dispatchEvent(event);
	};
	
	VSTUI.VSTUI = VSTUI;
	
	module.exports = VSTUI;

/***/ },
/* 398 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "arrow_left.9ff5f5be.svg";

/***/ },
/* 399 */
/***/ function(module, exports) {

	module.exports = "<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"20px\" height=\"20px\" viewBox=\"0 0 20 20\" style=\"enable-background:new 0 0 20 20;\" xml:space=\"preserve\"><style type=\"text/css\"> .st0{fill:#40404C;} </style><path class=\"st0\" d=\"M18,2.9C18,2.4,17.6,2,17.1,2L11,2l0,0l-8.7,8.7c-0.4,0.4-0.4,1,0,1.3l2.2,2.2l1.4,1.4L8,17.7 c0.4,0.4,1,0.4,1.3,0L18,9V2.9z M13.4,6.6c-0.6-0.6-0.6-1.7,0-2.3c0.6-0.6,1.7-0.6,2.3,0c0.6,0.6,0.6,1.7,0,2.3 C15.1,7.2,14.1,7.2,13.4,6.6z\"></path></svg>"

/***/ },
/* 400 */
/***/ function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ },
/* 401 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {module.exports = __webpack_amd_options__;
	
	/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ },
/* 402 */
/***/ function(module, exports, __webpack_require__) {

	if (typeof Promise === 'undefined') {
	  // Rejection tracking prevents a common issue where React gets into an
	  // inconsistent state due to an error, but it gets swallowed by a Promise,
	  // and the user has no idea what causes React's erratic future behavior.
	  __webpack_require__(818).enable();
	  window.Promise = __webpack_require__(817);
	}
	
	__webpack_require__(956);


/***/ },
/* 403 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _typeof = 'function' == typeof Symbol && 'symbol' == _typeof2(Symbol.iterator) ? function (obj) {
	  return typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
	} : function (obj) {
	  return obj && 'function' == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? 'symbol' : typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
	},
	    _extends = Object.assign || function (target) {
	  for (var source, i = 1; i < arguments.length; i++) {
	    for (var key in source = arguments[i], source) {
	      Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
	    }
	  }return target;
	},
	    _createClass = function () {
	  function defineProperties(target, props) {
	    for (var descriptor, i = 0; i < props.length; i++) {
	      descriptor = props[i], descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, 'value' in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    return protoProps && defineProperties(Constructor.prototype, protoProps), staticProps && defineProperties(Constructor, staticProps), Constructor;
	  };
	}(),
	    _templateObject = _taggedTemplateLiteral(['\n  /* Remove the margin in Firefox and Safari. */\n  margin: 0;\n\n  /* Show the overflow in IE. */\n  overflow: visible;\n\n  /* Remove the inheritance of text transform in Edge, Firefox, and IE. */\n  text-transform: none;\n\n  /* Remove the inner border and padding in Firefox. */\n  &::-moz-focus-inner {\n    border-style: none;\n    padding: 0;\n  }\n\n  /* Restore the focus styles unset by the previous rule. */\n  &:-moz-focusring {\n    outline: 1px dotted;\n  }\n\n  /* Change the cursor in all browsers. */\n  cursor: pointer;\n\n  /* Restore the default cursor to disabled elements unset by the previous rule. */\n  &:disabled {\n    cursor: default;\n  }\n\n  /* Remove gaps in links underline in iOS 8+ and Safari 8+. */\n  text-decoration-skip: objects;\n  text-decoration-skip-ink: none;\n'], ['\n  /* Remove the margin in Firefox and Safari. */\n  margin: 0;\n\n  /* Show the overflow in IE. */\n  overflow: visible;\n\n  /* Remove the inheritance of text transform in Edge, Firefox, and IE. */\n  text-transform: none;\n\n  /* Remove the inner border and padding in Firefox. */\n  &::-moz-focus-inner {\n    border-style: none;\n    padding: 0;\n  }\n\n  /* Restore the focus styles unset by the previous rule. */\n  &:-moz-focusring {\n    outline: 1px dotted;\n  }\n\n  /* Change the cursor in all browsers. */\n  cursor: pointer;\n\n  /* Restore the default cursor to disabled elements unset by the previous rule. */\n  &:disabled {\n    cursor: default;\n  }\n\n  /* Remove gaps in links underline in iOS 8+ and Safari 8+. */\n  text-decoration-skip: objects;\n  text-decoration-skip-ink: none;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n      /* top/bottom padding needs to be 0 so <button> and <a> render the same\n      (<button> has some padding by default) */\n      padding: 0 ', ';\n    '], ['\n      /* top/bottom padding needs to be 0 so <button> and <a> render the same\n      (<button> has some padding by default) */\n      padding: 0 ', ';\n    ']),
	    _templateObject3 = _taggedTemplateLiteral(['\n      max-width: ', ';\n      height: ', ';\n    '], ['\n      max-width: ', ';\n      height: ', ';\n    ']),
	    _templateObject4 = _taggedTemplateLiteral(['\n      margin-', ': ', ';\n    '], ['\n      margin-', ': ', ';\n    ']),
	    _templateObject5 = _taggedTemplateLiteral(['\n          fill: ', '; /* cloud 5 */\n        '], ['\n          fill: ', '; /* cloud 5 */\n        ']),
	    _templateObject6 = _taggedTemplateLiteral(['\n        display: inline;\n      '], ['\n        display: inline;\n      ']),
	    _templateObject7 = _taggedTemplateLiteral(['\n      display: inline-block;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n    '], ['\n      display: inline-block;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n    ']),
	    _react = __webpack_require__(3),
	    _react2 = _interopRequireDefault(_react),
	    _propTypes = __webpack_require__(6),
	    _propTypes2 = _interopRequireDefault(_propTypes),
	    _styledComponents = __webpack_require__(15),
	    _styledComponents2 = _interopRequireDefault(_styledComponents),
	    _themes = __webpack_require__(4),
	    _withCommonProps = __webpack_require__(38),
	    _withCommonProps2 = _interopRequireDefault(_withCommonProps),
	    _styles = __webpack_require__(31),
	    _propTypes3 = __webpack_require__(16),
	    _Tooltip = __webpack_require__(452),
	    _Tooltip2 = _interopRequireDefault(_Tooltip),
	    _componentTheme = __webpack_require__(404),
	    _componentTheme2 = _interopRequireDefault(_componentTheme),
	    _utils = __webpack_require__(59);Object.defineProperty(exports, '__esModule', { value: !0 });function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}function _objectWithoutProperties(obj, keys) {
	  var target = {};for (var i in obj) {
	    0 <= keys.indexOf(i) || Object.prototype.hasOwnProperty.call(obj, i) && (target[i] = obj[i]);
	  }return target;
	}function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
	}function _possibleConstructorReturn(self, call) {
	  if (!self) throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');return call && ('object' == (typeof call === 'undefined' ? 'undefined' : _typeof2(call)) || 'function' == typeof call) ? call : self;
	}function _inherits(subClass, superClass) {
	  if ('function' != typeof superClass && null !== superClass) throw new TypeError('Super expression must either be null or a function, not ' + (typeof superClass === 'undefined' ? 'undefined' : _typeof2(superClass)));subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: !1, writable: !0, configurable: !0 } }), superClass && (Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass);
	}function _taggedTemplateLiteral(strings, raw) {
	  return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } }));
	}var getVariant = function getVariant(color, naked, secondary) {
	  if ('neutral' === color) return naked ? 'neutralNaked' : 'neutral';return 'white' === color ? naked ? 'whiteNaked' : 'white' : secondary ? naked ? 'themeSecondaryNaked' : 'themeSecondary' : naked ? 'themePrimaryNaked' : 'themePrimary';
	},
	    getVariantStyle = function getVariantStyle(property, state) {
	  return function (props) {
	    var _props$sc = props.sc,
	        color = _props$sc.color,
	        naked = _props$sc.naked,
	        secondary = _props$sc.secondary,
	        variant = getVariant(color, naked, secondary),
	        token = 'Button_' + property + '_' + variant + (state ? '_' + state : '');return (0, _themes.getStyle)(token);
	  };
	},
	    getHeight = function getHeight() {
	  return function (props) {
	    var _props$sc2 = props.sc,
	        inline = _props$sc2.inline,
	        size = _props$sc2.size;if (inline) return 'auto';var _props$theme$vstui = props.theme.vstui,
	        rem = _props$theme$vstui.rem,
	        typography = _props$theme$vstui.typography,
	        minHeight = (0, _themes.getStyle)('Button_minHeight_' + size)(props),
	        height = Math.max(minHeight, 1.5 * typography.fontSize);return rem(height);
	  };
	},
	    normalizeStyles = (0, _styles.css)(_templateObject),
	    Styled = { div: {}, span: {} };Styled.Tooltip = (0, _styledComponents2.default)(_Tooltip2.default).withConfig({ displayName: 'Button__Tooltip' })(['display:inline-block;width:', ';'], function (_ref) {
	  var sc = _ref.sc;return sc.fullWidth && '100%';
	}), Styled.button = _styledComponents2.default.button.withConfig({ displayName: 'Button__button' })(['', ';', ';display:', ';box-sizing:border-box;align-items:center;width:', ';max-width:100%;height:', ';min-height:', ';', ';background-color:', ';border-width:', ';border-style:', ';border-color:', ';border-radius:', ';color:', ';font-family:', ';font-size:', ';font-weight:', ';text-decoration:', ';-webkit-font-smoothing:antialiased;transition-property:none;transition-duration:', ';transition-timing-function:', ';&:-moz-focusring{outline-color:', ';}&:focus{background-color:', ';border-color:', ';outline:none;box-shadow:', ';color:', ';}&:hover{background-color:', ';border-color:', ';color:', ';&:focus{border-color:', ';}}&:active{background-color:', ';border-color:', ';color:', ';}&:disabled{background-color:', ';border-color:', ';color:', ';font-weight:', ';text-decoration:none;}'], function (props) {
	  return props.sc.inheritStyles ? '' : _styles.resetInheritedStyles;
	}, normalizeStyles, function (_ref2) {
	  var sc = _ref2.sc;return sc.inline ? 'inline' : 'inline-flex';
	}, function (_ref3) {
	  var sc = _ref3.sc;return sc.fullWidth && '100%';
	}, getHeight(), getHeight(), function (_ref4) {
	  var sc = _ref4.sc,
	      fullWidth = sc.fullWidth,
	      iconEnd = sc.iconEnd,
	      iconStart = sc.iconStart,
	      inline = sc.inline,
	      size = sc.size;if (inline) return 0;var paddingHorizontal,
	      sizeCapitalized = size.replace(/^\w/, function (letter) {
	    return letter.toUpperCase();
	  });return paddingHorizontal = fullWidth ? (0, _themes.getStyle)('Button_paddingHorizontal_fullWidth') : iconStart || iconEnd ? (0, _themes.getStyle)('Button_paddingHorizontal_withIcon' + sizeCapitalized) : (0, _themes.getStyle)('Button_paddingHorizontal_' + size), (0, _styles.css)(_templateObject2, paddingHorizontal);
	}, getVariantStyle('backgroundColor'), (0, _themes.getStyle)('Button_borderWidth'), (0, _themes.getStyle)('Button_borderStyle'), getVariantStyle('borderColor'), (0, _themes.getStyle)('Button_borderRadius'), getVariantStyle('color'), (0, _themes.getStyle)('Button_fontFamily'), function (props) {
	  return props.sc.inline ? props.theme.vstui.rem((0, _themes.getStyle)('Button_fontSize_inline')(props)) : props.theme.vstui.rem((0, _themes.getStyle)('Button_fontSize_' + props.sc.size)(props));
	}, function (_ref5) {
	  var sc = _ref5.sc,
	      theme = _ref5.theme,
	      color = sc.color,
	      naked = sc.naked,
	      secondary = sc.secondary;return naked ? theme.vstui.Button_fontWeight_naked : 'neutral' === color ? theme.vstui.Button_fontWeight_neutral : 'white' === color ? theme.vstui.Button_fontWeight_white : secondary ? theme.vstui.Button_fontWeight_themeSecondary : theme.vstui.Button_fontWeight_themePrimary;
	}, function (props) {
	  return props.sc.inline ? (0, _themes.getStyle)('Button_textDecoration_inline') : (0, _themes.getStyle)('Button_textDecoration');
	}, (0, _themes.getStyle)('Button_transitionDuration'), function (_ref6) {
	  var theme = _ref6.theme;return theme.vstui.Button_transitionEasing;
	}, function (_ref7) {
	  var sc = _ref7.sc,
	      theme = _ref7.theme,
	      color = sc.color,
	      secondary = sc.secondary;return 'neutral' === color ? null : 'white' === color ? theme.vstui.Button_backgroundColor_white : secondary ? theme.vstui.Button_backgroundColor_themeSecondary_hover : theme.vstui.Button_backgroundColor_themePrimary_hover;
	}, getVariantStyle('backgroundColor', 'focus'), getVariantStyle('borderColor', 'focus'), getVariantStyle('boxShadow', 'focus'), getVariantStyle('color', 'focus'), getVariantStyle('backgroundColor', 'hover'), getVariantStyle('borderColor', 'hover'), getVariantStyle('color', 'hover'), getVariantStyle('borderColor', 'focus'), getVariantStyle('backgroundColor', 'active'), getVariantStyle('borderColor', 'active'), getVariantStyle('color', 'active'), getVariantStyle('backgroundColor', 'disabled'), getVariantStyle('borderColor', 'disabled'), getVariantStyle('color', 'disabled'), (0, _themes.getStyle)('Button_fontWeight_disabled')), Styled.button.displayName = 'Styled_button', Styled.a = Styled.button.withComponent('a'), Styled.a.displayName = 'Styled_a', Styled.div.buttonContent = _styledComponents2.default.div.withConfig({ displayName: 'Button__buttonContent' })(['display:', ';align-items:center;justify-content:', ';min-width:100%;'], function (_ref8) {
	  var sc = _ref8.sc;return sc.inline ? 'inline' : 'flex';
	}, function (_ref9) {
	  var theme = _ref9.theme;return theme.vstui.ButtonContent_justifyContent;
	}), Styled.div.iconWrapper = _styledComponents2.default.div.withConfig({ displayName: 'Button__iconWrapper' })(['display:flex;align-self:center;flex-shrink:0;', ';', ';svg{max-width:100%;max-height:100%;}', ':disabled & > svg{', ';}'], function (_ref10) {
	  var sc = _ref10.sc,
	      theme = _ref10.theme,
	      size = sc.size,
	      height = theme.vstui['size_' + size],
	      iconSize = 'auto';return 28 > height ? iconSize = '14px' : 32 > height && (iconSize = '16px'), (0, _styles.css)(_templateObject3, iconSize, iconSize);
	}, function (_ref11) {
	  var sc = _ref11.sc,
	      theme = _ref11.theme,
	      hasContent = sc.hasContent,
	      iconPosition = sc.iconPosition,
	      naked = sc.naked,
	      direction = theme.vstui.i18n.direction,
	      margin = '0';hasContent && (naked && (margin = '6px'), margin = '10px');var side = 'start' === iconPosition ? 'rtl' === direction ? 'left' : 'right' : 'rtl' === direction ? 'right' : 'left';return (0, _styles.css)(_templateObject4, side, margin);
	}, Styled.button, function (_ref12) {
	  var sc = _ref12.sc,
	      color = sc.color;return 'theme' === color || 'neutral' === color ? (0, _styles.css)(_templateObject5, (0, _themes.getStyle)('ButtonIcon_fill_disabled')) : null;
	}), Styled.div.labelText = _styledComponents2.default.div.withConfig({ displayName: 'Button__labelText' })(['', ';'], function (_ref13) {
	  var sc = _ref13.sc,
	      inline = sc.inline;return inline ? (0, _styles.css)(_templateObject6) : (0, _styles.css)(_templateObject7);
	}), Styled.div.labelText.displayName = 'Styled_div_label', Styled.span.hidden = _styledComponents2.default.span.withConfig({ displayName: 'Button__hidden' })(['', ';'], (0, _styles.visuallyHidden)());var Button = function (_Component) {
	  function Button() {
	    _classCallCheck(this, Button);var _this = _possibleConstructorReturn(this, (Button.__proto__ || Object.getPrototypeOf(Button)).call(this));return _this.tooltipId = (0, _utils.generateUniqueId)('tooltip'), _this;
	  }return _inherits(Button, _Component), _createClass(Button, [{ key: 'renderButton', value: function renderButton(_ref14) {
	      var inheritStyles = _ref14.inheritStyles,
	          theme = _ref14.theme,
	          tooltipId = _ref14.tooltipId,
	          _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          color = _props.color,
	          colorBehindButton = _props.colorBehindButton,
	          commonProps = _props.commonProps,
	          description = _props.description,
	          disabled = _props.disabled,
	          fullWidth = _props.fullWidth,
	          href = _props.href,
	          iconEndProp = _props.iconEnd,
	          iconStartProp = _props.iconStart,
	          inline = _props.inline,
	          inheritStylesIgnored = _props.inheritStyles,
	          label = _props.label,
	          labelledBy = _props.labelledBy,
	          nakedProp = _props.naked,
	          secondary = _props.secondary,
	          size = _props.size,
	          target = _props.target,
	          themeIgnored = _props.theme,
	          tooltipPlacementIgnored = _props.tooltipPlacement,
	          otherProps = _objectWithoutProperties(_props, ['children', 'className', 'color', 'colorBehindButton', 'commonProps', 'description', 'disabled', 'fullWidth', 'href', 'iconEnd', 'iconStart', 'inline', 'inheritStyles', 'label', 'labelledBy', 'naked', 'secondary', 'size', 'target', 'theme', 'tooltipPlacement']),
	          i18n = theme.vstui.i18n,
	          iconEnd = iconEndProp && _react2.default.cloneElement(iconEndProp, { className: iconEndProp.props.className }),
	          iconStart = iconStartProp && _react2.default.cloneElement(iconStartProp, { className: iconStartProp.props.className }),
	          hasContent = void 0 !== children && '' !== children,
	          ButtonComponent = href && !disabled ? Styled.a : Styled.button,
	          conditionalProps = {};description && (conditionalProps['aria-describedby'] = tooltipId), href && !disabled && target && (conditionalProps.rel = 'noopener'), tooltipId || (conditionalProps.className = className);var height = theme.vstui['size_' + size];return _react2.default.createElement(ButtonComponent, _extends({}, commonProps, otherProps, conditionalProps, { "aria-label": label, "aria-labelledby": labelledBy, disabled: disabled, href: href, sc: { color: color, colorBehindButton: colorBehindButton, fullWidth: fullWidth, height: height, iconEnd: iconEnd, iconStart: iconStart, inline: inline, inheritStyles: inheritStyles, naked: inline || nakedProp, secondary: secondary, size: size }, target: target, theme: theme }), _react2.default.createElement(Styled.div.buttonContent, { sc: { fullWidth: fullWidth, inline: inline }, theme: theme }, iconStart && _react2.default.createElement(Styled.div.iconWrapper, { sc: { color: color, hasContent: hasContent, iconPosition: 'start', size: size }, theme: theme }, iconStart), _react2.default.createElement(Styled.div.labelText, { sc: { inline: inline } }, children, '_blank' === target && _react2.default.createElement(Styled.span.hidden, null, i18n.t('button.newWindowWarning', { link: '' }))), iconEnd && _react2.default.createElement(Styled.div.iconWrapper, { sc: { color: color, height: height, hasContent: hasContent, iconPosition: 'end' }, theme: theme }, iconEnd)));
	    } }, { key: 'render', value: function render() {
	      var _props2 = this.props,
	          className = _props2.className,
	          description = _props2.description,
	          disabled = _props2.disabled,
	          fullWidth = _props2.fullWidth,
	          inheritStyles = _props2.inheritStyles,
	          label = _props2.label,
	          onBlur = _props2.onBlur,
	          onFocus = _props2.onFocus,
	          onMouseEnter = _props2.onMouseEnter,
	          onMouseLeave = _props2.onMouseLeave,
	          themeProp = _props2.theme,
	          tooltipPlacement = _props2.tooltipPlacement,
	          theme = (0, _componentTheme2.default)(themeProp);return !disabled && (description || label) ? _react2.default.createElement(Styled.Tooltip, { className: className, id: this.tooltipId, inheritStyles: inheritStyles, onBlur: onBlur, onFocus: onFocus, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, placement: tooltipPlacement, sc: { fullWidth: fullWidth }, theme: theme, title: description || label }, this.renderButton({ inheritStyles: !0, theme: theme, tooltipId: this.tooltipId })) : this.renderButton({ inheritStyles: inheritStyles, theme: theme });
	    } }]), Button;
	}(_react.Component);Button.propTypes = { children: _propTypes2.default.node, className: _propTypes2.default.string, color: _propTypes2.default.oneOf(['theme', 'neutral', 'white']), colorBehindButton: function colorBehindButton(props, propName, componentName) {
	    if ('white' === props.color && !props.naked && !props.inline) {
	      if (props[propName] === void 0) return new Error('Please add prop `' + propName + '` to `' + componentName + '`');if ('string' != typeof props[propName]) return new Error('Invalid prop `' + propName + '` of type `' + _typeof(props[propName]) + '` supplied to `' + componentName + '`, expected `string`.');
	    }
	  }, commonProps: _propTypes3.commonPropsShape, description: _propTypes2.default.string, disabled: _propTypes2.default.bool, fullWidth: _propTypes2.default.bool, href: _propTypes2.default.string, iconEnd: function iconEnd(props, propName, componentName) {
	    var iconEnd = props[propName];if (iconEnd && 'Icon' !== iconEnd.type.vstuiName) return new Error('Invalid prop `' + propName + '` of type `' + iconEnd.type.displayName + '` supplied to `' + componentName + '`, expected instance of `Icon`.');
	  }, iconStart: function iconStart(props, propName, componentName) {
	    var iconStart = props[propName];if (iconStart && 'Icon' !== iconStart.type.vstuiName) return new Error('Invalid prop `' + propName + '` of type `' + iconStart.type.displayName + '` supplied to `' + componentName + '`, expected instance of `Icon`.');
	  }, inheritStyles: _propTypes2.default.bool, inline: _propTypes2.default.bool, label: function label(props, propName, componentName) {
	    if ((props.children === void 0 || '' === props.children) && props['aria-hidden'] === void 0) {
	      if (props[propName] === void 0) return new Error('Please add either prop `' + propName + '` or prop `children` to `' + componentName + '`.');if ('string' != typeof props[propName]) return new Error('Invalid prop `' + propName + '` of type `' + _typeof(props[propName]) + '` supplied to `' + componentName + '`, expected `string`.');
	    }
	  }, labelledBy: _propTypes2.default.string, naked: _propTypes2.default.bool, onBlur: _propTypes2.default.func, onFocus: _propTypes2.default.func, onMouseEnter: _propTypes2.default.func, onMouseLeave: _propTypes2.default.func, secondary: _propTypes2.default.bool, size: _propTypes2.default.oneOf(['small', 'medium', 'large']), target: _propTypes2.default.string, theme: _propTypes3.themeShape, tooltipPlacement: _propTypes2.default.oneOf(['auto', 'top', 'right', 'bottom', 'left', 'auto-start', 'top-start', 'right-start', 'bottom-start', 'left-start', 'auto-end', 'top-end', 'right-end', 'bottom-end', 'left-end']) }, Button.defaultProps = { color: 'theme', size: 'medium', tooltipPlacement: 'top', theme: (0, _themes.createTheme)() }, Button.displayName = 'Button';var ButtonWithTheme = (0, _withCommonProps2.default)(Button);ButtonWithTheme.WrappedComponent = Button, exports.default = ButtonWithTheme;

/***/ },
/* 404 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	Object.defineProperty(exports, '__esModule', { value: !0 });var _themes = __webpack_require__(4),
	    componentTheme = function componentTheme(baseTheme) {
	  var _Mathround = Math.round,
	      _baseTheme$vstui = baseTheme.vstui,
	      color = _baseTheme$vstui.color,
	      rem = _baseTheme$vstui.rem,
	      shape = _baseTheme$vstui.shape,
	      size = _baseTheme$vstui.size,
	      transition = _baseTheme$vstui.transition,
	      typography = _baseTheme$vstui.typography,
	      primaryMain = function primaryMain(_ref) {
	    var sc = _ref.sc;return color.primary.getMainShade({ backgroundColor: sc.colorBehindButton });
	  },
	      primaryDarker = function primaryDarker(_ref2) {
	    var sc = _ref2.sc;return color.primary.getMainShade({ backgroundColor: sc.colorBehindButton, offset: 1 });
	  },
	      primaryDarkest = function primaryDarkest(_ref3) {
	    var sc = _ref3.sc;return color.primary.getMainShade({ backgroundColor: sc.colorBehindButton, offset: 2 });
	  },
	      secondaryMain = function secondaryMain(_ref4) {
	    var sc = _ref4.sc;return color.secondary.getMainShade({ backgroundColor: sc.colorBehindButton });
	  },
	      secondaryDarker = function secondaryDarker(_ref5) {
	    var sc = _ref5.sc;return color.secondary.getMainShade({ backgroundColor: sc.colorBehindButton, offset: 1 });
	  },
	      secondaryDarkest = function secondaryDarkest(_ref6) {
	    var sc = _ref6.sc;return color.secondary.getMainShade({ backgroundColor: sc.colorBehindButton, offset: 2 });
	  },
	      cloud3 = color.cloud.getShade(3),
	      cloud4 = color.cloud.getShade(4),
	      ninja9 = color.ninja.getShade(9),
	      black43 = 'rgba(0, 0, 0, 0.43)',
	      backgroundColor_disabled = color.transparent,
	      backgroundColor_naked = color.transparent,
	      borderColor_disabled = 'rgba(0, 0, 0, 0.20)',
	      borderColor_naked = color.transparent,
	      color_disabled = color.black,
	      white80 = 'rgba(255, 255, 255, 0.8)';return (0, _themes.createComponentTheme)(baseTheme, { Button_backgroundColor_themePrimary: primaryMain, Button_backgroundColor_themePrimary_disabled: backgroundColor_disabled, Button_backgroundColor_themePrimary_active: primaryDarker, Button_backgroundColor_themePrimary_focus: primaryDarker, Button_backgroundColor_themePrimary_hover: primaryDarker, Button_backgroundColor_themePrimaryNaked: backgroundColor_naked, Button_backgroundColor_themePrimaryNaked_disabled: backgroundColor_naked, Button_backgroundColor_themePrimaryNaked_active: backgroundColor_naked, Button_backgroundColor_themePrimaryNaked_focus: backgroundColor_naked, Button_backgroundColor_themePrimaryNaked_hover: backgroundColor_naked, Button_backgroundColor_themeSecondary: secondaryMain, Button_backgroundColor_themeSecondary_disabled: backgroundColor_disabled, Button_backgroundColor_themeSecondary_active: secondaryDarker, Button_backgroundColor_themeSecondary_focus: secondaryDarker, Button_backgroundColor_themeSecondary_hover: secondaryDarker, Button_backgroundColor_themeSecondaryNaked: backgroundColor_naked, Button_backgroundColor_themeSecondaryNaked_disabled: backgroundColor_naked, Button_backgroundColor_themeSecondaryNaked_active: backgroundColor_naked, Button_backgroundColor_themeSecondaryNaked_focus: backgroundColor_naked, Button_backgroundColor_themeSecondaryNaked_hover: backgroundColor_naked, Button_backgroundColor_neutral: cloud3, Button_backgroundColor_neutral_disabled: backgroundColor_disabled, Button_backgroundColor_neutral_active: cloud4, Button_backgroundColor_neutral_focus: cloud4, Button_backgroundColor_neutral_hover: cloud4, Button_backgroundColor_neutralNaked: backgroundColor_naked, Button_backgroundColor_neutralNaked_disabled: backgroundColor_naked, Button_backgroundColor_neutralNaked_active: backgroundColor_naked, Button_backgroundColor_neutralNaked_focus: backgroundColor_naked, Button_backgroundColor_neutralNaked_hover: backgroundColor_naked, Button_backgroundColor_white: color.surface, Button_backgroundColor_white_disabled: backgroundColor_disabled, Button_backgroundColor_white_active: white80, Button_backgroundColor_white_focus: white80, Button_backgroundColor_white_hover: white80, Button_backgroundColor_whiteNaked: backgroundColor_naked, Button_backgroundColor_whiteNaked_disabled: backgroundColor_naked, Button_backgroundColor_whiteNaked_active: backgroundColor_naked, Button_backgroundColor_whiteNaked_focus: backgroundColor_naked, Button_backgroundColor_whiteNaked_hover: backgroundColor_naked, Button_borderColor_themePrimary: primaryMain, Button_borderColor_themePrimary_disabled: borderColor_disabled, Button_borderColor_themePrimary_active: primaryDarker, Button_borderColor_themePrimary_focus: primaryDarker, Button_borderColor_themePrimary_hover: primaryDarker, Button_borderColor_themePrimaryNaked: borderColor_naked, Button_borderColor_themePrimaryNaked_disabled: borderColor_naked, Button_borderColor_themePrimaryNaked_active: borderColor_naked, Button_borderColor_themePrimaryNaked_focus: borderColor_naked, Button_borderColor_themePrimaryNaked_hover: borderColor_naked, Button_borderColor_themeSecondary: secondaryMain, Button_borderColor_themeSecondary_disabled: borderColor_disabled, Button_borderColor_themeSecondary_active: secondaryDarker, Button_borderColor_themeSecondary_focus: secondaryDarker, Button_borderColor_themeSecondary_hover: secondaryDarker, Button_borderColor_themeSecondaryNaked: borderColor_naked, Button_borderColor_themeSecondaryNaked_disabled: borderColor_naked, Button_borderColor_themeSecondaryNaked_active: borderColor_naked, Button_borderColor_themeSecondaryNaked_focus: borderColor_naked, Button_borderColor_themeSecondaryNaked_hover: borderColor_naked, Button_borderColor_neutral: black43, Button_borderColor_neutral_disabled: borderColor_disabled, Button_borderColor_neutral_active: black43, Button_borderColor_neutral_focus: black43, Button_borderColor_neutral_hover: black43, Button_borderColor_neutralNaked: borderColor_naked, Button_borderColor_neutralNaked_disabled: borderColor_naked, Button_borderColor_neutralNaked_active: borderColor_naked, Button_borderColor_neutralNaked_focus: borderColor_naked, Button_borderColor_neutralNaked_hover: borderColor_naked, Button_borderColor_white: color.surface, Button_borderColor_white_disabled: color.surface, Button_borderColor_white_active: white80, Button_borderColor_white_focus: white80, Button_borderColor_white_hover: white80, Button_borderColor_whiteNaked: borderColor_naked, Button_borderColor_whiteNaked_disabled: borderColor_naked, Button_borderColor_whiteNaked_active: borderColor_naked, Button_borderColor_whiteNaked_focus: borderColor_naked, Button_borderColor_whiteNaked_hover: borderColor_naked, Button_borderRadius: shape.borderRadius, Button_borderStyle: shape.borderStyle, Button_borderWidth: shape.borderWidth, Button_boxShadow_themePrimary_focus: function Button_boxShadow_themePrimary_focus(props) {
	      return '0 0 0 2px ' + color.onPrimary + ', 0 0 0 4px ' + primaryDarker(props);
	    }, Button_boxShadow_themePrimaryNaked_focus: function Button_boxShadow_themePrimaryNaked_focus(props) {
	      return '0 0 0 2px ' + primaryDarker(props);
	    }, Button_boxShadow_themeSecondary_focus: function Button_boxShadow_themeSecondary_focus(props) {
	      return '0 0 0 2px ' + color.onSecondary + ', 0 0 0 4px ' + secondaryDarker(props);
	    }, Button_boxShadow_themeSecondaryNaked_focus: function Button_boxShadow_themeSecondaryNaked_focus(props) {
	      return '0 0 0 2px ' + secondaryDarker(props);
	    }, Button_boxShadow_neutral_focus: '0 0 0 2px ' + color.surface + ', 0 0 0 4px ' + black43, Button_boxShadow_neutralNaked_focus: '0 0 0 2px ' + black43, Button_boxShadow_white_focus: function Button_boxShadow_white_focus(_ref7) {
	      var sc = _ref7.sc;return '0 0 0 2px ' + (sc.colorBehindButton || color.black) + ', 0 0 0 4px ' + white80;
	    }, Button_boxShadow_whiteNaked_focus: '0 0 0 2px ' + white80, Button_fontFamily: typography.fontFamily, Button_fontSize_small: typography.fontSize - 2, Button_fontSize_medium: typography.fontSize, Button_fontSize_large: typography.fontSize + 4, Button_fontSize_inline: 'inherit', Button_fontWeight_themePrimary: typography.fontWeightMedium, Button_fontWeight_themeSecondary: typography.fontWeightMedium, Button_fontWeight_neutral: typography.fontWeightRegular, Button_fontWeight_white: typography.fontWeightMedium, Button_fontWeight_naked: typography.fontWeightMedium, Button_fontWeight_disabled: typography.fontWeightLight, Button_minHeight_small: size.small, Button_minHeight_medium: size.medium, Button_minHeight_large: size.large, Button_textDecoration: 'none', Button_textDecoration_inline: 'underline', Button_color_themePrimary: color.onPrimary, Button_color_themePrimary_disabled: color_disabled, Button_color_themePrimary_active: color.onPrimary, Button_color_themePrimary_focus: color.onPrimary, Button_color_themePrimary_hover: color.onPrimary, Button_color_themePrimaryNaked: primaryDarker, Button_color_themePrimaryNaked_disabled: color_disabled, Button_color_themePrimaryNaked_active: primaryDarkest, Button_color_themePrimaryNaked_focus: primaryDarkest, Button_color_themePrimaryNaked_hover: primaryDarkest, Button_color_themeSecondary: color.onSecondary, Button_color_themeSecondary_disabled: color_disabled, Button_color_themeSecondary_active: color.onSecondary, Button_color_themeSecondary_focus: color.onSecondary, Button_color_themeSecondary_hover: color.onSecondary, Button_color_themeSecondaryNaked: secondaryDarker, Button_color_themeSecondaryNaked_disabled: color_disabled, Button_color_themeSecondaryNaked_active: secondaryDarkest, Button_color_themeSecondaryNaked_focus: secondaryDarkest, Button_color_themeSecondaryNaked_hover: secondaryDarkest, Button_color_neutral: color.black, Button_color_neutral_disabled: color_disabled, Button_color_neutral_active: color.black, Button_color_neutral_focus: color.black, Button_color_neutral_hover: color.black, Button_color_neutralNaked: color.black, Button_color_neutralNaked_disabled: color_disabled, Button_color_neutralNaked_active: ninja9, Button_color_neutralNaked_focus: ninja9, Button_color_neutralNaked_hover: ninja9, Button_color_white: function Button_color_white(_ref8) {
	      var sc = _ref8.sc;return sc.colorBehindButton || color.black;
	    }, Button_color_white_disabled: color.surface, Button_color_white_active: function Button_color_white_active(_ref9) {
	      var sc = _ref9.sc;return sc.colorBehindButton || color.black;
	    }, Button_color_white_focus: function Button_color_white_focus(_ref10) {
	      var sc = _ref10.sc;return sc.colorBehindButton || color.black;
	    }, Button_color_white_hover: function Button_color_white_hover(_ref11) {
	      var sc = _ref11.sc;return sc.colorBehindButton || color.black;
	    }, Button_color_whiteNaked: color.surface, Button_color_whiteNaked_disabled: color.surface, Button_color_whiteNaked_active: white80, Button_color_whiteNaked_focus: white80, Button_color_whiteNaked_hover: white80, Button_paddingHorizontal_small: _Mathround(size.small * (2 / 3)) + 'px', Button_paddingHorizontal_medium: _Mathround(size.medium * (2 / 3)) + 'px', Button_paddingHorizontal_large: _Mathround(size.large * (2 / 3)) + 'px', Button_paddingHorizontal_fullWidth: '' + rem(typography.fontSize - 2), Button_paddingHorizontal_withIconSmall: '' + rem(typography.fontSize - 2), Button_paddingHorizontal_withIconMedium: '' + rem(typography.fontSize), Button_paddingHorizontal_withIconLarge: '' + rem(typography.fontSize), Button_transitionDuration: transition.duration.shortest, Button_transitionEasing: transition.easing.easeIn, ButtonContent_justifyContent: 'center', ButtonIcon_fill_disabled: 'rgba(0, 0, 0, 0.3)' });
	};exports.default = componentTheme;

/***/ },
/* 405 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) {
	  for (var source, i = 1; i < arguments.length; i++) {
	    for (var key in source = arguments[i], source) {
	      Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
	    }
	  }return target;
	},
	    _createClass = function () {
	  function defineProperties(target, props) {
	    for (var descriptor, i = 0; i < props.length; i++) {
	      descriptor = props[i], descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, 'value' in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    return protoProps && defineProperties(Constructor.prototype, protoProps), staticProps && defineProperties(Constructor, staticProps), Constructor;
	  };
	}(),
	    _react = __webpack_require__(3),
	    _react2 = _interopRequireDefault(_react),
	    _propTypes = __webpack_require__(6),
	    _propTypes2 = _interopRequireDefault(_propTypes),
	    _styledComponents = __webpack_require__(15),
	    _styledComponents2 = _interopRequireDefault(_styledComponents),
	    _themes = __webpack_require__(4),
	    _propTypes3 = __webpack_require__(16),
	    _componentTheme = __webpack_require__(406),
	    _componentTheme2 = _interopRequireDefault(_componentTheme);Object.defineProperty(exports, '__esModule', { value: !0 });function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}function _objectWithoutProperties(obj, keys) {
	  var target = {};for (var i in obj) {
	    0 <= keys.indexOf(i) || Object.prototype.hasOwnProperty.call(obj, i) && (target[i] = obj[i]);
	  }return target;
	}function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
	}function _possibleConstructorReturn(self, call) {
	  if (!self) throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');return call && ('object' == (typeof call === 'undefined' ? 'undefined' : _typeof(call)) || 'function' == typeof call) ? call : self;
	}function _inherits(subClass, superClass) {
	  if ('function' != typeof superClass && null !== superClass) throw new TypeError('Super expression must either be null or a function, not ' + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: !1, writable: !0, configurable: !0 } }), superClass && (Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass);
	}var Styled = { div: {} };Styled.div.root = _styledComponents2.default.div.withConfig({ displayName: 'Card__root' })(['display:inline-block;padding:', ';overflow:hidden;background-color:', ';border-color:', ';border-width:', ';border-style:', ';border-radius:', ';box-shadow:', ';transition-property:none;transition-duration:', ';transition-timing-function:', ';&:hover{box-shadow:', ';}@media print{border:1px solid black;box-shadow:none;}'], (0, _themes.getStyle)('Card_padding'), (0, _themes.getStyle)('Card_backgroundColor'), (0, _themes.getStyle)('Card_borderColor'), (0, _themes.getStyle)('Card_borderWidth'), function (_ref) {
	  var sc = _ref.sc;return sc.raised ? (0, _themes.getStyle)('Card_borderStyle_raised') : (0, _themes.getStyle)('Card_borderStyle');
	}, (0, _themes.getStyle)('Card_borderRadius'), function (_ref2) {
	  var sc = _ref2.sc;return sc.raised ? (0, _themes.getStyle)('Card_boxShadow_raised') : (0, _themes.getStyle)('Card_boxShadow');
	}, function (props) {
	  return props.theme.vstui.transition.duration.shortest;
	}, function (props) {
	  return props.theme.vstui.transition.easing.easeIn;
	}, function (_ref3) {
	  var sc = _ref3.sc;return sc.raised && sc.interactive ? (0, _themes.getStyle)('Card_boxShadow_raisedInteractive_hover') : sc.raised ? (0, _themes.getStyle)('Card_boxShadow_raised_hover') : (0, _themes.getStyle)('Card_boxShadow_hover');
	});var Card = function (_PureComponent) {
	  function Card() {
	    return _classCallCheck(this, Card), _possibleConstructorReturn(this, (Card.__proto__ || Object.getPrototypeOf(Card)).apply(this, arguments));
	  }return _inherits(Card, _PureComponent), _createClass(Card, [{ key: 'render', value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          interactive = _props.interactive,
	          raised = _props.raised,
	          themeProp = _props.theme,
	          otherProps = _objectWithoutProperties(_props, ['className', 'interactive', 'raised', 'theme']),
	          theme = (0, _componentTheme2.default)(themeProp);return _react2.default.createElement(Styled.div.root, _extends({}, otherProps, { className: className, sc: { interactive: interactive, raised: raised }, theme: theme }));
	    } }]), Card;
	}(_react.PureComponent);Card.propTypes = { children: _propTypes2.default.node.isRequired, className: _propTypes2.default.string, interactive: _propTypes2.default.bool, raised: _propTypes2.default.bool, theme: _propTypes3.themeShape }, Card.defaultProps = { theme: (0, _themes.createTheme)() }, Card.displayName = 'Card';var CardWithTheme = (0, _themes.withTheme)(Card);CardWithTheme.WrappedComponent = Card, exports.default = CardWithTheme;

/***/ },
/* 406 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	Object.defineProperty(exports, '__esModule', { value: !0 });var _themes = __webpack_require__(4),
	    componentTheme = function componentTheme(baseTheme) {
	  var _baseTheme$vstui = baseTheme.vstui,
	      color = _baseTheme$vstui.color,
	      shape = _baseTheme$vstui.shape,
	      shadow = _baseTheme$vstui.shadow,
	      cloud3 = color.cloud.getShade(3);return (0, _themes.createComponentTheme)(baseTheme, { Card_padding: 0, Card_backgroundColor: color.surface, Card_borderColor: cloud3, Card_borderRadius: shape.borderRadius, Card_borderStyle: shape.borderStyle, Card_borderStyle_raised: 'none', Card_borderWidth: shape.borderWidth, Card_boxShadow: 'none', Card_boxShadow_hover: 'none', Card_boxShadow_raised: shadow.low, Card_boxShadow_raised_hover: shadow.low, Card_boxShadow_raisedInteractive_hover: shadow.high });
	};exports.default = componentTheme;

/***/ },
/* 407 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _typeof = 'function' == typeof Symbol && 'symbol' == _typeof2(Symbol.iterator) ? function (obj) {
	  return typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
	} : function (obj) {
	  return obj && 'function' == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? 'symbol' : typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
	},
	    _extends = Object.assign || function (target) {
	  for (var source, i = 1; i < arguments.length; i++) {
	    for (var key in source = arguments[i], source) {
	      Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
	    }
	  }return target;
	},
	    _createClass = function () {
	  function defineProperties(target, props) {
	    for (var descriptor, i = 0; i < props.length; i++) {
	      descriptor = props[i], descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, 'value' in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    return protoProps && defineProperties(Constructor.prototype, protoProps), staticProps && defineProperties(Constructor, staticProps), Constructor;
	  };
	}(),
	    _react = __webpack_require__(3),
	    _react2 = _interopRequireDefault(_react),
	    _propTypes = __webpack_require__(6),
	    _propTypes2 = _interopRequireDefault(_propTypes),
	    _FormGroup = __webpack_require__(129),
	    _FormGroup2 = _interopRequireDefault(_FormGroup),
	    _CheckboxControl = __webpack_require__(411),
	    _CheckboxControl2 = _interopRequireDefault(_CheckboxControl),
	    _themes = __webpack_require__(4),
	    _propTypes3 = __webpack_require__(16),
	    _utils = __webpack_require__(59);Object.defineProperty(exports, '__esModule', { value: !0 });function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}function _objectWithoutProperties(obj, keys) {
	  var target = {};for (var i in obj) {
	    0 <= keys.indexOf(i) || Object.prototype.hasOwnProperty.call(obj, i) && (target[i] = obj[i]);
	  }return target;
	}function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
	}function _possibleConstructorReturn(self, call) {
	  if (!self) throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');return call && ('object' == (typeof call === 'undefined' ? 'undefined' : _typeof2(call)) || 'function' == typeof call) ? call : self;
	}function _inherits(subClass, superClass) {
	  if ('function' != typeof superClass && null !== superClass) throw new TypeError('Super expression must either be null or a function, not ' + (typeof superClass === 'undefined' ? 'undefined' : _typeof2(superClass)));subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: !1, writable: !0, configurable: !0 } }), superClass && (Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass);
	}var Checkbox = function (_Component) {
	  function Checkbox(props) {
	    _classCallCheck(this, Checkbox);var _this = _possibleConstructorReturn(this, (Checkbox.__proto__ || Object.getPrototypeOf(Checkbox)).call(this, props));return _this.generatedId = (0, _utils.generateUniqueId)('checkbox'), _this.state = { id: props.id || _this.generatedId, validationMessage: '' }, _this.handleFormControlRef = _this.handleFormControlRef.bind(_this), _this.handleNativeFormControlRef = _this.handleNativeFormControlRef.bind(_this), _this.handleValidate = _this.handleValidate.bind(_this), _this;
	  }return _inherits(Checkbox, _Component), _createClass(Checkbox, [{ key: 'componentWillReceiveProps', value: function componentWillReceiveProps(nextProps) {
	      var id = nextProps.id || this.generatedId;id !== this.state.id && this.setState({ id: id });
	    } }, { key: 'focus', value: function focus() {
	      this.nativeFormControl && this.nativeFormControl.focus();
	    } }, { key: 'validate', value: function validate(callback) {
	      this.formControl && this.formControl.validate(callback);
	    } }, { key: 'handleFormControlRef', value: function handleFormControlRef(node) {
	      this.formControl = node;
	    } }, { key: 'handleNativeFormControlRef', value: function handleNativeFormControlRef(node) {
	      var nativeFormControlRef = this.props.nativeFormControlRef;this.nativeFormControl = node, nativeFormControlRef && nativeFormControlRef(node);
	    } }, { key: 'handleValidate', value: function handleValidate(valid, validationMessage) {
	      this.setState({ validationMessage: validationMessage });
	    } }, { key: 'render', value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          dir = _props.dir,
	          disabled = _props.disabled,
	          fullWidth = _props.fullWidth,
	          helperText = _props.helperText,
	          idIgnored = _props.id,
	          inheritStyles = _props.inheritStyles,
	          label = _props.label,
	          labelHidden = _props.labelHidden,
	          lang = _props.lang,
	          rootProps = _props.rootProps,
	          secondary = _props.secondary,
	          size = _props.size,
	          theme = _props.theme,
	          otherProps = _objectWithoutProperties(_props, ['className', 'dir', 'disabled', 'fullWidth', 'helperText', 'id', 'inheritStyles', 'label', 'labelHidden', 'lang', 'rootProps', 'secondary', 'size', 'theme']),
	          _state = this.state,
	          id = _state.id,
	          validationMessage = _state.validationMessage;return _react2.default.createElement(_FormGroup2.default, { checkboxControl: _react2.default.createElement(_CheckboxControl2.default, _extends({}, otherProps, { labelHidden: labelHidden, nativeFormControlRef: this.handleNativeFormControlRef, onRef: this.handleFormControlRef, onValidate: this.handleValidate, theme: theme })), className: className, dir: dir, disabled: disabled, fullWidth: fullWidth, helperText: helperText, id: id, inheritStyles: inheritStyles, label: label, labelHidden: labelHidden, lang: lang, rootProps: rootProps, secondary: secondary, size: size, theme: theme, validationMessage: validationMessage });
	    } }]), Checkbox;
	}(_react.Component);Checkbox.propTypes = { checked: _propTypes2.default.bool, className: _propTypes2.default.string, defaultChecked: function defaultChecked(props, propName, componentName) {
	    if (props[propName] !== void 0) {
	      if (props.checked !== void 0) throw new Error('Props `defaultChecked` and `checked` are both defined in `' + componentName + '`, but only one is allowed. Use `defaultChecked` for an uncontrolled component, or `checked` for a controlled component.');if ('boolean' != typeof props[propName] && null !== props[propName]) return new Error('Invalid prop `' + propName + '` of type `' + _typeof(props[propName]) + '` supplied to `' + componentName + '`, expected `boolean`, or a value of `null`.');
	    }
	  }, dir: _propTypes2.default.oneOf(['ltr', 'rtl', 'auto']), disabled: _propTypes2.default.bool, fullWidth: _propTypes2.default.bool, helperText: _propTypes2.default.string, id: _propTypes2.default.string, inheritStyles: _propTypes2.default.bool, label: _propTypes2.default.node.isRequired, labelHidden: _propTypes2.default.bool, lang: _propTypes2.default.string, nativeFormControlRef: _propTypes2.default.func, onBlur: _propTypes2.default.func, onChange: _propTypes2.default.func, onFocus: _propTypes2.default.func, required: _propTypes2.default.bool, rootProps: _propTypes2.default.object, secondary: _propTypes2.default.bool, size: _propTypes2.default.oneOf(['small', 'medium', 'large']), theme: _propTypes3.themeShape, validate: _propTypes2.default.func }, Checkbox.defaultProps = { size: 'medium', theme: (0, _themes.createTheme)() }, Checkbox.displayName = 'Checkbox';var CheckboxWithTheme = (0, _themes.withTheme)(Checkbox);CheckboxWithTheme.WrappedComponent = Checkbox, exports.default = CheckboxWithTheme;

/***/ },
/* 408 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	Object.defineProperty(exports, '__esModule', { value: !0 });var _Checkbox = __webpack_require__(407);Object.defineProperty(exports, 'default', { enumerable: !0, get: function get() {
	    return _interopRequireDefault(_Checkbox).default;
	  } });function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}

/***/ },
/* 409 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) {
	  for (var source, i = 1; i < arguments.length; i++) {
	    for (var key in source = arguments[i], source) {
	      Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
	    }
	  }return target;
	},
	    _createClass = function () {
	  function defineProperties(target, props) {
	    for (var descriptor, i = 0; i < props.length; i++) {
	      descriptor = props[i], descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, 'value' in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    return protoProps && defineProperties(Constructor.prototype, protoProps), staticProps && defineProperties(Constructor, staticProps), Constructor;
	  };
	}(),
	    _react = __webpack_require__(3),
	    _react2 = _interopRequireDefault(_react),
	    _propTypes = __webpack_require__(6),
	    _propTypes2 = _interopRequireDefault(_propTypes),
	    _styledComponents = __webpack_require__(15),
	    _styledComponents2 = _interopRequireDefault(_styledComponents),
	    _classnames = __webpack_require__(25),
	    _classnames2 = _interopRequireDefault(_classnames),
	    _styles = __webpack_require__(31),
	    _propTypes3 = __webpack_require__(16),
	    _withCommonProps = __webpack_require__(38),
	    _withCommonProps2 = _interopRequireDefault(_withCommonProps),
	    _themes = __webpack_require__(4),
	    _Label = __webpack_require__(185),
	    _Label2 = _interopRequireDefault(_Label),
	    _CheckboxIcon = __webpack_require__(410),
	    _CheckboxIcon2 = _interopRequireDefault(_CheckboxIcon),
	    _FormControl = __webpack_require__(100),
	    _FormControl2 = _interopRequireDefault(_FormControl),
	    _componentTheme = __webpack_require__(184),
	    _componentTheme2 = _interopRequireDefault(_componentTheme);Object.defineProperty(exports, '__esModule', { value: !0 });function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}function _objectWithoutProperties(obj, keys) {
	  var target = {};for (var i in obj) {
	    0 <= keys.indexOf(i) || Object.prototype.hasOwnProperty.call(obj, i) && (target[i] = obj[i]);
	  }return target;
	}function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
	}function _possibleConstructorReturn(self, call) {
	  if (!self) throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');return call && ('object' == (typeof call === 'undefined' ? 'undefined' : _typeof(call)) || 'function' == typeof call) ? call : self;
	}function _inherits(subClass, superClass) {
	  if ('function' != typeof superClass && null !== superClass) throw new TypeError('Super expression must either be null or a function, not ' + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: !1, writable: !0, configurable: !0 } }), superClass && (Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass);
	}var lineHeight = 1.4,
	    Styled = {};Styled.div = {}, Styled.div.root = _styledComponents2.default.div.withConfig({ displayName: 'CheckboxControl__root' })(['', ';display:inline-flex;box-sizing:border-box;align-items:center;width:', ';max-width:100%;vertical-align:top;&.required{display:flex;min-height:', ';padding:', ';background-color:', ';background-image:', ';background-position:', ';background-repeat:no-repeat;background-size:', ';border-color:', ';border-style:', ';border-width:', ';border-radius:', ';}&.invalid{background-image:', ';}'], function (props) {
	  return props.sc.inheritStyles ? '' : (0, _styles.resetInheritedStyles)({ direction: props.dir });
	}, function (props) {
	  return props.sc.fullWidth ? '100%' : (0, _themes.getStyle)('CheckboxControl_width');
	}, function (props) {
	  return props.theme.vstui.rem((0, _themes.getStyle)('CheckboxControl_minHeight_' + props.sc.size)(props));
	}, function (props) {
	  return 'rtl' === props.dir ? '0 12px 0 38px' : '0 38px 0 12px';
	}, (0, _themes.getStyle)('CheckboxContainer_backgroundColor'), (0, _themes.getStyle)('CheckboxControl_backgroundImage'), function (props) {
	  return (0, _themes.getStyle)('CheckboxControl_backgroundPosition_' + props.sc.size)(props);
	}, (0, _themes.getStyle)('CheckboxControl_backgroundSize'), (0, _themes.getStyle)('CheckboxContainer_borderColor'), (0, _themes.getStyle)('CheckboxContainer_borderStyle'), (0, _themes.getStyle)('CheckboxContainer_borderWidth'), (0, _themes.getStyle)('CheckboxContainer_borderRadius'), (0, _themes.getStyle)('CheckboxControl_backgroundImage_invalid')), Styled.input = _styledComponents2.default.input.withConfig({ displayName: 'CheckboxControl__input' })(['', ';'], (0, _styles.visuallyHidden)()), Styled.div.checkboxIcon = _styledComponents2.default.div.withConfig({ displayName: 'CheckboxControl__checkboxIcon' })(['display:flex;align-items:center;height:', ';'], function (props) {
	  return props.theme.vstui.typography.pxToRem(props.theme.vstui.typography.fontSize * lineHeight);
	}), Styled.div.labelContent = _styledComponents2.default.div.withConfig({ displayName: 'CheckboxControl__labelContent' })(['display:inline-block;align-self:center;flex-grow:1;margin:', ';line-height:', ';user-select:none;', ';'], function (props) {
	  return 'rtl' === props.sc.dir ? '0 10px 0 0' : '0 0 0 10px';
	}, lineHeight, function (props) {
	  return props.sc.visuallyHidden ? (0, _styles.visuallyHidden)() : '';
	}), Styled.div.labelContent.displayName = 'Styled_div_labelContent', Styled.Label = (0, _styledComponents2.default)(_Label2.default).withConfig({ displayName: 'CheckboxControl__Label' })(['position:relative;display:flex;font-size:', ';font-weight:', ';cursor:pointer;.required &{width:100%;padding:10px 0;}&.disabled{cursor:default;}'], function (props) {
	  return props.theme.vstui.rem((0, _themes.getStyle)('CheckboxControl_fontSize_' + props.sc.size)(props));
	}, (0, _themes.getStyle)('CheckboxControl_fontWeight')), Styled.Label.displayName = 'Styled_Label';var CheckboxControl = function (_PureComponent) {
	  function CheckboxControl() {
	    _classCallCheck(this, CheckboxControl);var _this = _possibleConstructorReturn(this, (CheckboxControl.__proto__ || Object.getPrototypeOf(CheckboxControl)).call(this));return _this.handleFormControlRef = _this.handleFormControlRef.bind(_this), _this.handleValidate = _this.handleValidate.bind(_this), _this.renderContent = _this.renderContent.bind(_this), _this;
	  }return _inherits(CheckboxControl, _PureComponent), _createClass(CheckboxControl, [{ key: 'componentDidMount', value: function componentDidMount() {
	      this.props.onRef && this.props.onRef(this);
	    } }, { key: 'getValidationMessage', value: function getValidationMessage(validity) {
	      var i18n = this.props.theme.vstui.i18n;return validity.valueMissing ? i18n.t('form.missingCheckbox') : '';
	    } }, { key: 'validate', value: function validate(callback) {
	      this.formControl.validate(callback);
	    } }, { key: 'handleFormControlRef', value: function handleFormControlRef(node) {
	      this.formControl = node;
	    } }, { key: 'handleValidate', value: function handleValidate(validity) {
	      var _ref2 = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {},
	          callback = _ref2.callback,
	          onlyValidateIfValid = _ref2.onlyValidateIfValid,
	          _ref = arguments[2],
	          checked = _ref.checked,
	          updateValidationState = _ref.updateValidationState,
	          value = _ref.value,
	          _props = this.props,
	          onValidate = _props.onValidate,
	          validate = _props.validate,
	          passedDefaultValidation = validity.valid,
	          defaultValidationMessage = this.getValidationMessage(validity, { checked: checked, value: value }),
	          customValidationMessagePromise = Promise.resolve(validate ? validate(value) : ''),
	          update = function update(valid, validationMessage) {
	        (!onlyValidateIfValid || onlyValidateIfValid && valid) && updateValidationState(valid, validationMessage, onValidate);
	      };update(passedDefaultValidation, defaultValidationMessage), passedDefaultValidation ? customValidationMessagePromise.then(function (customValidationMessage) {
	        var passedCustomValidation = !customValidationMessage;update(passedCustomValidation, customValidationMessage), callback && callback(passedCustomValidation, customValidationMessage);
	      }) : callback && callback(passedDefaultValidation, defaultValidationMessage);
	    } }, { key: 'renderContent', value: function renderContent(_ref3) {
	      var checked = _ref3.checked,
	          checkedFormControlValue = _ref3.checkedFormControlValue,
	          defaultChecked = _ref3.defaultChecked,
	          focused = _ref3.focused,
	          invalid = _ref3.invalid,
	          handleBlur = _ref3.handleBlur,
	          handleChange = _ref3.handleChange,
	          handleFocus = _ref3.handleFocus,
	          handleNativeFormControlRef = _ref3.handleNativeFormControlRef,
	          _props2 = this.props,
	          classNameProp = _props2.className,
	          commonProps = _props2.commonProps,
	          disabled = _props2.disabled,
	          fullWidth = _props2.fullWidth,
	          id = _props2.id,
	          inheritStyles = _props2.inheritStyles,
	          label = _props2.label,
	          labelHidden = _props2.labelHidden,
	          labelledBy = _props2.labelledBy,
	          nativeFormControlRefIgnored = _props2.nativeFormControlRef,
	          onBlurIgnored = _props2.onBlur,
	          onChangeIgnored = _props2.onChange,
	          onValidateIgnored = _props2.onValidate,
	          required = _props2.required,
	          secondary = _props2.secondary,
	          size = _props2.size,
	          themeProp = _props2.theme,
	          validateIgnored = _props2.validate,
	          otherProps = _objectWithoutProperties(_props2, ['className', 'commonProps', 'disabled', 'fullWidth', 'id', 'inheritStyles', 'label', 'labelHidden', 'labelledBy', 'nativeFormControlRef', 'onBlur', 'onChange', 'onValidate', 'required', 'secondary', 'size', 'theme', 'validate']),
	          theme = (0, _componentTheme2.default)(themeProp),
	          i18n = theme.vstui.i18n,
	          className = (0, _classnames2.default)(classNameProp, { invalid: invalid, required: required }),
	          conditionalProps = {};return invalid && (conditionalProps['aria-invalid'] = !0), required && (conditionalProps['aria-required'] = !0), _react2.default.createElement(Styled.div.root, _extends({}, commonProps, { className: className, sc: { fullWidth: fullWidth, inheritStyles: inheritStyles, size: size }, theme: theme }), _react2.default.createElement(Styled.input, _extends({}, otherProps, conditionalProps, { "aria-labelledby": labelledBy, checked: checkedFormControlValue, defaultChecked: defaultChecked, disabled: disabled, id: id, innerRef: handleNativeFormControlRef, onBlur: handleBlur, onChange: handleChange, onFocus: handleFocus, required: required, theme: theme, type: 'checkbox' })), _react2.default.createElement(Styled.Label, { disabled: disabled, htmlFor: id, inheritStyles: !0, sc: { size: size }, theme: theme }, _react2.default.createElement(Styled.div.checkboxIcon, { theme: theme }, _react2.default.createElement(_CheckboxIcon2.default, { checked: checked, disabled: disabled, focused: focused, invalid: invalid, secondary: secondary, theme: theme })), label && _react2.default.createElement(Styled.div.labelContent, { sc: { dir: i18n.direction, visuallyHidden: labelHidden }, theme: theme }, label)));
	    } }, { key: 'render', value: function render() {
	      var _props3 = this.props,
	          checked = _props3.checked,
	          defaultChecked = _props3.defaultChecked,
	          nativeFormControlRef = _props3.nativeFormControlRef,
	          onBlur = _props3.onBlur,
	          onChange = _props3.onChange,
	          theme = _props3.theme;return _react2.default.createElement(_FormControl2.default, { checked: checked, defaultChecked: defaultChecked, nativeFormControlRef: nativeFormControlRef, onFormControlBlur: onBlur, onFormControlChange: onChange, onValidate: this.handleValidate, ref: this.handleFormControlRef, render: this.renderContent, theme: theme, type: 'checkbox' });
	    } }]), CheckboxControl;
	}(_react.PureComponent);CheckboxControl.propTypes = { checked: _propTypes2.default.bool, className: _propTypes2.default.string, commonProps: _propTypes3.commonPropsShape, defaultChecked: _propTypes2.default.bool, disabled: _propTypes2.default.bool, fullWidth: _propTypes2.default.bool, id: _propTypes2.default.string, inheritStyles: _propTypes2.default.bool, label: _propTypes2.default.node, labelHidden: _propTypes2.default.bool, labelledBy: _propTypes2.default.string, nativeFormControlRef: _propTypes2.default.func, onBlur: _propTypes2.default.func, onChange: _propTypes2.default.func, onFocus: _propTypes2.default.func, onRef: _propTypes2.default.func, onValidate: _propTypes2.default.func, required: _propTypes2.default.bool, secondary: _propTypes2.default.bool, size: _propTypes2.default.oneOf(['small', 'medium', 'large']), theme: _propTypes3.themeShape, validate: _propTypes2.default.func }, CheckboxControl.defaultProps = { size: 'medium', theme: (0, _themes.createTheme)() }, CheckboxControl.displayName = 'CheckboxControl';var CheckboxControlWithTheme = (0, _withCommonProps2.default)(CheckboxControl);CheckboxControlWithTheme.WrappedComponent = CheckboxControl, exports.default = CheckboxControlWithTheme;

/***/ },
/* 410 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var descriptor, i = 0; i < props.length; i++) {
	      descriptor = props[i], descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, 'value' in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    return protoProps && defineProperties(Constructor.prototype, protoProps), staticProps && defineProperties(Constructor, staticProps), Constructor;
	  };
	}(),
	    _react = __webpack_require__(3),
	    _react2 = _interopRequireDefault(_react),
	    _propTypes = __webpack_require__(6),
	    _propTypes2 = _interopRequireDefault(_propTypes),
	    _styledComponents = __webpack_require__(15),
	    _styledComponents2 = _interopRequireDefault(_styledComponents),
	    _propTypes3 = __webpack_require__(16),
	    _themes = __webpack_require__(4),
	    _icons = __webpack_require__(102),
	    _componentTheme = __webpack_require__(184),
	    _componentTheme2 = _interopRequireDefault(_componentTheme);Object.defineProperty(exports, '__esModule', { value: !0 });function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
	}function _possibleConstructorReturn(self, call) {
	  if (!self) throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');return call && ('object' == (typeof call === 'undefined' ? 'undefined' : _typeof(call)) || 'function' == typeof call) ? call : self;
	}function _inherits(subClass, superClass) {
	  if ('function' != typeof superClass && null !== superClass) throw new TypeError('Super expression must either be null or a function, not ' + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: !1, writable: !0, configurable: !0 } }), superClass && (Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass);
	}var Styled = { div: {} };Styled.div.root = _styledComponents2.default.div.withConfig({ displayName: 'CheckboxIcon__root' })(['width:14px;height:14px;border-radius:50%;box-shadow:0 0 0 ', ' ', ';transition-property:none;transition-duration:', ';'], function (props) {
	  return props.sc.focused ? '7px' : 0;
	}, function (props) {
	  return props.sc.highlightColor;
	}, function (props) {
	  return props.theme.vstui.transition.duration.shortest;
	});var CheckboxIcon = function (_React$Component) {
	  function CheckboxIcon() {
	    return _classCallCheck(this, CheckboxIcon), _possibleConstructorReturn(this, (CheckboxIcon.__proto__ || Object.getPrototypeOf(CheckboxIcon)).apply(this, arguments));
	  }return _inherits(CheckboxIcon, _React$Component), _createClass(CheckboxIcon, [{ key: 'render', value: function render() {
	      var _props = this.props,
	          checked = _props.checked,
	          disabled = _props.disabled,
	          focused = _props.focused,
	          invalid = _props.invalid,
	          secondary = _props.secondary,
	          themeProp = _props.theme,
	          theme = (0, _componentTheme2.default)(themeProp),
	          variant = secondary ? 'secondary' : 'primary',
	          iconColor = void 0,
	          highlightColor = void 0;return checked ? disabled ? (iconColor = { color1: theme.vstui['CheckboxIcon_borderColor_' + variant + '_checkedDisabled'], color2: theme.vstui['CheckboxIcon_backgroundColor_' + variant + '_checkedDisabled'], color3: theme.vstui['CheckboxIcon_color_' + variant + '_checkedDisabled'] }, highlightColor = theme.vstui['CheckboxIconHighlight_backgroundColor_' + variant + '_checkedDisabled']) : invalid && focused ? (iconColor = { color1: theme.vstui['CheckboxIcon_borderColor_' + variant + '_checkedInvalidFocus'], color2: theme.vstui['CheckboxIcon_backgroundColor_' + variant + '_checkedInvalidFocus'], color3: theme.vstui['CheckboxIcon_color_' + variant + '_checkedInvalidFocus'] }, highlightColor = theme.vstui['CheckboxIconHighlight_backgroundColor_' + variant + '_checkedInvalidFocus']) : invalid ? (iconColor = { color1: theme.vstui['CheckboxIcon_borderColor_' + variant + '_checkedInvalid'], color2: theme.vstui['CheckboxIcon_backgroundColor_' + variant + '_checkedInvalid'], color3: theme.vstui['CheckboxIcon_color_' + variant + '_checkedInvalid'] }, highlightColor = theme.vstui['CheckboxIconHighlight_backgroundColor_' + variant + '_checkedInvalid']) : focused ? (iconColor = { color1: theme.vstui['CheckboxIcon_borderColor_' + variant + '_checkedFocus'], color2: theme.vstui['CheckboxIcon_backgroundColor_' + variant + '_checkedFocus'], color3: theme.vstui['CheckboxIcon_color_' + variant + '_checkedFocus'] }, highlightColor = theme.vstui['CheckboxIconHighlight_backgroundColor_' + variant + '_checkedFocus']) : (iconColor = { color1: theme.vstui['CheckboxIcon_borderColor_' + variant + '_checked'], color2: theme.vstui['CheckboxIcon_backgroundColor_' + variant + '_checked'], color3: theme.vstui['CheckboxIcon_color_' + variant + '_checked'] }, highlightColor = theme.vstui['CheckboxIconHighlight_backgroundColor_' + variant + '_checked']) : disabled ? (iconColor = { color1: theme.vstui['CheckboxIcon_borderColor_' + variant + '_disabled'], color2: theme.vstui['CheckboxIcon_backgroundColor_' + variant + '_disabled'], color3: theme.vstui['CheckboxIcon_backgroundColor_' + variant + '_disabled'] }, highlightColor = theme.vstui['CheckboxIconHighlight_backgroundColor_' + variant + '_disabled']) : invalid && focused ? (iconColor = { color1: theme.vstui['CheckboxIcon_borderColor_' + variant + '_invalidFocus'], color2: theme.vstui['CheckboxIcon_backgroundColor_' + variant + '_invalidFocus'], color3: theme.vstui['CheckboxIcon_backgroundColor_' + variant + '_invalidFocus'] }, highlightColor = theme.vstui['CheckboxIconHighlight_backgroundColor_' + variant + '_invalidFocus']) : invalid ? (iconColor = { color1: theme.vstui['CheckboxIcon_borderColor_' + variant + '_invalid'], color2: theme.vstui['CheckboxIcon_backgroundColor_' + variant + '_invalidFocus'], color3: theme.vstui['CheckboxIcon_backgroundColor_' + variant + '_invalidFocus'] }, highlightColor = theme.vstui['CheckboxIconHighlight_backgroundColor_' + variant + '_invalid']) : focused ? (iconColor = { color1: theme.vstui['CheckboxIcon_borderColor_' + variant + '_focus'], color2: theme.vstui['CheckboxIcon_backgroundColor_' + variant + '_focus'], color3: theme.vstui['CheckboxIcon_backgroundColor_' + variant + '_focus'] }, highlightColor = theme.vstui['CheckboxIconHighlight_backgroundColor_' + variant + '_focus']) : (iconColor = { color1: theme.vstui['CheckboxIcon_borderColor_' + variant], color2: theme.vstui['CheckboxIcon_backgroundColor_' + variant], color3: theme.vstui['CheckboxIcon_backgroundColor_' + variant] }, highlightColor = theme.vstui['CheckboxIconHighlight_backgroundColor_' + variant]), _react2.default.createElement(Styled.div.root, { sc: { highlightColor: highlightColor, focused: focused, invalid: invalid }, theme: theme }, _react2.default.createElement(_icons.CheckboxChecked, { color: iconColor, theme: theme }));
	    } }]), CheckboxIcon;
	}(_react2.default.Component);CheckboxIcon.propTypes = { checked: _propTypes2.default.bool, disabled: _propTypes2.default.bool, focused: _propTypes2.default.bool, invalid: _propTypes2.default.bool, secondary: _propTypes2.default.bool, theme: _propTypes3.themeShape }, CheckboxIcon.defaultProps = { theme: (0, _themes.createTheme)() }, CheckboxIcon.displayName = 'CheckboxIcon';var CheckboxIconWithTheme = (0, _themes.withTheme)(CheckboxIcon);CheckboxIconWithTheme.WrappedComponent = CheckboxIcon, exports.default = CheckboxIconWithTheme;

/***/ },
/* 411 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	Object.defineProperty(exports, '__esModule', { value: !0 });var _CheckboxControl = __webpack_require__(409);Object.defineProperty(exports, 'default', { enumerable: !0, get: function get() {
	    return _interopRequireDefault(_CheckboxControl).default;
	  } });function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}

/***/ },
/* 412 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) {
	  for (var source, i = 1; i < arguments.length; i++) {
	    for (var key in source = arguments[i], source) {
	      Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
	    }
	  }return target;
	},
	    _createClass = function () {
	  function defineProperties(target, props) {
	    for (var descriptor, i = 0; i < props.length; i++) {
	      descriptor = props[i], descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, 'value' in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    return protoProps && defineProperties(Constructor.prototype, protoProps), staticProps && defineProperties(Constructor, staticProps), Constructor;
	  };
	}(),
	    _templateObject = _taggedTemplateLiteral(['\n      transition-duration: ', 'ms;\n    '], ['\n      transition-duration: ', 'ms;\n    ']),
	    _templateObject2 = _taggedTemplateLiteral(['\n      width: 100%;\n      max-width: 100%;\n      max-height: 100%;\n      height: 100%;\n      border-radius: 0;\n\n      transition-duration: ', 'ms;\n\n      transform: translate(\n        -50%,\n        ', '\n      );\n    '], ['\n      width: 100%;\n      max-width: 100%;\n      max-height: 100%;\n      height: 100%;\n      border-radius: 0;\n\n      transition-duration: ', 'ms;\n\n      transform: translate(\n        -50%,\n        ', '\n      );\n    ']),
	    _templateObject3 = _taggedTemplateLiteral(['\n      margin: 44px 0 0 0;\n      padding: 24px 20px 12px;\n      height: auto;\n      line-height: 1.35;\n      background-color: ', ';\n      border-radius: ', ';\n      color: ', ';\n    '], ['\n      margin: 44px 0 0 0;\n      padding: 24px 20px 12px;\n      height: auto;\n      line-height: 1.35;\n      background-color: ', ';\n      border-radius: ', ';\n      color: ', ';\n    ']),
	    _templateObject4 = _taggedTemplateLiteral(['\n      margin: 0;\n    '], ['\n      margin: 0;\n    ']),
	    _templateObject5 = _taggedTemplateLiteral(['\n      margin: 0;\n      padding: 0 20px 24px 20px;\n    '], ['\n      margin: 0;\n      padding: 0 20px 24px 20px;\n    ']),
	    _templateObject6 = _taggedTemplateLiteral(['\n      margin: 0;\n      padding-bottom: 24px;\n    '], ['\n      margin: 0;\n      padding-bottom: 24px;\n    ']),
	    _templateObject7 = _taggedTemplateLiteral(['\n      position: fixed;\n      top: 0;\n      right: 0;\n      left: 0;\n      display: flex;\n      justify-content: space-between;\n      height: 44px;\n      padding: 0;\n      background-color: ', ';\n      border-radius: ', ';\n    '], ['\n      position: fixed;\n      top: 0;\n      right: 0;\n      left: 0;\n      display: flex;\n      justify-content: space-between;\n      height: 44px;\n      padding: 0;\n      background-color: ', ';\n      border-radius: ', ';\n    ']),
	    _templateObject8 = _taggedTemplateLiteral(['\n      display: none;\n    '], ['\n      display: none;\n    ']),
	    _react = __webpack_require__(3),
	    _react2 = _interopRequireDefault(_react),
	    _propTypes = __webpack_require__(6),
	    _propTypes2 = _interopRequireDefault(_propTypes),
	    _a11yDialog = __webpack_require__(515),
	    _a11yDialog2 = _interopRequireDefault(_a11yDialog),
	    _styledComponents = __webpack_require__(15),
	    _styledComponents2 = _interopRequireDefault(_styledComponents),
	    _classnames = __webpack_require__(25),
	    _classnames2 = _interopRequireDefault(_classnames),
	    _lodash = __webpack_require__(814),
	    _lodash2 = _interopRequireDefault(_lodash),
	    _reactMedia = __webpack_require__(890),
	    _reactMedia2 = _interopRequireDefault(_reactMedia),
	    _Transition = __webpack_require__(492),
	    _Transition2 = _interopRequireDefault(_Transition),
	    _utils = __webpack_require__(59),
	    _DialogCloseButton = __webpack_require__(413),
	    _DialogCloseButton2 = _interopRequireDefault(_DialogCloseButton),
	    _DialogFullScreenActionButton = __webpack_require__(414),
	    _DialogFullScreenActionButton2 = _interopRequireDefault(_DialogFullScreenActionButton),
	    _Button = __webpack_require__(58),
	    _Button2 = _interopRequireDefault(_Button),
	    _Form = __webpack_require__(128),
	    _Form2 = _interopRequireDefault(_Form),
	    _withCommonProps = __webpack_require__(38),
	    _withCommonProps2 = _interopRequireDefault(_withCommonProps),
	    _themes = __webpack_require__(4),
	    _componentTheme = __webpack_require__(415),
	    _componentTheme2 = _interopRequireDefault(_componentTheme),
	    _styles = __webpack_require__(31),
	    _propTypes3 = __webpack_require__(16);Object.defineProperty(exports, '__esModule', { value: !0 });function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
	}function _possibleConstructorReturn(self, call) {
	  if (!self) throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');return call && ('object' == (typeof call === 'undefined' ? 'undefined' : _typeof(call)) || 'function' == typeof call) ? call : self;
	}function _inherits(subClass, superClass) {
	  if ('function' != typeof superClass && null !== superClass) throw new TypeError('Super expression must either be null or a function, not ' + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: !1, writable: !0, configurable: !0 } }), superClass && (Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass);
	}function _taggedTemplateLiteral(strings, raw) {
	  return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } }));
	}var transitionDurationSmallExpand = 150,
	    transitionDurationSmallCollapse = 75,
	    transitionDurationLargeExpand = 300,
	    transitionDurationLargeCollapse = 350,
	    Styled = { div: {}, h2: {} };Styled.div.root = _styledComponents2.default.div.withConfig({ displayName: 'Dialog__root' })(['', ';position:fixed;z-index:', ';opacity:', ';font-family:', ';-webkit-font-smoothing:antialiased;&[aria-hidden=\'true\']{display:', ';}transition-property:opacity;transition-duration:', 'ms;transition-timing-function:cubic-bezier(0,0,0.2,1);', ';'], function (props) {
	  return props.sc.inheritStyles ? '' : (0, _styles.resetInheritedStyles)({ direction: props.theme.vstui.i18n.direction });
	}, (0, _themes.getStyle)('Dialog_zIndex'), function (props) {
	  return 'entering' === props.sc.transitionState || 'entered' === props.sc.transitionState ? 1 : 0;
	}, (0, _themes.getStyle)('Dialog_fontFamily'), function (props) {
	  return 'exited' === props.sc.transitionState ? 'none' : 'block';
	}, function (props) {
	  return 'entering' === props.sc.transitionState || 'entered' === props.sc.transitionState ? transitionDurationSmallExpand : transitionDurationSmallCollapse;
	}, function (props) {
	  return props.sc.fullScreen && (0, _styles.css)(_templateObject, 'entering' === props.sc.transitionState || 'entered' === props.sc.transitionState ? transitionDurationLargeExpand : transitionDurationLargeCollapse);
	}), Styled.div.backdrop = _styledComponents2.default.div.withConfig({ displayName: 'Dialog__backdrop' })(['position:fixed;top:0;right:0;bottom:0;left:0;z-index:-1;background-color:', ';'], (0, _themes.getStyle)('DialogBackdrop_backgroundColor')), Styled.div.backdrop.displayName = 'Styled_div_backdrop', Styled.div.dialog = _styledComponents2.default.div.withConfig({ displayName: 'Dialog__dialog' })(['position:fixed;top:50%;left:50%;width:', ';max-width:calc(100% - 40px);min-height:', ';max-height:calc(100% - 40px);background-color:', ';border-radius:', ';box-shadow:', ';transform:translate(-50%,-50%) scale( ', ' );transition-property:transform;transition-duration:', 'ms;transition-timing-function:cubic-bezier(0,0,0.2,1);', ';'], function (props) {
	  return (0, _themes.getStyle)('Dialog_width_' + props.size);
	}, function (props) {
	  return 'calc(' + (props.sc.darkHeader ? '20px' : '0px') + ' + ' + props.sc.headerHeight + 'px + 22px + ' + props.sc.footerHeight + 'px)';
	}, (0, _themes.getStyle)('Dialog_backgroundColor'), (0, _themes.getStyle)('Dialog_borderRadius'), (0, _themes.getStyle)('Dialog_boxShadow'), function (props) {
	  return 'entering' === props.sc.transitionState || 'entered' === props.sc.transitionState ? 1 : 0.9;
	}, function (props) {
	  return 'entering' === props.sc.transitionState || 'entered' === props.sc.transitionState ? transitionDurationSmallExpand : transitionDurationSmallCollapse;
	}, function (props) {
	  return props.sc.fullScreen && (0, _styles.css)(_templateObject2, 'entering' === props.sc.transitionState || 'entered' === props.sc.transitionState ? transitionDurationLargeExpand : transitionDurationLargeCollapse, 'entering' === props.sc.transitionState || 'entered' === props.sc.transitionState ? '-50%' : '50%');
	}), Styled.div.content = _styledComponents2.default.div.withConfig({ displayName: 'Dialog__content' })(['display:flex;flex-direction:column;']), Styled.DialogCloseButton = (0, _styledComponents2.default)(_DialogCloseButton2.default).withConfig({ displayName: 'Dialog__DialogCloseButton' })(['position:absolute;top:0;right:', ';left:', ';z-index:2;'], function (props) {
	  return 'rtl' === props.theme.vstui.i18n.direction ? 'auto' : 0;
	}, function (props) {
	  return 'rtl' === props.theme.vstui.i18n.direction ? 0 : 'auto';
	}), Styled.DialogCloseButton.displayName = 'Styled_DialogCloseButton', Styled.h2.DialogTitle = _styledComponents2.default.h2.withConfig({ displayName: 'Dialog__DialogTitle' })(['z-index:1;margin:0;padding:', ';background-color:', ';border-radius:', ';box-shadow:', ';color:', ';font-size:', ';font-weight:', ';line-height:1.35;transition-property:none;transition-duration:', ';transition-timing-function:', ';', ';', ';'], function (props) {
	  return props.sc.darkHeader ? '13px 24px' : '24px 24px 12px 24px';
	}, function (props) {
	  return props.sc.darkHeader ? props.sc.secondary ? (0, _themes.getStyle)('DialogTitle_backgroundColor_darkHeaderSecondary') : (0, _themes.getStyle)('DialogTitle_backgroundColor_darkHeaderPrimary') : (0, _themes.getStyle)('DialogTitle_backgroundColor');
	}, (0, _themes.getStyle)('DialogTitle_borderRadius'), function (props) {
	  return props.sc.canScrollUp ? (0, _themes.getStyle)('DialogTitle_boxShadow') : 'none';
	}, function (props) {
	  return props.sc.darkHeader ? props.sc.secondary ? (0, _themes.getStyle)('DialogTitle_color_darkHeaderSecondary') : (0, _themes.getStyle)('DialogTitle_color_darkHeaderPrimary') : props.sc.secondary ? (0, _themes.getStyle)('DialogTitle_color_secondary') : (0, _themes.getStyle)('DialogTitle_color_primary');
	}, (0, _themes.getStyle)('DialogTitle_fontSize'), (0, _themes.getStyle)('DialogTitle_fontWeight'), function (props) {
	  return props.theme.vstui.transition.duration.shortest;
	}, function (props) {
	  return props.theme.vstui.transition.easing.easeIn;
	}, function (props) {
	  return props.sc.fullScreen && (0, _styles.css)(_templateObject3, (0, _themes.getStyle)('DialogTitle_backgroundColor_fullScreen'), (0, _themes.getStyle)('DialogTitle_borderRadius_fullScreen'), props.sc.secondary ? (0, _themes.getStyle)('DialogTitle_color_secondary_fullScreen') : (0, _themes.getStyle)('DialogTitle_color_primary_fullScreen'));
	}, function (props) {
	  return !props.sc.renderActions && !props.sc.fullScreen && (0, _styles.css)(_templateObject4);
	}), Styled.div.DialogContent = _styledComponents2.default.div.withConfig({ displayName: 'Dialog__DialogContent' })(['box-sizing:border-box;flex:1 1 auto;min-height:', ';max-height:', ';margin:0 0 calc(56px + 24px) 0;padding:', ';overflow-y:auto;color:', ';font-size:', ';line-height:1.43;word-break:break-word;', ';', ';'], function (props) {
	  return props.sc.darkHeader ? '42px' : '22px';
	}, function (props) {
	  return 'calc(100vh - (' + (props.sc.fullScreen ? '0px' : '40px') + ' + ' + props.sc.headerHeight + 'px + ' + (props.sc.renderActions || props.sc.fullScreen ? props.sc.footerHeight : 0) + 'px))';
	}, function (props) {
	  return props.sc.darkHeader ? '20px 24px 0' : '0 24px';
	}, (0, _themes.getStyle)('DialogContent_color'), (0, _themes.getStyle)('DialogContent_fontSize'), function (props) {
	  return props.sc.fullScreen && (0, _styles.css)(_templateObject5);
	}, function (props) {
	  return !props.sc.renderActions && (0, _styles.css)(_templateObject6);
	}), Styled.div.dialogActions = _styledComponents2.default.div.withConfig({ displayName: 'Dialog__dialogActions' })(['position:absolute;right:0;bottom:0;left:0;display:flex;justify-content:flex-end;padding:24px;background-color:', ';border-radius:', ';box-shadow:', ';transition-property:none;transition-duration:', ';transition-timing-function:', ';', ';', ';'], (0, _themes.getStyle)('DialogActions_backgroundColor'), (0, _themes.getStyle)('DialogActions_borderRadius'), function (props) {
	  return props.sc.canScrollDown ? (0, _themes.getStyle)('DialogActions_boxShadow') : 'none';
	}, function (props) {
	  return props.theme.vstui.transition.duration.shortest;
	}, function (props) {
	  return props.theme.vstui.transition.easing.easeIn;
	}, function (props) {
	  return props.sc.fullScreen && (0, _styles.css)(_templateObject7, props.sc.secondary ? (0, _themes.getStyle)('DialogActions_backgroundColor_secondary_fullScreen') : (0, _themes.getStyle)('DialogActions_backgroundColor_primary_fullScreen'), (0, _themes.getStyle)('DialogActions_borderRadius_fullScreen'));
	}, function (props) {
	  return !props.sc.renderActions && !props.sc.fullScreen && (0, _styles.css)(_templateObject8);
	});var Dialog = function (_Component) {
	  function Dialog(props) {
	    _classCallCheck(this, Dialog);var _this = _possibleConstructorReturn(this, (Dialog.__proto__ || Object.getPrototypeOf(Dialog)).call(this, props));return _this.generatedId = (0, _utils.generateUniqueId)('dialog'), _this.state = { canScrollDown: !1, canScrollUp: !1, id: props.id || _this.generatedId, headerHeight: 0, footerHeight: 0 }, _this.handleActionsRef = _this.handleActionsRef.bind(_this), _this.handleCloseButtonClick = _this.handleCloseButtonClick.bind(_this), _this.handleContentRef = _this.handleContentRef.bind(_this), _this.handleFormRef = _this.handleFormRef.bind(_this), _this.handleKeyDown = _this.handleKeyDown.bind(_this), _this.handleOverlayClick = _this.handleOverlayClick.bind(_this), _this.handleRef = _this.handleRef.bind(_this), _this.handleResize = _this.handleResize.bind(_this), _this.handleScroll = _this.handleScroll.bind(_this), _this.handleTitleRef = _this.handleTitleRef.bind(_this), _this.handleResizeThrottled = (0, _lodash2.default)(_this.handleResize, 100), _this;
	  }return _inherits(Dialog, _Component), _createClass(Dialog, [{ key: 'componentDidMount', value: function componentDidMount() {
	      this.a11yDialog = this.a11yDialog || this.initDialog(), this.props.open && this.show(), window.addEventListener('resize', this.handleResizeThrottled);
	    } }, { key: 'componentWillReceiveProps', value: function componentWillReceiveProps(nextProps) {
	      var id = nextProps.id || this.generatedId;id !== this.state.id && this.setState({ id: id }), !1 === nextProps.open && !1 !== this.props.open && this.form && this.form.reset();
	    } }, { key: 'componentDidUpdate', value: function componentDidUpdate(prevProps) {
	      prevProps.open !== this.props.open && (this.props.open ? this.show() : this.hide()), (prevProps.alert !== this.props.alert || prevProps.children !== this.props.children || prevProps.darkHeader !== this.props.darkHeader || prevProps.size !== this.props.size || prevProps.title !== this.props.title) && this.updateDimensionsState(), this.updateScrollState();
	    } }, { key: 'componentWillUnmount', value: function componentWillUnmount() {
	      document.removeEventListener('keydown', this.handleKeyDown), this.content && this.content.removeEventListener('scroll', this.handleScroll), this.a11yDialog && this.a11yDialog.destroy(), this.moveNodeBack(), window.removeEventListener('resize', this.handleResizeThrottled);
	    } }, { key: 'show', value: function show() {
	      document.addEventListener('keydown', this.handleKeyDown), this.a11yDialog.show();
	    } }, { key: 'hide', value: function hide() {
	      document.removeEventListener('keydown', this.handleKeyDown), this.a11yDialog.hide(), this.props.onRequestClose();
	    } }, { key: 'moveNodeBack', value: function moveNodeBack() {
	      this.mainContainer && (this.mainContainer.parentNode.removeChild(this.node), this.ancestor.appendChild(this.node));
	    } }, { key: 'moveNode', value: function moveNode() {
	      this.mainContainer && (this.ancestor.removeChild(this.node), this.mainContainer.parentNode.appendChild(this.node));
	    } }, { key: 'initDialog', value: function initDialog() {
	      return this.mainContainer = document.querySelector(this.props.rootSelector), this.ancestor = this.node.parentNode, this.moveNode(), new _a11yDialog2.default(this.node, this.mainContainer);
	    } }, { key: 'handleResize', value: function handleResize() {
	      this.updateDimensionsState();
	    } }, { key: 'updateDimensionsState', value: function updateDimensionsState() {
	      var headerHeight = this.title ? this.title.offsetHeight : 0,
	          footerHeight = this.actions ? this.actions.offsetHeight : 0;this.setState({ headerHeight: headerHeight, footerHeight: footerHeight });
	    } }, { key: 'handleActionsRef', value: function handleActionsRef(node) {
	      this.actions = node, this.actions && this.updateDimensionsState();
	    } }, { key: 'handleTitleRef', value: function handleTitleRef(node) {
	      this.title = node, this.title && this.updateDimensionsState();
	    } }, { key: 'handleContentRef', value: function handleContentRef(node) {
	      this.content = node, this.content && (this.content.addEventListener('scroll', this.handleScroll), this.updateScrollState());
	    } }, { key: 'handleFormRef', value: function handleFormRef(node) {
	      this.form = node;var formProps = this.props.formProps;formProps && formProps.innerRef && formProps.innerRef(node);
	    } }, { key: 'handleRef', value: function handleRef(node) {
	      this.node = node;
	    } }, { key: 'handleOverlayClick', value: function handleOverlayClick(event) {
	      this.props.requireInteraction || this.props.onRequestClose(event);
	    } }, { key: 'handleCloseButtonClick', value: function handleCloseButtonClick(event) {
	      this.props.onRequestClose(event);
	    } }, { key: 'handleKeyDown', value: function handleKeyDown(event) {
	      event.which === 27 && (event.stopImmediatePropagation(), !this.props.requireInteraction && this.props.onRequestClose(event));
	    } }, { key: 'handleScroll', value: function handleScroll() {
	      this.updateScrollState();
	    } }, { key: 'updateScrollState', value: function updateScrollState() {
	      var _state = this.state,
	          canScrollDown = _state.canScrollDown,
	          canScrollUp = _state.canScrollUp,
	          _content = this.content,
	          clientHeight = _content.clientHeight,
	          scrollHeight = _content.scrollHeight,
	          scrollTop = _content.scrollTop;!canScrollUp && 0 < scrollTop ? this.setState({ canScrollUp: !0 }) : canScrollUp && 0 === scrollTop && this.setState({ canScrollUp: !1 }), !canScrollDown && scrollTop + clientHeight < scrollHeight ? this.setState({ canScrollDown: !0 }) : canScrollDown && scrollTop + clientHeight === scrollHeight && this.setState({ canScrollDown: !1 });
	    } }, { key: 'renderDialogActions', value: function renderDialogActions(theme, fullScreen, closeButtonLabel) {
	      var _props = this.props,
	          primaryActionButtonProp = _props.primaryActionButton,
	          secondary = _props.secondary,
	          secondaryActionButtonProp = _props.secondaryActionButton,
	          requireInteraction = _props.requireInteraction,
	          canScrollDown = this.state.canScrollDown,
	          primaryActionButton = primaryActionButtonProp ? _react2.default.createElement(_Button2.default, { inheritStyles: !0, key: primaryActionButtonProp.label, onClick: primaryActionButtonProp.onClick, secondary: secondary, theme: theme }, primaryActionButtonProp.label) : null,
	          secondaryActionButton = secondaryActionButtonProp ? _react2.default.createElement(_Button2.default, { color: 'neutral', inheritStyles: !0, key: secondaryActionButtonProp.label, naked: !0, onClick: secondaryActionButtonProp.onClick, secondary: secondary, theme: theme, type: 'button' }, secondaryActionButtonProp.label) : null,
	          primaryFullScreenActionButton = primaryActionButtonProp ? _react2.default.createElement(_DialogFullScreenActionButton2.default, { inheritStyles: !0, key: primaryActionButtonProp.label, onClick: primaryActionButtonProp.onClick, secondary: secondary, theme: theme, variant: 'primary' }, primaryActionButtonProp.label) : fullScreen && !requireInteraction ? _react2.default.createElement(_DialogFullScreenActionButton2.default, { key: closeButtonLabel, onClick: this.handleCloseButtonClick, secondary: secondary, theme: theme, variant: 'primary' }, closeButtonLabel) : null,
	          secondaryFullScreenActionButton = secondaryActionButtonProp ? _react2.default.createElement(_DialogFullScreenActionButton2.default, { inheritStyles: !0, key: secondaryActionButtonProp.label, onClick: secondaryActionButtonProp.onClick, secondary: secondary, theme: theme, type: 'button', variant: 'secondary' }, secondaryActionButtonProp.label) : null;return _react2.default.createElement(Styled.div.dialogActions, { innerRef: this.handleActionsRef, sc: { canScrollDown: canScrollDown, fullScreen: fullScreen, renderActions: primaryActionButton || secondaryActionButton, secondary: secondary }, theme: theme }, fullScreen ? secondaryFullScreenActionButton : secondaryActionButton, fullScreen ? primaryFullScreenActionButton : primaryActionButton);
	    } }, { key: 'render', value: function render() {
	      var _this2 = this,
	          _props2 = this.props,
	          alert = _props2.alert,
	          ariaDescribedBy = _props2['aria-describedby'],
	          children = _props2.children,
	          classes = _props2.classes,
	          className = _props2.className,
	          closeButtonLabelProp = _props2.closeButtonLabel,
	          commonProps = _props2.commonProps,
	          darkHeader = _props2.darkHeader,
	          formProps = _props2.formProps,
	          idIgnored = _props2.id,
	          inheritStyles = _props2.inheritStyles,
	          open = _props2.open,
	          requireInteraction = _props2.requireInteraction,
	          secondary = _props2.secondary,
	          size = _props2.size,
	          themeProp = _props2.theme,
	          title = _props2.title,
	          primaryActionButton = _props2.primaryActionButton,
	          secondaryActionButton = _props2.secondaryActionButton,
	          _state2 = this.state,
	          footerHeight = _state2.footerHeight,
	          headerHeight = _state2.headerHeight,
	          id = _state2.id,
	          theme = (0, _componentTheme2.default)(themeProp),
	          i18n = theme.vstui.i18n,
	          closeButtonLabel = closeButtonLabelProp || i18n.t('dialog.closeButton'),
	          canScrollUp = this.state.canScrollUp,
	          titleId = id + '-title';return _react2.default.createElement(_reactMedia2.default, { query: theme.vstui.Dialog_breakpoint_xs }, function (matches) {
	        var fullScreen = matches && !alert,
	            renderActions = primaryActionButton || secondaryActionButton;return _react2.default.createElement(_Transition2.default, { in: open, timeout: { enter: fullScreen ? transitionDurationLargeExpand : transitionDurationSmallExpand, exit: fullScreen ? transitionDurationLargeCollapse : transitionDurationSmallCollapse } }, function (transitionState) {
	          return _react2.default.createElement(Styled.div.root, _extends({}, commonProps, { "aria-hidden": !open, className: (0, _classnames2.default)(className, classes.root), id: id, innerRef: _this2.handleRef, sc: { fullScreen: fullScreen, inheritStyles: inheritStyles, transitionState: transitionState }, theme: theme }), _react2.default.createElement(Styled.div.backdrop, { className: classes.backdrop, onClick: _this2.handleOverlayClick, tabIndex: -1, theme: theme }), _react2.default.createElement(Styled.div.dialog, { "aria-describedby": ariaDescribedBy, "aria-labelledby": titleId, className: classes.dialog, role: 'dialog', sc: { darkHeader: darkHeader, footerHeight: footerHeight, fullScreen: fullScreen, headerHeight: headerHeight, transitionState: transitionState }, size: size, theme: theme }, _react2.default.createElement(Styled.div.content, { className: classes.content, role: 'document' }, !requireInteraction && !fullScreen && _react2.default.createElement(Styled.DialogCloseButton, { className: classes.closeButton, color: darkHeader ? 'white' : 'neutral', inheritStyles: !0, label: closeButtonLabel, onClick: _this2.handleCloseButtonClick, theme: theme }), _react2.default.createElement(Styled.h2.DialogTitle, { id: titleId, innerRef: _this2.handleTitleRef, sc: { darkHeader: darkHeader, fullScreen: fullScreen, canScrollUp: canScrollUp, secondary: secondary, renderActions: renderActions }, theme: theme }, title), _react2.default.createElement(Styled.div.DialogContent, { innerRef: _this2.handleContentRef, sc: { darkHeader: darkHeader, fullScreen: fullScreen, headerHeight: headerHeight, footerHeight: footerHeight, renderActions: renderActions }, theme: theme }, formProps && _react2.default.createElement(_Form2.default, _extends({}, formProps, { inheritStyles: !0, innerRef: _this2.handleFormRef }), children, _this2.renderDialogActions(theme, fullScreen, closeButtonLabel)), !formProps && children), !formProps && _this2.renderDialogActions(theme, fullScreen, closeButtonLabel))));
	        });
	      });
	    } }]), Dialog;
	}(_react.Component);Dialog.propTypes = { "aria-describedby": _propTypes2.default.string, primaryActionButton: _propTypes2.default.shape({ label: _propTypes2.default.string.isRequired, onClick: _propTypes2.default.func }), secondaryActionButton: _propTypes2.default.shape({ label: _propTypes2.default.string.isRequired, onClick: _propTypes2.default.func }), formProps: _propTypes2.default.shape({ action: _propTypes2.default.string, innerRef: _propTypes2.default.func, method: _propTypes2.default.oneOf(['get', 'post']), onSubmit: _propTypes2.default.func, onValidate: _propTypes2.default.func }), alert: _propTypes2.default.bool, children: _propTypes2.default.node, classes: _propTypes2.default.objectOf(_propTypes2.default.string), className: _propTypes2.default.string, closeButtonLabel: _propTypes2.default.string, commonProps: _propTypes3.commonPropsShape, darkHeader: _propTypes2.default.bool, id: _propTypes2.default.string, inheritStyles: _propTypes2.default.bool, onRequestClose: _propTypes2.default.func, open: _propTypes2.default.bool, requireInteraction: _propTypes2.default.bool, rootSelector: _propTypes2.default.string, secondary: _propTypes2.default.bool, size: _propTypes2.default.oneOf(['small', 'medium', 'large']), theme: _propTypes3.themeShape, title: _propTypes2.default.string.isRequired }, Dialog.defaultProps = { rootSelector: '#root', classes: { root: '', backdrop: '', dialog: '', content: '', closeButton: '' }, size: 'small', theme: (0, _themes.createTheme)() }, Dialog.displayName = 'Dialog';var DialogWithTheme = (0, _withCommonProps2.default)(Dialog);DialogWithTheme.WrappedComponent = Dialog, exports.default = DialogWithTheme;

/***/ },
/* 413 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) {
	  for (var source, i = 1; i < arguments.length; i++) {
	    for (var key in source = arguments[i], source) {
	      Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
	    }
	  }return target;
	},
	    _createClass = function () {
	  function defineProperties(target, props) {
	    for (var descriptor, i = 0; i < props.length; i++) {
	      descriptor = props[i], descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, 'value' in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    return protoProps && defineProperties(Constructor.prototype, protoProps), staticProps && defineProperties(Constructor, staticProps), Constructor;
	  };
	}(),
	    _react = __webpack_require__(3),
	    _react2 = _interopRequireDefault(_react),
	    _Button = __webpack_require__(58),
	    _Button2 = _interopRequireDefault(_Button),
	    _themes = __webpack_require__(4),
	    _icons = __webpack_require__(102);Object.defineProperty(exports, '__esModule', { value: !0 });function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
	}function _possibleConstructorReturn(self, call) {
	  if (!self) throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');return call && ('object' == (typeof call === 'undefined' ? 'undefined' : _typeof(call)) || 'function' == typeof call) ? call : self;
	}function _inherits(subClass, superClass) {
	  if ('function' != typeof superClass && null !== superClass) throw new TypeError('Super expression must either be null or a function, not ' + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: !1, writable: !0, configurable: !0 } }), superClass && (Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass);
	}var ThemedButton = (0, _themes.createThemedComponent)(_Button2.default, { Button_paddingHorizontal_withIcon_medium: '10px', Button_minHeight_medium: 30, Button_borderWidth: 0, Button_color_neutralNaked: function Button_color_neutralNaked(props) {
	    return props.theme.vstui.color.cloud.getShade(5);
	  }, Button_color_neutralNaked_active: function Button_color_neutralNaked_active(props) {
	    return props.theme.vstui.color.cloud.getShade(6);
	  }, Button_color_neutralNaked_focus: function Button_color_neutralNaked_focus(props) {
	    return props.theme.vstui.color.cloud.getShade(6);
	  }, Button_color_neutralNaked_hover: function Button_color_neutralNaked_hover(props) {
	    return props.theme.vstui.color.cloud.getShade(6);
	  } }),
	    DialogCloseButton = function (_Component) {
	  function DialogCloseButton() {
	    return _classCallCheck(this, DialogCloseButton), _possibleConstructorReturn(this, (DialogCloseButton.__proto__ || Object.getPrototypeOf(DialogCloseButton)).apply(this, arguments));
	  }return _inherits(DialogCloseButton, _Component), _createClass(DialogCloseButton, [{ key: 'render', value: function render() {
	      return _react2.default.createElement(ThemedButton, _extends({}, this.props, { iconStart: _react2.default.createElement(_icons.XSmall, null), naked: !0 }));
	    } }]), DialogCloseButton;
	}(_react.Component);DialogCloseButton.defaultProps = {}, exports.default = DialogCloseButton;

/***/ },
/* 414 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) {
	  for (var source, i = 1; i < arguments.length; i++) {
	    for (var key in source = arguments[i], source) {
	      Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
	    }
	  }return target;
	},
	    _createClass = function () {
	  function defineProperties(target, props) {
	    for (var descriptor, i = 0; i < props.length; i++) {
	      descriptor = props[i], descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, 'value' in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    return protoProps && defineProperties(Constructor.prototype, protoProps), staticProps && defineProperties(Constructor, staticProps), Constructor;
	  };
	}(),
	    _react = __webpack_require__(3),
	    _react2 = _interopRequireDefault(_react),
	    _propTypes = __webpack_require__(6),
	    _propTypes2 = _interopRequireDefault(_propTypes),
	    _Button = __webpack_require__(58),
	    _Button2 = _interopRequireDefault(_Button),
	    _themes = __webpack_require__(4),
	    _propTypes3 = __webpack_require__(16);Object.defineProperty(exports, '__esModule', { value: !0 });function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}function _objectWithoutProperties(obj, keys) {
	  var target = {};for (var i in obj) {
	    0 <= keys.indexOf(i) || Object.prototype.hasOwnProperty.call(obj, i) && (target[i] = obj[i]);
	  }return target;
	}function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
	}function _possibleConstructorReturn(self, call) {
	  if (!self) throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');return call && ('object' == (typeof call === 'undefined' ? 'undefined' : _typeof(call)) || 'function' == typeof call) ? call : self;
	}function _inherits(subClass, superClass) {
	  if ('function' != typeof superClass && null !== superClass) throw new TypeError('Super expression must either be null or a function, not ' + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: !1, writable: !0, configurable: !0 } }), superClass && (Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass);
	}var ThemedButton = (0, _themes.createThemedComponent)(_Button2.default, function (props) {
	  var typography = props.theme.vstui.typography;return { Button_paddingHorizontal_medium: '20px', Button_minHeight_medium: '44px', Button_borderRadius: 0, Button_fontWeight_themePrimary: 'primary' === props.sc.variant ? typography.fontWeightMedium : typography.fontWeightRegular };
	}),
	    DialogFullScreenActionButton = function (_Component) {
	  function DialogFullScreenActionButton() {
	    return _classCallCheck(this, DialogFullScreenActionButton), _possibleConstructorReturn(this, (DialogFullScreenActionButton.__proto__ || Object.getPrototypeOf(DialogFullScreenActionButton)).apply(this, arguments));
	  }return _inherits(DialogFullScreenActionButton, _Component), _createClass(DialogFullScreenActionButton, [{ key: 'render', value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          theme = _props.theme,
	          variant = _props.variant,
	          otherProps = _objectWithoutProperties(_props, ['className', 'theme', 'variant']);return _react2.default.createElement(ThemedButton, _extends({}, otherProps, { className: className, sc: { variant: variant }, theme: theme }));
	    } }]), DialogFullScreenActionButton;
	}(_react.Component);DialogFullScreenActionButton.propTypes = { className: _propTypes2.default.string, theme: _propTypes3.themeShape, variant: _propTypes2.default.oneOf(['primary', 'secondary']) }, DialogFullScreenActionButton.defaultProps = {}, exports.default = DialogFullScreenActionButton;

/***/ },
/* 415 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	Object.defineProperty(exports, '__esModule', { value: !0 });var _themes = __webpack_require__(4),
	    componentTheme = function componentTheme(baseTheme) {
	  var _baseTheme$vstui = baseTheme.vstui,
	      breakpoint = _baseTheme$vstui.breakpoint,
	      color = _baseTheme$vstui.color,
	      rem = _baseTheme$vstui.rem,
	      shadow = _baseTheme$vstui.shadow,
	      shape = _baseTheme$vstui.shape,
	      typography = _baseTheme$vstui.typography,
	      zIndex = _baseTheme$vstui.zIndex,
	      primaryMain = color.primary.getMainShade(),
	      secondaryMain = color.secondary.getMainShade();return (0, _themes.createComponentTheme)(baseTheme, { Dialog_zIndex: zIndex.modal, Dialog_width_small: '300px', Dialog_width_medium: '400px', Dialog_width_large: '500px', Dialog_backgroundColor: color.surface, Dialog_borderRadius: shape.borderRadius, Dialog_boxShadow: shadow.high, Dialog_fontFamily: typography.fontFamily, Dialog_breakpoint_xs: breakpoint.xs, DialogBackdrop_backgroundColor: 'rgba(0, 0, 0, 0.5)', DialogTitle_backgroundColor: color.transparent, DialogTitle_backgroundColor_darkHeaderPrimary: primaryMain, DialogTitle_backgroundColor_darkHeaderSecondary: secondaryMain, DialogTitle_backgroundColor_fullScreen: color.transparent, DialogTitle_borderRadius: shape.borderRadius + ' ' + shape.borderRadius + ' 0 0', DialogTitle_borderRadius_fullScreen: 0, DialogTitle_boxShadow: '0 4px 3px -3px rgba(0, 0, 0, 0.2)', DialogTitle_fontSize: rem(typography.fontSize + 3), DialogTitle_fontWeight: typography.fontWeightMedium, DialogTitle_color_darkHeaderPrimary: color.onPrimary, DialogTitle_color_darkHeaderSecondary: color.onSecondary, DialogTitle_color_primary: primaryMain, DialogTitle_color_secondary: secondaryMain, DialogTitle_color_primary_fullScreen: primaryMain, DialogTitle_color_secondary_fullScreen: secondaryMain, DialogContent_fontSize: rem(typography.fontSize), DialogContent_color: color.onSurface, DialogActions_backgroundColor: color.transparent, DialogActions_backgroundColor_primary_fullScreen: primaryMain, DialogActions_backgroundColor_secondary_fullScreen: secondaryMain, DialogActions_borderRadius: '0 0 ' + shape.borderRadius + ' ' + shape.borderRadius, DialogActions_borderRadius_fullScreen: 0, DialogActions_boxShadow: '0 -4px 3px -3px rgba(0, 0, 0, 0.2)' });
	};exports.default = componentTheme;

/***/ },
/* 416 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	Object.defineProperty(exports, '__esModule', { value: !0 });var _Dialog = __webpack_require__(412);Object.defineProperty(exports, 'default', { enumerable: !0, get: function get() {
	    return _interopRequireDefault(_Dialog).default;
	  } });function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}

/***/ },
/* 417 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) {
	  for (var source, i = 1; i < arguments.length; i++) {
	    for (var key in source = arguments[i], source) {
	      Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
	    }
	  }return target;
	},
	    _slicedToArray = function () {
	  function sliceIterator(arr, i) {
	    var _arr = [],
	        _n = !0,
	        _d = !1,
	        _e = void 0;try {
	      for (var _s, _i = arr[Symbol.iterator](); !(_n = (_s = _i.next()).done) && (_arr.push(_s.value), !(i && _arr.length === i)); _n = !0) {}
	    } catch (err) {
	      _d = !0, _e = err;
	    } finally {
	      try {
	        !_n && _i['return'] && _i['return']();
	      } finally {
	        if (_d) throw _e;
	      }
	    }return _arr;
	  }return function (arr, i) {
	    if (Array.isArray(arr)) return arr;if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);throw new TypeError('Invalid attempt to destructure non-iterable instance');
	  };
	}(),
	    _createClass = function () {
	  function defineProperties(target, props) {
	    for (var descriptor, i = 0; i < props.length; i++) {
	      descriptor = props[i], descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, 'value' in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    return protoProps && defineProperties(Constructor.prototype, protoProps), staticProps && defineProperties(Constructor, staticProps), Constructor;
	  };
	}(),
	    _react = __webpack_require__(3),
	    _react2 = _interopRequireDefault(_react),
	    _propTypes = __webpack_require__(6),
	    _propTypes2 = _interopRequireDefault(_propTypes),
	    _styledComponents = __webpack_require__(15),
	    _styledComponents2 = _interopRequireDefault(_styledComponents),
	    _FormContext = __webpack_require__(192),
	    _FormContext2 = _interopRequireDefault(_FormContext),
	    _propTypes3 = __webpack_require__(16),
	    _styles = __webpack_require__(31),
	    _withCommonProps = __webpack_require__(38),
	    _withCommonProps2 = _interopRequireDefault(_withCommonProps),
	    _themes = __webpack_require__(4),
	    _utils = __webpack_require__(59);Object.defineProperty(exports, '__esModule', { value: !0 });function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}function _objectWithoutProperties(obj, keys) {
	  var target = {};for (var i in obj) {
	    0 <= keys.indexOf(i) || Object.prototype.hasOwnProperty.call(obj, i) && (target[i] = obj[i]);
	  }return target;
	}function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
	}function _possibleConstructorReturn(self, call) {
	  if (!self) throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');return call && ('object' == (typeof call === 'undefined' ? 'undefined' : _typeof(call)) || 'function' == typeof call) ? call : self;
	}function _inherits(subClass, superClass) {
	  if ('function' != typeof superClass && null !== superClass) throw new TypeError('Super expression must either be null or a function, not ' + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: !1, writable: !0, configurable: !0 } }), superClass && (Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass);
	}var Styled = { form: _styledComponents2.default.form.withConfig({ displayName: 'Form__form' })(['', ';color:', ';font-family:', ';font-size:', ';font-weight:', ';-webkit-font-smoothing:antialiased;'], function (props) {
	    return props.sc.inheritStyles ? '' : (0, _styles.resetInheritedStyles)({ direction: props.theme.vstui.i18n.direction });
	  }, function (props) {
	    return props.theme.vstui.color.onSurface;
	  }, function (props) {
	    return props.theme.vstui.typography.fontFamily;
	  }, function (props) {
	    return props.theme.vstui.typography.pxToRem(props.theme.vstui.typography.fontSize);
	  }, function (props) {
	    return props.theme.vstui.typography.fontWeightRegular;
	  }) },
	    Form = function (_Component) {
	  function Form() {
	    _classCallCheck(this, Form);var _this = _possibleConstructorReturn(this, (Form.__proto__ || Object.getPrototypeOf(Form)).call(this));return _this.isReadyToSubmit = !1, _this.isValidating = !1, _this.registeredFormControls = {}, _this.handleFormRef = _this.handleFormRef.bind(_this), _this.handleSubmit = _this.handleSubmit.bind(_this), _this.registerFormControl = _this.registerFormControl.bind(_this), _this;
	  }return _inherits(Form, _Component), _createClass(Form, [{ key: 'componentDidMount', value: function componentDidMount() {
	      this.props.onRef && this.props.onRef(this);
	    } }, { key: 'componentWillUnmount', value: function componentWillUnmount() {
	      this.props.onRef && this.props.onRef(void 0);
	    } }, { key: 'reset', value: function reset() {
	      this.resetForm();
	    } }, { key: 'validate', value: function validate(callback) {
	      this.validateForm(function (valid) {
	        callback && callback(valid);
	      });
	    } }, { key: 'registerFormControl', value: function registerFormControl(_ref) {
	      var focus = _ref.focus,
	          id = _ref.id,
	          reset = _ref.reset,
	          validate = _ref.validate;this.registeredFormControls[id] = { focus: focus, reset: reset, validate: validate };
	    } }, { key: 'handleFormRef', value: function handleFormRef(node) {
	      node && (this.nativeForm = node);
	    } }, { key: 'resetForm', value: function resetForm() {
	      var _this2 = this,
	          onReset = this.props.onReset;this.nativeForm.reset();var resetFormControls = new Promise(function (resolve) {
	        Object.values(_this2.registeredFormControls).forEach(function (_ref2, i) {
	          var reset = _ref2.reset;reset(), i === Object.keys(_this2.registeredFormControls).length - 1 && resolve();
	        });
	      });resetFormControls.then(function () {
	        onReset && onReset();
	      });
	    } }, { key: 'validateForm', value: function validateForm(callback) {
	      var _this3 = this,
	          onValidate = this.props.onValidate,
	          focusFirstInvalidFormControl = void 0,
	          validationMessages = {},
	          validateFormControls = new Promise(function (resolve) {
	        (0, _utils.entries)(_this3.registeredFormControls).forEach(function (_ref3) {
	          var _ref4 = _slicedToArray(_ref3, 2),
	              key = _ref4[0],
	              validate = _ref4[1].validate;validate(function (valid, validationMessage) {
	            validationMessages[key] = validationMessage, Object.keys(validationMessages).length === Object.keys(_this3.registeredFormControls).length && resolve();
	          });
	        });
	      });validateFormControls.then(function () {
	        (0, _utils.entries)(_this3.registeredFormControls).forEach(function (_ref5) {
	          var _ref6 = _slicedToArray(_ref5, 2),
	              key = _ref6[0],
	              focus = _ref6[1].focus;!focusFirstInvalidFormControl && validationMessages[key] && (focusFirstInvalidFormControl = focus);
	        }), focusFirstInvalidFormControl ? (focusFirstInvalidFormControl(), onValidate && onValidate(!1), callback && callback(!1)) : (onValidate && onValidate(!0), callback && callback(!0));
	      });
	    } }, { key: 'handleSubmit', value: function handleSubmit(event) {
	      var _this4 = this,
	          onSubmit = this.props.onSubmit;return this.isValidating ? void event.preventDefault() : void (this.isReadyToSubmit ? (onSubmit && onSubmit(event), !event.isTrusted && !event.defaultPrevented && this.nativeForm.submit(), this.isReadyToSubmit = !1) : (event.preventDefault(), this.isValidating = !0, this.validateForm(function (valid) {
	        _this4.isValidating = !1, _this4.isReadyToSubmit = valid, valid && _this4.dispatchSubmitEvent();
	      })));
	    } }, { key: 'dispatchSubmitEvent', value: function dispatchSubmitEvent() {
	      var _this5 = this,
	          submitEvent = (0, _utils.createEvent)('submit', { bubbles: !0, cancelable: !0 });setTimeout(function () {
	        _this5.nativeForm.dispatchEvent(submitEvent);
	      });
	    } }, { key: 'render', value: function render() {
	      var _props = this.props,
	          commonProps = _props.commonProps,
	          inheritStyles = _props.inheritStyles,
	          theme = _props.theme,
	          otherProps = _objectWithoutProperties(_props, ['commonProps', 'inheritStyles', 'theme']);return _react2.default.createElement(_FormContext2.default.Provider, { value: this.registerFormControl }, _react2.default.createElement(Styled.form, _extends({}, commonProps, otherProps, { innerRef: this.handleFormRef, noValidate: !0, onSubmit: this.handleSubmit, sc: { inheritStyles: inheritStyles }, theme: theme })));
	    } }]), Form;
	}(_react.Component);Form.propTypes = { commonProps: _propTypes3.commonPropsShape, inheritStyles: _propTypes2.default.bool, onRef: _propTypes2.default.func, onReset: _propTypes2.default.func, onSubmit: _propTypes2.default.func, onValidate: _propTypes2.default.func, theme: _propTypes3.themeShape }, Form.defaultProps = { theme: (0, _themes.createTheme)() }, Form.displayName = 'Form';var FormWithTheme = (0, _withCommonProps2.default)(Form);FormWithTheme.WrappedComponent = Form, exports.default = FormWithTheme;

/***/ },
/* 418 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _typeof = 'function' == typeof Symbol && 'symbol' == _typeof2(Symbol.iterator) ? function (obj) {
	  return typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
	} : function (obj) {
	  return obj && 'function' == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? 'symbol' : typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
	},
	    _extends = Object.assign || function (target) {
	  for (var source, i = 1; i < arguments.length; i++) {
	    for (var key in source = arguments[i], source) {
	      Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
	    }
	  }return target;
	},
	    _createClass = function () {
	  function defineProperties(target, props) {
	    for (var descriptor, i = 0; i < props.length; i++) {
	      descriptor = props[i], descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, 'value' in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    return protoProps && defineProperties(Constructor.prototype, protoProps), staticProps && defineProperties(Constructor, staticProps), Constructor;
	  };
	}(),
	    _react = __webpack_require__(3),
	    _react2 = _interopRequireDefault(_react),
	    _propTypes = __webpack_require__(6),
	    _propTypes2 = _interopRequireDefault(_propTypes),
	    _FormContext = __webpack_require__(192),
	    _FormContext2 = _interopRequireDefault(_FormContext);Object.defineProperty(exports, '__esModule', { value: !0 });function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
	}function _possibleConstructorReturn(self, call) {
	  if (!self) throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');return call && ('object' == (typeof call === 'undefined' ? 'undefined' : _typeof2(call)) || 'function' == typeof call) ? call : self;
	}function _inherits(subClass, superClass) {
	  if ('function' != typeof superClass && null !== superClass) throw new TypeError('Super expression must either be null or a function, not ' + (typeof superClass === 'undefined' ? 'undefined' : _typeof2(superClass)));subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: !1, writable: !0, configurable: !0 } }), superClass && (Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass);
	}var FormControl = function (_Component) {
	  function FormControl(props) {
	    _classCallCheck(this, FormControl);var _this = _possibleConstructorReturn(this, (FormControl.__proto__ || Object.getPrototypeOf(FormControl)).call(this, props));return _this.state = { checked: !1, checkedFormControlValue: !1, dirty: !1, focused: !1, invalid: !1, readyToValidate: !1, touched: !1, value: '' }, _this.focus = _this.focus.bind(_this), _this.handleBlur = _this.handleBlur.bind(_this), _this.handleChange = _this.handleChange.bind(_this), _this.handleFocus = _this.handleFocus.bind(_this), _this.handleNativeFormControlRef = _this.handleNativeFormControlRef.bind(_this), _this.handleValidate = _this.handleValidate.bind(_this), _this.reset = _this.reset.bind(_this), _this.validate = _this.validate.bind(_this), _this;
	  }return _inherits(FormControl, _Component), _createClass(FormControl, [{ key: 'componentWillMount', value: function componentWillMount() {
	      var _props = this.props,
	          checkedProp = _props.checked,
	          defaultCheckedProp = _props.defaultChecked,
	          defaultValueProp = _props.defaultValue,
	          type = _props.type,
	          valueProp = _props.value,
	          checked = this.getChecked(checkedProp),
	          defaultChecked = this.getChecked(defaultCheckedProp),
	          defaultValue = this.getValue(defaultValueProp),
	          value = this.getValue(valueProp),
	          usesChecked = 'checkbox' === type || 'radio' === type;this.isControlled = usesChecked ? void 0 !== checked : void 0 !== value, usesChecked ? this.setState({ defaultChecked: defaultChecked, checkedFormControlValue: this.isControlled ? checked : void 0, checked: checked }) : this.setState({ defaultValue: defaultValue, value: this.isControlled ? value : void 0 });
	    } }, { key: 'componentWillReceiveProps', value: function componentWillReceiveProps(nextProps) {
	      var checked = this.getChecked(nextProps.checked),
	          value = this.getValue(nextProps.value),
	          updatedState = { value: value };void 0 !== checked && (updatedState.checkedFormControlValue = checked, updatedState.checked = checked), this.setState(updatedState);
	    } }, { key: 'getChecked', value: function getChecked(checked) {
	      return null !== checked && checked;
	    } }, { key: 'getValue', value: function getValue(value) {
	      return null === value ? '' : value;
	    } }, { key: 'focus', value: function focus() {
	      this.nativeFormControl.focus();
	    } }, { key: 'reset', value: function reset() {
	      var type = this.props.type;this.setState({ dirty: !1, invalid: !1, readyToValidate: !1, touched: !1 }), ('checkbox' === type || 'radio' === type) && this.setState({ checked: !1 }), this.isControlled || ('checkbox' === type || 'radio' === type ? this.nativeFormControl.checked = !1 : this.nativeFormControl.value = ''), this.handleValidate({ valid: !0 });
	    } }, { key: 'validate', value: function validate(callback) {
	      this.handleValidate(this.nativeFormControl.validity, { callback: callback });
	    } }, { key: 'handleBlur', value: function handleBlur(event) {
	      var _this2 = this,
	          validity = event.target.validity,
	          onFormControlBlur = this.props.onFormControlBlur,
	          _state = this.state,
	          dirty = _state.dirty,
	          readyToValidate = _state.readyToValidate;this.setState({ focused: !1, touched: !0, readyToValidate: dirty }, function () {
	        !readyToValidate && dirty && _this2.handleValidate(validity);
	      }), onFormControlBlur && onFormControlBlur(event);
	    } }, { key: 'handleChange', value: function handleChange(event) {
	      var _this3 = this,
	          input = event.target,
	          checked = input.checked,
	          type = input.type,
	          validity = input.validity,
	          value = input.value,
	          onFormControlChange = this.props.onFormControlChange,
	          readyToValidate = this.state.readyToValidate;if (this.setState({ dirty: !0 }), ('checkbox' === type || 'radio' === type) && this.setState({ checked: checked }), this.isControlled) {
	        var updatedState = {};'checkbox' === type || 'radio' === type ? updatedState.checkedFormControlValue = checked : updatedState.value = value, this.setState(updatedState, function () {
	          readyToValidate && _this3.handleValidate(validity);
	        });
	      }onFormControlChange && onFormControlChange(event), !this.isControlled && readyToValidate && this.handleValidate(validity);
	    } }, { key: 'handleFocus', value: function handleFocus(event) {
	      var onFormControlFocus = this.props.onFormControlFocus;this.setState({ focused: !0 }), onFormControlFocus && onFormControlFocus(event);
	    } }, { key: 'handleNativeFormControlRef', value: function handleNativeFormControlRef(node) {
	      var nativeFormControlRef = this.props.nativeFormControlRef;this.nativeFormControl = node, this.nativeFormControl && this.registerFormControl && this.registerFormControl({ focus: this.focus, id: this.nativeFormControl.id, reset: this.reset, validate: this.validate }), nativeFormControlRef && nativeFormControlRef(node);
	    } }, { key: 'handleValidate', value: function handleValidate(validity, options) {
	      var _this4 = this,
	          onValidate = this.props.onValidate;onValidate(validity, options, _extends({ updateValidationState: function updateValidationState(valid, validationMessage, onValidateCallback) {
	          _this4.setState({ invalid: !valid }), onValidateCallback && onValidateCallback(valid, validationMessage);
	        } }, this.state));
	    } }, { key: 'render', value: function render() {
	      var _this5 = this,
	          _state2 = this.state,
	          checked = _state2.checked,
	          checkedFormControlValue = _state2.checkedFormControlValue,
	          defaultChecked = _state2.defaultChecked,
	          defaultValue = _state2.defaultValue,
	          focused = _state2.focused,
	          invalid = _state2.invalid,
	          value = _state2.value;return _react2.default.createElement(_FormContext2.default.Consumer, null, function (registerFormControl) {
	        return _this5.registerFormControl = registerFormControl, _this5.props.render({ checked: checked, checkedFormControlValue: checkedFormControlValue, defaultChecked: defaultChecked, defaultValue: defaultValue, focused: focused, invalid: invalid, handleBlur: _this5.handleBlur, handleChange: _this5.handleChange, handleFocus: _this5.handleFocus, handleNativeFormControlRef: _this5.handleNativeFormControlRef, value: value });
	      });
	    } }]), FormControl;
	}(_react.Component);FormControl.propTypes = { checked: _propTypes2.default.bool, defaultChecked: _propTypes2.default.bool, defaultValue: function defaultValue(props, propName, componentName) {
	    if (props[propName] !== void 0) {
	      if (props.value !== void 0) throw new Error('Props `defaultValue` and `value` are both defined in `' + componentName + '`, but only one is allowed. Use `defaultValue` for an uncontrolled component, or `value` for a controlled component.');if ('string' != typeof props[propName] && null !== props[propName]) return new Error('Invalid prop `' + propName + '` of type `' + _typeof(props[propName]) + '` supplied to `' + componentName + '`, expected `string`, or a value of `null`.');
	    }
	  }, nativeFormControlRef: _propTypes2.default.func, onFormControlBlur: _propTypes2.default.func, onFormControlChange: _propTypes2.default.func, onFormControlFocus: _propTypes2.default.func, onValidate: _propTypes2.default.func, render: _propTypes2.default.func, type: _propTypes2.default.string, value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]) }, FormControl.defaultProps = {}, FormControl.displayName = 'FormControl', FormControl.WrappedComponent = FormControl, exports.default = FormControl;

/***/ },
/* 419 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) {
	  for (var source, i = 1; i < arguments.length; i++) {
	    for (var key in source = arguments[i], source) {
	      Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
	    }
	  }return target;
	},
	    _createClass = function () {
	  function defineProperties(target, props) {
	    for (var descriptor, i = 0; i < props.length; i++) {
	      descriptor = props[i], descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, 'value' in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    return protoProps && defineProperties(Constructor.prototype, protoProps), staticProps && defineProperties(Constructor, staticProps), Constructor;
	  };
	}(),
	    _react = __webpack_require__(3),
	    _react2 = _interopRequireDefault(_react),
	    _propTypes = __webpack_require__(6),
	    _propTypes2 = _interopRequireDefault(_propTypes),
	    _styledComponents = __webpack_require__(15),
	    _styledComponents2 = _interopRequireDefault(_styledComponents),
	    _styles = __webpack_require__(31),
	    _withCommonProps = __webpack_require__(38),
	    _withCommonProps2 = _interopRequireDefault(_withCommonProps),
	    _themes = __webpack_require__(4),
	    _propTypes3 = __webpack_require__(16),
	    _componentTheme = __webpack_require__(420),
	    _componentTheme2 = _interopRequireDefault(_componentTheme);Object.defineProperty(exports, '__esModule', { value: !0 });function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}function _objectWithoutProperties(obj, keys) {
	  var target = {};for (var i in obj) {
	    0 <= keys.indexOf(i) || Object.prototype.hasOwnProperty.call(obj, i) && (target[i] = obj[i]);
	  }return target;
	}function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
	}function _possibleConstructorReturn(self, call) {
	  if (!self) throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');return call && ('object' == (typeof call === 'undefined' ? 'undefined' : _typeof(call)) || 'function' == typeof call) ? call : self;
	}function _inherits(subClass, superClass) {
	  if ('function' != typeof superClass && null !== superClass) throw new TypeError('Super expression must either be null or a function, not ' + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: !1, writable: !0, configurable: !0 } }), superClass && (Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass);
	}var Styled = { div: _styledComponents2.default.div.withConfig({ displayName: 'FormControlMessage__div' })(['', ';color:', ';font-family:', ';font-size:', ';font-weight:', ';-webkit-font-smoothing:antialiased;transition-property:none;transition-duration:', ';transition-timing-function:', ';'], function (props) {
	    return props.sc.inheritStyles ? '' : (0, _styles.resetInheritedStyles)({ direction: props.theme.vstui.i18n.direction });
	  }, function (props) {
	    return props.sc.disabled ? (0, _themes.getStyle)('FormControlMessage_color_disabled') : props.sc.error ? (0, _themes.getStyle)('FormControlMessage_color_error') : (0, _themes.getStyle)('FormControlMessage_color');
	  }, (0, _themes.getStyle)('FormControlMessage_fontFamily'), function (props) {
	    return (0, _themes.getStyle)('FormControlMessage_fontSize_' + props.sc.size);
	  }, (0, _themes.getStyle)('FormControlMessage_fontWeight'), function (props) {
	    return props.theme.vstui.transition.duration.shortest;
	  }, function (props) {
	    return props.theme.vstui.transition.easing.easeIn;
	  }) },
	    FormControlMessage = function (_PureComponent) {
	  function FormControlMessage() {
	    return _classCallCheck(this, FormControlMessage), _possibleConstructorReturn(this, (FormControlMessage.__proto__ || Object.getPrototypeOf(FormControlMessage)).apply(this, arguments));
	  }return _inherits(FormControlMessage, _PureComponent), _createClass(FormControlMessage, [{ key: 'render', value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          commonProps = _props.commonProps,
	          disabled = _props.disabled,
	          error = _props.error,
	          inheritStyles = _props.inheritStyles,
	          size = _props.size,
	          themeProp = _props.theme,
	          otherProps = _objectWithoutProperties(_props, ['className', 'commonProps', 'disabled', 'error', 'inheritStyles', 'size', 'theme']),
	          theme = (0, _componentTheme2.default)(themeProp);return _react2.default.createElement(Styled.div, _extends({}, commonProps, otherProps, { className: className, "data-vstui-test": 'FormControlMessage', sc: { disabled: disabled, error: error, inheritStyles: inheritStyles, size: size }, theme: theme }), this.props.children);
	    } }]), FormControlMessage;
	}(_react.PureComponent);FormControlMessage.propTypes = { children: _propTypes2.default.node.isRequired, className: _propTypes2.default.string, commonProps: _propTypes3.commonPropsShape, disabled: _propTypes2.default.bool, error: _propTypes2.default.bool, inheritStyles: _propTypes2.default.bool, size: _propTypes2.default.oneOf(['small', 'medium', 'large']), theme: _propTypes3.themeShape }, FormControlMessage.defaultProps = { size: 'medium', theme: (0, _themes.createTheme)() }, FormControlMessage.displayName = 'FormControlMessage';var FormControlMessageWithTheme = (0, _withCommonProps2.default)(FormControlMessage);FormControlMessageWithTheme.WrappedComponent = FormControlMessage, exports.default = FormControlMessageWithTheme;

/***/ },
/* 420 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	Object.defineProperty(exports, '__esModule', { value: !0 });var _themes = __webpack_require__(4),
	    componentTheme = function componentTheme(baseTheme) {
	  var _baseTheme$vstui = baseTheme.vstui,
	      color = _baseTheme$vstui.color,
	      rem = _baseTheme$vstui.rem,
	      typography = _baseTheme$vstui.typography;return (0, _themes.createComponentTheme)(baseTheme, { FormControlMessage_fontFamily: typography.fontFamily, FormControlMessage_fontSize_small: rem(typography.fontSize - 1), FormControlMessage_fontSize_medium: rem(typography.fontSize - 1), FormControlMessage_fontSize_large: rem(typography.fontSize), FormControlMessage_fontWeight: typography.fontWeightRegular, FormControlMessage_color: color.onSurface, FormControlMessage_color_disabled: 'rgba(0, 0, 0, 0.57)', FormControlMessage_color_error: color.error });
	};exports.default = componentTheme;

/***/ },
/* 421 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	Object.defineProperty(exports, '__esModule', { value: !0 });var _FormControlMessage = __webpack_require__(419);Object.defineProperty(exports, 'default', { enumerable: !0, get: function get() {
	    return _interopRequireDefault(_FormControlMessage).default;
	  } });function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}

/***/ },
/* 422 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) {
	  for (var source, i = 1; i < arguments.length; i++) {
	    for (var key in source = arguments[i], source) {
	      Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
	    }
	  }return target;
	},
	    _createClass = function () {
	  function defineProperties(target, props) {
	    for (var descriptor, i = 0; i < props.length; i++) {
	      descriptor = props[i], descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, 'value' in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    return protoProps && defineProperties(Constructor.prototype, protoProps), staticProps && defineProperties(Constructor, staticProps), Constructor;
	  };
	}(),
	    _react = __webpack_require__(3),
	    _react2 = _interopRequireDefault(_react),
	    _propTypes = __webpack_require__(6),
	    _propTypes2 = _interopRequireDefault(_propTypes),
	    _styledComponents = __webpack_require__(15),
	    _styledComponents2 = _interopRequireDefault(_styledComponents),
	    _propTypes3 = __webpack_require__(16),
	    _withCommonProps = __webpack_require__(38),
	    _withCommonProps2 = _interopRequireDefault(_withCommonProps),
	    _themes = __webpack_require__(4),
	    _styles = __webpack_require__(31),
	    _Label = __webpack_require__(185),
	    _Label2 = _interopRequireDefault(_Label),
	    _FormControlMessage = __webpack_require__(421),
	    _FormControlMessage2 = _interopRequireDefault(_FormControlMessage);Object.defineProperty(exports, '__esModule', { value: !0 });function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
	}function _possibleConstructorReturn(self, call) {
	  if (!self) throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');return call && ('object' == (typeof call === 'undefined' ? 'undefined' : _typeof(call)) || 'function' == typeof call) ? call : self;
	}function _inherits(subClass, superClass) {
	  if ('function' != typeof superClass && null !== superClass) throw new TypeError('Super expression must either be null or a function, not ' + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: !1, writable: !0, configurable: !0 } }), superClass && (Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass);
	}var Styled = {};Styled.div = {}, Styled.div.root = _styledComponents2.default.div.withConfig({ displayName: 'FormGroup__root' })(['', ';width:', ';max-width:100%;margin:0 0 20px 0;font-size:10px;vertical-align:top;'], function (props) {
	  return props.sc.inheritStyles ? '' : (0, _styles.resetInheritedStyles)({ direction: props.theme.vstui.i18n.direction });
	}, function (_ref) {
	  var sc = _ref.sc;return sc.fullWidth ? '100%' : '270px';
	}), Styled.Label = (0, _styledComponents2.default)(_Label2.default).withConfig({ displayName: 'FormGroup__Label' })(['display:block;margin:0 0 7px 0;']), Styled.Label.displayName = 'Styled_Label', Styled.FormControlMessage = (0, _styledComponents2.default)(_FormControlMessage2.default).withConfig({ displayName: 'FormGroup__FormControlMessage' })(['margin:7px 0 0 0;']), Styled.FormControlMessage.displayName = 'Styled_FormControlMessage';var FormGroup = function (_PureComponent) {
	  function FormGroup() {
	    return _classCallCheck(this, FormGroup), _possibleConstructorReturn(this, (FormGroup.__proto__ || Object.getPrototypeOf(FormGroup)).apply(this, arguments));
	  }return _inherits(FormGroup, _PureComponent), _createClass(FormGroup, [{ key: 'renderCheckboxControl', value: function renderCheckboxControl() {
	      var _props = this.props,
	          checkboxControl = _props.checkboxControl,
	          disabled = _props.disabled,
	          fullWidth = _props.fullWidth,
	          id = _props.id,
	          label = _props.label,
	          labelHidden = _props.labelHidden,
	          secondary = _props.secondary,
	          size = _props.size,
	          theme = _props.theme;return checkboxControl ? _react2.default.cloneElement(checkboxControl, { disabled: disabled, fullWidth: fullWidth, id: id, inheritStyles: !0, label: label, labelHidden: labelHidden, secondary: secondary, size: size, theme: theme }) : null;
	    } }, { key: 'renderFormControl', value: function renderFormControl() {
	      var conditionalProps = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {},
	          _props2 = this.props,
	          disabled = _props2.disabled,
	          formControl = _props2.formControl,
	          fullWidth = _props2.fullWidth,
	          id = _props2.id,
	          secondary = _props2.secondary,
	          size = _props2.size,
	          theme = _props2.theme;return formControl ? _react2.default.cloneElement(formControl, _extends({}, conditionalProps, { disabled: disabled, fullWidth: fullWidth, id: id, inheritStyles: !0, secondary: secondary, size: size, theme: theme })) : null;
	    } }, { key: 'render', value: function render() {
	      var _props3 = this.props,
	          className = _props3.className,
	          commonProps = _props3.commonProps,
	          disabled = _props3.disabled,
	          fullWidth = _props3.fullWidth,
	          helperText = _props3.helperText,
	          id = _props3.id,
	          inheritStyles = _props3.inheritStyles,
	          label = _props3.label,
	          labelHidden = _props3.labelHidden,
	          rootProps = _props3.rootProps,
	          secondary = _props3.secondary,
	          size = _props3.size,
	          theme = _props3.theme,
	          validationMessage = _props3.validationMessage,
	          formControlMessage = validationMessage || helperText,
	          formControlMessageId = id + '-form-control-message',
	          conditionalFormControlProps = {};formControlMessage && (conditionalFormControlProps['aria-describedby'] = formControlMessageId);var checkboxControl = this.renderCheckboxControl(),
	          formControl = this.renderFormControl(conditionalFormControlProps);return _react2.default.createElement(Styled.div.root, _extends({}, commonProps, rootProps, { className: className, sc: { fullWidth: fullWidth, inheritStyles: inheritStyles }, theme: theme }), formControl && label && _react2.default.createElement(Styled.Label, { disabled: disabled, htmlFor: id, inheritStyles: !0, secondary: secondary, size: size, theme: theme, visuallyHidden: labelHidden }, label), formControl || checkboxControl, formControlMessage && _react2.default.createElement(Styled.FormControlMessage, { disabled: disabled, error: !!validationMessage, id: formControlMessageId, inheritStyles: !0, secondary: secondary, size: size, theme: theme }, formControlMessage));
	    } }]), FormGroup;
	}(_react.PureComponent);FormGroup.propTypes = { checkboxControl: _propTypes2.default.node, className: _propTypes2.default.string, commonProps: _propTypes3.commonPropsShape, disabled: _propTypes2.default.bool, formControl: _propTypes2.default.node, fullWidth: _propTypes2.default.bool, helperText: _propTypes2.default.string, id: _propTypes2.default.string, inheritStyles: _propTypes2.default.bool, label: _propTypes2.default.node, labelHidden: _propTypes2.default.bool, rootProps: _propTypes2.default.object, secondary: _propTypes2.default.bool, size: _propTypes2.default.oneOf(['small', 'medium', 'large']), theme: _propTypes3.themeShape, validationMessage: _propTypes2.default.string }, FormGroup.defaultProps = { theme: (0, _themes.createTheme)() }, FormGroup.displayName = 'FormGroup';var FormGroupWithTheme = (0, _withCommonProps2.default)(FormGroup);FormGroupWithTheme.WrappedComponent = FormGroup, exports.default = FormGroupWithTheme;

/***/ },
/* 423 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) {
	  for (var source, i = 1; i < arguments.length; i++) {
	    for (var key in source = arguments[i], source) {
	      Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
	    }
	  }return target;
	},
	    _createClass = function () {
	  function defineProperties(target, props) {
	    for (var descriptor, i = 0; i < props.length; i++) {
	      descriptor = props[i], descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, 'value' in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    return protoProps && defineProperties(Constructor.prototype, protoProps), staticProps && defineProperties(Constructor, staticProps), Constructor;
	  };
	}(),
	    _react = __webpack_require__(3),
	    _react2 = _interopRequireDefault(_react),
	    _propTypes = __webpack_require__(6),
	    _propTypes2 = _interopRequireDefault(_propTypes),
	    _styledComponents = __webpack_require__(15),
	    _styledComponents2 = _interopRequireDefault(_styledComponents),
	    _themes = __webpack_require__(4),
	    _propTypes3 = __webpack_require__(16);Object.defineProperty(exports, '__esModule', { value: !0 });function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}function _objectWithoutProperties(obj, keys) {
	  var target = {};for (var i in obj) {
	    0 <= keys.indexOf(i) || Object.prototype.hasOwnProperty.call(obj, i) && (target[i] = obj[i]);
	  }return target;
	}function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
	}function _possibleConstructorReturn(self, call) {
	  if (!self) throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');return call && ('object' == (typeof call === 'undefined' ? 'undefined' : _typeof(call)) || 'function' == typeof call) ? call : self;
	}function _inherits(subClass, superClass) {
	  if ('function' != typeof superClass && null !== superClass) throw new TypeError('Super expression must either be null or a function, not ' + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: !1, writable: !0, configurable: !0 } }), superClass && (Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass);
	}var Styled = { svg: _styledComponents2.default.svg.withConfig({ displayName: 'Icon__svg' })(['display:inline-block;width:', 'px;height:', 'px;vertical-align:top;transform:', ';pointer-events:none;fill:', ';.color1{fill:', ';}.color2{fill:', ';}.color3{fill:', ';}'], function (props) {
	    return props.sc.width;
	  }, function (props) {
	    return props.sc.height;
	  }, function (props) {
	    return props.sc.mirrored ? 'scaleX(-1)' : 'none';
	  }, function (props) {
	    return props.sc.color.color1;
	  }, function (props) {
	    return props.sc.color.color1;
	  }, function (props) {
	    return props.sc.color.color2;
	  }, function (props) {
	    return props.sc.color.color3;
	  }) },
	    Icon = function (_React$Component) {
	  function Icon() {
	    return _classCallCheck(this, Icon), _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
	  }return _inherits(Icon, _React$Component), _createClass(Icon, [{ key: 'render', value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          colorProp = _props.color,
	          height = _props.height,
	          rtlProp = _props.rtl,
	          theme = _props.theme,
	          width = _props.width,
	          otherProps = _objectWithoutProperties(_props, ['children', 'color', 'height', 'rtl', 'theme', 'width']),
	          i18n = theme.vstui.i18n,
	          color = {};'string' == typeof colorProp ? color.color1 = colorProp : color = Object.assign({}, colorProp);var rtl = !1;'boolean' == typeof rtlProp ? rtl = rtlProp : rtlProp && rtlProp.forEach(function (locale) {
	        locale === i18n.locale && (rtl = !0);
	      });var mirrored = rtl && 'rtl' === theme.vstui.direction;return _react2.default.createElement(Styled.svg, _extends({ "aria-hidden": !0, focusable: 'false', sc: { color: color, height: height, mirrored: mirrored, width: width }, theme: theme, viewBox: '0 0 ' + width + ' ' + height }, otherProps), children);
	    } }]), Icon;
	}(_react2.default.Component);Icon.propTypes = { children: _propTypes2.default.node.isRequired, color: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({ color1: _propTypes2.default.string.isRequired, color2: _propTypes2.default.string.isRequired, color3: _propTypes2.default.string })]), height: _propTypes2.default.number.isRequired, rtl: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.arrayOf(_propTypes2.default.string)]), theme: _propTypes3.themeShape, width: _propTypes2.default.number.isRequired }, Icon.defaultProps = { color: 'currentColor', theme: (0, _themes.createTheme)() }, Icon.vstuiName = 'Icon', Icon.displayName = 'Icon';var IconWithTheme = (0, _themes.withTheme)(Icon);IconWithTheme.WrappedComponent = Icon, exports.default = IconWithTheme;

/***/ },
/* 424 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _typeof = 'function' == typeof Symbol && 'symbol' == _typeof2(Symbol.iterator) ? function (obj) {
	  return typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
	} : function (obj) {
	  return obj && 'function' == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? 'symbol' : typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
	},
	    _extends = Object.assign || function (target) {
	  for (var source, i = 1; i < arguments.length; i++) {
	    for (var key in source = arguments[i], source) {
	      Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
	    }
	  }return target;
	},
	    _createClass = function () {
	  function defineProperties(target, props) {
	    for (var descriptor, i = 0; i < props.length; i++) {
	      descriptor = props[i], descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, 'value' in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    return protoProps && defineProperties(Constructor.prototype, protoProps), staticProps && defineProperties(Constructor, staticProps), Constructor;
	  };
	}(),
	    _react = __webpack_require__(3),
	    _react2 = _interopRequireDefault(_react),
	    _propTypes = __webpack_require__(6),
	    _propTypes2 = _interopRequireDefault(_propTypes),
	    _styledComponents = __webpack_require__(15),
	    _styledComponents2 = _interopRequireDefault(_styledComponents),
	    _styles = __webpack_require__(31),
	    _withCommonProps = __webpack_require__(38),
	    _withCommonProps2 = _interopRequireDefault(_withCommonProps),
	    _themes = __webpack_require__(4),
	    _propTypes3 = __webpack_require__(16),
	    _colors = __webpack_require__(101),
	    _icons = __webpack_require__(102),
	    _FormControl = __webpack_require__(100),
	    _FormControl2 = _interopRequireDefault(_FormControl),
	    _Button = __webpack_require__(58),
	    _Button2 = _interopRequireDefault(_Button),
	    _componentTheme = __webpack_require__(425),
	    _componentTheme2 = _interopRequireDefault(_componentTheme);Object.defineProperty(exports, '__esModule', { value: !0 });function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}function _objectWithoutProperties(obj, keys) {
	  var target = {};for (var i in obj) {
	    0 <= keys.indexOf(i) || Object.prototype.hasOwnProperty.call(obj, i) && (target[i] = obj[i]);
	  }return target;
	}function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
	}function _possibleConstructorReturn(self, call) {
	  if (!self) throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');return call && ('object' == (typeof call === 'undefined' ? 'undefined' : _typeof2(call)) || 'function' == typeof call) ? call : self;
	}function _inherits(subClass, superClass) {
	  if ('function' != typeof superClass && null !== superClass) throw new TypeError('Super expression must either be null or a function, not ' + (typeof superClass === 'undefined' ? 'undefined' : _typeof2(superClass)));subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: !1, writable: !0, configurable: !0 } }), superClass && (Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass);
	}var cloud6 = _colors.cloud.getShade(6),
	    ClearButton = (0, _themes.createThemedComponent)(_Button2.default, { Button_color_neutralNaked: cloud6, Button_color_neutralNaked_active: cloud6, Button_color_neutralNaked_focus: cloud6, Button_color_neutralNaked_hover: cloud6, Button_boxShadow_neutralNaked_focus: '' }),
	    Styled = { div: {} };Styled.div.root = _styledComponents2.default.div.withConfig({ displayName: 'InputControl__root' })(['', ';position:relative;display:inline-block;width:', ';max-width:100%;& > svg{position:absolute;top:0;left:0;width:12px;height:12px;margin:', ';color:', ';}'], function (props) {
	  return props.sc.inheritStyles ? '' : (0, _styles.resetInheritedStyles)({ direction: props.theme.vstui.i18n.direction });
	}, function (props) {
	  return props.sc.fullWidth ? '100%' : (0, _themes.getStyle)('InputControl_width');
	}, function (props) {
	  var size = (0, _themes.getStyle)('InputControl_minHeight_' + props.sc.size)(props),
	      verticalMargin = (size - 12) / 2;return verticalMargin + 'px 8px ' + verticalMargin + 'px 16px';
	}, function (props) {
	  return props.theme.vstui.color.cloud.getMainShade;
	}), Styled.input = _styledComponents2.default.input.withConfig({ displayName: 'InputControl__input' })(['box-sizing:border-box;width:100%;min-height:', ';margin:0;padding:', ';background-color:', ';background-image:', ';background-position:', ';background-repeat:no-repeat;background-size:', ';border-color:', ';border-style:', ';border-width:', ';border-radius:', ';color:', ';font-family:', ';font-size:', ';font-weight:', ';-webkit-font-smoothing:antialiased;text-align:start;transition-property:none;transition-duration:', ';transition-timing-function:', ';appearance:none;&[type=\'checkbox\'],&[type=\'radio\']{', ';}&[type=\'search\']{border-radius:', ';&::-ms-clear{display:none;}&::-webkit-search-cancel-button{appearance:none;}}&::-moz-placeholder{opacity:1;}&::placeholder{color:', ';font-weight:', ';text-align:', ';}&:required{box-shadow:none;}&:read-only{background-color:', ';color:', ';}&:focus{outline:none;border-color:', ';box-shadow:', ';}&[aria-invalid]{padding-right:', 'px;padding-left:', 'px;background-image:', ';border-color:', ';box-shadow:none;&:focus{background-image:', ';border-color:', ';box-shadow:', ';}}&:disabled{background-color:', ';border-color:', ';color:', ';cursor:default;}'], function (props) {
	  return props.theme.vstui.rem((0, _themes.getStyle)('InputControl_minHeight_' + props.sc.size)(props));
	}, function (props) {
	  var paddingLeft = '12px',
	      paddingRight = '12px';return props.sc.showClearButton && (paddingRight = '36px'), props.sc.hasIcon && (paddingLeft = '36px'), '0 ' + paddingRight + ' 0 ' + paddingLeft;
	}, (0, _themes.getStyle)('InputControl_backgroundColor'), (0, _themes.getStyle)('InputControl_backgroundImage'), function (props) {
	  return (0, _themes.getStyle)('InputControl_backgroundPosition_' + props.sc.size)(props);
	}, (0, _themes.getStyle)('InputControl_backgroundSize'), (0, _themes.getStyle)('InputControl_borderColor'), (0, _themes.getStyle)('InputControl_borderStyle'), (0, _themes.getStyle)('InputControl_borderWidth'), (0, _themes.getStyle)('InputControl_borderRadius'), (0, _themes.getStyle)('InputControl_color'), (0, _themes.getStyle)('InputControl_fontFamily'), function (props) {
	  return props.theme.vstui.rem((0, _themes.getStyle)('InputControl_fontSize_' + props.sc.size)(props));
	}, (0, _themes.getStyle)('InputControl_fontWeight'), function (props) {
	  return props.theme.vstui.transition.duration.shortest;
	}, function (props) {
	  return props.theme.vstui.transition.easing.easeIn;
	}, (0, _styles.visuallyHidden)(), (0, _themes.getStyle)('InputControl_borderRadius_search'), (0, _themes.getStyle)('InputControlPlaceholder_color'), (0, _themes.getStyle)('InputControlPlaceholder_fontWeight'), function (props) {
	  return 'rtl' === props.theme.vstui.i18n.direction ? 'right' : 'left';
	}, (0, _themes.getStyle)('InputControl_backgroundColor_readOnly'), (0, _themes.getStyle)('InputControl_color_readOnly'), (0, _themes.getStyle)('InputControl_borderColor_focus'), (0, _themes.getStyle)('InputControl_boxShadow_focus'), function (props) {
	  return 'rtl' === props.theme.vstui.i18n.direction ? props.sc.hasIcon ? 36 : 12 : 38;
	}, function (props) {
	  return 'rtl' === props.theme.vstui.i18n.direction ? 38 : props.sc.hasIcon ? 36 : 12;
	}, (0, _themes.getStyle)('InputControl_backgroundImage_invalid'), (0, _themes.getStyle)('InputControl_borderColor_invalid'), (0, _themes.getStyle)('InputControl_backgroundImage_invalidFocus'), (0, _themes.getStyle)('InputControl_borderColor_invalidFocus'), (0, _themes.getStyle)('InputControl_boxShadow_focus'), (0, _themes.getStyle)('InputControl_backgroundColor_disabled'), (0, _themes.getStyle)('InputControl_borderColor_disabled'), (0, _themes.getStyle)('InputControl_color_disabled')), Styled.input.displayName = 'Styled_input', Styled.ClearButton = (0, _styledComponents2.default)(ClearButton).withConfig({ displayName: 'InputControl__ClearButton' })(['position:absolute;top:0;right:0;']);var InputControl = function (_Component) {
	  function InputControl() {
	    _classCallCheck(this, InputControl);var _this = _possibleConstructorReturn(this, (InputControl.__proto__ || Object.getPrototypeOf(InputControl)).call(this));return _this.state = { showClearButton: !1 }, _this.handleChange = _this.handleChange.bind(_this), _this.handleClearButtonClick = _this.handleClearButtonClick.bind(_this), _this.handleFormControlRef = _this.handleFormControlRef.bind(_this), _this.handleValidate = _this.handleValidate.bind(_this), _this.renderContent = _this.renderContent.bind(_this), _this;
	  }return _inherits(InputControl, _Component), _createClass(InputControl, [{ key: 'componentDidMount', value: function componentDidMount() {
	      this.props.onRef && this.props.onRef(this);
	    } }, { key: 'componentWillReceiveProps', value: function componentWillReceiveProps(nextProps) {
	      var clearButtonDisabled = nextProps.clearButtonDisabled,
	          defaultValue = nextProps.defaultValue,
	          onClearRequest = nextProps.onClearRequest,
	          type = nextProps.type,
	          value = nextProps.value;this.updateShowClearButtonState({ clearButtonDisabled: clearButtonDisabled, defaultValue: defaultValue, onClearRequest: onClearRequest, type: type, value: value });
	    } }, { key: 'componentWillUnmount', value: function componentWillUnmount() {
	      this.props.onRef && this.props.onRef(void 0);
	    } }, { key: 'getValidationMessage', value: function getValidationMessage(validity, _ref) {
	      var max = _ref.max,
	          maxLength = _ref.maxLength,
	          min = _ref.min,
	          minLength = _ref.minLength,
	          type = _ref.type,
	          value = _ref.value,
	          i18n = this.props.theme.vstui.i18n;if (validity.valueMissing) return 'checkbox' === type ? i18n.t('form.missingCheckbox') : 'email' === type ? i18n.t('form.missingEmail') : 'number' === type ? i18n.t('form.missingNumber') : 'password' === type ? i18n.t('form.missingPassword') : 'tel' === type ? i18n.t('form.missingTel') : 'url' === type ? i18n.t('form.missingUrl') : i18n.t('form.missingText');if (validity.typeMismatch) {
	        if ('email' === type) return i18n.t('form.typeMismatchEmail');if ('url' === type) return i18n.t('form.typeMismatchUrl');
	      } else {
	        if (validity.patternMismatch) return i18n.t('form.patternMismatch');if (validity.tooLong || validity.tooShort) {
	          var id = validity.tooLong ? 'form.shortenCharacters' : 'form.lengthenCharacters',
	              quantity = validity.tooLong ? maxLength : minLength,
	              changeCharacters = i18n.t(id, { quantity: quantity }),
	              currentlyUsingCharacters = i18n.t('form.currentlyUsingCharacters', { quantity: value.length });return i18n.t('form.badLength', { changeCharacters: changeCharacters, currentlyUsingCharacters: currentlyUsingCharacters });
	        }if (validity.rangeUnderflow) {
	          var _id = this.isTypeDatetime(type) ? 'form.rangeUnderflowDatetime' : 'form.rangeUnderflow';return i18n.t(_id, { min: min });
	        }if (validity.rangeOverflow) {
	          var _id2 = this.isTypeDatetime(type) ? 'form.rangeOverflowDatetime' : 'form.rangeOverflow';return i18n.t(_id2, { max: max });
	        }if (validity.stepMismatch) return 'Please enter a valid value.';if (validity.badInput) {
	          var _id3 = this.isTypeDatetime(type) ? 'form.badInputDatetime' : 'form.badInputNumber';return i18n.t(_id3);
	        }
	      }return '';
	    } }, { key: 'updateShowClearButtonState', value: function updateShowClearButtonState(_ref2) {
	      var clearButtonDisabled = _ref2.clearButtonDisabled,
	          defaultValue = _ref2.defaultValue,
	          onClearRequest = _ref2.onClearRequest,
	          type = _ref2.type,
	          value = _ref2.value,
	          showClearButton = this.state.showClearButton;if ('search' === type) {
	        if (clearButtonDisabled) return void this.setState({ showClearButton: !1 });this.formControl.isControlled ? onClearRequest && void 0 !== value && !!value !== showClearButton && this.setState({ showClearButton: !!value }) : void 0 !== defaultValue && !!defaultValue !== showClearButton ? this.setState({ showClearButton: !!defaultValue }) : void 0 !== value && !!value !== showClearButton && this.setState({ showClearButton: !!value });
	      } else showClearButton && this.setState({ showClearButton: !1 });
	    } }, { key: 'isTypeDatetime', value: function isTypeDatetime(type) {
	      return 'date' === type || 'datetime-local' === type || 'month' === type || 'time' === type || 'week' === type;
	    } }, { key: 'validate', value: function validate(callback) {
	      this.formControl.validate(callback);
	    } }, { key: 'handleChange', value: function handleChange(event) {
	      var value = event.target.value,
	          _props = this.props,
	          clearButtonDisabled = _props.clearButtonDisabled,
	          onChange = _props.onChange,
	          onClearRequest = _props.onClearRequest,
	          type = _props.type;this.updateShowClearButtonState({ clearButtonDisabled: clearButtonDisabled, onClearRequest: onClearRequest, type: type, value: value }), onChange && onChange(event);
	    } }, { key: 'handleClearButtonClick', value: function handleClearButtonClick(event) {
	      var _props2 = this.props,
	          onClearRequest = _props2.onClearRequest,
	          type = _props2.type;this.formControl.isControlled ? onClearRequest && (this.formControl.reset(), this.formControl.focus(), onClearRequest(event)) : (this.formControl.reset(), this.formControl.focus(), this.updateShowClearButtonState({ onClearRequest: onClearRequest, type: type, value: '' }));
	    } }, { key: 'handleFormControlRef', value: function handleFormControlRef(node) {
	      this.formControl = node;
	    } }, { key: 'handleValidate', value: function handleValidate(validity) {
	      var _ref4 = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {},
	          callback = _ref4.callback,
	          onlyValidateIfValid = _ref4.onlyValidateIfValid,
	          _ref3 = arguments[2],
	          checked = _ref3.checked,
	          updateValidationState = _ref3.updateValidationState,
	          value = _ref3.value,
	          _props3 = this.props,
	          max = _props3.max,
	          maxLength = _props3.maxLength,
	          min = _props3.min,
	          minLength = _props3.minLength,
	          onValidate = _props3.onValidate,
	          type = _props3.type,
	          validate = _props3.validate,
	          passedDefaultValidation = validity.valid,
	          defaultValidationMessage = this.getValidationMessage(validity, { checked: checked, max: max, maxLength: maxLength, min: min, minLength: minLength, type: type, value: value }),
	          customValidationMessagePromise = Promise.resolve(validate ? validate(value) : ''),
	          update = function update(valid, validationMessage) {
	        (!onlyValidateIfValid || onlyValidateIfValid && valid) && updateValidationState(valid, validationMessage, onValidate);
	      };update(passedDefaultValidation, defaultValidationMessage), passedDefaultValidation ? customValidationMessagePromise.then(function (customValidationMessage) {
	        var passedCustomValidation = !customValidationMessage;update(passedCustomValidation, customValidationMessage), callback && callback(passedCustomValidation, customValidationMessage);
	      }) : callback && callback(passedDefaultValidation, defaultValidationMessage);
	    } }, { key: 'renderContent', value: function renderContent(_ref5) {
	      var checked = _ref5.checked,
	          defaultChecked = _ref5.defaultChecked,
	          defaultValue = _ref5.defaultValue,
	          invalid = _ref5.invalid,
	          handleBlur = _ref5.handleBlur,
	          handleChange = _ref5.handleChange,
	          handleNativeFormControlRef = _ref5.handleNativeFormControlRef,
	          value = _ref5.value,
	          _props4 = this.props,
	          className = _props4.className,
	          clearButtonDisabledIgnored = _props4.clearButtonDisabled,
	          commonProps = _props4.commonProps,
	          disabled = _props4.disabled,
	          fullWidth = _props4.fullWidth,
	          iconProp = _props4.icon,
	          inheritStyles = _props4.inheritStyles,
	          labelledBy = _props4.labelledBy,
	          max = _props4.max,
	          maxLength = _props4.maxLength,
	          min = _props4.min,
	          minLength = _props4.minLength,
	          nativeFormControlRefIgnored = _props4.nativeFormControlRef,
	          onBlurIgnored = _props4.onBlur,
	          onChangeIgnored = _props4.onChange,
	          onValidateIgnored = _props4.onValidate,
	          pattern = _props4.pattern,
	          placeholder = _props4.placeholder,
	          readOnly = _props4.readOnly,
	          required = _props4.required,
	          secondaryIgnored = _props4.secondary,
	          size = _props4.size,
	          step = _props4.step,
	          themeProp = _props4.theme,
	          type = _props4.type,
	          validateIgnored = _props4.validate,
	          otherProps = _objectWithoutProperties(_props4, ['className', 'clearButtonDisabled', 'commonProps', 'disabled', 'fullWidth', 'icon', 'inheritStyles', 'labelledBy', 'max', 'maxLength', 'min', 'minLength', 'nativeFormControlRef', 'onBlur', 'onChange', 'onValidate', 'pattern', 'placeholder', 'readOnly', 'required', 'secondary', 'size', 'step', 'theme', 'type', 'validate']),
	          showClearButton = this.state.showClearButton,
	          theme = (0, _componentTheme2.default)(themeProp),
	          icon = iconProp || ('search' === type && null !== iconProp ? _react2.default.createElement(_icons.Search, null) : null),
	          hasIcon = !!icon,
	          conditionalProps = {};return invalid && (conditionalProps['aria-invalid'] = !0), required && (conditionalProps['aria-required'] = !0), _react2.default.createElement(Styled.div.root, _extends({}, commonProps, { sc: { fullWidth: fullWidth, inheritStyles: inheritStyles, size: size }, theme: theme }), _react2.default.createElement(Styled.input, _extends({}, otherProps, conditionalProps, { "aria-labelledby": labelledBy, checked: checked, className: className, defaultChecked: defaultChecked, defaultValue: defaultValue, dir: 'auto', disabled: disabled, innerRef: handleNativeFormControlRef, max: max, maxLength: maxLength, min: min, minLength: minLength, onBlur: handleBlur, onChange: handleChange, pattern: pattern, placeholder: placeholder, readOnly: readOnly, required: required, sc: { hasIcon: hasIcon, showClearButton: showClearButton, size: size }, step: step, theme: theme, type: type, value: value })), hasIcon && icon, showClearButton && _react2.default.createElement(Styled.ClearButton, { "aria-hidden": !0, color: 'neutral', iconStart: _react2.default.createElement(_icons.XSmall, null), naked: !0, onClick: this.handleClearButtonClick, size: size, tabIndex: -1, type: 'button' }));
	    } }, { key: 'render', value: function render() {
	      var _props5 = this.props,
	          checked = _props5.checked,
	          defaultChecked = _props5.defaultChecked,
	          defaultValue = _props5.defaultValue,
	          nativeFormControlRef = _props5.nativeFormControlRef,
	          onBlur = _props5.onBlur,
	          type = _props5.type,
	          value = _props5.value;return _react2.default.createElement(_FormControl2.default, { checked: checked, defaultChecked: defaultChecked, defaultValue: defaultValue, nativeFormControlRef: nativeFormControlRef, onFormControlBlur: onBlur, onFormControlChange: this.handleChange, onValidate: this.handleValidate, ref: this.handleFormControlRef, render: this.renderContent, type: type, value: value });
	    } }]), InputControl;
	}(_react.Component);InputControl.propTypes = { checked: _propTypes2.default.bool, className: _propTypes2.default.string, clearButtonDisabled: _propTypes2.default.bool, commonProps: _propTypes3.commonPropsShape, defaultChecked: _propTypes2.default.bool, defaultValue: function defaultValue(props, propName, componentName) {
	    if (props[propName] !== void 0) {
	      if (props.value !== void 0) throw new Error('Props `defaultValue` and `value` are both defined in `' + componentName + '`, but only one is allowed. Use `defaultValue` for an uncontrolled component, or `value` for a controlled component.');if ('string' != typeof props[propName] && 'number' != typeof props[propName] && null !== props[propName]) return new Error('Invalid prop `' + propName + '` of type `' + _typeof(props[propName]) + '` supplied to `' + componentName + '`, expected `string`, `number`, or a value of `null`.');
	    }
	  }, disabled: _propTypes2.default.bool, fullWidth: _propTypes2.default.bool, icon: function icon(props, propName, componentName) {
	    var icon = props[propName];if (icon && 'Icon' !== icon.type.vstuiName) return new Error('Invalid prop `' + propName + '` of type `' + icon.type.displayName + '` supplied to `' + componentName + '`, expected instance of `Icon`.');
	  }, i18n: _propTypes3.i18nShape, inheritStyles: _propTypes2.default.bool, labelledBy: _propTypes2.default.string, max: function max(props, propName, componentName) {
	    if (props[propName] !== void 0 && 'number' != typeof props[propName] && 'string' != typeof props[propName]) return new Error('Invalid prop `' + propName + '` of type `' + _typeof(props[propName]) + '` supplied to `' + componentName + '`, expected `number` or `string`.');
	  }, maxLength: function maxLength(props, propName, componentName) {
	    if (props[propName] !== void 0 && 'number' != typeof props[propName]) return new Error('Invalid prop `' + propName + '` of type `' + _typeof(props[propName]) + '` supplied to `' + componentName + '`, expected `number`.');
	  }, min: function min(props, propName, componentName) {
	    if (props[propName] !== void 0 && 'number' != typeof props[propName] && 'string' != typeof props[propName]) return new Error('Invalid prop `' + propName + '` of type `' + _typeof(props[propName]) + '` supplied to `' + componentName + '`, expected `number` or `string`.');
	  }, minLength: function minLength(props, propName, componentName) {
	    if (props[propName] !== void 0 && 'number' != typeof props[propName]) return new Error('Invalid prop `' + propName + '` of type `' + _typeof(props[propName]) + '` supplied to `' + componentName + '`, expected `number`.');
	  }, nativeFormControlRef: _propTypes2.default.func, onBlur: _propTypes2.default.func, onChange: _propTypes2.default.func, onClearRequest: _propTypes2.default.func, onRef: _propTypes2.default.func, onValidate: _propTypes2.default.func, pattern: _propTypes2.default.string, placeholder: _propTypes2.default.string, readOnly: _propTypes2.default.bool, required: _propTypes2.default.bool, secondary: _propTypes2.default.bool, size: _propTypes2.default.oneOf(['small', 'medium', 'large']), step: function step(props, propName, componentName) {
	    if (props[propName] !== void 0 && 'number' != typeof props[propName] && 'any' !== props[propName]) return new Error('Invalid prop `' + propName + '` of type `' + _typeof(props[propName]) + '` supplied to `' + componentName + '`, expected either `number`, or `string` with a value of "any".');
	  }, theme: _propTypes3.themeShape, type: _propTypes2.default.string, validate: _propTypes2.default.func, value: function value(props, propName, componentName) {
	    if (props[propName] !== void 0) {
	      if (props.defaultValue !== void 0) throw new Error('Props `defaultValue` and `value` are both defined in `' + componentName + '`, but only one is allowed. Use `defaultValue` for an uncontrolled component, or `value` for a controlled component.');if (void 0 === props.onChange) throw new Error('Please add prop `onChange` to `' + componentName + '`. Prop `value` has been set, which makes this a controlled component.');if ('string' != typeof props[propName] && 'number' != typeof props[propName] && null !== props[propName]) return new Error('Invalid prop `' + propName + '` of type `' + _typeof(props[propName]) + '` supplied to `' + componentName + '`, expected `string`, `number`, or a value of `null`.');
	    }
	  } }, InputControl.defaultProps = { size: 'medium', theme: (0, _themes.createTheme)(), validate: function validate() {
	    return '';
	  } }, InputControl.displayName = 'InputControl';var InputControlWithTheme = (0, _withCommonProps2.default)(InputControl);InputControlWithTheme.WrappedComponent = InputControl, exports.default = InputControlWithTheme;

/***/ },
/* 425 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	Object.defineProperty(exports, '__esModule', { value: !0 });var _themes = __webpack_require__(4),
	    getBackgroundImage = function getBackgroundImage(color) {
	  var encodedColor = encodeURIComponent(color);return 'url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 14 14\'%3E%3Cpath fill=\'' + encodedColor + '\' d=\'M8 6a1 1 0 1 1-2 0V4a1 1 0 1 1 2 0v2zm-1 5a1 1 0 1 1 0-2 1 1 0 1 1 0 2zM7 0a7 7 0 1 0 0 14A7 7 0 0 0 7 0z\' /%3E%3C/svg%3E%0A")';
	},
	    componentTheme = function componentTheme(baseTheme) {
	  var _baseTheme$vstui = baseTheme.vstui,
	      color = _baseTheme$vstui.color,
	      shape = _baseTheme$vstui.shape,
	      size = _baseTheme$vstui.size,
	      typography = _baseTheme$vstui.typography,
	      cloud2 = color.cloud.getShade(2),
	      ninja11 = color.ninja.getShade(11),
	      backgroundImage = getBackgroundImage(color.transparent),
	      backgroundImage_invalid = getBackgroundImage(color.error),
	      backgroundImage_invalidFocus = getBackgroundImage(color.error),
	      black57 = 'rgba(0, 0, 0, 0.57)';return (0, _themes.createComponentTheme)(baseTheme, { InputControl_width: '270px', InputControl_minHeight_small: size.small, InputControl_minHeight_medium: size.medium, InputControl_minHeight_large: size.large, InputControl_backgroundColor: color.surface, InputControl_backgroundColor_disabled: color.transparent, InputControl_backgroundColor_readOnly: cloud2, InputControl_backgroundImage: backgroundImage, InputControl_backgroundImage_invalid: backgroundImage_invalid, InputControl_backgroundImage_invalidFocus: backgroundImage_invalidFocus, InputControl_backgroundPosition_small: 'right 12px top ' + (size.small - 2 - 14) / 2 + 'px', InputControl_backgroundPosition_medium: 'right 12px top ' + (size.medium - 2 - 14) / 2 + 'px', InputControl_backgroundPosition_large: 'right 14px top ' + (size.large - 2 - 14) / 2 + 'px', InputControl_backgroundSize: '14px 14px', InputControl_borderColor: 'rgba(0, 0, 0, 0.43)', InputControl_borderColor_focus: ninja11, InputControl_borderColor_disabled: 'rgba(0, 0, 0, 0.20)', InputControl_borderColor_invalid: color.error, InputControl_borderColor_invalidFocus: ninja11, InputControl_borderStyle: shape.borderStyle, InputControl_borderWidth: shape.borderWidth, InputControl_borderRadius: shape.borderRadius, InputControl_borderRadius_search: '16px', InputControl_fontFamily: typography.fontFamily, InputControl_fontSize_small: typography.fontSize, InputControl_fontSize_medium: typography.fontSize, InputControl_fontSize_large: typography.fontSize + 2, InputControl_fontWeight: typography.fontWeightRegular, InputControl_color: color.onSurface, InputControl_color_disabled: black57, InputControl_color_readOnly: black57, InputControl_boxShadow_focus: '0 0 0 1px ' + ninja11, InputControlPlaceholder_fontWeight: typography.fontWeightLight, InputControlPlaceholder_color: black57 });
	};exports.default = componentTheme;

/***/ },
/* 426 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	Object.defineProperty(exports, '__esModule', { value: !0 });var _InputControl = __webpack_require__(424);Object.defineProperty(exports, 'default', { enumerable: !0, get: function get() {
	    return _interopRequireDefault(_InputControl).default;
	  } });function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}

/***/ },
/* 427 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) {
	  for (var source, i = 1; i < arguments.length; i++) {
	    for (var key in source = arguments[i], source) {
	      Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
	    }
	  }return target;
	},
	    _createClass = function () {
	  function defineProperties(target, props) {
	    for (var descriptor, i = 0; i < props.length; i++) {
	      descriptor = props[i], descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, 'value' in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    return protoProps && defineProperties(Constructor.prototype, protoProps), staticProps && defineProperties(Constructor, staticProps), Constructor;
	  };
	}(),
	    _react = __webpack_require__(3),
	    _react2 = _interopRequireDefault(_react),
	    _propTypes = __webpack_require__(6),
	    _propTypes2 = _interopRequireDefault(_propTypes),
	    _styledComponents = __webpack_require__(15),
	    _styledComponents2 = _interopRequireDefault(_styledComponents),
	    _withCommonProps = __webpack_require__(38),
	    _withCommonProps2 = _interopRequireDefault(_withCommonProps),
	    _themes = __webpack_require__(4),
	    _styles = __webpack_require__(31),
	    _propTypes3 = __webpack_require__(16),
	    _componentTheme = __webpack_require__(428),
	    _componentTheme2 = _interopRequireDefault(_componentTheme);Object.defineProperty(exports, '__esModule', { value: !0 });function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}function _objectWithoutProperties(obj, keys) {
	  var target = {};for (var i in obj) {
	    0 <= keys.indexOf(i) || Object.prototype.hasOwnProperty.call(obj, i) && (target[i] = obj[i]);
	  }return target;
	}function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
	}function _possibleConstructorReturn(self, call) {
	  if (!self) throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');return call && ('object' == (typeof call === 'undefined' ? 'undefined' : _typeof(call)) || 'function' == typeof call) ? call : self;
	}function _inherits(subClass, superClass) {
	  if ('function' != typeof superClass && null !== superClass) throw new TypeError('Super expression must either be null or a function, not ' + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: !1, writable: !0, configurable: !0 } }), superClass && (Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass);
	}var Styled = { label: _styledComponents2.default.label.withConfig({ displayName: 'Label__label' })(['', ';color:', ';font-family:', ';font-size:', ';font-weight:', ';-webkit-font-smoothing:antialiased;transition-property:none;transition-duration:', ';transition-timing-function:', ';', ';'], function (props) {
	    return props.sc.inheritStyles ? '' : (0, _styles.resetInheritedStyles)({ direction: props.theme.vstui.i18n.direction });
	  }, function (props) {
	    return props.sc.disabled ? (0, _themes.getStyle)('Label_color_disabled') : (0, _themes.getStyle)('Label_color');
	  }, (0, _themes.getStyle)('Label_fontFamily'), function (props) {
	    return props.theme.vstui.rem((0, _themes.getStyle)('Label_fontSize_' + props.sc.size)(props));
	  }, (0, _themes.getStyle)('Label_fontWeight'), function (props) {
	    return props.theme.vstui.transition.duration.shortest;
	  }, function (props) {
	    return props.theme.vstui.transition.easing.easeIn;
	  }, function (props) {
	    return props.sc.visuallyHidden && (0, _styles.visuallyHidden)();
	  }) },
	    Label = function (_Component) {
	  function Label() {
	    return _classCallCheck(this, Label), _possibleConstructorReturn(this, (Label.__proto__ || Object.getPrototypeOf(Label)).apply(this, arguments));
	  }return _inherits(Label, _Component), _createClass(Label, [{ key: 'render', value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          commonProps = _props.commonProps,
	          disabled = _props.disabled,
	          inheritStyles = _props.inheritStyles,
	          size = _props.size,
	          themeProp = _props.theme,
	          visuallyHidden = _props.visuallyHidden,
	          otherProps = _objectWithoutProperties(_props, ['children', 'className', 'commonProps', 'disabled', 'inheritStyles', 'size', 'theme', 'visuallyHidden']),
	          theme = (0, _componentTheme2.default)(themeProp);return _react2.default.createElement(Styled.label, _extends({}, commonProps, otherProps, { className: className, sc: { disabled: disabled, inheritStyles: inheritStyles, size: size, visuallyHidden: visuallyHidden }, theme: theme }), children);
	    } }]), Label;
	}(_react.Component);Label.propTypes = { children: _propTypes2.default.node.isRequired, className: _propTypes2.default.string, commonProps: _propTypes3.commonPropsShape, disabled: _propTypes2.default.bool, inheritStyles: _propTypes2.default.bool, size: _propTypes2.default.oneOf(['small', 'medium', 'large']), visuallyHidden: _propTypes2.default.bool, theme: _propTypes3.themeShape }, Label.defaultProps = { size: 'medium', theme: (0, _themes.createTheme)() }, Label.displayName = 'Label';var LabelWithTheme = (0, _withCommonProps2.default)(Label);LabelWithTheme.WrappedComponent = Label, exports.default = LabelWithTheme;

/***/ },
/* 428 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	Object.defineProperty(exports, '__esModule', { value: !0 });var _themes = __webpack_require__(4),
	    componentTheme = function componentTheme(baseTheme) {
	  var _baseTheme$vstui = baseTheme.vstui,
	      color = _baseTheme$vstui.color,
	      typography = _baseTheme$vstui.typography;return (0, _themes.createComponentTheme)(baseTheme, { Label_fontFamily: typography.fontFamily, Label_fontSize_small: typography.fontSize - 1, Label_fontSize_medium: typography.fontSize - 1, Label_fontSize_large: typography.fontSize, Label_fontWeight: typography.fontWeightMedium, Label_color: color.onSurface, Label_color_disabled: 'rgba(0, 0, 0, 0.57)' });
	};exports.default = componentTheme;

/***/ },
/* 429 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) {
	  for (var source, i = 1; i < arguments.length; i++) {
	    for (var key in source = arguments[i], source) {
	      Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
	    }
	  }return target;
	},
	    _createClass = function () {
	  function defineProperties(target, props) {
	    for (var descriptor, i = 0; i < props.length; i++) {
	      descriptor = props[i], descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, 'value' in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    return protoProps && defineProperties(Constructor.prototype, protoProps), staticProps && defineProperties(Constructor, staticProps), Constructor;
	  };
	}(),
	    _react = __webpack_require__(3),
	    _react2 = _interopRequireDefault(_react),
	    _themes = __webpack_require__(4),
	    _Button = __webpack_require__(58),
	    _Button2 = _interopRequireDefault(_Button);Object.defineProperty(exports, '__esModule', { value: !0 });function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
	}function _possibleConstructorReturn(self, call) {
	  if (!self) throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');return call && ('object' == (typeof call === 'undefined' ? 'undefined' : _typeof(call)) || 'function' == typeof call) ? call : self;
	}function _inherits(subClass, superClass) {
	  if ('function' != typeof superClass && null !== superClass) throw new TypeError('Super expression must either be null or a function, not ' + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: !1, writable: !0, configurable: !0 } }), superClass && (Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass);
	}var ThemedButton = (0, _themes.createThemedComponent)(_Button2.default, { Button_minHeight_small: 0, Button_minHeight_medium: 0, Button_minHeight_large: 0, Button_fontSize_small: 'inherit', Button_fontSize_medium: 'inherit', Button_fontSize_large: 'inherit', Button_textDecoration: 'underline', Button_paddingHorizontal_small: 0, Button_paddingHorizontal_medium: 0, Button_paddingHorizontal_large: 0 }),
	    Link = function (_Component) {
	  function Link() {
	    return _classCallCheck(this, Link), _possibleConstructorReturn(this, (Link.__proto__ || Object.getPrototypeOf(Link)).apply(this, arguments));
	  }return _inherits(Link, _Component), _createClass(Link, [{ key: 'render', value: function render() {
	      return _react2.default.createElement(ThemedButton, _extends({}, this.props, { naked: !0 }));
	    } }]), Link;
	}(_react.Component);exports.default = Link;

/***/ },
/* 430 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	Object.defineProperty(exports, '__esModule', { value: !0 });var _Link = __webpack_require__(429);Object.defineProperty(exports, 'default', { enumerable: !0, get: function get() {
	    return _interopRequireDefault(_Link).default;
	  } });function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}

/***/ },
/* 431 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _typeof = 'function' == typeof Symbol && 'symbol' == _typeof2(Symbol.iterator) ? function (obj) {
	  return typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
	} : function (obj) {
	  return obj && 'function' == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? 'symbol' : typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
	},
	    _extends = Object.assign || function (target) {
	  for (var source, i = 1; i < arguments.length; i++) {
	    for (var key in source = arguments[i], source) {
	      Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
	    }
	  }return target;
	},
	    _createClass = function () {
	  function defineProperties(target, props) {
	    for (var descriptor, i = 0; i < props.length; i++) {
	      descriptor = props[i], descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, 'value' in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    return protoProps && defineProperties(Constructor.prototype, protoProps), staticProps && defineProperties(Constructor, staticProps), Constructor;
	  };
	}(),
	    _react = __webpack_require__(3),
	    _react2 = _interopRequireDefault(_react),
	    _propTypes = __webpack_require__(6),
	    _propTypes2 = _interopRequireDefault(_propTypes),
	    _styledComponents = __webpack_require__(15),
	    _styledComponents2 = _interopRequireDefault(_styledComponents),
	    _withCommonProps = __webpack_require__(38),
	    _withCommonProps2 = _interopRequireDefault(_withCommonProps),
	    _themes = __webpack_require__(4),
	    _propTypes3 = __webpack_require__(16),
	    _componentTheme = __webpack_require__(432),
	    _componentTheme2 = _interopRequireDefault(_componentTheme),
	    _Form = __webpack_require__(128),
	    _Form2 = _interopRequireDefault(_Form),
	    _TextField = __webpack_require__(191),
	    _TextField2 = _interopRequireDefault(_TextField),
	    _Button = __webpack_require__(58),
	    _Button2 = _interopRequireDefault(_Button),
	    _icons = __webpack_require__(102);Object.defineProperty(exports, '__esModule', { value: !0 });function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}function _objectWithoutProperties(obj, keys) {
	  var target = {};for (var i in obj) {
	    0 <= keys.indexOf(i) || Object.prototype.hasOwnProperty.call(obj, i) && (target[i] = obj[i]);
	  }return target;
	}function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
	}function _possibleConstructorReturn(self, call) {
	  if (!self) throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');return call && ('object' == (typeof call === 'undefined' ? 'undefined' : _typeof2(call)) || 'function' == typeof call) ? call : self;
	}function _inherits(subClass, superClass) {
	  if ('function' != typeof superClass && null !== superClass) throw new TypeError('Super expression must either be null or a function, not ' + (typeof superClass === 'undefined' ? 'undefined' : _typeof2(superClass)));subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: !1, writable: !0, configurable: !0 } }), superClass && (Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass);
	}var Styled = { div: {} };Styled.Form = (0, _styledComponents2.default)(_Form2.default).withConfig({ displayName: 'SearchForm__Form' })(['input[type=\'search\']{background-image:', ';', ';&[aria-invalid]{', ';background-image:', ';&:focus{background-image:', ';}}}&:focus-within input[type=\'search\']{outline:none;border-color:', ';box-shadow:', ';}'], (0, _themes.getStyle)('SearchFormInput_backgroundImage'), function (props) {
	  return !props.sc.incremental && '\n        padding: 0 52px 0 12px;\n        background-position: right 52px top 8px;\n      ';
	}, function (props) {
	  var side = 'rtl' === props.theme.vstui.i18n.direction ? 'left' : 'right';return '\n          padding-' + side + ': ' + (props.sc.incremental ? 66 : 76) + 'px;\n        ';
	}, (0, _themes.getStyle)('SearchFormInput_backgroundImage_invalid'), (0, _themes.getStyle)('SearchFormInput_backgroundImage_invalidFocus'), (0, _themes.getStyle)('SearchFormInputControl_borderColor_focus'), (0, _themes.getStyle)('SearchFormInputControl_boxShadow_focus')), Styled.div.wrapper = _styledComponents2.default.div.withConfig({ displayName: 'SearchForm__wrapper' })(['position:relative;display:inline-block;width:', ';& > div{margin:0;}'], function (props) {
	  return props.sc.fullWidth ? '100%' : 'auto';
	}), Styled.Button = (0, _styledComponents2.default)(_Button2.default).withConfig({ displayName: 'SearchForm__Button' })(['position:absolute;top:0;right:0;']);var SearchForm = function (_React$Component) {
	  function SearchForm() {
	    return _classCallCheck(this, SearchForm), _possibleConstructorReturn(this, (SearchForm.__proto__ || Object.getPrototypeOf(SearchForm)).apply(this, arguments));
	  }return _inherits(SearchForm, _React$Component), _createClass(SearchForm, [{ key: 'render', value: function render() {
	      var _props = this.props,
	          disabled = _props.disabled,
	          formProps = _props.formProps,
	          fullWidth = _props.fullWidth,
	          incremental = _props.incremental,
	          placeholder = _props.placeholder,
	          secondary = _props.secondary,
	          size = _props.size,
	          themeProp = _props.theme,
	          otherProps = _objectWithoutProperties(_props, ['disabled', 'formProps', 'fullWidth', 'incremental', 'placeholder', 'secondary', 'size', 'theme']),
	          theme = (0, _componentTheme2.default)(themeProp),
	          label = 'Search' + (incremental ? ' (results update as you type)' : '');return _react2.default.createElement(Styled.Form, _extends({}, formProps, { sc: { incremental: incremental }, theme: theme }), _react2.default.createElement(Styled.div.wrapper, { sc: { fullWidth: fullWidth } }, _react2.default.createElement(_TextField2.default, _extends({ clearButtonDisabled: disabled || !incremental, disabled: disabled, fullWidth: fullWidth }, incremental ? {} : { icon: null }, { label: label, labelHidden: !0, placeholder: placeholder, secondary: secondary, size: size }, otherProps, { type: 'search' })), !incremental && _react2.default.createElement(Styled.Button, { disabled: disabled, iconStart: _react2.default.createElement(_icons.Search, null), label: 'Search', secondary: secondary, size: size, theme: theme })));
	    } }]), SearchForm;
	}(_react2.default.Component);SearchForm.propTypes = { defaultValue: function defaultValue(props, propName, componentName) {
	    if (props[propName] !== void 0) {
	      if (props.value !== void 0) throw new Error('Props `defaultValue` and `value` are both defined in `' + componentName + '`, but only one is allowed. Use `defaultValue` for an uncontrolled component, or `value` for a controlled component.');if ('string' != typeof props[propName] && 'number' != typeof props[propName] && null !== props[propName]) return new Error('Invalid prop `' + propName + '` of type `' + _typeof(props[propName]) + '` supplied to `' + componentName + '`, expected `string`, `number`, or a value of `null`.');
	    }
	  }, disabled: _propTypes2.default.bool, formProps: _propTypes2.default.object, fullWidth: _propTypes2.default.bool, incremental: _propTypes2.default.bool, nativeFormControlRef: _propTypes2.default.func, onChange: _propTypes2.default.func, placeholder: _propTypes2.default.string, readOnly: _propTypes2.default.bool, required: _propTypes2.default.bool, secondary: _propTypes2.default.bool, size: _propTypes2.default.oneOf(['small', 'medium', 'large']), theme: _propTypes3.themeShape, value: function value(props, propName, componentName) {
	    if (props[propName] !== void 0) {
	      if (props.defaultValue !== void 0) throw new Error('Props `defaultValue` and `value` are both defined in `' + componentName + '`, but only one is allowed. Use `defaultValue` for an uncontrolled component, or `value` for a controlled component.');if (void 0 === props.onChange) throw new Error('Please add prop `onChange` to `' + componentName + '`. Prop `value` has been set, which makes this a controlled component.');if ('string' != typeof props[propName] && 'number' != typeof props[propName] && null !== props[propName]) return new Error('Invalid prop `' + propName + '` of type `' + _typeof(props[propName]) + '` supplied to `' + componentName + '`, expected `string`, `number`, or a value of `null`.');
	    }
	  } }, SearchForm.defaultProps = { incremental: !1, theme: (0, _themes.createTheme)() }, SearchForm.displayName = 'SearchForm';var SearchFormWithTheme = (0, _withCommonProps2.default)(SearchForm);SearchFormWithTheme.WrappedComponent = SearchForm, exports.default = SearchFormWithTheme;

/***/ },
/* 432 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	Object.defineProperty(exports, '__esModule', { value: !0 });var _themes = __webpack_require__(4),
	    componentTheme = function componentTheme(baseTheme) {
	  var _baseTheme$vstui = baseTheme.vstui,
	      color = _baseTheme$vstui.color,
	      size = _baseTheme$vstui.size,
	      ninja11 = color.ninja.getShade(11),
	      backgroundColor_naked = color.transparent,
	      borderColor_naked = color.transparent,
	      color_disabled = color.black;return (0, _themes.createComponentTheme)(baseTheme, { SearchFormInputControl_borderColor_focus: ninja11, SearchFormInputControl_boxShadow_focus: '0 0 0 1px ' + ninja11, InputControl_backgroundPosition_small: 'right 40px top ' + (size.small - 2 - 14) / 2 + 'px', InputControl_backgroundPosition_medium: 'right 40px top ' + (size.medium - 2 - 14) / 2 + 'px', InputControl_backgroundPosition_large: 'right 40px top ' + (size.large - 2 - 14) / 2 + 'px', InputControl_backgroundSize: '14px 14px', Button_backgroundColor_themePrimary: backgroundColor_naked, Button_backgroundColor_themePrimary_disabled: backgroundColor_naked, Button_backgroundColor_themeSecondary: backgroundColor_naked, Button_backgroundColor_themeSecondary_disabled: backgroundColor_naked, Button_borderColor_themePrimary: borderColor_naked, Button_borderColor_themePrimary_disabled: borderColor_naked, Button_borderColor_themePrimary_active: ninja11 + ' ' + ninja11 + ' ' + ninja11 + ' ' + color.transparent, Button_borderColor_themePrimary_focus: ninja11 + ' ' + ninja11 + ' ' + ninja11 + ' ' + color.transparent, Button_borderColor_themePrimary_hover: ninja11 + ' ' + ninja11 + ' ' + ninja11 + ' ' + color.transparent, Button_borderColor_themeSecondary: borderColor_naked, Button_borderColor_themeSecondary_disabled: borderColor_naked, Button_borderColor_themeSecondary_active: ninja11 + ' ' + ninja11 + ' ' + ninja11 + ' ' + color.transparent, Button_borderColor_themeSecondary_focus: ninja11 + ' ' + ninja11 + ' ' + ninja11 + ' ' + color.transparent, Button_borderColor_themeSecondary_hover: ninja11 + ' ' + ninja11 + ' ' + ninja11 + ' ' + color.transparent, Button_color_themePrimary: function primaryDarker(_ref) {
	      var sc = _ref.sc;return color.primary.getMainShade({ backgroundColor: sc.colorBehindButton, offset: 1 });
	    }, Button_color_themePrimary_disabled: color_disabled, Button_color_themeSecondary: function secondaryDarker(_ref2) {
	      var sc = _ref2.sc;return color.secondary.getMainShade({ backgroundColor: sc.colorBehindButton, offset: 1 });
	    }, Button_color_themeSecondary_disabled: color_disabled, Button_borderRadius: '0 16px 16px 0', Button_boxShadow_themePrimary_focus: 'none', Button_boxShadow_themeSecondary_focus: 'none', Button_paddingHorizontal_withIconSmall: '12px', Button_paddingHorizontal_withIconMedium: '12px', Button_paddingHorizontal_withIconLarge: '12px' });
	};exports.default = componentTheme;

/***/ },
/* 433 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	Object.defineProperty(exports, '__esModule', { value: !0 });var _SearchForm = __webpack_require__(431);Object.defineProperty(exports, 'default', { enumerable: !0, get: function get() {
	    return _interopRequireDefault(_SearchForm).default;
	  } });function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}

/***/ },
/* 434 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _typeof = 'function' == typeof Symbol && 'symbol' == _typeof2(Symbol.iterator) ? function (obj) {
	  return typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
	} : function (obj) {
	  return obj && 'function' == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? 'symbol' : typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
	},
	    _extends = Object.assign || function (target) {
	  for (var source, i = 1; i < arguments.length; i++) {
	    for (var key in source = arguments[i], source) {
	      Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
	    }
	  }return target;
	},
	    _createClass = function () {
	  function defineProperties(target, props) {
	    for (var descriptor, i = 0; i < props.length; i++) {
	      descriptor = props[i], descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, 'value' in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    return protoProps && defineProperties(Constructor.prototype, protoProps), staticProps && defineProperties(Constructor, staticProps), Constructor;
	  };
	}(),
	    _react = __webpack_require__(3),
	    _react2 = _interopRequireDefault(_react),
	    _propTypes = __webpack_require__(6),
	    _propTypes2 = _interopRequireDefault(_propTypes),
	    _styledComponents = __webpack_require__(15),
	    _styledComponents2 = _interopRequireDefault(_styledComponents),
	    _propTypes3 = __webpack_require__(16),
	    _themes = __webpack_require__(4),
	    _FormGroup = __webpack_require__(129),
	    _FormGroup2 = _interopRequireDefault(_FormGroup),
	    _SelectControl = __webpack_require__(438),
	    _SelectControl2 = _interopRequireDefault(_SelectControl),
	    _utils = __webpack_require__(59);Object.defineProperty(exports, '__esModule', { value: !0 });function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}function _objectWithoutProperties(obj, keys) {
	  var target = {};for (var i in obj) {
	    0 <= keys.indexOf(i) || Object.prototype.hasOwnProperty.call(obj, i) && (target[i] = obj[i]);
	  }return target;
	}function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
	}function _possibleConstructorReturn(self, call) {
	  if (!self) throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');return call && ('object' == (typeof call === 'undefined' ? 'undefined' : _typeof2(call)) || 'function' == typeof call) ? call : self;
	}function _inherits(subClass, superClass) {
	  if ('function' != typeof superClass && null !== superClass) throw new TypeError('Super expression must either be null or a function, not ' + (typeof superClass === 'undefined' ? 'undefined' : _typeof2(superClass)));subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: !1, writable: !0, configurable: !0 } }), superClass && (Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass);
	}var Styled = { SelectControl: (0, _styledComponents2.default)(_SelectControl2.default).withConfig({ displayName: 'Select__SelectControl' })(['display:block;']) },
	    Select = function (_Component) {
	  function Select(props) {
	    _classCallCheck(this, Select);var _this = _possibleConstructorReturn(this, (Select.__proto__ || Object.getPrototypeOf(Select)).call(this, props));return _this.generatedId = (0, _utils.generateUniqueId)('select'), _this.state = { id: props.id || _this.generatedId, validationMessage: null }, _this.handleFormControlRef = _this.handleFormControlRef.bind(_this), _this.handleNativeFormControlRef = _this.handleNativeFormControlRef.bind(_this), _this.handleValidate = _this.handleValidate.bind(_this), _this;
	  }return _inherits(Select, _Component), _createClass(Select, [{ key: 'componentWillReceiveProps', value: function componentWillReceiveProps(nextProps) {
	      var id = nextProps.id || this.generatedId;id !== this.state.id && this.setState({ id: id });
	    } }, { key: 'focus', value: function focus() {
	      this.nativeFormControl && this.nativeFormControl.focus();
	    } }, { key: 'validate', value: function validate(callback) {
	      this.formControl && this.formControl.validate(callback);
	    } }, { key: 'handleFormControlRef', value: function handleFormControlRef(node) {
	      this.formControl = node;
	    } }, { key: 'handleNativeFormControlRef', value: function handleNativeFormControlRef(node) {
	      var nativeFormControlRef = this.props.nativeFormControlRef;this.nativeFormControl = node, nativeFormControlRef && nativeFormControlRef(node);
	    } }, { key: 'handleValidate', value: function handleValidate(valid, validationMessage) {
	      this.setState({ validationMessage: validationMessage });
	    } }, { key: 'render', value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          dir = _props.dir,
	          disabled = _props.disabled,
	          fullWidth = _props.fullWidth,
	          helperText = _props.helperText,
	          idIgnored = _props.id,
	          inheritStyles = _props.inheritStyles,
	          label = _props.label,
	          labelHidden = _props.labelHidden,
	          lang = _props.lang,
	          nativeFormControlRefIgnored = _props.nativeFormControlRef,
	          rootProps = _props.rootProps,
	          secondary = _props.secondary,
	          size = _props.size,
	          theme = _props.theme,
	          otherProps = _objectWithoutProperties(_props, ['className', 'dir', 'disabled', 'fullWidth', 'helperText', 'id', 'inheritStyles', 'label', 'labelHidden', 'lang', 'nativeFormControlRef', 'rootProps', 'secondary', 'size', 'theme']),
	          _state = this.state,
	          id = _state.id,
	          validationMessage = _state.validationMessage;return _react2.default.createElement(_FormGroup2.default, { className: className, dir: dir, disabled: disabled, formControl: _react2.default.createElement(Styled.SelectControl, _extends({}, otherProps, { nativeFormControlRef: this.handleNativeFormControlRef, onRef: this.handleFormControlRef, onValidate: this.handleValidate }), this.props.children), fullWidth: fullWidth, helperText: helperText, id: id, inheritStyles: inheritStyles, label: label, labelHidden: labelHidden, lang: lang, rootProps: rootProps, secondary: secondary, size: size, theme: theme, validationMessage: validationMessage });
	    } }]), Select;
	}(_react.Component);Select.propTypes = { children: _propTypes2.default.node, className: _propTypes2.default.string, defaultValue: _propTypes2.default.string, dir: _propTypes2.default.oneOf(['ltr', 'rtl', 'auto']), disabled: _propTypes2.default.bool, fullWidth: _propTypes2.default.bool, helperText: _propTypes2.default.string, id: _propTypes2.default.string, inheritStyles: _propTypes2.default.bool, label: function label(props, propName, componentName) {
	    if (props.label === void 0 && props.labelledBy === void 0) return new Error(componentName + ' requires either the `label` prop or the `labelledBy` prop.');if (void 0 !== props[propName]) {
	      if ('string' != typeof props[propName]) return new Error('Invalid prop `' + propName + '` of type `' + _typeof(props[propName]) + '` supplied to `' + componentName + '`, expected `string`.');'' === props[propName];
	    }
	  }, labelHidden: _propTypes2.default.bool, labelledBy: function labelledBy(props, propName, componentName) {
	    if (props.label === void 0 && props.labelledBy === void 0) return new Error(componentName + ' requires either the `label` prop or the `labelledBy` prop.');if (void 0 !== props[propName]) {
	      if ('string' != typeof props[propName]) return new Error('Invalid prop `' + propName + '` of type `' + _typeof(props[propName]) + '` supplied to `' + componentName + '`, expected `string`.');'' === props[propName];
	    }
	  }, lang: _propTypes2.default.string, nativeFormControlRef: _propTypes2.default.func, onChange: _propTypes2.default.func, required: _propTypes2.default.bool, rootProps: _propTypes2.default.object, secondary: _propTypes2.default.bool, size: _propTypes2.default.oneOf(['small', 'medium', 'large']), theme: _propTypes3.themeShape, validate: _propTypes2.default.func, value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]) }, Select.defaultProps = { size: 'medium', theme: (0, _themes.createTheme)(), validate: function validate() {
	    return '';
	  } }, Select.displayName = 'Select';var SelectWithTheme = (0, _themes.withTheme)(Select);SelectWithTheme.WrappedComponent = Select, exports.default = SelectWithTheme;

/***/ },
/* 435 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	Object.defineProperty(exports, '__esModule', { value: !0 });var _Select = __webpack_require__(434);Object.defineProperty(exports, 'default', { enumerable: !0, get: function get() {
	    return _interopRequireDefault(_Select).default;
	  } });function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}

/***/ },
/* 436 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) {
	  for (var source, i = 1; i < arguments.length; i++) {
	    for (var key in source = arguments[i], source) {
	      Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
	    }
	  }return target;
	},
	    _createClass = function () {
	  function defineProperties(target, props) {
	    for (var descriptor, i = 0; i < props.length; i++) {
	      descriptor = props[i], descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, 'value' in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    return protoProps && defineProperties(Constructor.prototype, protoProps), staticProps && defineProperties(Constructor, staticProps), Constructor;
	  };
	}(),
	    _react = __webpack_require__(3),
	    _react2 = _interopRequireDefault(_react),
	    _propTypes = __webpack_require__(6),
	    _propTypes2 = _interopRequireDefault(_propTypes),
	    _styledComponents = __webpack_require__(15),
	    _styledComponents2 = _interopRequireDefault(_styledComponents),
	    _withCommonProps = __webpack_require__(38),
	    _withCommonProps2 = _interopRequireDefault(_withCommonProps),
	    _themes = __webpack_require__(4),
	    _styles = __webpack_require__(31),
	    _propTypes3 = __webpack_require__(16),
	    _FormControl = __webpack_require__(100),
	    _FormControl2 = _interopRequireDefault(_FormControl),
	    _componentTheme = __webpack_require__(437),
	    _componentTheme2 = _interopRequireDefault(_componentTheme);Object.defineProperty(exports, '__esModule', { value: !0 });function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}function _objectWithoutProperties(obj, keys) {
	  var target = {};for (var i in obj) {
	    0 <= keys.indexOf(i) || Object.prototype.hasOwnProperty.call(obj, i) && (target[i] = obj[i]);
	  }return target;
	}function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
	}function _possibleConstructorReturn(self, call) {
	  if (!self) throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');return call && ('object' == (typeof call === 'undefined' ? 'undefined' : _typeof(call)) || 'function' == typeof call) ? call : self;
	}function _inherits(subClass, superClass) {
	  if ('function' != typeof superClass && null !== superClass) throw new TypeError('Super expression must either be null or a function, not ' + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: !1, writable: !0, configurable: !0 } }), superClass && (Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass);
	}var getHeight = function getHeight() {
	  return function (props) {
	    var size = props.sc.size,
	        _props$theme$vstui = props.theme.vstui,
	        rem = _props$theme$vstui.rem,
	        typography = _props$theme$vstui.typography,
	        minHeight = (0, _themes.getStyle)('SelectControl_minHeight_' + size)(props) - 4,
	        height = Math.max(minHeight, 1.4 * typography.fontSize);return rem(height);
	  };
	},
	    Styled = {};Styled.div = {}, Styled.select = _styledComponents2.default.select.withConfig({ displayName: 'SelectControl__select' })(['', ';width:', ';min-width:74px;max-width:100%;min-height:', ';padding:', ';background-color:', ';background-image:', ';background-position:', ';background-repeat:no-repeat;background-size:10px 6px,14px 14px;border-color:', ';border-style:', ';border-width:', ';border-radius:', ';color:', ';font-family:', ';font-size:', ';font-weight:', ';-webkit-font-smoothing:antialiased;white-space:pre;transition-property:none;transition-duration:', ';transition-timing-function:', ';cursor:pointer;appearance:none;option{height:', ';}&::-ms-expand{display:none;}&:focus{outline:none;border-color:', ';box-shadow:', ';}&[aria-invalid]{padding-right:', 'px;padding-left:', 'px;background-image:', ';border-color:', ';&:focus{background-image:', ';border-color:', ';}}&:disabled{background-image:', ';border-color:', ';color:', ';cursor:default;}'], function (props) {
	  return props.sc.inheritStyles ? '' : (0, _styles.resetInheritedStyles)({ direction: props.theme.vstui.i18n.direction });
	}, function (props) {
	  return props.sc.fullWidth ? '100%' : (0, _themes.getStyle)('SelectControl_width');
	}, function (props) {
	  return props.theme.vstui.rem((0, _themes.getStyle)('SelectControl_minHeight_' + props.sc.size)(props));
	}, function (props) {
	  return 'rtl' === props.theme.vstui.i18n.direction ? '0 12px 0 34px' : '0 34px 0 12px';
	}, (0, _themes.getStyle)('SelectControl_backgroundColor'), function (props) {
	  return props.sc.secondary ? (0, _themes.getStyle)('SelectControl_backgroundImage_themeSecondary') : (0, _themes.getStyle)('SelectControl_backgroundImage_themePrimary');
	}, function (props) {
	  return (0, _themes.getStyle)('SelectControl_backgroundPosition_' + props.sc.size)(props);
	}, (0, _themes.getStyle)('SelectControl_borderColor'), (0, _themes.getStyle)('SelectControl_borderStyle'), (0, _themes.getStyle)('SelectControl_borderWidth'), (0, _themes.getStyle)('SelectControl_borderRadius'), (0, _themes.getStyle)('SelectControl_color'), (0, _themes.getStyle)('SelectControl_fontFamily'), function (props) {
	  return props.theme.vstui.rem((0, _themes.getStyle)('SelectControl_fontSize_' + props.sc.size)(props));
	}, (0, _themes.getStyle)('SelectControl_fontWeight'), function (props) {
	  return props.theme.vstui.transition.duration.shortest;
	}, function (props) {
	  return props.theme.vstui.transition.easing.easeIn;
	}, getHeight(), (0, _themes.getStyle)('SelectControl_borderColor_focus'), (0, _themes.getStyle)('SelectControl_boxShadow_focus'), function (props) {
	  return 'rtl' === props.theme.vstui.i18n.direction ? 34 : 60;
	}, function (props) {
	  return 'rtl' === props.theme.vstui.i18n.direction ? 60 : 34;
	}, (0, _themes.getStyle)('SelectControl_backgroundImage_invalid'), (0, _themes.getStyle)('SelectControl_borderColor_invalid'), (0, _themes.getStyle)('SelectControl_backgroundImage_invalidFocus'), (0, _themes.getStyle)('SelectControl_borderColor_invalidFocus'), function (props) {
	  return props.sc.secondary ? (0, _themes.getStyle)('SelectControl_backgroundImage_themeSecondary_disabled') : (0, _themes.getStyle)('SelectControl_backgroundImage_themePrimary_disabled');
	}, (0, _themes.getStyle)('SelectControl_borderColor_disabled'), (0, _themes.getStyle)('SelectControl_color_disabled')), Styled.select.displayName = 'Styled_select';var SelectControl = function (_PureComponent) {
	  function SelectControl(props) {
	    _classCallCheck(this, SelectControl);var _this = _possibleConstructorReturn(this, (SelectControl.__proto__ || Object.getPrototypeOf(SelectControl)).call(this, props));return _this.handleFormControlRef = _this.handleFormControlRef.bind(_this), _this.handleValidate = _this.handleValidate.bind(_this), _this.renderChildren = _this.renderChildren.bind(_this), _this.renderContent = _this.renderContent.bind(_this), _this;
	  }return _inherits(SelectControl, _PureComponent), _createClass(SelectControl, [{ key: 'componentDidMount', value: function componentDidMount() {
	      this.props.onRef && this.props.onRef(this);
	    } }, { key: 'componentWillUnmount', value: function componentWillUnmount() {
	      this.props.onRef && this.props.onRef(void 0);
	    } }, { key: 'getValidationMessage', value: function getValidationMessage(validity) {
	      var i18n = this.props.theme.vstui.i18n;return validity.valueMissing ? i18n.t('form.missingSelect') : '';
	    } }, { key: 'validate', value: function validate(callback) {
	      this.formControl.validate(callback);
	    } }, { key: 'handleFormControlRef', value: function handleFormControlRef(node) {
	      this.formControl = node;
	    } }, { key: 'handleValidate', value: function handleValidate(validity) {
	      var _ref2 = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {},
	          callback = _ref2.callback,
	          onlyValidateIfValid = _ref2.onlyValidateIfValid,
	          _ref = arguments[2],
	          updateValidationState = _ref.updateValidationState,
	          value = _ref.value,
	          _props = this.props,
	          onValidate = _props.onValidate,
	          validate = _props.validate,
	          passedDefaultValidation = validity.valid,
	          defaultValidationMessage = this.getValidationMessage(validity),
	          customValidationMessagePromise = Promise.resolve(validate ? validate(value) : ''),
	          update = function update(valid, validationMessage) {
	        (!onlyValidateIfValid || onlyValidateIfValid && valid) && updateValidationState(valid, validationMessage, onValidate);
	      };update(passedDefaultValidation, defaultValidationMessage), passedDefaultValidation ? customValidationMessagePromise.then(function (customValidationMessage) {
	        var passedCustomValidation = !customValidationMessage;update(passedCustomValidation, customValidationMessage), callback && callback(passedCustomValidation, customValidationMessage);
	      }) : callback && callback(passedDefaultValidation, defaultValidationMessage);
	    } }, { key: 'renderChildren', value: function renderChildren() {
	      var _this2 = this;return _react2.default.Children.map(this.props.children, function (child) {
	        return _react2.default.cloneElement(child, { key: 'option-' + _this2.props.id + '-' + child.props.value });
	      });
	    } }, { key: 'renderContent', value: function renderContent(_ref3) {
	      var defaultValue = _ref3.defaultValue,
	          invalid = _ref3.invalid,
	          handleBlur = _ref3.handleBlur,
	          handleChange = _ref3.handleChange,
	          handleFocus = _ref3.handleFocus,
	          handleNativeFormControlRef = _ref3.handleNativeFormControlRef,
	          value = _ref3.value,
	          _props2 = this.props,
	          childrenIgnored = _props2.children,
	          className = _props2.className,
	          commonProps = _props2.commonProps,
	          fullWidth = _props2.fullWidth,
	          inheritStyles = _props2.inheritStyles,
	          labelledBy = _props2.labelledBy,
	          required = _props2.required,
	          secondary = _props2.secondary,
	          size = _props2.size,
	          themeProp = _props2.theme,
	          otherProps = _objectWithoutProperties(_props2, ['children', 'className', 'commonProps', 'fullWidth', 'inheritStyles', 'labelledBy', 'required', 'secondary', 'size', 'theme']),
	          theme = (0, _componentTheme2.default)(themeProp),
	          conditionalProps = {};return invalid && (conditionalProps['aria-invalid'] = !0), required && (conditionalProps['aria-required'] = !0), _react2.default.createElement(Styled.select, _extends({}, commonProps, otherProps, conditionalProps, { "aria-labelledby": labelledBy, className: className, defaultValue: defaultValue, innerRef: handleNativeFormControlRef, onBlur: handleBlur, onChange: handleChange, onFocus: handleFocus, required: required, sc: { fullWidth: fullWidth, inheritStyles: inheritStyles, secondary: secondary, size: size }, theme: theme, value: value }), this.renderChildren());
	    } }, { key: 'render', value: function render() {
	      var _props3 = this.props,
	          defaultValue = _props3.defaultValue,
	          nativeFormControlRef = _props3.nativeFormControlRef,
	          onBlur = _props3.onBlur,
	          onChange = _props3.onChange,
	          value = _props3.value;return _react2.default.createElement(_FormControl2.default, { defaultValue: defaultValue, nativeFormControlRef: nativeFormControlRef, onFormControlBlur: onBlur, onFormControlChange: onChange, onValidate: this.handleValidate, ref: this.handleFormControlRef, render: this.renderContent, value: value });
	    } }]), SelectControl;
	}(_react.PureComponent);SelectControl.propTypes = { children: _propTypes2.default.node, className: _propTypes2.default.string, commonProps: _propTypes3.commonPropsShape, defaultValue: _propTypes2.default.string, disabled: _propTypes2.default.bool, fullWidth: _propTypes2.default.bool, id: _propTypes2.default.string, inheritStyles: _propTypes2.default.bool, labelledBy: _propTypes2.default.string, nativeFormControlRef: _propTypes2.default.func, onBlur: _propTypes2.default.func, onChange: _propTypes2.default.func, onFocus: _propTypes2.default.func, onRef: _propTypes2.default.func, onValidate: _propTypes2.default.func, required: _propTypes2.default.bool, secondary: _propTypes2.default.bool, size: _propTypes2.default.oneOf(['small', 'medium', 'large']), theme: _propTypes3.themeShape, validate: _propTypes2.default.func, value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]) }, SelectControl.defaultProps = { size: 'medium', theme: (0, _themes.createTheme)(), validate: function validate() {
	    return '';
	  } }, SelectControl.displayName = 'SelectControl';var SelectControlWithTheme = (0, _withCommonProps2.default)(SelectControl);SelectControlWithTheme.WrappedComponent = SelectControl, exports.default = SelectControlWithTheme;

/***/ },
/* 437 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	Object.defineProperty(exports, '__esModule', { value: !0 });var _themes = __webpack_require__(4),
	    getBackgroundImage = function getBackgroundImage(caretColor, errorColor) {
	  var encodedCaretColor = encodeURIComponent(caretColor),
	      encodedErrorColor = encodeURIComponent(errorColor);return 'url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 10 6\'%3E%3Cpath fill=\'' + encodedCaretColor + '\' d=\'M5 3.586L8.293.293a.999.999 0 1 1 1.414 1.414l-4 4a.999.999 0 0 1-1.414 0l-4-4a.997.997 0 0 1 0-1.414.999.999 0 0 1 1.414 0L5 3.586z\' /%3E%3C/svg%3E%0A")' + ', ' + ('url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 14 14\'%3E%3Cpath fill=\'' + encodedErrorColor + '\' d=\'M8 6a1 1 0 1 1-2 0V4a1 1 0 1 1 2 0v2zm-1 5a1 1 0 1 1 0-2 1 1 0 1 1 0 2zM7 0a7 7 0 1 0 0 14A7 7 0 0 0 7 0z\' /%3E%3C/svg%3E%0A")');
	},
	    componentTheme = function componentTheme(baseTheme) {
	  var _baseTheme$vstui = baseTheme.vstui,
	      color = _baseTheme$vstui.color,
	      shape = _baseTheme$vstui.shape,
	      size = _baseTheme$vstui.size,
	      typography = _baseTheme$vstui.typography,
	      ninja11 = color.ninja.getShade(11),
	      black57 = 'rgba(0, 0, 0, 0.57)',
	      primaryMain = color.primary.getMainShade(),
	      secondaryMain = color.secondary.getMainShade(),
	      backgroundImagePrimary = getBackgroundImage(primaryMain, color.transparent),
	      backgroundImagePrimary_disabled = getBackgroundImage(primaryMain + '80', color.transparent),
	      backgroundImageSecondary = getBackgroundImage(secondaryMain, color.transparent),
	      backgroundImageSecondary_disabled = getBackgroundImage(secondaryMain + '80', color.transparent),
	      backgroundImage_invalid = getBackgroundImage(color.error, color.error),
	      backgroundImage_invalidFocus = getBackgroundImage(color.error, color.error);return (0, _themes.createComponentTheme)(baseTheme, { SelectControl_width: '270px', SelectControl_minHeight_small: size.small, SelectControl_minHeight_medium: size.medium, SelectControl_minHeight_large: size.large, SelectControl_backgroundColor: color.surface, SelectControl_backgroundColor_disabled: color.transparent, SelectControl_backgroundImage_themePrimary: backgroundImagePrimary, SelectControl_backgroundImage_themePrimary_disabled: backgroundImagePrimary_disabled, SelectControl_backgroundImage_themeSecondary: backgroundImageSecondary, SelectControl_backgroundImage_themeSecondary_disabled: backgroundImageSecondary_disabled, SelectControl_backgroundImage_invalid: backgroundImage_invalid, SelectControl_backgroundImage_invalidFocus: backgroundImage_invalidFocus, SelectControl_backgroundPosition_small: 'right 12px center, right 34px center', SelectControl_backgroundPosition_medium: 'right 12px center, right 34px center', SelectControl_backgroundPosition_large: 'right 14px center, right 38px center', SelectControl_borderColor: 'rgba(0, 0, 0, 0.43)', SelectControl_borderColor_focus: ninja11, SelectControl_borderColor_disabled: 'rgba(0, 0, 0, 0.20)', SelectControl_borderColor_invalid: color.error, SelectControl_borderColor_invalidFocus: ninja11, SelectControl_borderStyle: shape.borderStyle, SelectControl_borderWidth: shape.borderWidth, SelectControl_borderRadius: shape.borderRadius, SelectControl_color: color.onSurface, SelectControl_color_disabled: black57, SelectControl_color_readOnly: black57, SelectControl_fontFamily: typography.fontFamily, SelectControl_fontSize_small: typography.fontSize, SelectControl_fontSize_medium: typography.fontSize, SelectControl_fontSize_large: typography.fontSize + 2, SelectControl_fontWeight: typography.fontWeightRegular, SelectControl_boxShadow_focus: '0 0 0 1px ' + ninja11 });
	};exports.default = componentTheme;

/***/ },
/* 438 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	Object.defineProperty(exports, '__esModule', { value: !0 });var _SelectControl = __webpack_require__(436);Object.defineProperty(exports, 'default', { enumerable: !0, get: function get() {
	    return _interopRequireDefault(_SelectControl).default;
	  } });function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}

/***/ },
/* 439 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) {
	  for (var source, i = 1; i < arguments.length; i++) {
	    for (var key in source = arguments[i], source) {
	      Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
	    }
	  }return target;
	},
	    _createClass = function () {
	  function defineProperties(target, props) {
	    for (var descriptor, i = 0; i < props.length; i++) {
	      descriptor = props[i], descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, 'value' in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    return protoProps && defineProperties(Constructor.prototype, protoProps), staticProps && defineProperties(Constructor, staticProps), Constructor;
	  };
	}(),
	    _react = __webpack_require__(3),
	    _react2 = _interopRequireDefault(_react),
	    _propTypes = __webpack_require__(6),
	    _propTypes2 = _interopRequireDefault(_propTypes),
	    _styledComponents = __webpack_require__(15),
	    _styledComponents2 = _interopRequireDefault(_styledComponents),
	    _themes = __webpack_require__(4),
	    _propTypes3 = __webpack_require__(16),
	    _componentTheme = __webpack_require__(440),
	    _componentTheme2 = _interopRequireDefault(_componentTheme),
	    _Button = __webpack_require__(58),
	    _Button2 = _interopRequireDefault(_Button);Object.defineProperty(exports, '__esModule', { value: !0 });function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}function _objectWithoutProperties(obj, keys) {
	  var target = {};for (var i in obj) {
	    0 <= keys.indexOf(i) || Object.prototype.hasOwnProperty.call(obj, i) && (target[i] = obj[i]);
	  }return target;
	}function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
	}function _possibleConstructorReturn(self, call) {
	  if (!self) throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');return call && ('object' == (typeof call === 'undefined' ? 'undefined' : _typeof(call)) || 'function' == typeof call) ? call : self;
	}function _inherits(subClass, superClass) {
	  if ('function' != typeof superClass && null !== superClass) throw new TypeError('Super expression must either be null or a function, not ' + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: !1, writable: !0, configurable: !0 } }), superClass && (Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass);
	}var ThemedButton = (0, _themes.createThemedComponent)(_Button2.default, { Button_backgroundColor_themePrimary_disabled: (0, _themes.getStyle)('Switch_backgroundColor_themePrimary_disabled_on'), Button_borderRadius: (0, _themes.getStyle)('Switch_borderRadius'), Button_paddingHorizontal_small: 0, Button_paddingHorizontal_medium: 0, Button_paddingHorizontal_large: 0, Button_paddingHorizontal_fullWidth: 0 }),
	    Styled = {};Styled.Button = (0, _styledComponents2.default)(ThemedButton).withConfig({ displayName: 'Switch__Button' })(['position:relative;width:', ';&::after{content:\'\';position:absolute;top:3px;left:0;box-sizing:border-box;width:', ';height:', ';background:white;border-width:1px;border-style:solid;border-color:', ';border-radius:100%;transition-property:transform;transition-duration:', ';pointer-events:none;}&:disabled{opacity:0.5;}&[aria-pressed=\'false\'],[aria-pressed=\'false\']{background:', ';border-color:', ';&:focus{border-color:', ';}&:hover{border-color:', ';&:focus{border-color:', ';}}&::after{transform:', ';}}&[aria-pressed=\'true\'],[aria-pressed=\'true\']{&::after{border-color:white;transform:', ';}}'], function (props) {
	  return (0, _themes.getStyle)('Switch_width_' + props.size)(props);
	}, function (props) {
	  return (0, _themes.getStyle)('SwitchKnob_width_' + props.size)(props);
	}, function (props) {
	  return (0, _themes.getStyle)('SwitchKnob_width_' + props.size)(props);
	}, (0, _themes.getStyle)('Switch_borderColor_off'), (0, _themes.getStyle)('Switch_transitionDuration'), (0, _themes.getStyle)('Switch_backgroundColor_off'), (0, _themes.getStyle)('Switch_borderColor_off'), (0, _themes.getStyle)('Switch_borderColor_off_focus'), (0, _themes.getStyle)('Switch_borderColor_off_hover'), (0, _themes.getStyle)('Switch_borderColor_off_focus'), function (props) {
	  return (0, _themes.getStyle)('SwitchKnob_translateX_' + props.size)(props);
	}, function (props) {
	  return (0, _themes.getStyle)('SwitchKnob_translateX_' + props.size + '_pressed')(props);
	});var Switch = function (_React$Component) {
	  function Switch() {
	    _classCallCheck(this, Switch);var _this = _possibleConstructorReturn(this, (Switch.__proto__ || Object.getPrototypeOf(Switch)).call(this));return _this.state = { pressed: !1 }, _this.handleClick = _this.handleClick.bind(_this), _this;
	  }return _inherits(Switch, _React$Component), _createClass(Switch, [{ key: 'handleClick', value: function handleClick() {
	      var pressed = this.state.pressed;this.setState({ pressed: !pressed });
	    } }, { key: 'render', value: function render() {
	      var _props = this.props,
	          size = _props.size,
	          themeProp = _props.theme,
	          otherProps = _objectWithoutProperties(_props, ['size', 'theme']),
	          theme = (0, _componentTheme2.default)(themeProp),
	          pressed = this.state.pressed;return _react2.default.createElement(Styled.Button, _extends({}, otherProps, { "aria-pressed": pressed, onClick: this.handleClick, size: size, theme: theme }));
	    } }]), Switch;
	}(_react2.default.Component);Switch.propTypes = { disabled: _propTypes2.default.bool, labelledBy: _propTypes2.default.string, size: _propTypes2.default.oneOf(['small', 'medium', 'large']), theme: _propTypes3.themeShape }, Switch.defaultProps = { size: 'medium', theme: (0, _themes.createTheme)() }, Switch.displayName = 'Switch';var SwitchWithTheme = (0, _themes.withTheme)(Switch);SwitchWithTheme.WrappedComponent = Switch, exports.default = SwitchWithTheme;

/***/ },
/* 440 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	Object.defineProperty(exports, '__esModule', { value: !0 });var _themes = __webpack_require__(4),
	    componentTheme = function componentTheme(baseTheme) {
	  var _baseTheme$vstui = baseTheme.vstui,
	      color = _baseTheme$vstui.color,
	      size = _baseTheme$vstui.size,
	      transition = _baseTheme$vstui.transition,
	      cloud3 = color.cloud.getShade(3),
	      black43 = 'rgba(0, 0, 0, 0.43)',
	      knobPadding = 4,
	      switchKnobDiameterSmall = size.small - 2 * knobPadding,
	      switchKnobDiameterMedium = size.medium - 2 * knobPadding,
	      switchKnobDiameterLarge = size.large - 2 * knobPadding;return (0, _themes.createComponentTheme)(baseTheme, { Switch_width_small: knobPadding + 2 * switchKnobDiameterSmall + 'px', Switch_width_medium: knobPadding + 2 * switchKnobDiameterMedium + 'px', Switch_width_large: knobPadding + 2 * switchKnobDiameterLarge + 'px', Switch_backgroundColor_themePrimary_disabled_on: function primaryMain(_ref) {
	      var sc = _ref.sc;return color.primary.getMainShade({ backgroundColor: sc.colorBehindButton });
	    }, Switch_backgroundColor_off: cloud3, Switch_borderColor_off: black43, Switch_borderColor_off_active: black43, Switch_borderColor_off_focus: black43, Switch_borderColor_off_hover: black43, Switch_borderRadius: '100px', Switch_transitionDuration: transition.duration.shortest, SwitchKnob_width_small: switchKnobDiameterSmall + 'px', SwitchKnob_width_medium: switchKnobDiameterMedium + 'px', SwitchKnob_width_large: switchKnobDiameterLarge + 'px', SwitchKnob_translateX_small: 'translateX(' + (knobPadding - 1) + 'px)', SwitchKnob_translateX_medium: 'translateX(' + (knobPadding - 1) + 'px)', SwitchKnob_translateX_large: 'translateX(' + (knobPadding - 1) + 'px)', SwitchKnob_translateX_small_pressed: 'translateX(' + (switchKnobDiameterSmall - 1) + 'px)', SwitchKnob_translateX_medium_pressed: 'translateX(' + (switchKnobDiameterMedium - 1) + 'px)', SwitchKnob_translateX_large_pressed: 'translateX(' + (switchKnobDiameterLarge - 1) + 'px)' });
	};exports.default = componentTheme;

/***/ },
/* 441 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	Object.defineProperty(exports, '__esModule', { value: !0 });var _Switch = __webpack_require__(439);Object.defineProperty(exports, 'default', { enumerable: !0, get: function get() {
	    return _interopRequireDefault(_Switch).default;
	  } });function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}

/***/ },
/* 442 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) {
	  for (var source, i = 1; i < arguments.length; i++) {
	    for (var key in source = arguments[i], source) {
	      Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
	    }
	  }return target;
	},
	    _createClass = function () {
	  function defineProperties(target, props) {
	    for (var descriptor, i = 0; i < props.length; i++) {
	      descriptor = props[i], descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, 'value' in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    return protoProps && defineProperties(Constructor.prototype, protoProps), staticProps && defineProperties(Constructor, staticProps), Constructor;
	  };
	}(),
	    _react = __webpack_require__(3),
	    _react2 = _interopRequireDefault(_react),
	    _propTypes = __webpack_require__(6),
	    _propTypes2 = _interopRequireDefault(_propTypes),
	    _Icon = __webpack_require__(26),
	    _Icon2 = _interopRequireDefault(_Icon),
	    _colors = __webpack_require__(101);Object.defineProperty(exports, '__esModule', { value: !0 });function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}function _objectWithoutProperties(obj, keys) {
	  var target = {};for (var i in obj) {
	    0 <= keys.indexOf(i) || Object.prototype.hasOwnProperty.call(obj, i) && (target[i] = obj[i]);
	  }return target;
	}function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
	}function _possibleConstructorReturn(self, call) {
	  if (!self) throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');return call && ('object' == (typeof call === 'undefined' ? 'undefined' : _typeof(call)) || 'function' == typeof call) ? call : self;
	}function _inherits(subClass, superClass) {
	  if ('function' != typeof superClass && null !== superClass) throw new TypeError('Super expression must either be null or a function, not ' + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: !1, writable: !0, configurable: !0 } }), superClass && (Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass);
	}var SortIcon = function (_PureComponent) {
	  function SortIcon() {
	    return _classCallCheck(this, SortIcon), _possibleConstructorReturn(this, (SortIcon.__proto__ || Object.getPrototypeOf(SortIcon)).apply(this, arguments));
	  }return _inherits(SortIcon, _PureComponent), _createClass(SortIcon, [{ key: 'render', value: function render() {
	      var _props = this.props,
	          direction = _props.direction,
	          other = _objectWithoutProperties(_props, ['direction']);return 'ascending' === direction && (other.transform = 'rotate(180)'), _react2.default.createElement(_Icon2.default, _extends({}, other, { height: 4, width: 6 }), _react2.default.createElement('path', { d: 'M5.547.2c.396 0 .6.474.327.762L3.358 3.617c-.18.24-.54.24-.717 0L.125.962A.45.45 0 0 1 .45.2h5.097z', fill: _colors.cloud.getShade(7) }));
	    } }]), SortIcon;
	}(_react.PureComponent);SortIcon.propTypes = { direction: _propTypes2.default.oneOf(['ascending', 'descending']) }, SortIcon.defaultProps = {}, SortIcon.displayName = 'SortIcon', exports.default = SortIcon;

/***/ },
/* 443 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) {
	  for (var source, i = 1; i < arguments.length; i++) {
	    for (var key in source = arguments[i], source) {
	      Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
	    }
	  }return target;
	},
	    _createClass = function () {
	  function defineProperties(target, props) {
	    for (var descriptor, i = 0; i < props.length; i++) {
	      descriptor = props[i], descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, 'value' in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    return protoProps && defineProperties(Constructor.prototype, protoProps), staticProps && defineProperties(Constructor, staticProps), Constructor;
	  };
	}(),
	    _templateObject = _taggedTemplateLiteral(['\n  box-sizing: border-box;\n  & *,\n  & *::before,\n  & *::after {\n    box-sizing: inherit;\n  }\n\n  button {\n    cursor: pointer;\n  }\n  button[disabled] {\n    cursor: default;\n  }\n'], ['\n  box-sizing: border-box;\n  & *,\n  & *::before,\n  & *::after {\n    box-sizing: inherit;\n  }\n\n  button {\n    cursor: pointer;\n  }\n  button[disabled] {\n    cursor: default;\n  }\n']),
	    _react = __webpack_require__(3),
	    _react2 = _interopRequireDefault(_react),
	    _reactDom = __webpack_require__(63),
	    _reactDom2 = _interopRequireDefault(_reactDom),
	    _propTypes = __webpack_require__(6),
	    _propTypes2 = _interopRequireDefault(_propTypes),
	    _styledComponents = __webpack_require__(15),
	    _styledComponents2 = _interopRequireDefault(_styledComponents),
	    _TableHeader = __webpack_require__(188),
	    _TableHeader2 = _interopRequireDefault(_TableHeader),
	    _TableBody = __webpack_require__(186),
	    _TableBody2 = _interopRequireDefault(_TableBody),
	    _TableRow = __webpack_require__(190),
	    _TableRow2 = _interopRequireDefault(_TableRow),
	    _TableHeaderCell = __webpack_require__(189),
	    _TableHeaderCell2 = _interopRequireDefault(_TableHeaderCell),
	    _TableDataCell = __webpack_require__(187),
	    _TableDataCell2 = _interopRequireDefault(_TableDataCell),
	    _Card = __webpack_require__(183),
	    _Card2 = _interopRequireDefault(_Card),
	    _styles = __webpack_require__(31),
	    _withCommonProps = __webpack_require__(38),
	    _withCommonProps2 = _interopRequireDefault(_withCommonProps),
	    _themes = __webpack_require__(4),
	    _propTypes3 = __webpack_require__(16),
	    _componentTheme = __webpack_require__(444),
	    _componentTheme2 = _interopRequireDefault(_componentTheme);Object.defineProperty(exports, '__esModule', { value: !0 });function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}function _toConsumableArray(arr) {
	  if (Array.isArray(arr)) {
	    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
	      arr2[i] = arr[i];
	    }return arr2;
	  }return Array.from(arr);
	}function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
	}function _possibleConstructorReturn(self, call) {
	  if (!self) throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');return call && ('object' == (typeof call === 'undefined' ? 'undefined' : _typeof(call)) || 'function' == typeof call) ? call : self;
	}function _inherits(subClass, superClass) {
	  if ('function' != typeof superClass && null !== superClass) throw new TypeError('Super expression must either be null or a function, not ' + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: !1, writable: !0, configurable: !0 } }), superClass && (Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass);
	}function _taggedTemplateLiteral(strings, raw) {
	  return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } }));
	}var Styled = { Card: {}, div: {}, table: {} },
	    normalizeStyles = (0, _styles.css)(_templateObject);Styled.Card.root = (0, _styledComponents2.default)(_Card2.default).withConfig({ displayName: 'Table__root' })(['', ';', ';width:', ';max-width:100%;overflow-x:auto;-webkit-overflow-scrolling:touch;font-family:', ';font-size:', ';font-weight:', ';line-height:1.5;@media print{max-width:none;overflow:visible;border:none;}'], _styles.resetInheritedStyles, normalizeStyles, function (props) {
	  return props.sc.fullWidth ? '100%' : 'auto';
	}, (0, _themes.getStyle)('Table_fontFamily'), function (props) {
	  return props.theme.vstui.rem((0, _themes.getStyle)('Table_fontSize')(props));
	}, (0, _themes.getStyle)('Table_fontWeight')), Styled.div.tableWrapper = _styledComponents2.default.div.withConfig({ displayName: 'Table__tableWrapper' })(['position:relative;display:table;width:100%;']), Styled.div.headerTableWrapper = _styledComponents2.default.div.withConfig({ displayName: 'Table__headerTableWrapper' })(['position:absolute;top:0;right:0;bottom:0;left:0;z-index:2;margin-right:', 'px;pointer-events:none;'], function (props) {
	  return props.scrollable ? props.scrollbarWidth : 0;
	}), Styled.table.header = _styledComponents2.default.table.withConfig({ displayName: 'Table__header' })(['position:absolute;top:0;left:0;width:100%;border-collapse:separate;border-spacing:0;thead{th{position:relative;pointer-events:auto;}position:relative;}tbody{visibility:hidden;tr{th,td{padding-top:0;padding-bottom:0;border-top:none;border-bottom:none;line-height:0.1;}& + tr th,& + tr td{line-height:0;}}}tbody tr:last-child td{border-bottom:none;}tfoot{position:relative;th,td{position:relative;}}@media print{display:none;}']), Styled.div.bodyTableWrapper = _styledComponents2.default.div.withConfig({ displayName: 'Table__bodyTableWrapper' })(['position:relative;z-index:1;width:100%;max-height:', ';overflow-y:', ';-webkit-overflow-scrolling:touch;outline-offset:-10px;@media print{max-height:100%;overflow:visible;}'], function (props) {
	  return props.maxHeight ? props.theme.vstui.rem(props.maxHeight) : 'none';
	}, function (props) {
	  return props.scrollable ? 'scroll' : 'visible';
	}), Styled.table.body = _styledComponents2.default.table.withConfig({ displayName: 'Table__body' })(['width:100%;border-collapse:separate;border-spacing:0;tbody tr:last-child td{border-bottom:none;}@media print{page-break-inside:avoid;}']);var Table = function (_Component) {
	  function Table() {
	    _classCallCheck(this, Table);var _this = _possibleConstructorReturn(this, (Table.__proto__ || Object.getPrototypeOf(Table)).call(this));return _this.handleBodyTableRef = _this.handleBodyTableRef.bind(_this), _this.handleHeaderClick = _this.handleHeaderClick.bind(_this), _this.compare = _this.compare.bind(_this), _this.state = { scrollable: !1, sortOrder: 1, sortedHeaderIndex: null, scrollbarWidth: _this.getScrollbarWidth() }, _this;
	  }return _inherits(Table, _Component), _createClass(Table, [{ key: 'getScrollbarWidth', value: function getScrollbarWidth() {
	      var outer = document.createElement('div');outer.style.visibility = 'hidden', outer.style.width = '100px', document.body.appendChild(outer);var widthWithoutScroll = outer.offsetWidth;outer.style.overflow = 'scroll';var inner = document.createElement('div');inner.style.width = '100%', outer.appendChild(inner);var widthWithScroll = inner.offsetWidth;return outer.parentNode.removeChild(outer), widthWithoutScroll - widthWithScroll;
	    } }, { key: 'getSortValue', value: function getSortValue(row) {
	      var cellData = Object.values(row)[this.state.sortedHeaderIndex];return void 0 === cellData || null === cellData ? null : cellData.content ? cellData.sort || this.toString(cellData.content) : this.toString(cellData);
	    } }, { key: 'toString', value: function toString(element) {
	      var _this2 = this;if (_react2.default.isValidElement(element)) return this.toString(_react2.default.Children.toArray(element.props.children));if (Array.isArray(element)) {
	        var _ref,
	            array = element.map(function (child) {
	          return 'string' == typeof child ? child.toLowerCase() : _this2.toString(child);
	        });return (_ref = []).concat.apply(_ref, _toConsumableArray(array)).join('');
	      }return element;
	    } }, { key: 'compare', value: function compare(rowA, rowB) {
	      var sortValueA = this.getSortValue(rowA),
	          sortValueB = this.getSortValue(rowB);return sortValueA > sortValueB ? this.state.sortOrder : sortValueA < sortValueB ? -1 * this.state.sortOrder : 0;
	    } }, { key: 'handleBodyTableRef', value: function handleBodyTableRef(table) {
	      var maxStaticHeight = this.props.maxStaticHeight;if (table && maxStaticHeight) {
	        var height,
	            pxRegex = /px$/,
	            percentRegex = /%$/;if (maxStaticHeight.match(pxRegex)) height = parseInt(maxStaticHeight.split(pxRegex)[0], 10);else if (maxStaticHeight.match(percentRegex)) {
	          var rootNode = _reactDom2.default.findDOMNode(this),
	              parentHeight = rootNode.parentNode.offsetHeight;height = parentHeight * (parseInt(maxStaticHeight.split(percentRegex)[0], 10) / 100);
	        }this.setState({ maxHeight: height + 'px', scrollable: !0 });
	      }
	    } }, { key: 'handleHeaderClick', value: function handleHeaderClick(event, index) {
	      -1 === this.state.sortOrder || this.state.sortedHeaderIndex !== index ? this.setState({ sortOrder: 1, sortedHeaderIndex: index }) : this.setState({ sortOrder: -1, sortedHeaderIndex: index });
	    } }, { key: 'renderHeaderTable', value: function renderHeaderTable(theme) {
	      return _react2.default.createElement(Styled.table.header, null, this.renderTableHeader('header', theme), this.renderTableBody(theme));
	    } }, { key: 'renderBodyTable', value: function renderBodyTable(theme) {
	      return _react2.default.createElement(Styled.table.body, { innerRef: this.handleBodyTableRef }, this.renderTableHeader('body', theme), this.renderTableBody(theme));
	    } }, { key: 'renderTableHeader', value: function renderTableHeader(tableType, theme) {
	      var _this3 = this,
	          columns = this.props.columns,
	          _state = this.state,
	          sortedHeaderIndex = _state.sortedHeaderIndex,
	          sortOrder = _state.sortOrder;return _react2.default.createElement(_TableHeader2.default, { theme: theme }, _react2.default.createElement(_TableRow2.default, { theme: theme }, columns.map(function (column, index) {
	        return _react2.default.createElement(_TableHeaderCell2.default, { hidden: !0 === column.hiddenHeader, index: index, key: index, numeric: !0 === column.numeric, onClick: _this3.handleHeaderClick, sortIndex: sortedHeaderIndex, sortOrder: sortOrder, tableType: tableType, theme: theme }, column.header);
	      })));
	    } }, { key: 'renderTableBody', value: function renderTableBody(theme) {
	      var _this4 = this,
	          _props = this.props,
	          rows = _props.rows,
	          secondary = _props.secondary,
	          _state2 = this.state,
	          sortedHeaderIndex = _state2.sortedHeaderIndex,
	          sortOrder = _state2.sortOrder,
	          sortedRows = void 0;return sortedRows = null === this.state.sortedHeaderIndex ? rows : rows.sort(this.compare), _react2.default.createElement(_TableBody2.default, { secondary: secondary, sortIndex: sortedHeaderIndex, sortOrder: sortOrder, theme: theme }, sortedRows.map(function (row, rowIndex) {
	        return _react2.default.createElement(_TableRow2.default, { key: rowIndex, theme: theme }, _this4.props.columns.map(function (column, columnIndex) {
	          return _this4.renderTableDataCell(row, column, columnIndex, theme);
	        }));
	      }));
	    } }, { key: 'renderTableDataCell', value: function renderTableDataCell(row, column, columnIndex, theme) {
	      var secondary = this.props.secondary,
	          hover = this.state.hover,
	          cellData = row[column.rowKey],
	          content = void 0;return content = void 0 === cellData || null === cellData ? null : cellData.content ? cellData.content : cellData, _react2.default.createElement(_TableDataCell2.default, { key: columnIndex, numeric: !0 === column.numeric, rowHover: hover, secondary: secondary, theme: theme }, content);
	    } }, { key: 'render', value: function render() {
	      var _props2 = this.props,
	          className = _props2.className,
	          commonProps = _props2.commonProps,
	          dir = _props2.dir,
	          fullWidth = _props2.fullWidth,
	          inheritStyles = _props2.inheritStyles,
	          raised = _props2.raised,
	          themeProp = _props2.theme,
	          _state3 = this.state,
	          maxHeight = _state3.maxHeight,
	          scrollable = _state3.scrollable,
	          scrollbarWidth = _state3.scrollbarWidth,
	          theme = (0, _componentTheme2.default)(themeProp);return _react2.default.createElement(Styled.Card.root, _extends({}, commonProps, { className: className, dir: dir, raised: raised, sc: { fullWidth: fullWidth, inheritStyles: inheritStyles }, theme: theme }), _react2.default.createElement(Styled.div.tableWrapper, null, _react2.default.createElement(Styled.div.headerTableWrapper, { "aria-hidden": !0, scrollable: scrollable, scrollbarWidth: scrollbarWidth }, this.renderHeaderTable(theme)), _react2.default.createElement(Styled.div.bodyTableWrapper, { maxHeight: maxHeight, role: 'region', scrollable: scrollable, tabIndex: scrollable ? 0 : void 0 }, this.renderBodyTable(theme))));
	    } }]), Table;
	}(_react.Component);Table.propTypes = { className: _propTypes2.default.string, columns: _propTypes2.default.arrayOf(_propTypes2.default.shape({ header: _propTypes2.default.string.isRequired, hiddenHeader: _propTypes2.default.bool, numeric: _propTypes2.default.bool, rowKey: _propTypes2.default.string.isRequired })).isRequired, commonProps: _propTypes3.commonPropsShape, dir: _propTypes2.default.oneOf(['ltr', 'rtl', 'auto']), fullWidth: _propTypes2.default.bool, inheritStyles: _propTypes2.default.bool, maxStaticHeight: _propTypes2.default.string, raised: _propTypes2.default.bool, rows: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired, secondary: _propTypes2.default.bool, theme: _propTypes3.themeShape }, Table.defaultProps = { theme: (0, _themes.createTheme)() }, Table.displayName = 'Table';var TableWithTheme = (0, _withCommonProps2.default)(Table);TableWithTheme.WrappedComponent = Table, exports.default = TableWithTheme;

/***/ },
/* 444 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	Object.defineProperty(exports, '__esModule', { value: !0 });var _themes = __webpack_require__(4),
	    componentTheme = function componentTheme(baseTheme) {
	  var _baseTheme$vstui = baseTheme.vstui,
	      color = _baseTheme$vstui.color,
	      shape = _baseTheme$vstui.shape,
	      typography = _baseTheme$vstui.typography,
	      cloud2 = color.cloud.getShade(2),
	      cloud3 = color.cloud.getShade(3),
	      cloud4 = color.cloud.getShade(4),
	      cloud9 = color.cloud.getShade(9);return (0, _themes.createComponentTheme)(baseTheme, { Table_borderRadius: shape.borderRadius, Table_fontFamily: typography.fontFamily, Table_fontSize: typography.fontSize, Table_fontWeight: typography.fontWeightRegular, TableDataCell_backgroundColor: color.surface, TableDataCell_backgroundColor_primary_hover: color.surface, TableDataCell_backgroundColor_secondary_hover: color.surface, TableDataCell_borderColor: cloud3, TableDataCell_color: color.onSurface, TableDataCell_fontFamily: typography.fontFamily, TableDataCell_fontSize: typography.fontSize, TableDataCell_fontWeight: typography.fontWeightRegular, TableHeaderCell_backgroundColor: cloud2, TableHeaderCell_borderColor: cloud4, TableHeaderCell_color: cloud9, TableHeaderCell_fontFamily: typography.fontFamily, TableHeaderCell_fontSize: typography.fontSize - 1, TableHeaderCell_fontWeight: typography.fontWeightRegular });
	};exports.default = componentTheme;

/***/ },
/* 445 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	Object.defineProperty(exports, '__esModule', { value: !0 });var _Table = __webpack_require__(443);Object.defineProperty(exports, 'default', { enumerable: !0, get: function get() {
	    return _interopRequireDefault(_Table).default;
	  } });var _TableBody = __webpack_require__(186);Object.defineProperty(exports, 'TableBody', { enumerable: !0, get: function get() {
	    return _interopRequireDefault(_TableBody).default;
	  } });var _TableDataCell = __webpack_require__(187);Object.defineProperty(exports, 'TableDataCell', { enumerable: !0, get: function get() {
	    return _interopRequireDefault(_TableDataCell).default;
	  } });var _TableHeader = __webpack_require__(188);Object.defineProperty(exports, 'TableHeader', { enumerable: !0, get: function get() {
	    return _interopRequireDefault(_TableHeader).default;
	  } });var _TableHeaderCell = __webpack_require__(189);Object.defineProperty(exports, 'TableHeaderCell', { enumerable: !0, get: function get() {
	    return _interopRequireDefault(_TableHeaderCell).default;
	  } });var _TableRow = __webpack_require__(190);Object.defineProperty(exports, 'TableRow', { enumerable: !0, get: function get() {
	    return _interopRequireDefault(_TableRow).default;
	  } });function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}

/***/ },
/* 446 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _typeof = 'function' == typeof Symbol && 'symbol' == _typeof2(Symbol.iterator) ? function (obj) {
	  return typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
	} : function (obj) {
	  return obj && 'function' == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? 'symbol' : typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
	},
	    _extends = Object.assign || function (target) {
	  for (var source, i = 1; i < arguments.length; i++) {
	    for (var key in source = arguments[i], source) {
	      Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
	    }
	  }return target;
	},
	    _createClass = function () {
	  function defineProperties(target, props) {
	    for (var descriptor, i = 0; i < props.length; i++) {
	      descriptor = props[i], descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, 'value' in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    return protoProps && defineProperties(Constructor.prototype, protoProps), staticProps && defineProperties(Constructor, staticProps), Constructor;
	  };
	}(),
	    _react = __webpack_require__(3),
	    _react2 = _interopRequireDefault(_react),
	    _propTypes = __webpack_require__(6),
	    _propTypes2 = _interopRequireDefault(_propTypes),
	    _styledComponents = __webpack_require__(15),
	    _styledComponents2 = _interopRequireDefault(_styledComponents),
	    _styles = __webpack_require__(31),
	    _withCommonProps = __webpack_require__(38),
	    _withCommonProps2 = _interopRequireDefault(_withCommonProps),
	    _themes = __webpack_require__(4),
	    _propTypes3 = __webpack_require__(16),
	    _FormControl = __webpack_require__(100),
	    _FormControl2 = _interopRequireDefault(_FormControl),
	    _componentTheme = __webpack_require__(447),
	    _componentTheme2 = _interopRequireDefault(_componentTheme);Object.defineProperty(exports, '__esModule', { value: !0 });function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}function _objectWithoutProperties(obj, keys) {
	  var target = {};for (var i in obj) {
	    0 <= keys.indexOf(i) || Object.prototype.hasOwnProperty.call(obj, i) && (target[i] = obj[i]);
	  }return target;
	}function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
	}function _possibleConstructorReturn(self, call) {
	  if (!self) throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');return call && ('object' == (typeof call === 'undefined' ? 'undefined' : _typeof2(call)) || 'function' == typeof call) ? call : self;
	}function _inherits(subClass, superClass) {
	  if ('function' != typeof superClass && null !== superClass) throw new TypeError('Super expression must either be null or a function, not ' + (typeof superClass === 'undefined' ? 'undefined' : _typeof2(superClass)));subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: !1, writable: !0, configurable: !0 } }), superClass && (Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass);
	}var Styled = {};Styled.div = {}, Styled.textarea = _styledComponents2.default.textarea.withConfig({ displayName: 'TextAreaControl__textarea' })(['', ';box-sizing:border-box;width:', ';max-width:100%;min-height:', ';padding:5px 12px;background-color:', ';background-image:', ';background-position:', ';background-repeat:no-repeat;background-size:', ';border-color:', ';border-style:', ';border-width:', ';border-radius:', ';color:', ';font-family:', ';font-size:', ';font-weight:', ';-webkit-font-smoothing:antialiased;line-height:1.5;text-align:start;white-space:pre-wrap;vertical-align:top;transition-property:none;transition-duration:', ';transition-timing-function:', ';appearance:none;resize:none;word-wrap:break-word;&::-moz-placeholder{opacity:1;}&::placeholder{color:', ';font-weight:', ';text-align:', ';}&:required{box-shadow:none;}&:read-only{background-color:', ';color:', ';}&:focus{outline:none;border-color:', ';box-shadow:', ';}&[aria-invalid]{padding-right:', 'px;background-image:', ';border-color:', ';box-shadow:none;&:focus{background-image:', ';border-color:', ';box-shadow:', ';}}&:disabled{background-color:', ';border-color:', ';color:', ';cursor:default;}'], function (props) {
	  return props.sc.inheritStyles ? '' : (0, _styles.resetInheritedStyles)({ direction: props.theme.vstui.i18n.direction });
	}, function (props) {
	  return props.sc.fullWidth ? '100%' : (0, _themes.getStyle)('TextAreaControl_width');
	}, function (props) {
	  return props.theme.vstui.rem((0, _themes.getStyle)('InputControl_minHeight_' + props.sc.size)(props));
	}, (0, _themes.getStyle)('TextAreaControl_backgroundColor'), (0, _themes.getStyle)('TextAreaControl_backgroundImage'), function (props) {
	  return (0, _themes.getStyle)('TextAreaControl_backgroundPosition_' + props.sc.size)(props);
	}, (0, _themes.getStyle)('TextAreaControl_backgroundSize'), (0, _themes.getStyle)('TextAreaControl_borderColor'), (0, _themes.getStyle)('TextAreaControl_borderStyle'), (0, _themes.getStyle)('TextAreaControl_borderWidth'), (0, _themes.getStyle)('TextAreaControl_borderRadius'), (0, _themes.getStyle)('TextAreaControl_color'), (0, _themes.getStyle)('TextAreaControl_fontFamily'), function (props) {
	  return props.theme.vstui.rem((0, _themes.getStyle)('TextAreaControl_fontSize_' + props.sc.size)(props));
	}, (0, _themes.getStyle)('TextAreaControl_fontWeight'), function (props) {
	  return props.theme.vstui.transition.duration.shortest;
	}, function (props) {
	  return props.theme.vstui.transition.easing.easeIn;
	}, (0, _themes.getStyle)('TextAreaControlPlaceholder_color'), (0, _themes.getStyle)('TextAreaControlPlaceholder_fontWeight'), function (props) {
	  return 'rtl' === props.theme.vstui.i18n.direction ? 'right' : 'left';
	}, (0, _themes.getStyle)('TextAreaControl_backgroundColor_readOnly'), (0, _themes.getStyle)('TextAreaControl_color_readOnly'), (0, _themes.getStyle)('TextAreaControl_borderColor_focus'), (0, _themes.getStyle)('TextAreaControl_boxShadow_focus'), function (props) {
	  return 'rtl' === props.theme.vstui.i18n.direction ? 12 : 38;
	}, (0, _themes.getStyle)('TextAreaControl_backgroundImage_invalid'), (0, _themes.getStyle)('TextAreaControl_borderColor_invalid'), (0, _themes.getStyle)('TextAreaControl_backgroundImage_invalidFocus'), (0, _themes.getStyle)('TextAreaControl_borderColor_invalidFocus'), (0, _themes.getStyle)('TextAreaControl_boxShadow_focus'), (0, _themes.getStyle)('TextAreaControl_backgroundColor_disabled'), (0, _themes.getStyle)('TextAreaControl_borderColor_disabled'), (0, _themes.getStyle)('TextAreaControl_color_disabled')), Styled.textarea.displayName = 'Styled_textarea';var TextAreaControl = function (_PureComponent) {
	  function TextAreaControl(props) {
	    _classCallCheck(this, TextAreaControl);var _this = _possibleConstructorReturn(this, (TextAreaControl.__proto__ || Object.getPrototypeOf(TextAreaControl)).call(this, props));return _this.handleFormControlRef = _this.handleFormControlRef.bind(_this), _this.handleValidate = _this.handleValidate.bind(_this), _this.renderContent = _this.renderContent.bind(_this), _this.formValidation = { missingText: function missingText() {
	        return 'Please fill out this field.';
	      }, tooLong: function tooLong(maxLength, currentLength) {
	        return 'Please shorten this text to ' + maxLength + ' characters or less (you are currently using ' + currentLength + ' characters).';
	      }, tooShort: function tooShort(minLength, currentLength) {
	        return 'Please use at least ' + minLength + ' characters (you are currently using ' + currentLength + ' characters).';
	      } }, _this;
	  }return _inherits(TextAreaControl, _PureComponent), _createClass(TextAreaControl, [{ key: 'componentDidMount', value: function componentDidMount() {
	      this.props.onRef && this.props.onRef(this);
	    } }, { key: 'componentWillUnmount', value: function componentWillUnmount() {
	      this.props.onRef && this.props.onRef(void 0);
	    } }, { key: 'getValidationMessage', value: function getValidationMessage(validity) {
	      var _props = this.props,
	          maxLength = _props.maxLength,
	          minLength = _props.minLength,
	          theme = _props.theme,
	          value = _props.value,
	          i18n = theme.vstui.i18n;if (validity.valueMissing) return i18n.t('form.missingText');if (validity.tooLong || validity.tooShort) {
	        var id = validity.tooLong ? 'form.shortenCharacters' : 'form.lengthenCharacters',
	            quantity = validity.tooLong ? maxLength : minLength,
	            changeCharacters = i18n.t(id, { quantity: quantity }),
	            currentlyUsingCharacters = i18n.t('form.currentlyUsingCharacters', { quantity: value.length });return i18n.t('form.badLength', { changeCharacters: changeCharacters, currentlyUsingCharacters: currentlyUsingCharacters });
	      }return '';
	    } }, { key: 'validate', value: function validate(callback) {
	      this.formControl.validate(callback);
	    } }, { key: 'handleFormControlRef', value: function handleFormControlRef(node) {
	      this.formControl = node;
	    } }, { key: 'handleValidate', value: function handleValidate(validity) {
	      var _ref2 = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {},
	          callback = _ref2.callback,
	          onlyValidateIfValid = _ref2.onlyValidateIfValid,
	          _ref = arguments[2],
	          updateValidationState = _ref.updateValidationState,
	          value = _ref.value,
	          _props2 = this.props,
	          onValidate = _props2.onValidate,
	          validate = _props2.validate,
	          passedDefaultValidation = validity.valid,
	          defaultValidationMessage = this.getValidationMessage(validity),
	          customValidationMessagePromise = Promise.resolve(validate ? validate(value) : ''),
	          update = function update(valid, validationMessage) {
	        (!onlyValidateIfValid || onlyValidateIfValid && valid) && updateValidationState(valid, validationMessage, onValidate);
	      };update(passedDefaultValidation, defaultValidationMessage), passedDefaultValidation ? customValidationMessagePromise.then(function (customValidationMessage) {
	        var passedCustomValidation = !customValidationMessage;update(passedCustomValidation, customValidationMessage), callback && callback(passedCustomValidation, customValidationMessage);
	      }) : callback && callback(passedDefaultValidation, defaultValidationMessage);
	    } }, { key: 'renderContent', value: function renderContent(_ref3) {
	      var defaultValue = _ref3.defaultValue,
	          invalid = _ref3.invalid,
	          handleBlur = _ref3.handleBlur,
	          handleChange = _ref3.handleChange,
	          handleNativeFormControlRef = _ref3.handleNativeFormControlRef,
	          value = _ref3.value,
	          _props3 = this.props,
	          className = _props3.className,
	          commonProps = _props3.commonProps,
	          dir = _props3.dir,
	          disabled = _props3.disabled,
	          fullWidth = _props3.fullWidth,
	          inheritStyles = _props3.inheritStyles,
	          labelledBy = _props3.labelledBy,
	          nativeFormControlRefIgnored = _props3.nativeFormControlRef,
	          onValidateIgnored = _props3.onValidate,
	          placeholder = _props3.placeholder,
	          readOnly = _props3.readOnly,
	          required = _props3.required,
	          rows = _props3.rows,
	          secondary = _props3.secondary,
	          size = _props3.size,
	          themeProp = _props3.theme,
	          otherProps = _objectWithoutProperties(_props3, ['className', 'commonProps', 'dir', 'disabled', 'fullWidth', 'inheritStyles', 'labelledBy', 'nativeFormControlRef', 'onValidate', 'placeholder', 'readOnly', 'required', 'rows', 'secondary', 'size', 'theme']),
	          theme = (0, _componentTheme2.default)(themeProp),
	          conditionalProps = {};return invalid && (conditionalProps['aria-invalid'] = !0), required && (conditionalProps['aria-required'] = !0), _react2.default.createElement(Styled.textarea, _extends({}, commonProps, otherProps, conditionalProps, { "aria-labelledby": labelledBy, className: className, defaultValue: defaultValue, dir: dir, disabled: disabled, innerRef: handleNativeFormControlRef, onBlur: handleBlur, onChange: handleChange, placeholder: placeholder, readOnly: readOnly, required: required, rows: rows, sc: { fullWidth: fullWidth, inheritStyles: inheritStyles, secondary: secondary, size: size }, theme: theme, value: value }));
	    } }, { key: 'render', value: function render() {
	      var _props4 = this.props,
	          defaultValue = _props4.defaultValue,
	          nativeFormControlRef = _props4.nativeFormControlRef,
	          onBlur = _props4.onBlur,
	          onChange = _props4.onChange,
	          theme = _props4.theme,
	          value = _props4.value;return _react2.default.createElement(_FormControl2.default, { defaultValue: defaultValue, nativeFormControlRef: nativeFormControlRef, onFormControlBlur: onBlur, onFormControlChange: onChange, onValidate: this.handleValidate, ref: this.handleFormControlRef, render: this.renderContent, theme: theme, value: value });
	    } }]), TextAreaControl;
	}(_react.PureComponent);TextAreaControl.propTypes = { className: _propTypes2.default.string, commonProps: _propTypes3.commonPropsShape, defaultValue: function defaultValue(props, propName, componentName) {
	    if (props[propName] !== void 0) {
	      if (props.value !== void 0) throw new Error('Props `defaultValue` and `value` are both defined in `' + componentName + '`, but only one is allowed. Use `defaultValue` for an uncontrolled component, or `value` for a controlled component.');if ('string' != typeof props[propName] && 'number' != typeof props[propName] && null !== props[propName]) return new Error('Invalid prop `' + propName + '` of type `' + _typeof(props[propName]) + '` supplied to `' + componentName + '`, expected `string`, `number`, or a value of `null`.');
	    }
	  }, dir: _propTypes2.default.oneOf(['ltr', 'rtl', 'auto']), disabled: _propTypes2.default.bool, fullWidth: _propTypes2.default.bool, inheritStyles: _propTypes2.default.bool, labelledBy: _propTypes2.default.string, maxLength: function maxLength(props, propName, componentName) {
	    if (props[propName] !== void 0 && 'number' != typeof props[propName]) return new Error('Invalid prop `' + propName + '` of type `' + _typeof(props[propName]) + '` supplied to `' + componentName + '`, expected `number`.');
	  }, minLength: function minLength(props, propName, componentName) {
	    if (props[propName] !== void 0 && 'number' != typeof props[propName]) return new Error('Invalid prop `' + propName + '` of type `' + _typeof(props[propName]) + '` supplied to `' + componentName + '`, expected `number`.');
	  }, nativeFormControlRef: _propTypes2.default.func, onBlur: _propTypes2.default.func, onChange: _propTypes2.default.func, onRef: _propTypes2.default.func, onValidate: _propTypes2.default.func, placeholder: _propTypes2.default.string, readOnly: _propTypes2.default.bool, required: _propTypes2.default.bool, rows: _propTypes2.default.number, secondary: _propTypes2.default.bool, size: _propTypes2.default.oneOf(['small', 'medium', 'large']), theme: _propTypes3.themeShape, validate: _propTypes2.default.func, value: function value(props, propName, componentName) {
	    if (props[propName] !== void 0) {
	      if (props.defaultValue !== void 0) throw new Error('Props `defaultValue` and `value` are both defined in `' + componentName + '`, but only one is allowed. Use `defaultValue` for an uncontrolled component, or `value` for a controlled component.');if (void 0 === props.onChange) throw new Error('Please add prop `onChange` to `' + componentName + '`. Prop `value` has been set, which makes this a controlled component.');if ('string' != typeof props[propName] && 'number' != typeof props[propName] && null !== props[propName]) return new Error('Invalid prop `' + propName + '` of type `' + _typeof(props[propName]) + '` supplied to `' + componentName + '`, expected `string`, `number`, or a value of `null`.');
	    }
	  } }, TextAreaControl.defaultProps = { dir: 'auto', rows: 3, size: 'medium', theme: (0, _themes.createTheme)(), validate: function validate() {
	    return '';
	  } }, TextAreaControl.displayName = 'TextAreaControl';var TextAreaControlWithTheme = (0, _withCommonProps2.default)(TextAreaControl);TextAreaControlWithTheme.WrappedComponent = TextAreaControl, exports.default = TextAreaControlWithTheme;

/***/ },
/* 447 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	Object.defineProperty(exports, '__esModule', { value: !0 });var _themes = __webpack_require__(4),
	    getBackgroundImage = function getBackgroundImage(color) {
	  var encodedColor = encodeURIComponent(color);return 'url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 14 14\'%3E%3Cpath fill=\'' + encodedColor + '\' d=\'M8 6a1 1 0 1 1-2 0V4a1 1 0 1 1 2 0v2zm-1 5a1 1 0 1 1 0-2 1 1 0 1 1 0 2zM7 0a7 7 0 1 0 0 14A7 7 0 0 0 7 0z\' /%3E%3C/svg%3E%0A")';
	},
	    componentTheme = function componentTheme(baseTheme) {
	  var _baseTheme$vstui = baseTheme.vstui,
	      color = _baseTheme$vstui.color,
	      shape = _baseTheme$vstui.shape,
	      size = _baseTheme$vstui.size,
	      typography = _baseTheme$vstui.typography,
	      cloud2 = color.cloud.getShade(2),
	      ninja11 = color.ninja.getShade(11),
	      black57 = 'rgba(0, 0, 0, 0.57)',
	      backgroundImage = getBackgroundImage(color.transparent),
	      backgroundImage_invalid = getBackgroundImage(color.error),
	      backgroundImage_invalidFocus = getBackgroundImage(color.error);return (0, _themes.createComponentTheme)(baseTheme, { TextAreaControl_width: '270px', InputControl_minHeight_small: size.small, InputControl_minHeight_medium: size.medium, InputControl_minHeight_large: size.large, TextAreaControl_backgroundColor: color.surface, TextAreaControl_backgroundColor_disabled: color.transparent, TextAreaControl_backgroundColor_readOnly: cloud2, TextAreaControl_backgroundImage: backgroundImage, TextAreaControl_backgroundImage_invalid: backgroundImage_invalid, TextAreaControl_backgroundImage_invalidFocus: backgroundImage_invalidFocus, TextAreaControl_backgroundPosition_small: 'right 12px top ' + (size.small - 2 - 14) / 2 + 'px', TextAreaControl_backgroundPosition_medium: 'right 12px top ' + (size.medium - 2 - 14) / 2 + 'px', TextAreaControl_backgroundPosition_large: 'right 14px top ' + (size.large - 2 - 14) / 2 + 'px', TextAreaControl_backgroundSize: '14px 14px', TextAreaControl_borderColor: 'rgba(0, 0, 0, 0.43)', TextAreaControl_borderColor_focus: ninja11, TextAreaControl_borderColor_disabled: 'rgba(0, 0, 0, 0.20)', TextAreaControl_borderColor_invalid: color.error, TextAreaControl_borderColor_invalidFocus: ninja11, TextAreaControl_borderStyle: shape.borderStyle, TextAreaControl_borderWidth: shape.borderWidth, TextAreaControl_borderRadius: shape.borderRadius, TextAreaControl_fontFamily: typography.fontFamily, TextAreaControl_fontSize_small: typography.fontSize, TextAreaControl_fontSize_medium: typography.fontSize, TextAreaControl_fontSize_large: typography.fontSize + 2, TextAreaControl_fontWeight: typography.fontWeightRegular, TextAreaControl_color: color.onSurface, TextAreaControl_color_disabled: black57, TextAreaControl_color_readOnly: black57, TextAreaControl_boxShadow_focus: '0 0 0 1px ' + ninja11, TextAreaControlPlaceholder_fontWeight: typography.fontWeightLight, TextAreaControlPlaceholder_color: black57 });
	};exports.default = componentTheme;

/***/ },
/* 448 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	Object.defineProperty(exports, '__esModule', { value: !0 });var _TextAreaControl = __webpack_require__(446);Object.defineProperty(exports, 'default', { enumerable: !0, get: function get() {
	    return _interopRequireDefault(_TextAreaControl).default;
	  } });function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}

/***/ },
/* 449 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _typeof = 'function' == typeof Symbol && 'symbol' == _typeof2(Symbol.iterator) ? function (obj) {
	  return typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
	} : function (obj) {
	  return obj && 'function' == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? 'symbol' : typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
	},
	    _extends = Object.assign || function (target) {
	  for (var source, i = 1; i < arguments.length; i++) {
	    for (var key in source = arguments[i], source) {
	      Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
	    }
	  }return target;
	},
	    _createClass = function () {
	  function defineProperties(target, props) {
	    for (var descriptor, i = 0; i < props.length; i++) {
	      descriptor = props[i], descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, 'value' in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    return protoProps && defineProperties(Constructor.prototype, protoProps), staticProps && defineProperties(Constructor, staticProps), Constructor;
	  };
	}(),
	    _react = __webpack_require__(3),
	    _react2 = _interopRequireDefault(_react),
	    _propTypes = __webpack_require__(6),
	    _propTypes2 = _interopRequireDefault(_propTypes),
	    _styledComponents = __webpack_require__(15),
	    _styledComponents2 = _interopRequireDefault(_styledComponents),
	    _propTypes3 = __webpack_require__(16),
	    _themes = __webpack_require__(4),
	    _utils = __webpack_require__(59),
	    _FormGroup = __webpack_require__(129),
	    _FormGroup2 = _interopRequireDefault(_FormGroup),
	    _InputControl = __webpack_require__(426),
	    _InputControl2 = _interopRequireDefault(_InputControl),
	    _TextAreaControl = __webpack_require__(448),
	    _TextAreaControl2 = _interopRequireDefault(_TextAreaControl);Object.defineProperty(exports, '__esModule', { value: !0 });function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}function _objectWithoutProperties(obj, keys) {
	  var target = {};for (var i in obj) {
	    0 <= keys.indexOf(i) || Object.prototype.hasOwnProperty.call(obj, i) && (target[i] = obj[i]);
	  }return target;
	}function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
	}function _possibleConstructorReturn(self, call) {
	  if (!self) throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');return call && ('object' == (typeof call === 'undefined' ? 'undefined' : _typeof2(call)) || 'function' == typeof call) ? call : self;
	}function _inherits(subClass, superClass) {
	  if ('function' != typeof superClass && null !== superClass) throw new TypeError('Super expression must either be null or a function, not ' + (typeof superClass === 'undefined' ? 'undefined' : _typeof2(superClass)));subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: !1, writable: !0, configurable: !0 } }), superClass && (Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass);
	}var Styled = {};Styled.InputControl = (0, _styledComponents2.default)(_InputControl2.default).withConfig({ displayName: 'TextField__InputControl' })(['display:block;']), Styled.InputControl.displayName = 'Styled_InputControl', Styled.TextAreaControl = (0, _styledComponents2.default)(_TextAreaControl2.default).withConfig({ displayName: 'TextField__TextAreaControl' })(['display:block;']), Styled.TextAreaControl.displayName = 'Styled_TextAreaControl';var TextField = function (_Component) {
	  function TextField(props) {
	    _classCallCheck(this, TextField);var _this = _possibleConstructorReturn(this, (TextField.__proto__ || Object.getPrototypeOf(TextField)).call(this, props));return _this.generatedId = (0, _utils.generateUniqueId)('text-field'), _this.state = { id: props.id || _this.generatedId, validationMessage: '' }, _this.handleFormControlRef = _this.handleFormControlRef.bind(_this), _this.handleNativeFormControlRef = _this.handleNativeFormControlRef.bind(_this), _this.handleValidate = _this.handleValidate.bind(_this), _this;
	  }return _inherits(TextField, _Component), _createClass(TextField, [{ key: 'componentWillReceiveProps', value: function componentWillReceiveProps(nextProps) {
	      var id = nextProps.id || this.generatedId;id !== this.state.id && this.setState({ id: id });
	    } }, { key: 'focus', value: function focus() {
	      this.nativeFormControl && this.nativeFormControl.focus();
	    } }, { key: 'validate', value: function validate(callback) {
	      this.formControl && this.formControl.validate(callback);
	    } }, { key: 'handleFormControlRef', value: function handleFormControlRef(node) {
	      this.formControl = node;
	    } }, { key: 'handleNativeFormControlRef', value: function handleNativeFormControlRef(node) {
	      var nativeFormControlRef = this.props.nativeFormControlRef;this.nativeFormControl = node, nativeFormControlRef && nativeFormControlRef(node);
	    } }, { key: 'handleValidate', value: function handleValidate(valid, validationMessage) {
	      this.setState({ validationMessage: validationMessage });
	    } }, { key: 'render', value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          dir = _props.dir,
	          disabled = _props.disabled,
	          fullWidth = _props.fullWidth,
	          helperText = _props.helperText,
	          idIgnored = _props.id,
	          inheritStyles = _props.inheritStyles,
	          label = _props.label,
	          labelHidden = _props.labelHidden,
	          lang = _props.lang,
	          max = _props.max,
	          min = _props.min,
	          multiline = _props.multiline,
	          nativeFormControlRefIgnored = _props.nativeFormControlRef,
	          pattern = _props.pattern,
	          rootProps = _props.rootProps,
	          rows = _props.rows,
	          secondary = _props.secondary,
	          size = _props.size,
	          step = _props.step,
	          theme = _props.theme,
	          type = _props.type,
	          otherProps = _objectWithoutProperties(_props, ['className', 'dir', 'disabled', 'fullWidth', 'helperText', 'id', 'inheritStyles', 'label', 'labelHidden', 'lang', 'max', 'min', 'multiline', 'nativeFormControlRef', 'pattern', 'rootProps', 'rows', 'secondary', 'size', 'step', 'theme', 'type']),
	          id = this.state.id,
	          validationMessage = this.state.validationMessage,
	          conditionalProps = {};multiline ? conditionalProps.rows = rows : (conditionalProps.max = max, conditionalProps.min = min, conditionalProps.pattern = pattern, conditionalProps.step = step, conditionalProps.type = type);var Control = multiline ? Styled.TextAreaControl : Styled.InputControl;return _react2.default.createElement(_FormGroup2.default, { className: className, dir: dir, disabled: disabled, formControl: _react2.default.createElement(Control, _extends({}, otherProps, conditionalProps, { nativeFormControlRef: this.handleNativeFormControlRef, onRef: this.handleFormControlRef, onValidate: this.handleValidate })), fullWidth: fullWidth, helperText: helperText, id: id, inheritStyles: inheritStyles, label: label, labelHidden: labelHidden, lang: lang, rootProps: rootProps, secondary: secondary, size: size, theme: theme, validationMessage: validationMessage });
	    } }]), TextField;
	}(_react.Component);TextField.propTypes = { className: _propTypes2.default.string, defaultValue: function defaultValue(props, propName, componentName) {
	    if (props[propName] !== void 0) {
	      if (props.value !== void 0) throw new Error('Props `defaultValue` and `value` are both defined in `' + componentName + '`, but only one is allowed. Use `defaultValue` for an uncontrolled component, or `value` for a controlled component.');if ('string' != typeof props[propName] && 'number' != typeof props[propName] && null !== props[propName]) return new Error('Invalid prop `' + propName + '` of type `' + _typeof(props[propName]) + '` supplied to `' + componentName + '`, expected `string`, `number`, or a value of `null`.');
	    }
	  }, dir: _propTypes2.default.oneOf(['ltr', 'rtl', 'auto']), disabled: _propTypes2.default.bool, fullWidth: _propTypes2.default.bool, helperText: _propTypes2.default.string, id: _propTypes2.default.string, inheritStyles: _propTypes2.default.bool, label: function label(props, propName, componentName) {
	    if (props.label === void 0 && props.labelledBy === void 0) return new Error(componentName + ' requires either the `label` prop or the `labelledBy` prop.');if (void 0 !== props[propName]) {
	      if ('string' != typeof props[propName]) return new Error('Invalid prop `' + propName + '` of type `' + _typeof(props[propName]) + '` supplied to `' + componentName + '`, expected `string`.');'' === props[propName];
	    }
	  }, labelHidden: _propTypes2.default.bool, labelledBy: function labelledBy(props, propName, componentName) {
	    if (props.label === void 0 && props.labelledBy === void 0) return new Error(componentName + ' requires either the `label` prop or the `labelledBy` prop.');if (void 0 !== props[propName]) {
	      if ('string' != typeof props[propName]) return new Error('Invalid prop `' + propName + '` of type `' + _typeof(props[propName]) + '` supplied to `' + componentName + '`, expected `string`.');'' === props[propName];
	    }
	  }, lang: _propTypes2.default.string, max: function max(props, propName, componentName) {
	    if (props[propName] !== void 0 && 'number' != typeof props[propName] && 'string' != typeof props[propName]) return new Error('Invalid prop `' + propName + '` of type `' + _typeof(props[propName]) + '` supplied to `' + componentName + '`, expected `number` or `string`.');
	  }, maxLength: function maxLength(props, propName, componentName) {
	    if (props[propName] !== void 0 && 'number' != typeof props[propName]) return new Error('Invalid prop `' + propName + '` of type `' + _typeof(props[propName]) + '` supplied to `' + componentName + '`, expected `number`.');
	  }, min: function min(props, propName, componentName) {
	    if (props[propName] !== void 0 && 'number' != typeof props[propName] && 'string' != typeof props[propName]) return new Error('Invalid prop `' + propName + '` of type `' + _typeof(props[propName]) + '` supplied to `' + componentName + '`, expected `number` or `string`.');
	  }, minLength: function minLength(props, propName, componentName) {
	    if (props[propName] !== void 0 && 'number' != typeof props[propName]) return new Error('Invalid prop `' + propName + '` of type `' + _typeof(props[propName]) + '` supplied to `' + componentName + '`, expected `number`.');
	  }, multiline: _propTypes2.default.bool, nativeFormControlRef: _propTypes2.default.func, onChange: _propTypes2.default.func, pattern: _propTypes2.default.string, placeholder: _propTypes2.default.string, readOnly: _propTypes2.default.bool, required: _propTypes2.default.bool, rootProps: _propTypes2.default.object, rows: _propTypes2.default.number, secondary: _propTypes2.default.bool, size: _propTypes2.default.oneOf(['small', 'medium', 'large']), step: function step(props, propName, componentName) {
	    if (props[propName] !== void 0 && 'number' != typeof props[propName] && 'any' !== props[propName]) return new Error('Invalid prop `' + propName + '` of type `' + _typeof(props[propName]) + '` supplied to `' + componentName + '`, expected either `number`, or `string` with a value of "any".');
	  }, theme: _propTypes3.themeShape, type: _propTypes2.default.oneOf(['date', 'datetime-local', 'email', 'month', 'number', 'password', 'search', 'tel', 'text', 'time', 'url', 'week']), validate: _propTypes2.default.func, value: function value(props, propName, componentName) {
	    if (props[propName] !== void 0) {
	      if (props.defaultValue !== void 0) throw new Error('Props `defaultValue` and `value` are both defined in `' + componentName + '`, but only one is allowed. Use `defaultValue` for an uncontrolled component, or `value` for a controlled component.');if (void 0 === props.onChange) throw new Error('Please add prop `onChange` to `' + componentName + '`. Prop `value` has been set, which makes this a controlled component.');if ('string' != typeof props[propName] && 'number' != typeof props[propName] && null !== props[propName]) return new Error('Invalid prop `' + propName + '` of type `' + _typeof(props[propName]) + '` supplied to `' + componentName + '`, expected `string`, `number`, or a value of `null`.');
	    }
	  } }, TextField.defaultProps = { rows: 3, size: 'medium', theme: (0, _themes.createTheme)(), validate: function validate() {
	    return '';
	  } }, TextField.displayName = 'TextField';var TextFieldWithTheme = (0, _themes.withTheme)(TextField);TextFieldWithTheme.WrappedComponent = TextField, exports.default = TextFieldWithTheme;

/***/ },
/* 450 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) {
	  for (var source, i = 1; i < arguments.length; i++) {
	    for (var key in source = arguments[i], source) {
	      Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
	    }
	  }return target;
	},
	    _createClass = function () {
	  function defineProperties(target, props) {
	    for (var descriptor, i = 0; i < props.length; i++) {
	      descriptor = props[i], descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, 'value' in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    return protoProps && defineProperties(Constructor.prototype, protoProps), staticProps && defineProperties(Constructor, staticProps), Constructor;
	  };
	}(),
	    _react = __webpack_require__(3),
	    _react2 = _interopRequireDefault(_react),
	    _propTypes = __webpack_require__(6),
	    _propTypes2 = _interopRequireDefault(_propTypes),
	    _styledComponents = __webpack_require__(15),
	    _styledComponents2 = _interopRequireDefault(_styledComponents),
	    _reactPopper = __webpack_require__(891),
	    _styles = __webpack_require__(31),
	    _themes = __webpack_require__(4),
	    _propTypes3 = __webpack_require__(16),
	    _componentTheme = __webpack_require__(451),
	    _componentTheme2 = _interopRequireDefault(_componentTheme);Object.defineProperty(exports, '__esModule', { value: !0 });function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}function _objectWithoutProperties(obj, keys) {
	  var target = {};for (var i in obj) {
	    0 <= keys.indexOf(i) || Object.prototype.hasOwnProperty.call(obj, i) && (target[i] = obj[i]);
	  }return target;
	}function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
	}function _possibleConstructorReturn(self, call) {
	  if (!self) throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');return call && ('object' == (typeof call === 'undefined' ? 'undefined' : _typeof(call)) || 'function' == typeof call) ? call : self;
	}function _inherits(subClass, superClass) {
	  if ('function' != typeof superClass && null !== superClass) throw new TypeError('Super expression must either be null or a function, not ' + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: !1, writable: !0, configurable: !0 } }), superClass && (Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass);
	}var Styled = { div: {} };Styled.Manager = (0, _styledComponents2.default)(_reactPopper.Manager).withConfig({ displayName: 'Tooltip__Manager' })(['display:inline-block;']), Styled.div.tooltip = _styledComponents2.default.div.withConfig({ displayName: 'Tooltip__tooltip' })(['padding:3px 8px;opacity:', ';background:', ';border-radius:2px;box-shadow:0 2px 8px rgba(0,0,0,0.2);color:', ';font-family:', ';font-size:', ';font-weight:', ';-webkit-font-smoothing:antialiased;transform:translate( ', ',', ' );transition-property:opacity transform;transition-duration:', ';transition-timing-function:', ';'], function (props) {
	  return props.sc.open ? 1 : 0;
	}, function (props) {
	  return props.theme.vstui.Tooltip_backgroundColor;
	}, function (props) {
	  return props.theme.vstui.Tooltip_color;
	}, function (props) {
	  return props.theme.vstui.Tooltip_fontFamily;
	}, function (props) {
	  return props.theme.vstui.Tooltip_fontSize;
	}, function (props) {
	  return props.theme.vstui.Tooltip_fontWeight;
	}, function (props) {
	  return props.sc.open ? 0 : -1 === props.sc.placement.indexOf('left') ? -1 === props.sc.placement.indexOf('right') ? 0 : '-2px' : '2px';
	}, function (props) {
	  return props.sc.open ? 0 : 0 === props.sc.placement.indexOf('top') ? '2px' : 0 === props.sc.placement.indexOf('bottom') ? '-2px' : 0;
	}, function (props) {
	  return props.theme.vstui.Tooltip_transitionDuration;
	}, function (props) {
	  return props.theme.vstui.Tooltip_transitionEasing;
	});var Tooltip = function (_PureComponent) {
	  function Tooltip(props) {
	    _classCallCheck(this, Tooltip);var _this = _possibleConstructorReturn(this, (Tooltip.__proto__ || Object.getPrototypeOf(Tooltip)).call(this, props));return _this.state = { open: !1 }, _this.handleBlur = _this.handleBlur.bind(_this), _this.handleFocus = _this.handleFocus.bind(_this), _this.handleKeyDown = _this.handleKeyDown.bind(_this), _this.handleTargetMouseEnter = _this.handleTargetMouseEnter.bind(_this), _this.handleTargetMouseLeave = _this.handleTargetMouseLeave.bind(_this), _this.handlePopperMouseEnter = _this.handlePopperMouseEnter.bind(_this), _this.handlePopperMouseLeave = _this.handlePopperMouseLeave.bind(_this), _this;
	  }return _inherits(Tooltip, _PureComponent), _createClass(Tooltip, [{ key: 'componentDidMount', value: function componentDidMount() {
	      void 0 === this.props.theme.vstui.fontFamily && (this.theme = (0, _themes.createTheme)()), document.addEventListener('keydown', this.handleKeyDown);
	    } }, { key: 'componentWillUnmount', value: function componentWillUnmount() {
	      this.clearOpenTimeout(), this.clearCloseTimeout(), document.removeEventListener('keydown', this.handleKeyDown);
	    } }, { key: 'handleBlur', value: function handleBlur() {
	      this.close(), this.props.onBlur();
	    } }, { key: 'handleFocus', value: function handleFocus() {
	      this.delayedOpen(), this.props.onFocus();
	    } }, { key: 'handleKeyDown', value: function handleKeyDown(event) {
	      var open = this.state.open;open && event.which === 27 && this.close();
	    } }, { key: 'handleTargetMouseEnter', value: function handleTargetMouseEnter(event) {
	      event.target.disabled || this.delayedOpen(), this.props.onMouseEnter();
	    } }, { key: 'handleTargetMouseLeave', value: function handleTargetMouseLeave() {
	      this.delayedClose(), this.props.onMouseLeave();
	    } }, { key: 'handlePopperMouseEnter', value: function handlePopperMouseEnter() {
	      this.clearCloseTimeout();
	    } }, { key: 'handlePopperMouseLeave', value: function handlePopperMouseLeave() {
	      this.delayedClose();
	    } }, { key: 'clearOpenTimeout', value: function clearOpenTimeout() {
	      clearTimeout(this.openTimeout), this.openTimeout = null;
	    } }, { key: 'clearCloseTimeout', value: function clearCloseTimeout() {
	      clearTimeout(this.closeTimeout), this.closeTimeout = null;
	    } }, { key: 'delayedOpen', value: function delayedOpen() {
	      var _this2 = this,
	          open = this.state.open;this.clearOpenTimeout(), this.clearCloseTimeout(), open || (this.openTimeout = setTimeout(function () {
	        _this2.setState({ open: !0 });
	      }, 500));
	    } }, { key: 'close', value: function close() {
	      this.clearOpenTimeout(), this.clearCloseTimeout(), this.setState({ open: !1 });
	    } }, { key: 'delayedClose', value: function delayedClose() {
	      var _this3 = this;this.clearOpenTimeout(), this.clearCloseTimeout(), this.closeTimeout = setTimeout(function () {
	        _this3.setState({ open: !1 });
	      }, 0);
	    } }, { key: 'render', value: function render() {
	      var _this4 = this,
	          _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          id = _props.id,
	          inheritStyles = _props.inheritStyles,
	          placement = _props.placement,
	          themeProp = _props.theme,
	          title = _props.title,
	          theme = (0, _componentTheme2.default)(themeProp),
	          i18n = theme.vstui.i18n,
	          offset = 4;return _react2.default.createElement(Styled.Manager, { className: className, dir: inheritStyles ? void 0 : i18n.direction, lang: inheritStyles ? void 0 : i18n.locale, style: inheritStyles ? {} : (0, _styles.resetInheritedStylesObject)({ direction: i18n.direction }), tag: 'div' }, _react2.default.createElement(_reactPopper.Target, null, function (_ref) {
	        var targetProps = _ref.targetProps;return _react2.default.cloneElement(children, { innerRef: targetProps.ref, onBlur: _this4.handleBlur, onFocus: _this4.handleFocus, onMouseEnter: _this4.handleTargetMouseEnter, onMouseLeave: _this4.handleTargetMouseLeave });
	      }), _react2.default.createElement(_reactPopper.Popper, { modifiers: { offset: { offset: '0, ' + offset + 'px' } }, placement: placement }, function (_ref2) {
	        var popperProps = _ref2.popperProps,
	            open = _this4.state.open,
	            style = popperProps.style,
	            otherProps = _objectWithoutProperties(popperProps, ['style']);style.pointerEvents = open ? 'auto' : 'none', style.cursor = 'default', style.zIndex = theme.vstui.Tooltip_zIndex;var conditionalProps = open ? otherProps : {};return _react2.default.createElement('div', _extends({}, conditionalProps, { "aria-hidden": 'true', id: id, onMouseEnter: _this4.handlePopperMouseEnter, onMouseLeave: _this4.handlePopperMouseLeave, role: 'tooltip', style: style }), _react2.default.createElement('div', { style: { position: 'absolute', top: '-' + offset + 'px', right: '-' + offset + 'px', bottom: '-' + offset + 'px', left: '-' + offset + 'px' } }), _react2.default.createElement(Styled.div.tooltip, { sc: { open: open, placement: popperProps['data-placement'] || '' }, theme: theme }, title));
	      }));
	    } }]), Tooltip;
	}(_react.PureComponent);Tooltip.propTypes = { children: _propTypes2.default.element.isRequired, className: _propTypes2.default.string, id: _propTypes2.default.string, inheritStyles: _propTypes2.default.bool, title: _propTypes2.default.string, onBlur: _propTypes2.default.func, onFocus: _propTypes2.default.func, onMouseEnter: _propTypes2.default.func, onMouseLeave: _propTypes2.default.func, open: _propTypes2.default.bool, placement: _propTypes2.default.oneOf(['auto', 'top', 'right', 'bottom', 'left', 'auto-start', 'top-start', 'right-start', 'bottom-start', 'left-start', 'auto-end', 'top-end', 'right-end', 'bottom-end', 'left-end']), theme: _propTypes3.themeShape }, Tooltip.defaultProps = { onBlur: function onBlur() {}, onFocus: function onFocus() {}, onMouseEnter: function onMouseEnter() {}, onMouseLeave: function onMouseLeave() {}, theme: (0, _themes.createTheme)() }, Tooltip.displayName = Tooltip;var TooltipWithTheme = (0, _themes.withTheme)(Tooltip);TooltipWithTheme.WrappedComponent = Tooltip, exports.default = TooltipWithTheme;

/***/ },
/* 451 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	Object.defineProperty(exports, '__esModule', { value: !0 });var _themes = __webpack_require__(4),
	    componentTheme = function componentTheme(baseTheme) {
	  var _baseTheme$vstui = baseTheme.vstui,
	      color = _baseTheme$vstui.color,
	      typography = _baseTheme$vstui.typography,
	      zIndex = _baseTheme$vstui.zIndex;return (0, _themes.createComponentTheme)(baseTheme, { Tooltip_backgroundColor: color.ninja.getShade(10), Tooltip_color: color.white, Tooltip_fontFamily: typography.fontFamily, Tooltip_fontSize: typography.pxToRem(typography.fontSize - 2), Tooltip_fontWeight: typography.fontWeightRegular, Tooltip_transitionDuration: '150ms', Tooltip_transitionEasing: 'cubic-bezier(0.7, 0, 0.7, 1)', Tooltip_zIndex: zIndex.tooltip });
	};exports.default = componentTheme;

/***/ },
/* 452 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	Object.defineProperty(exports, '__esModule', { value: !0 });var _Tooltip = __webpack_require__(450);Object.defineProperty(exports, 'default', { enumerable: !0, get: function get() {
	    return _interopRequireDefault(_Tooltip).default;
	  } });function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}

/***/ },
/* 453 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	Object.defineProperty(exports, '__esModule', { value: !0 });var _createColorPalette = __webpack_require__(19),
	    _createColorPalette2 = _interopRequireDefault(_createColorPalette);function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}var blue = { 1: '#eef7ff', 2: '#deedfd', 3: '#bddbf4', 4: '#84baeb', 5: '#3b8fde', 6: '#1176d4', 7: '#0d66b8', 8: '#09549c', 9: '#0a4276', 10: '#072d52', inflection: 6 };exports.default = (0, _createColorPalette2.default)(blue, 'blue');

/***/ },
/* 454 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	Object.defineProperty(exports, '__esModule', { value: !0 });var _createColorPalette = __webpack_require__(19),
	    _createColorPalette2 = _interopRequireDefault(_createColorPalette);function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}var brick = { 1: '#fef3f1', 2: '#fac3bb', 3: '#faa094', 4: '#fa7d6d', 5: '#eb4f3b', 6: '#d24634', 7: '#b83e2e', 8: '#9e3528', 9: '#7a291f', 10: '#571d16', inflection: 6 };exports.default = (0, _createColorPalette2.default)(brick, 'brick');

/***/ },
/* 455 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	Object.defineProperty(exports, '__esModule', { value: !0 });var _createColorPalette = __webpack_require__(19),
	    _createColorPalette2 = _interopRequireDefault(_createColorPalette);function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}var cheddar = { 1: '#fef3e9', 2: '#fec491', 3: '#fead64', 4: '#f58525', 5: '#e06107', 6: '#ca500f', 7: '#b0430c', 8: '#983600', 9: '#772700', 10: '#571d00', inflection: 6 };exports.default = (0, _createColorPalette2.default)(cheddar, 'cheddar');

/***/ },
/* 456 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	Object.defineProperty(exports, '__esModule', { value: !0 });var _createColorPalette = __webpack_require__(19),
	    _createColorPalette2 = _interopRequireDefault(_createColorPalette);function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}var cherry = { 1: '#f54250', 2: '#cc313d', 3: '#510006' };exports.default = (0, _createColorPalette2.default)(cherry, 'cherry');

/***/ },
/* 457 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	Object.defineProperty(exports, '__esModule', { value: !0 });var _createColorPalette = __webpack_require__(19),
	    _createColorPalette2 = _interopRequireDefault(_createColorPalette);function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}var cloud = { 1: '#fafafa', 2: '#f6f6f6', 3: '#ececec', 4: '#dadada', 5: '#949494', 6: '#757575', 7: '#646464', 8: '#525252', 9: '#3c3c3c', 10: '#1c1c1c', inflection: 6 };exports.default = (0, _createColorPalette2.default)(cloud, 'cloud');

/***/ },
/* 458 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	Object.defineProperty(exports, '__esModule', { value: !0 });var _createColorPalette = __webpack_require__(19),
	    _createColorPalette2 = _interopRequireDefault(_createColorPalette);function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}var eggplant = { 1: '#f8f5fa', 2: '#ddcbe9', 3: '#c4a4d9', 4: '#b389d0', 5: '#a775c9', 6: '#945eb9', 7: '#794d96', 8: '#5e3c75', 9: '#3f284f', 10: '#2d1c38', inflection: 6 };exports.default = (0, _createColorPalette2.default)(eggplant, 'eggplant');

/***/ },
/* 459 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	Object.defineProperty(exports, '__esModule', { value: !0 });var _createColorPalette = __webpack_require__(19),
	    _createColorPalette2 = _interopRequireDefault(_createColorPalette);function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}var frost = { 1: '#f6f8fc', 2: '#edf0f5', 3: '#dfe4eb', 4: '#ced2d9', 5: '#888c94', 6: '#71747a', 7: '#5b5e63', 8: '#46494d', 9: '#343538', 10: '#1c1d1f', inflection: 6 };exports.default = (0, _createColorPalette2.default)(frost, 'frost');

/***/ },
/* 460 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	Object.defineProperty(exports, '__esModule', { value: !0 });var _createColorPalette = __webpack_require__(19),
	    _createColorPalette2 = _interopRequireDefault(_createColorPalette);function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}var gold = { 1: '#fff5dd', 2: '#ffe29c', 3: '#ffd560', 4: '#e8b520', 5: '#be8a0d', 6: '#9a6f07', 7: '#855f07', 8: '#715005', 9: '#5a4206', 10: '#3b2b04', inflection: 6 };exports.default = (0, _createColorPalette2.default)(gold, 'gold');

/***/ },
/* 461 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	Object.defineProperty(exports, '__esModule', { value: !0 });var _createColorPalette = __webpack_require__(19),
	    _createColorPalette2 = _interopRequireDefault(_createColorPalette);function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}var grass = { 1: '#21a921', 2: '#0a870a' };exports.default = (0, _createColorPalette2.default)(grass, 'grass');

/***/ },
/* 462 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	Object.defineProperty(exports, '__esModule', { value: !0 });var _createColorPalette = __webpack_require__(19),
	    _createColorPalette2 = _interopRequireDefault(_createColorPalette);function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}var green = { 1: '#edf7ed', 2: '#d1ead1', 3: '#a3d4a3', 4: '#79c679', 5: '#35a335', 6: '#048a04', 7: '#047103', 8: '#015e02', 9: '#024d03', 10: '#023302', inflection: 6 };exports.default = (0, _createColorPalette2.default)(green, 'green');

/***/ },
/* 463 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	Object.defineProperty(exports, '__esModule', { value: !0 });var _createColorPalette = __webpack_require__(19),
	    _createColorPalette2 = _interopRequireDefault(_createColorPalette);function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}var jungle = { 1: '#e8f7f2', 2: '#c0eadb', 3: '#86e0c2', 4: '#24c991', 5: '#1a9c6e', 6: '#16825c', 7: '#12694a', 8: '#0d4f38', 9: '#0a3c2b', 10: '#07291d', inflection: 6 };exports.default = (0, _createColorPalette2.default)(jungle, 'jungle');

/***/ },
/* 464 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	Object.defineProperty(exports, '__esModule', { value: !0 });var _createColorPalette = __webpack_require__(19),
	    _createColorPalette2 = _interopRequireDefault(_createColorPalette);function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}var magic = { 1: '#f2f4f9', 2: '#d2d9ed', 3: '#b2bee0', 4: '#91a3d4', 5: '#7188c7', 6: '#5773bf', 7: '#425ba1', 8: '#334a88', 9: '#24386e', 10: '#002244', inflection: 6 };exports.default = (0, _createColorPalette2.default)(magic, 'magic');

/***/ },
/* 465 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	Object.defineProperty(exports, '__esModule', { value: !0 });var _createColorPalette = __webpack_require__(19),
	    _createColorPalette2 = _interopRequireDefault(_createColorPalette);function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}var mist = { 1: '#ebf9fc', 2: '#c9e5ea', 3: '#acd5dd', 4: '#6eadba', 5: '#5f96a1', 6: '#4f7e87', 7: '#41666e', 8: '#324e54', 9: '#273e42', 10: '#1d2d30', inflection: 6 };exports.default = (0, _createColorPalette2.default)(mist, 'mist');

/***/ },
/* 466 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	Object.defineProperty(exports, '__esModule', { value: !0 });var _createColorPalette = __webpack_require__(19),
	    _createColorPalette2 = _interopRequireDefault(_createColorPalette);function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}var ninja = { 9: '#40404c', 10: '#2f2f39', 11: '#1b1b26' };exports.default = (0, _createColorPalette2.default)(ninja, 'ninja');

/***/ },
/* 467 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	Object.defineProperty(exports, '__esModule', { value: !0 });var _createColorPalette = __webpack_require__(19),
	    _createColorPalette2 = _interopRequireDefault(_createColorPalette);function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}var ocean = { 1: '#eaf7fc', 2: '#b0e3f4', 3: '#75cfec', 4: '#00a7db', 5: '#0093c4', 6: '#007fad', 7: '#006c94', 8: '#005a75', 9: '#00465c', 10: '#003342', inflection: 6 };exports.default = (0, _createColorPalette2.default)(ocean, 'ocean');

/***/ },
/* 468 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	Object.defineProperty(exports, '__esModule', { value: !0 });var _createColorPalette = __webpack_require__(19),
	    _createColorPalette2 = _interopRequireDefault(_createColorPalette);function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}var orange = { 1: '#fff3e3', 2: '#ffd69b', 3: '#ffb55f', 4: '#ff943b', 5: '#e65f14', 6: '#d04a00', 7: '#b54102', 8: '#983702', 9: '#7a2d00', 10: '#541f00', inflection: 6 };exports.default = (0, _createColorPalette2.default)(orange, 'orange');

/***/ },
/* 469 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	Object.defineProperty(exports, '__esModule', { value: !0 });var _createColorPalette = __webpack_require__(19),
	    _createColorPalette2 = _interopRequireDefault(_createColorPalette);function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}var pickle = { 1: '#f4f6ea', 2: '#e0eab8', 3: '#ccde87', 4: '#a3c523', 5: '#7e9e06', 6: '#637d05', 7: '#536904', 8: '#415203', 9: '#303d02', 10: '#202902', inflection: 6 };exports.default = (0, _createColorPalette2.default)(pickle, 'pickle');

/***/ },
/* 470 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	Object.defineProperty(exports, '__esModule', { value: !0 });var _createColorPalette = __webpack_require__(19),
	    _createColorPalette2 = _interopRequireDefault(_createColorPalette);function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}var purple = { 1: '#f7f5ff', 2: '#e3dbff', 3: '#ccbdfe', 4: '#bca9fa', 5: '#9375f2', 6: '#8956f0', 7: '#683ac8', 8: '#532ca6', 9: '#3f1c86', 10: '#2a1359', inflection: 6 };exports.default = (0, _createColorPalette2.default)(purple, 'purple');

/***/ },
/* 471 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	Object.defineProperty(exports, '__esModule', { value: !0 });var _createColorPalette = __webpack_require__(19),
	    _createColorPalette2 = _interopRequireDefault(_createColorPalette);function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}var red = { 1: '#fff2f4', 2: '#ffe1e6', 3: '#fabcc5', 4: '#f78394', 5: '#ed596f', 6: '#e71d3a', 7: '#d21c35', 8: '#a9172c', 9: '#7e1021', 10: '#5c0c18', inflection: 6 };exports.default = (0, _createColorPalette2.default)(red, 'red');

/***/ },
/* 472 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	Object.defineProperty(exports, '__esModule', { value: !0 });var _createColorPalette = __webpack_require__(19),
	    _createColorPalette2 = _interopRequireDefault(_createColorPalette);function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}var sangria = { 1: '#fdf2f5', 2: '#fbcada', 3: '#f8a2bf', 4: '#f57aa3', 5: '#ed3e79', 6: '#d81e5d', 7: '#bf1b52', 8: '#a61747', 9: '#8c143c', 10: '#610e29', inflection: 6 };exports.default = (0, _createColorPalette2.default)(sangria, 'sangria');

/***/ },
/* 473 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	Object.defineProperty(exports, '__esModule', { value: !0 });var _createColorPalette = __webpack_require__(19),
	    _createColorPalette2 = _interopRequireDefault(_createColorPalette);function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}var silver = { 1: '#fafafa', 2: '#f6f6f6', 3: '#ececec', 4: '#dadada', 5: '#949494', 6: '#757575', 7: '#646464', 8: '#525252', 9: '#3c3c3c', 10: '#1c1c1c', inflection: 6 };exports.default = (0, _createColorPalette2.default)(silver, 'silver');

/***/ },
/* 474 */
/***/ function(module, exports) {

	'use strict';
	Object.defineProperty(exports, '__esModule', { value: !0 });var get = function get(object, path) {
	  for (var keys = path.split('.'), index = 0, resultObject = object; index < keys.length;) {
	    var key = keys[index++];resultObject = resultObject[key];
	  }return index && index === keys.length ? resultObject : void 0;
	},
	    translate = function translate(id, values, messages) {
	  var func = get(messages, id);return func(values);
	};exports.default = translate;

/***/ },
/* 475 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _typeof = 'function' == typeof Symbol && 'symbol' == _typeof2(Symbol.iterator) ? function (obj) {
	  return typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
	} : function (obj) {
	  return obj && 'function' == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? 'symbol' : typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
	},
	    en = function en(n, ord) {
	  var s = (n + '').split('.'),
	      v0 = !s[1],
	      t0 = +s[0] == n,
	      n10 = t0 && s[0].slice(-1),
	      n100 = t0 && s[0].slice(-2);return ord ? 1 == n10 && 11 != n100 ? 'one' : 2 == n10 && 12 != n100 ? 'two' : 3 == n10 && 13 != n100 ? 'few' : 'other' : 1 == n && v0 ? 'one' : 'other';
	},
	    plural = function plural(value, offset, lcfunc, data, isOrdinal) {
	  if ({}.hasOwnProperty.call(data, value)) return data[value];offset && (value -= offset);var key = lcfunc(value, isOrdinal);return key in data ? data[key] : data.other;
	},
	    fmt = { number: function number(value, lc, arg) {
	    var a = arg && arg.split(':') || [],
	        opt = { integer: { maximumFractionDigits: 0 }, percent: { style: 'percent' }, currency: { style: 'currency', currency: a[1] && a[1].trim() || 'USD', minimumFractionDigits: 2, maximumFractionDigits: 2 } };return new Intl.NumberFormat(lc, opt[a[0]] || {}).format(value);
	  } };(function (root, G) {
	   true ? !(__WEBPACK_AMD_DEFINE_FACTORY__ = (G), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : 'object' === ('undefined' == typeof exports ? 'undefined' : _typeof(exports)) ? module.exports = G : root.vstuiLocaleData = G;
	})(void 0, { locale: 'en', direction: 'ltr', messages: { button: { newWindowWarning: function newWindowWarning(d) {
	        return d.link + ' (opens in a new window)';
	      } }, dialog: { closeButton: function closeButton() {
	        return 'Close';
	      } }, form: { badInputDatetime: function badInputDatetime() {
	        return 'Please enter a valid value. The field is incomplete or has an invalid date.';
	      }, badInputNumber: function badInputNumber() {
	        return 'Please enter a valid number.';
	      }, badLength: function badLength(d) {
	        return d.changeCharacters + ' (' + d.currentlyUsingCharacters + ').';
	      }, missingCheckbox: function missingCheckbox() {
	        return 'Please check this box if you want to proceed.';
	      }, missingEmail: function missingEmail() {
	        return 'Please enter an email address.';
	      }, missingFile: function missingFile() {
	        return 'Please select a file.';
	      }, missingNumber: function missingNumber() {
	        return 'Please enter a number.';
	      }, missingPassword: function missingPassword() {
	        return 'Please enter a password.';
	      }, missingRadio: function missingRadio() {
	        return 'Please select one of these options.';
	      }, missingSelect: function missingSelect() {
	        return 'Please select an item in the list.';
	      }, missingTel: function missingTel() {
	        return 'Please enter a telephone number.';
	      }, missingText: function missingText() {
	        return 'Please fill out this field.';
	      }, missingUrl: function missingUrl() {
	        return 'Please enter a URL.';
	      }, patternMismatch: function patternMismatch() {
	        return 'Please match the requested format.';
	      }, rangeOverflow: function rangeOverflow(d) {
	        return 'Value must be less than or equal to ' + fmt.number(d.max, 'en') + '.';
	      }, rangeOverflowDatetime: function rangeOverflowDatetime(d) {
	        return 'Value must be ' + d.date + ' or earlier.';
	      }, rangeUnderflow: function rangeUnderflow(d) {
	        return 'Value must be greater than or equal to ' + fmt.number(d.min, 'en') + '.';
	      }, rangeUnderflowDatetime: function rangeUnderflowDatetime(d) {
	        return 'Value must be ' + d.date + ' or later.';
	      }, stepMismatch: function stepMismatch(d) {
	        return 'Please enter a valid value. The two nearest valid values are ' + d.value1 + ' and ' + d.value2 + '.';
	      }, stepMismatchOneValue: function stepMismatchOneValue(d) {
	        return 'Please enter a valid value. The nearest valid value is ' + d.value + '.';
	      }, typeMismatchEmail: function typeMismatchEmail() {
	        return 'Please enter a valid email address.';
	      }, typeMismatchUrl: function typeMismatchUrl() {
	        return 'Please enter a valid URL.';
	      }, shortenCharacters: function shortenCharacters(d) {
	        return plural(d.quantity, 0, en, { one: 'Please shorten this text to ' + fmt.number(d.quantity, 'en', 'integer') + ' character or less', other: 'Please shorten this text to ' + fmt.number(d.quantity, 'en', 'integer') + ' characters or less' });
	      }, lengthenCharacters: function lengthenCharacters(d) {
	        return plural(d.quantity, 0, en, { one: 'Please use at least ' + fmt.number(d.quantity, 'en', 'integer') + ' character', other: 'Please use at least ' + fmt.number(d.quantity, 'en', 'integer') + ' characters' });
	      }, currentlyUsingCharacters: function currentlyUsingCharacters(d) {
	        return plural(d.quantity, 0, en, { one: 'you are currently using ' + fmt.number(d.quantity, 'en', 'integer') + ' character', other: 'you are currently using ' + fmt.number(d.quantity, 'en', 'integer') + ' characters' });
	      } }, table: { sortedAscending: function sortedAscending(d) {
	        return 'Sorted in ascending order by ' + d.columnHeader;
	      }, sortedDescending: function sortedDescending(d) {
	        return 'Sorted in descending order by ' + d.columnHeader;
	      } } }, version: '1.1.0-3' });

/***/ },
/* 476 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) {
	  for (var source, i = 1; i < arguments.length; i++) {
	    for (var key in source = arguments[i], source) {
	      Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
	    }
	  }return target;
	},
	    _createClass = function () {
	  function defineProperties(target, props) {
	    for (var descriptor, i = 0; i < props.length; i++) {
	      descriptor = props[i], descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, 'value' in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    return protoProps && defineProperties(Constructor.prototype, protoProps), staticProps && defineProperties(Constructor, staticProps), Constructor;
	  };
	}(),
	    _react = __webpack_require__(3),
	    _react2 = _interopRequireDefault(_react),
	    _Icon = __webpack_require__(26),
	    _Icon2 = _interopRequireDefault(_Icon);Object.defineProperty(exports, '__esModule', { value: !0 });function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
	}function _possibleConstructorReturn(self, call) {
	  if (!self) throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');return call && ('object' == (typeof call === 'undefined' ? 'undefined' : _typeof(call)) || 'function' == typeof call) ? call : self;
	}function _inherits(subClass, superClass) {
	  if ('function' != typeof superClass && null !== superClass) throw new TypeError('Super expression must either be null or a function, not ' + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: !1, writable: !0, configurable: !0 } }), superClass && (Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass);
	}var CaretDownSmall = function (_PureComponent) {
	  function CaretDownSmall() {
	    return _classCallCheck(this, CaretDownSmall), _possibleConstructorReturn(this, (CaretDownSmall.__proto__ || Object.getPrototypeOf(CaretDownSmall)).apply(this, arguments));
	  }return _inherits(CaretDownSmall, _PureComponent), _createClass(CaretDownSmall, [{ key: 'render', value: function render() {
	      return _react2.default.createElement(_Icon2.default, _extends({}, this.props, { height: 6, width: 10 }), _react2.default.createElement('path', { d: 'M5 3.586L8.293.293a.999.999 0 1 1 1.414 1.414l-4 4a.999.999 0 0 1-1.414 0l-4-4a.997.997 0 0 1 0-1.414.999.999 0 0 1 1.414 0L5 3.586z' }));
	    } }]), CaretDownSmall;
	}(_react.PureComponent);CaretDownSmall.displayName = 'CaretDownSmall', CaretDownSmall.vstuiName = 'Icon', exports.default = CaretDownSmall;

/***/ },
/* 477 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) {
	  for (var source, i = 1; i < arguments.length; i++) {
	    for (var key in source = arguments[i], source) {
	      Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
	    }
	  }return target;
	},
	    _createClass = function () {
	  function defineProperties(target, props) {
	    for (var descriptor, i = 0; i < props.length; i++) {
	      descriptor = props[i], descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, 'value' in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    return protoProps && defineProperties(Constructor.prototype, protoProps), staticProps && defineProperties(Constructor, staticProps), Constructor;
	  };
	}(),
	    _react = __webpack_require__(3),
	    _react2 = _interopRequireDefault(_react),
	    _Icon = __webpack_require__(26),
	    _Icon2 = _interopRequireDefault(_Icon);Object.defineProperty(exports, '__esModule', { value: !0 });function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
	}function _possibleConstructorReturn(self, call) {
	  if (!self) throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');return call && ('object' == (typeof call === 'undefined' ? 'undefined' : _typeof(call)) || 'function' == typeof call) ? call : self;
	}function _inherits(subClass, superClass) {
	  if ('function' != typeof superClass && null !== superClass) throw new TypeError('Super expression must either be null or a function, not ' + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: !1, writable: !0, configurable: !0 } }), superClass && (Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass);
	}var CaretLeftSmall = function (_PureComponent) {
	  function CaretLeftSmall() {
	    return _classCallCheck(this, CaretLeftSmall), _possibleConstructorReturn(this, (CaretLeftSmall.__proto__ || Object.getPrototypeOf(CaretLeftSmall)).apply(this, arguments));
	  }return _inherits(CaretLeftSmall, _PureComponent), _createClass(CaretLeftSmall, [{ key: 'render', value: function render() {
	      return _react2.default.createElement(_Icon2.default, _extends({}, this.props, { height: 10, width: 6 }), _react2.default.createElement('path', { d: 'M2.414 5l3.293 3.293a.999.999 0 1 1-1.414 1.414l-4-4a.999.999 0 0 1 0-1.414l4-4a.997.997 0 0 1 1.414 0 .999.999 0 0 1 0 1.414L2.414 5z' }));
	    } }]), CaretLeftSmall;
	}(_react.PureComponent);CaretLeftSmall.displayName = 'CaretLeftSmall', CaretLeftSmall.vstuiName = 'Icon', exports.default = CaretLeftSmall;

/***/ },
/* 478 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) {
	  for (var source, i = 1; i < arguments.length; i++) {
	    for (var key in source = arguments[i], source) {
	      Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
	    }
	  }return target;
	},
	    _createClass = function () {
	  function defineProperties(target, props) {
	    for (var descriptor, i = 0; i < props.length; i++) {
	      descriptor = props[i], descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, 'value' in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    return protoProps && defineProperties(Constructor.prototype, protoProps), staticProps && defineProperties(Constructor, staticProps), Constructor;
	  };
	}(),
	    _react = __webpack_require__(3),
	    _react2 = _interopRequireDefault(_react),
	    _Icon = __webpack_require__(26),
	    _Icon2 = _interopRequireDefault(_Icon);Object.defineProperty(exports, '__esModule', { value: !0 });function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
	}function _possibleConstructorReturn(self, call) {
	  if (!self) throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');return call && ('object' == (typeof call === 'undefined' ? 'undefined' : _typeof(call)) || 'function' == typeof call) ? call : self;
	}function _inherits(subClass, superClass) {
	  if ('function' != typeof superClass && null !== superClass) throw new TypeError('Super expression must either be null or a function, not ' + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: !1, writable: !0, configurable: !0 } }), superClass && (Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass);
	}var CaretRightSmall = function (_PureComponent) {
	  function CaretRightSmall() {
	    return _classCallCheck(this, CaretRightSmall), _possibleConstructorReturn(this, (CaretRightSmall.__proto__ || Object.getPrototypeOf(CaretRightSmall)).apply(this, arguments));
	  }return _inherits(CaretRightSmall, _PureComponent), _createClass(CaretRightSmall, [{ key: 'render', value: function render() {
	      return _react2.default.createElement(_Icon2.default, _extends({}, this.props, { height: 10, width: 6 }), _react2.default.createElement('path', { d: 'M3.586 5L.293 1.707A.999.999 0 1 1 1.707.293l4 4a.999.999 0 0 1 0 1.414l-4 4a.997.997 0 0 1-1.414 0 .999.999 0 0 1 0-1.414L3.586 5z' }));
	    } }]), CaretRightSmall;
	}(_react.PureComponent);CaretRightSmall.displayName = 'CaretRightSmall', CaretRightSmall.vstuiName = 'Icon', exports.default = CaretRightSmall;

/***/ },
/* 479 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) {
	  for (var source, i = 1; i < arguments.length; i++) {
	    for (var key in source = arguments[i], source) {
	      Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
	    }
	  }return target;
	},
	    _createClass = function () {
	  function defineProperties(target, props) {
	    for (var descriptor, i = 0; i < props.length; i++) {
	      descriptor = props[i], descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, 'value' in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    return protoProps && defineProperties(Constructor.prototype, protoProps), staticProps && defineProperties(Constructor, staticProps), Constructor;
	  };
	}(),
	    _react = __webpack_require__(3),
	    _react2 = _interopRequireDefault(_react),
	    _Icon = __webpack_require__(26),
	    _Icon2 = _interopRequireDefault(_Icon);Object.defineProperty(exports, '__esModule', { value: !0 });function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
	}function _possibleConstructorReturn(self, call) {
	  if (!self) throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');return call && ('object' == (typeof call === 'undefined' ? 'undefined' : _typeof(call)) || 'function' == typeof call) ? call : self;
	}function _inherits(subClass, superClass) {
	  if ('function' != typeof superClass && null !== superClass) throw new TypeError('Super expression must either be null or a function, not ' + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: !1, writable: !0, configurable: !0 } }), superClass && (Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass);
	}var Checkbox = function (_PureComponent) {
	  function Checkbox() {
	    return _classCallCheck(this, Checkbox), _possibleConstructorReturn(this, (Checkbox.__proto__ || Object.getPrototypeOf(Checkbox)).apply(this, arguments));
	  }return _inherits(Checkbox, _PureComponent), _createClass(Checkbox, [{ key: 'render', value: function render() {
	      return _react2.default.createElement(_Icon2.default, _extends({}, this.props, { height: 14, width: 14 }), _react2.default.createElement('rect', { className: 'color2', height: '14', rx: '3', width: '14' }), _react2.default.createElement('path', { className: 'color1', d: 'M1 3.003v7.994C1 12.104 1.896 13 3.003 13h7.994A2.002 2.002 0 0 0 13 10.997V3.003A2.002 2.002 0 0 0 10.997 1H3.003A2.002 2.002 0 0 0 1 3.003zm-1 0A3.002 3.002 0 0 1 3.003 0h7.994A3.002 3.002 0 0 1 14 3.003v7.994A3.002 3.002 0 0 1 10.997 14H3.003A3.002 3.002 0 0 1 0 10.997V3.003z' }));
	    } }]), Checkbox;
	}(_react.PureComponent);Checkbox.displayName = 'Checkbox', Checkbox.vstuiName = 'Icon', exports.default = Checkbox;

/***/ },
/* 480 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) {
	  for (var source, i = 1; i < arguments.length; i++) {
	    for (var key in source = arguments[i], source) {
	      Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
	    }
	  }return target;
	},
	    _createClass = function () {
	  function defineProperties(target, props) {
	    for (var descriptor, i = 0; i < props.length; i++) {
	      descriptor = props[i], descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, 'value' in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    return protoProps && defineProperties(Constructor.prototype, protoProps), staticProps && defineProperties(Constructor, staticProps), Constructor;
	  };
	}(),
	    _react = __webpack_require__(3),
	    _react2 = _interopRequireDefault(_react),
	    _Icon = __webpack_require__(26),
	    _Icon2 = _interopRequireDefault(_Icon);Object.defineProperty(exports, '__esModule', { value: !0 });function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
	}function _possibleConstructorReturn(self, call) {
	  if (!self) throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');return call && ('object' == (typeof call === 'undefined' ? 'undefined' : _typeof(call)) || 'function' == typeof call) ? call : self;
	}function _inherits(subClass, superClass) {
	  if ('function' != typeof superClass && null !== superClass) throw new TypeError('Super expression must either be null or a function, not ' + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: !1, writable: !0, configurable: !0 } }), superClass && (Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass);
	}var CheckboxChecked = function (_PureComponent) {
	  function CheckboxChecked() {
	    return _classCallCheck(this, CheckboxChecked), _possibleConstructorReturn(this, (CheckboxChecked.__proto__ || Object.getPrototypeOf(CheckboxChecked)).apply(this, arguments));
	  }return _inherits(CheckboxChecked, _PureComponent), _createClass(CheckboxChecked, [{ key: 'render', value: function render() {
	      return _react2.default.createElement(_Icon2.default, _extends({}, this.props, { height: 14, width: 14 }), _react2.default.createElement('rect', { className: 'color3', height: '14', rx: '3', width: '14' }), _react2.default.createElement('path', { className: 'color2', d: 'M10.793 5.563L6.648 9.707c-.39.39-1.024.39-1.415 0l-1.94-1.94A1 1 0 1 1 4.707 6.35L5.94 7.585 9.379 4.15a.999.999 0 1 1 1.414 1.413M11 0H3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V3a2.999 2.999 0 0 0-3-3' }), _react2.default.createElement('path', { className: 'color1', d: 'M1 3.003v7.994C1 12.104 1.896 13 3.003 13h7.994A2.002 2.002 0 0 0 13 10.997V3.003A2.002 2.002 0 0 0 10.997 1H3.003A2.002 2.002 0 0 0 1 3.003zm-1 0A3.002 3.002 0 0 1 3.003 0h7.994A3.002 3.002 0 0 1 14 3.003v7.994A3.002 3.002 0 0 1 10.997 14H3.003A3.002 3.002 0 0 1 0 10.997V3.003z' }));
	    } }]), CheckboxChecked;
	}(_react.PureComponent);CheckboxChecked.displayName = 'CheckboxChecked', CheckboxChecked.vstuiName = 'Icon', exports.default = CheckboxChecked;

/***/ },
/* 481 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) {
	  for (var source, i = 1; i < arguments.length; i++) {
	    for (var key in source = arguments[i], source) {
	      Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
	    }
	  }return target;
	},
	    _createClass = function () {
	  function defineProperties(target, props) {
	    for (var descriptor, i = 0; i < props.length; i++) {
	      descriptor = props[i], descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, 'value' in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    return protoProps && defineProperties(Constructor.prototype, protoProps), staticProps && defineProperties(Constructor, staticProps), Constructor;
	  };
	}(),
	    _react = __webpack_require__(3),
	    _react2 = _interopRequireDefault(_react),
	    _Icon = __webpack_require__(26),
	    _Icon2 = _interopRequireDefault(_Icon);Object.defineProperty(exports, '__esModule', { value: !0 });function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
	}function _possibleConstructorReturn(self, call) {
	  if (!self) throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');return call && ('object' == (typeof call === 'undefined' ? 'undefined' : _typeof(call)) || 'function' == typeof call) ? call : self;
	}function _inherits(subClass, superClass) {
	  if ('function' != typeof superClass && null !== superClass) throw new TypeError('Super expression must either be null or a function, not ' + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: !1, writable: !0, configurable: !0 } }), superClass && (Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass);
	}var Checkmark = function (_PureComponent) {
	  function Checkmark() {
	    return _classCallCheck(this, Checkmark), _possibleConstructorReturn(this, (Checkmark.__proto__ || Object.getPrototypeOf(Checkmark)).apply(this, arguments));
	  }return _inherits(Checkmark, _PureComponent), _createClass(Checkmark, [{ key: 'render', value: function render() {
	      return _react2.default.createElement(_Icon2.default, _extends({}, this.props, { height: 10, width: 13 }), _react2.default.createElement('path', { d: 'M4 10a.997.997 0 0 1-.707-.293l-3-3a.999.999 0 1 1 1.414-1.414L4 7.586 11.293.293a.999.999 0 1 1 1.414 1.414l-8 8A.997.997 0 0 1 4 10' }));
	    } }]), Checkmark;
	}(_react.PureComponent);Checkmark.displayName = 'Checkmark', Checkmark.vstuiName = 'Icon', exports.default = Checkmark;

/***/ },
/* 482 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) {
	  for (var source, i = 1; i < arguments.length; i++) {
	    for (var key in source = arguments[i], source) {
	      Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
	    }
	  }return target;
	},
	    _createClass = function () {
	  function defineProperties(target, props) {
	    for (var descriptor, i = 0; i < props.length; i++) {
	      descriptor = props[i], descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, 'value' in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    return protoProps && defineProperties(Constructor.prototype, protoProps), staticProps && defineProperties(Constructor, staticProps), Constructor;
	  };
	}(),
	    _react = __webpack_require__(3),
	    _react2 = _interopRequireDefault(_react),
	    _Icon = __webpack_require__(26),
	    _Icon2 = _interopRequireDefault(_Icon);Object.defineProperty(exports, '__esModule', { value: !0 });function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
	}function _possibleConstructorReturn(self, call) {
	  if (!self) throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');return call && ('object' == (typeof call === 'undefined' ? 'undefined' : _typeof(call)) || 'function' == typeof call) ? call : self;
	}function _inherits(subClass, superClass) {
	  if ('function' != typeof superClass && null !== superClass) throw new TypeError('Super expression must either be null or a function, not ' + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: !1, writable: !0, configurable: !0 } }), superClass && (Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass);
	}var CheckmarkCircle = function (_PureComponent) {
	  function CheckmarkCircle() {
	    return _classCallCheck(this, CheckmarkCircle), _possibleConstructorReturn(this, (CheckmarkCircle.__proto__ || Object.getPrototypeOf(CheckmarkCircle)).apply(this, arguments));
	  }return _inherits(CheckmarkCircle, _PureComponent), _createClass(CheckmarkCircle, [{ key: 'render', value: function render() {
	      return _react2.default.createElement(_Icon2.default, _extends({}, this.props, { height: 18, width: 18 }), _react2.default.createElement('path', { d: 'M9 16c-3.859 0-7-3.141-7-7s3.141-7 7-7 7 3.141 7 7-3.141 7-7 7M9 0a9 9 0 0 1 9 9 9 9 0 0 1-9 9 9 9 0 0 1-9-9 9 9 0 0 1 9-9zm4.706 6.05a.999.999 0 0 0-1.414 0l-4.534 4.536-2.063-2.062a.999.999 0 1 0-1.414 1.414l2.77 2.769a1 1 0 0 0 1.414 0l5.241-5.241a1 1 0 0 0 0-1.415z', fillRule: 'evenodd' }));
	    } }]), CheckmarkCircle;
	}(_react.PureComponent);CheckmarkCircle.displayName = 'CheckmarkCircle', CheckmarkCircle.vstuiName = 'Icon', exports.default = CheckmarkCircle;

/***/ },
/* 483 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) {
	  for (var source, i = 1; i < arguments.length; i++) {
	    for (var key in source = arguments[i], source) {
	      Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
	    }
	  }return target;
	},
	    _createClass = function () {
	  function defineProperties(target, props) {
	    for (var descriptor, i = 0; i < props.length; i++) {
	      descriptor = props[i], descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, 'value' in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    return protoProps && defineProperties(Constructor.prototype, protoProps), staticProps && defineProperties(Constructor, staticProps), Constructor;
	  };
	}(),
	    _react = __webpack_require__(3),
	    _react2 = _interopRequireDefault(_react),
	    _Icon = __webpack_require__(26),
	    _Icon2 = _interopRequireDefault(_Icon);Object.defineProperty(exports, '__esModule', { value: !0 });function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
	}function _possibleConstructorReturn(self, call) {
	  if (!self) throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');return call && ('object' == (typeof call === 'undefined' ? 'undefined' : _typeof(call)) || 'function' == typeof call) ? call : self;
	}function _inherits(subClass, superClass) {
	  if ('function' != typeof superClass && null !== superClass) throw new TypeError('Super expression must either be null or a function, not ' + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: !1, writable: !0, configurable: !0 } }), superClass && (Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass);
	}var ExclamationCircle = function (_PureComponent) {
	  function ExclamationCircle() {
	    return _classCallCheck(this, ExclamationCircle), _possibleConstructorReturn(this, (ExclamationCircle.__proto__ || Object.getPrototypeOf(ExclamationCircle)).apply(this, arguments));
	  }return _inherits(ExclamationCircle, _PureComponent), _createClass(ExclamationCircle, [{ key: 'render', value: function render() {
	      return _react2.default.createElement(_Icon2.default, _extends({}, this.props, { height: 18, width: 18 }), _react2.default.createElement('path', { d: 'M9 18a9 9 0 0 0 9-9 9 9 0 0 0-9-9 9 9 0 0 0-9 9 9 9 0 0 0 9 9m0-2c-3.859 0-7-3.141-7-7s3.141-7 7-7 7 3.141 7 7-3.141 7-7 7zM9 4.25a1 1 0 0 0-1 1v4a1 1 0 1 0 2 0v-4a1 1 0 0 0-1-1zm1.25 8.25a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0z' }));
	    } }]), ExclamationCircle;
	}(_react.PureComponent);ExclamationCircle.displayName = 'ExclamationCircle', ExclamationCircle.vstuiName = 'Icon', exports.default = ExclamationCircle;

/***/ },
/* 484 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) {
	  for (var source, i = 1; i < arguments.length; i++) {
	    for (var key in source = arguments[i], source) {
	      Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
	    }
	  }return target;
	},
	    _createClass = function () {
	  function defineProperties(target, props) {
	    for (var descriptor, i = 0; i < props.length; i++) {
	      descriptor = props[i], descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, 'value' in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    return protoProps && defineProperties(Constructor.prototype, protoProps), staticProps && defineProperties(Constructor, staticProps), Constructor;
	  };
	}(),
	    _react = __webpack_require__(3),
	    _react2 = _interopRequireDefault(_react),
	    _Icon = __webpack_require__(26),
	    _Icon2 = _interopRequireDefault(_Icon);Object.defineProperty(exports, '__esModule', { value: !0 });function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
	}function _possibleConstructorReturn(self, call) {
	  if (!self) throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');return call && ('object' == (typeof call === 'undefined' ? 'undefined' : _typeof(call)) || 'function' == typeof call) ? call : self;
	}function _inherits(subClass, superClass) {
	  if ('function' != typeof superClass && null !== superClass) throw new TypeError('Super expression must either be null or a function, not ' + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: !1, writable: !0, configurable: !0 } }), superClass && (Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass);
	}var FormError = function (_PureComponent) {
	  function FormError() {
	    return _classCallCheck(this, FormError), _possibleConstructorReturn(this, (FormError.__proto__ || Object.getPrototypeOf(FormError)).apply(this, arguments));
	  }return _inherits(FormError, _PureComponent), _createClass(FormError, [{ key: 'render', value: function render() {
	      return _react2.default.createElement(_Icon2.default, _extends({}, this.props, { height: 14, width: 14 }), _react2.default.createElement('path', { d: 'M8 6a1 1 0 1 1-2 0V4a1 1 0 1 1 2 0v2zm-1 5a1 1 0 1 1 0-2 1 1 0 1 1 0 2zM7 0a7 7 0 1 0 0 14A7 7 0 0 0 7 0z' }));
	    } }]), FormError;
	}(_react.PureComponent);FormError.displayName = 'FormError', FormError.vstuiName = 'Icon', exports.default = FormError;

/***/ },
/* 485 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) {
	  for (var source, i = 1; i < arguments.length; i++) {
	    for (var key in source = arguments[i], source) {
	      Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
	    }
	  }return target;
	},
	    _createClass = function () {
	  function defineProperties(target, props) {
	    for (var descriptor, i = 0; i < props.length; i++) {
	      descriptor = props[i], descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, 'value' in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    return protoProps && defineProperties(Constructor.prototype, protoProps), staticProps && defineProperties(Constructor, staticProps), Constructor;
	  };
	}(),
	    _react = __webpack_require__(3),
	    _react2 = _interopRequireDefault(_react),
	    _Icon = __webpack_require__(26),
	    _Icon2 = _interopRequireDefault(_Icon);Object.defineProperty(exports, '__esModule', { value: !0 });function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
	}function _possibleConstructorReturn(self, call) {
	  if (!self) throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');return call && ('object' == (typeof call === 'undefined' ? 'undefined' : _typeof(call)) || 'function' == typeof call) ? call : self;
	}function _inherits(subClass, superClass) {
	  if ('function' != typeof superClass && null !== superClass) throw new TypeError('Super expression must either be null or a function, not ' + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: !1, writable: !0, configurable: !0 } }), superClass && (Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass);
	}var ICircle = function (_PureComponent) {
	  function ICircle() {
	    return _classCallCheck(this, ICircle), _possibleConstructorReturn(this, (ICircle.__proto__ || Object.getPrototypeOf(ICircle)).apply(this, arguments));
	  }return _inherits(ICircle, _PureComponent), _createClass(ICircle, [{ key: 'render', value: function render() {
	      return _react2.default.createElement(_Icon2.default, _extends({}, this.props, { height: 18, width: 18 }), _react2.default.createElement('path', { d: 'M9 0a9 9 0 0 0-9 9 9 9 0 0 0 9 9 9 9 0 0 0 9-9 9 9 0 0 0-9-9m0 2c3.859 0 7 3.141 7 7s-3.141 7-7 7-7-3.141-7-7 3.141-7 7-7zm0 11.75a1 1 0 0 0 1-1v-4a1 1 0 1 0-2 0v4a1 1 0 0 0 1 1zM7.75 5.5a1.25 1.25 0 1 0 2.5 0 1.25 1.25 0 0 0-2.5 0z' }));
	    } }]), ICircle;
	}(_react.PureComponent);ICircle.displayName = 'ICircle', ICircle.vstuiName = 'Icon', exports.default = ICircle;

/***/ },
/* 486 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) {
	  for (var source, i = 1; i < arguments.length; i++) {
	    for (var key in source = arguments[i], source) {
	      Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
	    }
	  }return target;
	},
	    _createClass = function () {
	  function defineProperties(target, props) {
	    for (var descriptor, i = 0; i < props.length; i++) {
	      descriptor = props[i], descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, 'value' in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    return protoProps && defineProperties(Constructor.prototype, protoProps), staticProps && defineProperties(Constructor, staticProps), Constructor;
	  };
	}(),
	    _react = __webpack_require__(3),
	    _react2 = _interopRequireDefault(_react),
	    _Icon = __webpack_require__(26),
	    _Icon2 = _interopRequireDefault(_Icon);Object.defineProperty(exports, '__esModule', { value: !0 });function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
	}function _possibleConstructorReturn(self, call) {
	  if (!self) throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');return call && ('object' == (typeof call === 'undefined' ? 'undefined' : _typeof(call)) || 'function' == typeof call) ? call : self;
	}function _inherits(subClass, superClass) {
	  if ('function' != typeof superClass && null !== superClass) throw new TypeError('Super expression must either be null or a function, not ' + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: !1, writable: !0, configurable: !0 } }), superClass && (Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass);
	}var RadioButton = function (_PureComponent) {
	  function RadioButton() {
	    return _classCallCheck(this, RadioButton), _possibleConstructorReturn(this, (RadioButton.__proto__ || Object.getPrototypeOf(RadioButton)).apply(this, arguments));
	  }return _inherits(RadioButton, _PureComponent), _createClass(RadioButton, [{ key: 'render', value: function render() {
	      return _react2.default.createElement(_Icon2.default, _extends({}, this.props, { height: 14, width: 14 }), _react2.default.createElement('circle', { cx: '7', cy: '7', fill: '#ffffff', r: '7' }), _react2.default.createElement('path', { d: 'M7 13A6 6 0 1 0 7 1a6 6 0 0 0 0 12zm0 1A7 7 0 1 1 7 0a7 7 0 0 1 0 14z' }));
	    } }]), RadioButton;
	}(_react.PureComponent);RadioButton.displayName = 'RadioButton', RadioButton.vstuiName = 'Icon', exports.default = RadioButton;

/***/ },
/* 487 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) {
	  for (var source, i = 1; i < arguments.length; i++) {
	    for (var key in source = arguments[i], source) {
	      Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
	    }
	  }return target;
	},
	    _createClass = function () {
	  function defineProperties(target, props) {
	    for (var descriptor, i = 0; i < props.length; i++) {
	      descriptor = props[i], descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, 'value' in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    return protoProps && defineProperties(Constructor.prototype, protoProps), staticProps && defineProperties(Constructor, staticProps), Constructor;
	  };
	}(),
	    _react = __webpack_require__(3),
	    _react2 = _interopRequireDefault(_react),
	    _Icon = __webpack_require__(26),
	    _Icon2 = _interopRequireDefault(_Icon);Object.defineProperty(exports, '__esModule', { value: !0 });function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
	}function _possibleConstructorReturn(self, call) {
	  if (!self) throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');return call && ('object' == (typeof call === 'undefined' ? 'undefined' : _typeof(call)) || 'function' == typeof call) ? call : self;
	}function _inherits(subClass, superClass) {
	  if ('function' != typeof superClass && null !== superClass) throw new TypeError('Super expression must either be null or a function, not ' + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: !1, writable: !0, configurable: !0 } }), superClass && (Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass);
	}var RadioButtonSelected = function (_PureComponent) {
	  function RadioButtonSelected() {
	    return _classCallCheck(this, RadioButtonSelected), _possibleConstructorReturn(this, (RadioButtonSelected.__proto__ || Object.getPrototypeOf(RadioButtonSelected)).apply(this, arguments));
	  }return _inherits(RadioButtonSelected, _PureComponent), _createClass(RadioButtonSelected, [{ key: 'render', value: function render() {
	      return _react2.default.createElement(_Icon2.default, _extends({}, this.props, { height: 14, width: 14 }), _react2.default.createElement('circle', { cx: '7', cy: '7', r: '7' }), _react2.default.createElement('path', { d: 'M7 13A6 6 0 1 0 7 1a6 6 0 0 0 0 12zm0 1A7 7 0 1 1 7 0a7 7 0 0 1 0 14z' }), _react2.default.createElement('circle', { cx: '7', cy: '7', fill: '#ffffff', r: '2' }));
	    } }]), RadioButtonSelected;
	}(_react.PureComponent);RadioButtonSelected.displayName = 'RadioButtonSelected', RadioButtonSelected.vstuiName = 'Icon', exports.default = RadioButtonSelected;

/***/ },
/* 488 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) {
	  for (var source, i = 1; i < arguments.length; i++) {
	    for (var key in source = arguments[i], source) {
	      Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
	    }
	  }return target;
	},
	    _createClass = function () {
	  function defineProperties(target, props) {
	    for (var descriptor, i = 0; i < props.length; i++) {
	      descriptor = props[i], descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, 'value' in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    return protoProps && defineProperties(Constructor.prototype, protoProps), staticProps && defineProperties(Constructor, staticProps), Constructor;
	  };
	}(),
	    _react = __webpack_require__(3),
	    _react2 = _interopRequireDefault(_react),
	    _Icon = __webpack_require__(26),
	    _Icon2 = _interopRequireDefault(_Icon);Object.defineProperty(exports, '__esModule', { value: !0 });function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
	}function _possibleConstructorReturn(self, call) {
	  if (!self) throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');return call && ('object' == (typeof call === 'undefined' ? 'undefined' : _typeof(call)) || 'function' == typeof call) ? call : self;
	}function _inherits(subClass, superClass) {
	  if ('function' != typeof superClass && null !== superClass) throw new TypeError('Super expression must either be null or a function, not ' + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: !1, writable: !0, configurable: !0 } }), superClass && (Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass);
	}var Search = function (_PureComponent) {
	  function Search() {
	    return _classCallCheck(this, Search), _possibleConstructorReturn(this, (Search.__proto__ || Object.getPrototypeOf(Search)).apply(this, arguments));
	  }return _inherits(Search, _PureComponent), _createClass(Search, [{ key: 'render', value: function render() {
	      return _react2.default.createElement(_Icon2.default, _extends({}, this.props, { height: 16, width: 16 }), _react2.default.createElement('path', { d: 'M6.5 11A4.505 4.505 0 0 1 2 6.5C2 4.019 4.019 2 6.5 2S11 4.019 11 6.5 8.981 11 6.5 11m9.208 3.294l-3.964-3.964A6.465 6.465 0 0 0 13 6.5 6.5 6.5 0 1 0 6.5 13c1.434 0 2.755-.47 3.83-1.256l3.964 3.964a1 1 0 0 0 1.414-1.414' }));
	    } }]), Search;
	}(_react.PureComponent);Search.displayName = 'Search', Search.vstuiName = 'Icon', exports.default = Search;

/***/ },
/* 489 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) {
	  for (var source, i = 1; i < arguments.length; i++) {
	    for (var key in source = arguments[i], source) {
	      Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
	    }
	  }return target;
	},
	    _createClass = function () {
	  function defineProperties(target, props) {
	    for (var descriptor, i = 0; i < props.length; i++) {
	      descriptor = props[i], descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, 'value' in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    return protoProps && defineProperties(Constructor.prototype, protoProps), staticProps && defineProperties(Constructor, staticProps), Constructor;
	  };
	}(),
	    _react = __webpack_require__(3),
	    _react2 = _interopRequireDefault(_react),
	    _Icon = __webpack_require__(26),
	    _Icon2 = _interopRequireDefault(_Icon);Object.defineProperty(exports, '__esModule', { value: !0 });function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
	}function _possibleConstructorReturn(self, call) {
	  if (!self) throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');return call && ('object' == (typeof call === 'undefined' ? 'undefined' : _typeof(call)) || 'function' == typeof call) ? call : self;
	}function _inherits(subClass, superClass) {
	  if ('function' != typeof superClass && null !== superClass) throw new TypeError('Super expression must either be null or a function, not ' + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: !1, writable: !0, configurable: !0 } }), superClass && (Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass);
	}var XSmall = function (_PureComponent) {
	  function XSmall() {
	    return _classCallCheck(this, XSmall), _possibleConstructorReturn(this, (XSmall.__proto__ || Object.getPrototypeOf(XSmall)).apply(this, arguments));
	  }return _inherits(XSmall, _PureComponent), _createClass(XSmall, [{ key: 'render', value: function render() {
	      return _react2.default.createElement(_Icon2.default, _extends({}, this.props, { height: 10, width: 10 }), _react2.default.createElement('path', { d: 'M6.414 5l3.293-3.293A.999.999 0 1 0 8.293.293L5 3.586 1.707.293A.999.999 0 1 0 .293 1.707L3.586 5 .293 8.293a.999.999 0 1 0 1.414 1.414L5 6.414l3.293 3.293a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414L6.414 5z' }));
	    } }]), XSmall;
	}(_react.PureComponent);XSmall.displayName = 'XSmall', XSmall.vstuiName = 'Icon', exports.default = XSmall;

/***/ },
/* 490 */
[1041, 491],
/* 491 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;

/***/ },
/* 492 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = void 0;
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(3));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(63));
	
	var _reactLifecyclesCompat = __webpack_require__(888);
	
	var _PropTypes = __webpack_require__(493);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  } else {
	    var newObj = {};if (obj != null) {
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};if (desc.get || desc.set) {
	            Object.defineProperty(newObj, key, desc);
	          } else {
	            newObj[key] = obj[key];
	          }
	        }
	      }
	    }newObj.default = obj;return newObj;
	  }
	}
	
	function _objectWithoutPropertiesLoose(source, excluded) {
	  if (source == null) return {};var target = {};var sourceKeys = Object.keys(source);var key, i;for (i = 0; i < sourceKeys.length; i++) {
	    key = sourceKeys[i];if (excluded.indexOf(key) >= 0) continue;target[key] = source[key];
	  }return target;
	}
	
	function _inheritsLoose(subClass, superClass) {
	  subClass.prototype = Object.create(superClass.prototype);subClass.prototype.constructor = subClass;subClass.__proto__ = superClass;
	}
	
	var UNMOUNTED = 'unmounted';
	exports.UNMOUNTED = UNMOUNTED;
	var EXITED = 'exited';
	exports.EXITED = EXITED;
	var ENTERING = 'entering';
	exports.ENTERING = ENTERING;
	var ENTERED = 'entered';
	exports.ENTERED = ENTERED;
	var EXITING = 'exiting';
	/**
	 * The Transition component lets you describe a transition from one component
	 * state to another _over time_ with a simple declarative API. Most commonly
	 * it's used to animate the mounting and unmounting of a component, but can also
	 * be used to describe in-place transition states as well.
	 *
	 * ---
	 *
	 * **Note**: `Transition` is a platform-agnostic base component. If you're using
	 * transitions in CSS, you'll probably want to use
	 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
	 * instead. It inherits all the features of `Transition`, but contains
	 * additional features necessary to play nice with CSS transitions (hence the
	 * name of the component).
	 *
	 * ---
	 *
	 * By default the `Transition` component does not alter the behavior of the
	 * component it renders, it only tracks "enter" and "exit" states for the
	 * components. It's up to you to give meaning and effect to those states. For
	 * example we can add styles to a component when it enters or exits:
	 *
	 * ```jsx
	 * import { Transition } from 'react-transition-group';
	 *
	 * const duration = 300;
	 *
	 * const defaultStyle = {
	 *   transition: `opacity ${duration}ms ease-in-out`,
	 *   opacity: 0,
	 * }
	 *
	 * const transitionStyles = {
	 *   entering: { opacity: 0 },
	 *   entered:  { opacity: 1 },
	 * };
	 *
	 * const Fade = ({ in: inProp }) => (
	 *   <Transition in={inProp} timeout={duration}>
	 *     {state => (
	 *       <div style={{
	 *         ...defaultStyle,
	 *         ...transitionStyles[state]
	 *       }}>
	 *         I'm a fade Transition!
	 *       </div>
	 *     )}
	 *   </Transition>
	 * );
	 * ```
	 *
	 * There are 4 main states a Transition can be in:
	 *  - `'entering'`
	 *  - `'entered'`
	 *  - `'exiting'`
	 *  - `'exited'`
	 *
	 * Transition state is toggled via the `in` prop. When `true` the component
	 * begins the "Enter" stage. During this stage, the component will shift from
	 * its current transition state, to `'entering'` for the duration of the
	 * transition and then to the `'entered'` stage once it's complete. Let's take
	 * the following example (we'll use the
	 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
	 *
	 * ```jsx
	 * function App() {
	 *   const [inProp, setInProp] = useState(false);
	 *   return (
	 *     <div>
	 *       <Transition in={inProp} timeout={500}>
	 *         {state => (
	 *           // ...
	 *         )}
	 *       </Transition>
	 *       <button onClick={() => setInProp(true)}>
	 *         Click to Enter
	 *       </button>
	 *     </div>
	 *   );
	 * }
	 * ```
	 *
	 * When the button is clicked the component will shift to the `'entering'` state
	 * and stay there for 500ms (the value of `timeout`) before it finally switches
	 * to `'entered'`.
	 *
	 * When `in` is `false` the same thing happens except the state moves from
	 * `'exiting'` to `'exited'`.
	 */
	
	exports.EXITING = EXITING;
	
	var Transition =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(Transition, _React$Component);
	
	  function Transition(props, context) {
	    var _this;
	
	    _this = _React$Component.call(this, props, context) || this;
	    var parentGroup = context.transitionGroup; // In the context of a TransitionGroup all enters are really appears
	
	    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
	    var initialStatus;
	    _this.appearStatus = null;
	
	    if (props.in) {
	      if (appear) {
	        initialStatus = EXITED;
	        _this.appearStatus = ENTERING;
	      } else {
	        initialStatus = ENTERED;
	      }
	    } else {
	      if (props.unmountOnExit || props.mountOnEnter) {
	        initialStatus = UNMOUNTED;
	      } else {
	        initialStatus = EXITED;
	      }
	    }
	
	    _this.state = {
	      status: initialStatus
	    };
	    _this.nextCallback = null;
	    return _this;
	  }
	
	  var _proto = Transition.prototype;
	
	  _proto.getChildContext = function getChildContext() {
	    return {
	      transitionGroup: null // allows for nested Transitions
	
	    };
	  };
	
	  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
	    var nextIn = _ref.in;
	
	    if (nextIn && prevState.status === UNMOUNTED) {
	      return {
	        status: EXITED
	      };
	    }
	
	    return null;
	  }; // getSnapshotBeforeUpdate(prevProps) {
	  //   let nextStatus = null
	  //   if (prevProps !== this.props) {
	  //     const { status } = this.state
	  //     if (this.props.in) {
	  //       if (status !== ENTERING && status !== ENTERED) {
	  //         nextStatus = ENTERING
	  //       }
	  //     } else {
	  //       if (status === ENTERING || status === ENTERED) {
	  //         nextStatus = EXITING
	  //       }
	  //     }
	  //   }
	  //   return { nextStatus }
	  // }
	
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.updateStatus(true, this.appearStatus);
	  };
	
	  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var nextStatus = null;
	
	    if (prevProps !== this.props) {
	      var status = this.state.status;
	
	      if (this.props.in) {
	        if (status !== ENTERING && status !== ENTERED) {
	          nextStatus = ENTERING;
	        }
	      } else {
	        if (status === ENTERING || status === ENTERED) {
	          nextStatus = EXITING;
	        }
	      }
	    }
	
	    this.updateStatus(false, nextStatus);
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.cancelNextCallback();
	  };
	
	  _proto.getTimeouts = function getTimeouts() {
	    var timeout = this.props.timeout;
	    var exit, enter, appear;
	    exit = enter = appear = timeout;
	
	    if (timeout != null && typeof timeout !== 'number') {
	      exit = timeout.exit;
	      enter = timeout.enter; // TODO: remove fallback for next major
	
	      appear = timeout.appear !== undefined ? timeout.appear : enter;
	    }
	
	    return {
	      exit: exit,
	      enter: enter,
	      appear: appear
	    };
	  };
	
	  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
	    if (mounting === void 0) {
	      mounting = false;
	    }
	
	    if (nextStatus !== null) {
	      // nextStatus will always be ENTERING or EXITING.
	      this.cancelNextCallback();
	
	      var node = _reactDom.default.findDOMNode(this);
	
	      if (nextStatus === ENTERING) {
	        this.performEnter(node, mounting);
	      } else {
	        this.performExit(node);
	      }
	    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
	      this.setState({
	        status: UNMOUNTED
	      });
	    }
	  };
	
	  _proto.performEnter = function performEnter(node, mounting) {
	    var _this2 = this;
	
	    var enter = this.props.enter;
	    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;
	    var timeouts = this.getTimeouts();
	    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
	    // if we are mounting and running this it means appear _must_ be set
	
	    if (!mounting && !enter) {
	      this.safeSetState({
	        status: ENTERED
	      }, function () {
	        _this2.props.onEntered(node);
	      });
	      return;
	    }
	
	    this.props.onEnter(node, appearing);
	    this.safeSetState({
	      status: ENTERING
	    }, function () {
	      _this2.props.onEntering(node, appearing);
	
	      _this2.onTransitionEnd(node, enterTimeout, function () {
	        _this2.safeSetState({
	          status: ENTERED
	        }, function () {
	          _this2.props.onEntered(node, appearing);
	        });
	      });
	    });
	  };
	
	  _proto.performExit = function performExit(node) {
	    var _this3 = this;
	
	    var exit = this.props.exit;
	    var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED
	
	    if (!exit) {
	      this.safeSetState({
	        status: EXITED
	      }, function () {
	        _this3.props.onExited(node);
	      });
	      return;
	    }
	
	    this.props.onExit(node);
	    this.safeSetState({
	      status: EXITING
	    }, function () {
	      _this3.props.onExiting(node);
	
	      _this3.onTransitionEnd(node, timeouts.exit, function () {
	        _this3.safeSetState({
	          status: EXITED
	        }, function () {
	          _this3.props.onExited(node);
	        });
	      });
	    });
	  };
	
	  _proto.cancelNextCallback = function cancelNextCallback() {
	    if (this.nextCallback !== null) {
	      this.nextCallback.cancel();
	      this.nextCallback = null;
	    }
	  };
	
	  _proto.safeSetState = function safeSetState(nextState, callback) {
	    // This shouldn't be necessary, but there are weird race conditions with
	    // setState callbacks and unmounting in testing, so always make sure that
	    // we can cancel any pending setState callbacks after we unmount.
	    callback = this.setNextCallback(callback);
	    this.setState(nextState, callback);
	  };
	
	  _proto.setNextCallback = function setNextCallback(callback) {
	    var _this4 = this;
	
	    var active = true;
	
	    this.nextCallback = function (event) {
	      if (active) {
	        active = false;
	        _this4.nextCallback = null;
	        callback(event);
	      }
	    };
	
	    this.nextCallback.cancel = function () {
	      active = false;
	    };
	
	    return this.nextCallback;
	  };
	
	  _proto.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
	    this.setNextCallback(handler);
	    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
	
	    if (!node || doesNotHaveTimeoutOrListener) {
	      setTimeout(this.nextCallback, 0);
	      return;
	    }
	
	    if (this.props.addEndListener) {
	      this.props.addEndListener(node, this.nextCallback);
	    }
	
	    if (timeout != null) {
	      setTimeout(this.nextCallback, timeout);
	    }
	  };
	
	  _proto.render = function render() {
	    var status = this.state.status;
	
	    if (status === UNMOUNTED) {
	      return null;
	    }
	
	    var _this$props = this.props,
	        children = _this$props.children,
	        childProps = _objectWithoutPropertiesLoose(_this$props, ["children"]); // filter props for Transtition
	
	
	    delete childProps.in;
	    delete childProps.mountOnEnter;
	    delete childProps.unmountOnExit;
	    delete childProps.appear;
	    delete childProps.enter;
	    delete childProps.exit;
	    delete childProps.timeout;
	    delete childProps.addEndListener;
	    delete childProps.onEnter;
	    delete childProps.onEntering;
	    delete childProps.onEntered;
	    delete childProps.onExit;
	    delete childProps.onExiting;
	    delete childProps.onExited;
	
	    if (typeof children === 'function') {
	      return children(status, childProps);
	    }
	
	    var child = _react.default.Children.only(children);
	
	    return _react.default.cloneElement(child, childProps);
	  };
	
	  return Transition;
	}(_react.default.Component);
	
	Transition.contextTypes = {
	  transitionGroup: PropTypes.object
	};
	Transition.childContextTypes = {
	  transitionGroup: function transitionGroup() {}
	};
	Transition.propTypes =  false ? {
	  /**
	   * A `function` child can be used instead of a React element. This function is
	   * called with the current transition status (`'entering'`, `'entered'`,
	   * `'exiting'`, `'exited'`, `'unmounted'`), which can be used to apply context
	   * specific props to a component.
	   *
	   * ```jsx
	   * <Transition in={this.state.in} timeout={150}>
	   *   {state => (
	   *     <MyComponent className={`fade fade-${state}`} />
	   *   )}
	   * </Transition>
	   * ```
	   */
	  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,
	
	  /**
	   * Show the component; triggers the enter or exit states
	   */
	  in: PropTypes.bool,
	
	  /**
	   * By default the child component is mounted immediately along with
	   * the parent `Transition` component. If you want to "lazy mount" the component on the
	   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
	   * mounted, even on "exited", unless you also specify `unmountOnExit`.
	   */
	  mountOnEnter: PropTypes.bool,
	
	  /**
	   * By default the child component stays mounted after it reaches the `'exited'` state.
	   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
	   */
	  unmountOnExit: PropTypes.bool,
	
	  /**
	   * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
	   * If you want to transition on the first mount set `appear` to `true`, and the
	   * component will transition in as soon as the `<Transition>` mounts.
	   *
	   * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
	   */
	  appear: PropTypes.bool,
	
	  /**
	   * Enable or disable enter transitions.
	   */
	  enter: PropTypes.bool,
	
	  /**
	   * Enable or disable exit transitions.
	   */
	  exit: PropTypes.bool,
	
	  /**
	   * The duration of the transition, in milliseconds.
	   * Required unless `addEndListener` is provided.
	   *
	   * You may specify a single timeout for all transitions:
	   *
	   * ```jsx
	   * timeout={500}
	   * ```
	   *
	   * or individually:
	   *
	   * ```jsx
	   * timeout={{
	   *  appear: 500,
	   *  enter: 300,
	   *  exit: 500,
	   * }}
	   * ```
	   *
	   * - `appear` defaults to the value of `enter`
	   * - `enter` defaults to `0`
	   * - `exit` defaults to `0`
	   *
	   * @type {number | { enter?: number, exit?: number, appear?: number }}
	   */
	  timeout: function timeout(props) {
	    var pt = _PropTypes.timeoutsShape;
	    if (!props.addEndListener) pt = pt.isRequired;
	
	    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    return pt.apply(void 0, [props].concat(args));
	  },
	
	  /**
	   * Add a custom transition end trigger. Called with the transitioning
	   * DOM node and a `done` callback. Allows for more fine grained transition end
	   * logic. **Note:** Timeouts are still used as a fallback if provided.
	   *
	   * ```jsx
	   * addEndListener={(node, done) => {
	   *   // use the css transitionend event to mark the finish of a transition
	   *   node.addEventListener('transitionend', done, false);
	   * }}
	   * ```
	   */
	  addEndListener: PropTypes.func,
	
	  /**
	   * Callback fired before the "entering" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool) -> void
	   */
	  onEnter: PropTypes.func,
	
	  /**
	   * Callback fired after the "entering" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntering: PropTypes.func,
	
	  /**
	   * Callback fired after the "entered" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool) -> void
	   */
	  onEntered: PropTypes.func,
	
	  /**
	   * Callback fired before the "exiting" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExit: PropTypes.func,
	
	  /**
	   * Callback fired after the "exiting" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExiting: PropTypes.func,
	
	  /**
	   * Callback fired after the "exited" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExited: PropTypes.func // Name the function so it is clearer in the documentation
	
	} : {};
	
	function noop() {}
	
	Transition.defaultProps = {
	  in: false,
	  mountOnEnter: false,
	  unmountOnExit: false,
	  appear: false,
	  enter: true,
	  exit: true,
	  onEnter: noop,
	  onEntering: noop,
	  onEntered: noop,
	  onExit: noop,
	  onExiting: noop,
	  onExited: noop
	};
	Transition.UNMOUNTED = 0;
	Transition.EXITED = 1;
	Transition.ENTERING = 2;
	Transition.ENTERED = 3;
	Transition.EXITING = 4;
	
	var _default = (0, _reactLifecyclesCompat.polyfill)(Transition);
	
	exports.default = _default;

/***/ },
/* 493 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.classNamesShape = exports.timeoutsShape = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	var timeoutsShape =  false ? _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	  enter: _propTypes.default.number,
	  exit: _propTypes.default.number,
	  appear: _propTypes.default.number
	}).isRequired]) : null;
	exports.timeoutsShape = timeoutsShape;
	var classNamesShape =  false ? _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({
	  enter: _propTypes.default.string,
	  exit: _propTypes.default.string,
	  active: _propTypes.default.string
	}), _propTypes.default.shape({
	  enter: _propTypes.default.string,
	  enterDone: _propTypes.default.string,
	  enterActive: _propTypes.default.string,
	  exit: _propTypes.default.string,
	  exitDone: _propTypes.default.string,
	  exitActive: _propTypes.default.string
	})]) : null;
	exports.classNamesShape = classNamesShape;

/***/ },
/* 494 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var __DEV__ = ("production") !== 'production';
	
	var warning = function warning() {};
	
	if (__DEV__) {
	  var printWarning = function printWarning(format, args) {
	    var len = arguments.length;
	    args = new Array(len > 1 ? len - 1 : 0);
	    for (var key = 1; key < len; key++) {
	      args[key - 1] = arguments[key];
	    }
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  warning = function warning(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	    if (!condition) {
	      printWarning.apply(null, [format].concat(args));
	    }
	  };
	}
	
	module.exports = warning;

/***/ },
/* 495 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	Object.defineProperty(exports, '__esModule', { value: !0 });var _propTypes = __webpack_require__(6),
	    _propTypes2 = _interopRequireDefault(_propTypes),
	    _i18nShape = __webpack_require__(193),
	    _i18nShape2 = _interopRequireDefault(_i18nShape),
	    _themeShape = __webpack_require__(194),
	    _themeShape2 = _interopRequireDefault(_themeShape);function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}var commonPropsShape = _propTypes2.default.shape({ i18n: _i18nShape2.default, theme: _themeShape2.default });exports.default = commonPropsShape;

/***/ },
/* 496 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	Object.defineProperty(exports, '__esModule', { value: !0 });var _styledComponents = __webpack_require__(15),
	    _styledComponents2 = _interopRequireDefault(_styledComponents);function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}var createStyledComponent = function createStyledComponent(element, styleTemplate) {
	  return (0, _styledComponents2.default)(element).withConfig({ displayName: 'createStyledComponent' })(['', ';'], styleTemplate);
	};exports.default = createStyledComponent;

/***/ },
/* 497 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	Object.defineProperty(exports, '__esModule', { value: !0 });var _styledComponents = __webpack_require__(15);Object.defineProperty(exports, 'default', { enumerable: !0, get: function get() {
	    return _styledComponents.css;
	  } });

/***/ },
/* 498 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) {
	  for (var source, i = 1; i < arguments.length; i++) {
	    for (var key in source = arguments[i], source) {
	      Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
	    }
	  }return target;
	},
	    _typeof = 'function' == typeof Symbol && 'symbol' == _typeof2(Symbol.iterator) ? function (obj) {
	  return typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
	} : function (obj) {
	  return obj && 'function' == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? 'symbol' : typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
	},
	    _slicedToArray = function () {
	  function sliceIterator(arr, i) {
	    var _arr = [],
	        _n = !0,
	        _d = !1,
	        _e = void 0;try {
	      for (var _s, _i = arr[Symbol.iterator](); !(_n = (_s = _i.next()).done) && (_arr.push(_s.value), !(i && _arr.length === i)); _n = !0) {}
	    } catch (err) {
	      _d = !0, _e = err;
	    } finally {
	      try {
	        !_n && _i['return'] && _i['return']();
	      } finally {
	        if (_d) throw _e;
	      }
	    }return _arr;
	  }return function (arr, i) {
	    if (Array.isArray(arr)) return arr;if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);throw new TypeError('Invalid attempt to destructure non-iterable instance');
	  };
	}(),
	    _utils = __webpack_require__(59);Object.defineProperty(exports, '__esModule', { value: !0 });function _defineProperty(obj, key, value) {
	  return key in obj ? Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }) : obj[key] = value, obj;
	}var validProperties = ['display', 'position', 'top', 'right', 'bottom', 'left', 'width', 'minWidth', 'maxWidth', 'height', 'minHeight', 'maxHeight', 'margin', 'marginTop', 'marginRight', 'marginBottom', 'marginLeft', 'zIndex', 'flex', 'flexGrow', 'flexShrink', 'flexBasis', 'alignSelf', 'float'],
	    filterLayoutStyles = function filterLayoutStyles(styles) {
	  if (styles === void 0) return {};var filteredStyles = (0, _utils.entries)(styles).reduce(function (accumulator, _ref) {
	    var _ref2 = _slicedToArray(_ref, 2),
	        key = _ref2[0],
	        value = _ref2[1];if ('object' === ('undefined' == typeof value ? 'undefined' : _typeof(value))) {
	      if (0 !== key.indexOf('@media')) return accumulator;var filteredValue = (0, _utils.entries)(value).reduce(function (mediaAccumulator, _ref3) {
	        var _ref4 = _slicedToArray(_ref3, 2),
	            mediaKey = _ref4[0],
	            mediaValue = _ref4[1];return 'object' === ('undefined' == typeof mediaValue ? 'undefined' : _typeof(mediaValue)) ? mediaAccumulator : _extends({}, mediaAccumulator, _defineProperty({}, mediaKey, mediaValue));
	      }, {});return _extends({}, accumulator, _defineProperty({}, key, filteredValue));
	    }return validProperties.includes(key) ? _extends({}, accumulator, _defineProperty({}, key, value)) : accumulator;
	  }, {});return filteredStyles;
	};exports.default = filterLayoutStyles;

/***/ },
/* 499 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var _extends = Object.assign || function (target) {
	  for (var source, i = 1; i < arguments.length; i++) {
	    for (var key in source = arguments[i], source) {
	      Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
	    }
	  }return target;
	},
	    _slicedToArray = function () {
	  function sliceIterator(arr, i) {
	    var _arr = [],
	        _n = !0,
	        _d = !1,
	        _e = void 0;try {
	      for (var _s, _i = arr[Symbol.iterator](); !(_n = (_s = _i.next()).done) && (_arr.push(_s.value), !(i && _arr.length === i)); _n = !0) {}
	    } catch (err) {
	      _d = !0, _e = err;
	    } finally {
	      try {
	        !_n && _i['return'] && _i['return']();
	      } finally {
	        if (_d) throw _e;
	      }
	    }return _arr;
	  }return function (arr, i) {
	    if (Array.isArray(arr)) return arr;if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);throw new TypeError('Invalid attempt to destructure non-iterable instance');
	  };
	}(),
	    _inherited = __webpack_require__(732),
	    _inherited2 = _interopRequireDefault(_inherited),
	    _utils = __webpack_require__(59);Object.defineProperty(exports, '__esModule', { value: !0 }), exports.resetInheritedStylesObject = void 0;function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}function _defineProperty(obj, key, value) {
	  return key in obj ? Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }) : obj[key] = value, obj;
	}var snakeToCamel = function snakeToCamel(s) {
	  return s.replace(/(-\w)/g, function (m) {
	    return m[1].toUpperCase();
	  });
	},
	    modifyStyles = function modifyStyles(obj, _ref) {
	  var _ref$direction = _ref.direction,
	      direction = _ref$direction === void 0 ? 'ltr' : _ref$direction,
	      styles = (0, _utils.entries)(obj).map(function (_ref2) {
	    var _ref3 = _slicedToArray(_ref2, 2),
	        key = _ref3[0],
	        value = _ref3[1];return 'text-align' === key ? [key, 'rtl' === direction ? 'right' : 'left'] : [key, value];
	  }).reduce(function (o, _ref4) {
	    var _ref5 = _slicedToArray(_ref4, 2),
	        k = _ref5[0],
	        v = _ref5[1];return _extends({}, o, _defineProperty({}, k, v));
	  }, {});return styles;
	},
	    toCSS = function toCSS(obj) {
	  return Object.keys(obj).map(function (key) {
	    return key + ': ' + obj[key] + ';';
	  }).join('\n');
	},
	    toObject = function toObject(obj) {
	  return (0, _utils.entries)(obj).map(function (_ref6) {
	    var _ref7 = _slicedToArray(_ref6, 2),
	        key = _ref7[0],
	        value = _ref7[1];return [snakeToCamel(key), value];
	  }).reduce(function (o, _ref8) {
	    var _ref9 = _slicedToArray(_ref8, 2),
	        k = _ref9[0],
	        v = _ref9[1];return _extends({}, o, _defineProperty({}, k, v));
	  }, {});
	},
	    ltrStyles = modifyStyles(_inherited2.default, { direction: 'ltr' }),
	    rtlStyles = modifyStyles(_inherited2.default, { direction: 'rtl' }),
	    ltrCSS = toCSS(ltrStyles),
	    rtlCSS = toCSS(rtlStyles),
	    ltrObject = toObject(ltrStyles),
	    rtlObject = toObject(rtlStyles),
	    resetInheritedStyles = function resetInheritedStyles(props) {
	  return '\n  ' + ('rtl' === props.direction ? rtlCSS : ltrCSS) + '\n';
	},
	    resetInheritedStylesObject = exports.resetInheritedStylesObject = function (_ref10) {
	  var _ref10$direction = _ref10.direction,
	      direction = _ref10$direction === void 0 ? 'ltr' : _ref10$direction;return 'rtl' === direction ? rtlObject : ltrObject;
	};exports.default = resetInheritedStyles;

/***/ },
/* 500 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: !0 });var visuallyHidden = function visuallyHidden() {
	  return "\n    position: absolute;\n    left: -10000px;\n    top: auto;\n    width: 1px;\n    height: 1px;\n    overflow: hidden;\n  ";
	};exports.default = visuallyHidden;

/***/ },
/* 501 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	Object.defineProperty(exports, '__esModule', { value: !0 });var _react = __webpack_require__(3),
	    _react2 = _interopRequireDefault(_react),
	    _propTypes = __webpack_require__(6),
	    _propTypes2 = _interopRequireDefault(_propTypes),
	    _styledComponents = __webpack_require__(15),
	    _createTheme = __webpack_require__(130),
	    _createTheme2 = _interopRequireDefault(_createTheme),
	    _propTypes3 = __webpack_require__(16);function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}var ThemeProvider = function ThemeProvider(props) {
	  var theme = props.theme ? props.theme : (0, _createTheme2.default)();return _react2.default.createElement(_styledComponents.ThemeProvider, { theme: theme }, props.children);
	};ThemeProvider.propTypes = { children: _propTypes2.default.node, theme: _propTypes3.themeShape }, exports.default = ThemeProvider;

/***/ },
/* 502 */
/***/ function(module, exports) {

	'use strict';
	Object.defineProperty(exports, '__esModule', { value: !0 });var createBoxShadows = function createBoxShadows(options) {
	  var _options$menu = options.menu,
	      menu = _options$menu === void 0 ? '0 1px 3px rgba(0, 0, 0, 0.5)' : _options$menu,
	      _options$low = options.low,
	      low = _options$low === void 0 ? '0 1px 3px rgba(0, 0, 0, 0.2)' : _options$low,
	      _options$medium = options.medium,
	      medium = _options$medium === void 0 ? '0 2px 8px rgba(0, 0, 0, 0.2)' : _options$medium,
	      _options$high = options.high,
	      high = _options$high === void 0 ? '0 4px 15px rgba(0, 0, 0, 0.2)' : _options$high;return { menu: menu, low: low, medium: medium, high: high };
	};exports.default = createBoxShadows;

/***/ },
/* 503 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	Object.defineProperty(exports, '__esModule', { value: !0 });var _colors = __webpack_require__(101),
	    black = '#000000',
	    white = '#ffffff',
	    transparent = 'rgba(0, 0, 0, 0)',
	    createThemePalette = function createThemePalette(options) {
	  var _options$primary = options.primary,
	      primary = _options$primary === void 0 ? _colors.ocean : _options$primary,
	      _options$secondary = options.secondary,
	      secondary = _options$secondary === void 0 ? primary : _options$secondary,
	      _options$surface = options.surface,
	      surface = _options$surface === void 0 ? white : _options$surface,
	      _options$error = options.error,
	      error = _options$error === void 0 ? '#cc313d' : _options$error,
	      _options$onPrimary = options.onPrimary,
	      onPrimary = _options$onPrimary === void 0 ? white : _options$onPrimary,
	      _options$onSecondary = options.onSecondary,
	      onSecondary = _options$onSecondary === void 0 ? white : _options$onSecondary,
	      _options$onSurface = options.onSurface,
	      onSurface = _options$onSurface === void 0 ? _colors.ninja.getShade(11) : _options$onSurface;return { primary: primary, secondary: secondary, surface: surface, onPrimary: onPrimary, onSecondary: onSecondary, onSurface: onSurface, error: error, black: black, white: white, transparent: transparent, cloud: _colors.cloud, ninja: _colors.ninja };
	};exports.default = createThemePalette;

/***/ },
/* 504 */
/***/ function(module, exports) {

	'use strict';
	Object.defineProperty(exports, '__esModule', { value: !0 });var createShape = function createShape(options) {
	  var _options$borderStyle = options.borderStyle,
	      borderStyle = _options$borderStyle === void 0 ? 'solid' : _options$borderStyle,
	      _options$borderWidth = options.borderWidth,
	      borderWidth = _options$borderWidth === void 0 ? '1px' : _options$borderWidth,
	      _options$borderRadius = options.borderRadius,
	      borderRadius = _options$borderRadius === void 0 ? '4px' : _options$borderRadius;return { borderStyle: borderStyle, borderWidth: borderWidth, borderRadius: borderRadius };
	};exports.default = createShape;

/***/ },
/* 505 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: !0 });var createSizes = function createSizes(options) {
	  var _options$small = options.small,
	      small = _options$small === void 0 ? 24 : _options$small,
	      _options$medium = options.medium,
	      medium = _options$medium === void 0 ? 32 : _options$medium,
	      _options$large = options.large,
	      large = _options$large === void 0 ? 44 : _options$large;return { small: small, medium: medium, large: large };
	};exports.default = createSizes;

/***/ },
/* 506 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var _extends = Object.assign || function (target) {
	  for (var source, i = 1; i < arguments.length; i++) {
	    for (var key in source = arguments[i], source) {
	      Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
	    }
	  }return target;
	};Object.defineProperty(exports, '__esModule', { value: !0 });exports.default = createThemedComponent;var _react = __webpack_require__(3),
	    _react2 = _interopRequireDefault(_react),
	    _withTheme = __webpack_require__(197),
	    _withTheme2 = _interopRequireDefault(_withTheme),
	    _createComponentTheme = __webpack_require__(195),
	    _createComponentTheme2 = _interopRequireDefault(_createComponentTheme),
	    _createTheme = __webpack_require__(130),
	    _createTheme2 = _interopRequireDefault(_createTheme);function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}function _objectWithoutProperties(obj, keys) {
	  var target = {};for (var i in obj) {
	    0 <= keys.indexOf(i) || Object.prototype.hasOwnProperty.call(obj, i) && (target[i] = obj[i]);
	  }return target;
	}function getComponentDisplayName(Component) {
	  return 'string' == typeof Component ? Component : Component.displayName || Component.name || 'Component';
	}function createThemedComponent(ComponentToTheme, styleOverrides) {
	  var ThemedComponent = function ThemedComponent(props, context) {
	    var theme = props.theme,
	        otherProps = _objectWithoutProperties(props, ['theme']),
	        componentStyles = 'function' == typeof styleOverrides ? styleOverrides(props, context) : styleOverrides,
	        componentTheme = (0, _createComponentTheme2.default)(theme, componentStyles);return _react2.default.createElement(ComponentToTheme, _extends({}, otherProps, { theme: componentTheme }));
	  };return ThemedComponent.propTypes = ComponentToTheme.propTypes, ThemedComponent.defaultProps = { theme: (0, _createTheme2.default)() }, ThemedComponent.displayName = 'Themed(' + getComponentDisplayName(ComponentToTheme) + ')', (0, _withTheme2.default)(ThemedComponent);
	}

/***/ },
/* 507 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	Object.defineProperty(exports, '__esModule', { value: !0 });var _deepmerge = __webpack_require__(734),
	    _deepmerge2 = _interopRequireDefault(_deepmerge);function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}var createTransitions = function createTransitions(options) {
	  return (0, _deepmerge2.default)({ easing: { easeIn: 'ease-in', easeOut: 'ease-out' }, duration: { shortest: '100ms', short: '250ms', enteringScreen: '250ms', leavingScreen: '250ms' } }, options);
	};exports.default = createTransitions;

/***/ },
/* 508 */
/***/ function(module, exports) {

	'use strict';
	Object.defineProperty(exports, '__esModule', { value: !0 });var createTypography = function createTypography(options) {
	  var _options$fontFamily = options.fontFamily,
	      fontFamily = _options$fontFamily === void 0 ? '"Roboto", sans-serif' : _options$fontFamily,
	      _options$fontSize = options.fontSize,
	      fontSize = _options$fontSize === void 0 ? 14 : _options$fontSize,
	      _options$fontWeightLi = options.fontWeightLight,
	      fontWeightLight = _options$fontWeightLi === void 0 ? 300 : _options$fontWeightLi,
	      _options$fontWeightRe = options.fontWeightRegular,
	      fontWeightRegular = _options$fontWeightRe === void 0 ? 400 : _options$fontWeightRe,
	      _options$fontWeightMe = options.fontWeightMedium,
	      fontWeightMedium = _options$fontWeightMe === void 0 ? 500 : _options$fontWeightMe,
	      _options$fontWeightBo = options.fontWeightBold,
	      fontWeightBold = _options$fontWeightBo === void 0 ? 700 : _options$fontWeightBo,
	      _options$fontWeightBl = options.fontWeightBlack,
	      fontWeightBlack = _options$fontWeightBl === void 0 ? 900 : _options$fontWeightBl,
	      _options$htmlFontSize = options.htmlFontSize,
	      htmlFontSize = _options$htmlFontSize === void 0 ? 16 : _options$htmlFontSize;return { fontFamily: fontFamily, htmlFontSize: htmlFontSize, fontSize: Math.max(fontSize, 12), fontWeightLight: fontWeightLight, fontWeightRegular: fontWeightRegular, fontWeightMedium: fontWeightMedium, fontWeightBold: fontWeightBold, fontWeightBlack: fontWeightBlack, pxToRem: function pxToRem(value) {
	      return value / htmlFontSize + 'rem';
	    } };
	};exports.default = createTypography;

/***/ },
/* 509 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: !0 });var createZIndex = function createZIndex(options) {
	  var _options$modal = options.modal,
	      modal = _options$modal === void 0 ? 1300 : _options$modal,
	      _options$tooltip = options.tooltip,
	      tooltip = _options$tooltip === void 0 ? 1500 : _options$tooltip;return { modal: modal, tooltip: tooltip };
	};exports.default = createZIndex;

/***/ },
/* 510 */
/***/ function(module, exports) {

	'use strict';
	Object.defineProperty(exports, '__esModule', { value: !0 });var getStyle = function getStyle(token) {
	  return function (props) {
	    var style = props.theme.vstui[token],
	        styleValue = 'function' == typeof style ? style(props) : style;if (void 0 === styleValue || 'string' == typeof styleValue && (-1 !== styleValue.indexOf('undefined') || -1 !== styleValue.indexOf('null') || -1 !== styleValue.indexOf('NaN'))) return console.log('Token \'' + token + '\' does not exist.'), styleValue;if (token.match(/\w+_backgroundPosition.*/) && 'rtl' === props.theme.vstui.i18n.direction) {
	      var rtlStyleValue = styleValue.toLowerCase().replace(/right/g, 'LEFT').replace(/left/g, 'right').replace(/LEFT/g, 'left');return rtlStyleValue;
	    }return styleValue;
	  };
	};exports.default = getStyle;

/***/ },
/* 511 */
/***/ function(module, exports) {

	'use strict';
	Object.defineProperty(exports, '__esModule', { value: !0 });var createEvent = function createEvent(type, _ref) {
	  var bubbles = _ref.bubbles,
	      cancelable = _ref.cancelable,
	      event = void 0;return 'function' == typeof Event ? event = new Event(type, { bubbles: bubbles, cancelable: cancelable }) : (event = document.createEvent('Event'), event.initEvent(type, bubbles, cancelable)), event;
	};exports.default = createEvent;

/***/ },
/* 512 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: !0 });var entries = function entries(obj) {
	  for (var ownProps = Object.keys(obj), i = ownProps.length, resArray = Array(i); i--;) {
	    resArray[i] = [ownProps[i], obj[ownProps[i]]];
	  }return resArray;
	};exports.default = entries;

/***/ },
/* 513 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	Object.defineProperty(exports, '__esModule', { value: !0 });var _shortid = __webpack_require__(912),
	    _shortid2 = _interopRequireDefault(_shortid);function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}var generateUniqueId = function generateUniqueId() {
	  var name = 0 < arguments.length && arguments[0] !== void 0 ? arguments[0] : 'id';return name + '-' + _shortid2.default.generate();
	};exports.default = generateUniqueId;

/***/ },
/* 514 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) {
	  for (var source, i = 1; i < arguments.length; i++) {
	    for (var key in source = arguments[i], source) {
	      Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
	    }
	  }return target;
	},
	    _createClass = function () {
	  function defineProperties(target, props) {
	    for (var descriptor, i = 0; i < props.length; i++) {
	      descriptor = props[i], descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, 'value' in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    return protoProps && defineProperties(Constructor.prototype, protoProps), staticProps && defineProperties(Constructor, staticProps), Constructor;
	  };
	}(),
	    _react = __webpack_require__(3),
	    _react2 = _interopRequireDefault(_react),
	    _propTypes = __webpack_require__(6),
	    _propTypes2 = _interopRequireDefault(_propTypes),
	    _propTypes3 = __webpack_require__(16),
	    _themes = __webpack_require__(4);Object.defineProperty(exports, '__esModule', { value: !0 });function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
	}function _possibleConstructorReturn(self, call) {
	  if (!self) throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');return call && ('object' == (typeof call === 'undefined' ? 'undefined' : _typeof(call)) || 'function' == typeof call) ? call : self;
	}function _inherits(subClass, superClass) {
	  if ('function' != typeof superClass && null !== superClass) throw new TypeError('Super expression must either be null or a function, not ' + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: !1, writable: !0, configurable: !0 } }), superClass && (Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass);
	}var withCommonProps = function withCommonProps(WrappedComponent) {
	  var WithCommonProps = function (_React$Component) {
	    function WithCommonProps() {
	      return _classCallCheck(this, WithCommonProps), _possibleConstructorReturn(this, (WithCommonProps.__proto__ || Object.getPrototypeOf(WithCommonProps)).apply(this, arguments));
	    }return _inherits(WithCommonProps, _React$Component), _createClass(WithCommonProps, [{ key: 'render', value: function render() {
	        var _props = this.props,
	            dir = _props.dir,
	            inheritStyles = _props.inheritStyles,
	            lang = _props.lang,
	            theme = _props.theme,
	            i18n = theme.vstui.i18n,
	            commonProps = {};return inheritStyles ? (dir && (commonProps.dir = dir), lang && (commonProps.lang = lang)) : (commonProps.dir = dir || i18n.direction, commonProps.lang = lang || i18n.locale), _react2.default.createElement(WrappedComponent, _extends({}, this.props, { commonProps: commonProps }));
	      } }]), WithCommonProps;
	  }(_react2.default.Component);return WithCommonProps.propTypes = { dir: _propTypes2.default.oneOf(['ltr', 'rtl', 'auto']), inheritStyles: _propTypes2.default.bool, lang: _propTypes2.default.string, theme: _propTypes3.themeShape }, WithCommonProps.defaultProps = { theme: (0, _themes.createTheme)() }, WithCommonProps.displayName = 'WithCommonProps(' + (WrappedComponent.displayName || WrappedComponent.name || 'Component') + ')', (0, _themes.withTheme)(WithCommonProps);
	};exports.default = withCommonProps;

/***/ },
/* 515 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/* global NodeList, Element, define */
	
	(function (global) {
	  'use strict';
	
	  var FOCUSABLE_ELEMENTS = ['a[href]', 'area[href]', 'input:not([disabled])', 'select:not([disabled])', 'textarea:not([disabled])', 'button:not([disabled])', 'iframe', 'object', 'embed', '[contenteditable]', '[tabindex]:not([tabindex^="-"])'];
	  var TAB_KEY = 9;
	  var ESCAPE_KEY = 27;
	  var focusedBeforeDialog;
	
	  /**
	   * Define the constructor to instantiate a dialog
	   *
	   * @constructor
	   * @param {Element} node
	   * @param {(NodeList | Element | string)} targets
	   */
	  function A11yDialog(node, targets) {
	    // Prebind the functions that will be bound in addEventListener and
	    // removeEventListener to avoid losing references
	    this._show = this.show.bind(this);
	    this._hide = this.hide.bind(this);
	    this._maintainFocus = this._maintainFocus.bind(this);
	    this._bindKeypress = this._bindKeypress.bind(this);
	
	    // Keep a reference of the node on the instance
	    this.node = node;
	
	    // Keep an object of listener types mapped to callback functions
	    this._listeners = {};
	
	    // Initialise everything needed for the dialog to work properly
	    this.create(targets);
	  }
	
	  /**
	   * Set up everything necessary for the dialog to be functioning
	   *
	   * @param {(NodeList | Element | string)} targets
	   * @return {this}
	   */
	  A11yDialog.prototype.create = function (targets) {
	    // Keep a collection of nodes to disable/enable when toggling the dialog
	    this._targets = this._targets || collect(targets) || getSiblings(this.node);
	
	    // Make sure the dialog element is disabled on load, and that the `shown`
	    // property is synced with its value
	    this.node.setAttribute('aria-hidden', true);
	    this.shown = false;
	
	    // Keep a collection of dialog openers, each of which will be bound a click
	    // event listener to open the dialog
	    this._openers = $$('[data-a11y-dialog-show="' + this.node.id + '"]');
	    this._openers.forEach(function (opener) {
	      opener.addEventListener('click', this._show);
	    }.bind(this));
	
	    // Keep a collection of dialog closers, each of which will be bound a click
	    // event listener to close the dialog
	    this._closers = $$('[data-a11y-dialog-hide]', this.node).concat($$('[data-a11y-dialog-hide="' + this.node.id + '"]'));
	    this._closers.forEach(function (closer) {
	      closer.addEventListener('click', this._hide);
	    }.bind(this));
	
	    // Execute all callbacks registered for the `create` event
	    this._fire('create');
	
	    return this;
	  };
	
	  /**
	   * Show the dialog element, disable all the targets (siblings), trap the
	   * current focus within it, listen for some specific key presses and fire all
	   * registered callbacks for `show` event
	   *
	   * @param {Event} event
	   * @return {this}
	   */
	  A11yDialog.prototype.show = function (event) {
	    // If the dialog is already open, abort
	    if (this.shown) {
	      return this;
	    }
	
	    this.shown = true;
	    this.node.removeAttribute('aria-hidden');
	
	    // Iterate over the targets to disable them by setting their `aria-hidden`
	    // attribute to `true`; in case they already have this attribute, keep a
	    // reference of their original value to be able to restore it later
	    this._targets.forEach(function (target) {
	      var original = target.getAttribute('aria-hidden');
	
	      if (original) {
	        target.setAttribute('data-a11y-dialog-original', original);
	      }
	
	      target.setAttribute('aria-hidden', 'true');
	    });
	
	    // Keep a reference to the currently focused element to be able to restore
	    // it later, then set the focus to the first focusable child of the dialog
	    // element
	    focusedBeforeDialog = document.activeElement;
	    setFocusToFirstItem(this.node);
	
	    // Bind a focus event listener to the body element to make sure the focus
	    // stays trapped inside the dialog while open, and start listening for some
	    // specific key presses (TAB and ESC)
	    document.body.addEventListener('focus', this._maintainFocus, true);
	    document.addEventListener('keydown', this._bindKeypress);
	
	    // Execute all callbacks registered for the `show` event
	    this._fire('show', event);
	
	    return this;
	  };
	
	  /**
	   * Hide the dialog element, enable all the targets (siblings), restore the
	   * focus to the previously active element, stop listening for some specific
	   * key presses and fire all registered callbacks for `hide` event
	   *
	   * @param {Event} event
	   * @return {this}
	   */
	  A11yDialog.prototype.hide = function (event) {
	    // If the dialog is already closed, abort
	    if (!this.shown) {
	      return this;
	    }
	
	    this.shown = false;
	    this.node.setAttribute('aria-hidden', 'true');
	
	    // Iterate over the targets to enable them by remove their `aria-hidden`
	    // attribute or resetting them to their initial value
	    this._targets.forEach(function (target) {
	      var original = target.getAttribute('data-a11y-dialog-original');
	
	      if (original) {
	        target.setAttribute('aria-hidden', original);
	        target.removeAttribute('data-a11y-dialog-original');
	      } else {
	        target.removeAttribute('aria-hidden');
	      }
	    });
	
	    // If their was a focused element before the dialog was opened, restore the
	    // focus back to it
	    if (focusedBeforeDialog) {
	      focusedBeforeDialog.focus();
	    }
	
	    // Remove the focus event listener to the body element and stop listening
	    // for specific key presses
	    document.body.removeEventListener('focus', this._maintainFocus, true);
	    document.removeEventListener('keydown', this._bindKeypress);
	
	    // Execute all callbacks registered for the `hide` event
	    this._fire('hide', event);
	
	    return this;
	  };
	
	  /**
	   * Destroy the current instance (after making sure the dialog has been hidden)
	   * and remove all associated listeners from dialog openers and closers
	   *
	   * @return {this}
	   */
	  A11yDialog.prototype.destroy = function () {
	    // Hide the dialog to avoid destroying an open instance
	    this.hide();
	
	    // Remove the click event listener from all dialog openers
	    this._openers.forEach(function (opener) {
	      opener.removeEventListener('click', this._show);
	    }.bind(this));
	
	    // Remove the click event listener from all dialog closers
	    this._closers.forEach(function (closer) {
	      closer.removeEventListener('click', this._hide);
	    }.bind(this));
	
	    // Execute all callbacks registered for the `destroy` event
	    this._fire('destroy');
	
	    // Keep an object of listener types mapped to callback functions
	    this._listeners = {};
	
	    return this;
	  };
	
	  /**
	   * Register a new callback for the given event type
	   *
	   * @param {string} type
	   * @param {Function} handler
	   */
	  A11yDialog.prototype.on = function (type, handler) {
	    if (typeof this._listeners[type] === 'undefined') {
	      this._listeners[type] = [];
	    }
	
	    this._listeners[type].push(handler);
	
	    return this;
	  };
	
	  /**
	   * Unregister an existing callback for the given event type
	   *
	   * @param {string} type
	   * @param {Function} handler
	   */
	  A11yDialog.prototype.off = function (type, handler) {
	    var index = this._listeners[type].indexOf(handler);
	
	    if (index > -1) {
	      this._listeners[type].splice(index, 1);
	    }
	
	    return this;
	  };
	
	  /**
	   * Iterate over all registered handlers for given type and call them all with
	   * the dialog element as first argument, event as second argument (if any).
	   *
	   * @access private
	   * @param {string} type
	   * @param {Event} event
	   */
	  A11yDialog.prototype._fire = function (type, event) {
	    var listeners = this._listeners[type] || [];
	
	    listeners.forEach(function (listener) {
	      listener(this.node, event);
	    }.bind(this));
	  };
	
	  /**
	   * Private event handler used when listening to some specific key presses
	   * (namely ESCAPE and TAB)
	   *
	   * @access private
	   * @param {Event} event
	   */
	  A11yDialog.prototype._bindKeypress = function (event) {
	    // If the dialog is shown and the ESCAPE key is being pressed, prevent any
	    // further effects from the ESCAPE key and hide the dialog
	    if (this.shown && event.which === ESCAPE_KEY) {
	      event.preventDefault();
	      this.hide();
	    }
	
	    // If the dialog is shown and the TAB key is being pressed, make sure the
	    // focus stays trapped within the dialog element
	    if (this.shown && event.which === TAB_KEY) {
	      trapTabKey(this.node, event);
	    }
	  };
	
	  /**
	   * Private event handler used when making sure the focus stays within the
	   * currently open dialog
	   *
	   * @access private
	   * @param {Event} event
	   */
	  A11yDialog.prototype._maintainFocus = function (event) {
	    // If the dialog is shown and the focus is not within the dialog element,
	    // move it back to its first focusable child
	    if (this.shown && !this.node.contains(event.target)) {
	      setFocusToFirstItem(this.node);
	    }
	  };
	
	  /**
	   * Convert a NodeList into an array
	   *
	   * @param {NodeList} collection
	   * @return {Array<Element>}
	   */
	  function toArray(collection) {
	    return Array.prototype.slice.call(collection);
	  }
	
	  /**
	   * Query the DOM for nodes matching the given selector, scoped to context (or
	   * the whole document)
	   *
	   * @param {String} selector
	   * @param {Element} [context = document]
	   * @return {Array<Element>}
	   */
	  function $$(selector, context) {
	    return toArray((context || document).querySelectorAll(selector));
	  }
	
	  /**
	   * Return an array of Element based on given argument (NodeList, Element or
	   * string representing a selector)
	   *
	   * @param {(NodeList | Element | string)} target
	   * @return {Array<Element>}
	   */
	  function collect(target) {
	    if (NodeList.prototype.isPrototypeOf(target)) {
	      return toArray(target);
	    }
	
	    if (Element.prototype.isPrototypeOf(target)) {
	      return [target];
	    }
	
	    if (typeof target === 'string') {
	      return $$(target);
	    }
	  }
	
	  /**
	   * Set the focus to the first focusable child of the given element
	   *
	   * @param {Element} node
	   */
	  function setFocusToFirstItem(node) {
	    var focusableChildren = getFocusableChildren(node);
	
	    if (focusableChildren.length) {
	      focusableChildren[0].focus();
	    }
	  }
	
	  /**
	   * Get the focusable children of the given element
	   *
	   * @param {Element} node
	   * @return {Array<Element>}
	   */
	  function getFocusableChildren(node) {
	    return $$(FOCUSABLE_ELEMENTS.join(','), node).filter(function (child) {
	      return !!(child.offsetWidth || child.offsetHeight || child.getClientRects().length);
	    });
	  }
	
	  /**
	   * Trap the focus inside the given element
	   *
	   * @param {Element} node
	   * @param {Event} event
	   */
	  function trapTabKey(node, event) {
	    var focusableChildren = getFocusableChildren(node);
	    var focusedItemIndex = focusableChildren.indexOf(document.activeElement);
	
	    // If the SHIFT key is being pressed while tabbing (moving backwards) and
	    // the currently focused item is the first one, move the focus to the last
	    // focusable item from the dialog element
	    if (event.shiftKey && focusedItemIndex === 0) {
	      focusableChildren[focusableChildren.length - 1].focus();
	      event.preventDefault();
	      // If the SHIFT key is not being pressed (moving forwards) and the currently
	      // focused item is the last one, move the focus to the first focusable item
	      // from the dialog element
	    } else if (!event.shiftKey && focusedItemIndex === focusableChildren.length - 1) {
	      focusableChildren[0].focus();
	      event.preventDefault();
	    }
	  }
	
	  /**
	   * Retrieve siblings from given element
	   *
	   * @param {Element} node
	   * @return {Array<Element>}
	   */
	  function getSiblings(node) {
	    var nodes = toArray(node.parentNode.childNodes);
	    var siblings = nodes.filter(function (node) {
	      return node.nodeType === 1;
	    });
	
	    siblings.splice(siblings.indexOf(node), 1);
	
	    return siblings;
	  }
	
	  if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
	    module.exports = A11yDialog;
	  } else if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	      return A11yDialog;
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if ((typeof global === 'undefined' ? 'undefined' : _typeof(global)) === 'object') {
	    global.A11yDialog = A11yDialog;
	  }
	})(typeof global !== 'undefined' ? global : window);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 516 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	// Use the fastest means possible to execute a task in its own turn, with
	// priority over other events including IO, animation, reflow, and redraw
	// events in browsers.
	//
	// An exception thrown by a task will permanently interrupt the processing of
	// subsequent tasks. The higher level `asap` function ensures that if an
	// exception is thrown by a task, that the task queue will continue flushing as
	// soon as possible, but if you use `rawAsap` directly, you are responsible to
	// either ensure that no exceptions are thrown from your task, or to manually
	// call `rawAsap.requestFlush` if an exception is thrown.
	
	module.exports = rawAsap;
	function rawAsap(task) {
	    if (!queue.length) {
	        requestFlush();
	        flushing = true;
	    }
	    // Equivalent to push, but avoids a function call.
	    queue[queue.length] = task;
	}
	
	var queue = [];
	// Once a flush has been requested, no further calls to `requestFlush` are
	// necessary until the next `flush` completes.
	var flushing = false;
	// `requestFlush` is an implementation-specific method that attempts to kick
	// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
	// the event queue before yielding to the browser's own event loop.
	var requestFlush;
	// The position of the next task to execute in the task queue. This is
	// preserved between calls to `flush` so that it can be resumed if
	// a task throws an exception.
	var index = 0;
	// If a task schedules additional tasks recursively, the task queue can grow
	// unbounded. To prevent memory exhaustion, the task queue will periodically
	// truncate already-completed tasks.
	var capacity = 1024;
	
	// The flush function processes all tasks that have been scheduled with
	// `rawAsap` unless and until one of those tasks throws an exception.
	// If a task throws an exception, `flush` ensures that its state will remain
	// consistent and will resume where it left off when called again.
	// However, `flush` does not make any arrangements to be called again if an
	// exception is thrown.
	function flush() {
	    while (index < queue.length) {
	        var currentIndex = index;
	        // Advance the index before calling the task. This ensures that we will
	        // begin flushing on the next task the task throws an error.
	        index = index + 1;
	        queue[currentIndex].call();
	        // Prevent leaking memory for long chains of recursive calls to `asap`.
	        // If we call `asap` within tasks scheduled by `asap`, the queue will
	        // grow, but to avoid an O(n) walk for every task we execute, we don't
	        // shift tasks off the queue after they have been executed.
	        // Instead, we periodically shift 1024 tasks off the queue.
	        if (index > capacity) {
	            // Manually shift all values starting at the index back to the
	            // beginning of the queue.
	            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
	                queue[scan] = queue[scan + index];
	            }
	            queue.length -= index;
	            index = 0;
	        }
	    }
	    queue.length = 0;
	    index = 0;
	    flushing = false;
	}
	
	// `requestFlush` is implemented using a strategy based on data collected from
	// every available SauceLabs Selenium web driver worker at time of writing.
	// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
	
	// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
	// have WebKitMutationObserver but not un-prefixed MutationObserver.
	// Must use `global` or `self` instead of `window` to work in both frames and web
	// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.
	
	/* globals self */
	var scope = typeof global !== "undefined" ? global : self;
	var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;
	
	// MutationObservers are desirable because they have high priority and work
	// reliably everywhere they are implemented.
	// They are implemented in all modern browsers.
	//
	// - Android 4-4.3
	// - Chrome 26-34
	// - Firefox 14-29
	// - Internet Explorer 11
	// - iPad Safari 6-7.1
	// - iPhone Safari 7-7.1
	// - Safari 6-7
	if (typeof BrowserMutationObserver === "function") {
	    requestFlush = makeRequestCallFromMutationObserver(flush);
	
	    // MessageChannels are desirable because they give direct access to the HTML
	    // task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
	    // 11-12, and in web workers in many engines.
	    // Although message channels yield to any queued rendering and IO tasks, they
	    // would be better than imposing the 4ms delay of timers.
	    // However, they do not work reliably in Internet Explorer or Safari.
	
	    // Internet Explorer 10 is the only browser that has setImmediate but does
	    // not have MutationObservers.
	    // Although setImmediate yields to the browser's renderer, it would be
	    // preferrable to falling back to setTimeout since it does not have
	    // the minimum 4ms penalty.
	    // Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
	    // Desktop to a lesser extent) that renders both setImmediate and
	    // MessageChannel useless for the purposes of ASAP.
	    // https://github.com/kriskowal/q/issues/396
	
	    // Timers are implemented universally.
	    // We fall back to timers in workers in most engines, and in foreground
	    // contexts in the following browsers.
	    // However, note that even this simple case requires nuances to operate in a
	    // broad spectrum of browsers.
	    //
	    // - Firefox 3-13
	    // - Internet Explorer 6-9
	    // - iPad Safari 4.3
	    // - Lynx 2.8.7
	} else {
	    requestFlush = makeRequestCallFromTimer(flush);
	}
	
	// `requestFlush` requests that the high priority event queue be flushed as
	// soon as possible.
	// This is useful to prevent an error thrown in a task from stalling the event
	// queue if the exception handled by Node.js’s
	// `process.on("uncaughtException")` or by a domain.
	rawAsap.requestFlush = requestFlush;
	
	// To request a high priority event, we induce a mutation observer by toggling
	// the text of a text node between "1" and "-1".
	function makeRequestCallFromMutationObserver(callback) {
	    var toggle = 1;
	    var observer = new BrowserMutationObserver(callback);
	    var node = document.createTextNode("");
	    observer.observe(node, { characterData: true });
	    return function requestCall() {
	        toggle = -toggle;
	        node.data = toggle;
	    };
	}
	
	// The message channel technique was discovered by Malte Ubl and was the
	// original foundation for this library.
	// http://www.nonblocking.io/2011/06/windownexttick.html
	
	// Safari 6.0.5 (at least) intermittently fails to create message ports on a
	// page's first load. Thankfully, this version of Safari supports
	// MutationObservers, so we don't need to fall back in that case.
	
	// function makeRequestCallFromMessageChannel(callback) {
	//     var channel = new MessageChannel();
	//     channel.port1.onmessage = callback;
	//     return function requestCall() {
	//         channel.port2.postMessage(0);
	//     };
	// }
	
	// For reasons explained above, we are also unable to use `setImmediate`
	// under any circumstances.
	// Even if we were, there is another bug in Internet Explorer 10.
	// It is not sufficient to assign `setImmediate` to `requestFlush` because
	// `setImmediate` must be called *by name* and therefore must be wrapped in a
	// closure.
	// Never forget.
	
	// function makeRequestCallFromSetImmediate(callback) {
	//     return function requestCall() {
	//         setImmediate(callback);
	//     };
	// }
	
	// Safari 6.0 has a problem where timers will get lost while the user is
	// scrolling. This problem does not impact ASAP because Safari 6.0 supports
	// mutation observers, so that implementation is used instead.
	// However, if we ever elect to use timers in Safari, the prevalent work-around
	// is to add a scroll event listener that calls for a flush.
	
	// `setTimeout` does not call the passed callback if the delay is less than
	// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
	// even then.
	
	function makeRequestCallFromTimer(callback) {
	    return function requestCall() {
	        // We dispatch a timeout with a specified delay of 0 for engines that
	        // can reliably accommodate that request. This will usually be snapped
	        // to a 4 milisecond delay, but once we're flushing, there's no delay
	        // between events.
	        var timeoutHandle = setTimeout(handleTimer, 0);
	        // However, since this timer gets frequently dropped in Firefox
	        // workers, we enlist an interval handle that will try to fire
	        // an event 20 times per second until it succeeds.
	        var intervalHandle = setInterval(handleTimer, 50);
	
	        function handleTimer() {
	            // Whichever timer succeeds will cancel both timers and
	            // execute the callback.
	            clearTimeout(timeoutHandle);
	            clearInterval(intervalHandle);
	            callback();
	        }
	    };
	}
	
	// This is for `asap.js` only.
	// Its name will be periodically randomized to break any code that depends on
	// its existence.
	rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;
	
	// ASAP was originally a nextTick shim included in Q. This was factored out
	// into this ASAP package. It was later adapted to RSVP which made further
	// amendments. These decisions, particularly to marginalize MessageChannel and
	// to capture the MutationObserver implementation in a closure, were integrated
	// back into ASAP proper.
	// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 517 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/**
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
	 * additional grant of patent rights can be found in the PATENTS file in
	 * the same directory.
	 */
	
	!function (global) {
	  "use strict";
	
	  var Op = Object.prototype;
	  var hasOwn = Op.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  var inModule = ( false ? "undefined" : _typeof(module)) === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  // This is a polyfill for %IteratorPrototype% for environments that
	  // don't natively support it.
	  var IteratorPrototype = {};
	  IteratorPrototype[iteratorSymbol] = function () {
	    return this;
	  };
	
	  var getProto = Object.getPrototypeOf;
	  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
	  if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
	    // This environment has a native %IteratorPrototype%; use it instead
	    // of the polyfill.
	    IteratorPrototype = NativeIteratorPrototype;
	  }
	
	  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] = GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function (method) {
	      prototype[method] = function (arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function (genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor ? ctor === GeneratorFunction ||
	    // For the native GeneratorFunction constructor, the best we can
	    // do is to check its .name property.
	    (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
	  };
	
	  runtime.mark = function (genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `hasOwn.call(value, "__await")` to determine if the yielded value is
	  // meant to be awaited.
	  runtime.awrap = function (arg) {
	    return { __await: arg };
	  };
	
	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value && (typeof value === "undefined" ? "undefined" : _typeof(value)) === "object" && hasOwn.call(value, "__await")) {
	          return Promise.resolve(value.__await).then(function (value) {
	            invoke("next", value, resolve, reject);
	          }, function (err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return Promise.resolve(value).then(function (unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }
	
	    if (_typeof(global.process) === "object" && global.process.domain) {
	      invoke = global.process.domain.bind(invoke);
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function (resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	      // If enqueue has been called before, then we want to wait until
	      // all previous Promises have been resolved before calling invoke,
	      // so that results are always delivered in the correct order. If
	      // enqueue has not been called before, then it is important to
	      // call invoke immediately, without waiting on a callback to fire,
	      // so that the async generator function has the opportunity to do
	      // any necessary setup in a predictable way. This predictability
	      // is why the Promise constructor synchronously invokes its
	      // executor callback, and why async functions synchronously
	      // execute code before the first await. Since we implement simple
	      // async functions in terms of async generators, it is especially
	      // important to get this right, even though it requires care.
	      previousPromise ? previousPromise.then(callInvokeWithMethodAndArg,
	      // Avoid propagating failures to Promises returned by later
	      // invocations of the iterator.
	      callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
	    return this;
	  };
	  runtime.AsyncIterator = AsyncIterator;
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function (innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList));
	
	    return runtime.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
	    : iter.next().then(function (result) {
	      return result.done ? result.value : iter.next();
	    });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      context.method = method;
	      context.arg = arg;
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          var delegateResult = maybeInvokeDelegate(delegate, context);
	          if (delegateResult) {
	            if (delegateResult === ContinueSentinel) continue;
	            return delegateResult;
	          }
	        }
	
	        if (context.method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = context.arg;
	        } else if (context.method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw context.arg;
	          }
	
	          context.dispatchException(context.arg);
	        } else if (context.method === "return") {
	          context.abrupt("return", context.arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done ? GenStateCompleted : GenStateSuspendedYield;
	
	          if (record.arg === ContinueSentinel) {
	            continue;
	          }
	
	          return {
	            value: record.arg,
	            done: context.done
	          };
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(context.arg) call above.
	          context.method = "throw";
	          context.arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Call delegate.iterator[context.method](context.arg) and handle the
	  // result, either by returning a { value, done } result from the
	  // delegate iterator, or by modifying context.method and context.arg,
	  // setting context.delegate to null, and returning the ContinueSentinel.
	  function maybeInvokeDelegate(delegate, context) {
	    var method = delegate.iterator[context.method];
	    if (method === undefined) {
	      // A .throw or .return when the delegate iterator has no .throw
	      // method always terminates the yield* loop.
	      context.delegate = null;
	
	      if (context.method === "throw") {
	        if (delegate.iterator.return) {
	          // If the delegate iterator has a return method, give it a
	          // chance to clean up.
	          context.method = "return";
	          context.arg = undefined;
	          maybeInvokeDelegate(delegate, context);
	
	          if (context.method === "throw") {
	            // If maybeInvokeDelegate(context) changed context.method from
	            // "return" to "throw", let that override the TypeError below.
	            return ContinueSentinel;
	          }
	        }
	
	        context.method = "throw";
	        context.arg = new TypeError("The iterator does not provide a 'throw' method");
	      }
	
	      return ContinueSentinel;
	    }
	
	    var record = tryCatch(method, delegate.iterator, context.arg);
	
	    if (record.type === "throw") {
	      context.method = "throw";
	      context.arg = record.arg;
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    var info = record.arg;
	
	    if (!info) {
	      context.method = "throw";
	      context.arg = new TypeError("iterator result is not an object");
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    if (info.done) {
	      // Assign the result of the finished delegate to the temporary
	      // variable specified by delegate.resultName (see delegateYield).
	      context[delegate.resultName] = info.value;
	
	      // Resume execution at the desired location (see delegateYield).
	      context.next = delegate.nextLoc;
	
	      // If context.method was "throw" but the delegate handled the
	      // exception, let the outer generator proceed normally. If
	      // context.method was "next", forget context.arg since it has been
	      // "consumed" by the delegate iterator. If context.method was
	      // "return", allow the original .return call to continue in the
	      // outer generator.
	      if (context.method !== "return") {
	        context.method = "next";
	        context.arg = undefined;
	      }
	    } else {
	      // Re-yield the result returned by the delegate method.
	      return info;
	    }
	
	    // The delegate iterator is finished, so forget it and continue with
	    // the outer generator.
	    context.delegate = null;
	    return ContinueSentinel;
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  // A Generator should always return itself as the iterator object when the
	  // @@iterator function is called on it. Some browsers' implementations of the
	  // iterator prototype chain incorrectly implement this, causing the Generator
	  // object to not be returned from this call. This ensures that doesn't happen.
	  // See https://github.com/facebook/regenerator/issues/274 for more details.
	  Gp[iteratorSymbol] = function () {
	    return this;
	  };
	
	  Gp.toString = function () {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function (object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1,
	            next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function reset(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.method = "next";
	      this.arg = undefined;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function stop() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function dispatchException(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	
	        if (caught) {
	          // If the dispatched exception was caught by a catch block,
	          // then let that catch block handle the exception normally.
	          context.method = "next";
	          context.arg = undefined;
	        }
	
	        return !!caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function abrupt(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.method = "next";
	        this.next = finallyEntry.finallyLoc;
	        return ContinueSentinel;
	      }
	
	      return this.complete(record);
	    },
	
	    complete: function complete(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" || record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = this.arg = record.arg;
	        this.method = "return";
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	
	      return ContinueSentinel;
	    },
	
	    finish: function finish(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function _catch(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function delegateYield(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      if (this.method === "next") {
	        // Deliberately forget the last sent value so that we don't
	        // accidentally pass it on to the delegate.
	        this.arg = undefined;
	      }
	
	      return ContinueSentinel;
	    }
	  };
	}(
	// Among the various tricks for obtaining a reference to the global
	// object, this seems to be the most reliable technique that does not
	// use indirect eval (which violates Content Security Policy).
	(typeof global === "undefined" ? "undefined" : _typeof(global)) === "object" ? global : (typeof window === "undefined" ? "undefined" : _typeof(window)) === "object" ? window : (typeof self === "undefined" ? "undefined" : _typeof(self)) === "object" ? self : undefined);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(88)(module)))

/***/ },
/* 518 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	// This method of obtaining a reference to the global object needs to be
	// kept identical to the way it is obtained in runtime.js
	var g = (typeof global === "undefined" ? "undefined" : _typeof(global)) === "object" ? global : (typeof window === "undefined" ? "undefined" : _typeof(window)) === "object" ? window : (typeof self === "undefined" ? "undefined" : _typeof(self)) === "object" ? self : undefined;
	
	// Use `getOwnPropertyNames` because not all browsers support calling
	// `hasOwnProperty` on the global `self` object in a worker. See #183.
	var hadRuntime = g.regeneratorRuntime && Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;
	
	// Save the old regeneratorRuntime in case it needs to be restored later.
	var oldRuntime = hadRuntime && g.regeneratorRuntime;
	
	// Force reevalutation of runtime.js.
	g.regeneratorRuntime = undefined;
	
	module.exports = __webpack_require__(519);
	
	if (hadRuntime) {
	  // Restore the original runtime.
	  g.regeneratorRuntime = oldRuntime;
	} else {
	  // Remove the global property added by runtime.js.
	  try {
	    delete g.regeneratorRuntime;
	  } catch (e) {
	    g.regeneratorRuntime = undefined;
	  }
	}
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 519 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module, process) {"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/**
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
	 * additional grant of patent rights can be found in the PATENTS file in
	 * the same directory.
	 */
	
	!function (global) {
	  "use strict";
	
	  var hasOwn = Object.prototype.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  var inModule = ( false ? "undefined" : _typeof(module)) === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype;
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] = GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function (method) {
	      prototype[method] = function (arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function (genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor ? ctor === GeneratorFunction ||
	    // For the native GeneratorFunction constructor, the best we can
	    // do is to check its .name property.
	    (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
	  };
	
	  runtime.mark = function (genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `value instanceof AwaitArgument` to determine if the yielded value is
	  // meant to be awaited. Some may consider the name of this method too
	  // cutesy, but they are curmudgeons.
	  runtime.awrap = function (arg) {
	    return new AwaitArgument(arg);
	  };
	
	  function AwaitArgument(arg) {
	    this.arg = arg;
	  }
	
	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value instanceof AwaitArgument) {
	          return Promise.resolve(value.arg).then(function (value) {
	            invoke("next", value, resolve, reject);
	          }, function (err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return Promise.resolve(value).then(function (unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }
	
	    if ((typeof process === "undefined" ? "undefined" : _typeof(process)) === "object" && process.domain) {
	      invoke = process.domain.bind(invoke);
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function (resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	      // If enqueue has been called before, then we want to wait until
	      // all previous Promises have been resolved before calling invoke,
	      // so that results are always delivered in the correct order. If
	      // enqueue has not been called before, then it is important to
	      // call invoke immediately, without waiting on a callback to fire,
	      // so that the async generator function has the opportunity to do
	      // any necessary setup in a predictable way. This predictability
	      // is why the Promise constructor synchronously invokes its
	      // executor callback, and why async functions synchronously
	      // execute code before the first await. Since we implement simple
	      // async functions in terms of async generators, it is especially
	      // important to get this right, even though it requires care.
	      previousPromise ? previousPromise.then(callInvokeWithMethodAndArg,
	      // Avoid propagating failures to Promises returned by later
	      // invocations of the iterator.
	      callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function (innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList));
	
	    return runtime.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
	    : iter.next().then(function (result) {
	      return result.done ? result.value : iter.next();
	    });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          if (method === "return" || method === "throw" && delegate.iterator[method] === undefined) {
	            // A return or throw (when the delegate iterator has no throw
	            // method) always terminates the yield* loop.
	            context.delegate = null;
	
	            // If the delegate iterator has a return method, give it a
	            // chance to clean up.
	            var returnMethod = delegate.iterator["return"];
	            if (returnMethod) {
	              var record = tryCatch(returnMethod, delegate.iterator, arg);
	              if (record.type === "throw") {
	                // If the return method threw an exception, let that
	                // exception prevail over the original return or throw.
	                method = "throw";
	                arg = record.arg;
	                continue;
	              }
	            }
	
	            if (method === "return") {
	              // Continue with the outer return, now that the delegate
	              // iterator has been terminated.
	              continue;
	            }
	          }
	
	          var record = tryCatch(delegate.iterator[method], delegate.iterator, arg);
	
	          if (record.type === "throw") {
	            context.delegate = null;
	
	            // Like returning generator.throw(uncaught), but without the
	            // overhead of an extra function call.
	            method = "throw";
	            arg = record.arg;
	            continue;
	          }
	
	          // Delegate generator ran and handled its own exceptions so
	          // regardless of what the method was, we continue as if it is
	          // "next" with an undefined arg.
	          method = "next";
	          arg = undefined;
	
	          var info = record.arg;
	          if (info.done) {
	            context[delegate.resultName] = info.value;
	            context.next = delegate.nextLoc;
	          } else {
	            state = GenStateSuspendedYield;
	            return info;
	          }
	
	          context.delegate = null;
	        }
	
	        if (method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = arg;
	        } else if (method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw arg;
	          }
	
	          if (context.dispatchException(arg)) {
	            // If the dispatched exception was caught by a catch block,
	            // then let that catch block handle the exception normally.
	            method = "next";
	            arg = undefined;
	          }
	        } else if (method === "return") {
	          context.abrupt("return", arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done ? GenStateCompleted : GenStateSuspendedYield;
	
	          var info = {
	            value: record.arg,
	            done: context.done
	          };
	
	          if (record.arg === ContinueSentinel) {
	            if (context.delegate && method === "next") {
	              // Deliberately forget the last sent value so that we don't
	              // accidentally pass it on to the delegate.
	              arg = undefined;
	            }
	          } else {
	            return info;
	          }
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(arg) call above.
	          method = "throw";
	          arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[iteratorSymbol] = function () {
	    return this;
	  };
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  Gp.toString = function () {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function (object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1,
	            next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function reset(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function stop() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function dispatchException(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	        return !!caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function abrupt(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.next = finallyEntry.finallyLoc;
	      } else {
	        this.complete(record);
	      }
	
	      return ContinueSentinel;
	    },
	
	    complete: function complete(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" || record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = record.arg;
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	    },
	
	    finish: function finish(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function _catch(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function delegateYield(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      return ContinueSentinel;
	    }
	  };
	}(
	// Among the various tricks for obtaining a reference to the global
	// object, this seems to be the most reliable technique that does not
	// use indirect eval (which violates Content Security Policy).
	(typeof global === "undefined" ? "undefined" : _typeof(global)) === "object" ? global : (typeof window === "undefined" ? "undefined" : _typeof(window)) === "object" ? window : (typeof self === "undefined" ? "undefined" : _typeof(self)) === "object" ? self : undefined);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(88)(module), __webpack_require__(121)))

/***/ },
/* 520 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	module.exports = __webpack_require__(518);

/***/ },
/* 521 */
/***/ function(module, exports) {

	'use strict';
	
	exports.byteLength = byteLength;
	exports.toByteArray = toByteArray;
	exports.fromByteArray = fromByteArray;
	
	var lookup = [];
	var revLookup = [];
	var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
	
	var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
	for (var i = 0, len = code.length; i < len; ++i) {
	  lookup[i] = code[i];
	  revLookup[code.charCodeAt(i)] = i;
	}
	
	revLookup['-'.charCodeAt(0)] = 62;
	revLookup['_'.charCodeAt(0)] = 63;
	
	function placeHoldersCount(b64) {
	  var len = b64.length;
	  if (len % 4 > 0) {
	    throw new Error('Invalid string. Length must be a multiple of 4');
	  }
	
	  // the number of equal signs (place holders)
	  // if there are two placeholders, than the two characters before it
	  // represent one byte
	  // if there is only one, then the three characters before it represent 2 bytes
	  // this is just a cheap hack to not do indexOf twice
	  return b64[len - 2] === '=' ? 2 : b64[len - 1] === '=' ? 1 : 0;
	}
	
	function byteLength(b64) {
	  // base64 is 4/3 + up to two characters of the original data
	  return b64.length * 3 / 4 - placeHoldersCount(b64);
	}
	
	function toByteArray(b64) {
	  var i, l, tmp, placeHolders, arr;
	  var len = b64.length;
	  placeHolders = placeHoldersCount(b64);
	
	  arr = new Arr(len * 3 / 4 - placeHolders);
	
	  // if there are placeholders, only get up to the last complete 4 chars
	  l = placeHolders > 0 ? len - 4 : len;
	
	  var L = 0;
	
	  for (i = 0; i < l; i += 4) {
	    tmp = revLookup[b64.charCodeAt(i)] << 18 | revLookup[b64.charCodeAt(i + 1)] << 12 | revLookup[b64.charCodeAt(i + 2)] << 6 | revLookup[b64.charCodeAt(i + 3)];
	    arr[L++] = tmp >> 16 & 0xFF;
	    arr[L++] = tmp >> 8 & 0xFF;
	    arr[L++] = tmp & 0xFF;
	  }
	
	  if (placeHolders === 2) {
	    tmp = revLookup[b64.charCodeAt(i)] << 2 | revLookup[b64.charCodeAt(i + 1)] >> 4;
	    arr[L++] = tmp & 0xFF;
	  } else if (placeHolders === 1) {
	    tmp = revLookup[b64.charCodeAt(i)] << 10 | revLookup[b64.charCodeAt(i + 1)] << 4 | revLookup[b64.charCodeAt(i + 2)] >> 2;
	    arr[L++] = tmp >> 8 & 0xFF;
	    arr[L++] = tmp & 0xFF;
	  }
	
	  return arr;
	}
	
	function tripletToBase64(num) {
	  return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F];
	}
	
	function encodeChunk(uint8, start, end) {
	  var tmp;
	  var output = [];
	  for (var i = start; i < end; i += 3) {
	    tmp = (uint8[i] << 16) + (uint8[i + 1] << 8) + uint8[i + 2];
	    output.push(tripletToBase64(tmp));
	  }
	  return output.join('');
	}
	
	function fromByteArray(uint8) {
	  var tmp;
	  var len = uint8.length;
	  var extraBytes = len % 3; // if we have 1 byte left, pad 2 bytes
	  var output = '';
	  var parts = [];
	  var maxChunkLength = 16383; // must be multiple of 3
	
	  // go through the array every three bytes, we'll deal with trailing stuff later
	  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
	    parts.push(encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
	  }
	
	  // pad the end with zeros, but make sure to not forget the extra bytes
	  if (extraBytes === 1) {
	    tmp = uint8[len - 1];
	    output += lookup[tmp >> 2];
	    output += lookup[tmp << 4 & 0x3F];
	    output += '==';
	  } else if (extraBytes === 2) {
	    tmp = (uint8[len - 2] << 8) + uint8[len - 1];
	    output += lookup[tmp >> 10];
	    output += lookup[tmp >> 4 & 0x3F];
	    output += lookup[tmp << 2 & 0x3F];
	    output += '=';
	  }
	
	  parts.push(output);
	
	  return parts.join('');
	}

/***/ },
/* 522 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = function chain() {
	  var len = arguments.length;
	  var args = [];
	
	  for (var i = 0; i < len; i++) {
	    args[i] = arguments[i];
	  }args = args.filter(function (fn) {
	    return fn != null;
	  });
	
	  if (args.length === 0) return undefined;
	  if (args.length === 1) return args[0];
	
	  return args.reduce(function (current, next) {
	    return function chainedFunction() {
	      current.apply(this, arguments);
	      next.apply(this, arguments);
	    };
	  });
	};

/***/ },
/* 523 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _objectSpread(a) {
		for (var b = 1; b < arguments.length; b++) {
			var c = null == arguments[b] ? {} : arguments[b],
			    d = Object.keys(c);"function" == typeof Object.getOwnPropertySymbols && (d = d.concat(Object.getOwnPropertySymbols(c).filter(function (a) {
				return Object.getOwnPropertyDescriptor(c, a).enumerable;
			}))), d.forEach(function (b) {
				_defineProperty(a, b, c[b]);
			});
		}return a;
	}function _defineProperty(a, b, c) {
		return b in a ? Object.defineProperty(a, b, { value: c, enumerable: !0, configurable: !0, writable: !0 }) : a[b] = c, a;
	}function _typeof(a) {
		return _typeof = "function" == typeof Symbol && "symbol" == _typeof2(Symbol.iterator) ? function (a) {
			return typeof a === "undefined" ? "undefined" : _typeof2(a);
		} : function (a) {
			return a && "function" == typeof Symbol && a.constructor === Symbol && a !== Symbol.prototype ? "symbol" : typeof a === "undefined" ? "undefined" : _typeof2(a);
		}, _typeof(a);
	}(function (a, b) {
		"object" === ( false ? "undefined" : _typeof(exports)) && "undefined" != typeof module ? b() :  true ? !(__WEBPACK_AMD_DEFINE_FACTORY__ = (b), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : b();
	})(undefined, function () {
		"use strict";
		var l = Math.min;function a(a) {
			return a && a.__esModule && Object.prototype.hasOwnProperty.call(a, "default") ? a.default : a;
		}function b(a, b) {
			return b = { exports: {} }, a(b, b.exports), b.exports;
		}function d(a) {
			return a && a.default || a;
		}function e(a) {
			return Math.pow((a + .055) / 1.055, 2.4);
		} /*
	   * @param {number} a luminance value
	   * @param {number} b luminance value
	   * @returns {number} contrast ratio
	   */function f(c, a) {
			var b = Math.max(c, a),
			    d = l(c, a);return (b + .05) / (d + .05);
		} /*
	   * @param {array} a rgb value
	   * @param {array} b rgb value
	   * @returns {number} contrast ratio
	   */function g(c, a) {
			return f(B(c), B(a));
		} /*
	   * @param {string} a hex value
	   * @param {string} b hex value
	   * @returns {number} contrast ratio
	   */function h() {
			// ensure that runtime compilation only happens once
			return y || (y = /^[\s	\n\v\f\r   ᠎             　\u2028\u2029﻿"]+$/);
		}function i(a, b, c) {
			return a = j(a, c), b = j(b, c), D.rgb(a, b);
		}function j(a, b) {
			if ("string" != typeof a) throw new TypeError("get-contrast expects colors as strings");return xc(a) && (a = mf[a]), a = k(a, b), a.match(/\((.*)\)/)[1].split(",").slice(0, 3);
		}function k(a, b) {
			b = b || {}, a = z(a); // Check if the rgb returned color is rgba and if the 'a' value is 0.
			var c = a.match(/\((.*)\)/)[1].split(",");if (4 == c.length && "0" == c[3] && !b.ignoreAlpha) throw new TypeError("get-contrast cannot contrast transparent colors");else return a;
		}var m = { maroon: "#800000", red: "#ff0000", orange: "#ffA500", yellow: "#ffff00", olive: "#808000", purple: "#800080", fuchsia: "#ff00ff", white: "#ffffff", lime: "#00ff00", green: "#008000", navy: "#000080", blue: "#0000ff", aqua: "#00ffff", teal: "#008080", black: "#000000", silver: "#c0c0c0", gray: "#808080", transparent: "#0000" },
		    n = function n(c, d, e, f) {
			var h = Math.round;return (null == f || "" === f) && (f = 1), c = parseFloat(c), d = parseFloat(d), e = parseFloat(e), f = parseFloat(f), 255 >= c && 0 <= c && 255 >= d && 0 <= d && 255 >= e && 0 <= e && 1 >= f && 0 <= f ? [h(c), h(d), h(e), f] : null;
		},
		    o = function o(a) {
			if (3 === a.length && (a += "f"), 4 === a.length) {
				var b = a.charAt(0),
				    c = a.charAt(1),
				    d = a.charAt(2),
				    e = a.charAt(3);a = b + b + c + c + d + d + e + e;
			}6 === a.length && (a += "ff");for (var f = [], g = 0, h = a.length; g < h; g += 2) {
				f.push(parseInt(a.substr(g, 2), 16) / (6 == g ? 255 : 1));
			}return f;
		},
		    r = function r(a, b, c) {
			return 0 > c && (c += 1), 1 < c && (c -= 1), c < 1 / 6 ? a + 6 * (b - a) * c : c < 1 / 2 ? b : c < 2 / 3 ? a + 6 * ((b - a) * (2 / 3 - c)) : a;
		},
		    s = function s(c, d, e, f) {
			var i, j, k;if ((null == f || "" === f) && (f = 1), c = parseFloat(c) / 360, d = parseFloat(d) / 100, e = parseFloat(e) / 100, f = parseFloat(f) / 1, 1 < c || 0 > c || 1 < d || 0 > d || 1 < e || 0 > e || 1 < f || 0 > f) return null;if (0 === d) i = j = k = e;else {
				var m = .5 > e ? e * (1 + d) : e + d - e * d,
				    n = 2 * e - m;i = r(n, m, c + 1 / 3), k = r(n, m, c), j = r(n, m, c - 1 / 3);
			}return [255 * i, 255 * k, 255 * j, f];
		},
		    t = [];for (var u in m) {
			t.push(u);
		}var c = "(" + t.join("|") + ")",
		    p = /(?:#([a-f0-9]{3,8}))/i,
		    q = /(?:rgb)a?\(\s*([.\d%]+)\s*,\s*([.\d%]+)\s*,\s*([.\d%]+)\s*(?:,\s*([.\d]+)\s*)?\)/i,
		    v = /(?:hsl)a?\(\s*([.\d%]+)\s*,\s*([.\d%]+)\s*,\s*([.\d%]+)\s*(?:,\s*([.\d]+)\s*)?\)/i,
		    w = function w(a, b) {
			if (null == a) return null;a = (a + "").replace(/\s+/, "");var c = m[a];if (c) return w(c, b);if (c = a.match(p)) a = o(c[1]);else if (c = a.match(q)) a = c.slice(1);else if (c = a.match(v)) a = s.apply(null, c.slice(1));else return null;return a && (a = n.apply(null, a)) ? b ? a : (1 === a[3] && a.splice(3, 1), "rgb" + (4 === a.length ? "a" : "") + "(" + a + ")") : null;
		},
		    x = RegExp([c, "(?:#([a-f0-9]{3,8}))", "(?:rgb)a?\\(\\s*([.\\d%]+)\\s*,\\s*([.\\d%]+)\\s*,\\s*([.\\d%]+)\\s*(?:,\\s*([.\\d]+)\\s*)?\\)", "(?:hsl)a?\\(\\s*([.\\d%]+)\\s*,\\s*([.\\d%]+)\\s*,\\s*([.\\d%]+)\\s*(?:,\\s*([.\\d]+)\\s*)?\\)"].join("|"), "gi");w.replace = function (a, b) {
			return b || (b = function b(a) {
				return w(a);
			}), (a + "").replace(x, b);
		}, w.matches = function (a) {
			return !!(a + "").match(x);
		};var y,
		    z = w,
		    // low-gamma adjust coefficient
		A = 1 / 12.92,
		    B = function B(a) {
			var c = a[0] / 255,
			    d = a[1] / 255,
			    f = a[2] / 255,
			    h = .03928 >= c ? c * A : e(c),
			    i = .03928 >= d ? d * A : e(d),
			    g = .03928 >= f ? f * A : e(f);return h * .2126 + i * .7152 + g * .0722;
		},
		    C = function C(a) {
			if ("string" != typeof a) throw new TypeError("Expected a string");a = a.replace(/^#/, ""), 3 === a.length && (a = a[0] + a[0] + a[1] + a[1] + a[2] + a[2]);var b = parseInt(a, 16);return [b >> 16, 255 & b >> 8, 255 & b];
		},
		    D = { luminance: f, rgb: g, hex: function hex(c, a) {
				return g(C(c), C(a));
			} /*
	    * @param {array} a rgb value
	    * @param {array} b rgb value
	    * @returns {number} contrast ratio
	    */, score: function score(a) {
				return 7 <= a ? "AAA" : 4.5 <= a ? "AA" : "";
			} },
		    E = /**
	         * Test whether a value is "empty".
	         *
	         * @param {Mixed} val
	         * @return {Boolean}
	         */function E(a) {
			if (null == a) return !0;if ("number" == typeof a) return 0 == a;if (void 0 !== a.length) return 0 === a.length;for (var b in a) {
				if (F.call(a, b)) return !1;
			}return !0;
		} /*!
	   * is-whitespace <https://github.com/jonschlinkert/is-whitespace>
	   *
	   * Copyright (c) 2014-2015, Jon Schlinkert.
	   * Licensed under the MIT License.
	   */,
		    F = Object.prototype.hasOwnProperty,
		    G = function G(a) {
			return "string" == typeof a && h().test(a);
		},
		    H = function H(a) {
			return "boolean" != typeof a && ("string" == typeof a && a.length ? G(a) : E(a));
		},
		    I = "#00ffff",
		    J = "#f0f8ff",
		    K = "#faebd7",
		    L = "#000000",
		    M = "#0000ff",
		    N = "#00ffff",
		    O = "#00008b",
		    P = "#008b8b",
		    Q = "#006400",
		    R = "#00ced1",
		    S = "#00bfff",
		    T = "#008000",
		    U = "#00ff00",
		    V = "#0000cd",
		    W = "#00fa9a",
		    X = "#000080",
		    Y = "#00ff7f",
		    Z = "#008080",
		    $ = "#191970",
		    _ = "#1e90ff",
		    aa = "#20b2aa",
		    ba = "#228b22",
		    ca = "#2e8b57",
		    da = "#2f4f4f",
		    ea = "#2f4f4f",
		    fa = "#32cd32",
		    ga = "#3cb371",
		    ha = "#40e0d0",
		    ia = "#4169e1",
		    ja = "#4682b4",
		    ka = "#483d8b",
		    la = "#48d1cc",
		    ma = "#4b0082",
		    na = "#556b2f",
		    oa = "#5f9ea0",
		    pa = "#6495ed",
		    qa = "#66cdaa",
		    ra = "#696969",
		    sa = "#696969",
		    ta = "#6a5acd",
		    ua = "#6b8e23",
		    va = "#708090",
		    wa = "#708090",
		    xa = "#778899",
		    ya = "#778899",
		    za = "#7b68ee",
		    Aa = "#7cfc00",
		    Ba = "#7fffd4",
		    Ca = "#7fff00",
		    Da = "#808080",
		    Ea = "#808080",
		    Fa = "#800000",
		    Ga = "#808000",
		    Ha = "#800080",
		    Ia = "#87cefa",
		    Ja = "#87ceeb",
		    Ka = "#8a2be2",
		    La = "#8b008b",
		    Ma = "#8b0000",
		    Na = "#8b4513",
		    Oa = "#8fbc8f",
		    Pa = "#90ee90",
		    Qa = "#9370db",
		    Ra = "#9400d3",
		    Sa = "#98fb98",
		    Ta = "#9932cc",
		    Ua = "#9acd32",
		    Va = "#a0522d",
		    Wa = "#a52a2a",
		    Xa = "#a9a9a9",
		    Ya = "#a9a9a9",
		    Za = "#adff2f",
		    $a = "#add8e6",
		    _a = "#afeeee",
		    ab = "#b0c4de",
		    bb = "#b0e0e6",
		    cb = "#b22222",
		    db = "#b8860b",
		    eb = "#ba55d3",
		    fb = "#bc8f8f",
		    gb = "#bdb76b",
		    hb = "#c0c0c0",
		    ib = "#c71585",
		    jb = "#cd5c5c",
		    kb = "#cd853f",
		    lb = "#d2691e",
		    mb = "#d2b48c",
		    nb = "#d3d3d3",
		    ob = "#d3d3d3",
		    pb = "#d8bfd8",
		    qb = "#daa520",
		    rb = "#da70d6",
		    sb = "#db7093",
		    tb = "#dc143c",
		    ub = "#dcdcdc",
		    vb = "#dda0dd",
		    wb = "#deb887",
		    xb = "#e0ffff",
		    yb = "#e6e6fa",
		    zb = "#e9967a",
		    Ab = "#eee8aa",
		    Bb = "#ee82ee",
		    Cb = "#f0ffff",
		    Db = "#f0fff0",
		    Eb = "#f0e68c",
		    Fb = "#f08080",
		    Gb = "#f4a460",
		    Hb = "#f5f5dc",
		    Ib = "#f5fffa",
		    Jb = "#f5deb3",
		    Kb = "#f5f5f5",
		    Lb = "#f8f8ff",
		    Mb = "#fafad2",
		    Nb = "#faf0e6",
		    Ob = "#fa8072",
		    Pb = "#fdf5e6",
		    Qb = "#ffe4c4",
		    Rb = "#ffebcd",
		    Sb = "#ff7f50",
		    Tb = "#fff8dc",
		    Ub = "#ff8c00",
		    Vb = "#ff1493",
		    Wb = "#fffaf0",
		    Xb = "#ff00ff",
		    Yb = "#ffd700",
		    Zb = "#ff69b4",
		    $b = "#fffff0",
		    _b = "#fff0f5",
		    ac = "#fffacd",
		    bc = "#ffb6c1",
		    cc = "#ffa07a",
		    dc = "#ffffe0",
		    ec = "#ff00ff",
		    fc = "#ffe4e1",
		    gc = "#ffe4b5",
		    hc = "#ffdead",
		    ic = "#ffa500",
		    jc = "#ff4500",
		    kc = "#ffefd5",
		    lc = "#ffdab9",
		    mc = "#ffc0cb",
		    nc = "#ff0000",
		    oc = "#fff5ee",
		    pc = "#fffafa",
		    qc = "#ff6347",
		    rc = "#ffffff",
		    sc = "#ffff00",
		    tc = "#663399",
		    uc = /*#__PURE__*/Object.freeze({ aqua: I, aliceblue: J, antiquewhite: K, black: L, blue: M, cyan: N, darkblue: O, darkcyan: P, darkgreen: Q, darkturquoise: R, deepskyblue: S, green: T, lime: U, mediumblue: V, mediumspringgreen: W, navy: X, springgreen: Y, teal: Z, midnightblue: $, dodgerblue: _, lightseagreen: aa, forestgreen: ba, seagreen: ca, darkslategray: da, darkslategrey: ea, limegreen: fa, mediumseagreen: ga, turquoise: ha, royalblue: ia, steelblue: ja, darkslateblue: ka, mediumturquoise: la, indigo: ma, darkolivegreen: na, cadetblue: oa, cornflowerblue: pa, mediumaquamarine: qa, dimgray: ra, dimgrey: sa, slateblue: ta, olivedrab: ua, slategray: va, slategrey: wa, lightslategray: xa, lightslategrey: ya, mediumslateblue: za, lawngreen: Aa, aquamarine: Ba, chartreuse: Ca, gray: Da, grey: Ea, maroon: Fa, olive: Ga, purple: Ha, lightskyblue: Ia, skyblue: Ja, blueviolet: Ka, darkmagenta: La, darkred: Ma, saddlebrown: Na, darkseagreen: Oa, lightgreen: Pa, mediumpurple: Qa, darkviolet: Ra, palegreen: Sa, darkorchid: Ta, yellowgreen: Ua, sienna: Va, brown: Wa, darkgray: Xa, darkgrey: Ya, greenyellow: Za, lightblue: $a, paleturquoise: _a, lightsteelblue: ab, powderblue: bb, firebrick: cb, darkgoldenrod: db, mediumorchid: eb, rosybrown: fb, darkkhaki: gb, silver: hb, mediumvioletred: ib, indianred: jb, peru: kb, chocolate: lb, tan: mb, lightgray: nb, lightgrey: ob, thistle: pb, goldenrod: qb, orchid: rb, palevioletred: sb, crimson: tb, gainsboro: ub, plum: vb, burlywood: wb, lightcyan: xb, lavender: yb, darksalmon: zb, palegoldenrod: Ab, violet: Bb, azure: Cb, honeydew: Db, khaki: Eb, lightcoral: Fb, sandybrown: Gb, beige: Hb, mintcream: Ib, wheat: Jb, whitesmoke: Kb, ghostwhite: Lb, lightgoldenrodyellow: Mb, linen: Nb, salmon: Ob, oldlace: Pb, bisque: Qb, blanchedalmond: Rb, coral: Sb, cornsilk: Tb, darkorange: Ub, deeppink: Vb, floralwhite: Wb, fuchsia: Xb, gold: Yb, hotpink: Zb, ivory: $b, lavenderblush: _b, lemonchiffon: ac, lightpink: bc, lightsalmon: cc, lightyellow: dc, magenta: ec, mistyrose: fc, moccasin: gc, navajowhite: hc, orange: ic, orangered: jc, papayawhip: kc, peachpuff: lc, pink: mc, red: nc, seashell: oc, snow: pc, tomato: qc, white: rc, yellow: sc, rebeccapurple: tc, default: { aqua: I, aliceblue: J, antiquewhite: K, black: L, blue: M, cyan: N, darkblue: O, darkcyan: P, darkgreen: Q, darkturquoise: R, deepskyblue: S, green: T, lime: U, mediumblue: V, mediumspringgreen: W, navy: X, springgreen: Y, teal: Z, midnightblue: $, dodgerblue: _, lightseagreen: aa, forestgreen: ba, seagreen: ca, darkslategray: da, darkslategrey: ea, limegreen: fa, mediumseagreen: ga, turquoise: ha, royalblue: ia, steelblue: ja, darkslateblue: ka, mediumturquoise: la, indigo: ma, darkolivegreen: na, cadetblue: oa, cornflowerblue: pa, mediumaquamarine: qa, dimgray: ra, dimgrey: sa, slateblue: ta, olivedrab: ua, slategray: va, slategrey: wa, lightslategray: xa, lightslategrey: ya, mediumslateblue: za, lawngreen: Aa, aquamarine: Ba, chartreuse: Ca, gray: Da, grey: Ea, maroon: Fa, olive: Ga, purple: Ha, lightskyblue: Ia, skyblue: Ja, blueviolet: Ka, darkmagenta: La, darkred: Ma, saddlebrown: Na, darkseagreen: Oa, lightgreen: Pa, mediumpurple: Qa, darkviolet: Ra, palegreen: Sa, darkorchid: Ta, yellowgreen: Ua, sienna: Va, brown: Wa, darkgray: Xa, darkgrey: Ya, greenyellow: Za, lightblue: $a, paleturquoise: _a, lightsteelblue: ab, powderblue: bb, firebrick: cb, darkgoldenrod: db, mediumorchid: eb, rosybrown: fb, darkkhaki: gb, silver: hb, mediumvioletred: ib, indianred: jb, peru: kb, chocolate: lb, tan: mb, lightgray: nb, lightgrey: ob, thistle: pb, goldenrod: qb, orchid: rb, palevioletred: sb, crimson: tb, gainsboro: ub, plum: vb, burlywood: wb, lightcyan: xb, lavender: yb, darksalmon: zb, palegoldenrod: Ab, violet: Bb, azure: Cb, honeydew: Db, khaki: Eb, lightcoral: Fb, sandybrown: Gb, beige: Hb, mintcream: Ib, wheat: Jb, whitesmoke: Kb, ghostwhite: Lb, lightgoldenrodyellow: Mb, linen: Nb, salmon: Ob, oldlace: Pb, bisque: Qb, blanchedalmond: Rb, coral: Sb, cornsilk: Tb, darkorange: Ub, deeppink: Vb, floralwhite: Wb, fuchsia: Xb, gold: Yb, hotpink: Zb, ivory: $b, lavenderblush: _b, lemonchiffon: ac, lightpink: bc, lightsalmon: cc, lightyellow: dc, magenta: ec, mistyrose: fc, moccasin: gc, navajowhite: hc, orange: ic, orangered: jc, papayawhip: kc, peachpuff: lc, pink: mc, red: nc, seashell: oc, snow: pc, tomato: qc, white: rc, yellow: sc, rebeccapurple: tc } }),
		    vc = d(uc),
		    wc = function wc() {
			return Object.keys(vc);
		},
		    xc = function xc(a) {
			if ("string" != typeof a) throw new TypeError("is-named-css-color expects a string");var b = new RegExp("^" + wc().join("|") + "$", "i");return b.test(a);
		},
		    yc = "#f0f8ff",
		    zc = "#faebd7",
		    Ac = "#00ffff",
		    Bc = "#7fffd4",
		    Cc = "#f0ffff",
		    Dc = "#f5f5dc",
		    Ec = "#ffe4c4",
		    Fc = "#000000",
		    Gc = "#ffebcd",
		    Hc = "#0000ff",
		    Ic = "#8a2be2",
		    Jc = "#a52a2a",
		    Kc = "#deb887",
		    Lc = "#5f9ea0",
		    Mc = "#7fff00",
		    Nc = "#d2691e",
		    Oc = "#ff7f50",
		    Pc = "#6495ed",
		    Qc = "#fff8dc",
		    Rc = "#dc143c",
		    Sc = "#00ffff",
		    Tc = "#00008b",
		    Uc = "#008b8b",
		    Vc = "#b8860b",
		    Wc = "#a9a9a9",
		    Xc = "#006400",
		    Yc = "#a9a9a9",
		    Zc = "#bdb76b",
		    $c = "#8b008b",
		    _c = "#556b2f",
		    ad = "#ff8c00",
		    bd = "#9932cc",
		    cd = "#8b0000",
		    dd = "#e9967a",
		    ed = "#8fbc8f",
		    fd = "#483d8b",
		    gd = "#2f4f4f",
		    hd = "#2f4f4f",
		    id = "#00ced1",
		    jd = "#9400d3",
		    kd = "#ff1493",
		    ld = "#00bfff",
		    md = "#696969",
		    nd = "#696969",
		    od = "#1e90ff",
		    pd = "#b22222",
		    qd = "#fffaf0",
		    rd = "#228b22",
		    sd = "#ff00ff",
		    td = "#dcdcdc",
		    ud = "#f8f8ff",
		    vd = "#ffd700",
		    wd = "#daa520",
		    xd = "#808080",
		    yd = "#008000",
		    zd = "#adff2f",
		    Ad = "#808080",
		    Bd = "#f0fff0",
		    Cd = "#ff69b4",
		    Dd = "#cd5c5c",
		    Ed = "#4b0082",
		    Fd = "#fffff0",
		    Gd = "#f0e68c",
		    Hd = "#e6e6fa",
		    Id = "#fff0f5",
		    Jd = "#7cfc00",
		    Kd = "#fffacd",
		    Ld = "#add8e6",
		    Md = "#f08080",
		    Nd = "#e0ffff",
		    Od = "#fafad2",
		    Pd = "#d3d3d3",
		    Qd = "#90ee90",
		    Rd = "#d3d3d3",
		    Sd = "#ffb6c1",
		    Td = "#ffa07a",
		    Ud = "#20b2aa",
		    Vd = "#87cefa",
		    Wd = "#778899",
		    Xd = "#778899",
		    Yd = "#b0c4de",
		    Zd = "#ffffe0",
		    $d = "#00ff00",
		    _d = "#32cd32",
		    ae = "#faf0e6",
		    be = "#ff00ff",
		    ce = "#800000",
		    de = "#66cdaa",
		    ee = "#0000cd",
		    fe = "#ba55d3",
		    ge = "#9370db",
		    he = "#3cb371",
		    ie = "#7b68ee",
		    je = "#00fa9a",
		    ke = "#48d1cc",
		    le = "#c71585",
		    me = "#191970",
		    ne = "#f5fffa",
		    oe = "#ffe4e1",
		    pe = "#ffe4b5",
		    qe = "#ffdead",
		    re = "#000080",
		    se = "#fdf5e6",
		    te = "#808000",
		    ue = "#6b8e23",
		    ve = "#ffa500",
		    we = "#ff4500",
		    xe = "#da70d6",
		    ye = "#eee8aa",
		    ze = "#98fb98",
		    Ae = "#afeeee",
		    Be = "#db7093",
		    Ce = "#ffefd5",
		    De = "#ffdab9",
		    Ee = "#cd853f",
		    Fe = "#ffc0cb",
		    Ge = "#dda0dd",
		    He = "#b0e0e6",
		    Ie = "#800080",
		    Je = "#663399",
		    Ke = "#ff0000",
		    Le = "#bc8f8f",
		    Me = "#4169e1",
		    Ne = "#8b4513",
		    Oe = "#fa8072",
		    Pe = "#f4a460",
		    Qe = "#2e8b57",
		    Re = "#fff5ee",
		    Se = "#a0522d",
		    Te = "#c0c0c0",
		    Ue = "#87ceeb",
		    Ve = "#6a5acd",
		    We = "#708090",
		    Xe = "#708090",
		    Ye = "#fffafa",
		    Ze = "#00ff7f",
		    $e = "#4682b4",
		    _e = "#d2b48c",
		    af = "#008080",
		    bf = "#d8bfd8",
		    cf = "#ff6347",
		    df = "#40e0d0",
		    ef = "#ee82ee",
		    ff = "#f5deb3",
		    gf = "#ffffff",
		    hf = "#f5f5f5",
		    jf = "#ffff00",
		    kf = "#9acd32",
		    lf = /*#__PURE__*/Object.freeze({ aliceblue: yc, antiquewhite: zc, aqua: Ac, aquamarine: Bc, azure: Cc, beige: Dc, bisque: Ec, black: Fc, blanchedalmond: Gc, blue: Hc, blueviolet: Ic, brown: Jc, burlywood: Kc, cadetblue: Lc, chartreuse: Mc, chocolate: Nc, coral: Oc, cornflowerblue: Pc, cornsilk: Qc, crimson: Rc, cyan: Sc, darkblue: Tc, darkcyan: Uc, darkgoldenrod: Vc, darkgray: Wc, darkgreen: Xc, darkgrey: Yc, darkkhaki: Zc, darkmagenta: $c, darkolivegreen: _c, darkorange: ad, darkorchid: bd, darkred: cd, darksalmon: dd, darkseagreen: ed, darkslateblue: fd, darkslategray: gd, darkslategrey: hd, darkturquoise: id, darkviolet: jd, deeppink: kd, deepskyblue: ld, dimgray: md, dimgrey: nd, dodgerblue: od, firebrick: pd, floralwhite: qd, forestgreen: rd, fuchsia: sd, gainsboro: td, ghostwhite: ud, gold: vd, goldenrod: wd, gray: xd, green: yd, greenyellow: zd, grey: Ad, honeydew: Bd, hotpink: Cd, indianred: Dd, indigo: Ed, ivory: Fd, khaki: Gd, lavender: Hd, lavenderblush: Id, lawngreen: Jd, lemonchiffon: Kd, lightblue: Ld, lightcoral: Md, lightcyan: Nd, lightgoldenrodyellow: Od, lightgray: Pd, lightgreen: Qd, lightgrey: Rd, lightpink: Sd, lightsalmon: Td, lightseagreen: Ud, lightskyblue: Vd, lightslategray: Wd, lightslategrey: Xd, lightsteelblue: Yd, lightyellow: Zd, lime: $d, limegreen: _d, linen: ae, magenta: be, maroon: ce, mediumaquamarine: de, mediumblue: ee, mediumorchid: fe, mediumpurple: ge, mediumseagreen: he, mediumslateblue: ie, mediumspringgreen: je, mediumturquoise: ke, mediumvioletred: le, midnightblue: me, mintcream: ne, mistyrose: oe, moccasin: pe, navajowhite: qe, navy: re, oldlace: se, olive: te, olivedrab: ue, orange: ve, orangered: we, orchid: xe, palegoldenrod: ye, palegreen: ze, paleturquoise: Ae, palevioletred: Be, papayawhip: Ce, peachpuff: De, peru: Ee, pink: Fe, plum: Ge, powderblue: He, purple: Ie, rebeccapurple: Je, red: Ke, rosybrown: Le, royalblue: Me, saddlebrown: Ne, salmon: Oe, sandybrown: Pe, seagreen: Qe, seashell: Re, sienna: Se, silver: Te, skyblue: Ue, slateblue: Ve, slategray: We, slategrey: Xe, snow: Ye, springgreen: Ze, steelblue: $e, tan: _e, teal: af, thistle: bf, tomato: cf, turquoise: df, violet: ef, wheat: ff, white: gf, whitesmoke: hf, yellow: jf, yellowgreen: kf, default: { aliceblue: yc, antiquewhite: zc, aqua: Ac, aquamarine: Bc, azure: Cc, beige: Dc, bisque: Ec, black: Fc, blanchedalmond: Gc, blue: Hc, blueviolet: Ic, brown: Jc, burlywood: Kc, cadetblue: Lc, chartreuse: Mc, chocolate: Nc, coral: Oc, cornflowerblue: Pc, cornsilk: Qc, crimson: Rc, cyan: Sc, darkblue: Tc, darkcyan: Uc, darkgoldenrod: Vc, darkgray: Wc, darkgreen: Xc, darkgrey: Yc, darkkhaki: Zc, darkmagenta: $c, darkolivegreen: _c, darkorange: ad, darkorchid: bd, darkred: cd, darksalmon: dd, darkseagreen: ed, darkslateblue: fd, darkslategray: gd, darkslategrey: hd, darkturquoise: id, darkviolet: jd, deeppink: kd, deepskyblue: ld, dimgray: md, dimgrey: nd, dodgerblue: od, firebrick: pd, floralwhite: qd, forestgreen: rd, fuchsia: sd, gainsboro: td, ghostwhite: ud, gold: vd, goldenrod: wd, gray: xd, green: yd, greenyellow: zd, grey: Ad, honeydew: Bd, hotpink: Cd, indianred: Dd, indigo: Ed, ivory: Fd, khaki: Gd, lavender: Hd, lavenderblush: Id, lawngreen: Jd, lemonchiffon: Kd, lightblue: Ld, lightcoral: Md, lightcyan: Nd, lightgoldenrodyellow: Od, lightgray: Pd, lightgreen: Qd, lightgrey: Rd, lightpink: Sd, lightsalmon: Td, lightseagreen: Ud, lightskyblue: Vd, lightslategray: Wd, lightslategrey: Xd, lightsteelblue: Yd, lightyellow: Zd, lime: $d, limegreen: _d, linen: ae, magenta: be, maroon: ce, mediumaquamarine: de, mediumblue: ee, mediumorchid: fe, mediumpurple: ge, mediumseagreen: he, mediumslateblue: ie, mediumspringgreen: je, mediumturquoise: ke, mediumvioletred: le, midnightblue: me, mintcream: ne, mistyrose: oe, moccasin: pe, navajowhite: qe, navy: re, oldlace: se, olive: te, olivedrab: ue, orange: ve, orangered: we, orchid: xe, palegoldenrod: ye, palegreen: ze, paleturquoise: Ae, palevioletred: Be, papayawhip: Ce, peachpuff: De, peru: Ee, pink: Fe, plum: Ge, powderblue: He, purple: Ie, rebeccapurple: Je, red: Ke, rosybrown: Le, royalblue: Me, saddlebrown: Ne, salmon: Oe, sandybrown: Pe, seagreen: Qe, seashell: Re, sienna: Se, silver: Te, skyblue: Ue, slateblue: Ve, slategray: We, slategrey: Xe, snow: Ye, springgreen: Ze, steelblue: $e, tan: _e, teal: af, thistle: bf, tomato: cf, turquoise: df, violet: ef, wheat: ff, white: gf, whitesmoke: hf, yellow: jf, yellowgreen: kf } }),
		    mf = d(lf),
		    nf = { ratio: i, score: function score(a, b, c) {
				var d = D.score(i(a, b, c));return H(d) ? "F" : d;
			}, isAccessible: function isAccessible(a, b, c) {
				return 4.5 < i(a, b, c);
			}, isNotTransparent: k },
		    of = b(function (a, b) {
			Object.defineProperty(b, "__esModule", { value: !0 });var c = function (a) {
				return a && a.__esModule ? a : { default: a };
			}(nf),
			    d = function d(a, b) {
				for (var d = 6, e = c.default.isAccessible(a[d], b); !e;) {
					d++, void 0 === a[d] ? (console.warn("Shades #6 and higher in the color palette do not have a high enough contrast ratio against a background color of " + b + "."), e = !0) : e = c.default.isAccessible(a[d], b);
				}return l(d, Object.keys(a).length - 1);
			};b.default = function c(a, b) {
				return { get name() {
						return b;
					}, getShade: function getShade(b) {
						return a[b];
					}, getMainShade: function getMainShade() {
						var b,
						    c = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {},
						    e = c.backgroundColor,
						    f = void 0 === e ? "#ffffff" : e,
						    g = c.offset,
						    h = void 0 === g ? 0 : g;return b = "#ffffff" === f ? (a.inflection || d(a, f)) + h : d(a, f) + h, a[l(b, Object.keys(a).length - 1)];
					} };
			};
		}),
		    pf = a(of),
		    qf = b(function (a, b) {
			Object.defineProperty(b, "__esModule", { value: !0 });var c = function (a) {
				return a && a.__esModule ? a : { default: a };
			}(of);b.default = (0, c.default)({ 1: "#eef7ff", 2: "#deedfd", 3: "#bddbf4", 4: "#84baeb", 5: "#3b8fde", 6: "#1176d4", 7: "#0d66b8", 8: "#09549c", 9: "#0a4276", 10: "#072d52", inflection: 6 }, "blue");
		}); // # Relative luminance
		//
		// http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
		// https://en.wikipedia.org/wiki/Luminance_(relative)
		// https://en.wikipedia.org/wiki/Luminosity_function
		// https://en.wikipedia.org/wiki/Rec._709#Luma_coefficients
		// red, green, and blue coefficients
		a(qf);var rf = b(function (a, b) {
			Object.defineProperty(b, "__esModule", { value: !0 });var c = function (a) {
				return a && a.__esModule ? a : { default: a };
			}(of);b.default = (0, c.default)({ 1: "#fef3f1", 2: "#fac3bb", 3: "#faa094", 4: "#fa7d6d", 5: "#eb4f3b", 6: "#d24634", 7: "#b83e2e", 8: "#9e3528", 9: "#7a291f", 10: "#571d16", inflection: 6 }, "brick");
		});a(rf);var sf = b(function (a, b) {
			Object.defineProperty(b, "__esModule", { value: !0 });var c = function (a) {
				return a && a.__esModule ? a : { default: a };
			}(of);b.default = (0, c.default)({ 1: "#fef3e9", 2: "#fec491", 3: "#fead64", 4: "#f58525", 5: "#e06107", 6: "#ca500f", 7: "#b0430c", 8: "#983600", 9: "#772700", 10: "#571d00", inflection: 6 }, "cheddar");
		});a(sf);var tf = b(function (a, b) {
			Object.defineProperty(b, "__esModule", { value: !0 });var c = function (a) {
				return a && a.__esModule ? a : { default: a };
			}(of);b.default = (0, c.default)({ 1: "#f54250", 2: "#cc313d" }, "cherry");
		});a(tf);var uf = b(function (a, b) {
			Object.defineProperty(b, "__esModule", { value: !0 });var c = function (a) {
				return a && a.__esModule ? a : { default: a };
			}(of);b.default = (0, c.default)({ 1: "#fafafa", 2: "#f6f6f6", 3: "#ececec", 4: "#dadada", 5: "#949494", 6: "#757575", 7: "#646464", 8: "#525252", 9: "#3c3c3c", 10: "#1c1c1c", inflection: 6 }, "cloud");
		});a(uf);var vf = b(function (a, b) {
			Object.defineProperty(b, "__esModule", { value: !0 });var c = function (a) {
				return a && a.__esModule ? a : { default: a };
			}(of);b.default = (0, c.default)({ 1: "#f8f5fa", 2: "#ddcbe9", 3: "#c4a4d9", 4: "#b389d0", 5: "#a775c9", 6: "#945eb9", 7: "#794d96", 8: "#5e3c75", 9: "#3f284f", 10: "#2d1c38", inflection: 6 }, "eggplant");
		});a(vf);var wf = b(function (a, b) {
			Object.defineProperty(b, "__esModule", { value: !0 });var c = function (a) {
				return a && a.__esModule ? a : { default: a };
			}(of);b.default = (0, c.default)({ 1: "#fff5dd", 2: "#ffe29c", 3: "#ffd560", 4: "#e8b520", 5: "#be8a0d", 6: "#9a6f07", 7: "#855f07", 8: "#715005", 9: "#5a4206", 10: "#3b2b04", inflection: 6 }, "gold");
		});a(wf);var xf = b(function (a, b) {
			Object.defineProperty(b, "__esModule", { value: !0 });var c = function (a) {
				return a && a.__esModule ? a : { default: a };
			}(of);b.default = (0, c.default)({ 1: "#21a921", 2: "#0a870a" }, "grass");
		});a(xf);var yf = b(function (a, b) {
			Object.defineProperty(b, "__esModule", { value: !0 });var c = function (a) {
				return a && a.__esModule ? a : { default: a };
			}(of);b.default = (0, c.default)({ 1: "#edf7ed", 2: "#d1ead1", 3: "#a3d4a3", 4: "#79c679", 5: "#35a335", 6: "#048a04", 7: "#047103", 8: "#015e02", 9: "#024d03", 10: "#023302", inflection: 6 }, "green");
		});a(yf);var zf = b(function (a, b) {
			Object.defineProperty(b, "__esModule", { value: !0 });var c = function (a) {
				return a && a.__esModule ? a : { default: a };
			}(of);b.default = (0, c.default)({ 1: "#e8f7f2", 2: "#c0eadb", 3: "#86e0c2", 4: "#24c991", 5: "#1a9c6e", 6: "#16825c", 7: "#12694a", 8: "#0d4f38", 9: "#0a3c2b", 10: "#07291d", inflection: 6 }, "jungle");
		});a(zf);var Af = b(function (a, b) {
			Object.defineProperty(b, "__esModule", { value: !0 });var c = function (a) {
				return a && a.__esModule ? a : { default: a };
			}(of);b.default = (0, c.default)({ 1: "#f2f4f9", 2: "#d2d9ed", 3: "#b2bee0", 4: "#91a3d4", 5: "#7188c7", 6: "#5773bf", 7: "#425ba1", 8: "#334a88", 9: "#24386e", 10: "#002244", inflection: 6 }, "magic");
		});a(Af);var Bf = b(function (a, b) {
			Object.defineProperty(b, "__esModule", { value: !0 });var c = function (a) {
				return a && a.__esModule ? a : { default: a };
			}(of);b.default = (0, c.default)({ 1: "#ebf9fc", 2: "#c9e5ea", 3: "#acd5dd", 4: "#6eadba", 5: "#5f96a1", 6: "#4f7e87", 7: "#41666e", 8: "#324e54", 9: "#273e42", 10: "#1d2d30", inflection: 6 }, "mist");
		});a(Bf);var Cf = b(function (a, b) {
			Object.defineProperty(b, "__esModule", { value: !0 });var c = function (a) {
				return a && a.__esModule ? a : { default: a };
			}(of);b.default = (0, c.default)({ 9: "#40404c", 10: "#2f2f39", 11: "#1b1b26" }, "ninja");
		});a(Cf);var Df = b(function (a, b) {
			Object.defineProperty(b, "__esModule", { value: !0 });var c = function (a) {
				return a && a.__esModule ? a : { default: a };
			}(of);b.default = (0, c.default)({ 1: "#eaf7fc", 2: "#b0e3f4", 3: "#75cfec", 4: "#00a7db", 5: "#0093c4", 6: "#007fad", 7: "#006c94", 8: "#005a75", 9: "#00465c", 10: "#003342", inflection: 6 }, "ocean");
		});a(Df);var Ef = b(function (a, b) {
			Object.defineProperty(b, "__esModule", { value: !0 });var c = function (a) {
				return a && a.__esModule ? a : { default: a };
			}(of);b.default = (0, c.default)({ 1: "#fff3e3", 2: "#ffd69b", 3: "#ffb55f", 4: "#ff943b", 5: "#e65f14", 6: "#d04a00", 7: "#b54102", 8: "#983702", 9: "#7a2d00", 10: "#541f00", inflection: 6 }, "orange");
		});a(Ef);var Ff = b(function (a, b) {
			Object.defineProperty(b, "__esModule", { value: !0 });var c = function (a) {
				return a && a.__esModule ? a : { default: a };
			}(of);b.default = (0, c.default)({ 1: "#f4f6ea", 2: "#e0eab8", 3: "#ccde87", 4: "#a3c523", 5: "#7e9e06", 6: "#637d05", 7: "#536904", 8: "#415203", 9: "#303d02", 10: "#202902", inflection: 6 }, "pickle");
		});a(Ff);var Gf = b(function (a, b) {
			Object.defineProperty(b, "__esModule", { value: !0 });var c = function (a) {
				return a && a.__esModule ? a : { default: a };
			}(of);b.default = (0, c.default)({ 1: "#f7f5ff", 2: "#e3dbff", 3: "#ccbdfe", 4: "#bca9fa", 5: "#9375f2", 6: "#8956f0", 7: "#683ac8", 8: "#532ca6", 9: "#3f1c86", 10: "#2a1359", inflection: 6 }, "purple");
		});a(Gf);var Hf = b(function (a, b) {
			Object.defineProperty(b, "__esModule", { value: !0 });var c = function (a) {
				return a && a.__esModule ? a : { default: a };
			}(of);b.default = (0, c.default)({ 1: "#fff2f4", 2: "#ffe1e6", 3: "#fabcc5", 4: "#f78394", 5: "#ed596f", 6: "#e71d3a", 7: "#d21c35", 8: "#a9172c", 9: "#7e1021", 10: "#5c0c18", inflection: 6 }, "red");
		});a(Hf);var If = b(function (a, b) {
			Object.defineProperty(b, "__esModule", { value: !0 });var c = function (a) {
				return a && a.__esModule ? a : { default: a };
			}(of);b.default = (0, c.default)({ 1: "#fdf2f5", 2: "#fbcada", 3: "#f8a2bf", 4: "#f57aa3", 5: "#ed3e79", 6: "#d81e5d", 7: "#bf1b52", 8: "#a61747", 9: "#8c143c", 10: "#610e29", inflection: 6 }, "sangria");
		});a(If);var Jf = b(function (a, b) {
			Object.defineProperty(b, "__esModule", { value: !0 });var c = function (a) {
				return a && a.__esModule ? a : { default: a };
			}(of);b.default = (0, c.default)({ 1: "#fafafa", 2: "#f6f6f6", 3: "#ececec", 4: "#dadada", 5: "#949494", 6: "#757575", 7: "#646464", 8: "#525252", 9: "#3c3c3c", 10: "#1c1c1c", inflection: 6 }, "silver");
		});a(Jf);var Kf = b(function (a, b) {
			function c(a) {
				return a && a.__esModule ? a : { default: a };
			}Object.defineProperty(b, "__esModule", { value: !0 }), Object.defineProperty(b, "blue", { enumerable: !0, get: function get() {
					return c(qf).default;
				} }), Object.defineProperty(b, "brick", { enumerable: !0, get: function get() {
					return c(rf).default;
				} }), Object.defineProperty(b, "cheddar", { enumerable: !0, get: function get() {
					return c(sf).default;
				} }), Object.defineProperty(b, "cherry", { enumerable: !0, get: function get() {
					return c(tf).default;
				} }), Object.defineProperty(b, "cloud", { enumerable: !0, get: function get() {
					return c(uf).default;
				} }), Object.defineProperty(b, "eggplant", { enumerable: !0, get: function get() {
					return c(vf).default;
				} }), Object.defineProperty(b, "gold", { enumerable: !0, get: function get() {
					return c(wf).default;
				} }), Object.defineProperty(b, "grass", { enumerable: !0, get: function get() {
					return c(xf).default;
				} }), Object.defineProperty(b, "green", { enumerable: !0, get: function get() {
					return c(yf).default;
				} }), Object.defineProperty(b, "jungle", { enumerable: !0, get: function get() {
					return c(zf).default;
				} }), Object.defineProperty(b, "magic", { enumerable: !0, get: function get() {
					return c(Af).default;
				} }), Object.defineProperty(b, "mist", { enumerable: !0, get: function get() {
					return c(Bf).default;
				} }), Object.defineProperty(b, "ninja", { enumerable: !0, get: function get() {
					return c(Cf).default;
				} }), Object.defineProperty(b, "ocean", { enumerable: !0, get: function get() {
					return c(Df).default;
				} }), Object.defineProperty(b, "orange", { enumerable: !0, get: function get() {
					return c(Ef).default;
				} }), Object.defineProperty(b, "pickle", { enumerable: !0, get: function get() {
					return c(Ff).default;
				} }), Object.defineProperty(b, "purple", { enumerable: !0, get: function get() {
					return c(Gf).default;
				} }), Object.defineProperty(b, "red", { enumerable: !0, get: function get() {
					return c(Hf).default;
				} }), Object.defineProperty(b, "sangria", { enumerable: !0, get: function get() {
					return c(If).default;
				} }), Object.defineProperty(b, "silver", { enumerable: !0, get: function get() {
					return c(Jf).default;
				} });
		}),
		    Lf = a(Kf),
		    Mf = pf({ 1: "#fef3e9", 2: "#fedbbd", 3: "#fedbbd", 4: "#fead64", 5: "#ff993f", 6: "#f58525", 7: "#EB7100", 8: "#e06107", 9: "#ca500f", 10: "#b0430c" }, "chegg"),
		    Nf = pf({ 1: "#FAE6E3", 2: "#FAC3BB", 3: "#F36671", 4: "#E64956", 5: "#F75F4B", 6: "#D92F3E", 7: "#DA1B2C", 8: "#B83E2E", 9: "#B31522", 10: "#852D21" }, "macmillan"),
		    Of = pf({ 1: "#F7F5FF", 2: "#DED6FF", 3: "#C2B4FF", 4: "#A793FF", 5: "#866BFF", 6: "#6840F7", 7: "#461DD9", 8: "#2D04BF", 9: "#290B97", 10: "#1C056F" }, "jrPurple"),
		    Pf = _objectSpread({}, Lf, { chegg: Mf, macmillan: Nf, jrPurple: Of }),
		    Qf = function Qf(a, b) {
			var c = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : "prod",
			    d = "dev" === c ? "chameleon-dev.vitalbook.com" : "chameleon.vitalsource.com",
			    e = "https://".concat(d, "/api/brands/").concat(a, "/").concat(b);return Tf(e, 2500).then(function (d) {
				return 200 === d.status ? d.json() : Rf(a, b, d.json(), c);
			}).catch(function () {
				return Rf(a, b, "BrandError", c);
			});
		},
		    Rf = function Rf(a, b, c) {
			var d = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : "prod",
			    e = "https://storage.googleapis.com/vst-chameleon-".concat(d, "/backups/backup_").concat(a, "_").concat(b, ".json");return fetch(e).then(function (a) {
				return 200 === a.status ? a.json() : c;
			}).catch(function () {
				return c;
			});
		},
		    Sf = function Sf(a) {
			// This is necessary to prevent loading brands from external unexpected sources
			// When using the brand param
			// EX: brand=../../evils3bucket/myEvilBrand.json will load an evil brand
			// REGEX built with characters from https://www.owasp.org/index.php/XSS_(Cross_Site_Scripting)_Prevention_Cheat_Sheet
			return a.replace(/\.\.|[\\&<>"'/]/gi, "");
		},
		    Tf = function Tf(a, b) {
			return new Promise(function (c, d) {
				var e = !1,
				    f = setTimeout(function () {
					e = !0, d(new Error("Request timed out"));
				}, b);fetch(a).then(function (a) {
					clearTimeout(f), e || c(a);
				}).catch(function (a) {
					e || d(a);
				});
			});
		};module.exports = { loadBrand: function e(a, b) {
				var c = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : "prod",
				    d = Sf(a); // First try Chameleon
				return new Promise(function (a) {
					Qf(d, b, c).then(function (b) {
						a(b.data || b);
					}).catch(function (a) {
						return console.log(a);
					});
				});
			}, colors: Pf };
	});

/***/ },
/* 524 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(534);
	module.exports = __webpack_require__(48).RegExp.escape;

/***/ },
/* 525 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var isObject = __webpack_require__(14);
	var isArray = __webpack_require__(108);
	var SPECIES = __webpack_require__(17)('species');
	
	module.exports = function (original) {
	  var C;
	  if (isArray(original)) {
	    C = original.constructor;
	    // cross-realm fallback
	    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
	    if (isObject(C)) {
	      C = C[SPECIES];
	      if (C === null) C = undefined;
	    }
	  }return C === undefined ? Array : C;
	};

/***/ },
/* 526 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	
	var fails = __webpack_require__(10);
	var getTime = Date.prototype.getTime;
	var $toISOString = Date.prototype.toISOString;
	
	var lz = function lz(num) {
	  return num > 9 ? num : '0' + num;
	};
	
	// PhantomJS / old WebKit has a broken implementations
	module.exports = fails(function () {
	  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
	}) || !fails(function () {
	  $toISOString.call(new Date(NaN));
	}) ? function toISOString() {
	  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
	  var d = this;
	  var y = d.getUTCFullYear();
	  var m = d.getUTCMilliseconds();
	  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
	  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) + '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) + 'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) + ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
	} : $toISOString;

/***/ },
/* 527 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var anObject = __webpack_require__(7);
	var toPrimitive = __webpack_require__(52);
	var NUMBER = 'number';
	
	module.exports = function (hint) {
	  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
	  return toPrimitive(anObject(this), hint != NUMBER);
	};

/***/ },
/* 528 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(62);
	var gOPS = __webpack_require__(112);
	var pIE = __webpack_require__(92);
	module.exports = function (it) {
	  var result = getKeys(it);
	  var getSymbols = gOPS.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = pIE.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) {
	      if (isEnum.call(it, key = symbols[i++])) result.push(key);
	    }
	  }return result;
	};

/***/ },
/* 529 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var getKeys = __webpack_require__(62);
	var toIObject = __webpack_require__(37);
	module.exports = function (object, el) {
	  var O = toIObject(object);
	  var keys = getKeys(O);
	  var length = keys.length;
	  var index = 0;
	  var key;
	  while (length > index) {
	    if (O[key = keys[index++]] === el) return key;
	  }
	};

/***/ },
/* 530 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var path = __webpack_require__(531);
	var invoke = __webpack_require__(107);
	var aFunction = __webpack_require__(27);
	module.exports = function () /* ...pargs */{
	  var fn = aFunction(this);
	  var length = arguments.length;
	  var pargs = Array(length);
	  var i = 0;
	  var _ = path._;
	  var holder = false;
	  while (length > i) {
	    if ((pargs[i] = arguments[i++]) === _) holder = true;
	  }return function () /* ...args */{
	    var that = this;
	    var aLen = arguments.length;
	    var j = 0;
	    var k = 0;
	    var args;
	    if (!holder && !aLen) return invoke(fn, pargs, that);
	    args = pargs.slice();
	    if (holder) for (; length > j; j++) {
	      if (args[j] === _) args[j] = arguments[k++];
	    }while (aLen > k) {
	      args.push(arguments[k++]);
	    }return invoke(fn, args, that);
	  };
	};

/***/ },
/* 531 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(8);

/***/ },
/* 532 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = function (regExp, replace) {
	  var replacer = replace === Object(replace) ? function (part) {
	    return replace[part];
	  } : replace;
	  return function (it) {
	    return String(it).replace(regExp, replacer);
	  };
	};

/***/ },
/* 533 */
/***/ function(module, exports) {

	"use strict";
	
	// 7.2.9 SameValue(x, y)
	module.exports = Object.is || function is(x, y) {
	  // eslint-disable-next-line no-self-compare
	  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
	};

/***/ },
/* 534 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// https://github.com/benjamingr/RexExp.escape
	var $export = __webpack_require__(2);
	var $re = __webpack_require__(532)(/[\\^$*+?.()|[\]{}]/g, '\\$&');
	
	$export($export.S, 'RegExp', { escape: function escape(it) {
	    return $re(it);
	  } });

/***/ },
/* 535 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	var $export = __webpack_require__(2);
	
	$export($export.P, 'Array', { copyWithin: __webpack_require__(201) });
	
	__webpack_require__(60)('copyWithin');

/***/ },
/* 536 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var $export = __webpack_require__(2);
	var $every = __webpack_require__(47)(4);
	
	$export($export.P + $export.F * !__webpack_require__(45)([].every, true), 'Array', {
	  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
	  every: function every(callbackfn /* , thisArg */) {
	    return $every(this, callbackfn, arguments[1]);
	  }
	});

/***/ },
/* 537 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	var $export = __webpack_require__(2);
	
	$export($export.P, 'Array', { fill: __webpack_require__(131) });
	
	__webpack_require__(60)('fill');

/***/ },
/* 538 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var $export = __webpack_require__(2);
	var $filter = __webpack_require__(47)(2);
	
	$export($export.P + $export.F * !__webpack_require__(45)([].filter, true), 'Array', {
	  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
	  filter: function filter(callbackfn /* , thisArg */) {
	    return $filter(this, callbackfn, arguments[1]);
	  }
	});

/***/ },
/* 539 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
	
	var $export = __webpack_require__(2);
	var $find = __webpack_require__(47)(6);
	var KEY = 'findIndex';
	var forced = true;
	// Shouldn't skip holes
	if (KEY in []) Array(1)[KEY](function () {
	  forced = false;
	});
	$export($export.P + $export.F * forced, 'Array', {
	  findIndex: function findIndex(callbackfn /* , that = undefined */) {
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(60)(KEY);

/***/ },
/* 540 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
	
	var $export = __webpack_require__(2);
	var $find = __webpack_require__(47)(5);
	var KEY = 'find';
	var forced = true;
	// Shouldn't skip holes
	if (KEY in []) Array(1)[KEY](function () {
	  forced = false;
	});
	$export($export.P + $export.F * forced, 'Array', {
	  find: function find(callbackfn /* , that = undefined */) {
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(60)(KEY);

/***/ },
/* 541 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var $export = __webpack_require__(2);
	var $forEach = __webpack_require__(47)(0);
	var STRICT = __webpack_require__(45)([].forEach, true);
	
	$export($export.P + $export.F * !STRICT, 'Array', {
	  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
	  forEach: function forEach(callbackfn /* , thisArg */) {
	    return $forEach(this, callbackfn, arguments[1]);
	  }
	});

/***/ },
/* 542 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var ctx = __webpack_require__(44);
	var $export = __webpack_require__(2);
	var toObject = __webpack_require__(24);
	var call = __webpack_require__(211);
	var isArrayIter = __webpack_require__(139);
	var toLength = __webpack_require__(22);
	var createProperty = __webpack_require__(133);
	var getIterFn = __webpack_require__(155);
	
	$export($export.S + $export.F * !__webpack_require__(110)(function (iter) {
	  Array.from(iter);
	}), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
	    var O = toObject(arrayLike);
	    var C = typeof this == 'function' ? this : Array;
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var index = 0;
	    var iterFn = getIterFn(O);
	    var length, result, step, iterator;
	    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
	      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for (result = new C(length); length > index; index++) {
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});

/***/ },
/* 543 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var $export = __webpack_require__(2);
	var $indexOf = __webpack_require__(103)(false);
	var $native = [].indexOf;
	var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(45)($native)), 'Array', {
	  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
	  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
	    return NEGATIVE_ZERO
	    // convert -0 to +0
	    ? $native.apply(this, arguments) || 0 : $indexOf(this, searchElement, arguments[1]);
	  }
	});

/***/ },
/* 544 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Array', { isArray: __webpack_require__(108) });

/***/ },
/* 545 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.13 Array.prototype.join(separator)
	
	var $export = __webpack_require__(2);
	var toIObject = __webpack_require__(37);
	var arrayJoin = [].join;
	
	// fallback for not array-like strings
	$export($export.P + $export.F * (__webpack_require__(91) != Object || !__webpack_require__(45)(arrayJoin)), 'Array', {
	  join: function join(separator) {
	    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
	  }
	});

/***/ },
/* 546 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var $export = __webpack_require__(2);
	var toIObject = __webpack_require__(37);
	var toInteger = __webpack_require__(51);
	var toLength = __webpack_require__(22);
	var $native = [].lastIndexOf;
	var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(45)($native)), 'Array', {
	  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
	  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
	    // convert -0 to +0
	    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
	    var O = toIObject(this);
	    var length = toLength(O.length);
	    var index = length - 1;
	    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
	    if (index < 0) index = length + index;
	    for (; index >= 0; index--) {
	      if (index in O) if (O[index] === searchElement) return index || 0;
	    }return -1;
	  }
	});

/***/ },
/* 547 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var $export = __webpack_require__(2);
	var $map = __webpack_require__(47)(1);
	
	$export($export.P + $export.F * !__webpack_require__(45)([].map, true), 'Array', {
	  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
	  map: function map(callbackfn /* , thisArg */) {
	    return $map(this, callbackfn, arguments[1]);
	  }
	});

/***/ },
/* 548 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var $export = __webpack_require__(2);
	var createProperty = __webpack_require__(133);
	
	// WebKit Array.of isn't generic
	$export($export.S + $export.F * __webpack_require__(10)(function () {
	  function F() {/* empty */}
	  return !(Array.of.call(F) instanceof F);
	}), 'Array', {
	  // 22.1.2.3 Array.of( ...items)
	  of: function of() /* ...args */{
	    var index = 0;
	    var aLen = arguments.length;
	    var result = new (typeof this == 'function' ? this : Array)(aLen);
	    while (aLen > index) {
	      createProperty(result, index, arguments[index++]);
	    }result.length = aLen;
	    return result;
	  }
	});

/***/ },
/* 549 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var $export = __webpack_require__(2);
	var $reduce = __webpack_require__(203);
	
	$export($export.P + $export.F * !__webpack_require__(45)([].reduceRight, true), 'Array', {
	  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
	  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
	    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
	  }
	});

/***/ },
/* 550 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var $export = __webpack_require__(2);
	var $reduce = __webpack_require__(203);
	
	$export($export.P + $export.F * !__webpack_require__(45)([].reduce, true), 'Array', {
	  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
	  reduce: function reduce(callbackfn /* , initialValue */) {
	    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
	  }
	});

/***/ },
/* 551 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var $export = __webpack_require__(2);
	var html = __webpack_require__(137);
	var cof = __webpack_require__(43);
	var toAbsoluteIndex = __webpack_require__(73);
	var toLength = __webpack_require__(22);
	var arraySlice = [].slice;
	
	// fallback for not array-like ES3 strings and DOM objects
	$export($export.P + $export.F * __webpack_require__(10)(function () {
	  if (html) arraySlice.call(html);
	}), 'Array', {
	  slice: function slice(begin, end) {
	    var len = toLength(this.length);
	    var klass = cof(this);
	    end = end === undefined ? len : end;
	    if (klass == 'Array') return arraySlice.call(this, begin, end);
	    var start = toAbsoluteIndex(begin, len);
	    var upTo = toAbsoluteIndex(end, len);
	    var size = toLength(upTo - start);
	    var cloned = Array(size);
	    var i = 0;
	    for (; i < size; i++) {
	      cloned[i] = klass == 'String' ? this.charAt(start + i) : this[start + i];
	    }return cloned;
	  }
	});

/***/ },
/* 552 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var $export = __webpack_require__(2);
	var $some = __webpack_require__(47)(3);
	
	$export($export.P + $export.F * !__webpack_require__(45)([].some, true), 'Array', {
	  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
	  some: function some(callbackfn /* , thisArg */) {
	    return $some(this, callbackfn, arguments[1]);
	  }
	});

/***/ },
/* 553 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var $export = __webpack_require__(2);
	var aFunction = __webpack_require__(27);
	var toObject = __webpack_require__(24);
	var fails = __webpack_require__(10);
	var $sort = [].sort;
	var test = [1, 2, 3];
	
	$export($export.P + $export.F * (fails(function () {
	  // IE8-
	  test.sort(undefined);
	}) || !fails(function () {
	  // V8 bug
	  test.sort(null);
	  // Old WebKit
	}) || !__webpack_require__(45)($sort)), 'Array', {
	  // 22.1.3.25 Array.prototype.sort(comparefn)
	  sort: function sort(comparefn) {
	    return comparefn === undefined ? $sort.call(toObject(this)) : $sort.call(toObject(this), aFunction(comparefn));
	  }
	});

/***/ },
/* 554 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(72)('Array');

/***/ },
/* 555 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// 20.3.3.1 / 15.9.4.4 Date.now()
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Date', { now: function now() {
	    return new Date().getTime();
	  } });

/***/ },
/* 556 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	var $export = __webpack_require__(2);
	var toISOString = __webpack_require__(526);
	
	// PhantomJS / old WebKit has a broken implementations
	$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
	  toISOString: toISOString
	});

/***/ },
/* 557 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var $export = __webpack_require__(2);
	var toObject = __webpack_require__(24);
	var toPrimitive = __webpack_require__(52);
	
	$export($export.P + $export.F * __webpack_require__(10)(function () {
	  return new Date(NaN).toJSON() !== null || Date.prototype.toJSON.call({ toISOString: function toISOString() {
	      return 1;
	    } }) !== 1;
	}), 'Date', {
	  // eslint-disable-next-line no-unused-vars
	  toJSON: function toJSON(key) {
	    var O = toObject(this);
	    var pv = toPrimitive(O);
	    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
	  }
	});

/***/ },
/* 558 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var TO_PRIMITIVE = __webpack_require__(17)('toPrimitive');
	var proto = Date.prototype;
	
	if (!(TO_PRIMITIVE in proto)) __webpack_require__(34)(proto, TO_PRIMITIVE, __webpack_require__(527));

/***/ },
/* 559 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var DateProto = Date.prototype;
	var INVALID_DATE = 'Invalid Date';
	var TO_STRING = 'toString';
	var $toString = DateProto[TO_STRING];
	var getTime = DateProto.getTime;
	if (new Date(NaN) + '' != INVALID_DATE) {
	  __webpack_require__(35)(DateProto, TO_STRING, function toString() {
	    var value = getTime.call(this);
	    // eslint-disable-next-line no-self-compare
	    return value === value ? $toString.call(this) : INVALID_DATE;
	  });
	}

/***/ },
/* 560 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
	var $export = __webpack_require__(2);
	
	$export($export.P, 'Function', { bind: __webpack_require__(204) });

/***/ },
/* 561 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var isObject = __webpack_require__(14);
	var getPrototypeOf = __webpack_require__(40);
	var HAS_INSTANCE = __webpack_require__(17)('hasInstance');
	var FunctionProto = Function.prototype;
	// 19.2.3.6 Function.prototype[@@hasInstance](V)
	if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(21).f(FunctionProto, HAS_INSTANCE, { value: function value(O) {
	    if (typeof this != 'function' || !isObject(O)) return false;
	    if (!isObject(this.prototype)) return O instanceof this;
	    // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
	    while (O = getPrototypeOf(O)) {
	      if (this.prototype === O) return true;
	    }return false;
	  } });

/***/ },
/* 562 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var dP = __webpack_require__(21).f;
	var FProto = Function.prototype;
	var nameRE = /^\s*function ([^ (]*)/;
	var NAME = 'name';
	
	// 19.2.4.2 name
	NAME in FProto || __webpack_require__(20) && dP(FProto, NAME, {
	  configurable: true,
	  get: function get() {
	    try {
	      return ('' + this).match(nameRE)[1];
	    } catch (e) {
	      return '';
	    }
	  }
	});

/***/ },
/* 563 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// 20.2.2.3 Math.acosh(x)
	var $export = __webpack_require__(2);
	var log1p = __webpack_require__(214);
	var sqrt = Math.sqrt;
	var $acosh = Math.acosh;
	
	$export($export.S + $export.F * !($acosh
	// V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
	&& Math.floor($acosh(Number.MAX_VALUE)) == 710
	// Tor Browser bug: Math.acosh(Infinity) -> NaN
	&& $acosh(Infinity) == Infinity), 'Math', {
	  acosh: function acosh(x) {
	    return (x = +x) < 1 ? NaN : x > 94906265.62425156 ? Math.log(x) + Math.LN2 : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
	  }
	});

/***/ },
/* 564 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// 20.2.2.5 Math.asinh(x)
	var $export = __webpack_require__(2);
	var $asinh = Math.asinh;
	
	function asinh(x) {
	  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
	}
	
	// Tor Browser bug: Math.asinh(0) -> -0
	$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });

/***/ },
/* 565 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// 20.2.2.7 Math.atanh(x)
	var $export = __webpack_require__(2);
	var $atanh = Math.atanh;
	
	// Tor Browser bug: Math.atanh(-0) -> 0
	$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
	  atanh: function atanh(x) {
	    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
	  }
	});

/***/ },
/* 566 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// 20.2.2.9 Math.cbrt(x)
	var $export = __webpack_require__(2);
	var sign = __webpack_require__(143);
	
	$export($export.S, 'Math', {
	  cbrt: function cbrt(x) {
	    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
	  }
	});

/***/ },
/* 567 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// 20.2.2.11 Math.clz32(x)
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', {
	  clz32: function clz32(x) {
	    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
	  }
	});

/***/ },
/* 568 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// 20.2.2.12 Math.cosh(x)
	var $export = __webpack_require__(2);
	var exp = Math.exp;
	
	$export($export.S, 'Math', {
	  cosh: function cosh(x) {
	    return (exp(x = +x) + exp(-x)) / 2;
	  }
	});

/***/ },
/* 569 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// 20.2.2.14 Math.expm1(x)
	var $export = __webpack_require__(2);
	var $expm1 = __webpack_require__(142);
	
	$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });

/***/ },
/* 570 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// 20.2.2.16 Math.fround(x)
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', { fround: __webpack_require__(213) });

/***/ },
/* 571 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
	var $export = __webpack_require__(2);
	var abs = Math.abs;
	
	$export($export.S, 'Math', {
	  hypot: function hypot(value1, value2) {
	    // eslint-disable-line no-unused-vars
	    var sum = 0;
	    var i = 0;
	    var aLen = arguments.length;
	    var larg = 0;
	    var arg, div;
	    while (i < aLen) {
	      arg = abs(arguments[i++]);
	      if (larg < arg) {
	        div = larg / arg;
	        sum = sum * div * div + 1;
	        larg = arg;
	      } else if (arg > 0) {
	        div = arg / larg;
	        sum += div * div;
	      } else sum += arg;
	    }
	    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
	  }
	});

/***/ },
/* 572 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// 20.2.2.18 Math.imul(x, y)
	var $export = __webpack_require__(2);
	var $imul = Math.imul;
	
	// some WebKit versions fails with big numbers, some has wrong arity
	$export($export.S + $export.F * __webpack_require__(10)(function () {
	  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
	}), 'Math', {
	  imul: function imul(x, y) {
	    var UINT16 = 0xffff;
	    var xn = +x;
	    var yn = +y;
	    var xl = UINT16 & xn;
	    var yl = UINT16 & yn;
	    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
	  }
	});

/***/ },
/* 573 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// 20.2.2.21 Math.log10(x)
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', {
	  log10: function log10(x) {
	    return Math.log(x) * Math.LOG10E;
	  }
	});

/***/ },
/* 574 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// 20.2.2.20 Math.log1p(x)
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', { log1p: __webpack_require__(214) });

/***/ },
/* 575 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// 20.2.2.22 Math.log2(x)
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', {
	  log2: function log2(x) {
	    return Math.log(x) / Math.LN2;
	  }
	});

/***/ },
/* 576 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// 20.2.2.28 Math.sign(x)
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', { sign: __webpack_require__(143) });

/***/ },
/* 577 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// 20.2.2.30 Math.sinh(x)
	var $export = __webpack_require__(2);
	var expm1 = __webpack_require__(142);
	var exp = Math.exp;
	
	// V8 near Chromium 38 has a problem with very small numbers
	$export($export.S + $export.F * __webpack_require__(10)(function () {
	  return !Math.sinh(-2e-17) != -2e-17;
	}), 'Math', {
	  sinh: function sinh(x) {
	    return Math.abs(x = +x) < 1 ? (expm1(x) - expm1(-x)) / 2 : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
	  }
	});

/***/ },
/* 578 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// 20.2.2.33 Math.tanh(x)
	var $export = __webpack_require__(2);
	var expm1 = __webpack_require__(142);
	var exp = Math.exp;
	
	$export($export.S, 'Math', {
	  tanh: function tanh(x) {
	    var a = expm1(x = +x);
	    var b = expm1(-x);
	    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
	  }
	});

/***/ },
/* 579 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// 20.2.2.34 Math.trunc(x)
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', {
	  trunc: function trunc(it) {
	    return (it > 0 ? Math.floor : Math.ceil)(it);
	  }
	});

/***/ },
/* 580 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var global = __webpack_require__(8);
	var has = __webpack_require__(33);
	var cof = __webpack_require__(43);
	var inheritIfRequired = __webpack_require__(138);
	var toPrimitive = __webpack_require__(52);
	var fails = __webpack_require__(10);
	var gOPN = __webpack_require__(69).f;
	var gOPD = __webpack_require__(39).f;
	var dP = __webpack_require__(21).f;
	var $trim = __webpack_require__(79).trim;
	var NUMBER = 'Number';
	var $Number = global[NUMBER];
	var Base = $Number;
	var proto = $Number.prototype;
	// Opera ~12 has broken Object#toString
	var BROKEN_COF = cof(__webpack_require__(68)(proto)) == NUMBER;
	var TRIM = 'trim' in String.prototype;
	
	// 7.1.3 ToNumber(argument)
	var toNumber = function toNumber(argument) {
	  var it = toPrimitive(argument, false);
	  if (typeof it == 'string' && it.length > 2) {
	    it = TRIM ? it.trim() : $trim(it, 3);
	    var first = it.charCodeAt(0);
	    var third, radix, maxCode;
	    if (first === 43 || first === 45) {
	      third = it.charCodeAt(2);
	      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
	    } else if (first === 48) {
	      switch (it.charCodeAt(1)) {
	        case 66:case 98:
	          radix = 2;maxCode = 49;break; // fast equal /^0b[01]+$/i
	        case 79:case 111:
	          radix = 8;maxCode = 55;break; // fast equal /^0o[0-7]+$/i
	        default:
	          return +it;
	      }
	      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
	        code = digits.charCodeAt(i);
	        // parseInt parses a string to a first unavailable symbol
	        // but ToNumber should return NaN if a string contains unavailable symbols
	        if (code < 48 || code > maxCode) return NaN;
	      }return parseInt(digits, radix);
	    }
	  }return +it;
	};
	
	if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
	  $Number = function Number(value) {
	    var it = arguments.length < 1 ? 0 : value;
	    var that = this;
	    return that instanceof $Number
	    // check on 1..constructor(foo) case
	    && (BROKEN_COF ? fails(function () {
	      proto.valueOf.call(that);
	    }) : cof(that) != NUMBER) ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
	  };
	  for (var keys = __webpack_require__(20) ? gOPN(Base) : (
	  // ES3:
	  'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
	  // ES6 (in case, if modules with ES6 Number statics required before):
	  'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' + 'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger').split(','), j = 0, key; keys.length > j; j++) {
	    if (has(Base, key = keys[j]) && !has($Number, key)) {
	      dP($Number, key, gOPD(Base, key));
	    }
	  }
	  $Number.prototype = proto;
	  proto.constructor = $Number;
	  __webpack_require__(35)(global, NUMBER, $Number);
	}

/***/ },
/* 581 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// 20.1.2.1 Number.EPSILON
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });

/***/ },
/* 582 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// 20.1.2.2 Number.isFinite(number)
	var $export = __webpack_require__(2);
	var _isFinite = __webpack_require__(8).isFinite;
	
	$export($export.S, 'Number', {
	  isFinite: function isFinite(it) {
	    return typeof it == 'number' && _isFinite(it);
	  }
	});

/***/ },
/* 583 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// 20.1.2.3 Number.isInteger(number)
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Number', { isInteger: __webpack_require__(210) });

/***/ },
/* 584 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// 20.1.2.4 Number.isNaN(number)
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Number', {
	  isNaN: function isNaN(number) {
	    // eslint-disable-next-line no-self-compare
	    return number != number;
	  }
	});

/***/ },
/* 585 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// 20.1.2.5 Number.isSafeInteger(number)
	var $export = __webpack_require__(2);
	var isInteger = __webpack_require__(210);
	var abs = Math.abs;
	
	$export($export.S, 'Number', {
	  isSafeInteger: function isSafeInteger(number) {
	    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
	  }
	});

/***/ },
/* 586 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// 20.1.2.6 Number.MAX_SAFE_INTEGER
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });

/***/ },
/* 587 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// 20.1.2.10 Number.MIN_SAFE_INTEGER
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });

/***/ },
/* 588 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var $export = __webpack_require__(2);
	var $parseFloat = __webpack_require__(222);
	// 20.1.2.12 Number.parseFloat(string)
	$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });

/***/ },
/* 589 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var $export = __webpack_require__(2);
	var $parseInt = __webpack_require__(223);
	// 20.1.2.13 Number.parseInt(string, radix)
	$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });

/***/ },
/* 590 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var $export = __webpack_require__(2);
	var toInteger = __webpack_require__(51);
	var aNumberValue = __webpack_require__(200);
	var repeat = __webpack_require__(150);
	var $toFixed = 1.0.toFixed;
	var floor = Math.floor;
	var data = [0, 0, 0, 0, 0, 0];
	var ERROR = 'Number.toFixed: incorrect invocation!';
	var ZERO = '0';
	
	var multiply = function multiply(n, c) {
	  var i = -1;
	  var c2 = c;
	  while (++i < 6) {
	    c2 += n * data[i];
	    data[i] = c2 % 1e7;
	    c2 = floor(c2 / 1e7);
	  }
	};
	var divide = function divide(n) {
	  var i = 6;
	  var c = 0;
	  while (--i >= 0) {
	    c += data[i];
	    data[i] = floor(c / n);
	    c = c % n * 1e7;
	  }
	};
	var numToString = function numToString() {
	  var i = 6;
	  var s = '';
	  while (--i >= 0) {
	    if (s !== '' || i === 0 || data[i] !== 0) {
	      var t = String(data[i]);
	      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
	    }
	  }return s;
	};
	var pow = function pow(x, n, acc) {
	  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
	};
	var log = function log(x) {
	  var n = 0;
	  var x2 = x;
	  while (x2 >= 4096) {
	    n += 12;
	    x2 /= 4096;
	  }
	  while (x2 >= 2) {
	    n += 1;
	    x2 /= 2;
	  }return n;
	};
	
	$export($export.P + $export.F * (!!$toFixed && (0.00008.toFixed(3) !== '0.000' || 0.9.toFixed(0) !== '1' || 1.255.toFixed(2) !== '1.25' || 1000000000000000128.0.toFixed(0) !== '1000000000000000128') || !__webpack_require__(10)(function () {
	  // V8 ~ Android 4.3-
	  $toFixed.call({});
	})), 'Number', {
	  toFixed: function toFixed(fractionDigits) {
	    var x = aNumberValue(this, ERROR);
	    var f = toInteger(fractionDigits);
	    var s = '';
	    var m = ZERO;
	    var e, z, j, k;
	    if (f < 0 || f > 20) throw RangeError(ERROR);
	    // eslint-disable-next-line no-self-compare
	    if (x != x) return 'NaN';
	    if (x <= -1e21 || x >= 1e21) return String(x);
	    if (x < 0) {
	      s = '-';
	      x = -x;
	    }
	    if (x > 1e-21) {
	      e = log(x * pow(2, 69, 1)) - 69;
	      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
	      z *= 0x10000000000000;
	      e = 52 - e;
	      if (e > 0) {
	        multiply(0, z);
	        j = f;
	        while (j >= 7) {
	          multiply(1e7, 0);
	          j -= 7;
	        }
	        multiply(pow(10, j, 1), 0);
	        j = e - 1;
	        while (j >= 23) {
	          divide(1 << 23);
	          j -= 23;
	        }
	        divide(1 << j);
	        multiply(1, 1);
	        divide(2);
	        m = numToString();
	      } else {
	        multiply(0, z);
	        multiply(1 << -e, 0);
	        m = numToString() + repeat.call(ZERO, f);
	      }
	    }
	    if (f > 0) {
	      k = m.length;
	      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
	    } else {
	      m = s + m;
	    }return m;
	  }
	});

/***/ },
/* 591 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var $export = __webpack_require__(2);
	var $fails = __webpack_require__(10);
	var aNumberValue = __webpack_require__(200);
	var $toPrecision = 1.0.toPrecision;
	
	$export($export.P + $export.F * ($fails(function () {
	  // IE7-
	  return $toPrecision.call(1, undefined) !== '1';
	}) || !$fails(function () {
	  // V8 ~ Android 4.3-
	  $toPrecision.call({});
	})), 'Number', {
	  toPrecision: function toPrecision(precision) {
	    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
	    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
	  }
	});

/***/ },
/* 592 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(2);
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(216) });

/***/ },
/* 593 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var $export = __webpack_require__(2);
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', { create: __webpack_require__(68) });

/***/ },
/* 594 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var $export = __webpack_require__(2);
	// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
	$export($export.S + $export.F * !__webpack_require__(20), 'Object', { defineProperties: __webpack_require__(217) });

/***/ },
/* 595 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var $export = __webpack_require__(2);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(20), 'Object', { defineProperty: __webpack_require__(21).f });

/***/ },
/* 596 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// 19.1.2.5 Object.freeze(O)
	var isObject = __webpack_require__(14);
	var meta = __webpack_require__(61).onFreeze;
	
	__webpack_require__(50)('freeze', function ($freeze) {
	  return function freeze(it) {
	    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
	  };
	});

/***/ },
/* 597 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	var toIObject = __webpack_require__(37);
	var $getOwnPropertyDescriptor = __webpack_require__(39).f;
	
	__webpack_require__(50)('getOwnPropertyDescriptor', function () {
	  return function getOwnPropertyDescriptor(it, key) {
	    return $getOwnPropertyDescriptor(toIObject(it), key);
	  };
	});

/***/ },
/* 598 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// 19.1.2.7 Object.getOwnPropertyNames(O)
	__webpack_require__(50)('getOwnPropertyNames', function () {
	  return __webpack_require__(218).f;
	});

/***/ },
/* 599 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// 19.1.2.9 Object.getPrototypeOf(O)
	var toObject = __webpack_require__(24);
	var $getPrototypeOf = __webpack_require__(40);
	
	__webpack_require__(50)('getPrototypeOf', function () {
	  return function getPrototypeOf(it) {
	    return $getPrototypeOf(toObject(it));
	  };
	});

/***/ },
/* 600 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// 19.1.2.11 Object.isExtensible(O)
	var isObject = __webpack_require__(14);
	
	__webpack_require__(50)('isExtensible', function ($isExtensible) {
	  return function isExtensible(it) {
	    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
	  };
	});

/***/ },
/* 601 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// 19.1.2.12 Object.isFrozen(O)
	var isObject = __webpack_require__(14);
	
	__webpack_require__(50)('isFrozen', function ($isFrozen) {
	  return function isFrozen(it) {
	    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
	  };
	});

/***/ },
/* 602 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// 19.1.2.13 Object.isSealed(O)
	var isObject = __webpack_require__(14);
	
	__webpack_require__(50)('isSealed', function ($isSealed) {
	  return function isSealed(it) {
	    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
	  };
	});

/***/ },
/* 603 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// 19.1.3.10 Object.is(value1, value2)
	var $export = __webpack_require__(2);
	$export($export.S, 'Object', { is: __webpack_require__(533) });

/***/ },
/* 604 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(24);
	var $keys = __webpack_require__(62);
	
	__webpack_require__(50)('keys', function () {
	  return function keys(it) {
	    return $keys(toObject(it));
	  };
	});

/***/ },
/* 605 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// 19.1.2.15 Object.preventExtensions(O)
	var isObject = __webpack_require__(14);
	var meta = __webpack_require__(61).onFreeze;
	
	__webpack_require__(50)('preventExtensions', function ($preventExtensions) {
	  return function preventExtensions(it) {
	    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
	  };
	});

/***/ },
/* 606 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// 19.1.2.17 Object.seal(O)
	var isObject = __webpack_require__(14);
	var meta = __webpack_require__(61).onFreeze;
	
	__webpack_require__(50)('seal', function ($seal) {
	  return function seal(it) {
	    return $seal && isObject(it) ? $seal(meta(it)) : it;
	  };
	});

/***/ },
/* 607 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(2);
	$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(146).set });

/***/ },
/* 608 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.3.6 Object.prototype.toString()
	
	var classof = __webpack_require__(90);
	var test = {};
	test[__webpack_require__(17)('toStringTag')] = 'z';
	if (test + '' != '[object z]') {
	  __webpack_require__(35)(Object.prototype, 'toString', function toString() {
	    return '[object ' + classof(this) + ']';
	  }, true);
	}

/***/ },
/* 609 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var $export = __webpack_require__(2);
	var $parseFloat = __webpack_require__(222);
	// 18.2.4 parseFloat(string)
	$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });

/***/ },
/* 610 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var $export = __webpack_require__(2);
	var $parseInt = __webpack_require__(223);
	// 18.2.5 parseInt(string, radix)
	$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });

/***/ },
/* 611 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var LIBRARY = __webpack_require__(67);
	var global = __webpack_require__(8);
	var ctx = __webpack_require__(44);
	var classof = __webpack_require__(90);
	var $export = __webpack_require__(2);
	var isObject = __webpack_require__(14);
	var aFunction = __webpack_require__(27);
	var anInstance = __webpack_require__(65);
	var forOf = __webpack_require__(66);
	var speciesConstructor = __webpack_require__(116);
	var task = __webpack_require__(152).set;
	var microtask = __webpack_require__(144)();
	var newPromiseCapabilityModule = __webpack_require__(145);
	var perform = __webpack_require__(224);
	var promiseResolve = __webpack_require__(225);
	var PROMISE = 'Promise';
	var TypeError = global.TypeError;
	var process = global.process;
	var $Promise = global[PROMISE];
	var isNode = classof(process) == 'process';
	var empty = function empty() {/* empty */};
	var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
	var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;
	
	var USE_NATIVE = !!function () {
	  try {
	    // correct subclassing with @@species support
	    var promise = $Promise.resolve(1);
	    var FakePromise = (promise.constructor = {})[__webpack_require__(17)('species')] = function (exec) {
	      exec(empty, empty);
	    };
	    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
	    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
	  } catch (e) {/* empty */}
	}();
	
	// helpers
	var sameConstructor = LIBRARY ? function (a, b) {
	  // with library wrapper special case
	  return a === b || a === $Promise && b === Wrapper;
	} : function (a, b) {
	  return a === b;
	};
	var isThenable = function isThenable(it) {
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var notify = function notify(promise, isReject) {
	  if (promise._n) return;
	  promise._n = true;
	  var chain = promise._c;
	  microtask(function () {
	    var value = promise._v;
	    var ok = promise._s == 1;
	    var i = 0;
	    var run = function run(reaction) {
	      var handler = ok ? reaction.ok : reaction.fail;
	      var resolve = reaction.resolve;
	      var reject = reaction.reject;
	      var domain = reaction.domain;
	      var result, then;
	      try {
	        if (handler) {
	          if (!ok) {
	            if (promise._h == 2) onHandleUnhandled(promise);
	            promise._h = 1;
	          }
	          if (handler === true) result = value;else {
	            if (domain) domain.enter();
	            result = handler(value);
	            if (domain) domain.exit();
	          }
	          if (result === reaction.promise) {
	            reject(TypeError('Promise-chain cycle'));
	          } else if (then = isThenable(result)) {
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch (e) {
	        reject(e);
	      }
	    };
	    while (chain.length > i) {
	      run(chain[i++]);
	    } // variable length - can't use forEach
	    promise._c = [];
	    promise._n = false;
	    if (isReject && !promise._h) onUnhandled(promise);
	  });
	};
	var onUnhandled = function onUnhandled(promise) {
	  task.call(global, function () {
	    var value = promise._v;
	    var unhandled = isUnhandled(promise);
	    var result, handler, console;
	    if (unhandled) {
	      result = perform(function () {
	        if (isNode) {
	          process.emit('unhandledRejection', value, promise);
	        } else if (handler = global.onunhandledrejection) {
	          handler({ promise: promise, reason: value });
	        } else if ((console = global.console) && console.error) {
	          console.error('Unhandled promise rejection', value);
	        }
	      });
	      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
	      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
	    }promise._a = undefined;
	    if (unhandled && result.e) throw result.v;
	  });
	};
	var isUnhandled = function isUnhandled(promise) {
	  if (promise._h == 1) return false;
	  var chain = promise._a || promise._c;
	  var i = 0;
	  var reaction;
	  while (chain.length > i) {
	    reaction = chain[i++];
	    if (reaction.fail || !isUnhandled(reaction.promise)) return false;
	  }return true;
	};
	var onHandleUnhandled = function onHandleUnhandled(promise) {
	  task.call(global, function () {
	    var handler;
	    if (isNode) {
	      process.emit('rejectionHandled', promise);
	    } else if (handler = global.onrejectionhandled) {
	      handler({ promise: promise, reason: promise._v });
	    }
	  });
	};
	var $reject = function $reject(value) {
	  var promise = this;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  promise._v = value;
	  promise._s = 2;
	  if (!promise._a) promise._a = promise._c.slice();
	  notify(promise, true);
	};
	var $resolve = function $resolve(value) {
	  var promise = this;
	  var then;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  try {
	    if (promise === value) throw TypeError("Promise can't be resolved itself");
	    if (then = isThenable(value)) {
	      microtask(function () {
	        var wrapper = { _w: promise, _d: false }; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch (e) {
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      promise._v = value;
	      promise._s = 1;
	      notify(promise, false);
	    }
	  } catch (e) {
	    $reject.call({ _w: promise, _d: false }, e); // wrap
	  }
	};
	
	// constructor polyfill
	if (!USE_NATIVE) {
	  // 25.4.3.1 Promise(executor)
	  $Promise = function Promise(executor) {
	    anInstance(this, $Promise, PROMISE, '_h');
	    aFunction(executor);
	    Internal.call(this);
	    try {
	      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
	    } catch (err) {
	      $reject.call(this, err);
	    }
	  };
	  // eslint-disable-next-line no-unused-vars
	  Internal = function Promise(executor) {
	    this._c = []; // <- awaiting reactions
	    this._a = undefined; // <- checked in isUnhandled reactions
	    this._s = 0; // <- state
	    this._d = false; // <- done
	    this._v = undefined; // <- value
	    this._h = 0; // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
	    this._n = false; // <- notify
	  };
	  Internal.prototype = __webpack_require__(71)($Promise.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected) {
	      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
	      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail = typeof onRejected == 'function' && onRejected;
	      reaction.domain = isNode ? process.domain : undefined;
	      this._c.push(reaction);
	      if (this._a) this._a.push(reaction);
	      if (this._s) notify(this, false);
	      return reaction.promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function _catch(onRejected) {
	      return this.then(undefined, onRejected);
	    }
	  });
	  OwnPromiseCapability = function OwnPromiseCapability() {
	    var promise = new Internal();
	    this.promise = promise;
	    this.resolve = ctx($resolve, promise, 1);
	    this.reject = ctx($reject, promise, 1);
	  };
	  newPromiseCapabilityModule.f = newPromiseCapability = function newPromiseCapability(C) {
	    return sameConstructor($Promise, C) ? new OwnPromiseCapability(C) : newGenericPromiseCapability(C);
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
	__webpack_require__(78)($Promise, PROMISE);
	__webpack_require__(72)(PROMISE);
	Wrapper = __webpack_require__(48)[PROMISE];
	
	// statics
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r) {
	    var capability = newPromiseCapability(this);
	    var $$reject = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x) {
	    // instanceof instead of internal slot check because we should fix it without replacement native Promise core
	    if (x instanceof $Promise && sameConstructor(x.constructor, this)) return x;
	    return promiseResolve(this, x);
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(110)(function (iter) {
	  $Promise.all(iter)['catch'](empty);
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var resolve = capability.resolve;
	    var reject = capability.reject;
	    var result = perform(function () {
	      var values = [];
	      var index = 0;
	      var remaining = 1;
	      forOf(iterable, false, function (promise) {
	        var $index = index++;
	        var alreadyCalled = false;
	        values.push(undefined);
	        remaining++;
	        C.resolve(promise).then(function (value) {
	          if (alreadyCalled) return;
	          alreadyCalled = true;
	          values[$index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var reject = capability.reject;
	    var result = perform(function () {
	      forOf(iterable, false, function (promise) {
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  }
	});

/***/ },
/* 612 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
	var $export = __webpack_require__(2);
	var aFunction = __webpack_require__(27);
	var anObject = __webpack_require__(7);
	var rApply = (__webpack_require__(8).Reflect || {}).apply;
	var fApply = Function.apply;
	// MS Edge argumentsList argument is optional
	$export($export.S + $export.F * !__webpack_require__(10)(function () {
	  rApply(function () {/* empty */});
	}), 'Reflect', {
	  apply: function apply(target, thisArgument, argumentsList) {
	    var T = aFunction(target);
	    var L = anObject(argumentsList);
	    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
	  }
	});

/***/ },
/* 613 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
	var $export = __webpack_require__(2);
	var create = __webpack_require__(68);
	var aFunction = __webpack_require__(27);
	var anObject = __webpack_require__(7);
	var isObject = __webpack_require__(14);
	var fails = __webpack_require__(10);
	var bind = __webpack_require__(204);
	var rConstruct = (__webpack_require__(8).Reflect || {}).construct;
	
	// MS Edge supports only 2 arguments and argumentsList argument is optional
	// FF Nightly sets third argument as `new.target`, but does not create `this` from it
	var NEW_TARGET_BUG = fails(function () {
	  function F() {/* empty */}
	  return !(rConstruct(function () {/* empty */}, [], F) instanceof F);
	});
	var ARGS_BUG = !fails(function () {
	  rConstruct(function () {/* empty */});
	});
	
	$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
	  construct: function construct(Target, args /* , newTarget */) {
	    aFunction(Target);
	    anObject(args);
	    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
	    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
	    if (Target == newTarget) {
	      // w/o altered newTarget, optimization for 0-4 arguments
	      switch (args.length) {
	        case 0:
	          return new Target();
	        case 1:
	          return new Target(args[0]);
	        case 2:
	          return new Target(args[0], args[1]);
	        case 3:
	          return new Target(args[0], args[1], args[2]);
	        case 4:
	          return new Target(args[0], args[1], args[2], args[3]);
	      }
	      // w/o altered newTarget, lot of arguments case
	      var $args = [null];
	      $args.push.apply($args, args);
	      return new (bind.apply(Target, $args))();
	    }
	    // with altered newTarget, not support built-in constructors
	    var proto = newTarget.prototype;
	    var instance = create(isObject(proto) ? proto : Object.prototype);
	    var result = Function.apply.call(Target, instance, args);
	    return isObject(result) ? result : instance;
	  }
	});

/***/ },
/* 614 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
	var dP = __webpack_require__(21);
	var $export = __webpack_require__(2);
	var anObject = __webpack_require__(7);
	var toPrimitive = __webpack_require__(52);
	
	// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
	$export($export.S + $export.F * __webpack_require__(10)(function () {
	  // eslint-disable-next-line no-undef
	  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
	}), 'Reflect', {
	  defineProperty: function defineProperty(target, propertyKey, attributes) {
	    anObject(target);
	    propertyKey = toPrimitive(propertyKey, true);
	    anObject(attributes);
	    try {
	      dP.f(target, propertyKey, attributes);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});

/***/ },
/* 615 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// 26.1.4 Reflect.deleteProperty(target, propertyKey)
	var $export = __webpack_require__(2);
	var gOPD = __webpack_require__(39).f;
	var anObject = __webpack_require__(7);
	
	$export($export.S, 'Reflect', {
	  deleteProperty: function deleteProperty(target, propertyKey) {
	    var desc = gOPD(anObject(target), propertyKey);
	    return desc && !desc.configurable ? false : delete target[propertyKey];
	  }
	});

/***/ },
/* 616 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 26.1.5 Reflect.enumerate(target)
	
	var $export = __webpack_require__(2);
	var anObject = __webpack_require__(7);
	var Enumerate = function Enumerate(iterated) {
	  this._t = anObject(iterated); // target
	  this._i = 0; // next index
	  var keys = this._k = []; // keys
	  var key;
	  for (key in iterated) {
	    keys.push(key);
	  }
	};
	__webpack_require__(140)(Enumerate, 'Object', function () {
	  var that = this;
	  var keys = that._k;
	  var key;
	  do {
	    if (that._i >= keys.length) return { value: undefined, done: true };
	  } while (!((key = keys[that._i++]) in that._t));
	  return { value: key, done: false };
	});
	
	$export($export.S, 'Reflect', {
	  enumerate: function enumerate(target) {
	    return new Enumerate(target);
	  }
	});

/***/ },
/* 617 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
	var gOPD = __webpack_require__(39);
	var $export = __webpack_require__(2);
	var anObject = __webpack_require__(7);
	
	$export($export.S, 'Reflect', {
	  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
	    return gOPD.f(anObject(target), propertyKey);
	  }
	});

/***/ },
/* 618 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// 26.1.8 Reflect.getPrototypeOf(target)
	var $export = __webpack_require__(2);
	var getProto = __webpack_require__(40);
	var anObject = __webpack_require__(7);
	
	$export($export.S, 'Reflect', {
	  getPrototypeOf: function getPrototypeOf(target) {
	    return getProto(anObject(target));
	  }
	});

/***/ },
/* 619 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// 26.1.6 Reflect.get(target, propertyKey [, receiver])
	var gOPD = __webpack_require__(39);
	var getPrototypeOf = __webpack_require__(40);
	var has = __webpack_require__(33);
	var $export = __webpack_require__(2);
	var isObject = __webpack_require__(14);
	var anObject = __webpack_require__(7);
	
	function get(target, propertyKey /* , receiver */) {
	  var receiver = arguments.length < 3 ? target : arguments[2];
	  var desc, proto;
	  if (anObject(target) === receiver) return target[propertyKey];
	  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value') ? desc.value : desc.get !== undefined ? desc.get.call(receiver) : undefined;
	  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
	}
	
	$export($export.S, 'Reflect', { get: get });

/***/ },
/* 620 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// 26.1.9 Reflect.has(target, propertyKey)
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Reflect', {
	  has: function has(target, propertyKey) {
	    return propertyKey in target;
	  }
	});

/***/ },
/* 621 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// 26.1.10 Reflect.isExtensible(target)
	var $export = __webpack_require__(2);
	var anObject = __webpack_require__(7);
	var $isExtensible = Object.isExtensible;
	
	$export($export.S, 'Reflect', {
	  isExtensible: function isExtensible(target) {
	    anObject(target);
	    return $isExtensible ? $isExtensible(target) : true;
	  }
	});

/***/ },
/* 622 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// 26.1.11 Reflect.ownKeys(target)
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Reflect', { ownKeys: __webpack_require__(221) });

/***/ },
/* 623 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// 26.1.12 Reflect.preventExtensions(target)
	var $export = __webpack_require__(2);
	var anObject = __webpack_require__(7);
	var $preventExtensions = Object.preventExtensions;
	
	$export($export.S, 'Reflect', {
	  preventExtensions: function preventExtensions(target) {
	    anObject(target);
	    try {
	      if ($preventExtensions) $preventExtensions(target);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});

/***/ },
/* 624 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// 26.1.14 Reflect.setPrototypeOf(target, proto)
	var $export = __webpack_require__(2);
	var setProto = __webpack_require__(146);
	
	if (setProto) $export($export.S, 'Reflect', {
	  setPrototypeOf: function setPrototypeOf(target, proto) {
	    setProto.check(target, proto);
	    try {
	      setProto.set(target, proto);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});

/***/ },
/* 625 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
	var dP = __webpack_require__(21);
	var gOPD = __webpack_require__(39);
	var getPrototypeOf = __webpack_require__(40);
	var has = __webpack_require__(33);
	var $export = __webpack_require__(2);
	var createDesc = __webpack_require__(70);
	var anObject = __webpack_require__(7);
	var isObject = __webpack_require__(14);
	
	function set(target, propertyKey, V /* , receiver */) {
	  var receiver = arguments.length < 4 ? target : arguments[3];
	  var ownDesc = gOPD.f(anObject(target), propertyKey);
	  var existingDescriptor, proto;
	  if (!ownDesc) {
	    if (isObject(proto = getPrototypeOf(target))) {
	      return set(proto, propertyKey, V, receiver);
	    }
	    ownDesc = createDesc(0);
	  }
	  if (has(ownDesc, 'value')) {
	    if (ownDesc.writable === false || !isObject(receiver)) return false;
	    existingDescriptor = gOPD.f(receiver, propertyKey) || createDesc(0);
	    existingDescriptor.value = V;
	    dP.f(receiver, propertyKey, existingDescriptor);
	    return true;
	  }
	  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
	}
	
	$export($export.S, 'Reflect', { set: set });

/***/ },
/* 626 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var global = __webpack_require__(8);
	var inheritIfRequired = __webpack_require__(138);
	var dP = __webpack_require__(21).f;
	var gOPN = __webpack_require__(69).f;
	var isRegExp = __webpack_require__(109);
	var $flags = __webpack_require__(106);
	var $RegExp = global.RegExp;
	var Base = $RegExp;
	var proto = $RegExp.prototype;
	var re1 = /a/g;
	var re2 = /a/g;
	// "new" creates a new object, old webkit buggy here
	var CORRECT_NEW = new $RegExp(re1) !== re1;
	
	if (__webpack_require__(20) && (!CORRECT_NEW || __webpack_require__(10)(function () {
	  re2[__webpack_require__(17)('match')] = false;
	  // RegExp constructor can alter flags and IsRegExp works correct with @@match
	  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
	}))) {
	  $RegExp = function RegExp(p, f) {
	    var tiRE = this instanceof $RegExp;
	    var piRE = isRegExp(p);
	    var fiU = f === undefined;
	    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p : inheritIfRequired(CORRECT_NEW ? new Base(piRE && !fiU ? p.source : p, f) : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f), tiRE ? this : proto, $RegExp);
	  };
	  var proxy = function proxy(key) {
	    key in $RegExp || dP($RegExp, key, {
	      configurable: true,
	      get: function get() {
	        return Base[key];
	      },
	      set: function set(it) {
	        Base[key] = it;
	      }
	    });
	  };
	  for (var keys = gOPN(Base), i = 0; keys.length > i;) {
	    proxy(keys[i++]);
	  }proto.constructor = $RegExp;
	  $RegExp.prototype = proto;
	  __webpack_require__(35)(global, 'RegExp', $RegExp);
	}
	
	__webpack_require__(72)('RegExp');

/***/ },
/* 627 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// @@match logic
	__webpack_require__(105)('match', 1, function (defined, MATCH, $match) {
	  // 21.1.3.11 String.prototype.match(regexp)
	  return [function match(regexp) {
	    'use strict';
	
	    var O = defined(this);
	    var fn = regexp == undefined ? undefined : regexp[MATCH];
	    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
	  }, $match];
	});

/***/ },
/* 628 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// @@replace logic
	__webpack_require__(105)('replace', 2, function (defined, REPLACE, $replace) {
	  // 21.1.3.14 String.prototype.replace(searchValue, replaceValue)
	  return [function replace(searchValue, replaceValue) {
	    'use strict';
	
	    var O = defined(this);
	    var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
	    return fn !== undefined ? fn.call(searchValue, O, replaceValue) : $replace.call(String(O), searchValue, replaceValue);
	  }, $replace];
	});

/***/ },
/* 629 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// @@search logic
	__webpack_require__(105)('search', 1, function (defined, SEARCH, $search) {
	  // 21.1.3.15 String.prototype.search(regexp)
	  return [function search(regexp) {
	    'use strict';
	
	    var O = defined(this);
	    var fn = regexp == undefined ? undefined : regexp[SEARCH];
	    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
	  }, $search];
	});

/***/ },
/* 630 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// @@split logic
	__webpack_require__(105)('split', 2, function (defined, SPLIT, $split) {
	  'use strict';
	
	  var isRegExp = __webpack_require__(109);
	  var _split = $split;
	  var $push = [].push;
	  var $SPLIT = 'split';
	  var LENGTH = 'length';
	  var LAST_INDEX = 'lastIndex';
	  if ('abbc'[$SPLIT](/(b)*/)[1] == 'c' || 'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 || 'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 || '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 || '.'[$SPLIT](/()()/)[LENGTH] > 1 || ''[$SPLIT](/.?/)[LENGTH]) {
	    var NPCG = /()??/.exec('')[1] === undefined; // nonparticipating capturing group
	    // based on es5-shim implementation, need to rework it
	    $split = function $split(separator, limit) {
	      var string = String(this);
	      if (separator === undefined && limit === 0) return [];
	      // If `separator` is not a regex, use native split
	      if (!isRegExp(separator)) return _split.call(string, separator, limit);
	      var output = [];
	      var flags = (separator.ignoreCase ? 'i' : '') + (separator.multiline ? 'm' : '') + (separator.unicode ? 'u' : '') + (separator.sticky ? 'y' : '');
	      var lastLastIndex = 0;
	      var splitLimit = limit === undefined ? 4294967295 : limit >>> 0;
	      // Make `global` and avoid `lastIndex` issues by working with a copy
	      var separatorCopy = new RegExp(separator.source, flags + 'g');
	      var separator2, match, lastIndex, lastLength, i;
	      // Doesn't need flags gy, but they don't hurt
	      if (!NPCG) separator2 = new RegExp('^' + separatorCopy.source + '$(?!\\s)', flags);
	      while (match = separatorCopy.exec(string)) {
	        // `separatorCopy.lastIndex` is not reliable cross-browser
	        lastIndex = match.index + match[0][LENGTH];
	        if (lastIndex > lastLastIndex) {
	          output.push(string.slice(lastLastIndex, match.index));
	          // Fix browsers whose `exec` methods don't consistently return `undefined` for NPCG
	          // eslint-disable-next-line no-loop-func
	          if (!NPCG && match[LENGTH] > 1) match[0].replace(separator2, function () {
	            for (i = 1; i < arguments[LENGTH] - 2; i++) {
	              if (arguments[i] === undefined) match[i] = undefined;
	            }
	          });
	          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
	          lastLength = match[0][LENGTH];
	          lastLastIndex = lastIndex;
	          if (output[LENGTH] >= splitLimit) break;
	        }
	        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
	      }
	      if (lastLastIndex === string[LENGTH]) {
	        if (lastLength || !separatorCopy.test('')) output.push('');
	      } else output.push(string.slice(lastLastIndex));
	      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
	    };
	    // Chakra, V8
	  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
	    $split = function $split(separator, limit) {
	      return separator === undefined && limit === 0 ? [] : _split.call(this, separator, limit);
	    };
	  }
	  // 21.1.3.17 String.prototype.split(separator, limit)
	  return [function split(separator, limit) {
	    var O = defined(this);
	    var fn = separator == undefined ? undefined : separator[SPLIT];
	    return fn !== undefined ? fn.call(separator, O, limit) : $split.call(String(O), separator, limit);
	  }, $split];
	});

/***/ },
/* 631 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(230);
	var anObject = __webpack_require__(7);
	var $flags = __webpack_require__(106);
	var DESCRIPTORS = __webpack_require__(20);
	var TO_STRING = 'toString';
	var $toString = /./[TO_STRING];
	
	var define = function define(fn) {
	  __webpack_require__(35)(RegExp.prototype, TO_STRING, fn, true);
	};
	
	// 21.2.5.14 RegExp.prototype.toString()
	if (__webpack_require__(10)(function () {
	  return $toString.call({ source: 'a', flags: 'b' }) != '/a/b';
	})) {
	  define(function toString() {
	    var R = anObject(this);
	    return '/'.concat(R.source, '/', 'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
	  });
	  // FF44- RegExp#toString has a wrong name
	} else if ($toString.name != TO_STRING) {
	  define(function toString() {
	    return $toString.call(this);
	  });
	}

/***/ },
/* 632 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.2 String.prototype.anchor(name)
	
	__webpack_require__(36)('anchor', function (createHTML) {
	  return function anchor(name) {
	    return createHTML(this, 'a', 'name', name);
	  };
	});

/***/ },
/* 633 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.3 String.prototype.big()
	
	__webpack_require__(36)('big', function (createHTML) {
	  return function big() {
	    return createHTML(this, 'big', '', '');
	  };
	});

/***/ },
/* 634 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.4 String.prototype.blink()
	
	__webpack_require__(36)('blink', function (createHTML) {
	  return function blink() {
	    return createHTML(this, 'blink', '', '');
	  };
	});

/***/ },
/* 635 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.5 String.prototype.bold()
	
	__webpack_require__(36)('bold', function (createHTML) {
	  return function bold() {
	    return createHTML(this, 'b', '', '');
	  };
	});

/***/ },
/* 636 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var $export = __webpack_require__(2);
	var $at = __webpack_require__(148)(false);
	$export($export.P, 'String', {
	  // 21.1.3.3 String.prototype.codePointAt(pos)
	  codePointAt: function codePointAt(pos) {
	    return $at(this, pos);
	  }
	});

/***/ },
/* 637 */
/***/ function(module, exports, __webpack_require__) {

	// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])
	'use strict';
	
	var $export = __webpack_require__(2);
	var toLength = __webpack_require__(22);
	var context = __webpack_require__(149);
	var ENDS_WITH = 'endsWith';
	var $endsWith = ''[ENDS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(136)(ENDS_WITH), 'String', {
	  endsWith: function endsWith(searchString /* , endPosition = @length */) {
	    var that = context(this, searchString, ENDS_WITH);
	    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
	    var len = toLength(that.length);
	    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
	    var search = String(searchString);
	    return $endsWith ? $endsWith.call(that, search, end) : that.slice(end - search.length, end) === search;
	  }
	});

/***/ },
/* 638 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.6 String.prototype.fixed()
	
	__webpack_require__(36)('fixed', function (createHTML) {
	  return function fixed() {
	    return createHTML(this, 'tt', '', '');
	  };
	});

/***/ },
/* 639 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.7 String.prototype.fontcolor(color)
	
	__webpack_require__(36)('fontcolor', function (createHTML) {
	  return function fontcolor(color) {
	    return createHTML(this, 'font', 'color', color);
	  };
	});

/***/ },
/* 640 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.8 String.prototype.fontsize(size)
	
	__webpack_require__(36)('fontsize', function (createHTML) {
	  return function fontsize(size) {
	    return createHTML(this, 'font', 'size', size);
	  };
	});

/***/ },
/* 641 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var $export = __webpack_require__(2);
	var toAbsoluteIndex = __webpack_require__(73);
	var fromCharCode = String.fromCharCode;
	var $fromCodePoint = String.fromCodePoint;
	
	// length should be 1, old FF problem
	$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
	  // 21.1.2.2 String.fromCodePoint(...codePoints)
	  fromCodePoint: function fromCodePoint(x) {
	    // eslint-disable-line no-unused-vars
	    var res = [];
	    var aLen = arguments.length;
	    var i = 0;
	    var code;
	    while (aLen > i) {
	      code = +arguments[i++];
	      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
	      res.push(code < 0x10000 ? fromCharCode(code) : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00));
	    }return res.join('');
	  }
	});

/***/ },
/* 642 */
/***/ function(module, exports, __webpack_require__) {

	// 21.1.3.7 String.prototype.includes(searchString, position = 0)
	'use strict';
	
	var $export = __webpack_require__(2);
	var context = __webpack_require__(149);
	var INCLUDES = 'includes';
	
	$export($export.P + $export.F * __webpack_require__(136)(INCLUDES), 'String', {
	  includes: function includes(searchString /* , position = 0 */) {
	    return !!~context(this, searchString, INCLUDES).indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});

/***/ },
/* 643 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.9 String.prototype.italics()
	
	__webpack_require__(36)('italics', function (createHTML) {
	  return function italics() {
	    return createHTML(this, 'i', '', '');
	  };
	});

/***/ },
/* 644 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var $at = __webpack_require__(148)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(141)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0; // next index
	  // 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});

/***/ },
/* 645 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.10 String.prototype.link(url)
	
	__webpack_require__(36)('link', function (createHTML) {
	  return function link(url) {
	    return createHTML(this, 'a', 'href', url);
	  };
	});

/***/ },
/* 646 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var $export = __webpack_require__(2);
	var toIObject = __webpack_require__(37);
	var toLength = __webpack_require__(22);
	
	$export($export.S, 'String', {
	  // 21.1.2.4 String.raw(callSite, ...substitutions)
	  raw: function raw(callSite) {
	    var tpl = toIObject(callSite.raw);
	    var len = toLength(tpl.length);
	    var aLen = arguments.length;
	    var res = [];
	    var i = 0;
	    while (len > i) {
	      res.push(String(tpl[i++]));
	      if (i < aLen) res.push(String(arguments[i]));
	    }return res.join('');
	  }
	});

/***/ },
/* 647 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var $export = __webpack_require__(2);
	
	$export($export.P, 'String', {
	  // 21.1.3.13 String.prototype.repeat(count)
	  repeat: __webpack_require__(150)
	});

/***/ },
/* 648 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.11 String.prototype.small()
	
	__webpack_require__(36)('small', function (createHTML) {
	  return function small() {
	    return createHTML(this, 'small', '', '');
	  };
	});

/***/ },
/* 649 */
/***/ function(module, exports, __webpack_require__) {

	// 21.1.3.18 String.prototype.startsWith(searchString [, position ])
	'use strict';
	
	var $export = __webpack_require__(2);
	var toLength = __webpack_require__(22);
	var context = __webpack_require__(149);
	var STARTS_WITH = 'startsWith';
	var $startsWith = ''[STARTS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(136)(STARTS_WITH), 'String', {
	  startsWith: function startsWith(searchString /* , position = 0 */) {
	    var that = context(this, searchString, STARTS_WITH);
	    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
	    var search = String(searchString);
	    return $startsWith ? $startsWith.call(that, search, index) : that.slice(index, index + search.length) === search;
	  }
	});

/***/ },
/* 650 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.12 String.prototype.strike()
	
	__webpack_require__(36)('strike', function (createHTML) {
	  return function strike() {
	    return createHTML(this, 'strike', '', '');
	  };
	});

/***/ },
/* 651 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.13 String.prototype.sub()
	
	__webpack_require__(36)('sub', function (createHTML) {
	  return function sub() {
	    return createHTML(this, 'sub', '', '');
	  };
	});

/***/ },
/* 652 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.14 String.prototype.sup()
	
	__webpack_require__(36)('sup', function (createHTML) {
	  return function sup() {
	    return createHTML(this, 'sup', '', '');
	  };
	});

/***/ },
/* 653 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 21.1.3.25 String.prototype.trim()
	
	__webpack_require__(79)('trim', function ($trim) {
	  return function trim() {
	    return $trim(this, 3);
	  };
	});

/***/ },
/* 654 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var global = __webpack_require__(8);
	var has = __webpack_require__(33);
	var DESCRIPTORS = __webpack_require__(20);
	var $export = __webpack_require__(2);
	var redefine = __webpack_require__(35);
	var META = __webpack_require__(61).KEY;
	var $fails = __webpack_require__(10);
	var shared = __webpack_require__(115);
	var setToStringTag = __webpack_require__(78);
	var uid = __webpack_require__(74);
	var wks = __webpack_require__(17);
	var wksExt = __webpack_require__(228);
	var wksDefine = __webpack_require__(154);
	var keyOf = __webpack_require__(529);
	var enumKeys = __webpack_require__(528);
	var isArray = __webpack_require__(108);
	var anObject = __webpack_require__(7);
	var toIObject = __webpack_require__(37);
	var toPrimitive = __webpack_require__(52);
	var createDesc = __webpack_require__(70);
	var _create = __webpack_require__(68);
	var gOPNExt = __webpack_require__(218);
	var $GOPD = __webpack_require__(39);
	var $DP = __webpack_require__(21);
	var $keys = __webpack_require__(62);
	var gOPD = $GOPD.f;
	var dP = $DP.f;
	var gOPN = gOPNExt.f;
	var $Symbol = global.Symbol;
	var $JSON = global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE = 'prototype';
	var HIDDEN = wks('_hidden');
	var TO_PRIMITIVE = wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = shared('symbol-registry');
	var AllSymbols = shared('symbols');
	var OPSymbols = shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE];
	var USE_NATIVE = typeof $Symbol == 'function';
	var QObject = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function () {
	  return _create(dP({}, 'a', {
	    get: function get() {
	      return dP(this, 'a', { value: 7 }).a;
	    }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD(ObjectProto, key);
	  if (protoDesc) delete ObjectProto[key];
	  dP(it, key, D);
	  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function wrap(tag) {
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && _typeof($Symbol.iterator) == 'symbol' ? function (it) {
	  return (typeof it === 'undefined' ? 'undefined' : _typeof(it)) == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if (has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	      D = _create(D, { enumerable: createDesc(0, false) });
	    }return setSymbolDesc(it, key, D);
	  }return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) {
	    $defineProperty(it, key = keys[i++], P[key]);
	  }return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  it = toIObject(it);
	  key = toPrimitive(key, true);
	  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
	  var D = gOPD(it, key);
	  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN(toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	  }return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	  }return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function _Symbol() {
	    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function $set(value) {
	      if (this === ObjectProto) $set.call(OPSymbols, value);
	      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f = $defineProperty;
	  __webpack_require__(69).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(92).f = $propertyIsEnumerable;
	  __webpack_require__(112).f = $getOwnPropertySymbols;
	
	  if (DESCRIPTORS && !__webpack_require__(67)) {
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function (name) {
	    return wrap(wks(name));
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });
	
	for (var es6Symbols =
	// 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'.split(','), j = 0; es6Symbols.length > j;) {
	  wks(es6Symbols[j++]);
	}for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) {
	  wksDefine(wellKnownSymbols[k++]);
	}$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function _for(key) {
	    return has(SymbolRegistry, key += '') ? SymbolRegistry[key] : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(key) {
	    if (isSymbol(key)) return keyOf(SymbolRegistry, key);
	    throw TypeError(key + ' is not a symbol!');
	  },
	  useSetter: function useSetter() {
	    setter = true;
	  },
	  useSimple: function useSimple() {
	    setter = false;
	  }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    if (it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) {
	      args.push(arguments[i++]);
	    }replacer = args[1];
	    if (typeof replacer == 'function') $replacer = replacer;
	    if ($replacer || !isArray(replacer)) replacer = function replacer(key, value) {
	      if ($replacer) value = $replacer.call(this, key, value);
	      if (!isSymbol(value)) return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(34)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);

/***/ },
/* 655 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var $export = __webpack_require__(2);
	var $typed = __webpack_require__(117);
	var buffer = __webpack_require__(153);
	var anObject = __webpack_require__(7);
	var toAbsoluteIndex = __webpack_require__(73);
	var toLength = __webpack_require__(22);
	var isObject = __webpack_require__(14);
	var ArrayBuffer = __webpack_require__(8).ArrayBuffer;
	var speciesConstructor = __webpack_require__(116);
	var $ArrayBuffer = buffer.ArrayBuffer;
	var $DataView = buffer.DataView;
	var $isView = $typed.ABV && ArrayBuffer.isView;
	var $slice = $ArrayBuffer.prototype.slice;
	var VIEW = $typed.VIEW;
	var ARRAY_BUFFER = 'ArrayBuffer';
	
	$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });
	
	$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
	  // 24.1.3.1 ArrayBuffer.isView(arg)
	  isView: function isView(it) {
	    return $isView && $isView(it) || isObject(it) && VIEW in it;
	  }
	});
	
	$export($export.P + $export.U + $export.F * __webpack_require__(10)(function () {
	  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
	}), ARRAY_BUFFER, {
	  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
	  slice: function slice(start, end) {
	    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
	    var len = anObject(this).byteLength;
	    var first = toAbsoluteIndex(start, len);
	    var final = toAbsoluteIndex(end === undefined ? len : end, len);
	    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(final - first));
	    var viewS = new $DataView(this);
	    var viewT = new $DataView(result);
	    var index = 0;
	    while (first < final) {
	      viewT.setUint8(index++, viewS.getUint8(first++));
	    }return result;
	  }
	});
	
	__webpack_require__(72)(ARRAY_BUFFER);

/***/ },
/* 656 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var $export = __webpack_require__(2);
	$export($export.G + $export.W + $export.F * !__webpack_require__(117).ABV, {
	  DataView: __webpack_require__(153).DataView
	});

/***/ },
/* 657 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(55)('Float32', 4, function (init) {
	  return function Float32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ },
/* 658 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(55)('Float64', 8, function (init) {
	  return function Float64Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ },
/* 659 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(55)('Int16', 2, function (init) {
	  return function Int16Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ },
/* 660 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(55)('Int32', 4, function (init) {
	  return function Int32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ },
/* 661 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(55)('Int8', 1, function (init) {
	  return function Int8Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ },
/* 662 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(55)('Uint16', 2, function (init) {
	  return function Uint16Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ },
/* 663 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(55)('Uint32', 4, function (init) {
	  return function Uint32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ },
/* 664 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(55)('Uint8', 1, function (init) {
	  return function Uint8Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ },
/* 665 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(55)('Uint8', 1, function (init) {
	  return function Uint8ClampedArray(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	}, true);

/***/ },
/* 666 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var weak = __webpack_require__(207);
	var validate = __webpack_require__(80);
	var WEAK_SET = 'WeakSet';
	
	// 23.4 WeakSet Objects
	__webpack_require__(104)(WEAK_SET, function (get) {
	  return function WeakSet() {
	    return get(this, arguments.length > 0 ? arguments[0] : undefined);
	  };
	}, {
	  // 23.4.3.1 WeakSet.prototype.add(value)
	  add: function add(value) {
	    return weak.def(validate(this, WEAK_SET), value, true);
	  }
	}, weak, false, true);

/***/ },
/* 667 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
	
	var $export = __webpack_require__(2);
	var flattenIntoArray = __webpack_require__(208);
	var toObject = __webpack_require__(24);
	var toLength = __webpack_require__(22);
	var aFunction = __webpack_require__(27);
	var arraySpeciesCreate = __webpack_require__(132);
	
	$export($export.P, 'Array', {
	  flatMap: function flatMap(callbackfn /* , thisArg */) {
	    var O = toObject(this);
	    var sourceLen, A;
	    aFunction(callbackfn);
	    sourceLen = toLength(O.length);
	    A = arraySpeciesCreate(O, 0);
	    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
	    return A;
	  }
	});
	
	__webpack_require__(60)('flatMap');

/***/ },
/* 668 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
	
	var $export = __webpack_require__(2);
	var flattenIntoArray = __webpack_require__(208);
	var toObject = __webpack_require__(24);
	var toLength = __webpack_require__(22);
	var toInteger = __webpack_require__(51);
	var arraySpeciesCreate = __webpack_require__(132);
	
	$export($export.P, 'Array', {
	  flatten: function flatten() /* depthArg = 1 */{
	    var depthArg = arguments[0];
	    var O = toObject(this);
	    var sourceLen = toLength(O.length);
	    var A = arraySpeciesCreate(O, 0);
	    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
	    return A;
	  }
	});
	
	__webpack_require__(60)('flatten');

/***/ },
/* 669 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/Array.prototype.includes
	
	var $export = __webpack_require__(2);
	var $includes = __webpack_require__(103)(true);
	
	$export($export.P, 'Array', {
	  includes: function includes(el /* , fromIndex = 0 */) {
	    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	
	__webpack_require__(60)('includes');

/***/ },
/* 670 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
	var $export = __webpack_require__(2);
	var microtask = __webpack_require__(144)();
	var process = __webpack_require__(8).process;
	var isNode = __webpack_require__(43)(process) == 'process';
	
	$export($export.G, {
	  asap: function asap(fn) {
	    var domain = isNode && process.domain;
	    microtask(domain ? domain.bind(fn) : fn);
	  }
	});

/***/ },
/* 671 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// https://github.com/ljharb/proposal-is-error
	var $export = __webpack_require__(2);
	var cof = __webpack_require__(43);
	
	$export($export.S, 'Error', {
	  isError: function isError(it) {
	    return cof(it) === 'Error';
	  }
	});

/***/ },
/* 672 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// https://github.com/tc39/proposal-global
	var $export = __webpack_require__(2);
	
	$export($export.G, { global: __webpack_require__(8) });

/***/ },
/* 673 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
	__webpack_require__(113)('Map');

/***/ },
/* 674 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
	__webpack_require__(114)('Map');

/***/ },
/* 675 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export = __webpack_require__(2);
	
	$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(206)('Map') });

/***/ },
/* 676 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', {
	  clamp: function clamp(x, lower, upper) {
	    return Math.min(upper, Math.max(lower, x));
	  }
	});

/***/ },
/* 677 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });

/***/ },
/* 678 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(2);
	var RAD_PER_DEG = 180 / Math.PI;
	
	$export($export.S, 'Math', {
	  degrees: function degrees(radians) {
	    return radians * RAD_PER_DEG;
	  }
	});

/***/ },
/* 679 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(2);
	var scale = __webpack_require__(215);
	var fround = __webpack_require__(213);
	
	$export($export.S, 'Math', {
	  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
	    return fround(scale(x, inLow, inHigh, outLow, outHigh));
	  }
	});

/***/ },
/* 680 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', {
	  iaddh: function iaddh(x0, x1, y0, y1) {
	    var $x0 = x0 >>> 0;
	    var $x1 = x1 >>> 0;
	    var $y0 = y0 >>> 0;
	    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
	  }
	});

/***/ },
/* 681 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', {
	  imulh: function imulh(u, v) {
	    var UINT16 = 0xffff;
	    var $u = +u;
	    var $v = +v;
	    var u0 = $u & UINT16;
	    var v0 = $v & UINT16;
	    var u1 = $u >> 16;
	    var v1 = $v >> 16;
	    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
	  }
	});

/***/ },
/* 682 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', {
	  isubh: function isubh(x0, x1, y0, y1) {
	    var $x0 = x0 >>> 0;
	    var $x1 = x1 >>> 0;
	    var $y0 = y0 >>> 0;
	    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
	  }
	});

/***/ },
/* 683 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });

/***/ },
/* 684 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(2);
	var DEG_PER_RAD = Math.PI / 180;
	
	$export($export.S, 'Math', {
	  radians: function radians(degrees) {
	    return degrees * DEG_PER_RAD;
	  }
	});

/***/ },
/* 685 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', { scale: __webpack_require__(215) });

/***/ },
/* 686 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// http://jfbastien.github.io/papers/Math.signbit.html
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', { signbit: function signbit(x) {
	    // eslint-disable-next-line no-self-compare
	    return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
	  } });

/***/ },
/* 687 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', {
	  umulh: function umulh(u, v) {
	    var UINT16 = 0xffff;
	    var $u = +u;
	    var $v = +v;
	    var u0 = $u & UINT16;
	    var v0 = $v & UINT16;
	    var u1 = $u >>> 16;
	    var v1 = $v >>> 16;
	    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
	  }
	});

/***/ },
/* 688 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var $export = __webpack_require__(2);
	var toObject = __webpack_require__(24);
	var aFunction = __webpack_require__(27);
	var $defineProperty = __webpack_require__(21);
	
	// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
	__webpack_require__(20) && $export($export.P + __webpack_require__(111), 'Object', {
	  __defineGetter__: function __defineGetter__(P, getter) {
	    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
	  }
	});

/***/ },
/* 689 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var $export = __webpack_require__(2);
	var toObject = __webpack_require__(24);
	var aFunction = __webpack_require__(27);
	var $defineProperty = __webpack_require__(21);
	
	// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
	__webpack_require__(20) && $export($export.P + __webpack_require__(111), 'Object', {
	  __defineSetter__: function __defineSetter__(P, setter) {
	    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
	  }
	});

/***/ },
/* 690 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(2);
	var $entries = __webpack_require__(220)(true);
	
	$export($export.S, 'Object', {
	  entries: function entries(it) {
	    return $entries(it);
	  }
	});

/***/ },
/* 691 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// https://github.com/tc39/proposal-object-getownpropertydescriptors
	var $export = __webpack_require__(2);
	var ownKeys = __webpack_require__(221);
	var toIObject = __webpack_require__(37);
	var gOPD = __webpack_require__(39);
	var createProperty = __webpack_require__(133);
	
	$export($export.S, 'Object', {
	  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
	    var O = toIObject(object);
	    var getDesc = gOPD.f;
	    var keys = ownKeys(O);
	    var result = {};
	    var i = 0;
	    var key, desc;
	    while (keys.length > i) {
	      desc = getDesc(O, key = keys[i++]);
	      if (desc !== undefined) createProperty(result, key, desc);
	    }
	    return result;
	  }
	});

/***/ },
/* 692 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var $export = __webpack_require__(2);
	var toObject = __webpack_require__(24);
	var toPrimitive = __webpack_require__(52);
	var getPrototypeOf = __webpack_require__(40);
	var getOwnPropertyDescriptor = __webpack_require__(39).f;
	
	// B.2.2.4 Object.prototype.__lookupGetter__(P)
	__webpack_require__(20) && $export($export.P + __webpack_require__(111), 'Object', {
	  __lookupGetter__: function __lookupGetter__(P) {
	    var O = toObject(this);
	    var K = toPrimitive(P, true);
	    var D;
	    do {
	      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
	    } while (O = getPrototypeOf(O));
	  }
	});

/***/ },
/* 693 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var $export = __webpack_require__(2);
	var toObject = __webpack_require__(24);
	var toPrimitive = __webpack_require__(52);
	var getPrototypeOf = __webpack_require__(40);
	var getOwnPropertyDescriptor = __webpack_require__(39).f;
	
	// B.2.2.5 Object.prototype.__lookupSetter__(P)
	__webpack_require__(20) && $export($export.P + __webpack_require__(111), 'Object', {
	  __lookupSetter__: function __lookupSetter__(P) {
	    var O = toObject(this);
	    var K = toPrimitive(P, true);
	    var D;
	    do {
	      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
	    } while (O = getPrototypeOf(O));
	  }
	});

/***/ },
/* 694 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(2);
	var $values = __webpack_require__(220)(false);
	
	$export($export.S, 'Object', {
	  values: function values(it) {
	    return $values(it);
	  }
	});

/***/ },
/* 695 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/zenparsing/es-observable
	
	var $export = __webpack_require__(2);
	var global = __webpack_require__(8);
	var core = __webpack_require__(48);
	var microtask = __webpack_require__(144)();
	var OBSERVABLE = __webpack_require__(17)('observable');
	var aFunction = __webpack_require__(27);
	var anObject = __webpack_require__(7);
	var anInstance = __webpack_require__(65);
	var redefineAll = __webpack_require__(71);
	var hide = __webpack_require__(34);
	var forOf = __webpack_require__(66);
	var RETURN = forOf.RETURN;
	
	var getMethod = function getMethod(fn) {
	  return fn == null ? undefined : aFunction(fn);
	};
	
	var cleanupSubscription = function cleanupSubscription(subscription) {
	  var cleanup = subscription._c;
	  if (cleanup) {
	    subscription._c = undefined;
	    cleanup();
	  }
	};
	
	var subscriptionClosed = function subscriptionClosed(subscription) {
	  return subscription._o === undefined;
	};
	
	var closeSubscription = function closeSubscription(subscription) {
	  if (!subscriptionClosed(subscription)) {
	    subscription._o = undefined;
	    cleanupSubscription(subscription);
	  }
	};
	
	var Subscription = function Subscription(observer, subscriber) {
	  anObject(observer);
	  this._c = undefined;
	  this._o = observer;
	  observer = new SubscriptionObserver(this);
	  try {
	    var cleanup = subscriber(observer);
	    var subscription = cleanup;
	    if (cleanup != null) {
	      if (typeof cleanup.unsubscribe === 'function') cleanup = function cleanup() {
	        subscription.unsubscribe();
	      };else aFunction(cleanup);
	      this._c = cleanup;
	    }
	  } catch (e) {
	    observer.error(e);
	    return;
	  }if (subscriptionClosed(this)) cleanupSubscription(this);
	};
	
	Subscription.prototype = redefineAll({}, {
	  unsubscribe: function unsubscribe() {
	    closeSubscription(this);
	  }
	});
	
	var SubscriptionObserver = function SubscriptionObserver(subscription) {
	  this._s = subscription;
	};
	
	SubscriptionObserver.prototype = redefineAll({}, {
	  next: function next(value) {
	    var subscription = this._s;
	    if (!subscriptionClosed(subscription)) {
	      var observer = subscription._o;
	      try {
	        var m = getMethod(observer.next);
	        if (m) return m.call(observer, value);
	      } catch (e) {
	        try {
	          closeSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      }
	    }
	  },
	  error: function error(value) {
	    var subscription = this._s;
	    if (subscriptionClosed(subscription)) throw value;
	    var observer = subscription._o;
	    subscription._o = undefined;
	    try {
	      var m = getMethod(observer.error);
	      if (!m) throw value;
	      value = m.call(observer, value);
	    } catch (e) {
	      try {
	        cleanupSubscription(subscription);
	      } finally {
	        throw e;
	      }
	    }cleanupSubscription(subscription);
	    return value;
	  },
	  complete: function complete(value) {
	    var subscription = this._s;
	    if (!subscriptionClosed(subscription)) {
	      var observer = subscription._o;
	      subscription._o = undefined;
	      try {
	        var m = getMethod(observer.complete);
	        value = m ? m.call(observer, value) : undefined;
	      } catch (e) {
	        try {
	          cleanupSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      }cleanupSubscription(subscription);
	      return value;
	    }
	  }
	});
	
	var $Observable = function Observable(subscriber) {
	  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
	};
	
	redefineAll($Observable.prototype, {
	  subscribe: function subscribe(observer) {
	    return new Subscription(observer, this._f);
	  },
	  forEach: function forEach(fn) {
	    var that = this;
	    return new (core.Promise || global.Promise)(function (resolve, reject) {
	      aFunction(fn);
	      var subscription = that.subscribe({
	        next: function next(value) {
	          try {
	            return fn(value);
	          } catch (e) {
	            reject(e);
	            subscription.unsubscribe();
	          }
	        },
	        error: reject,
	        complete: resolve
	      });
	    });
	  }
	});
	
	redefineAll($Observable, {
	  from: function from(x) {
	    var C = typeof this === 'function' ? this : $Observable;
	    var method = getMethod(anObject(x)[OBSERVABLE]);
	    if (method) {
	      var observable = anObject(method.call(x));
	      return observable.constructor === C ? observable : new C(function (observer) {
	        return observable.subscribe(observer);
	      });
	    }
	    return new C(function (observer) {
	      var done = false;
	      microtask(function () {
	        if (!done) {
	          try {
	            if (forOf(x, false, function (it) {
	              observer.next(it);
	              if (done) return RETURN;
	            }) === RETURN) return;
	          } catch (e) {
	            if (done) throw e;
	            observer.error(e);
	            return;
	          }observer.complete();
	        }
	      });
	      return function () {
	        done = true;
	      };
	    });
	  },
	  of: function of() {
	    for (var i = 0, l = arguments.length, items = Array(l); i < l;) {
	      items[i] = arguments[i++];
	    }return new (typeof this === 'function' ? this : $Observable)(function (observer) {
	      var done = false;
	      microtask(function () {
	        if (!done) {
	          for (var j = 0; j < items.length; ++j) {
	            observer.next(items[j]);
	            if (done) return;
	          }observer.complete();
	        }
	      });
	      return function () {
	        done = true;
	      };
	    });
	  }
	});
	
	hide($Observable.prototype, OBSERVABLE, function () {
	  return this;
	});
	
	$export($export.G, { Observable: $Observable });
	
	__webpack_require__(72)('Observable');

/***/ },
/* 696 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-promise-finally
	'use strict';
	
	var $export = __webpack_require__(2);
	var core = __webpack_require__(48);
	var global = __webpack_require__(8);
	var speciesConstructor = __webpack_require__(116);
	var promiseResolve = __webpack_require__(225);
	
	$export($export.P + $export.R, 'Promise', { 'finally': function _finally(onFinally) {
	    var C = speciesConstructor(this, core.Promise || global.Promise);
	    var isFunction = typeof onFinally == 'function';
	    return this.then(isFunction ? function (x) {
	      return promiseResolve(C, onFinally()).then(function () {
	        return x;
	      });
	    } : onFinally, isFunction ? function (e) {
	      return promiseResolve(C, onFinally()).then(function () {
	        throw e;
	      });
	    } : onFinally);
	  } });

/***/ },
/* 697 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-promise-try
	
	var $export = __webpack_require__(2);
	var newPromiseCapability = __webpack_require__(145);
	var perform = __webpack_require__(224);
	
	$export($export.S, 'Promise', { 'try': function _try(callbackfn) {
	    var promiseCapability = newPromiseCapability.f(this);
	    var result = perform(callbackfn);
	    (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
	    return promiseCapability.promise;
	  } });

/***/ },
/* 698 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var metadata = __webpack_require__(54);
	var anObject = __webpack_require__(7);
	var toMetaKey = metadata.key;
	var ordinaryDefineOwnMetadata = metadata.set;
	
	metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
	    ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
	  } });

/***/ },
/* 699 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var metadata = __webpack_require__(54);
	var anObject = __webpack_require__(7);
	var toMetaKey = metadata.key;
	var getOrCreateMetadataMap = metadata.map;
	var store = metadata.store;
	
	metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
	    var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
	    var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
	    if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
	    if (metadataMap.size) return true;
	    var targetMetadata = store.get(target);
	    targetMetadata['delete'](targetKey);
	    return !!targetMetadata.size || store['delete'](target);
	  } });

/***/ },
/* 700 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Set = __webpack_require__(231);
	var from = __webpack_require__(202);
	var metadata = __webpack_require__(54);
	var anObject = __webpack_require__(7);
	var getPrototypeOf = __webpack_require__(40);
	var ordinaryOwnMetadataKeys = metadata.keys;
	var toMetaKey = metadata.key;
	
	var ordinaryMetadataKeys = function ordinaryMetadataKeys(O, P) {
	  var oKeys = ordinaryOwnMetadataKeys(O, P);
	  var parent = getPrototypeOf(O);
	  if (parent === null) return oKeys;
	  var pKeys = ordinaryMetadataKeys(parent, P);
	  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
	};
	
	metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
	    return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	  } });

/***/ },
/* 701 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var metadata = __webpack_require__(54);
	var anObject = __webpack_require__(7);
	var getPrototypeOf = __webpack_require__(40);
	var ordinaryHasOwnMetadata = metadata.has;
	var ordinaryGetOwnMetadata = metadata.get;
	var toMetaKey = metadata.key;
	
	var ordinaryGetMetadata = function ordinaryGetMetadata(MetadataKey, O, P) {
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
	};
	
	metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
	    return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	  } });

/***/ },
/* 702 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var metadata = __webpack_require__(54);
	var anObject = __webpack_require__(7);
	var ordinaryOwnMetadataKeys = metadata.keys;
	var toMetaKey = metadata.key;
	
	metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
	    return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	  } });

/***/ },
/* 703 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var metadata = __webpack_require__(54);
	var anObject = __webpack_require__(7);
	var ordinaryGetOwnMetadata = metadata.get;
	var toMetaKey = metadata.key;
	
	metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
	    return ordinaryGetOwnMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	  } });

/***/ },
/* 704 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var metadata = __webpack_require__(54);
	var anObject = __webpack_require__(7);
	var getPrototypeOf = __webpack_require__(40);
	var ordinaryHasOwnMetadata = metadata.has;
	var toMetaKey = metadata.key;
	
	var ordinaryHasMetadata = function ordinaryHasMetadata(MetadataKey, O, P) {
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if (hasOwn) return true;
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
	};
	
	metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
	    return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	  } });

/***/ },
/* 705 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var metadata = __webpack_require__(54);
	var anObject = __webpack_require__(7);
	var ordinaryHasOwnMetadata = metadata.has;
	var toMetaKey = metadata.key;
	
	metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
	    return ordinaryHasOwnMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	  } });

/***/ },
/* 706 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var $metadata = __webpack_require__(54);
	var anObject = __webpack_require__(7);
	var aFunction = __webpack_require__(27);
	var toMetaKey = $metadata.key;
	var ordinaryDefineOwnMetadata = $metadata.set;
	
	$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
	    return function decorator(target, targetKey) {
	      ordinaryDefineOwnMetadata(metadataKey, metadataValue, (targetKey !== undefined ? anObject : aFunction)(target), toMetaKey(targetKey));
	    };
	  } });

/***/ },
/* 707 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
	__webpack_require__(113)('Set');

/***/ },
/* 708 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
	__webpack_require__(114)('Set');

/***/ },
/* 709 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export = __webpack_require__(2);
	
	$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(206)('Set') });

/***/ },
/* 710 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/mathiasbynens/String.prototype.at
	
	var $export = __webpack_require__(2);
	var $at = __webpack_require__(148)(true);
	
	$export($export.P, 'String', {
	  at: function at(pos) {
	    return $at(this, pos);
	  }
	});

/***/ },
/* 711 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/String.prototype.matchAll/
	
	var $export = __webpack_require__(2);
	var defined = __webpack_require__(49);
	var toLength = __webpack_require__(22);
	var isRegExp = __webpack_require__(109);
	var getFlags = __webpack_require__(106);
	var RegExpProto = RegExp.prototype;
	
	var $RegExpStringIterator = function $RegExpStringIterator(regexp, string) {
	  this._r = regexp;
	  this._s = string;
	};
	
	__webpack_require__(140)($RegExpStringIterator, 'RegExp String', function next() {
	  var match = this._r.exec(this._s);
	  return { value: match, done: match === null };
	});
	
	$export($export.P, 'String', {
	  matchAll: function matchAll(regexp) {
	    defined(this);
	    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
	    var S = String(this);
	    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
	    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
	    rx.lastIndex = toLength(regexp.lastIndex);
	    return new $RegExpStringIterator(rx, S);
	  }
	});

/***/ },
/* 712 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	
	var $export = __webpack_require__(2);
	var $pad = __webpack_require__(226);
	
	$export($export.P, 'String', {
	  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
	  }
	});

/***/ },
/* 713 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	
	var $export = __webpack_require__(2);
	var $pad = __webpack_require__(226);
	
	$export($export.P, 'String', {
	  padStart: function padStart(maxLength /* , fillString = ' ' */) {
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
	  }
	});

/***/ },
/* 714 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	
	__webpack_require__(79)('trimLeft', function ($trim) {
	  return function trimLeft() {
	    return $trim(this, 1);
	  };
	}, 'trimStart');

/***/ },
/* 715 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	
	__webpack_require__(79)('trimRight', function ($trim) {
	  return function trimRight() {
	    return $trim(this, 2);
	  };
	}, 'trimEnd');

/***/ },
/* 716 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(154)('asyncIterator');

/***/ },
/* 717 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(154)('observable');

/***/ },
/* 718 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// https://github.com/tc39/proposal-global
	var $export = __webpack_require__(2);
	
	$export($export.S, 'System', { global: __webpack_require__(8) });

/***/ },
/* 719 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
	__webpack_require__(113)('WeakMap');

/***/ },
/* 720 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
	__webpack_require__(114)('WeakMap');

/***/ },
/* 721 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
	__webpack_require__(113)('WeakSet');

/***/ },
/* 722 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
	__webpack_require__(114)('WeakSet');

/***/ },
/* 723 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var $iterators = __webpack_require__(156);
	var getKeys = __webpack_require__(62);
	var redefine = __webpack_require__(35);
	var global = __webpack_require__(8);
	var hide = __webpack_require__(34);
	var Iterators = __webpack_require__(77);
	var wks = __webpack_require__(17);
	var ITERATOR = wks('iterator');
	var TO_STRING_TAG = wks('toStringTag');
	var ArrayValues = Iterators.Array;
	
	var DOMIterables = {
	  CSSRuleList: true, // TODO: Not spec compliant, should be false.
	  CSSStyleDeclaration: false,
	  CSSValueList: false,
	  ClientRectList: false,
	  DOMRectList: false,
	  DOMStringList: false,
	  DOMTokenList: true,
	  DataTransferItemList: false,
	  FileList: false,
	  HTMLAllCollection: false,
	  HTMLCollection: false,
	  HTMLFormElement: false,
	  HTMLSelectElement: false,
	  MediaList: true, // TODO: Not spec compliant, should be false.
	  MimeTypeArray: false,
	  NamedNodeMap: false,
	  NodeList: true,
	  PaintRequestList: false,
	  Plugin: false,
	  PluginArray: false,
	  SVGLengthList: false,
	  SVGNumberList: false,
	  SVGPathSegList: false,
	  SVGPointList: false,
	  SVGStringList: false,
	  SVGTransformList: false,
	  SourceBufferList: false,
	  StyleSheetList: true, // TODO: Not spec compliant, should be false.
	  TextTrackCueList: false,
	  TextTrackList: false,
	  TouchList: false
	};
	
	for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
	  var NAME = collections[i];
	  var explicit = DOMIterables[NAME];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  var key;
	  if (proto) {
	    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
	    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	    Iterators[NAME] = ArrayValues;
	    if (explicit) for (key in $iterators) {
	      if (!proto[key]) redefine(proto, key, $iterators[key], true);
	    }
	  }
	}

/***/ },
/* 724 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var $export = __webpack_require__(2);
	var $task = __webpack_require__(152);
	$export($export.G + $export.B, {
	  setImmediate: $task.set,
	  clearImmediate: $task.clear
	});

/***/ },
/* 725 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// ie9- setTimeout & setInterval additional parameters fix
	var global = __webpack_require__(8);
	var $export = __webpack_require__(2);
	var invoke = __webpack_require__(107);
	var partial = __webpack_require__(530);
	var navigator = global.navigator;
	var MSIE = !!navigator && /MSIE .\./.test(navigator.userAgent); // <- dirty ie9- check
	var wrap = function wrap(set) {
	  return MSIE ? function (fn, time /* , ...args */) {
	    return set(invoke(partial, [].slice.call(arguments, 2),
	    // eslint-disable-next-line no-new-func
	    typeof fn == 'function' ? fn : Function(fn)), time);
	  } : set;
	};
	$export($export.G + $export.B + $export.F * MSIE, {
	  setTimeout: wrap(global.setTimeout),
	  setInterval: wrap(global.setInterval)
	});

/***/ },
/* 726 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(654);
	__webpack_require__(593);
	__webpack_require__(595);
	__webpack_require__(594);
	__webpack_require__(597);
	__webpack_require__(599);
	__webpack_require__(604);
	__webpack_require__(598);
	__webpack_require__(596);
	__webpack_require__(606);
	__webpack_require__(605);
	__webpack_require__(601);
	__webpack_require__(602);
	__webpack_require__(600);
	__webpack_require__(592);
	__webpack_require__(603);
	__webpack_require__(607);
	__webpack_require__(608);
	__webpack_require__(560);
	__webpack_require__(562);
	__webpack_require__(561);
	__webpack_require__(610);
	__webpack_require__(609);
	__webpack_require__(580);
	__webpack_require__(590);
	__webpack_require__(591);
	__webpack_require__(581);
	__webpack_require__(582);
	__webpack_require__(583);
	__webpack_require__(584);
	__webpack_require__(585);
	__webpack_require__(586);
	__webpack_require__(587);
	__webpack_require__(588);
	__webpack_require__(589);
	__webpack_require__(563);
	__webpack_require__(564);
	__webpack_require__(565);
	__webpack_require__(566);
	__webpack_require__(567);
	__webpack_require__(568);
	__webpack_require__(569);
	__webpack_require__(570);
	__webpack_require__(571);
	__webpack_require__(572);
	__webpack_require__(573);
	__webpack_require__(574);
	__webpack_require__(575);
	__webpack_require__(576);
	__webpack_require__(577);
	__webpack_require__(578);
	__webpack_require__(579);
	__webpack_require__(641);
	__webpack_require__(646);
	__webpack_require__(653);
	__webpack_require__(644);
	__webpack_require__(636);
	__webpack_require__(637);
	__webpack_require__(642);
	__webpack_require__(647);
	__webpack_require__(649);
	__webpack_require__(632);
	__webpack_require__(633);
	__webpack_require__(634);
	__webpack_require__(635);
	__webpack_require__(638);
	__webpack_require__(639);
	__webpack_require__(640);
	__webpack_require__(643);
	__webpack_require__(645);
	__webpack_require__(648);
	__webpack_require__(650);
	__webpack_require__(651);
	__webpack_require__(652);
	__webpack_require__(555);
	__webpack_require__(557);
	__webpack_require__(556);
	__webpack_require__(559);
	__webpack_require__(558);
	__webpack_require__(544);
	__webpack_require__(542);
	__webpack_require__(548);
	__webpack_require__(545);
	__webpack_require__(551);
	__webpack_require__(553);
	__webpack_require__(541);
	__webpack_require__(547);
	__webpack_require__(538);
	__webpack_require__(552);
	__webpack_require__(536);
	__webpack_require__(550);
	__webpack_require__(549);
	__webpack_require__(543);
	__webpack_require__(546);
	__webpack_require__(535);
	__webpack_require__(537);
	__webpack_require__(540);
	__webpack_require__(539);
	__webpack_require__(554);
	__webpack_require__(156);
	__webpack_require__(626);
	__webpack_require__(631);
	__webpack_require__(230);
	__webpack_require__(627);
	__webpack_require__(628);
	__webpack_require__(629);
	__webpack_require__(630);
	__webpack_require__(611);
	__webpack_require__(229);
	__webpack_require__(231);
	__webpack_require__(232);
	__webpack_require__(666);
	__webpack_require__(655);
	__webpack_require__(656);
	__webpack_require__(661);
	__webpack_require__(664);
	__webpack_require__(665);
	__webpack_require__(659);
	__webpack_require__(662);
	__webpack_require__(660);
	__webpack_require__(663);
	__webpack_require__(657);
	__webpack_require__(658);
	__webpack_require__(612);
	__webpack_require__(613);
	__webpack_require__(614);
	__webpack_require__(615);
	__webpack_require__(616);
	__webpack_require__(619);
	__webpack_require__(617);
	__webpack_require__(618);
	__webpack_require__(620);
	__webpack_require__(621);
	__webpack_require__(622);
	__webpack_require__(623);
	__webpack_require__(625);
	__webpack_require__(624);
	__webpack_require__(669);
	__webpack_require__(667);
	__webpack_require__(668);
	__webpack_require__(710);
	__webpack_require__(713);
	__webpack_require__(712);
	__webpack_require__(714);
	__webpack_require__(715);
	__webpack_require__(711);
	__webpack_require__(716);
	__webpack_require__(717);
	__webpack_require__(691);
	__webpack_require__(694);
	__webpack_require__(690);
	__webpack_require__(688);
	__webpack_require__(689);
	__webpack_require__(692);
	__webpack_require__(693);
	__webpack_require__(675);
	__webpack_require__(709);
	__webpack_require__(674);
	__webpack_require__(708);
	__webpack_require__(720);
	__webpack_require__(722);
	__webpack_require__(673);
	__webpack_require__(707);
	__webpack_require__(719);
	__webpack_require__(721);
	__webpack_require__(672);
	__webpack_require__(718);
	__webpack_require__(671);
	__webpack_require__(676);
	__webpack_require__(677);
	__webpack_require__(678);
	__webpack_require__(679);
	__webpack_require__(680);
	__webpack_require__(682);
	__webpack_require__(681);
	__webpack_require__(683);
	__webpack_require__(684);
	__webpack_require__(685);
	__webpack_require__(687);
	__webpack_require__(686);
	__webpack_require__(696);
	__webpack_require__(697);
	__webpack_require__(698);
	__webpack_require__(699);
	__webpack_require__(701);
	__webpack_require__(700);
	__webpack_require__(703);
	__webpack_require__(702);
	__webpack_require__(704);
	__webpack_require__(705);
	__webpack_require__(706);
	__webpack_require__(670);
	__webpack_require__(695);
	__webpack_require__(725);
	__webpack_require__(724);
	__webpack_require__(723);
	module.exports = __webpack_require__(48);

/***/ },
/* 727 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _assign = __webpack_require__(11);
	
	var emptyObject = __webpack_require__(120);
	var _invariant = __webpack_require__(5);
	
	if (false) {
	  var warning = require('fbjs/lib/warning');
	}
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	var ReactPropTypeLocationNames;
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	} else {
	  ReactPropTypeLocationNames = {};
	}
	
	function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
	  /**
	   * Policies that describe methods in `ReactClassInterface`.
	   */
	
	  var injectedMixins = [];
	
	  /**
	   * Composite components are higher-level components that compose other composite
	   * or host components.
	   *
	   * To create a new type of `ReactClass`, pass a specification of
	   * your new class to `React.createClass`. The only requirement of your class
	   * specification is that you implement a `render` method.
	   *
	   *   var MyComponent = React.createClass({
	   *     render: function() {
	   *       return <div>Hello World</div>;
	   *     }
	   *   });
	   *
	   * The class specification supports a specific protocol of methods that have
	   * special meaning (e.g. `render`). See `ReactClassInterface` for
	   * more the comprehensive protocol. Any other properties and methods in the
	   * class specification will be available on the prototype.
	   *
	   * @interface ReactClassInterface
	   * @internal
	   */
	  var ReactClassInterface = {
	    /**
	     * An array of Mixin objects to include when defining your component.
	     *
	     * @type {array}
	     * @optional
	     */
	    mixins: 'DEFINE_MANY',
	
	    /**
	     * An object containing properties and methods that should be defined on
	     * the component's constructor instead of its prototype (static methods).
	     *
	     * @type {object}
	     * @optional
	     */
	    statics: 'DEFINE_MANY',
	
	    /**
	     * Definition of prop types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    propTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    contextTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types this component sets for its children.
	     *
	     * @type {object}
	     * @optional
	     */
	    childContextTypes: 'DEFINE_MANY',
	
	    // ==== Definition methods ====
	
	    /**
	     * Invoked when the component is mounted. Values in the mapping will be set on
	     * `this.props` if that prop is not specified (i.e. using an `in` check).
	     *
	     * This method is invoked before `getInitialState` and therefore cannot rely
	     * on `this.state` or use `this.setState`.
	     *
	     * @return {object}
	     * @optional
	     */
	    getDefaultProps: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Invoked once before the component is mounted. The return value will be used
	     * as the initial value of `this.state`.
	     *
	     *   getInitialState: function() {
	     *     return {
	     *       isOn: false,
	     *       fooBaz: new BazFoo()
	     *     }
	     *   }
	     *
	     * @return {object}
	     * @optional
	     */
	    getInitialState: 'DEFINE_MANY_MERGED',
	
	    /**
	     * @return {object}
	     * @optional
	     */
	    getChildContext: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Uses props from `this.props` and state from `this.state` to render the
	     * structure of the component.
	     *
	     * No guarantees are made about when or how often this method is invoked, so
	     * it must not have side effects.
	     *
	     *   render: function() {
	     *     var name = this.props.name;
	     *     return <div>Hello, {name}!</div>;
	     *   }
	     *
	     * @return {ReactComponent}
	     * @required
	     */
	    render: 'DEFINE_ONCE',
	
	    // ==== Delegate methods ====
	
	    /**
	     * Invoked when the component is initially created and about to be mounted.
	     * This may have side effects, but any external subscriptions or data created
	     * by this method must be cleaned up in `componentWillUnmount`.
	     *
	     * @optional
	     */
	    componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component has been mounted and has a DOM representation.
	     * However, there is no guarantee that the DOM node is in the document.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been mounted (initialized and rendered) for the first time.
	     *
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked before the component receives new props.
	     *
	     * Use this as an opportunity to react to a prop transition by updating the
	     * state using `this.setState`. Current props are accessed via `this.props`.
	     *
	     *   componentWillReceiveProps: function(nextProps, nextContext) {
	     *     this.setState({
	     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	     *     });
	     *   }
	     *
	     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	     * transition may cause a state change, but the opposite is not true. If you
	     * need it, you are probably looking for `componentWillUpdate`.
	     *
	     * @param {object} nextProps
	     * @optional
	     */
	    componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Invoked while deciding if the component should be updated as a result of
	     * receiving new props, state and/or context.
	     *
	     * Use this as an opportunity to `return false` when you're certain that the
	     * transition to the new props/state/context will not require a component
	     * update.
	     *
	     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	     *     return !equal(nextProps, this.props) ||
	     *       !equal(nextState, this.state) ||
	     *       !equal(nextContext, this.context);
	     *   }
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @return {boolean} True if the component should update.
	     * @optional
	     */
	    shouldComponentUpdate: 'DEFINE_ONCE',
	
	    /**
	     * Invoked when the component is about to update due to a transition from
	     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	     * and `nextContext`.
	     *
	     * Use this as an opportunity to perform preparation before an update occurs.
	     *
	     * NOTE: You **cannot** use `this.setState()` in this method.
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @param {ReactReconcileTransaction} transaction
	     * @optional
	     */
	    componentWillUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component's DOM representation has been updated.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been updated.
	     *
	     * @param {object} prevProps
	     * @param {?object} prevState
	     * @param {?object} prevContext
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component is about to be removed from its parent and have
	     * its DOM representation destroyed.
	     *
	     * Use this as an opportunity to deallocate any external resources.
	     *
	     * NOTE: There is no `componentDidUnmount` since your component will have been
	     * destroyed by that point.
	     *
	     * @optional
	     */
	    componentWillUnmount: 'DEFINE_MANY',
	
	    // ==== Advanced methods ====
	
	    /**
	     * Updates the component's currently mounted DOM representation.
	     *
	     * By default, this implements React's rendering and reconciliation algorithm.
	     * Sophisticated clients may wish to override this.
	     *
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     * @overridable
	     */
	    updateComponent: 'OVERRIDE_BASE'
	  };
	
	  /**
	   * Mapping from class specification keys to special processing functions.
	   *
	   * Although these are declared like instance properties in the specification
	   * when defining classes using `React.createClass`, they are actually static
	   * and are accessible on the constructor instead of the prototype. Despite
	   * being static, they must be defined outside of the "statics" key under
	   * which all other static methods are defined.
	   */
	  var RESERVED_SPEC_KEYS = {
	    displayName: function displayName(Constructor, _displayName) {
	      Constructor.displayName = _displayName;
	    },
	    mixins: function mixins(Constructor, _mixins) {
	      if (_mixins) {
	        for (var i = 0; i < _mixins.length; i++) {
	          mixSpecIntoComponent(Constructor, _mixins[i]);
	        }
	      }
	    },
	    childContextTypes: function childContextTypes(Constructor, _childContextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, _childContextTypes, 'childContext');
	      }
	      Constructor.childContextTypes = _assign({}, Constructor.childContextTypes, _childContextTypes);
	    },
	    contextTypes: function contextTypes(Constructor, _contextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, _contextTypes, 'context');
	      }
	      Constructor.contextTypes = _assign({}, Constructor.contextTypes, _contextTypes);
	    },
	    /**
	     * Special case getDefaultProps which should move into statics but requires
	     * automatic merging.
	     */
	    getDefaultProps: function getDefaultProps(Constructor, _getDefaultProps) {
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps = createMergedResultFunction(Constructor.getDefaultProps, _getDefaultProps);
	      } else {
	        Constructor.getDefaultProps = _getDefaultProps;
	      }
	    },
	    propTypes: function propTypes(Constructor, _propTypes) {
	      if (false) {
	        validateTypeDef(Constructor, _propTypes, 'prop');
	      }
	      Constructor.propTypes = _assign({}, Constructor.propTypes, _propTypes);
	    },
	    statics: function statics(Constructor, _statics) {
	      mixStaticSpecIntoComponent(Constructor, _statics);
	    },
	    autobind: function autobind() {}
	  };
	
	  function validateTypeDef(Constructor, typeDef, location) {
	    for (var propName in typeDef) {
	      if (typeDef.hasOwnProperty(propName)) {
	        // use a warning instead of an _invariant so components
	        // don't show up in prod but only in __DEV__
	        if (false) {
	          warning(typeof typeDef[propName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', Constructor.displayName || 'ReactClass', ReactPropTypeLocationNames[location], propName);
	        }
	      }
	    }
	  }
	
	  function validateMethodOverride(isAlreadyDefined, name) {
	    var specPolicy = ReactClassInterface.hasOwnProperty(name) ? ReactClassInterface[name] : null;
	
	    // Disallow overriding of base class methods unless explicitly allowed.
	    if (ReactClassMixin.hasOwnProperty(name)) {
	      _invariant(specPolicy === 'OVERRIDE_BASE', 'ReactClassInterface: You are attempting to override ' + '`%s` from your class specification. Ensure that your method names ' + 'do not overlap with React methods.', name);
	    }
	
	    // Disallow defining methods more than once unless explicitly allowed.
	    if (isAlreadyDefined) {
	      _invariant(specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED', 'ReactClassInterface: You are attempting to define ' + '`%s` on your component more than once. This conflict may be due ' + 'to a mixin.', name);
	    }
	  }
	
	  /**
	   * Mixin helper which handles policy validation and reserved
	   * specification keys when building React classes.
	   */
	  function mixSpecIntoComponent(Constructor, spec) {
	    if (!spec) {
	      if (false) {
	        var typeofSpec = typeof spec === 'undefined' ? 'undefined' : _typeof(spec);
	        var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	        if (process.env.NODE_ENV !== 'production') {
	          warning(isMixinValid, "%s: You're attempting to include a mixin that is either null " + 'or not an object. Check the mixins included by the component, ' + 'as well as any mixins they include themselves. ' + 'Expected object but got %s.', Constructor.displayName || 'ReactClass', spec === null ? null : typeofSpec);
	        }
	      }
	
	      return;
	    }
	
	    _invariant(typeof spec !== 'function', "ReactClass: You're attempting to " + 'use a component class or function as a mixin. Instead, just use a ' + 'regular object.');
	    _invariant(!isValidElement(spec), "ReactClass: You're attempting to " + 'use a component as a mixin. Instead, just use a regular object.');
	
	    var proto = Constructor.prototype;
	    var autoBindPairs = proto.__reactAutoBindPairs;
	
	    // By handling mixins before any other properties, we ensure the same
	    // chaining order is applied to methods with DEFINE_MANY policy, whether
	    // mixins are listed before or after these methods in the spec.
	    if (spec.hasOwnProperty(MIXINS_KEY)) {
	      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	    }
	
	    for (var name in spec) {
	      if (!spec.hasOwnProperty(name)) {
	        continue;
	      }
	
	      if (name === MIXINS_KEY) {
	        // We have already handled mixins in a special case above.
	        continue;
	      }
	
	      var property = spec[name];
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      validateMethodOverride(isAlreadyDefined, name);
	
	      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	        RESERVED_SPEC_KEYS[name](Constructor, property);
	      } else {
	        // Setup methods on prototype:
	        // The following member methods should not be automatically bound:
	        // 1. Expected ReactClass methods (in the "interface").
	        // 2. Overridden methods (that were mixed in).
	        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	        var isFunction = typeof property === 'function';
	        var shouldAutoBind = isFunction && !isReactClassMethod && !isAlreadyDefined && spec.autobind !== false;
	
	        if (shouldAutoBind) {
	          autoBindPairs.push(name, property);
	          proto[name] = property;
	        } else {
	          if (isAlreadyDefined) {
	            var specPolicy = ReactClassInterface[name];
	
	            // These cases should already be caught by validateMethodOverride.
	            _invariant(isReactClassMethod && (specPolicy === 'DEFINE_MANY_MERGED' || specPolicy === 'DEFINE_MANY'), 'ReactClass: Unexpected spec policy %s for key %s ' + 'when mixing in component specs.', specPolicy, name);
	
	            // For methods which are defined more than once, call the existing
	            // methods before calling the new property, merging if appropriate.
	            if (specPolicy === 'DEFINE_MANY_MERGED') {
	              proto[name] = createMergedResultFunction(proto[name], property);
	            } else if (specPolicy === 'DEFINE_MANY') {
	              proto[name] = createChainedFunction(proto[name], property);
	            }
	          } else {
	            proto[name] = property;
	            if (false) {
	              // Add verbose displayName to the function, which helps when looking
	              // at profiling tools.
	              if (typeof property === 'function' && spec.displayName) {
	                proto[name].displayName = spec.displayName + '_' + name;
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	
	  function mixStaticSpecIntoComponent(Constructor, statics) {
	    if (!statics) {
	      return;
	    }
	    for (var name in statics) {
	      var property = statics[name];
	      if (!statics.hasOwnProperty(name)) {
	        continue;
	      }
	
	      var isReserved = name in RESERVED_SPEC_KEYS;
	      _invariant(!isReserved, 'ReactClass: You are attempting to define a reserved ' + 'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' + 'as an instance property instead; it will still be accessible on the ' + 'constructor.', name);
	
	      var isInherited = name in Constructor;
	      _invariant(!isInherited, 'ReactClass: You are attempting to define ' + '`%s` on your component more than once. This conflict may be ' + 'due to a mixin.', name);
	      Constructor[name] = property;
	    }
	  }
	
	  /**
	   * Merge two objects, but throw if both contain the same key.
	   *
	   * @param {object} one The first object, which is mutated.
	   * @param {object} two The second object
	   * @return {object} one after it has been mutated to contain everything in two.
	   */
	  function mergeIntoWithNoDuplicateKeys(one, two) {
	    _invariant(one && two && (typeof one === 'undefined' ? 'undefined' : _typeof(one)) === 'object' && (typeof two === 'undefined' ? 'undefined' : _typeof(two)) === 'object', 'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.');
	
	    for (var key in two) {
	      if (two.hasOwnProperty(key)) {
	        _invariant(one[key] === undefined, 'mergeIntoWithNoDuplicateKeys(): ' + 'Tried to merge two objects with the same key: `%s`. This conflict ' + 'may be due to a mixin; in particular, this may be caused by two ' + 'getInitialState() or getDefaultProps() methods returning objects ' + 'with clashing keys.', key);
	        one[key] = two[key];
	      }
	    }
	    return one;
	  }
	
	  /**
	   * Creates a function that invokes two functions and merges their return values.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createMergedResultFunction(one, two) {
	    return function mergedResult() {
	      var a = one.apply(this, arguments);
	      var b = two.apply(this, arguments);
	      if (a == null) {
	        return b;
	      } else if (b == null) {
	        return a;
	      }
	      var c = {};
	      mergeIntoWithNoDuplicateKeys(c, a);
	      mergeIntoWithNoDuplicateKeys(c, b);
	      return c;
	    };
	  }
	
	  /**
	   * Creates a function that invokes two functions and ignores their return vales.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createChainedFunction(one, two) {
	    return function chainedFunction() {
	      one.apply(this, arguments);
	      two.apply(this, arguments);
	    };
	  }
	
	  /**
	   * Binds a method to the component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   * @param {function} method Method to be bound.
	   * @return {function} The bound method.
	   */
	  function bindAutoBindMethod(component, method) {
	    var boundMethod = method.bind(component);
	    if (false) {
	      boundMethod.__reactBoundContext = component;
	      boundMethod.__reactBoundMethod = method;
	      boundMethod.__reactBoundArguments = null;
	      var componentName = component.constructor.displayName;
	      var _bind = boundMethod.bind;
	      boundMethod.bind = function (newThis) {
	        for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        // User is trying to bind() an autobound method; we effectively will
	        // ignore the value of "this" that the user is trying to use, so
	        // let's warn.
	        if (newThis !== component && newThis !== null) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(false, 'bind(): React component methods may only be bound to the ' + 'component instance. See %s', componentName);
	          }
	        } else if (!args.length) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(false, 'bind(): You are binding a component method to the component. ' + 'React does this for you automatically in a high-performance ' + 'way, so you can safely remove this call. See %s', componentName);
	          }
	          return boundMethod;
	        }
	        var reboundMethod = _bind.apply(boundMethod, arguments);
	        reboundMethod.__reactBoundContext = component;
	        reboundMethod.__reactBoundMethod = method;
	        reboundMethod.__reactBoundArguments = args;
	        return reboundMethod;
	      };
	    }
	    return boundMethod;
	  }
	
	  /**
	   * Binds all auto-bound methods in a component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   */
	  function bindAutoBindMethods(component) {
	    var pairs = component.__reactAutoBindPairs;
	    for (var i = 0; i < pairs.length; i += 2) {
	      var autoBindKey = pairs[i];
	      var method = pairs[i + 1];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	
	  var IsMountedPreMixin = {
	    componentDidMount: function componentDidMount() {
	      this.__isMounted = true;
	    }
	  };
	
	  var IsMountedPostMixin = {
	    componentWillUnmount: function componentWillUnmount() {
	      this.__isMounted = false;
	    }
	  };
	
	  /**
	   * Add more to the ReactClass base class. These are all legacy features and
	   * therefore not already part of the modern ReactComponent.
	   */
	  var ReactClassMixin = {
	    /**
	     * TODO: This will be deprecated because state should always keep a consistent
	     * type signature and the only use case for this, is to avoid that.
	     */
	    replaceState: function replaceState(newState, callback) {
	      this.updater.enqueueReplaceState(this, newState, callback);
	    },
	
	    /**
	     * Checks whether or not this composite component is mounted.
	     * @return {boolean} True if mounted, false otherwise.
	     * @protected
	     * @final
	     */
	    isMounted: function isMounted() {
	      if (false) {
	        warning(this.__didWarnIsMounted, '%s: isMounted is deprecated. Instead, make sure to clean up ' + 'subscriptions and pending requests in componentWillUnmount to ' + 'prevent memory leaks.', this.constructor && this.constructor.displayName || this.name || 'Component');
	        this.__didWarnIsMounted = true;
	      }
	      return !!this.__isMounted;
	    }
	  };
	
	  var ReactClassComponent = function ReactClassComponent() {};
	  _assign(ReactClassComponent.prototype, ReactComponent.prototype, ReactClassMixin);
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  function createClass(spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function (props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        warning(this instanceof Constructor, 'Something is calling a React component directly. Use a factory or ' + 'JSX instead. See: https://fb.me/react-legacyfactory');
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (initialState === undefined && this.getInitialState._isMockFunction) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      _invariant((typeof initialState === 'undefined' ? 'undefined' : _typeof(initialState)) === 'object' && !Array.isArray(initialState), '%s.getInitialState(): must return an object or null', Constructor.displayName || 'ReactCompositeComponent');
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
	    mixSpecIntoComponent(Constructor, spec);
	    mixSpecIntoComponent(Constructor, IsMountedPostMixin);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    _invariant(Constructor.prototype.render, 'createClass(...): Class specification must implement a `render` method.');
	
	    if (false) {
	      warning(!Constructor.prototype.componentShouldUpdate, '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', spec.displayName || 'A component');
	      warning(!Constructor.prototype.componentWillRecieveProps, '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', spec.displayName || 'A component');
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  }
	
	  return createClass;
	}
	
	module.exports = factory;

/***/ },
/* 728 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(29);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gud = __webpack_require__(789);
	
	var _gud2 = _interopRequireDefault(_gud);
	
	var _warning = __webpack_require__(9);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var MAX_SIGNED_31_BIT_INT = 1073741823;
	
	// Inlined Object.is polyfill.
	// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	function objectIs(x, y) {
	  if (x === y) {
	    return x !== 0 || 1 / x === 1 / y;
	  } else {
	    return x !== x && y !== y;
	  }
	}
	
	function createEventEmitter(value) {
	  var handlers = [];
	  return {
	    on: function on(handler) {
	      handlers.push(handler);
	    },
	    off: function off(handler) {
	      handlers = handlers.filter(function (h) {
	        return h !== handler;
	      });
	    },
	    get: function get() {
	      return value;
	    },
	    set: function set(newValue, changedBits) {
	      value = newValue;
	      handlers.forEach(function (handler) {
	        return handler(value, changedBits);
	      });
	    }
	  };
	}
	
	function onlyChild(children) {
	  return Array.isArray(children) ? children[0] : children;
	}
	
	function createReactContext(defaultValue, calculateChangedBits) {
	  var _Provider$childContex, _Consumer$contextType;
	
	  var contextProp = '__create-react-context-' + (0, _gud2.default)() + '__';
	
	  var Provider = function (_Component) {
	    _inherits(Provider, _Component);
	
	    function Provider() {
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, Provider);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.emitter = createEventEmitter(_this.props.value), _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    Provider.prototype.getChildContext = function getChildContext() {
	      var _ref;
	
	      return _ref = {}, _ref[contextProp] = this.emitter, _ref;
	    };
	
	    Provider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	      if (this.props.value !== nextProps.value) {
	        var oldValue = this.props.value;
	        var newValue = nextProps.value;
	        var changedBits = void 0;
	
	        if (objectIs(oldValue, newValue)) {
	          changedBits = 0; // No change
	        } else {
	          changedBits = typeof calculateChangedBits === 'function' ? calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;
	          if (false) {
	            (0, _warning2.default)((changedBits & MAX_SIGNED_31_BIT_INT) === changedBits, 'calculateChangedBits: Expected the return value to be a ' + '31-bit integer. Instead received: %s', changedBits);
	          }
	
	          changedBits |= 0;
	
	          if (changedBits !== 0) {
	            this.emitter.set(nextProps.value, changedBits);
	          }
	        }
	      }
	    };
	
	    Provider.prototype.render = function render() {
	      return this.props.children;
	    };
	
	    return Provider;
	  }(_react.Component);
	
	  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = _propTypes2.default.object.isRequired, _Provider$childContex);
	
	  var Consumer = function (_Component2) {
	    _inherits(Consumer, _Component2);
	
	    function Consumer() {
	      var _temp2, _this2, _ret2;
	
	      _classCallCheck(this, Consumer);
	
	      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, _Component2.call.apply(_Component2, [this].concat(args))), _this2), _this2.state = {
	        value: _this2.getValue()
	      }, _this2.onUpdate = function (newValue, changedBits) {
	        var observedBits = _this2.observedBits | 0;
	        if ((observedBits & changedBits) !== 0) {
	          _this2.setState({ value: _this2.getValue() });
	        }
	      }, _temp2), _possibleConstructorReturn(_this2, _ret2);
	    }
	
	    Consumer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	      var observedBits = nextProps.observedBits;
	
	      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
	      : observedBits;
	    };
	
	    Consumer.prototype.componentDidMount = function componentDidMount() {
	      if (this.context[contextProp]) {
	        this.context[contextProp].on(this.onUpdate);
	      }
	      var observedBits = this.props.observedBits;
	
	      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
	      : observedBits;
	    };
	
	    Consumer.prototype.componentWillUnmount = function componentWillUnmount() {
	      if (this.context[contextProp]) {
	        this.context[contextProp].off(this.onUpdate);
	      }
	    };
	
	    Consumer.prototype.getValue = function getValue() {
	      if (this.context[contextProp]) {
	        return this.context[contextProp].get();
	      } else {
	        return defaultValue;
	      }
	    };
	
	    Consumer.prototype.render = function render() {
	      return onlyChild(this.props.children)(this.state.value);
	    };
	
	    return Consumer;
	  }(_react.Component);
	
	  Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = _propTypes2.default.object, _Consumer$contextType);
	
	  return {
	    Provider: Provider,
	    Consumer: Consumer
	  };
	}
	
	exports.default = createReactContext;
	module.exports = exports['default'];

/***/ },
/* 729 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _implementation = __webpack_require__(728);
	
	var _implementation2 = _interopRequireDefault(_implementation);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	exports.default = _react2.default.createContext || _implementation2.default;
	module.exports = exports['default'];

/***/ },
/* 730 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var cssColorNames = __webpack_require__(966);
	
	module.exports = function cssColorList() {
	  return Object.keys(cssColorNames);
	};

/***/ },
/* 731 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = hyphenateProperty;
	
	var _hyphenateStyleName = __webpack_require__(792);
	
	var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function hyphenateProperty(property) {
	  return (0, _hyphenateStyleName2.default)(property);
	}
	module.exports = exports['default'];

/***/ },
/* 732 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = {
	  "azimuth": "center",
	  "border-collapse": "separate",
	  "border-spacing": "0",
	  "caption-side": "top",
	  "caret-color": "auto",
	  "color": "initial",
	  "cursor": "auto",
	  "empty-cells": "show",
	  "font-family": "initial",
	  "font-feature-settings": "normal",
	  "font-kerning": "auto",
	  "font-language-override": "normal",
	  "font-size": "medium",
	  "font-size-adjust": "none",
	  "font-stretch": "normal",
	  "font-style": "normal",
	  "font-synthesis": "weight style",
	  "font-variant": "normal",
	  "font-variant-alternates": "normal",
	  "font-variant-caps": "normal",
	  "font-variant-east-asian": "normal",
	  "font-variant-ligatures": "normal",
	  "font-variant-numeric": "normal",
	  "font-variant-position": "normal",
	  "font-weight": "normal",
	  "hyphens": "manual",
	  "image-orientation": "0deg",
	  "image-rendering": "auto",
	  "image-resolution": "1dppx",
	  "letter-spacing": "normal",
	  "line-height": "normal",
	  "list-style-image": "none",
	  "list-style-position": "outside",
	  "list-style-type": "disc",
	  "object-position": "50% 50%",
	  "orphans": "2",
	  "overflow-wrap": "normal",
	  "pointer-events": "auto",
	  "quotes": "initial",
	  "ruby-align": "space-around",
	  "ruby-merge": "separate",
	  "ruby-position": "over",
	  "tab-size": "8",
	  "text-align": "initial",
	  "text-align-last": "auto",
	  "text-combine-upright": "none",
	  "text-indent": "0",
	  "text-justify": "auto",
	  "text-orientation": "mixed",
	  "text-rendering": "auto",
	  "text-shadow": "none",
	  "text-transform": "none",
	  "text-underline-position": "auto",
	  "visibility": "visible",
	  "white-space": "normal",
	  "widows": "2",
	  "word-break": "normal",
	  "word-spacing": "normal",
	  "word-wrap": "normal",
	  "writing-mode": "horizontal-tb",
	  "-webkit-appearance": "none",
	  "-moz-appearance": "none",
	  "-ms-appearance": "none",
	  "appearance": "none"
	};

/***/ },
/* 733 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {/*!
	 * @description Recursive object extending
	 * @author Viacheslav Lotsmanov <lotsmanov89@gmail.com>
	 * @license MIT
	 *
	 * The MIT License (MIT)
	 *
	 * Copyright (c) 2013-2015 Viacheslav Lotsmanov
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy of
	 * this software and associated documentation files (the "Software"), to deal in
	 * the Software without restriction, including without limitation the rights to
	 * use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
	 * the Software, and to permit persons to whom the Software is furnished to do so,
	 * subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all
	 * copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
	 * FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
	 * COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
	 * IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
	 * CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	 */
	
	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function isSpecificValue(val) {
		return val instanceof Buffer || val instanceof Date || val instanceof RegExp ? true : false;
	}
	
	function cloneSpecificValue(val) {
		if (val instanceof Buffer) {
			var x = new Buffer(val.length);
			val.copy(x);
			return x;
		} else if (val instanceof Date) {
			return new Date(val.getTime());
		} else if (val instanceof RegExp) {
			return new RegExp(val);
		} else {
			throw new Error('Unexpected situation');
		}
	}
	
	/**
	 * Recursive cloning array.
	 */
	function deepCloneArray(arr) {
		var clone = [];
		arr.forEach(function (item, index) {
			if ((typeof item === 'undefined' ? 'undefined' : _typeof(item)) === 'object' && item !== null) {
				if (Array.isArray(item)) {
					clone[index] = deepCloneArray(item);
				} else if (isSpecificValue(item)) {
					clone[index] = cloneSpecificValue(item);
				} else {
					clone[index] = deepExtend({}, item);
				}
			} else {
				clone[index] = item;
			}
		});
		return clone;
	}
	
	/**
	 * Extening object that entered in first argument.
	 *
	 * Returns extended object or false if have no target object or incorrect type.
	 *
	 * If you wish to clone source object (without modify it), just use empty new
	 * object as first argument, like this:
	 *   deepExtend({}, yourObj_1, [yourObj_N]);
	 */
	var deepExtend = module.exports = function () /*obj_1, [obj_2], [obj_N]*/{
		if (arguments.length < 1 || _typeof(arguments[0]) !== 'object') {
			return false;
		}
	
		if (arguments.length < 2) {
			return arguments[0];
		}
	
		var target = arguments[0];
	
		// convert arguments to array and cut off target object
		var args = Array.prototype.slice.call(arguments, 1);
	
		var val, src, clone;
	
		args.forEach(function (obj) {
			// skip argument if isn't an object, is null, or is an array
			if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) !== 'object' || obj === null || Array.isArray(obj)) {
				return;
			}
	
			Object.keys(obj).forEach(function (key) {
				src = target[key]; // source value
				val = obj[key]; // new value
	
				// recursion prevention
				if (val === target) {
					return;
	
					/**
	     * if new value isn't object then just overwrite by new value
	     * instead of extending.
	     */
				} else if ((typeof val === 'undefined' ? 'undefined' : _typeof(val)) !== 'object' || val === null) {
					target[key] = val;
					return;
	
					// just clone arrays (and recursive clone objects inside)
				} else if (Array.isArray(val)) {
					target[key] = deepCloneArray(val);
					return;
	
					// custom cloning and overwrite for specific objects
				} else if (isSpecificValue(val)) {
					target[key] = cloneSpecificValue(val);
					return;
	
					// overwrite by new value if source isn't object or array
				} else if ((typeof src === 'undefined' ? 'undefined' : _typeof(src)) !== 'object' || src === null || Array.isArray(src)) {
					target[key] = deepExtend({}, val);
					return;
	
					// source value and new value is objects both, extending...
				} else {
					target[key] = deepExtend(src, val);
					return;
				}
			});
		});
	
		return target;
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(199).Buffer))

/***/ },
/* 734 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	(function (global, factory) {
		( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? module.exports = factory() :  true ? !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : global.deepmerge = factory();
	})(undefined, function () {
		'use strict';
	
		var isMergeableObject = function isMergeableObject(value) {
			return isNonNullObject(value) && !isSpecial(value);
		};
	
		function isNonNullObject(value) {
			return !!value && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object';
		}
	
		function isSpecial(value) {
			var stringValue = Object.prototype.toString.call(value);
	
			return stringValue === '[object RegExp]' || stringValue === '[object Date]' || isReactElement(value);
		}
	
		// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
		var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
		var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;
	
		function isReactElement(value) {
			return value.$$typeof === REACT_ELEMENT_TYPE;
		}
	
		function emptyTarget(val) {
			return Array.isArray(val) ? [] : {};
		}
	
		function cloneUnlessOtherwiseSpecified(value, options) {
			return options.clone !== false && options.isMergeableObject(value) ? deepmerge(emptyTarget(value), value, options) : value;
		}
	
		function defaultArrayMerge(target, source, options) {
			return target.concat(source).map(function (element) {
				return cloneUnlessOtherwiseSpecified(element, options);
			});
		}
	
		function mergeObject(target, source, options) {
			var destination = {};
			if (options.isMergeableObject(target)) {
				Object.keys(target).forEach(function (key) {
					destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
				});
			}
			Object.keys(source).forEach(function (key) {
				if (!options.isMergeableObject(source[key]) || !target[key]) {
					destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
				} else {
					destination[key] = deepmerge(target[key], source[key], options);
				}
			});
			return destination;
		}
	
		function deepmerge(target, source, options) {
			options = options || {};
			options.arrayMerge = options.arrayMerge || defaultArrayMerge;
			options.isMergeableObject = options.isMergeableObject || isMergeableObject;
	
			var sourceIsArray = Array.isArray(source);
			var targetIsArray = Array.isArray(target);
			var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;
	
			if (!sourceAndTargetTypesMatch) {
				return cloneUnlessOtherwiseSpecified(source, options);
			} else if (sourceIsArray) {
				return options.arrayMerge(target, source, options);
			} else {
				return mergeObject(target, source, options);
			}
		}
	
		deepmerge.all = function deepmergeAll(array, options) {
			if (!Array.isArray(array)) {
				throw new Error('first argument should be an array');
			}
	
			return array.reduce(function (prev, next) {
				return deepmerge(prev, next, options);
			}, {});
		};
	
		var deepmerge_1 = deepmerge;
	
		return deepmerge_1;
	});

/***/ },
/* 735 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _regenerator = __webpack_require__(520);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	__webpack_require__(765);
	
	var _routes = __webpack_require__(163);
	
	var _userStore = __webpack_require__(81);
	
	var _userStore2 = _interopRequireDefault(_userStore);
	
	var _dispatcher = __webpack_require__(18);
	
	var _dispatcher2 = _interopRequireDefault(_dispatcher);
	
	var _locales = __webpack_require__(162);
	
	var _locales2 = _interopRequireDefault(_locales);
	
	var _brands = __webpack_require__(763);
	
	var _brands2 = _interopRequireDefault(_brands);
	
	var _utils = __webpack_require__(28);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	__webpack_require__(771);
	
	__webpack_require__(234);
	
	var _chameleonjs = __webpack_require__(523);
	
	var _chameleonjs2 = _interopRequireDefault(_chameleonjs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	window.Routes = _routes.MulliganRouter;
	window.Mulligan = {};
	
	
	var Branding = {
	  setup: function setup() {
	    document.body.setAttribute('data-theme', Mulligan.Brand.theme);
	    if (Mulligan.Brand.jigsawHost) {
	      Jigsaw.host = Mulligan.Brand.jigsawHost;
	      Mulligan.Brand.jigsawHost = "//" + Mulligan.Brand.jigsawHost + "/";
	    }
	    var user = _userStore2.default.get();
	    var newlocale = localStorage.getItem('updateLanguageOnLogin');
	    if (user) {
	      if (newlocale && newlocale !== "false") {
	        _locales2.default.changeLocale(newlocale);
	        Jigsaw.User.setInfo({ email: user.email, locale: newlocale }, function (response) {
	          if (response.isSuccess()) {
	            localStorage.removeItem('updateLanguageOnLogin');
	          } else {
	            if (response.message !== "Unauthorized") {
	              localStorage.removeItem('updateLanguageOnLogin');
	            }
	          }
	        });
	      } else if (user.locale) {
	        // null locale means no set locale, ingore it
	        _locales2.default.changeLocale(user.locale);
	      }
	    } else {
	      _locales2.default.changeLocale(Mulligan.Brand.locale);
	    }
	  }
	};
	
	var Setup = {
	  init: function init() {
	    Mulligan.brandParam = _utils2.default.getParameterByName('brand');
	    if (Mulligan.brandParam.length === 0) {
	      Mulligan.brandParam = false;
	    }
	    Mulligan.brandParam = Mulligan.brandParam || _brands2.default[window.location.hostname] || false;
	
	    this.render(this);
	    _dispatcher2.default.once(_dispatcher2.default.USER_STORE_CHANGE, this._loadUserBrand);
	  },
	  loadChameleonBrand: function loadChameleonBrand(brand) {
	    return _chameleonjs2.default.loadBrand(brand, "mulligan").then(function (json) {
	      return json;
	    }).catch(function (error) {
	      return false;
	    });
	  },
	  loadDefaultBrand: function () {
	    var _ref = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee(callback) {
	      var _this = this;
	
	      var response;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              if (Mulligan.Brand) {
	                _context.next = 7;
	                break;
	              }
	
	              _context.next = 3;
	              return this.loadChameleonBrand(Mulligan.brandParam || "vitalsource");
	
	            case 3:
	              response = _context.sent;
	
	              if (response) {
	                Mulligan.Brand = response;
	                Branding.setup();
	                callback();
	              } else {
	                Jigsaw.getBrandConfig(Mulligan.brandParam || 'vitalsource', function (response) {
	                  if (response.isSuccess()) {
	                    Mulligan.Brand = response;
	                  } else {
	                    Mulligan.brandParam = false;
	                    _this.loadDefaultBrand(callback);
	                    return;
	                  }
	                  Branding.setup();
	                  callback();
	                });
	              }
	
	              _context.next = 8;
	              break;
	
	            case 7:
	              callback();
	
	            case 8:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, this);
	    }));
	
	    function loadDefaultBrand(_x) {
	      return _ref.apply(this, arguments);
	    }
	
	    return loadDefaultBrand;
	  }(),
	  _loadUserBrand: function () {
	    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
	      var user, response;
	      return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              user = _userStore2.default.get();
	
	              if (!(user && !this.userBrandLoaded)) {
	                _context2.next = 9;
	                break;
	              }
	
	              this.userBrandLoaded = true;
	              _context2.next = 5;
	              return Setup.loadChameleonBrand(Mulligan.brandParam || user.lastBrandAccessed);
	
	            case 5:
	              response = _context2.sent;
	
	              if (response) {
	                Mulligan.Brand = response || Mulligan.Brand;
	                Branding.setup();
	                _dispatcher2.default.emit(_dispatcher2.default.BRAND_CHANGE);
	              } else {
	                Jigsaw.getBrandConfig(Mulligan.brandParam || user.lastBrandAccessed, function (response) {
	                  if (response.isSuccess()) {
	                    Mulligan.Brand = response || Mulligan.Brand;
	                  }
	                  Branding.setup();
	                  _dispatcher2.default.emit(_dispatcher2.default.BRAND_CHANGE);
	                });
	              }
	              _context2.next = 10;
	              break;
	
	            case 9:
	              _dispatcher2.default.emit(_dispatcher2.default.BRAND_CHANGE);
	
	            case 10:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, this);
	    }));
	
	    function _loadUserBrand() {
	      return _ref2.apply(this, arguments);
	    }
	
	    return _loadUserBrand;
	  }(),
	  _setupFavIcon: function _setupFavIcon() {
	    var link = document.createElement('link');
	    link.type = 'image/png';
	    link.rel = 'shortcut icon';
	
	    // If `brand` param is present, we're in branding tool preview so omit the
	    // protocal and location host.
	    link.href = Mulligan.Brand.Graphics.favicon;
	    var href = document.createElement("a");
	    href.href = link.href;
	    if (href.hostname === window.location.hostname || href.hostname === "") {
	      link.href = "https://bookshelf.vitalsource.com" + Mulligan.Brand.Graphics.favicon;
	    }
	    document.getElementsByTagName('head')[0].appendChild(link);
	  },
	  render: function render(setup) {
	    var _this2 = this;
	
	    _routes.MulliganController.loader();
	
	    setup.loadDefaultBrand(function () {
	      _this2._loadUserBrand();
	      _dispatcher2.default.on(_dispatcher2.default.BRAND_CHANGE, function () {
	        _this2._setupFavIcon();
	        Routes.init('/');
	      });
	    });
	  }
	};
	
	Setup.init();

/***/ },
/* 736 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _dispatcher = __webpack_require__(18);
	
	var _dispatcher2 = _interopRequireDefault(_dispatcher);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		deactivateDevice: function deactivateDevice(id) {
			_dispatcher2.default.emit(_dispatcher2.default.DEVICE_DEACTIVATE_DEVICE, id);
		}
	};

/***/ },
/* 737 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _dispatcher = __webpack_require__(18);
	
	var _dispatcher2 = _interopRequireDefault(_dispatcher);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  redeemAccessCode: function redeemAccessCode(vbid) {
	
	    Jigsaw.redeemAncillary(vbid, function (response) {
	      _dispatcher2.default.emit(_dispatcher2.default.ACCESS_CODE_STORE_CHANGE);
	    });
	  }
	};

/***/ },
/* 738 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  openSupport: function openSupport() {
	    window.open(Mulligan.Brand.Support.url);
	  },
	  openBookshelf: function openBookshelf() {
	    window.open(Mulligan.Brand.endpoint);
	  }
	};

/***/ },
/* 739 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(28);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _accessCodesStore = __webpack_require__(237);
	
	var _accessCodesStore2 = _interopRequireDefault(_accessCodesStore);
	
	var _dispatcher = __webpack_require__(18);
	
	var _dispatcher2 = _interopRequireDefault(_dispatcher);
	
	var _resourceAction = __webpack_require__(737);
	
	var _resourceAction2 = _interopRequireDefault(_resourceAction);
	
	var _vstui = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement(
	  "div",
	  { className: "deck resource-list" },
	  _react2.default.createElement(_vstui.VstLoader, null)
	);
	
	var AccessCodes = _react2.default.createClass({
	  displayName: "AccessCodes",
	  getInitialState: function getInitialState() {
	    return {
	      resources: _accessCodesStore2.default.getAll()
	    };
	  },
	
	
	  // Force update of assets
	  _getUpdatedState: function _getUpdatedState() {
	    this.setState({
	      resources: _accessCodesStore2.default.getAll(true)
	    });
	  },
	  componentDidMount: function componentDidMount() {
	    _dispatcher2.default.on(_dispatcher2.default.ACCESS_CODE_STORE_CHANGE, this._handleResourceChange);
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    _dispatcher2.default.removeListener(_dispatcher2.default.ACCESS_CODE_STORE_CHANGE, this._handleResourceChange);
	  },
	  _handleResourceChange: function _handleResourceChange() {
	    this.setState({ resources: _accessCodesStore2.default.getAll(true) });
	  },
	  _revealCode: function _revealCode(e) {
	    var code = e.currentTarget.getAttribute("data-id");
	
	    _resourceAction2.default.redeemAccessCode(code);
	  },
	  _copyCode: function _copyCode(e) {
	    // Select input field and fire copy command
	    var prev = e.currentTarget.previousSibling;
	    prev.select();
	    try {
	      var successful = document.execCommand("copy");
	      var msg = successful ? "successful" : "unsuccessful";
	    } catch (err) {
	      alert(i18n.t("resources.copy-fail"));
	    }
	  },
	  render: function render() {
	    var _this = this;
	
	    var resources = this.state.resources ? this.state.resources.licenses : [];
	    var accessCodes = [];
	    // Filter through data to display all ancillaries with book covers/authors/etc.
	    resources.forEach(function (value, key) {
	      var anc = value.ancillaries || [];
	      if (anc.length > 0) {
	        // Select last accesscode from object
	        var lastAccessCode = anc[anc.length - 1];
	        // Add book info to each access code
	        lastAccessCode.author = value.author;
	        lastAccessCode.title = value.title;
	        lastAccessCode.coverURL = value.coverURL;
	        lastAccessCode.isbn = value.isbn;
	        accessCodes.push(lastAccessCode);
	      }
	    });
	
	    if (accessCodes.length > 0) {
	      accessCodes = _react2.default.createElement(
	        "div",
	        { className: "deck resource-list" },
	        accessCodes.map(function (item, index) {
	          var href = void 0,
	              linkText = void 0;
	          if (item.href) {
	            href = item.href;
	            linkText = i18n.t("resources.launch-site");
	          } else {
	            href = "https:" + Mulligan.Brand.endpoint + "/#/books/" + item.isbn;
	            linkText = i18n.t("resources.launch-book");
	          }
	          return _react2.default.createElement(
	            "div",
	            { className: "clear card", key: index },
	            _react2.default.createElement(
	              "div",
	              { className: "left" },
	              _react2.default.createElement("img", { className: "cover", src: item.coverURL, alt: "" }),
	              _react2.default.createElement(
	                "div",
	                { className: "details" },
	                _react2.default.createElement(
	                  "strong",
	                  { className: "title" },
	                  _utils2.default.toHTML(item.title)
	                ),
	                _react2.default.createElement(
	                  "span",
	                  { className: "author" },
	                  item.author
	                ),
	                _react2.default.createElement(
	                  "span",
	                  { className: "expiration" },
	                  i18n.t("resources.expiration-message")
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "right access-code-width" },
	              item.revealed && _react2.default.createElement(
	                "div",
	                { className: "access-code-container" },
	                _react2.default.createElement("input", { value: item.accessCode, readOnly: "true" }),
	                _react2.default.createElement(
	                  "a",
	                  {
	                    className: "vst-href-to-button copy-button",
	                    onClick: _this._copyCode
	                  },
	                  i18n.t("base.copy")
	                ),
	                _react2.default.createElement(
	                  "a",
	                  { href: href, target: "_blank" },
	                  linkText
	                )
	              ),
	              !item.revealed && _react2.default.createElement(
	                "div",
	                { className: "access-code-container" },
	                _react2.default.createElement(
	                  "a",
	                  {
	                    className: "vst-href-to-button",
	                    onClick: _this._revealCode,
	                    "data-id": item.isbn
	                  },
	                  i18n.t("resources.reveal-code")
	                )
	              )
	            )
	          );
	        })
	      );
	    } else if (this.state.resources === undefined) {
	      accessCodes = _ref;
	    } else {
	      accessCodes = _react2.default.createElement(
	        "p",
	        null,
	        i18n.t("resources.no-access-codes")
	      );
	    }
	
	    return _react2.default.createElement(
	      "div",
	      null,
	      accessCodes
	    );
	  }
	});
	
	exports.default = AccessCodes;

/***/ },
/* 740 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(28);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _vstui = __webpack_require__(30);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Ancillaries = function Ancillaries(_ref) {
		var user = _ref.user,
		    resources = _ref.resources;
	
	
		var filterDate = function filterDate(date) {
			var time = (0, _moment2.default)(date).calendar();
			return i18n.t('resources.expires') + " " + time;
		};
	
		var ancillaries;
		if (!user || user.licenseUpdating || !resources) {
			ancillaries = _react2.default.createElement(
				_vstui.VstLoader,
				{ delay: 500 },
				i18n.t('resources.loading')
			);
		} else if (resources.length > 0) {
			ancillaries = resources.map(function (item, index) {
				var detailsUrl = "#/resources/ancillaries/" + item.isbn;
				if (item.ancillariesCount > 0) {
					return _react2.default.createElement(
						'div',
						{ className: 'clear card', key: index },
						_react2.default.createElement(
							'div',
							{ className: 'left' },
							_react2.default.createElement('img', { className: 'cover', src: item.coverURL, alt: '' }),
							_react2.default.createElement(
								'div',
								{ className: 'details' },
								_react2.default.createElement(
									'strong',
									{ className: 'title' },
									_utils2.default.toHTML(item.title)
								),
								_react2.default.createElement(
									'span',
									{ className: 'author' },
									item.author
								),
								_react2.default.createElement(
									'span',
									{ className: 'expiration' },
									filterDate(item.expires)
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'right' },
							_react2.default.createElement(
								'div',
								{ className: 'link-container' },
								_react2.default.createElement(
									'a',
									{ href: detailsUrl },
									item.ancillariesCount,
									' ',
									i18n.t('resources.ancillaries'),
									_react2.default.createElement('img', { src: __webpack_require__(959), alt: '' })
								)
							)
						)
					);
				}
			});
		} else {
			ancillaries = _react2.default.createElement(
				'p',
				null,
				i18n.t('resources.no-resources')
			);
		}
	
		return _react2.default.createElement(
			'div',
			null,
			ancillaries
		);
	};
	
	exports.default = Ancillaries;

/***/ },
/* 741 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _locales = __webpack_require__(162);
	
	var _locales2 = _interopRequireDefault(_locales);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CookieCat = function (_React$Component) {
	  _inherits(CookieCat, _React$Component);
	
	  function CookieCat() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, CookieCat);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CookieCat.__proto__ || Object.getPrototypeOf(CookieCat)).call.apply(_ref, [this].concat(args))), _this), _this.initCookieCat = function () {
	      var theme = "ocean";
	      var locale = _locales2.default.getLocale(i18n.getCurrentLocale());
	      if (Mulligan.Brand.Cookies.notify) {
	        //optional chaining no supported in mulligan
	        if (window.CookieCat && window.CookieCat.init) {
	          window.CookieCat.init({
	            app: "mulligan",
	            theme: theme,
	            locale: locale.rfc
	          });
	        }
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(CookieCat, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.initCookieCat();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return null;
	    }
	  }]);
	
	  return CookieCat;
	}(_react2.default.Component);
	
	exports.default = CookieCat;

/***/ },
/* 742 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _deviceAction = __webpack_require__(736);
	
	var _deviceAction2 = _interopRequireDefault(_deviceAction);
	
	var _vstui = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Device = function Device(props) {
	  var _onDeactivate = function _onDeactivate() {
	    _deviceAction2.default.deactivateDevice(props.id);
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'clear card device', key: 'device-line-item-' + props.id },
	    _react2.default.createElement(
	      'div',
	      { className: 'left' },
	      props.mobile ? _react2.default.createElement('img', { className: 'device', src: __webpack_require__(964), alt: 'mobile' }) : _react2.default.createElement('img', { className: 'device', src: __webpack_require__(962), alt: 'desktop' }),
	      _react2.default.createElement(
	        'div',
	        { className: 'details' },
	        _react2.default.createElement(
	          'span',
	          { className: 'title' },
	          props.clientName
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: 'computer-name' },
	          props.name
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: 'client-version' },
	          props.clientVersion
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: 'last-accessed' },
	          props.lastLicenseUpdate
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _vstui.VstButton,
	      { className: 'deactivate', options: 'btn-36', onClick: _onDeactivate },
	      i18n.t('devices.deactivate')
	    )
	  );
	};
	
	exports.default = Device;

/***/ },
/* 743 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _deviceStore = __webpack_require__(760);
	
	var _deviceStore2 = _interopRequireDefault(_deviceStore);
	
	var _userStore = __webpack_require__(81);
	
	var _userStore2 = _interopRequireDefault(_userStore);
	
	var _device = __webpack_require__(742);
	
	var _device2 = _interopRequireDefault(_device);
	
	var _dispatcher = __webpack_require__(18);
	
	var _dispatcher2 = _interopRequireDefault(_dispatcher);
	
	var _vstui = __webpack_require__(30);
	
	var _utils = __webpack_require__(28);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DevicesContainer = function (_React$Component) {
	  _inherits(DevicesContainer, _React$Component);
	
	  function DevicesContainer() {
	    _classCallCheck(this, DevicesContainer);
	
	    var _this = _possibleConstructorReturn(this, (DevicesContainer.__proto__ || Object.getPrototypeOf(DevicesContainer)).call(this));
	
	    _this.state = {
	      devices: _deviceStore2.default.getAll(),
	      user: _userStore2.default.get()
	    };
	
	    _this._handleUserChange = _this._handleUserChange.bind(_this);
	    _this._handleDevicesChange = _this._handleDevicesChange.bind(_this);
	    return _this;
	  }
	
	  _createClass(DevicesContainer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      _dispatcher2.default.on(_dispatcher2.default.USER_STORE_CHANGE, this._handleUserChange);
	      _dispatcher2.default.on(_dispatcher2.default.DEVICE_STORE_CHANGE, this._handleDevicesChange);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      _dispatcher2.default.removeListener(_dispatcher2.default.USER_STORE_CHANGE, this._handleUserChange);
	      _dispatcher2.default.removeListener(_dispatcher2.default.DEVICE_STORE_CHANGE, this._handleDevicesChange);
	    }
	  }, {
	    key: '_handleDevicesChange',
	    value: function _handleDevicesChange() {
	      this.setState({ devices: _deviceStore2.default.getAll() });
	    }
	  }, {
	    key: '_handleUserChange',
	    value: function _handleUserChange() {
	      this.setState({ user: _userStore2.default.get() });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var deviceList = void 0;
	      if (this.state.devices) {
	        if (this.state.devices.length > 0) {
	          deviceList = _react2.default.createElement(
	            'div',
	            { className: 'deck device-list' },
	            this.state.devices.map(function (device) {
	              if (device.active) {
	                return _react2.default.createElement(_device2.default, _extends({}, device, { key: 'device-' + device.id }));
	              }
	            })
	          );
	        } else {
	          deviceList = _react2.default.createElement(
	            'span',
	            null,
	            i18n.t('devices.no-active')
	          );
	        }
	      } else {
	        deviceList = _react2.default.createElement(
	          'div',
	          { className: 'deck device-list' },
	          _react2.default.createElement(
	            _vstui.VstLoader,
	            { delay: 500 },
	            i18n.t('devices.loading')
	          )
	        );
	      }
	
	      var desktopActivations = this.state.user && this.state.user.maxDesktopActivations || 0;
	      var mobileActivations = this.state.user && this.state.user.maxMobileActivations || 0;
	      return _react2.default.createElement(
	        'div',
	        { className: 'page devices' },
	        _react2.default.createElement(
	          'h1',
	          null,
	          i18n.t('base.devices')
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: 'page-description' },
	          _utils2.default.toHTML(i18n.t('devices.description', { brand: Mulligan.Brand.brand, desktop: desktopActivations, mobile: mobileActivations }))
	        ),
	        deviceList
	      );
	    }
	  }]);
	
	  return DevicesContainer;
	}(_react2.default.Component);
	
	exports.default = DevicesContainer;
	;

/***/ },
/* 744 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FormAlert = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(["\n  margin: 10px 0;\n  border-radius: 4px;\n  background: ", ";\n  padding: 18px;\n  & > *:first-child {\n    margin-top: 0;\n  }\n"], ["\n  margin: 10px 0;\n  border-radius: 4px;\n  background: ", ";\n  padding: 18px;\n  & > *:first-child {\n    margin-top: 0;\n  }\n"]),
	    _templateObject2 = _taggedTemplateLiteral(["\n  background: ", ";\n  border: 2px solid ", ";\n  padding: 16px;\n  margin: 10px 0;\n  border-radius: 4px;\n"], ["\n  background: ", ";\n  border: 2px solid ", ";\n  padding: 16px;\n  margin: 10px 0;\n  border-radius: 4px;\n"]);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(15);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _colors = __webpack_require__(101);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var GrayBlock = _styledComponents2.default.div(_templateObject, _colors.cloud.getShade(3));
	
	var StyledFormError = _styledComponents2.default.div(_templateObject2, _colors.red.getShade(3), _colors.cherry.getShade(1));
	
	var FormAlert = exports.FormAlert = function (_React$PureComponent) {
	  _inherits(FormAlert, _React$PureComponent);
	
	  function FormAlert() {
	    _classCallCheck(this, FormAlert);
	
	    return _possibleConstructorReturn(this, (FormAlert.__proto__ || Object.getPrototypeOf(FormAlert)).apply(this, arguments));
	  }
	
	  _createClass(FormAlert, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.formAlert.focus();
	    }
	  }, {
	    key: "renderWarning",
	    value: function renderWarning() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        GrayBlock,
	        { tabIndex: -1, innerRef: function innerRef(x) {
	            return _this2.formAlert = x;
	          } },
	        this.props.children
	      );
	    }
	  }, {
	    key: "renderError",
	    value: function renderError() {
	      var _this3 = this;
	
	      return _react2.default.createElement(
	        StyledFormError,
	        { tabIndex: -1, innerRef: function innerRef(x) {
	            return _this3.formAlert = x;
	          } },
	        this.props.children
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      switch (this.props.level) {
	        case "info":
	        case "warning":
	        case "debug":
	          return this.renderWarning();
	        case "error":
	        case "fatal":
	          return this.renderError();
	        default:
	          return this.renderWarning();
	      }
	    }
	  }]);
	
	  return FormAlert;
	}(_react2.default.PureComponent);
	
	exports.default = FormAlert;

/***/ },
/* 745 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _vstui = __webpack_require__(30);
	
	var _userAction = __webpack_require__(159);
	
	var _userAction2 = _interopRequireDefault(_userAction);
	
	var _userStore = __webpack_require__(81);
	
	var _userStore2 = _interopRequireDefault(_userStore);
	
	var _utilityStore = __webpack_require__(161);
	
	var _utilityStore2 = _interopRequireDefault(_utilityStore);
	
	var _dispatcher = __webpack_require__(18);
	
	var _dispatcher2 = _interopRequireDefault(_dispatcher);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Header = function (_React$Component) {
	  _inherits(Header, _React$Component);
	
	  function Header() {
	    _classCallCheck(this, Header);
	
	    var _this = _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).call(this));
	
	    _this.state = {
	      user: _userStore2.default.get(),
	      activeHamburger: _utilityStore2.default.get(_utilityStore2.default.HAMBURGER_STATE)
	    };
	
	    _this._handleUserChange = _this._handleUserChange.bind(_this);
	    _this._handleHamburgerChange = _this._handleHamburgerChange.bind(_this);
	    return _this;
	  }
	
	  _createClass(Header, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      _dispatcher2.default.on(_dispatcher2.default.USER_STORE_CHANGE, this._handleUserChange);
	      _dispatcher2.default.on(_dispatcher2.default.HEADER_HAMBURGER_CHANGE, this._handleHamburgerChange);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      _dispatcher2.default.removeListener(_dispatcher2.default.USER_STORE_CHANGE, this._handleUserChange);
	      _dispatcher2.default.removeListener(_dispatcher2.default.HEADER_HAMBURGER_CHANGE, this._handleHamburgerChange);
	    }
	  }, {
	    key: '_handleUserChange',
	    value: function _handleUserChange() {
	      this.setState({ user: _userStore2.default.get() });
	    }
	  }, {
	    key: '_handleHamburgerChange',
	    value: function _handleHamburgerChange() {
	      this.setState({ activeHamburger: _utilityStore2.default.get(_utilityStore2.default.HAMBURGER_STATE) });
	    }
	  }, {
	    key: '_clickLogo',
	    value: function _clickLogo(e) {
	      e.preventDefault();
	      Routes.setRoute('/');
	    }
	  }, {
	    key: '_clickHamburger',
	    value: function _clickHamburger(e) {
	      _dispatcher2.default.emit(_dispatcher2.default.HEADER_HAMBURGER_TOGGLE);
	    }
	  }, {
	    key: '_clickSignOut',
	    value: function _clickSignOut(e) {
	      _userAction2.default.signOut();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	
	      // Prevent errors when user is not yet loaded
	      var firstName = this.state.user ? this.state.user.firstName : "";
	      var lastName = this.state.user ? this.state.user.lastName : "";
	      var email = this.state.user ? this.state.user.email : "";
	      var ssoOnly = this.state.user && this.state.user.ssoOnly;
	
	      var logo = __webpack_require__(958);
	      if (Mulligan.Brand.Graphics.logo !== "/img/logo_bookshelf.svg") {
	        var url = document.createElement("a");
	        url.href = Mulligan.Brand.Graphics.logo;
	        logo = Mulligan.Brand.Graphics.logo;
	      }
	
	      return _react2.default.createElement(
	        _vstui.VstHeader,
	        { className: classNames("header", { "navigation-open": this.state.activeHamburger }),
	          logo: logo,
	          title: 'Account Center Home',
	          clickLogo: this._clickLogo,
	          activeHamburger: this.state.activeHamburger,
	          clickHamburger: this._clickHamburger },
	        Mulligan.Brand.AccountCenter.Header.visible && _react2.default.createElement(
	          _vstui.VstLilHead,
	          null,
	          !ssoOnly && _react2.default.createElement(_vstui.VstLilHeadUser, { firstName: firstName,
	            lastName: lastName,
	            email: email }),
	          _react2.default.createElement(
	            _vstui.VstLilHeadList,
	            null,
	            Mulligan.Brand.Bookshelf.visible && _react2.default.createElement(
	              _vstui.VstLilHeadListLink,
	              { icon: 'bookshelf', target: '_blank', href: Mulligan.Brand.endpoint },
	              Mulligan.Brand.brand
	            ),
	            Mulligan.Brand.Support.visible && _react2.default.createElement(
	              _vstui.VstLilHeadListLink,
	              { icon: 'support', target: '_blank', href: Mulligan.Brand.Support.url },
	              i18n.t('base.support')
	            )
	          ),
	          _react2.default.createElement(
	            _vstui.VstLilHeadFooter,
	            null,
	            _react2.default.createElement(
	              _vstui.VstButton,
	              { className: 'sign-out', options: 'btn-28', onClick: this._clickSignOut },
	              i18n.t('base.sign-out')
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Header;
	}(_react2.default.Component);
	
	exports.default = Header;
	;

/***/ },
/* 746 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(63);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var cancelScrollEvent = function cancelScrollEvent(e) {
	  e.stopImmediatePropagation();
	  e.preventDefault();
	  e.returnValue = false;
	  return false;
	};
	
	var addScrollEventListener = function addScrollEventListener(node, handler) {
	  node.addEventListener('wheel', handler, false);
	};
	
	var removeScrollEventListener = function removeScrollEventListener(node, handler) {
	  node.removeEventListener('wheel', handler, false);
	};
	
	var ScrollView = function (_React$Component) {
	  _inherits(ScrollView, _React$Component);
	
	  function ScrollView() {
	    _classCallCheck(this, ScrollView);
	
	    return _possibleConstructorReturn(this, (ScrollView.__proto__ || Object.getPrototypeOf(ScrollView)).apply(this, arguments));
	  }
	
	  _createClass(ScrollView, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.scrollRemove = this.scrollLock();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.scrollRemove();
	    }
	  }, {
	    key: 'scrollLock',
	    value: function scrollLock(node) {
	      var _this2 = this;
	
	      node = node || _reactDom2.default.findDOMNode(this);
	      this.scrollNode = node;
	      addScrollEventListener(node, this.onScrollHandler);
	      return function (el) {
	        el = el || _this2.scrollNode;
	        removeScrollEventListener(el, _this2.onScrollHandler);
	      };
	    }
	  }, {
	    key: 'onScrollHandler',
	    value: function onScrollHandler(e) {
	      var node = this;
	      var scrollTop = node.scrollTop;
	      var scrollHeight = node.scrollHeight;
	      var height = node.clientHeight;
	      var wheelDelta = e.deltaY;
	      var isDeltaPositive = wheelDelta > 0;
	
	      if (isDeltaPositive && wheelDelta > scrollHeight - height - scrollTop) {
	        node.scrollTop = scrollHeight;
	        return cancelScrollEvent(e);
	      } else if (!isDeltaPositive && -wheelDelta > scrollTop) {
	        node.scrollTop = 0;
	        return cancelScrollEvent(e);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          element = _props.element;
	
	
	      switch (element) {
	        case 'table-body':
	          return _react2.default.createElement(
	            'tbody',
	            { className: className },
	            children
	          );
	        default:
	          return _react2.default.createElement(
	            'ul',
	            null,
	            children
	          );
	      }
	    }
	  }]);
	
	  return ScrollView;
	}(_react2.default.Component);
	
	exports.default = ScrollView;
	
	
	ScrollView.defaultProps = {
	  className: ''
	};

/***/ },
/* 747 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _header = __webpack_require__(745);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _navigation = __webpack_require__(748);
	
	var _navigation2 = _interopRequireDefault(_navigation);
	
	var _dispatcher = __webpack_require__(18);
	
	var _dispatcher2 = _interopRequireDefault(_dispatcher);
	
	var _utilityStore = __webpack_require__(161);
	
	var _utilityStore2 = _interopRequireDefault(_utilityStore);
	
	var _themes = __webpack_require__(4);
	
	var _cookieCat = __webpack_require__(741);
	
	var _cookieCat2 = _interopRequireDefault(_cookieCat);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _ref = _react2.default.createElement(_cookieCat2.default, null);
	
	var _ref2 = _react2.default.createElement(_header2.default, null);
	
	var Layout = function (_React$Component) {
	  _inherits(Layout, _React$Component);
	
	  function Layout() {
	    _classCallCheck(this, Layout);
	
	    var _this = _possibleConstructorReturn(this, (Layout.__proto__ || Object.getPrototypeOf(Layout)).call(this));
	
	    _this.state = {
	      navigationOpen: _utilityStore2.default.get(_utilityStore2.default.HAMBURGER_STATE)
	    };
	
	    _this._handleHamburgerToggle = _this._handleHamburgerToggle.bind(_this);
	    _this._localeChange = _this._localeChange.bind(_this);
	    return _this;
	  }
	
	  _createClass(Layout, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      _dispatcher2.default.on(_dispatcher2.default.HEADER_HAMBURGER_CHANGE, this._handleHamburgerToggle);
	      _dispatcher2.default.on(_dispatcher2.default.LOCALE_CHANGE, this._localeChange);
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      _dispatcher2.default.removeListener(_dispatcher2.default.HEADER_HAMBURGER_CHANGE, this._handleHamburgerToggle);
	      _dispatcher2.default.removeListener(_dispatcher2.default.LOCALE_CHANGE, this._localeChange);
	    }
	  }, {
	    key: "_localeChange",
	    value: function _localeChange() {
	      this.forceUpdate();
	    }
	  }, {
	    key: "_handleHamburgerToggle",
	    value: function _handleHamburgerToggle() {
	      this.setState({
	        navigationOpen: _utilityStore2.default.get(_utilityStore2.default.HAMBURGER_STATE)
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var theme = (0, _themes.createTheme)({ typography: { htmlFontSize: 10 } });
	      return _react2.default.createElement(
	        _themes.ThemeProvider,
	        { theme: theme },
	        _react2.default.createElement(
	          "div",
	          null,
	          _ref,
	          _ref2,
	          _react2.default.createElement(_navigation2.default, { page: this.props.page }),
	          _react2.default.createElement(
	            "div",
	            {
	              id: "content-right",
	              className: classNames({
	                "navigation-open": this.state.navigationOpen
	              })
	            },
	            this.props.component
	          )
	        )
	      );
	    }
	  }]);
	
	  return Layout;
	}(_react2.default.Component);
	
	exports.default = Layout;

/***/ },
/* 748 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _userAction = __webpack_require__(159);
	
	var _userAction2 = _interopRequireDefault(_userAction);
	
	var _utilityAction = __webpack_require__(738);
	
	var _utilityAction2 = _interopRequireDefault(_utilityAction);
	
	var _dispatcher = __webpack_require__(18);
	
	var _dispatcher2 = _interopRequireDefault(_dispatcher);
	
	var _userStore = __webpack_require__(81);
	
	var _userStore2 = _interopRequireDefault(_userStore);
	
	var _utilityStore = __webpack_require__(161);
	
	var _utilityStore2 = _interopRequireDefault(_utilityStore);
	
	var _inlineSvg = __webpack_require__(764);
	
	var _inlineSvg2 = _interopRequireDefault(_inlineSvg);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _ref = _react2.default.createElement('div', { className: 'navigation-divider' });
	
	var _ref2 = _react2.default.createElement('div', { className: 'navigation-divider' });
	
	var _ref3 = _react2.default.createElement(_inlineSvg2.default, { src: 'sign_out.svg' });
	
	var Navigation = function (_React$Component) {
	  _inherits(Navigation, _React$Component);
	
	  function Navigation() {
	    _classCallCheck(this, Navigation);
	
	    var _this = _possibleConstructorReturn(this, (Navigation.__proto__ || Object.getPrototypeOf(Navigation)).call(this));
	
	    _this.state = {
	      blah: Math.random(),
	      user: _userStore2.default.get(),
	      navigationOpen: _utilityStore2.default.get(_utilityStore2.default.HAMBURGER_STATE)
	    };
	
	    _this._handleUserChange = _this._handleUserChange.bind(_this);
	    _this._handleHamburgerToggle = _this._handleHamburgerToggle.bind(_this);
	    return _this;
	  }
	
	  _createClass(Navigation, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      _dispatcher2.default.on(_dispatcher2.default.USER_STORE_CHANGE, this._handleUserChange);
	      _dispatcher2.default.on(_dispatcher2.default.HEADER_HAMBURGER_CHANGE, this._handleHamburgerToggle);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      _dispatcher2.default.removeListener(_dispatcher2.default.USER_STORE_CHANGE, this._handleUserChange);
	      _dispatcher2.default.removeListener(_dispatcher2.default.HEADER_HAMBURGER_CHANGE, this._handleHamburgerToggle);
	    }
	  }, {
	    key: '_handleUserChange',
	    value: function _handleUserChange() {
	      this.setState({ user: _userStore2.default.get() });
	    }
	  }, {
	    key: '_handleHamburgerToggle',
	    value: function _handleHamburgerToggle() {
	      this.setState({ navigationOpen: _utilityStore2.default.get(_utilityStore2.default.HAMBURGER_STATE) });
	    }
	  }, {
	    key: '_userInfoButton',
	    value: function _userInfoButton() {
	      Routes.setRoute('/');
	      _dispatcher2.default.emit(_dispatcher2.default.HEADER_HAMBURGER_OFF);
	    }
	  }, {
	    key: '_devicesButton',
	    value: function _devicesButton() {
	      Routes.setRoute('devices');
	      _dispatcher2.default.emit(_dispatcher2.default.HEADER_HAMBURGER_OFF);
	    }
	  }, {
	    key: '_resourcesButton',
	    value: function _resourcesButton() {
	      Routes.setRoute('resources');
	      _dispatcher2.default.emit(_dispatcher2.default.HEADER_HAMBURGER_OFF);
	    }
	  }, {
	    key: '_transactionsButton',
	    value: function _transactionsButton() {
	      window.open('https://' + ({"jigsawURL":"//jigsaw.vitalsource.com/assets/v1/jigsaw/box.js","jigsawRootURL":"//jigsaw.vitalsource.com/","alohomoraHost":"login.vitalsource.com","sslSignin":true,"storeOrderHistory":"https://www.vitalsource.com/order-history","environment":"production"}).alohomoraHost + '?redirect_uri=' + encodeURIComponent(({"jigsawURL":"//jigsaw.vitalsource.com/assets/v1/jigsaw/box.js","jigsawRootURL":"//jigsaw.vitalsource.com/","alohomoraHost":"login.vitalsource.com","sslSignin":true,"storeOrderHistory":"https://www.vitalsource.com/order-history","environment":"production"}).storeOrderHistory) + '&method=jwt&brand=' + (Mulligan.brandParam || window.location.hostname), '_blank').focus();
	    }
	  }, {
	    key: '_bookshelfButton',
	    value: function _bookshelfButton(e) {
	      e.preventDefault();
	      _utilityAction2.default.openBookshelf();
	    }
	  }, {
	    key: '_supportButton',
	    value: function _supportButton(e) {
	      e.preventDefault();
	      _utilityAction2.default.openSupport();
	    }
	  }, {
	    key: '_signOutButton',
	    value: function _signOutButton() {
	      _userAction2.default.signOut();
	    }
	  }, {
	    key: '_clickNavigationMask',
	    value: function _clickNavigationMask() {
	      _dispatcher2.default.emit(_dispatcher2.default.HEADER_HAMBURGER_OFF);
	    }
	  }, {
	    key: '_renderNavigationButton',
	    value: function _renderNavigationButton(id, callback) {
	      if (Mulligan.Brand.AccountCenter.Sidebar[id]) {
	        return _react2.default.createElement(
	          'li',
	          { className: id + '-button ' + (this.props.page === id ? "active" : "") },
	          _react2.default.createElement(
	            'button',
	            { className: 'vst-no-button',
	              onClick: callback },
	            _react2.default.createElement(_inlineSvg2.default, { src: id + '.svg' }),
	            _react2.default.createElement(
	              'span',
	              { className: 'nav-text' },
	              i18n.t('base.' + id)
	            )
	          )
	        );
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	
	      // Prevent errors when user is not yet loaded
	      var firstName = this.state.user ? this.state.user.firstName : "";
	      var lastName = this.state.user ? this.state.user.lastName : "";
	      var email = this.state.user ? this.state.user.email : "";
	      var ssoOnly = this.state.user && this.state.user.ssoOnly;
	
	      return _react2.default.createElement(
	        'div',
	        { id: 'content-left', className: classNames({ 'navigation-open': this.state.navigationOpen }) },
	        !ssoOnly && _react2.default.createElement(
	          'div',
	          { className: 'user-info' },
	          _react2.default.createElement(
	            'div',
	            { className: 'user-info-header' },
	            _react2.default.createElement(
	              'div',
	              { className: 'name' },
	              _react2.default.createElement(
	                'span',
	                null,
	                firstName
	              ),
	              ' ',
	              _react2.default.createElement(
	                'span',
	                null,
	                lastName
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'email' },
	              _react2.default.createElement(
	                'span',
	                null,
	                email
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'nav',
	          { className: 'user-profile-menu' },
	          _react2.default.createElement(
	            'ul',
	            null,
	            !Mulligan.Brand.AccountCompletion.ssoOnly && this._renderNavigationButton('user', this._userInfoButton),
	            this._renderNavigationButton('devices', this._devicesButton),
	            this._renderNavigationButton('resources', this._resourcesButton),
	            this._renderNavigationButton('transactions', this._transactionsButton),
	            Mulligan.Brand.AccountCenter.Header.visible && [Mulligan.Brand.Bookshelf.visible && _react2.default.createElement(
	              'li',
	              { className: 'bookshelf-button' },
	              _ref,
	              _react2.default.createElement(
	                'button',
	                { className: 'vst-no-button',
	                  onClick: this._bookshelfButton },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'inline-svg' },
	                  _react2.default.createElement('img', { role: 'presentation', src: __webpack_require__(960) })
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'nav-text' },
	                  Mulligan.Brand.brand
	                )
	              )
	            ), Mulligan.Brand.Support.visible && _react2.default.createElement(
	              'li',
	              { className: 'support-button' },
	              _react2.default.createElement(
	                'button',
	                { className: 'vst-no-button',
	                  onClick: this._supportButton },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'inline-svg' },
	                  _react2.default.createElement('img', { role: 'presentation', src: __webpack_require__(961) })
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'nav-text' },
	                  i18n.t('base.support')
	                )
	              )
	            ), _react2.default.createElement(
	              'li',
	              { className: 'sign-out-button' },
	              _ref2,
	              _react2.default.createElement(
	                'button',
	                { className: 'vst-no-button',
	                  onClick: this._signOutButton },
	                _ref3,
	                _react2.default.createElement(
	                  'span',
	                  { className: 'nav-text' },
	                  i18n.t('base.sign-out')
	                )
	              )
	            )]
	          )
	        ),
	        _react2.default.createElement('div', { className: 'navigation-mask', onClick: this._clickNavigationMask })
	      );
	    }
	  }]);
	
	  return Navigation;
	}(_react2.default.Component);
	
	exports.default = Navigation;
	;

/***/ },
/* 749 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _ref = _react2.default.createElement('div', null);
	
	var Redirect = function (_React$Component) {
	  _inherits(Redirect, _React$Component);
	
	  function Redirect() {
	    _classCallCheck(this, Redirect);
	
	    return _possibleConstructorReturn(this, (Redirect.__proto__ || Object.getPrototypeOf(Redirect)).apply(this, arguments));
	  }
	
	  _createClass(Redirect, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      window.location = this.props.url;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.props.hideMessage) {
	        // Sometimes we don't want a message to flash when redirecting
	        return _ref;
	      }
	      return _react2.default.createElement(
	        'div',
	        null,
	        'Please wait while we redirect you to: ',
	        this.props.url
	      );
	    }
	  }]);
	
	  return Redirect;
	}(_react2.default.Component);
	
	exports.default = Redirect;
	;

/***/ },
/* 750 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _transactionStore = __webpack_require__(119);
	
	var _transactionStore2 = _interopRequireDefault(_transactionStore);
	
	var _dispatcher = __webpack_require__(18);
	
	var _dispatcher2 = _interopRequireDefault(_dispatcher);
	
	var _transactionDetailHeader = __webpack_require__(236);
	
	var _transactionDetailHeader2 = _interopRequireDefault(_transactionDetailHeader);
	
	var _backLinkHeader = __webpack_require__(235);
	
	var _backLinkHeader2 = _interopRequireDefault(_backLinkHeader);
	
	var _purchaseItem = __webpack_require__(160);
	
	var _purchaseItem2 = _interopRequireDefault(_purchaseItem);
	
	var _vstui = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _ref = _react2.default.createElement(
	  'div',
	  { className: 'deck' },
	  _react2.default.createElement(_vstui.VstLoader, null)
	);
	
	var RefundDetail = function (_React$Component) {
	  _inherits(RefundDetail, _React$Component);
	
	  function RefundDetail(props) {
	    _classCallCheck(this, RefundDetail);
	
	    var _this = _possibleConstructorReturn(this, (RefundDetail.__proto__ || Object.getPrototypeOf(RefundDetail)).call(this, props));
	
	    _this.state = {
	      transaction: _transactionStore2.default.get(_this.props.number)
	    };
	
	    _this._onChange = _this._onChange.bind(_this);
	    return _this;
	  }
	
	  _createClass(RefundDetail, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      _dispatcher2.default.on(_dispatcher2.default.TRANSACTION_STORE_CHANGE, this._onChange);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      _dispatcher2.default.removeListener(_dispatcher2.default.TRANSACTION_STORE_CHANGE, this._onChange);
	    }
	  }, {
	    key: '_onChange',
	    value: function _onChange() {
	      this.setState({
	        transaction: _transactionStore2.default.get(this.props.number)
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var body = void 0;
	      var transaction = this.state.transaction;
	
	      if (transaction === undefined) {
	        body = _ref;
	      } else {
	        var items = transaction.purchaseItems.map(function (i) {
	          return _react2.default.createElement(_purchaseItem2.default, { item: i, transaction: transaction, key: 'purchase-item-' + i.isbn, hideRight: true, hideDownloadCodes: true, isRefund: true });
	        });
	        body = _react2.default.createElement(
	          'div',
	          { className: 'deck transaction-detail' },
	          _react2.default.createElement(_transactionDetailHeader2.default, { transaction: transaction, transactionType: 'refund' }),
	          items
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'page refund-detail' },
	        _react2.default.createElement(_backLinkHeader2.default, { alt: i18n.t('refunds.back'), href: '#/transactions', title: i18n.t('transactions.refund-details') }),
	        body
	      );
	    }
	  }]);
	
	  return RefundDetail;
	}(_react2.default.Component);
	
	exports.default = RefundDetail;
	;

/***/ },
/* 751 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SlimBody = exports.BulkyBody = undefined;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _scrollView = __webpack_require__(746);
	
	var _scrollView2 = _interopRequireDefault(_scrollView);
	
	var _utils = __webpack_require__(28);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _price = __webpack_require__(118);
	
	var _price2 = _interopRequireDefault(_price);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref2 = _react2.default.createElement('div', null);
	
	var BulkyBody = exports.BulkyBody = function BulkyBody(_ref) {
	  var item = _ref.item,
	      currency = _ref.currency,
	      reasonError = _ref.reasonError,
	      refundsRequested = _ref.refundsRequested,
	      setState = _ref.setState;
	
	
	  var _refundableCodes = item.codes.filter(function (obj) {
	    return obj.refundable;
	  });
	
	  var _bulkRefundRequest = function _bulkRefundRequest(code) {
	    var refundCodes = void 0,
	        nextReasonError = void 0;
	    if (refundsRequested.length === 0) {
	      nextReasonError = false;
	    }
	    if (!!code) {
	      refundCodes = refundsRequested;
	      if (refundCodes.includes(code)) {
	        refundCodes.splice(refundCodes.indexOf(code), 1);
	      } else {
	        refundCodes.push(code);
	      }
	    } else {
	      if (refundsRequested.length === _refundableCodes.length) {
	        refundCodes = [];
	      } else {
	        refundCodes = _refundableCodes.map(function (code) {
	          return code.code;
	        });
	      }
	    }
	    setState({ refundCodes: refundCodes, reasonError: nextReasonError, refundSuccess: undefined });
	  };
	
	  var rows = _refundableCodes.map(function (code) {
	    var checked = refundsRequested.includes(code.code);
	    return _react2.default.createElement(
	      'tr',
	      { key: code.code, className: checked ? 'checked' : '', onClick: function onClick() {
	          return _bulkRefundRequest(code.code);
	        } },
	      _react2.default.createElement(
	        'td',
	        { className: 'checkbox' },
	        _react2.default.createElement('input', { type: 'checkbox', checked: checked, readOnly: true })
	      ),
	      _react2.default.createElement(
	        'td',
	        { className: 'code' },
	        code.code
	      ),
	      _react2.default.createElement(
	        'td',
	        { className: 'price' },
	        _react2.default.createElement(_price2.default, { price: _utils2.default._itemPrice(item, currency), currency: currency, skipCurrency: true })
	      )
	    );
	  });
	
	  var headerChecked = _refundableCodes.length === refundsRequested.length;
	  return _react2.default.createElement(
	    'div',
	    { className: 'bulk-refunds-table-container' },
	    _react2.default.createElement(
	      'strong',
	      null,
	      i18n.t('refunds.select-codes')
	    ),
	    reasonError && _react2.default.createElement(
	      'div',
	      { className: 'failure-message visible' },
	      i18n.t("refunds.bulk.pick-one")
	    ),
	    _react2.default.createElement(
	      'table',
	      { className: 'bulk-refunds' },
	      _react2.default.createElement(
	        'thead',
	        null,
	        _react2.default.createElement(
	          'tr',
	          { className: headerChecked ? 'checked' : '', onClick: function onClick() {
	              return _bulkRefundRequest();
	            } },
	          _react2.default.createElement(
	            'th',
	            { className: 'checkbox' },
	            _react2.default.createElement('input', { type: 'checkbox', checked: headerChecked, readOnly: true })
	          ),
	          _react2.default.createElement(
	            'th',
	            { className: 'codes' },
	            i18n.t('refunds.bulk.available-codes'),
	            ' (',
	            _react2.default.createElement(
	              'strong',
	              null,
	              _refundableCodes.length
	            ),
	            ')'
	          ),
	          _react2.default.createElement(
	            'th',
	            { className: 'price' },
	            i18n.t('transactions.price')
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _scrollView2.default,
	        { element: 'table-body' },
	        rows
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'code-selections' },
	      _react2.default.createElement(
	        'span',
	        { className: 'codes' },
	        i18n.t('refunds.bulk.codes-selected'),
	        ': ',
	        _react2.default.createElement(
	          'strong',
	          null,
	          refundsRequested.length
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'price-wrapper' },
	        _react2.default.createElement(
	          'span',
	          { className: 'total' },
	          i18n.t('transactions.total'),
	          ': ',
	          _react2.default.createElement(
	            'strong',
	            null,
	            _react2.default.createElement(_price2.default, { price: parseInt(refundsRequested.length, 10) * _utils2.default._itemPrice(item, currency), currency: currency, skipCurrency: true })
	          )
	        )
	      )
	    ),
	    _ref2
	  );
	};
	
	var SlimBody = exports.SlimBody = function SlimBody(_ref3) {
	  var setState = _ref3.setState,
	      reasonError = _ref3.reasonError,
	      reasons = _ref3.reasons;
	
	  var _onCheckboxChange = function _onCheckboxChange(e) {
	    var input = e.target;
	    var name = input.getAttribute('name');
	    var stateUpdates = {};
	    stateUpdates[name] = !reasons[name];
	    stateUpdates.reasonError = false;
	    stateUpdates.refundSuccess = undefined;
	    if (name === 'other' && stateUpdates.other === false) {
	      stateUpdates['otherExplain'] = '';
	    }
	    setState(stateUpdates);
	  };
	
	  var _onOtherExplainChange = function _onOtherExplainChange(e) {
	    var otherExplain = e.target.value;
	    var other = !!otherExplain;
	    setState({ otherExplain: otherExplain, other: other, reasonError: false, refundSuccess: undefined });
	  };
	
	  var _giveReasons = function _giveReasons() {
	    return reasons.other && !reasons["other-explain"];
	  };
	
	  var _errorMessage = function _errorMessage() {
	    if (reasonError) {
	      var localizedString = void 0;
	      if (_giveReasons()) {
	        localizedString = 'refunds.missing-elaboration';
	      } else {
	        localizedString = 'refunds.missing-reason';
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: 'failure-message visible' },
	        i18n.t(localizedString)
	      );
	    }
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'why' },
	    _react2.default.createElement(
	      'strong',
	      null,
	      i18n.t('refunds.why')
	    ),
	    ' ',
	    _react2.default.createElement(
	      'span',
	      null,
	      i18n.t('base.required'),
	      '*'
	    ),
	    reasonError && _errorMessage(),
	    _react2.default.createElement(
	      'ul',
	      { className: 'reasons' },
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement('input', { type: 'checkbox', name: 'dropped', id: 'dropped-course', checked: !!reasons.dropped, onChange: function onChange(e) {
	            return _onCheckboxChange(e);
	          } }),
	        _react2.default.createElement(
	          'label',
	          { htmlFor: 'dropped-course' },
	          i18n.t('refunds.reasons.dropped')
	        )
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement('input', { type: 'checkbox', name: 'wrong', id: 'wrong-book', checked: !!reasons.wrong, onChange: function onChange(e) {
	            return _onCheckboxChange(e);
	          } }),
	        _react2.default.createElement(
	          'label',
	          { htmlFor: 'wrong-book' },
	          i18n.t('refunds.reasons.wrong')
	        )
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement('input', { type: 'checkbox', name: 'print', id: 'print-version', checked: !!reasons.print, onChange: function onChange(e) {
	            return _onCheckboxChange(e);
	          } }),
	        _react2.default.createElement(
	          'label',
	          { htmlFor: 'print-version' },
	          i18n.t('refunds.reasons.print')
	        )
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement('input', { type: 'checkbox', name: 'missing', id: 'missing-content', checked: !!reasons.missing, onChange: function onChange(e) {
	            return _onCheckboxChange(e);
	          } }),
	        _react2.default.createElement(
	          'label',
	          { htmlFor: 'missing-content' },
	          i18n.t('refunds.reasons.missing')
	        )
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement('input', { type: 'checkbox', name: 'other', id: 'other-reason', checked: !!reasons.other, onChange: function onChange(e) {
	            return _onCheckboxChange(e);
	          } }),
	        _react2.default.createElement('input', { className: "medium" + (reasonError && _giveReasons() ? " failure" : ""), type: 'text', name: 'other-explain', id: 'other-explain', value: reasons.otherExplain || '', onChange: function onChange(e) {
	            return _onOtherExplainChange(e);
	          } })
	      )
	    )
	  );
	};

/***/ },
/* 752 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _refundAction = __webpack_require__(157);
	
	var _refundAction2 = _interopRequireDefault(_refundAction);
	
	var _refundResponse = __webpack_require__(753);
	
	var _refundRequestBody = __webpack_require__(751);
	
	var _transactionAction = __webpack_require__(158);
	
	var _transactionAction2 = _interopRequireDefault(_transactionAction);
	
	var _purchaseItem = __webpack_require__(160);
	
	var _purchaseItem2 = _interopRequireDefault(_purchaseItem);
	
	var _dispatcher = __webpack_require__(18);
	
	var _dispatcher2 = _interopRequireDefault(_dispatcher);
	
	var _utils = __webpack_require__(28);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _vstui = __webpack_require__(30);
	
	var _vstui2 = __webpack_require__(89);
	
	var _themes = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _ref = _react2.default.createElement(_vstui.VstLoader, null);
	
	var RefundRequest = function (_React$Component) {
	  _inherits(RefundRequest, _React$Component);
	
	  function RefundRequest(props) {
	    _classCallCheck(this, RefundRequest);
	
	    var _this = _possibleConstructorReturn(this, (RefundRequest.__proto__ || Object.getPrototypeOf(RefundRequest)).call(this, props));
	
	    var _this$props = _this.props,
	        transaction = _this$props.transaction,
	        item = _this$props.item;
	
	    _this.state = {
	      refundCodes: transaction.bulk ? [] : item.codes.map(function (c) {
	        return c.code;
	      })
	    };
	
	    _this._onRefundSuccess = _this._onRefundSuccess.bind(_this);
	    _this._onRefundFailure = _this._onRefundFailure.bind(_this);
	    _this._onProgressButtonReset = _this._onProgressButtonReset.bind(_this);
	    _this._requestRefund = _this._requestRefund.bind(_this);
	    _this._hideModal = _this._hideModal.bind(_this);
	    return _this;
	  }
	
	  _createClass(RefundRequest, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      _dispatcher2.default.on(_dispatcher2.default.TRANSACTION_REFUND_SUCCESS, this._onRefundSuccess);
	      _dispatcher2.default.on(_dispatcher2.default.TRANSACTION_REFUND_FAILURE, this._onRefundFailure);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      _dispatcher2.default.removeListener(_dispatcher2.default.TRANSACTION_REFUND_SUCCESS, this._onRefundSuccess);
	      _dispatcher2.default.removeListener(_dispatcher2.default.TRANSACTION_REFUND_FAILURE, this._onRefundFailure);
	    }
	  }, {
	    key: '_hideModal',
	    value: function _hideModal() {
	      _transactionAction2.default.showDetails(this.props.transaction.number);
	    }
	  }, {
	    key: '_onRefundSuccess',
	    value: function _onRefundSuccess(data) {
	      this.setState({ refundSuccess: data.codes === this.state.refundCodes });
	    }
	  }, {
	    key: '_onRefundFailure',
	    value: function _onRefundFailure(details) {
	      if (details.itemCodes === this.state.refundCodes) {
	        this.setState({ refundSuccess: false, refundError: true });
	      }
	    }
	  }, {
	    key: '_onProgressButtonReset',
	    value: function _onProgressButtonReset() {
	      var refundSuccess = this.state.refundSuccess;
	
	      if (refundSuccess === false) {
	        this.setState({ refundSuccess: undefined });
	      } else if (refundSuccess === true) {
	        this._hideModal();
	      }
	    }
	  }, {
	    key: '_getReasonDetails',
	    value: function _getReasonDetails() {
	      var reasons = [];
	      var _state = this.state,
	          dropped = _state.dropped,
	          wrong = _state.wrong,
	          print = _state.print,
	          missing = _state.missing,
	          other = _state.other,
	          otherExplain = _state.otherExplain;
	
	      if (other && !otherExplain) {
	        return '';
	      }
	
	      if (dropped) {
	        reasons.push("Dropped course");
	      }
	      if (wrong) {
	        reasons.push("Wrong book");
	      }
	      if (print) {
	        reasons.push("Purchased print book");
	      }
	      if (missing) {
	        reasons.push("Missing content");
	      }
	      if (other && otherExplain) {
	        reasons.push("Other: " + otherExplain);
	      }
	
	      return reasons.join("; ");
	    }
	  }, {
	    key: '_requestRefund',
	    value: function _requestRefund() {
	      var _props = this.props,
	          _props$transaction = _props.transaction,
	          bulk = _props$transaction.bulk,
	          transactionId = _props$transaction.number,
	          creditCardType = _props$transaction.creditCardType,
	          creditCardNumber = _props$transaction.creditCardNumber,
	          currency = _props$transaction.currency,
	          item = _props.item;
	      var codes = this.state.refundCodes;
	
	      var details = this._getReasonDetails();
	      if (details === '' && (!bulk || codes.length === 0)) {
	        this.setState({ reasonError: true, refundSuccess: false });
	      } else {
	        this.setState({ refundError: false });
	        var params = {
	          codes: codes,
	          isbn: item.sku,
	          transactionId: transactionId,
	          reason: this._getReasonDetails(),
	          creditCardType: creditCardType,
	          creditCardNumber: creditCardNumber,
	          currency: _utils2.default.getCurrencySymbol(currency),
	          amount: (_utils2.default._itemPrice(item, currency, true) * codes.length).toFixed(2) + ' ' + currency,
	          bulk: bulk
	        };
	        _refundAction2.default.requestRefund(params);
	      }
	    }
	  }, {
	    key: '_modalTitle',
	    value: function _modalTitle() {
	      if (this.state.refundError) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'h2',
	            { id: 'refund-request-title', className: 'error' },
	            i18n.t('refunds.error')
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            i18n.t('refunds.error-explain')
	          )
	        );
	      } else {
	        var bulk = this.props.transaction.bulk;
	
	        var text = bulk ? 'refunds.bulk.complete' : 'refunds.sorry';
	        return _react2.default.createElement(
	          'h2',
	          { id: 'refund-request-title', className: bulk ? "bulk" : "slim" },
	          i18n.t(text)
	        );
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var body = void 0;
	      var _props2 = this.props,
	          transaction = _props2.transaction,
	          item = _props2.item;
	      var _state2 = this.state,
	          refundSuccess = _state2.refundSuccess,
	          reasonError = _state2.reasonError,
	          refundCodes = _state2.refundCodes;
	
	
	      if (transaction) {
	        if (refundSuccess === true) {
	          body = _react2.default.createElement(_refundResponse.RefundComplete, {
	            transactionNumber: transaction.number,
	            isbn: item.isbn });
	        } else if (refundSuccess === false && refundCodes.length !== 0 && !reasonError) {
	          body = _react2.default.createElement(_refundResponse.RefundFailed, {
	            retry: function retry() {
	              return _this2.setState({ refundSuccess: undefined, refundError: undefined });
	            },
	            transactionNumber: transaction.number });
	        } else {
	          var mainClassName = void 0,
	              purchaseItemClassName = void 0,
	              refundPolicy = void 0,
	              buttonClassName = void 0,
	              component = void 0,
	              refundText = void 0;
	          if (transaction.bulk) {
	            mainClassName = "";
	            purchaseItemClassName = "";
	            buttonClassName = "bulk-complete";
	            component = _react2.default.createElement(_refundRequestBody.BulkyBody, {
	              setState: function setState(newState) {
	                return _this2.setState(newState);
	              },
	              currency: transaction.currency,
	              item: item,
	              refundsRequested: refundCodes,
	              reasonError: reasonError
	            });
	            refundPolicy = _utils2.default.toHTML(i18n.t('refunds.bulk.policy', { brand: Mulligan.Brand.AccountCenter.brand, policy_url: "https://support.vitalsource.com/hc/en-us/articles/234745668-Bulk-Purchase-Refund-Policy" }));
	            refundText = i18n.t("refunds.bulk.complete");
	          } else {
	            var _state3 = this.state,
	                dropped = _state3.dropped,
	                wrong = _state3.wrong,
	                print = _state3.print,
	                missing = _state3.missing,
	                other = _state3.other,
	                otherExplain = _state3.otherExplain;
	
	            mainClassName = "details-wrapper";
	            purchaseItemClassName = "request-refund-header";
	            component = _react2.default.createElement(_refundRequestBody.SlimBody, {
	              setState: function setState(newState) {
	                return _this2.setState(newState);
	              },
	              reasons: { dropped: dropped, wrong: wrong, print: print, missing: missing, other: other, otherExplain: otherExplain },
	              reasonError: reasonError
	            });
	            buttonClassName = 'medium';
	            refundPolicy = _utils2.default.toHTML(i18n.t('refunds.policy', { brand: Mulligan.Brand.AccountCenter.brand }));
	            refundText = i18n.t("refunds.refund");
	          }
	          body = _react2.default.createElement(
	            'div',
	            { className: 'deck refund-request' },
	            this._modalTitle(),
	            _react2.default.createElement(
	              'div',
	              { className: mainClassName },
	              _react2.default.createElement(_purchaseItem2.default, { className: purchaseItemClassName,
	                item: item,
	                transaction: transaction,
	                hideRefundButton: true,
	                hideDownloadCodes: true,
	                isRefund: true,
	                hideRight: transaction.bulk }),
	              component
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'policy' },
	              refundPolicy
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'button-container' },
	              _react2.default.createElement(
	                'button',
	                { className: 'vst-href-text-button', onClick: this._hideModal },
	                i18n.t('base.cancel')
	              ),
	              _react2.default.createElement(
	                _vstui.VstProgressButton,
	                { className: buttonClassName,
	                  progressText: 'Requesting...',
	                  success: refundSuccess,
	                  onReset: this._onProgressButtonReset,
	                  onClick: this._requestRefund },
	                refundText
	              )
	            )
	          );
	        }
	      } else {
	        body = _ref;
	      }
	      return _react2.default.createElement(
	        _vstui2.Dialog,
	        { title: '', size: 'large', onRequestClose: this._hideModal, open: true },
	        body
	      );
	    }
	  }]);
	
	  return RefundRequest;
	}(_react2.default.Component);
	
	exports.default = RefundRequest;
	;

/***/ },
/* 753 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.RefundFailed = exports.RefundComplete = undefined;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _vstui = __webpack_require__(30);
	
	var _transactionAction = __webpack_require__(158);
	
	var _transactionAction2 = _interopRequireDefault(_transactionAction);
	
	var _transactionStore = __webpack_require__(119);
	
	var _transactionStore2 = _interopRequireDefault(_transactionStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _hideModal = function _hideModal(transactionNumber) {
	  _transactionAction2.default.showDetails(transactionNumber);
	  return true;
	};
	
	var RefundComplete = exports.RefundComplete = function RefundComplete(_ref) {
	  var transactionNumber = _ref.transactionNumber;
	
	
	  // NOTE: remove if statement when receiving whole refund transaction from api
	  return _react2.default.createElement(
	    'div',
	    { className: 'refund-complete' },
	    _react2.default.createElement('img', { src: __webpack_require__(965), role: 'presentation', style: { width: '90px', height: '90px' } }),
	    _react2.default.createElement(
	      'p',
	      { className: 'success-message' },
	      i18n.t("refunds.bulk.success")
	    ),
	    _react2.default.createElement(
	      _vstui.VstButton,
	      {
	        className: 'view-details',
	        options: 'btn-36',
	        onClick: function onClick() {
	          return _hideModal(transactionNumber);
	        }
	      },
	      i18n.t('base.close')
	    )
	  );
	};
	
	var RefundFailed = exports.RefundFailed = function RefundFailed(_ref2) {
	  var retry = _ref2.retry,
	      transactionNumber = _ref2.transactionNumber;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'refund-failed' },
	    _react2.default.createElement('img', { src: __webpack_require__(963), role: 'presentation', style: { width: '90px', height: '90px' } }),
	    _react2.default.createElement(
	      'p',
	      { className: 'refund-failure-message' },
	      i18n.t("refunds.bulk.failure")
	    ),
	    _react2.default.createElement(
	      _vstui.VstButton,
	      { options: 'btn-36', onClick: retry, className: 'try-again' },
	      i18n.t("refunds.bulk.retry")
	    ),
	    _react2.default.createElement(
	      'a',
	      { href: Mulligan.Brand.Support.url, target: '_blank', className: 'vst-href-text-button close-refund-complete', onClick: function onClick() {
	          return _hideModal(transactionNumber);
	        } },
	      i18n.t('refunds.bulk.support')
	    )
	  );
	};
	
	exports.default = RefundComplete;

/***/ },
/* 754 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _vstui = __webpack_require__(30);
	
	var _vstui2 = __webpack_require__(89);
	
	var _utils = __webpack_require__(28);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _transactionAction = __webpack_require__(158);
	
	var _transactionAction2 = _interopRequireDefault(_transactionAction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RefundRestrictions = function RefundRestrictions(_ref) {
	  var open = _ref.open,
	      bulk = _ref.bulk,
	      orderNumber = _ref.orderNumber;
	
	
	  var reasons = function reasons() {
	    if (bulk) {
	      return _react2.default.createElement(
	        'ol',
	        null,
	        _react2.default.createElement(
	          'li',
	          null,
	          i18n.t('transactions.modal.cant-refund-5')
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          i18n.t('transactions.modal.cant-refund-6')
	        )
	      );
	    } else {
	      return _react2.default.createElement(
	        'ol',
	        null,
	        _react2.default.createElement(
	          'li',
	          null,
	          i18n.t('transactions.modal.cant-refund-1')
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          i18n.t('transactions.modal.cant-refund-2')
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          i18n.t('transactions.modal.cant-refund-3')
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          i18n.t('transactions.modal.cant-refund-4')
	        )
	      );
	    }
	  };
	
	  var _hideModal = function _hideModal() {
	    _transactionAction2.default.showDetails(orderNumber);
	  };
	
	  if (open) {
	    return _react2.default.createElement(
	      _vstui2.Dialog,
	      { open: true, onRequestClose: _hideModal, title: i18n.t('transactions.modal.cant-refund-title'), size: 'large' },
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'p',
	          null,
	          i18n.t('transactions.modal.cant-refund')
	        ),
	        reasons(),
	        _react2.default.createElement(
	          'p',
	          null,
	          _utils2.default.toHTML(i18n.t('transactions.modal.cant-refund-support', { brand: Mulligan.Brand.AccountCenter.brand, support_url: Mulligan.Brand.Support.url }))
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'button-container' },
	          _react2.default.createElement(
	            _vstui2.Button,
	            { onClick: _hideModal },
	            i18n.t('base.close')
	          )
	        )
	      )
	    );
	  } else {
	    return null;
	  }
	};
	
	RefundRestrictions.defaultProps = {
	  open: false
	};
	
	exports.default = RefundRestrictions;

/***/ },
/* 755 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _dispatcher = __webpack_require__(18);
	
	var _dispatcher2 = _interopRequireDefault(_dispatcher);
	
	var _transactionStore = __webpack_require__(119);
	
	var _transactionStore2 = _interopRequireDefault(_transactionStore);
	
	var _price = __webpack_require__(118);
	
	var _price2 = _interopRequireDefault(_price);
	
	var _refundAction = __webpack_require__(157);
	
	var _refundAction2 = _interopRequireDefault(_refundAction);
	
	var _utils = __webpack_require__(28);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _vstui = __webpack_require__(30);
	
	var _vstui2 = __webpack_require__(89);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement(
	  "div",
	  { className: "deck" },
	  _react2.default.createElement(_vstui.VstLoader, null)
	);
	
	var RefundsContainer = _react2.default.createClass({
	  displayName: "RefundsContainer",
	  getInitialState: function getInitialState() {
	    return { transactions: _transactionStore2.default.getAllRefunds() };
	  },
	  componentDidMount: function componentDidMount() {
	    _dispatcher2.default.on(_dispatcher2.default.TRANSACTION_STORE_CHANGE, this._onChange);
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    _dispatcher2.default.removeListener(_dispatcher2.default.TRANSACTION_STORE_CHANGE, this._onChange);
	  },
	  _onChange: function _onChange() {
	    this.setState({ transactions: _transactionStore2.default.getAllRefunds() });
	  },
	  _onDetailClick: function _onDetailClick(e) {
	    e.preventDefault();
	    var code = e.currentTarget.dataset.code;
	    _refundAction2.default.viewDetails(code);
	  },
	  _renderTableRows: function _renderTableRows() {
	    var _this = this;
	
	    var tableRows = this.state.transactions.map(function (transaction, index) {
	      var i = transaction.purchaseItems[0];
	      var currency = transaction.currency,
	          number = transaction.number,
	          orderDate = transaction.orderDate;
	
	      var date = new Date(orderDate);
	      var price = i.quantity * _utils2.default._itemPrice(i, currency, true);
	      return {
	        refunded: {
	          content: _utils2.default.toDateString(transaction.orderDate),
	          sort: transaction.orderDate
	        },
	        title: i.title,
	        total: {
	          content: _react2.default.createElement(_price2.default, { price: price, currency: currency }),
	          sort: price
	        },
	        details: _react2.default.createElement(
	          "a",
	          {
	            className: "details-link",
	            href: "/transactions/refunds/" + number,
	            "data-code": number,
	            onClick: _this._onDetailClick
	          },
	          _react2.default.createElement(
	            "span",
	            null,
	            i18n.t("base.details")
	          )
	        )
	      };
	    });
	    return tableRows;
	  },
	  _renderTableHeaders: function _renderTableHeaders() {
	    return [{
	      header: i18n.t("refunds.refunded"),
	      numeric: false,
	      hiddenHeader: false,
	      rowKey: "refunded"
	    }, {
	      header: i18n.t("transactions.book-title"),
	      numeric: false,
	      hiddenHeader: false,
	      rowKey: "title"
	    }, {
	      header: i18n.t("transactions.total"),
	      numeric: false,
	      hiddenHeader: false,
	      rowKey: "total"
	    }, { header: "", numeric: false, hiddenHeader: false, rowKey: "details" }];
	  },
	  render: function render() {
	    var body = _ref;
	
	    var transactions = this.state.transactions;
	
	    if (transactions) {
	      if (transactions.length > 0) {
	        body = _react2.default.createElement(_vstui2.Table, {
	          fullWidth: true,
	          columns: this._renderTableHeaders(),
	          rows: this._renderTableRows()
	        });
	      } else {
	        body = _react2.default.createElement(
	          "p",
	          null,
	          i18n.t("refunds.no-refunds")
	        );
	      }
	    }
	
	    return body;
	  }
	});
	
	exports.default = RefundsContainer;

/***/ },
/* 756 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _resourceDetailsStore = __webpack_require__(761);
	
	var _resourceDetailsStore2 = _interopRequireDefault(_resourceDetailsStore);
	
	var _dispatcher = __webpack_require__(18);
	
	var _dispatcher2 = _interopRequireDefault(_dispatcher);
	
	var _utils = __webpack_require__(28);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _vstui = __webpack_require__(30);
	
	var _vstui2 = __webpack_require__(89);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement(
	  "div",
	  { className: "deck resource-list" },
	  _react2.default.createElement(_vstui.VstLoader, null)
	);
	
	var Resource = _react2.default.createClass({
	  displayName: "Resource",
	  getInitialState: function getInitialState() {
	    return {
	      resource: this._filterAncillaries(_resourceDetailsStore2.default.get(this.props.isbn)),
	      downloadSupported: false
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    _dispatcher2.default.on(_dispatcher2.default.RESOURCE_DETAILS_STORE_CHANGE, this._handleChange);
	    this._checkDownloadAttrSupport();
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    _dispatcher2.default.removeListener(_dispatcher2.default.RESOURCE_DETAILS_STORE_CHANGE, this._handleChange);
	  },
	  _handleChange: function _handleChange() {
	    this.setState({
	      resource: this._filterAncillaries(_resourceDetailsStore2.default.get(this.props.isbn))
	    });
	  },
	  _checkDownloadAttrSupport: function _checkDownloadAttrSupport() {
	    // For now, disable Firefox as well, since it technically allows the download
	    // attribute, but ONLY from same origin (not AWS)
	    var a = document.createElement("a");
	
	    var browser = navigator.userAgent.toLowerCase();
	    var isFirefox = browser.indexOf("firefox") > -1 ? true : false;
	
	    if (typeof a.download != "undefined" && !isFirefox) {
	      this.setState({
	        downloadSupported: true
	      });
	    }
	  },
	  _downloadAll: function _downloadAll() {
	    var anchors = document.getElementsByClassName("file-download");
	    var download = function download(anchor, count) {
	      if (anchor) {
	        anchor.click();
	      }
	      count++;
	      if (count < anchors.length) {
	        setTimeout(function () {
	          download(anchors[count], count);
	        }, 100);
	      }
	    };
	
	    setTimeout(function () {
	      download(anchors[0], 0);
	    }, 1000);
	  },
	  _filterAncillaries: function _filterAncillaries(data) {
	    var _this = this;
	
	    if (data && data.ancillaries.length > 0) {
	      data.ancillaries = data.ancillaries.filter(function (item, index) {
	        if (item.type !== "accesscode") {
	          item.name = item.title;
	          if (item.type === "url") {
	            item.typeDisplay = "URL";
	            item.size = "-";
	            item.action = _react2.default.createElement(
	              "a",
	              { href: item.href, target: "_blank" },
	              i18n.t("base.launch")
	            );
	          } else if (item.type === "file") {
	            item.typeDisplay = _this._getFileExtension(item.href).toUpperCase();
	            item.action = _react2.default.createElement(
	              "a",
	              {
	                href: item.href,
	                target: "_blank",
	                className: "file-download",
	                download: ""
	              },
	              i18n.t("base.download")
	            );
	          } else {
	            item.typeDisplay = "-";
	            item.action = _react2.default.createElement(
	              "a",
	              { href: item.href, target: "_blank" },
	              i18n.t("base.launch")
	            );
	          }
	
	          return item;
	        }
	      });
	    }
	    return data;
	  },
	  _getFileExtension: function _getFileExtension(url) {
	    return url.split("?")[0].split(".").pop();
	  },
	  renderTable: function renderTable() {
	    var resource = this.state.resource;
	
	    var count = resource ? resource.ancillaries.length : "";
	    var tableHeaders = [{
	      header: i18n.t("resources.name"),
	      numeric: false,
	      hiddenHeader: false,
	      rowKey: "name"
	    }, {
	      header: i18n.t("resources.type"),
	      numeric: false,
	      hiddenHeader: false,
	      rowKey: "type"
	    }, {
	      header: i18n.t("resources.size"),
	      numeric: false,
	      hiddenHeader: false,
	      rowKey: "size"
	    }, { header: "", numeric: false, hiddenHeader: false, rowKey: "action" }];
	
	    var tableRows = [];
	
	    if (resource) {
	      tableRows = resource.ancillaries.map(function (ancillary) {
	        return {
	          name: ancillary.name || "",
	          type: ancillary.typeDisplay || "",
	          size: ancillary.size || 0,
	          action: ancillary.action
	        };
	      });
	    }
	
	    if (!resource) {
	      return _ref;
	    } else if (tableRows.length < 1) {
	      return _react2.default.createElement(
	        "div",
	        { className: "deck resource-list" },
	        i18n.t("resources.no-ancillaries")
	      );
	    }
	    return _react2.default.createElement(_vstui2.Table, { columns: tableHeaders, rows: tableRows, fullWidth: true });
	  },
	  render: function render() {
	    var _state = this.state,
	        resource = _state.resource,
	        downloadSupported = _state.downloadSupported;
	
	    var count = resource ? resource.ancillaries.length : "";
	    var title = resource ? resource.title : "";
	    var downloadAll = downloadSupported && _react2.default.createElement(
	      _vstui2.Button,
	      { naked: true, className: "download-all", onClick: this._downloadAll },
	      i18n.t("resources.download-all")
	    );
	    var table = this.renderTable();
	
	    return _react2.default.createElement(
	      "div",
	      { className: "page resources" },
	      _react2.default.createElement(
	        "header",
	        null,
	        _react2.default.createElement(
	          "a",
	          { className: "arrow-back-button", href: "#/resources" },
	          _react2.default.createElement("img", {
	            src: __webpack_require__(398),
	            alt: i18n.t("resources.back")
	          })
	        ),
	        _react2.default.createElement(
	          "h1",
	          { className: "resource-title" },
	          count,
	          " ",
	          i18n.t("resources.ancillaries"),
	          _react2.default.createElement(
	            "span",
	            { className: "not-link" },
	            i18n.t("resources.in"),
	            " ",
	            _utils2.default.toHTML(title)
	          )
	        ),
	        downloadAll
	      ),
	      table
	    );
	  }
	});
	
	exports.default = Resource;

/***/ },
/* 757 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _resourceStore = __webpack_require__(762);
	
	var _resourceStore2 = _interopRequireDefault(_resourceStore);
	
	var _accessCodesStore = __webpack_require__(237);
	
	var _accessCodesStore2 = _interopRequireDefault(_accessCodesStore);
	
	var _userStore = __webpack_require__(81);
	
	var _userStore2 = _interopRequireDefault(_userStore);
	
	var _dispatcher = __webpack_require__(18);
	
	var _dispatcher2 = _interopRequireDefault(_dispatcher);
	
	var _ancillaries = __webpack_require__(740);
	
	var _ancillaries2 = _interopRequireDefault(_ancillaries);
	
	var _accessCodes = __webpack_require__(739);
	
	var _accessCodes2 = _interopRequireDefault(_accessCodes);
	
	var _vstui = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ResourcesContainer = function (_React$Component) {
	  _inherits(ResourcesContainer, _React$Component);
	
	  function ResourcesContainer() {
	    _classCallCheck(this, ResourcesContainer);
	
	    var _this = _possibleConstructorReturn(this, (ResourcesContainer.__proto__ || Object.getPrototypeOf(ResourcesContainer)).call(this));
	
	    _this.state = {
	      resources: _resourceStore2.default.getAll(),
	      user: _userStore2.default.get()
	    };
	
	    _this._handleResourceChange = _this._handleResourceChange.bind(_this);
	    _this._handleUserChange = _this._handleUserChange.bind(_this);
	    return _this;
	  }
	
	  _createClass(ResourcesContainer, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      _dispatcher2.default.on(_dispatcher2.default.RESOURCE_STORE_CHANGE, this._handleResourceChange);
	      _dispatcher2.default.on(_dispatcher2.default.USER_STORE_CHANGE, this._handleUserChange);
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      _dispatcher2.default.removeListener(_dispatcher2.default.RESOURCE_STORE_CHANGE, this._handleResourceChange);
	      _dispatcher2.default.removeListener(_dispatcher2.default.USER_STORE_CHANGE, this._handleUserChange);
	    }
	  }, {
	    key: "_handleResourceChange",
	    value: function _handleResourceChange() {
	      this.setState({ resources: _resourceStore2.default.getAll() });
	    }
	  }, {
	    key: "_handleUserChange",
	    value: function _handleUserChange() {
	      this.setState({ user: _userStore2.default.get() });
	    }
	  }, {
	    key: "_clickTab",
	    value: function _clickTab(e) {
	      Routes.setRoute("resources/" + e.currentTarget.dataset.key);
	    }
	  }, {
	    key: "_getTotalAncillaryCount",
	    value: function _getTotalAncillaryCount() {
	      if (!this.state.resources) {
	        return 0;
	      }
	      return this.state.resources.reduce(function (acc, item) {
	        return item.ancillariesCount > 0 ? acc + 1 : acc;
	      }, 0);
	    }
	  }, {
	    key: "_getTotalAccessCodeCount",
	    value: function _getTotalAccessCodeCount() {
	      if (!this.state.resources) {
	        return 0;
	      }
	      return this.state.resources.reduce(function (acc, item) {
	        return acc.accessCodeCount || item.accessCodeCount > 0 ? acc + 1 : acc;
	      }, 0);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        "div",
	        { className: "page resources" },
	        _react2.default.createElement(
	          "h1",
	          null,
	          i18n.t("base.resources")
	        ),
	        _react2.default.createElement(
	          _vstui.VstTabs,
	          { activeIndex: this.props.activeIndex },
	          _react2.default.createElement(
	            _vstui.VstTabs.Bar,
	            null,
	            _react2.default.createElement(
	              _vstui.VstTabs.Tab,
	              { href: "#/resources/ancillaries" },
	              i18n.t("resources.ancillaries"),
	              " ",
	              _react2.default.createElement(
	                "span",
	                null,
	                "(",
	                this._getTotalAncillaryCount(),
	                ")"
	              )
	            ),
	            _react2.default.createElement(
	              _vstui.VstTabs.Tab,
	              { href: "#resources/access-codes" },
	              i18n.t("resources.access-codes"),
	              " ",
	              _react2.default.createElement(
	                "span",
	                null,
	                "(",
	                this._getTotalAccessCodeCount(),
	                ")"
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _vstui.VstTabs.Panels,
	            null,
	            _react2.default.createElement(
	              "div",
	              { className: "deck resource-list" },
	              _react2.default.createElement(_ancillaries2.default, {
	                user: this.state.user,
	                resources: this.state.resources
	              })
	            ),
	            _react2.default.createElement(_accessCodes2.default, { user: this.state.user })
	          )
	        )
	      );
	    }
	  }]);
	
	  return ResourcesContainer;
	}(_react2.default.Component);
	
	exports.default = ResourcesContainer;

/***/ },
/* 758 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _dispatcher = __webpack_require__(18);
	
	var _dispatcher2 = _interopRequireDefault(_dispatcher);
	
	var _refundRestrictions = __webpack_require__(754);
	
	var _refundRestrictions2 = _interopRequireDefault(_refundRestrictions);
	
	var _transactionStore = __webpack_require__(119);
	
	var _transactionStore2 = _interopRequireDefault(_transactionStore);
	
	var _transactionDetailHeader = __webpack_require__(236);
	
	var _transactionDetailHeader2 = _interopRequireDefault(_transactionDetailHeader);
	
	var _backLinkHeader = __webpack_require__(235);
	
	var _backLinkHeader2 = _interopRequireDefault(_backLinkHeader);
	
	var _purchaseItem = __webpack_require__(160);
	
	var _purchaseItem2 = _interopRequireDefault(_purchaseItem);
	
	var _refundRequest = __webpack_require__(752);
	
	var _refundRequest2 = _interopRequireDefault(_refundRequest);
	
	var _vstui = __webpack_require__(30);
	
	var _utils = __webpack_require__(28);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement(
	  'div',
	  { className: 'deck' },
	  _react2.default.createElement(_vstui.VstLoader, null)
	);
	
	var TransactionDetail = _react2.default.createClass({
	  displayName: 'TransactionDetail',
	  _onTransactionChange: function _onTransactionChange() {
	    var state = { transaction: _transactionStore2.default.get(this.props.orderNumber) };
	    this.setState(state);
	  },
	  getInitialState: function getInitialState() {
	    var state = { transaction: _transactionStore2.default.get(this.props.orderNumber) };
	    return state;
	  },
	  componentDidMount: function componentDidMount() {
	    _dispatcher2.default.on(_dispatcher2.default.TRANSACTION_STORE_CHANGE, this._onTransactionChange);
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    _dispatcher2.default.removeListener(_dispatcher2.default.TRANSACTION_STORE_CHANGE, this._onTransactionChange);
	  },
	  _renderLineItems: function _renderLineItems() {
	    var _this = this;
	
	    return this.state.transaction.purchaseItems.map(function (item) {
	      return _react2.default.createElement(_purchaseItem2.default, { transaction: _this.state.transaction,
	        item: item,
	        hideright: false,
	        key: 'purchase-item-' + item.isbn });
	    });
	  },
	  render: function render() {
	    var t = this.state.transaction,
	        body = void 0;
	
	    if (t === undefined) {
	      body = _ref;
	    } else {
	      var _props = this.props,
	          orderNumber = _props.orderNumber,
	          refundItemNumber = _props.refundItemNumber,
	          refundRestrictions = _props.refundRestrictions;
	
	      body = _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'deck', key: 'transaction-detail-' + t.number },
	          _react2.default.createElement(_transactionDetailHeader2.default, { transaction: t }),
	          this._renderLineItems()
	        ),
	        refundItemNumber && _react2.default.createElement(_refundRequest2.default, { transaction: t, item: t.purchaseItems.find(function (item) {
	            return item.isbn === refundItemNumber;
	          }) }),
	        _react2.default.createElement(_refundRestrictions2.default, { open: refundRestrictions, bulk: t.bulk, orderNumber: orderNumber })
	      );
	    }
	    return _react2.default.createElement(
	      'div',
	      { className: 'page transaction-detail' },
	      _react2.default.createElement(_backLinkHeader2.default, { alt: i18n.t('purchases.back'), href: '#/transactions', title: i18n.t('transactions.purchase-details') }),
	      body
	    );
	  }
	});
	
	exports.default = TransactionDetail;

/***/ },
/* 759 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _dispatcher = __webpack_require__(18);
	
	var _dispatcher2 = _interopRequireDefault(_dispatcher);
	
	var _userStore = __webpack_require__(81);
	
	var _userStore2 = _interopRequireDefault(_userStore);
	
	var _userAction = __webpack_require__(159);
	
	var _userAction2 = _interopRequireDefault(_userAction);
	
	var _utils = __webpack_require__(28);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _vstui = __webpack_require__(30);
	
	var _vstui2 = __webpack_require__(89);
	
	var _formAlert = __webpack_require__(744);
	
	var _formAlert2 = _interopRequireDefault(_formAlert);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement("option", { value: "" });
	
	var User = _react2.default.createClass({
	  displayName: "User",
	  getInitialState: function getInitialState() {
	    var state = this._getUserObject(_userStore2.default.get());
	    return state;
	  },
	  componentDidMount: function componentDidMount() {
	    _dispatcher2.default.on(_dispatcher2.default.USER_STORE_CHANGE, this._handleChange);
	    _dispatcher2.default.on(_dispatcher2.default.USER_UPDATE_SUCCESS, this._handleSetInfoSuccess);
	    _dispatcher2.default.on(_dispatcher2.default.USER_CHANGE_PASSWORD_SUCCESS, this._handleChangePasswordSuccess);
	    _dispatcher2.default.on(_dispatcher2.default.USER_UPDATE_SECURITY_SUCCESS, this._handleSecuritySuccess);
	    _dispatcher2.default.on(_dispatcher2.default.USER_UPDATE_FAILURE, this._handleSetInfoFailure);
	    _dispatcher2.default.on(_dispatcher2.default.USER_CHANGE_PASSWORD_FAILURE, this._handleChangePasswordFailure);
	    _dispatcher2.default.on(_dispatcher2.default.USER_UPDATE_SECURITY_FAILURE, this._handleSecurityFailure);
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    _dispatcher2.default.removeListener(_dispatcher2.default.USER_STORE_CHANGE, this._handleChange);
	    _dispatcher2.default.removeListener(_dispatcher2.default.USER_UPDATE_SUCCESS, this._handleSetInfoSuccess);
	    _dispatcher2.default.removeListener(_dispatcher2.default.USER_CHANGE_PASSWORD_SUCCESS, this._handleChangePasswordSuccess);
	    _dispatcher2.default.removeListener(_dispatcher2.default.USER_UPDATE_SECURITY_SUCCESS, this._handleSecuritySuccess);
	    _dispatcher2.default.removeListener(_dispatcher2.default.USER_UPDATE_FAILURE, this._handleSetInfoFailure);
	    _dispatcher2.default.removeListener(_dispatcher2.default.USER_CHANGE_PASSWORD_FAILURE, this._handleChangePasswordFailure);
	    _dispatcher2.default.removeListener(_dispatcher2.default.USER_UPDATE_SECURITY_FAILURE, this._handleSecurityFailure);
	  },
	  _handleChange: function _handleChange() {
	    this.setState(this._getUserObject(_userStore2.default.get()));
	  },
	  _handleSetInfoSuccess: function _handleSetInfoSuccess() {
	    this._hideModal();
	    _vstui.VstToastUtils.notify(i18n.t("user.info-updated"), {
	      type: "success",
	      horizontalPosition: "right"
	    });
	    this.setState({ settingInfo: false });
	  },
	  _handleChangePasswordSuccess: function _handleChangePasswordSuccess() {
	    this._hideModal();
	    _vstui.VstToastUtils.notify(i18n.t("user.password-updated"), {
	      type: "success",
	      horizontalPosition: "right"
	    });
	    this.setState({ updatingPassword: false });
	  },
	  _handleSecuritySuccess: function _handleSecuritySuccess() {
	    this._hideModal();
	    _vstui.VstToastUtils.notify(i18n.t("user.security-updated"), {
	      type: "success",
	      horizontalPosition: "right"
	    });
	    this.setState({ updatingSecurity: false });
	  },
	  _handleSetInfoFailure: function _handleSetInfoFailure() {
	    this.setState({
	      setInfoError: i18n.t("user.error-updating-info"),
	      settingInfo: false
	    });
	  },
	  _handleChangePasswordFailure: function _handleChangePasswordFailure(response) {
	    if (response && response.errors) {
	      if (response.errors.current_password && response.errors.current_password.indexOf("is not correct") !== -1) {
	        this.setState({
	          passwordChangeError: i18n.t("user.incorrect-password"),
	          updatingPassword: false
	        });
	      } else if (response.errors.password && response.errors.password.indexOf("password can not be the same as the previous password") !== -1) {
	        this.setState({
	          passwordChangeError: i18n.t("user.password-cannot-be-same"),
	          updatingPassword: false
	        });
	      }
	    }
	  },
	  _handleSecurityFailure: function _handleSecurityFailure() {
	    this.setState({
	      securityError: i18n.t("user.error-updating-info"),
	      updatingSecurity: false
	    });
	  },
	  _getUserObject: function _getUserObject(user) {
	    if (user) {
	      return {
	        user: user,
	        firstName: user.firstName,
	        lastName: user.lastName,
	        email: user.email,
	        questionId: user.questionId || ""
	      };
	    } else {
	      return { user: false };
	    }
	  },
	  _isValidPassword: function _isValidPassword(password) {
	    return !(password.length < 8 || !(password.match(/[A-Z]/) && password.match(/[a-z]/) && password.match(/[~!@#\$%\^&*\(\)_\-\+=\|\}\]\{\[:;"',\.\?\/<>]/)));
	  },
	  _onSubmit: function _onSubmit(e) {
	    e.preventDefault();
	    _userAction2.default.setInfo({
	      firstName: this.firstName.value,
	      lastName: this.lastName.value,
	      email: this.email ? this.email.value : this.state.email
	    });
	    this.setState({ setInfoError: false, settingInfo: true });
	    return false;
	  },
	  _onUpdatePassword: function _onUpdatePassword(e) {
	    e.preventDefault();
	    if (!this.state.updatingPassword) {
	      _userAction2.default.changePassword({
	        password: this.password.value,
	        passwordConfirmation: this.passwordConfirmation.value,
	        currentPassword: this.currentPassword ? this.currentPassword.value : "not-required"
	      });
	      this.setState({ passwordChangeError: false, updatingPassword: true });
	    }
	    return false;
	  },
	  _onUpdateSecurityQuestion: function _onUpdateSecurityQuestion(e) {
	    e.preventDefault();
	    if (!this.state.updatingSecurity) {
	      _userAction2.default.updateSecurityQuestion({
	        questionId: this.questionId.value,
	        questionResponse: this.questionResponse.value
	      });
	      this.setState({ securityError: false, updatingSecurity: true });
	    }
	    return false;
	  },
	  _changePassword: function _changePassword(e) {
	    e.preventDefault();
	    Routes.setRoute("user/profile/change-password");
	  },
	  _changeSecurityQuestion: function _changeSecurityQuestion(e) {
	    e.preventDefault();
	    Routes.setRoute("user/profile/change-security-question");
	  },
	  _hideModal: function _hideModal(_e) {
	    Routes.setRoute("/");
	  },
	  _toggleEmailLockedModal: function _toggleEmailLockedModal() {
	    this.setState({ emailLockedModal: !this.state.emailLockedModal });
	  },
	  render: function render() {
	    var _this = this;
	
	    if (this.state.user && this.state.user.ssoOnly) {
	      var completeAccountUrl = encodeURIComponent(Mulligan.Brand.endpoint + "/user/sso?after=" + window.location);
	      return _react2.default.createElement(
	        "div",
	        { className: "page user" },
	        _react2.default.createElement(
	          "h1",
	          null,
	          i18n.t("base.user")
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          _utils2.default.toHTML(i18n.t("user.complete-account", {
	            href: "/#/redirect/" + completeAccountUrl
	          }))
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          i18n.t("user.completing-allows")
	        )
	      );
	    }
	    var userBody = void 0;
	    if (this.state.user) {
	      var emailLocked = this.state.user.emailLocked || Mulligan.Brand.Account && Mulligan.Brand.Account.emailLocked;
	      userBody = _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "h1",
	          null,
	          i18n.t("base.user")
	        ),
	        _react2.default.createElement(
	          "h2",
	          null,
	          i18n.t("user.personal-information")
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "deck" },
	          _react2.default.createElement(
	            "form",
	            { id: "user-personal-info", onSubmit: this._onSubmit },
	            this.state.setInfoError && _react2.default.createElement(
	              _formAlert2.default,
	              { level: "error" },
	              this.state.setInfoError
	            ),
	            emailLocked ? _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                "div",
	                null,
	                i18n.t("user.email-locked-description"),
	                "\xA0",
	                _react2.default.createElement(
	                  "a",
	                  { onClick: this._toggleEmailLockedModal },
	                  i18n.t("base.learn-more"),
	                  "."
	                )
	              ),
	              this.state.emailLockedModal && _react2.default.createElement(
	                _vstui2.Dialog,
	                {
	                  onRequestClose: this._toggleEmailLockedModal,
	                  rootSelector: "#root",
	                  open: true,
	                  title: i18n.t("user.email-locked")
	                },
	                _react2.default.createElement(
	                  "div",
	                  null,
	                  i18n.t("user.email-locked-description")
	                ),
	                _react2.default.createElement(
	                  "div",
	                  null,
	                  i18n.t("user.email-locked-more")
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "locked-email" },
	                this.state.email
	              )
	            ) : _react2.default.createElement(_vstui2.TextField, {
	              label: i18n.t("base.email"),
	              type: "email",
	              defaultValue: this.state.email,
	              required: true,
	              fullWidth: true,
	              nativeFormControlRef: function nativeFormControlRef(x) {
	                _this.email = x;
	              }
	            }),
	            _react2.default.createElement(_vstui2.TextField, {
	              label: i18n.t("user.first-name"),
	              type: "text",
	              required: true,
	              defaultValue: this.state.firstName,
	              fullWidth: true,
	              nativeFormControlRef: function nativeFormControlRef(x) {
	                _this.firstName = x;
	              }
	            }),
	            _react2.default.createElement(_vstui2.TextField, {
	              label: i18n.t("user.last-name"),
	              type: "text",
	              required: true,
	              defaultValue: this.state.lastName,
	              fullWidth: true,
	              nativeFormControlRef: function nativeFormControlRef(x) {
	                _this.lastName = x;
	              }
	            }),
	            _react2.default.createElement(
	              "div",
	              { className: "user-save" },
	              _react2.default.createElement(
	                _vstui2.Button,
	                {
	                  type: "submit",
	                  disabled: this.state.settingInfo
	                },
	                i18n.t("base.save")
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "h2",
	          null,
	          i18n.t("user.security-information")
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "deck" },
	          _react2.default.createElement(
	            "ul",
	            { className: "security-info-list" },
	            _react2.default.createElement(
	              "li",
	              null,
	              i18n.t("user.security-password"),
	              _react2.default.createElement(
	                _vstui2.Button,
	                {
	                  onClick: this._changePassword,
	                  label: i18n.t("user.security-info-change"),
	                  naked: true
	                },
	                i18n.t("user.security-info-change")
	              )
	            ),
	            _react2.default.createElement(
	              "li",
	              null,
	              i18n.t("user.security-question"),
	              _react2.default.createElement(
	                _vstui2.Button,
	                {
	                  onClick: this._changeSecurityQuestion,
	                  label: i18n.t("user.security-info-change"),
	                  naked: true
	                },
	                i18n.t("user.security-info-change")
	              )
	            )
	          )
	        ),
	        this.props.modalOpen === "change-password" && _react2.default.createElement(
	          _vstui2.Dialog,
	          {
	            rootSelector: "#root",
	            open: true,
	            formProps: {
	              onSubmit: this._onUpdatePassword
	            },
	            onRequestClose: this._hideModal,
	            primaryActionButton: {
	              label: i18n.t("base.save"),
	              disabled: this.state.updatingPassword
	            },
	            secondaryActionButton: {
	              label: i18n.t("base.cancel"),
	              onClick: this._hideModal
	            },
	            title: i18n.t("user.change-password-title")
	          },
	          this.state.passwordChangeError && _react2.default.createElement(
	            _formAlert2.default,
	            { level: "error" },
	            this.state.passwordChangeError
	          ),
	          Mulligan.Brand.Account.requireCurrentPassword && _react2.default.createElement(_vstui2.TextField, {
	            label: i18n.t("user.current-password"),
	            type: "password",
	            nativeFormControlRef: function nativeFormControlRef(x) {
	              _this.currentPassword = x;
	            },
	            required: true
	          }),
	          _react2.default.createElement(_vstui2.TextField, {
	            label: i18n.t("user.new-password"),
	            helperText: i18n.t("user.new-password-tooltip"),
	            validate: function validate() {
	              if (!_this._isValidPassword(_this.password.value)) {
	                return i18n.t("user.change-password-text");
	              }
	            },
	            type: "password",
	            nativeFormControlRef: function nativeFormControlRef(x) {
	              _this.password = x;
	            },
	            required: true
	          }),
	          _react2.default.createElement(_vstui2.TextField, {
	            label: i18n.t("user.confirm-new-password"),
	            validate: function validate() {
	              if (_this.passwordConfirmation.value !== _this.password.value) {
	                return i18n.t("user.confirm-password-failure");
	              }
	            },
	            type: "password",
	            nativeFormControlRef: function nativeFormControlRef(x) {
	              _this.passwordConfirmation = x;
	            },
	            required: true
	          })
	        ),
	        this.props.modalOpen === "change-security-question" && _react2.default.createElement(
	          _vstui2.Dialog,
	          {
	            rootSelector: "#root",
	            open: true,
	            formProps: {
	              onSubmit: this._onUpdateSecurityQuestion
	            },
	            onRequestClose: this._hideModal,
	            primaryActionButton: {
	              label: i18n.t("base.save"),
	              disabled: this.state.updatingSecurity
	            },
	            secondaryActionButton: {
	              label: i18n.t("base.cancel"),
	              onClick: this._hideModal
	            },
	            title: i18n.t("user.security-question")
	          },
	          this.state.securityError && _react2.default.createElement(
	            _formAlert2.default,
	            { level: "error" },
	            this.state.securityError
	          ),
	          _react2.default.createElement(
	            _vstui2.Select,
	            {
	              label: i18n.t("user.question"),
	              nativeFormControlRef: function nativeFormControlRef(x) {
	                _this.questionId = x;
	              }
	            },
	            _ref,
	            _react2.default.createElement(
	              "option",
	              { value: 6 },
	              i18n.t("user.security-question6")
	            ),
	            _react2.default.createElement(
	              "option",
	              { value: 7 },
	              i18n.t("user.security-question7")
	            ),
	            _react2.default.createElement(
	              "option",
	              { value: 8 },
	              i18n.t("user.security-question8")
	            ),
	            _react2.default.createElement(
	              "option",
	              { value: 9 },
	              i18n.t("user.security-question9")
	            ),
	            _react2.default.createElement(
	              "option",
	              { value: 10 },
	              i18n.t("user.security-question10")
	            )
	          ),
	          _react2.default.createElement(_vstui2.TextField, {
	            label: i18n.t("user.answer"),
	            required: true,
	            type: "text",
	            nativeFormControlRef: function nativeFormControlRef(x) {
	              _this.questionResponse = x;
	            }
	          })
	        )
	      );
	    } else {
	      userBody = _react2.default.createElement(
	        "div",
	        { className: "deck" },
	        _react2.default.createElement(
	          _vstui.VstLoader,
	          { delay: 500 },
	          i18n.t("user.loading")
	        )
	      );
	    }
	    return _react2.default.createElement(
	      "div",
	      { className: "page user" },
	      userBody
	    );
	  }
	});
	
	exports.default = User;

/***/ },
/* 760 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _events = __webpack_require__(82);
	
	var _dispatcher = __webpack_require__(18);
	
	var _dispatcher2 = _interopRequireDefault(_dispatcher);
	
	var _objectAssign = __webpack_require__(11);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	__webpack_require__(198);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceStore = (0, _objectAssign2.default)({}, _events.EventEmitter.prototype, {
	
	  _state: undefined,
	  isLoading: false,
	
	  init: function init() {
	    var _this = this;
	
	    _dispatcher2.default.on(_dispatcher2.default.DEVICE_DEACTIVATE_DEVICE, function (id) {
	      Jigsaw.User.deactivateDevice(id, function (response) {
	        if (response.isSuccess()) {
	          var device = _this.get(id);
	          device.active = false;
	          _dispatcher2.default.emit(_dispatcher2.default.DEVICE_STORE_CHANGE);
	        }
	      });
	    });
	  },
	
	  _updateState: function _updateState(state) {
	    this._state = state;
	    _dispatcher2.default.emit(_dispatcher2.default.DEVICE_STORE_CHANGE);
	  },
	
	  get: function get(id) {
	    this._load();
	    if (!this._state) {
	      return undefined;
	    }
	
	    return this._state.find(function (d) {
	      return d.id === id;
	    });
	  },
	
	  getAll: function getAll() {
	    this._load();
	    return this._state;
	  },
	
	  _load: function _load(update) {
	    if (!this.isLoading && (update || this._state === undefined)) {
	      this.isLoading = true;
	      Jigsaw.User.getDevices(function (response) {
	        if (response.isSuccess()) {
	          var activeDevices = response.data.devices.filter(function (device) {
	            return device.active;
	          });
	          this._updateState(activeDevices);
	        } else {
	          this._updateState([]);
	        }
	        this.isLoading = false;
	      }.bind(this));
	    }
	  }
	
	});
	
	DeviceStore.init();
	exports.default = DeviceStore;

/***/ },
/* 761 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _events = __webpack_require__(82);
	
	var _dispatcher = __webpack_require__(18);
	
	var _dispatcher2 = _interopRequireDefault(_dispatcher);
	
	var _objectAssign = __webpack_require__(11);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ResourceDetailsStore = (0, _objectAssign2.default)({}, _events.EventEmitter.prototype, {
	
	  _state: undefined,
	  isLoading: false,
	
	  init: function init() {},
	
	  _updateState: function _updateState(state) {
	    this._state = state;
	    _dispatcher2.default.emit(_dispatcher2.default.RESOURCE_DETAILS_STORE_CHANGE);
	  },
	
	  _addToState: function _addToState(key, object) {
	    this._state = this._state || {};
	    this._state[key] = object;
	
	    _dispatcher2.default.emit(_dispatcher2.default.RESOURCE_DETAILS_STORE_CHANGE);
	  },
	
	  get: function get(id) {
	    this._load(id);
	    return this._state ? this._state[id] : undefined;
	  },
	
	  // TODO: Remove if not being used
	  getAll: function getAll() {
	    this._load();
	    return this._state || [];
	  },
	
	  _load: function _load(id, update) {
	    var _this = this;
	
	    if (!this.isLoading && (update || this._state === undefined || this._state[id] === undefined)) {
	      this.isLoading = true;
	      Jigsaw.getAncillariesForVbid(id, function (response) {
	        if (response.isSuccess()) {
	          _this._addToState(id, response.data);
	        } else {
	          _this._addToState(id, null);
	        }
	        _this.isLoading = false;
	      });
	    }
	  }
	
	});
	
	ResourceDetailsStore.init();
	exports.default = ResourceDetailsStore;

/***/ },
/* 762 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _events = __webpack_require__(82);
	
	var _dispatcher = __webpack_require__(18);
	
	var _dispatcher2 = _interopRequireDefault(_dispatcher);
	
	var _objectAssign = __webpack_require__(11);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ResourceStore = (0, _objectAssign2.default)({}, _events.EventEmitter.prototype, {
	
	  _state: undefined,
	  isLoading: false,
	
	  _updateState: function _updateState(state) {
	    this._state = state;
	    _dispatcher2.default.emit(_dispatcher2.default.RESOURCE_STORE_CHANGE);
	  },
	  get: function get(id) {
	    this._load();
	    return this._state ? this._state[id] : undefined;
	  },
	  getAll: function getAll() {
	    this._load();
	    return this._state || undefined;
	  },
	  _filterResponse: function _filterResponse(data) {
	
	    // Widths coming back in response, can use this if we don't feel like hard coding
	    var width = 60;
	
	    data.ancillaries.map(function (item) {
	      item.coverURL = data.coverURL.replace(":isbn", item.isbn).replace(":width", width);
	
	      return item;
	    });
	    return data.ancillaries;
	  },
	  _load: function _load(update) {
	    if (!this.isLoading && (update || this._state === undefined)) {
	      this.isLoading = true;
	      Jigsaw.getAncillariesSummary(function (response) {
	        if (response.isSuccess()) {
	          this._updateState(this._filterResponse(response.data));
	        } else {
	          this._updateState([]);
	        }
	        this.isLoading = false;
	      }.bind(this));
	    }
	  },
	  init: function init() {
	    var _this = this;
	
	    _dispatcher2.default.on(_dispatcher2.default.USER_LICENSE_UPDATED, function () {
	      _this._updateState(undefined);
	    });
	  }
	});
	
	ResourceStore.init();
	exports.default = ResourceStore;

/***/ },
/* 763 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  "myaccount.yuzu.com": "reader.yuzu.com"
	};

/***/ },
/* 764 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _img = __webpack_require__(234);
	
	var _img2 = _interopRequireDefault(_img);
	
	var _utils = __webpack_require__(28);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InlineSvg = _react2.default.createClass({
	  displayName: 'InlineSvg',
	  render: function render() {
	    return _react2.default.createElement(
	      'span',
	      { className: 'inline-svg' },
	      _utils2.default.toHTML(_img2.default[this.props.src])
	    );
	  }
	});
	
	exports.default = InlineSvg;

/***/ },
/* 765 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	window.i18n = __webpack_require__(769);
	window.DirectorRouter = __webpack_require__(768).Router;
	window.ajax = __webpack_require__(910);
	window.classNames = __webpack_require__(25);
	__webpack_require__(766);
	__webpack_require__(770);
	__webpack_require__(767);

/***/ },
/* 766 */
/***/ function(module, exports) {

	'use strict';
	
	//https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/includes
	if (!Array.prototype.includes) {
	  Array.prototype.includes = function (searchElement /*, fromIndex*/) {
	    'use strict';
	
	    var O = Object(this);
	    var len = parseInt(O.length) || 0;
	    if (len === 0) {
	      return false;
	    }
	    var n = parseInt(arguments[1]) || 0;
	    var k;
	    if (n >= 0) {
	      k = n;
	    } else {
	      k = len + n;
	      if (k < 0) {
	        k = 0;
	      }
	    }
	    var currentElement;
	    while (k < len) {
	      currentElement = O[k];
	      if (searchElement === currentElement || searchElement !== searchElement && currentElement !== currentElement) {
	        // NaN !== NaN
	        return true;
	      }
	      k++;
	    }
	    return false;
	  };
	}

/***/ },
/* 767 */
/***/ function(module, exports) {

	"use strict";
	
	// https://gist.github.com/brettz9/4093766#file_html5_dataset.js
	
	/**
	 * Add dataset support to elements
	 * No globals, no overriding prototype with non-standard methods,
	 *   handles CamelCase properly, attempts to use standard
	 *   Object.defineProperty() (and Function bind()) methods,
	 *   falls back to native implementation when existing
	 * Inspired by http://code.eligrey.com/html5/dataset/
	 *   (via https://github.com/adalgiso/html5-dataset/blob/master/html5-dataset.js )
	 * Depends on Function.bind and Object.defineProperty/Object.getOwnPropertyDescriptor (polyfills below)
	 * All code below is Licensed under the X11/MIT License
	*/
	
	// Inspired by https://developer.mozilla.org/en-US/docs/JavaScript/Reference/Global_Objects/Function/bind#Compatibility
	if (!Function.prototype.bind) {
	    Function.prototype.bind = function (oThis) {
	        'use strict';
	
	        if (typeof this !== "function") {
	            // closest thing possible to the ECMAScript 5 internal IsCallable function
	            throw new TypeError("Function.prototype.bind - what is trying to be bound is not callable");
	        }
	
	        var aArgs = Array.prototype.slice.call(arguments, 1),
	            fToBind = this,
	            FNOP = function FNOP() {},
	            fBound = function fBound() {
	            return fToBind.apply(this instanceof FNOP && oThis ? this : oThis, aArgs.concat(Array.prototype.slice.call(arguments)));
	        };
	
	        FNOP.prototype = this.prototype;
	        fBound.prototype = new FNOP();
	
	        return fBound;
	    };
	}
	
	/*
	 * Xccessors Standard: Cross-browser ECMAScript 5 accessors
	 * http://purl.eligrey.com/github/Xccessors
	 *
	 * 2010-06-21
	 *
	 * By Eli Grey, http://eligrey.com
	 *
	 * A shim that partially implements Object.defineProperty,
	 * Object.getOwnPropertyDescriptor, and Object.defineProperties in browsers that have
	 * legacy __(define|lookup)[GS]etter__ support.
	 *
	 * Licensed under the X11/MIT License
	 *   See LICENSE.md
	*/
	
	// Removed a few JSLint options as Notepad++ JSLint validator complaining and
	//   made comply with JSLint; also moved 'use strict' inside function
	/*jslint white: true, undef: true, plusplus: true,
	  bitwise: true, regexp: true, newcap: true, maxlen: 90 */
	
	/*! @source http://purl.eligrey.com/github/Xccessors/blob/master/xccessors-standard.js*/
	
	(function () {
	    'use strict';
	
	    var ObjectProto = Object.prototype,
	        defineGetter = ObjectProto.__defineGetter__,
	        defineSetter = ObjectProto.__defineSetter__,
	        lookupGetter = ObjectProto.__lookupGetter__,
	        lookupSetter = ObjectProto.__lookupSetter__,
	        hasOwnProp = ObjectProto.hasOwnProperty;
	
	    if (defineGetter && defineSetter && lookupGetter && lookupSetter) {
	
	        if (!Object.defineProperty) {
	            Object.defineProperty = function (obj, prop, descriptor) {
	                if (arguments.length < 3) {
	                    // all arguments required
	                    throw new TypeError("Arguments not optional");
	                }
	
	                prop += ""; // convert prop to string
	
	                if (hasOwnProp.call(descriptor, "value")) {
	                    if (!lookupGetter.call(obj, prop) && !lookupSetter.call(obj, prop)) {
	                        // data property defined and no pre-existing accessors
	                        obj[prop] = descriptor.value;
	                    }
	
	                    if (hasOwnProp.call(descriptor, "get") || hasOwnProp.call(descriptor, "set")) {
	                        // descriptor has a value prop but accessor already exists
	                        throw new TypeError("Cannot specify an accessor and a value");
	                    }
	                }
	
	                // can't switch off these features in ECMAScript 3
	                // so throw a TypeError if any are false
	                if (!(descriptor.writable && descriptor.enumerable && descriptor.configurable)) {
	                    throw new TypeError("This implementation of Object.defineProperty does not support" + " false for configurable, enumerable, or writable.");
	                }
	
	                if (descriptor.get) {
	                    defineGetter.call(obj, prop, descriptor.get);
	                }
	                if (descriptor.set) {
	                    defineSetter.call(obj, prop, descriptor.set);
	                }
	
	                return obj;
	            };
	        }
	
	        if (!Object.getOwnPropertyDescriptor) {
	            Object.getOwnPropertyDescriptor = function (obj, prop) {
	                if (arguments.length < 2) {
	                    // all arguments required
	                    throw new TypeError("Arguments not optional.");
	                }
	
	                prop += ""; // convert prop to string
	
	                var descriptor = {
	                    configurable: true,
	                    enumerable: true,
	                    writable: true
	                },
	                    getter = lookupGetter.call(obj, prop),
	                    setter = lookupSetter.call(obj, prop);
	
	                if (!hasOwnProp.call(obj, prop)) {
	                    // property doesn't exist or is inherited
	                    return descriptor;
	                }
	                if (!getter && !setter) {
	                    // not an accessor so return prop
	                    descriptor.value = obj[prop];
	                    return descriptor;
	                }
	
	                // there is an accessor, remove descriptor.writable;
	                // populate descriptor.get and descriptor.set (IE's behavior)
	                delete descriptor.writable;
	                descriptor.get = descriptor.set = undefined;
	
	                if (getter) {
	                    descriptor.get = getter;
	                }
	                if (setter) {
	                    descriptor.set = setter;
	                }
	
	                return descriptor;
	            };
	        }
	
	        if (!Object.defineProperties) {
	            Object.defineProperties = function (obj, props) {
	                var prop;
	                for (prop in props) {
	                    if (hasOwnProp.call(props, prop)) {
	                        Object.defineProperty(obj, prop, props[prop]);
	                    }
	                }
	            };
	        }
	    }
	})();
	
	// Begin dataset code
	
	if (!document.documentElement.dataset && (
	// FF is empty while IE gives empty object
	!Object.getOwnPropertyDescriptor(Element.prototype, 'dataset') || !Object.getOwnPropertyDescriptor(Element.prototype, 'dataset').get)) {
	    var propDescriptor = {
	        enumerable: true,
	        get: function get() {
	            'use strict';
	
	            var i,
	                that = this,
	                HTML5_DOMStringMap,
	                attrVal,
	                attrName,
	                propName,
	                attribute,
	                attributes = this.attributes,
	                attsLength = attributes.length,
	                toUpperCase = function toUpperCase(n0) {
	                return n0.charAt(1).toUpperCase();
	            },
	                getter = function getter() {
	                return this;
	            },
	                setter = function setter(attrName, value) {
	                return typeof value !== 'undefined' ? this.setAttribute(attrName, value) : this.removeAttribute(attrName);
	            };
	            try {
	                // Simulate DOMStringMap w/accessor support
	                // Test setting accessor on normal object
	                ({}).__defineGetter__('test', function () {});
	                HTML5_DOMStringMap = {};
	            } catch (e1) {
	                // Use a DOM object for IE8
	                HTML5_DOMStringMap = document.createElement('div');
	            }
	            for (i = 0; i < attsLength; i++) {
	                attribute = attributes[i];
	                // Fix: This test really should allow any XML Name without
	                //         colons (and non-uppercase for XHTML)
	                if (attribute && attribute.name && /^data-\w[\w\-]*$/.test(attribute.name)) {
	                    attrVal = attribute.value;
	                    attrName = attribute.name;
	                    // Change to CamelCase
	                    propName = attrName.substr(5).replace(/-./g, toUpperCase);
	                    try {
	                        Object.defineProperty(HTML5_DOMStringMap, propName, {
	                            enumerable: this.enumerable,
	                            get: getter.bind(attrVal || ''),
	                            set: setter.bind(that, attrName)
	                        });
	                    } catch (e2) {
	                        // if accessors are not working
	                        HTML5_DOMStringMap[propName] = attrVal;
	                    }
	                }
	            }
	            return HTML5_DOMStringMap;
	        }
	    };
	    try {
	        // FF enumerates over element's dataset, but not
	        //   Element.prototype.dataset; IE9 iterates over both
	        Object.defineProperty(Element.prototype, 'dataset', propDescriptor);
	    } catch (e) {
	        propDescriptor.enumerable = false; // IE8 does not allow setting to true
	        Object.defineProperty(Element.prototype, 'dataset', propDescriptor);
	    }
	}

/***/ },
/* 768 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//
	// Generated on Mon Jul 27 2015 23:40:23 GMT-0400 (EDT) by Charlie Robbins, Paolo Fragomeni & the Contributors (Using Codesurgeon).
	// Version 1.2.8
	//
	(function (a) {
	  function d() {
	    return b.hash === "" || b.hash === "#";
	  }function g(a, b) {
	    for (var c = 0; c < a.length; c += 1) {
	      if (b(a[c], c, a) === !1) return;
	    }
	  }function h(a) {
	    var b = [];for (var c = 0, d = a.length; c < d; c++) {
	      b = b.concat(a[c]);
	    }return b;
	  }function i(a, b, c) {
	    if (!a.length) return c();var d = 0;(function e() {
	      b(a[d], function (b) {
	        b || b === !1 ? (c(b), c = function c() {}) : (d += 1, d === a.length ? c() : e());
	      });
	    })();
	  }function j(a, b, c) {
	    c = a;for (var d in b) {
	      if (b.hasOwnProperty(d)) {
	        c = b[d](a);if (c !== a) break;
	      }
	    }return c === a ? "([._a-zA-Z0-9-%()]+)" : c;
	  }function k(a, b) {
	    var c,
	        d = 0,
	        e = "";while (c = a.substr(d).match(/[^\w\d\- %@&]*\*[^\w\d\- %@&]*/)) {
	      d = c.index + c[0].length, c[0] = c[0].replace(/^\*/, "([_.()!\\ %@&a-zA-Z0-9-]+)"), e += a.substr(0, c.index) + c[0];
	    }a = e += a.substr(d);var f = a.match(/:([^\/]+)/ig),
	        g,
	        h;if (f) {
	      h = f.length;for (var i = 0; i < h; i++) {
	        g = f[i], g.slice(0, 2) === "::" ? a = g.slice(1) : a = a.replace(g, j(g, b));
	      }
	    }return a;
	  }function l(a, b, c, d) {
	    var e = 0,
	        f = 0,
	        g = 0,
	        c = (c || "(").toString(),
	        d = (d || ")").toString(),
	        h;for (h = 0; h < a.length; h++) {
	      var i = a[h];if (i.indexOf(c, e) > i.indexOf(d, e) || ~i.indexOf(c, e) && !~i.indexOf(d, e) || !~i.indexOf(c, e) && ~i.indexOf(d, e)) {
	        f = i.indexOf(c, e), g = i.indexOf(d, e);if (~f && !~g || !~f && ~g) {
	          var j = a.slice(0, (h || 1) + 1).join(b);a = [j].concat(a.slice((h || 1) + 1));
	        }e = (g > f ? g : f) + 1, h = 0;
	      } else e = 0;
	    }return a;
	  }var b = document.location,
	      c = /\?.*/,
	      e = { mode: "modern", hash: b.hash, history: !1, skip: !1, check: function check() {
	      var a = b.hash;a != this.hash && (this.hash = a, this.onHashChanged());
	    }, fire: function fire() {
	      this.mode === "modern" ? this.history === !0 ? window.onpopstate() : window.onhashchange() : this.onHashChanged();
	    }, init: function init(a, b) {
	      function d(a) {
	        if (!c.skip) for (var b = 0, d = f.listeners.length; b < d; b++) {
	          f.listeners[b](a);
	        }c.skip = !1;
	      }var c = this;this.history = b, f.listeners || (f.listeners = []);if ("onhashchange" in window && (document.documentMode === undefined || document.documentMode > 7)) this.history === !0 ? setTimeout(function () {
	        window.onpopstate = d;
	      }, 500) : window.onhashchange = d, this.mode = "modern";else {
	        var e = document.createElement("iframe");e.id = "state-frame", e.style.display = "none", document.body.appendChild(e), this.writeFrame(""), "onpropertychange" in document && "attachEvent" in document && document.attachEvent("onpropertychange", function () {
	          event.propertyName === "location" && c.check();
	        }), window.setInterval(function () {
	          c.check();
	        }, 50), this.onHashChanged = d, this.mode = "legacy";
	      }return f.listeners.push(a), this.mode;
	    }, destroy: function destroy(a) {
	      if (!f || !f.listeners) return;var b = f.listeners;for (var c = b.length - 1; c >= 0; c--) {
	        b[c] === a && b.splice(c, 1);
	      }
	    }, setHash: function setHash(a) {
	      return this.mode === "legacy" && this.writeFrame(a), this.history === !0 ? (window.history.pushState({}, document.title, a), this.fire()) : b.hash = a[0] === "/" ? a : "/" + a, this;
	    }, writeFrame: function writeFrame(a) {
	      var b = document.getElementById("state-frame"),
	          c = b.contentDocument || b.contentWindow.document;c.open(), c.write("<script>_hash = '" + a + "'; onload = parent.listener.syncHash;<script>"), c.close();
	    }, syncHash: function syncHash() {
	      var a = this._hash;return a != b.hash && (b.hash = a), this;
	    }, onHashChanged: function onHashChanged() {} },
	      f = a.Router = function (a) {
	    if (this instanceof f) this.params = {}, this.routes = {}, this.methods = ["on", "once", "after", "before"], this.scope = [], this._methods = {}, this._insert = this.insert, this.insert = this.insertEx, this.historySupport = (window.history != null ? window.history.pushState : null) != null, this.configure(), this.mount(a || {});else return new f(a);
	  };f.prototype.init = function (a) {
	    var c = this,
	        f;this.handler = function (a) {
	      var b = a && a.newURL || window.location.hash,
	          d = c.history === !0 ? c.getPath() : b.replace(/.*#/, "");c.dispatch("on", d.charAt(0) === "/" ? d : "/" + d);
	    }, e.init(this.handler, this.history);var g = d();return this.history === !1 ? g && a ? b.hash = a : g || c.dispatch("on", "/" + b.hash.replace(/^(#\/|#|\/)/, "")) : (this.convert_hash_in_init ? (f = g && a ? a : g ? null : b.hash.replace(/^#/, ""), f && window.history.replaceState({}, document.title, f)) : f = this.getPath(), (f || this.run_in_init === !0) && this.handler()), this;
	  }, f.prototype.explode = function (a) {
	    var d = this.history === !0 ? this.getPath() : b.hash;return a === !0 && (d = d.replace(c, "")), d.charAt(1) === "/" && (d = d.slice(1)), d.slice(1, d.length).split("/");
	  }, f.prototype.setRoute = function (a, b, c, d) {
	    var f = this.explode();return typeof a == "number" && typeof b == "string" ? (f[a] = b, d = c) : typeof c == "string" ? f.splice(a, b, s) : (f = [a], d = b), e.skip = d, e.setHash(f.join("/")), f;
	  }, f.prototype.insertEx = function (a, b, c, d) {
	    return a === "once" && (a = "on", c = function (a) {
	      var b = !1;return function () {
	        if (b) return;return b = !0, a.apply(this, arguments);
	      };
	    }(c)), this._insert(a, b, c, d);
	  }, f.prototype.getRoute = function (a) {
	    var b = a;if (typeof a == "number") b = this.explode(!0)[a];else if (typeof a == "string") {
	      var c = this.explode(!0);b = c.indexOf(a);
	    } else b = this.explode(!0);return b;
	  }, f.prototype.destroy = function () {
	    return e.destroy(this.handler), this;
	  }, f.prototype.getPath = function () {
	    var a = window.location.pathname;return a.substr(0, 1) !== "/" && (a = "/" + a), a.replace(c, "");
	  };var c = /\?.*/;f.prototype.configure = function (a) {
	    a = a || {};for (var b = 0; b < this.methods.length; b++) {
	      this._methods[this.methods[b]] = !0;
	    }return this.recurse = typeof a.recurse == "undefined" ? this.recurse || !1 : a.recurse, this.async = a.async || !1, this.delimiter = a.delimiter || "/", this.strict = typeof a.strict == "undefined" ? !0 : a.strict, this.notfound = a.notfound, this.resource = a.resource, this.history = a.html5history && this.historySupport || !1, this.run_in_init = this.history === !0 && a.run_handler_in_init !== !1, this.convert_hash_in_init = this.history === !0 && a.convert_hash_in_init !== !1, this.every = { after: a.after || null, before: a.before || null, on: a.on || null }, this;
	  }, f.prototype.param = function (a, b) {
	    a[0] !== ":" && (a = ":" + a);var c = new RegExp(a, "g");return this.params[a] = function (a) {
	      return a.replace(c, b.source || b);
	    }, this;
	  }, f.prototype.on = f.prototype.route = function (a, b, c) {
	    var d = this;return !c && typeof b == "function" && (c = b, b = a, a = "on"), Array.isArray(b) ? b.forEach(function (b) {
	      d.on(a, b, c);
	    }) : (b.source && (b = b.source.replace(/\\\//ig, "/")), Array.isArray(a) ? a.forEach(function (a) {
	      d.on(a.toLowerCase(), b, c);
	    }) : (b = b.split(new RegExp(this.delimiter)), b = l(b, this.delimiter), this.insert(a, this.scope.concat(b), c), this));
	  }, f.prototype.path = function (a, b) {
	    var c = this,
	        d = this.scope.length;return a.source && (a = a.source.replace(/\\\//ig, "/")), a = a.split(new RegExp(this.delimiter)), a = l(a, this.delimiter), this.scope = this.scope.concat(a), b.call(this, this), this.scope.splice(d, a.length), this;
	  }, f.prototype.dispatch = function (a, b, d) {
	    function j() {
	      f.last = g.after, f.invoke(f.runlist(g), f, d);
	    }var e = this.parseQuery(b);b = b.replace(c, "");var f = this,
	        g = this.traverse(a, b, this.routes, ""),
	        h = this._invoked,
	        i;return this._invoked = !0, !g || g.length === 0 ? (this.last = [], typeof this.notfound == "function" && this.invoke([this.notfound], { method: a, path: b }, d), !1) : (this.query = e, this.recurse === "forward" && (g = g.reverse()), i = this.every && this.every.after ? [this.every.after].concat(this.last) : [this.last], i && i.length > 0 && h ? (this.async ? this.invoke(i, this, j) : (this.invoke(i, this), j()), !0) : (j(), !0));
	  }, f.prototype.invoke = function (a, b, c) {
	    var d = this,
	        _e2;this.async ? (_e2 = function e(c, d) {
	      if (Array.isArray(c)) return i(c, _e2, d);typeof c == "function" && c.apply(b, (a.captures || []).concat(d));
	    }, i(a, _e2, function () {
	      c && c.apply(b, arguments);
	    })) : (_e2 = function _e(c) {
	      if (Array.isArray(c)) return g(c, _e2);if (typeof c == "function") return c.apply(b, a.captures || []);typeof c == "string" && d.resource && d.resource[c].apply(b, a.captures || []);
	    }, g(a, _e2));
	  }, f.prototype.traverse = function (a, b, c, d, e) {
	    function l(a) {
	      function b(a) {
	        var c = [];for (var d = 0; d < a.length; d++) {
	          c[d] = Array.isArray(a[d]) ? b(a[d]) : a[d];
	        }return c;
	      }function c(a) {
	        for (var b = a.length - 1; b >= 0; b--) {
	          Array.isArray(a[b]) ? (c(a[b]), a[b].length === 0 && a.splice(b, 1)) : e(a[b]) || a.splice(b, 1);
	        }
	      }if (!e) return a;var d = b(a);return d.matched = a.matched, d.captures = a.captures, d.after = a.after.filter(e), c(d), d;
	    }var f = [],
	        g,
	        h,
	        i,
	        j,
	        k;if (b === this.delimiter && c[a]) return j = [[c.before, c[a]].filter(Boolean)], j.after = [c.after].filter(Boolean), j.matched = !0, j.captures = [], l(j);for (var m in c) {
	      if (c.hasOwnProperty(m) && (!this._methods[m] || this._methods[m] && _typeof(c[m]) == "object" && !Array.isArray(c[m]))) {
	        g = h = d + this.delimiter + m, this.strict || (h += "[" + this.delimiter + "]?"), i = b.match(new RegExp("^" + h));if (!i) continue;if (i[0] && i[0] == b && c[m][a]) return j = [[c[m].before, c[m][a]].filter(Boolean)], j.after = [c[m].after].filter(Boolean), j.matched = !0, j.captures = i.slice(1), this.recurse && c === this.routes && (j.push([c.before, c.on].filter(Boolean)), j.after = j.after.concat([c.after].filter(Boolean))), l(j);j = this.traverse(a, b, c[m], g);if (j.matched) return j.length > 0 && (f = f.concat(j)), this.recurse && (f.push([c[m].before, c[m][a]].filter(Boolean)), j.after = j.after.concat([c[m].after].filter(Boolean)), c === this.routes && (f.push([c.before, c.on].filter(Boolean)), j.after = j.after.concat([c.after].filter(Boolean)))), f.matched = !0, f.captures = j.captures, f.after = j.after, l(f);
	      }
	    }return !1;
	  }, f.prototype.insert = function (a, b, c, d) {
	    var e, f, g, h, i;b = b.filter(function (a) {
	      return a && a.length > 0;
	    }), d = d || this.routes, i = b.shift(), /\:|\*/.test(i) && !/\\d|\\w/.test(i) && (i = k(i, this.params));if (b.length > 0) return d[i] = d[i] || {}, this.insert(a, b, c, d[i]);if (!i && !b.length && d === this.routes) {
	      e = _typeof(d[a]);switch (e) {case "function":
	          d[a] = [d[a], c];return;case "object":
	          d[a].push(c);return;case "undefined":
	          d[a] = c;return;}return;
	    }f = _typeof(d[i]), g = Array.isArray(d[i]);if (d[i] && !g && f == "object") {
	      e = _typeof(d[i][a]);switch (e) {case "function":
	          d[i][a] = [d[i][a], c];return;case "object":
	          d[i][a].push(c);return;case "undefined":
	          d[i][a] = c;return;}
	    } else if (f == "undefined") {
	      h = {}, h[a] = c, d[i] = h;return;
	    }throw new Error("Invalid route context: " + f);
	  }, f.prototype.extend = function (a) {
	    function e(a) {
	      b._methods[a] = !0, b[a] = function () {
	        var c = arguments.length === 1 ? [a, ""] : [a];b.on.apply(b, c.concat(Array.prototype.slice.call(arguments)));
	      };
	    }var b = this,
	        c = a.length,
	        d;for (d = 0; d < c; d++) {
	      e(a[d]);
	    }
	  }, f.prototype.runlist = function (a) {
	    var b = this.every && this.every.before ? [this.every.before].concat(h(a)) : h(a);return this.every && this.every.on && b.push(this.every.on), b.captures = a.captures, b.source = a.source, b;
	  }, f.prototype.mount = function (a, b) {
	    function d(b, d) {
	      var e = b,
	          f = b.split(c.delimiter),
	          g = _typeof(a[b]),
	          h = f[0] === "" || !c._methods[f[0]],
	          i = h ? "on" : e;h && (e = e.slice((e.match(new RegExp("^" + c.delimiter)) || [""])[0].length), f.shift());if (h && g === "object" && !Array.isArray(a[b])) {
	        d = d.concat(f), c.mount(a[b], d);return;
	      }h && (d = d.concat(e.split(c.delimiter)), d = l(d, c.delimiter)), c.insert(i, d, a[b]);
	    }if (!a || (typeof a === "undefined" ? "undefined" : _typeof(a)) != "object" || Array.isArray(a)) return;var c = this;b = b || [], Array.isArray(b) || (b = b.split(c.delimiter));for (var e in a) {
	      a.hasOwnProperty(e) && d(e, b.slice(0));
	    }
	  }, f.prototype.parseQuery = function (a) {
	    function g(a, b) {
	      e.hasOwnProperty(a) ? Array.isArray(e[a]) ? e[a].push(b) : e[a] = [e[a], b] : e[a] = b;
	    }var b = a.match(c);if (!b) return null;var d = b[0].substr(1),
	        e = {},
	        f = decodeURIComponent;return d.length && d.split(/&/g).forEach(function (a) {
	      var b = a.split("="),
	          c = f(b.shift()),
	          d = b.length ? f(b.join("=")) : !0;g(c, d);
	    }), e;
	  };
	})(( false ? "undefined" : _typeof(exports)) == "object" ? exports : window);

/***/ },
/* 769 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _dispatcher = __webpack_require__(18);
	
	var _dispatcher2 = _interopRequireDefault(_dispatcher);
	
	var _locales = __webpack_require__(162);
	
	var _locales2 = _interopRequireDefault(_locales);
	
	var _deepExtend = __webpack_require__(733);
	
	var _deepExtend2 = _interopRequireDefault(_deepExtend);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var shuffleArray = function shuffleArray(array) {
	  for (var i = array.length - 1; i > 0; i--) {
	    var j = Math.floor(Math.random() * (i + 1));
	    var temp = array[i];
	    array[i] = array[j];
	    array[j] = temp;
	  }
	  return array;
	};
	
	var I18n = function () {
	
	  var I18n = function I18n() {
	    // this should be overridden when the init() function is called
	    var localPath = '/locales/';
	    var langs = {};
	    var currentLocale;
	    this.lang_key = 'en';
	    this.emojisOn = false;
	    this.emojiArray = ["😁", "😂", "😃", "😄", "😅", "😆", "😉", "😊", "😋", "😌", "😍", "😏", "😒", "😓", "😔", "😖", "😘", "😚", "😜", "😝", "😞", "😠", "😡", "😢", "😣", "😤", "😥", "😨", "😩", "😪", "😫", "😭", "😰", "😱", "😲", "😳", "😵", "😷", "😸", "😹", "😺", "😻", "😼", "😽", "😾", "😿", "🙀", "🙅", "🙆", "🙇", "🙈", "🙉", "🙊", "🙋", "🙌", "🙍", "🙎", "🙏", "✂", "✅", "✈", "✉", "✊", "✋", "✌", "✏", "✒", "✔", "✖", "✨", "✴", "❄", "❇", "❌", "❎", "❓", "❔", "❕", "❗", "❤", "➕", "➖", "➗", "➡", "➰", "🚀", "🚃", "🚄", "🚅", "🚇", "🚉", "🚌", "🚏", "🚑", "🚒", "🚓", "🚕", "🚗", "🚙", "🚚", "🚢", "🚤", "🚥", "🚧", "🚨", "🚩", "🚪", "🚫", "🚬", "🚭", "🚲", "🚶", "🚹", "🚺", "🚻", "🚼", "🚽", "🚾", "🛀", "Ⓜ", "🅰", "🅱", "🅾", "🅿", "🆎", "🆑", "🆒", "🆓", "🆔", "🆕", "🆖", "🆗", "🆘", "🆙", "🆚", "🈁", "🈚", "🈯", "🈲", "🈳", "🈴", "🈵", "🈶", "🈸", "🈹", "🈺", "🉐", "🉑", "⌚", "⌛", "⏩", "⏪", "⏫", "⏬", "⏰", "⏳", "◼", "◽", "◾", "☀", "☁", "☎", "☑", "☔", "☕", "☝", "☺", "♈", "♉", "♊", "♋", "♌", "♍", "♎", "♏", "♐", "♑", "♒", "♓", "♠", "♣", "♥", "♦", "♨", "♻", "♿", "⚓", "⚠", "⚡", "⚪", "⚫", "⚽", "⚾", "⛄", "⛅", "⛎", "⛔", "⛪", "⛲", "⛳", "⛵", "⛺", "⛽", "⤴", "⤵", "⬅", "⬆", "⬇", "⬛", "⬜", "⭐", "⭕", "〰", "〽", "㊗", "㊙", "🀄", "🃏", "🌀", "🌁", "🌂", "🌃", "🌄", "🌅", "🌆", "🌇", "🌈", "🌉", "🌊", "🌋", "🌌", "🌏", "🌑", "🌓", "🌔", "🌕", "🌙", "🌛", "🌟", "🌠", "🌰", "🌱", "🌴", "🌵", "🌷", "🌸", "🌹", "🌺", "🌻", "🌼", "🌽", "🌾", "🌿", "🍀", "🍁", "🍂", "🍃", "🍄", "🍅", "🍆", "🍇", "🍈", "🍉", "🍊", "🍌", "🍍", "🍎", "🍏", "🍑", "🍒", "🍓", "🍔", "🍕", "🍖", "🍗", "🍘", "🍙", "🍚", "🍛", "🍜", "🍝", "🍞", "🍟", "🍠", "🍡", "🍢", "🍣", "🍤", "🍥", "🍦", "🍧", "🍨", "🍩", "🍪", "🍫", "🍬", "🍭", "🍮", "🍯", "🍰", "🍱", "🍲", "🍳", "🍴", "🍵", "🍶", "🍷", "🍸", "🍹", "🍺", "🍻", "🎀", "🎁", "🎂", "🎃", "🎄", "🎅", "🎆", "🎇", "🎈", "🎉", "🎊", "🎋", "🎌", "🎍", "🎎", "🎏", "🎐", "🎑", "🎒", "🎓", "🎠", "🎡", "🎢", "🎣", "🎤", "🎥", "🎦", "🎧", "🎨", "🎩", "🎪", "🎫", "🎬", "🎭", "🎮", "🎯", "🎰", "🎱", "🎲", "🎳", "🎴", "🎵", "🎶", "🎷", "🎸", "🎹", "🎺", "🎻", "🎼", "🎽", "🎾", "🎿", "🏀", "🏁", "🏂", "🏃", "🏄", "🏆", "🏈", "🏊", "🏠", "🏡", "🏢", "🏣", "🏥", "🏦", "🏧", "🏨", "🏩", "🏪", "🏫", "🏬", "🏭", "🏮", "🏯", "🏰", "🐌", "🐍", "🐎", "🐑", "🐒", "🐔", "🐗", "🐘", "🐙", "🐚", "🐛", "🐜", "🐝", "🐞", "🐟", "🐠", "🐡", "🐢", "🐣", "🐤", "🐥", "🐦", "🐧", "🐨", "🐩", "🐫", "🐬", "🐭", "🐮", "🐯", "🐰", "🐱", "🐲", "🐳", "🐴", "🐵", "🐶", "🐷", "🐸", "🐹", "🐺", "🐻", "🐼", "🐽", "🐾", "👀", "👂", "👃", "👄", "👅", "👆", "👇", "👈", "👉", "👊", "👋", "👌", "👍", "👎", "👏", "👐", "👑", "👒", "👓", "👔", "👕", "👖", "👗", "👘", "👙", "👚", "👛", "👜", "👝", "👞", "👟", "👠", "👡", "👢", "👣", "👤", "👦", "👧", "👨", "👩", "👪", "👫", "👮", "👯", "👰", "👱", "👲", "👳", "👴", "👵", "👶", "👷", "👸", "👹", "👺", "👻", "👼", "👽", "👾", "👿", "💀", "💁", "💂", "💃", "💄", "💅", "💆", "💇", "💈", "💉", "💊", "💋", "💌", "💍", "💎", "💏", "💐", "💑", "💒", "💓", "💔", "💕", "💖", "💗", "💘", "💙", "💚", "💛", "💜", "💝", "💞", "💟", "💠", "💡", "💢", "💣", "💤", "💥", "💦", "💧", "💨", "💩", "💪", "💫", "💬", "💮", "💯", "💰", "💱", "💲", "💳", "💴", "💵", "💸", "💹", "💺", "💻", "💼", "💽", "💾", "💿", "📀", "📁", "📂", "📃", "📄", "📅", "📆", "📇", "📈", "📉", "📊", "📋", "📌", "📍", "📎", "📏", "📐", "📑", "📒", "📓", "📔", "📕", "📖", "📗", "📘", "📙", "📚", "📛", "📜", "📝", "📞", "📟", "📠", "📡", "📢", "📣", "📤", "📥", "📦", "📧", "📨", "📩", "📪", "📫", "📮", "📰", "📱", "📲", "📳", "📴", "📶", "📷", "📹", "📺", "📻", "📼", "🔃", "🔊", "🔋", "🔌", "🔍", "🔎", "🔏", "🔐", "🔑", "🔒", "🔓", "🔔", "🔖", "🔗", "🔘", "🔙", "🔚", "🔛", "🔜", "🔝", "🔞", "🔟", "🔠", "🔡", "🔢", "🔣", "🔤", "🔥", "🔦", "🔧", "🔨", "🔩", "🔪", "🔫", "🔮", "🔯", "🔰", "🔱", "🔲", "🔳", "🔴", "🔵", "🔶", "🔷", "🔸", "🔹", "🔺", "🔻", "🔼", "🔽", "🕐", "🕑", "🕒", "🕓", "🕔", "🕕", "🕖", "🕗", "🕘", "🕙", "🕚", "🕛", "🗻", "🗼", "🗽", "🗾", "🗿", "😀", "😇", "😈", "😎", "😐", "😑", "😕", "😗", "😙", "😛", "😟", "😦", "😧", "😬", "😮", "😯", "😴", "😶", "🚁", "🚂", "🚆", "🚈", "🚊", "🚍", "🚎", "🚐", "🚔", "🚖", "🚘", "🚛", "🚜", "🚝", "🚞", "🚟", "🚠", "🚡", "🚣", "🚦", "🚮", "🚯", "🚰", "🚱", "🚳", "🚴", "🚵", "🚷", "🚸", "🚿", "🛁", "🛂", "🛃", "🛄", "🛅", "🌍", "🌎", "🌐", "🌒", "🌖", "🌗", "🌘", "🌚", "🌜", "🌝", "🌞", "🌲", "🌳", "🍋", "🍐", "🍼", "🏇", "🏉", "🏤", "🐀", "🐁", "🐂", "🐃", "🐄", "🐅", "🐆", "🐇", "🐈", "🐉", "🐊", "🐋", "🐏", "🐐", "🐓", "🐕", "🐖", "🐪", "👥", "👬", "👭", "💭", "💶", "💷", "📬", "📭", "📯", "📵", "🔀", "🔁", "🔂", "🔄", "🔅", "🔆", "🔇", "🔉", "🔕", "🔬", "🔭", "🕜", "🕝", "🕞", "🕟", "🕠", "🕡", "🕢", "🕣", "🕤", "🕥", "🕦", "🕧"];
	    this.languageMap = {
	      "en": "English",
	      "ar": "العربية",
	      "bg": "Български",
	      "ca": "Català",
	      "cs": "čeština",
	      "cy": "Cymraeg",
	      "da": "Dansk",
	      "de": "Deutsch",
	      "el": "ελληνικά",
	      "en_GB": "English (UK)",
	      "es": "Español",
	      "es_MX": "Español - México",
	      "fi": "Suomi",
	      "fil": "Tagalog",
	      "fr_CA": "Français - Canada",
	      "fr": "Français",
	      "ga": "Gaeilge",
	      "he": "עברית",
	      "hi": "हिंदी",
	      "is": "Íslenska",
	      "it": "Italiano",
	      "ja": "日本語",
	      "ko": "한국어",
	      "nl": "Nederlands",
	      "no": "Norsk",
	      "pl": "Polski",
	      "pt_BR": "Português do Brasil",
	      "pt": "Português",
	      "ro": "Română",
	      "ru": "Pусский",
	      "sv": "Svensk",
	      "th": "ภาษาไทย",
	      "tr": "Türk",
	      "vi": "Tiếng Việt",
	      "zh_CN": "中文简体",
	      "zh_TW": "繁體中文"
	    };
	
	    // Initialize the object with the relative path to the locales
	    //  files in .json format
	    // Right now it is pretty simple and requires you to include all
	    //  necessary slashes to reach the file (/)
	    this.init = function (path) {
	      localPath = path;
	    };
	
	    // Already have your language json object in memory but not in i18n?
	    //  Pass it into ingest as ('en',en_object) to have it stored in i18n.
	    this.ingest = function (lang_key, lang_object) {
	      langs[lang_key] = lang_object;
	    };
	
	    // Get the key for the current locale
	    this.getCurrentLocale = function () {
	      return this.lang_key;
	    };
	
	    // allow an arbitrary object to extend the locale object
	    this.extendLocale = function (obj) {
	      (0, _deepExtend2.default)(currentLocale, obj);
	    };
	
	    // Load the locale file with the given key from the locales
	    //  folder and set the object as the current Locale to use.
	    // If it does not exist, it will not change the
	    //  current locale.
	    this.changeLocale = function (lang_key, callback) {
	      if (!lang_key) {
	        callback();
	        return;
	      }
	      lang_key = lang_key.replace("-", "_");
	      if (!this.languageMap[lang_key]) {
	        lang_key = Mulligan.Brand.locale;
	      }
	      this.lang_key = lang_key;
	      if (langs[lang_key]) {
	        // Load the locale object from memory if it exists.
	        // This prevents the need to make an extra external request.
	        // DO NOT store this persistently as it would need to reflect
	        //  changes made to the locales
	        currentLocale = langs[lang_key];
	        _dispatcher2.default.emit(_dispatcher2.default.LOCALE_CHANGE, currentLocale);
	        callback();
	      } else {
	        // build the path to the file, this could probably be more robust
	        var path = _locales2.default.locales[lang_key]; // localPath+lang_key+'.json';
	        langs[lang_key] = _locales2.default.locales[lang_key]; // store in memory
	        currentLocale = langs[lang_key];
	        _dispatcher2.default.emit(_dispatcher2.default.LOCALE_CHANGE, currentLocale);
	        callback();
	        /*
	        ajax({
	          url: path,
	          dataType: 'json',
	          cache: false, // android has trouble with knowing when things change, I guess
	          success: function(data) {
	            langs[lang_key] = data; // store in memory
	            currentLocale = langs[lang_key];
	            callback();
	          },
	          error: function(jqXHR, textStatus, errorThrown) {
	              //console.log(errorThrown);
	              // Don't want to log anything for compatibility, but use this
	              // if you're having trouble to debug.
	          }
	        });
	        */
	      }
	    };
	
	    this.emojify = function () {
	      this.emojiArray = shuffleArray(this.emojiArray);
	      this.emojisOn = !this.emojisOn;
	    };
	
	    this.getRandomEmoji = function () {
	      return this.emojiArray[Math.floor(this.emojiArray.length * Math.random())];
	    };
	
	    this.mapEmoji = function (character) {
	      var index = character.charCodeAt(0);
	      if (index >= 0 && index < this.emojiArray.length) {
	        return this.emojiArray[index];
	      } else {
	        return this.getRandomEmoji();
	      }
	    };
	
	    this.emojiString = function (input) {
	      var newstring = "";
	      for (var i = 0; i < input.length; i += 2) {
	        newstring = newstring + this.mapEmoji(input[i]);
	      }
	      return newstring;
	    };
	
	    this.translate = function (key, replacements, locale_override) {
	      var thisLocale = currentLocale || _locales2.default.locales.en;
	      if (locale_override) {
	        thisLocale = langs[locale_override];
	      }
	      var i;
	
	      replacements = replacements || {};
	
	      var tokenizer = /(%\{[^\}]+\})/,
	          interpolation = /(%\{([^\}]+)\})/,
	          tokens;
	
	      // get out of here if we can't find the locale
	      // this probably means it was never initialized
	      if (!thisLocale) {
	        return 'locale not found: ' + this.locale;
	      }
	
	      // Split up the key passed in and loop through
	      //  to find the translated string
	      // ex: base.sample.hello references the object
	      //  base -> sample -> hellow = "Hello World"
	      //  this will end with found="Hello World" or translation not found
	      var parts = key.split('.'),
	          found = thisLocale;
	
	      for (i = 0; i < parts.length; i++) {
	        found = found[parts[i]];
	        if (!found && typeof found !== "string") {
	          if (this.getCurrentLocale() === "en" || locale_override === "en") {
	            return 'translation not found' + key;
	          } else {
	            return this.translate(key, replacements, "en");
	          }
	        }
	      }
	
	      // we only handle strings
	      if (found.constructor !== String) {
	        return 'translation not found: ' + key;
	      }
	
	      // Split up found into tokens to separate any variables denoted
	      //  by %{*}
	      tokens = found.split(tokenizer);
	
	      var t;
	      for (i = tokens.length - 1; i >= 0; i--) {
	        // Matching by interpolation will return an array with the name
	        //  of the variable we want to replace that should be in our
	        //  replacements object (passed in as an optional argument)
	        /*jshint -W084 */
	        if (t = tokens[i].match(interpolation)) {
	          // console.log(replacements);
	          if (replacements && replacements[t[t.length - 1]] !== undefined) {
	            tokens[i] = replacements[t[t.length - 1]];
	          }
	        }
	        if (this.emojisOn) {
	          tokens[i] = this.emojiString(tokens[i]);
	        }
	      }
	
	      return tokens.join('');
	    };
	
	    // alias the translate function
	    this.t = this.translate;
	  };
	
	  return new I18n();
	}();
	
	module.exports = I18n;

/***/ },
/* 770 */
/***/ function(module, exports) {

	'use strict';
	
	// based on http://www.paciellogroup.com/blog/2012/04/how-to-remove-css-outlines-in-an-accessible-manner/
	(function (d) {
	
	  var style_element = d.createElement('STYLE'),
	      dom_events = 'addEventListener' in d,
	      add_event_listener = function add_event_listener(type, callback) {
	    // Basic cross-browser event handling
	    if (dom_events) {
	      d.addEventListener(type, callback);
	    } else {
	      d.attachEvent('on' + type, callback);
	    }
	  },
	      set_css = function set_css(css_text) {
	    // Handle setting of <style> element contents in IE8
	    !!style_element.styleSheet ? style_element.styleSheet.cssText = css_text : style_element.innerHTML = css_text;
	  };
	
	  d.getElementsByTagName('HEAD')[0].appendChild(style_element);
	
	  // Using mousedown instead of mouseover, so that previously focused elements don't lose focus ring on mouse move
	  add_event_listener('mousedown', function () {
	    set_css(':focus{outline:0}::-moz-focus-inner{border:0;}');
	  });
	
	  add_event_listener('keydown', function () {
	    set_css('');
	  });
	})(document);

/***/ },
/* 771 */
/***/ function(module, exports) {

	//import './styles/vst-shared.scss';
	"use strict";

/***/ },
/* 772 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var _hyphenPattern = /-(.)/g;
	
	/**
	 * Camelcases a hyphenated string, for example:
	 *
	 *   > camelize('background-color')
	 *   < "backgroundColor"
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelize(string) {
	  return string.replace(_hyphenPattern, function (_, character) {
	    return character.toUpperCase();
	  });
	}
	
	module.exports = camelize;

/***/ },
/* 773 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	var isTextNode = __webpack_require__(780);
	
	/*eslint-disable no-bitwise */
	
	/**
	 * Checks if a given DOM node contains or is another DOM node.
	 */
	function containsNode(outerNode, innerNode) {
	  if (!outerNode || !innerNode) {
	    return false;
	  } else if (outerNode === innerNode) {
	    return true;
	  } else if (isTextNode(outerNode)) {
	    return false;
	  } else if (isTextNode(innerNode)) {
	    return containsNode(outerNode, innerNode.parentNode);
	  } else if ('contains' in outerNode) {
	    return outerNode.contains(innerNode);
	  } else if (outerNode.compareDocumentPosition) {
	    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
	  } else {
	    return false;
	  }
	}
	
	module.exports = containsNode;

/***/ },
/* 774 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var invariant = __webpack_require__(5);
	
	/**
	 * Convert array-like objects to arrays.
	 *
	 * This API assumes the caller knows the contents of the data type. For less
	 * well defined inputs use createArrayFromMixed.
	 *
	 * @param {object|function|filelist} obj
	 * @return {array}
	 */
	function toArray(obj) {
	  var length = obj.length;
	
	  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
	  // in old versions of Safari).
	  !(!Array.isArray(obj) && ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;
	
	  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;
	
	  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;
	
	  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;
	
	  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
	  // without method will throw during the slice call and skip straight to the
	  // fallback.
	  if (obj.hasOwnProperty) {
	    try {
	      return Array.prototype.slice.call(obj);
	    } catch (e) {
	      // IE < 9 does not support Array#slice on collections objects
	    }
	  }
	
	  // Fall back to copying key by key. This assumes all keys have a value,
	  // so will not preserve sparsely populated inputs.
	  var ret = Array(length);
	  for (var ii = 0; ii < length; ii++) {
	    ret[ii] = obj[ii];
	  }
	  return ret;
	}
	
	/**
	 * Perform a heuristic test to determine if an object is "array-like".
	 *
	 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
	 *   Joshu replied: "Mu."
	 *
	 * This function determines if its argument has "array nature": it returns
	 * true if the argument is an actual array, an `arguments' object, or an
	 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
	 *
	 * It will return false for other array-like objects like Filelist.
	 *
	 * @param {*} obj
	 * @return {boolean}
	 */
	function hasArrayNature(obj) {
	  return (
	    // not null/false
	    !!obj && (
	    // arrays are objects, NodeLists are functions in Safari
	    (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) == 'object' || typeof obj == 'function') &&
	    // quacks like an array
	    'length' in obj &&
	    // not window
	    !('setInterval' in obj) &&
	    // no DOM node should be considered an array-like
	    // a 'select' element has 'length' and 'item' properties on IE8
	    typeof obj.nodeType != 'number' && (
	    // a real array
	    Array.isArray(obj) ||
	    // arguments
	    'callee' in obj ||
	    // HTMLCollection/NodeList
	    'item' in obj)
	  );
	}
	
	/**
	 * Ensure that the argument is an array by wrapping it in an array if it is not.
	 * Creates a copy of the argument if it is already an array.
	 *
	 * This is mostly useful idiomatically:
	 *
	 *   var createArrayFromMixed = require('createArrayFromMixed');
	 *
	 *   function takesOneOrMoreThings(things) {
	 *     things = createArrayFromMixed(things);
	 *     ...
	 *   }
	 *
	 * This allows you to treat `things' as an array, but accept scalars in the API.
	 *
	 * If you need to convert an array-like object, like `arguments`, into an array
	 * use toArray instead.
	 *
	 * @param {*} obj
	 * @return {array}
	 */
	function createArrayFromMixed(obj) {
	  if (!hasArrayNature(obj)) {
	    return [obj];
	  } else if (Array.isArray(obj)) {
	    return obj.slice();
	  } else {
	    return toArray(obj);
	  }
	}
	
	module.exports = createArrayFromMixed;

/***/ },
/* 775 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	/*eslint-disable fb-www/unsafe-html*/
	
	var ExecutionEnvironment = __webpack_require__(32);
	
	var createArrayFromMixed = __webpack_require__(774);
	var getMarkupWrap = __webpack_require__(776);
	var invariant = __webpack_require__(5);
	
	/**
	 * Dummy container used to render all markup.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Pattern used by `getNodeName`.
	 */
	var nodeNamePattern = /^\s*<(\w+)/;
	
	/**
	 * Extracts the `nodeName` of the first element in a string of markup.
	 *
	 * @param {string} markup String of markup.
	 * @return {?string} Node name of the supplied markup.
	 */
	function getNodeName(markup) {
	  var nodeNameMatch = markup.match(nodeNamePattern);
	  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
	}
	
	/**
	 * Creates an array containing the nodes rendered from the supplied markup. The
	 * optionally supplied `handleScript` function will be invoked once for each
	 * <script> element that is rendered. If no `handleScript` function is supplied,
	 * an exception is thrown if any <script> elements are rendered.
	 *
	 * @param {string} markup A string of valid HTML markup.
	 * @param {?function} handleScript Invoked once for each rendered <script>.
	 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
	 */
	function createNodesFromMarkup(markup, handleScript) {
	  var node = dummyNode;
	  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
	  var nodeName = getNodeName(markup);
	
	  var wrap = nodeName && getMarkupWrap(nodeName);
	  if (wrap) {
	    node.innerHTML = wrap[1] + markup + wrap[2];
	
	    var wrapDepth = wrap[0];
	    while (wrapDepth--) {
	      node = node.lastChild;
	    }
	  } else {
	    node.innerHTML = markup;
	  }
	
	  var scripts = node.getElementsByTagName('script');
	  if (scripts.length) {
	    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
	    createArrayFromMixed(scripts).forEach(handleScript);
	  }
	
	  var nodes = Array.from(node.childNodes);
	  while (node.lastChild) {
	    node.removeChild(node.lastChild);
	  }
	  return nodes;
	}
	
	module.exports = createNodesFromMarkup;

/***/ },
/* 776 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/*eslint-disable fb-www/unsafe-html */
	
	var ExecutionEnvironment = __webpack_require__(32);
	
	var invariant = __webpack_require__(5);
	
	/**
	 * Dummy container used to detect which wraps are necessary.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Some browsers cannot use `innerHTML` to render certain elements standalone,
	 * so we wrap them, render the wrapped nodes, then extract the desired node.
	 *
	 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
	 */
	
	var shouldWrap = {};
	
	var selectWrap = [1, '<select multiple="true">', '</select>'];
	var tableWrap = [1, '<table>', '</table>'];
	var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];
	
	var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];
	
	var markupWrap = {
	  '*': [1, '?<div>', '</div>'],
	
	  'area': [1, '<map>', '</map>'],
	  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
	  'legend': [1, '<fieldset>', '</fieldset>'],
	  'param': [1, '<object>', '</object>'],
	  'tr': [2, '<table><tbody>', '</tbody></table>'],
	
	  'optgroup': selectWrap,
	  'option': selectWrap,
	
	  'caption': tableWrap,
	  'colgroup': tableWrap,
	  'tbody': tableWrap,
	  'tfoot': tableWrap,
	  'thead': tableWrap,
	
	  'td': trWrap,
	  'th': trWrap
	};
	
	// Initialize the SVG elements since we know they'll always need to be wrapped
	// consistently. If they are created inside a <div> they will be initialized in
	// the wrong namespace (and will not display).
	var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
	svgElements.forEach(function (nodeName) {
	  markupWrap[nodeName] = svgWrap;
	  shouldWrap[nodeName] = true;
	});
	
	/**
	 * Gets the markup wrap configuration for the supplied `nodeName`.
	 *
	 * NOTE: This lazily detects which wraps are necessary for the current browser.
	 *
	 * @param {string} nodeName Lowercase `nodeName`.
	 * @return {?array} Markup wrap configuration, if applicable.
	 */
	function getMarkupWrap(nodeName) {
	  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
	  if (!markupWrap.hasOwnProperty(nodeName)) {
	    nodeName = '*';
	  }
	  if (!shouldWrap.hasOwnProperty(nodeName)) {
	    if (nodeName === '*') {
	      dummyNode.innerHTML = '<link />';
	    } else {
	      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
	    }
	    shouldWrap[nodeName] = !dummyNode.firstChild;
	  }
	  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
	}
	
	module.exports = getMarkupWrap;

/***/ },
/* 777 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	/**
	 * Gets the scroll position of the supplied element or window.
	 *
	 * The return values are unbounded, unlike `getScrollPosition`. This means they
	 * may be negative or exceed the element boundaries (which is possible using
	 * inertial scrolling).
	 *
	 * @param {DOMWindow|DOMElement} scrollable
	 * @return {object} Map with `x` and `y` keys.
	 */
	
	function getUnboundedScrollPosition(scrollable) {
	  if (scrollable.Window && scrollable instanceof scrollable.Window) {
	    return {
	      x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
	      y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
	    };
	  }
	  return {
	    x: scrollable.scrollLeft,
	    y: scrollable.scrollTop
	  };
	}
	
	module.exports = getUnboundedScrollPosition;

/***/ },
/* 778 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var _uppercasePattern = /([A-Z])/g;
	
	/**
	 * Hyphenates a camelcased string, for example:
	 *
	 *   > hyphenate('backgroundColor')
	 *   < "background-color"
	 *
	 * For CSS style names, use `hyphenateStyleName` instead which works properly
	 * with all vendor prefixes, including `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenate(string) {
	  return string.replace(_uppercasePattern, '-$1').toLowerCase();
	}
	
	module.exports = hyphenate;

/***/ },
/* 779 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM node.
	 */
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function isNode(object) {
	  var doc = object ? object.ownerDocument || object : document;
	  var defaultView = doc.defaultView || window;
	  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : (typeof object === 'undefined' ? 'undefined' : _typeof(object)) === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
	}
	
	module.exports = isNode;

/***/ },
/* 780 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var isNode = __webpack_require__(779);
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM text node.
	 */
	function isTextNode(object) {
	  return isNode(object) && object.nodeType == 3;
	}
	
	module.exports = isTextNode;

/***/ },
/* 781 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var rgb = __webpack_require__(911);
	var wcag = __webpack_require__(955);
	var isBlank = __webpack_require__(808);
	var isNamedCssColor = __webpack_require__(810);
	var cssColorNames = __webpack_require__(967);
	
	module.exports.ratio = ratio;
	module.exports.score = score;
	module.exports.isAccessible = isAccessible;
	module.exports.isNotTransparent = isNotTransparent;
	
	function ratio(colorOne, colorTwo, options) {
	  colorOne = getRgbTriplet(colorOne, options);
	  colorTwo = getRgbTriplet(colorTwo, options);
	
	  return wcag.rgb(colorOne, colorTwo);
	}
	
	function score(colorOne, colorTwo, options) {
	  var wcagScore = wcag.score(ratio(colorOne, colorTwo, options));
	
	  if (isBlank(wcagScore)) {
	    return 'F';
	  } else {
	    return wcagScore;
	  }
	}
	
	function isAccessible(colorOne, colorTwo, options) {
	  return ratio(colorOne, colorTwo, options) > 4.5;
	}
	
	function getRgbTriplet(color, options) {
	  if (typeof color !== 'string') {
	    throw new TypeError('get-contrast expects colors as strings');
	  }
	
	  if (isNamedCssColor(color)) {
	    color = cssColorNames[color];
	  }
	
	  color = isNotTransparent(color, options);
	  return color.match(/\((.*)\)/)[1].split(',').slice(0, 3);
	}
	
	function isNotTransparent(color, options) {
	  options = options || {};
	
	  // Convert to RGB.
	  color = rgb(color);
	  // Check if the rgb returned color is rgba and if the 'a' value is 0.
	  var cArray = color.match(/\((.*)\)/)[1].split(',');
	  if (cArray.length == 4 && cArray[3] == '0' && !options.ignoreAlpha) {
	    throw new TypeError('get-contrast cannot contrast transparent colors');
	  } else {
	    return color;
	  }
	}

/***/ },
/* 782 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule CSSProperty
	 */
	
	/**
	 * CSS properties which accept numbers but are not in units of "px".
	 */
	
	var isUnitlessNumber = {
	  animationIterationCount: true,
	  borderImageOutset: true,
	  borderImageSlice: true,
	  borderImageWidth: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  flexOrder: true,
	  gridRow: true,
	  gridRowStart: true,
	  gridRowEnd: true,
	  gridColumn: true,
	  gridColumnStart: true,
	  gridColumnEnd: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	
	  // SVG-related properties
	  fillOpacity: true,
	  floodOpacity: true,
	  stopOpacity: true,
	  strokeDasharray: true,
	  strokeDashoffset: true,
	  strokeMiterlimit: true,
	  strokeOpacity: true,
	  strokeWidth: true
	
	  /**
	   * @param {string} prefix vendor-specific prefix, eg: Webkit
	   * @param {string} key style name, eg: transitionDuration
	   * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
	   * WebkitTransitionDuration
	   */
	};function prefixKey(prefix, key) {
	  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	}
	
	/**
	 * Support style names that may come passed in prefixed by adding permutations
	 * of vendor prefixes.
	 */
	var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
	
	// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
	// infinite loop, because it iterates over the newly added props too.
	Object.keys(isUnitlessNumber).forEach(function (prop) {
	  prefixes.forEach(function (prefix) {
	    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
	  });
	});
	
	/**
	 * Most style properties can be unset by doing .style[prop] = '' but IE8
	 * doesn't like doing that with shorthand properties so for the properties that
	 * IE8 breaks on, which are listed here, we instead unset each of the
	 * individual properties. See http://bugs.jquery.com/ticket/12385.
	 * The 4-value 'clock' properties like margin, padding, border-width seem to
	 * behave without any problems. Curiously, list-style works too without any
	 * special prodding.
	 */
	var shorthandPropertyExpansions = {
	  background: {
	    backgroundAttachment: true,
	    backgroundColor: true,
	    backgroundImage: true,
	    backgroundPositionX: true,
	    backgroundPositionY: true,
	    backgroundRepeat: true
	  },
	  backgroundPosition: {
	    backgroundPositionX: true,
	    backgroundPositionY: true
	  },
	  border: {
	    borderWidth: true,
	    borderStyle: true,
	    borderColor: true
	  },
	  borderBottom: {
	    borderBottomWidth: true,
	    borderBottomStyle: true,
	    borderBottomColor: true
	  },
	  borderLeft: {
	    borderLeftWidth: true,
	    borderLeftStyle: true,
	    borderLeftColor: true
	  },
	  borderRight: {
	    borderRightWidth: true,
	    borderRightStyle: true,
	    borderRightColor: true
	  },
	  borderTop: {
	    borderTopWidth: true,
	    borderTopStyle: true,
	    borderTopColor: true
	  },
	  font: {
	    fontStyle: true,
	    fontVariant: true,
	    fontWeight: true,
	    fontSize: true,
	    lineHeight: true,
	    fontFamily: true
	  },
	  outline: {
	    outlineWidth: true,
	    outlineStyle: true,
	    outlineColor: true
	  }
	};
	
	var CSSProperty = {
	  isUnitlessNumber: isUnitlessNumber,
	  shorthandPropertyExpansions: shorthandPropertyExpansions
	};
	
	exports.default = CSSProperty;

/***/ },
/* 783 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CSSProperty = __webpack_require__(782);
	
	var _CSSProperty2 = _interopRequireDefault(_CSSProperty);
	
	var _warning = __webpack_require__(9);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule dangerousStyleValue
	 */
	
	var isUnitlessNumber = _CSSProperty2.default.isUnitlessNumber;
	var styleWarnings = {};
	
	/**
	 * Convert a value into the proper css writable value. The style name `name`
	 * should be logical (no hyphens), as specified
	 * in `CSSProperty.isUnitlessNumber`.
	 *
	 * @param {string} name CSS property name such as `topMargin`.
	 * @param {*} value CSS property value such as `10px`.
	 * @param {ReactDOMComponent} component
	 * @return {string} Normalized style value with dimensions applied.
	 */
	function dangerousStyleValue(name, value, component) {
	  // Note that we've removed escapeTextForBrowser() calls here since the
	  // whole string will be escaped when the attribute is injected into
	  // the markup. If you provide unsafe user data here they can inject
	  // arbitrary CSS which may be problematic (I couldn't repro this):
	  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
	  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
	  // This is not an XSS hole but instead a potential CSS injection issue
	  // which has lead to a greater discussion about how we're going to
	  // trust URLs moving forward. See #2115901
	
	  var isEmpty = value == null || typeof value === 'boolean' || value === '';
	  if (isEmpty) {
	    return '';
	  }
	
	  var isNonNumeric = isNaN(value);
	  if (isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
	    return '' + value; // cast to string
	  }
	
	  if (typeof value === 'string') {
	    if (false) {
	      // Allow '0' to pass through without warning. 0 is already special and
	      // doesn't require units, so we don't need to warn about it.
	      if (component && value !== '0') {
	        var owner = component._currentElement._owner;
	        var ownerName = owner ? owner.getName() : null;
	        if (ownerName && !styleWarnings[ownerName]) {
	          styleWarnings[ownerName] = {};
	        }
	        var warned = false;
	        if (ownerName) {
	          var warnings = styleWarnings[ownerName];
	          warned = warnings[name];
	          if (!warned) {
	            warnings[name] = true;
	          }
	        }
	        if (!warned) {
	          process.env.NODE_ENV !== 'production' ? (0, _warning2.default)(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
	        }
	      }
	    }
	    value = value.trim();
	  }
	  return value + 'px';
	}
	
	exports.default = dangerousStyleValue;

/***/ },
/* 784 */
/***/ function(module, exports) {

	'use strict';
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
	  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	} : function (obj) {
	  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	};
	
	exports.default = clean;
	// Returns true for null, false, undefined and {}
	function isFalsy(value) {
	  return value === null || value === undefined || value === false || (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && Object.keys(value).length === 0;
	}
	
	function cleanObject(object) {
	  if (isFalsy(object)) return null;
	  if ((typeof object === 'undefined' ? 'undefined' : _typeof(object)) !== 'object') return object;
	
	  var acc = {},
	      keys = Object.keys(object),
	      hasFalsy = false;
	  for (var i = 0; i < keys.length; i++) {
	    var value = object[keys[i]];
	    var filteredValue = clean(value);
	    if (filteredValue === null || filteredValue !== value) {
	      hasFalsy = true;
	    }
	    if (filteredValue !== null) {
	      acc[keys[i]] = filteredValue;
	    }
	  }
	  return Object.keys(acc).length === 0 ? null : hasFalsy ? acc : object;
	}
	
	function cleanArray(rules) {
	  var hasFalsy = false;
	  var filtered = [];
	  rules.forEach(function (rule) {
	    var filteredRule = clean(rule);
	    if (filteredRule === null || filteredRule !== rule) {
	      hasFalsy = true;
	    }
	    if (filteredRule !== null) {
	      filtered.push(filteredRule);
	    }
	  });
	  return filtered.length == 0 ? null : hasFalsy ? filtered : rules;
	}
	
	// Takes style array or object provided by user and clears all the falsy data 
	// If there is no styles left after filtration returns null
	function clean(input) {
	  return Array.isArray(input) ? cleanArray(input) : cleanObject(input);
	}

/***/ },
/* 785 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = doHash;
	// murmurhash2 via https://gist.github.com/raycmorgan/588423
	
	function doHash(str, seed) {
	  var m = 0x5bd1e995;
	  var r = 24;
	  var h = seed ^ str.length;
	  var length = str.length;
	  var currentIndex = 0;
	
	  while (length >= 4) {
	    var k = UInt32(str, currentIndex);
	
	    k = Umul32(k, m);
	    k ^= k >>> r;
	    k = Umul32(k, m);
	
	    h = Umul32(h, m);
	    h ^= k;
	
	    currentIndex += 4;
	    length -= 4;
	  }
	
	  switch (length) {
	    case 3:
	      h ^= UInt16(str, currentIndex);
	      h ^= str.charCodeAt(currentIndex + 2) << 16;
	      h = Umul32(h, m);
	      break;
	
	    case 2:
	      h ^= UInt16(str, currentIndex);
	      h = Umul32(h, m);
	      break;
	
	    case 1:
	      h ^= str.charCodeAt(currentIndex);
	      h = Umul32(h, m);
	      break;
	  }
	
	  h ^= h >>> 13;
	  h = Umul32(h, m);
	  h ^= h >>> 15;
	
	  return h >>> 0;
	}
	
	function UInt32(str, pos) {
	  return str.charCodeAt(pos++) + (str.charCodeAt(pos++) << 8) + (str.charCodeAt(pos++) << 16) + (str.charCodeAt(pos) << 24);
	}
	
	function UInt16(str, pos) {
	  return str.charCodeAt(pos++) + (str.charCodeAt(pos++) << 8);
	}
	
	function Umul32(n, m) {
	  n = n | 0;
	  m = m | 0;
	  var nlo = n & 0xffff;
	  var nhi = n >>> 16;
	  var res = nlo * m + ((nhi * m & 0xffff) << 16) | 0;
	  return res;
	}

/***/ },
/* 786 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }return target;
	};
	
	exports.PluginSet = PluginSet;
	exports.fallbacks = fallbacks;
	exports.contentWrap = contentWrap;
	exports.prefixes = prefixes;
	
	var _objectAssign = __webpack_require__(11);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _CSSPropertyOperations = __webpack_require__(244);
	
	var _prefixer = __webpack_require__(787);
	
	var _prefixer2 = _interopRequireDefault(_prefixer);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	var isDev = function (x) {
	  return x === 'development' || !x;
	}(("production"));
	
	function PluginSet(initial) {
	  this.fns = initial || [];
	}
	
	(0, _objectAssign2.default)(PluginSet.prototype, {
	  add: function add() {
	    var _this = this;
	
	    for (var _len = arguments.length, fns = Array(_len), _key = 0; _key < _len; _key++) {
	      fns[_key] = arguments[_key];
	    }
	
	    fns.forEach(function (fn) {
	      if (_this.fns.indexOf(fn) >= 0) {
	        if (isDev) {
	          console.warn('adding the same plugin again, ignoring'); //eslint-disable-line no-console
	        }
	      } else {
	        _this.fns = [fn].concat(_this.fns);
	      }
	    });
	  },
	  remove: function remove(fn) {
	    this.fns = this.fns.filter(function (x) {
	      return x !== fn;
	    });
	  },
	  clear: function clear() {
	    this.fns = [];
	  },
	  transform: function transform(o) {
	    return this.fns.reduce(function (o, fn) {
	      return fn(o);
	    }, o);
	  }
	});
	
	function fallbacks(node) {
	  var hasArray = Object.keys(node.style).map(function (x) {
	    return Array.isArray(node.style[x]);
	  }).indexOf(true) >= 0;
	  if (hasArray) {
	    var style = node.style;
	
	    var flattened = Object.keys(style).reduce(function (o, key) {
	      o[key] = Array.isArray(style[key]) ? style[key].join('; ' + (0, _CSSPropertyOperations.processStyleName)(key) + ': ') : style[key];
	      return o;
	    }, {});
	    // todo - 
	    // flatten arrays which haven't been flattened yet 
	    return (0, _objectAssign2.default)({}, node, { style: flattened });
	  }
	  return node;
	}
	
	var contentValues = ['normal', 'none', 'counter', 'open-quote', 'close-quote', 'no-open-quote', 'no-close-quote', 'initial', 'inherit'];
	
	function contentWrap(node) {
	  if (node.style.content) {
	    var cont = node.style.content;
	    if (contentValues.indexOf(cont) >= 0) {
	      return node;
	    }
	    if (/^(attr|calc|counters?|url)\(/.test(cont)) {
	      return node;
	    }
	    if (cont.charAt(0) === cont.charAt(cont.length - 1) && (cont.charAt(0) === '"' || cont.charAt(0) === "'")) {
	      return node;
	    }
	    return _extends({}, node, { style: _extends({}, node.style, { content: '"' + cont + '"' }) });
	  }
	  return node;
	}
	
	function prefixes(node) {
	  return (0, _objectAssign2.default)({}, node, { style: (0, _prefixer2.default)(_extends({}, node.style)) });
	}

/***/ },
/* 787 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = prefixer;
	
	var _staticData = __webpack_require__(804);
	
	var _staticData2 = _interopRequireDefault(_staticData);
	
	var _prefixProperty = __webpack_require__(805);
	
	var _prefixProperty2 = _interopRequireDefault(_prefixProperty);
	
	var _prefixValue = __webpack_require__(806);
	
	var _prefixValue2 = _interopRequireDefault(_prefixValue);
	
	var _cursor = __webpack_require__(795);
	
	var _cursor2 = _interopRequireDefault(_cursor);
	
	var _crossFade = __webpack_require__(794);
	
	var _crossFade2 = _interopRequireDefault(_crossFade);
	
	var _filter = __webpack_require__(796);
	
	var _filter2 = _interopRequireDefault(_filter);
	
	var _flex = __webpack_require__(797);
	
	var _flex2 = _interopRequireDefault(_flex);
	
	var _flexboxOld = __webpack_require__(798);
	
	var _flexboxOld2 = _interopRequireDefault(_flexboxOld);
	
	var _gradient = __webpack_require__(799);
	
	var _gradient2 = _interopRequireDefault(_gradient);
	
	var _imageSet = __webpack_require__(800);
	
	var _imageSet2 = _interopRequireDefault(_imageSet);
	
	var _position = __webpack_require__(801);
	
	var _position2 = _interopRequireDefault(_position);
	
	var _sizing = __webpack_require__(802);
	
	var _sizing2 = _interopRequireDefault(_sizing);
	
	var _transition = __webpack_require__(803);
	
	var _transition2 = _interopRequireDefault(_transition);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	var plugins = [_crossFade2.default, _cursor2.default, _filter2.default, _flexboxOld2.default, _gradient2.default, _imageSet2.default, _position2.default, _sizing2.default, _transition2.default, _flex2.default]; // custom facade for inline-style-prefixer
	
	var prefixMap = _staticData2.default.prefixMap;
	
	function prefixer(style) {
	  for (var property in style) {
	    var value = style[property];
	
	    var processedValue = (0, _prefixValue2.default)(plugins, property, value, style, prefixMap);
	
	    // only modify the value if it was touched
	    // by any plugin to prevent unnecessary mutations
	    if (processedValue) {
	      style[property] = processedValue;
	    }
	
	    (0, _prefixProperty2.default)(prefixMap, property, style);
	  }
	  return style;
	}

/***/ },
/* 788 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.StyleSheet = StyleSheet;
	
	var _objectAssign = __webpack_require__(11);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _toConsumableArray(arr) {
	  if (Array.isArray(arr)) {
	    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
	      arr2[i] = arr[i];
	    }return arr2;
	  } else {
	    return Array.from(arr);
	  }
	}
	
	/* 
	
	high performance StyleSheet for css-in-js systems 
	
	- uses multiple style tags behind the scenes for millions of rules 
	- uses `insertRule` for appending in production for *much* faster performance
	- 'polyfills' on server side 
	
	
	// usage
	
	import StyleSheet from 'glamor/lib/sheet'
	let styleSheet = new StyleSheet()
	
	styleSheet.inject() 
	- 'injects' the stylesheet into the page (or into memory if on server)
	
	styleSheet.insert('#box { border: 1px solid red; }') 
	- appends a css rule into the stylesheet 
	
	styleSheet.flush() 
	- empties the stylesheet of all its contents
	
	
	*/
	
	function last(arr) {
	  return arr[arr.length - 1];
	}
	
	function sheetForTag(tag) {
	  if (tag.sheet) {
	    return tag.sheet;
	  }
	
	  // this weirdness brought to you by firefox 
	  for (var i = 0; i < document.styleSheets.length; i++) {
	    if (document.styleSheets[i].ownerNode === tag) {
	      return document.styleSheets[i];
	    }
	  }
	}
	
	var isBrowser = typeof window !== 'undefined';
	var isDev = ("production") === 'development' || !("production"); //(x => (x === 'development') || !x)(process.env.NODE_ENV)
	var isTest = ("production") === 'test';
	
	var oldIE = function () {
	  if (isBrowser) {
	    var div = document.createElement('div');
	    div.innerHTML = '<!--[if lt IE 10]><i></i><![endif]-->';
	    return div.getElementsByTagName('i').length === 1;
	  }
	}();
	
	function makeStyleTag() {
	  var tag = document.createElement('style');
	  tag.type = 'text/css';
	  tag.setAttribute('data-glamor', '');
	  tag.appendChild(document.createTextNode(''));
	  (document.head || document.getElementsByTagName('head')[0]).appendChild(tag);
	  return tag;
	}
	
	function StyleSheet() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      _ref$speedy = _ref.speedy,
	      speedy = _ref$speedy === undefined ? !isDev && !isTest : _ref$speedy,
	      _ref$maxLength = _ref.maxLength,
	      maxLength = _ref$maxLength === undefined ? isBrowser && oldIE ? 4000 : 65000 : _ref$maxLength;
	
	  this.isSpeedy = speedy; // the big drawback here is that the css won't be editable in devtools
	  this.sheet = undefined;
	  this.tags = [];
	  this.maxLength = maxLength;
	  this.ctr = 0;
	}
	
	(0, _objectAssign2.default)(StyleSheet.prototype, {
	  getSheet: function getSheet() {
	    return sheetForTag(last(this.tags));
	  },
	  inject: function inject() {
	    var _this = this;
	
	    if (this.injected) {
	      throw new Error('already injected stylesheet!');
	    }
	    if (isBrowser) {
	      this.tags[0] = makeStyleTag();
	    } else {
	      // server side 'polyfill'. just enough behavior to be useful.
	      this.sheet = {
	        cssRules: [],
	        insertRule: function insertRule(rule) {
	          // enough 'spec compliance' to be able to extract the rules later  
	          // in other words, just the cssText field 
	          _this.sheet.cssRules.push({ cssText: rule });
	        }
	      };
	    }
	    this.injected = true;
	  },
	  speedy: function speedy(bool) {
	    if (this.ctr !== 0) {
	      throw new Error('cannot change speedy mode after inserting any rule to sheet. Either call speedy(' + bool + ') earlier in your app, or call flush() before speedy(' + bool + ')');
	    }
	    this.isSpeedy = !!bool;
	  },
	  _insert: function _insert(rule) {
	    // this weirdness for perf, and chrome's weird bug 
	    // https://stackoverflow.com/questions/20007992/chrome-suddenly-stopped-accepting-insertrule
	    try {
	      var sheet = this.getSheet();
	      sheet.insertRule(rule, rule.indexOf('@import') !== -1 ? 0 : sheet.cssRules.length);
	    } catch (e) {
	      if (isDev) {
	        // might need beter dx for this 
	        console.warn('whoops, illegal rule inserted', rule); //eslint-disable-line no-console
	      }
	    }
	  },
	  insert: function insert(rule) {
	
	    if (isBrowser) {
	      // this is the ultrafast version, works across browsers 
	      if (this.isSpeedy && this.getSheet().insertRule) {
	        this._insert(rule);
	      }
	      // more browser weirdness. I don't even know    
	      // else if(this.tags.length > 0 && this.tags::last().styleSheet) {      
	      //   this.tags::last().styleSheet.cssText+= rule
	      // }
	      else {
	          if (rule.indexOf('@import') !== -1) {
	            var tag = last(this.tags);
	            tag.insertBefore(document.createTextNode(rule), tag.firstChild);
	          } else {
	            last(this.tags).appendChild(document.createTextNode(rule));
	          }
	        }
	    } else {
	      // server side is pretty simple         
	      this.sheet.insertRule(rule, rule.indexOf('@import') !== -1 ? 0 : this.sheet.cssRules.length);
	    }
	
	    this.ctr++;
	    if (isBrowser && this.ctr % this.maxLength === 0) {
	      this.tags.push(makeStyleTag());
	    }
	    return this.ctr - 1;
	  },
	
	  // commenting this out till we decide on v3's decision 
	  // _replace(index, rule) {
	  //   // this weirdness for perf, and chrome's weird bug 
	  //   // https://stackoverflow.com/questions/20007992/chrome-suddenly-stopped-accepting-insertrule
	  //   try {  
	  //     let sheet = this.getSheet()        
	  //     sheet.deleteRule(index) // todo - correct index here     
	  //     sheet.insertRule(rule, index)
	  //   }
	  //   catch(e) {
	  //     if(isDev) {
	  //       // might need beter dx for this 
	  //       console.warn('whoops, problem replacing rule', rule) //eslint-disable-line no-console
	  //     }          
	  //   }          
	
	  // }
	  // replace(index, rule) {
	  //   if(isBrowser) {
	  //     if(this.isSpeedy && this.getSheet().insertRule) {
	  //       this._replace(index, rule)
	  //     }
	  //     else {
	  //       let _slot = Math.floor((index  + this.maxLength) / this.maxLength) - 1        
	  //       let _index = (index % this.maxLength) + 1
	  //       let tag = this.tags[_slot]
	  //       tag.replaceChild(document.createTextNode(rule), tag.childNodes[_index])
	  //     }
	  //   }
	  //   else {
	  //     let rules = this.sheet.cssRules
	  //     this.sheet.cssRules = [ ...rules.slice(0, index), { cssText: rule }, ...rules.slice(index + 1) ]
	  //   }
	  // }
	  delete: function _delete(index) {
	    // we insert a blank rule when 'deleting' so previously returned indexes remain stable
	    return this.replace(index, '');
	  },
	  flush: function flush() {
	    if (isBrowser) {
	      this.tags.forEach(function (tag) {
	        return tag.parentNode.removeChild(tag);
	      });
	      this.tags = [];
	      this.sheet = null;
	      this.ctr = 0;
	      // todo - look for remnants in document.styleSheets
	    } else {
	      // simpler on server 
	      this.sheet.cssRules = [];
	    }
	    this.injected = false;
	  },
	  rules: function rules() {
	    if (!isBrowser) {
	      return this.sheet.cssRules;
	    }
	    var arr = [];
	    this.tags.forEach(function (tag) {
	      return arr.splice.apply(arr, [arr.length, 0].concat(_toConsumableArray(Array.from(sheetForTag(tag).cssRules))));
	    });
	    return arr;
	  }
	});

/***/ },
/* 789 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var key = '__global_unique_id__';
	
	module.exports = function () {
	  return global[key] = (global[key] || 0) + 1;
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 790 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function (hex) {
		if (typeof hex !== 'string') {
			throw new TypeError('Expected a string');
		}
	
		hex = hex.replace(/^#/, '');
	
		if (hex.length === 3) {
			hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
		}
	
		var num = parseInt(hex, 16);
	
		return [num >> 16, num >> 8 & 255, num & 255];
	};

/***/ },
/* 791 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    getDerivedStateFromProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    callee: true,
	    arguments: true,
	    arity: true
	};
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	
	function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	    if (typeof sourceComponent !== 'string') {
	        // don't hoist over string (html) components
	
	        if (objectPrototype) {
	            var inheritedComponent = getPrototypeOf(sourceComponent);
	            if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	            }
	        }
	
	        var keys = getOwnPropertyNames(sourceComponent);
	
	        if (getOwnPropertySymbols) {
	            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                try {
	                    // Avoid failures from read-only properties
	                    defineProperty(targetComponent, key, descriptor);
	                } catch (e) {}
	            }
	        }
	
	        return targetComponent;
	    }
	
	    return targetComponent;
	}
	
	module.exports = hoistNonReactStatics;

/***/ },
/* 792 */
/***/ function(module, exports) {

	'use strict';
	
	var uppercasePattern = /[A-Z]/g;
	var msPattern = /^ms-/;
	var cache = {};
	
	function hyphenateStyleName(string) {
	  return string in cache ? cache[string] : cache[string] = string.replace(uppercasePattern, '-$&').toLowerCase().replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;

/***/ },
/* 793 */
/***/ function(module, exports) {

	"use strict";
	
	exports.read = function (buffer, offset, isLE, mLen, nBytes) {
	  var e, m;
	  var eLen = nBytes * 8 - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var nBits = -7;
	  var i = isLE ? nBytes - 1 : 0;
	  var d = isLE ? -1 : 1;
	  var s = buffer[offset + i];
	
	  i += d;
	
	  e = s & (1 << -nBits) - 1;
	  s >>= -nBits;
	  nBits += eLen;
	  for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {}
	
	  m = e & (1 << -nBits) - 1;
	  e >>= -nBits;
	  nBits += mLen;
	  for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {}
	
	  if (e === 0) {
	    e = 1 - eBias;
	  } else if (e === eMax) {
	    return m ? NaN : (s ? -1 : 1) * Infinity;
	  } else {
	    m = m + Math.pow(2, mLen);
	    e = e - eBias;
	  }
	  return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
	};
	
	exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
	  var e, m, c;
	  var eLen = nBytes * 8 - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
	  var i = isLE ? 0 : nBytes - 1;
	  var d = isLE ? 1 : -1;
	  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
	
	  value = Math.abs(value);
	
	  if (isNaN(value) || value === Infinity) {
	    m = isNaN(value) ? 1 : 0;
	    e = eMax;
	  } else {
	    e = Math.floor(Math.log(value) / Math.LN2);
	    if (value * (c = Math.pow(2, -e)) < 1) {
	      e--;
	      c *= 2;
	    }
	    if (e + eBias >= 1) {
	      value += rt / c;
	    } else {
	      value += rt * Math.pow(2, 1 - eBias);
	    }
	    if (value * c >= 2) {
	      e++;
	      c /= 2;
	    }
	
	    if (e + eBias >= eMax) {
	      m = 0;
	      e = eMax;
	    } else if (e + eBias >= 1) {
	      m = (value * c - 1) * Math.pow(2, mLen);
	      e = e + eBias;
	    } else {
	      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
	      e = 0;
	    }
	  }
	
	  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}
	
	  e = e << mLen | m;
	  eLen += mLen;
	  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}
	
	  buffer[offset + i - d] |= s * 128;
	};

/***/ },
/* 794 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = crossFade;
	
	var _isPrefixedValue = __webpack_require__(93);
	
	var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	// http://caniuse.com/#search=cross-fade
	var prefixes = ['-webkit-', ''];
	function crossFade(property, value) {
	  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.indexOf('cross-fade(') > -1) {
	    return prefixes.map(function (prefix) {
	      return value.replace(/cross-fade\(/g, prefix + 'cross-fade(');
	    });
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 795 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = cursor;
	var prefixes = ['-webkit-', '-moz-', ''];
	
	var values = {
	  'zoom-in': true,
	  'zoom-out': true,
	  grab: true,
	  grabbing: true
	};
	
	function cursor(property, value) {
	  if (property === 'cursor' && values.hasOwnProperty(value)) {
	    return prefixes.map(function (prefix) {
	      return prefix + value;
	    });
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 796 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = filter;
	
	var _isPrefixedValue = __webpack_require__(93);
	
	var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	// http://caniuse.com/#feat=css-filter-function
	var prefixes = ['-webkit-', ''];
	function filter(property, value) {
	  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.indexOf('filter(') > -1) {
	    return prefixes.map(function (prefix) {
	      return value.replace(/filter\(/g, prefix + 'filter(');
	    });
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 797 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flex;
	var values = {
	  flex: ['-webkit-box', '-moz-box', '-ms-flexbox', '-webkit-flex', 'flex'],
	  'inline-flex': ['-webkit-inline-box', '-moz-inline-box', '-ms-inline-flexbox', '-webkit-inline-flex', 'inline-flex']
	};
	
	function flex(property, value) {
	  if (property === 'display' && values.hasOwnProperty(value)) {
	    return values[value];
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 798 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flexboxOld;
	var alternativeValues = {
	  'space-around': 'justify',
	  'space-between': 'justify',
	  'flex-start': 'start',
	  'flex-end': 'end',
	  'wrap-reverse': 'multiple',
	  wrap: 'multiple'
	};
	
	var alternativeProps = {
	  alignItems: 'WebkitBoxAlign',
	  justifyContent: 'WebkitBoxPack',
	  flexWrap: 'WebkitBoxLines'
	};
	
	function flexboxOld(property, value, style) {
	  if (property === 'flexDirection' && typeof value === 'string') {
	    if (value.indexOf('column') > -1) {
	      style.WebkitBoxOrient = 'vertical';
	    } else {
	      style.WebkitBoxOrient = 'horizontal';
	    }
	    if (value.indexOf('reverse') > -1) {
	      style.WebkitBoxDirection = 'reverse';
	    } else {
	      style.WebkitBoxDirection = 'normal';
	    }
	  }
	  if (alternativeProps.hasOwnProperty(property)) {
	    style[alternativeProps[property]] = alternativeValues[value] || value;
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 799 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = gradient;
	
	var _isPrefixedValue = __webpack_require__(93);
	
	var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	var prefixes = ['-webkit-', '-moz-', ''];
	
	var values = /linear-gradient|radial-gradient|repeating-linear-gradient|repeating-radial-gradient/;
	
	function gradient(property, value) {
	  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && values.test(value)) {
	    return prefixes.map(function (prefix) {
	      return prefix + value;
	    });
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 800 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = imageSet;
	
	var _isPrefixedValue = __webpack_require__(93);
	
	var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	// http://caniuse.com/#feat=css-image-set
	var prefixes = ['-webkit-', ''];
	function imageSet(property, value) {
	  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.indexOf('image-set(') > -1) {
	    return prefixes.map(function (prefix) {
	      return value.replace(/image-set\(/g, prefix + 'image-set(');
	    });
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 801 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = position;
	function position(property, value) {
	  if (property === 'position' && value === 'sticky') {
	    return ['-webkit-sticky', 'sticky'];
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 802 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = sizing;
	var prefixes = ['-webkit-', '-moz-', ''];
	
	var properties = {
	  maxHeight: true,
	  maxWidth: true,
	  width: true,
	  height: true,
	  columnWidth: true,
	  minWidth: true,
	  minHeight: true
	};
	var values = {
	  'min-content': true,
	  'max-content': true,
	  'fill-available': true,
	  'fit-content': true,
	  'contain-floats': true
	};
	
	function sizing(property, value) {
	  if (properties.hasOwnProperty(property) && values.hasOwnProperty(value)) {
	    return prefixes.map(function (prefix) {
	      return prefix + value;
	    });
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 803 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = transition;
	
	var _hyphenateProperty = __webpack_require__(731);
	
	var _hyphenateProperty2 = _interopRequireDefault(_hyphenateProperty);
	
	var _isPrefixedValue = __webpack_require__(93);
	
	var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);
	
	var _capitalizeString = __webpack_require__(246);
	
	var _capitalizeString2 = _interopRequireDefault(_capitalizeString);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	var properties = {
	  transition: true,
	  transitionProperty: true,
	  WebkitTransition: true,
	  WebkitTransitionProperty: true,
	  MozTransition: true,
	  MozTransitionProperty: true
	};
	
	var prefixMapping = {
	  Webkit: '-webkit-',
	  Moz: '-moz-',
	  ms: '-ms-'
	};
	
	function prefixValue(value, propertyPrefixMap) {
	  if ((0, _isPrefixedValue2.default)(value)) {
	    return value;
	  }
	
	  // only split multi values, not cubic beziers
	  var multipleValues = value.split(/,(?![^()]*(?:\([^()]*\))?\))/g);
	
	  for (var i = 0, len = multipleValues.length; i < len; ++i) {
	    var singleValue = multipleValues[i];
	    var values = [singleValue];
	    for (var property in propertyPrefixMap) {
	      var dashCaseProperty = (0, _hyphenateProperty2.default)(property);
	
	      if (singleValue.indexOf(dashCaseProperty) > -1 && dashCaseProperty !== 'order') {
	        var prefixes = propertyPrefixMap[property];
	        for (var j = 0, pLen = prefixes.length; j < pLen; ++j) {
	          // join all prefixes and create a new value
	          values.unshift(singleValue.replace(dashCaseProperty, prefixMapping[prefixes[j]] + dashCaseProperty));
	        }
	      }
	    }
	
	    multipleValues[i] = values.join(',');
	  }
	
	  return multipleValues.join(',');
	}
	
	function transition(property, value, style, propertyPrefixMap) {
	  // also check for already prefixed transitions
	  if (typeof value === 'string' && properties.hasOwnProperty(property)) {
	    var outputValue = prefixValue(value, propertyPrefixMap);
	    // if the property is already prefixed
	    var webkitOutput = outputValue.split(/,(?![^()]*(?:\([^()]*\))?\))/g).filter(function (val) {
	      return !/-moz-|-ms-/.test(val);
	    }).join(',');
	
	    if (property.indexOf('Webkit') > -1) {
	      return webkitOutput;
	    }
	
	    var mozOutput = outputValue.split(/,(?![^()]*(?:\([^()]*\))?\))/g).filter(function (val) {
	      return !/-webkit-|-ms-/.test(val);
	    }).join(',');
	
	    if (property.indexOf('Moz') > -1) {
	      return mozOutput;
	    }
	
	    style['Webkit' + (0, _capitalizeString2.default)(property)] = webkitOutput;
	    style['Moz' + (0, _capitalizeString2.default)(property)] = mozOutput;
	    return outputValue;
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 804 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var w = ["Webkit"];
	var m = ["Moz"];
	var ms = ["ms"];
	var wm = ["Webkit", "Moz"];
	var wms = ["Webkit", "ms"];
	var wmms = ["Webkit", "Moz", "ms"];
	
	exports.default = {
	  plugins: [],
	  prefixMap: { "appearance": wm, "userSelect": wmms, "textEmphasisPosition": w, "textEmphasis": w, "textEmphasisStyle": w, "textEmphasisColor": w, "boxDecorationBreak": w, "clipPath": w, "maskImage": w, "maskMode": w, "maskRepeat": w, "maskPosition": w, "maskClip": w, "maskOrigin": w, "maskSize": w, "maskComposite": w, "mask": w, "maskBorderSource": w, "maskBorderMode": w, "maskBorderSlice": w, "maskBorderWidth": w, "maskBorderOutset": w, "maskBorderRepeat": w, "maskBorder": w, "maskType": w, "textDecorationStyle": w, "textDecorationSkip": w, "textDecorationLine": w, "textDecorationColor": w, "filter": w, "fontFeatureSettings": w, "breakAfter": wmms, "breakBefore": wmms, "breakInside": wmms, "columnCount": wm, "columnFill": wm, "columnGap": wm, "columnRule": wm, "columnRuleColor": wm, "columnRuleStyle": wm, "columnRuleWidth": wm, "columns": wm, "columnSpan": wm, "columnWidth": wm, "writingMode": wms, "flex": w, "flexBasis": w, "flexDirection": w, "flexGrow": w, "flexFlow": w, "flexShrink": w, "flexWrap": w, "alignContent": w, "alignItems": w, "alignSelf": w, "justifyContent": w, "order": w, "transform": w, "transformOrigin": w, "transformOriginX": w, "transformOriginY": w, "backfaceVisibility": w, "perspective": w, "perspectiveOrigin": w, "transformStyle": w, "transformOriginZ": w, "animation": w, "animationDelay": w, "animationDirection": w, "animationFillMode": w, "animationDuration": w, "animationIterationCount": w, "animationName": w, "animationPlayState": w, "animationTimingFunction": w, "backdropFilter": w, "fontKerning": w, "scrollSnapType": wms, "scrollSnapPointsX": wms, "scrollSnapPointsY": wms, "scrollSnapDestination": wms, "scrollSnapCoordinate": wms, "shapeImageThreshold": w, "shapeImageMargin": w, "shapeImageOutside": w, "hyphens": wmms, "flowInto": wms, "flowFrom": wms, "regionFragment": wms, "textAlignLast": m, "tabSize": m, "wrapFlow": ms, "wrapThrough": ms, "wrapMargin": ms, "gridTemplateColumns": ms, "gridTemplateRows": ms, "gridTemplateAreas": ms, "gridTemplate": ms, "gridAutoColumns": ms, "gridAutoRows": ms, "gridAutoFlow": ms, "grid": ms, "gridRowStart": ms, "gridColumnStart": ms, "gridRowEnd": ms, "gridRow": ms, "gridColumn": ms, "gridColumnEnd": ms, "gridColumnGap": ms, "gridRowGap": ms, "gridArea": ms, "gridGap": ms, "textSizeAdjust": wms, "borderImage": w, "borderImageOutset": w, "borderImageRepeat": w, "borderImageSlice": w, "borderImageSource": w, "borderImageWidth": w, "transitionDelay": w, "transitionDuration": w, "transitionProperty": w, "transitionTimingFunction": w }
	};
	module.exports = exports["default"];

/***/ },
/* 805 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = prefixProperty;
	
	var _capitalizeString = __webpack_require__(246);
	
	var _capitalizeString2 = _interopRequireDefault(_capitalizeString);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function prefixProperty(prefixProperties, property, style) {
	  if (prefixProperties.hasOwnProperty(property)) {
	    var requiredPrefixes = prefixProperties[property];
	    for (var i = 0, len = requiredPrefixes.length; i < len; ++i) {
	      style[requiredPrefixes[i] + (0, _capitalizeString2.default)(property)] = style[property];
	    }
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 806 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = prefixValue;
	function prefixValue(plugins, property, value, style, metaData) {
	  for (var i = 0, len = plugins.length; i < len; ++i) {
	    var processedValue = plugins[i](property, value, style, metaData);
	
	    // we can stop processing if a value is returned
	    // as all plugin criteria are unique
	    if (processedValue) {
	      return processedValue;
	    }
	  }
	}
	module.exports = exports["default"];

/***/ },
/* 807 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function invariant(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;

/***/ },
/* 808 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var isEmpty = __webpack_require__(809);
	var isWhitespace = __webpack_require__(811);
	
	module.exports = function isBlank(object) {
	  if (typeof object === 'boolean') {
	    return false;
	  }
	
	  if (typeof object === 'string' && object.length) {
	    return isWhitespace(object);
	  } else {
	    return isEmpty(object);
	  }
	};

/***/ },
/* 809 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Expose `isEmpty`.
	 */
	
	module.exports = isEmpty;
	
	/**
	 * Has.
	 */
	
	var has = Object.prototype.hasOwnProperty;
	
	/**
	 * Test whether a value is "empty".
	 *
	 * @param {Mixed} val
	 * @return {Boolean}
	 */
	
	function isEmpty(val) {
	  if (null == val) return true;
	  if ('number' == typeof val) return 0 === val;
	  if (undefined !== val.length) return 0 === val.length;
	  for (var key in val) {
	    if (has.call(val, key)) return false;
	  }return true;
	}

/***/ },
/* 810 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var cssColors = __webpack_require__(730);
	
	module.exports = function isNamedCssColor(color) {
	  if (typeof color !== 'string') {
	    throw new TypeError('is-named-css-color expects a string');
	  }
	
	  var cssColorRegex = new RegExp('^' + cssColors().join('|') + '$', 'i');
	  return cssColorRegex.test(color);
	};

/***/ },
/* 811 */
/***/ function(module, exports) {

	/*!
	 * is-whitespace <https://github.com/jonschlinkert/is-whitespace>
	 *
	 * Copyright (c) 2014-2015, Jon Schlinkert.
	 * Licensed under the MIT License.
	 */
	
	'use strict';
	
	var cache;
	
	module.exports = function isWhitespace(str) {
	  return typeof str === 'string' && regex().test(str);
	};
	
	function regex() {
	  // ensure that runtime compilation only happens once
	  return cache || (cache = new RegExp('^[\\s\t\n\x0B\f\r \xA0\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF"]+$'));
	}

/***/ },
/* 812 */
/***/ function(module, exports) {

	'use strict';
	
	var toString = {}.toString;
	
	module.exports = Array.isArray || function (arr) {
	  return toString.call(arr) == '[object Array]';
	};

/***/ },
/* 813 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var camel2hyphen = __webpack_require__(920);
	
	var isDimension = function isDimension(feature) {
	  var re = /[height|width]$/;
	  return re.test(feature);
	};
	
	var obj2mq = function obj2mq(obj) {
	  var mq = '';
	  var features = Object.keys(obj);
	  features.forEach(function (feature, index) {
	    var value = obj[feature];
	    feature = camel2hyphen(feature);
	    // Add px to dimension features
	    if (isDimension(feature) && typeof value === 'number') {
	      value = value + 'px';
	    }
	    if (value === true) {
	      mq += feature;
	    } else if (value === false) {
	      mq += 'not ' + feature;
	    } else {
	      mq += '(' + feature + ': ' + value + ')';
	    }
	    if (index < features.length - 1) {
	      mq += ' and ';
	    }
	  });
	  return mq;
	};
	
	var json2mq = function json2mq(query) {
	  var mq = '';
	  if (typeof query === 'string') {
	    return query;
	  }
	  // Handling array of media queries
	  if (query instanceof Array) {
	    query.forEach(function (q, index) {
	      mq += obj2mq(q);
	      if (index < query.length - 1) {
	        mq += ', ';
	      }
	    });
	    return mq;
	  }
	  // Handling single media query
	  return obj2mq(query);
	};
	
	module.exports = json2mq;

/***/ },
/* 814 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = (typeof global === 'undefined' ? 'undefined' : _typeof(global)) == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = (typeof self === 'undefined' ? 'undefined' : _typeof(self)) == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	var now = function now() {
	  return root.Date.now();
	};
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        result = wait - timeSinceLastCall;
	
	    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
	  }
	
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	
	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	/**
	 * Creates a throttled function that only invokes `func` at most once per
	 * every `wait` milliseconds. The throttled function comes with a `cancel`
	 * method to cancel delayed `func` invocations and a `flush` method to
	 * immediately invoke them. Provide `options` to indicate whether `func`
	 * should be invoked on the leading and/or trailing edge of the `wait`
	 * timeout. The `func` is invoked with the last arguments provided to the
	 * throttled function. Subsequent calls to the throttled function return the
	 * result of the last `func` invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the throttled function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.throttle` and `_.debounce`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to throttle.
	 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=true]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new throttled function.
	 * @example
	 *
	 * // Avoid excessively updating the position while scrolling.
	 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	 *
	 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	 * jQuery(element).on('click', throttled);
	 *
	 * // Cancel the trailing throttled invocation.
	 * jQuery(window).on('popstate', throttled.cancel);
	 */
	function throttle(func, wait, options) {
	  var leading = true,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  if (isObject(options)) {
	    leading = 'leading' in options ? !!options.leading : leading;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	  return debounce(func, wait, {
	    'leading': leading,
	    'maxWait': wait,
	    'trailing': trailing
	  });
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return (typeof value === 'undefined' ? 'undefined' : _typeof(value)) == 'symbol' || isObjectLike(value) && objectToString.call(value) == symbolTag;
	}
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? other + '' : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
	}
	
	module.exports = throttle;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 815 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Secure random string generator with custom alphabet.
	 *
	 * Alphabet must contain 256 symbols or less. Otherwise, the generator
	 * will not be secure.
	 *
	 * @param {generator} random The random bytes generator.
	 * @param {string} alphabet Symbols to be used in new random string.
	 * @param {size} size The number of symbols in new random string.
	 *
	 * @return {string} Random string.
	 *
	 * @example
	 * const format = require('nanoid/format')
	 *
	 * function random (size) {
	 *   const result = []
	 *   for (let i = 0; i < size; i++) {
	 *     result.push(randomByte())
	 *   }
	 *   return result
	 * }
	 *
	 * format(random, "abcdef", 5) //=> "fbaef"
	 *
	 * @name format
	 * @function
	 */
	module.exports = function (random, alphabet, size) {
	  var mask = (2 << Math.log(alphabet.length - 1) / Math.LN2) - 1;
	  var step = Math.ceil(1.6 * mask * size / alphabet.length);
	  size = +size;
	
	  var id = '';
	  while (true) {
	    var bytes = random(step);
	    for (var i = 0; i < step; i++) {
	      var byte = bytes[i] & mask;
	      if (alphabet[byte]) {
	        id += alphabet[byte];
	        if (id.length === size) return id;
	      }
	    }
	  }
	};
	
	/**
	 * @callback generator
	 * @param {number} bytes The number of bytes to generate.
	 * @return {number[]} Random bytes.
	 */

/***/ },
/* 816 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/**!
	 * @fileOverview Kickass library to create and place poppers near their reference elements.
	 * @version 1.15.0
	 * @license
	 * Copyright (c) 2016 Federico Zivolo and contributors
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy
	 * of this software and associated documentation files (the "Software"), to deal
	 * in the Software without restriction, including without limitation the rights
	 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	 * copies of the Software, and to permit persons to whom the Software is
	 * furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all
	 * copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	 * SOFTWARE.
	 */
	(function (global, factory) {
	  ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? module.exports = factory() :  true ? !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : global.Popper = factory();
	})(undefined, function () {
	  'use strict';
	
	  var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';
	
	  var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
	  var timeoutDuration = 0;
	  for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
	    if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
	      timeoutDuration = 1;
	      break;
	    }
	  }
	
	  function microtaskDebounce(fn) {
	    var called = false;
	    return function () {
	      if (called) {
	        return;
	      }
	      called = true;
	      window.Promise.resolve().then(function () {
	        called = false;
	        fn();
	      });
	    };
	  }
	
	  function taskDebounce(fn) {
	    var scheduled = false;
	    return function () {
	      if (!scheduled) {
	        scheduled = true;
	        setTimeout(function () {
	          scheduled = false;
	          fn();
	        }, timeoutDuration);
	      }
	    };
	  }
	
	  var supportsMicroTasks = isBrowser && window.Promise;
	
	  /**
	  * Create a debounced version of a method, that's asynchronously deferred
	  * but called in the minimum time possible.
	  *
	  * @method
	  * @memberof Popper.Utils
	  * @argument {Function} fn
	  * @returns {Function}
	  */
	  var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;
	
	  /**
	   * Check if the given variable is a function
	   * @method
	   * @memberof Popper.Utils
	   * @argument {Any} functionToCheck - variable to check
	   * @returns {Boolean} answer to: is a function?
	   */
	  function isFunction(functionToCheck) {
	    var getType = {};
	    return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
	  }
	
	  /**
	   * Get CSS computed property of the given element
	   * @method
	   * @memberof Popper.Utils
	   * @argument {Eement} element
	   * @argument {String} property
	   */
	  function getStyleComputedProperty(element, property) {
	    if (element.nodeType !== 1) {
	      return [];
	    }
	    // NOTE: 1 DOM access here
	    var window = element.ownerDocument.defaultView;
	    var css = window.getComputedStyle(element, null);
	    return property ? css[property] : css;
	  }
	
	  /**
	   * Returns the parentNode or the host of the element
	   * @method
	   * @memberof Popper.Utils
	   * @argument {Element} element
	   * @returns {Element} parent
	   */
	  function getParentNode(element) {
	    if (element.nodeName === 'HTML') {
	      return element;
	    }
	    return element.parentNode || element.host;
	  }
	
	  /**
	   * Returns the scrolling parent of the given element
	   * @method
	   * @memberof Popper.Utils
	   * @argument {Element} element
	   * @returns {Element} scroll parent
	   */
	  function getScrollParent(element) {
	    // Return body, `getScroll` will take care to get the correct `scrollTop` from it
	    if (!element) {
	      return document.body;
	    }
	
	    switch (element.nodeName) {
	      case 'HTML':
	      case 'BODY':
	        return element.ownerDocument.body;
	      case '#document':
	        return element.body;
	    }
	
	    // Firefox want us to check `-x` and `-y` variations as well
	
	    var _getStyleComputedProp = getStyleComputedProperty(element),
	        overflow = _getStyleComputedProp.overflow,
	        overflowX = _getStyleComputedProp.overflowX,
	        overflowY = _getStyleComputedProp.overflowY;
	
	    if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
	      return element;
	    }
	
	    return getScrollParent(getParentNode(element));
	  }
	
	  var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
	  var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);
	
	  /**
	   * Determines if the browser is Internet Explorer
	   * @method
	   * @memberof Popper.Utils
	   * @param {Number} version to check
	   * @returns {Boolean} isIE
	   */
	  function isIE(version) {
	    if (version === 11) {
	      return isIE11;
	    }
	    if (version === 10) {
	      return isIE10;
	    }
	    return isIE11 || isIE10;
	  }
	
	  /**
	   * Returns the offset parent of the given element
	   * @method
	   * @memberof Popper.Utils
	   * @argument {Element} element
	   * @returns {Element} offset parent
	   */
	  function getOffsetParent(element) {
	    if (!element) {
	      return document.documentElement;
	    }
	
	    var noOffsetParent = isIE(10) ? document.body : null;
	
	    // NOTE: 1 DOM access here
	    var offsetParent = element.offsetParent || null;
	    // Skip hidden elements which don't have an offsetParent
	    while (offsetParent === noOffsetParent && element.nextElementSibling) {
	      offsetParent = (element = element.nextElementSibling).offsetParent;
	    }
	
	    var nodeName = offsetParent && offsetParent.nodeName;
	
	    if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
	      return element ? element.ownerDocument.documentElement : document.documentElement;
	    }
	
	    // .offsetParent will return the closest TH, TD or TABLE in case
	    // no offsetParent is present, I hate this job...
	    if (['TH', 'TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
	      return getOffsetParent(offsetParent);
	    }
	
	    return offsetParent;
	  }
	
	  function isOffsetContainer(element) {
	    var nodeName = element.nodeName;
	
	    if (nodeName === 'BODY') {
	      return false;
	    }
	    return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
	  }
	
	  /**
	   * Finds the root node (document, shadowDOM root) of the given element
	   * @method
	   * @memberof Popper.Utils
	   * @argument {Element} node
	   * @returns {Element} root node
	   */
	  function getRoot(node) {
	    if (node.parentNode !== null) {
	      return getRoot(node.parentNode);
	    }
	
	    return node;
	  }
	
	  /**
	   * Finds the offset parent common to the two provided nodes
	   * @method
	   * @memberof Popper.Utils
	   * @argument {Element} element1
	   * @argument {Element} element2
	   * @returns {Element} common offset parent
	   */
	  function findCommonOffsetParent(element1, element2) {
	    // This check is needed to avoid errors in case one of the elements isn't defined for any reason
	    if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
	      return document.documentElement;
	    }
	
	    // Here we make sure to give as "start" the element that comes first in the DOM
	    var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
	    var start = order ? element1 : element2;
	    var end = order ? element2 : element1;
	
	    // Get common ancestor container
	    var range = document.createRange();
	    range.setStart(start, 0);
	    range.setEnd(end, 0);
	    var commonAncestorContainer = range.commonAncestorContainer;
	
	    // Both nodes are inside #document
	
	    if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
	      if (isOffsetContainer(commonAncestorContainer)) {
	        return commonAncestorContainer;
	      }
	
	      return getOffsetParent(commonAncestorContainer);
	    }
	
	    // one of the nodes is inside shadowDOM, find which one
	    var element1root = getRoot(element1);
	    if (element1root.host) {
	      return findCommonOffsetParent(element1root.host, element2);
	    } else {
	      return findCommonOffsetParent(element1, getRoot(element2).host);
	    }
	  }
	
	  /**
	   * Gets the scroll value of the given element in the given side (top and left)
	   * @method
	   * @memberof Popper.Utils
	   * @argument {Element} element
	   * @argument {String} side `top` or `left`
	   * @returns {number} amount of scrolled pixels
	   */
	  function getScroll(element) {
	    var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';
	
	    var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
	    var nodeName = element.nodeName;
	
	    if (nodeName === 'BODY' || nodeName === 'HTML') {
	      var html = element.ownerDocument.documentElement;
	      var scrollingElement = element.ownerDocument.scrollingElement || html;
	      return scrollingElement[upperSide];
	    }
	
	    return element[upperSide];
	  }
	
	  /*
	   * Sum or subtract the element scroll values (left and top) from a given rect object
	   * @method
	   * @memberof Popper.Utils
	   * @param {Object} rect - Rect object you want to change
	   * @param {HTMLElement} element - The element from the function reads the scroll values
	   * @param {Boolean} subtract - set to true if you want to subtract the scroll values
	   * @return {Object} rect - The modifier rect object
	   */
	  function includeScroll(rect, element) {
	    var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	    var scrollTop = getScroll(element, 'top');
	    var scrollLeft = getScroll(element, 'left');
	    var modifier = subtract ? -1 : 1;
	    rect.top += scrollTop * modifier;
	    rect.bottom += scrollTop * modifier;
	    rect.left += scrollLeft * modifier;
	    rect.right += scrollLeft * modifier;
	    return rect;
	  }
	
	  /*
	   * Helper to detect borders of a given element
	   * @method
	   * @memberof Popper.Utils
	   * @param {CSSStyleDeclaration} styles
	   * Result of `getStyleComputedProperty` on the given element
	   * @param {String} axis - `x` or `y`
	   * @return {number} borders - The borders size of the given axis
	   */
	
	  function getBordersSize(styles, axis) {
	    var sideA = axis === 'x' ? 'Left' : 'Top';
	    var sideB = sideA === 'Left' ? 'Right' : 'Bottom';
	
	    return parseFloat(styles['border' + sideA + 'Width'], 10) + parseFloat(styles['border' + sideB + 'Width'], 10);
	  }
	
	  function getSize(axis, body, html, computedStyle) {
	    return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
	  }
	
	  function getWindowSizes(document) {
	    var body = document.body;
	    var html = document.documentElement;
	    var computedStyle = isIE(10) && getComputedStyle(html);
	
	    return {
	      height: getSize('Height', body, html, computedStyle),
	      width: getSize('Width', body, html, computedStyle)
	    };
	  }
	
	  var classCallCheck = function classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  };
	
	  var createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  var defineProperty = function defineProperty(obj, key, value) {
	    if (key in obj) {
	      Object.defineProperty(obj, key, {
	        value: value,
	        enumerable: true,
	        configurable: true,
	        writable: true
	      });
	    } else {
	      obj[key] = value;
	    }
	
	    return obj;
	  };
	
	  var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  /**
	   * Given element offsets, generate an output similar to getBoundingClientRect
	   * @method
	   * @memberof Popper.Utils
	   * @argument {Object} offsets
	   * @returns {Object} ClientRect like output
	   */
	  function getClientRect(offsets) {
	    return _extends({}, offsets, {
	      right: offsets.left + offsets.width,
	      bottom: offsets.top + offsets.height
	    });
	  }
	
	  /**
	   * Get bounding client rect of given element
	   * @method
	   * @memberof Popper.Utils
	   * @param {HTMLElement} element
	   * @return {Object} client rect
	   */
	  function getBoundingClientRect(element) {
	    var rect = {};
	
	    // IE10 10 FIX: Please, don't ask, the element isn't
	    // considered in DOM in some circumstances...
	    // This isn't reproducible in IE10 compatibility mode of IE11
	    try {
	      if (isIE(10)) {
	        rect = element.getBoundingClientRect();
	        var scrollTop = getScroll(element, 'top');
	        var scrollLeft = getScroll(element, 'left');
	        rect.top += scrollTop;
	        rect.left += scrollLeft;
	        rect.bottom += scrollTop;
	        rect.right += scrollLeft;
	      } else {
	        rect = element.getBoundingClientRect();
	      }
	    } catch (e) {}
	
	    var result = {
	      left: rect.left,
	      top: rect.top,
	      width: rect.right - rect.left,
	      height: rect.bottom - rect.top
	    };
	
	    // subtract scrollbar size from sizes
	    var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
	    var width = sizes.width || element.clientWidth || result.right - result.left;
	    var height = sizes.height || element.clientHeight || result.bottom - result.top;
	
	    var horizScrollbar = element.offsetWidth - width;
	    var vertScrollbar = element.offsetHeight - height;
	
	    // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
	    // we make this check conditional for performance reasons
	    if (horizScrollbar || vertScrollbar) {
	      var styles = getStyleComputedProperty(element);
	      horizScrollbar -= getBordersSize(styles, 'x');
	      vertScrollbar -= getBordersSize(styles, 'y');
	
	      result.width -= horizScrollbar;
	      result.height -= vertScrollbar;
	    }
	
	    return getClientRect(result);
	  }
	
	  function getOffsetRectRelativeToArbitraryNode(children, parent) {
	    var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	    var isIE10 = isIE(10);
	    var isHTML = parent.nodeName === 'HTML';
	    var childrenRect = getBoundingClientRect(children);
	    var parentRect = getBoundingClientRect(parent);
	    var scrollParent = getScrollParent(children);
	
	    var styles = getStyleComputedProperty(parent);
	    var borderTopWidth = parseFloat(styles.borderTopWidth, 10);
	    var borderLeftWidth = parseFloat(styles.borderLeftWidth, 10);
	
	    // In cases where the parent is fixed, we must ignore negative scroll in offset calc
	    if (fixedPosition && isHTML) {
	      parentRect.top = Math.max(parentRect.top, 0);
	      parentRect.left = Math.max(parentRect.left, 0);
	    }
	    var offsets = getClientRect({
	      top: childrenRect.top - parentRect.top - borderTopWidth,
	      left: childrenRect.left - parentRect.left - borderLeftWidth,
	      width: childrenRect.width,
	      height: childrenRect.height
	    });
	    offsets.marginTop = 0;
	    offsets.marginLeft = 0;
	
	    // Subtract margins of documentElement in case it's being used as parent
	    // we do this only on HTML because it's the only element that behaves
	    // differently when margins are applied to it. The margins are included in
	    // the box of the documentElement, in the other cases not.
	    if (!isIE10 && isHTML) {
	      var marginTop = parseFloat(styles.marginTop, 10);
	      var marginLeft = parseFloat(styles.marginLeft, 10);
	
	      offsets.top -= borderTopWidth - marginTop;
	      offsets.bottom -= borderTopWidth - marginTop;
	      offsets.left -= borderLeftWidth - marginLeft;
	      offsets.right -= borderLeftWidth - marginLeft;
	
	      // Attach marginTop and marginLeft because in some circumstances we may need them
	      offsets.marginTop = marginTop;
	      offsets.marginLeft = marginLeft;
	    }
	
	    if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
	      offsets = includeScroll(offsets, parent);
	    }
	
	    return offsets;
	  }
	
	  function getViewportOffsetRectRelativeToArtbitraryNode(element) {
	    var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	    var html = element.ownerDocument.documentElement;
	    var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
	    var width = Math.max(html.clientWidth, window.innerWidth || 0);
	    var height = Math.max(html.clientHeight, window.innerHeight || 0);
	
	    var scrollTop = !excludeScroll ? getScroll(html) : 0;
	    var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;
	
	    var offset = {
	      top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
	      left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
	      width: width,
	      height: height
	    };
	
	    return getClientRect(offset);
	  }
	
	  /**
	   * Check if the given element is fixed or is inside a fixed parent
	   * @method
	   * @memberof Popper.Utils
	   * @argument {Element} element
	   * @argument {Element} customContainer
	   * @returns {Boolean} answer to "isFixed?"
	   */
	  function isFixed(element) {
	    var nodeName = element.nodeName;
	    if (nodeName === 'BODY' || nodeName === 'HTML') {
	      return false;
	    }
	    if (getStyleComputedProperty(element, 'position') === 'fixed') {
	      return true;
	    }
	    var parentNode = getParentNode(element);
	    if (!parentNode) {
	      return false;
	    }
	    return isFixed(parentNode);
	  }
	
	  /**
	   * Finds the first parent of an element that has a transformed property defined
	   * @method
	   * @memberof Popper.Utils
	   * @argument {Element} element
	   * @returns {Element} first transformed parent or documentElement
	   */
	
	  function getFixedPositionOffsetParent(element) {
	    // This check is needed to avoid errors in case one of the elements isn't defined for any reason
	    if (!element || !element.parentElement || isIE()) {
	      return document.documentElement;
	    }
	    var el = element.parentElement;
	    while (el && getStyleComputedProperty(el, 'transform') === 'none') {
	      el = el.parentElement;
	    }
	    return el || document.documentElement;
	  }
	
	  /**
	   * Computed the boundaries limits and return them
	   * @method
	   * @memberof Popper.Utils
	   * @param {HTMLElement} popper
	   * @param {HTMLElement} reference
	   * @param {number} padding
	   * @param {HTMLElement} boundariesElement - Element used to define the boundaries
	   * @param {Boolean} fixedPosition - Is in fixed position mode
	   * @returns {Object} Coordinates of the boundaries
	   */
	  function getBoundaries(popper, reference, padding, boundariesElement) {
	    var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
	
	    // NOTE: 1 DOM access here
	
	    var boundaries = { top: 0, left: 0 };
	    var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, reference);
	
	    // Handle viewport case
	    if (boundariesElement === 'viewport') {
	      boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
	    } else {
	      // Handle other cases based on DOM element used as boundaries
	      var boundariesNode = void 0;
	      if (boundariesElement === 'scrollParent') {
	        boundariesNode = getScrollParent(getParentNode(reference));
	        if (boundariesNode.nodeName === 'BODY') {
	          boundariesNode = popper.ownerDocument.documentElement;
	        }
	      } else if (boundariesElement === 'window') {
	        boundariesNode = popper.ownerDocument.documentElement;
	      } else {
	        boundariesNode = boundariesElement;
	      }
	
	      var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);
	
	      // In case of HTML, we need a different computation
	      if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
	        var _getWindowSizes = getWindowSizes(popper.ownerDocument),
	            height = _getWindowSizes.height,
	            width = _getWindowSizes.width;
	
	        boundaries.top += offsets.top - offsets.marginTop;
	        boundaries.bottom = height + offsets.top;
	        boundaries.left += offsets.left - offsets.marginLeft;
	        boundaries.right = width + offsets.left;
	      } else {
	        // for all the other DOM elements, this one is good
	        boundaries = offsets;
	      }
	    }
	
	    // Add paddings
	    padding = padding || 0;
	    var isPaddingNumber = typeof padding === 'number';
	    boundaries.left += isPaddingNumber ? padding : padding.left || 0;
	    boundaries.top += isPaddingNumber ? padding : padding.top || 0;
	    boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
	    boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;
	
	    return boundaries;
	  }
	
	  function getArea(_ref) {
	    var width = _ref.width,
	        height = _ref.height;
	
	    return width * height;
	  }
	
	  /**
	   * Utility used to transform the `auto` placement to the placement with more
	   * available space.
	   * @method
	   * @memberof Popper.Utils
	   * @argument {Object} data - The data object generated by update method
	   * @argument {Object} options - Modifiers configuration and options
	   * @returns {Object} The data object, properly modified
	   */
	  function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
	    var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
	
	    if (placement.indexOf('auto') === -1) {
	      return placement;
	    }
	
	    var boundaries = getBoundaries(popper, reference, padding, boundariesElement);
	
	    var rects = {
	      top: {
	        width: boundaries.width,
	        height: refRect.top - boundaries.top
	      },
	      right: {
	        width: boundaries.right - refRect.right,
	        height: boundaries.height
	      },
	      bottom: {
	        width: boundaries.width,
	        height: boundaries.bottom - refRect.bottom
	      },
	      left: {
	        width: refRect.left - boundaries.left,
	        height: boundaries.height
	      }
	    };
	
	    var sortedAreas = Object.keys(rects).map(function (key) {
	      return _extends({
	        key: key
	      }, rects[key], {
	        area: getArea(rects[key])
	      });
	    }).sort(function (a, b) {
	      return b.area - a.area;
	    });
	
	    var filteredAreas = sortedAreas.filter(function (_ref2) {
	      var width = _ref2.width,
	          height = _ref2.height;
	      return width >= popper.clientWidth && height >= popper.clientHeight;
	    });
	
	    var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;
	
	    var variation = placement.split('-')[1];
	
	    return computedPlacement + (variation ? '-' + variation : '');
	  }
	
	  /**
	   * Get offsets to the reference element
	   * @method
	   * @memberof Popper.Utils
	   * @param {Object} state
	   * @param {Element} popper - the popper element
	   * @param {Element} reference - the reference element (the popper will be relative to this)
	   * @param {Element} fixedPosition - is in fixed position mode
	   * @returns {Object} An object containing the offsets which will be applied to the popper
	   */
	  function getReferenceOffsets(state, popper, reference) {
	    var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
	
	    var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, reference);
	    return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
	  }
	
	  /**
	   * Get the outer sizes of the given element (offset size + margins)
	   * @method
	   * @memberof Popper.Utils
	   * @argument {Element} element
	   * @returns {Object} object containing width and height properties
	   */
	  function getOuterSizes(element) {
	    var window = element.ownerDocument.defaultView;
	    var styles = window.getComputedStyle(element);
	    var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
	    var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
	    var result = {
	      width: element.offsetWidth + y,
	      height: element.offsetHeight + x
	    };
	    return result;
	  }
	
	  /**
	   * Get the opposite placement of the given one
	   * @method
	   * @memberof Popper.Utils
	   * @argument {String} placement
	   * @returns {String} flipped placement
	   */
	  function getOppositePlacement(placement) {
	    var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
	    return placement.replace(/left|right|bottom|top/g, function (matched) {
	      return hash[matched];
	    });
	  }
	
	  /**
	   * Get offsets to the popper
	   * @method
	   * @memberof Popper.Utils
	   * @param {Object} position - CSS position the Popper will get applied
	   * @param {HTMLElement} popper - the popper element
	   * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
	   * @param {String} placement - one of the valid placement options
	   * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
	   */
	  function getPopperOffsets(popper, referenceOffsets, placement) {
	    placement = placement.split('-')[0];
	
	    // Get popper node sizes
	    var popperRect = getOuterSizes(popper);
	
	    // Add position, width and height to our offsets object
	    var popperOffsets = {
	      width: popperRect.width,
	      height: popperRect.height
	    };
	
	    // depending by the popper placement we have to compute its offsets slightly differently
	    var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
	    var mainSide = isHoriz ? 'top' : 'left';
	    var secondarySide = isHoriz ? 'left' : 'top';
	    var measurement = isHoriz ? 'height' : 'width';
	    var secondaryMeasurement = !isHoriz ? 'height' : 'width';
	
	    popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
	    if (placement === secondarySide) {
	      popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
	    } else {
	      popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
	    }
	
	    return popperOffsets;
	  }
	
	  /**
	   * Mimics the `find` method of Array
	   * @method
	   * @memberof Popper.Utils
	   * @argument {Array} arr
	   * @argument prop
	   * @argument value
	   * @returns index or -1
	   */
	  function find(arr, check) {
	    // use native find if supported
	    if (Array.prototype.find) {
	      return arr.find(check);
	    }
	
	    // use `filter` to obtain the same behavior of `find`
	    return arr.filter(check)[0];
	  }
	
	  /**
	   * Return the index of the matching object
	   * @method
	   * @memberof Popper.Utils
	   * @argument {Array} arr
	   * @argument prop
	   * @argument value
	   * @returns index or -1
	   */
	  function findIndex(arr, prop, value) {
	    // use native findIndex if supported
	    if (Array.prototype.findIndex) {
	      return arr.findIndex(function (cur) {
	        return cur[prop] === value;
	      });
	    }
	
	    // use `find` + `indexOf` if `findIndex` isn't supported
	    var match = find(arr, function (obj) {
	      return obj[prop] === value;
	    });
	    return arr.indexOf(match);
	  }
	
	  /**
	   * Loop trough the list of modifiers and run them in order,
	   * each of them will then edit the data object.
	   * @method
	   * @memberof Popper.Utils
	   * @param {dataObject} data
	   * @param {Array} modifiers
	   * @param {String} ends - Optional modifier name used as stopper
	   * @returns {dataObject}
	   */
	  function runModifiers(modifiers, data, ends) {
	    var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));
	
	    modifiersToRun.forEach(function (modifier) {
	      if (modifier['function']) {
	        // eslint-disable-line dot-notation
	        console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
	      }
	      var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
	      if (modifier.enabled && isFunction(fn)) {
	        // Add properties to offsets to make them a complete clientRect object
	        // we do this before each modifier to make sure the previous one doesn't
	        // mess with these values
	        data.offsets.popper = getClientRect(data.offsets.popper);
	        data.offsets.reference = getClientRect(data.offsets.reference);
	
	        data = fn(data, modifier);
	      }
	    });
	
	    return data;
	  }
	
	  /**
	   * Updates the position of the popper, computing the new offsets and applying
	   * the new style.<br />
	   * Prefer `scheduleUpdate` over `update` because of performance reasons.
	   * @method
	   * @memberof Popper
	   */
	  function update() {
	    // if popper is destroyed, don't perform any further update
	    if (this.state.isDestroyed) {
	      return;
	    }
	
	    var data = {
	      instance: this,
	      styles: {},
	      arrowStyles: {},
	      attributes: {},
	      flipped: false,
	      offsets: {}
	    };
	
	    // compute reference element offsets
	    data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);
	
	    // compute auto placement, store placement inside the data object,
	    // modifiers will be able to edit `placement` if needed
	    // and refer to originalPlacement to know the original value
	    data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);
	
	    // store the computed placement inside `originalPlacement`
	    data.originalPlacement = data.placement;
	
	    data.positionFixed = this.options.positionFixed;
	
	    // compute the popper offsets
	    data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);
	
	    data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';
	
	    // run the modifiers
	    data = runModifiers(this.modifiers, data);
	
	    // the first `update` will call `onCreate` callback
	    // the other ones will call `onUpdate` callback
	    if (!this.state.isCreated) {
	      this.state.isCreated = true;
	      this.options.onCreate(data);
	    } else {
	      this.options.onUpdate(data);
	    }
	  }
	
	  /**
	   * Helper used to know if the given modifier is enabled.
	   * @method
	   * @memberof Popper.Utils
	   * @returns {Boolean}
	   */
	  function isModifierEnabled(modifiers, modifierName) {
	    return modifiers.some(function (_ref) {
	      var name = _ref.name,
	          enabled = _ref.enabled;
	      return enabled && name === modifierName;
	    });
	  }
	
	  /**
	   * Get the prefixed supported property name
	   * @method
	   * @memberof Popper.Utils
	   * @argument {String} property (camelCase)
	   * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
	   */
	  function getSupportedPropertyName(property) {
	    var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
	    var upperProp = property.charAt(0).toUpperCase() + property.slice(1);
	
	    for (var i = 0; i < prefixes.length; i++) {
	      var prefix = prefixes[i];
	      var toCheck = prefix ? '' + prefix + upperProp : property;
	      if (typeof document.body.style[toCheck] !== 'undefined') {
	        return toCheck;
	      }
	    }
	    return null;
	  }
	
	  /**
	   * Destroys the popper.
	   * @method
	   * @memberof Popper
	   */
	  function destroy() {
	    this.state.isDestroyed = true;
	
	    // touch DOM only if `applyStyle` modifier is enabled
	    if (isModifierEnabled(this.modifiers, 'applyStyle')) {
	      this.popper.removeAttribute('x-placement');
	      this.popper.style.position = '';
	      this.popper.style.top = '';
	      this.popper.style.left = '';
	      this.popper.style.right = '';
	      this.popper.style.bottom = '';
	      this.popper.style.willChange = '';
	      this.popper.style[getSupportedPropertyName('transform')] = '';
	    }
	
	    this.disableEventListeners();
	
	    // remove the popper if user explicity asked for the deletion on destroy
	    // do not use `remove` because IE11 doesn't support it
	    if (this.options.removeOnDestroy) {
	      this.popper.parentNode.removeChild(this.popper);
	    }
	    return this;
	  }
	
	  /**
	   * Get the window associated with the element
	   * @argument {Element} element
	   * @returns {Window}
	   */
	  function getWindow(element) {
	    var ownerDocument = element.ownerDocument;
	    return ownerDocument ? ownerDocument.defaultView : window;
	  }
	
	  function attachToScrollParents(scrollParent, event, callback, scrollParents) {
	    var isBody = scrollParent.nodeName === 'BODY';
	    var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
	    target.addEventListener(event, callback, { passive: true });
	
	    if (!isBody) {
	      attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
	    }
	    scrollParents.push(target);
	  }
	
	  /**
	   * Setup needed event listeners used to update the popper position
	   * @method
	   * @memberof Popper.Utils
	   * @private
	   */
	  function setupEventListeners(reference, options, state, updateBound) {
	    // Resize event listener on window
	    state.updateBound = updateBound;
	    getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });
	
	    // Scroll event listener on scroll parents
	    var scrollElement = getScrollParent(reference);
	    attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
	    state.scrollElement = scrollElement;
	    state.eventsEnabled = true;
	
	    return state;
	  }
	
	  /**
	   * It will add resize/scroll events and start recalculating
	   * position of the popper element when they are triggered.
	   * @method
	   * @memberof Popper
	   */
	  function enableEventListeners() {
	    if (!this.state.eventsEnabled) {
	      this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
	    }
	  }
	
	  /**
	   * Remove event listeners used to update the popper position
	   * @method
	   * @memberof Popper.Utils
	   * @private
	   */
	  function removeEventListeners(reference, state) {
	    // Remove resize event listener on window
	    getWindow(reference).removeEventListener('resize', state.updateBound);
	
	    // Remove scroll event listener on scroll parents
	    state.scrollParents.forEach(function (target) {
	      target.removeEventListener('scroll', state.updateBound);
	    });
	
	    // Reset state
	    state.updateBound = null;
	    state.scrollParents = [];
	    state.scrollElement = null;
	    state.eventsEnabled = false;
	    return state;
	  }
	
	  /**
	   * It will remove resize/scroll events and won't recalculate popper position
	   * when they are triggered. It also won't trigger `onUpdate` callback anymore,
	   * unless you call `update` method manually.
	   * @method
	   * @memberof Popper
	   */
	  function disableEventListeners() {
	    if (this.state.eventsEnabled) {
	      cancelAnimationFrame(this.scheduleUpdate);
	      this.state = removeEventListeners(this.reference, this.state);
	    }
	  }
	
	  /**
	   * Tells if a given input is a number
	   * @method
	   * @memberof Popper.Utils
	   * @param {*} input to check
	   * @return {Boolean}
	   */
	  function isNumeric(n) {
	    return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
	  }
	
	  /**
	   * Set the style to the given popper
	   * @method
	   * @memberof Popper.Utils
	   * @argument {Element} element - Element to apply the style to
	   * @argument {Object} styles
	   * Object with a list of properties and values which will be applied to the element
	   */
	  function setStyles(element, styles) {
	    Object.keys(styles).forEach(function (prop) {
	      var unit = '';
	      // add unit if the value is numeric and is one of the following
	      if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
	        unit = 'px';
	      }
	      element.style[prop] = styles[prop] + unit;
	    });
	  }
	
	  /**
	   * Set the attributes to the given popper
	   * @method
	   * @memberof Popper.Utils
	   * @argument {Element} element - Element to apply the attributes to
	   * @argument {Object} styles
	   * Object with a list of properties and values which will be applied to the element
	   */
	  function setAttributes(element, attributes) {
	    Object.keys(attributes).forEach(function (prop) {
	      var value = attributes[prop];
	      if (value !== false) {
	        element.setAttribute(prop, attributes[prop]);
	      } else {
	        element.removeAttribute(prop);
	      }
	    });
	  }
	
	  /**
	   * @function
	   * @memberof Modifiers
	   * @argument {Object} data - The data object generated by `update` method
	   * @argument {Object} data.styles - List of style properties - values to apply to popper element
	   * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
	   * @argument {Object} options - Modifiers configuration and options
	   * @returns {Object} The same data object
	   */
	  function applyStyle(data) {
	    // any property present in `data.styles` will be applied to the popper,
	    // in this way we can make the 3rd party modifiers add custom styles to it
	    // Be aware, modifiers could override the properties defined in the previous
	    // lines of this modifier!
	    setStyles(data.instance.popper, data.styles);
	
	    // any property present in `data.attributes` will be applied to the popper,
	    // they will be set as HTML attributes of the element
	    setAttributes(data.instance.popper, data.attributes);
	
	    // if arrowElement is defined and arrowStyles has some properties
	    if (data.arrowElement && Object.keys(data.arrowStyles).length) {
	      setStyles(data.arrowElement, data.arrowStyles);
	    }
	
	    return data;
	  }
	
	  /**
	   * Set the x-placement attribute before everything else because it could be used
	   * to add margins to the popper margins needs to be calculated to get the
	   * correct popper offsets.
	   * @method
	   * @memberof Popper.modifiers
	   * @param {HTMLElement} reference - The reference element used to position the popper
	   * @param {HTMLElement} popper - The HTML element used as popper
	   * @param {Object} options - Popper.js options
	   */
	  function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
	    // compute reference element offsets
	    var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);
	
	    // compute auto placement, store placement inside the data object,
	    // modifiers will be able to edit `placement` if needed
	    // and refer to originalPlacement to know the original value
	    var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);
	
	    popper.setAttribute('x-placement', placement);
	
	    // Apply `position` to popper before anything else because
	    // without the position applied we can't guarantee correct computations
	    setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });
	
	    return options;
	  }
	
	  /**
	   * @function
	   * @memberof Popper.Utils
	   * @argument {Object} data - The data object generated by `update` method
	   * @argument {Boolean} shouldRound - If the offsets should be rounded at all
	   * @returns {Object} The popper's position offsets rounded
	   *
	   * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
	   * good as it can be within reason.
	   * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
	   *
	   * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
	   * as well on High DPI screens).
	   *
	   * Firefox prefers no rounding for positioning and does not have blurriness on
	   * high DPI screens.
	   *
	   * Only horizontal placement and left/right values need to be considered.
	   */
	  function getRoundedOffsets(data, shouldRound) {
	    var _data$offsets = data.offsets,
	        popper = _data$offsets.popper,
	        reference = _data$offsets.reference;
	    var round = Math.round,
	        floor = Math.floor;
	
	    var noRound = function noRound(v) {
	      return v;
	    };
	
	    var referenceWidth = round(reference.width);
	    var popperWidth = round(popper.width);
	
	    var isVertical = ['left', 'right'].indexOf(data.placement) !== -1;
	    var isVariation = data.placement.indexOf('-') !== -1;
	    var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
	    var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;
	
	    var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
	    var verticalToInteger = !shouldRound ? noRound : round;
	
	    return {
	      left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
	      top: verticalToInteger(popper.top),
	      bottom: verticalToInteger(popper.bottom),
	      right: horizontalToInteger(popper.right)
	    };
	  }
	
	  var isFirefox = isBrowser && /Firefox/i.test(navigator.userAgent);
	
	  /**
	   * @function
	   * @memberof Modifiers
	   * @argument {Object} data - The data object generated by `update` method
	   * @argument {Object} options - Modifiers configuration and options
	   * @returns {Object} The data object, properly modified
	   */
	  function computeStyle(data, options) {
	    var x = options.x,
	        y = options.y;
	    var popper = data.offsets.popper;
	
	    // Remove this legacy support in Popper.js v2
	
	    var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
	      return modifier.name === 'applyStyle';
	    }).gpuAcceleration;
	    if (legacyGpuAccelerationOption !== undefined) {
	      console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
	    }
	    var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;
	
	    var offsetParent = getOffsetParent(data.instance.popper);
	    var offsetParentRect = getBoundingClientRect(offsetParent);
	
	    // Styles
	    var styles = {
	      position: popper.position
	    };
	
	    var offsets = getRoundedOffsets(data, window.devicePixelRatio < 2 || !isFirefox);
	
	    var sideA = x === 'bottom' ? 'top' : 'bottom';
	    var sideB = y === 'right' ? 'left' : 'right';
	
	    // if gpuAcceleration is set to `true` and transform is supported,
	    //  we use `translate3d` to apply the position to the popper we
	    // automatically use the supported prefixed version if needed
	    var prefixedProperty = getSupportedPropertyName('transform');
	
	    // now, let's make a step back and look at this code closely (wtf?)
	    // If the content of the popper grows once it's been positioned, it
	    // may happen that the popper gets misplaced because of the new content
	    // overflowing its reference element
	    // To avoid this problem, we provide two options (x and y), which allow
	    // the consumer to define the offset origin.
	    // If we position a popper on top of a reference element, we can set
	    // `x` to `top` to make the popper grow towards its top instead of
	    // its bottom.
	    var left = void 0,
	        top = void 0;
	    if (sideA === 'bottom') {
	      // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
	      // and not the bottom of the html element
	      if (offsetParent.nodeName === 'HTML') {
	        top = -offsetParent.clientHeight + offsets.bottom;
	      } else {
	        top = -offsetParentRect.height + offsets.bottom;
	      }
	    } else {
	      top = offsets.top;
	    }
	    if (sideB === 'right') {
	      if (offsetParent.nodeName === 'HTML') {
	        left = -offsetParent.clientWidth + offsets.right;
	      } else {
	        left = -offsetParentRect.width + offsets.right;
	      }
	    } else {
	      left = offsets.left;
	    }
	    if (gpuAcceleration && prefixedProperty) {
	      styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
	      styles[sideA] = 0;
	      styles[sideB] = 0;
	      styles.willChange = 'transform';
	    } else {
	      // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
	      var invertTop = sideA === 'bottom' ? -1 : 1;
	      var invertLeft = sideB === 'right' ? -1 : 1;
	      styles[sideA] = top * invertTop;
	      styles[sideB] = left * invertLeft;
	      styles.willChange = sideA + ', ' + sideB;
	    }
	
	    // Attributes
	    var attributes = {
	      'x-placement': data.placement
	    };
	
	    // Update `data` attributes, styles and arrowStyles
	    data.attributes = _extends({}, attributes, data.attributes);
	    data.styles = _extends({}, styles, data.styles);
	    data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);
	
	    return data;
	  }
	
	  /**
	   * Helper used to know if the given modifier depends from another one.<br />
	   * It checks if the needed modifier is listed and enabled.
	   * @method
	   * @memberof Popper.Utils
	   * @param {Array} modifiers - list of modifiers
	   * @param {String} requestingName - name of requesting modifier
	   * @param {String} requestedName - name of requested modifier
	   * @returns {Boolean}
	   */
	  function isModifierRequired(modifiers, requestingName, requestedName) {
	    var requesting = find(modifiers, function (_ref) {
	      var name = _ref.name;
	      return name === requestingName;
	    });
	
	    var isRequired = !!requesting && modifiers.some(function (modifier) {
	      return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
	    });
	
	    if (!isRequired) {
	      var _requesting = '`' + requestingName + '`';
	      var requested = '`' + requestedName + '`';
	      console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
	    }
	    return isRequired;
	  }
	
	  /**
	   * @function
	   * @memberof Modifiers
	   * @argument {Object} data - The data object generated by update method
	   * @argument {Object} options - Modifiers configuration and options
	   * @returns {Object} The data object, properly modified
	   */
	  function arrow(data, options) {
	    var _data$offsets$arrow;
	
	    // arrow depends on keepTogether in order to work
	    if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
	      return data;
	    }
	
	    var arrowElement = options.element;
	
	    // if arrowElement is a string, suppose it's a CSS selector
	    if (typeof arrowElement === 'string') {
	      arrowElement = data.instance.popper.querySelector(arrowElement);
	
	      // if arrowElement is not found, don't run the modifier
	      if (!arrowElement) {
	        return data;
	      }
	    } else {
	      // if the arrowElement isn't a query selector we must check that the
	      // provided DOM node is child of its popper node
	      if (!data.instance.popper.contains(arrowElement)) {
	        console.warn('WARNING: `arrow.element` must be child of its popper element!');
	        return data;
	      }
	    }
	
	    var placement = data.placement.split('-')[0];
	    var _data$offsets = data.offsets,
	        popper = _data$offsets.popper,
	        reference = _data$offsets.reference;
	
	    var isVertical = ['left', 'right'].indexOf(placement) !== -1;
	
	    var len = isVertical ? 'height' : 'width';
	    var sideCapitalized = isVertical ? 'Top' : 'Left';
	    var side = sideCapitalized.toLowerCase();
	    var altSide = isVertical ? 'left' : 'top';
	    var opSide = isVertical ? 'bottom' : 'right';
	    var arrowElementSize = getOuterSizes(arrowElement)[len];
	
	    //
	    // extends keepTogether behavior making sure the popper and its
	    // reference have enough pixels in conjunction
	    //
	
	    // top/left side
	    if (reference[opSide] - arrowElementSize < popper[side]) {
	      data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
	    }
	    // bottom/right side
	    if (reference[side] + arrowElementSize > popper[opSide]) {
	      data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
	    }
	    data.offsets.popper = getClientRect(data.offsets.popper);
	
	    // compute center of the popper
	    var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;
	
	    // Compute the sideValue using the updated popper offsets
	    // take popper margin in account because we don't have this info available
	    var css = getStyleComputedProperty(data.instance.popper);
	    var popperMarginSide = parseFloat(css['margin' + sideCapitalized], 10);
	    var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width'], 10);
	    var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;
	
	    // prevent arrowElement from being placed not contiguously to its popper
	    sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);
	
	    data.arrowElement = arrowElement;
	    data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);
	
	    return data;
	  }
	
	  /**
	   * Get the opposite placement variation of the given one
	   * @method
	   * @memberof Popper.Utils
	   * @argument {String} placement variation
	   * @returns {String} flipped placement variation
	   */
	  function getOppositeVariation(variation) {
	    if (variation === 'end') {
	      return 'start';
	    } else if (variation === 'start') {
	      return 'end';
	    }
	    return variation;
	  }
	
	  /**
	   * List of accepted placements to use as values of the `placement` option.<br />
	   * Valid placements are:
	   * - `auto`
	   * - `top`
	   * - `right`
	   * - `bottom`
	   * - `left`
	   *
	   * Each placement can have a variation from this list:
	   * - `-start`
	   * - `-end`
	   *
	   * Variations are interpreted easily if you think of them as the left to right
	   * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
	   * is right.<br />
	   * Vertically (`left` and `right`), `start` is top and `end` is bottom.
	   *
	   * Some valid examples are:
	   * - `top-end` (on top of reference, right aligned)
	   * - `right-start` (on right of reference, top aligned)
	   * - `bottom` (on bottom, centered)
	   * - `auto-end` (on the side with more space available, alignment depends by placement)
	   *
	   * @static
	   * @type {Array}
	   * @enum {String}
	   * @readonly
	   * @method placements
	   * @memberof Popper
	   */
	  var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];
	
	  // Get rid of `auto` `auto-start` and `auto-end`
	  var validPlacements = placements.slice(3);
	
	  /**
	   * Given an initial placement, returns all the subsequent placements
	   * clockwise (or counter-clockwise).
	   *
	   * @method
	   * @memberof Popper.Utils
	   * @argument {String} placement - A valid placement (it accepts variations)
	   * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
	   * @returns {Array} placements including their variations
	   */
	  function clockwise(placement) {
	    var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	    var index = validPlacements.indexOf(placement);
	    var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
	    return counter ? arr.reverse() : arr;
	  }
	
	  var BEHAVIORS = {
	    FLIP: 'flip',
	    CLOCKWISE: 'clockwise',
	    COUNTERCLOCKWISE: 'counterclockwise'
	  };
	
	  /**
	   * @function
	   * @memberof Modifiers
	   * @argument {Object} data - The data object generated by update method
	   * @argument {Object} options - Modifiers configuration and options
	   * @returns {Object} The data object, properly modified
	   */
	  function flip(data, options) {
	    // if `inner` modifier is enabled, we can't use the `flip` modifier
	    if (isModifierEnabled(data.instance.modifiers, 'inner')) {
	      return data;
	    }
	
	    if (data.flipped && data.placement === data.originalPlacement) {
	      // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
	      return data;
	    }
	
	    var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);
	
	    var placement = data.placement.split('-')[0];
	    var placementOpposite = getOppositePlacement(placement);
	    var variation = data.placement.split('-')[1] || '';
	
	    var flipOrder = [];
	
	    switch (options.behavior) {
	      case BEHAVIORS.FLIP:
	        flipOrder = [placement, placementOpposite];
	        break;
	      case BEHAVIORS.CLOCKWISE:
	        flipOrder = clockwise(placement);
	        break;
	      case BEHAVIORS.COUNTERCLOCKWISE:
	        flipOrder = clockwise(placement, true);
	        break;
	      default:
	        flipOrder = options.behavior;
	    }
	
	    flipOrder.forEach(function (step, index) {
	      if (placement !== step || flipOrder.length === index + 1) {
	        return data;
	      }
	
	      placement = data.placement.split('-')[0];
	      placementOpposite = getOppositePlacement(placement);
	
	      var popperOffsets = data.offsets.popper;
	      var refOffsets = data.offsets.reference;
	
	      // using floor because the reference offsets may contain decimals we are not going to consider here
	      var floor = Math.floor;
	      var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);
	
	      var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
	      var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
	      var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
	      var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);
	
	      var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;
	
	      // flip the variation if required
	      var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
	
	      // flips variation if reference element overflows boundaries
	      var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);
	
	      // flips variation if popper content overflows boundaries
	      var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === 'start' && overflowsRight || isVertical && variation === 'end' && overflowsLeft || !isVertical && variation === 'start' && overflowsBottom || !isVertical && variation === 'end' && overflowsTop);
	
	      var flippedVariation = flippedVariationByRef || flippedVariationByContent;
	
	      if (overlapsRef || overflowsBoundaries || flippedVariation) {
	        // this boolean to detect any flip loop
	        data.flipped = true;
	
	        if (overlapsRef || overflowsBoundaries) {
	          placement = flipOrder[index + 1];
	        }
	
	        if (flippedVariation) {
	          variation = getOppositeVariation(variation);
	        }
	
	        data.placement = placement + (variation ? '-' + variation : '');
	
	        // this object contains `position`, we want to preserve it along with
	        // any additional property we may add in the future
	        data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));
	
	        data = runModifiers(data.instance.modifiers, data, 'flip');
	      }
	    });
	    return data;
	  }
	
	  /**
	   * @function
	   * @memberof Modifiers
	   * @argument {Object} data - The data object generated by update method
	   * @argument {Object} options - Modifiers configuration and options
	   * @returns {Object} The data object, properly modified
	   */
	  function keepTogether(data) {
	    var _data$offsets = data.offsets,
	        popper = _data$offsets.popper,
	        reference = _data$offsets.reference;
	
	    var placement = data.placement.split('-')[0];
	    var floor = Math.floor;
	    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
	    var side = isVertical ? 'right' : 'bottom';
	    var opSide = isVertical ? 'left' : 'top';
	    var measurement = isVertical ? 'width' : 'height';
	
	    if (popper[side] < floor(reference[opSide])) {
	      data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
	    }
	    if (popper[opSide] > floor(reference[side])) {
	      data.offsets.popper[opSide] = floor(reference[side]);
	    }
	
	    return data;
	  }
	
	  /**
	   * Converts a string containing value + unit into a px value number
	   * @function
	   * @memberof {modifiers~offset}
	   * @private
	   * @argument {String} str - Value + unit string
	   * @argument {String} measurement - `height` or `width`
	   * @argument {Object} popperOffsets
	   * @argument {Object} referenceOffsets
	   * @returns {Number|String}
	   * Value in pixels, or original string if no values were extracted
	   */
	  function toValue(str, measurement, popperOffsets, referenceOffsets) {
	    // separate value from unit
	    var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
	    var value = +split[1];
	    var unit = split[2];
	
	    // If it's not a number it's an operator, I guess
	    if (!value) {
	      return str;
	    }
	
	    if (unit.indexOf('%') === 0) {
	      var element = void 0;
	      switch (unit) {
	        case '%p':
	          element = popperOffsets;
	          break;
	        case '%':
	        case '%r':
	        default:
	          element = referenceOffsets;
	      }
	
	      var rect = getClientRect(element);
	      return rect[measurement] / 100 * value;
	    } else if (unit === 'vh' || unit === 'vw') {
	      // if is a vh or vw, we calculate the size based on the viewport
	      var size = void 0;
	      if (unit === 'vh') {
	        size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
	      } else {
	        size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
	      }
	      return size / 100 * value;
	    } else {
	      // if is an explicit pixel unit, we get rid of the unit and keep the value
	      // if is an implicit unit, it's px, and we return just the value
	      return value;
	    }
	  }
	
	  /**
	   * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
	   * @function
	   * @memberof {modifiers~offset}
	   * @private
	   * @argument {String} offset
	   * @argument {Object} popperOffsets
	   * @argument {Object} referenceOffsets
	   * @argument {String} basePlacement
	   * @returns {Array} a two cells array with x and y offsets in numbers
	   */
	  function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
	    var offsets = [0, 0];
	
	    // Use height if placement is left or right and index is 0 otherwise use width
	    // in this way the first offset will use an axis and the second one
	    // will use the other one
	    var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;
	
	    // Split the offset string to obtain a list of values and operands
	    // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
	    var fragments = offset.split(/(\+|\-)/).map(function (frag) {
	      return frag.trim();
	    });
	
	    // Detect if the offset string contains a pair of values or a single one
	    // they could be separated by comma or space
	    var divider = fragments.indexOf(find(fragments, function (frag) {
	      return frag.search(/,|\s/) !== -1;
	    }));
	
	    if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
	      console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
	    }
	
	    // If divider is found, we divide the list of values and operands to divide
	    // them by ofset X and Y.
	    var splitRegex = /\s*,\s*|\s+/;
	    var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];
	
	    // Convert the values with units to absolute pixels to allow our computations
	    ops = ops.map(function (op, index) {
	      // Most of the units rely on the orientation of the popper
	      var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
	      var mergeWithPrevious = false;
	      return op
	      // This aggregates any `+` or `-` sign that aren't considered operators
	      // e.g.: 10 + +5 => [10, +, +5]
	      .reduce(function (a, b) {
	        if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
	          a[a.length - 1] = b;
	          mergeWithPrevious = true;
	          return a;
	        } else if (mergeWithPrevious) {
	          a[a.length - 1] += b;
	          mergeWithPrevious = false;
	          return a;
	        } else {
	          return a.concat(b);
	        }
	      }, [])
	      // Here we convert the string values into number values (in px)
	      .map(function (str) {
	        return toValue(str, measurement, popperOffsets, referenceOffsets);
	      });
	    });
	
	    // Loop trough the offsets arrays and execute the operations
	    ops.forEach(function (op, index) {
	      op.forEach(function (frag, index2) {
	        if (isNumeric(frag)) {
	          offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
	        }
	      });
	    });
	    return offsets;
	  }
	
	  /**
	   * @function
	   * @memberof Modifiers
	   * @argument {Object} data - The data object generated by update method
	   * @argument {Object} options - Modifiers configuration and options
	   * @argument {Number|String} options.offset=0
	   * The offset value as described in the modifier description
	   * @returns {Object} The data object, properly modified
	   */
	  function offset(data, _ref) {
	    var offset = _ref.offset;
	    var placement = data.placement,
	        _data$offsets = data.offsets,
	        popper = _data$offsets.popper,
	        reference = _data$offsets.reference;
	
	    var basePlacement = placement.split('-')[0];
	
	    var offsets = void 0;
	    if (isNumeric(+offset)) {
	      offsets = [+offset, 0];
	    } else {
	      offsets = parseOffset(offset, popper, reference, basePlacement);
	    }
	
	    if (basePlacement === 'left') {
	      popper.top += offsets[0];
	      popper.left -= offsets[1];
	    } else if (basePlacement === 'right') {
	      popper.top += offsets[0];
	      popper.left += offsets[1];
	    } else if (basePlacement === 'top') {
	      popper.left += offsets[0];
	      popper.top -= offsets[1];
	    } else if (basePlacement === 'bottom') {
	      popper.left += offsets[0];
	      popper.top += offsets[1];
	    }
	
	    data.popper = popper;
	    return data;
	  }
	
	  /**
	   * @function
	   * @memberof Modifiers
	   * @argument {Object} data - The data object generated by `update` method
	   * @argument {Object} options - Modifiers configuration and options
	   * @returns {Object} The data object, properly modified
	   */
	  function preventOverflow(data, options) {
	    var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);
	
	    // If offsetParent is the reference element, we really want to
	    // go one step up and use the next offsetParent as reference to
	    // avoid to make this modifier completely useless and look like broken
	    if (data.instance.reference === boundariesElement) {
	      boundariesElement = getOffsetParent(boundariesElement);
	    }
	
	    // NOTE: DOM access here
	    // resets the popper's position so that the document size can be calculated excluding
	    // the size of the popper element itself
	    var transformProp = getSupportedPropertyName('transform');
	    var popperStyles = data.instance.popper.style; // assignment to help minification
	    var top = popperStyles.top,
	        left = popperStyles.left,
	        transform = popperStyles[transformProp];
	
	    popperStyles.top = '';
	    popperStyles.left = '';
	    popperStyles[transformProp] = '';
	
	    var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);
	
	    // NOTE: DOM access here
	    // restores the original style properties after the offsets have been computed
	    popperStyles.top = top;
	    popperStyles.left = left;
	    popperStyles[transformProp] = transform;
	
	    options.boundaries = boundaries;
	
	    var order = options.priority;
	    var popper = data.offsets.popper;
	
	    var check = {
	      primary: function primary(placement) {
	        var value = popper[placement];
	        if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
	          value = Math.max(popper[placement], boundaries[placement]);
	        }
	        return defineProperty({}, placement, value);
	      },
	      secondary: function secondary(placement) {
	        var mainSide = placement === 'right' ? 'left' : 'top';
	        var value = popper[mainSide];
	        if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
	          value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
	        }
	        return defineProperty({}, mainSide, value);
	      }
	    };
	
	    order.forEach(function (placement) {
	      var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
	      popper = _extends({}, popper, check[side](placement));
	    });
	
	    data.offsets.popper = popper;
	
	    return data;
	  }
	
	  /**
	   * @function
	   * @memberof Modifiers
	   * @argument {Object} data - The data object generated by `update` method
	   * @argument {Object} options - Modifiers configuration and options
	   * @returns {Object} The data object, properly modified
	   */
	  function shift(data) {
	    var placement = data.placement;
	    var basePlacement = placement.split('-')[0];
	    var shiftvariation = placement.split('-')[1];
	
	    // if shift shiftvariation is specified, run the modifier
	    if (shiftvariation) {
	      var _data$offsets = data.offsets,
	          reference = _data$offsets.reference,
	          popper = _data$offsets.popper;
	
	      var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
	      var side = isVertical ? 'left' : 'top';
	      var measurement = isVertical ? 'width' : 'height';
	
	      var shiftOffsets = {
	        start: defineProperty({}, side, reference[side]),
	        end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
	      };
	
	      data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
	    }
	
	    return data;
	  }
	
	  /**
	   * @function
	   * @memberof Modifiers
	   * @argument {Object} data - The data object generated by update method
	   * @argument {Object} options - Modifiers configuration and options
	   * @returns {Object} The data object, properly modified
	   */
	  function hide(data) {
	    if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
	      return data;
	    }
	
	    var refRect = data.offsets.reference;
	    var bound = find(data.instance.modifiers, function (modifier) {
	      return modifier.name === 'preventOverflow';
	    }).boundaries;
	
	    if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
	      // Avoid unnecessary DOM access if visibility hasn't changed
	      if (data.hide === true) {
	        return data;
	      }
	
	      data.hide = true;
	      data.attributes['x-out-of-boundaries'] = '';
	    } else {
	      // Avoid unnecessary DOM access if visibility hasn't changed
	      if (data.hide === false) {
	        return data;
	      }
	
	      data.hide = false;
	      data.attributes['x-out-of-boundaries'] = false;
	    }
	
	    return data;
	  }
	
	  /**
	   * @function
	   * @memberof Modifiers
	   * @argument {Object} data - The data object generated by `update` method
	   * @argument {Object} options - Modifiers configuration and options
	   * @returns {Object} The data object, properly modified
	   */
	  function inner(data) {
	    var placement = data.placement;
	    var basePlacement = placement.split('-')[0];
	    var _data$offsets = data.offsets,
	        popper = _data$offsets.popper,
	        reference = _data$offsets.reference;
	
	    var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;
	
	    var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;
	
	    popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);
	
	    data.placement = getOppositePlacement(placement);
	    data.offsets.popper = getClientRect(popper);
	
	    return data;
	  }
	
	  /**
	   * Modifier function, each modifier can have a function of this type assigned
	   * to its `fn` property.<br />
	   * These functions will be called on each update, this means that you must
	   * make sure they are performant enough to avoid performance bottlenecks.
	   *
	   * @function ModifierFn
	   * @argument {dataObject} data - The data object generated by `update` method
	   * @argument {Object} options - Modifiers configuration and options
	   * @returns {dataObject} The data object, properly modified
	   */
	
	  /**
	   * Modifiers are plugins used to alter the behavior of your poppers.<br />
	   * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
	   * needed by the library.
	   *
	   * Usually you don't want to override the `order`, `fn` and `onLoad` props.
	   * All the other properties are configurations that could be tweaked.
	   * @namespace modifiers
	   */
	  var modifiers = {
	    /**
	     * Modifier used to shift the popper on the start or end of its reference
	     * element.<br />
	     * It will read the variation of the `placement` property.<br />
	     * It can be one either `-end` or `-start`.
	     * @memberof modifiers
	     * @inner
	     */
	    shift: {
	      /** @prop {number} order=100 - Index used to define the order of execution */
	      order: 100,
	      /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	      enabled: true,
	      /** @prop {ModifierFn} */
	      fn: shift
	    },
	
	    /**
	     * The `offset` modifier can shift your popper on both its axis.
	     *
	     * It accepts the following units:
	     * - `px` or unit-less, interpreted as pixels
	     * - `%` or `%r`, percentage relative to the length of the reference element
	     * - `%p`, percentage relative to the length of the popper element
	     * - `vw`, CSS viewport width unit
	     * - `vh`, CSS viewport height unit
	     *
	     * For length is intended the main axis relative to the placement of the popper.<br />
	     * This means that if the placement is `top` or `bottom`, the length will be the
	     * `width`. In case of `left` or `right`, it will be the `height`.
	     *
	     * You can provide a single value (as `Number` or `String`), or a pair of values
	     * as `String` divided by a comma or one (or more) white spaces.<br />
	     * The latter is a deprecated method because it leads to confusion and will be
	     * removed in v2.<br />
	     * Additionally, it accepts additions and subtractions between different units.
	     * Note that multiplications and divisions aren't supported.
	     *
	     * Valid examples are:
	     * ```
	     * 10
	     * '10%'
	     * '10, 10'
	     * '10%, 10'
	     * '10 + 10%'
	     * '10 - 5vh + 3%'
	     * '-10px + 5vh, 5px - 6%'
	     * ```
	     * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
	     * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
	     * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
	     *
	     * @memberof modifiers
	     * @inner
	     */
	    offset: {
	      /** @prop {number} order=200 - Index used to define the order of execution */
	      order: 200,
	      /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	      enabled: true,
	      /** @prop {ModifierFn} */
	      fn: offset,
	      /** @prop {Number|String} offset=0
	       * The offset value as described in the modifier description
	       */
	      offset: 0
	    },
	
	    /**
	     * Modifier used to prevent the popper from being positioned outside the boundary.
	     *
	     * A scenario exists where the reference itself is not within the boundaries.<br />
	     * We can say it has "escaped the boundaries" — or just "escaped".<br />
	     * In this case we need to decide whether the popper should either:
	     *
	     * - detach from the reference and remain "trapped" in the boundaries, or
	     * - if it should ignore the boundary and "escape with its reference"
	     *
	     * When `escapeWithReference` is set to`true` and reference is completely
	     * outside its boundaries, the popper will overflow (or completely leave)
	     * the boundaries in order to remain attached to the edge of the reference.
	     *
	     * @memberof modifiers
	     * @inner
	     */
	    preventOverflow: {
	      /** @prop {number} order=300 - Index used to define the order of execution */
	      order: 300,
	      /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	      enabled: true,
	      /** @prop {ModifierFn} */
	      fn: preventOverflow,
	      /**
	       * @prop {Array} [priority=['left','right','top','bottom']]
	       * Popper will try to prevent overflow following these priorities by default,
	       * then, it could overflow on the left and on top of the `boundariesElement`
	       */
	      priority: ['left', 'right', 'top', 'bottom'],
	      /**
	       * @prop {number} padding=5
	       * Amount of pixel used to define a minimum distance between the boundaries
	       * and the popper. This makes sure the popper always has a little padding
	       * between the edges of its container
	       */
	      padding: 5,
	      /**
	       * @prop {String|HTMLElement} boundariesElement='scrollParent'
	       * Boundaries used by the modifier. Can be `scrollParent`, `window`,
	       * `viewport` or any DOM element.
	       */
	      boundariesElement: 'scrollParent'
	    },
	
	    /**
	     * Modifier used to make sure the reference and its popper stay near each other
	     * without leaving any gap between the two. Especially useful when the arrow is
	     * enabled and you want to ensure that it points to its reference element.
	     * It cares only about the first axis. You can still have poppers with margin
	     * between the popper and its reference element.
	     * @memberof modifiers
	     * @inner
	     */
	    keepTogether: {
	      /** @prop {number} order=400 - Index used to define the order of execution */
	      order: 400,
	      /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	      enabled: true,
	      /** @prop {ModifierFn} */
	      fn: keepTogether
	    },
	
	    /**
	     * This modifier is used to move the `arrowElement` of the popper to make
	     * sure it is positioned between the reference element and its popper element.
	     * It will read the outer size of the `arrowElement` node to detect how many
	     * pixels of conjunction are needed.
	     *
	     * It has no effect if no `arrowElement` is provided.
	     * @memberof modifiers
	     * @inner
	     */
	    arrow: {
	      /** @prop {number} order=500 - Index used to define the order of execution */
	      order: 500,
	      /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	      enabled: true,
	      /** @prop {ModifierFn} */
	      fn: arrow,
	      /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
	      element: '[x-arrow]'
	    },
	
	    /**
	     * Modifier used to flip the popper's placement when it starts to overlap its
	     * reference element.
	     *
	     * Requires the `preventOverflow` modifier before it in order to work.
	     *
	     * **NOTE:** this modifier will interrupt the current update cycle and will
	     * restart it if it detects the need to flip the placement.
	     * @memberof modifiers
	     * @inner
	     */
	    flip: {
	      /** @prop {number} order=600 - Index used to define the order of execution */
	      order: 600,
	      /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	      enabled: true,
	      /** @prop {ModifierFn} */
	      fn: flip,
	      /**
	       * @prop {String|Array} behavior='flip'
	       * The behavior used to change the popper's placement. It can be one of
	       * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
	       * placements (with optional variations)
	       */
	      behavior: 'flip',
	      /**
	       * @prop {number} padding=5
	       * The popper will flip if it hits the edges of the `boundariesElement`
	       */
	      padding: 5,
	      /**
	       * @prop {String|HTMLElement} boundariesElement='viewport'
	       * The element which will define the boundaries of the popper position.
	       * The popper will never be placed outside of the defined boundaries
	       * (except if `keepTogether` is enabled)
	       */
	      boundariesElement: 'viewport',
	      /**
	       * @prop {Boolean} flipVariations=false
	       * The popper will switch placement variation between `-start` and `-end` when
	       * the reference element overlaps its boundaries.
	       *
	       * The original placement should have a set variation.
	       */
	      flipVariations: false,
	      /**
	       * @prop {Boolean} flipVariationsByContent=false
	       * The popper will switch placement variation between `-start` and `-end` when
	       * the popper element overlaps its reference boundaries.
	       *
	       * The original placement should have a set variation.
	       */
	      flipVariationsByContent: false
	    },
	
	    /**
	     * Modifier used to make the popper flow toward the inner of the reference element.
	     * By default, when this modifier is disabled, the popper will be placed outside
	     * the reference element.
	     * @memberof modifiers
	     * @inner
	     */
	    inner: {
	      /** @prop {number} order=700 - Index used to define the order of execution */
	      order: 700,
	      /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
	      enabled: false,
	      /** @prop {ModifierFn} */
	      fn: inner
	    },
	
	    /**
	     * Modifier used to hide the popper when its reference element is outside of the
	     * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
	     * be used to hide with a CSS selector the popper when its reference is
	     * out of boundaries.
	     *
	     * Requires the `preventOverflow` modifier before it in order to work.
	     * @memberof modifiers
	     * @inner
	     */
	    hide: {
	      /** @prop {number} order=800 - Index used to define the order of execution */
	      order: 800,
	      /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	      enabled: true,
	      /** @prop {ModifierFn} */
	      fn: hide
	    },
	
	    /**
	     * Computes the style that will be applied to the popper element to gets
	     * properly positioned.
	     *
	     * Note that this modifier will not touch the DOM, it just prepares the styles
	     * so that `applyStyle` modifier can apply it. This separation is useful
	     * in case you need to replace `applyStyle` with a custom implementation.
	     *
	     * This modifier has `850` as `order` value to maintain backward compatibility
	     * with previous versions of Popper.js. Expect the modifiers ordering method
	     * to change in future major versions of the library.
	     *
	     * @memberof modifiers
	     * @inner
	     */
	    computeStyle: {
	      /** @prop {number} order=850 - Index used to define the order of execution */
	      order: 850,
	      /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	      enabled: true,
	      /** @prop {ModifierFn} */
	      fn: computeStyle,
	      /**
	       * @prop {Boolean} gpuAcceleration=true
	       * If true, it uses the CSS 3D transformation to position the popper.
	       * Otherwise, it will use the `top` and `left` properties
	       */
	      gpuAcceleration: true,
	      /**
	       * @prop {string} [x='bottom']
	       * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
	       * Change this if your popper should grow in a direction different from `bottom`
	       */
	      x: 'bottom',
	      /**
	       * @prop {string} [x='left']
	       * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
	       * Change this if your popper should grow in a direction different from `right`
	       */
	      y: 'right'
	    },
	
	    /**
	     * Applies the computed styles to the popper element.
	     *
	     * All the DOM manipulations are limited to this modifier. This is useful in case
	     * you want to integrate Popper.js inside a framework or view library and you
	     * want to delegate all the DOM manipulations to it.
	     *
	     * Note that if you disable this modifier, you must make sure the popper element
	     * has its position set to `absolute` before Popper.js can do its work!
	     *
	     * Just disable this modifier and define your own to achieve the desired effect.
	     *
	     * @memberof modifiers
	     * @inner
	     */
	    applyStyle: {
	      /** @prop {number} order=900 - Index used to define the order of execution */
	      order: 900,
	      /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	      enabled: true,
	      /** @prop {ModifierFn} */
	      fn: applyStyle,
	      /** @prop {Function} */
	      onLoad: applyStyleOnLoad,
	      /**
	       * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
	       * @prop {Boolean} gpuAcceleration=true
	       * If true, it uses the CSS 3D transformation to position the popper.
	       * Otherwise, it will use the `top` and `left` properties
	       */
	      gpuAcceleration: undefined
	    }
	  };
	
	  /**
	   * The `dataObject` is an object containing all the information used by Popper.js.
	   * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
	   * @name dataObject
	   * @property {Object} data.instance The Popper.js instance
	   * @property {String} data.placement Placement applied to popper
	   * @property {String} data.originalPlacement Placement originally defined on init
	   * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
	   * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
	   * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
	   * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
	   * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
	   * @property {Object} data.boundaries Offsets of the popper boundaries
	   * @property {Object} data.offsets The measurements of popper, reference and arrow elements
	   * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
	   * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
	   * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
	   */
	
	  /**
	   * Default options provided to Popper.js constructor.<br />
	   * These can be overridden using the `options` argument of Popper.js.<br />
	   * To override an option, simply pass an object with the same
	   * structure of the `options` object, as the 3rd argument. For example:
	   * ```
	   * new Popper(ref, pop, {
	   *   modifiers: {
	   *     preventOverflow: { enabled: false }
	   *   }
	   * })
	   * ```
	   * @type {Object}
	   * @static
	   * @memberof Popper
	   */
	  var Defaults = {
	    /**
	     * Popper's placement.
	     * @prop {Popper.placements} placement='bottom'
	     */
	    placement: 'bottom',
	
	    /**
	     * Set this to true if you want popper to position it self in 'fixed' mode
	     * @prop {Boolean} positionFixed=false
	     */
	    positionFixed: false,
	
	    /**
	     * Whether events (resize, scroll) are initially enabled.
	     * @prop {Boolean} eventsEnabled=true
	     */
	    eventsEnabled: true,
	
	    /**
	     * Set to true if you want to automatically remove the popper when
	     * you call the `destroy` method.
	     * @prop {Boolean} removeOnDestroy=false
	     */
	    removeOnDestroy: false,
	
	    /**
	     * Callback called when the popper is created.<br />
	     * By default, it is set to no-op.<br />
	     * Access Popper.js instance with `data.instance`.
	     * @prop {onCreate}
	     */
	    onCreate: function onCreate() {},
	
	    /**
	     * Callback called when the popper is updated. This callback is not called
	     * on the initialization/creation of the popper, but only on subsequent
	     * updates.<br />
	     * By default, it is set to no-op.<br />
	     * Access Popper.js instance with `data.instance`.
	     * @prop {onUpdate}
	     */
	    onUpdate: function onUpdate() {},
	
	    /**
	     * List of modifiers used to modify the offsets before they are applied to the popper.
	     * They provide most of the functionalities of Popper.js.
	     * @prop {modifiers}
	     */
	    modifiers: modifiers
	  };
	
	  /**
	   * @callback onCreate
	   * @param {dataObject} data
	   */
	
	  /**
	   * @callback onUpdate
	   * @param {dataObject} data
	   */
	
	  // Utils
	  // Methods
	  var Popper = function () {
	    /**
	     * Creates a new Popper.js instance.
	     * @class Popper
	     * @param {Element|referenceObject} reference - The reference element used to position the popper
	     * @param {Element} popper - The HTML / XML element used as the popper
	     * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
	     * @return {Object} instance - The generated Popper.js instance
	     */
	    function Popper(reference, popper) {
	      var _this = this;
	
	      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	      classCallCheck(this, Popper);
	
	      this.scheduleUpdate = function () {
	        return requestAnimationFrame(_this.update);
	      };
	
	      // make update() debounced, so that it only runs at most once-per-tick
	      this.update = debounce(this.update.bind(this));
	
	      // with {} we create a new object with the options inside it
	      this.options = _extends({}, Popper.Defaults, options);
	
	      // init state
	      this.state = {
	        isDestroyed: false,
	        isCreated: false,
	        scrollParents: []
	      };
	
	      // get reference and popper elements (allow jQuery wrappers)
	      this.reference = reference && reference.jquery ? reference[0] : reference;
	      this.popper = popper && popper.jquery ? popper[0] : popper;
	
	      // Deep merge modifiers options
	      this.options.modifiers = {};
	      Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
	        _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
	      });
	
	      // Refactoring modifiers' list (Object => Array)
	      this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
	        return _extends({
	          name: name
	        }, _this.options.modifiers[name]);
	      })
	      // sort the modifiers by order
	      .sort(function (a, b) {
	        return a.order - b.order;
	      });
	
	      // modifiers have the ability to execute arbitrary code when Popper.js get inited
	      // such code is executed in the same order of its modifier
	      // they could add new properties to their options configuration
	      // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
	      this.modifiers.forEach(function (modifierOptions) {
	        if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
	          modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
	        }
	      });
	
	      // fire the first update to position the popper in the right place
	      this.update();
	
	      var eventsEnabled = this.options.eventsEnabled;
	      if (eventsEnabled) {
	        // setup event listeners, they will take care of update the position in specific situations
	        this.enableEventListeners();
	      }
	
	      this.state.eventsEnabled = eventsEnabled;
	    }
	
	    // We can't use class properties because they don't get listed in the
	    // class prototype and break stuff like Sinon stubs
	
	
	    createClass(Popper, [{
	      key: 'update',
	      value: function update$$1() {
	        return update.call(this);
	      }
	    }, {
	      key: 'destroy',
	      value: function destroy$$1() {
	        return destroy.call(this);
	      }
	    }, {
	      key: 'enableEventListeners',
	      value: function enableEventListeners$$1() {
	        return enableEventListeners.call(this);
	      }
	    }, {
	      key: 'disableEventListeners',
	      value: function disableEventListeners$$1() {
	        return disableEventListeners.call(this);
	      }
	
	      /**
	       * Schedules an update. It will run on the next UI update available.
	       * @method scheduleUpdate
	       * @memberof Popper
	       */
	
	      /**
	       * Collection of utilities useful when writing custom modifiers.
	       * Starting from version 1.7, this method is available only if you
	       * include `popper-utils.js` before `popper.js`.
	       *
	       * **DEPRECATION**: This way to access PopperUtils is deprecated
	       * and will be removed in v2! Use the PopperUtils module directly instead.
	       * Due to the high instability of the methods contained in Utils, we can't
	       * guarantee them to follow semver. Use them at your own risk!
	       * @static
	       * @private
	       * @type {Object}
	       * @deprecated since version 1.8
	       * @member Utils
	       * @memberof Popper
	       */
	
	    }]);
	    return Popper;
	  }();
	
	  /**
	   * The `referenceObject` is an object that provides an interface compatible with Popper.js
	   * and lets you use it as replacement of a real DOM node.<br />
	   * You can use this method to position a popper relatively to a set of coordinates
	   * in case you don't have a DOM node to use as reference.
	   *
	   * ```
	   * new Popper(referenceObject, popperNode);
	   * ```
	   *
	   * NB: This feature isn't supported in Internet Explorer 10.
	   * @name referenceObject
	   * @property {Function} data.getBoundingClientRect
	   * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
	   * @property {number} data.clientWidth
	   * An ES6 getter that will return the width of the virtual reference element.
	   * @property {number} data.clientHeight
	   * An ES6 getter that will return the height of the virtual reference element.
	   */
	
	  Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
	  Popper.placements = placements;
	  Popper.Defaults = Defaults;
	
	  return Popper;
	});
	//# sourceMappingURL=popper.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 817 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	//This file contains the ES6 extensions to the core Promises/A+ API
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var Promise = __webpack_require__(362);
	
	module.exports = Promise;
	
	/* Static Functions */
	
	var TRUE = valuePromise(true);
	var FALSE = valuePromise(false);
	var NULL = valuePromise(null);
	var UNDEFINED = valuePromise(undefined);
	var ZERO = valuePromise(0);
	var EMPTYSTRING = valuePromise('');
	
	function valuePromise(value) {
	  var p = new Promise(Promise._61);
	  p._81 = 1;
	  p._65 = value;
	  return p;
	}
	Promise.resolve = function (value) {
	  if (value instanceof Promise) return value;
	
	  if (value === null) return NULL;
	  if (value === undefined) return UNDEFINED;
	  if (value === true) return TRUE;
	  if (value === false) return FALSE;
	  if (value === 0) return ZERO;
	  if (value === '') return EMPTYSTRING;
	
	  if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' || typeof value === 'function') {
	    try {
	      var then = value.then;
	      if (typeof then === 'function') {
	        return new Promise(then.bind(value));
	      }
	    } catch (ex) {
	      return new Promise(function (resolve, reject) {
	        reject(ex);
	      });
	    }
	  }
	  return valuePromise(value);
	};
	
	Promise.all = function (arr) {
	  var args = Array.prototype.slice.call(arr);
	
	  return new Promise(function (resolve, reject) {
	    if (args.length === 0) return resolve([]);
	    var remaining = args.length;
	    function res(i, val) {
	      if (val && ((typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object' || typeof val === 'function')) {
	        if (val instanceof Promise && val.then === Promise.prototype.then) {
	          while (val._81 === 3) {
	            val = val._65;
	          }
	          if (val._81 === 1) return res(i, val._65);
	          if (val._81 === 2) reject(val._65);
	          val.then(function (val) {
	            res(i, val);
	          }, reject);
	          return;
	        } else {
	          var then = val.then;
	          if (typeof then === 'function') {
	            var p = new Promise(then.bind(val));
	            p.then(function (val) {
	              res(i, val);
	            }, reject);
	            return;
	          }
	        }
	      }
	      args[i] = val;
	      if (--remaining === 0) {
	        resolve(args);
	      }
	    }
	    for (var i = 0; i < args.length; i++) {
	      res(i, args[i]);
	    }
	  });
	};
	
	Promise.reject = function (value) {
	  return new Promise(function (resolve, reject) {
	    reject(value);
	  });
	};
	
	Promise.race = function (values) {
	  return new Promise(function (resolve, reject) {
	    values.forEach(function (value) {
	      Promise.resolve(value).then(resolve, reject);
	    });
	  });
	};
	
	/* Prototype Methods */
	
	Promise.prototype['catch'] = function (onRejected) {
	  return this.then(null, onRejected);
	};

/***/ },
/* 818 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Promise = __webpack_require__(362);
	
	var DEFAULT_WHITELIST = [ReferenceError, TypeError, RangeError];
	
	var enabled = false;
	exports.disable = disable;
	function disable() {
	  enabled = false;
	  Promise._10 = null;
	  Promise._97 = null;
	}
	
	exports.enable = enable;
	function enable(options) {
	  options = options || {};
	  if (enabled) disable();
	  enabled = true;
	  var id = 0;
	  var displayId = 0;
	  var rejections = {};
	  Promise._10 = function (promise) {
	    if (promise._81 === 2 && // IS REJECTED
	    rejections[promise._72]) {
	      if (rejections[promise._72].logged) {
	        onHandled(promise._72);
	      } else {
	        clearTimeout(rejections[promise._72].timeout);
	      }
	      delete rejections[promise._72];
	    }
	  };
	  Promise._97 = function (promise, err) {
	    if (promise._45 === 0) {
	      // not yet handled
	      promise._72 = id++;
	      rejections[promise._72] = {
	        displayId: null,
	        error: err,
	        timeout: setTimeout(onUnhandled.bind(null, promise._72),
	        // For reference errors and type errors, this almost always
	        // means the programmer made a mistake, so log them after just
	        // 100ms
	        // otherwise, wait 2 seconds to see if they get handled
	        matchWhitelist(err, DEFAULT_WHITELIST) ? 100 : 2000),
	        logged: false
	      };
	    }
	  };
	  function onUnhandled(id) {
	    if (options.allRejections || matchWhitelist(rejections[id].error, options.whitelist || DEFAULT_WHITELIST)) {
	      rejections[id].displayId = displayId++;
	      if (options.onUnhandled) {
	        rejections[id].logged = true;
	        options.onUnhandled(rejections[id].displayId, rejections[id].error);
	      } else {
	        rejections[id].logged = true;
	        logError(rejections[id].displayId, rejections[id].error);
	      }
	    }
	  }
	  function onHandled(id) {
	    if (rejections[id].logged) {
	      if (options.onHandled) {
	        options.onHandled(rejections[id].displayId, rejections[id].error);
	      } else if (!rejections[id].onUnhandled) {
	        console.warn('Promise Rejection Handled (id: ' + rejections[id].displayId + '):');
	        console.warn('  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' + rejections[id].displayId + '.');
	      }
	    }
	  }
	}
	
	function logError(id, error) {
	  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
	  var errStr = (error && (error.stack || error)) + '';
	  errStr.split('\n').forEach(function (line) {
	    console.warn('  ' + line);
	  });
	}
	
	function matchWhitelist(error, list) {
	  return list.some(function (cls) {
	    return error instanceof cls;
	  });
	}

/***/ },
/* 819 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	if (false) {
	  var invariant = require('fbjs/lib/invariant');
	  var warning = require('fbjs/lib/warning');
	  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
	  var loggedTypeFailures = {};
	}
	
	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (false) {
	    for (var typeSpecName in typeSpecs) {
	      if (typeSpecs.hasOwnProperty(typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', componentName || 'React class', location, typeSpecName);
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error === 'undefined' ? 'undefined' : _typeof(error));
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;
	
	          var stack = getStack ? getStack() : '';
	
	          warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
	        }
	      }
	    }
	  }
	}
	
	module.exports = checkPropTypes;

/***/ },
/* 820 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(41);
	var invariant = __webpack_require__(5);
	var ReactPropTypesSecret = __webpack_require__(364);
	
	module.exports = function () {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    invariant(false, 'Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim
	  };
	
	  ReactPropTypes.checkPropTypes = emptyFunction;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};

/***/ },
/* 821 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var emptyFunction = __webpack_require__(41);
	var invariant = __webpack_require__(5);
	var warning = __webpack_require__(9);
	
	var ReactPropTypesSecret = __webpack_require__(364);
	var checkPropTypes = __webpack_require__(819);
	
	module.exports = function (isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */
	
	  var ANONYMOUS = '<<anonymous>>';
	
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),
	
	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker
	  };
	
	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/
	
	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message) {
	    this.message = message;
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;
	
	  function createChainableTypeChecker(validate) {
	    if (false) {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;
	
	      if (secret !== ReactPropTypesSecret) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          invariant(false, 'Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use `PropTypes.checkPropTypes()` to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
	        } else if (false) {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (!manualPropTypeCallCache[cacheKey] &&
	          // Avoid spamming the console because they are often not actionable except for lib authors
	          manualPropTypeWarningCount < 3) {
	            warning(false, 'You are manually calling a React.PropTypes validation ' + 'function for the `%s` prop on `%s`. This is deprecated ' + 'and will throw in the standalone `prop-types` package. ' + 'You may be seeing this warning due to a third-party PropTypes ' + 'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.', propFullName, componentName);
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }
	
	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);
	
	    return chainedCheckType;
	  }
	
	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);
	
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
	  }
	
	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	       false ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
	      return emptyFunction.thatReturnsNull;
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }
	
	      var valuesString = JSON.stringify(expectedValues);
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (propValue.hasOwnProperty(key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	       false ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunction.thatReturnsNull;
	    }
	
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        warning(false, 'Invalid argument supplid to oneOfType. Expected an array of check functions, but ' + 'received %s at index %s.', getPostfixForTypeWarning(checker), i);
	        return emptyFunction.thatReturnsNull;
	      }
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
	          return null;
	        }
	      }
	
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          continue;
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function isNode(propValue) {
	    switch (typeof propValue === 'undefined' ? 'undefined' : _typeof(propValue)) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }
	
	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }
	
	        return true;
	      default:
	        return false;
	    }
	  }
	
	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }
	
	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }
	
	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }
	
	    return false;
	  }
	
	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue === 'undefined' ? 'undefined' : _typeof(propValue);
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }
	
	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }
	
	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }
	
	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }
	
	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};

/***/ },
/* 822 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	module.exports = __webpack_require__(895);

/***/ },
/* 823 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = {
	  Properties: {
	    // Global States and Properties
	    'aria-current': 0, // state
	    'aria-details': 0,
	    'aria-disabled': 0, // state
	    'aria-hidden': 0, // state
	    'aria-invalid': 0, // state
	    'aria-keyshortcuts': 0,
	    'aria-label': 0,
	    'aria-roledescription': 0,
	    // Widget Attributes
	    'aria-autocomplete': 0,
	    'aria-checked': 0,
	    'aria-expanded': 0,
	    'aria-haspopup': 0,
	    'aria-level': 0,
	    'aria-modal': 0,
	    'aria-multiline': 0,
	    'aria-multiselectable': 0,
	    'aria-orientation': 0,
	    'aria-placeholder': 0,
	    'aria-pressed': 0,
	    'aria-readonly': 0,
	    'aria-required': 0,
	    'aria-selected': 0,
	    'aria-sort': 0,
	    'aria-valuemax': 0,
	    'aria-valuemin': 0,
	    'aria-valuenow': 0,
	    'aria-valuetext': 0,
	    // Live Region Attributes
	    'aria-atomic': 0,
	    'aria-busy': 0,
	    'aria-live': 0,
	    'aria-relevant': 0,
	    // Drag-and-Drop Attributes
	    'aria-dropeffect': 0,
	    'aria-grabbed': 0,
	    // Relationship Attributes
	    'aria-activedescendant': 0,
	    'aria-colcount': 0,
	    'aria-colindex': 0,
	    'aria-colspan': 0,
	    'aria-controls': 0,
	    'aria-describedby': 0,
	    'aria-errormessage': 0,
	    'aria-flowto': 0,
	    'aria-labelledby': 0,
	    'aria-owns': 0,
	    'aria-posinset': 0,
	    'aria-rowcount': 0,
	    'aria-rowindex': 0,
	    'aria-rowspan': 0,
	    'aria-setsize': 0
	  },
	  DOMAttributeNames: {},
	  DOMPropertyNames: {}
	};
	
	module.exports = ARIADOMPropertyConfig;

/***/ },
/* 824 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(23);
	
	var focusNode = __webpack_require__(240);
	
	var AutoFocusUtils = {
	  focusDOMComponent: function focusDOMComponent() {
	    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
	  }
	};
	
	module.exports = AutoFocusUtils;

/***/ },
/* 825 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var EventPropagators = __webpack_require__(96);
	var ExecutionEnvironment = __webpack_require__(32);
	var FallbackCompositionState = __webpack_require__(831);
	var SyntheticCompositionEvent = __webpack_require__(868);
	var SyntheticInputEvent = __webpack_require__(871);
	
	var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
	var START_KEYCODE = 229;
	
	var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;
	
	var documentMode = null;
	if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
	  documentMode = document.documentMode;
	}
	
	// Webkit offers a very useful `textInput` event that can be used to
	// directly represent `beforeInput`. The IE `textinput` event is not as
	// useful, so we don't use it.
	var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();
	
	// In IE9+, we have access to composition events, but the data supplied
	// by the native compositionend event may be incorrect. Japanese ideographic
	// spaces, for instance (\u3000) are not recorded correctly.
	var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
	
	/**
	 * Opera <= 12 includes TextEvent in window, but does not fire
	 * text input events. Rely on keypress instead.
	 */
	function isPresto() {
	  var opera = window.opera;
	  return (typeof opera === 'undefined' ? 'undefined' : _typeof(opera)) === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
	}
	
	var SPACEBAR_CODE = 32;
	var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
	
	// Events and their corresponding property names.
	var eventTypes = {
	  beforeInput: {
	    phasedRegistrationNames: {
	      bubbled: 'onBeforeInput',
	      captured: 'onBeforeInputCapture'
	    },
	    dependencies: ['topCompositionEnd', 'topKeyPress', 'topTextInput', 'topPaste']
	  },
	  compositionEnd: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionEnd',
	      captured: 'onCompositionEndCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionEnd', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionStart: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionStart',
	      captured: 'onCompositionStartCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionStart', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionUpdate: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionUpdate',
	      captured: 'onCompositionUpdateCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionUpdate', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  }
	};
	
	// Track whether we've ever handled a keypress on the space key.
	var hasSpaceKeypress = false;
	
	/**
	 * Return whether a native keypress event is assumed to be a command.
	 * This is required because Firefox fires `keypress` events for key commands
	 * (cut, copy, select-all, etc.) even though no character is inserted.
	 */
	function isKeypressCommand(nativeEvent) {
	  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
	  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
	  !(nativeEvent.ctrlKey && nativeEvent.altKey);
	}
	
	/**
	 * Translate native top level events into event types.
	 *
	 * @param {string} topLevelType
	 * @return {object}
	 */
	function getCompositionEventType(topLevelType) {
	  switch (topLevelType) {
	    case 'topCompositionStart':
	      return eventTypes.compositionStart;
	    case 'topCompositionEnd':
	      return eventTypes.compositionEnd;
	    case 'topCompositionUpdate':
	      return eventTypes.compositionUpdate;
	  }
	}
	
	/**
	 * Does our fallback best-guess model think this event signifies that
	 * composition has begun?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionStart(topLevelType, nativeEvent) {
	  return topLevelType === 'topKeyDown' && nativeEvent.keyCode === START_KEYCODE;
	}
	
	/**
	 * Does our fallback mode think that this event is the end of composition?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionEnd(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topKeyUp':
	      // Command keys insert or clear IME input.
	      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
	    case 'topKeyDown':
	      // Expect IME keyCode on each keydown. If we get any other
	      // code we must have exited earlier.
	      return nativeEvent.keyCode !== START_KEYCODE;
	    case 'topKeyPress':
	    case 'topMouseDown':
	    case 'topBlur':
	      // Events are not possible without cancelling IME.
	      return true;
	    default:
	      return false;
	  }
	}
	
	/**
	 * Google Input Tools provides composition data via a CustomEvent,
	 * with the `data` property populated in the `detail` object. If this
	 * is available on the event object, use it. If not, this is a plain
	 * composition event and we have nothing special to extract.
	 *
	 * @param {object} nativeEvent
	 * @return {?string}
	 */
	function getDataFromCustomEvent(nativeEvent) {
	  var detail = nativeEvent.detail;
	  if ((typeof detail === 'undefined' ? 'undefined' : _typeof(detail)) === 'object' && 'data' in detail) {
	    return detail.data;
	  }
	  return null;
	}
	
	// Track the current IME composition fallback object, if any.
	var currentComposition = null;
	
	/**
	 * @return {?object} A SyntheticCompositionEvent.
	 */
	function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var eventType;
	  var fallbackData;
	
	  if (canUseCompositionEvent) {
	    eventType = getCompositionEventType(topLevelType);
	  } else if (!currentComposition) {
	    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
	      eventType = eventTypes.compositionStart;
	    }
	  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	    eventType = eventTypes.compositionEnd;
	  }
	
	  if (!eventType) {
	    return null;
	  }
	
	  if (useFallbackCompositionData) {
	    // The current composition is stored statically and must not be
	    // overwritten while composition continues.
	    if (!currentComposition && eventType === eventTypes.compositionStart) {
	      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
	    } else if (eventType === eventTypes.compositionEnd) {
	      if (currentComposition) {
	        fallbackData = currentComposition.getData();
	      }
	    }
	  }
	
	  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);
	
	  if (fallbackData) {
	    // Inject data generated from fallback path into the synthetic event.
	    // This matches the property of native CompositionEventInterface.
	    event.data = fallbackData;
	  } else {
	    var customData = getDataFromCustomEvent(nativeEvent);
	    if (customData !== null) {
	      event.data = customData;
	    }
	  }
	
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The string corresponding to this `beforeInput` event.
	 */
	function getNativeBeforeInputChars(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topCompositionEnd':
	      return getDataFromCustomEvent(nativeEvent);
	    case 'topKeyPress':
	      /**
	       * If native `textInput` events are available, our goal is to make
	       * use of them. However, there is a special case: the spacebar key.
	       * In Webkit, preventing default on a spacebar `textInput` event
	       * cancels character insertion, but it *also* causes the browser
	       * to fall back to its default spacebar behavior of scrolling the
	       * page.
	       *
	       * Tracking at:
	       * https://code.google.com/p/chromium/issues/detail?id=355103
	       *
	       * To avoid this issue, use the keypress event as if no `textInput`
	       * event is available.
	       */
	      var which = nativeEvent.which;
	      if (which !== SPACEBAR_CODE) {
	        return null;
	      }
	
	      hasSpaceKeypress = true;
	      return SPACEBAR_CHAR;
	
	    case 'topTextInput':
	      // Record the characters to be added to the DOM.
	      var chars = nativeEvent.data;
	
	      // If it's a spacebar character, assume that we have already handled
	      // it at the keypress level and bail immediately. Android Chrome
	      // doesn't give us keycodes, so we need to blacklist it.
	      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
	        return null;
	      }
	
	      return chars;
	
	    default:
	      // For other native event types, do nothing.
	      return null;
	  }
	}
	
	/**
	 * For browsers that do not provide the `textInput` event, extract the
	 * appropriate string to use for SyntheticInputEvent.
	 *
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The fallback string for this `beforeInput` event.
	 */
	function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
	  // If we are currently composing (IME) and using a fallback to do so,
	  // try to extract the composed characters from the fallback object.
	  // If composition event is available, we extract a string only at
	  // compositionevent, otherwise extract it at fallback events.
	  if (currentComposition) {
	    if (topLevelType === 'topCompositionEnd' || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	      var chars = currentComposition.getData();
	      FallbackCompositionState.release(currentComposition);
	      currentComposition = null;
	      return chars;
	    }
	    return null;
	  }
	
	  switch (topLevelType) {
	    case 'topPaste':
	      // If a paste event occurs after a keypress, throw out the input
	      // chars. Paste events should not lead to BeforeInput events.
	      return null;
	    case 'topKeyPress':
	      /**
	       * As of v27, Firefox may fire keypress events even when no character
	       * will be inserted. A few possibilities:
	       *
	       * - `which` is `0`. Arrow keys, Esc key, etc.
	       *
	       * - `which` is the pressed key code, but no char is available.
	       *   Ex: 'AltGr + d` in Polish. There is no modified character for
	       *   this key combination and no character is inserted into the
	       *   document, but FF fires the keypress for char code `100` anyway.
	       *   No `input` event will occur.
	       *
	       * - `which` is the pressed key code, but a command combination is
	       *   being used. Ex: `Cmd+C`. No character is inserted, and no
	       *   `input` event will occur.
	       */
	      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
	        return String.fromCharCode(nativeEvent.which);
	      }
	      return null;
	    case 'topCompositionEnd':
	      return useFallbackCompositionData ? null : nativeEvent.data;
	    default:
	      return null;
	  }
	}
	
	/**
	 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
	 * `textInput` or fallback behavior.
	 *
	 * @return {?object} A SyntheticInputEvent.
	 */
	function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var chars;
	
	  if (canUseTextInputEvent) {
	    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
	  } else {
	    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
	  }
	
	  // If no characters are being inserted, no BeforeInput event should
	  // be fired.
	  if (!chars) {
	    return null;
	  }
	
	  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);
	
	  event.data = chars;
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * Create an `onBeforeInput` event to match
	 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
	 *
	 * This event plugin is based on the native `textInput` event
	 * available in Chrome, Safari, Opera, and IE. This event fires after
	 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
	 *
	 * `beforeInput` is spec'd but not implemented in any browsers, and
	 * the `input` event does not provide any useful information about what has
	 * actually been added, contrary to the spec. Thus, `textInput` is the best
	 * available event to identify the characters that have actually been inserted
	 * into the target node.
	 *
	 * This plugin is also responsible for emitting `composition` events, thus
	 * allowing us to share composition fallback code for both `beforeInput` and
	 * `composition` event types.
	 */
	var BeforeInputEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
	  }
	};
	
	module.exports = BeforeInputEventPlugin;

/***/ },
/* 826 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(365);
	var ExecutionEnvironment = __webpack_require__(32);
	var ReactInstrumentation = __webpack_require__(46);
	
	var camelizeStyleName = __webpack_require__(239);
	var dangerousStyleValue = __webpack_require__(877);
	var hyphenateStyleName = __webpack_require__(242);
	var memoizeStringOnly = __webpack_require__(243);
	var warning = __webpack_require__(9);
	
	var processStyleName = memoizeStringOnly(function (styleName) {
	  return hyphenateStyleName(styleName);
	});
	
	var hasShorthandPropertyBug = false;
	var styleFloatAccessor = 'cssFloat';
	if (ExecutionEnvironment.canUseDOM) {
	  var tempStyle = document.createElement('div').style;
	  try {
	    // IE8 throws "Invalid argument." if resetting shorthand style properties.
	    tempStyle.font = '';
	  } catch (e) {
	    hasShorthandPropertyBug = true;
	  }
	  // IE8 only supports accessing cssFloat (standard) as styleFloat
	  if (document.documentElement.style.cssFloat === undefined) {
	    styleFloatAccessor = 'styleFloat';
	  }
	}
	
	if (false) {
	  // 'msTransform' is correct, but the other prefixes should be capitalized
	  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
	
	  // style values shouldn't contain a semicolon
	  var badStyleValueWithSemicolonPattern = /;\s*$/;
	
	  var warnedStyleNames = {};
	  var warnedStyleValues = {};
	  var warnedForNaNValue = false;
	
	  var warnHyphenatedStyleName = function warnHyphenatedStyleName(name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnBadVendoredStyleName = function warnBadVendoredStyleName(name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnStyleValueWithSemicolon = function warnStyleValueWithSemicolon(name, value, owner) {
	    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
	      return;
	    }
	
	    warnedStyleValues[value] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, "Style property values shouldn't contain a semicolon.%s " + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
	  };
	
	  var warnStyleValueIsNaN = function warnStyleValueIsNaN(name, value, owner) {
	    if (warnedForNaNValue) {
	      return;
	    }
	
	    warnedForNaNValue = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
	  };
	
	  var checkRenderMessage = function checkRenderMessage(owner) {
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' Check the render method of `' + name + '`.';
	      }
	    }
	    return '';
	  };
	
	  /**
	   * @param {string} name
	   * @param {*} value
	   * @param {ReactDOMComponent} component
	   */
	  var warnValidStyle = function warnValidStyle(name, value, component) {
	    var owner;
	    if (component) {
	      owner = component._currentElement._owner;
	    }
	    if (name.indexOf('-') > -1) {
	      warnHyphenatedStyleName(name, owner);
	    } else if (badVendoredStyleNamePattern.test(name)) {
	      warnBadVendoredStyleName(name, owner);
	    } else if (badStyleValueWithSemicolonPattern.test(value)) {
	      warnStyleValueWithSemicolon(name, value, owner);
	    }
	
	    if (typeof value === 'number' && isNaN(value)) {
	      warnStyleValueIsNaN(name, value, owner);
	    }
	  };
	}
	
	/**
	 * Operations for dealing with CSS properties.
	 */
	var CSSPropertyOperations = {
	  /**
	   * Serializes a mapping of style properties for use as inline styles:
	   *
	   *   > createMarkupForStyles({width: '200px', height: 0})
	   *   "width:200px;height:0;"
	   *
	   * Undefined values are ignored so that declarative programming is easier.
	   * The result should be HTML-escaped before insertion into the DOM.
	   *
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   * @return {?string}
	   */
	  createMarkupForStyles: function createMarkupForStyles(styles, component) {
	    var serialized = '';
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var isCustomProperty = styleName.indexOf('--') === 0;
	      var styleValue = styles[styleName];
	      if (false) {
	        if (!isCustomProperty) {
	          warnValidStyle(styleName, styleValue, component);
	        }
	      }
	      if (styleValue != null) {
	        serialized += processStyleName(styleName) + ':';
	        serialized += dangerousStyleValue(styleName, styleValue, component, isCustomProperty) + ';';
	      }
	    }
	    return serialized || null;
	  },
	
	  /**
	   * Sets the value for multiple styles on a node.  If a value is specified as
	   * '' (empty string), the corresponding style property will be unset.
	   *
	   * @param {DOMElement} node
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   */
	  setValueForStyles: function setValueForStyles(node, styles, component) {
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: component._debugID,
	        type: 'update styles',
	        payload: styles
	      });
	    }
	
	    var style = node.style;
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var isCustomProperty = styleName.indexOf('--') === 0;
	      if (false) {
	        if (!isCustomProperty) {
	          warnValidStyle(styleName, styles[styleName], component);
	        }
	      }
	      var styleValue = dangerousStyleValue(styleName, styles[styleName], component, isCustomProperty);
	      if (styleName === 'float' || styleName === 'cssFloat') {
	        styleName = styleFloatAccessor;
	      }
	      if (isCustomProperty) {
	        style.setProperty(styleName, styleValue);
	      } else if (styleValue) {
	        style[styleName] = styleValue;
	      } else {
	        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
	        if (expansion) {
	          // Shorthand property that IE8 won't like unsetting, so unset each
	          // component to placate it
	          for (var individualStyleName in expansion) {
	            style[individualStyleName] = '';
	          }
	        } else {
	          style[styleName] = '';
	        }
	      }
	    }
	  }
	};
	
	module.exports = CSSPropertyOperations;

/***/ },
/* 827 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(95);
	var EventPropagators = __webpack_require__(96);
	var ExecutionEnvironment = __webpack_require__(32);
	var ReactDOMComponentTree = __webpack_require__(23);
	var ReactUpdates = __webpack_require__(53);
	var SyntheticEvent = __webpack_require__(56);
	
	var inputValueTracking = __webpack_require__(381);
	var getEventTarget = __webpack_require__(177);
	var isEventSupported = __webpack_require__(178);
	var isTextInputElement = __webpack_require__(383);
	
	var eventTypes = {
	  change: {
	    phasedRegistrationNames: {
	      bubbled: 'onChange',
	      captured: 'onChangeCapture'
	    },
	    dependencies: ['topBlur', 'topChange', 'topClick', 'topFocus', 'topInput', 'topKeyDown', 'topKeyUp', 'topSelectionChange']
	  }
	};
	
	function createAndAccumulateChangeEvent(inst, nativeEvent, target) {
	  var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, target);
	  event.type = 'change';
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	/**
	 * For IE shims
	 */
	var activeElement = null;
	var activeElementInst = null;
	
	/**
	 * SECTION: handle `change` event
	 */
	function shouldUseChangeEvent(elem) {
	  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
	  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
	}
	
	var doesChangeEventBubble = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // See `handleChange` comment below
	  doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
	}
	
	function manualDispatchChangeEvent(nativeEvent) {
	  var event = createAndAccumulateChangeEvent(activeElementInst, nativeEvent, getEventTarget(nativeEvent));
	
	  // If change and propertychange bubbled, we'd just bind to it like all the
	  // other events and have it go through ReactBrowserEventEmitter. Since it
	  // doesn't, we manually listen for the events and so we have to enqueue and
	  // process the abstract event manually.
	  //
	  // Batching is necessary here in order to ensure that all event handlers run
	  // before the next rerender (including event handlers attached to ancestor
	  // elements instead of directly on the input). Without this, controlled
	  // components don't work properly in conjunction with event bubbling because
	  // the component is rerendered and the value reverted before all the event
	  // handlers can run. See https://github.com/facebook/react/issues/708.
	  ReactUpdates.batchedUpdates(runEventInBatch, event);
	}
	
	function runEventInBatch(event) {
	  EventPluginHub.enqueueEvents(event);
	  EventPluginHub.processEventQueue(false);
	}
	
	function startWatchingForChangeEventIE8(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
	}
	
	function stopWatchingForChangeEventIE8() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
	  activeElement = null;
	  activeElementInst = null;
	}
	
	function getInstIfValueChanged(targetInst, nativeEvent) {
	  var updated = inputValueTracking.updateValueIfChanged(targetInst);
	  var simulated = nativeEvent.simulated === true && ChangeEventPlugin._allowSimulatedPassThrough;
	
	  if (updated || simulated) {
	    return targetInst;
	  }
	}
	
	function getTargetInstForChangeEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topChange') {
	    return targetInst;
	  }
	}
	
	function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForChangeEventIE8();
	    startWatchingForChangeEventIE8(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForChangeEventIE8();
	  }
	}
	
	/**
	 * SECTION: handle `input` event
	 */
	var isInputEventSupported = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // IE9 claims to support the input event but fails to trigger it when
	  // deleting text, so we ignore its input events.
	
	  isInputEventSupported = isEventSupported('input') && (!('documentMode' in document) || document.documentMode > 9);
	}
	
	/**
	 * (For IE <=9) Starts tracking propertychange events on the passed-in element
	 * and override the value property so that we can distinguish user events from
	 * value changes in JS.
	 */
	function startWatchingForValueChange(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onpropertychange', handlePropertyChange);
	}
	
	/**
	 * (For IE <=9) Removes the event listeners from the currently-tracked element,
	 * if any exists.
	 */
	function stopWatchingForValueChange() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onpropertychange', handlePropertyChange);
	
	  activeElement = null;
	  activeElementInst = null;
	}
	
	/**
	 * (For IE <=9) Handles a propertychange event, sending a `change` event if
	 * the value of the active element has changed.
	 */
	function handlePropertyChange(nativeEvent) {
	  if (nativeEvent.propertyName !== 'value') {
	    return;
	  }
	  if (getInstIfValueChanged(activeElementInst, nativeEvent)) {
	    manualDispatchChangeEvent(nativeEvent);
	  }
	}
	
	function handleEventsForInputEventPolyfill(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // In IE8, we can capture almost all .value changes by adding a
	    // propertychange handler and looking for events with propertyName
	    // equal to 'value'
	    // In IE9, propertychange fires for most input events but is buggy and
	    // doesn't fire when text is deleted, but conveniently, selectionchange
	    // appears to fire in all of the remaining cases so we catch those and
	    // forward the event if the value has changed
	    // In either case, we don't want to call the event handler if the value
	    // is changed from JS so we redefine a setter for `.value` that updates
	    // our activeElementValue variable, allowing us to ignore those changes
	    //
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForValueChange();
	    startWatchingForValueChange(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForValueChange();
	  }
	}
	
	// For IE8 and IE9.
	function getTargetInstForInputEventPolyfill(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topSelectionChange' || topLevelType === 'topKeyUp' || topLevelType === 'topKeyDown') {
	    // On the selectionchange event, the target is just document which isn't
	    // helpful for us so just check activeElement instead.
	    //
	    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
	    // propertychange on the first input event after setting `value` from a
	    // script and fires only keydown, keypress, keyup. Catching keyup usually
	    // gets it and catching keydown lets us fire an event for the first
	    // keystroke if user does a key repeat (it'll be a little delayed: right
	    // before the second keystroke). Other input methods (e.g., paste) seem to
	    // fire selectionchange normally.
	    return getInstIfValueChanged(activeElementInst, nativeEvent);
	  }
	}
	
	/**
	 * SECTION: handle `click` event
	 */
	function shouldUseClickEvent(elem) {
	  // Use the `click` event to detect changes to checkbox and radio inputs.
	  // This approach works across all browsers, whereas `change` does not fire
	  // until `blur` in IE8.
	  var nodeName = elem.nodeName;
	  return nodeName && nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
	}
	
	function getTargetInstForClickEvent(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topClick') {
	    return getInstIfValueChanged(targetInst, nativeEvent);
	  }
	}
	
	function getTargetInstForInputOrChangeEvent(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topInput' || topLevelType === 'topChange') {
	    return getInstIfValueChanged(targetInst, nativeEvent);
	  }
	}
	
	function handleControlledInputBlur(inst, node) {
	  // TODO: In IE, inst is occasionally null. Why?
	  if (inst == null) {
	    return;
	  }
	
	  // Fiber and ReactDOM keep wrapper state in separate places
	  var state = inst._wrapperState || node._wrapperState;
	
	  if (!state || !state.controlled || node.type !== 'number') {
	    return;
	  }
	
	  // If controlled, assign the value attribute to the current value on blur
	  var value = '' + node.value;
	  if (node.getAttribute('value') !== value) {
	    node.setAttribute('value', value);
	  }
	}
	
	/**
	 * This plugin creates an `onChange` event that normalizes change events
	 * across form elements. This event fires at a time when it's possible to
	 * change the element's value without seeing a flicker.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - select
	 */
	var ChangeEventPlugin = {
	  eventTypes: eventTypes,
	
	  _allowSimulatedPassThrough: true,
	  _isInputEventSupported: isInputEventSupported,
	
	  extractEvents: function extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    var getTargetInstFunc, handleEventFunc;
	    if (shouldUseChangeEvent(targetNode)) {
	      if (doesChangeEventBubble) {
	        getTargetInstFunc = getTargetInstForChangeEvent;
	      } else {
	        handleEventFunc = handleEventsForChangeEventIE8;
	      }
	    } else if (isTextInputElement(targetNode)) {
	      if (isInputEventSupported) {
	        getTargetInstFunc = getTargetInstForInputOrChangeEvent;
	      } else {
	        getTargetInstFunc = getTargetInstForInputEventPolyfill;
	        handleEventFunc = handleEventsForInputEventPolyfill;
	      }
	    } else if (shouldUseClickEvent(targetNode)) {
	      getTargetInstFunc = getTargetInstForClickEvent;
	    }
	
	    if (getTargetInstFunc) {
	      var inst = getTargetInstFunc(topLevelType, targetInst, nativeEvent);
	      if (inst) {
	        var event = createAndAccumulateChangeEvent(inst, nativeEvent, nativeEventTarget);
	        return event;
	      }
	    }
	
	    if (handleEventFunc) {
	      handleEventFunc(topLevelType, targetNode, targetInst);
	    }
	
	    // When blurring, set the value attribute for number inputs
	    if (topLevelType === 'topBlur') {
	      handleControlledInputBlur(targetInst, targetNode);
	    }
	  }
	};
	
	module.exports = ChangeEventPlugin;

/***/ },
/* 828 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(12);
	
	var DOMLazyTree = __webpack_require__(83);
	var ExecutionEnvironment = __webpack_require__(32);
	
	var createNodesFromMarkup = __webpack_require__(775);
	var emptyFunction = __webpack_require__(41);
	var invariant = __webpack_require__(5);
	
	var Danger = {
	  /**
	   * Replaces a node with a string of markup at its current position within its
	   * parent. The markup must render into a single root node.
	   *
	   * @param {DOMElement} oldChild Child node to replace.
	   * @param {string} markup Markup to render in place of the child node.
	   * @internal
	   */
	  dangerouslyReplaceNodeWithMarkup: function dangerouslyReplaceNodeWithMarkup(oldChild, markup) {
	    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
	    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
	    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;
	
	    if (typeof markup === 'string') {
	      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
	      oldChild.parentNode.replaceChild(newChild, oldChild);
	    } else {
	      DOMLazyTree.replaceChildWithTree(oldChild, markup);
	    }
	  }
	};
	
	module.exports = Danger;

/***/ },
/* 829 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Module that is injectable into `EventPluginHub`, that specifies a
	 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
	 * plugins, without having to package every one of them. This is better than
	 * having plugins be ordered in the same order that they are injected because
	 * that ordering would be influenced by the packaging order.
	 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
	 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
	 */
	
	var DefaultEventPluginOrder = ['ResponderEventPlugin', 'SimpleEventPlugin', 'TapEventPlugin', 'EnterLeaveEventPlugin', 'ChangeEventPlugin', 'SelectEventPlugin', 'BeforeInputEventPlugin'];
	
	module.exports = DefaultEventPluginOrder;

/***/ },
/* 830 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(96);
	var ReactDOMComponentTree = __webpack_require__(23);
	var SyntheticMouseEvent = __webpack_require__(123);
	
	var eventTypes = {
	  mouseEnter: {
	    registrationName: 'onMouseEnter',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  },
	  mouseLeave: {
	    registrationName: 'onMouseLeave',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  }
	};
	
	var EnterLeaveEventPlugin = {
	  eventTypes: eventTypes,
	
	  /**
	   * For almost every interaction we care about, there will be both a top-level
	   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
	   * we do not extract duplicate events. However, moving the mouse into the
	   * browser from outside will not fire a `mouseout` event. In this case, we use
	   * the `mouseover` top-level event.
	   */
	  extractEvents: function extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (topLevelType === 'topMouseOver' && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
	      return null;
	    }
	    if (topLevelType !== 'topMouseOut' && topLevelType !== 'topMouseOver') {
	      // Must not be a mouse in or mouse out - ignoring.
	      return null;
	    }
	
	    var win;
	    if (nativeEventTarget.window === nativeEventTarget) {
	      // `nativeEventTarget` is probably a window object.
	      win = nativeEventTarget;
	    } else {
	      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	      var doc = nativeEventTarget.ownerDocument;
	      if (doc) {
	        win = doc.defaultView || doc.parentWindow;
	      } else {
	        win = window;
	      }
	    }
	
	    var from;
	    var to;
	    if (topLevelType === 'topMouseOut') {
	      from = targetInst;
	      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
	      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
	    } else {
	      // Moving to a node from outside the window.
	      from = null;
	      to = targetInst;
	    }
	
	    if (from === to) {
	      // Nothing pertains to our managed components.
	      return null;
	    }
	
	    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
	    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);
	
	    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
	    leave.type = 'mouseleave';
	    leave.target = fromNode;
	    leave.relatedTarget = toNode;
	
	    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
	    enter.type = 'mouseenter';
	    enter.target = toNode;
	    enter.relatedTarget = fromNode;
	
	    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);
	
	    return [leave, enter];
	  }
	};
	
	module.exports = EnterLeaveEventPlugin;

/***/ },
/* 831 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(11);
	
	var PooledClass = __webpack_require__(75);
	
	var getTextContentAccessor = __webpack_require__(380);
	
	/**
	 * This helper class stores information about text content of a target node,
	 * allowing comparison of content before and after a given event.
	 *
	 * Identify the node where selection currently begins, then observe
	 * both its text content and its current position in the DOM. Since the
	 * browser may natively replace the target node during composition, we can
	 * use its position to find its replacement.
	 *
	 * @param {DOMEventTarget} root
	 */
	function FallbackCompositionState(root) {
	  this._root = root;
	  this._startText = this.getText();
	  this._fallbackText = null;
	}
	
	_assign(FallbackCompositionState.prototype, {
	  destructor: function destructor() {
	    this._root = null;
	    this._startText = null;
	    this._fallbackText = null;
	  },
	
	  /**
	   * Get current text of input.
	   *
	   * @return {string}
	   */
	  getText: function getText() {
	    if ('value' in this._root) {
	      return this._root.value;
	    }
	    return this._root[getTextContentAccessor()];
	  },
	
	  /**
	   * Determine the differing substring between the initially stored
	   * text content and the current content.
	   *
	   * @return {string}
	   */
	  getData: function getData() {
	    if (this._fallbackText) {
	      return this._fallbackText;
	    }
	
	    var start;
	    var startValue = this._startText;
	    var startLength = startValue.length;
	    var end;
	    var endValue = this.getText();
	    var endLength = endValue.length;
	
	    for (start = 0; start < startLength; start++) {
	      if (startValue[start] !== endValue[start]) {
	        break;
	      }
	    }
	
	    var minEnd = startLength - start;
	    for (end = 1; end <= minEnd; end++) {
	      if (startValue[startLength - end] !== endValue[endLength - end]) {
	        break;
	      }
	    }
	
	    var sliceTail = end > 1 ? 1 - end : undefined;
	    this._fallbackText = endValue.slice(start, sliceTail);
	    return this._fallbackText;
	  }
	});
	
	PooledClass.addPoolingTo(FallbackCompositionState);
	
	module.exports = FallbackCompositionState;

/***/ },
/* 832 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(84);
	
	var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
	var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
	var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
	var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
	var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;
	
	var HTMLDOMPropertyConfig = {
	  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
	  Properties: {
	    /**
	     * Standard Properties
	     */
	    accept: 0,
	    acceptCharset: 0,
	    accessKey: 0,
	    action: 0,
	    allowFullScreen: HAS_BOOLEAN_VALUE,
	    allowTransparency: 0,
	    alt: 0,
	    // specifies target context for links with `preload` type
	    as: 0,
	    async: HAS_BOOLEAN_VALUE,
	    autoComplete: 0,
	    // autoFocus is polyfilled/normalized by AutoFocusUtils
	    // autoFocus: HAS_BOOLEAN_VALUE,
	    autoPlay: HAS_BOOLEAN_VALUE,
	    capture: HAS_BOOLEAN_VALUE,
	    cellPadding: 0,
	    cellSpacing: 0,
	    charSet: 0,
	    challenge: 0,
	    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    cite: 0,
	    classID: 0,
	    className: 0,
	    cols: HAS_POSITIVE_NUMERIC_VALUE,
	    colSpan: 0,
	    content: 0,
	    contentEditable: 0,
	    contextMenu: 0,
	    controls: HAS_BOOLEAN_VALUE,
	    coords: 0,
	    crossOrigin: 0,
	    data: 0, // For `<object />` acts as `src`.
	    dateTime: 0,
	    'default': HAS_BOOLEAN_VALUE,
	    defer: HAS_BOOLEAN_VALUE,
	    dir: 0,
	    disabled: HAS_BOOLEAN_VALUE,
	    download: HAS_OVERLOADED_BOOLEAN_VALUE,
	    draggable: 0,
	    encType: 0,
	    form: 0,
	    formAction: 0,
	    formEncType: 0,
	    formMethod: 0,
	    formNoValidate: HAS_BOOLEAN_VALUE,
	    formTarget: 0,
	    frameBorder: 0,
	    headers: 0,
	    height: 0,
	    hidden: HAS_BOOLEAN_VALUE,
	    high: 0,
	    href: 0,
	    hrefLang: 0,
	    htmlFor: 0,
	    httpEquiv: 0,
	    icon: 0,
	    id: 0,
	    inputMode: 0,
	    integrity: 0,
	    is: 0,
	    keyParams: 0,
	    keyType: 0,
	    kind: 0,
	    label: 0,
	    lang: 0,
	    list: 0,
	    loop: HAS_BOOLEAN_VALUE,
	    low: 0,
	    manifest: 0,
	    marginHeight: 0,
	    marginWidth: 0,
	    max: 0,
	    maxLength: 0,
	    media: 0,
	    mediaGroup: 0,
	    method: 0,
	    min: 0,
	    minLength: 0,
	    // Caution; `option.selected` is not updated if `select.multiple` is
	    // disabled with `removeAttribute`.
	    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    name: 0,
	    nonce: 0,
	    noValidate: HAS_BOOLEAN_VALUE,
	    open: HAS_BOOLEAN_VALUE,
	    optimum: 0,
	    pattern: 0,
	    placeholder: 0,
	    playsInline: HAS_BOOLEAN_VALUE,
	    poster: 0,
	    preload: 0,
	    profile: 0,
	    radioGroup: 0,
	    readOnly: HAS_BOOLEAN_VALUE,
	    referrerPolicy: 0,
	    rel: 0,
	    required: HAS_BOOLEAN_VALUE,
	    reversed: HAS_BOOLEAN_VALUE,
	    role: 0,
	    rows: HAS_POSITIVE_NUMERIC_VALUE,
	    rowSpan: HAS_NUMERIC_VALUE,
	    sandbox: 0,
	    scope: 0,
	    scoped: HAS_BOOLEAN_VALUE,
	    scrolling: 0,
	    seamless: HAS_BOOLEAN_VALUE,
	    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    shape: 0,
	    size: HAS_POSITIVE_NUMERIC_VALUE,
	    sizes: 0,
	    span: HAS_POSITIVE_NUMERIC_VALUE,
	    spellCheck: 0,
	    src: 0,
	    srcDoc: 0,
	    srcLang: 0,
	    srcSet: 0,
	    start: HAS_NUMERIC_VALUE,
	    step: 0,
	    style: 0,
	    summary: 0,
	    tabIndex: 0,
	    target: 0,
	    title: 0,
	    // Setting .type throws on non-<input> tags
	    type: 0,
	    useMap: 0,
	    value: 0,
	    width: 0,
	    wmode: 0,
	    wrap: 0,
	
	    /**
	     * RDFa Properties
	     */
	    about: 0,
	    datatype: 0,
	    inlist: 0,
	    prefix: 0,
	    // property is also supported for OpenGraph in meta tags.
	    property: 0,
	    resource: 0,
	    'typeof': 0,
	    vocab: 0,
	
	    /**
	     * Non-standard Properties
	     */
	    // autoCapitalize and autoCorrect are supported in Mobile Safari for
	    // keyboard hints.
	    autoCapitalize: 0,
	    autoCorrect: 0,
	    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
	    autoSave: 0,
	    // color is for Safari mask-icon link
	    color: 0,
	    // itemProp, itemScope, itemType are for
	    // Microdata support. See http://schema.org/docs/gs.html
	    itemProp: 0,
	    itemScope: HAS_BOOLEAN_VALUE,
	    itemType: 0,
	    // itemID and itemRef are for Microdata support as well but
	    // only specified in the WHATWG spec document. See
	    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
	    itemID: 0,
	    itemRef: 0,
	    // results show looking glass icon and recent searches on input
	    // search fields in WebKit/Blink
	    results: 0,
	    // IE-only attribute that specifies security restrictions on an iframe
	    // as an alternative to the sandbox attribute on IE<10
	    security: 0,
	    // IE-only attribute that controls focus behavior
	    unselectable: 0
	  },
	  DOMAttributeNames: {
	    acceptCharset: 'accept-charset',
	    className: 'class',
	    htmlFor: 'for',
	    httpEquiv: 'http-equiv'
	  },
	  DOMPropertyNames: {},
	  DOMMutationMethods: {
	    value: function value(node, _value) {
	      if (_value == null) {
	        return node.removeAttribute('value');
	      }
	
	      // Number inputs get special treatment due to some edge cases in
	      // Chrome. Let everything else assign the value attribute as normal.
	      // https://github.com/facebook/react/issues/7253#issuecomment-236074326
	      if (node.type !== 'number' || node.hasAttribute('value') === false) {
	        node.setAttribute('value', '' + _value);
	      } else if (node.validity && !node.validity.badInput && node.ownerDocument.activeElement !== node) {
	        // Don't assign an attribute if validation reports bad
	        // input. Chrome will clear the value. Additionally, don't
	        // operate on inputs that have focus, otherwise Chrome might
	        // strip off trailing decimal places and cause the user's
	        // cursor position to jump to the beginning of the input.
	        //
	        // In ReactDOMInput, we have an onBlur event that will trigger
	        // this function again when focus is lost.
	        node.setAttribute('value', '' + _value);
	      }
	    }
	  }
	};
	
	module.exports = HTMLDOMPropertyConfig;

/***/ },
/* 833 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactReconciler = __webpack_require__(85);
	
	var instantiateReactComponent = __webpack_require__(382);
	var KeyEscapeUtils = __webpack_require__(169);
	var shouldUpdateReactComponent = __webpack_require__(179);
	var traverseAllChildren = __webpack_require__(385);
	var warning = __webpack_require__(9);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && process.env && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(387);
	}
	
	function instantiateChild(childInstances, child, name, selfDebugID) {
	  // We found a component instance.
	  var keyUnique = childInstances[name] === undefined;
	  if (false) {
	    if (!ReactComponentTreeHook) {
	      ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	    }
	    if (!keyUnique) {
	      process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	    }
	  }
	  if (child != null && keyUnique) {
	    childInstances[name] = instantiateReactComponent(child, true);
	  }
	}
	
	/**
	 * ReactChildReconciler provides helpers for initializing or updating a set of
	 * children. Its output is suitable for passing it onto ReactMultiChild which
	 * does diffed reordering and insertion.
	 */
	var ReactChildReconciler = {
	  /**
	   * Generates a "mount image" for each of the supplied children. In the case
	   * of `ReactDOMComponent`, a mount image is a string of markup.
	   *
	   * @param {?object} nestedChildNodes Nested child maps.
	   * @return {?object} A set of child instances.
	   * @internal
	   */
	  instantiateChildren: function instantiateChildren(nestedChildNodes, transaction, context, selfDebugID) // 0 in production and for roots
	  {
	    if (nestedChildNodes == null) {
	      return null;
	    }
	    var childInstances = {};
	
	    if (false) {
	      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
	        return instantiateChild(childInsts, child, name, selfDebugID);
	      }, childInstances);
	    } else {
	      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
	    }
	    return childInstances;
	  },
	
	  /**
	   * Updates the rendered children and returns a new set of children.
	   *
	   * @param {?object} prevChildren Previously initialized set of children.
	   * @param {?object} nextChildren Flat child element maps.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @return {?object} A new set of child instances.
	   * @internal
	   */
	  updateChildren: function updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID) // 0 in production and for roots
	  {
	    // We currently don't have a way to track moves here but if we use iterators
	    // instead of for..in we can zip the iterators and check if an item has
	    // moved.
	    // TODO: If nothing has changed, return the prevChildren object so that we
	    // can quickly bailout if nothing has changed.
	    if (!nextChildren && !prevChildren) {
	      return;
	    }
	    var name;
	    var prevChild;
	    for (name in nextChildren) {
	      if (!nextChildren.hasOwnProperty(name)) {
	        continue;
	      }
	      prevChild = prevChildren && prevChildren[name];
	      var prevElement = prevChild && prevChild._currentElement;
	      var nextElement = nextChildren[name];
	      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
	        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
	        nextChildren[name] = prevChild;
	      } else {
	        if (prevChild) {
	          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	          ReactReconciler.unmountComponent(prevChild, false);
	        }
	        // The child must be instantiated before it's mounted.
	        var nextChildInstance = instantiateReactComponent(nextElement, true);
	        nextChildren[name] = nextChildInstance;
	        // Creating mount image now ensures refs are resolved in right order
	        // (see https://github.com/facebook/react/pull/7101 for explanation).
	        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
	        mountImages.push(nextChildMountImage);
	      }
	    }
	    // Unmount children that are no longer present.
	    for (name in prevChildren) {
	      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
	        prevChild = prevChildren[name];
	        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	        ReactReconciler.unmountComponent(prevChild, false);
	      }
	    }
	  },
	
	  /**
	   * Unmounts all rendered children. This should be used to clean up children
	   * when this component is unmounted.
	   *
	   * @param {?object} renderedChildren Previously initialized set of children.
	   * @internal
	   */
	  unmountChildren: function unmountChildren(renderedChildren, safely) {
	    for (var name in renderedChildren) {
	      if (renderedChildren.hasOwnProperty(name)) {
	        var renderedChild = renderedChildren[name];
	        ReactReconciler.unmountComponent(renderedChild, safely);
	      }
	    }
	  }
	};
	
	module.exports = ReactChildReconciler;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(121)))

/***/ },
/* 834 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(165);
	var ReactDOMIDOperations = __webpack_require__(841);
	
	/**
	 * Abstracts away all functionality of the reconciler that requires knowledge of
	 * the browser context. TODO: These callers should be refactored to avoid the
	 * need for this injection.
	 */
	var ReactComponentBrowserEnvironment = {
	  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,
	
	  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup
	};
	
	module.exports = ReactComponentBrowserEnvironment;

/***/ },
/* 835 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _prodInvariant = __webpack_require__(12),
	    _assign = __webpack_require__(11);
	
	var React = __webpack_require__(86);
	var ReactComponentEnvironment = __webpack_require__(171);
	var ReactCurrentOwner = __webpack_require__(57);
	var ReactErrorUtils = __webpack_require__(172);
	var ReactInstanceMap = __webpack_require__(97);
	var ReactInstrumentation = __webpack_require__(46);
	var ReactNodeTypes = __webpack_require__(375);
	var ReactReconciler = __webpack_require__(85);
	
	if (false) {
	  var checkReactTypeSpec = require('./checkReactTypeSpec');
	}
	
	var emptyObject = __webpack_require__(120);
	var invariant = __webpack_require__(5);
	var shallowEqual = __webpack_require__(164);
	var shouldUpdateReactComponent = __webpack_require__(179);
	var warning = __webpack_require__(9);
	
	var CompositeTypes = {
	  ImpureClass: 0,
	  PureClass: 1,
	  StatelessFunctional: 2
	};
	
	function StatelessComponent(Component) {}
	StatelessComponent.prototype.render = function () {
	  var Component = ReactInstanceMap.get(this)._currentElement.type;
	  var element = Component(this.props, this.context, this.updater);
	  warnIfInvalidElement(Component, element);
	  return element;
	};
	
	function warnIfInvalidElement(Component, element) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || React.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
	  }
	}
	
	function shouldConstruct(Component) {
	  return !!(Component.prototype && Component.prototype.isReactComponent);
	}
	
	function isPureComponent(Component) {
	  return !!(Component.prototype && Component.prototype.isPureReactComponent);
	}
	
	// Separated into a function to contain deoptimizations caused by try/finally.
	function measureLifeCyclePerf(fn, debugID, timerType) {
	  if (debugID === 0) {
	    // Top-level wrappers (see ReactMount) and empty components (see
	    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
	    // Both are implementation details that should go away in the future.
	    return fn();
	  }
	
	  ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
	  try {
	    return fn();
	  } finally {
	    ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
	  }
	}
	
	/**
	 * ------------------ The Life-Cycle of a Composite Component ------------------
	 *
	 * - constructor: Initialization of state. The instance is now retained.
	 *   - componentWillMount
	 *   - render
	 *   - [children's constructors]
	 *     - [children's componentWillMount and render]
	 *     - [children's componentDidMount]
	 *     - componentDidMount
	 *
	 *       Update Phases:
	 *       - componentWillReceiveProps (only called if parent updated)
	 *       - shouldComponentUpdate
	 *         - componentWillUpdate
	 *           - render
	 *           - [children's constructors or receive props phases]
	 *         - componentDidUpdate
	 *
	 *     - componentWillUnmount
	 *     - [children's componentWillUnmount]
	 *   - [children destroyed]
	 * - (destroyed): The instance is now blank, released by React and ready for GC.
	 *
	 * -----------------------------------------------------------------------------
	 */
	
	/**
	 * An incrementing ID assigned to each component when it is mounted. This is
	 * used to enforce the order in which `ReactUpdates` updates dirty components.
	 *
	 * @private
	 */
	var nextMountID = 1;
	
	/**
	 * @lends {ReactCompositeComponent.prototype}
	 */
	var ReactCompositeComponent = {
	  /**
	   * Base constructor for all composite component.
	   *
	   * @param {ReactElement} element
	   * @final
	   * @internal
	   */
	  construct: function construct(element) {
	    this._currentElement = element;
	    this._rootNodeID = 0;
	    this._compositeType = null;
	    this._instance = null;
	    this._hostParent = null;
	    this._hostContainerInfo = null;
	
	    // See ReactUpdateQueue
	    this._updateBatchNumber = null;
	    this._pendingElement = null;
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    this._renderedNodeType = null;
	    this._renderedComponent = null;
	    this._context = null;
	    this._mountOrder = 0;
	    this._topLevelWrapper = null;
	
	    // See ReactUpdates and ReactUpdateQueue.
	    this._pendingCallbacks = null;
	
	    // ComponentWillUnmount shall only be called once
	    this._calledComponentWillUnmount = false;
	
	    if (false) {
	      this._warnedAboutRefsInRender = false;
	    }
	  },
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} hostParent
	   * @param {?object} hostContainerInfo
	   * @param {?object} context
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function mountComponent(transaction, hostParent, hostContainerInfo, context) {
	    var _this = this;
	
	    this._context = context;
	    this._mountOrder = nextMountID++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var publicProps = this._currentElement.props;
	    var publicContext = this._processContext(context);
	
	    var Component = this._currentElement.type;
	
	    var updateQueue = transaction.getUpdateQueue();
	
	    // Initialize the public class
	    var doConstruct = shouldConstruct(Component);
	    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
	    var renderedElement;
	
	    // Support functional components
	    if (!doConstruct && (inst == null || inst.render == null)) {
	      renderedElement = inst;
	      warnIfInvalidElement(Component, renderedElement);
	      !(inst === null || inst === false || React.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
	      inst = new StatelessComponent(Component);
	      this._compositeType = CompositeTypes.StatelessFunctional;
	    } else {
	      if (isPureComponent(Component)) {
	        this._compositeType = CompositeTypes.PureClass;
	      } else {
	        this._compositeType = CompositeTypes.ImpureClass;
	      }
	    }
	
	    if (false) {
	      // This will throw later in _renderValidatedComponent, but add an early
	      // warning now to help debugging
	      if (inst.render == null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
	      }
	
	      var propsMutated = inst.props !== publicProps;
	      var componentName = Component.displayName || Component.name || 'Component';
	
	      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + "up the same props that your component's constructor was passed.", componentName, componentName) : void 0;
	    }
	
	    // These should be set up in the constructor, but as a convenience for
	    // simpler class abstractions, we set them up after the fact.
	    inst.props = publicProps;
	    inst.context = publicContext;
	    inst.refs = emptyObject;
	    inst.updater = updateQueue;
	
	    this._instance = inst;
	
	    // Store a reference from the instance back to the internal representation
	    ReactInstanceMap.set(inst, this);
	
	    if (false) {
	      // Since plain JS classes are defined without any special initialization
	      // logic, we can not catch common errors early. Therefore, we have to
	      // catch them here, at initialization time, instead.
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved || inst.state, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
	    }
	
	    var initialState = inst.state;
	    if (initialState === undefined) {
	      inst.state = initialState = null;
	    }
	    !((typeof initialState === 'undefined' ? 'undefined' : _typeof(initialState)) === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    var markup;
	    if (inst.unstable_handleError) {
	      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } else {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	
	    if (inst.componentDidMount) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(function () {
	            return inst.componentDidMount();
	          }, _this._debugID, 'componentDidMount');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
	      }
	    }
	
	    return markup;
	  },
	
	  _constructComponent: function _constructComponent(doConstruct, publicProps, publicContext, updateQueue) {
	    if (false) {
	      ReactCurrentOwner.current = this;
	      try {
	        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	    }
	  },
	
	  _constructComponentWithoutOwner: function _constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue) {
	    var Component = this._currentElement.type;
	
	    if (doConstruct) {
	      if (false) {
	        return measureLifeCyclePerf(function () {
	          return new Component(publicProps, publicContext, updateQueue);
	        }, this._debugID, 'ctor');
	      } else {
	        return new Component(publicProps, publicContext, updateQueue);
	      }
	    }
	
	    // This can still be an instance in case of factory components
	    // but we'll count this as time spent rendering as the more common case.
	    if (false) {
	      return measureLifeCyclePerf(function () {
	        return Component(publicProps, publicContext, updateQueue);
	      }, this._debugID, 'render');
	    } else {
	      return Component(publicProps, publicContext, updateQueue);
	    }
	  },
	
	  performInitialMountWithErrorHandling: function performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var markup;
	    var checkpoint = transaction.checkpoint();
	    try {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } catch (e) {
	      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
	      transaction.rollback(checkpoint);
	      this._instance.unstable_handleError(e);
	      if (this._pendingStateQueue) {
	        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
	      }
	      checkpoint = transaction.checkpoint();
	
	      this._renderedComponent.unmountComponent(true);
	      transaction.rollback(checkpoint);
	
	      // Try again - we've informed the component about the error, so they can render an error message this time.
	      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	    return markup;
	  },
	
	  performInitialMount: function performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var inst = this._instance;
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (inst.componentWillMount) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillMount();
	        }, debugID, 'componentWillMount');
	      } else {
	        inst.componentWillMount();
	      }
	      // When mounting, calls to `setState` by `componentWillMount` will set
	      // `this._pendingStateQueue` without triggering a re-render.
	      if (this._pendingStateQueue) {
	        inst.state = this._processPendingState(inst.props, inst.context);
	      }
	    }
	
	    // If not a stateless component, we now render
	    if (renderedElement === undefined) {
	      renderedElement = this._renderValidatedComponent();
	    }
	
	    var nodeType = ReactNodeTypes.getType(renderedElement);
	    this._renderedNodeType = nodeType;
	    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	    );
	    this._renderedComponent = child;
	
	    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);
	
	    if (false) {
	      if (debugID !== 0) {
	        var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	        ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	      }
	    }
	
	    return markup;
	  },
	
	  getHostNode: function getHostNode() {
	    return ReactReconciler.getHostNode(this._renderedComponent);
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function unmountComponent(safely) {
	    if (!this._renderedComponent) {
	      return;
	    }
	
	    var inst = this._instance;
	
	    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
	      inst._calledComponentWillUnmount = true;
	
	      if (safely) {
	        var name = this.getName() + '.componentWillUnmount()';
	        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
	      } else {
	        if (false) {
	          measureLifeCyclePerf(function () {
	            return inst.componentWillUnmount();
	          }, this._debugID, 'componentWillUnmount');
	        } else {
	          inst.componentWillUnmount();
	        }
	      }
	    }
	
	    if (this._renderedComponent) {
	      ReactReconciler.unmountComponent(this._renderedComponent, safely);
	      this._renderedNodeType = null;
	      this._renderedComponent = null;
	      this._instance = null;
	    }
	
	    // Reset pending fields
	    // Even if this component is scheduled for another update in ReactUpdates,
	    // it would still be ignored because these fields are reset.
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	    this._pendingCallbacks = null;
	    this._pendingElement = null;
	
	    // These fields do not really need to be reset since this object is no
	    // longer accessible.
	    this._context = null;
	    this._rootNodeID = 0;
	    this._topLevelWrapper = null;
	
	    // Delete the reference from the instance to this internal representation
	    // which allow the internals to be properly cleaned up even if the user
	    // leaks a reference to the public instance.
	    ReactInstanceMap.remove(inst);
	
	    // Some existing components rely on inst.props even after they've been
	    // destroyed (in event handlers).
	    // TODO: inst.props = null;
	    // TODO: inst.state = null;
	    // TODO: inst.context = null;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _maskContext: function _maskContext(context) {
	    var Component = this._currentElement.type;
	    var contextTypes = Component.contextTypes;
	    if (!contextTypes) {
	      return emptyObject;
	    }
	    var maskedContext = {};
	    for (var contextName in contextTypes) {
	      maskedContext[contextName] = context[contextName];
	    }
	    return maskedContext;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`, and asserts that they are valid.
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _processContext: function _processContext(context) {
	    var maskedContext = this._maskContext(context);
	    if (false) {
	      var Component = this._currentElement.type;
	      if (Component.contextTypes) {
	        this._checkContextTypes(Component.contextTypes, maskedContext, 'context');
	      }
	    }
	    return maskedContext;
	  },
	
	  /**
	   * @param {object} currentContext
	   * @return {object}
	   * @private
	   */
	  _processChildContext: function _processChildContext(currentContext) {
	    var Component = this._currentElement.type;
	    var inst = this._instance;
	    var childContext;
	
	    if (inst.getChildContext) {
	      if (false) {
	        ReactInstrumentation.debugTool.onBeginProcessingChildContext();
	        try {
	          childContext = inst.getChildContext();
	        } finally {
	          ReactInstrumentation.debugTool.onEndProcessingChildContext();
	        }
	      } else {
	        childContext = inst.getChildContext();
	      }
	    }
	
	    if (childContext) {
	      !(_typeof(Component.childContextTypes) === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
	      if (false) {
	        this._checkContextTypes(Component.childContextTypes, childContext, 'child context');
	      }
	      for (var name in childContext) {
	        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
	      }
	      return _assign({}, currentContext, childContext);
	    }
	    return currentContext;
	  },
	
	  /**
	   * Assert that the context types are valid
	   *
	   * @param {object} typeSpecs Map of context field to a ReactPropType
	   * @param {object} values Runtime values that need to be type-checked
	   * @param {string} location e.g. "prop", "context", "child context"
	   * @private
	   */
	  _checkContextTypes: function _checkContextTypes(typeSpecs, values, location) {
	    if (false) {
	      checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
	    }
	  },
	
	  receiveComponent: function receiveComponent(nextElement, transaction, nextContext) {
	    var prevElement = this._currentElement;
	    var prevContext = this._context;
	
	    this._pendingElement = null;
	
	    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
	  },
	
	  /**
	   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
	   * is set, update the component.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function performUpdateIfNecessary(transaction) {
	    if (this._pendingElement != null) {
	      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
	    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
	      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
	    } else {
	      this._updateBatchNumber = null;
	    }
	  },
	
	  /**
	   * Perform an update to a mounted component. The componentWillReceiveProps and
	   * shouldComponentUpdate methods are called, then (assuming the update isn't
	   * skipped) the remaining update lifecycle methods are called and the DOM
	   * representation is updated.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevParentElement
	   * @param {ReactElement} nextParentElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function updateComponent(transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
	    var inst = this._instance;
	    !(inst != null) ?  false ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    var willReceive = false;
	    var nextContext;
	
	    // Determine if the context has changed or not
	    if (this._context === nextUnmaskedContext) {
	      nextContext = inst.context;
	    } else {
	      nextContext = this._processContext(nextUnmaskedContext);
	      willReceive = true;
	    }
	
	    var prevProps = prevParentElement.props;
	    var nextProps = nextParentElement.props;
	
	    // Not a simple state update but a props update
	    if (prevParentElement !== nextParentElement) {
	      willReceive = true;
	    }
	
	    // An update here will schedule an update but immediately set
	    // _pendingStateQueue which will ensure that any state updates gets
	    // immediately reconciled instead of waiting for the next batch.
	    if (willReceive && inst.componentWillReceiveProps) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillReceiveProps(nextProps, nextContext);
	        }, this._debugID, 'componentWillReceiveProps');
	      } else {
	        inst.componentWillReceiveProps(nextProps, nextContext);
	      }
	    }
	
	    var nextState = this._processPendingState(nextProps, nextContext);
	    var shouldUpdate = true;
	
	    if (!this._pendingForceUpdate) {
	      if (inst.shouldComponentUpdate) {
	        if (false) {
	          shouldUpdate = measureLifeCyclePerf(function () {
	            return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	          }, this._debugID, 'shouldComponentUpdate');
	        } else {
	          shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	        }
	      } else {
	        if (this._compositeType === CompositeTypes.PureClass) {
	          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
	        }
	      }
	    }
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
	    }
	
	    this._updateBatchNumber = null;
	    if (shouldUpdate) {
	      this._pendingForceUpdate = false;
	      // Will set `this.props`, `this.state` and `this.context`.
	      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
	    } else {
	      // If it's determined that a component should not update, we still want
	      // to set props and state but we shortcut the rest of the update.
	      this._currentElement = nextParentElement;
	      this._context = nextUnmaskedContext;
	      inst.props = nextProps;
	      inst.state = nextState;
	      inst.context = nextContext;
	    }
	  },
	
	  _processPendingState: function _processPendingState(props, context) {
	    var inst = this._instance;
	    var queue = this._pendingStateQueue;
	    var replace = this._pendingReplaceState;
	    this._pendingReplaceState = false;
	    this._pendingStateQueue = null;
	
	    if (!queue) {
	      return inst.state;
	    }
	
	    if (replace && queue.length === 1) {
	      return queue[0];
	    }
	
	    var nextState = _assign({}, replace ? queue[0] : inst.state);
	    for (var i = replace ? 1 : 0; i < queue.length; i++) {
	      var partial = queue[i];
	      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
	    }
	
	    return nextState;
	  },
	
	  /**
	   * Merges new props and state, notifies delegate methods of update and
	   * performs update.
	   *
	   * @param {ReactElement} nextElement Next element
	   * @param {object} nextProps Next public object to set as properties.
	   * @param {?object} nextState Next object to set as state.
	   * @param {?object} nextContext Next public object to set as context.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {?object} unmaskedContext
	   * @private
	   */
	  _performComponentUpdate: function _performComponentUpdate(nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
	    var _this2 = this;
	
	    var inst = this._instance;
	
	    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
	    var prevProps;
	    var prevState;
	    var prevContext;
	    if (hasComponentDidUpdate) {
	      prevProps = inst.props;
	      prevState = inst.state;
	      prevContext = inst.context;
	    }
	
	    if (inst.componentWillUpdate) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillUpdate(nextProps, nextState, nextContext);
	        }, this._debugID, 'componentWillUpdate');
	      } else {
	        inst.componentWillUpdate(nextProps, nextState, nextContext);
	      }
	    }
	
	    this._currentElement = nextElement;
	    this._context = unmaskedContext;
	    inst.props = nextProps;
	    inst.state = nextState;
	    inst.context = nextContext;
	
	    this._updateRenderedComponent(transaction, unmaskedContext);
	
	    if (hasComponentDidUpdate) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
	      }
	    }
	  },
	
	  /**
	   * Call the component's `render` method and update the DOM accordingly.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  _updateRenderedComponent: function _updateRenderedComponent(transaction, context) {
	    var prevComponentInstance = this._renderedComponent;
	    var prevRenderedElement = prevComponentInstance._currentElement;
	    var nextRenderedElement = this._renderValidatedComponent();
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
	      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
	    } else {
	      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
	      ReactReconciler.unmountComponent(prevComponentInstance, false);
	
	      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
	      this._renderedNodeType = nodeType;
	      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	      );
	      this._renderedComponent = child;
	
	      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);
	
	      if (false) {
	        if (debugID !== 0) {
	          var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	          ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	        }
	      }
	
	      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
	    }
	  },
	
	  /**
	   * Overridden in shallow rendering.
	   *
	   * @protected
	   */
	  _replaceNodeWithMarkup: function _replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance) {
	    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
	  },
	
	  /**
	   * @protected
	   */
	  _renderValidatedComponentWithoutOwnerOrContext: function _renderValidatedComponentWithoutOwnerOrContext() {
	    var inst = this._instance;
	    var renderedElement;
	
	    if (false) {
	      renderedElement = measureLifeCyclePerf(function () {
	        return inst.render();
	      }, this._debugID, 'render');
	    } else {
	      renderedElement = inst.render();
	    }
	
	    if (false) {
	      // We allow auto-mocks to proceed as if they're returning null.
	      if (renderedElement === undefined && inst.render._isMockFunction) {
	        // This is probably bad practice. Consider warning here and
	        // deprecating this convenience.
	        renderedElement = null;
	      }
	    }
	
	    return renderedElement;
	  },
	
	  /**
	   * @private
	   */
	  _renderValidatedComponent: function _renderValidatedComponent() {
	    var renderedElement;
	    if (("production") !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
	      ReactCurrentOwner.current = this;
	      try {
	        renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	    }
	    !(
	    // TODO: An `isValidNode` function would probably be more appropriate
	    renderedElement === null || renderedElement === false || React.isValidElement(renderedElement)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    return renderedElement;
	  },
	
	  /**
	   * Lazily allocates the refs object and stores `component` as `ref`.
	   *
	   * @param {string} ref Reference name.
	   * @param {component} component Component to store as `ref`.
	   * @final
	   * @private
	   */
	  attachRef: function attachRef(ref, component) {
	    var inst = this.getPublicInstance();
	    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
	    var publicComponentInstance = component.getPublicInstance();
	    if (false) {
	      var componentName = component && component.getName ? component.getName() : 'a component';
	      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
	    }
	    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
	    refs[ref] = publicComponentInstance;
	  },
	
	  /**
	   * Detaches a reference name.
	   *
	   * @param {string} ref Name to dereference.
	   * @final
	   * @private
	   */
	  detachRef: function detachRef(ref) {
	    var refs = this.getPublicInstance().refs;
	    delete refs[ref];
	  },
	
	  /**
	   * Get a text description of the component that can be used to identify it
	   * in error messages.
	   * @return {string} The name or null.
	   * @internal
	   */
	  getName: function getName() {
	    var type = this._currentElement.type;
	    var constructor = this._instance && this._instance.constructor;
	    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
	  },
	
	  /**
	   * Get the publicly accessible representation of this component - i.e. what
	   * is exposed by refs and returned by render. Can be null for stateless
	   * components.
	   *
	   * @return {ReactComponent} the public component instance.
	   * @internal
	   */
	  getPublicInstance: function getPublicInstance() {
	    var inst = this._instance;
	    if (this._compositeType === CompositeTypes.StatelessFunctional) {
	      return null;
	    }
	    return inst;
	  },
	
	  // Stub
	  _instantiateReactComponent: null
	};
	
	module.exports = ReactCompositeComponent;

/***/ },
/* 836 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(23);
	var ReactDefaultInjection = __webpack_require__(849);
	var ReactMount = __webpack_require__(374);
	var ReactReconciler = __webpack_require__(85);
	var ReactUpdates = __webpack_require__(53);
	var ReactVersion = __webpack_require__(862);
	
	var findDOMNode = __webpack_require__(878);
	var getHostComponentFromComposite = __webpack_require__(379);
	var renderSubtreeIntoContainer = __webpack_require__(885);
	var warning = __webpack_require__(9);
	
	ReactDefaultInjection.inject();
	
	var ReactDOM = {
	  findDOMNode: findDOMNode,
	  render: ReactMount.render,
	  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
	  version: ReactVersion,
	
	  /* eslint-disable camelcase */
	  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
	  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
	  /* eslint-enable camelcase */
	};
	
	// Inject the runtime into a devtools global hook regardless of browser.
	// Allows for debugging when the hook is injected on the page.
	if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
	  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
	    ComponentTree: {
	      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
	      getNodeFromInstance: function getNodeFromInstance(inst) {
	        // inst is an internal instance (but could be a composite)
	        if (inst._renderedComponent) {
	          inst = getHostComponentFromComposite(inst);
	        }
	        if (inst) {
	          return ReactDOMComponentTree.getNodeFromInstance(inst);
	        } else {
	          return null;
	        }
	      }
	    },
	    Mount: ReactMount,
	    Reconciler: ReactReconciler
	  });
	}
	
	if (false) {
	  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
	  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
	    // First check if devtools is not installed
	    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
	      // If we're in Chrome or Firefox, provide a download link if not installed.
	      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
	        // Firefox does not have the issue with devtools loaded over file://
	        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
	        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
	      }
	    }
	
	    var testFunc = function testFn() {};
	    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, "It looks like you're using a minified copy of the development build " + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;
	
	    // If we're in IE8, check to see if we are in compatibility mode and provide
	    // information on preventing compatibility mode
	    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;
	
	    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;
	
	    var expectedFeatures = [
	    // shims
	    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.trim];
	
	    for (var i = 0; i < expectedFeatures.length; i++) {
	      if (!expectedFeatures[i]) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
	        break;
	      }
	    }
	  }
	}
	
	if (false) {
	  var ReactInstrumentation = require('./ReactInstrumentation');
	  var ReactDOMUnknownPropertyHook = require('./ReactDOMUnknownPropertyHook');
	  var ReactDOMNullInputValuePropHook = require('./ReactDOMNullInputValuePropHook');
	  var ReactDOMInvalidARIAHook = require('./ReactDOMInvalidARIAHook');
	
	  ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMInvalidARIAHook);
	}
	
	module.exports = ReactDOM;

/***/ },
/* 837 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/* global hasOwnProperty:true */
	
	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _prodInvariant = __webpack_require__(12),
	    _assign = __webpack_require__(11);
	
	var AutoFocusUtils = __webpack_require__(824);
	var CSSPropertyOperations = __webpack_require__(826);
	var DOMLazyTree = __webpack_require__(83);
	var DOMNamespaces = __webpack_require__(166);
	var DOMProperty = __webpack_require__(84);
	var DOMPropertyOperations = __webpack_require__(367);
	var EventPluginHub = __webpack_require__(95);
	var EventPluginRegistry = __webpack_require__(167);
	var ReactBrowserEventEmitter = __webpack_require__(122);
	var ReactDOMComponentFlags = __webpack_require__(368);
	var ReactDOMComponentTree = __webpack_require__(23);
	var ReactDOMInput = __webpack_require__(842);
	var ReactDOMOption = __webpack_require__(843);
	var ReactDOMSelect = __webpack_require__(369);
	var ReactDOMTextarea = __webpack_require__(846);
	var ReactInstrumentation = __webpack_require__(46);
	var ReactMultiChild = __webpack_require__(855);
	var ReactServerRenderingTransaction = __webpack_require__(860);
	
	var emptyFunction = __webpack_require__(41);
	var escapeTextContentForBrowser = __webpack_require__(125);
	var invariant = __webpack_require__(5);
	var isEventSupported = __webpack_require__(178);
	var shallowEqual = __webpack_require__(164);
	var inputValueTracking = __webpack_require__(381);
	var validateDOMNesting = __webpack_require__(180);
	var warning = __webpack_require__(9);
	
	var Flags = ReactDOMComponentFlags;
	var deleteListener = EventPluginHub.deleteListener;
	var getNode = ReactDOMComponentTree.getNodeFromInstance;
	var listenTo = ReactBrowserEventEmitter.listenTo;
	var registrationNameModules = EventPluginRegistry.registrationNameModules;
	
	// For quickly matching children type, to test if can be treated as content.
	var CONTENT_TYPES = { string: true, number: true };
	
	var STYLE = 'style';
	var HTML = '__html';
	var RESERVED_PROPS = {
	  children: null,
	  dangerouslySetInnerHTML: null,
	  suppressContentEditableWarning: null
	};
	
	// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
	var DOC_FRAGMENT_TYPE = 11;
	
	function getDeclarationErrorAddendum(internalInstance) {
	  if (internalInstance) {
	    var owner = internalInstance._currentElement._owner || null;
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' This DOM node was rendered by `' + name + '`.';
	      }
	    }
	  }
	  return '';
	}
	
	function friendlyStringify(obj) {
	  if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object') {
	    if (Array.isArray(obj)) {
	      return '[' + obj.map(friendlyStringify).join(', ') + ']';
	    } else {
	      var pairs = [];
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
	          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
	        }
	      }
	      return '{' + pairs.join(', ') + '}';
	    }
	  } else if (typeof obj === 'string') {
	    return JSON.stringify(obj);
	  } else if (typeof obj === 'function') {
	    return '[function object]';
	  }
	  // Differs from JSON.stringify in that undefined because undefined and that
	  // inf and nan don't become null
	  return String(obj);
	}
	
	var styleMutationWarning = {};
	
	function checkAndWarnForMutatedStyle(style1, style2, component) {
	  if (style1 == null || style2 == null) {
	    return;
	  }
	  if (shallowEqual(style1, style2)) {
	    return;
	  }
	
	  var componentName = component._tag;
	  var owner = component._currentElement._owner;
	  var ownerName;
	  if (owner) {
	    ownerName = owner.getName();
	  }
	
	  var hash = ownerName + '|' + componentName;
	
	  if (styleMutationWarning.hasOwnProperty(hash)) {
	    return;
	  }
	
	  styleMutationWarning[hash] = true;
	
	   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
	}
	
	/**
	 * @param {object} component
	 * @param {?object} props
	 */
	function assertValidProps(component, props) {
	  if (!props) {
	    return;
	  }
	  // Note the use of `==` which checks for null or undefined.
	  if (voidElementTags[component._tag]) {
	    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
	  }
	  if (props.dangerouslySetInnerHTML != null) {
	    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
	    !(_typeof(props.dangerouslySetInnerHTML) === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
	  }
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
	  }
	  !(props.style == null || _typeof(props.style) === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
	}
	
	function enqueuePutListener(inst, registrationName, listener, transaction) {
	  if (transaction instanceof ReactServerRenderingTransaction) {
	    return;
	  }
	  if (false) {
	    // IE8 has no API for event capturing and the `onScroll` event doesn't
	    // bubble.
	    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), "This browser doesn't support the `onScroll` event") : void 0;
	  }
	  var containerInfo = inst._hostContainerInfo;
	  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
	  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
	  listenTo(registrationName, doc);
	  transaction.getReactMountReady().enqueue(putListener, {
	    inst: inst,
	    registrationName: registrationName,
	    listener: listener
	  });
	}
	
	function putListener() {
	  var listenerToPut = this;
	  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
	}
	
	function inputPostMount() {
	  var inst = this;
	  ReactDOMInput.postMountWrapper(inst);
	}
	
	function textareaPostMount() {
	  var inst = this;
	  ReactDOMTextarea.postMountWrapper(inst);
	}
	
	function optionPostMount() {
	  var inst = this;
	  ReactDOMOption.postMountWrapper(inst);
	}
	
	var setAndValidateContentChildDev = emptyFunction;
	if (false) {
	  setAndValidateContentChildDev = function setAndValidateContentChildDev(content) {
	    var hasExistingContent = this._contentDebugID != null;
	    var debugID = this._debugID;
	    // This ID represents the inlined child that has no backing instance:
	    var contentDebugID = -debugID;
	
	    if (content == null) {
	      if (hasExistingContent) {
	        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
	      }
	      this._contentDebugID = null;
	      return;
	    }
	
	    validateDOMNesting(null, String(content), this, this._ancestorInfo);
	    this._contentDebugID = contentDebugID;
	    if (hasExistingContent) {
	      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
	      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
	    } else {
	      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
	      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
	      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
	    }
	  };
	}
	
	// There are so many media events, it makes sense to just
	// maintain a list rather than create a `trapBubbledEvent` for each
	var mediaEvents = {
	  topAbort: 'abort',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTimeUpdate: 'timeupdate',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting'
	};
	
	function trackInputValue() {
	  inputValueTracking.track(this);
	}
	
	function trapBubbledEventsLocal() {
	  var inst = this;
	  // If a component renders to null or if another component fatals and causes
	  // the state of the tree to be corrupted, `node` here can be null.
	  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
	  var node = getNode(inst);
	  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;
	
	  switch (inst._tag) {
	    case 'iframe':
	    case 'object':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'video':
	    case 'audio':
	      inst._wrapperState.listeners = [];
	      // Create listener for each media event
	      for (var event in mediaEvents) {
	        if (mediaEvents.hasOwnProperty(event)) {
	          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(event, mediaEvents[event], node));
	        }
	      }
	      break;
	    case 'source':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node)];
	      break;
	    case 'img':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node), ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'form':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topReset', 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent('topSubmit', 'submit', node)];
	      break;
	    case 'input':
	    case 'select':
	    case 'textarea':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topInvalid', 'invalid', node)];
	      break;
	  }
	}
	
	function postUpdateSelectWrapper() {
	  ReactDOMSelect.postUpdateWrapper(this);
	}
	
	// For HTML, certain tags should omit their close tag. We keep a whitelist for
	// those special-case tags.
	
	var omittedCloseTags = {
	  area: true,
	  base: true,
	  br: true,
	  col: true,
	  embed: true,
	  hr: true,
	  img: true,
	  input: true,
	  keygen: true,
	  link: true,
	  meta: true,
	  param: true,
	  source: true,
	  track: true,
	  wbr: true
	  // NOTE: menuitem's close tag should be omitted, but that causes problems.
	};
	
	var newlineEatingTags = {
	  listing: true,
	  pre: true,
	  textarea: true
	};
	
	// For HTML, certain tags cannot have children. This has the same purpose as
	// `omittedCloseTags` except that `menuitem` should still have its closing tag.
	
	var voidElementTags = _assign({
	  menuitem: true
	}, omittedCloseTags);
	
	// We accept any tag to be rendered but since this gets injected into arbitrary
	// HTML, we want to make sure that it's a safe tag.
	// http://www.w3.org/TR/REC-xml/#NT-Name
	
	var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
	var validatedTagCache = {};
	var hasOwnProperty = {}.hasOwnProperty;
	
	function validateDangerousTag(tag) {
	  if (!hasOwnProperty.call(validatedTagCache, tag)) {
	    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
	    validatedTagCache[tag] = true;
	  }
	}
	
	function isCustomComponent(tagName, props) {
	  return tagName.indexOf('-') >= 0 || props.is != null;
	}
	
	var globalIdCounter = 1;
	
	/**
	 * Creates a new React class that is idempotent and capable of containing other
	 * React components. It accepts event listeners and DOM properties that are
	 * valid according to `DOMProperty`.
	 *
	 *  - Event listeners: `onClick`, `onMouseDown`, etc.
	 *  - DOM properties: `className`, `name`, `title`, etc.
	 *
	 * The `style` property functions differently from the DOM API. It accepts an
	 * object mapping of style properties to values.
	 *
	 * @constructor ReactDOMComponent
	 * @extends ReactMultiChild
	 */
	function ReactDOMComponent(element) {
	  var tag = element.type;
	  validateDangerousTag(tag);
	  this._currentElement = element;
	  this._tag = tag.toLowerCase();
	  this._namespaceURI = null;
	  this._renderedChildren = null;
	  this._previousStyle = null;
	  this._previousStyleCopy = null;
	  this._hostNode = null;
	  this._hostParent = null;
	  this._rootNodeID = 0;
	  this._domID = 0;
	  this._hostContainerInfo = null;
	  this._wrapperState = null;
	  this._topLevelWrapper = null;
	  this._flags = 0;
	  if (false) {
	    this._ancestorInfo = null;
	    setAndValidateContentChildDev.call(this, null);
	  }
	}
	
	ReactDOMComponent.displayName = 'ReactDOMComponent';
	
	ReactDOMComponent.Mixin = {
	  /**
	   * Generates root tag markup then recurses. This method has side effects and
	   * is not idempotent.
	   *
	   * @internal
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?ReactDOMComponent} the parent component instance
	   * @param {?object} info about the host container
	   * @param {object} context
	   * @return {string} The computed markup.
	   */
	  mountComponent: function mountComponent(transaction, hostParent, hostContainerInfo, context) {
	    this._rootNodeID = globalIdCounter++;
	    this._domID = hostContainerInfo._idCounter++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var props = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        this._wrapperState = {
	          listeners: null
	        };
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'input':
	        ReactDOMInput.mountWrapper(this, props, hostParent);
	        props = ReactDOMInput.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trackInputValue, this);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'option':
	        ReactDOMOption.mountWrapper(this, props, hostParent);
	        props = ReactDOMOption.getHostProps(this, props);
	        break;
	      case 'select':
	        ReactDOMSelect.mountWrapper(this, props, hostParent);
	        props = ReactDOMSelect.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.mountWrapper(this, props, hostParent);
	        props = ReactDOMTextarea.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trackInputValue, this);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	    }
	
	    assertValidProps(this, props);
	
	    // We create tags in the namespace of their parent container, except HTML
	    // tags get no namespace.
	    var namespaceURI;
	    var parentTag;
	    if (hostParent != null) {
	      namespaceURI = hostParent._namespaceURI;
	      parentTag = hostParent._tag;
	    } else if (hostContainerInfo._tag) {
	      namespaceURI = hostContainerInfo._namespaceURI;
	      parentTag = hostContainerInfo._tag;
	    }
	    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
	      namespaceURI = DOMNamespaces.html;
	    }
	    if (namespaceURI === DOMNamespaces.html) {
	      if (this._tag === 'svg') {
	        namespaceURI = DOMNamespaces.svg;
	      } else if (this._tag === 'math') {
	        namespaceURI = DOMNamespaces.mathml;
	      }
	    }
	    this._namespaceURI = namespaceURI;
	
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo._tag) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(this._tag, null, this, parentInfo);
	      }
	      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
	    }
	
	    var mountImage;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var el;
	      if (namespaceURI === DOMNamespaces.html) {
	        if (this._tag === 'script') {
	          // Create the script via .innerHTML so its "parser-inserted" flag is
	          // set to true and it does not execute
	          var div = ownerDocument.createElement('div');
	          var type = this._currentElement.type;
	          div.innerHTML = '<' + type + '></' + type + '>';
	          el = div.removeChild(div.firstChild);
	        } else if (props.is) {
	          el = ownerDocument.createElement(this._currentElement.type, props.is);
	        } else {
	          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
	          // See discussion in https://github.com/facebook/react/pull/6896
	          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
	          el = ownerDocument.createElement(this._currentElement.type);
	        }
	      } else {
	        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
	      }
	      ReactDOMComponentTree.precacheNode(this, el);
	      this._flags |= Flags.hasCachedChildNodes;
	      if (!this._hostParent) {
	        DOMPropertyOperations.setAttributeForRoot(el);
	      }
	      this._updateDOMProperties(null, props, transaction);
	      var lazyTree = DOMLazyTree(el);
	      this._createInitialChildren(transaction, props, context, lazyTree);
	      mountImage = lazyTree;
	    } else {
	      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
	      var tagContent = this._createContentMarkup(transaction, props, context);
	      if (!tagContent && omittedCloseTags[this._tag]) {
	        mountImage = tagOpen + '/>';
	      } else {
	        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
	      }
	    }
	
	    switch (this._tag) {
	      case 'input':
	        transaction.getReactMountReady().enqueue(inputPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'textarea':
	        transaction.getReactMountReady().enqueue(textareaPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'select':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'button':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'option':
	        transaction.getReactMountReady().enqueue(optionPostMount, this);
	        break;
	    }
	
	    return mountImage;
	  },
	
	  /**
	   * Creates markup for the open tag and all attributes.
	   *
	   * This method has side effects because events get registered.
	   *
	   * Iterating over object properties is faster than iterating over arrays.
	   * @see http://jsperf.com/obj-vs-arr-iteration
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @return {string} Markup of opening tag.
	   */
	  _createOpenTagMarkupAndPutListeners: function _createOpenTagMarkupAndPutListeners(transaction, props) {
	    var ret = '<' + this._currentElement.type;
	
	    for (var propKey in props) {
	      if (!props.hasOwnProperty(propKey)) {
	        continue;
	      }
	      var propValue = props[propKey];
	      if (propValue == null) {
	        continue;
	      }
	      if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (propValue) {
	          enqueuePutListener(this, propKey, propValue, transaction);
	        }
	      } else {
	        if (propKey === STYLE) {
	          if (propValue) {
	            if (false) {
	              // See `_updateDOMProperties`. style block
	              this._previousStyle = propValue;
	            }
	            propValue = this._previousStyleCopy = _assign({}, props.style);
	          }
	          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
	        }
	        var markup = null;
	        if (this._tag != null && isCustomComponent(this._tag, props)) {
	          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
	          }
	        } else {
	          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
	        }
	        if (markup) {
	          ret += ' ' + markup;
	        }
	      }
	    }
	
	    // For static pages, no need to put React ID and checksum. Saves lots of
	    // bytes.
	    if (transaction.renderToStaticMarkup) {
	      return ret;
	    }
	
	    if (!this._hostParent) {
	      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
	    }
	    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
	    return ret;
	  },
	
	  /**
	   * Creates markup for the content between the tags.
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @param {object} context
	   * @return {string} Content markup.
	   */
	  _createContentMarkup: function _createContentMarkup(transaction, props, context) {
	    var ret = '';
	
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        ret = innerHTML.__html;
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[_typeof(props.children)] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        ret = escapeTextContentForBrowser(contentToUse);
	        if (false) {
	          setAndValidateContentChildDev.call(this, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        ret = mountImages.join('');
	      }
	    }
	    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
	      // text/html ignores the first character in these tags if it's a newline
	      // Prefer to break application/xml over text/html (for now) by adding
	      // a newline specifically to get eaten by the parser. (Alternately for
	      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
	      // \r is normalized out by HTMLTextAreaElement#value.)
	      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
	      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
	      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
	      // See: Parsing of "textarea" "listing" and "pre" elements
	      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
	      return '\n' + ret;
	    } else {
	      return ret;
	    }
	  },
	
	  _createInitialChildren: function _createInitialChildren(transaction, props, context, lazyTree) {
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[_typeof(props.children)] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      // TODO: Validate that text is allowed as a child of this node
	      if (contentToUse != null) {
	        // Avoid setting textContent when the text is empty. In IE11 setting
	        // textContent on a text area will cause the placeholder to not
	        // show within the textarea until it has been focused and blurred again.
	        // https://github.com/facebook/react/issues/6731#issuecomment-254874553
	        if (contentToUse !== '') {
	          if (false) {
	            setAndValidateContentChildDev.call(this, contentToUse);
	          }
	          DOMLazyTree.queueText(lazyTree, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        for (var i = 0; i < mountImages.length; i++) {
	          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
	        }
	      }
	    }
	  },
	
	  /**
	   * Receives a next element and updates the component.
	   *
	   * @internal
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} context
	   */
	  receiveComponent: function receiveComponent(nextElement, transaction, context) {
	    var prevElement = this._currentElement;
	    this._currentElement = nextElement;
	    this.updateComponent(transaction, prevElement, nextElement, context);
	  },
	
	  /**
	   * Updates a DOM component after it has already been allocated and
	   * attached to the DOM. Reconciles the root DOM node, then recurses.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevElement
	   * @param {ReactElement} nextElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function updateComponent(transaction, prevElement, nextElement, context) {
	    var lastProps = prevElement.props;
	    var nextProps = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'input':
	        lastProps = ReactDOMInput.getHostProps(this, lastProps);
	        nextProps = ReactDOMInput.getHostProps(this, nextProps);
	        break;
	      case 'option':
	        lastProps = ReactDOMOption.getHostProps(this, lastProps);
	        nextProps = ReactDOMOption.getHostProps(this, nextProps);
	        break;
	      case 'select':
	        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
	        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
	        break;
	      case 'textarea':
	        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
	        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
	        break;
	    }
	
	    assertValidProps(this, nextProps);
	    this._updateDOMProperties(lastProps, nextProps, transaction);
	    this._updateDOMChildren(lastProps, nextProps, transaction, context);
	
	    switch (this._tag) {
	      case 'input':
	        // Update the wrapper around inputs *after* updating props. This has to
	        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
	        // raise warnings and prevent the new value from being assigned.
	        ReactDOMInput.updateWrapper(this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.updateWrapper(this);
	        break;
	      case 'select':
	        // <select> value update needs to occur after <option> children
	        // reconciliation
	        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
	        break;
	    }
	  },
	
	  /**
	   * Reconciles the properties by detecting differences in property values and
	   * updating the DOM as necessary. This function is probably the single most
	   * critical path for performance optimization.
	   *
	   * TODO: Benchmark whether checking for changed values in memory actually
	   *       improves performance (especially statically positioned elements).
	   * TODO: Benchmark the effects of putting this at the top since 99% of props
	   *       do not change for a given reconciliation.
	   * TODO: Benchmark areas that can be improved with caching.
	   *
	   * @private
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {?DOMElement} node
	   */
	  _updateDOMProperties: function _updateDOMProperties(lastProps, nextProps, transaction) {
	    var propKey;
	    var styleName;
	    var styleUpdates;
	    for (propKey in lastProps) {
	      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        var lastStyle = this._previousStyleCopy;
	        for (styleName in lastStyle) {
	          if (lastStyle.hasOwnProperty(styleName)) {
	            styleUpdates = styleUpdates || {};
	            styleUpdates[styleName] = '';
	          }
	        }
	        this._previousStyleCopy = null;
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (lastProps[propKey]) {
	          // Only call deleteListener if there was a listener previously or
	          // else willDeleteListener gets called when there wasn't actually a
	          // listener (e.g., onClick={null})
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, lastProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
	      }
	    }
	    for (propKey in nextProps) {
	      var nextProp = nextProps[propKey];
	      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
	      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        if (nextProp) {
	          if (false) {
	            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
	            this._previousStyle = nextProp;
	          }
	          nextProp = this._previousStyleCopy = _assign({}, nextProp);
	        } else {
	          this._previousStyleCopy = null;
	        }
	        if (lastProp) {
	          // Unset styles on `lastProp` but not on `nextProp`.
	          for (styleName in lastProp) {
	            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = '';
	            }
	          }
	          // Update styles that changed since `lastProp`.
	          for (styleName in nextProp) {
	            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = nextProp[styleName];
	            }
	          }
	        } else {
	          // Relies on `updateStylesByID` not mutating `styleUpdates`.
	          styleUpdates = nextProp;
	        }
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (nextProp) {
	          enqueuePutListener(this, propKey, nextProp, transaction);
	        } else if (lastProp) {
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, nextProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        var node = getNode(this);
	        // If we're updating to null or undefined, we should remove the property
	        // from the DOM node instead of inadvertently setting to a string. This
	        // brings us in line with the same behavior we have on initial render.
	        if (nextProp != null) {
	          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
	        } else {
	          DOMPropertyOperations.deleteValueForProperty(node, propKey);
	        }
	      }
	    }
	    if (styleUpdates) {
	      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
	    }
	  },
	
	  /**
	   * Reconciles the children with the various properties that affect the
	   * children content.
	   *
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   */
	  _updateDOMChildren: function _updateDOMChildren(lastProps, nextProps, transaction, context) {
	    var lastContent = CONTENT_TYPES[_typeof(lastProps.children)] ? lastProps.children : null;
	    var nextContent = CONTENT_TYPES[_typeof(nextProps.children)] ? nextProps.children : null;
	
	    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
	    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;
	
	    // Note the use of `!=` which checks for null or undefined.
	    var lastChildren = lastContent != null ? null : lastProps.children;
	    var nextChildren = nextContent != null ? null : nextProps.children;
	
	    // If we're switching from children to content/html or vice versa, remove
	    // the old content
	    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
	    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
	    if (lastChildren != null && nextChildren == null) {
	      this.updateChildren(null, transaction, context);
	    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
	      this.updateTextContent('');
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    }
	
	    if (nextContent != null) {
	      if (lastContent !== nextContent) {
	        this.updateTextContent('' + nextContent);
	        if (false) {
	          setAndValidateContentChildDev.call(this, nextContent);
	        }
	      }
	    } else if (nextHtml != null) {
	      if (lastHtml !== nextHtml) {
	        this.updateMarkup('' + nextHtml);
	      }
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    } else if (nextChildren != null) {
	      if (false) {
	        setAndValidateContentChildDev.call(this, null);
	      }
	
	      this.updateChildren(nextChildren, transaction, context);
	    }
	  },
	
	  getHostNode: function getHostNode() {
	    return getNode(this);
	  },
	
	  /**
	   * Destroys all event registrations for this instance. Does not remove from
	   * the DOM. That must be done by the parent.
	   *
	   * @internal
	   */
	  unmountComponent: function unmountComponent(safely) {
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        var listeners = this._wrapperState.listeners;
	        if (listeners) {
	          for (var i = 0; i < listeners.length; i++) {
	            listeners[i].remove();
	          }
	        }
	        break;
	      case 'input':
	      case 'textarea':
	        inputValueTracking.stopTracking(this);
	        break;
	      case 'html':
	      case 'head':
	      case 'body':
	        /**
	         * Components like <html> <head> and <body> can't be removed or added
	         * easily in a cross-browser way, however it's valuable to be able to
	         * take advantage of React's reconciliation for styling and <title>
	         * management. So we just document it and throw in dangerous cases.
	         */
	         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
	        break;
	    }
	
	    this.unmountChildren(safely);
	    ReactDOMComponentTree.uncacheNode(this);
	    EventPluginHub.deleteAllListeners(this);
	    this._rootNodeID = 0;
	    this._domID = 0;
	    this._wrapperState = null;
	
	    if (false) {
	      setAndValidateContentChildDev.call(this, null);
	    }
	  },
	
	  getPublicInstance: function getPublicInstance() {
	    return getNode(this);
	  }
	};
	
	_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);
	
	module.exports = ReactDOMComponent;

/***/ },
/* 838 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var validateDOMNesting = __webpack_require__(180);
	
	var DOC_NODE_TYPE = 9;
	
	function ReactDOMContainerInfo(topLevelWrapper, node) {
	  var info = {
	    _topLevelWrapper: topLevelWrapper,
	    _idCounter: 1,
	    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
	    _node: node,
	    _tag: node ? node.nodeName.toLowerCase() : null,
	    _namespaceURI: node ? node.namespaceURI : null
	  };
	  if (false) {
	    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
	  }
	  return info;
	}
	
	module.exports = ReactDOMContainerInfo;

/***/ },
/* 839 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(11);
	
	var DOMLazyTree = __webpack_require__(83);
	var ReactDOMComponentTree = __webpack_require__(23);
	
	var ReactDOMEmptyComponent = function ReactDOMEmptyComponent(instantiate) {
	  // ReactCompositeComponent uses this:
	  this._currentElement = null;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	  this._hostContainerInfo = null;
	  this._domID = 0;
	};
	_assign(ReactDOMEmptyComponent.prototype, {
	  mountComponent: function mountComponent(transaction, hostParent, hostContainerInfo, context) {
	    var domID = hostContainerInfo._idCounter++;
	    this._domID = domID;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var nodeValue = ' react-empty: ' + this._domID + ' ';
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var node = ownerDocument.createComment(nodeValue);
	      ReactDOMComponentTree.precacheNode(this, node);
	      return DOMLazyTree(node);
	    } else {
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd insert a comment node, but since this is a situation
	        // where React won't take over (static pages), we can simply return
	        // nothing.
	        return '';
	      }
	      return '<!--' + nodeValue + '-->';
	    }
	  },
	  receiveComponent: function receiveComponent() {},
	  getHostNode: function getHostNode() {
	    return ReactDOMComponentTree.getNodeFromInstance(this);
	  },
	  unmountComponent: function unmountComponent() {
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMEmptyComponent;

/***/ },
/* 840 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMFeatureFlags = {
	  useCreateElement: true,
	  useFiber: false
	};
	
	module.exports = ReactDOMFeatureFlags;

/***/ },
/* 841 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(165);
	var ReactDOMComponentTree = __webpack_require__(23);
	
	/**
	 * Operations used to process updates to DOM nodes.
	 */
	var ReactDOMIDOperations = {
	  /**
	   * Updates a component's children by processing a series of updates.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  dangerouslyProcessChildrenUpdates: function dangerouslyProcessChildrenUpdates(parentInst, updates) {
	    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
	    DOMChildrenOperations.processUpdates(node, updates);
	  }
	};
	
	module.exports = ReactDOMIDOperations;

/***/ },
/* 842 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(12),
	    _assign = __webpack_require__(11);
	
	var DOMPropertyOperations = __webpack_require__(367);
	var LinkedValueUtils = __webpack_require__(170);
	var ReactDOMComponentTree = __webpack_require__(23);
	var ReactUpdates = __webpack_require__(53);
	
	var invariant = __webpack_require__(5);
	var warning = __webpack_require__(9);
	
	var didWarnValueLink = false;
	var didWarnCheckedLink = false;
	var didWarnValueDefaultValue = false;
	var didWarnCheckedDefaultChecked = false;
	var didWarnControlledToUncontrolled = false;
	var didWarnUncontrolledToControlled = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMInput.updateWrapper(this);
	  }
	}
	
	function isControlled(props) {
	  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
	  return usesChecked ? props.checked != null : props.value != null;
	}
	
	/**
	 * Implements an <input> host component that allows setting these optional
	 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
	 *
	 * If `checked` or `value` are not supplied (or null/undefined), user actions
	 * that affect the checked state or value will trigger updates to the element.
	 *
	 * If they are supplied (and not null/undefined), the rendered element will not
	 * trigger updates to the element. Instead, the props must change in order for
	 * the rendered element to be updated.
	 *
	 * The rendered element will be initialized as unchecked (or `defaultChecked`)
	 * with an empty value (or `defaultValue`).
	 *
	 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
	 */
	var ReactDOMInput = {
	  getHostProps: function getHostProps(inst, props) {
	    var value = LinkedValueUtils.getValue(props);
	    var checked = LinkedValueUtils.getChecked(props);
	
	    var hostProps = _assign({
	      // Make sure we set .type before any other properties (setting .value
	      // before .type means .value is lost in IE11 and below)
	      type: undefined,
	      // Make sure we set .step before .value (setting .value before .step
	      // means .value is rounded on mount, based upon step precision)
	      step: undefined,
	      // Make sure we set .min & .max before .value (to ensure proper order
	      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
	      min: undefined,
	      max: undefined
	    }, props, {
	      defaultChecked: undefined,
	      defaultValue: undefined,
	      value: value != null ? value : inst._wrapperState.initialValue,
	      checked: checked != null ? checked : inst._wrapperState.initialChecked,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function mountWrapper(inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);
	
	      var owner = inst._currentElement._owner;
	
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnCheckedLink = true;
	      }
	      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnCheckedDefaultChecked = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnValueDefaultValue = true;
	      }
	    }
	
	    var defaultValue = props.defaultValue;
	    inst._wrapperState = {
	      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
	      initialValue: props.value != null ? props.value : defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      controlled: isControlled(props)
	    };
	  },
	
	  updateWrapper: function updateWrapper(inst) {
	    var props = inst._currentElement.props;
	
	    if (false) {
	      var controlled = isControlled(props);
	      var owner = inst._currentElement._owner;
	
	      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnUncontrolledToControlled = true;
	      }
	      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnControlledToUncontrolled = true;
	      }
	    }
	
	    // TODO: Shouldn't this be getChecked(props)?
	    var checked = props.checked;
	    if (checked != null) {
	      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      if (value === 0 && node.value === '') {
	        node.value = '0';
	        // Note: IE9 reports a number inputs as 'text', so check props instead.
	      } else if (props.type === 'number') {
	        // Simulate `input.valueAsNumber`. IE9 does not support it
	        var valueAsNumber = parseFloat(node.value, 10) || 0;
	
	        if (
	        // eslint-disable-next-line
	        value != valueAsNumber ||
	        // eslint-disable-next-line
	        value == valueAsNumber && node.value != value) {
	          // Cast `value` to a string to ensure the value is set correctly. While
	          // browsers typically do this as necessary, jsdom doesn't.
	          node.value = '' + value;
	        }
	      } else if (node.value !== '' + value) {
	        // Cast `value` to a string to ensure the value is set correctly. While
	        // browsers typically do this as necessary, jsdom doesn't.
	        node.value = '' + value;
	      }
	    } else {
	      if (props.value == null && props.defaultValue != null) {
	        // In Chrome, assigning defaultValue to certain input types triggers input validation.
	        // For number inputs, the display value loses trailing decimal points. For email inputs,
	        // Chrome raises "The specified value <x> is not a valid email address".
	        //
	        // Here we check to see if the defaultValue has actually changed, avoiding these problems
	        // when the user is inputting text
	        //
	        // https://github.com/facebook/react/issues/7253
	        if (node.defaultValue !== '' + props.defaultValue) {
	          node.defaultValue = '' + props.defaultValue;
	        }
	      }
	      if (props.checked == null && props.defaultChecked != null) {
	        node.defaultChecked = !!props.defaultChecked;
	      }
	    }
	  },
	
	  postMountWrapper: function postMountWrapper(inst) {
	    var props = inst._currentElement.props;
	
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	
	    // Detach value from defaultValue. We won't do anything if we're working on
	    // submit or reset inputs as those values & defaultValues are linked. They
	    // are not resetable nodes so this operation doesn't matter and actually
	    // removes browser-default values (eg "Submit Query") when no value is
	    // provided.
	
	    switch (props.type) {
	      case 'submit':
	      case 'reset':
	        break;
	      case 'color':
	      case 'date':
	      case 'datetime':
	      case 'datetime-local':
	      case 'month':
	      case 'time':
	      case 'week':
	        // This fixes the no-show issue on iOS Safari and Android Chrome:
	        // https://github.com/facebook/react/issues/7233
	        node.value = '';
	        node.value = node.defaultValue;
	        break;
	      default:
	        node.value = node.value;
	        break;
	    }
	
	    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
	    // this is needed to work around a chrome bug where setting defaultChecked
	    // will sometimes influence the value of checked (even after detachment).
	    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
	    // We need to temporarily unset name to avoid disrupting radio button groups.
	    var name = node.name;
	    if (name !== '') {
	      node.name = '';
	    }
	    node.defaultChecked = !node.defaultChecked;
	    node.defaultChecked = !node.defaultChecked;
	    if (name !== '') {
	      node.name = name;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  // Here we use asap to wait until all updates have propagated, which
	  // is important when using controlled components within layers:
	  // https://github.com/facebook/react/issues/1698
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	
	  var name = props.name;
	  if (props.type === 'radio' && name != null) {
	    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
	    var queryRoot = rootNode;
	
	    while (queryRoot.parentNode) {
	      queryRoot = queryRoot.parentNode;
	    }
	
	    // If `rootNode.form` was non-null, then we could try `form.elements`,
	    // but that sometimes behaves strangely in IE8. We could also try using
	    // `form.getElementsByName`, but that will only return direct children
	    // and won't include inputs that use the HTML5 `form=` attribute. Since
	    // the input might not even be in a form, let's just use the global
	    // `querySelectorAll` to ensure we don't miss anything.
	    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');
	
	    for (var i = 0; i < group.length; i++) {
	      var otherNode = group[i];
	      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
	        continue;
	      }
	      // This will throw if radio buttons rendered by different copies of React
	      // and the same name are rendered into the same form (same as #1939).
	      // That's probably okay; we don't support it just as we don't support
	      // mixing React radio buttons with non-React ones.
	      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
	      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
	      // If this is a controlled radio button group, forcing the input that
	      // was previously checked to update will cause it to be come re-checked
	      // as appropriate.
	      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
	    }
	  }
	
	  return returnValue;
	}
	
	module.exports = ReactDOMInput;

/***/ },
/* 843 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(11);
	
	var React = __webpack_require__(86);
	var ReactDOMComponentTree = __webpack_require__(23);
	var ReactDOMSelect = __webpack_require__(369);
	
	var warning = __webpack_require__(9);
	var didWarnInvalidOptionChildren = false;
	
	function flattenChildren(children) {
	  var content = '';
	
	  // Flatten children and warn if they aren't strings or numbers;
	  // invalid types are ignored.
	  React.Children.forEach(children, function (child) {
	    if (child == null) {
	      return;
	    }
	    if (typeof child === 'string' || typeof child === 'number') {
	      content += child;
	    } else if (!didWarnInvalidOptionChildren) {
	      didWarnInvalidOptionChildren = true;
	       false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
	    }
	  });
	
	  return content;
	}
	
	/**
	 * Implements an <option> host component that warns when `selected` is set.
	 */
	var ReactDOMOption = {
	  mountWrapper: function mountWrapper(inst, props, hostParent) {
	    // TODO (yungsters): Remove support for `selected` in <option>.
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
	    }
	
	    // Look up whether this option is 'selected'
	    var selectValue = null;
	    if (hostParent != null) {
	      var selectParent = hostParent;
	
	      if (selectParent._tag === 'optgroup') {
	        selectParent = selectParent._hostParent;
	      }
	
	      if (selectParent != null && selectParent._tag === 'select') {
	        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
	      }
	    }
	
	    // If the value is null (e.g., no specified value or after initial mount)
	    // or missing (e.g., for <datalist>), we don't change props.selected
	    var selected = null;
	    if (selectValue != null) {
	      var value;
	      if (props.value != null) {
	        value = props.value + '';
	      } else {
	        value = flattenChildren(props.children);
	      }
	      selected = false;
	      if (Array.isArray(selectValue)) {
	        // multiple
	        for (var i = 0; i < selectValue.length; i++) {
	          if ('' + selectValue[i] === value) {
	            selected = true;
	            break;
	          }
	        }
	      } else {
	        selected = '' + selectValue === value;
	      }
	    }
	
	    inst._wrapperState = { selected: selected };
	  },
	
	  postMountWrapper: function postMountWrapper(inst) {
	    // value="" should make a value attribute (#6219)
	    var props = inst._currentElement.props;
	    if (props.value != null) {
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      node.setAttribute('value', props.value);
	    }
	  },
	
	  getHostProps: function getHostProps(inst, props) {
	    var hostProps = _assign({ selected: undefined, children: undefined }, props);
	
	    // Read state only from initial mount because <select> updates value
	    // manually; we need the initial state only for server rendering
	    if (inst._wrapperState.selected != null) {
	      hostProps.selected = inst._wrapperState.selected;
	    }
	
	    var content = flattenChildren(props.children);
	
	    if (content) {
	      hostProps.children = content;
	    }
	
	    return hostProps;
	  }
	};
	
	module.exports = ReactDOMOption;

/***/ },
/* 844 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(32);
	
	var getNodeForCharacterOffset = __webpack_require__(882);
	var getTextContentAccessor = __webpack_require__(380);
	
	/**
	 * While `isCollapsed` is available on the Selection object and `collapsed`
	 * is available on the Range object, IE11 sometimes gets them wrong.
	 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
	 */
	function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
	  return anchorNode === focusNode && anchorOffset === focusOffset;
	}
	
	/**
	 * Get the appropriate anchor and focus node/offset pairs for IE.
	 *
	 * The catch here is that IE's selection API doesn't provide information
	 * about whether the selection is forward or backward, so we have to
	 * behave as though it's always forward.
	 *
	 * IE text differs from modern selection in that it behaves as though
	 * block elements end with a new line. This means character offsets will
	 * differ between the two APIs.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getIEOffsets(node) {
	  var selection = document.selection;
	  var selectedRange = selection.createRange();
	  var selectedLength = selectedRange.text.length;
	
	  // Duplicate selection so we can move range without breaking user selection.
	  var fromStart = selectedRange.duplicate();
	  fromStart.moveToElementText(node);
	  fromStart.setEndPoint('EndToStart', selectedRange);
	
	  var startOffset = fromStart.text.length;
	  var endOffset = startOffset + selectedLength;
	
	  return {
	    start: startOffset,
	    end: endOffset
	  };
	}
	
	/**
	 * @param {DOMElement} node
	 * @return {?object}
	 */
	function getModernOffsets(node) {
	  var selection = window.getSelection && window.getSelection();
	
	  if (!selection || selection.rangeCount === 0) {
	    return null;
	  }
	
	  var anchorNode = selection.anchorNode;
	  var anchorOffset = selection.anchorOffset;
	  var focusNode = selection.focusNode;
	  var focusOffset = selection.focusOffset;
	
	  var currentRange = selection.getRangeAt(0);
	
	  // In Firefox, range.startContainer and range.endContainer can be "anonymous
	  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
	  // divs do not seem to expose properties, triggering a "Permission denied
	  // error" if any of its properties are accessed. The only seemingly possible
	  // way to avoid erroring is to access a property that typically works for
	  // non-anonymous divs and catch any error that may otherwise arise. See
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
	  try {
	    /* eslint-disable no-unused-expressions */
	    currentRange.startContainer.nodeType;
	    currentRange.endContainer.nodeType;
	    /* eslint-enable no-unused-expressions */
	  } catch (e) {
	    return null;
	  }
	
	  // If the node and offset values are the same, the selection is collapsed.
	  // `Selection.isCollapsed` is available natively, but IE sometimes gets
	  // this value wrong.
	  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);
	
	  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;
	
	  var tempRange = currentRange.cloneRange();
	  tempRange.selectNodeContents(node);
	  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);
	
	  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);
	
	  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
	  var end = start + rangeLength;
	
	  // Detect whether the selection is backward.
	  var detectionRange = document.createRange();
	  detectionRange.setStart(anchorNode, anchorOffset);
	  detectionRange.setEnd(focusNode, focusOffset);
	  var isBackward = detectionRange.collapsed;
	
	  return {
	    start: isBackward ? end : start,
	    end: isBackward ? start : end
	  };
	}
	
	/**
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setIEOffsets(node, offsets) {
	  var range = document.selection.createRange().duplicate();
	  var start, end;
	
	  if (offsets.end === undefined) {
	    start = offsets.start;
	    end = start;
	  } else if (offsets.start > offsets.end) {
	    start = offsets.end;
	    end = offsets.start;
	  } else {
	    start = offsets.start;
	    end = offsets.end;
	  }
	
	  range.moveToElementText(node);
	  range.moveStart('character', start);
	  range.setEndPoint('EndToStart', range);
	  range.moveEnd('character', end - start);
	  range.select();
	}
	
	/**
	 * In modern non-IE browsers, we can support both forward and backward
	 * selections.
	 *
	 * Note: IE10+ supports the Selection object, but it does not support
	 * the `extend` method, which means that even in modern IE, it's not possible
	 * to programmatically create a backward selection. Thus, for all IE
	 * versions, we use the old IE API to create our selections.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setModernOffsets(node, offsets) {
	  if (!window.getSelection) {
	    return;
	  }
	
	  var selection = window.getSelection();
	  var length = node[getTextContentAccessor()].length;
	  var start = Math.min(offsets.start, length);
	  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);
	
	  // IE 11 uses modern selection, but doesn't support the extend method.
	  // Flip backward selections, so we can set with a single range.
	  if (!selection.extend && start > end) {
	    var temp = end;
	    end = start;
	    start = temp;
	  }
	
	  var startMarker = getNodeForCharacterOffset(node, start);
	  var endMarker = getNodeForCharacterOffset(node, end);
	
	  if (startMarker && endMarker) {
	    var range = document.createRange();
	    range.setStart(startMarker.node, startMarker.offset);
	    selection.removeAllRanges();
	
	    if (start > end) {
	      selection.addRange(range);
	      selection.extend(endMarker.node, endMarker.offset);
	    } else {
	      range.setEnd(endMarker.node, endMarker.offset);
	      selection.addRange(range);
	    }
	  }
	}
	
	var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);
	
	var ReactDOMSelection = {
	  /**
	   * @param {DOMElement} node
	   */
	  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,
	
	  /**
	   * @param {DOMElement|DOMTextNode} node
	   * @param {object} offsets
	   */
	  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
	};
	
	module.exports = ReactDOMSelection;

/***/ },
/* 845 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(12),
	    _assign = __webpack_require__(11);
	
	var DOMChildrenOperations = __webpack_require__(165);
	var DOMLazyTree = __webpack_require__(83);
	var ReactDOMComponentTree = __webpack_require__(23);
	
	var escapeTextContentForBrowser = __webpack_require__(125);
	var invariant = __webpack_require__(5);
	var validateDOMNesting = __webpack_require__(180);
	
	/**
	 * Text nodes violate a couple assumptions that React makes about components:
	 *
	 *  - When mounting text into the DOM, adjacent text nodes are merged.
	 *  - Text nodes cannot be assigned a React root ID.
	 *
	 * This component is used to wrap strings between comment nodes so that they
	 * can undergo the same reconciliation that is applied to elements.
	 *
	 * TODO: Investigate representing React components in the DOM with text nodes.
	 *
	 * @class ReactDOMTextComponent
	 * @extends ReactComponent
	 * @internal
	 */
	var ReactDOMTextComponent = function ReactDOMTextComponent(text) {
	  // TODO: This is really a ReactText (ReactNode), not a ReactElement
	  this._currentElement = text;
	  this._stringText = '' + text;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	
	  // Properties
	  this._domID = 0;
	  this._mountIndex = 0;
	  this._closingComment = null;
	  this._commentNodes = null;
	};
	
	_assign(ReactDOMTextComponent.prototype, {
	  /**
	   * Creates the markup for this text node. This node is not intended to have
	   * any features besides containing text content.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {string} Markup for this text node.
	   * @internal
	   */
	  mountComponent: function mountComponent(transaction, hostParent, hostContainerInfo, context) {
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo != null) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(null, this._stringText, this, parentInfo);
	      }
	    }
	
	    var domID = hostContainerInfo._idCounter++;
	    var openingValue = ' react-text: ' + domID + ' ';
	    var closingValue = ' /react-text ';
	    this._domID = domID;
	    this._hostParent = hostParent;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var openingComment = ownerDocument.createComment(openingValue);
	      var closingComment = ownerDocument.createComment(closingValue);
	      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
	      if (this._stringText) {
	        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
	      }
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
	      ReactDOMComponentTree.precacheNode(this, openingComment);
	      this._closingComment = closingComment;
	      return lazyTree;
	    } else {
	      var escapedText = escapeTextContentForBrowser(this._stringText);
	
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd wrap this between comment nodes for the reasons stated
	        // above, but since this is a situation where React won't take over
	        // (static pages), we can simply return the text as it is.
	        return escapedText;
	      }
	
	      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
	    }
	  },
	
	  /**
	   * Updates this component by updating the text content.
	   *
	   * @param {ReactText} nextText The next text content
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  receiveComponent: function receiveComponent(nextText, transaction) {
	    if (nextText !== this._currentElement) {
	      this._currentElement = nextText;
	      var nextStringText = '' + nextText;
	      if (nextStringText !== this._stringText) {
	        // TODO: Save this as pending props and use performUpdateIfNecessary
	        // and/or updateComponent to do the actual update for consistency with
	        // other component types?
	        this._stringText = nextStringText;
	        var commentNodes = this.getHostNode();
	        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
	      }
	    }
	  },
	
	  getHostNode: function getHostNode() {
	    var hostNode = this._commentNodes;
	    if (hostNode) {
	      return hostNode;
	    }
	    if (!this._closingComment) {
	      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
	      var node = openingComment.nextSibling;
	      while (true) {
	        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
	        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
	          this._closingComment = node;
	          break;
	        }
	        node = node.nextSibling;
	      }
	    }
	    hostNode = [this._hostNode, this._closingComment];
	    this._commentNodes = hostNode;
	    return hostNode;
	  },
	
	  unmountComponent: function unmountComponent() {
	    this._closingComment = null;
	    this._commentNodes = null;
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMTextComponent;

/***/ },
/* 846 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(12),
	    _assign = __webpack_require__(11);
	
	var LinkedValueUtils = __webpack_require__(170);
	var ReactDOMComponentTree = __webpack_require__(23);
	var ReactUpdates = __webpack_require__(53);
	
	var invariant = __webpack_require__(5);
	var warning = __webpack_require__(9);
	
	var didWarnValueLink = false;
	var didWarnValDefaultVal = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMTextarea.updateWrapper(this);
	  }
	}
	
	/**
	 * Implements a <textarea> host component that allows setting `value`, and
	 * `defaultValue`. This differs from the traditional DOM API because value is
	 * usually set as PCDATA children.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that affect the
	 * value will trigger updates to the element.
	 *
	 * If `value` is supplied (and not null/undefined), the rendered element will
	 * not trigger updates to the element. Instead, the `value` prop must change in
	 * order for the rendered element to be updated.
	 *
	 * The rendered element will be initialized with an empty value, the prop
	 * `defaultValue` if specified, or the children content (deprecated).
	 */
	var ReactDOMTextarea = {
	  getHostProps: function getHostProps(inst, props) {
	    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;
	
	    // Always set children to the same thing. In IE9, the selection range will
	    // get reset if `textContent` is mutated.  We could add a check in setTextContent
	    // to only set the value if/when the value differs from the node value (which would
	    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
	    // The value can be a boolean or object so that's why it's forced to be a string.
	    var hostProps = _assign({}, props, {
	      value: undefined,
	      defaultValue: undefined,
	      children: '' + inst._wrapperState.initialValue,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function mountWrapper(inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	        didWarnValDefaultVal = true;
	      }
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    var initialValue = value;
	
	    // Only bother fetching default value if we're going to use it
	    if (value == null) {
	      var defaultValue = props.defaultValue;
	      // TODO (yungsters): Remove support for children content in <textarea>.
	      var children = props.children;
	      if (children != null) {
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
	        }
	        !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
	        if (Array.isArray(children)) {
	          !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
	          children = children[0];
	        }
	
	        defaultValue = '' + children;
	      }
	      if (defaultValue == null) {
	        defaultValue = '';
	      }
	      initialValue = defaultValue;
	    }
	
	    inst._wrapperState = {
	      initialValue: '' + initialValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst)
	    };
	  },
	
	  updateWrapper: function updateWrapper(inst) {
	    var props = inst._currentElement.props;
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      var newValue = '' + value;
	
	      // To avoid side effects (such as losing text selection), only set value if changed
	      if (newValue !== node.value) {
	        node.value = newValue;
	      }
	      if (props.defaultValue == null) {
	        node.defaultValue = newValue;
	      }
	    }
	    if (props.defaultValue != null) {
	      node.defaultValue = props.defaultValue;
	    }
	  },
	
	  postMountWrapper: function postMountWrapper(inst) {
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var textContent = node.textContent;
	
	    // Only set node.value if textContent is equal to the expected
	    // initial value. In IE10/IE11 there is a bug where the placeholder attribute
	    // will populate textContent as well.
	    // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
	    if (textContent === inst._wrapperState.initialValue) {
	      node.value = textContent;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMTextarea;

/***/ },
/* 847 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(12);
	
	var invariant = __webpack_require__(5);
	
	/**
	 * Return the lowest common ancestor of A and B, or null if they are in
	 * different trees.
	 */
	function getLowestCommonAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  var depthA = 0;
	  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
	    depthA++;
	  }
	  var depthB = 0;
	  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
	    depthB++;
	  }
	
	  // If A is deeper, crawl up.
	  while (depthA - depthB > 0) {
	    instA = instA._hostParent;
	    depthA--;
	  }
	
	  // If B is deeper, crawl up.
	  while (depthB - depthA > 0) {
	    instB = instB._hostParent;
	    depthB--;
	  }
	
	  // Walk in lockstep until we find a match.
	  var depth = depthA;
	  while (depth--) {
	    if (instA === instB) {
	      return instA;
	    }
	    instA = instA._hostParent;
	    instB = instB._hostParent;
	  }
	  return null;
	}
	
	/**
	 * Return if A is an ancestor of B.
	 */
	function isAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	
	  while (instB) {
	    if (instB === instA) {
	      return true;
	    }
	    instB = instB._hostParent;
	  }
	  return false;
	}
	
	/**
	 * Return the parent instance of the passed-in instance.
	 */
	function getParentInstance(inst) {
	  !('_hostNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;
	
	  return inst._hostParent;
	}
	
	/**
	 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
	 */
	function traverseTwoPhase(inst, fn, arg) {
	  var path = [];
	  while (inst) {
	    path.push(inst);
	    inst = inst._hostParent;
	  }
	  var i;
	  for (i = path.length; i-- > 0;) {
	    fn(path[i], 'captured', arg);
	  }
	  for (i = 0; i < path.length; i++) {
	    fn(path[i], 'bubbled', arg);
	  }
	}
	
	/**
	 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
	 * should would receive a `mouseEnter` or `mouseLeave` event.
	 *
	 * Does not invoke the callback on the nearest common ancestor because nothing
	 * "entered" or "left" that element.
	 */
	function traverseEnterLeave(from, to, fn, argFrom, argTo) {
	  var common = from && to ? getLowestCommonAncestor(from, to) : null;
	  var pathFrom = [];
	  while (from && from !== common) {
	    pathFrom.push(from);
	    from = from._hostParent;
	  }
	  var pathTo = [];
	  while (to && to !== common) {
	    pathTo.push(to);
	    to = to._hostParent;
	  }
	  var i;
	  for (i = 0; i < pathFrom.length; i++) {
	    fn(pathFrom[i], 'bubbled', argFrom);
	  }
	  for (i = pathTo.length; i-- > 0;) {
	    fn(pathTo[i], 'captured', argTo);
	  }
	}
	
	module.exports = {
	  isAncestor: isAncestor,
	  getLowestCommonAncestor: getLowestCommonAncestor,
	  getParentInstance: getParentInstance,
	  traverseTwoPhase: traverseTwoPhase,
	  traverseEnterLeave: traverseEnterLeave
	};

/***/ },
/* 848 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(11);
	
	var ReactUpdates = __webpack_require__(53);
	var Transaction = __webpack_require__(124);
	
	var emptyFunction = __webpack_require__(41);
	
	var RESET_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: function close() {
	    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
	  }
	};
	
	var FLUSH_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
	};
	
	var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];
	
	function ReactDefaultBatchingStrategyTransaction() {
	  this.reinitializeTransaction();
	}
	
	_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction, {
	  getTransactionWrappers: function getTransactionWrappers() {
	    return TRANSACTION_WRAPPERS;
	  }
	});
	
	var transaction = new ReactDefaultBatchingStrategyTransaction();
	
	var ReactDefaultBatchingStrategy = {
	  isBatchingUpdates: false,
	
	  /**
	   * Call the provided function in a context within which calls to `setState`
	   * and friends are batched such that components aren't updated unnecessarily.
	   */
	  batchedUpdates: function batchedUpdates(callback, a, b, c, d, e) {
	    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;
	
	    ReactDefaultBatchingStrategy.isBatchingUpdates = true;
	
	    // The code is written this way to avoid extra allocations
	    if (alreadyBatchingUpdates) {
	      return callback(a, b, c, d, e);
	    } else {
	      return transaction.perform(callback, null, a, b, c, d, e);
	    }
	  }
	};
	
	module.exports = ReactDefaultBatchingStrategy;

/***/ },
/* 849 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = __webpack_require__(823);
	var BeforeInputEventPlugin = __webpack_require__(825);
	var ChangeEventPlugin = __webpack_require__(827);
	var DefaultEventPluginOrder = __webpack_require__(829);
	var EnterLeaveEventPlugin = __webpack_require__(830);
	var HTMLDOMPropertyConfig = __webpack_require__(832);
	var ReactComponentBrowserEnvironment = __webpack_require__(834);
	var ReactDOMComponent = __webpack_require__(837);
	var ReactDOMComponentTree = __webpack_require__(23);
	var ReactDOMEmptyComponent = __webpack_require__(839);
	var ReactDOMTreeTraversal = __webpack_require__(847);
	var ReactDOMTextComponent = __webpack_require__(845);
	var ReactDefaultBatchingStrategy = __webpack_require__(848);
	var ReactEventListener = __webpack_require__(852);
	var ReactInjection = __webpack_require__(853);
	var ReactReconcileTransaction = __webpack_require__(858);
	var SVGDOMPropertyConfig = __webpack_require__(863);
	var SelectEventPlugin = __webpack_require__(864);
	var SimpleEventPlugin = __webpack_require__(865);
	
	var alreadyInjected = false;
	
	function inject() {
	  if (alreadyInjected) {
	    // TODO: This is currently true because these injections are shared between
	    // the client and the server package. They should be built independently
	    // and not share any injection state. Then this problem will be solved.
	    return;
	  }
	  alreadyInjected = true;
	
	  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);
	
	  /**
	   * Inject modules for resolving DOM hierarchy and plugin ordering.
	   */
	  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
	  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
	  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);
	
	  /**
	   * Some important event plugins included by default (without having to require
	   * them).
	   */
	  ReactInjection.EventPluginHub.injectEventPluginsByName({
	    SimpleEventPlugin: SimpleEventPlugin,
	    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
	    ChangeEventPlugin: ChangeEventPlugin,
	    SelectEventPlugin: SelectEventPlugin,
	    BeforeInputEventPlugin: BeforeInputEventPlugin
	  });
	
	  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);
	
	  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);
	
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(ARIADOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);
	
	  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
	    return new ReactDOMEmptyComponent(instantiate);
	  });
	
	  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
	  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	
	  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
	}
	
	module.exports = {
	  inject: inject
	};

/***/ },
/* 850 */
388,
/* 851 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(95);
	
	function runEventQueueInBatch(events) {
	  EventPluginHub.enqueueEvents(events);
	  EventPluginHub.processEventQueue(false);
	}
	
	var ReactEventEmitterMixin = {
	  /**
	   * Streams a fired top-level event to `EventPluginHub` where plugins have the
	   * opportunity to create `ReactEvent`s to be dispatched.
	   */
	  handleTopLevel: function handleTopLevel(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	    runEventQueueInBatch(events);
	  }
	};
	
	module.exports = ReactEventEmitterMixin;

/***/ },
/* 852 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(11);
	
	var EventListener = __webpack_require__(238);
	var ExecutionEnvironment = __webpack_require__(32);
	var PooledClass = __webpack_require__(75);
	var ReactDOMComponentTree = __webpack_require__(23);
	var ReactUpdates = __webpack_require__(53);
	
	var getEventTarget = __webpack_require__(177);
	var getUnboundedScrollPosition = __webpack_require__(777);
	
	/**
	 * Find the deepest React component completely containing the root of the
	 * passed-in instance (for use when entire React trees are nested within each
	 * other). If React trees are not nested, returns null.
	 */
	function findParent(inst) {
	  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
	  // traversal, but caching is difficult to do correctly without using a
	  // mutation observer to listen for all DOM changes.
	  while (inst._hostParent) {
	    inst = inst._hostParent;
	  }
	  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
	  var container = rootNode.parentNode;
	  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
	}
	
	// Used to store ancestor hierarchy in top level callback
	function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
	  this.topLevelType = topLevelType;
	  this.nativeEvent = nativeEvent;
	  this.ancestors = [];
	}
	_assign(TopLevelCallbackBookKeeping.prototype, {
	  destructor: function destructor() {
	    this.topLevelType = null;
	    this.nativeEvent = null;
	    this.ancestors.length = 0;
	  }
	});
	PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);
	
	function handleTopLevelImpl(bookKeeping) {
	  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
	  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);
	
	  // Loop through the hierarchy, in case there's any nested components.
	  // It's important that we build the array of ancestors before calling any
	  // event handlers, because event handlers can modify the DOM, leading to
	  // inconsistencies with ReactMount's node cache. See #1105.
	  var ancestor = targetInst;
	  do {
	    bookKeeping.ancestors.push(ancestor);
	    ancestor = ancestor && findParent(ancestor);
	  } while (ancestor);
	
	  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
	    targetInst = bookKeeping.ancestors[i];
	    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
	  }
	}
	
	function scrollValueMonitor(cb) {
	  var scrollPosition = getUnboundedScrollPosition(window);
	  cb(scrollPosition);
	}
	
	var ReactEventListener = {
	  _enabled: true,
	  _handleTopLevel: null,
	
	  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,
	
	  setHandleTopLevel: function setHandleTopLevel(handleTopLevel) {
	    ReactEventListener._handleTopLevel = handleTopLevel;
	  },
	
	  setEnabled: function setEnabled(enabled) {
	    ReactEventListener._enabled = !!enabled;
	  },
	
	  isEnabled: function isEnabled() {
	    return ReactEventListener._enabled;
	  },
	
	  /**
	   * Traps top-level events by using event bubbling.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapBubbledEvent: function trapBubbledEvent(topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  /**
	   * Traps a top-level event by using event capturing.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapCapturedEvent: function trapCapturedEvent(topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  monitorScrollValue: function monitorScrollValue(refresh) {
	    var callback = scrollValueMonitor.bind(null, refresh);
	    EventListener.listen(window, 'scroll', callback);
	  },
	
	  dispatchEvent: function dispatchEvent(topLevelType, nativeEvent) {
	    if (!ReactEventListener._enabled) {
	      return;
	    }
	
	    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
	    try {
	      // Event queue being processed in the same cycle allows
	      // `preventDefault`.
	      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
	    } finally {
	      TopLevelCallbackBookKeeping.release(bookKeeping);
	    }
	  }
	};
	
	module.exports = ReactEventListener;

/***/ },
/* 853 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(84);
	var EventPluginHub = __webpack_require__(95);
	var EventPluginUtils = __webpack_require__(168);
	var ReactComponentEnvironment = __webpack_require__(171);
	var ReactEmptyComponent = __webpack_require__(370);
	var ReactBrowserEventEmitter = __webpack_require__(122);
	var ReactHostComponent = __webpack_require__(372);
	var ReactUpdates = __webpack_require__(53);
	
	var ReactInjection = {
	  Component: ReactComponentEnvironment.injection,
	  DOMProperty: DOMProperty.injection,
	  EmptyComponent: ReactEmptyComponent.injection,
	  EventPluginHub: EventPluginHub.injection,
	  EventPluginUtils: EventPluginUtils.injection,
	  EventEmitter: ReactBrowserEventEmitter.injection,
	  HostComponent: ReactHostComponent.injection,
	  Updates: ReactUpdates.injection
	};
	
	module.exports = ReactInjection;

/***/ },
/* 854 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var adler32 = __webpack_require__(876);
	
	var TAG_END = /\/?>/;
	var COMMENT_START = /^<\!\-\-/;
	
	var ReactMarkupChecksum = {
	  CHECKSUM_ATTR_NAME: 'data-react-checksum',
	
	  /**
	   * @param {string} markup Markup string
	   * @return {string} Markup string with checksum attribute attached
	   */
	  addChecksumToMarkup: function addChecksumToMarkup(markup) {
	    var checksum = adler32(markup);
	
	    // Add checksum (handle both parent tags, comments and self-closing tags)
	    if (COMMENT_START.test(markup)) {
	      return markup;
	    } else {
	      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
	    }
	  },
	
	  /**
	   * @param {string} markup to use
	   * @param {DOMElement} element root React element
	   * @returns {boolean} whether or not the markup is the same
	   */
	  canReuseMarkup: function canReuseMarkup(markup, element) {
	    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
	    var markupChecksum = adler32(markup);
	    return markupChecksum === existingChecksum;
	  }
	};
	
	module.exports = ReactMarkupChecksum;

/***/ },
/* 855 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(12);
	
	var ReactComponentEnvironment = __webpack_require__(171);
	var ReactInstanceMap = __webpack_require__(97);
	var ReactInstrumentation = __webpack_require__(46);
	
	var ReactCurrentOwner = __webpack_require__(57);
	var ReactReconciler = __webpack_require__(85);
	var ReactChildReconciler = __webpack_require__(833);
	
	var emptyFunction = __webpack_require__(41);
	var flattenChildren = __webpack_require__(879);
	var invariant = __webpack_require__(5);
	
	/**
	 * Make an update for markup to be rendered and inserted at a supplied index.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @param {number} toIndex Destination index.
	 * @private
	 */
	function makeInsertMarkup(markup, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'INSERT_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for moving an existing element to another index.
	 *
	 * @param {number} fromIndex Source index of the existing element.
	 * @param {number} toIndex Destination index of the element.
	 * @private
	 */
	function makeMove(child, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'MOVE_EXISTING',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: ReactReconciler.getHostNode(child),
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for removing an element at an index.
	 *
	 * @param {number} fromIndex Index of the element to remove.
	 * @private
	 */
	function makeRemove(child, node) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'REMOVE_NODE',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: node,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the markup of a node.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @private
	 */
	function makeSetMarkup(markup) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'SET_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the text content.
	 *
	 * @param {string} textContent Text content to set.
	 * @private
	 */
	function makeTextContent(textContent) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'TEXT_CONTENT',
	    content: textContent,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Push an update, if any, onto the queue. Creates a new queue if none is
	 * passed and always returns the queue. Mutative.
	 */
	function enqueue(queue, update) {
	  if (update) {
	    queue = queue || [];
	    queue.push(update);
	  }
	  return queue;
	}
	
	/**
	 * Processes any enqueued updates.
	 *
	 * @private
	 */
	function processQueue(inst, updateQueue) {
	  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
	}
	
	var setChildrenForInstrumentation = emptyFunction;
	if (false) {
	  var getDebugID = function getDebugID(inst) {
	    if (!inst._debugID) {
	      // Check for ART-like instances. TODO: This is silly/gross.
	      var internal;
	      if (internal = ReactInstanceMap.get(inst)) {
	        inst = internal;
	      }
	    }
	    return inst._debugID;
	  };
	  setChildrenForInstrumentation = function setChildrenForInstrumentation(children) {
	    var debugID = getDebugID(this);
	    // TODO: React Native empty components are also multichild.
	    // This means they still get into this method but don't have _debugID.
	    if (debugID !== 0) {
	      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
	        return children[key]._debugID;
	      }) : []);
	    }
	  };
	}
	
	/**
	 * ReactMultiChild are capable of reconciling multiple children.
	 *
	 * @class ReactMultiChild
	 * @internal
	 */
	var ReactMultiChild = {
	  /**
	   * Provides common functionality for components that must reconcile multiple
	   * children. This is used by `ReactDOMComponent` to mount, update, and
	   * unmount child components.
	   *
	   * @lends {ReactMultiChild.prototype}
	   */
	  Mixin: {
	    _reconcilerInstantiateChildren: function _reconcilerInstantiateChildren(nestedChildren, transaction, context) {
	      if (false) {
	        var selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	        }
	      }
	      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
	    },
	
	    _reconcilerUpdateChildren: function _reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
	      var nextChildren;
	      var selfDebugID = 0;
	      if (false) {
	        selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          return nextChildren;
	        }
	      }
	      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	      return nextChildren;
	    },
	
	    /**
	     * Generates a "mount image" for each of the supplied children. In the case
	     * of `ReactDOMComponent`, a mount image is a string of markup.
	     *
	     * @param {?object} nestedChildren Nested child maps.
	     * @return {array} An array of mounted representations.
	     * @internal
	     */
	    mountChildren: function mountChildren(nestedChildren, transaction, context) {
	      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
	      this._renderedChildren = children;
	
	      var mountImages = [];
	      var index = 0;
	      for (var name in children) {
	        if (children.hasOwnProperty(name)) {
	          var child = children[name];
	          var selfDebugID = 0;
	          if (false) {
	            selfDebugID = getDebugID(this);
	          }
	          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          child._mountIndex = index++;
	          mountImages.push(mountImage);
	        }
	      }
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, children);
	      }
	
	      return mountImages;
	    },
	
	    /**
	     * Replaces any rendered children with a text content string.
	     *
	     * @param {string} nextContent String of content.
	     * @internal
	     */
	    updateTextContent: function updateTextContent(nextContent) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      // Set new text content.
	      var updates = [makeTextContent(nextContent)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Replaces any rendered children with a markup string.
	     *
	     * @param {string} nextMarkup String of markup.
	     * @internal
	     */
	    updateMarkup: function updateMarkup(nextMarkup) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      var updates = [makeSetMarkup(nextMarkup)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Updates the rendered children with new children.
	     *
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     */
	    updateChildren: function updateChildren(nextNestedChildrenElements, transaction, context) {
	      // Hook used by React ART
	      this._updateChildren(nextNestedChildrenElements, transaction, context);
	    },
	
	    /**
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @final
	     * @protected
	     */
	    _updateChildren: function _updateChildren(nextNestedChildrenElements, transaction, context) {
	      var prevChildren = this._renderedChildren;
	      var removedNodes = {};
	      var mountImages = [];
	      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
	      if (!nextChildren && !prevChildren) {
	        return;
	      }
	      var updates = null;
	      var name;
	      // `nextIndex` will increment for each child in `nextChildren`, but
	      // `lastIndex` will be the last index visited in `prevChildren`.
	      var nextIndex = 0;
	      var lastIndex = 0;
	      // `nextMountIndex` will increment for each newly mounted child.
	      var nextMountIndex = 0;
	      var lastPlacedNode = null;
	      for (name in nextChildren) {
	        if (!nextChildren.hasOwnProperty(name)) {
	          continue;
	        }
	        var prevChild = prevChildren && prevChildren[name];
	        var nextChild = nextChildren[name];
	        if (prevChild === nextChild) {
	          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
	          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	          prevChild._mountIndex = nextIndex;
	        } else {
	          if (prevChild) {
	            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
	            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	            // The `removedNodes` loop below will actually remove the child.
	          }
	          // The child must be instantiated before it's mounted.
	          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
	          nextMountIndex++;
	        }
	        nextIndex++;
	        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
	      }
	      // Remove children that are no longer present.
	      for (name in removedNodes) {
	        if (removedNodes.hasOwnProperty(name)) {
	          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
	        }
	      }
	      if (updates) {
	        processQueue(this, updates);
	      }
	      this._renderedChildren = nextChildren;
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, nextChildren);
	      }
	    },
	
	    /**
	     * Unmounts all rendered children. This should be used to clean up children
	     * when this component is unmounted. It does not actually perform any
	     * backend operations.
	     *
	     * @internal
	     */
	    unmountChildren: function unmountChildren(safely) {
	      var renderedChildren = this._renderedChildren;
	      ReactChildReconciler.unmountChildren(renderedChildren, safely);
	      this._renderedChildren = null;
	    },
	
	    /**
	     * Moves a child component to the supplied index.
	     *
	     * @param {ReactComponent} child Component to move.
	     * @param {number} toIndex Destination index of the element.
	     * @param {number} lastIndex Last index visited of the siblings of `child`.
	     * @protected
	     */
	    moveChild: function moveChild(child, afterNode, toIndex, lastIndex) {
	      // If the index of `child` is less than `lastIndex`, then it needs to
	      // be moved. Otherwise, we do not need to move it because a child will be
	      // inserted or moved before `child`.
	      if (child._mountIndex < lastIndex) {
	        return makeMove(child, afterNode, toIndex);
	      }
	    },
	
	    /**
	     * Creates a child component.
	     *
	     * @param {ReactComponent} child Component to create.
	     * @param {string} mountImage Markup to insert.
	     * @protected
	     */
	    createChild: function createChild(child, afterNode, mountImage) {
	      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
	    },
	
	    /**
	     * Removes a child component.
	     *
	     * @param {ReactComponent} child Child to remove.
	     * @protected
	     */
	    removeChild: function removeChild(child, node) {
	      return makeRemove(child, node);
	    },
	
	    /**
	     * Mounts a child with the supplied name.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to mount.
	     * @param {string} name Name of the child.
	     * @param {number} index Index at which to insert the child.
	     * @param {ReactReconcileTransaction} transaction
	     * @private
	     */
	    _mountChildAtIndex: function _mountChildAtIndex(child, mountImage, afterNode, index, transaction, context) {
	      child._mountIndex = index;
	      return this.createChild(child, afterNode, mountImage);
	    },
	
	    /**
	     * Unmounts a rendered child.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to unmount.
	     * @private
	     */
	    _unmountChild: function _unmountChild(child, node) {
	      var update = this.removeChild(child, node);
	      child._mountIndex = null;
	      return update;
	    }
	  }
	};
	
	module.exports = ReactMultiChild;

/***/ },
/* 856 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(12);
	
	var invariant = __webpack_require__(5);
	
	/**
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid owner.
	 * @final
	 */
	function isValidOwner(object) {
	  return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
	}
	
	/**
	 * ReactOwners are capable of storing references to owned components.
	 *
	 * All components are capable of //being// referenced by owner components, but
	 * only ReactOwner components are capable of //referencing// owned components.
	 * The named reference is known as a "ref".
	 *
	 * Refs are available when mounted and updated during reconciliation.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return (
	 *         <div onClick={this.handleClick}>
	 *           <CustomComponent ref="custom" />
	 *         </div>
	 *       );
	 *     },
	 *     handleClick: function() {
	 *       this.refs.custom.handleClick();
	 *     },
	 *     componentDidMount: function() {
	 *       this.refs.custom.initialize();
	 *     }
	 *   });
	 *
	 * Refs should rarely be used. When refs are used, they should only be done to
	 * control data that is not handled by React's data flow.
	 *
	 * @class ReactOwner
	 */
	var ReactOwner = {
	  /**
	   * Adds a component by ref to an owner component.
	   *
	   * @param {ReactComponent} component Component to reference.
	   * @param {string} ref Name by which to refer to the component.
	   * @param {ReactOwner} owner Component on which to record the ref.
	   * @final
	   * @internal
	   */
	  addComponentAsRefTo: function addComponentAsRefTo(component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
	    owner.attachRef(ref, component);
	  },
	
	  /**
	   * Removes a component by ref from an owner component.
	   *
	   * @param {ReactComponent} component Component to dereference.
	   * @param {string} ref Name of the ref to remove.
	   * @param {ReactOwner} owner Component on which the ref is recorded.
	   * @final
	   * @internal
	   */
	  removeComponentAsRefFrom: function removeComponentAsRefFrom(component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
	    var ownerPublicInstance = owner.getPublicInstance();
	    // Check that `component`'s owner is still alive and that `component` is still the current ref
	    // because we do not want to detach the ref if another component stole it.
	    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
	      owner.detachRef(ref);
	    }
	  }
	};
	
	module.exports = ReactOwner;

/***/ },
/* 857 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;

/***/ },
/* 858 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(11);
	
	var CallbackQueue = __webpack_require__(366);
	var PooledClass = __webpack_require__(75);
	var ReactBrowserEventEmitter = __webpack_require__(122);
	var ReactInputSelection = __webpack_require__(373);
	var ReactInstrumentation = __webpack_require__(46);
	var Transaction = __webpack_require__(124);
	var ReactUpdateQueue = __webpack_require__(173);
	
	/**
	 * Ensures that, when possible, the selection range (currently selected text
	 * input) is not disturbed by performing the transaction.
	 */
	var SELECTION_RESTORATION = {
	  /**
	   * @return {Selection} Selection information.
	   */
	  initialize: ReactInputSelection.getSelectionInformation,
	  /**
	   * @param {Selection} sel Selection information returned from `initialize`.
	   */
	  close: ReactInputSelection.restoreSelection
	};
	
	/**
	 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
	 * high level DOM manipulations (like temporarily removing a text input from the
	 * DOM).
	 */
	var EVENT_SUPPRESSION = {
	  /**
	   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
	   * the reconciliation.
	   */
	  initialize: function initialize() {
	    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
	    ReactBrowserEventEmitter.setEnabled(false);
	    return currentlyEnabled;
	  },
	
	  /**
	   * @param {boolean} previouslyEnabled Enabled status of
	   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
	   *   restores the previous value.
	   */
	  close: function close(previouslyEnabled) {
	    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
	  }
	};
	
	/**
	 * Provides a queue for collecting `componentDidMount` and
	 * `componentDidUpdate` callbacks during the transaction.
	 */
	var ON_DOM_READY_QUEUEING = {
	  /**
	   * Initializes the internal `onDOMReady` queue.
	   */
	  initialize: function initialize() {
	    this.reactMountReady.reset();
	  },
	
	  /**
	   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
	   */
	  close: function close() {
	    this.reactMountReady.notifyAll();
	  }
	};
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	/**
	 * Currently:
	 * - The order that these are listed in the transaction is critical:
	 * - Suppresses events.
	 * - Restores selection range.
	 *
	 * Future:
	 * - Restore document/overflow scroll positions that were unintentionally
	 *   modified via DOM insertions above the top viewport boundary.
	 * - Implement/integrate with customized constraint based layout system and keep
	 *   track of which dimensions must be remeasured.
	 *
	 * @class ReactReconcileTransaction
	 */
	function ReactReconcileTransaction(useCreateElement) {
	  this.reinitializeTransaction();
	  // Only server-side rendering really needs this option (see
	  // `ReactServerRendering`), but server-side uses
	  // `ReactServerRenderingTransaction` instead. This option is here so that it's
	  // accessible and defaults to false when `ReactDOMComponent` and
	  // `ReactDOMTextComponent` checks it in `mountComponent`.`
	  this.renderToStaticMarkup = false;
	  this.reactMountReady = CallbackQueue.getPooled(null);
	  this.useCreateElement = useCreateElement;
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array<object>} List of operation wrap procedures.
	   *   TODO: convert to array<TransactionWrapper>
	   */
	  getTransactionWrappers: function getTransactionWrappers() {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function getReactMountReady() {
	    return this.reactMountReady;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function getUpdateQueue() {
	    return ReactUpdateQueue;
	  },
	
	  /**
	   * Save current transaction state -- if the return value from this method is
	   * passed to `rollback`, the transaction will be reset to that state.
	   */
	  checkpoint: function checkpoint() {
	    // reactMountReady is the our only stateful wrapper
	    return this.reactMountReady.checkpoint();
	  },
	
	  rollback: function rollback(checkpoint) {
	    this.reactMountReady.rollback(checkpoint);
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function destructor() {
	    CallbackQueue.release(this.reactMountReady);
	    this.reactMountReady = null;
	  }
	};
	
	_assign(ReactReconcileTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactReconcileTransaction);
	
	module.exports = ReactReconcileTransaction;

/***/ },
/* 859 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var ReactOwner = __webpack_require__(856);
	
	var ReactRef = {};
	
	function attachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(component.getPublicInstance());
	  } else {
	    // Legacy ref
	    ReactOwner.addComponentAsRefTo(component, ref, owner);
	  }
	}
	
	function detachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(null);
	  } else {
	    // Legacy ref
	    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
	  }
	}
	
	ReactRef.attachRefs = function (instance, element) {
	  if (element === null || (typeof element === 'undefined' ? 'undefined' : _typeof(element)) !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    attachRef(ref, instance, element._owner);
	  }
	};
	
	ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
	  // If either the owner or a `ref` has changed, make sure the newest owner
	  // has stored a reference to `this`, and the previous owner (if different)
	  // has forgotten the reference to `this`. We use the element instead
	  // of the public this.props because the post processing cannot determine
	  // a ref. The ref conceptually lives on the element.
	
	  // TODO: Should this even be possible? The owner cannot change because
	  // it's forbidden by shouldUpdateReactComponent. The ref can change
	  // if you swap the keys of but not the refs. Reconsider where this check
	  // is made. It probably belongs where the key checking and
	  // instantiateReactComponent is done.
	
	  var prevRef = null;
	  var prevOwner = null;
	  if (prevElement !== null && (typeof prevElement === 'undefined' ? 'undefined' : _typeof(prevElement)) === 'object') {
	    prevRef = prevElement.ref;
	    prevOwner = prevElement._owner;
	  }
	
	  var nextRef = null;
	  var nextOwner = null;
	  if (nextElement !== null && (typeof nextElement === 'undefined' ? 'undefined' : _typeof(nextElement)) === 'object') {
	    nextRef = nextElement.ref;
	    nextOwner = nextElement._owner;
	  }
	
	  return prevRef !== nextRef ||
	  // If owner changes but we have an unchanged function ref, don't update refs
	  typeof nextRef === 'string' && nextOwner !== prevOwner;
	};
	
	ReactRef.detachRefs = function (instance, element) {
	  if (element === null || (typeof element === 'undefined' ? 'undefined' : _typeof(element)) !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    detachRef(ref, instance, element._owner);
	  }
	};
	
	module.exports = ReactRef;

/***/ },
/* 860 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(11);
	
	var PooledClass = __webpack_require__(75);
	var Transaction = __webpack_require__(124);
	var ReactInstrumentation = __webpack_require__(46);
	var ReactServerUpdateQueue = __webpack_require__(861);
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	var noopCallbackQueue = {
	  enqueue: function enqueue() {}
	};
	
	/**
	 * @class ReactServerRenderingTransaction
	 * @param {boolean} renderToStaticMarkup
	 */
	function ReactServerRenderingTransaction(renderToStaticMarkup) {
	  this.reinitializeTransaction();
	  this.renderToStaticMarkup = renderToStaticMarkup;
	  this.useCreateElement = false;
	  this.updateQueue = new ReactServerUpdateQueue(this);
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array} Empty list of operation wrap procedures.
	   */
	  getTransactionWrappers: function getTransactionWrappers() {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function getReactMountReady() {
	    return noopCallbackQueue;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function getUpdateQueue() {
	    return this.updateQueue;
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function destructor() {},
	
	  checkpoint: function checkpoint() {},
	
	  rollback: function rollback() {}
	};
	
	_assign(ReactServerRenderingTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactServerRenderingTransaction);
	
	module.exports = ReactServerRenderingTransaction;

/***/ },
/* 861 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	var ReactUpdateQueue = __webpack_require__(173);
	
	var warning = __webpack_require__(9);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the update queue used for server rendering.
	 * It delegates to ReactUpdateQueue while server rendering is in progress and
	 * switches to ReactNoopUpdateQueue after the transaction has completed.
	 * @class ReactServerUpdateQueue
	 * @param {Transaction} transaction
	 */
	
	var ReactServerUpdateQueue = function () {
	  function ReactServerUpdateQueue(transaction) {
	    _classCallCheck(this, ReactServerUpdateQueue);
	
	    this.transaction = transaction;
	  }
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	
	  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
	    return false;
	  };
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	
	  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
	    }
	  };
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	
	  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
	    } else {
	      warnNoop(publicInstance, 'forceUpdate');
	    }
	  };
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} completeState Next state.
	   * @internal
	   */
	
	  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
	    } else {
	      warnNoop(publicInstance, 'replaceState');
	    }
	  };
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} partialState Next partial state to be merged with state.
	   * @internal
	   */
	
	  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
	    } else {
	      warnNoop(publicInstance, 'setState');
	    }
	  };
	
	  return ReactServerUpdateQueue;
	}();
	
	module.exports = ReactServerUpdateQueue;

/***/ },
/* 862 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	module.exports = '15.6.1';

/***/ },
/* 863 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var NS = {
	  xlink: 'http://www.w3.org/1999/xlink',
	  xml: 'http://www.w3.org/XML/1998/namespace'
	};
	
	// We use attributes for everything SVG so let's avoid some duplication and run
	// code instead.
	// The following are all specified in the HTML config already so we exclude here.
	// - class (as className)
	// - color
	// - height
	// - id
	// - lang
	// - max
	// - media
	// - method
	// - min
	// - name
	// - style
	// - target
	// - type
	// - width
	var ATTRS = {
	  accentHeight: 'accent-height',
	  accumulate: 0,
	  additive: 0,
	  alignmentBaseline: 'alignment-baseline',
	  allowReorder: 'allowReorder',
	  alphabetic: 0,
	  amplitude: 0,
	  arabicForm: 'arabic-form',
	  ascent: 0,
	  attributeName: 'attributeName',
	  attributeType: 'attributeType',
	  autoReverse: 'autoReverse',
	  azimuth: 0,
	  baseFrequency: 'baseFrequency',
	  baseProfile: 'baseProfile',
	  baselineShift: 'baseline-shift',
	  bbox: 0,
	  begin: 0,
	  bias: 0,
	  by: 0,
	  calcMode: 'calcMode',
	  capHeight: 'cap-height',
	  clip: 0,
	  clipPath: 'clip-path',
	  clipRule: 'clip-rule',
	  clipPathUnits: 'clipPathUnits',
	  colorInterpolation: 'color-interpolation',
	  colorInterpolationFilters: 'color-interpolation-filters',
	  colorProfile: 'color-profile',
	  colorRendering: 'color-rendering',
	  contentScriptType: 'contentScriptType',
	  contentStyleType: 'contentStyleType',
	  cursor: 0,
	  cx: 0,
	  cy: 0,
	  d: 0,
	  decelerate: 0,
	  descent: 0,
	  diffuseConstant: 'diffuseConstant',
	  direction: 0,
	  display: 0,
	  divisor: 0,
	  dominantBaseline: 'dominant-baseline',
	  dur: 0,
	  dx: 0,
	  dy: 0,
	  edgeMode: 'edgeMode',
	  elevation: 0,
	  enableBackground: 'enable-background',
	  end: 0,
	  exponent: 0,
	  externalResourcesRequired: 'externalResourcesRequired',
	  fill: 0,
	  fillOpacity: 'fill-opacity',
	  fillRule: 'fill-rule',
	  filter: 0,
	  filterRes: 'filterRes',
	  filterUnits: 'filterUnits',
	  floodColor: 'flood-color',
	  floodOpacity: 'flood-opacity',
	  focusable: 0,
	  fontFamily: 'font-family',
	  fontSize: 'font-size',
	  fontSizeAdjust: 'font-size-adjust',
	  fontStretch: 'font-stretch',
	  fontStyle: 'font-style',
	  fontVariant: 'font-variant',
	  fontWeight: 'font-weight',
	  format: 0,
	  from: 0,
	  fx: 0,
	  fy: 0,
	  g1: 0,
	  g2: 0,
	  glyphName: 'glyph-name',
	  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
	  glyphOrientationVertical: 'glyph-orientation-vertical',
	  glyphRef: 'glyphRef',
	  gradientTransform: 'gradientTransform',
	  gradientUnits: 'gradientUnits',
	  hanging: 0,
	  horizAdvX: 'horiz-adv-x',
	  horizOriginX: 'horiz-origin-x',
	  ideographic: 0,
	  imageRendering: 'image-rendering',
	  'in': 0,
	  in2: 0,
	  intercept: 0,
	  k: 0,
	  k1: 0,
	  k2: 0,
	  k3: 0,
	  k4: 0,
	  kernelMatrix: 'kernelMatrix',
	  kernelUnitLength: 'kernelUnitLength',
	  kerning: 0,
	  keyPoints: 'keyPoints',
	  keySplines: 'keySplines',
	  keyTimes: 'keyTimes',
	  lengthAdjust: 'lengthAdjust',
	  letterSpacing: 'letter-spacing',
	  lightingColor: 'lighting-color',
	  limitingConeAngle: 'limitingConeAngle',
	  local: 0,
	  markerEnd: 'marker-end',
	  markerMid: 'marker-mid',
	  markerStart: 'marker-start',
	  markerHeight: 'markerHeight',
	  markerUnits: 'markerUnits',
	  markerWidth: 'markerWidth',
	  mask: 0,
	  maskContentUnits: 'maskContentUnits',
	  maskUnits: 'maskUnits',
	  mathematical: 0,
	  mode: 0,
	  numOctaves: 'numOctaves',
	  offset: 0,
	  opacity: 0,
	  operator: 0,
	  order: 0,
	  orient: 0,
	  orientation: 0,
	  origin: 0,
	  overflow: 0,
	  overlinePosition: 'overline-position',
	  overlineThickness: 'overline-thickness',
	  paintOrder: 'paint-order',
	  panose1: 'panose-1',
	  pathLength: 'pathLength',
	  patternContentUnits: 'patternContentUnits',
	  patternTransform: 'patternTransform',
	  patternUnits: 'patternUnits',
	  pointerEvents: 'pointer-events',
	  points: 0,
	  pointsAtX: 'pointsAtX',
	  pointsAtY: 'pointsAtY',
	  pointsAtZ: 'pointsAtZ',
	  preserveAlpha: 'preserveAlpha',
	  preserveAspectRatio: 'preserveAspectRatio',
	  primitiveUnits: 'primitiveUnits',
	  r: 0,
	  radius: 0,
	  refX: 'refX',
	  refY: 'refY',
	  renderingIntent: 'rendering-intent',
	  repeatCount: 'repeatCount',
	  repeatDur: 'repeatDur',
	  requiredExtensions: 'requiredExtensions',
	  requiredFeatures: 'requiredFeatures',
	  restart: 0,
	  result: 0,
	  rotate: 0,
	  rx: 0,
	  ry: 0,
	  scale: 0,
	  seed: 0,
	  shapeRendering: 'shape-rendering',
	  slope: 0,
	  spacing: 0,
	  specularConstant: 'specularConstant',
	  specularExponent: 'specularExponent',
	  speed: 0,
	  spreadMethod: 'spreadMethod',
	  startOffset: 'startOffset',
	  stdDeviation: 'stdDeviation',
	  stemh: 0,
	  stemv: 0,
	  stitchTiles: 'stitchTiles',
	  stopColor: 'stop-color',
	  stopOpacity: 'stop-opacity',
	  strikethroughPosition: 'strikethrough-position',
	  strikethroughThickness: 'strikethrough-thickness',
	  string: 0,
	  stroke: 0,
	  strokeDasharray: 'stroke-dasharray',
	  strokeDashoffset: 'stroke-dashoffset',
	  strokeLinecap: 'stroke-linecap',
	  strokeLinejoin: 'stroke-linejoin',
	  strokeMiterlimit: 'stroke-miterlimit',
	  strokeOpacity: 'stroke-opacity',
	  strokeWidth: 'stroke-width',
	  surfaceScale: 'surfaceScale',
	  systemLanguage: 'systemLanguage',
	  tableValues: 'tableValues',
	  targetX: 'targetX',
	  targetY: 'targetY',
	  textAnchor: 'text-anchor',
	  textDecoration: 'text-decoration',
	  textRendering: 'text-rendering',
	  textLength: 'textLength',
	  to: 0,
	  transform: 0,
	  u1: 0,
	  u2: 0,
	  underlinePosition: 'underline-position',
	  underlineThickness: 'underline-thickness',
	  unicode: 0,
	  unicodeBidi: 'unicode-bidi',
	  unicodeRange: 'unicode-range',
	  unitsPerEm: 'units-per-em',
	  vAlphabetic: 'v-alphabetic',
	  vHanging: 'v-hanging',
	  vIdeographic: 'v-ideographic',
	  vMathematical: 'v-mathematical',
	  values: 0,
	  vectorEffect: 'vector-effect',
	  version: 0,
	  vertAdvY: 'vert-adv-y',
	  vertOriginX: 'vert-origin-x',
	  vertOriginY: 'vert-origin-y',
	  viewBox: 'viewBox',
	  viewTarget: 'viewTarget',
	  visibility: 0,
	  widths: 0,
	  wordSpacing: 'word-spacing',
	  writingMode: 'writing-mode',
	  x: 0,
	  xHeight: 'x-height',
	  x1: 0,
	  x2: 0,
	  xChannelSelector: 'xChannelSelector',
	  xlinkActuate: 'xlink:actuate',
	  xlinkArcrole: 'xlink:arcrole',
	  xlinkHref: 'xlink:href',
	  xlinkRole: 'xlink:role',
	  xlinkShow: 'xlink:show',
	  xlinkTitle: 'xlink:title',
	  xlinkType: 'xlink:type',
	  xmlBase: 'xml:base',
	  xmlns: 0,
	  xmlnsXlink: 'xmlns:xlink',
	  xmlLang: 'xml:lang',
	  xmlSpace: 'xml:space',
	  y: 0,
	  y1: 0,
	  y2: 0,
	  yChannelSelector: 'yChannelSelector',
	  z: 0,
	  zoomAndPan: 'zoomAndPan'
	};
	
	var SVGDOMPropertyConfig = {
	  Properties: {},
	  DOMAttributeNamespaces: {
	    xlinkActuate: NS.xlink,
	    xlinkArcrole: NS.xlink,
	    xlinkHref: NS.xlink,
	    xlinkRole: NS.xlink,
	    xlinkShow: NS.xlink,
	    xlinkTitle: NS.xlink,
	    xlinkType: NS.xlink,
	    xmlBase: NS.xml,
	    xmlLang: NS.xml,
	    xmlSpace: NS.xml
	  },
	  DOMAttributeNames: {}
	};
	
	Object.keys(ATTRS).forEach(function (key) {
	  SVGDOMPropertyConfig.Properties[key] = 0;
	  if (ATTRS[key]) {
	    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
	  }
	});
	
	module.exports = SVGDOMPropertyConfig;

/***/ },
/* 864 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(96);
	var ExecutionEnvironment = __webpack_require__(32);
	var ReactDOMComponentTree = __webpack_require__(23);
	var ReactInputSelection = __webpack_require__(373);
	var SyntheticEvent = __webpack_require__(56);
	
	var getActiveElement = __webpack_require__(241);
	var isTextInputElement = __webpack_require__(383);
	var shallowEqual = __webpack_require__(164);
	
	var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;
	
	var eventTypes = {
	  select: {
	    phasedRegistrationNames: {
	      bubbled: 'onSelect',
	      captured: 'onSelectCapture'
	    },
	    dependencies: ['topBlur', 'topContextMenu', 'topFocus', 'topKeyDown', 'topKeyUp', 'topMouseDown', 'topMouseUp', 'topSelectionChange']
	  }
	};
	
	var activeElement = null;
	var activeElementInst = null;
	var lastSelection = null;
	var mouseDown = false;
	
	// Track whether a listener exists for this plugin. If none exist, we do
	// not extract events. See #3639.
	var hasListener = false;
	
	/**
	 * Get an object which is a unique representation of the current selection.
	 *
	 * The return value will not be consistent across nodes or browsers, but
	 * two identical selections on the same node will return identical objects.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getSelection(node) {
	  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
	    return {
	      start: node.selectionStart,
	      end: node.selectionEnd
	    };
	  } else if (window.getSelection) {
	    var selection = window.getSelection();
	    return {
	      anchorNode: selection.anchorNode,
	      anchorOffset: selection.anchorOffset,
	      focusNode: selection.focusNode,
	      focusOffset: selection.focusOffset
	    };
	  } else if (document.selection) {
	    var range = document.selection.createRange();
	    return {
	      parentElement: range.parentElement(),
	      text: range.text,
	      top: range.boundingTop,
	      left: range.boundingLeft
	    };
	  }
	}
	
	/**
	 * Poll selection to see whether it's changed.
	 *
	 * @param {object} nativeEvent
	 * @return {?SyntheticEvent}
	 */
	function constructSelectEvent(nativeEvent, nativeEventTarget) {
	  // Ensure we have the right element, and that the user is not dragging a
	  // selection (this matches native `select` event behavior). In HTML5, select
	  // fires only on input and textarea thus if there's no focused element we
	  // won't dispatch.
	  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
	    return null;
	  }
	
	  // Only fire when selection has actually changed.
	  var currentSelection = getSelection(activeElement);
	  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
	    lastSelection = currentSelection;
	
	    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);
	
	    syntheticEvent.type = 'select';
	    syntheticEvent.target = activeElement;
	
	    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);
	
	    return syntheticEvent;
	  }
	
	  return null;
	}
	
	/**
	 * This plugin creates an `onSelect` event that normalizes select events
	 * across form elements.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - contentEditable
	 *
	 * This differs from native browser implementations in the following ways:
	 * - Fires on contentEditable fields as well as inputs.
	 * - Fires for collapsed selection.
	 * - Fires after user input.
	 */
	var SelectEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (!hasListener) {
	      return null;
	    }
	
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    switch (topLevelType) {
	      // Track the input node that has focus.
	      case 'topFocus':
	        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
	          activeElement = targetNode;
	          activeElementInst = targetInst;
	          lastSelection = null;
	        }
	        break;
	      case 'topBlur':
	        activeElement = null;
	        activeElementInst = null;
	        lastSelection = null;
	        break;
	      // Don't fire the event while the user is dragging. This matches the
	      // semantics of the native select event.
	      case 'topMouseDown':
	        mouseDown = true;
	        break;
	      case 'topContextMenu':
	      case 'topMouseUp':
	        mouseDown = false;
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	      // Chrome and IE fire non-standard event when selection is changed (and
	      // sometimes when it hasn't). IE's event fires out of order with respect
	      // to key and input events on deletion, so we discard it.
	      //
	      // Firefox doesn't support selectionchange, so check selection status
	      // after each key entry. The selection changes after keydown and before
	      // keyup, but we check on keydown as well in the case of holding down a
	      // key, when multiple keydown events are fired but only one keyup is.
	      // This is also our approach for IE handling, for the reason above.
	      case 'topSelectionChange':
	        if (skipSelectionChangeEvent) {
	          break;
	        }
	      // falls through
	      case 'topKeyDown':
	      case 'topKeyUp':
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	    }
	
	    return null;
	  },
	
	  didPutListener: function didPutListener(inst, registrationName, listener) {
	    if (registrationName === 'onSelect') {
	      hasListener = true;
	    }
	  }
	};
	
	module.exports = SelectEventPlugin;

/***/ },
/* 865 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(12);
	
	var EventListener = __webpack_require__(238);
	var EventPropagators = __webpack_require__(96);
	var ReactDOMComponentTree = __webpack_require__(23);
	var SyntheticAnimationEvent = __webpack_require__(866);
	var SyntheticClipboardEvent = __webpack_require__(867);
	var SyntheticEvent = __webpack_require__(56);
	var SyntheticFocusEvent = __webpack_require__(870);
	var SyntheticKeyboardEvent = __webpack_require__(872);
	var SyntheticMouseEvent = __webpack_require__(123);
	var SyntheticDragEvent = __webpack_require__(869);
	var SyntheticTouchEvent = __webpack_require__(873);
	var SyntheticTransitionEvent = __webpack_require__(874);
	var SyntheticUIEvent = __webpack_require__(98);
	var SyntheticWheelEvent = __webpack_require__(875);
	
	var emptyFunction = __webpack_require__(41);
	var getEventCharCode = __webpack_require__(175);
	var invariant = __webpack_require__(5);
	
	/**
	 * Turns
	 * ['abort', ...]
	 * into
	 * eventTypes = {
	 *   'abort': {
	 *     phasedRegistrationNames: {
	 *       bubbled: 'onAbort',
	 *       captured: 'onAbortCapture',
	 *     },
	 *     dependencies: ['topAbort'],
	 *   },
	 *   ...
	 * };
	 * topLevelEventsToDispatchConfig = {
	 *   'topAbort': { sameConfig }
	 * };
	 */
	var eventTypes = {};
	var topLevelEventsToDispatchConfig = {};
	['abort', 'animationEnd', 'animationIteration', 'animationStart', 'blur', 'canPlay', 'canPlayThrough', 'click', 'contextMenu', 'copy', 'cut', 'doubleClick', 'drag', 'dragEnd', 'dragEnter', 'dragExit', 'dragLeave', 'dragOver', 'dragStart', 'drop', 'durationChange', 'emptied', 'encrypted', 'ended', 'error', 'focus', 'input', 'invalid', 'keyDown', 'keyPress', 'keyUp', 'load', 'loadedData', 'loadedMetadata', 'loadStart', 'mouseDown', 'mouseMove', 'mouseOut', 'mouseOver', 'mouseUp', 'paste', 'pause', 'play', 'playing', 'progress', 'rateChange', 'reset', 'scroll', 'seeked', 'seeking', 'stalled', 'submit', 'suspend', 'timeUpdate', 'touchCancel', 'touchEnd', 'touchMove', 'touchStart', 'transitionEnd', 'volumeChange', 'waiting', 'wheel'].forEach(function (event) {
	  var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
	  var onEvent = 'on' + capitalizedEvent;
	  var topEvent = 'top' + capitalizedEvent;
	
	  var type = {
	    phasedRegistrationNames: {
	      bubbled: onEvent,
	      captured: onEvent + 'Capture'
	    },
	    dependencies: [topEvent]
	  };
	  eventTypes[event] = type;
	  topLevelEventsToDispatchConfig[topEvent] = type;
	});
	
	var onClickListeners = {};
	
	function getDictionaryKey(inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	}
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	var SimpleEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
	    if (!dispatchConfig) {
	      return null;
	    }
	    var EventConstructor;
	    switch (topLevelType) {
	      case 'topAbort':
	      case 'topCanPlay':
	      case 'topCanPlayThrough':
	      case 'topDurationChange':
	      case 'topEmptied':
	      case 'topEncrypted':
	      case 'topEnded':
	      case 'topError':
	      case 'topInput':
	      case 'topInvalid':
	      case 'topLoad':
	      case 'topLoadedData':
	      case 'topLoadedMetadata':
	      case 'topLoadStart':
	      case 'topPause':
	      case 'topPlay':
	      case 'topPlaying':
	      case 'topProgress':
	      case 'topRateChange':
	      case 'topReset':
	      case 'topSeeked':
	      case 'topSeeking':
	      case 'topStalled':
	      case 'topSubmit':
	      case 'topSuspend':
	      case 'topTimeUpdate':
	      case 'topVolumeChange':
	      case 'topWaiting':
	        // HTML Events
	        // @see http://www.w3.org/TR/html5/index.html#events-0
	        EventConstructor = SyntheticEvent;
	        break;
	      case 'topKeyPress':
	        // Firefox creates a keypress event for function keys too. This removes
	        // the unwanted keypress events. Enter is however both printable and
	        // non-printable. One would expect Tab to be as well (but it isn't).
	        if (getEventCharCode(nativeEvent) === 0) {
	          return null;
	        }
	      /* falls through */
	      case 'topKeyDown':
	      case 'topKeyUp':
	        EventConstructor = SyntheticKeyboardEvent;
	        break;
	      case 'topBlur':
	      case 'topFocus':
	        EventConstructor = SyntheticFocusEvent;
	        break;
	      case 'topClick':
	        // Firefox creates a click event on right mouse clicks. This removes the
	        // unwanted click events.
	        if (nativeEvent.button === 2) {
	          return null;
	        }
	      /* falls through */
	      case 'topDoubleClick':
	      case 'topMouseDown':
	      case 'topMouseMove':
	      case 'topMouseUp':
	      // TODO: Disabled elements should not respond to mouse events
	      /* falls through */
	      case 'topMouseOut':
	      case 'topMouseOver':
	      case 'topContextMenu':
	        EventConstructor = SyntheticMouseEvent;
	        break;
	      case 'topDrag':
	      case 'topDragEnd':
	      case 'topDragEnter':
	      case 'topDragExit':
	      case 'topDragLeave':
	      case 'topDragOver':
	      case 'topDragStart':
	      case 'topDrop':
	        EventConstructor = SyntheticDragEvent;
	        break;
	      case 'topTouchCancel':
	      case 'topTouchEnd':
	      case 'topTouchMove':
	      case 'topTouchStart':
	        EventConstructor = SyntheticTouchEvent;
	        break;
	      case 'topAnimationEnd':
	      case 'topAnimationIteration':
	      case 'topAnimationStart':
	        EventConstructor = SyntheticAnimationEvent;
	        break;
	      case 'topTransitionEnd':
	        EventConstructor = SyntheticTransitionEvent;
	        break;
	      case 'topScroll':
	        EventConstructor = SyntheticUIEvent;
	        break;
	      case 'topWheel':
	        EventConstructor = SyntheticWheelEvent;
	        break;
	      case 'topCopy':
	      case 'topCut':
	      case 'topPaste':
	        EventConstructor = SyntheticClipboardEvent;
	        break;
	    }
	    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
	    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
	    EventPropagators.accumulateTwoPhaseDispatches(event);
	    return event;
	  },
	
	  didPutListener: function didPutListener(inst, registrationName, listener) {
	    // Mobile Safari does not fire properly bubble click events on
	    // non-interactive elements, which means delegated click listeners do not
	    // fire. The workaround for this bug involves attaching an empty click
	    // listener on the target node.
	    // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      if (!onClickListeners[key]) {
	        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
	      }
	    }
	  },
	
	  willDeleteListener: function willDeleteListener(inst, registrationName) {
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      onClickListeners[key].remove();
	      delete onClickListeners[key];
	    }
	  }
	};
	
	module.exports = SimpleEventPlugin;

/***/ },
/* 866 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(56);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
	 */
	var AnimationEventInterface = {
	  animationName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);
	
	module.exports = SyntheticAnimationEvent;

/***/ },
/* 867 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(56);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/clipboard-apis/
	 */
	var ClipboardEventInterface = {
	  clipboardData: function clipboardData(event) {
	    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);
	
	module.exports = SyntheticClipboardEvent;

/***/ },
/* 868 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(56);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
	 */
	var CompositionEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);
	
	module.exports = SyntheticCompositionEvent;

/***/ },
/* 869 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(123);
	
	/**
	 * @interface DragEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var DragEventInterface = {
	  dataTransfer: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);
	
	module.exports = SyntheticDragEvent;

/***/ },
/* 870 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(98);
	
	/**
	 * @interface FocusEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var FocusEventInterface = {
	  relatedTarget: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);
	
	module.exports = SyntheticFocusEvent;

/***/ },
/* 871 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(56);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
	 *      /#events-inputevents
	 */
	var InputEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);
	
	module.exports = SyntheticInputEvent;

/***/ },
/* 872 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(98);
	
	var getEventCharCode = __webpack_require__(175);
	var getEventKey = __webpack_require__(880);
	var getEventModifierState = __webpack_require__(176);
	
	/**
	 * @interface KeyboardEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var KeyboardEventInterface = {
	  key: getEventKey,
	  location: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  repeat: null,
	  locale: null,
	  getModifierState: getEventModifierState,
	  // Legacy Interface
	  charCode: function charCode(event) {
	    // `charCode` is the result of a KeyPress event and represents the value of
	    // the actual printable character.
	
	    // KeyPress is deprecated, but its replacement is not yet final and not
	    // implemented in any major browser. Only KeyPress has charCode.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    return 0;
	  },
	  keyCode: function keyCode(event) {
	    // `keyCode` is the result of a KeyDown/Up event and represents the value of
	    // physical keyboard key.
	
	    // The actual meaning of the value depends on the users' keyboard layout
	    // which cannot be detected. Assuming that it is a US keyboard layout
	    // provides a surprisingly accurate mapping for US and European users.
	    // Due to this, it is left to the user to implement at this time.
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  },
	  which: function which(event) {
	    // `which` is an alias for either `keyCode` or `charCode` depending on the
	    // type of the event.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);
	
	module.exports = SyntheticKeyboardEvent;

/***/ },
/* 873 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(98);
	
	var getEventModifierState = __webpack_require__(176);
	
	/**
	 * @interface TouchEvent
	 * @see http://www.w3.org/TR/touch-events/
	 */
	var TouchEventInterface = {
	  touches: null,
	  targetTouches: null,
	  changedTouches: null,
	  altKey: null,
	  metaKey: null,
	  ctrlKey: null,
	  shiftKey: null,
	  getModifierState: getEventModifierState
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);
	
	module.exports = SyntheticTouchEvent;

/***/ },
/* 874 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(56);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
	 */
	var TransitionEventInterface = {
	  propertyName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);
	
	module.exports = SyntheticTransitionEvent;

/***/ },
/* 875 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(123);
	
	/**
	 * @interface WheelEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var WheelEventInterface = {
	  deltaX: function deltaX(event) {
	    return 'deltaX' in event ? event.deltaX : // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
	    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
	  },
	  deltaY: function deltaY(event) {
	    return 'deltaY' in event ? event.deltaY : // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
	    'wheelDeltaY' in event ? -event.wheelDeltaY : // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
	    'wheelDelta' in event ? -event.wheelDelta : 0;
	  },
	  deltaZ: null,
	
	  // Browsers without "deltaMode" is reporting in raw wheel delta where one
	  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
	  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
	  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
	  deltaMode: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticMouseEvent}
	 */
	function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);
	
	module.exports = SyntheticWheelEvent;

/***/ },
/* 876 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var MOD = 65521;
	
	// adler32 is not cryptographically strong, and is only used to sanity check that
	// markup generated on the server matches the markup generated on the client.
	// This implementation (a modified version of the SheetJS version) has been optimized
	// for our use case, at the expense of conforming to the adler32 specification
	// for non-ascii inputs.
	function adler32(data) {
	  var a = 1;
	  var b = 0;
	  var i = 0;
	  var l = data.length;
	  var m = l & ~0x3;
	  while (i < m) {
	    var n = Math.min(i + 4096, m);
	    for (; i < n; i += 4) {
	      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
	    }
	    a %= MOD;
	    b %= MOD;
	  }
	  for (; i < l; i++) {
	    b += a += data.charCodeAt(i);
	  }
	  a %= MOD;
	  b %= MOD;
	  return a | b << 16;
	}
	
	module.exports = adler32;

/***/ },
/* 877 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(365);
	var warning = __webpack_require__(9);
	
	var isUnitlessNumber = CSSProperty.isUnitlessNumber;
	var styleWarnings = {};
	
	/**
	 * Convert a value into the proper css writable value. The style name `name`
	 * should be logical (no hyphens), as specified
	 * in `CSSProperty.isUnitlessNumber`.
	 *
	 * @param {string} name CSS property name such as `topMargin`.
	 * @param {*} value CSS property value such as `10px`.
	 * @param {ReactDOMComponent} component
	 * @return {string} Normalized style value with dimensions applied.
	 */
	function dangerousStyleValue(name, value, component, isCustomProperty) {
	  // Note that we've removed escapeTextForBrowser() calls here since the
	  // whole string will be escaped when the attribute is injected into
	  // the markup. If you provide unsafe user data here they can inject
	  // arbitrary CSS which may be problematic (I couldn't repro this):
	  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
	  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
	  // This is not an XSS hole but instead a potential CSS injection issue
	  // which has lead to a greater discussion about how we're going to
	  // trust URLs moving forward. See #2115901
	
	  var isEmpty = value == null || typeof value === 'boolean' || value === '';
	  if (isEmpty) {
	    return '';
	  }
	
	  var isNonNumeric = isNaN(value);
	  if (isCustomProperty || isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
	    return '' + value; // cast to string
	  }
	
	  if (typeof value === 'string') {
	    if (false) {
	      // Allow '0' to pass through without warning. 0 is already special and
	      // doesn't require units, so we don't need to warn about it.
	      if (component && value !== '0') {
	        var owner = component._currentElement._owner;
	        var ownerName = owner ? owner.getName() : null;
	        if (ownerName && !styleWarnings[ownerName]) {
	          styleWarnings[ownerName] = {};
	        }
	        var warned = false;
	        if (ownerName) {
	          var warnings = styleWarnings[ownerName];
	          warned = warnings[name];
	          if (!warned) {
	            warnings[name] = true;
	          }
	        }
	        if (!warned) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
	        }
	      }
	    }
	    value = value.trim();
	  }
	  return value + 'px';
	}
	
	module.exports = dangerousStyleValue;

/***/ },
/* 878 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(12);
	
	var ReactCurrentOwner = __webpack_require__(57);
	var ReactDOMComponentTree = __webpack_require__(23);
	var ReactInstanceMap = __webpack_require__(97);
	
	var getHostComponentFromComposite = __webpack_require__(379);
	var invariant = __webpack_require__(5);
	var warning = __webpack_require__(9);
	
	/**
	 * Returns the DOM node rendered by this element.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
	 *
	 * @param {ReactComponent|DOMElement} componentOrElement
	 * @return {?DOMElement} The root node of this element.
	 */
	function findDOMNode(componentOrElement) {
	  if (false) {
	    var owner = ReactCurrentOwner.current;
	    if (owner !== null) {
	      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	      owner._warnedAboutRefsInRender = true;
	    }
	  }
	  if (componentOrElement == null) {
	    return null;
	  }
	  if (componentOrElement.nodeType === 1) {
	    return componentOrElement;
	  }
	
	  var inst = ReactInstanceMap.get(componentOrElement);
	  if (inst) {
	    inst = getHostComponentFromComposite(inst);
	    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
	  }
	
	  if (typeof componentOrElement.render === 'function') {
	     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
	  } else {
	     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
	  }
	}
	
	module.exports = findDOMNode;

/***/ },
/* 879 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var KeyEscapeUtils = __webpack_require__(169);
	var traverseAllChildren = __webpack_require__(385);
	var warning = __webpack_require__(9);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && process.env && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(387);
	}
	
	/**
	 * @param {function} traverseContext Context passed through traversal.
	 * @param {?ReactComponent} child React child component.
	 * @param {!string} name String name of key path to child.
	 * @param {number=} selfDebugID Optional debugID of the current internal instance.
	 */
	function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
	  // We found a component instance.
	  if (traverseContext && (typeof traverseContext === 'undefined' ? 'undefined' : _typeof(traverseContext)) === 'object') {
	    var result = traverseContext;
	    var keyUnique = result[name] === undefined;
	    if (false) {
	      if (!ReactComponentTreeHook) {
	        ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	      }
	      if (!keyUnique) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	      }
	    }
	    if (keyUnique && child != null) {
	      result[name] = child;
	    }
	  }
	}
	
	/**
	 * Flattens children that are typically specified as `props.children`. Any null
	 * children will not be included in the resulting object.
	 * @return {!object} flattened children keyed by name.
	 */
	function flattenChildren(children, selfDebugID) {
	  if (children == null) {
	    return children;
	  }
	  var result = {};
	
	  if (false) {
	    traverseAllChildren(children, function (traverseContext, child, name) {
	      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
	    }, result);
	  } else {
	    traverseAllChildren(children, flattenSingleChildIntoContext, result);
	  }
	  return result;
	}
	
	module.exports = flattenChildren;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(121)))

/***/ },
/* 880 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var getEventCharCode = __webpack_require__(175);
	
	/**
	 * Normalization of deprecated HTML5 `key` values
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var normalizeKey = {
	  Esc: 'Escape',
	  Spacebar: ' ',
	  Left: 'ArrowLeft',
	  Up: 'ArrowUp',
	  Right: 'ArrowRight',
	  Down: 'ArrowDown',
	  Del: 'Delete',
	  Win: 'OS',
	  Menu: 'ContextMenu',
	  Apps: 'ContextMenu',
	  Scroll: 'ScrollLock',
	  MozPrintableKey: 'Unidentified'
	};
	
	/**
	 * Translation from legacy `keyCode` to HTML5 `key`
	 * Only special keys supported, all others depend on keyboard layout or browser
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var translateToKey = {
	  8: 'Backspace',
	  9: 'Tab',
	  12: 'Clear',
	  13: 'Enter',
	  16: 'Shift',
	  17: 'Control',
	  18: 'Alt',
	  19: 'Pause',
	  20: 'CapsLock',
	  27: 'Escape',
	  32: ' ',
	  33: 'PageUp',
	  34: 'PageDown',
	  35: 'End',
	  36: 'Home',
	  37: 'ArrowLeft',
	  38: 'ArrowUp',
	  39: 'ArrowRight',
	  40: 'ArrowDown',
	  45: 'Insert',
	  46: 'Delete',
	  112: 'F1',
	  113: 'F2',
	  114: 'F3',
	  115: 'F4',
	  116: 'F5',
	  117: 'F6',
	  118: 'F7',
	  119: 'F8',
	  120: 'F9',
	  121: 'F10',
	  122: 'F11',
	  123: 'F12',
	  144: 'NumLock',
	  145: 'ScrollLock',
	  224: 'Meta'
	};
	
	/**
	 * @param {object} nativeEvent Native browser event.
	 * @return {string} Normalized `key` property.
	 */
	function getEventKey(nativeEvent) {
	  if (nativeEvent.key) {
	    // Normalize inconsistent values reported by browsers due to
	    // implementations of a working draft specification.
	
	    // FireFox implements `key` but returns `MozPrintableKey` for all
	    // printable characters (normalized to `Unidentified`), ignore it.
	    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
	    if (key !== 'Unidentified') {
	      return key;
	    }
	  }
	
	  // Browser does not implement `key`, polyfill as much of it as we can.
	  if (nativeEvent.type === 'keypress') {
	    var charCode = getEventCharCode(nativeEvent);
	
	    // The enter-key is technically both printable and non-printable and can
	    // thus be captured by `keypress`, no other non-printable key should.
	    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
	  }
	  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
	    // While user keyboard layout determines the actual meaning of each
	    // `keyCode` value, almost all function keys have a universal value.
	    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
	  }
	  return '';
	}
	
	module.exports = getEventKey;

/***/ },
/* 881 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/* global Symbol */
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ },
/* 882 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given any node return the first leaf node without children.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {DOMElement|DOMTextNode}
	 */
	
	function getLeafNode(node) {
	  while (node && node.firstChild) {
	    node = node.firstChild;
	  }
	  return node;
	}
	
	/**
	 * Get the next sibling within a container. This will walk up the
	 * DOM if a node's siblings have been exhausted.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {?DOMElement|DOMTextNode}
	 */
	function getSiblingNode(node) {
	  while (node) {
	    if (node.nextSibling) {
	      return node.nextSibling;
	    }
	    node = node.parentNode;
	  }
	}
	
	/**
	 * Get object describing the nodes which contain characters at offset.
	 *
	 * @param {DOMElement|DOMTextNode} root
	 * @param {number} offset
	 * @return {?object}
	 */
	function getNodeForCharacterOffset(root, offset) {
	  var node = getLeafNode(root);
	  var nodeStart = 0;
	  var nodeEnd = 0;
	
	  while (node) {
	    if (node.nodeType === 3) {
	      nodeEnd = nodeStart + node.textContent.length;
	
	      if (nodeStart <= offset && nodeEnd >= offset) {
	        return {
	          node: node,
	          offset: offset - nodeStart
	        };
	      }
	
	      nodeStart = nodeEnd;
	    }
	
	    node = getLeafNode(getSiblingNode(node));
	  }
	}
	
	module.exports = getNodeForCharacterOffset;

/***/ },
/* 883 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(32);
	
	/**
	 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
	 *
	 * @param {string} styleProp
	 * @param {string} eventName
	 * @returns {object}
	 */
	function makePrefixMap(styleProp, eventName) {
	  var prefixes = {};
	
	  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
	  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
	  prefixes['Moz' + styleProp] = 'moz' + eventName;
	  prefixes['ms' + styleProp] = 'MS' + eventName;
	  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();
	
	  return prefixes;
	}
	
	/**
	 * A list of event names to a configurable list of vendor prefixes.
	 */
	var vendorPrefixes = {
	  animationend: makePrefixMap('Animation', 'AnimationEnd'),
	  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
	  animationstart: makePrefixMap('Animation', 'AnimationStart'),
	  transitionend: makePrefixMap('Transition', 'TransitionEnd')
	};
	
	/**
	 * Event names that have already been detected and prefixed (if applicable).
	 */
	var prefixedEventNames = {};
	
	/**
	 * Element to check for prefixes on.
	 */
	var style = {};
	
	/**
	 * Bootstrap if a DOM exists.
	 */
	if (ExecutionEnvironment.canUseDOM) {
	  style = document.createElement('div').style;
	
	  // On some platforms, in particular some releases of Android 4.x,
	  // the un-prefixed "animation" and "transition" properties are defined on the
	  // style object but the events that fire will still be prefixed, so we need
	  // to check if the un-prefixed events are usable, and if not remove them from the map.
	  if (!('AnimationEvent' in window)) {
	    delete vendorPrefixes.animationend.animation;
	    delete vendorPrefixes.animationiteration.animation;
	    delete vendorPrefixes.animationstart.animation;
	  }
	
	  // Same as above
	  if (!('TransitionEvent' in window)) {
	    delete vendorPrefixes.transitionend.transition;
	  }
	}
	
	/**
	 * Attempts to determine the correct vendor prefixed event name.
	 *
	 * @param {string} eventName
	 * @returns {string}
	 */
	function getVendorPrefixedEventName(eventName) {
	  if (prefixedEventNames[eventName]) {
	    return prefixedEventNames[eventName];
	  } else if (!vendorPrefixes[eventName]) {
	    return eventName;
	  }
	
	  var prefixMap = vendorPrefixes[eventName];
	
	  for (var styleProp in prefixMap) {
	    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
	      return prefixedEventNames[eventName] = prefixMap[styleProp];
	    }
	  }
	
	  return '';
	}
	
	module.exports = getVendorPrefixedEventName;

/***/ },
/* 884 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var escapeTextContentForBrowser = __webpack_require__(125);
	
	/**
	 * Escapes attribute value to prevent scripting attacks.
	 *
	 * @param {*} value Value to escape.
	 * @return {string} An escaped string.
	 */
	function quoteAttributeValueForBrowser(value) {
	  return '"' + escapeTextContentForBrowser(value) + '"';
	}
	
	module.exports = quoteAttributeValueForBrowser;

/***/ },
/* 885 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactMount = __webpack_require__(374);
	
	module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ },
/* 886 */
/***/ function(module, exports) {

	/** @license React v16.13.1
	 * react-is.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var b = "function" === typeof Symbol && Symbol.for,
	    c = b ? Symbol.for("react.element") : 60103,
	    d = b ? Symbol.for("react.portal") : 60106,
	    e = b ? Symbol.for("react.fragment") : 60107,
	    f = b ? Symbol.for("react.strict_mode") : 60108,
	    g = b ? Symbol.for("react.profiler") : 60114,
	    h = b ? Symbol.for("react.provider") : 60109,
	    k = b ? Symbol.for("react.context") : 60110,
	    l = b ? Symbol.for("react.async_mode") : 60111,
	    m = b ? Symbol.for("react.concurrent_mode") : 60111,
	    n = b ? Symbol.for("react.forward_ref") : 60112,
	    p = b ? Symbol.for("react.suspense") : 60113,
	    q = b ? Symbol.for("react.suspense_list") : 60120,
	    r = b ? Symbol.for("react.memo") : 60115,
	    t = b ? Symbol.for("react.lazy") : 60116,
	    v = b ? Symbol.for("react.block") : 60121,
	    w = b ? Symbol.for("react.fundamental") : 60117,
	    x = b ? Symbol.for("react.responder") : 60118,
	    y = b ? Symbol.for("react.scope") : 60119;
	function z(a) {
	  if ("object" === (typeof a === "undefined" ? "undefined" : _typeof(a)) && null !== a) {
	    var u = a.$$typeof;switch (u) {case c:
	        switch (a = a.type, a) {case l:case m:case e:case g:case f:case p:
	            return a;default:
	            switch (a = a && a.$$typeof, a) {case k:case n:case t:case r:case h:
	                return a;default:
	                return u;}}case d:
	        return u;}
	  }
	}function A(a) {
	  return z(a) === m;
	}exports.AsyncMode = l;exports.ConcurrentMode = m;exports.ContextConsumer = k;exports.ContextProvider = h;exports.Element = c;exports.ForwardRef = n;exports.Fragment = e;exports.Lazy = t;exports.Memo = r;exports.Portal = d;
	exports.Profiler = g;exports.StrictMode = f;exports.Suspense = p;exports.isAsyncMode = function (a) {
	  return A(a) || z(a) === l;
	};exports.isConcurrentMode = A;exports.isContextConsumer = function (a) {
	  return z(a) === k;
	};exports.isContextProvider = function (a) {
	  return z(a) === h;
	};exports.isElement = function (a) {
	  return "object" === (typeof a === "undefined" ? "undefined" : _typeof(a)) && null !== a && a.$$typeof === c;
	};exports.isForwardRef = function (a) {
	  return z(a) === n;
	};exports.isFragment = function (a) {
	  return z(a) === e;
	};exports.isLazy = function (a) {
	  return z(a) === t;
	};
	exports.isMemo = function (a) {
	  return z(a) === r;
	};exports.isPortal = function (a) {
	  return z(a) === d;
	};exports.isProfiler = function (a) {
	  return z(a) === g;
	};exports.isStrictMode = function (a) {
	  return z(a) === f;
	};exports.isSuspense = function (a) {
	  return z(a) === p;
	};
	exports.isValidElementType = function (a) {
	  return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === (typeof a === "undefined" ? "undefined" : _typeof(a)) && null !== a && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
	};exports.typeOf = z;

/***/ },
/* 887 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(886);
	} else {
	  module.exports = require('./cjs/react-is.development.js');
	}

/***/ },
/* 888 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	function componentWillMount() {
	  // Call this.constructor.gDSFP to support sub-classes.
	  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
	  if (state !== null && state !== undefined) {
	    this.setState(state);
	  }
	}
	
	function componentWillReceiveProps(nextProps) {
	  // Call this.constructor.gDSFP to support sub-classes.
	  // Use the setState() updater to ensure state isn't stale in certain edge cases.
	  function updater(prevState) {
	    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
	    return state !== null && state !== undefined ? state : null;
	  }
	  // Binding "this" is important for shallow renderer support.
	  this.setState(updater.bind(this));
	}
	
	function componentWillUpdate(nextProps, nextState) {
	  try {
	    var prevProps = this.props;
	    var prevState = this.state;
	    this.props = nextProps;
	    this.state = nextState;
	    this.__reactInternalSnapshotFlag = true;
	    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(prevProps, prevState);
	  } finally {
	    this.props = prevProps;
	    this.state = prevState;
	  }
	}
	
	// React may warn about cWM/cWRP/cWU methods being deprecated.
	// Add a flag to suppress these warnings for this special case.
	componentWillMount.__suppressDeprecationWarning = true;
	componentWillReceiveProps.__suppressDeprecationWarning = true;
	componentWillUpdate.__suppressDeprecationWarning = true;
	
	function polyfill(Component) {
	  var prototype = Component.prototype;
	
	  if (!prototype || !prototype.isReactComponent) {
	    throw new Error('Can only polyfill class components');
	  }
	
	  if (typeof Component.getDerivedStateFromProps !== 'function' && typeof prototype.getSnapshotBeforeUpdate !== 'function') {
	    return Component;
	  }
	
	  // If new component APIs are defined, "unsafe" lifecycles won't be called.
	  // Error if any of these lifecycles are present,
	  // Because they would work differently between older and newer (16.3+) versions of React.
	  var foundWillMountName = null;
	  var foundWillReceivePropsName = null;
	  var foundWillUpdateName = null;
	  if (typeof prototype.componentWillMount === 'function') {
	    foundWillMountName = 'componentWillMount';
	  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
	    foundWillMountName = 'UNSAFE_componentWillMount';
	  }
	  if (typeof prototype.componentWillReceiveProps === 'function') {
	    foundWillReceivePropsName = 'componentWillReceiveProps';
	  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
	    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
	  }
	  if (typeof prototype.componentWillUpdate === 'function') {
	    foundWillUpdateName = 'componentWillUpdate';
	  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
	    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
	  }
	  if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
	    var componentName = Component.displayName || Component.name;
	    var newApiName = typeof Component.getDerivedStateFromProps === 'function' ? 'getDerivedStateFromProps()' : 'getSnapshotBeforeUpdate()';
	
	    throw Error('Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' + componentName + ' uses ' + newApiName + ' but also contains the following legacy lifecycles:' + (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') + (foundWillReceivePropsName !== null ? '\n  ' + foundWillReceivePropsName : '') + (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') + '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' + 'https://fb.me/react-async-component-lifecycle-hooks');
	  }
	
	  // React <= 16.2 does not support static getDerivedStateFromProps.
	  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
	  // Newer versions of React will ignore these lifecycles if gDSFP exists.
	  if (typeof Component.getDerivedStateFromProps === 'function') {
	    prototype.componentWillMount = componentWillMount;
	    prototype.componentWillReceiveProps = componentWillReceiveProps;
	  }
	
	  // React <= 16.2 does not support getSnapshotBeforeUpdate.
	  // As a workaround, use cWU to invoke the new lifecycle.
	  // Newer versions of React will ignore that lifecycle if gSBU exists.
	  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
	    if (typeof prototype.componentDidUpdate !== 'function') {
	      throw new Error('Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype');
	    }
	
	    prototype.componentWillUpdate = componentWillUpdate;
	
	    var componentDidUpdate = prototype.componentDidUpdate;
	
	    prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
	      // 16.3+ will not execute our will-update method;
	      // It will pass a snapshot value to did-update though.
	      // Older versions will require our polyfilled will-update value.
	      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
	      // Because for <= 15.x versions this might be a "prevContext" object.
	      // We also can't just check "__reactInternalSnapshot",
	      // Because get-snapshot might return a falsy value.
	      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
	      var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;
	
	      componentDidUpdate.call(this, prevProps, prevState, snapshot);
	    };
	  }
	
	  return Component;
	}
	
	exports.polyfill = polyfill;

/***/ },
/* 889 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _interopDefault(e) {
	  return e && "object" == (typeof e === "undefined" ? "undefined" : _typeof(e)) && "default" in e ? e.default : e;
	}var React = _interopDefault(__webpack_require__(3));__webpack_require__(29);var invariant = _interopDefault(__webpack_require__(807)),
	    json2mq = _interopDefault(__webpack_require__(813));function _defineProperty(e, t, i) {
	  return t in e ? Object.defineProperty(e, t, { value: i, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = i, e;
	}function _inheritsLoose(e, t) {
	  e.prototype = Object.create(t.prototype), (e.prototype.constructor = e).__proto__ = t;
	}function _assertThisInitialized(e) {
	  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e;
	}var MediaQueryList = function () {
	  function e(e, t, i) {
	    var n = this;this.nativeMediaQueryList = e.matchMedia(t), this.active = !0, this.cancellableListener = function () {
	      n.matches = n.nativeMediaQueryList.matches, n.active && i.apply(void 0, arguments);
	    }, this.nativeMediaQueryList.addListener(this.cancellableListener), this.matches = this.nativeMediaQueryList.matches;
	  }return e.prototype.cancel = function () {
	    this.active = !1, this.nativeMediaQueryList.removeListener(this.cancellableListener);
	  }, e;
	}(),
	    Media = function (r) {
	  function e() {
	    for (var i, e = arguments.length, t = new Array(e), n = 0; n < e; n++) {
	      t[n] = arguments[n];
	    }return _defineProperty(_assertThisInitialized(_assertThisInitialized(i = r.call.apply(r, [this].concat(t)) || this)), "state", { matches: i.props.defaultMatches }), _defineProperty(_assertThisInitialized(_assertThisInitialized(i)), "updateMatches", function () {
	      var e = i.mediaQueryList.matches;i.setState({ matches: e });var t = i.props.onChange;t && t(e);
	    }), i;
	  }_inheritsLoose(e, r);var t = e.prototype;return t.componentWillMount = function () {
	    if ("object" == (typeof window === "undefined" ? "undefined" : _typeof(window))) {
	      var e = this.props.targetWindow || window;"function" != typeof e.matchMedia && invariant(!1);var t = this.props.query;"string" != typeof t && (t = json2mq(t)), this.mediaQueryList = new MediaQueryList(e, t, this.updateMatches), this.updateMatches();
	    }
	  }, t.componentWillUnmount = function () {
	    this.mediaQueryList.cancel();
	  }, t.render = function () {
	    var e = this.props,
	        t = e.children,
	        i = e.render,
	        n = this.state.matches;return i ? n ? i() : null : t ? "function" == typeof t ? t(n) : (!Array.isArray(t) || t.length) && n ? React.Children.only(t) : null : null;
	  }, e;
	}(React.Component);_defineProperty(Media, "defaultProps", { defaultMatches: !0 }), module.exports = Media;

/***/ },
/* 890 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(889);
	} else {
	  module.exports = require('./cjs/react-media.js');
	}

/***/ },
/* 891 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault(ex) {
	  return ex && (typeof ex === 'undefined' ? 'undefined' : _typeof(ex)) === 'object' && 'default' in ex ? ex['default'] : ex;
	}
	
	var react = __webpack_require__(3);
	var PropTypes = _interopDefault(__webpack_require__(893));
	var PopperJS = _interopDefault(__webpack_require__(816));
	
	var classCallCheck = function classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	var createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	var inherits = function inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	};
	
	var objectWithoutProperties = function objectWithoutProperties(obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};
	
	var possibleConstructorReturn = function possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && ((typeof call === 'undefined' ? 'undefined' : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	};
	
	var Manager = function (_Component) {
	  inherits(Manager, _Component);
	
	  function Manager() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    classCallCheck(this, Manager);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = Manager.__proto__ || Object.getPrototypeOf(Manager)).call.apply(_ref, [this].concat(args))), _this), _this._setTargetNode = function (node) {
	      _this._targetNode = node;
	    }, _this._getTargetNode = function () {
	      return _this._targetNode;
	    }, _temp), possibleConstructorReturn(_this, _ret);
	  }
	
	  createClass(Manager, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {
	        popperManager: {
	          setTargetNode: this._setTargetNode,
	          getTargetNode: this._getTargetNode
	        }
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          tag = _props.tag,
	          children = _props.children,
	          restProps = objectWithoutProperties(_props, ['tag', 'children']);
	
	      if (tag !== false) {
	        return react.createElement(tag, restProps, children);
	      } else {
	        return children;
	      }
	    }
	  }]);
	  return Manager;
	}(react.Component);
	
	Manager.childContextTypes = {
	  popperManager: PropTypes.object.isRequired
	};
	Manager.propTypes = {
	  tag: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
	  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func])
	};
	Manager.defaultProps = {
	  tag: 'div'
	};
	
	var Target = function Target(props, context) {
	  var _props$component = props.component,
	      component = _props$component === undefined ? 'div' : _props$component,
	      innerRef = props.innerRef,
	      children = props.children,
	      restProps = objectWithoutProperties(props, ['component', 'innerRef', 'children']);
	  var popperManager = context.popperManager;
	
	  var targetRef = function targetRef(node) {
	    popperManager.setTargetNode(node);
	    if (typeof innerRef === 'function') {
	      innerRef(node);
	    }
	  };
	
	  if (typeof children === 'function') {
	    var targetProps = { ref: targetRef };
	    return children({ targetProps: targetProps, restProps: restProps });
	  }
	
	  var componentProps = _extends({}, restProps);
	
	  if (typeof component === 'string') {
	    componentProps.ref = targetRef;
	  } else {
	    componentProps.innerRef = targetRef;
	  }
	
	  return react.createElement(component, componentProps, children);
	};
	
	Target.contextTypes = {
	  popperManager: PropTypes.object.isRequired
	};
	
	Target.propTypes = {
	  component: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
	  innerRef: PropTypes.func,
	  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func])
	};
	
	var placements = PopperJS.placements;
	
	var Popper = function (_Component) {
	  inherits(Popper, _Component);
	
	  function Popper() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    classCallCheck(this, Popper);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = Popper.__proto__ || Object.getPrototypeOf(Popper)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this._setArrowNode = function (node) {
	      _this._arrowNode = node;
	    }, _this._getTargetNode = function () {
	      if (_this.props.target) {
	        return _this.props.target;
	      } else if (!_this.context.popperManager || !_this.context.popperManager.getTargetNode()) {
	        throw new Error('Target missing. Popper must be given a target from the Popper Manager, or as a prop.');
	      }
	      return _this.context.popperManager.getTargetNode();
	    }, _this._getOffsets = function (data) {
	      return Object.keys(data.offsets).map(function (key) {
	        return data.offsets[key];
	      });
	    }, _this._isDataDirty = function (data) {
	      if (_this.state.data) {
	        return JSON.stringify(_this._getOffsets(_this.state.data)) !== JSON.stringify(_this._getOffsets(data));
	      } else {
	        return true;
	      }
	    }, _this._updateStateModifier = {
	      enabled: true,
	      order: 900,
	      fn: function fn(data) {
	        if (_this._isDataDirty(data)) {
	          _this.setState({ data: data });
	        }
	        return data;
	      }
	    }, _this._getPopperStyle = function () {
	      var data = _this.state.data;
	
	      if (!_this._popper || !data) {
	        return {
	          position: 'absolute',
	          pointerEvents: 'none',
	          opacity: 0
	        };
	      }
	
	      return _extends({
	        position: data.offsets.popper.position
	      }, data.styles);
	    }, _this._getPopperPlacement = function () {
	      return _this.state.data ? _this.state.data.placement : undefined;
	    }, _this._getPopperHide = function () {
	      return !!_this.state.data && _this.state.data.hide ? '' : undefined;
	    }, _this._getArrowStyle = function () {
	      if (!_this.state.data || !_this.state.data.offsets.arrow) {
	        return {};
	      } else {
	        var _this$state$data$offs = _this.state.data.offsets.arrow,
	            top = _this$state$data$offs.top,
	            left = _this$state$data$offs.left;
	
	        return { top: top, left: left };
	      }
	    }, _this._handlePopperRef = function (node) {
	      _this._popperNode = node;
	      if (node) {
	        _this._createPopper();
	      } else {
	        _this._destroyPopper();
	      }
	      if (_this.props.innerRef) {
	        _this.props.innerRef(node);
	      }
	    }, _this._scheduleUpdate = function () {
	      _this._popper && _this._popper.scheduleUpdate();
	    }, _temp), possibleConstructorReturn(_this, _ret);
	  }
	
	  createClass(Popper, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {
	        popper: {
	          setArrowNode: this._setArrowNode,
	          getArrowStyle: this._getArrowStyle
	        }
	      };
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(lastProps) {
	      if (lastProps.placement !== this.props.placement || lastProps.eventsEnabled !== this.props.eventsEnabled || lastProps.target !== this.props.target) {
	        this._destroyPopper();
	        this._createPopper();
	      }
	      if (lastProps.children !== this.props.children) {
	        this._scheduleUpdate();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this._destroyPopper();
	    }
	  }, {
	    key: '_createPopper',
	    value: function _createPopper() {
	      var _this2 = this;
	
	      var _props = this.props,
	          placement = _props.placement,
	          eventsEnabled = _props.eventsEnabled,
	          positionFixed = _props.positionFixed;
	
	      var modifiers = _extends({}, this.props.modifiers, {
	        applyStyle: { enabled: false },
	        updateState: this._updateStateModifier
	      });
	      if (this._arrowNode) {
	        modifiers.arrow = _extends({}, this.props.modifiers.arrow || {}, {
	          element: this._arrowNode
	        });
	      }
	      this._popper = new PopperJS(this._getTargetNode(), this._popperNode, {
	        placement: placement,
	        positionFixed: positionFixed,
	        eventsEnabled: eventsEnabled,
	        modifiers: modifiers
	      });
	
	      // TODO: look into setTimeout scheduleUpdate call, without it, the popper will not position properly on creation
	      setTimeout(function () {
	        return _this2._scheduleUpdate();
	      });
	    }
	  }, {
	    key: '_destroyPopper',
	    value: function _destroyPopper() {
	      if (this._popper) {
	        this._popper.destroy();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          component = _props2.component,
	          innerRef = _props2.innerRef,
	          placement = _props2.placement,
	          eventsEnabled = _props2.eventsEnabled,
	          positionFixed = _props2.positionFixed,
	          modifiers = _props2.modifiers,
	          children = _props2.children,
	          restProps = objectWithoutProperties(_props2, ['component', 'innerRef', 'placement', 'eventsEnabled', 'positionFixed', 'modifiers', 'children']);
	
	      var popperStyle = this._getPopperStyle();
	      var popperPlacement = this._getPopperPlacement();
	      var popperHide = this._getPopperHide();
	
	      if (typeof children === 'function') {
	        var popperProps = {
	          ref: this._handlePopperRef,
	          style: popperStyle,
	          'data-placement': popperPlacement,
	          'data-x-out-of-boundaries': popperHide
	        };
	        return children({
	          popperProps: popperProps,
	          restProps: restProps,
	          scheduleUpdate: this._scheduleUpdate
	        });
	      }
	
	      var componentProps = _extends({}, restProps, {
	        style: _extends({}, restProps.style, popperStyle),
	        'data-placement': popperPlacement,
	        'data-x-out-of-boundaries': popperHide
	      });
	
	      if (typeof component === 'string') {
	        componentProps.ref = this._handlePopperRef;
	      } else {
	        componentProps.innerRef = this._handlePopperRef;
	      }
	
	      return react.createElement(component, componentProps, children);
	    }
	  }]);
	  return Popper;
	}(react.Component);
	
	Popper.contextTypes = {
	  popperManager: PropTypes.object
	};
	Popper.childContextTypes = {
	  popper: PropTypes.object.isRequired
	};
	Popper.propTypes = {
	  component: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
	  innerRef: PropTypes.func,
	  placement: PropTypes.oneOf(placements),
	  eventsEnabled: PropTypes.bool,
	  positionFixed: PropTypes.bool,
	  modifiers: PropTypes.object,
	  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
	  target: PropTypes.oneOfType([
	  // the following check is needed for SSR
	  PropTypes.instanceOf(typeof Element !== 'undefined' ? Element : Object), PropTypes.shape({
	    getBoundingClientRect: PropTypes.func.isRequired,
	    clientWidth: PropTypes.number.isRequired,
	    clientHeight: PropTypes.number.isRequired
	  })])
	};
	Popper.defaultProps = {
	  component: 'div',
	  placement: 'bottom',
	  eventsEnabled: true,
	  positionFixed: false,
	  modifiers: {}
	};
	
	var Arrow = function Arrow(props, context) {
	  var _props$component = props.component,
	      component = _props$component === undefined ? 'span' : _props$component,
	      innerRef = props.innerRef,
	      children = props.children,
	      restProps = objectWithoutProperties(props, ['component', 'innerRef', 'children']);
	  var popper = context.popper;
	
	  var arrowRef = function arrowRef(node) {
	    popper.setArrowNode(node);
	    if (typeof innerRef === 'function') {
	      innerRef(node);
	    }
	  };
	  var arrowStyle = popper.getArrowStyle();
	
	  if (typeof children === 'function') {
	    var arrowProps = {
	      ref: arrowRef,
	      style: arrowStyle
	    };
	    return children({ arrowProps: arrowProps, restProps: restProps });
	  }
	
	  var componentProps = _extends({}, restProps, {
	    style: _extends({}, arrowStyle, restProps.style)
	  });
	
	  if (typeof component === 'string') {
	    componentProps.ref = arrowRef;
	  } else {
	    componentProps.innerRef = arrowRef;
	  }
	
	  return react.createElement(component, componentProps, children);
	};
	
	Arrow.contextTypes = {
	  popper: PropTypes.object.isRequired
	};
	
	Arrow.propTypes = {
	  component: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
	  innerRef: PropTypes.func,
	  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func])
	};
	
	exports.Manager = Manager;
	exports.Target = Target;
	exports.Popper = Popper;
	exports.placements = placements;
	exports.Arrow = Arrow;
	//# sourceMappingURL=react-popper.js.map

/***/ },
/* 892 */
[1041, 894],
/* 893 */
[1042, 892],
/* 894 */
491,
/* 895 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }return target;
	};
	
	var _chainFunction = __webpack_require__(522);
	
	var _chainFunction2 = _interopRequireDefault(_chainFunction);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(29);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(954);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _ChildMapping = __webpack_require__(896);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var propTypes = {
	  component: _propTypes2.default.any,
	  childFactory: _propTypes2.default.func,
	  children: _propTypes2.default.node
	};
	
	var defaultProps = {
	  component: 'span',
	  childFactory: function childFactory(child) {
	    return child;
	  }
	};
	
	var TransitionGroup = function (_React$Component) {
	  _inherits(TransitionGroup, _React$Component);
	
	  function TransitionGroup(props, context) {
	    _classCallCheck(this, TransitionGroup);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    _this.performAppear = function (key, component) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      if (component.componentWillAppear) {
	        component.componentWillAppear(_this._handleDoneAppearing.bind(_this, key, component));
	      } else {
	        _this._handleDoneAppearing(key, component);
	      }
	    };
	
	    _this._handleDoneAppearing = function (key, component) {
	      if (component.componentDidAppear) {
	        component.componentDidAppear();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);
	
	      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
	        // This was removed before it had fully appeared. Remove it.
	        _this.performLeave(key, component);
	      }
	    };
	
	    _this.performEnter = function (key, component) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      if (component.componentWillEnter) {
	        component.componentWillEnter(_this._handleDoneEntering.bind(_this, key, component));
	      } else {
	        _this._handleDoneEntering(key, component);
	      }
	    };
	
	    _this._handleDoneEntering = function (key, component) {
	      if (component.componentDidEnter) {
	        component.componentDidEnter();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);
	
	      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
	        // This was removed before it had fully entered. Remove it.
	        _this.performLeave(key, component);
	      }
	    };
	
	    _this.performLeave = function (key, component) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      if (component.componentWillLeave) {
	        component.componentWillLeave(_this._handleDoneLeaving.bind(_this, key, component));
	      } else {
	        // Note that this is somewhat dangerous b/c it calls setState()
	        // again, effectively mutating the component before all the work
	        // is done.
	        _this._handleDoneLeaving(key, component);
	      }
	    };
	
	    _this._handleDoneLeaving = function (key, component) {
	      if (component.componentDidLeave) {
	        component.componentDidLeave();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);
	
	      if (currentChildMapping && currentChildMapping.hasOwnProperty(key)) {
	        // This entered again before it fully left. Add it again.
	        _this.keysToEnter.push(key);
	      } else {
	        _this.setState(function (state) {
	          var newChildren = _extends({}, state.children);
	          delete newChildren[key];
	          return { children: newChildren };
	        });
	      }
	    };
	
	    _this.childRefs = Object.create(null);
	
	    _this.state = {
	      children: (0, _ChildMapping.getChildMapping)(props.children)
	    };
	    return _this;
	  }
	
	  TransitionGroup.prototype.componentWillMount = function componentWillMount() {
	    this.currentlyTransitioningKeys = {};
	    this.keysToEnter = [];
	    this.keysToLeave = [];
	  };
	
	  TransitionGroup.prototype.componentDidMount = function componentDidMount() {
	    var initialChildMapping = this.state.children;
	    for (var key in initialChildMapping) {
	      if (initialChildMapping[key]) {
	        this.performAppear(key, this.childRefs[key]);
	      }
	    }
	  };
	
	  TransitionGroup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var nextChildMapping = (0, _ChildMapping.getChildMapping)(nextProps.children);
	    var prevChildMapping = this.state.children;
	
	    this.setState({
	      children: (0, _ChildMapping.mergeChildMappings)(prevChildMapping, nextChildMapping)
	    });
	
	    for (var key in nextChildMapping) {
	      var hasPrev = prevChildMapping && prevChildMapping.hasOwnProperty(key);
	      if (nextChildMapping[key] && !hasPrev && !this.currentlyTransitioningKeys[key]) {
	        this.keysToEnter.push(key);
	      }
	    }
	
	    for (var _key in prevChildMapping) {
	      var hasNext = nextChildMapping && nextChildMapping.hasOwnProperty(_key);
	      if (prevChildMapping[_key] && !hasNext && !this.currentlyTransitioningKeys[_key]) {
	        this.keysToLeave.push(_key);
	      }
	    }
	
	    // If we want to someday check for reordering, we could do it here.
	  };
	
	  TransitionGroup.prototype.componentDidUpdate = function componentDidUpdate() {
	    var _this2 = this;
	
	    var keysToEnter = this.keysToEnter;
	    this.keysToEnter = [];
	    keysToEnter.forEach(function (key) {
	      return _this2.performEnter(key, _this2.childRefs[key]);
	    });
	
	    var keysToLeave = this.keysToLeave;
	    this.keysToLeave = [];
	    keysToLeave.forEach(function (key) {
	      return _this2.performLeave(key, _this2.childRefs[key]);
	    });
	  };
	
	  TransitionGroup.prototype.render = function render() {
	    var _this3 = this;
	
	    // TODO: we could get rid of the need for the wrapper node
	    // by cloning a single child
	    var childrenToRender = [];
	
	    var _loop = function _loop(key) {
	      var child = _this3.state.children[key];
	      if (child) {
	        var isCallbackRef = typeof child.ref !== 'string';
	        var factoryChild = _this3.props.childFactory(child);
	        var ref = function ref(r) {
	          _this3.childRefs[key] = r;
	        };
	
	         false ? (0, _warning2.default)(isCallbackRef, 'string refs are not supported on children of TransitionGroup and will be ignored. ' + 'Please use a callback ref instead: https://facebook.github.io/react/docs/refs-and-the-dom.html#the-ref-callback-attribute') : void 0;
	
	        // Always chaining the refs leads to problems when the childFactory
	        // wraps the child. The child ref callback gets called twice with the
	        // wrapper and the child. So we only need to chain the ref if the
	        // factoryChild is not different from child.
	        if (factoryChild === child && isCallbackRef) {
	          ref = (0, _chainFunction2.default)(child.ref, ref);
	        }
	
	        // You may need to apply reactive updates to a child as it is leaving.
	        // The normal React way to do it won't work since the child will have
	        // already been removed. In case you need this behavior you can provide
	        // a childFactory function to wrap every child, even the ones that are
	        // leaving.
	        childrenToRender.push(_react2.default.cloneElement(factoryChild, {
	          key: key,
	          ref: ref
	        }));
	      }
	    };
	
	    for (var key in this.state.children) {
	      _loop(key);
	    }
	
	    // Do not forward TransitionGroup props to primitive DOM nodes
	    var props = _extends({}, this.props);
	    delete props.transitionLeave;
	    delete props.transitionName;
	    delete props.transitionAppear;
	    delete props.transitionEnter;
	    delete props.childFactory;
	    delete props.transitionLeaveTimeout;
	    delete props.transitionEnterTimeout;
	    delete props.transitionAppearTimeout;
	    delete props.component;
	
	    return _react2.default.createElement(this.props.component, props, childrenToRender);
	  };
	
	  return TransitionGroup;
	}(_react2.default.Component);
	
	TransitionGroup.displayName = 'TransitionGroup';
	
	TransitionGroup.propTypes =  false ? propTypes : {};
	TransitionGroup.defaultProps = defaultProps;
	
	exports.default = TransitionGroup;
	module.exports = exports['default'];

/***/ },
/* 896 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.getChildMapping = getChildMapping;
	exports.mergeChildMappings = mergeChildMappings;
	
	var _react = __webpack_require__(3);
	
	/**
	 * Given `this.props.children`, return an object mapping key to child.
	 *
	 * @param {*} children `this.props.children`
	 * @return {object} Mapping of key to child
	 */
	function getChildMapping(children) {
	  if (!children) {
	    return children;
	  }
	  var result = {};
	  _react.Children.map(children, function (child) {
	    return child;
	  }).forEach(function (child) {
	    result[child.key] = child;
	  });
	  return result;
	}
	
	/**
	 * When you're adding or removing children some may be added or removed in the
	 * same render pass. We want to show *both* since we want to simultaneously
	 * animate elements in and out. This function takes a previous set of keys
	 * and a new set of keys and merges them with its best guess of the correct
	 * ordering. In the future we may expose some of the utilities in
	 * ReactMultiChild to make this easy, but for now React itself does not
	 * directly have this concept of the union of prevChildren and nextChildren
	 * so we implement it here.
	 *
	 * @param {object} prev prev children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @param {object} next next children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @return {object} a key set that contains all keys in `prev` and all keys
	 * in `next` in a reasonable order.
	 */
	function mergeChildMappings(prev, next) {
	  prev = prev || {};
	  next = next || {};
	
	  function getValueForKey(key) {
	    if (next.hasOwnProperty(key)) {
	      return next[key];
	    }
	
	    return prev[key];
	  }
	
	  // For each key of `next`, the list of keys to insert before that key in
	  // the combined list
	  var nextKeysPending = {};
	
	  var pendingKeys = [];
	  for (var prevKey in prev) {
	    if (next.hasOwnProperty(prevKey)) {
	      if (pendingKeys.length) {
	        nextKeysPending[prevKey] = pendingKeys;
	        pendingKeys = [];
	      }
	    } else {
	      pendingKeys.push(prevKey);
	    }
	  }
	
	  var i = void 0;
	  var childMapping = {};
	  for (var nextKey in next) {
	    if (nextKeysPending.hasOwnProperty(nextKey)) {
	      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
	        var pendingNextKey = nextKeysPending[nextKey][i];
	        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
	      }
	    }
	    childMapping[nextKey] = getValueForKey(nextKey);
	  }
	
	  // Finally, add the keys which didn't appear before any key in `next`
	  for (i = 0; i < pendingKeys.length; i++) {
	    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
	  }
	
	  return childMapping;
	}

/***/ },
/* 897 */
169,
/* 898 */
[1043, 99],
/* 899 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(898);
	var ReactElement = __webpack_require__(87);
	
	var emptyFunction = __webpack_require__(41);
	var traverseAllChildren = __webpack_require__(908);
	
	var twoArgumentPooler = PooledClass.twoArgumentPooler;
	var fourArgumentPooler = PooledClass.fourArgumentPooler;
	
	var userProvidedKeyEscapeRegex = /\/+/g;
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * traversal. Allows avoiding binding callbacks.
	 *
	 * @constructor ForEachBookKeeping
	 * @param {!function} forEachFunction Function to perform traversal with.
	 * @param {?*} forEachContext Context to perform context with.
	 */
	function ForEachBookKeeping(forEachFunction, forEachContext) {
	  this.func = forEachFunction;
	  this.context = forEachContext;
	  this.count = 0;
	}
	ForEachBookKeeping.prototype.destructor = function () {
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);
	
	function forEachSingleChild(bookKeeping, child, name) {
	  var func = bookKeeping.func,
	      context = bookKeeping.context;
	
	  func.call(context, child, bookKeeping.count++);
	}
	
	/**
	 * Iterates through children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} forEachFunc
	 * @param {*} forEachContext Context for forEachContext.
	 */
	function forEachChildren(children, forEachFunc, forEachContext) {
	  if (children == null) {
	    return children;
	  }
	  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
	  traverseAllChildren(children, forEachSingleChild, traverseContext);
	  ForEachBookKeeping.release(traverseContext);
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * mapping. Allows avoiding binding callbacks.
	 *
	 * @constructor MapBookKeeping
	 * @param {!*} mapResult Object containing the ordered map of results.
	 * @param {!function} mapFunction Function to perform mapping with.
	 * @param {?*} mapContext Context to perform mapping with.
	 */
	function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
	  this.result = mapResult;
	  this.keyPrefix = keyPrefix;
	  this.func = mapFunction;
	  this.context = mapContext;
	  this.count = 0;
	}
	MapBookKeeping.prototype.destructor = function () {
	  this.result = null;
	  this.keyPrefix = null;
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);
	
	function mapSingleChildIntoContext(bookKeeping, child, childKey) {
	  var result = bookKeeping.result,
	      keyPrefix = bookKeeping.keyPrefix,
	      func = bookKeeping.func,
	      context = bookKeeping.context;
	
	  var mappedChild = func.call(context, child, bookKeeping.count++);
	  if (Array.isArray(mappedChild)) {
	    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
	  } else if (mappedChild != null) {
	    if (ReactElement.isValidElement(mappedChild)) {
	      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
	      // Keep both the (mapped) and old keys if they differ, just as
	      // traverseAllChildren used to do for objects as children
	      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
	    }
	    result.push(mappedChild);
	  }
	}
	
	function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
	  var escapedPrefix = '';
	  if (prefix != null) {
	    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
	  }
	  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	}
	
	/**
	 * Maps children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
	 *
	 * The provided mapFunction(child, key, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func The map function.
	 * @param {*} context Context for mapFunction.
	 * @return {object} Object containing the ordered map of results.
	 */
	function mapChildren(children, func, context) {
	  if (children == null) {
	    return children;
	  }
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
	  return result;
	}
	
	function forEachSingleChildDummy(traverseContext, child, name) {
	  return null;
	}
	
	/**
	 * Count the number of children that are typically specified as
	 * `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
	 *
	 * @param {?*} children Children tree container.
	 * @return {number} The number of children.
	 */
	function countChildren(children, context) {
	  return traverseAllChildren(children, forEachSingleChildDummy, null);
	}
	
	/**
	 * Flatten a children object (typically specified as `props.children`) and
	 * return an array with appropriately re-keyed children.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
	 */
	function toArray(children) {
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
	  return result;
	}
	
	var ReactChildren = {
	  forEach: forEachChildren,
	  map: mapChildren,
	  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
	  count: countChildren,
	  toArray: toArray
	};
	
	module.exports = ReactChildren;

/***/ },
/* 900 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(87);
	
	/**
	 * Create a factory that creates HTML tag elements.
	 *
	 * @private
	 */
	var createDOMFactory = ReactElement.createFactory;
	if (false) {
	  var ReactElementValidator = require('./ReactElementValidator');
	  createDOMFactory = ReactElementValidator.createFactory;
	}
	
	/**
	 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	 *
	 * @public
	 */
	var ReactDOMFactories = {
	  a: createDOMFactory('a'),
	  abbr: createDOMFactory('abbr'),
	  address: createDOMFactory('address'),
	  area: createDOMFactory('area'),
	  article: createDOMFactory('article'),
	  aside: createDOMFactory('aside'),
	  audio: createDOMFactory('audio'),
	  b: createDOMFactory('b'),
	  base: createDOMFactory('base'),
	  bdi: createDOMFactory('bdi'),
	  bdo: createDOMFactory('bdo'),
	  big: createDOMFactory('big'),
	  blockquote: createDOMFactory('blockquote'),
	  body: createDOMFactory('body'),
	  br: createDOMFactory('br'),
	  button: createDOMFactory('button'),
	  canvas: createDOMFactory('canvas'),
	  caption: createDOMFactory('caption'),
	  cite: createDOMFactory('cite'),
	  code: createDOMFactory('code'),
	  col: createDOMFactory('col'),
	  colgroup: createDOMFactory('colgroup'),
	  data: createDOMFactory('data'),
	  datalist: createDOMFactory('datalist'),
	  dd: createDOMFactory('dd'),
	  del: createDOMFactory('del'),
	  details: createDOMFactory('details'),
	  dfn: createDOMFactory('dfn'),
	  dialog: createDOMFactory('dialog'),
	  div: createDOMFactory('div'),
	  dl: createDOMFactory('dl'),
	  dt: createDOMFactory('dt'),
	  em: createDOMFactory('em'),
	  embed: createDOMFactory('embed'),
	  fieldset: createDOMFactory('fieldset'),
	  figcaption: createDOMFactory('figcaption'),
	  figure: createDOMFactory('figure'),
	  footer: createDOMFactory('footer'),
	  form: createDOMFactory('form'),
	  h1: createDOMFactory('h1'),
	  h2: createDOMFactory('h2'),
	  h3: createDOMFactory('h3'),
	  h4: createDOMFactory('h4'),
	  h5: createDOMFactory('h5'),
	  h6: createDOMFactory('h6'),
	  head: createDOMFactory('head'),
	  header: createDOMFactory('header'),
	  hgroup: createDOMFactory('hgroup'),
	  hr: createDOMFactory('hr'),
	  html: createDOMFactory('html'),
	  i: createDOMFactory('i'),
	  iframe: createDOMFactory('iframe'),
	  img: createDOMFactory('img'),
	  input: createDOMFactory('input'),
	  ins: createDOMFactory('ins'),
	  kbd: createDOMFactory('kbd'),
	  keygen: createDOMFactory('keygen'),
	  label: createDOMFactory('label'),
	  legend: createDOMFactory('legend'),
	  li: createDOMFactory('li'),
	  link: createDOMFactory('link'),
	  main: createDOMFactory('main'),
	  map: createDOMFactory('map'),
	  mark: createDOMFactory('mark'),
	  menu: createDOMFactory('menu'),
	  menuitem: createDOMFactory('menuitem'),
	  meta: createDOMFactory('meta'),
	  meter: createDOMFactory('meter'),
	  nav: createDOMFactory('nav'),
	  noscript: createDOMFactory('noscript'),
	  object: createDOMFactory('object'),
	  ol: createDOMFactory('ol'),
	  optgroup: createDOMFactory('optgroup'),
	  option: createDOMFactory('option'),
	  output: createDOMFactory('output'),
	  p: createDOMFactory('p'),
	  param: createDOMFactory('param'),
	  picture: createDOMFactory('picture'),
	  pre: createDOMFactory('pre'),
	  progress: createDOMFactory('progress'),
	  q: createDOMFactory('q'),
	  rp: createDOMFactory('rp'),
	  rt: createDOMFactory('rt'),
	  ruby: createDOMFactory('ruby'),
	  s: createDOMFactory('s'),
	  samp: createDOMFactory('samp'),
	  script: createDOMFactory('script'),
	  section: createDOMFactory('section'),
	  select: createDOMFactory('select'),
	  small: createDOMFactory('small'),
	  source: createDOMFactory('source'),
	  span: createDOMFactory('span'),
	  strong: createDOMFactory('strong'),
	  style: createDOMFactory('style'),
	  sub: createDOMFactory('sub'),
	  summary: createDOMFactory('summary'),
	  sup: createDOMFactory('sup'),
	  table: createDOMFactory('table'),
	  tbody: createDOMFactory('tbody'),
	  td: createDOMFactory('td'),
	  textarea: createDOMFactory('textarea'),
	  tfoot: createDOMFactory('tfoot'),
	  th: createDOMFactory('th'),
	  thead: createDOMFactory('thead'),
	  time: createDOMFactory('time'),
	  title: createDOMFactory('title'),
	  tr: createDOMFactory('tr'),
	  track: createDOMFactory('track'),
	  u: createDOMFactory('u'),
	  ul: createDOMFactory('ul'),
	  'var': createDOMFactory('var'),
	  video: createDOMFactory('video'),
	  wbr: createDOMFactory('wbr'),
	
	  // SVG
	  circle: createDOMFactory('circle'),
	  clipPath: createDOMFactory('clipPath'),
	  defs: createDOMFactory('defs'),
	  ellipse: createDOMFactory('ellipse'),
	  g: createDOMFactory('g'),
	  image: createDOMFactory('image'),
	  line: createDOMFactory('line'),
	  linearGradient: createDOMFactory('linearGradient'),
	  mask: createDOMFactory('mask'),
	  path: createDOMFactory('path'),
	  pattern: createDOMFactory('pattern'),
	  polygon: createDOMFactory('polygon'),
	  polyline: createDOMFactory('polyline'),
	  radialGradient: createDOMFactory('radialGradient'),
	  rect: createDOMFactory('rect'),
	  stop: createDOMFactory('stop'),
	  svg: createDOMFactory('svg'),
	  text: createDOMFactory('text'),
	  tspan: createDOMFactory('tspan')
	};
	
	module.exports = ReactDOMFactories;

/***/ },
/* 901 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(87),
	    isValidElement = _require.isValidElement;
	
	var factory = __webpack_require__(363);
	
	module.exports = factory(isValidElement);

/***/ },
/* 902 */
862,
/* 903 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(386),
	    Component = _require.Component;
	
	var _require2 = __webpack_require__(87),
	    isValidElement = _require2.isValidElement;
	
	var ReactNoopUpdateQueue = __webpack_require__(389);
	var factory = __webpack_require__(727);
	
	module.exports = factory(Component, isValidElement, ReactNoopUpdateQueue);

/***/ },
/* 904 */
881,
/* 905 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var nextDebugID = 1;
	
	function getNextDebugID() {
	  return nextDebugID++;
	}
	
	module.exports = getNextDebugID;

/***/ },
/* 906 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Forked from fbjs/warning:
	 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
	 *
	 * Only change is we use console.warn instead of console.error,
	 * and do nothing when 'console' is not supported.
	 * This really simplifies the code.
	 * ---
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var lowPriorityWarning = function lowPriorityWarning() {};
	
	if (false) {
	  var printWarning = function printWarning(format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.warn(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  lowPriorityWarning = function lowPriorityWarning(condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = lowPriorityWarning;

/***/ },
/* 907 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	'use strict';
	
	var _prodInvariant = __webpack_require__(99);
	
	var ReactElement = __webpack_require__(87);
	
	var invariant = __webpack_require__(5);
	
	/**
	 * Returns the first child in a collection of children and verifies that there
	 * is only one child in the collection.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
	 *
	 * The current implementation of this function assumes that a single child gets
	 * passed without a wrapper, but the purpose of this helper function is to
	 * abstract away the particular structure of children.
	 *
	 * @param {?object} children Child collection structure.
	 * @return {ReactElement} The first and only `ReactElement` contained in the
	 * structure.
	 */
	function onlyChild(children) {
	  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
	  return children;
	}
	
	module.exports = onlyChild;

/***/ },
/* 908 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _prodInvariant = __webpack_require__(99);
	
	var ReactCurrentOwner = __webpack_require__(57);
	var REACT_ELEMENT_TYPE = __webpack_require__(388);
	
	var getIteratorFn = __webpack_require__(904);
	var invariant = __webpack_require__(5);
	var KeyEscapeUtils = __webpack_require__(897);
	var warning = __webpack_require__(9);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && (typeof component === 'undefined' ? 'undefined' : _typeof(component)) === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children === 'undefined' ? 'undefined' : _typeof(children);
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 909 */
/***/ function(module, exports) {

	"use strict";
	
	// # Relative luminance
	//
	// http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
	// https://en.wikipedia.org/wiki/Luminance_(relative)
	// https://en.wikipedia.org/wiki/Luminosity_function
	// https://en.wikipedia.org/wiki/Rec._709#Luma_coefficients
	
	// red, green, and blue coefficients
	var rc = 0.2126,
	    gc = 0.7152,
	    bc = 0.0722,
	
	// low-gamma adjust coefficient
	lowc = 1 / 12.92;
	
	function adjustGamma(_) {
	    return Math.pow((_ + 0.055) / 1.055, 2.4);
	}
	
	module.exports = function (rgb) {
	    var rsrgb = rgb[0] / 255,
	        gsrgb = rgb[1] / 255,
	        bsrgb = rgb[2] / 255;
	
	    var r = rsrgb <= 0.03928 ? rsrgb * lowc : adjustGamma(rsrgb),
	        g = gsrgb <= 0.03928 ? gsrgb * lowc : adjustGamma(gsrgb),
	        b = bsrgb <= 0.03928 ? bsrgb * lowc : adjustGamma(bsrgb);
	
	    return r * rc + g * gc + b * bc;
	};

/***/ },
/* 910 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/*!
	  * Reqwest! A general purpose XHR connection manager
	  * license MIT (c) Dustin Diaz 2015
	  * https://github.com/ded/reqwest
	  */
	
	!function (name, context, definition) {
	  if (typeof module != 'undefined' && module.exports) module.exports = definition();else if (true) !(__WEBPACK_AMD_DEFINE_FACTORY__ = (definition), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else context[name] = definition();
	}('reqwest', undefined, function () {
	
	  var context = this;
	
	  if ('window' in context) {
	    var doc = document,
	        byTag = 'getElementsByTagName',
	        head = doc[byTag]('head')[0];
	  } else {
	    var XHR2;
	    try {
	      XHR2 = __webpack_require__(1040);
	    } catch (ex) {
	      throw new Error('Peer dependency `xhr2` required! Please npm install xhr2');
	    }
	  }
	
	  var httpsRe = /^http/,
	      protocolRe = /(^\w+):\/\//,
	      twoHundo = /^(20\d|1223)$/ //http://stackoverflow.com/questions/10046972/msie-returns-status-code-of-1223-for-ajax-request
	  ,
	      readyState = 'readyState',
	      contentType = 'Content-Type',
	      requestedWith = 'X-Requested-With',
	      uniqid = 0,
	      callbackPrefix = 'reqwest_' + +new Date(),
	      lastValue // data stored by the most recent JSONP callback
	  ,
	      xmlHttpRequest = 'XMLHttpRequest',
	      xDomainRequest = 'XDomainRequest',
	      noop = function noop() {},
	      isArray = typeof Array.isArray == 'function' ? Array.isArray : function (a) {
	    return a instanceof Array;
	  },
	      defaultHeaders = {
	    'contentType': 'application/x-www-form-urlencoded',
	    'requestedWith': xmlHttpRequest,
	    'accept': {
	      '*': 'text/javascript, text/html, application/xml, text/xml, */*',
	      'xml': 'application/xml, text/xml',
	      'html': 'text/html',
	      'text': 'text/plain',
	      'json': 'application/json, text/javascript',
	      'js': 'application/javascript, text/javascript'
	    }
	  },
	      xhr = function xhr(o) {
	    // is it x-domain
	    if (o['crossOrigin'] === true) {
	      var xhr = context[xmlHttpRequest] ? new XMLHttpRequest() : null;
	      if (xhr && 'withCredentials' in xhr) {
	        return xhr;
	      } else if (context[xDomainRequest]) {
	        return new XDomainRequest();
	      } else {
	        throw new Error('Browser does not support cross-origin requests');
	      }
	    } else if (context[xmlHttpRequest]) {
	      return new XMLHttpRequest();
	    } else if (XHR2) {
	      return new XHR2();
	    } else {
	      return new ActiveXObject('Microsoft.XMLHTTP');
	    }
	  },
	      globalSetupOptions = {
	    dataFilter: function dataFilter(data) {
	      return data;
	    }
	  };
	
	  function succeed(r) {
	    var protocol = protocolRe.exec(r.url);
	    protocol = protocol && protocol[1] || context.location.protocol;
	    return httpsRe.test(protocol) ? twoHundo.test(r.request.status) : !!r.request.response;
	  }
	
	  function handleReadyState(r, success, error) {
	    return function () {
	      // use _aborted to mitigate against IE err c00c023f
	      // (can't read props on aborted request objects)
	      if (r._aborted) return error(r.request);
	      if (r._timedOut) return error(r.request, 'Request is aborted: timeout');
	      if (r.request && r.request[readyState] == 4) {
	        r.request.onreadystatechange = noop;
	        if (succeed(r)) success(r.request);else error(r.request);
	      }
	    };
	  }
	
	  function setHeaders(http, o) {
	    var headers = o['headers'] || {},
	        h;
	
	    headers['Accept'] = headers['Accept'] || defaultHeaders['accept'][o['type']] || defaultHeaders['accept']['*'];
	
	    var isAFormData = typeof FormData !== 'undefined' && o['data'] instanceof FormData;
	    // breaks cross-origin requests with legacy browsers
	    if (!o['crossOrigin'] && !headers[requestedWith]) headers[requestedWith] = defaultHeaders['requestedWith'];
	    if (!headers[contentType] && !isAFormData) headers[contentType] = o['contentType'] || defaultHeaders['contentType'];
	    for (h in headers) {
	      headers.hasOwnProperty(h) && 'setRequestHeader' in http && http.setRequestHeader(h, headers[h]);
	    }
	  }
	
	  function setCredentials(http, o) {
	    if (typeof o['withCredentials'] !== 'undefined' && typeof http.withCredentials !== 'undefined') {
	      http.withCredentials = !!o['withCredentials'];
	    }
	  }
	
	  function generalCallback(data) {
	    lastValue = data;
	  }
	
	  function urlappend(url, s) {
	    return url + (/\?/.test(url) ? '&' : '?') + s;
	  }
	
	  function handleJsonp(o, fn, err, url) {
	    var reqId = uniqid++,
	        cbkey = o['jsonpCallback'] || 'callback' // the 'callback' key
	    ,
	        cbval = o['jsonpCallbackName'] || reqwest.getcallbackPrefix(reqId),
	        cbreg = new RegExp('((^|\\?|&)' + cbkey + ')=([^&]+)'),
	        match = url.match(cbreg),
	        script = doc.createElement('script'),
	        loaded = 0,
	        isIE10 = navigator.userAgent.indexOf('MSIE 10.0') !== -1;
	
	    if (match) {
	      if (match[3] === '?') {
	        url = url.replace(cbreg, '$1=' + cbval); // wildcard callback func name
	      } else {
	        cbval = match[3]; // provided callback func name
	      }
	    } else {
	      url = urlappend(url, cbkey + '=' + cbval); // no callback details, add 'em
	    }
	
	    context[cbval] = generalCallback;
	
	    script.type = 'text/javascript';
	    script.src = url;
	    script.async = true;
	    if (typeof script.onreadystatechange !== 'undefined' && !isIE10) {
	      // need this for IE due to out-of-order onreadystatechange(), binding script
	      // execution to an event listener gives us control over when the script
	      // is executed. See http://jaubourg.net/2010/07/loading-script-as-onclick-handler-of.html
	      script.htmlFor = script.id = '_reqwest_' + reqId;
	    }
	
	    script.onload = script.onreadystatechange = function () {
	      if (script[readyState] && script[readyState] !== 'complete' && script[readyState] !== 'loaded' || loaded) {
	        return false;
	      }
	      script.onload = script.onreadystatechange = null;
	      script.onclick && script.onclick();
	      // Call the user callback with the last value stored and clean up values and scripts.
	      fn(lastValue);
	      lastValue = undefined;
	      head.removeChild(script);
	      loaded = 1;
	    };
	
	    // Add the script to the DOM head
	    head.appendChild(script);
	
	    // Enable JSONP timeout
	    return {
	      abort: function abort() {
	        script.onload = script.onreadystatechange = null;
	        err({}, 'Request is aborted: timeout', {});
	        lastValue = undefined;
	        head.removeChild(script);
	        loaded = 1;
	      }
	    };
	  }
	
	  function getRequest(fn, err) {
	    var o = this.o,
	        method = (o['method'] || 'GET').toUpperCase(),
	        url = typeof o === 'string' ? o : o['url']
	    // convert non-string objects to query-string form unless o['processData'] is false
	    ,
	        data = o['processData'] !== false && o['data'] && typeof o['data'] !== 'string' ? reqwest.toQueryString(o['data']) : o['data'] || null,
	        http,
	        sendWait = false;
	
	    // if we're working on a GET request and we have data then we should append
	    // query string to end of URL and not post data
	    if ((o['type'] == 'jsonp' || method == 'GET') && data) {
	      url = urlappend(url, data);
	      data = null;
	    }
	
	    if (o['type'] == 'jsonp') return handleJsonp(o, fn, err, url);
	
	    // get the xhr from the factory if passed
	    // if the factory returns null, fall-back to ours
	    http = o.xhr && o.xhr(o) || xhr(o);
	
	    http.open(method, url, o['async'] === false ? false : true);
	    setHeaders(http, o);
	    setCredentials(http, o);
	    if (context[xDomainRequest] && http instanceof context[xDomainRequest]) {
	      http.onload = fn;
	      http.onerror = err;
	      // NOTE: see
	      // http://social.msdn.microsoft.com/Forums/en-US/iewebdevelopment/thread/30ef3add-767c-4436-b8a9-f1ca19b4812e
	      http.onprogress = function () {};
	      sendWait = true;
	    } else {
	      http.onreadystatechange = handleReadyState(this, fn, err);
	    }
	    o['before'] && o['before'](http);
	    if (sendWait) {
	      setTimeout(function () {
	        http.send(data);
	      }, 200);
	    } else {
	      http.send(data);
	    }
	    return http;
	  }
	
	  function Reqwest(o, fn) {
	    this.o = o;
	    this.fn = fn;
	
	    init.apply(this, arguments);
	  }
	
	  function setType(header) {
	    // json, javascript, text/plain, text/html, xml
	    if (header === null) return undefined; //In case of no content-type.
	    if (header.match('json')) return 'json';
	    if (header.match('javascript')) return 'js';
	    if (header.match('text')) return 'html';
	    if (header.match('xml')) return 'xml';
	  }
	
	  function init(o, fn) {
	
	    this.url = typeof o == 'string' ? o : o['url'];
	    this.timeout = null;
	
	    // whether request has been fulfilled for purpose
	    // of tracking the Promises
	    this._fulfilled = false;
	    // success handlers
	    this._successHandler = function () {};
	    this._fulfillmentHandlers = [];
	    // error handlers
	    this._errorHandlers = [];
	    // complete (both success and fail) handlers
	    this._completeHandlers = [];
	    this._erred = false;
	    this._responseArgs = {};
	
	    var self = this;
	
	    fn = fn || function () {};
	
	    if (o['timeout']) {
	      this.timeout = setTimeout(function () {
	        timedOut();
	      }, o['timeout']);
	    }
	
	    if (o['success']) {
	      this._successHandler = function () {
	        o['success'].apply(o, arguments);
	      };
	    }
	
	    if (o['error']) {
	      this._errorHandlers.push(function () {
	        o['error'].apply(o, arguments);
	      });
	    }
	
	    if (o['complete']) {
	      this._completeHandlers.push(function () {
	        o['complete'].apply(o, arguments);
	      });
	    }
	
	    function complete(resp) {
	      o['timeout'] && clearTimeout(self.timeout);
	      self.timeout = null;
	      while (self._completeHandlers.length > 0) {
	        self._completeHandlers.shift()(resp);
	      }
	    }
	
	    function success(resp) {
	      var type = o['type'] || resp && setType(resp.getResponseHeader('Content-Type')); // resp can be undefined in IE
	      resp = type !== 'jsonp' ? self.request : resp;
	      // use global data filter on response text
	      var filteredResponse = globalSetupOptions.dataFilter(resp.responseText, type),
	          r = filteredResponse;
	      try {
	        resp.responseText = r;
	      } catch (e) {
	        // can't assign this in IE<=8, just ignore
	      }
	      if (r) {
	        switch (type) {
	          case 'json':
	            try {
	              resp = context.JSON ? context.JSON.parse(r) : eval('(' + r + ')');
	            } catch (err) {
	              return error(resp, 'Could not parse JSON in response', err);
	            }
	            break;
	          case 'js':
	            resp = eval(r);
	            break;
	          case 'html':
	            resp = r;
	            break;
	          case 'xml':
	            resp = resp.responseXML && resp.responseXML.parseError // IE trololo
	            && resp.responseXML.parseError.errorCode && resp.responseXML.parseError.reason ? null : resp.responseXML;
	            break;
	        }
	      }
	
	      self._responseArgs.resp = resp;
	      self._fulfilled = true;
	      fn(resp);
	      self._successHandler(resp);
	      while (self._fulfillmentHandlers.length > 0) {
	        resp = self._fulfillmentHandlers.shift()(resp);
	      }
	
	      complete(resp);
	    }
	
	    function timedOut() {
	      self._timedOut = true;
	      self.request.abort();
	    }
	
	    function error(resp, msg, t) {
	      resp = self.request;
	      self._responseArgs.resp = resp;
	      self._responseArgs.msg = msg;
	      self._responseArgs.t = t;
	      self._erred = true;
	      while (self._errorHandlers.length > 0) {
	        self._errorHandlers.shift()(resp, msg, t);
	      }
	      complete(resp);
	    }
	
	    this.request = getRequest.call(this, success, error);
	  }
	
	  Reqwest.prototype = {
	    abort: function abort() {
	      this._aborted = true;
	      this.request.abort();
	    },
	
	    retry: function retry() {
	      init.call(this, this.o, this.fn);
	    }
	
	    /**
	     * Small deviation from the Promises A CommonJs specification
	     * http://wiki.commonjs.org/wiki/Promises/A
	     */
	
	    /**
	     * `then` will execute upon successful requests
	     */
	    , then: function then(success, fail) {
	      success = success || function () {};
	      fail = fail || function () {};
	      if (this._fulfilled) {
	        this._responseArgs.resp = success(this._responseArgs.resp);
	      } else if (this._erred) {
	        fail(this._responseArgs.resp, this._responseArgs.msg, this._responseArgs.t);
	      } else {
	        this._fulfillmentHandlers.push(success);
	        this._errorHandlers.push(fail);
	      }
	      return this;
	    }
	
	    /**
	     * `always` will execute whether the request succeeds or fails
	     */
	    , always: function always(fn) {
	      if (this._fulfilled || this._erred) {
	        fn(this._responseArgs.resp);
	      } else {
	        this._completeHandlers.push(fn);
	      }
	      return this;
	    }
	
	    /**
	     * `fail` will execute when the request fails
	     */
	    , fail: function fail(fn) {
	      if (this._erred) {
	        fn(this._responseArgs.resp, this._responseArgs.msg, this._responseArgs.t);
	      } else {
	        this._errorHandlers.push(fn);
	      }
	      return this;
	    },
	    'catch': function _catch(fn) {
	      return this.fail(fn);
	    }
	  };
	
	  function reqwest(o, fn) {
	    return new Reqwest(o, fn);
	  }
	
	  // normalize newline variants according to spec -> CRLF
	  function normalize(s) {
	    return s ? s.replace(/\r?\n/g, '\r\n') : '';
	  }
	
	  function serial(el, cb) {
	    var n = el.name,
	        t = el.tagName.toLowerCase(),
	        optCb = function optCb(o) {
	      // IE gives value="" even where there is no value attribute
	      // 'specified' ref: http://www.w3.org/TR/DOM-Level-3-Core/core.html#ID-862529273
	      if (o && !o['disabled']) cb(n, normalize(o['attributes']['value'] && o['attributes']['value']['specified'] ? o['value'] : o['text']));
	    },
	        ch,
	        ra,
	        val,
	        i;
	
	    // don't serialize elements that are disabled or without a name
	    if (el.disabled || !n) return;
	
	    switch (t) {
	      case 'input':
	        if (!/reset|button|image|file/i.test(el.type)) {
	          ch = /checkbox/i.test(el.type);
	          ra = /radio/i.test(el.type);
	          val = el.value
	          // WebKit gives us "" instead of "on" if a checkbox has no value, so correct it here
	          ;(!(ch || ra) || el.checked) && cb(n, normalize(ch && val === '' ? 'on' : val));
	        }
	        break;
	      case 'textarea':
	        cb(n, normalize(el.value));
	        break;
	      case 'select':
	        if (el.type.toLowerCase() === 'select-one') {
	          optCb(el.selectedIndex >= 0 ? el.options[el.selectedIndex] : null);
	        } else {
	          for (i = 0; el.length && i < el.length; i++) {
	            el.options[i].selected && optCb(el.options[i]);
	          }
	        }
	        break;
	    }
	  }
	
	  // collect up all form elements found from the passed argument elements all
	  // the way down to child elements; pass a '<form>' or form fields.
	  // called with 'this'=callback to use for serial() on each element
	  function eachFormElement() {
	    var cb = this,
	        e,
	        i,
	        serializeSubtags = function serializeSubtags(e, tags) {
	      var i, j, fa;
	      for (i = 0; i < tags.length; i++) {
	        fa = e[byTag](tags[i]);
	        for (j = 0; j < fa.length; j++) {
	          serial(fa[j], cb);
	        }
	      }
	    };
	
	    for (i = 0; i < arguments.length; i++) {
	      e = arguments[i];
	      if (/input|select|textarea/i.test(e.tagName)) serial(e, cb);
	      serializeSubtags(e, ['input', 'select', 'textarea']);
	    }
	  }
	
	  // standard query string style serialization
	  function serializeQueryString() {
	    return reqwest.toQueryString(reqwest.serializeArray.apply(null, arguments));
	  }
	
	  // { 'name': 'value', ... } style serialization
	  function serializeHash() {
	    var hash = {};
	    eachFormElement.apply(function (name, value) {
	      if (name in hash) {
	        hash[name] && !isArray(hash[name]) && (hash[name] = [hash[name]]);
	        hash[name].push(value);
	      } else hash[name] = value;
	    }, arguments);
	    return hash;
	  }
	
	  // [ { name: 'name', value: 'value' }, ... ] style serialization
	  reqwest.serializeArray = function () {
	    var arr = [];
	    eachFormElement.apply(function (name, value) {
	      arr.push({ name: name, value: value });
	    }, arguments);
	    return arr;
	  };
	
	  reqwest.serialize = function () {
	    if (arguments.length === 0) return '';
	    var opt,
	        fn,
	        args = Array.prototype.slice.call(arguments, 0);
	
	    opt = args.pop();
	    opt && opt.nodeType && args.push(opt) && (opt = null);
	    opt && (opt = opt.type);
	
	    if (opt == 'map') fn = serializeHash;else if (opt == 'array') fn = reqwest.serializeArray;else fn = serializeQueryString;
	
	    return fn.apply(null, args);
	  };
	
	  reqwest.toQueryString = function (o, trad) {
	    var prefix,
	        i,
	        traditional = trad || false,
	        s = [],
	        enc = encodeURIComponent,
	        add = function add(key, value) {
	      // If value is a function, invoke it and return its value
	      value = 'function' === typeof value ? value() : value == null ? '' : value;
	      s[s.length] = enc(key) + '=' + enc(value);
	    };
	    // If an array was passed in, assume that it is an array of form elements.
	    if (isArray(o)) {
	      for (i = 0; o && i < o.length; i++) {
	        add(o[i]['name'], o[i]['value']);
	      }
	    } else {
	      // If traditional, encode the "old" way (the way 1.3.2 or older
	      // did it), otherwise encode params recursively.
	      for (prefix in o) {
	        if (o.hasOwnProperty(prefix)) buildParams(prefix, o[prefix], traditional, add);
	      }
	    }
	
	    // spaces should be + according to spec
	    return s.join('&').replace(/%20/g, '+');
	  };
	
	  function buildParams(prefix, obj, traditional, add) {
	    var name,
	        i,
	        v,
	        rbracket = /\[\]$/;
	
	    if (isArray(obj)) {
	      // Serialize array item.
	      for (i = 0; obj && i < obj.length; i++) {
	        v = obj[i];
	        if (traditional || rbracket.test(prefix)) {
	          // Treat each array item as a scalar.
	          add(prefix, v);
	        } else {
	          buildParams(prefix + '[' + ((typeof v === 'undefined' ? 'undefined' : _typeof(v)) === 'object' ? i : '') + ']', v, traditional, add);
	        }
	      }
	    } else if (obj && obj.toString() === '[object Object]') {
	      // Serialize object item.
	      for (name in obj) {
	        buildParams(prefix + '[' + name + ']', obj[name], traditional, add);
	      }
	    } else {
	      // Serialize scalar item.
	      add(prefix, obj);
	    }
	  }
	
	  reqwest.getcallbackPrefix = function () {
	    return callbackPrefix;
	  };
	
	  // jQuery and Zepto compatibility, differences can be remapped here so you can call
	  // .ajax.compat(options, callback)
	  reqwest.compat = function (o, fn) {
	    if (o) {
	      o['type'] && (o['method'] = o['type']) && delete o['type'];
	      o['dataType'] && (o['type'] = o['dataType']);
	      o['jsonpCallback'] && (o['jsonpCallbackName'] = o['jsonpCallback']) && delete o['jsonpCallback'];
	      o['jsonp'] && (o['jsonpCallback'] = o['jsonp']);
	    }
	    return new Reqwest(o, fn);
	  };
	
	  reqwest.ajaxSetup = function (options) {
	    options = options || {};
	    for (var k in options) {
	      globalSetupOptions[k] = options[k];
	    }
	  };
	
	  return reqwest;
	});

/***/ },
/* 911 */
/***/ function(module, exports) {

	/*
	color
	*/"use strict";
	
	var colors = {
	    maroon: "#800000",
	    red: "#ff0000",
	    orange: "#ffA500",
	    yellow: "#ffff00",
	    olive: "#808000",
	    purple: "#800080",
	    fuchsia: "#ff00ff",
	    white: "#ffffff",
	    lime: "#00ff00",
	    green: "#008000",
	    navy: "#000080",
	    blue: "#0000ff",
	    aqua: "#00ffff",
	    teal: "#008080",
	    black: "#000000",
	    silver: "#c0c0c0",
	    gray: "#808080",
	    transparent: "#0000"
	};
	
	var RGBtoRGB = function RGBtoRGB(r, g, b, a) {
	    if (a == null || a === "") a = 1;
	    r = parseFloat(r);
	    g = parseFloat(g);
	    b = parseFloat(b);
	    a = parseFloat(a);
	    if (!(r <= 255 && r >= 0 && g <= 255 && g >= 0 && b <= 255 && b >= 0 && a <= 1 && a >= 0)) return null;
	
	    return [Math.round(r), Math.round(g), Math.round(b), a];
	};
	
	var HEXtoRGB = function HEXtoRGB(hex) {
	    if (hex.length === 3) hex += "f";
	    if (hex.length === 4) {
	        var h0 = hex.charAt(0),
	            h1 = hex.charAt(1),
	            h2 = hex.charAt(2),
	            h3 = hex.charAt(3);
	
	        hex = h0 + h0 + h1 + h1 + h2 + h2 + h3 + h3;
	    }
	    if (hex.length === 6) hex += "ff";
	    var rgb = [];
	    for (var i = 0, l = hex.length; i < l; i += 2) {
	        rgb.push(parseInt(hex.substr(i, 2), 16) / (i === 6 ? 255 : 1));
	    }return rgb;
	};
	
	// HSL to RGB conversion from:
	// http://mjijackson.com/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript
	// thank you!
	
	var HUEtoRGB = function HUEtoRGB(p, q, t) {
	    if (t < 0) t += 1;
	    if (t > 1) t -= 1;
	    if (t < 1 / 6) return p + (q - p) * 6 * t;
	    if (t < 1 / 2) return q;
	    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
	    return p;
	};
	
	var HSLtoRGB = function HSLtoRGB(h, s, l, a) {
	    var r, b, g;
	    if (a == null || a === "") a = 1;
	    h = parseFloat(h) / 360;
	    s = parseFloat(s) / 100;
	    l = parseFloat(l) / 100;
	    a = parseFloat(a) / 1;
	    if (h > 1 || h < 0 || s > 1 || s < 0 || l > 1 || l < 0 || a > 1 || a < 0) return null;
	    if (s === 0) {
	        r = b = g = l;
	    } else {
	        var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
	        var p = 2 * l - q;
	        r = HUEtoRGB(p, q, h + 1 / 3);
	        g = HUEtoRGB(p, q, h);
	        b = HUEtoRGB(p, q, h - 1 / 3);
	    }
	    return [r * 255, g * 255, b * 255, a];
	};
	
	var keys = [];
	for (var c in colors) {
	    keys.push(c);
	}var shex = "(?:#([a-f0-9]{3,8}))",
	    sval = "\\s*([.\\d%]+)\\s*",
	    sop = "(?:,\\s*([.\\d]+)\\s*)?",
	    slist = "\\(" + [sval, sval, sval] + sop + "\\)",
	    srgb = "(?:rgb)a?",
	    shsl = "(?:hsl)a?",
	    skeys = "(" + keys.join("|") + ")";
	
	var xhex = RegExp(shex, "i"),
	    xrgb = RegExp(srgb + slist, "i"),
	    xhsl = RegExp(shsl + slist, "i");
	
	var color = function color(input, array) {
	    if (input == null) return null;
	    input = (input + "").replace(/\s+/, "");
	
	    var match = colors[input];
	    if (match) {
	        return color(match, array);
	    } else if (match = input.match(xhex)) {
	        input = HEXtoRGB(match[1]);
	    } else if (match = input.match(xrgb)) {
	        input = match.slice(1);
	    } else if (match = input.match(xhsl)) {
	        input = HSLtoRGB.apply(null, match.slice(1));
	    } else return null;
	
	    if (!(input && (input = RGBtoRGB.apply(null, input)))) return null;
	    if (array) return input;
	    if (input[3] === 1) input.splice(3, 1);
	    return "rgb" + (input.length === 4 ? "a" : "") + "(" + input + ")";
	};
	
	var regexp = RegExp([skeys, shex, srgb + slist, shsl + slist].join("|"), "gi");
	
	color.replace = function (string, method) {
	    if (!method) method = function method(match) {
	        return color(match);
	    };
	    return (string + "").replace(regexp, method);
	};
	
	color.matches = function (string) {
	    return !!(string + "").match(regexp);
	};
	
	module.exports = color;

/***/ },
/* 912 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(915);

/***/ },
/* 913 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var generate = __webpack_require__(914);
	var alphabet = __webpack_require__(127);
	
	// Ignore all milliseconds before a certain time to reduce the size of the date entropy without sacrificing uniqueness.
	// This number should be updated every year or so to keep the generated id short.
	// To regenerate `new Date() - 0` and bump the version. Always bump the version!
	var REDUCE_TIME = 1459707606518;
	
	// don't change unless we change the algos or REDUCE_TIME
	// must be an integer and less than 16
	var version = 6;
	
	// Counter is used when shortid is called multiple times in one second.
	var counter;
	
	// Remember the last time shortid was called in case counter is needed.
	var previousSeconds;
	
	/**
	 * Generate unique id
	 * Returns string id
	 */
	function build(clusterWorkerId) {
	    var str = '';
	
	    var seconds = Math.floor((Date.now() - REDUCE_TIME) * 0.001);
	
	    if (seconds === previousSeconds) {
	        counter++;
	    } else {
	        counter = 0;
	        previousSeconds = seconds;
	    }
	
	    str = str + generate(version);
	    str = str + generate(clusterWorkerId);
	    if (counter > 0) {
	        str = str + generate(counter);
	    }
	    str = str + generate(seconds);
	    return str;
	}
	
	module.exports = build;

/***/ },
/* 914 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var alphabet = __webpack_require__(127);
	var random = __webpack_require__(917);
	var format = __webpack_require__(815);
	
	function generate(number) {
	    var loopCounter = 0;
	    var done;
	
	    var str = '';
	
	    while (!done) {
	        str = str + format(random, alphabet.get(), 1);
	        done = number < Math.pow(16, loopCounter + 1);
	        loopCounter++;
	    }
	    return str;
	}
	
	module.exports = generate;

/***/ },
/* 915 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var alphabet = __webpack_require__(127);
	var build = __webpack_require__(913);
	var isValid = __webpack_require__(916);
	
	// if you are using cluster or multiple servers use this to make each instance
	// has a unique value for worker
	// Note: I don't know if this is automatically set when using third
	// party cluster solutions such as pm2.
	var clusterWorkerId = __webpack_require__(919) || 0;
	
	/**
	 * Set the seed.
	 * Highly recommended if you don't want people to try to figure out your id schema.
	 * exposed as shortid.seed(int)
	 * @param seed Integer value to seed the random alphabet.  ALWAYS USE THE SAME SEED or you might get overlaps.
	 */
	function seed(seedValue) {
	  alphabet.seed(seedValue);
	  return module.exports;
	}
	
	/**
	 * Set the cluster worker or machine id
	 * exposed as shortid.worker(int)
	 * @param workerId worker must be positive integer.  Number less than 16 is recommended.
	 * returns shortid module so it can be chained.
	 */
	function worker(workerId) {
	  clusterWorkerId = workerId;
	  return module.exports;
	}
	
	/**
	 *
	 * sets new characters to use in the alphabet
	 * returns the shuffled alphabet
	 */
	function characters(newCharacters) {
	  if (newCharacters !== undefined) {
	    alphabet.characters(newCharacters);
	  }
	
	  return alphabet.shuffled();
	}
	
	/**
	 * Generate unique id
	 * Returns string id
	 */
	function generate() {
	  return build(clusterWorkerId);
	}
	
	// Export all other functions as properties of the generate function
	module.exports = generate;
	module.exports.generate = generate;
	module.exports.seed = seed;
	module.exports.worker = worker;
	module.exports.characters = characters;
	module.exports.isValid = isValid;

/***/ },
/* 916 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var alphabet = __webpack_require__(127);
	
	function isShortId(id) {
	    if (!id || typeof id !== 'string' || id.length < 6) {
	        return false;
	    }
	
	    var nonAlphabetic = new RegExp('[^' + alphabet.get().replace(/[|\\{}()[\]^$+*?.-]/g, '\\$&') + ']');
	    return !nonAlphabetic.test(id);
	}
	
	module.exports = isShortId;

/***/ },
/* 917 */
/***/ function(module, exports) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var crypto = (typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object' && (window.crypto || window.msCrypto); // IE 11 uses window.msCrypto
	
	var randomByte;
	
	if (!crypto || !crypto.getRandomValues) {
	    randomByte = function randomByte(size) {
	        var bytes = [];
	        for (var i = 0; i < size; i++) {
	            bytes.push(Math.floor(Math.random() * 256));
	        }
	        return bytes;
	    };
	} else {
	    randomByte = function randomByte(size) {
	        return crypto.getRandomValues(new Uint8Array(size));
	    };
	}
	
	module.exports = randomByte;

/***/ },
/* 918 */
/***/ function(module, exports) {

	'use strict';
	
	// Found this seed-based random generator somewhere
	// Based on The Central Randomizer 1.3 (C) 1997 by Paul Houle (houle@msc.cornell.edu)
	
	var seed = 1;
	
	/**
	 * return a random number based on a seed
	 * @param seed
	 * @returns {number}
	 */
	function getNextValue() {
	    seed = (seed * 9301 + 49297) % 233280;
	    return seed / 233280.0;
	}
	
	function setSeed(_seed_) {
	    seed = _seed_;
	}
	
	module.exports = {
	    nextValue: getNextValue,
	    seed: setSeed
	};

/***/ },
/* 919 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = 0;

/***/ },
/* 920 */
/***/ function(module, exports) {

	'use strict';
	
	var camel2hyphen = function camel2hyphen(str) {
	  return str.replace(/[A-Z]/g, function (match) {
	    return '-' + match.toLowerCase();
	  }).toLowerCase();
	};
	
	module.exports = camel2hyphen;

/***/ },
/* 921 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var _uppercasePattern = /([A-Z])/g;
	
	/**
	 * Hyphenates a camelcased string, for example:
	 *
	 *   > hyphenate('backgroundColor')
	 *   < "background-color"
	 *
	 * For CSS style names, use `hyphenateStyleName` instead which works properly
	 * with all vendor prefixes, including `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenate(string) {
	  return string.replace(_uppercasePattern, '-$1').toLowerCase();
	}
	
	module.exports = hyphenate;

/***/ },
/* 922 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var hyphenate = __webpack_require__(921);
	
	var msPattern = /^ms-/;
	
	/**
	 * Hyphenates a camelcased CSS property name, for example:
	 *
	 *   > hyphenateStyleName('backgroundColor')
	 *   < "background-color"
	 *   > hyphenateStyleName('MozTransition')
	 *   < "-moz-transition"
	 *   > hyphenateStyleName('msTransition')
	 *   < "-ms-transition"
	 *
	 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
	 * is converted to `-ms-`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenateStyleName(string) {
	  return hyphenate(string).replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;

/***/ },
/* 923 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	(function (factory) {
		( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? module['exports'] = factory() : "function" === 'function' && __webpack_require__(400)['amd'] ? !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory()), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : window['stylisRuleSheet'] = factory();
	})(function () {
	
		'use strict';
	
		return function (insertRule) {
			var delimiter = '/*|*/';
			var needle = delimiter + '}';
	
			function toSheet(block) {
				if (block) try {
					insertRule(block + '}');
				} catch (e) {}
			}
	
			return function ruleSheet(context, content, selectors, parents, line, column, length, ns, depth, at) {
				switch (context) {
					// property
					case 1:
						// @import
						if (depth === 0 && content.charCodeAt(0) === 64) return insertRule(content + ';'), '';
						break;
					// selector
					case 2:
						if (ns === 0) return content + delimiter;
						break;
					// at-rule
					case 3:
						switch (ns) {
							// @font-face, @page
							case 102:
							case 112:
								return insertRule(selectors[0] + content), '';
							default:
								return content + (at === 0 ? delimiter : '');
						}
					case -2:
						content.split(needle).forEach(toSheet);
				}
			};
		};
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(88)(module)))

/***/ },
/* 924 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/*
	 *          __        ___
	 *    _____/ /___  __/ (_)____
	 *   / ___/ __/ / / / / / ___/
	 *  (__  ) /_/ /_/ / / (__  )
	 * /____/\__/\__, /_/_/____/
	 *          /____/
	 *
	 * light - weight css preprocessor @licence MIT
	 */
	(function (factory) {
		/* eslint-disable */
		( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? module['exports'] = factory(null) : "function" === 'function' && __webpack_require__(400)['amd'] ? !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory(null)), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : window['stylis'] = factory(null);
	})( /** @param {*=} options */function factory(options) {
		/* eslint-disable */
	
		'use strict';
	
		/**
	  * Notes
	  *
	  * The ['<method name>'] pattern is used to support closure compiler
	  * the jsdoc signatures are also used to the same effect
	  *
	  * ----
	  *
	  * int + int + int === n4 [faster]
	  *
	  * vs
	  *
	  * int === n1 && int === n2 && int === n3
	  *
	  * ----
	  *
	  * switch (int) { case ints...} [faster]
	  *
	  * vs
	  *
	  * if (int == 1 && int === 2 ...)
	  *
	  * ----
	  *
	  * The (first*n1 + second*n2 + third*n3) format used in the property parser
	  * is a simple way to hash the sequence of characters
	  * taking into account the index they occur in
	  * since any number of 3 character sequences could produce duplicates.
	  *
	  * On the other hand sequences that are directly tied to the index of the character
	  * resolve a far more accurate measure, it's also faster
	  * to evaluate one condition in a switch statement
	  * than three in an if statement regardless of the added math.
	  *
	  * This allows the vendor prefixer to be both small and fast.
	  */
	
		var nullptn = /^\0+/g; /* matches leading null characters */
		var formatptn = /[\0\r\f]/g; /* matches new line, null and formfeed characters */
		var colonptn = /: */g; /* splits animation rules */
		var cursorptn = /zoo|gra/; /* assert cursor varient */
		var transformptn = /([,: ])(transform)/g; /* vendor prefix transform, older webkit */
		var animationptn = /,+\s*(?![^(]*[)])/g; /* splits multiple shorthand notation animations */
		var propertiesptn = / +\s*(?![^(]*[)])/g; /* animation properties */
		var elementptn = / *[\0] */g; /* selector elements */
		var selectorptn = /,\r+?/g; /* splits selectors */
		var andptn = /([\t\r\n ])*\f?&/g; /* match & */
		var escapeptn = /:global\(((?:[^\(\)\[\]]*|\[.*\]|\([^\(\)]*\))*)\)/g; /* matches :global(.*) */
		var invalidptn = /\W+/g; /* removes invalid characters from keyframes */
		var keyframeptn = /@(k\w+)\s*(\S*)\s*/; /* matches @keyframes $1 */
		var plcholdrptn = /::(place)/g; /* match ::placeholder varient */
		var readonlyptn = /:(read-only)/g; /* match :read-only varient */
		var beforeptn = /\s+(?=[{\];=:>])/g; /* matches \s before ] ; = : */
		var afterptn = /([[}=:>])\s+/g; /* matches \s after characters [ } = : */
		var tailptn = /(\{[^{]+?);(?=\})/g; /* matches tail semi-colons ;} */
		var whiteptn = /\s{2,}/g; /* matches repeating whitespace */
		var pseudoptn = /([^\(])(:+) */g; /* pseudo element */
		var writingptn = /[svh]\w+-[tblr]{2}/; /* match writing mode property values */
		var gradientptn = /([\w-]+t\()/g; /* match *gradient property */
		var supportsptn = /\(\s*(.*)\s*\)/g; /* match supports (groups) */
		var propertyptn = /([\s\S]*?);/g; /* match properties leading semicolon */
		var selfptn = /-self|flex-/g; /* match flex- and -self in align-self: flex-*; */
		var pseudofmt = /[^]*?(:[rp][el]a[\w-]+)[^]*/; /* extrats :readonly or :placholder from selector */
		var trimptn = /[ \t]+$/; /* match tail whitspace */
		var dimensionptn = /stretch|:\s*\w+\-(?:conte|avail)/; /* match max/min/fit-content, fill-available */
		var imgsrcptn = /([^-])(image-set\()/;
	
		/* vendors */
		var webkit = '-webkit-';
		var moz = '-moz-';
		var ms = '-ms-';
	
		/* character codes */
		var SEMICOLON = 59; /* ; */
		var CLOSEBRACES = 125; /* } */
		var OPENBRACES = 123; /* { */
		var OPENPARENTHESES = 40; /* ( */
		var CLOSEPARENTHESES = 41; /* ) */
		var OPENBRACKET = 91; /* [ */
		var CLOSEBRACKET = 93; /* ] */
		var NEWLINE = 10; /* \n */
		var CARRIAGE = 13; /* \r */
		var TAB = 9; /* \t */
		var AT = 64; /* @ */
		var SPACE = 32; /*   */
		var AND = 38; /* & */
		var DASH = 45; /* - */
		var UNDERSCORE = 95; /* _ */
		var STAR = 42; /* * */
		var COMMA = 44; /* , */
		var COLON = 58; /* : */
		var SINGLEQUOTE = 39; /* ' */
		var DOUBLEQUOTE = 34; /* " */
		var FOWARDSLASH = 47; /* / */
		var GREATERTHAN = 62; /* > */
		var PLUS = 43; /* + */
		var TILDE = 126; /* ~ */
		var NULL = 0; /* \0 */
		var FORMFEED = 12; /* \f */
		var VERTICALTAB = 11; /* \v */
	
		/* special identifiers */
		var KEYFRAME = 107; /* k */
		var MEDIA = 109; /* m */
		var SUPPORTS = 115; /* s */
		var PLACEHOLDER = 112; /* p */
		var READONLY = 111; /* o */
		var IMPORT = 105; /* <at>i */
		var CHARSET = 99; /* <at>c */
		var DOCUMENT = 100; /* <at>d */
		var PAGE = 112; /* <at>p */
	
		var column = 1; /* current column */
		var line = 1; /* current line numebr */
		var pattern = 0; /* :pattern */
	
		var cascade = 1; /* #id h1 h2 vs h1#id h2#id  */
		var prefix = 1; /* vendor prefix */
		var escape = 1; /* escape :global() pattern */
		var compress = 0; /* compress output */
		var semicolon = 0; /* no/semicolon option */
		var preserve = 0; /* preserve empty selectors */
	
		/* empty reference */
		var array = [];
	
		/* plugins */
		var plugins = [];
		var plugged = 0;
		var should = null;
	
		/* plugin context */
		var POSTS = -2;
		var PREPS = -1;
		var UNKWN = 0;
		var PROPS = 1;
		var BLCKS = 2;
		var ATRUL = 3;
	
		/* plugin newline context */
		var unkwn = 0;
	
		/* keyframe animation */
		var keyed = 1;
		var key = '';
	
		/* selector namespace */
		var nscopealt = '';
		var nscope = '';
	
		/**
	  * Compile
	  *
	  * @param {Array<string>} parent
	  * @param {Array<string>} current
	  * @param {string} body
	  * @param {number} id
	  * @param {number} depth
	  * @return {string}
	  */
		function compile(parent, current, body, id, depth) {
			var bracket = 0; /* brackets [] */
			var comment = 0; /* comments /* // or /* */
			var parentheses = 0; /* functions () */
			var quote = 0; /* quotes '', "" */
	
			var first = 0; /* first character code */
			var second = 0; /* second character code */
			var code = 0; /* current character code */
			var tail = 0; /* previous character code */
			var trail = 0; /* character before previous code */
			var peak = 0; /* previous non-whitespace code */
	
			var counter = 0; /* count sequence termination */
			var context = 0; /* track current context */
			var atrule = 0; /* track @at-rule context */
			var pseudo = 0; /* track pseudo token index */
			var caret = 0; /* current character index */
			var format = 0; /* control character formating context */
			var insert = 0; /* auto semicolon insertion */
			var invert = 0; /* inverted selector pattern */
			var length = 0; /* generic length address */
			var eof = body.length; /* end of file(length) */
			var eol = eof - 1; /* end of file(characters) */
	
			var char = ''; /* current character */
			var chars = ''; /* current buffer of characters */
			var child = ''; /* next buffer of characters */
			var out = ''; /* compiled body */
			var children = ''; /* compiled children */
			var flat = ''; /* compiled leafs */
			var selector; /* generic selector address */
			var result; /* generic address */
	
			// ...build body
			while (caret < eof) {
				code = body.charCodeAt(caret);
	
				// eof varient
				if (caret === eol) {
					// last character + noop context, add synthetic padding for noop context to terminate
					if (comment + quote + parentheses + bracket !== 0) {
						if (comment !== 0) {
							code = comment === FOWARDSLASH ? NEWLINE : FOWARDSLASH;
						}
	
						quote = parentheses = bracket = 0;
						eof++;
						eol++;
					}
				}
	
				if (comment + quote + parentheses + bracket === 0) {
					// eof varient
					if (caret === eol) {
						if (format > 0) {
							chars = chars.replace(formatptn, '');
						}
	
						if (chars.trim().length > 0) {
							switch (code) {
								case SPACE:
								case TAB:
								case SEMICOLON:
								case CARRIAGE:
								case NEWLINE:
									{
										break;
									}
								default:
									{
										chars += body.charAt(caret);
									}
							}
	
							code = SEMICOLON;
						}
					}
	
					// auto semicolon insertion
					if (insert === 1) {
						switch (code) {
							// false flags
							case OPENBRACES:
							case CLOSEBRACES:
							case SEMICOLON:
							case DOUBLEQUOTE:
							case SINGLEQUOTE:
							case OPENPARENTHESES:
							case CLOSEPARENTHESES:
							case COMMA:
								{
									insert = 0;
								}
							// ignore
							case TAB:
							case CARRIAGE:
							case NEWLINE:
							case SPACE:
								{
									break;
								}
							// valid
							default:
								{
									insert = 0;
									length = caret;
									first = code;
									caret--;
									code = SEMICOLON;
	
									while (length < eof) {
										switch (body.charCodeAt(length++)) {
											case NEWLINE:
											case CARRIAGE:
											case SEMICOLON:
												{
													++caret;
													code = first;
													length = eof;
													break;
												}
											case COLON:
												{
													if (format > 0) {
														++caret;
														code = first;
													}
												}
											case OPENBRACES:
												{
													length = eof;
												}
										}
									}
								}
						}
					}
	
					// token varient
					switch (code) {
						case OPENBRACES:
							{
								chars = chars.trim();
								first = chars.charCodeAt(0);
								counter = 1;
								length = ++caret;
	
								while (caret < eof) {
									switch (code = body.charCodeAt(caret)) {
										case OPENBRACES:
											{
												counter++;
												break;
											}
										case CLOSEBRACES:
											{
												counter--;
												break;
											}
										case FOWARDSLASH:
											{
												switch (second = body.charCodeAt(caret + 1)) {
													// /*, //
													case STAR:
													case FOWARDSLASH:
														{
															caret = delimited(second, caret, eol, body);
														}
												}
												break;
											}
										// given "[" === 91 & "]" === 93 hence forth 91 + 1 + 1 === 93
										case OPENBRACKET:
											{
												code++;
											}
										// given "(" === 40 & ")" === 41 hence forth 40 + 1 === 41
										case OPENPARENTHESES:
											{
												code++;
											}
										// quote tail delimiter is identical to the head delimiter hence noop,
										// fallthrough clauses have been shifted to the correct tail delimiter
										case DOUBLEQUOTE:
										case SINGLEQUOTE:
											{
												while (caret++ < eol) {
													if (body.charCodeAt(caret) === code) {
														break;
													}
												}
											}
									}
	
									if (counter === 0) {
										break;
									}
	
									caret++;
								}
	
								child = body.substring(length, caret);
	
								if (first === NULL) {
									first = (chars = chars.replace(nullptn, '').trim()).charCodeAt(0);
								}
	
								switch (first) {
									// @at-rule
									case AT:
										{
											if (format > 0) {
												chars = chars.replace(formatptn, '');
											}
	
											second = chars.charCodeAt(1);
	
											switch (second) {
												case DOCUMENT:
												case MEDIA:
												case SUPPORTS:
												case DASH:
													{
														selector = current;
														break;
													}
												default:
													{
														selector = array;
													}
											}
	
											child = compile(current, selector, child, second, depth + 1);
											length = child.length;
	
											// preserve empty @at-rule
											if (preserve > 0 && length === 0) {
												length = chars.length;
											}
	
											// execute plugins, @at-rule context
											if (plugged > 0) {
												selector = select(array, chars, invert);
												result = proxy(ATRUL, child, selector, current, line, column, length, second, depth, id);
												chars = selector.join('');
	
												if (result !== void 0) {
													if ((length = (child = result.trim()).length) === 0) {
														second = 0;
														child = '';
													}
												}
											}
	
											if (length > 0) {
												switch (second) {
													case SUPPORTS:
														{
															chars = chars.replace(supportsptn, supports);
														}
													case DOCUMENT:
													case MEDIA:
													case DASH:
														{
															child = chars + '{' + child + '}';
															break;
														}
													case KEYFRAME:
														{
															chars = chars.replace(keyframeptn, '$1 $2' + (keyed > 0 ? key : ''));
															child = chars + '{' + child + '}';
	
															if (prefix === 1 || prefix === 2 && vendor('@' + child, 3)) {
																child = '@' + webkit + child + '@' + child;
															} else {
																child = '@' + child;
															}
															break;
														}
													default:
														{
															child = chars + child;
	
															if (id === PAGE) {
																child = (out += child, '');
															}
														}
												}
											} else {
												child = '';
											}
	
											break;
										}
									// selector
									default:
										{
											child = compile(current, select(current, chars, invert), child, id, depth + 1);
										}
								}
	
								children += child;
	
								// reset
								context = 0;
								insert = 0;
								pseudo = 0;
								format = 0;
								invert = 0;
								atrule = 0;
								chars = '';
								child = '';
								code = body.charCodeAt(++caret);
								break;
							}
						case CLOSEBRACES:
						case SEMICOLON:
							{
								chars = (format > 0 ? chars.replace(formatptn, '') : chars).trim();
	
								if ((length = chars.length) > 1) {
									// monkey-patch missing colon
									if (pseudo === 0) {
										first = chars.charCodeAt(0);
	
										// first character is a letter or dash, buffer has a space character
										if (first === DASH || first > 96 && first < 123) {
											length = (chars = chars.replace(' ', ':')).length;
										}
									}
	
									// execute plugins, property context
									if (plugged > 0) {
										if ((result = proxy(PROPS, chars, current, parent, line, column, out.length, id, depth, id)) !== void 0) {
											if ((length = (chars = result.trim()).length) === 0) {
												chars = '\0\0';
											}
										}
									}
	
									first = chars.charCodeAt(0);
									second = chars.charCodeAt(1);
	
									switch (first) {
										case NULL:
											{
												break;
											}
										case AT:
											{
												if (second === IMPORT || second === CHARSET) {
													flat += chars + body.charAt(caret);
													break;
												}
											}
										default:
											{
												if (chars.charCodeAt(length - 1) === COLON) {
													break;
												}
	
												out += property(chars, first, second, chars.charCodeAt(2));
											}
									}
								}
	
								// reset
								context = 0;
								insert = 0;
								pseudo = 0;
								format = 0;
								invert = 0;
								chars = '';
								code = body.charCodeAt(++caret);
								break;
							}
					}
				}
	
				// parse characters
				switch (code) {
					case CARRIAGE:
					case NEWLINE:
						{
							// auto insert semicolon
							if (comment + quote + parentheses + bracket + semicolon === 0) {
								// valid non-whitespace characters that
								// may precede a newline
								switch (peak) {
									case CLOSEPARENTHESES:
									case SINGLEQUOTE:
									case DOUBLEQUOTE:
									case AT:
									case TILDE:
									case GREATERTHAN:
									case STAR:
									case PLUS:
									case FOWARDSLASH:
									case DASH:
									case COLON:
									case COMMA:
									case SEMICOLON:
									case OPENBRACES:
									case CLOSEBRACES:
										{
											break;
										}
									default:
										{
											// current buffer has a colon
											if (pseudo > 0) {
												insert = 1;
											}
										}
								}
							}
	
							// terminate line comment
							if (comment === FOWARDSLASH) {
								comment = 0;
							} else if (cascade + context === 0 && id !== KEYFRAME && chars.length > 0) {
								format = 1;
								chars += '\0';
							}
	
							// execute plugins, newline context
							if (plugged * unkwn > 0) {
								proxy(UNKWN, chars, current, parent, line, column, out.length, id, depth, id);
							}
	
							// next line, reset column position
							column = 1;
							line++;
							break;
						}
					case SEMICOLON:
					case CLOSEBRACES:
						{
							if (comment + quote + parentheses + bracket === 0) {
								column++;
								break;
							}
						}
					default:
						{
							// increment column position
							column++;
	
							// current character
							char = body.charAt(caret);
	
							// remove comments, escape functions, strings, attributes and prepare selectors
							switch (code) {
								case TAB:
								case SPACE:
									{
										if (quote + bracket + comment === 0) {
											switch (tail) {
												case COMMA:
												case COLON:
												case TAB:
												case SPACE:
													{
														char = '';
														break;
													}
												default:
													{
														if (code !== SPACE) {
															char = ' ';
														}
													}
											}
										}
										break;
									}
								// escape breaking control characters
								case NULL:
									{
										char = '\\0';
										break;
									}
								case FORMFEED:
									{
										char = '\\f';
										break;
									}
								case VERTICALTAB:
									{
										char = '\\v';
										break;
									}
								// &
								case AND:
									{
										// inverted selector pattern i.e html &
										if (quote + comment + bracket === 0 && cascade > 0) {
											invert = 1;
											format = 1;
											char = '\f' + char;
										}
										break;
									}
								// ::p<l>aceholder, l
								// :read-on<l>y, l
								case 108:
									{
										if (quote + comment + bracket + pattern === 0 && pseudo > 0) {
											switch (caret - pseudo) {
												// ::placeholder
												case 2:
													{
														if (tail === PLACEHOLDER && body.charCodeAt(caret - 3) === COLON) {
															pattern = tail;
														}
													}
												// :read-only
												case 8:
													{
														if (trail === READONLY) {
															pattern = trail;
														}
													}
											}
										}
										break;
									}
								// :<pattern>
								case COLON:
									{
										if (quote + comment + bracket === 0) {
											pseudo = caret;
										}
										break;
									}
								// selectors
								case COMMA:
									{
										if (comment + parentheses + quote + bracket === 0) {
											format = 1;
											char += '\r';
										}
										break;
									}
								// quotes
								case DOUBLEQUOTE:
								case SINGLEQUOTE:
									{
										if (comment === 0) {
											quote = quote === code ? 0 : quote === 0 ? code : quote;
										}
										break;
									}
								// attributes
								case OPENBRACKET:
									{
										if (quote + comment + parentheses === 0) {
											bracket++;
										}
										break;
									}
								case CLOSEBRACKET:
									{
										if (quote + comment + parentheses === 0) {
											bracket--;
										}
										break;
									}
								// functions
								case CLOSEPARENTHESES:
									{
										if (quote + comment + bracket === 0) {
											parentheses--;
										}
										break;
									}
								case OPENPARENTHESES:
									{
										if (quote + comment + bracket === 0) {
											if (context === 0) {
												switch (tail * 2 + trail * 3) {
													// :matches
													case 533:
														{
															break;
														}
													// :global, :not, :nth-child etc...
													default:
														{
															counter = 0;
															context = 1;
														}
												}
											}
	
											parentheses++;
										}
										break;
									}
								case AT:
									{
										if (comment + parentheses + quote + bracket + pseudo + atrule === 0) {
											atrule = 1;
										}
										break;
									}
								// block/line comments
								case STAR:
								case FOWARDSLASH:
									{
										if (quote + bracket + parentheses > 0) {
											break;
										}
	
										switch (comment) {
											// initialize line/block comment context
											case 0:
												{
													switch (code * 2 + body.charCodeAt(caret + 1) * 3) {
														// //
														case 235:
															{
																comment = FOWARDSLASH;
																break;
															}
														// /*
														case 220:
															{
																length = caret;
																comment = STAR;
																break;
															}
													}
													break;
												}
											// end block comment context
											case STAR:
												{
													if (code === FOWARDSLASH && tail === STAR && length + 2 !== caret) {
														// /*<!> ... */, !
														if (body.charCodeAt(length + 2) === 33) {
															out += body.substring(length, caret + 1);
														}
														char = '';
														comment = 0;
													}
												}
										}
									}
							}
	
							// ignore comment blocks
							if (comment === 0) {
								// aggressive isolation mode, divide each individual selector
								// including selectors in :not function but excluding selectors in :global function
								if (cascade + quote + bracket + atrule === 0 && id !== KEYFRAME && code !== SEMICOLON) {
									switch (code) {
										case COMMA:
										case TILDE:
										case GREATERTHAN:
										case PLUS:
										case CLOSEPARENTHESES:
										case OPENPARENTHESES:
											{
												if (context === 0) {
													// outside of an isolated context i.e nth-child(<...>)
													switch (tail) {
														case TAB:
														case SPACE:
														case NEWLINE:
														case CARRIAGE:
															{
																char = char + '\0';
																break;
															}
														default:
															{
																char = '\0' + char + (code === COMMA ? '' : '\0');
															}
													}
													format = 1;
												} else {
													// within an isolated context, sleep untill it's terminated
													switch (code) {
														case OPENPARENTHESES:
															{
																// :globa<l>(
																if (pseudo + 7 === caret && tail === 108) {
																	pseudo = 0;
																}
																context = ++counter;
																break;
															}
														case CLOSEPARENTHESES:
															{
																if ((context = --counter) === 0) {
																	format = 1;
																	char += '\0';
																}
																break;
															}
													}
												}
												break;
											}
										case TAB:
										case SPACE:
											{
												switch (tail) {
													case NULL:
													case OPENBRACES:
													case CLOSEBRACES:
													case SEMICOLON:
													case COMMA:
													case FORMFEED:
													case TAB:
													case SPACE:
													case NEWLINE:
													case CARRIAGE:
														{
															break;
														}
													default:
														{
															// ignore in isolated contexts
															if (context === 0) {
																format = 1;
																char += '\0';
															}
														}
												}
											}
									}
								}
	
								// concat buffer of characters
								chars += char;
	
								// previous non-whitespace character code
								if (code !== SPACE && code !== TAB) {
									peak = code;
								}
							}
						}
				}
	
				// tail character codes
				trail = tail;
				tail = code;
	
				// visit every character
				caret++;
			}
	
			length = out.length;
	
			// preserve empty selector
			if (preserve > 0) {
				if (length === 0 && children.length === 0 && current[0].length === 0 === false) {
					if (id !== MEDIA || current.length === 1 && (cascade > 0 ? nscopealt : nscope) === current[0]) {
						length = current.join(',').length + 2;
					}
				}
			}
	
			if (length > 0) {
				// cascade isolation mode?
				selector = cascade === 0 && id !== KEYFRAME ? isolate(current) : current;
	
				// execute plugins, block context
				if (plugged > 0) {
					result = proxy(BLCKS, out, selector, parent, line, column, length, id, depth, id);
	
					if (result !== void 0 && (out = result).length === 0) {
						return flat + out + children;
					}
				}
	
				out = selector.join(',') + '{' + out + '}';
	
				if (prefix * pattern !== 0) {
					if (prefix === 2 && !vendor(out, 2)) pattern = 0;
	
					switch (pattern) {
						// ::read-only
						case READONLY:
							{
								out = out.replace(readonlyptn, ':' + moz + '$1') + out;
								break;
							}
						// ::placeholder
						case PLACEHOLDER:
							{
								out = out.replace(plcholdrptn, '::' + webkit + 'input-$1') + out.replace(plcholdrptn, '::' + moz + '$1') + out.replace(plcholdrptn, ':' + ms + 'input-$1') + out;
								break;
							}
					}
	
					pattern = 0;
				}
			}
	
			return flat + out + children;
		}
	
		/**
	  * Select
	  *
	  * @param {Array<string>} parent
	  * @param {string} current
	  * @param {number} invert
	  * @return {Array<string>}
	  */
		function select(parent, current, invert) {
			var selectors = current.trim().split(selectorptn);
			var out = selectors;
	
			var length = selectors.length;
			var l = parent.length;
	
			switch (l) {
				// 0-1 parent selectors
				case 0:
				case 1:
					{
						for (var i = 0, selector = l === 0 ? '' : parent[0] + ' '; i < length; ++i) {
							out[i] = scope(selector, out[i], invert, l).trim();
						}
						break;
					}
				// >2 parent selectors, nested
				default:
					{
						for (var i = 0, j = 0, out = []; i < length; ++i) {
							for (var k = 0; k < l; ++k) {
								out[j++] = scope(parent[k] + ' ', selectors[i], invert, l).trim();
							}
						}
					}
			}
	
			return out;
		}
	
		/**
	  * Scope
	  *
	  * @param {string} parent
	  * @param {string} current
	  * @param {number} invert
	  * @param {number} level
	  * @return {string}
	  */
		function scope(parent, current, invert, level) {
			var selector = current;
			var code = selector.charCodeAt(0);
	
			// trim leading whitespace
			if (code < 33) {
				code = (selector = selector.trim()).charCodeAt(0);
			}
	
			switch (code) {
				// &
				case AND:
					{
						switch (cascade + level) {
							case 0:
							case 1:
								{
									if (parent.trim().length === 0) {
										break;
									}
								}
							default:
								{
									return selector.replace(andptn, '$1' + parent.trim());
								}
						}
						break;
					}
				// :
				case COLON:
					{
						switch (selector.charCodeAt(1)) {
							// g in :global
							case 103:
								{
									if (escape > 0 && cascade > 0) {
										return selector.replace(escapeptn, '$1').replace(andptn, '$1' + nscope);
									}
									break;
								}
							default:
								{
									// :hover
									return parent.trim() + selector.replace(andptn, '$1' + parent.trim());
								}
						}
					}
				default:
					{
						// html &
						if (invert * cascade > 0 && selector.indexOf('\f') > 0) {
							return selector.replace(andptn, (parent.charCodeAt(0) === COLON ? '' : '$1') + parent.trim());
						}
					}
			}
	
			return parent + selector;
		}
	
		/**
	  * Property
	  *
	  * @param {string} input
	  * @param {number} first
	  * @param {number} second
	  * @param {number} third
	  * @return {string}
	  */
		function property(input, first, second, third) {
			var index = 0;
			var out = input + ';';
			var hash = first * 2 + second * 3 + third * 4;
			var cache;
	
			// animation: a, n, i characters
			if (hash === 944) {
				return animation(out);
			} else if (prefix === 0 || prefix === 2 && !vendor(out, 1)) {
				return out;
			}
	
			// vendor prefix
			switch (hash) {
				// text-decoration/text-size-adjust/text-shadow/text-align/text-transform: t, e, x
				case 1015:
					{
						// text-shadow/text-align/text-transform, a
						return out.charCodeAt(10) === 97 ? webkit + out + out : out;
					}
				// filter/fill f, i, l
				case 951:
					{
						// filter, t
						return out.charCodeAt(3) === 116 ? webkit + out + out : out;
					}
				// color/column, c, o, l
				case 963:
					{
						// column, n
						return out.charCodeAt(5) === 110 ? webkit + out + out : out;
					}
				// box-decoration-break, b, o, x
				case 1009:
					{
						if (out.charCodeAt(4) !== 100) {
							break;
						}
					}
				// mask, m, a, s
				// clip-path, c, l, i
				case 969:
				case 942:
					{
						return webkit + out + out;
					}
				// appearance: a, p, p
				case 978:
					{
						return webkit + out + moz + out + out;
					}
				// hyphens: h, y, p
				// user-select: u, s, e
				case 1019:
				case 983:
					{
						return webkit + out + moz + out + ms + out + out;
					}
				// background/backface-visibility, b, a, c
				case 883:
					{
						// backface-visibility, -
						if (out.charCodeAt(8) === DASH) {
							return webkit + out + out;
						}
	
						// image-set(...)
						if (out.indexOf('image-set(', 11) > 0) {
							return out.replace(imgsrcptn, '$1' + webkit + '$2') + out;
						}
	
						return out;
					}
				// flex: f, l, e
				case 932:
					{
						if (out.charCodeAt(4) === DASH) {
							switch (out.charCodeAt(5)) {
								// flex-grow, g
								case 103:
									{
										return webkit + 'box-' + out.replace('-grow', '') + webkit + out + ms + out.replace('grow', 'positive') + out;
									}
								// flex-shrink, s
								case 115:
									{
										return webkit + out + ms + out.replace('shrink', 'negative') + out;
									}
								// flex-basis, b
								case 98:
									{
										return webkit + out + ms + out.replace('basis', 'preferred-size') + out;
									}
							}
						}
	
						return webkit + out + ms + out + out;
					}
				// order: o, r, d
				case 964:
					{
						return webkit + out + ms + 'flex' + '-' + out + out;
					}
				// justify-items/justify-content, j, u, s
				case 1023:
					{
						// justify-content, c
						if (out.charCodeAt(8) !== 99) {
							break;
						}
	
						cache = out.substring(out.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
						return webkit + 'box-pack' + cache + webkit + out + ms + 'flex-pack' + cache + out;
					}
				// cursor, c, u, r
				case 1005:
					{
						return cursorptn.test(out) ? out.replace(colonptn, ':' + webkit) + out.replace(colonptn, ':' + moz) + out : out;
					}
				// writing-mode, w, r, i
				case 1000:
					{
						cache = out.substring(13).trim();
						index = cache.indexOf('-') + 1;
	
						switch (cache.charCodeAt(0) + cache.charCodeAt(index)) {
							// vertical-lr
							case 226:
								{
									cache = out.replace(writingptn, 'tb');
									break;
								}
							// vertical-rl
							case 232:
								{
									cache = out.replace(writingptn, 'tb-rl');
									break;
								}
							// horizontal-tb
							case 220:
								{
									cache = out.replace(writingptn, 'lr');
									break;
								}
							default:
								{
									return out;
								}
						}
	
						return webkit + out + ms + cache + out;
					}
				// position: sticky
				case 1017:
					{
						if (out.indexOf('sticky', 9) === -1) {
							return out;
						}
					}
				// display(flex/inline-flex/inline-box): d, i, s
				case 975:
					{
						index = (out = input).length - 10;
						cache = (out.charCodeAt(index) === 33 ? out.substring(0, index) : out).substring(input.indexOf(':', 7) + 1).trim();
	
						switch (hash = cache.charCodeAt(0) + (cache.charCodeAt(7) | 0)) {
							// inline-
							case 203:
								{
									// inline-box
									if (cache.charCodeAt(8) < 111) {
										break;
									}
								}
							// inline-box/sticky
							case 115:
								{
									out = out.replace(cache, webkit + cache) + ';' + out;
									break;
								}
							// inline-flex
							// flex
							case 207:
							case 102:
								{
									out = out.replace(cache, webkit + (hash > 102 ? 'inline-' : '') + 'box') + ';' + out.replace(cache, webkit + cache) + ';' + out.replace(cache, ms + cache + 'box') + ';' + out;
								}
						}
	
						return out + ';';
					}
				// align-items, align-center, align-self: a, l, i, -
				case 938:
					{
						if (out.charCodeAt(5) === DASH) {
							switch (out.charCodeAt(6)) {
								// align-items, i
								case 105:
									{
										cache = out.replace('-items', '');
										return webkit + out + webkit + 'box-' + cache + ms + 'flex-' + cache + out;
									}
								// align-self, s
								case 115:
									{
										return webkit + out + ms + 'flex-item-' + out.replace(selfptn, '') + out;
									}
								// align-content
								default:
									{
										return webkit + out + ms + 'flex-line-pack' + out.replace('align-content', '').replace(selfptn, '') + out;
									}
							}
						}
						break;
					}
				// min/max
				case 973:
				case 989:
					{
						// min-/max- height/width/block-size/inline-size
						if (out.charCodeAt(3) !== DASH || out.charCodeAt(4) === 122) {
							break;
						}
					}
				// height/width: min-content / width: max-content
				case 931:
				case 953:
					{
						if (dimensionptn.test(input) === true) {
							// stretch
							if ((cache = input.substring(input.indexOf(':') + 1)).charCodeAt(0) === 115) return property(input.replace('stretch', 'fill-available'), first, second, third).replace(':fill-available', ':stretch');else return out.replace(cache, webkit + cache) + out.replace(cache, moz + cache.replace('fill-', '')) + out;
						}
						break;
					}
				// transform, transition: t, r, a
				case 962:
					{
						out = webkit + out + (out.charCodeAt(5) === 102 ? ms + out : '') + out;
	
						// transitions
						if (second + third === 211 && out.charCodeAt(13) === 105 && out.indexOf('transform', 10) > 0) {
							return out.substring(0, out.indexOf(';', 27) + 1).replace(transformptn, '$1' + webkit + '$2') + out;
						}
	
						break;
					}
			}
	
			return out;
		}
	
		/**
	  * Vendor
	  *
	  * @param {string} content
	  * @param {number} context
	  * @return {boolean}
	  */
		function vendor(content, context) {
			var index = content.indexOf(context === 1 ? ':' : '{');
			var key = content.substring(0, context !== 3 ? index : 10);
			var value = content.substring(index + 1, content.length - 1);
	
			return should(context !== 2 ? key : key.replace(pseudofmt, '$1'), value, context);
		}
	
		/**
	  * Supports
	  *
	  * @param {string} match
	  * @param {string} group
	  * @return {string}
	  */
		function supports(match, group) {
			var out = property(group, group.charCodeAt(0), group.charCodeAt(1), group.charCodeAt(2));
	
			return out !== group + ';' ? out.replace(propertyptn, ' or ($1)').substring(4) : '(' + group + ')';
		}
	
		/**
	  * Animation
	  *
	  * @param {string} input
	  * @return {string}
	  */
		function animation(input) {
			var length = input.length;
			var index = input.indexOf(':', 9) + 1;
			var declare = input.substring(0, index).trim();
			var out = input.substring(index, length - 1).trim();
	
			switch (input.charCodeAt(9) * keyed) {
				case 0:
					{
						break;
					}
				// animation-*, -
				case DASH:
					{
						// animation-name, n
						if (input.charCodeAt(10) !== 110) {
							break;
						}
					}
				// animation/animation-name
				default:
					{
						// split in case of multiple animations
						var list = out.split((out = '', animationptn));
	
						for (var i = 0, index = 0, length = list.length; i < length; index = 0, ++i) {
							var value = list[i];
							var items = value.split(propertiesptn);
	
							while (value = items[index]) {
								var peak = value.charCodeAt(0);
	
								if (keyed === 1 && (
								// letters
								peak > AT && peak < 90 || peak > 96 && peak < 123 || peak === UNDERSCORE ||
								// dash but not in sequence i.e --
								peak === DASH && value.charCodeAt(1) !== DASH)) {
									// not a number/function
									switch (isNaN(parseFloat(value)) + (value.indexOf('(') !== -1)) {
										case 1:
											{
												switch (value) {
													// not a valid reserved keyword
													case 'infinite':case 'alternate':case 'backwards':case 'running':
													case 'normal':case 'forwards':case 'both':case 'none':case 'linear':
													case 'ease':case 'ease-in':case 'ease-out':case 'ease-in-out':
													case 'paused':case 'reverse':case 'alternate-reverse':case 'inherit':
													case 'initial':case 'unset':case 'step-start':case 'step-end':
														{
															break;
														}
													default:
														{
															value += key;
														}
												}
											}
									}
								}
	
								items[index++] = value;
							}
	
							out += (i === 0 ? '' : ',') + items.join(' ');
						}
					}
			}
	
			out = declare + out + ';';
	
			if (prefix === 1 || prefix === 2 && vendor(out, 1)) return webkit + out + out;
	
			return out;
		}
	
		/**
	  * Isolate
	  *
	  * @param {Array<string>} current
	  */
		function isolate(current) {
			for (var i = 0, length = current.length, selector = Array(length), padding, element; i < length; ++i) {
				// split individual elements in a selector i.e h1 h2 === [h1, h2]
				var elements = current[i].split(elementptn);
				var out = '';
	
				for (var j = 0, size = 0, tail = 0, code = 0, l = elements.length; j < l; ++j) {
					// empty element
					if ((size = (element = elements[j]).length) === 0 && l > 1) {
						continue;
					}
	
					tail = out.charCodeAt(out.length - 1);
					code = element.charCodeAt(0);
					padding = '';
	
					if (j !== 0) {
						// determine if we need padding
						switch (tail) {
							case STAR:
							case TILDE:
							case GREATERTHAN:
							case PLUS:
							case SPACE:
							case OPENPARENTHESES:
								{
									break;
								}
							default:
								{
									padding = ' ';
								}
						}
					}
	
					switch (code) {
						case AND:
							{
								element = padding + nscopealt;
							}
						case TILDE:
						case GREATERTHAN:
						case PLUS:
						case SPACE:
						case CLOSEPARENTHESES:
						case OPENPARENTHESES:
							{
								break;
							}
						case OPENBRACKET:
							{
								element = padding + element + nscopealt;
								break;
							}
						case COLON:
							{
								switch (element.charCodeAt(1) * 2 + element.charCodeAt(2) * 3) {
									// :global
									case 530:
										{
											if (escape > 0) {
												element = padding + element.substring(8, size - 1);
												break;
											}
										}
									// :hover, :nth-child(), ...
									default:
										{
											if (j < 1 || elements[j - 1].length < 1) {
												element = padding + nscopealt + element;
											}
										}
								}
								break;
							}
						case COMMA:
							{
								padding = '';
							}
						default:
							{
								if (size > 1 && element.indexOf(':') > 0) {
									element = padding + element.replace(pseudoptn, '$1' + nscopealt + '$2');
								} else {
									element = padding + element + nscopealt;
								}
							}
					}
	
					out += element;
				}
	
				selector[i] = out.replace(formatptn, '').trim();
			}
	
			return selector;
		}
	
		/**
	  * Proxy
	  *
	  * @param {number} context
	  * @param {string} content
	  * @param {Array<string>} selectors
	  * @param {Array<string>} parents
	  * @param {number} line
	  * @param {number} column
	  * @param {number} length
	  * @param {number} id
	  * @param {number} depth
	  * @param {number} at
	  * @return {(string|void|*)}
	  */
		function proxy(context, content, selectors, parents, line, column, length, id, depth, at) {
			for (var i = 0, out = content, next; i < plugged; ++i) {
				switch (next = plugins[i].call(stylis, context, out, selectors, parents, line, column, length, id, depth, at)) {
					case void 0:
					case false:
					case true:
					case null:
						{
							break;
						}
					default:
						{
							out = next;
						}
				}
			}
			if (out !== content) {
				return out;
			}
		}
	
		/**
	  * @param {number} code
	  * @param {number} index
	  * @param {number} length
	  * @param {string} body
	  * @return {number}
	  */
		function delimited(code, index, length, body) {
			for (var i = index + 1; i < length; ++i) {
				switch (body.charCodeAt(i)) {
					// /*
					case FOWARDSLASH:
						{
							if (code === STAR) {
								if (body.charCodeAt(i - 1) === STAR && index + 2 !== i) {
									return i + 1;
								}
							}
							break;
						}
					// //
					case NEWLINE:
						{
							if (code === FOWARDSLASH) {
								return i + 1;
							}
						}
				}
			}
	
			return i;
		}
	
		/**
	  * @param {number} type
	  * @param {number} index
	  * @param {number} length
	  * @param {number} find
	  * @param {string} body
	  * @return {number}
	  */
		function match(type, index, length, body) {
			for (var i = index + 1; i < length; ++i) {
				switch (body.charCodeAt(i)) {
					case type:
						{
							return i;
						}
				}
			}
	
			return i;
		}
	
		/**
	  * Minify
	  *
	  * @param {(string|*)} output
	  * @return {string}
	  */
		function minify(output) {
			return output.replace(formatptn, '').replace(beforeptn, '').replace(afterptn, '$1').replace(tailptn, '$1').replace(whiteptn, ' ');
		}
	
		/**
	  * Use
	  *
	  * @param {(Array<function(...?)>|function(...?)|number|void)?} plugin
	  */
		function use(plugin) {
			switch (plugin) {
				case void 0:
				case null:
					{
						plugged = plugins.length = 0;
						break;
					}
				default:
					{
						if (typeof plugin === 'function') {
							plugins[plugged++] = plugin;
						} else if ((typeof plugin === 'undefined' ? 'undefined' : _typeof(plugin)) === 'object') {
							for (var i = 0, length = plugin.length; i < length; ++i) {
								use(plugin[i]);
							}
						} else {
							unkwn = !!plugin | 0;
						}
					}
			}
	
			return use;
		}
	
		/**
	  * Set
	  *
	  * @param {*} options
	  */
		function set(options) {
			for (var name in options) {
				var value = options[name];
				switch (name) {
					case 'keyframe':
						keyed = value | 0;break;
					case 'global':
						escape = value | 0;break;
					case 'cascade':
						cascade = value | 0;break;
					case 'compress':
						compress = value | 0;break;
					case 'semicolon':
						semicolon = value | 0;break;
					case 'preserve':
						preserve = value | 0;break;
					case 'prefix':
						should = null;
	
						if (!value) {
							prefix = 0;
						} else if (typeof value !== 'function') {
							prefix = 1;
						} else {
							prefix = 2;
							should = value;
						}
				}
			}
	
			return set;
		}
	
		/**
	  * Stylis
	  *
	  * @param {string} selector
	  * @param {string} input
	  * @return {*}
	  */
		function stylis(selector, input) {
			if (this !== void 0 && this.constructor === stylis) {
				return factory(selector);
			}
	
			// setup
			var ns = selector;
			var code = ns.charCodeAt(0);
	
			// trim leading whitespace
			if (code < 33) {
				code = (ns = ns.trim()).charCodeAt(0);
			}
	
			// keyframe/animation namespace
			if (keyed > 0) {
				key = ns.replace(invalidptn, code === OPENBRACKET ? '' : '-');
			}
	
			// reset, used to assert if a plugin is moneky-patching the return value
			code = 1;
	
			// cascade/isolate
			if (cascade === 1) {
				nscope = ns;
			} else {
				nscopealt = ns;
			}
	
			var selectors = [nscope];
			var result;
	
			// execute plugins, pre-process context
			if (plugged > 0) {
				result = proxy(PREPS, input, selectors, selectors, line, column, 0, 0, 0, 0);
	
				if (result !== void 0 && typeof result === 'string') {
					input = result;
				}
			}
	
			// build
			var output = compile(array, selectors, input, 0, 0);
	
			// execute plugins, post-process context
			if (plugged > 0) {
				result = proxy(POSTS, output, selectors, selectors, line, column, output.length, 0, 0, 0);
	
				// bypass minification
				if (result !== void 0 && typeof (output = result) !== 'string') {
					code = 0;
				}
			}
	
			// reset
			key = '';
			nscope = '';
			nscopealt = '';
			pattern = 0;
			line = 1;
			column = 1;
	
			return compress * code === 0 ? output : minify(output);
		}
	
		stylis['use'] = use;
		stylis['set'] = set;
	
		if (options !== void 0) {
			set(options);
		}
	
		return stylis;
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(88)(module)))

/***/ },
/* 925 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }return target;
	};
	
	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	  };
	}();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _VstComponent2 = __webpack_require__(13);
	
	var _VstComponent3 = _interopRequireDefault(_VstComponent2);
	
	var _addClassName = __webpack_require__(64);
	
	var _addClassName2 = _interopRequireDefault(_addClassName);
	
	var _copyProps = __webpack_require__(42);
	
	var _copyProps2 = _interopRequireDefault(_copyProps);
	
	var _classnames = __webpack_require__(25);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _namespaceOptions = __webpack_require__(76);
	
	var _namespaceOptions2 = _interopRequireDefault(_namespaceOptions);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var VstCard = function (_VstComponent) {
	  _inherits(VstCard, _VstComponent);
	
	  function VstCard() {
	    _classCallCheck(this, VstCard);
	
	    return _possibleConstructorReturn(this, (VstCard.__proto__ || Object.getPrototypeOf(VstCard)).apply(this, arguments));
	  }
	
	  _createClass(VstCard, [{
	    key: 'render',
	    value: function render() {
	      var props = (0, _addClassName2.default)(this.props, (0, _classnames2.default)((0, _namespaceOptions2.default)('vst', this.props.options), 'vst-card'));
	      props = (0, _copyProps2.default)(props, ['options']);
	
	      return _react2.default.createElement('li', _extends({ className: 'vst-card' }, props), this.props.children);
	    }
	  }]);
	
	  return VstCard;
	}(_VstComponent3.default);
	
	module.exports = VstCard;

/***/ },
/* 926 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }return target;
	};
	
	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	  };
	}();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _VstComponent2 = __webpack_require__(13);
	
	var _VstComponent3 = _interopRequireDefault(_VstComponent2);
	
	var _addClassName = __webpack_require__(64);
	
	var _addClassName2 = _interopRequireDefault(_addClassName);
	
	var _copyProps = __webpack_require__(42);
	
	var _copyProps2 = _interopRequireDefault(_copyProps);
	
	var _classnames = __webpack_require__(25);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _namespaceOptions = __webpack_require__(76);
	
	var _namespaceOptions2 = _interopRequireDefault(_namespaceOptions);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var VstCardList = function (_VstComponent) {
	  _inherits(VstCardList, _VstComponent);
	
	  function VstCardList() {
	    _classCallCheck(this, VstCardList);
	
	    return _possibleConstructorReturn(this, (VstCardList.__proto__ || Object.getPrototypeOf(VstCardList)).apply(this, arguments));
	  }
	
	  _createClass(VstCardList, [{
	    key: 'render',
	    value: function render() {
	      var props = (0, _addClassName2.default)(this.props, (0, _classnames2.default)((0, _namespaceOptions2.default)('vst', this.props.options), 'vst-card-list'));
	      props = (0, _copyProps2.default)(props, ['options']);
	
	      return _react2.default.createElement('ul', _extends({ className: 'vst-card-list' }, props), this.props.children, _react2.default.createElement('li', { className: 'vst-hidden-card', tabIndex: '-1', 'aria-hidden': 'true' }), _react2.default.createElement('li', { className: 'vst-hidden-card', tabIndex: '-1', 'aria-hidden': 'true' }), _react2.default.createElement('li', { className: 'vst-hidden-card', tabIndex: '-1', 'aria-hidden': 'true' }), _react2.default.createElement('li', { className: 'vst-hidden-card', tabIndex: '-1', 'aria-hidden': 'true' }), _react2.default.createElement('li', { className: 'vst-hidden-card', tabIndex: '-1', 'aria-hidden': 'true' }), _react2.default.createElement('li', { className: 'vst-hidden-card', tabIndex: '-1', 'aria-hidden': 'true' }), _react2.default.createElement('li', { className: 'vst-hidden-card', tabIndex: '-1', 'aria-hidden': 'true' }), _react2.default.createElement('li', { className: 'vst-hidden-card', tabIndex: '-1', 'aria-hidden': 'true' }), _react2.default.createElement('li', { className: 'vst-hidden-card', tabIndex: '-1', 'aria-hidden': 'true' }));
	    }
	  }]);
	
	  return VstCardList;
	}(_VstComponent3.default);
	
	module.exports = VstCardList;

/***/ },
/* 927 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }return target;
	};
	
	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	  };
	}();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _VstComponent2 = __webpack_require__(13);
	
	var _VstComponent3 = _interopRequireDefault(_VstComponent2);
	
	var _addClassName = __webpack_require__(64);
	
	var _addClassName2 = _interopRequireDefault(_addClassName);
	
	var _copyProps = __webpack_require__(42);
	
	var _copyProps2 = _interopRequireDefault(_copyProps);
	
	var _classnames = __webpack_require__(25);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _namespaceOptions = __webpack_require__(76);
	
	var _namespaceOptions2 = _interopRequireDefault(_namespaceOptions);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var VstContainer = function (_VstComponent) {
	  _inherits(VstContainer, _VstComponent);
	
	  function VstContainer() {
	    _classCallCheck(this, VstContainer);
	
	    return _possibleConstructorReturn(this, (VstContainer.__proto__ || Object.getPrototypeOf(VstContainer)).apply(this, arguments));
	  }
	
	  _createClass(VstContainer, [{
	    key: 'render',
	    value: function render() {
	      var props = (0, _addClassName2.default)(this.props, (0, _classnames2.default)((0, _namespaceOptions2.default)('vst', this.props.options), 'vst-container'));
	      props = (0, _copyProps2.default)(props, ['options']);
	
	      return _react2.default.createElement('div', _extends({ className: 'vst-container' }, props), this.props.children);
	    }
	  }]);
	
	  return VstContainer;
	}(_VstComponent3.default);
	
	module.exports = VstContainer;

/***/ },
/* 928 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	  };
	}();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _VstComponent2 = __webpack_require__(13);
	
	var _VstComponent3 = _interopRequireDefault(_VstComponent2);
	
	var _VstHamburger = __webpack_require__(392);
	
	var _VstHamburger2 = _interopRequireDefault(_VstHamburger);
	
	var _classnames = __webpack_require__(25);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var VstHeader = function (_VstComponent) {
	  _inherits(VstHeader, _VstComponent);
	
	  function VstHeader() {
	    _classCallCheck(this, VstHeader);
	
	    var _this = _possibleConstructorReturn(this, (VstHeader.__proto__ || Object.getPrototypeOf(VstHeader)).call(this));
	
	    _this._clickLogo = _this._clickLogo.bind(_this);
	    return _this;
	  }
	
	  _createClass(VstHeader, [{
	    key: '_clickLogo',
	    value: function _clickLogo(e) {
	      if (this.props.clickLogo) {
	        this.props.clickLogo(e);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement('header', { className: (0, _classnames2.default)(this.props.className, 'vst-header'), 'aria-hidden': 'false' }, _react2.default.createElement('div', { className: 'vst-left' }, _react2.default.createElement('div', { className: 'vst-logo' }, _react2.default.createElement('a', { className: 'vst-link', href: '/#/', ref: 'logo', onClick: this._clickLogo }, _react2.default.createElement('img', { src: this.props.logo, alt: this.props.title })))), _react2.default.createElement('div', { className: 'vst-right' }, _react2.default.createElement('ul', { className: 'header-list' }, this.props.children)), _react2.default.createElement('div', { className: 'vst-center' }, this.props.clickHamburger && _react2.default.createElement(_VstHamburger2.default, { active: this.props.activeHamburger,
	        clickHamburger: this.props.clickHamburger
	      }), _react2.default.createElement('span', null, this.props.title)));
	    }
	  }]);
	
	  return VstHeader;
	}(_VstComponent3.default);
	
	exports.default = VstHeader;

/***/ },
/* 929 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }return target;
	};
	
	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	  };
	}();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _VstComponent2 = __webpack_require__(13);
	
	var _VstComponent3 = _interopRequireDefault(_VstComponent2);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var VstHeaderButton = function (_VstComponent) {
	  _inherits(VstHeaderButton, _VstComponent);
	
	  function VstHeaderButton() {
	    _classCallCheck(this, VstHeaderButton);
	
	    return _possibleConstructorReturn(this, (VstHeaderButton.__proto__ || Object.getPrototypeOf(VstHeaderButton)).apply(this, arguments));
	  }
	
	  _createClass(VstHeaderButton, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement('li', { className: 'vst-header-button' }, _react2.default.createElement('button', _extends({}, this.props, { className: 'vst-no-button little-head-button' }), this.props.children));
	    }
	  }]);
	
	  return VstHeaderButton;
	}(_VstComponent3.default);
	
	exports.default = VstHeaderButton;

/***/ },
/* 930 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }return target;
	};
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(29);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _VstInput = __webpack_require__(182);
	
	var _VstInput2 = _interopRequireDefault(_VstInput);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	var Button = function Button(_ref) {
	  var children = _ref.children;
	  return _react2.default.createElement('div', { className: 'vst-input-button' }, children);
	};
	Button.propTypes = {
	  children: _propTypes2.default.node.isRequired
	};
	
	var Addon = function Addon(_ref2) {
	  var children = _ref2.children;
	  return _react2.default.createElement('div', { className: 'vst-input-addon' }, children);
	};
	Addon.propTypes = {
	  children: _propTypes2.default.node.isRequired
	};
	
	var Input = function Input(props) {
	  return _react2.default.createElement(_VstInput2.default, _extends({}, props, { ignoreLabel: true }));
	};
	
	var VstInputGroup = function VstInputGroup(_ref3) {
	  var children = _ref3.children,
	      label = _ref3.label,
	      height = _ref3.height;
	  return _react2.default.createElement('div', { className: 'vst-input-group' }, _react2.default.createElement('fieldset', null, label && _react2.default.createElement('legend', null, label), _react2.default.createElement('div', { className: 'vst-input-row', style: { height: height } }, children)));
	};
	
	VstInputGroup.propTypes = {
	  children: _propTypes2.default.node.isRequired,
	  label: _propTypes2.default.string.isRequired,
	  height: _propTypes2.default.string
	};
	VstInputGroup.defaultProps = {
	  label: null,
	  height: '32px'
	};
	
	VstInputGroup.Addon = Addon;
	VstInputGroup.Button = Button;
	VstInputGroup.Input = Input;
	
	exports.default = VstInputGroup;

/***/ },
/* 931 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	  };
	}();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(25);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _VstComponent2 = __webpack_require__(13);
	
	var _VstComponent3 = _interopRequireDefault(_VstComponent2);
	
	var _VstMenu = __webpack_require__(394);
	
	var _VstMenu2 = _interopRequireDefault(_VstMenu);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var VstLittleHead = function (_VstComponent) {
	  _inherits(VstLittleHead, _VstComponent);
	
	  function VstLittleHead() {
	    _classCallCheck(this, VstLittleHead);
	
	    var _this = _possibleConstructorReturn(this, (VstLittleHead.__proto__ || Object.getPrototypeOf(VstLittleHead)).call(this));
	
	    _this._clickLilHead = _this._clickLilHead.bind(_this);
	    _this._closeMenu = _this._closeMenu.bind(_this);
	    _this.state = {
	      menuRight: 0,
	      visible: false
	    };
	    return _this;
	  }
	
	  _createClass(VstLittleHead, [{
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      // update the location of the dropdown menu depending on the location of the button
	      var menuRight = window.innerWidth - this.refs.lilHeadButton.offsetLeft - this.refs.lilHeadButton.offsetWidth;
	      if (menuRight !== this.state.menuRight) {
	        // TODO: fix lint error
	        /* eslint-disable react/no-did-update-set-state */
	        this.setState({ menuRight: menuRight });
	        /* eslint-enable react/no-did-update-set-state */
	      }
	    }
	  }, {
	    key: '_clickLilHead',
	    value: function _clickLilHead() {
	      this.setState({ visible: !this.state.visible });
	    }
	  }, {
	    key: '_closeMenu',
	    value: function _closeMenu() {
	      this.setState({ visible: false });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement('li', { ref: 'lilHeadButton', id: 'lil-head-button', className: (0, _classnames2.default)('lil-head-item', { expanded: this.state.visible }) }, _react2.default.createElement('button', { className: 'vst-no-button',
	        onClick: this._clickLilHead,
	        'aria-expanded': this.state.visible
	      }, _react2.default.createElement('span', { className: 'vst-off-screen' }, i18n.t('global-bar.account'))), _react2.default.createElement(_VstMenu2.default, { className: 'lil-head-menu',
	        visible: this.state.visible,
	        closeMenu: this._closeMenu
	      }, this.props.children));
	    }
	  }]);
	
	  return VstLittleHead;
	}(_VstComponent3.default);
	
	exports.default = VstLittleHead;

/***/ },
/* 932 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	  };
	}();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _VstComponent2 = __webpack_require__(13);
	
	var _VstComponent3 = _interopRequireDefault(_VstComponent2);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var VstLilHeadFooter = function (_VstComponent) {
	  _inherits(VstLilHeadFooter, _VstComponent);
	
	  function VstLilHeadFooter() {
	    _classCallCheck(this, VstLilHeadFooter);
	
	    return _possibleConstructorReturn(this, (VstLilHeadFooter.__proto__ || Object.getPrototypeOf(VstLilHeadFooter)).apply(this, arguments));
	  }
	
	  _createClass(VstLilHeadFooter, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement('div', { className: 'vst-lil-head-footer' }, this.props.children);
	    }
	  }]);
	
	  return VstLilHeadFooter;
	}(_VstComponent3.default);
	
	exports.default = VstLilHeadFooter;

/***/ },
/* 933 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	  };
	}();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _VstComponent2 = __webpack_require__(13);
	
	var _VstComponent3 = _interopRequireDefault(_VstComponent2);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var VstLilHeadLink = function (_VstComponent) {
	  _inherits(VstLilHeadLink, _VstComponent);
	
	  function VstLilHeadLink() {
	    _classCallCheck(this, VstLilHeadLink);
	
	    return _possibleConstructorReturn(this, (VstLilHeadLink.__proto__ || Object.getPrototypeOf(VstLilHeadLink)).apply(this, arguments));
	  }
	
	  _createClass(VstLilHeadLink, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement('ul', { className: 'vst-lil-head-list' }, _react2.default.createElement('li', { className: 'vst-lil-head-divider' }), this.props.children);
	    }
	  }]);
	
	  return VstLilHeadLink;
	}(_VstComponent3.default);
	
	exports.default = VstLilHeadLink;

/***/ },
/* 934 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }return target;
	};
	
	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	  };
	}();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _VstComponent2 = __webpack_require__(13);
	
	var _VstComponent3 = _interopRequireDefault(_VstComponent2);
	
	var _classnames = __webpack_require__(25);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _copyProps = __webpack_require__(42);
	
	var _copyProps2 = _interopRequireDefault(_copyProps);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var VstLilHeadListLink = function (_VstComponent) {
	  _inherits(VstLilHeadListLink, _VstComponent);
	
	  function VstLilHeadListLink() {
	    _classCallCheck(this, VstLilHeadListLink);
	
	    var _this = _possibleConstructorReturn(this, (VstLilHeadListLink.__proto__ || Object.getPrototypeOf(VstLilHeadListLink)).call(this));
	
	    _this._getIcon = _this._getIcon.bind(_this);
	    return _this;
	  }
	
	  _createClass(VstLilHeadListLink, [{
	    key: '_getIcon',
	    value: function _getIcon() {
	      return;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var props = (0, _copyProps2.default)(this.props, ['icon']);
	      return _react2.default.createElement('li', null, _react2.default.createElement('a', _extends({}, props, { className: 'vst-link vst-lil-head-list-link' }), _react2.default.createElement('span', { className: (0, _classnames2.default)('link-icon', this.props.icon) }), _react2.default.createElement('span', { className: 'link-text' }, this.props.children)));
	    }
	  }]);
	
	  return VstLilHeadListLink;
	}(_VstComponent3.default);
	
	exports.default = VstLilHeadListLink;

/***/ },
/* 935 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	  };
	}();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _VstComponent2 = __webpack_require__(13);
	
	var _VstComponent3 = _interopRequireDefault(_VstComponent2);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var VstLilHeadUser = function (_VstComponent) {
	  _inherits(VstLilHeadUser, _VstComponent);
	
	  function VstLilHeadUser() {
	    _classCallCheck(this, VstLilHeadUser);
	
	    return _possibleConstructorReturn(this, (VstLilHeadUser.__proto__ || Object.getPrototypeOf(VstLilHeadUser)).apply(this, arguments));
	  }
	
	  _createClass(VstLilHeadUser, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement('div', { className: 'vst-lil-head-user vst-lil-head-section' }, _react2.default.createElement('span', { className: 'user-name' }, this.props.firstName, ' ', this.props.lastName), _react2.default.createElement('span', { className: 'user-email' }, this.props.email));
	    }
	  }]);
	
	  return VstLilHeadUser;
	}(_VstComponent3.default);
	
	exports.default = VstLilHeadUser;

/***/ },
/* 936 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	  };
	}();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _VstComponent2 = __webpack_require__(13);
	
	var _VstComponent3 = _interopRequireDefault(_VstComponent2);
	
	var _propTypes = __webpack_require__(29);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _jsColors = __webpack_require__(396);
	
	var _jsColors2 = _interopRequireDefault(_jsColors);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var VstLoader = function (_VstComponent) {
	  _inherits(VstLoader, _VstComponent);
	
	  function VstLoader(props) {
	    _classCallCheck(this, VstLoader);
	
	    var _this = _possibleConstructorReturn(this, (VstLoader.__proto__ || Object.getPrototypeOf(VstLoader)).call(this));
	
	    _this.state = { hidden: props.delay };
	    return _this;
	  }
	
	  _createClass(VstLoader, [{
	    key: 'svgLoader',
	    value: function svgLoader() {
	      return _react2.default.createElement('svg', { xmlns: 'http://www.w3.org/2000/svg', width: '52', height: '52', viewBox: '0 0 52 52' }, _react2.default.createElement('path', { fill: _jsColors2.default.CLOUD[4], d: 'M26 4c12.1 0 22 9.9 22 22s-9.9 22-22 22S4 38.1 4 26 13.9 4 26 4m0-4C11.6 0 0 11.6 0 26s11.6 26 26 26 26-11.6 26-26S40.4 0 26 0z', opacity: '.8' }), _react2.default.createElement('path', { fill: this._theme(7), d: 'M26 0v4c12.1 0 22 9.9 22 22s-9.9 22-22 22v4c14.4 0 26-11.6 26-26S40.4 0 26 0z' }));
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      if (this.props.delay) {
	        this.delayTimeout = setTimeout(function () {
	          _this2.setState({ hidden: false });
	        }, this.props.delay);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.delayTimeout) {
	        clearTimeout(this.delayTimeout);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!this.state.hidden) {
	        return _react2.default.createElement('div', { className: 'vst-loader-container' }, _react2.default.createElement('div', null, _react2.default.createElement('span', { className: 'loader' }, this.svgLoader())), _react2.default.createElement('span', null, this.props.children));
	      }
	      return _react2.default.createElement('span', null);
	    }
	  }]);
	
	  return VstLoader;
	}(_VstComponent3.default);
	
	VstLoader.propTypes = {
	  accent: _propTypes2.default.bool,
	  delay: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.number])
	};
	
	VstLoader.defaultProps = {
	  accent: true,
	  delay: false
	};
	
	module.exports = VstLoader;

/***/ },
/* 937 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	  };
	}();
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }return target;
	};
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(29);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _VstDropdown = __webpack_require__(391);
	
	var _VstDropdown2 = _interopRequireDefault(_VstDropdown);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var upArrow = function upArrow(props) {
	  return _react2.default.createElement('svg', _extends({
	    xmlns: 'http://www.w3.org/2000/svg',
	    width: '10',
	    height: '7',
	    viewBox: '0 0 10 7'
	  }, props), _react2.default.createElement('path', {
	    fill: '#40404C',
	    d: 'M5 3L1.5 6.5 0 5l5-5 5 5-1.5 1.5z'
	  }));
	};
	
	var downArrow = function downArrow(props) {
	  return _react2.default.createElement('svg', _extends({
	    xmlns: 'http://www.w3.org/2000/svg',
	    width: '10',
	    height: '7',
	    viewBox: '0 0 10 7'
	  }, props), _react2.default.createElement('path', {
	    fill: '#40404C',
	    d: 'M5 4L1.5.5 0 2l5 5 5-5L8.5.5z'
	  }));
	};
	
	var checkmark = function checkmark(props) {
	  return _react2.default.createElement('svg', _extends({
	    xmlns: 'http://www.w3.org/2000/svg',
	    width: '16.8',
	    height: '14',
	    viewBox: '0 0 16.8 14'
	  }, props), _react2.default.createElement('path', {
	    fill: '#40404C',
	    d: 'M16.8 2.1L14.7 0 4.9 9.7 2.1 6.9 0 9.1 4.9 14l2.2-2.1z'
	  }));
	};
	
	var path = 'https://bookshelf.vitalsource.com/img/locales/';
	var languages = [{ short: 'en', long: 'English', img: 'en.png' }, { short: 'ar', long: 'العربية', img: 'ar.png' }, { short: 'bg', long: 'Български', img: 'bg.png' }, { short: 'ca', long: 'Català', img: 'ca.png' }, { short: 'cs', long: 'čeština', img: 'cs.png' }, { short: 'cy', long: 'Cymraeg', img: 'cy.png' }, { short: 'da', long: 'Dansk', img: 'da.png' }, { short: 'de', long: 'Deutsch', img: 'de.png' }, { short: 'el', long: 'ελληνικά', img: 'el.png' }, { short: 'en_GB', long: 'English (UK)', img: 'en-GB.png' }, { short: 'es', long: 'Español', img: 'es.png' }, { short: 'es_MX', long: 'Español - México', img: 'es-MX.png' }, { short: 'fi', long: 'Suomi', img: 'fi.png' }, { short: 'fil', long: 'Tagalog', img: 'fil.png' }, { short: 'fr_CA', long: 'Français - Canada', img: 'fr-CA.png' }, { short: 'fr', long: 'Français', img: 'fr.png' }, { short: 'gd', long: 'Gaeilge', img: 'gd.png' }, { short: 'he', long: 'עברית', img: 'he.png' }, { short: 'hi', long: 'हिंदी', img: 'hi.png' }, { short: 'is', long: 'Íslenska', img: 'is.png' }, { short: 'it', long: 'Italiano', img: 'it.png' }, { short: 'ja', long: '日本語', img: 'ja.png' }, { short: 'ko', long: '한국어', img: 'ko.png' }, { short: 'nl', long: 'Nederlands', img: 'nl.png' }, { short: 'no', long: 'Norsk', img: 'no.png' }, { short: 'pl', long: 'Polski', img: 'pl.png' }, { short: 'pt_BR', long: 'Português do Brasil', img: 'pt-BR.png' }, { short: 'pt', long: 'Português', img: 'pt.png' }, { short: 'ro', long: 'Română', img: 'ro.png' }, { short: 'ru', long: 'Pусский', img: 'ru.png' }, { short: 'sv', long: 'Svensk', img: 'sv.png' }, { short: 'th', long: 'ภาษาไทย', img: 'th.png' }, { short: 'tr', long: 'Türk', img: 'tr.png' }, { short: 'vi', long: 'Tiếng Việt', img: 'vi.png' }, { short: 'zh_CN', long: '中文简体', img: 'zh-CN.png' }, { short: 'zh_TW', long: '繁體中文', img: 'zh-TW.png' }];
	
	var VstLocales = function (_React$Component) {
	  _inherits(VstLocales, _React$Component);
	
	  function VstLocales(props) {
	    _classCallCheck(this, VstLocales);
	
	    var _this = _possibleConstructorReturn(this, (VstLocales.__proto__ || Object.getPrototypeOf(VstLocales)).call(this, props));
	
	    _this.state = {
	      selected: _this.props.selected
	    };
	    return _this;
	  }
	
	  _createClass(VstLocales, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_VstDropdown2.default, {
	        className: 'vst-locales ' + this.props.menuName,
	        horizontal: this.props.horizontal,
	        vertical: this.props.vertical,
	        target: this.renderTarget(),
	        height: this.props.height,
	        customX: this.props.customX,
	        customY: this.props.customY,
	        isMobile: this.props.isMobile,
	        headerTitle: this.props.headerTitle,
	        showBackBtn: this.props.showBackBtn,
	        showApplyBtn: this.props.showApplyBtn,
	        headerBackButton: this.props.headerBackButton,
	        scrollable: true
	      }, this.renderLanguages());
	    }
	  }, {
	    key: 'onClick',
	    value: function onClick(selected) {
	      this.setState({ selected: selected });
	      if (this.props.onChange) {
	        this.props.onChange(selected);
	      }
	    }
	  }, {
	    key: 'renderTarget',
	    value: function renderTarget() {
	      var _this2 = this;
	
	      var language = languages.find(function (l) {
	        return l.short === _this2.state.selected;
	      });
	      return _react2.default.createElement('button', { key: 'vst-locale-target', className: 'vst-locales-button' }, _react2.default.createElement('span', { className: 'vst-locales-target-label' }, this.props.label), _react2.default.createElement('span', { className: 'vst-language' }, this.props.customText || language.long), _react2.default.createElement('img', { role: 'presentation', src: path + '/' + language.img }), this.props.vertical === 'top' ? upArrow() : downArrow());
	    }
	  }, {
	    key: 'renderLanguages',
	    value: function renderLanguages() {
	      var _this3 = this;
	
	      return languages.map(function (language) {
	        return _react2.default.createElement(_VstDropdown2.default.Item, {
	          key: 'locales-' + language.short,
	          className: 'vst-language ' + _this3.props.className,
	          selected: _this3.state.selected === language.short,
	          onClick: function onClick() {
	            return _this3.onClick(language.short);
	          },
	          style: {
	            backgroundImage: 'url(\'' + path + '/' + language.img + '\')',
	            backgroundRepeat: 'no-repeat',
	            backgroundPosition: '10px',
	            paddingLeft: '40px',
	            display: 'flex',
	            alignItems: 'center',
	            justifyContent: 'space-between'
	          }
	        }, language.long, _this3.state.selected === language.short && checkmark());
	      });
	    }
	  }]);
	
	  return VstLocales;
	}(_react2.default.Component);
	
	exports.default = VstLocales;
	
	VstLocales.propTypes = {
	  selected: _propTypes2.default.string,
	  className: _propTypes2.default.string,
	  label: _propTypes2.default.string,
	  menuName: _propTypes2.default.string,
	  headerTitle: _propTypes2.default.string,
	  customX: _propTypes2.default.number,
	  customY: _propTypes2.default.number,
	  onChange: _propTypes2.default.func,
	  horizontal: _propTypes2.default.oneOf(['left', 'right']),
	  vertical: _propTypes2.default.oneOf(['bottom', 'top']),
	  height: _propTypes2.default.string,
	  headerBackButton: _propTypes2.default.string,
	  isMobile: _propTypes2.default.bool,
	  customText: _propTypes2.default.string,
	  showBackBtn: false,
	  showApplyBtn: false
	};
	
	VstLocales.defaultProps = {
	  selected: 'en',
	  className: '',
	  label: '',
	  menuName: '',
	  headerTitle: 'Language',
	  customX: 0,
	  customY: 0,
	  vertical: 'top',
	  horizontal: 'left',
	  height: '400px',
	  isMobile: false,
	  showBackBtn: true,
	  customText: '',
	  showApplyBtn: true,
	  headerBackButton: 'Language'
	};

/***/ },
/* 938 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	  };
	}();
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }return target;
	};
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(29);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var svgXIcon = function svgXIcon(props) {
	  return _react2.default.createElement('svg', _extends({
	    xmlns: 'http://www.w3.org/2000/svg',
	    width: '10',
	    height: '10',
	    viewBox: '0 0 10 10'
	  }, props), _react2.default.createElement('path', {
	    fill: '#757575',
	    d: 'M10 1.1L8.9 0 5 3.9 1.1 0 0 1.1 3.9 5 0 8.9 1.1 10 5 6.1 8.9 10 10 8.9 6.1 5z'
	  }));
	};
	
	var VstModal = function (_Component) {
	  _inherits(VstModal, _Component);
	
	  function VstModal() {
	    _classCallCheck(this, VstModal);
	
	    var _this = _possibleConstructorReturn(this, (VstModal.__proto__ || Object.getPrototypeOf(VstModal)).call(this));
	
	    _this.state = {
	      modalWidth: '',
	      modalHeight: ''
	    };
	    _this._hideModal = _this._hideModal.bind(_this);
	    return _this;
	  }
	
	  _createClass(VstModal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.getElementById('root').setAttribute('aria-hidden', 'true');
	      document.getElementById('content-right').style.overflow = 'hidden';
	      this._modalScrollValues();
	      window.addEventListener('resize', this._modalScrollValues);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps() {
	      setTimeout(this._modalScrollValues, 0);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      document.getElementById('root').setAttribute('aria-hidden', 'false');
	      document.getElementById('content-right').style.overflow = 'auto';
	    }
	  }, {
	    key: '_modalScrollValues',
	    value: function _modalScrollValues() {
	      var rootWidth = document.getElementById('root').offsetWidth;
	      var maxDocWidth = document.getElementsByClassName('vst-modalOverlay')[0].clientWidth * 0.9 - 60;
	      var modalInnerWidth = Math.min(maxDocWidth, document.getElementById('modal-document-inner').offsetWidth);
	      var maxDocHeight = document.getElementsByClassName('vst-modalOverlay')[0].clientHeight * 0.9 - 60;
	      var modalInnerHeight = Math.min(maxDocHeight, document.getElementById('modal-document-inner').offsetHeight);
	      if (rootWidth >= 500) {
	        this.setState({ modalWidth: modalInnerWidth, modalHeight: modalInnerHeight });
	      } else {
	        this.setState({ modalWidth: modalInnerWidth, modalHeight: modalInnerHeight });
	      }
	    }
	  }, {
	    key: '_showModal',
	    value: function _showModal() {
	      // attach a listener to redirect the tab to the modal window if the user somehow gets out of the modal window
	      /* jQuery('body').on('focusin','#mainPage',function() {
	          this._setFocusToFirstItemInModal(jQuery('#modal'));
	      }) */
	      // save current focus
	      // focusedElementBeforeModal = jQuery(':focus');
	      // this._setFocusToFirstItemInModal(obj);
	    }
	  }, {
	    key: '_hideModal',
	    value: function _hideModal(e, obj) {
	      // remove the listener which redirects tab keys in the main content area to the modal
	      // jQuery('body').off('focusin','#mainPage');
	      // set focus back to element that had it before the modal was opened
	      // focusedElementBeforeModal.focus();
	      if (this.props.hideModal) {
	        this.props.hideModal(e, obj);
	      }
	    }
	  }, {
	    key: '_setFocusToFirstItemInModal',
	    value: function _setFocusToFirstItemInModal(obj) {
	      // get list of all children elements in given object
	      var o = obj.find('*');
	
	      // set the focus to the first keyboard focusable item
	      // TODO: fix lint error
	      /* eslint-disable no-undef */
	      o.filter(focusableElementsString).filter(':visible').first().focus();
	      /* eslint-enable no-undef */
	    }
	  }, {
	    key: '_setInitialFocusModal',
	    value: function _setInitialFocusModal(obj) {
	      // get list of all children elements in given object
	      var o = obj.find('*');
	
	      // set focus to first focusable item
	      // TODO: fix lint error
	      /* eslint-disable no-unused-vars, no-undef */
	      var focusableItems = o.filter(focusableElementsString).filter(':visible').first().focus();
	      /* eslint-enable no-unused-vars, no-undef */
	    }
	
	    /* _trapTabKey(obj, e) {
	       // if tab or shift-tab pressed
	      if (e.which == 9) {
	           // get list of all children elements in given object
	          // var o = obj.find('*');
	           // get list of focusable items
	          var focusableItems;
	          // focusableItems = o.filter(focusableElementsString).filter(':visible')
	          focusableItems = obj.querySelectorAll(focusableElementsString).filter((el)=>{
	            return el.offsetParent !== null;
	          });
	           // get currently focused item
	          var focusedItem;
	          focusedItem = jQuery(':focus');
	          //focusedItem = document.querySelector(":focus");
	           // get the number of focusable items
	          var numberOfFocusableItems;
	          numberOfFocusableItems = focusableItems.length
	           // get the index of the currently focused item
	          var focusedItemIndex;
	          focusedItemIndex = focusableItems.index(focusedItem);
	           if (e.shiftKey) {
	              //back tab
	              // if focused on first item and user preses back-tab, go to the last focusable item
	              if (focusedItemIndex == 0) {
	                  focusableItems.get(numberOfFocusableItems - 1).focus();
	                  e.preventDefault();
	              }
	           } else {
	              //forward tab
	              // if focused on the last item and user preses tab, go to the first focusable item
	              if (focusedItemIndex == numberOfFocusableItems - 1) {
	                  focusableItems.get(0).focus();
	                  e.preventDefault();
	              }
	          }
	      }
	     },
	     _trapEscapeKey(obj, e) {
	       // if escape pressed
	      if (e.which == 27) {
	           // get list of all children elements in given object
	          var o = obj.find('*');
	           // get list of focusable items
	          var cancelElement;
	          cancelElement = o.filter("#cancel")
	           // close the modal window
	          cancelElement.click();
	          e.preventDefault();
	      }
	     }, */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      // TODO: fix these lint errors
	      /* eslint-disable no-unused-vars */
	
	      // jQuery formatted selector to search for focusable items
	      var focusableElementsString = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]';
	      // store the item that has focus before opening the modal window
	      var focusedElementBeforeModal = void 0;
	
	      /* eslint-enable no-unused-vars */
	
	      return _react2.default.createElement('div', null, _react2.default.createElement('div', { id: 'modal-container', className: 'vst-modal', onKeyDown: this._trapTabKey, 'aria-labelledby': 'modalTitle', 'aria-describedby': 'modalDescription', role: 'dialog' }, _react2.default.createElement('div', { style: { width: this.state.modalWidth, height: this.state.modalHeight }, className: 'modal-document', role: 'document' }, _react2.default.createElement('div', { id: 'modal-document-inner' }, _react2.default.createElement('h1', { id: 'modal-title' }, this.props.title), this.props.children, _react2.default.createElement('button', { onClick: this._hideModal, className: 'modal-close-button' }, svgXIcon(), _react2.default.createElement('span', { className: 'offScreen' }, i18n.t('base.close')))))), _react2.default.createElement('div', { onClick: this._hideModal, 'aria-hidden': true, className: 'vst-modalOverlay', tabIndex: '-1' }));
	    }
	  }]);
	
	  return VstModal;
	}(_react.Component);
	
	VstModal.propTypes = {
	  hideModal: _propTypes2.default.func,
	  title: _propTypes2.default.string,
	  children: _propTypes2.default.node
	};
	
	exports.default = VstModal;

/***/ },
/* 939 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }return target;
	};
	
	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	  };
	}();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(63);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _propTypes = __webpack_require__(29);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _VstListItem = __webpack_require__(393);
	
	var _VstListItem2 = _interopRequireDefault(_VstListItem);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _objectWithoutProperties(obj, keys) {
	  var target = {};for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
	  }return target;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var VstPopover = function (_React$Component) {
	  _inherits(VstPopover, _React$Component);
	
	  function VstPopover(props) {
	    _classCallCheck(this, VstPopover);
	
	    var _this = _possibleConstructorReturn(this, (VstPopover.__proto__ || Object.getPrototypeOf(VstPopover)).call(this, props));
	
	    _this.createPortal = _this.createPortal.bind(_this);
	    _this.onDocumentMouseUp = _this.onDocumentMouseUp.bind(_this);
	    return _this;
	  }
	
	  _createClass(VstPopover, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.createPortal();
	      this.doRender(this.props);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.doRender(nextProps);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.portal) {
	        _reactDom2.default.unmountComponentAtNode(this.portal);
	        document.body.removeChild(this.portal);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }, {
	    key: 'createPortal',
	    value: function createPortal() {
	      this.portal = document.createElement('div');
	      this.portal.setAttribute('class', 'vst-popover');
	      document.body.appendChild(this.portal);
	    }
	  }, {
	    key: 'doRender',
	    value: function doRender(props) {
	      _reactDom2.default.render(this.renderComponent(props), this.portal);
	    }
	  }, {
	    key: 'onDocumentMouseUp',
	    value: function onDocumentMouseUp(e) {
	      var portal = (0, _reactDom.findDOMNode)(this.portal);
	      if (portal && portal.contains(e.target) || e.button && e.button !== 0) return;
	      e.stopPropagation();
	    }
	  }, {
	    key: 'renderComponent',
	    value: function renderComponent(props) {
	      var className = props.className,
	          style = props.style,
	          children = props.children,
	          onBackdropClick = props.onBackdropClick,
	          showOverlay = props.showOverlay,
	          restProps = _objectWithoutProperties(props, ['className', 'style', 'children', 'onBackdropClick', 'showOverlay']);
	
	      return _react2.default.createElement('div', null, showOverlay && _react2.default.createElement('div', { className: 'vst-popover-overlay', onClick: onBackdropClick }), _react2.default.createElement('div', _extends({
	        style: _extends({ position: 'fixed' }, style),
	        className: 'vst-list ' + className
	      }, restProps), children));
	    }
	  }]);
	
	  return VstPopover;
	}(_react2.default.Component);
	
	VstPopover.propTypes = {
	  children: _propTypes2.default.node,
	  className: _propTypes2.default.string,
	  open: _propTypes2.default.bool,
	  onBackdropClick: _propTypes2.default.func,
	  showOverlay: _propTypes2.default.bool,
	  style: _propTypes2.default.shape({
	    top: _propTypes2.default.number,
	    left: _propTypes2.default.number
	  })
	};
	
	VstPopover.defaultProps = {
	  className: '',
	  open: false,
	  showOverlay: false,
	  style: {}
	};
	
	VstPopover.Item = _VstListItem2.default;
	
	exports.default = VstPopover;

/***/ },
/* 940 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }return target;
	};
	
	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	  };
	}();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(25);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _copyProps = __webpack_require__(42);
	
	var _copyProps2 = _interopRequireDefault(_copyProps);
	
	var _addClassName = __webpack_require__(64);
	
	var _addClassName2 = _interopRequireDefault(_addClassName);
	
	var _VstButton = __webpack_require__(181);
	
	var _VstButton2 = _interopRequireDefault(_VstButton);
	
	var _VstComponent2 = __webpack_require__(13);
	
	var _VstComponent3 = _interopRequireDefault(_VstComponent2);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var VstProgressButton = function (_VstComponent) {
	  _inherits(VstProgressButton, _VstComponent);
	
	  function VstProgressButton() {
	    _classCallCheck(this, VstProgressButton);
	
	    var _this = _possibleConstructorReturn(this, (VstProgressButton.__proto__ || Object.getPrototypeOf(VstProgressButton)).call(this));
	
	    _this._incrementProgress = _this._incrementProgress.bind(_this);
	    _this._clearTimeouts = _this._clearTimeouts.bind(_this);
	    _this._reset = _this._reset.bind(_this);
	    _this._onClick = _this._onClick.bind(_this);
	    _this.state = { progress: 0 };
	    return _this;
	  }
	
	  _createClass(VstProgressButton, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this._clearTimeouts();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      var f = function f(p) {
	        _this2._clearTimeouts();
	        _this2.setState({ progress: p });
	        setTimeout(_this2._reset, 1300);
	      };
	
	      if (nextProps.success) {
	        f(100);
	      } else if (nextProps.success === false) {
	        f(100);
	      }
	    }
	  }, {
	    key: '_clearTimeouts',
	    value: function _clearTimeouts() {
	      clearTimeout(this._incrementTimeout);
	    }
	  }, {
	    key: '_incrementProgress',
	    value: function _incrementProgress(el) {
	      var _this3 = this;
	
	      this._incrementTimeout = setTimeout(function () {
	        var newProgress = _this3.state.progress + Math.floor(Math.random() * 10);
	        newProgress = Math.min(newProgress, 99);
	        _this3.setState({ progress: newProgress });
	        _this3._incrementProgress(el);
	      }, 100);
	    }
	  }, {
	    key: '_reset',
	    value: function _reset() {
	      this.setState({ progress: 0 });
	      if (this.props.onReset) {
	        this.props.onReset();
	      }
	    }
	  }, {
	    key: '_onClick',
	    value: function _onClick(e) {
	      if (this.state.progress === 0) {
	        this._incrementProgress(this.refs.progress);
	      }
	      if (this.props.onClick) {
	        this.props.onClick(e);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var props = (0, _addClassName2.default)(this.props, 'vst-progress-button');
	
	      var buttonText = void 0;
	      if (this.props.success) {
	        buttonText = this.props.successText || 'Done';
	      } else if (this.props.success === false) {
	        buttonText = this.props.failureText || 'Failed';
	      } else if (this.state.progress > 0) {
	        buttonText = this.props.progressText || 'Saving...';
	      } else {
	        buttonText = this.props.children;
	      }
	
	      var isSuccess = this.props.success && this.state.progress >= 100;
	      var isFailure = this.props.success === false;
	
	      return _react2.default.createElement(_VstButton2.default, _extends({}, (0, _copyProps2.default)(props, ['success', 'progressText', 'failureText', 'successText']), { onClick: this._onClick }), _react2.default.createElement('span', { className: (0, _classnames2.default)('wrapper', { success: isSuccess, failure: isFailure }) }, _react2.default.createElement('span', { className: 'content', ref: 'text' }, buttonText), _react2.default.createElement('span', { className: (0, _classnames2.default)('progress', { 'no-transition': this.state.progress === 0 || this.state.progress === 100 }),
	        style: { width: this.state.progress + '%', backgroundColor: this._theme(9) },
	        ref: 'progress'
	      })));
	    }
	  }]);
	
	  return VstProgressButton;
	}(_VstComponent3.default);
	
	exports.default = VstProgressButton;

/***/ },
/* 941 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	  };
	}();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _VstComponent2 = __webpack_require__(13);
	
	var _VstComponent3 = _interopRequireDefault(_VstComponent2);
	
	var _addClassName = __webpack_require__(64);
	
	var _addClassName2 = _interopRequireDefault(_addClassName);
	
	var _copyProps = __webpack_require__(42);
	
	var _copyProps2 = _interopRequireDefault(_copyProps);
	
	var _classnames = __webpack_require__(25);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _namespaceOptions = __webpack_require__(76);
	
	var _namespaceOptions2 = _interopRequireDefault(_namespaceOptions);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var VstSelect = function (_VstComponent) {
	  _inherits(VstSelect, _VstComponent);
	
	  function VstSelect() {
	    _classCallCheck(this, VstSelect);
	
	    return _possibleConstructorReturn(this, (VstSelect.__proto__ || Object.getPrototypeOf(VstSelect)).apply(this, arguments));
	  }
	
	  _createClass(VstSelect, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var props = (0, _addClassName2.default)(this.props, (0, _classnames2.default)((0, _namespaceOptions2.default)('vst', this.props.options), 'vst-select'));
	      props = (0, _copyProps2.default)(props, ['options', 'data', 'label', 'items']);
	
	      return _react2.default.createElement('div', { className: (0, _classnames2.default)('vst-form-group', (0, _namespaceOptions2.default)('vst-form-group', this.props.options)) }, _react2.default.createElement('label', { className: 'vst-label vst-label-select', htmlFor: this.props.id }, this.props.label), _react2.default.createElement('select', props, this.props.items.map(function (option) {
	        return _react2.default.createElement('option', { key: 'option-' + _this2.props.id + '-' + option.value, value: option.value }, option.label);
	      }), _react2.default.createElement('optgroup', { label: '' })));
	    }
	  }]);
	
	  return VstSelect;
	}(_VstComponent3.default);
	
	module.exports = VstSelect;

/***/ },
/* 942 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }return target;
	};
	
	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	  };
	}();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(63);
	
	var _propTypes = __webpack_require__(29);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var VstSubmenuItem = function (_React$Component) {
	  _inherits(VstSubmenuItem, _React$Component);
	
	  function VstSubmenuItem(props) {
	    _classCallCheck(this, VstSubmenuItem);
	
	    var _this = _possibleConstructorReturn(this, (VstSubmenuItem.__proto__ || Object.getPrototypeOf(VstSubmenuItem)).call(this, props));
	
	    _this.state = {
	      style: {},
	      visible: _this.props.visible
	    };
	
	    _this.calculatePosition = _this.calculatePosition.bind(_this);
	    _this.onBackButtonClick = _this.onBackButtonClick.bind(_this);
	    _this.focusAtFirstChild = _this.focusAtFirstChild.bind(_this);
	    _this.onElementClick = _this.onElementClick.bind(_this);
	    return _this;
	  }
	
	  _createClass(VstSubmenuItem, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.calculatePosition();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.calculatePosition();
	      if (nextProps.isMobile) {
	        if (!nextProps.visible) {
	          this.setState({ style: { display: 'none' } });
	        } else {
	          this.setState({ style: { display: 'flex' } });
	        }
	      }
	      this.setState({ visible: nextProps.visible });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          style = _props.style,
	          isList = _props.isList,
	          children = _props.children;
	
	      return _react2.default.createElement('div', { className: 'vst-list submenu', style: _extends({}, style, this.state.style) }, this.renderMobileHeader(), isList ? this.renderList() : children);
	    }
	  }, {
	    key: 'onElementClick',
	    value: function onElementClick(e, onClick) {
	      if (onClick) {
	        onClick(e);
	      }
	      this.props.closeMenu();
	    }
	  }, {
	    key: 'renderList',
	    value: function renderList() {
	      var _this2 = this;
	
	      return _react2.default.createElement('ul', { ref: function ref(submenu) {
	          _this2.submenu = submenu;
	        } }, _react.Children.map(this.props.children, function (child) {
	        if (!child.props.hidden) {
	          return (0, _react.cloneElement)(child, { onClick: function onClick(e) {
	              return _this2.onElementClick(e, child.props.onClick);
	            } });
	        }
	        return child;
	      }), _react2.default.createElement('li', null, _react2.default.createElement('div', {
	        role: 'button',
	        tabIndex: 0,
	        onFocus: this.focusAtFirstChild
	      })));
	    }
	  }, {
	    key: 'focusAtFirstChild',
	    value: function focusAtFirstChild() {
	      if (this.submenu.firstChild.firstChild.focus) {
	        this.submenu.firstChild.firstChild.focus();
	      } else {
	        this.submenu.firstChild.focus();
	      }
	    }
	  }, {
	    key: 'onBackButtonClick',
	    value: function onBackButtonClick(e) {
	      if (this.props.onBackButtonClick) {
	        this.props.onBackButtonClick();
	      }
	      e.stopPropagation();
	    }
	  }, {
	    key: 'renderMobileHeader',
	    value: function renderMobileHeader() {
	      if (this.props.isMobile) {
	        return _react2.default.createElement('header', { className: this.props.headerClassName }, _react2.default.createElement('div', { className: 'back-title' }, _react2.default.createElement('button', { className: 'noButton', onClick: this.onBackButtonClick }, this.props.headerBackButton), _react2.default.createElement('h2', { tabIndex: 0 }, this.props.headerTitle)), _react2.default.createElement('button', {
	          className: 'noButton',
	          onClick: this.onApplyClick
	        }, this.props.headerApplyButton));
	      }
	      return null;
	    }
	  }, {
	    key: 'getWinSize',
	    value: function getWinSize() {
	      var body = document.body;
	      var elem = document.documentElement;
	      return {
	        innerWidth: window.innerWidth || Math.max(elem.clientWidth, body.clientWidth),
	        innerHeight: window.innerHeight || Math.max(elem.clientHeight, body.clientHeight),
	        scrollY: window.scrollY || elem.scrollTop || body.scrollTop || 0,
	        scrollX: window.scrollX || elem.scrollLeft || body.scrollLeft || 0
	      };
	    }
	  }, {
	    key: 'calculatePosition',
	    value: function calculatePosition() {
	      if (this.props.isMobile) {
	        return;
	      }
	      var submenuNode = (0, _reactDom.findDOMNode)(this);
	      var targetNode = (0, _reactDom.findDOMNode)(submenuNode.parentNode);
	      var menuNode = (0, _reactDom.findDOMNode)(targetNode.parentNode);
	      var menu = menuNode.getBoundingClientRect();
	      var target = targetNode.getBoundingClientRect();
	      var submenu = submenuNode.getBoundingClientRect();
	      var windowHeight = window.innerHeight;
	      var windowWidth = window.innerWidth;
	
	      var style = {};
	      // Overflows bottom
	      var offset = target.top - menu.top;
	      if (target.top - offset + submenu.height > windowHeight) {
	        style.bottom = target.top - windowHeight + 50;
	      } else {
	        style.top = offset;
	      }
	
	      // Overflows right
	      var overflowsRight = menu.left + menu.width + submenu.width > windowWidth;
	      var overflowsLeft = menu.left < submenu.width;
	
	      if (overflowsRight && overflowsLeft) {
	        style.right = 'unset';
	        style.left = windowWidth - menu.width - menu.left - 5;
	      } else if (overflowsRight) {
	        style.left = 'unset';
	        style.right = menu.width;
	      } else if (overflowsLeft) {
	        style.right = 'unset';
	        style.left = menu.width;
	      }
	
	      this.setState({ style: style });
	    }
	  }]);
	
	  return VstSubmenuItem;
	}(_react2.default.Component);
	
	VstSubmenuItem.propTypes = {
	  children: _propTypes2.default.node.isRequired,
	  closeMenu: _propTypes2.default.func,
	  onClick: _propTypes2.default.func,
	  tabIndex: _propTypes2.default.number,
	  style: _propTypes2.default.object,
	  onBackButtonClick: _propTypes2.default.func,
	  headerBackButton: _propTypes2.default.node,
	  headerTitle: _propTypes2.default.node,
	  headerClassName: _propTypes2.default.node,
	  headerApplyButton: _propTypes2.default.node,
	  isMobile: _propTypes2.default.bool,
	  visible: _propTypes2.default.bool,
	  isList: _propTypes2.default.bool
	};
	
	VstSubmenuItem.defaultProps = {
	  headerTitle: 'Submenu Title',
	  headerBackButton: 'Back',
	  style: {},
	  isList: true
	};
	
	exports.default = VstSubmenuItem;

/***/ },
/* 943 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }return target;
	};
	
	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	  };
	}();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(25);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _copyProps = __webpack_require__(42);
	
	var _copyProps2 = _interopRequireDefault(_copyProps);
	
	var _VstComponent2 = __webpack_require__(13);
	
	var _VstComponent3 = _interopRequireDefault(_VstComponent2);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var VstTab = function (_VstComponent) {
	  _inherits(VstTab, _VstComponent);
	
	  function VstTab() {
	    _classCallCheck(this, VstTab);
	
	    var _this = _possibleConstructorReturn(this, (VstTab.__proto__ || Object.getPrototypeOf(VstTab)).call(this));
	
	    _this.tabTo = _this.tabTo.bind(_this);
	    _this.onKeyDown = _this.onKeyDown.bind(_this);
	    return _this;
	  }
	
	  _createClass(VstTab, [{
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (!prevProps.active && this.props.active) {
	        this.tab.focus();
	      }
	    }
	
	    // I added this so routing in mulligan didn't have to change much, but ideally tabs wouldn't change the url
	
	  }, {
	    key: 'tabTo',
	    value: function tabTo() {
	      var _props = this.props,
	          href = _props.href,
	          onClick = _props.onClick;
	
	      if (href) {
	        window.location.assign(href);
	      }
	      onClick();
	    }
	  }, {
	    key: 'onKeyDown',
	    value: function onKeyDown(e) {
	      if (e.keyCode === 37 || e.keyCode === 38) {
	        this.props.onPreviousTab();
	      } else if (e.keyCode === 39 || e.keyCode === 40) {
	        this.props.onNextTab();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement('li', _extends({ role: 'presentation' }, (0, _copyProps2.default)(this.props, ['active', 'onClick', 'href', 'onPreviousTab', 'onNextTab']), { className: (0, _classnames2.default)('vst-tab', { active: this.props.active }) }), _react2.default.createElement('a', {
	        'aria-selected': this.props.active,
	        onClick: this.tabTo, className: 'vst-link',
	        ref: function ref(tab) {
	          _this2.tab = tab;
	        },
	        role: 'tab',
	        tabIndex: this.props.active ? 0 : -1,
	        onKeyDown: this.onKeyDown
	      }, this.props.children));
	    }
	  }]);
	
	  return VstTab;
	}(_VstComponent3.default);
	
	exports.default = VstTab;

/***/ },
/* 944 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	  };
	}();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _VstComponent2 = __webpack_require__(13);
	
	var _VstComponent3 = _interopRequireDefault(_VstComponent2);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var VstTabBar = function (_VstComponent) {
	  _inherits(VstTabBar, _VstComponent);
	
	  function VstTabBar() {
	    _classCallCheck(this, VstTabBar);
	
	    return _possibleConstructorReturn(this, (VstTabBar.__proto__ || Object.getPrototypeOf(VstTabBar)).apply(this, arguments));
	  }
	
	  _createClass(VstTabBar, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var maxIndex = this.props.children && this.props.children.length - 1;
	      var children = _react2.default.Children.map(this.props.children, function (child, index) {
	        return _react2.default.cloneElement(child, {
	          active: index === _this2.props.activeIndex,
	          onClick: function onClick() {
	            return _this2.props.onClick(index);
	          },
	          onPreviousTab: index > 0 ? function () {
	            return _this2.props.onClick(index - 1);
	          } : function () {},
	          onNextTab: index < maxIndex ? function () {
	            return _this2.props.onClick(index + 1);
	          } : function () {}
	        });
	      });
	      var defaultClass = 'vst-tab-bar';
	      var className = this.props.className ? defaultClass + ' ' + this.props.className : defaultClass;
	      return _react2.default.createElement('ul', { className: className, role: 'tablist' }, children);
	    }
	  }]);
	
	  return VstTabBar;
	}(_VstComponent3.default);
	
	exports.default = VstTabBar;
	
	VstTabBar.defaultProps = {
	  onClick: function onClick() {}
	};

/***/ },
/* 945 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	  };
	}();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _VstComponent2 = __webpack_require__(13);
	
	var _VstComponent3 = _interopRequireDefault(_VstComponent2);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var VstTabPanels = function (_VstComponent) {
	  _inherits(VstTabPanels, _VstComponent);
	
	  function VstTabPanels() {
	    _classCallCheck(this, VstTabPanels);
	
	    return _possibleConstructorReturn(this, (VstTabPanels.__proto__ || Object.getPrototypeOf(VstTabPanels)).apply(this, arguments));
	  }
	
	  _createClass(VstTabPanels, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          activeIndex = _props.activeIndex,
	          children = _props.children;
	
	      return _react2.default.createElement('div', { role: 'tabpanel' }, children[activeIndex]);
	    }
	  }]);
	
	  return VstTabPanels;
	}(_VstComponent3.default);
	
	exports.default = VstTabPanels;
	
	VstTabPanels.defaultProps = {
	  activeIndex: 0,
	  children: []
	};

/***/ },
/* 946 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }return target;
	};
	
	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	  };
	}();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _copyProps = __webpack_require__(42);
	
	var _copyProps2 = _interopRequireDefault(_copyProps);
	
	var _VstComponent2 = __webpack_require__(13);
	
	var _VstComponent3 = _interopRequireDefault(_VstComponent2);
	
	var _VstTableHeader = __webpack_require__(949);
	
	var _VstTableHeader2 = _interopRequireDefault(_VstTableHeader);
	
	var _VstTableBody = __webpack_require__(947);
	
	var _VstTableBody2 = _interopRequireDefault(_VstTableBody);
	
	var _VstTableRow = __webpack_require__(950);
	
	var _VstTableRow2 = _interopRequireDefault(_VstTableRow);
	
	var _VstTableCell = __webpack_require__(948);
	
	var _VstTableCell2 = _interopRequireDefault(_VstTableCell);
	
	var _glamor = __webpack_require__(94);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	/*
	  Data passed in should include props for 'headers' and 'items'
	  The keys for 'items' should match the keys for headers
	
	  By default items will be sorted on their string value passed in
	  For something different (such as dates or prices before appending currencies),
	  add an additional key prepended with '_sort_'.
	  For example, for {price="$1.00"} you'd add {_sort_price:1.00}
	
	*/
	var VstTable = function (_VstComponent) {
	  _inherits(VstTable, _VstComponent);
	
	  // TODO: Handle when original props change
	  function VstTable() {
	    _classCallCheck(this, VstTable);
	
	    var _this = _possibleConstructorReturn(this, (VstTable.__proto__ || Object.getPrototypeOf(VstTable)).call(this));
	
	    _this._toggleSortOrder = _this._toggleSortOrder.bind(_this);
	    _this.state = {
	      sortOrder: 1,
	      sortedHeaderIndex: null
	    };
	    return _this;
	  }
	
	  _createClass(VstTable, [{
	    key: '_toggleSortOrder',
	    value: function _toggleSortOrder(toggledHeaderIndex) {
	      var headerIndex = parseInt(toggledHeaderIndex, 10);
	      if (this.state.sortOrder === -1 || this.state.sortedHeaderIndex !== headerIndex) {
	        this.setState({
	          sortOrder: 1,
	          sortedHeaderIndex: headerIndex
	        });
	      } else {
	        this.setState({
	          sortOrder: -1,
	          sortedHeaderIndex: headerIndex
	        });
	      }
	    }
	  }, {
	    key: '_getCSS',
	    value: function _getCSS() {
	      return {
	        '& tbody tr:hover td': {
	          background: this._theme(1)
	        }
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var children = _react2.default.Children.map(this.props.children, function (child) {
	        if (child.type.displayName === 'VstTableHeader') {
	          return _react2.default.cloneElement(child, { onClick: _this2._toggleSortOrder });
	        } else if (child.type.displayName === 'VstTableBody') {
	          return _react2.default.cloneElement(child, {
	            sortOrder: _this2.state.sortOrder,
	            sortIndex: _this2.state.sortedHeaderIndex
	          });
	        }
	        return child;
	      });
	
	      var rule = (0, _glamor.css)(this._getCSS());
	
	      return _react2.default.createElement('div', { className: 'vst-table-wrapper', style: { height: this.props.height } }, _react2.default.createElement('div', { className: 'vst-table-inner-wrapper' }, _react2.default.createElement('table', _extends({ className: 'vst-table ' + rule }, (0, _copyProps2.default)(this.props, ['items'])), children)));
	    }
	  }]);
	
	  return VstTable;
	}(_VstComponent3.default);
	
	VstTable.Header = _VstTableHeader2.default;
	VstTable.Header.displayName = 'VstTableHeader';
	VstTable.Body = _VstTableBody2.default;
	VstTable.Body.displayName = 'VstTableBody';
	VstTable.Row = _VstTableRow2.default;
	VstTable.Cell = _VstTableCell2.default;
	
	exports.default = VstTable;

/***/ },
/* 947 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	  };
	}();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _VstComponent2 = __webpack_require__(13);
	
	var _VstComponent3 = _interopRequireDefault(_VstComponent2);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var VstTableBody = function (_VstComponent) {
	  _inherits(VstTableBody, _VstComponent);
	
	  function VstTableBody() {
	    _classCallCheck(this, VstTableBody);
	
	    var _this = _possibleConstructorReturn(this, (VstTableBody.__proto__ || Object.getPrototypeOf(VstTableBody)).call(this));
	
	    _this._sort = _this._sort.bind(_this);
	    _this._getString = _this._getString.bind(_this);
	    return _this;
	  }
	
	  _createClass(VstTableBody, [{
	    key: '_sort',
	    value: function _sort(a, b) {
	      var _props = this.props,
	          sortIndex = _props.sortIndex,
	          sortOrder = _props.sortOrder;
	
	      if (sortIndex === null) {
	        return;
	      }
	
	      // I don't love this
	      // Checks the row's sorted cell for a sort prop and defaults to the cell's child
	      var aProps = a.props.children[sortIndex].props;
	      var aSortValue = typeof aProps.sort !== 'undefined' ? aProps.sort : this._getString(aProps.children).toLowerCase();
	
	      var bProps = b.props.children[sortIndex].props;
	      var bSortValue = typeof bProps.sort !== 'undefined' ? bProps.sort : this._getString(bProps.children).toLowerCase();
	      /* eslint consistent-return: "off" */
	      if (aSortValue > bSortValue) return sortOrder;
	      if (aSortValue < bSortValue) return sortOrder * -1;
	      return 0;
	    }
	  }, {
	    key: '_getString',
	    value: function _getString(children) {
	      var _this2 = this;
	
	      var result = '';
	      if (children.props && children.props.children) {
	        if (children.props.children.forEach) {
	          children.props.children.forEach(function (child) {
	            result += _this2._getString(child);
	          });
	        } else {
	          result += children.props.children;
	        }
	        return result;
	      } else if (children.forEach) {
	        children.forEach(function (child) {
	          result += _this2._getString(child);
	        });
	        return result;
	      }
	
	      return children;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var children = _react2.default.Children.toArray(this.props.children);
	      children = children.sort(this._sort);
	
	      return _react2.default.createElement('tbody', null, children);
	    }
	  }]);
	
	  return VstTableBody;
	}(_VstComponent3.default);
	
	exports.default = VstTableBody;

/***/ },
/* 948 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	  };
	}();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _VstComponent2 = __webpack_require__(13);
	
	var _VstComponent3 = _interopRequireDefault(_VstComponent2);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var VstTableCell = function (_VstComponent) {
	  _inherits(VstTableCell, _VstComponent);
	
	  function VstTableCell() {
	    _classCallCheck(this, VstTableCell);
	
	    return _possibleConstructorReturn(this, (VstTableCell.__proto__ || Object.getPrototypeOf(VstTableCell)).apply(this, arguments));
	  }
	
	  _createClass(VstTableCell, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement('td', null, this.props.children);
	    }
	  }]);
	
	  return VstTableCell;
	}(_VstComponent3.default);
	
	exports.default = VstTableCell;

/***/ },
/* 949 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	  };
	}();
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }return target;
	};
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _VstComponent2 = __webpack_require__(13);
	
	var _VstComponent3 = _interopRequireDefault(_VstComponent2);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var svgSortIcon = function svgSortIcon(props) {
	  return _react2.default.createElement('svg', _extends({
	    width: '6',
	    height: '10',
	    viewBox: '0 0 6 10',
	    xmlns: 'http://www.w3.org/2000/svg'
	  }, props), _react2.default.createElement('title', null, 'Sort Icon'), _react2.default.createElement('g', {
	    fill: '#DADADA',
	    fillRule: 'evenodd'
	  }, _react2.default.createElement('path', {
	    d: 'M6 6l-3 4-3-4zM0 4l3-4 3 4z'
	  })));
	};
	
	var VstTableHeader = function (_VstComponent) {
	  _inherits(VstTableHeader, _VstComponent);
	
	  function VstTableHeader() {
	    _classCallCheck(this, VstTableHeader);
	
	    return _possibleConstructorReturn(this, (VstTableHeader.__proto__ || Object.getPrototypeOf(VstTableHeader)).apply(this, arguments));
	  }
	
	  _createClass(VstTableHeader, [{
	    key: '_capitalizeFirst',
	    value: function _capitalizeFirst(string) {
	      return string.charAt(0).toUpperCase() + string.slice(1);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var children = _react2.default.Children.map(this.props.children, function (child, index) {
	        if (child) {
	          return _react2.default.createElement('th', { key: 'header-cell-' + index }, _react2.default.createElement('button', { onClick: function onClick() {
	              return _this2.props.onClick(index);
	            } }, _react2.default.createElement('span', null, _this2._capitalizeFirst(child), ' ', _react2.default.createElement('span', { className: 'sortIcon', role: 'presentation' }, svgSortIcon()))));
	        }
	        return _react2.default.createElement('th', { key: 'header-cell-' + index }, _react2.default.createElement('button', null, _react2.default.createElement('span', null)));
	      });
	
	      return _react2.default.createElement('thead', null, _react2.default.createElement('tr', null, children, _react2.default.createElement('th', { className: 'vst-table-col-hidden', key: 'header-cell- ' + children.length }, _react2.default.createElement('div', null))));
	    }
	  }]);
	
	  return VstTableHeader;
	}(_VstComponent3.default);
	
	exports.default = VstTableHeader;

/***/ },
/* 950 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	  };
	}();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _VstComponent2 = __webpack_require__(13);
	
	var _VstComponent3 = _interopRequireDefault(_VstComponent2);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var VstTableRow = function (_VstComponent) {
	  _inherits(VstTableRow, _VstComponent);
	
	  function VstTableRow() {
	    _classCallCheck(this, VstTableRow);
	
	    return _possibleConstructorReturn(this, (VstTableRow.__proto__ || Object.getPrototypeOf(VstTableRow)).apply(this, arguments));
	  }
	
	  _createClass(VstTableRow, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement('tr', {
	        style: { cursor: this.props.onClick ? 'pointer' : '' },
	        onClick: this.props.onClick,
	        tabIndex: 0
	      }, this.props.children, _react2.default.createElement('td', {
	        className: 'vst-table-col-hidden'
	      }, this.props.onClick && _react2.default.createElement('button', { tabIndex: '-1', onClick: this.props.onClick }, 'Select')));
	    }
	  }]);
	
	  return VstTableRow;
	}(_VstComponent3.default);
	
	exports.default = VstTableRow;

/***/ },
/* 951 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	  };
	}();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _VstComponent2 = __webpack_require__(13);
	
	var _VstComponent3 = _interopRequireDefault(_VstComponent2);
	
	var _VstTabBar = __webpack_require__(944);
	
	var _VstTabBar2 = _interopRequireDefault(_VstTabBar);
	
	var _VstTabPanels = __webpack_require__(945);
	
	var _VstTabPanels2 = _interopRequireDefault(_VstTabPanels);
	
	var _VstTab = __webpack_require__(943);
	
	var _VstTab2 = _interopRequireDefault(_VstTab);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var VstTabs = function (_VstComponent) {
	  _inherits(VstTabs, _VstComponent);
	
	  function VstTabs(props) {
	    _classCallCheck(this, VstTabs);
	
	    var _this = _possibleConstructorReturn(this, (VstTabs.__proto__ || Object.getPrototypeOf(VstTabs)).call(this, props));
	
	    _this.state = {
	      activeIndex: props.activeIndex
	    };
	    return _this;
	  }
	
	  _createClass(VstTabs, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var activeIndex = this.state.activeIndex;
	
	      var children = _react2.default.Children.map(this.props.children, function (child) {
	        if (child.type.displayName === "VstTabPanels") {
	          return _react2.default.cloneElement(child, { activeIndex: activeIndex });
	        } else if (child.type.displayName === "VstTabBar") {
	          return _react2.default.cloneElement(child, {
	            activeIndex: activeIndex,
	            onClick: function onClick(activeIndex) {
	              _this2.setState({ activeIndex: activeIndex });
	            }
	          });
	        } else {
	          return child;
	        }
	      });
	
	      return _react2.default.createElement('div', null, children);
	    }
	  }]);
	
	  return VstTabs;
	}(_VstComponent3.default);
	
	exports.default = VstTabs;
	
	VstTabs.defaultProps = {
	  activeIndex: 0
	};
	
	VstTabs.Bar = _VstTabBar2.default;
	VstTabs.Bar.displayName = "VstTabBar";
	VstTabs.Panels = _VstTabPanels2.default;
	VstTabs.Panels.displayName = "VstTabPanels";
	VstTabs.Tab = _VstTab2.default;

/***/ },
/* 952 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }return target;
	};
	
	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	  };
	}();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(63);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _VstToast = __webpack_require__(395);
	
	var _VstToast2 = _interopRequireDefault(_VstToast);
	
	var _customEvent = __webpack_require__(233);
	
	var _customEvent2 = _interopRequireDefault(_customEvent);
	
	var _reactAddonsTransitionGroup = __webpack_require__(822);
	
	var _reactAddonsTransitionGroup2 = _interopRequireDefault(_reactAddonsTransitionGroup);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var toastMethods = function toastMethods() {
	  var _toasts = [];
	
	  var defaultOptions = function defaultOptions() {
	    return {
	      id: 'vst-toast-' + Math.random(),
	      timeout: 5000,
	      type: 'info',
	      horizontalPosition: 'center',
	      verticalPosition: 'top'
	    };
	  };
	
	  var renderToasts = function renderToasts() {
	    var event = new _customEvent2.default('_vstui_add_toast', {});
	    document.dispatchEvent(event);
	  };
	
	  var VstToastDom = function (_Component) {
	    _inherits(VstToastDom, _Component);
	
	    function VstToastDom() {
	      _classCallCheck(this, VstToastDom);
	
	      var _this = _possibleConstructorReturn(this, (VstToastDom.__proto__ || Object.getPrototypeOf(VstToastDom)).call(this));
	
	      _this.state = {};
	
	      _this.addToast = _this.addToast.bind(_this);
	      return _this;
	    }
	
	    _createClass(VstToastDom, [{
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        document.addEventListener('_vstui_add_toast', this.addToast);
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        // We need first toast options to understand where to position our toasts
	        var firstToastOptions = _toasts.length > 0 ? _toasts[0] : {};
	        return _react2.default.createElement('span', { className: 'vst-toast-dom' }, _react2.default.createElement('div', null, this.renderToastGroup('left', 'top'), this.renderToastGroup('center', 'top'), this.renderToastGroup('right', 'top')), _react2.default.createElement('div', null, this.renderToastGroup('left', 'bottom'), this.renderToastGroup('center', 'bottom'), this.renderToastGroup('right', 'bottom')));
	      }
	    }, {
	      key: 'addToast',
	      value: function addToast() {
	        this.forceUpdate();
	      }
	    }, {
	      key: 'filterToasts',
	      value: function filterToasts(horizontal, vertical) {
	        return _toasts.filter(function (toast) {
	          return toast.horizontalPosition === horizontal && toast.verticalPosition === vertical;
	        });
	      }
	    }, {
	      key: 'renderToastGroup',
	      value: function renderToastGroup(horizontal, vertical) {
	        return _react2.default.createElement('div', null, _react2.default.createElement(_reactAddonsTransitionGroup2.default, null, this.filterToasts(horizontal, vertical).map(function (toast) {
	          return _react2.default.createElement(_VstToast2.default, _extends({
	            key: 'vst-toast-portal-item-' + toast.id
	          }, toast));
	        })));
	      }
	    }]);
	
	    return VstToastDom;
	  }(_react.Component);
	
	  try {
	    document.addEventListener('DOMContentLoaded', function () {
	      try {
	        var node = document.createElement('div');
	        node.class = 'vst-toast-container-portal';
	        document.body.appendChild(node);
	
	        _reactDom2.default.render(_react2.default.createElement(VstToastDom, null), node);
	      } catch (e) {
	        // Toats won't work, but any app still will in < ie9
	      }
	    });
	  } catch (e) {
	    // document is not defined
	  }
	
	  var dismiss = function dismiss(id) {
	    _toasts = _toasts.filter(function (toast) {
	      return toast.id !== id;
	    });
	    renderToasts();
	  };
	
	  var dismissAll = function dismissAll() {
	    _toasts = [];
	    renderToasts();
	  };
	
	  var notify = function notify(description) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    var opts = void 0;
	    if (typeof description === 'string') {
	      opts = Object.assign({}, defaultOptions(), { description: description }, options);
	    } else {
	      opts = Object.assign({}, defaultOptions(), description);
	      opts.originalOnDismiss = opts.onDismiss;
	    }
	    opts.onDismiss = function () {
	      if (opts.originalOnDismiss) {
	        opts.originalOnDismiss();
	      }
	      dismiss(opts.id);
	    };
	    _toasts.push(_extends({}, opts));
	    renderToasts();
	  };
	
	  return {
	    notify: notify, dismiss: dismiss, dismissAll: dismissAll
	  };
	};
	
	exports.default = toastMethods();

/***/ },
/* 953 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }return target;
	};
	
	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	  };
	}();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _VstComponent2 = __webpack_require__(13);
	
	var _VstComponent3 = _interopRequireDefault(_VstComponent2);
	
	var _propTypes = __webpack_require__(29);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _glamor = __webpack_require__(94);
	
	var _addClassName = __webpack_require__(64);
	
	var _addClassName2 = _interopRequireDefault(_addClassName);
	
	var _classnames = __webpack_require__(25);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _copyProps = __webpack_require__(42);
	
	var _copyProps2 = _interopRequireDefault(_copyProps);
	
	var _namespaceOptions = __webpack_require__(76);
	
	var _namespaceOptions2 = _interopRequireDefault(_namespaceOptions);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var VstToggleButton = function (_VstComponent) {
	  _inherits(VstToggleButton, _VstComponent);
	
	  function VstToggleButton(props) {
	    _classCallCheck(this, VstToggleButton);
	
	    var _this = _possibleConstructorReturn(this, (VstToggleButton.__proto__ || Object.getPrototypeOf(VstToggleButton)).call(this, props));
	
	    _this._toggleButton = _this._toggleButton.bind(_this);
	    return _this;
	  }
	
	  _createClass(VstToggleButton, [{
	    key: '_toggleButton',
	    value: function _toggleButton(e) {
	      if (this.props.disabled) {
	        e.preventDefault();
	        return;
	      }
	      this.props.onToggle(e);
	    }
	  }, {
	    key: '_getCSS',
	    value: function _getCSS() {
	      return {
	        '&.on': {
	          backgroundColor: this._theme(7)
	        }
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          disabled = _props.disabled,
	          on = _props.on,
	          onText = _props.onText,
	          offText = _props.offText;
	
	      var classes = 'boolean-toggle no-highlight noButton';
	      var rule = (0, _glamor.css)(this._getCSS());
	
	      var props = (0, _addClassName2.default)(this.props, (0, _classnames2.default)((0, _namespaceOptions2.default)('vst', this.props.options), classes, { disabled: disabled }, { on: on }, rule.toString()));
	      props = (0, _copyProps2.default)(props, ['options', 'on', 'onToggle', 'offText', 'onText']);
	      return _react2.default.createElement('button', _extends({
	        'aria-pressed': on,
	        onClick: this._toggleButton
	      }, props), _react2.default.createElement('div', { className: 'toggle-dot' }), _react2.default.createElement('span', { className: 'toggle-text' }, _react2.default.createElement('span', { 'aria-hidden': !on }, onText), _react2.default.createElement('span', { 'aria-hidden': on }, offText)));
	    }
	  }]);
	
	  return VstToggleButton;
	}(_VstComponent3.default);
	
	exports.default = VstToggleButton;
	
	VstToggleButton.propTypes = {
	  on: _propTypes2.default.bool,
	  disabled: _propTypes2.default.bool,
	  onToggle: _propTypes2.default.func,
	  offText: _propTypes2.default.string,
	  onText: _propTypes2.default.string,
	  'aria-describedby': _propTypes2.default.string,
	  'aria-label': _propTypes2.default.string,
	  style: _propTypes2.default.object
	};
	
	VstToggleButton.defaultProps = {
	  on: false,
	  onToggle: function onToggle() {},
	  disabled: false,
	  offText: '',
	  onText: '',
	  'aria-describedby': '',
	  'aria-label': '',
	  style: {}
	};

/***/ },
/* 954 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = function warning() {};
	
	if (false) {
	  warning = function warning(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.length < 10 || /^[s\W]*$/.test(format)) {
	      throw new Error('The warning format should be able to uniquely identify this ' + 'warning. Please, use a more descriptive format than: ' + format);
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' + format.replace(/%s/g, function () {
	        return args[argIndex++];
	      });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch (x) {}
	    }
	  };
	}
	
	module.exports = warning;

/***/ },
/* 955 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var luminance = __webpack_require__(909);
	var hexRgb = __webpack_require__(790);
	
	// http://www.w3.org/TR/WCAG20/#contrast-ratiodef
	
	module.exports.luminance = fromLum;
	module.exports.rgb = fromRGB;
	module.exports.hex = fromHex;
	module.exports.score = score;
	
	/*
	 * @param {number} a luminance value
	 * @param {number} b luminance value
	 * @returns {number} contrast ratio
	 */
	function fromLum(a, b) {
	    var l1 = Math.max(a, b),
	        l2 = Math.min(a, b);
	    return (l1 + 0.05) / (l2 + 0.05);
	}
	
	/*
	 * @param {array} a rgb value
	 * @param {array} b rgb value
	 * @returns {number} contrast ratio
	 */
	function fromRGB(a, b) {
	    return fromLum(luminance(a), luminance(b));
	}
	
	/*
	 * @param {string} a hex value
	 * @param {string} b hex value
	 * @returns {number} contrast ratio
	 */
	function fromHex(a, b) {
	    return fromRGB(hexRgb(a), hexRgb(b));
	}
	
	/*
	 * @param {array} a rgb value
	 * @param {array} b rgb value
	 * @returns {number} contrast ratio
	 */
	function score(contrast) {
	    return contrast >= 7 ? 'AAA' : contrast >= 4.5 ? 'AA' : '';
	}

/***/ },
/* 956 */
/***/ function(module, exports) {

	'use strict';
	
	(function (self) {
	  'use strict';
	
	  if (self.fetch) {
	    return;
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && function () {
	      try {
	        new Blob();
	        return true;
	      } catch (e) {
	        return false;
	      }
	    }(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  };
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name);
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name');
	    }
	    return name.toLowerCase();
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value);
	    }
	    return value;
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function next() {
	        var value = items.shift();
	        return { done: value === undefined, value: value };
	      }
	    };
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function () {
	        return iterator;
	      };
	    }
	
	    return iterator;
	  }
	
	  function Headers(headers) {
	    this.map = {};
	
	    if (headers instanceof Headers) {
	      headers.forEach(function (value, name) {
	        this.append(name, value);
	      }, this);
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function (name) {
	        this.append(name, headers[name]);
	      }, this);
	    }
	  }
	
	  Headers.prototype.append = function (name, value) {
	    name = normalizeName(name);
	    value = normalizeValue(value);
	    var list = this.map[name];
	    if (!list) {
	      list = [];
	      this.map[name] = list;
	    }
	    list.push(value);
	  };
	
	  Headers.prototype['delete'] = function (name) {
	    delete this.map[normalizeName(name)];
	  };
	
	  Headers.prototype.get = function (name) {
	    var values = this.map[normalizeName(name)];
	    return values ? values[0] : null;
	  };
	
	  Headers.prototype.getAll = function (name) {
	    return this.map[normalizeName(name)] || [];
	  };
	
	  Headers.prototype.has = function (name) {
	    return this.map.hasOwnProperty(normalizeName(name));
	  };
	
	  Headers.prototype.set = function (name, value) {
	    this.map[normalizeName(name)] = [normalizeValue(value)];
	  };
	
	  Headers.prototype.forEach = function (callback, thisArg) {
	    Object.getOwnPropertyNames(this.map).forEach(function (name) {
	      this.map[name].forEach(function (value) {
	        callback.call(thisArg, value, name, this);
	      }, this);
	    }, this);
	  };
	
	  Headers.prototype.keys = function () {
	    var items = [];
	    this.forEach(function (value, name) {
	      items.push(name);
	    });
	    return iteratorFor(items);
	  };
	
	  Headers.prototype.values = function () {
	    var items = [];
	    this.forEach(function (value) {
	      items.push(value);
	    });
	    return iteratorFor(items);
	  };
	
	  Headers.prototype.entries = function () {
	    var items = [];
	    this.forEach(function (value, name) {
	      items.push([name, value]);
	    });
	    return iteratorFor(items);
	  };
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'));
	    }
	    body.bodyUsed = true;
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function (resolve, reject) {
	      reader.onload = function () {
	        resolve(reader.result);
	      };
	      reader.onerror = function () {
	        reject(reader.error);
	      };
	    });
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader();
	    reader.readAsArrayBuffer(blob);
	    return fileReaderReady(reader);
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader();
	    reader.readAsText(blob);
	    return fileReaderReady(reader);
	  }
	
	  function Body() {
	    this.bodyUsed = false;
	
	    this._initBody = function (body) {
	      this._bodyInit = body;
	      if (typeof body === 'string') {
	        this._bodyText = body;
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body;
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body;
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString();
	      } else if (!body) {
	        this._bodyText = '';
	      } else if (support.arrayBuffer && ArrayBuffer.prototype.isPrototypeOf(body)) {
	        // Only support ArrayBuffers for POST method.
	        // Receiving ArrayBuffers happens via Blobs, instead.
	      } else {
	        throw new Error('unsupported BodyInit type');
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8');
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type);
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
	        }
	      }
	    };
	
	    if (support.blob) {
	      this.blob = function () {
	        var rejected = consumed(this);
	        if (rejected) {
	          return rejected;
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob);
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob');
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]));
	        }
	      };
	
	      this.arrayBuffer = function () {
	        return this.blob().then(readBlobAsArrayBuffer);
	      };
	
	      this.text = function () {
	        var rejected = consumed(this);
	        if (rejected) {
	          return rejected;
	        }
	
	        if (this._bodyBlob) {
	          return readBlobAsText(this._bodyBlob);
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as text');
	        } else {
	          return Promise.resolve(this._bodyText);
	        }
	      };
	    } else {
	      this.text = function () {
	        var rejected = consumed(this);
	        return rejected ? rejected : Promise.resolve(this._bodyText);
	      };
	    }
	
	    if (support.formData) {
	      this.formData = function () {
	        return this.text().then(decode);
	      };
	    }
	
	    this.json = function () {
	      return this.text().then(JSON.parse);
	    };
	
	    return this;
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT'];
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase();
	    return methods.indexOf(upcased) > -1 ? upcased : method;
	  }
	
	  function Request(input, options) {
	    options = options || {};
	    var body = options.body;
	    if (Request.prototype.isPrototypeOf(input)) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read');
	      }
	      this.url = input.url;
	      this.credentials = input.credentials;
	      if (!options.headers) {
	        this.headers = new Headers(input.headers);
	      }
	      this.method = input.method;
	      this.mode = input.mode;
	      if (!body) {
	        body = input._bodyInit;
	        input.bodyUsed = true;
	      }
	    } else {
	      this.url = input;
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit';
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers);
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET');
	    this.mode = options.mode || this.mode || null;
	    this.referrer = null;
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests');
	    }
	    this._initBody(body);
	  }
	
	  Request.prototype.clone = function () {
	    return new Request(this);
	  };
	
	  function decode(body) {
	    var form = new FormData();
	    body.trim().split('&').forEach(function (bytes) {
	      if (bytes) {
	        var split = bytes.split('=');
	        var name = split.shift().replace(/\+/g, ' ');
	        var value = split.join('=').replace(/\+/g, ' ');
	        form.append(decodeURIComponent(name), decodeURIComponent(value));
	      }
	    });
	    return form;
	  }
	
	  function headers(xhr) {
	    var head = new Headers();
	    var pairs = (xhr.getAllResponseHeaders() || '').trim().split('\n');
	    pairs.forEach(function (header) {
	      var split = header.trim().split(':');
	      var key = split.shift().trim();
	      var value = split.join(':').trim();
	      head.append(key, value);
	    });
	    return head;
	  }
	
	  Body.call(Request.prototype);
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {};
	    }
	
	    this.type = 'default';
	    this.status = options.status;
	    this.ok = this.status >= 200 && this.status < 300;
	    this.statusText = options.statusText;
	    this.headers = options.headers instanceof Headers ? options.headers : new Headers(options.headers);
	    this.url = options.url || '';
	    this._initBody(bodyInit);
	  }
	
	  Body.call(Response.prototype);
	
	  Response.prototype.clone = function () {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    });
	  };
	
	  Response.error = function () {
	    var response = new Response(null, { status: 0, statusText: '' });
	    response.type = 'error';
	    return response;
	  };
	
	  var redirectStatuses = [301, 302, 303, 307, 308];
	
	  Response.redirect = function (url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code');
	    }
	
	    return new Response(null, { status: status, headers: { location: url } });
	  };
	
	  self.Headers = Headers;
	  self.Request = Request;
	  self.Response = Response;
	
	  self.fetch = function (input, init) {
	    return new Promise(function (resolve, reject) {
	      var request;
	      if (Request.prototype.isPrototypeOf(input) && !init) {
	        request = input;
	      } else {
	        request = new Request(input, init);
	      }
	
	      var xhr = new XMLHttpRequest();
	
	      function responseURL() {
	        if ('responseURL' in xhr) {
	          return xhr.responseURL;
	        }
	
	        // Avoid security warnings on getResponseHeader when not allowed by CORS
	        if (/^X-Request-URL:/m.test(xhr.getAllResponseHeaders())) {
	          return xhr.getResponseHeader('X-Request-URL');
	        }
	
	        return;
	      }
	
	      xhr.onload = function () {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: headers(xhr),
	          url: responseURL()
	        };
	        var body = 'response' in xhr ? xhr.response : xhr.responseText;
	        resolve(new Response(body, options));
	      };
	
	      xhr.onerror = function () {
	        reject(new TypeError('Network request failed'));
	      };
	
	      xhr.ontimeout = function () {
	        reject(new TypeError('Network request failed'));
	      };
	
	      xhr.open(request.method, request.url, true);
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true;
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob';
	      }
	
	      request.headers.forEach(function (value, name) {
	        xhr.setRequestHeader(name, value);
	      });
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
	    });
	  };
	  self.fetch.polyfill = true;
	})(typeof self !== 'undefined' ? self : undefined);

/***/ },
/* 957 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 958 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "account_center_logo.3e0b025f.svg";

/***/ },
/* 959 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "arrow_blue_right.a441f213.svg";

/***/ },
/* 960 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "circle_bookshelf_sm.e6e3994d.svg";

/***/ },
/* 961 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "circle_support_sm.97ce96f9.svg";

/***/ },
/* 962 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "devices.34f57576.svg";

/***/ },
/* 963 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "error_icon.e0fb12a8.svg";

/***/ },
/* 964 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "mobile.d5840416.svg";

/***/ },
/* 965 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "success_icon.4bc99f37.svg";

/***/ },
/* 966 */
/***/ function(module, exports) {

	module.exports = {
		"aqua": "#00ffff",
		"aliceblue": "#f0f8ff",
		"antiquewhite": "#faebd7",
		"black": "#000000",
		"blue": "#0000ff",
		"cyan": "#00ffff",
		"darkblue": "#00008b",
		"darkcyan": "#008b8b",
		"darkgreen": "#006400",
		"darkturquoise": "#00ced1",
		"deepskyblue": "#00bfff",
		"green": "#008000",
		"lime": "#00ff00",
		"mediumblue": "#0000cd",
		"mediumspringgreen": "#00fa9a",
		"navy": "#000080",
		"springgreen": "#00ff7f",
		"teal": "#008080",
		"midnightblue": "#191970",
		"dodgerblue": "#1e90ff",
		"lightseagreen": "#20b2aa",
		"forestgreen": "#228b22",
		"seagreen": "#2e8b57",
		"darkslategray": "#2f4f4f",
		"darkslategrey": "#2f4f4f",
		"limegreen": "#32cd32",
		"mediumseagreen": "#3cb371",
		"turquoise": "#40e0d0",
		"royalblue": "#4169e1",
		"steelblue": "#4682b4",
		"darkslateblue": "#483d8b",
		"mediumturquoise": "#48d1cc",
		"indigo": "#4b0082",
		"darkolivegreen": "#556b2f",
		"cadetblue": "#5f9ea0",
		"cornflowerblue": "#6495ed",
		"mediumaquamarine": "#66cdaa",
		"dimgray": "#696969",
		"dimgrey": "#696969",
		"slateblue": "#6a5acd",
		"olivedrab": "#6b8e23",
		"slategray": "#708090",
		"slategrey": "#708090",
		"lightslategray": "#778899",
		"lightslategrey": "#778899",
		"mediumslateblue": "#7b68ee",
		"lawngreen": "#7cfc00",
		"aquamarine": "#7fffd4",
		"chartreuse": "#7fff00",
		"gray": "#808080",
		"grey": "#808080",
		"maroon": "#800000",
		"olive": "#808000",
		"purple": "#800080",
		"lightskyblue": "#87cefa",
		"skyblue": "#87ceeb",
		"blueviolet": "#8a2be2",
		"darkmagenta": "#8b008b",
		"darkred": "#8b0000",
		"saddlebrown": "#8b4513",
		"darkseagreen": "#8fbc8f",
		"lightgreen": "#90ee90",
		"mediumpurple": "#9370db",
		"darkviolet": "#9400d3",
		"palegreen": "#98fb98",
		"darkorchid": "#9932cc",
		"yellowgreen": "#9acd32",
		"sienna": "#a0522d",
		"brown": "#a52a2a",
		"darkgray": "#a9a9a9",
		"darkgrey": "#a9a9a9",
		"greenyellow": "#adff2f",
		"lightblue": "#add8e6",
		"paleturquoise": "#afeeee",
		"lightsteelblue": "#b0c4de",
		"powderblue": "#b0e0e6",
		"firebrick": "#b22222",
		"darkgoldenrod": "#b8860b",
		"mediumorchid": "#ba55d3",
		"rosybrown": "#bc8f8f",
		"darkkhaki": "#bdb76b",
		"silver": "#c0c0c0",
		"mediumvioletred": "#c71585",
		"indianred": "#cd5c5c",
		"peru": "#cd853f",
		"chocolate": "#d2691e",
		"tan": "#d2b48c",
		"lightgray": "#d3d3d3",
		"lightgrey": "#d3d3d3",
		"thistle": "#d8bfd8",
		"goldenrod": "#daa520",
		"orchid": "#da70d6",
		"palevioletred": "#db7093",
		"crimson": "#dc143c",
		"gainsboro": "#dcdcdc",
		"plum": "#dda0dd",
		"burlywood": "#deb887",
		"lightcyan": "#e0ffff",
		"lavender": "#e6e6fa",
		"darksalmon": "#e9967a",
		"palegoldenrod": "#eee8aa",
		"violet": "#ee82ee",
		"azure": "#f0ffff",
		"honeydew": "#f0fff0",
		"khaki": "#f0e68c",
		"lightcoral": "#f08080",
		"sandybrown": "#f4a460",
		"beige": "#f5f5dc",
		"mintcream": "#f5fffa",
		"wheat": "#f5deb3",
		"whitesmoke": "#f5f5f5",
		"ghostwhite": "#f8f8ff",
		"lightgoldenrodyellow": "#fafad2",
		"linen": "#faf0e6",
		"salmon": "#fa8072",
		"oldlace": "#fdf5e6",
		"bisque": "#ffe4c4",
		"blanchedalmond": "#ffebcd",
		"coral": "#ff7f50",
		"cornsilk": "#fff8dc",
		"darkorange": "#ff8c00",
		"deeppink": "#ff1493",
		"floralwhite": "#fffaf0",
		"fuchsia": "#ff00ff",
		"gold": "#ffd700",
		"hotpink": "#ff69b4",
		"ivory": "#fffff0",
		"lavenderblush": "#fff0f5",
		"lemonchiffon": "#fffacd",
		"lightpink": "#ffb6c1",
		"lightsalmon": "#ffa07a",
		"lightyellow": "#ffffe0",
		"magenta": "#ff00ff",
		"mistyrose": "#ffe4e1",
		"moccasin": "#ffe4b5",
		"navajowhite": "#ffdead",
		"orange": "#ffa500",
		"orangered": "#ff4500",
		"papayawhip": "#ffefd5",
		"peachpuff": "#ffdab9",
		"pink": "#ffc0cb",
		"red": "#ff0000",
		"seashell": "#fff5ee",
		"snow": "#fffafa",
		"tomato": "#ff6347",
		"white": "#ffffff",
		"yellow": "#ffff00",
		"rebeccapurple": "#663399"
	};

/***/ },
/* 967 */
/***/ function(module, exports) {

	module.exports = {
		"aliceblue": "#f0f8ff",
		"antiquewhite": "#faebd7",
		"aqua": "#00ffff",
		"aquamarine": "#7fffd4",
		"azure": "#f0ffff",
		"beige": "#f5f5dc",
		"bisque": "#ffe4c4",
		"black": "#000000",
		"blanchedalmond": "#ffebcd",
		"blue": "#0000ff",
		"blueviolet": "#8a2be2",
		"brown": "#a52a2a",
		"burlywood": "#deb887",
		"cadetblue": "#5f9ea0",
		"chartreuse": "#7fff00",
		"chocolate": "#d2691e",
		"coral": "#ff7f50",
		"cornflowerblue": "#6495ed",
		"cornsilk": "#fff8dc",
		"crimson": "#dc143c",
		"cyan": "#00ffff",
		"darkblue": "#00008b",
		"darkcyan": "#008b8b",
		"darkgoldenrod": "#b8860b",
		"darkgray": "#a9a9a9",
		"darkgreen": "#006400",
		"darkgrey": "#a9a9a9",
		"darkkhaki": "#bdb76b",
		"darkmagenta": "#8b008b",
		"darkolivegreen": "#556b2f",
		"darkorange": "#ff8c00",
		"darkorchid": "#9932cc",
		"darkred": "#8b0000",
		"darksalmon": "#e9967a",
		"darkseagreen": "#8fbc8f",
		"darkslateblue": "#483d8b",
		"darkslategray": "#2f4f4f",
		"darkslategrey": "#2f4f4f",
		"darkturquoise": "#00ced1",
		"darkviolet": "#9400d3",
		"deeppink": "#ff1493",
		"deepskyblue": "#00bfff",
		"dimgray": "#696969",
		"dimgrey": "#696969",
		"dodgerblue": "#1e90ff",
		"firebrick": "#b22222",
		"floralwhite": "#fffaf0",
		"forestgreen": "#228b22",
		"fuchsia": "#ff00ff",
		"gainsboro": "#dcdcdc",
		"ghostwhite": "#f8f8ff",
		"gold": "#ffd700",
		"goldenrod": "#daa520",
		"gray": "#808080",
		"green": "#008000",
		"greenyellow": "#adff2f",
		"grey": "#808080",
		"honeydew": "#f0fff0",
		"hotpink": "#ff69b4",
		"indianred": "#cd5c5c",
		"indigo": "#4b0082",
		"ivory": "#fffff0",
		"khaki": "#f0e68c",
		"lavender": "#e6e6fa",
		"lavenderblush": "#fff0f5",
		"lawngreen": "#7cfc00",
		"lemonchiffon": "#fffacd",
		"lightblue": "#add8e6",
		"lightcoral": "#f08080",
		"lightcyan": "#e0ffff",
		"lightgoldenrodyellow": "#fafad2",
		"lightgray": "#d3d3d3",
		"lightgreen": "#90ee90",
		"lightgrey": "#d3d3d3",
		"lightpink": "#ffb6c1",
		"lightsalmon": "#ffa07a",
		"lightseagreen": "#20b2aa",
		"lightskyblue": "#87cefa",
		"lightslategray": "#778899",
		"lightslategrey": "#778899",
		"lightsteelblue": "#b0c4de",
		"lightyellow": "#ffffe0",
		"lime": "#00ff00",
		"limegreen": "#32cd32",
		"linen": "#faf0e6",
		"magenta": "#ff00ff",
		"maroon": "#800000",
		"mediumaquamarine": "#66cdaa",
		"mediumblue": "#0000cd",
		"mediumorchid": "#ba55d3",
		"mediumpurple": "#9370db",
		"mediumseagreen": "#3cb371",
		"mediumslateblue": "#7b68ee",
		"mediumspringgreen": "#00fa9a",
		"mediumturquoise": "#48d1cc",
		"mediumvioletred": "#c71585",
		"midnightblue": "#191970",
		"mintcream": "#f5fffa",
		"mistyrose": "#ffe4e1",
		"moccasin": "#ffe4b5",
		"navajowhite": "#ffdead",
		"navy": "#000080",
		"oldlace": "#fdf5e6",
		"olive": "#808000",
		"olivedrab": "#6b8e23",
		"orange": "#ffa500",
		"orangered": "#ff4500",
		"orchid": "#da70d6",
		"palegoldenrod": "#eee8aa",
		"palegreen": "#98fb98",
		"paleturquoise": "#afeeee",
		"palevioletred": "#db7093",
		"papayawhip": "#ffefd5",
		"peachpuff": "#ffdab9",
		"peru": "#cd853f",
		"pink": "#ffc0cb",
		"plum": "#dda0dd",
		"powderblue": "#b0e0e6",
		"purple": "#800080",
		"rebeccapurple": "#663399",
		"red": "#ff0000",
		"rosybrown": "#bc8f8f",
		"royalblue": "#4169e1",
		"saddlebrown": "#8b4513",
		"salmon": "#fa8072",
		"sandybrown": "#f4a460",
		"seagreen": "#2e8b57",
		"seashell": "#fff5ee",
		"sienna": "#a0522d",
		"silver": "#c0c0c0",
		"skyblue": "#87ceeb",
		"slateblue": "#6a5acd",
		"slategray": "#708090",
		"slategrey": "#708090",
		"snow": "#fffafa",
		"springgreen": "#00ff7f",
		"steelblue": "#4682b4",
		"tan": "#d2b48c",
		"teal": "#008080",
		"thistle": "#d8bfd8",
		"tomato": "#ff6347",
		"turquoise": "#40e0d0",
		"violet": "#ee82ee",
		"wheat": "#f5deb3",
		"white": "#ffffff",
		"whitesmoke": "#f5f5f5",
		"yellow": "#ffff00",
		"yellowgreen": "#9acd32"
	};

/***/ },
/* 968 */
/***/ function(module, exports) {

	module.exports = {
		"base": {
			"welcome": "مرحبًا بك في Mulligans، %{name} !",
			"user": "معلومات المستخدم",
			"devices": "الأجهزة",
			"refunds": "استرداد الأموال",
			"resources": "الموارد",
			"transactions": "الطلبات والمرتجعات",
			"email": "البريد الإلكتروني",
			"password": "كلمة المرور",
			"save": "حفظ",
			"sign-out": "تسجيل الخروج",
			"cancel": "إلغاء",
			"close": "إغلاق",
			"learn-more": "أعرف المزيد",
			"required": "مطلوب",
			"support": "دعم",
			"bookshelf": "Bookshelf",
			"launch": "إطلاق",
			"download": "تنزيل",
			"details": "التفاصيل",
			"cannot-be-blank": "%{field} لا يمكن أن تكون فارغة.",
			"saving": "جارِ الحفظ...",
			"done": "تم",
			"failed": "فشل",
			"copy": "نسخ"
		},
		"signin": {
			"login-failure": "البريد الإلكتروني أو كلمة المرور غير صحيحة",
			"welcome-large": "مرحبًا بك في <span class='inner'>مركز حساب %{brand}</span>",
			"welcome-small": "<span class='inner'> مركز الحساب </span>",
			"signin-button": "تسجيل الدخول",
			"forgot-password": "نسيت كلمة المرور الخاصة بك",
			"new-to-vst": "جديد لـ %{brand} ؟",
			"create-account": "إنشاء حساب",
			"signing-in": "تسجيل الدخول...",
			"signin-failed": "فشل تسجيل الدخول"
		},
		"transactions": {
			"price": "السعر",
			"excluded": "(باستثناء الضرائب)",
			"quantity": "الكمية",
			"confirmation#": "تأكيد #",
			"payment": "الدفع",
			"purchased": "ما تم شراؤه",
			"purchase-details": "تفاصيل الشراء",
			"subtotal": "المجموع الفرعي",
			"total": "إجمالي",
			"tax": "ضريبة",
			"loading": "أيها المنفق الكبير، نقوم بتحميل المعاملات الخاصة بك ...",
			"no-purchases": "لا يوجد لديك مشتريات.",
			"seller-vat": "ضريبة القيمة المضافة للبائع",
			"total-vat": "إجمالي %{vat} المدفوعة",
			"portion": "%{subTax} الضرائب بنسبة %{rate}%",
			"vat-disclosure": "يتضمن السعر %{vat}",
			"purchases": "المشتريات",
			"refunded-items": "العناصر التي تم الخصم عليها",
			"book-title": "عنوان الكتاب",
			"refund-details": "تفاصيل استرداد الأموال",
			"print-receipt": "طباعة الإيصال",
			"request-refund": "طلب استرداد الأموال",
			"expired": "انتهت مدة الصلاحية",
			"expires-in": "تنتهي في %{date}",
			"details-refund": "التفاصيل واسترداد الأموال",
			"modal": {
				"cant-refund-title": "استرداد الأموال غير متوفر",
				"cant-refund": "لا يمكن استرداد أموال كتابك لسبب أو أكثر من الأسباب التالية.",
				"cant-refund-1": "تم عرض نسخ كثيرة من كتابك.",
				"cant-refund-2": "لقد مضى أكثر من 14 يومًا من تاريخ الشراء.",
				"cant-refund-3": "تم الكشف عن رمز مواردك على الانترنت.",
				"cant-refund-4": "تم استرداد أموال كتابك مسبقًا.",
				"cant-refund-5": "تم بالفعل استعادة جميع الرموز و / أو استردادها.",
				"cant-refund-6": "لقد مضى أكثر من 30 يومًا من تاريخ الشراء.",
				"cant-refund-support": "إذا كنت لا تزال غير متأكد من سياسة استرداد %{brand} اتصل <a href='%{support_url}' target='_blank'>بالدعم </a>."
			},
			"license": {
				"perpetual": "الوصول عبر الإنترنت لا ينتهي",
				"days": "%{days} يوم الوصول"
			}
		},
		"devices": {
			"description": "يمكّنك %{brand} من أن يكون لديك <span>%{desktop}</span> أجهزة كمبيوتر و <span>%{mobile}</span> أجهزة محمول/كمبيوتر لوحي مفعلة في الوقت المحدد.",
			"loading": "هيا، نحن نحصل على الأجهزة الخاصة بك :)",
			"no-active": "لا يوجد لديك أجهزة نشطة.",
			"deactivate": "إلغاء التفعيل"
		},
		"user": {
			"personal-information": "المعلومات الشخصية",
			"security-information": "معلومات الأمان",
			"notifications": "الإشعارات",
			"first-name": "الاسم الأول",
			"last-name": "الاسم الأخير",
			"change-password-title": "تغيير كلمة المرور",
			"current-password": "كلمة المرور الحالية",
			"new-password": "كلمة المرور الجديدة",
			"security-password": "كلمة المرور",
			"confirm-new-password": "تأكيد كلمة المرور الجديدة",
			"security-question": "سؤال الأمان",
			"security-info-change": "تغيير",
			"question": "سؤال",
			"answer": "الإجابة",
			"notifications-text": "قم بإرسال التحديثات العرضية حول نشاط حسابي وتحديثات المنتج والعروض الخاصة.",
			"loading": "النقطة هي من جلبت معلومات المستخدم الخاصة بك، ثانية واحدة 🐶",
			"change-password-text": "يجب أن تحتوي كلمة المرور الجديدة على 8 حروف على الأقل وحرف كبير وحرف صغير وحرف خاص.",
			"email-locked": "تم إغلاق البريد الإلكتروني",
			"email-locked-description": "ليس لديك إمكانية الوصول لتغيير البريد الإلكتروني الخاص بك.",
			"email-locked-more": "يرجى الاتصال بالمسؤول.",
			"security-question6": "ما هي رياضتك المفضلة؟",
			"security-question7": "ما هي النكهة المفضلة لديك من الآيس كريم؟",
			"security-question8": "ما هو اسم الحيوان الأليف المفضل لديك؟",
			"security-question9": "عندما كنت صغيرًا، ماذا أردت أن تكون حينما تكبر؟",
			"security-question10": "ماذا كان الاسم الأخير للمدرس المفضل لديك؟",
			"new-password-failure": "لا تلبي كلمة المرور المتطلبات",
			"confirm-password-failure": "يجب أن تتطابق كلمة المرور",
			"new-password-tooltip": "يجب ان يحتوي على 8 حروف على الأقل، حرف كبير وحرف صغير وحرف خاص.",
			"enter-valid-email": "يرجى إدخال البريد الإلكتروني الصحيح.",
			"password-cannot-be-same": "لا يمكن أن تكون كلمة المرور هي نفس كلمة المرور السابقة",
			"incorrect-password": "كلمة مرور غير صحيحة",
			"complete-account": "يبدو أنك تحتاج إلى <a href='%{href}'>إكمال حسابك</a>.",
			"completing-allows": "يتيح لك إكمال حسابك إمكانية قراءة الكتب دون الاتصال بالإنترنت على تطبيقات الهاتف المحمول لديك ومشاركة الملاحظات والتمييزات مع الأصدقاء.",
			"error-updating-info": "There was an error updating your information.",
			"password-updated": "Password successfully updated",
			"security-updated": "Security question successfully updated",
			"info-updated": "User information successfully updated"
		},
		"resources": {
			"ancillaries": "المساعدون",
			"access-codes": "رموز الوصول",
			"print-on-demand": "طباعة عند الطلب",
			"check-pod": "قم بمراجعة خيارات طباعة الناشر في كتبك.",
			"check-now": "تحقق الآن",
			"loading": "انتظر برهة، نقوم بتحديث الموارد الخاصة بك!",
			"in": "في",
			"access-code-intro": "رمز الوصول هو كلمة المرور التي تستخدمها للوصول إلى محتوى الدورة على الانترنت. بمجرد أن يظهر رمز العنصر، فإنك لن تتمكن من إعادته. لمزيد من التعليمات حول كيفية استخدام رموز الوصول الخاصة بك، تفضل بزيارة <a href='%{support_url}' target='_blank'>الدعم</a>.",
			"expires": "تنتهي في",
			"expiration-message": "يحتوي على التعليمات الخاصة باستخدام رمز الوصول.",
			"copy-fail": "غير قادر على النسخ. يرجى اختيار رمز ونسخه يدويًا.",
			"launch-site": "إطلاق موقع",
			"launch-book": "طرح كتاب",
			"reveal-code": "إظهار الرمز",
			"no-resources": "ليس لديك أي موارد.",
			"no-access-codes": "ليس لديك أي رموز وصول.",
			"no-ancillaries": "لا يوجد مساعدون لهذا العنوان",
			"name": "الاسم",
			"type": "النوع",
			"size": "الحجم",
			"download-all": "تنزيل الكل",
			"back": "العودة إلى الموارد"
		},
		"refunds": {
			"states": {
				"refunded": "تم استردادها",
				"unavailable": "استرداد الأموال غير متوفر"
			},
			"reasons": {
				"dropped": "لقد تركت الدورة",
				"wrong": "كان هذا الكتاب الخاطيء لدورتي",
				"print": "قررت شراء نسخة مطبوعة بدلاً من ذلك",
				"missing": "لا يحتوي الكتاب على كل ما أحتاج إليه لدورتي (على سبيل المثال. قرص مضغوط، الوصول إلى شبكة الإنترنت، فيديوهات)",
				"other": "أخرى"
			},
			"bulk": {
				"policy": "بالضغط على زر &quot;استرداد كامل&quot; أدناه، فأنا أوافق على سياسة <a href='%{policy_url}' target='_blank'>استرداد %{brand}</a>.",
				"complete": "استرداد كامل",
				"view-details": "عرض تفاصيل الاسترداد",
				"success": "تم طلب استرداد أموالك. يرجى الانتظار 48 ساعة للمعالجة.",
				"failure": "عفوًا - شيٌء ما حدث بشكل خاطئ! للأسف لم يتم الاسترداد الخاص بك.",
				"retry": "حاول مرة أخرى",
				"support": "الاتصال بالدعم",
				"available-codes": "الرموز المتاحة",
				"codes-selected": "الرموز المحددة",
				"download": "رموز التنزيل",
				"partially-refunded": "استرداد جزئي",
				"pick-one": "يجب تحديد رمز واحد على الأقل لعمل استرداد"
			},
			"refund": "استرداد",
			"all": "استرداد الكل؟",
			"missing-reason": "يجب تحديد سبب للمتابعة",
			"missing-elaboration": "يرجى التوضيح",
			"policy": "بالضغط على زر \"استكمال طلب استرداد المال\" أدناه، أفهم أنه إذا قمت بشراء هذا الكتاب الإلكتروني من %{brand} مرة أخرى، لن أكون مؤهلاً لطلب أي مبالغ معادة أخرى لنفس الكتاب الإلكتروني. عرض سياسة الاسترداد بالكامل.",
			"refunded": "تم استردادها",
			"sorry": "نعتذر لأنك لم تكن راضيًَا عن عملية الشراء.",
			"error": "حدث خطأ ما",
			"error-explain": "لم نتمكن من معالجة استرداد الأموال. يرجى إعادة المحاولة.",
			"why": "أخبرنا عن السبب؟",
			"no-refunds": "لا يوجد لديك عناصر مستردة.",
			"select-codes": "حدد الرمز (الرموز) للاسترداد:",
			"number": "كم العدد؟",
			"back": "العودة إلى عمليات استرداد الأموال"
		},
		"purchases": {
			"back": "العودة إلى المشتريات"
		},
		"global-bar": {
			"account": "إعدادات الحساب"
		}
	};

/***/ },
/* 969 */
/***/ function(module, exports) {

	module.exports = {
		"base": {
			"welcome": "Добре дошли в Mulligans, %{name}.",
			"user": "Информация за потребителя",
			"devices": "Устройства",
			"refunds": "Възстановяване на средства",
			"resources": "Източници",
			"transactions": "Поръчки и връщания",
			"email": "Имейл",
			"password": "Парола",
			"save": "Запиши",
			"sign-out": "Излизане",
			"cancel": "Отказ",
			"close": "Затвори",
			"learn-more": "Научете повече",
			"required": "Задължително",
			"support": "Поддръжка",
			"bookshelf": "Bookshelf",
			"launch": "Пусни",
			"download": "Изтегли",
			"details": "По-подробно",
			"cannot-be-blank": "%{field} не може да бъде празно.",
			"saving": "Записва се...",
			"done": "Готово",
			"failed": "Неуспешно",
			"copy": "Копирай"
		},
		"signin": {
			"login-failure": "Имейл адресът или паролата са неправилни",
			"welcome-large": "Добре дошли в <span class='inner'>центъра за профили на %{brand} </span>",
			"welcome-small": "<span class='inner'>Център за профили</span>",
			"signin-button": "Влизане",
			"forgot-password": "Забравена парола",
			"new-to-vst": "Нови ли сте в %{brand}?",
			"create-account": "Създайте си профил",
			"signing-in": "Влизане...",
			"signin-failed": "Неуспешно влизане"
		},
		"transactions": {
			"price": "Цена",
			"excluded": "(Без данъка)",
			"quantity": "Количество",
			"confirmation#": "Потвърждение №",
			"payment": "Плащане",
			"purchased": "Купени",
			"purchase-details": "Данни за покупката",
			"subtotal": "Междинна сума",
			"total": "Обща сума",
			"tax": "Данък",
			"loading": "Здравей потребителю, ние зареждаме вашите транзакции...",
			"no-purchases": "Вие нямате покупки.",
			"seller-vat": "ДДС на продавача",
			"total-vat": "Общо платено %{vat}",
			"portion": "%{subTax} Данък %{rate}%",
			"vat-disclosure": "Цената включва %{vat}",
			"purchases": "Покупки",
			"refunded-items": "Възстановени артикули",
			"book-title": "Заглавие на книга ",
			"refund-details": "Данни за възстановяването",
			"print-receipt": "Отпечатване на разписка",
			"request-refund": "Заявете възстановяване",
			"expired": "Изтекъл",
			"expires-in": "Изтича на %{date}",
			"details-refund": "Детайли и възстановяване на средства",
			"modal": {
				"cant-refund-title": "Възстановяването е недостъпно",
				"cant-refund": "Средствата за книгата ви не може да бъдат възстановени поради една или повече от следните причини.",
				"cant-refund-1": "Твърде много съдържание от вашата книга е било разгледано.",
				"cant-refund-2": "Изминали са повече от 14 дни от датата на покупката.",
				"cant-refund-3": "Вашият код за онлайн ресурси е бил разкрит.",
				"cant-refund-4": "Преди време са ви възстановявани средства за тази книга.",
				"cant-refund-5": "Всички кодове вече са предявени и/или средствата по тях са възстановени.",
				"cant-refund-6": "Изминали са повече от 30 дни от датата на покупката.",
				"cant-refund-support": "Ако все още не сте сигурни в правилата за възстановяване на средства от %{brand}, свържете се с <a href='%{support_url}' target='_blank'>поддръжката</a>."
			},
			"license": {
				"perpetual": "Онлайн достъпът няма дата на изтичане",
				"days": "%{days}-дневен достъп"
			}
		},
		"devices": {
			"description": "%{brand} ви позволява да имате <span>%{desktop}</span> компютъра и <span>%{mobile}</span> мобилни устройства/таблета, които да са активирани във всеки един момент.",
			"loading": "Здравейте, ние регистрираме вашите устройства:)",
			"no-active": "Нямате активни устройства.",
			"deactivate": "Деактивирай"
		},
		"user": {
			"personal-information": "Лични данни",
			"security-information": "Информация за сигурността",
			"notifications": "Известия",
			"first-name": "Собствено име",
			"last-name": "Фамилно име",
			"change-password-title": "Смяна на паролата",
			"current-password": "Текуща парола",
			"new-password": "Нова парола",
			"security-password": "Парола",
			"confirm-new-password": "Повторете новата парола",
			"security-question": "Въпрос за сигурност",
			"security-info-change": "Промяна",
			"question": "Въпрос",
			"answer": "Отговор",
			"notifications-text": "Изпращайте ми информация по имейла за промени в активността на профила ми, актуализации на продукти, както и специални предложения.",
			"loading": "Спот извлича вашата потребителска информация, моля изчакайте малко 🐶",
			"change-password-text": "Паролата трябва да съдържа най-малко осем знака, да има поне една главна буква, една малка буква и един специален символ.",
			"email-locked": "Имейлът е заключен",
			"email-locked-description": "Вие нямате необходимия достъп, за да промените имейла си.",
			"email-locked-more": "Моля, свържете се с администратора",
			"security-question6": "Кой е любимият ви спорт?",
			"security-question7": "Кой е любимият ви вид сладолед?",
			"security-question8": "Как е името на домашния ви любимец?",
			"security-question9": "Като малък какъв искахте да станете?",
			"security-question10": "Какво беше фамилното име на любимия ви учител?",
			"new-password-failure": "Парола не отговаря на изискванията",
			"confirm-password-failure": "Паролите трябва да съвпадат",
			"new-password-tooltip": "Трябва да съдържа поне 8 символа, главна буква, малка буква и специален знак.",
			"enter-valid-email": "Моля въведете валиден имейл адрес.",
			"password-cannot-be-same": "Паролата не може да бъде същата като предишната парола",
			"incorrect-password": "Грешна парола",
			"complete-account": "Изглежда, че трябва да <a href='%{href}'>завършите своя акаунт</a>.",
			"completing-allows": "Завършването на вашия акаунт ще ви позволи да четете книги офлайн в нашите мобилни приложения и да споделяте бележки и маркирания с приятели.",
			"error-updating-info": "There was an error updating your information.",
			"password-updated": "Password successfully updated",
			"security-updated": "Security question successfully updated",
			"info-updated": "User information successfully updated"
		},
		"resources": {
			"ancillaries": "Спомагателни",
			"access-codes": "Кодове за достъп",
			"print-on-demand": "Печат пo поръчка",
			"check-pod": "Проверете опциите за издателски печат на вашите книги.",
			"check-now": "Провери сега",
			"loading": "Моля изчакайте, ние актуализираме вашите ресурси!",
			"in": "в",
			"access-code-intro": "Кодът за достъп е паролата, която използвате за достъп до съдържанието на онлайн курса. След като разкриете кода за даден продукт, няма да можете да го върнете. За повече инструкции относно това как да използвате кодовете за достъп, посетете <a href='%{support_url}' target='_blank'>Поддръжка</a>.",
			"expires": "Изтича на",
			"expiration-message": "Съдържа инструкции как да използвате кода си за достъп.",
			"copy-fail": "Не може да се копира. Моля, изберете кода и ръчно го копирайте.",
			"launch-site": "Пускане на сайта",
			"launch-book": "Стартирай книгата",
			"reveal-code": "Разкрий кода",
			"no-resources": "Вие нямате никакви ресурси.",
			"no-access-codes": "Вие нямате никакви кодове за достъп.",
			"no-ancillaries": "Няма спомагателни средства за това заглавие",
			"name": "Име",
			"type": "Тип",
			"size": "Размер",
			"download-all": "Изтегли всички",
			"back": "Назад към ресурсите"
		},
		"refunds": {
			"states": {
				"refunded": "С възстановени средства",
				"unavailable": "Възстановяването е недостъпно"
			},
			"reasons": {
				"dropped": "Напуснах курса",
				"wrong": "Това не беше правилната книга за моя курс",
				"print": "Реших да си купя печатно издание вместо това",
				"missing": "Книгата не съдържа всичко, което ми трябва за моя курс (напр. компактдиск, уеб достъп, видео)",
				"other": "Друго"
			},
			"bulk": {
				"policy": "С натискането на бутона &quot;Завърши възстановяването&quot; по-долу аз съм се съгласявам с правилата на %{brand}  <a href='%{policy_url}' target='_blank'>за възстановяване </a>.",
				"complete": "Завърши възстановяването",
				"view-details": "Покажи данни за възстановяването",
				"success": "Вашата заявка за възстановяване на средства е подадена. Моля, изчакайте 48 часа за обработка.",
				"failure": "Съжаляваме – нещо се обърка! Възстановяването на средствата не се осъществи.",
				"retry": "Опитайте пак",
				"support": "Свързване с поддръжката",
				"available-codes": "Налични кодове",
				"codes-selected": "Избрани кодове",
				"download": "Изтегляне на кодове",
				"partially-refunded": "Частично възстановени",
				"pick-one": "Трябва да изберете поне един код, за да извърши възстановяване на средства"
			},
			"refund": "Възстановяване",
			"all": "Всички ли да се възстановят?",
			"missing-reason": "Трябва да изберете причина, за да продължите",
			"missing-elaboration": "Моля, прецизирайте",
			"policy": "С натискането на бутона \"Изпълни заявката за възстановяване\" по-долу аз разбирам, че ако купя този електронен учебник (eTextbook) от %{brand} отново, няма да имам право да поискам последващо възстановяване на средствата за същия електронен учебник. Вижте пълния списък на правилата за връщане.",
			"refunded": "С възстановени средства",
			"sorry": "Съжаляваме, че не сте доволни от покупката си.",
			"error": "Нещо се обърка",
			"error-explain": "Не успяхме да обработим възстановяването на средствата ви. Моля, опитайте отново.",
			"why": "Кажете ни защо?",
			"no-refunds": "Вие нямате продукти с възстановени средства.",
			"select-codes": "Изберете код(ове) за възстановяване:",
			"number": "Колко?",
			"back": "Назад към възстановяването"
		},
		"purchases": {
			"back": "Назад към покупките"
		},
		"global-bar": {
			"account": "Настройки на профила"
		}
	};

/***/ },
/* 970 */
/***/ function(module, exports) {

	module.exports = {
		"base": {
			"welcome": "Us donem la benvinguda a Mulligans, %{name}.",
			"user": "Informació de l'usuari",
			"devices": "Dispositius",
			"refunds": "Reemborsaments",
			"resources": "Recursos",
			"transactions": "Comandes i devolucions",
			"email": "Correu electrònic",
			"password": "Contrasenya",
			"save": "Desa",
			"sign-out": "Tanca la sessió",
			"cancel": "Cancel•la",
			"close": "Tanca",
			"learn-more": "Més informació",
			"required": "Necessari",
			"support": "Assistència",
			"bookshelf": "Bookshelf",
			"launch": "Inicia",
			"download": "Baixa",
			"details": "Dades",
			"cannot-be-blank": "%{field} no pot estar buit.",
			"saving": "S'està desant…",
			"done": "Fet",
			"failed": "Error",
			"copy": "Copia"
		},
		"signin": {
			"login-failure": "Correu electrònic o contrasenya incorrectes",
			"welcome-large": "Us donem la benvinguda al <span class='inner'>Account Center de %{brand}</span>",
			"welcome-small": "<span class='inner'>Account Center</span>",
			"signin-button": "Inicia la sessió",
			"forgot-password": "Heu oblidat la contrasenya?",
			"new-to-vst": "Nou a %{brand}?",
			"create-account": "Creeu un compte",
			"signing-in": "Iniciant la sessió...",
			"signin-failed": "Error d'inici de sessió"
		},
		"transactions": {
			"price": "Preu",
			"excluded": "(impost no inclòs)",
			"quantity": "Quantitat",
			"confirmation#": "Núm. de confirmació",
			"payment": "Pagament",
			"purchased": "Comprats",
			"purchase-details": "Dades de la compra",
			"subtotal": "Subtotal",
			"total": "Total",
			"tax": "Impost",
			"loading": "Ei, malgastador, estem carregant les teves transaccions...",
			"no-purchases": "No tens cap compra.",
			"seller-vat": "IVA del venedor",
			"total-vat": "%{vat} total pagat",
			"portion": "%{subTax} Impost %{rate}%",
			"vat-disclosure": "El preu inclou %{vat}",
			"purchases": "Compres",
			"refunded-items": "Articles reembossats",
			"book-title": "Títol del llibre",
			"refund-details": "Dades del reemborsament",
			"print-receipt": "Imprimeix el rebut",
			"request-refund": "Sol·licita el reembossament",
			"expired": "Ha caducat",
			"expires-in": "Caduca el %{date}",
			"details-refund": "Detalls i reemborsament",
			"modal": {
				"cant-refund-title": "Reemborsament no disponible",
				"cant-refund": "El teu llibre no es pot reembossar per alguna o diverses raons.",
				"cant-refund-1": "S'ha vist una part considerable del teu llibre.",
				"cant-refund-2": "Han passat més de 14 dies des de la data de compra.",
				"cant-refund-3": "S'ha mostrat el teu codi de recursos en línia.",
				"cant-refund-4": "El teu llibre ha estat reembossat prèviament.",
				"cant-refund-5": "Tots els codis ja s'han bescanviat o reembossat.",
				"cant-refund-6": "Han passat més de 30 dies des de la data de compra.",
				"cant-refund-support": "Si encara teniu dubtes sobre la política de reembossaments de %{brand}, poseu-vos en contacte amb <a href='%{support_url}' target='_blank'>el servei d'assistència</a>."
			},
			"license": {
				"perpetual": "L'accés en línia no caduca",
				"days": "Accés per %{days}"
			}
		},
		"devices": {
			"description": "%{brand} us permet tenir <span>%{desktop}</span> ordinadors i <span>%{mobile}</span> dispositius mòbils i tauletes activats en tot moment.",
			"loading": "Ei tu, estem obtenint els teus dispositius :)",
			"no-active": "No tens cap dispositiu actiu.",
			"deactivate": "Desactiva"
		},
		"user": {
			"personal-information": "Dades personals",
			"security-information": "Informació de seguretat",
			"notifications": "Notificacions",
			"first-name": "Nom",
			"last-name": "Cognom",
			"change-password-title": "Canvia la contrasenya",
			"current-password": "Contrasenya actual",
			"new-password": "Nova contrasenya",
			"security-password": "Contrasenya",
			"confirm-new-password": "Confirma la nova contrasenya",
			"security-question": "Pregunta de seguretat",
			"security-info-change": "Canvia",
			"question": "Pregunta",
			"answer": "Resposta",
			"notifications-text": "Envieu-me per correu electrònic de tant en tant actualitzacions sobre l'activitat del meu compte, novetats de productes i ofertes especials.",
			"loading": "Llampec està treient les teves dades d'usuari, espera un segon 🐶",
			"change-password-text": "La contrasenya ha de tenir vuit caràcters com a mínim, una lletra en majúscules, una lletra en minúscules i un caràcter especial.",
			"email-locked": "Correu electrònic bloquejat",
			"email-locked-description": "No teniu permís per canviar el vostre correu electrònic.",
			"email-locked-more": "Poseu-vos en contacte amb el vostre administrador.",
			"security-question6": "Quin és el vostre esport preferit?",
			"security-question7": "Quin és el vostre gust de gelat preferit?",
			"security-question8": "Quin és el vostre nom preferit per a un animal de companyia?",
			"security-question9": "Quan éreu jove, què volieu ser quan fóssiu gran?",
			"security-question10": "Quin era el cognom del vostre mestre preferit?",
			"new-password-failure": "La contrasenya no compleix els requisits",
			"confirm-password-failure": "La contrasenya ha de coincidir",
			"new-password-tooltip": "Ha de tenir 8 o més caràcters, una lletra en majúscules, una lletra en minúscules i un caràcter especial.",
			"enter-valid-email": "Introduïu un correu electrònic vàlid.",
			"password-cannot-be-same": "La contrasenya no pot coincidir amb la contrasenya antiga",
			"incorrect-password": "Contrasenya incorrecta",
			"complete-account": "Pel que sembla, encara no heu <a href='%{href}'>completat el vostre compte</a>.",
			"completing-allows": "Completar el vostre compte us permet llegir llibres fora de línia en les nostres aplicacions per al mòbil, a m´és de compartir notes i elements realçats amb els amics.",
			"error-updating-info": "There was an error updating your information.",
			"password-updated": "Password successfully updated",
			"security-updated": "Security question successfully updated",
			"info-updated": "User information successfully updated"
		},
		"resources": {
			"ancillaries": "Complements",
			"access-codes": "Codis d'accés",
			"print-on-demand": "Impressió sota demanda",
			"check-pod": "Comproveu les opcions d'impressió de l'editor pels vostres llibres.",
			"check-now": "Comprova-ho ara",
			"loading": "No marxis, estem actualitzant els teus recursos!",
			"in": "en",
			"access-code-intro": "Un codi d'accés és una contrasenya que utilitzeu per accedir al contingut del curs en línia. Un cop mostrat el codi d'un element, ja no el podreu retornar. Per a obtenir més instruccions sobre com usar els vostres codis d'accés, visiteu <a href='%{support_url}' target='_blank'>el servei d'assistència</a>.",
			"expires": "Caduca",
			"expiration-message": "Conté instruccions per a utilitzar el vostre codi d'accés.",
			"copy-fail": "No es pot copiar. Seleccioneu el codi i copieu-lo manualment.",
			"launch-site": "Inicia el lloc",
			"launch-book": "Inicia el llibre",
			"reveal-code": "Mostra el codi",
			"no-resources": "No tens cap recurs.",
			"no-access-codes": "No tens cap codi d'accés.",
			"no-ancillaries": "Aquest títol no té cap complement",
			"name": "Nom",
			"type": "Tipus",
			"size": "Mida",
			"download-all": "Baixa tot",
			"back": "Torna als recursos"
		},
		"refunds": {
			"states": {
				"refunded": "Reembossat",
				"unavailable": "Reembossament no disponible"
			},
			"reasons": {
				"dropped": "He deixat el curs",
				"wrong": "Aquest no era el llibre correcte pel meu curs",
				"print": "Vaig decidir comprar una versió impresa ",
				"missing": "El llibre no inclou tot el que necessito pel meu curs (per exemple, un CD, accés web, videos)",
				"other": "Altres"
			},
			"bulk": {
				"policy": "En fer clic al botó &quot;Completa el reembossament&quot;, a sota, estic acceptant la política de reembossament <a href='%{policy_url}' target='_blank'></a> de %{brand}.",
				"complete": "Completa el reembossament",
				"view-details": "Mostra les dades del reembossament",
				"success": "S'ha sol·licitat el reemborsament. Tardarà 48 hores a processar-se.",
				"failure": "Vaja, alguna cosa no ha anat bé. Malauradament el vostre reembossament no s'ha processat.",
				"retry": "Torneu-ho a provar",
				"support": "Poseu-vos en contacte amb el servei d'assistència",
				"available-codes": "Codis disponibles",
				"codes-selected": "Codis seleccionats",
				"download": "Baixa els codis",
				"partially-refunded": "Reembossats parcialment",
				"pick-one": "Per obtenir un reembossament cal que seleccioneu almenys un codi"
			},
			"refund": "Reembossats",
			"all": "Reembossar tots?",
			"missing-reason": "Cal que seleccioneu una raó per continuar",
			"missing-elaboration": "Podeu donar-nos més detalls?",
			"policy": "En fer clic al botó “Completa la sol·licitud de reembossament” a sota, entenc que si torno a adquirir aquest llibre de text electrònic de %{brand} no tindré dret a sol·licitar cap altre reembossament addicional d'aquest mateix llibre de text electrònic. Veure la política de devolucions completa.",
			"refunded": "Reembossat",
			"sorry": "Lamentem que no estigueu satisfets amb la vostra compra.",
			"error": "Alguna cosa no ha anat bé",
			"error-explain": "No hem pogut processar el vostre reembossament. Torneu-ho a provar.",
			"why": "Diga'ns el perquè",
			"no-refunds": "No tens cap element reembossat.",
			"select-codes": "Seleccioneu el codi o codis que voleu reembossar:",
			"number": "Quants?",
			"back": "Torna als reembossaments"
		},
		"purchases": {
			"back": "Torna a les compres"
		},
		"global-bar": {
			"account": "Configuració del compte"
		}
	};

/***/ },
/* 971 */
/***/ function(module, exports) {

	module.exports = {
		"base": {
			"welcome": "Vítá vás Mulligans, uživateli %{name}!",
			"user": "Informace o uživateli",
			"devices": "Zařízení",
			"refunds": "Vrácení peněz",
			"resources": "Zdroje",
			"transactions": "Objednávky a vrácení zboží",
			"email": "E-mail",
			"password": "Heslo",
			"save": "Uložit",
			"sign-out": "Odhlásit se",
			"cancel": "Zrušit",
			"close": "Zavřít",
			"learn-more": "Více informací",
			"required": "Povinné",
			"support": "Podpora",
			"bookshelf": "Bookshelf",
			"launch": "Spustit",
			"download": "Stáhnout",
			"details": "Podrobnosti",
			"cannot-be-blank": "Pole %{field} nemůže být prázdné",
			"saving": "Ukládání…",
			"done": "Hotovo",
			"failed": "Nezdařilo se",
			"copy": "Kopírovat"
		},
		"signin": {
			"login-failure": "E-mail nebo heslo jsou nesprávné",
			"welcome-large": "Vítá vás <span class='inner'>Centrum účtu %{brand}</span>",
			"welcome-small": "<span class='inner'>Centrum účtu</span>",
			"signin-button": "Prihlásit se",
			"forgot-password": "Zapomenuté heslo",
			"new-to-vst": "Jste novým uživatelem služby %{brand}?",
			"create-account": "Vytvořit účet",
			"signing-in": "Přihlašování…",
			"signin-failed": "Přihlášení se nezdařilo"
		},
		"transactions": {
			"price": "Cena",
			"excluded": "(Bez daně)",
			"quantity": "Množství",
			"confirmation#": "Číslo potvrzení",
			"payment": "Platba",
			"purchased": "Zakoupeno",
			"purchase-details": "Podrobnosti o nákupu",
			"subtotal": "Dílčí součet",
			"total": "Celkem",
			"tax": "Daň",
			"loading": "Dobrý den, načítáme vaše transakce…",
			"no-purchases": "Nemáte žádné nákupy.",
			"seller-vat": "DPH prodejce",
			"total-vat": "Celkem zaplaceno na %{vat}",
			"portion": "Daň %{subTax} %{rate} %",
			"vat-disclosure": "Cena zahrnuje %{vat}",
			"purchases": "Nákupy",
			"refunded-items": "Položky, za které byly vráceny peníze",
			"book-title": "Název knihy",
			"refund-details": "Informace o vrácení peněz",
			"print-receipt": "Vytisknout účtenku",
			"request-refund": "Požádat o vrácení peněz",
			"expired": "Vypršelo",
			"expires-in": "Platí do %{date}",
			"details-refund": "Podrobnosti a vrácení peněz",
			"modal": {
				"cant-refund-title": "Vrácení peněz není k dispozici",
				"cant-refund": "Za knihu nelze vrátit peníze z jednoho či více následujících důvodů.",
				"cant-refund-1": "Zobrazili jste si příliš velkou část knihy.",
				"cant-refund-2": "Uplynulo více než 14 dní od data nákupu.",
				"cant-refund-3": "Váš kód zdrojů online byl odhalen.",
				"cant-refund-4": "Za knihu vám už dříve byly vráceny peníze.",
				"cant-refund-5": "Všechny kódy již byly uplatněny nebo za ně byly vráceny peníze.",
				"cant-refund-6": "Uplynulo více než 30 dní od data nákupu.",
				"cant-refund-support": "Pokud si stále nejste jistí, jestli správně chápete zásady vracení peněz ve službě %{brand}, kontaktujte <a href='%{support_url}' target='_blank'>podporu</a>."
			},
			"license": {
				"perpetual": "Přístup online nemá časově omezenou platnost",
				"days": "%{days}denní přístup"
			}
		},
		"devices": {
			"description": "%{brand} umožňuje mít současně aktivováno <span>%{desktop}</span> počítačů a <span>%{mobile}</span> mobilních telefonů / tabletů.",
			"loading": "Dobrý den, získáváme vaše zařízení :)",
			"no-active": "Nemáte žádná aktivní zařízení.",
			"deactivate": "Deaktivovat"
		},
		"user": {
			"personal-information": "Osobní údaje",
			"security-information": "Bezpečnostní informace",
			"notifications": "Oznámení",
			"first-name": "Krestní jméno",
			"last-name": "Príjmení",
			"change-password-title": "Změnit heslo",
			"current-password": "Aktuální heslo",
			"new-password": "Nové heslo",
			"security-password": "Heslo",
			"confirm-new-password": "Potvrzení nového hesla",
			"security-question": "Bezpečnostní otázka",
			"security-info-change": "Změnit",
			"question": "Otázka",
			"answer": "Odpověď",
			"notifications-text": "Posílejte mi čas od času e-maily o změnách mého účtu, změnách v produktech a zvláštních nabídkách.",
			"loading": "Vydržte, Spot zrovna běží pro vaše uživatelské informace 🐶",
			"change-password-text": "Heslo musí obsahovat nejméně 8 znaků, velké písmeno, malé písmeno a zvláštní znak.",
			"email-locked": "E-mail je uzamčen",
			"email-locked-description": "Nemáte oprávnění ke změně e-mailu.",
			"email-locked-more": "Obraťte se na správce.",
			"security-question6": "Jaký je váš oblíbený sport?",
			"security-question7": "Jaká je vaše oblíbená příchuť zmrzliny?",
			"security-question8": "Jak se jmenuje váš domácí mazlíček?",
			"security-question9": "Čím jste se chtěli stát, když jste byli malí?",
			"security-question10": "Jaké bylo příjmení vašeho oblíbeného učitele?",
			"new-password-failure": "Heslo nesplňuje požadavky",
			"confirm-password-failure": "Heslo se musí shodovat",
			"new-password-tooltip": "Musí obsahovat nejméně 8 znaků, velké písmeno, malé písmeno a zvláštní znak.",
			"enter-valid-email": "Zadejte platný e-mail",
			"password-cannot-be-same": "Heslo se nesmí shodovat s předchozím heslem",
			"incorrect-password": "Nesprávné heslo",
			"complete-account": "Vypadá to, že potřebujete <a href='%{href}'>dokončit nastavení svého účtu</a>.",
			"completing-allows": "Až si nastavení účtu dokončíte, budete moci číst knihy offline v našich mobilních aplikacích a sdílet poznámky či zvýraznění s přáteli.",
			"error-updating-info": "There was an error updating your information.",
			"password-updated": "Password successfully updated",
			"security-updated": "Security question successfully updated",
			"info-updated": "User information successfully updated"
		},
		"resources": {
			"ancillaries": "Dodatky",
			"access-codes": "Přístupové kódy",
			"print-on-demand": "Tisk na vyžádání",
			"check-pod": "Seznamte se s vydavatelskými možnostmi tisku vašich knih.",
			"check-now": "Zkontrolovat",
			"loading": "Vydržte, aktualizujeme vaše zdroje!",
			"in": "v",
			"access-code-intro": "Přístupový kód je heslo sloužící k přístupu k obsahu kurzů online. Jakmile odhalíte kód položky, už ji nebude možné vrátit. Další informace o použití přístupových kódů vám poskytne <a href='%{support_url}' target='_blank'>podpora</a>.",
			"expires": "Platí do",
			"expiration-message": "Obsahuje pokyny k použití přístupového kódu.",
			"copy-fail": "Zkopírování není možné. Vyberte kód a zkopírujte jej ručně.",
			"launch-site": "Spustit stránky",
			"launch-book": "Spustit knihu",
			"reveal-code": "Odhalit kód",
			"no-resources": "Nemáte žádné zdroje.",
			"no-access-codes": "Nemáte žádné přístupové kódy.",
			"no-ancillaries": "Pro tento titul nejsou dostupné žádné dodatky",
			"name": "Jméno",
			"type": "Typ",
			"size": "Velikost",
			"download-all": "Stáhnout vše",
			"back": "Zpět na zdroje"
		},
		"refunds": {
			"states": {
				"refunded": "Vráceny peníze",
				"unavailable": "Vrácení peněz není k dispozici"
			},
			"reasons": {
				"dropped": "Zanechal(a) jsem kurzu",
				"wrong": "Tohle byla nesprávná kniha pro můj kurz",
				"print": "Rozhodl(a) jsem se namísto toho koupit si tištěnou verzi",
				"missing": "Kniha neobsahuje vše, co potřebuji pro svůj kurz (např. disk CD, webový přístup, videa)",
				"other": "Jiné"
			},
			"bulk": {
				"policy": "Kliknutím na níže uvedené tlačítko „Dokončit vrácení peněz“ vyjadřuji souhlas s <a href='%{policy_url}' target='_blank'>pravidly pro vracení peněz</a>společnosti %{brand}.",
				"complete": "Dokončit vrácení peněz",
				"view-details": "Zobrazit podrobnosti o vrácení peněz",
				"success": "Byla podána žádost o vrácení peněz. Vyčkejte prosím 48 hodin na zpracování.",
				"failure": "Jejda, něco se pokazilo. Vrácení peněz bohužel nebylo realizováno.",
				"retry": "Zkuste to znovu",
				"support": "Kontaktovat oddělení podpory",
				"available-codes": "Dostupné kódy",
				"codes-selected": "Vybrané kódy",
				"download": "Stáhnout kódy",
				"partially-refunded": "Částečné vrácení peněz",
				"pick-one": "Chcete-li vrátit peníze, je nutné vybrat alespoň jeden kód"
			},
			"refund": "Vrátit peníze",
			"all": "Vrátit peníze za vše?",
			"missing-reason": "Chcete-li pokračovat, je nutné vybrat důvod",
			"missing-elaboration": "Upřesněte",
			"policy": "Kliknutím na níže uvedené tlačítko „Dokončit žádost o vrácení peněz“ vyjadřuji své pochopení skutečnosti, že v případě opakovaného nákupu této elektronické učebnice ve službě %{brand} přijdu o nárok na vrácení peněz za tuto učebnici. Podívejte se na úplné znění zásad pro vracení.",
			"refunded": "Vráceny peníze",
			"sorry": "Je nám líto, že jste s nákupem nebyli spokojeni.",
			"error": "Došlo k chybě",
			"error-explain": "Vrácení peněz nebylo možné zpracovat. Zkuste to znovu.",
			"why": "Povíte nám důvod?",
			"no-refunds": "Nemáte žádné položky, za které vám byly vráceny peníze.",
			"select-codes": "Vyberte kódy, za které chcete vrátit peníze:",
			"number": "Kolik?",
			"back": "Zpět na vrácení peněz"
		},
		"purchases": {
			"back": "Zpět na nákupy"
		},
		"global-bar": {
			"account": "Nastavení účtu"
		}
	};

/***/ },
/* 972 */
/***/ function(module, exports) {

	module.exports = {
		"base": {
			"welcome": "Croeso i Mulligans, %{name}!",
			"user": "Gwybodaeth Defnyddiwr",
			"devices": "Dyfeisiau",
			"refunds": "Ad-daliadadau",
			"resources": "Adnoddau",
			"transactions": "Archebion a Dychweliadau",
			"email": "E-bost",
			"password": "Cyfrinair",
			"save": "Cadw",
			"sign-out": "Allgofnodi",
			"cancel": "Canslo",
			"close": "Cau",
			"learn-more": "Dysgwch fwy",
			"required": "a Fynnir",
			"support": "Cymorth",
			"bookshelf": "Bookshelf",
			"launch": "Lansio",
			"download": "Llwytho i Lawr",
			"details": "Manylion",
			"cannot-be-blank": "Ni all %{field} fod yn wag.",
			"saving": "Yn arbed...",
			"done": "Wedi gorffen",
			"failed": "Wedi methu",
			"copy": "Copïo"
		},
		"signin": {
			"login-failure": "Mae'r e-bost neu'r cyfrinair yn anghywir",
			"welcome-large": "Croeso i  <span class='inner'>Ganolfan Cyfrif %{brand}</span>",
			"welcome-small": "<span class='inner'>Canolfan Gyfrif</span>",
			"signin-button": "Mewngofnodi",
			"forgot-password": "Ydych chi wedi anghofio eich cyfrinair?",
			"new-to-vst": "Ydych chi'n newydd i %{brand}?",
			"create-account": "Crëwch gyfrif",
			"signing-in": "Mewngofnodi...",
			"signin-failed": "Ni wnaethoch fewngofnodi'n llwyddianus"
		},
		"transactions": {
			"price": "Pris",
			"excluded": "(Ac eithrio treth)",
			"quantity": "Maint",
			"confirmation#": "Cadarnhad #",
			"payment": "Taliad",
			"purchased": "Wedi'u prynu",
			"purchase-details": "Manylion Taliad",
			"subtotal": "Is-gyfanswm",
			"total": "Cyfanswm",
			"tax": "Treth",
			"loading": "Helo siopwr! Rydym ni'n llwytho eich pryniannau ...",
			"no-purchases": "Nid oes gennych unrhyw bryniannau.",
			"seller-vat": "TAW y gwerthwr",
			"total-vat": "Cyfanswm %{vat} TAW a Dalwyd",
			"portion": "%{subTax} Tax %{rate}%",
			"vat-disclosure": "Mae'r Pris yn Cynnwys %{vat}",
			"purchases": "Pryniannau",
			"refunded-items": "Eitemau Wedi'u Had-dalu",
			"book-title": "Teitl y Llyfr",
			"refund-details": "Manylion Ad-daliad",
			"print-receipt": "Argraffwch Dderbynneb",
			"request-refund": "Gwnewch Gais am Ad-daliad",
			"expired": "Wedi dod i ben",
			"expires-in": "Mae'n dod i ben ar %{date}",
			"details-refund": "Manylion ac Ad-daliad",
			"modal": {
				"cant-refund-title": "Nid oes Ad-daliad ar Gael",
				"cant-refund": "Ni ellir ad-dalu eich llyfr o ganlyniad i un o'r rhesymau canlynol:",
				"cant-refund-1": "Mae gormod o'ch llyfr wedi'u gweld.",
				"cant-refund-2": "Mae mwy na 14 diwrnod wedi mynd heibio ers i'r dyddiad prynu.",
				"cant-refund-3": "Datgelir eich cod adnoddau ar-lein.",
				"cant-refund-4": "Mae eich llyfr wedi'i ad-dalu yn flaenorol.",
				"cant-refund-5": "Mae pob cod eisoes wedi ei ddefnyddio a/neu ei ad-dalu.",
				"cant-refund-6": "Mae hi wedi bod mwy na 30 diwrnod o'r dyddiad prynu.",
				"cant-refund-support": "Os ydych chi'n dal i fod yn ansicr o bolisi ad-dalu %{brand}, cysylltwch â'n <a href='%{support_url}' target='_blank'> tîm cefnogi</a>."
			},
			"license": {
				"perpetual": "Nid yw mynediad ar-lein yn dod i ben",
				"days": "Mynediad %{days} diwrnod"
			}
		},
		"devices": {
			"description": "Mae %{brand} yn eich caniatáu i <span>actifadu cyfrifiaduron %{desktop}</span>  a dyfeisiau symudol  <span>%{mobile}</span> ar unrhyw adeg.",
			"loading": "Helo! Rydym ni'n dod o hyd i'ch dyfeisiau :)",
			"no-active": "Nid oes gennych ddyfeisiau sydd wedi'u hactifadu.",
			"deactivate": "Dirymu"
		},
		"user": {
			"personal-information": "Gwybodaeth Bersonol",
			"security-information": "Gwybodaeth am Ddiogelwch",
			"notifications": "Hysbysiadau",
			"first-name": "Enw cyntaf",
			"last-name": "Cyfenw",
			"change-password-title": "Newidiwch eich Cyfrinair",
			"current-password": "Cyfrinair presennol",
			"new-password": "Cyfrinair Newydd",
			"security-password": "Cyfrinair",
			"confirm-new-password": "Cadarnhau'r Cyfrinair Newydd",
			"security-question": "Cwestiwn Diogelwch",
			"security-info-change": "Newid",
			"question": "Cwestiwn",
			"answer": "Ateb",
			"notifications-text": "E-bostiwch ddiweddariadau achlysurol am fy ngweithgareddau ar fy nghyfrif, diweddariadau am gynhyrchion, a chynigion arbennig.",
			"loading": "Mae Spot yn chwilio am eich gwybodaeth defnyddiwr, arhoswch eiliad",
			"change-password-text": "Rhaid i gyfrinair gynnwys o leiaf 8 cymeriad, priflythyren, a chymeriad arbennnig.",
			"email-locked": "E-bost ar Glo",
			"email-locked-description": "Nid oes gennych fynediad i newid eich e-bost.",
			"email-locked-more": "Cysylltwch â'ch gweinyddwr.",
			"security-question6": "Beth yw eich hoff chwaraeon?",
			"security-question7": "Beth yw eich hoff flas hufen iâ?",
			"security-question8": "Beth yw enw eich hoff anifail anwes?",
			"security-question9": "Pan oeddech yn ifancach, beth oeddech eisiau bod ar ôl tyfu i fyny?",
			"security-question10": "Beth oedd cyfenw eich hoff athro?",
			"new-password-failure": "Nid yw'r cyfrinair yn bodloni'r gofynion",
			"confirm-password-failure": "Rhaid i'r cyfrinair gyd-fynd",
			"new-password-tooltip": "Rhaid iddo gynnwys o leiaf 8 cymeriad, priflythyren, llythyren fach, a chymeriad arbennig.",
			"enter-valid-email": "Nodwch e-bost dilys.",
			"password-cannot-be-same": "Ni all y cyfrinair fod yr un peth na'r cyfrinair blaenorol",
			"incorrect-password": "Cyfrinair Anghywir",
			"complete-account": "Mae'n edrych yn debyg eich bod angen <a href='%{href}'>cwblhau'ch cyfrif</a>.",
			"completing-allows": "Mae cwblhau'ch cyfrif yn caniatáu ichi ddarllen llyfrau all-lein ar ein hapiau symudol a rhannu nodiadau ac amlygiadau â ffrindiau.",
			"error-updating-info": "There was an error updating your information.",
			"password-updated": "Password successfully updated",
			"security-updated": "Security question successfully updated",
			"info-updated": "User information successfully updated"
		},
		"resources": {
			"ancillaries": "Cynorthwywyr",
			"access-codes": "Codau Mynediad",
			"print-on-demand": "Argraffu Ar Alw",
			"check-pod": "Gwiriwch opsiynau printio cyhoeddwr ar gyfer eich llyfrau.",
			"check-now": "Gwiriwch nawr",
			"loading": "Aroswch eiliad; rydym ni'n diweddaru eich adnoddau!",
			"in": "yn",
			"access-code-intro": "Cod mynediad yw cyfrinair yr ydych chi'n ei ddefnyddio i gael mynediad i gynnwys cwrs ar-lein. Unwaith yr ydych chi'n datgelu cod ar gyfer eitem, ni fyddwch chi'n gallu ei ddychwelyd. I gael mwy o gyfeiriadau ar sut i ddefnyddio eich codau mynediad, ewch i <a href='%{support_url}' target='_blank'>Gefnogaeth</a>.",
			"expires": "Mae'n dod i ben.",
			"expiration-message": "Mae'n cynnwys cyfeiriadau ar gyfer defnyddio eich cod mynediad.",
			"copy-fail": "Nid yw'n bosib ei gopïo. Dewiswch y cod a'i gopio â dwylo.",
			"launch-site": "Lansiwch y Safle",
			"launch-book": "Lansio Llyfr",
			"reveal-code": "Datgelwch Gôd",
			"no-resources": "Nid oes gennych unrhyw adnodd.",
			"no-access-codes": "Nid oes gennych unrhyw godau mynediad.",
			"no-ancillaries": "Nid oes unrhyw beth ategol ar gyfer y teitl hwn",
			"name": "Enw",
			"type": "Teip",
			"size": "Maint",
			"download-all": "Lawrlwytho Popeth",
			"back": "Yn ôl i adnoddau"
		},
		"refunds": {
			"states": {
				"refunded": "Ad-dalwyd",
				"unavailable": "Nid yw Ad-daliad ar Gael"
			},
			"reasons": {
				"dropped": "Rydw i wedi rhoi'r gorau i'r cwrs",
				"wrong": "Nid oedd y llyfr hwn yn addas i fy nghwrs i",
				"print": "Penderfynais i brynu fersiwn caled yn lle.",
				"missing": "Nid yw'r llyfr yn cynnwys popeth sydd angen arnaf ar gyfer fy nghwrs (e.e. CD, mynediad we, fideos)",
				"other": "Arall"
			},
			"bulk": {
				"policy": "Trwy glicio ar y botwm &quot;Cwblhau Ad-daliad&quot; isod, rydw i'n cytuno â pholisi ad-dalu'r %{brand}. <a href='%{policy_url}' target='_blank'></a>",
				"complete": "Ad-daliad Llawn",
				"view-details": "Gweld Manylion yr Ad-daliad",
				"success": "Gofynnwyd am eich ad-daliad. Arhoswch 48 awr ar gyfer prosesu os gwelwch yn dda.",
				"failure": "Wps - aeth rhywbeth o'i le! Yn anffodus ni aeth eich ad-daliad fynd trwodd.",
				"retry": "Trïwch Eto",
				"support": "Cysylltu â'r tîm Cymorth",
				"available-codes": "Codau Ar Gael",
				"codes-selected": "Codau a Ddewiswyd",
				"download": "Lawrlwytho Codau",
				"partially-refunded": "Wedi'i Ad-dalu'n Rhannol",
				"pick-one": "Mae rhaid i chi ddewis o leiaf un cod er mwyn gwneud ad-daliad"
			},
			"refund": "Ad-daliad",
			"all": "Ad-dalu pob un?",
			"missing-reason": "Rhaid i chi ddewis rheswm er mwyn mynd yn eich blaen",
			"missing-elaboration": "Manylwch, os gwelwch chi'n dda",
			"policy": "Drwy glicio \"Cwblhau Cais am Ad-daliad\" isod, rwy'n deall ni fyddaf yn gymwys i wneud cais am unrhyw ad-daliadau pellach ar gyfer yr un llyfr electronig. Gwelwch y polisi dychwelyd yn llawn.",
			"refunded": "Ad-dalwyd",
			"sorry": "Rydym ni'n ymddiheuro nad oeddech chi'n hapus gyda'ch pryniad.",
			"error": "Roedd rhywbeth o'i le",
			"error-explain": "Nid oedd yn bosib i ni brosesu eich ad-daliad. Ceisiwch eto.",
			"why": "Beth yw eich rhesymau dros wneud cais am ad-daliad?",
			"no-refunds": "Nid oes genych eitemau wedi'u ad-dalu.",
			"select-codes": "Dewiswch y cod(au) i ad-dalu:",
			"number": "Faint?",
			"back": "Yn ôl i ad-daliadau"
		},
		"purchases": {
			"back": "Yn ôl i bryniadau"
		},
		"global-bar": {
			"account": "Gosodiadau Cyfrif"
		}
	};

/***/ },
/* 973 */
/***/ function(module, exports) {

	module.exports = {
		"base": {
			"welcome": "Velkommen til Mulligans, %{name}!",
			"user": "Brugeroplysninger",
			"devices": "Enheder",
			"refunds": "Refunderinger",
			"resources": "Resourcer",
			"transactions": "Ordrer & Returneringer",
			"email": "E-mail",
			"password": "Adgangskode",
			"save": "Gem",
			"sign-out": "Log af",
			"cancel": "Annuller",
			"close": "Luk",
			"learn-more": "Lær mere",
			"required": "Påkrævet",
			"support": "Support",
			"bookshelf": "Boghylde",
			"launch": "Start",
			"download": "Download",
			"details": "Detaljer",
			"cannot-be-blank": "%{field} må ikke være tomt.",
			"saving": "Gemmer...",
			"done": "Udført",
			"failed": "Mislykkedes",
			"copy": "Kopiér"
		},
		"signin": {
			"login-failure": "E-mail eller adgangskode er forkert",
			"welcome-large": "Velkommen til <span class='inner'>%{brand} Kontocenter</span>",
			"welcome-small": "<span class='inner'>Account Center</span>",
			"signin-button": "Log på",
			"forgot-password": "Har du glemt din adgangskode",
			"new-to-vst": "Ny til %{brand}?",
			"create-account": "Opret en konto",
			"signing-in": "Logger på...",
			"signin-failed": "Log-in slog fejl"
		},
		"transactions": {
			"price": "Pris",
			"excluded": "(Ekskl. moms)",
			"quantity": "Antal",
			"confirmation#": "Bekræftelse #",
			"payment": "Betaling",
			"purchased": "Købt",
			"purchase-details": "Købsdetaljer",
			"subtotal": "Mellemregning",
			"total": "I alt",
			"tax": "Skat",
			"loading": "Hej med dig, vi henter dine transaktioner...",
			"no-purchases": "Du har ikke nogen køb.",
			"seller-vat": "Sælger MOMS",
			"total-vat": "%{vat} betalt i alt",
			"portion": "%{subTax} Skat %{rate}%",
			"vat-disclosure": "Pris inkluderer %{vat}",
			"purchases": "Køb",
			"refunded-items": "Refunderede varer",
			"book-title": "Bogtitel",
			"refund-details": "Refunderingsoplysninger",
			"print-receipt": "Udskriv kvittering",
			"request-refund": "Bed om refundering",
			"expired": "Udløbet",
			"expires-in": "Udløber %{date}",
			"details-refund": "Detaljer og refundering",
			"modal": {
				"cant-refund-title": "Refundering ikke tilgængelig",
				"cant-refund": "Din bog kan ikke refunderes af en af de følgende årsager.",
				"cant-refund-1": "Du har læst for stor en del af din bog.",
				"cant-refund-2": "Der er gået mere end 14 dage siden købsdatoen.",
				"cant-refund-3": "Din online ressource-kode er blevet vist.",
				"cant-refund-4": "Din bog er allerede blevet refunderet.",
				"cant-refund-5": "Alle koder er allerede blevet indløst og/eller refunderet.",
				"cant-refund-6": "Der er gået mere end 30 dage fra købsdatoen.",
				"cant-refund-support": "Hvis du ikke er sikker på %{brand} refunderingspolitik kan du kontakte <a href='%{support_url}' target='_blank'>support</a>."
			},
			"license": {
				"perpetual": "Online adgang udløber ikke",
				"days": "%{days} daglig adgang"
			}
		},
		"devices": {
			"description": "%{brand} lader dig have <span>%{desktop}</span> computere og <span>%{mobile}</span> mobile/tablet enheder aktiveret på samme tid.",
			"loading": "Hej, vi henter dine enheder :)",
			"no-active": "Du har ikke nogen aktive enheder.",
			"deactivate": "Deaktiver"
		},
		"user": {
			"personal-information": "Personlige oplysninger",
			"security-information": "Sikkerhedsoplysninger",
			"notifications": "Meddelelser",
			"first-name": "Fornavn",
			"last-name": "Efternavn",
			"change-password-title": "Ændre adgangskode",
			"current-password": "Nuværende adgangskode",
			"new-password": "Ny adgangskode",
			"security-password": "Adgangskode",
			"confirm-new-password": "Bekræft ny adgangskode",
			"security-question": "Sikkerhedsspørgsmål",
			"security-info-change": "Skift",
			"question": "Spørgmål",
			"answer": "Svar",
			"notifications-text": "Send mig lejlighedsvise opdateringer med email om aktivitet på min konto, produktopdateringer og specielle tilbud.",
			"loading": "Spot henter dine brugeroplysninger, lige et øjeblik 🐶",
			"change-password-text": "Adgangskoden skal indeholde mindst 8 tegn, et stort bogstav, et lille bogstav og et specielt tegn.",
			"email-locked": "Email låst",
			"email-locked-description": "Du har ikke adgang til at ændre din email.",
			"email-locked-more": "Kontakt venligst din administrator.",
			"security-question6": "Hvad er din favoritsport?",
			"security-question7": "Hvad er din favoritsmag på is?",
			"security-question8": "Hvad hedder dit favorit-kæledyr?",
			"security-question9": "Da du var lille, hvad ville du være, når du blev voksen?",
			"security-question10": "Hvad hed din favorit-lærer til efternavn?",
			"new-password-failure": "Adgangskoden opfylder ikke kravene",
			"confirm-password-failure": "Adgangskoderne skal være ens",
			"new-password-tooltip": "Skal indeholde mindst 8 tegn, et stort bogstav, et lille bogstav og et specielt tegn.",
			"enter-valid-email": "Indtast venligst en gyldig e-mail.",
			"password-cannot-be-same": "Adgangskoden må ikke være den samme, som den du brugte tidligere",
			"incorrect-password": "Forkert adgangskode",
			"complete-account": "Det ser ud til at du skal <a href='%{href}'>udfylde din konto.</a>",
			"completing-allows": "Når du udfylder din konto, kan du læse bøger offline på dine mobile apps og dele notater og anmærkninger med venner.",
			"error-updating-info": "There was an error updating your information.",
			"password-updated": "Password successfully updated",
			"security-updated": "Security question successfully updated",
			"info-updated": "User information successfully updated"
		},
		"resources": {
			"ancillaries": "Tilbehør",
			"access-codes": "Adgangskoder",
			"print-on-demand": "Udskriv ",
			"check-pod": "Tjek forlagets printmuligheder for dine bøger.",
			"check-now": "Tjek nu",
			"loading": "Vent, vi opdaterer dine ressourcer!",
			"in": "ind",
			"access-code-intro": "En adgangskode er et kodeord, som du bruger til at få adgang til kursusindhold online. Når du viser en kode til et element, kan du ikke gå tilbage til den. For at få flere oplysninger om, hvordan du bruger adgangskoder, gå til <a href='%{support_url}' target='_blank'>support</a>.",
			"expires": "Udløber",
			"expiration-message": "Indeholder oplysninger om hvordan du bruger adgangskoder.",
			"copy-fail": "Kan ikke kopiere. Vælg koden og kopier den manuelt.",
			"launch-site": "Start hjemmesiden",
			"launch-book": "Start bog",
			"reveal-code": "Vis kode",
			"no-resources": "Du har ikke nogen ressourcer.",
			"no-access-codes": "Du har ikke nogen adgangskoder.",
			"no-ancillaries": "Ikke noget tilbehør til denne titel",
			"name": "Navn",
			"type": "Type",
			"size": "Størrelse",
			"download-all": "Download alle",
			"back": "Tilbage til ressourcer"
		},
		"refunds": {
			"states": {
				"refunded": "Refunderet",
				"unavailable": "Refundering ikke tilgængelig"
			},
			"reasons": {
				"dropped": "Jeg sprang fra kurset",
				"wrong": "Det var den forkerte bog til mit kursus",
				"print": "Jeg bestemte mig til at købe bogen i stedet",
				"missing": "Bogen indeholder ikke alt, hvad jeg skal bruge til mit kursus (dvs. en CD, web adgang, videoer)",
				"other": "Andet"
			},
			"bulk": {
				"policy": "Ved at klikke på &quot;Fuld refundering&quot; nedenfor, accepterer jeg %{brand}s <a href='%{policy_url}' target='_blank'>refunderingspolitik</a>.",
				"complete": "Fuld refundering",
				"view-details": "Se refunderingsdetaljer",
				"success": "Du har anmodet om refundering. Vent 48 timer, mens anmodningen behandles.",
				"failure": "Hov - der opstod en fejl! Uheldigvis gik din refundering ikke igennem.",
				"retry": "Prøv igen",
				"support": "Kontakt support",
				"available-codes": "Tilgængelige koder",
				"codes-selected": "Valgte koder ",
				"download": "Download koder",
				"partially-refunded": "Delvist refunderet",
				"pick-one": "Du skal vælge mindst en kode for at få en refundering"
			},
			"refund": "Refunder",
			"all": "Refunder alle?",
			"missing-reason": "Du skal vælge en grund for at fortsætte",
			"missing-elaboration": "Uddyb venligst",
			"policy": "Ved at klikke på \"Færdiggør refunderingsanmodning\" nedenfor, accepterer jeg, at hvis jeg køber denne %{brand} e lærebog igen, vil jeg ikke kunne bede om flere refunderinger for den samme lærebog. Se refunderingspolitik.",
			"refunded": "Refunderet",
			"sorry": "Vi beklager at du ikke var tilfreds med dit køb.",
			"error": "Der gik noget galt",
			"error-explain": "Vi kunne ikke behandle din refundering. Prøv igen.",
			"why": "Fortæl hvorfor?",
			"no-refunds": "Du har ikke nogen refunderede elementer.",
			"select-codes": "Vælg kode(r) der skal refunderes:",
			"number": "Hvor mange?",
			"back": "Tilbage til refunderinger"
		},
		"purchases": {
			"back": "Tilbage til køb"
		},
		"global-bar": {
			"account": "Kontoindstillinger"
		}
	};

/***/ },
/* 974 */
/***/ function(module, exports) {

	module.exports = {
		"base": {
			"welcome": "Willkommen bei Mulligans, %{name}!",
			"user": "Benutzerinfo",
			"devices": "Geräte",
			"refunds": "Rückerstattung",
			"resources": "Ressourcen",
			"transactions": "Bestellungen und Rücksendungen",
			"email": "E-Mail",
			"password": "Kennwort",
			"save": "Speichern",
			"sign-out": "Abmelden",
			"cancel": "Abbrechen",
			"close": "Schließen",
			"learn-more": "Erfahren Sie mehr",
			"required": "Erforderlich",
			"support": "Support",
			"bookshelf": "Bücherregal",
			"launch": "Starten",
			"download": "Download",
			"details": "Details",
			"cannot-be-blank": "%{field} darf nicht leer sein.",
			"saving": "Speichern…",
			"done": "Fertig",
			"failed": "Fehlgeschlagen",
			"copy": "Kopieren"
		},
		"signin": {
			"login-failure": "E-Mail oder Passwort ist falsch",
			"welcome-large": "Willkommen beim <span class='inner'>%{brand} Account Center</span>",
			"welcome-small": "<span class='inner'>Account Center</span>",
			"signin-button": "Anmelden",
			"forgot-password": "Passwort vergessen?",
			"new-to-vst": "Neu bei %{brand}?",
			"create-account": "Ein Konto erstellen",
			"signing-in": "Anmelden...",
			"signin-failed": "Anmelden fehlgeschlagen"
		},
		"transactions": {
			"price": "Preis",
			"excluded": "(Ohne MwSt.)",
			"quantity": "Menge",
			"confirmation#": "Bestätigung #",
			"payment": "Zahlung",
			"purchased": "Gekauft",
			"purchase-details": "Einkaufsdetails",
			"subtotal": "Zwischensumme",
			"total": "Gesamt",
			"tax": "Steuern",
			"loading": "Hallo Käufer, wir laden Ihre Transaktionen...",
			"no-purchases": "Sie haben keine Käufe.",
			"seller-vat": "MwSt. Verkäufer",
			"total-vat": "Gezahlte %{vat} insgesamt",
			"portion": "%{subTax} MwSt. %{rate}%",
			"vat-disclosure": "Preis beinhaltet %{vat}",
			"purchases": "Käufe",
			"refunded-items": "Rückerstattete Artikel",
			"book-title": "Buchtitel",
			"refund-details": "Details zur Rückerstattung",
			"print-receipt": "Beleg ausdrucken",
			"request-refund": "Rückerstattung anfordern",
			"expired": "Abgelaufen",
			"expires-in": "Läuft ab: %{date}",
			"details-refund": "Details & Rückerstattung",
			"modal": {
				"cant-refund-title": "Rückerstattung nicht verfügbar",
				"cant-refund": "Ihr Buch kann aus einem oder mehreren der folgenden Gründe nicht rückerstattet werden.",
				"cant-refund-1": "Ein zu großer Teil des Buchs wurde angesehen.",
				"cant-refund-2": "Seit dem Kaufdatum sind mehr als 14 Tage verstrichen.",
				"cant-refund-3": "Ihr Online-Ressourcen-Code wurde angezeigt.",
				"cant-refund-4": "Das Buch wurde bereits rückerstattet.",
				"cant-refund-5": "Alle Codes wurden bereits eingelöst und/oder rückerstattet.",
				"cant-refund-6": "Seit dem Kaufdatum sind mehr als 30 Tage verstrichen.",
				"cant-refund-support": "Wenn Sie noch Fragen zu den Rückerstattungsbestimmungen von %{brand} haben, kontaktieren Sie den <a href='%{support_url}' target='_blank'>Support</a>."
			},
			"license": {
				"perpetual": "Der Online-Zugang läuft nicht ab",
				"days": "%{days}-tägiger Zugang"
			}
		},
		"devices": {
			"description": "%{brand} erlaubt Ihnen, <span>%{desktop}</span> Computer und <span>%{mobile}</span> Mobilgeräte/Tablets jederzeit aktiviert zu haben.",
			"loading": "Hi, wir rufen Ihre Geräte ab :)",
			"no-active": "Sie haben keine aktiven Geräte.",
			"deactivate": "Deaktivieren"
		},
		"user": {
			"personal-information": "Persönliche Informationen",
			"security-information": "Sicherheitsinformationen",
			"notifications": "Benachrichtigungen",
			"first-name": "Vorname",
			"last-name": "Nachname",
			"change-password-title": "Kennwort ändern",
			"current-password": "Aktuelles Passwort",
			"new-password": "Neues Kennwort",
			"security-password": "Kennwort",
			"confirm-new-password": "Neues Kennwort bestätigen",
			"security-question": "Sicherheitsfrage",
			"security-info-change": "Ändern",
			"question": "Frage",
			"answer": "Antwort",
			"notifications-text": "Senden Sie mir gelegentlich Updates zu meiner Kontoaktivität, Produkt-Updates und Sonderangeboten zu.",
			"loading": "Rex ist auf der Suche nach Ihren Benutzerinformationen, eine Sekunde 🐶",
			"change-password-text": "Passwörter müssen mind. 8 Zeichen und davon mind. einen Großbuchstaben, einen Kleinbuchstaben und ein Sonderzeichen enthalten.",
			"email-locked": "E-Mail gesperrt",
			"email-locked-description": "Sie haben keinen Zugang zum Ändern Ihrer E-Mail.",
			"email-locked-more": "Bitte kontaktieren Sie Ihren Administrator.",
			"security-question6": "Welcher ist Ihr Lieblingssport?",
			"security-question7": "Welche Geschmacksrichtung hat Ihr Lieblingseis?",
			"security-question8": "Wie ist der Name Ihres Lieblingstiers?",
			"security-question9": "Als Sie jung waren, was wollten Sie als Erwachsener werden?",
			"security-question10": "Wie ist der Nachname Ihres Lieblingslehrers?",
			"new-password-failure": "Das Passwort erfüllt die Anforderungen nicht",
			"confirm-password-failure": "Das Passwort muss übereinstimmen",
			"new-password-tooltip": "Das Passwort muss mind. 8 Zeichen und davon mind. einen Großbuchstaben, einen Kleinbuchstaben und ein Sonderzeichen enthalten.",
			"enter-valid-email": "Bitte geben Sie eine gültige E-Mail-Adresse ein.",
			"password-cannot-be-same": "Das Passwort darf nicht das gleiche wie das vorherige Passwort sein",
			"incorrect-password": "Falsches Passwort",
			"complete-account": "Anscheinend musst du <a href='%{href}'>dein Konto abschließen</a>.",
			"completing-allows": "Wenn du dein Konto abschließt, kannst du Bücher offline auf deinen Mobil-Apps lesen und Notizen mit Freunden teilen und markieren.",
			"error-updating-info": "There was an error updating your information.",
			"password-updated": "Password successfully updated",
			"security-updated": "Security question successfully updated",
			"info-updated": "User information successfully updated"
		},
		"resources": {
			"ancillaries": "Zusätzliche Ressourcen",
			"access-codes": "Zugangscodes",
			"print-on-demand": "Print-on-Demand",
			"check-pod": "Druckoptionen des Verlags für Ihre Bücher prüfen.",
			"check-now": "Jetzt prüfen",
			"loading": "Bitte warten Sie, wir aktualisieren Ihre Ressourcen.",
			"in": "in",
			"access-code-intro": "Ein Zugangscode ist ein Passwort, das Sie verwenden, um auf Kursinhalte online zuzugreifen. Wenn Sie einen Code für einen Artikel angezeigt haben, können Sie diesen Artikel nicht mehr zurückgeben. Für weitere Informationen zur Verwendung Ihrer Zugangscodes, besuchen Sie den <a href='%{support_url}' target='_blank'>Support</a>.",
			"expires": "Läuft ab:",
			"expiration-message": "Enthält Anweisungen zur Verwendung Ihres Zugangscodes.",
			"copy-fail": "Kopieren nicht möglich. Bitte wählen Sie den Code aus und kopieren Sie ihn manuell.",
			"launch-site": "Site starten",
			"launch-book": "Buch starten",
			"reveal-code": "Code anzeigen",
			"no-resources": "Sie haben keine Ressourcen.",
			"no-access-codes": "Sie haben keine Zugangscodes.",
			"no-ancillaries": "Keine zusätzlichen Ressourcen für diesen Titel",
			"name": "Name",
			"type": "Typ",
			"size": "Größe",
			"download-all": "Alles herunterladen",
			"back": "Zurück zu Ressourcen"
		},
		"refunds": {
			"states": {
				"refunded": "Rückerstattet",
				"unavailable": "Rückerstattung nicht verfügbar"
			},
			"reasons": {
				"dropped": "Ich habe den Kurs gestrichen",
				"wrong": "Dies war das falsche Buch für meinen Kurs",
				"print": "Ich habe stattdessen die Druckversion gekauft",
				"missing": "Das Buch enthält nicht alles, was ich für meinen Kurs benötige (z.B. eine CD, Webzugang, Videos)",
				"other": "Sonstiges"
			},
			"bulk": {
				"policy": "Durch Klicken auf die Schaltfläche „Rückerstattung abschließen“ unten, stimme ich den Rückerstattungsbestimmungen von %{brand} <a href='%{policy_url}' target='_blank'>zu</a>.",
				"complete": "Rückerstattung abschließen",
				"view-details": "Details zur Rückerstattung ansehen",
				"success": "Deine Rückerstattung wurde angefordert. Bitte warte 48 Stunden auf die Verarbeitung.",
				"failure": "Huch! Etwas ist schiefgegangen! Leider ist Ihre Rückerstattung nicht abgeschlossen.",
				"retry": "Versuchen Sie es erneut",
				"support": "Support kontaktieren",
				"available-codes": "Erhältliche Codes",
				"codes-selected": "Ausgewählte Codes",
				"download": "Codes herunterladen",
				"partially-refunded": "Teilweise rückerstattet",
				"pick-one": "Sie müssen mindestens einen Code für eine Rückerstattung auswählen"
			},
			"refund": "Rückerstatten",
			"all": "Alles rückerstatten?",
			"missing-reason": "Sie müssen einen Grund auswählen, um fortzufahren",
			"missing-elaboration": "Bitte genauer angeben",
			"policy": "Wenn Sie auf die Schaltfläche „Anforderung der Rückerstattung abschließen“ unten klicken, stimmen Sie zu, dass Sie bei einem erneuten Kauf dieses %{brand} eTextbooks keine weiteren Rückerstattungen für das selbe eTextbook anfragen können. Die vollständigen Rückgaberichtlinien anzeigen.",
			"refunded": "Rückerstattet",
			"sorry": "Es tut uns leid, dass Sie mit Ihrem Kauf nicht zufrieden waren.",
			"error": "Etwas ist schiefgegangen",
			"error-explain": "Wir konnten Ihre Rückerstattung nicht verarbeiten. Versuchen Sie es bitte erneut.",
			"why": "Wir möchten wissen warum",
			"no-refunds": "Sie haben keine rückerstatteten Artikel.",
			"select-codes": "Wählen Sie Code (s) zur Rückerstattung:",
			"number": "Wie viele?",
			"back": "Zurück zu Rückerstattungen"
		},
		"purchases": {
			"back": "Zurück zu Käufen"
		},
		"global-bar": {
			"account": "Kontoeinstellungen"
		}
	};

/***/ },
/* 975 */
/***/ function(module, exports) {

	module.exports = {
		"base": {
			"welcome": "Καλώς ορίσατε στο Mulligans %{name}.",
			"user": "Πληροφορίες χρήστη",
			"devices": "Συσκευές",
			"refunds": "Επιστροφές χρημάτων",
			"resources": "Πηγές",
			"transactions": "Παραγγελίες & Επιστροφές",
			"email": "Ηλεκτρονικό ταχυδρομείο",
			"password": "Κωδικός πρόσβασης",
			"save": "Αποθήκευση",
			"sign-out": "Έξοδος",
			"cancel": "Άκυρο",
			"close": "Κλείσιμο",
			"learn-more": "Περισσότερα",
			"required": "Απαιτούμενο",
			"support": "Υποστήριξη",
			"bookshelf": "Bookshelf",
			"launch": "Εκκίνηση",
			"download": "Λήψη",
			"details": "Λεπτομέρειες",
			"cannot-be-blank": "%{field} δεν μπορεί να είναι κενό.",
			"saving": "Αποθήκευση…",
			"done": "Τέλος",
			"failed": "Απέτυχε",
			"copy": "Αντιγραφή"
		},
		"signin": {
			"login-failure": "Η διεύθυνση ηλεκτρονικού ταχυδρομείου ή ο κωδικός πρόσβασής σας είναι εσφαλμένα",
			"welcome-large": "Καλώς ορίσατε στον  <span class='inner'>%{brand} λογαριασμό σας</span>",
			"welcome-small": "<span class='inner'>Λογαριασμός</span>",
			"signin-button": "Είσοδος",
			"forgot-password": "Ξεχάσατε τον κωδικό πρόσβασής σας;",
			"new-to-vst": "Νέος χρήστης του %{brand}; ",
			"create-account": "Δημιουργία λογαριασμού",
			"signing-in": "Είσοδος...",
			"signin-failed": "Η σύνδεση απέτυχε"
		},
		"transactions": {
			"price": "Τιμή",
			"excluded": "(Εξαιρείται ο φόρος)",
			"quantity": "Ποσότητα",
			"confirmation#": "Επιβεβαίωση #",
			"payment": "Πληρωμή",
			"purchased": "Αγοράστηκε",
			"purchase-details": "Στοιχεία αγοράς",
			"subtotal": "Μερικό σύνολο",
			"total": "Σύνολο",
			"tax": "Φόρος",
			"loading": "Χαίρετε καλέ μας πελάτη, φορτώνουμε τις συναλλαγές σας ...",
			"no-purchases": "Δεν έχετε αγορές.",
			"seller-vat": "ΦΠΑ Πωλητή",
			"total-vat": "Σύνολο %{vat} καταβληθέντος ποσού",
			"portion": "%{subTax} Φόρος %{rate}%",
			"vat-disclosure": "Η τιμή περιλαμβάνει %{vat}",
			"purchases": "Αγορές",
			"refunded-items": "Επιστρεφόμενα στοιχεία",
			"book-title": "Τίτλος βιβλίου",
			"refund-details": "Λεπτομέρειες για την επιστροφή χρημάτων",
			"print-receipt": "Εκτύπωση Απόδειξης",
			"request-refund": "Αίτημα επιστροφής χρημάτων",
			"expired": "Έληξε",
			"expires-in": "Ημερομηνία λήξης %{date}",
			"details-refund": "Λεπτομέρειες και επιστροφή χρημάτων",
			"modal": {
				"cant-refund-title": "Μη διαθέσιμη επιστροφή χρημάτων",
				"cant-refund": "Το βιβλίο σας δεν μπορεί να επιστραφεί για έναν ή περισσότερους από τους παρακάτω λόγους.",
				"cant-refund-1": "Μεγάλο τμήμα του βιβλίου σας έχει προβληθεί.",
				"cant-refund-2": "Έχουν περάσει περισσότερες από 14 ημέρες από την ημερομηνία αγοράς.",
				"cant-refund-3": "Ο διαδικτυακός κωδικός πηγών σας έχει αποκαλυφθεί.",
				"cant-refund-4": "Το βιβλίο σας έχει προηγουμένως επιστραφεί.",
				"cant-refund-5": "Όλοι οι κωδικοί έχουν ήδη εξαργυρωθεί ή / και έχει γίνει επιστροφή χρημάτων.",
				"cant-refund-6": "Έχουν περάσει περισσότερες από 30 ημέρες από την ημερομηνία αγοράς.",
				"cant-refund-support": "Αν δεν είστε σίγουροι για την πολιτική επιστροφής του%{brand} επικοινωνήστε  <a href='%{support_url}' target='_blank'>με το τμήμα υποστήριξης</a> ."
			},
			"license": {
				"perpetual": "Η ηλεκτρονική πρόσβαση δεν λήγει",
				"days": "%{days} Πρόσβαση ημέρας "
			}
		},
		"devices": {
			"description": "Το %{brand} σας επιτρέπει να <span>έχετε</span> %{desktop} υπολογιστές και <span>%{mobile}</span> συσκευές κινητών τηλεφώνων/tablet ενεργοποιημένα κάθε στιγμή.",
			"loading": "Αναζητούμε τις συσκευές σας :)",
			"no-active": "Δεν έχετε ενεργοποιημένες συσκευές.",
			"deactivate": "Απενεργοποίηση"
		},
		"user": {
			"personal-information": "Προσωπικά στοιχεία",
			"security-information": "Πληροφορίες ασφαλείας",
			"notifications": "Ειδοποιήσεις",
			"first-name": "Όνομα",
			"last-name": "Επώνυμο",
			"change-password-title": "Αλλαγή κωδικού πρόσβασης",
			"current-password": "Τρέχων κωδικός πρόσβασης",
			"new-password": "Νέος κωδικός πρόσβασης",
			"security-password": "Κωδικός πρόσβασης",
			"confirm-new-password": "Επιβεβαίωση νέου κωδικού πρόσβασης",
			"security-question": "Ερώτηση ασφαλείας",
			"security-info-change": "Αλλαγή",
			"question": "Ερώτηση",
			"answer": "Απάντηση",
			"notifications-text": "Να λαμβάνω περιστασιακά μηνύματα ηλεκτρονικού ταχυδρομείου με ενημερώσεις για τη δραστηριότητα του λογαριασμού μου και ειδικές προσφορές.",
			"loading": "Συλλέγουμε τις πληροφορίες χρήστη, μισό λεπτό🐶",
			"change-password-text": "Ο κωδικός πρόσβασης πρέπει να περιέχει τουλάχιστον 8 χαρακτήρες, ένα κεφαλαίο γράμμα, ένα πεζό γράμμα και έναν ειδικό χαρακτήρα.",
			"email-locked": "Το πεδίο email κλειδώθηκε",
			"email-locked-description": "Δεν έχετε πρόσβαση για να αλλάξετε το email σας.",
			"email-locked-more": "Επικοινωνήστε με το διαχειριστή.",
			"security-question6": "Ποιο είναι το αγαπημένο σας άθλημα;",
			"security-question7": "Ποιά είναι η αγαπημένη σας γεύση παγωτού;",
			"security-question8": "Ποιό είναι το όνομα του αγαπημένου σας κατοικιδίου;",
			"security-question9": "Όταν ήσασταν μικροί, τι θέλατε να γίνετε όταν μεγαλώσετε;",
			"security-question10": "Ποιό είναι το επώνυμο του αγαπημένου δασκάλου σας;",
			"new-password-failure": "Ο κωδικός πρόσβασης δεν πληροί τις προδιαγραφές",
			"confirm-password-failure": "Οι κωδικοί πρόσβασης δεν ταιριάζουν",
			"new-password-tooltip": "Πρέπει να έχει 8 χαρακτήρες τουλάχιστον, ένα κεφαλαίο γράμμα, ένα πεζό γράμμα και έναν ειδικό χαρακτήρα.",
			"enter-valid-email": "Εισαγάγετε μία έγκυρη διεύθυνση ηλεκτρονικού ταχυδρομείου.",
			"password-cannot-be-same": "Ο κωδικός πρόσβασης δεν μπορεί να είναι ίδιος με τον προηγούμενο κωδικό πρόσβασης",
			"incorrect-password": "Λανθασμένος κωδικός πρόσβασης",
			"complete-account": "Φαίνεται ότι πρέπει να <a href='%{href}'>ολοκληρώσετε τη δημιουργία λογαριασμού</a>.",
			"completing-allows": "Η ολοκλήρωση της δημιουργίας του λογαριασμού σας θα σας επιτρέψει να διαβάζετε βιβλία εκτός σύνδεσης σε εφαρμογές κινητού τηλεφώνου και να μοιράζεστε σημειώσεις και επισημάνσεις με τους φίλους σας.",
			"error-updating-info": "There was an error updating your information.",
			"password-updated": "Password successfully updated",
			"security-updated": "Security question successfully updated",
			"info-updated": "User information successfully updated"
		},
		"resources": {
			"ancillaries": "Παραρτήματα",
			"access-codes": "Κωδικοί πρόσβασης",
			"print-on-demand": "Εκτύπωση κατόπιν αιτήματος",
			"check-pod": "Ελέγξτε τις επιλογές εκτύπωσης του εκδότη για τα βιβλία σας.",
			"check-now": "Έλεγχος τώρα",
			"loading": "Περιμένετε, ενημερώνουμε τις πηγές σας!",
			"in": "σε",
			"access-code-intro": "Ο κωδικός πρόσβασης είναι ένας κωδικός που χρησιμοποιείτε για να έχετε ηλεκτρονική πρόσβαση σε περιεχόμενα μαθημάτων. Μόλις αποκαλύψετε τον κωδικό για ένα αντικείμενο, δεν θα είστε σε θέση να το επιστρέψετε. Για περισσότερες οδηγίες για τη χρήση του κωδικού πρόσβασης, επισκεφθείτε την <a href='%{support_url}' target='_blank'>Υποστήριξη</a>.",
			"expires": "Ημερομηνία λήξης",
			"expiration-message": "Περιέχει οδηγίες για τη χρήση του κωδικού πρόσβασής σας.",
			"copy-fail": "Δεν είναι δυνατή η αντιγραφή. Επιλέξτε τον κωδικό και αντιγράψτε τον χειροκίνητα.",
			"launch-site": "Εκκίνηση ιστοσελίδας",
			"launch-book": "Εκκίνηση Book",
			"reveal-code": "Αποκάλυψη κωδικού",
			"no-resources": "Δεν έχετε πηγές.",
			"no-access-codes": "Δεν έχετε κανέναν κωδικό πρόσβασης.",
			"no-ancillaries": "Δεν υπάρχουν παραρτήματα για αυτόν τον τίτλο",
			"name": "Όνομα",
			"type": "Τύπος",
			"size": "Μέγεθος",
			"download-all": "Λήψη όλων",
			"back": "Πίσω στις πηγές"
		},
		"refunds": {
			"states": {
				"refunded": "Έγινε επιστροφή χρημάτων",
				"unavailable": "Μη διαθέσιμη επιστροφή χρημάτων"
			},
			"reasons": {
				"dropped": "Απέρριψα το μάθημα",
				"wrong": "Δεν ήταν το σωστό βιβλίο για το μάθημά μου",
				"print": "Αποφάσισα να αγοράσω έντυπη έκδοση",
				"missing": "Το βιβλίο δεν περιέχει όλα όσα χρειάζομαι για το μάθημά μου (πχ. Ένα CD, πρόσβαση στο διαδίκτυο, βίντεο)",
				"other": "Άλλα"
			},
			"bulk": {
				"policy": "Κάνοντας κλικ στο παρακάτω κουμπί &quot;Πλήρης Επιστροφή&quot;, συμφωνώ με την %{brand} <a href='%{policy_url}' target='_blank'> πολιτική επιστροφής </a> .",
				"complete": "Πλήρης Επιστροφή",
				"view-details": "Δείτε Λεπτομέρειες για την επιστροφή χρημάτων",
				"success": "Υποβλήθηκε αίτημα για την επιστροφή χρημάτων σας. Περιμένετε 48 ώρες για επεξεργασία του αιτήματός σας.",
				"failure": "Ωχ! Κάτι πήγε στραβά! Δυστυχώς η επιστροφή χρημάτων σας δεν ολοκληρώθηκε.",
				"retry": "Δοκιμάστε ξανά",
				"support": "Επικοινωνία με το τμήμα υποστήριξης",
				"available-codes": "Διαθέσιμοι Κωδικοί",
				"codes-selected": "Επιλεγμένοι Κωδικοί",
				"download": "Κωδικοί που έχουν ληφθεί",
				"partially-refunded": "Μερική Επιστροφή Χρημάτων",
				"pick-one": "Πρέπει να επιλέξετε τουλάχιστον έναν κωδικό για να κάνει μια επιστροφή"
			},
			"refund": "Επιστροφή χρημάτων",
			"all": "Επιστροφή χρημάτων για όλα;",
			"missing-reason": "Πρέπει να επιλέξετε ένα λόγο για να συνεχίσετε",
			"missing-elaboration": "Δώστε περισσότερες πληροφορίες",
			"policy": "Κάνοντας κλικ στο παρακάτω κουμπί «Ολοκλήρωση Αιτήματος Επιστροφής Χρημάτων», καταλαβαίνω ότι αν αγοράσω ξανά το συγκεκριμένο %{brand} eTextbook, δεν θα μπορώ να ζητήσω περαιτέρω επιστροφές για τον ίδιο eTextbook. Δείτε την πλήρη πολιτική επιστροφής.",
			"refunded": "Έγινε επιστροφή χρημάτων",
			"sorry": "Λυπούμαστε που δεν μείνατε ικανοποιημένοι από την αγορά σας.",
			"error": "Κάτι δεν πήγε καλά",
			"error-explain": "Δεν κατέστη δυνατό να επεξεργαστούμε την επιστροφή χρημάτων σας. Δοκιμάστε ξανά αργότερα.",
			"why": "Πείτε μας γιατί;",
			"no-refunds": "Δεν έχετε επιστρεφόμενα στοιχεία.",
			"select-codes": "Επιλέξτε τον κωδικό (ούς) για την επιστροφή χρημάτων:",
			"number": "Πόσοι?",
			"back": "Πίσω στις επιστροφές χρημάτων"
		},
		"purchases": {
			"back": "Πίσω στις αγορές"
		},
		"global-bar": {
			"account": "Ρυθμίσεις λογαριασμού"
		}
	};

/***/ },
/* 976 */
/***/ function(module, exports) {

	module.exports = {
		"base": {
			"welcome": "Welcome to Mulligans, %{name}!",
			"user": "User info",
			"devices": "Devices",
			"refunds": "Refunds",
			"resources": "Resources",
			"transactions": "Orders & Returns",
			"email": "Email",
			"password": "Password",
			"save": "Save",
			"sign-out": "Sign Out",
			"cancel": "Cancel",
			"close": "Close",
			"learn-more": "Learn more",
			"required": "Required",
			"support": "Support",
			"bookshelf": "Bookshelf",
			"launch": "Launch",
			"download": "Download",
			"details": "Details",
			"cannot-be-blank": "%{field} cannot be blank.",
			"saving": "Saving...",
			"done": "Done",
			"failed": "Failed",
			"copy": "Copy"
		},
		"signin": {
			"login-failure": "Email or password is incorrect",
			"welcome-large": "Welcome to <span class='inner'>%{brand} Account Centre</span>",
			"welcome-small": "<span class='inner'>Account Centre</span>",
			"signin-button": "Sign In",
			"forgot-password": "Forgotten your password?",
			"new-to-vst": "New to %{brand}?",
			"create-account": "Create an account",
			"signing-in": "Signing in...",
			"signin-failed": "Sign-in failed"
		},
		"transactions": {
			"price": "Price",
			"excluded": "(Excluding tax)",
			"quantity": "Quantity",
			"confirmation#": "Confirmation #",
			"payment": "Payment",
			"purchased": "Purchased",
			"purchase-details": "Purchase details",
			"subtotal": "Subtotal",
			"total": "Total",
			"tax": "Tax",
			"loading": "Hey big spender, we're loading your transactions...",
			"no-purchases": "You have no purchases.",
			"seller-vat": "Seller VAT",
			"total-vat": "Total %{vat} Paid",
			"portion": "%{subTax} Tax %{rate}%",
			"vat-disclosure": "Price Includes %{vat}",
			"purchases": "Purchases",
			"refunded-items": "Refunded items",
			"book-title": "Book title",
			"refund-details": "Refund details",
			"print-receipt": "Print receipt",
			"request-refund": "Request a refund",
			"expired": "Expired",
			"expires-in": "Expires %{date}",
			"details-refund": "Details & Refund",
			"modal": {
				"cant-refund-title": "Refund not available",
				"cant-refund": "Your book cannot be refunded because of one or more of the following reasons.",
				"cant-refund-1": "Too much of your book has been viewed.",
				"cant-refund-2": "It has been more than 14 days from the purchase date.",
				"cant-refund-3": "Your online resources code has been revealed.",
				"cant-refund-4": "Your book has previously been refunded.",
				"cant-refund-5": "All codes have been redeemed and/or refunded already.",
				"cant-refund-6": "It has been more than 30 days since the purchase date.",
				"cant-refund-support": "If you are still unsure about %{brand}'s refund policy, contact <a href='%{support_url}' target='_blank'>support</a>."
			},
			"license": {
				"perpetual": "Online access does not expire",
				"days": "%{days} day access"
			}
		},
		"devices": {
			"description": "%{brand} allows you to have <span>%{desktop}</span> computers and <span>%{mobile}</span> mobile/tablet devices activated at any given time.",
			"loading": "Hello, we're getting your devices :)",
			"no-active": "You have no active devices.",
			"deactivate": "Deactivate"
		},
		"user": {
			"personal-information": "Personal information",
			"security-information": "Security information",
			"notifications": "Notifications",
			"first-name": "First Name",
			"last-name": "Last Name",
			"change-password-title": "Change password",
			"current-password": "Current password",
			"new-password": "New password",
			"security-password": "Password",
			"confirm-new-password": "Confirm new password",
			"security-question": "Security Question",
			"security-info-change": "Change",
			"question": "Question",
			"answer": "Answer",
			"notifications-text": "Email me occasional updates about my account activity, product updates and special offers.",
			"loading": "Spot is out fetching your user information, one sec 🐶",
			"change-password-text": "Password must contain at least 8 characters, an uppercase letter, a lower case letter and a special character.",
			"email-locked": "Email locked",
			"email-locked-description": "You do not have access to change your email.",
			"email-locked-more": "Please contact your administrator.",
			"security-question6": "What is your favourite sport?",
			"security-question7": "What is your favourite flavour of ice cream?",
			"security-question8": "What is the name of your favourite pet?",
			"security-question9": "When you were young, what did you want to be when you grew up?",
			"security-question10": "What was the last name of your favourite teacher?",
			"new-password-failure": "Password doesn't meet requrements",
			"confirm-password-failure": "Password must match",
			"new-password-tooltip": "Must contain at least 8 characters, an uppercase letter, a lowercase letter and a special character.",
			"enter-valid-email": "Please enter a valid email.",
			"password-cannot-be-same": "Password can not be the same as the previous password",
			"incorrect-password": "Incorrect password",
			"complete-account": "Looks like you need to <a href='%{href}'>complete your account</a>.",
			"completing-allows": "Completing your account allows you to read books offline on our mobile apps and share notes and highlights with friends.",
			"error-updating-info": "There was an error updating your information.",
			"password-updated": "Password successfully updated",
			"security-updated": "Security question successfully updated",
			"info-updated": "User information successfully updated"
		},
		"resources": {
			"ancillaries": "Ancillaries",
			"access-codes": "Access codes",
			"print-on-demand": "Print on demand",
			"check-pod": "Check publisher printing options for your books.",
			"check-now": "Check now",
			"loading": "Hang tight, we are updating your resources!",
			"in": "in",
			"access-code-intro": "An access code is a password you use to access course content online. Once you reveal a code for an item, you will not be able to return it. For more instructions on how to use your access codes, visit <a href='%{support_url}' target='_blank'>Support</a>.",
			"expires": "Expires",
			"expiration-message": "Contains instructions for using your access code.",
			"copy-fail": "Unable to copy. Please select the code and manually copy it.",
			"launch-site": "Launch site",
			"launch-book": "Launch Book",
			"reveal-code": "Reveal code",
			"no-resources": "You do not have any resources.",
			"no-access-codes": "You do not have any access codes.",
			"no-ancillaries": "No ancillaries for this title",
			"name": "Name",
			"type": "Type",
			"size": "Size",
			"download-all": "Download All",
			"back": "Back to resources"
		},
		"refunds": {
			"states": {
				"refunded": "Refunded",
				"unavailable": "Refund unavailable"
			},
			"reasons": {
				"dropped": "I dropped the course",
				"wrong": "This was the wrong book for my course",
				"print": "I decided to buy a print version instead",
				"missing": "The book does not contain everything I need for my course (eg. a CD, web access, videos)",
				"other": "Other"
			},
			"bulk": {
				"policy": "By clicking the &quot;Complete Refund&quot; button below, I am agreeing to %{brand}'s <a href='%{policy_url}' target='_blank'>refund policy</a>.",
				"complete": "Complete Refund",
				"view-details": "View refund details",
				"success": "Your refund has been requested. Please wait 48 hours for processing.",
				"failure": "Oops - something went wrong! Unfortunately your refund didn't go through.",
				"retry": "Try again",
				"support": "Contact support",
				"available-codes": "Available codes",
				"codes-selected": "Codes selected",
				"download": "Download codes",
				"partially-refunded": "Partially refunded",
				"pick-one": "You must select at least one code to make a refund"
			},
			"refund": "Refund",
			"all": "Refund all?",
			"missing-reason": "You must select a reason to continue",
			"missing-elaboration": "Please elaborate",
			"policy": "By clicking the “Complete Refund Request” button below, I understand that if I purchase this %{brand} eTextbook again, I will not be eligible to request any further refunds for the same eTextbook. View full return policy.",
			"refunded": "Refunded",
			"sorry": "We are sorry you were not satisfied with your purchase.",
			"error": "Something went wrong",
			"error-explain": "We were unable to process your refund. Please try again.",
			"why": "Tell us why?",
			"no-refunds": "You have no refunded items.",
			"select-codes": "Select code(s) to refund:",
			"number": "How many?",
			"back": "Back to refunds"
		},
		"purchases": {
			"back": "Back to purchases"
		},
		"global-bar": {
			"account": "Account settings"
		}
	};

/***/ },
/* 977 */
/***/ function(module, exports) {

	module.exports = {
		"smartling": {
			"translate_mode": "all",
			"source_key_paths": [
				"{*}"
			],
			"placeholder_format_custom": [
				"%\\{([^\\}]*)\\}"
			],
			"variants_enabled": true
		},
		"base": {
			"welcome": "Welcome to Mulligans, %{name}!",
			"user": "User Info",
			"devices": "Devices",
			"refunds": "Refunds",
			"resources": "Resources",
			"transactions": "Orders & Returns",
			"email": "Email",
			"password": "Password",
			"save": "Save",
			"sign-out": "Sign Out",
			"cancel": "Cancel",
			"close": "Close",
			"learn-more": "Learn more",
			"required": "Required",
			"support": "Support",
			"bookshelf": "Bookshelf",
			"launch": "Launch",
			"download": "Download",
			"details": "Details",
			"cannot-be-blank": "%{field} cannot be blank.",
			"saving": "Saving...",
			"done": "Done",
			"failed": "Failed",
			"copy": "Copy"
		},
		"signin": {
			"login-failure": "Email or password is incorrect",
			"welcome-large": "Welcome to <span class='inner'>%{brand} Account Center</span>",
			"welcome-small": "<span class='inner'>Account Center</span>",
			"signin-button": "Sign In",
			"forgot-password": "Forgot your Password",
			"new-to-vst": "New to %{brand}?",
			"create-account": "Create an account",
			"signing-in": "Signing in...",
			"signin-failed": "Sign-in failed"
		},
		"transactions": {
			"price": "Price",
			"excluded": "(Excluding tax)",
			"quantity": "Quantity",
			"confirmation#": "Confirmation #",
			"payment": "Payment",
			"purchased": "Purchased",
			"purchase-details": "Purchase Details",
			"subtotal": "Subtotal",
			"total": "Total",
			"tax": "Tax",
			"loading": "Hey big spender, we're loading your transactions...",
			"no-purchases": "You have no purchases.",
			"seller-vat": "Seller VAT",
			"total-vat": "Total %{vat} Paid",
			"portion": "%{subTax} Tax %{rate}%",
			"vat-disclosure": "Price Includes %{vat}",
			"purchases": "Purchases",
			"refunded-items": "Refunded Items",
			"book-title": "Book Title",
			"refund-details": "Refund Details",
			"print-receipt": "Print Receipt",
			"request-refund": "Request Refund",
			"expired": "Expired",
			"expires-in": "Expires %{date}",
			"details-refund": "Details & Refund",
			"modal": {
				"cant-refund-title": "Refund Not Available",
				"cant-refund": "Your book cannot be refunded because of one or more of the following reasons.",
				"cant-refund-1": "Too much of your book has been viewed.",
				"cant-refund-2": "It has been more than 14 days from the purchase date.",
				"cant-refund-3": "Your online resources code has been revealed.",
				"cant-refund-4": "Your book has previously been refunded.",
				"cant-refund-5": "All codes have already been redeemed and/or refunded.",
				"cant-refund-6": "It has been more than 30 days from the purchase date.",
				"cant-refund-support": "If you are still unsure of %{brand}'s refund policy, contact <a href='%{support_url}' target='_blank'>support</a>."
			},
			"license": {
				"perpetual": "Online access does not expire",
				"days": "%{days} Day Access"
			}
		},
		"devices": {
			"description": "%{brand} allows you to have <span>%{desktop}</span> computers and <span>%{mobile}</span> mobile/tablet devices activated at any given time.",
			"loading": "Heya, we're getting your devices :)",
			"no-active": "You have no active devices.",
			"deactivate": "Deactivate"
		},
		"user": {
			"personal-information": "Personal Information",
			"security-information": "Security Information",
			"notifications": "Notifications",
			"first-name": "First Name",
			"last-name": "Last Name",
			"change-password-title": "Change Password",
			"current-password": "Current Password",
			"new-password": "New Password",
			"security-password": "Password",
			"confirm-new-password": "Confirm New Password",
			"security-question": "Security Question",
			"security-info-change": "Change",
			"question": "Question",
			"answer": "Answer",
			"notifications-text": "Email me occasional updates about my account activity, product updates, and special offers.",
			"loading": "Spot is out fetching your user information, one sec 🐶",
			"change-password-text": "Password must contain at least 8 characters, an uppercase letter, a lower case letter, and a special character.",
			"email-locked": "Email Locked",
			"email-locked-description": "You do not have access to change your email.",
			"email-locked-more": "Please contact your administrator.",
			"security-question6": "What is your favorite sport?",
			"security-question7": "What is your favorite flavor of ice cream?",
			"security-question8": "What is the name of your favorite pet?",
			"security-question9": "When you were young, what did you want to be when you grew up?",
			"security-question10": "What was the last name of your favorite teacher?",
			"new-password-failure": "Password doesn't meet requrements",
			"confirm-password-failure": "Password must match",
			"new-password-tooltip": "Must contain at least 8 characters, an uppercase letter, a lowercase letter, and a special character.",
			"enter-valid-email": "Please enter a valid email.",
			"password-cannot-be-same": "Password can not be the same as the previous password",
			"incorrect-password": "Incorrect Password",
			"complete-account": "Looks like you need to <a href='%{href}'>complete your account</a>.",
			"completing-allows": "Completing your account allows you to read books offline on our mobile apps and share notes and highlights with friends.",
			"error-updating-info": "There was an error updating your information.",
			"password-updated": "Password successfully updated",
			"security-updated": "Security question successfully updated",
			"info-updated": "User information successfully updated"
		},
		"resources": {
			"ancillaries": "Ancillaries",
			"access-codes": "Access Codes",
			"print-on-demand": "Print on Demand",
			"check-pod": "Check publisher printing options for your books.",
			"check-now": "Check Now",
			"loading": "Hang tight, we are updating your resources!",
			"in": "in",
			"access-code-intro": "An access code is a password you use to access course content online. Once you reveal a code for an item, you will not be able to return it. For more instructions on how to use your access codes, visit <a href='%{support_url}' target='_blank'>Support</a>.",
			"expires": "Expires",
			"expiration-message": "Contains instructions for using your access code.",
			"copy-fail": "Unable to copy. Please select the code and manually copy it.",
			"launch-site": "Launch Site",
			"launch-book": "Launch Book",
			"reveal-code": "Reveal Code",
			"no-resources": "You do not have any resources.",
			"no-access-codes": "You do not have any access codes.",
			"no-ancillaries": "No ancillaries for this title",
			"name": "Name",
			"type": "Type",
			"size": "Size",
			"download-all": "Download All",
			"back": "Back to resources"
		},
		"refunds": {
			"states": {
				"refunded": "Refunded",
				"unavailable": "Refund Unavailable"
			},
			"reasons": {
				"dropped": "I dropped the course",
				"wrong": "This was the wrong book for my course",
				"print": "I decided to buy a print version instead",
				"missing": "The book does not contain everything I need for my course (eg. a CD, web access, videos)",
				"other": "Other"
			},
			"bulk": {
				"policy": "By clicking  the \"Complete Refund\" button below, I am agreeing to %{brand}'s <a href='%{policy_url}' target='_blank'>refund policy</a>.",
				"complete": "Complete Refund",
				"view-details": "View Refund Details",
				"success": "Your refund request has been received and will be processed in 24-48 hours.",
				"failure": "Oops - something went wrong! Unfortunately your refund didn't go through.",
				"retry": "Try Again",
				"support": "Contact Support",
				"available-codes": "Available Codes",
				"codes-selected": "Codes Selected",
				"download": "Download Codes",
				"partially-refunded": "Partially Refunded",
				"pick-one": "You must select at least one code to make a refund"
			},
			"refund": "Refund",
			"all": "Refund All?",
			"missing-reason": "You must select a reason to continue",
			"missing-elaboration": "Please elaborate",
			"policy": "By clicking the “Complete Refund Request” button below, I understand that if I purchase this %{brand} eTextbook again, I will not be eligible to request any further refunds for the same eTextbook. View full return policy.",
			"refunded": "Refunded",
			"sorry": "We are sorry you were not satisfied with your purchase.",
			"error": "Something went wrong",
			"error-explain": "We were unable to process your refund. Please try again.",
			"why": "Tell us why?",
			"no-refunds": "You have no refunded items.",
			"select-codes": "Select code(s) to refund:",
			"number": "How many?",
			"back": "Back to refunds"
		},
		"purchases": {
			"back": "Back to purchases"
		},
		"global-bar": {
			"account": "Account Settings"
		}
	};

/***/ },
/* 978 */
/***/ function(module, exports) {

	module.exports = {
		"base": {
			"welcome": "¡Bienvenido a Mulligans, %{name}!",
			"user": "Información del usuario",
			"devices": "Dispositivos",
			"refunds": "Reembolsos",
			"resources": "Recursos",
			"transactions": "Pedidos y devoluciones",
			"email": "Correo electrónico",
			"password": "Contraseña",
			"save": "Guardar",
			"sign-out": "Cerrar sesión",
			"cancel": "Cancelar",
			"close": "Cerrar",
			"learn-more": "Más información",
			"required": "Requerido",
			"support": "Asistencia técnica",
			"bookshelf": "Librería",
			"launch": "Ejecutar",
			"download": "Descargar",
			"details": "Detalles",
			"cannot-be-blank": "%{field} no puede estar en blanco.",
			"saving": "Guardando...",
			"done": "Realizado",
			"failed": "Error",
			"copy": "Copiar"
		},
		"signin": {
			"login-failure": "El correo electrónico o la contraseña son incorrectos",
			"welcome-large": "Bienvenido al <span class='inner'>%{brand} Account Center</span>",
			"welcome-small": "<span class='inner'>Account Center</span>",
			"signin-button": "Identificarse",
			"forgot-password": "Olvidó su contraseña",
			"new-to-vst": "¿Eres nuevo en %{brand}?",
			"create-account": "Cree una cuenta",
			"signing-in": "Iniciando sesión...",
			"signin-failed": "Falló inicio de sesión"
		},
		"transactions": {
			"price": "Precio",
			"excluded": "(Excluyendo impuestos)",
			"quantity": "Cantidad",
			"confirmation#": "No. de confirmación",
			"payment": "Pago",
			"purchased": "Adquirido",
			"purchase-details": "Detalles de la compra",
			"subtotal": "Subtotal",
			"total": "Total",
			"tax": "Impuesto",
			"loading": "¡Hola! Estamos cargando sus transacciones...",
			"no-purchases": "No tiene compras.",
			"seller-vat": "IVA del vendedor",
			"total-vat": "Total %{vat} pagado",
			"portion": "%{subTax} Impuesto %{rate}%",
			"vat-disclosure": "El precio incluye %{vat}",
			"purchases": "Compras",
			"refunded-items": "Elementos con reembolso",
			"book-title": "Título del libro",
			"refund-details": "Detalles del reembolso",
			"print-receipt": "Imprimir recibo",
			"request-refund": "Solicitar reembolso",
			"expired": "Caducado",
			"expires-in": "Caduca el %{date}",
			"details-refund": "Detalles y reembolso",
			"modal": {
				"cant-refund-title": "Reembolso no disponible",
				"cant-refund": "No se puede reembolsar su libro por una o más de las siguientes razones:",
				"cant-refund-1": "Se ha consultado una porción demasiado extensa de su libro.",
				"cant-refund-2": "Han pasado más de 14 días desde la fecha de compra.",
				"cant-refund-3": "Su código de recursos en línea se reveló.",
				"cant-refund-4": "Su libro se reembolsó anteriormente.",
				"cant-refund-5": "Todos los códigos se han canjeado o reembolsado.",
				"cant-refund-6": "Han pasado más de 30 días desde la fecha de compra.",
				"cant-refund-support": "Si aún no conoces bien la política de reembolso de %{brand}, contacta a <a href='%{support_url}' target='_blank'>Asistencia Técnica</a>."
			},
			"license": {
				"perpetual": "El acceso en línea no caduca",
				"days": "Acceso por %{days} días"
			}
		},
		"devices": {
			"description": "%{brand} te permite tener <span>%{desktop}</span> computadoras y <span>%{mobile}</span> dispositivos móviles/tabletas activados en un momento dado.",
			"loading": "Bien, estamos reconociendo sus dispositivos :)",
			"no-active": "No tiene dispositivos activos.",
			"deactivate": "Desactivar"
		},
		"user": {
			"personal-information": "Información personal",
			"security-information": "Informacion de seguridad",
			"notifications": "Notificaciones",
			"first-name": "Nombre",
			"last-name": "Apellido",
			"change-password-title": "Cambiar contraseña",
			"current-password": "Contraseña actual",
			"new-password": "Nueva contraseña",
			"security-password": "Contraseña",
			"confirm-new-password": "Confirmar contraseña",
			"security-question": "Pregunta de seguridad",
			"security-info-change": "Cambiar",
			"question": "Pregunta",
			"answer": "Respuesta",
			"notifications-text": "Enviarme por correo electrónico actualizaciones ocasionales sobre la actividad de mi cuenta, actualizaciones de productos y ofertas especiales.",
			"loading": "Spot está buscando su información de usuario. Un segundo 🐶",
			"change-password-text": "La contraseña debe contener al menos 8 caracteres, una letra mayúscula, una letra minúscula y un carácter especial.",
			"email-locked": "Correo electrónico bloqueado ",
			"email-locked-description": "Usted no tiene acceso para cambiar su correo electrónico.",
			"email-locked-more": "Por favor, comuníquese con su administrador.",
			"security-question6": "¿Cuál es su deporte favorito?",
			"security-question7": "¿Cuál es su sabor de helado favorito?",
			"security-question8": "¿Cuál es el nombre de su mascota favorita?",
			"security-question9": "Cuando era joven, ¿qué quería ser cuando fuera grande?",
			"security-question10": "¿Cuál era el apellido de su profesor favorito?",
			"new-password-failure": "La contraseña no cumple con los requisitos",
			"confirm-password-failure": "La contraseña debe coincidir",
			"new-password-tooltip": "Debe contener al menos 8 caracteres, una letra mayúscula, una letra minúscula y un carácter especial.",
			"enter-valid-email": "Introduzca un correo electrónico válido.",
			"password-cannot-be-same": "La contraseña no puede ser igual a la contraseña anterior",
			"incorrect-password": "Contraseña incorrecta",
			"complete-account": "Parece que necesitas <a href='%{href}'>completar tu cuenta</a>.",
			"completing-allows": "Completar tu cuenta te permite leer libros fuera de línea en nuestras aplicaciones móviles y compartir notas y resaltados con amigos.",
			"error-updating-info": "There was an error updating your information.",
			"password-updated": "Password successfully updated",
			"security-updated": "Security question successfully updated",
			"info-updated": "User information successfully updated"
		},
		"resources": {
			"ancillaries": "Auxiliares",
			"access-codes": "Códigos de acceso",
			"print-on-demand": "Imprimir a solicitud",
			"check-pod": "Verifica las opciones de impresión de la editorial de tus libros.",
			"check-now": "Verificar ahora",
			"loading": "Un momento, ¡estamos actualizando sus recursos!",
			"in": "en",
			"access-code-intro": "Un código de acceso es una contraseña que se utiliza para acceder al contenido del curso en línea. Una vez que revela un código de un elemento, no podrá regresarlo. Para ver más instrucciones sobre cómo usar sus códigos, visite <a href='%{support_url}' target='_blank'>Asistencia técnica</a>.",
			"expires": "Caduca",
			"expiration-message": "Contiene instrucciones para utilizar el código de acceso.",
			"copy-fail": "No se puede copiar. Seleccione el código y cópielo manualmente.",
			"launch-site": "Ejecutar el sitio",
			"launch-book": "Ejecutar libro",
			"reveal-code": "Revelar código",
			"no-resources": "No tiene ningún recurso.",
			"no-access-codes": "No tiene ningún código de acceso.",
			"no-ancillaries": "No hay elementos auxiliares para este título",
			"name": "Nombre",
			"type": "Tipo",
			"size": "Tamaño",
			"download-all": "Descargar todo",
			"back": "Volver a recursos"
		},
		"refunds": {
			"states": {
				"refunded": "Reembolsado",
				"unavailable": "Reembolso no disponible"
			},
			"reasons": {
				"dropped": "Abandoné el curso",
				"wrong": "Este libro no era apropiado para mi curso",
				"print": "En su lugar, decidí comprar una versión impresa",
				"missing": "El libro no contiene todo lo que necesito para mi curso (por ejemplo, un CD, acceso a la web, videos)",
				"other": "Otro"
			},
			"bulk": {
				"policy": "Al hacer clic en el botón &quot;Completar reembolso&quot; abajo, acepto la política de reembolso de %{brand} <a href='%{policy_url}' target='_blank'>.</a> ",
				"complete": "Completar reembolso",
				"view-details": "Ver detalles del reembolso",
				"success": "Se solicitó tu reembolso. El trámite puede tardar 48 horas.",
				"failure": "Lo sentimos. Hubo un problema. Lamentablemente, no se pudo realizar su reembolso.",
				"retry": "Volver a intentar",
				"support": "Contactar la Asistencia Técnica",
				"available-codes": "Códigos disponibles",
				"codes-selected": "Códigos seleccionados",
				"download": "Descargar códigos",
				"partially-refunded": "Parcialmente reembolsado",
				"pick-one": "Debe seleccionar por lo menos un código para hacer un reembolso"
			},
			"refund": "Reembolso",
			"all": "¿Reembolsar todo?",
			"missing-reason": "Debe seleccionar una razón para continuar",
			"missing-elaboration": "Sírvase proporcionar más detalles",
			"policy": "Al hacer clic en el botón “Completar solicitud de reembolso” abajo, entiendo que si compro este eTextbook de %{brand} nuevamente, no seré elegible para solicitar cualquier reembolso por el mismo eTextbook. Ver la política de reembolso completa.",
			"refunded": "Reembolsado",
			"sorry": "Lamentamos que no se sienta satisfecho con su compra.",
			"error": "Hubo un problema",
			"error-explain": "No podemos procesar su reembolso. Intente más tarde.",
			"why": "Cuéntenos el motivo.",
			"no-refunds": "No tiene elementos reembolsados.",
			"select-codes": "Seleccionar código(s) para reembolsar:",
			"number": "¿Cuántos?",
			"back": "Volver a reembolsos"
		},
		"purchases": {
			"back": "Volver a compras"
		},
		"global-bar": {
			"account": "Configuración de la Cuenta"
		}
	};

/***/ },
/* 979 */
/***/ function(module, exports) {

	module.exports = {
		"base": {
			"welcome": "¡Bienvenido a Mulligans, %{name}!",
			"user": "Información de usuario",
			"devices": "Dispositivos",
			"refunds": "Devoluciones",
			"resources": "Recursos",
			"transactions": "Pedidos y devoluciones",
			"email": "Correo electrónico",
			"password": "Contraseña",
			"save": "Guardar",
			"sign-out": "Cerrar sesión",
			"cancel": "Cancelar",
			"close": "Cerrar",
			"learn-more": "Más informacíón",
			"required": "Requisito",
			"support": "Asistencia técnica",
			"bookshelf": "Librería",
			"launch": "Iniciar",
			"download": "Descargar",
			"details": "Detalles",
			"cannot-be-blank": "%{field} no puede estar en blanco.",
			"saving": "Guardando...",
			"done": "Listo",
			"failed": "Error",
			"copy": "Copiar"
		},
		"signin": {
			"login-failure": "El correo electrónico o la contraseña es incorrecto",
			"welcome-large": "Bienvenido al centro de cuentas de <span class='inner'>%{brand}</span>",
			"welcome-small": "<span class='inner'>Centro de cuentas</span>",
			"signin-button": "Identificarse",
			"forgot-password": "¿Ha olvidado su contraseña?",
			"new-to-vst": "¿Nuevo en %{brand}?",
			"create-account": "Crear una cuenta",
			"signing-in": "Identificándose...",
			"signin-failed": "Se ha producido un error en la identificación"
		},
		"transactions": {
			"price": "Precio",
			"excluded": "(Impuestos no incluidos)",
			"quantity": "Cantidad",
			"confirmation#": "N.º de confirmación",
			"payment": "Pago",
			"purchased": "Comprado",
			"purchase-details": "Detalles de la compra",
			"subtotal": "Subtotal",
			"total": "Total",
			"tax": "Impuesto",
			"loading": "Ey, gran consumidor, estamos cargando sus transacciones...",
			"no-purchases": "No tiene ninguna compra.",
			"seller-vat": "IVA del vendedor",
			"total-vat": "%{vat} total pagado",
			"portion": "Impuesto de %{subTax} del %{rate} %",
			"vat-disclosure": "El precio incluye el %{vat} % de IVA",
			"purchases": "Compras",
			"refunded-items": "Artículos devueltos",
			"book-title": "Título del libro",
			"refund-details": "Detalles de reintegro",
			"print-receipt": "Imprimir recibo",
			"request-refund": "Solicitar reembolso",
			"expired": "Caducado",
			"expires-in": "Caduca el %{date}",
			"details-refund": "Detalles y reembolso",
			"modal": {
				"cant-refund-title": "Devolución no disponible",
				"cant-refund": "No es posible devolver su libro por una o más de una de las siguientes razones.",
				"cant-refund-1": "Se ha visualizado una gran parte del libro.",
				"cant-refund-2": "Han pasado más de 14 días desde la fecha de compra.",
				"cant-refund-3": "Se ha mostrado su código de recursos en línea.",
				"cant-refund-4": "Su libro se ha devuelto anteriormente.",
				"cant-refund-5": "Todos los códigos ya se han canjeado y/o devuelto.",
				"cant-refund-6": "Han pasado más de 30 días desde la fecha de compra.",
				"cant-refund-support": "Si todavía tiene dudas acerca de la política de devoluciones de %{brand}, póngase en contacto con <a href='%{support_url}' target='_blank'>la asistencia técnica.</a>"
			},
			"license": {
				"perpetual": "El acceso en línea no caduca",
				"days": "Acceso de %{days} día"
			}
		},
		"devices": {
			"description": "%{brand} le permite tener <span>%{desktop}</span> ordenadores y <span>%{mobile}</span> dispositivos móviles o tabletas activados a la vez.",
			"loading": "Ey, estamos accediendo a sus dispositivos :)",
			"no-active": "No tiene dispositivos activos.",
			"deactivate": "Desactivar"
		},
		"user": {
			"personal-information": "Información personal",
			"security-information": "Información de seguridad",
			"notifications": "Notificaciones",
			"first-name": "Nombre",
			"last-name": "Apellido",
			"change-password-title": "Cambiar contraseña",
			"current-password": "Contraseña actual",
			"new-password": "Contraseña nueva",
			"security-password": "Contraseña",
			"confirm-new-password": "Confirmar contraseña nueva",
			"security-question": "Pregunta de seguridad",
			"security-info-change": "Cambiar",
			"question": "Pregunta",
			"answer": "Respuesta",
			"notifications-text": "Deseo recibir actualizaciones sobre actividad en mi cuenta, productos y ofertas especiales por correo electrónico.",
			"loading": "Spot está recopilando su información de usuario; espere un segundo 🐶",
			"change-password-text": "La contraseña debe contener al menos 8 caracteres, una mayúscula, una minúscula y un carácter especial.",
			"email-locked": "Correo electrónico bloqueado",
			"email-locked-description": "No tiene acceso al cambio del correo electrónico.",
			"email-locked-more": "Póngase en contacto con el administrador.",
			"security-question6": "¿Cuál es su deporte favorito?",
			"security-question7": "¿Cuál es su sabor de helado favorito?",
			"security-question8": "¿Cómo se llama su mascota favorita?",
			"security-question9": "Cuando era pequeño/a, ¿qué quería ser de mayor?",
			"security-question10": "¿Cuál era el apellido de su profesor/a favorito/a?",
			"new-password-failure": "La contraseña no cumple los requisitos",
			"confirm-password-failure": "La contraseña debe coincidir",
			"new-password-tooltip": "Debe contener al menos 8 caracteres, una mayúscula, una minúscula y un carácter especial.",
			"enter-valid-email": "Escriba un correo electrónico válido.",
			"password-cannot-be-same": "La contraseña no puede ser la misma que la contraseña anterior",
			"incorrect-password": "Contraseña incorrecta",
			"complete-account": "Parece que debes <a href='%{href}'>completar tu cuenta</a>.",
			"completing-allows": "Cuando la completes podrás leer libros sin conexión en tus dispositivos móviles y compartir con tus amigos notas y resaltados.",
			"error-updating-info": "There was an error updating your information.",
			"password-updated": "Password successfully updated",
			"security-updated": "Security question successfully updated",
			"info-updated": "User information successfully updated"
		},
		"resources": {
			"ancillaries": "Auxiliares",
			"access-codes": "Códigos de acceso",
			"print-on-demand": "Imprimir a petición",
			"check-pod": "Comprueba las opciones de impresión del editor para tus libros.",
			"check-now": "Comprobar ahora",
			"loading": "¡Un momento, estamos actualizando sus recursos!",
			"in": "en",
			"access-code-intro": "Un código de acceso es una contraseña que se utiliza para acceder al contenido del curso en línea. Una vez que muestre el código de un artículo, ya no podrá devolverlo. Para más instrucciones sobre el uso de los códigos de acceso, visite la <a href='%{support_url}' target='_blank'>Asistencia técnica</a>.",
			"expires": "Caduca",
			"expiration-message": "Contiene instrucciones sobre el uso del código de acceso.",
			"copy-fail": "No se puede copiar. Seleccione el código y cópielo manualmente.",
			"launch-site": "Iniciar sitio",
			"launch-book": "Iniciar libro",
			"reveal-code": "Mostrar código",
			"no-resources": "No tiene ningún recurso.",
			"no-access-codes": "No tiene ningún código de acceso.",
			"no-ancillaries": "No hay auxiliares para este título",
			"name": "Nombre",
			"type": "Tipo",
			"size": "Tamaño",
			"download-all": "Descargar todo",
			"back": "Volver a los recursos"
		},
		"refunds": {
			"states": {
				"refunded": "Devuelto",
				"unavailable": "Devolución no disponible"
			},
			"reasons": {
				"dropped": "He abandonado el curso",
				"wrong": "Este libro no era el correcto para el curso",
				"print": "He decidido comprar una versión impresa",
				"missing": "El libro no contiene todo lo que necesito para el curso (por ejemplo un CD, acceso a la web, vídeos...)",
				"other": "Otro"
			},
			"bulk": {
				"policy": "Entiendo que al hacer clic en el botón &quot;Completar devolución&quot; de más abajo acepto la política de devoluciones de %{brand} <a href='%{policy_url}' target='_blank'>.</a>",
				"complete": "Completar devolución",
				"view-details": "Ver detalles de devolución",
				"success": "Se ha solicitado tu reembolso. Espera 48 horas para el procesamiento.",
				"failure": "¡Vaya! Algo ha salido mal. Lamentablemente la devolución no se ha procesado.",
				"retry": "Intentar de nuevo",
				"support": "Ponerse en contacto con la asistencia técnica",
				"available-codes": "Códigos disponibles",
				"codes-selected": "Códigos seleccionados",
				"download": "Descargar códigos",
				"partially-refunded": "Devuelto parcialmente",
				"pick-one": "Debe seleccionar al menos un código para realizar una devolución"
			},
			"refund": "Devolver",
			"all": "¿Devolver todo?",
			"missing-reason": "Debe seleccionar una razón para continuar",
			"missing-elaboration": "Indique detalles",
			"policy": "Al hacer clic en el botón \"Completar solicitud de devolución\" de más abajo, entiendo que si vuelvo a comprar este libro de texto electrónico de %{brand}, no podré solicitar más devoluciones del mismo libro de texto electrónico. Consulte la política de devoluciones.",
			"refunded": "Devuelto",
			"sorry": "Lamentamos mucho que no esté satisfecho con su compra.",
			"error": "Algo ha salido mal",
			"error-explain": "No hemos podido procesar su devolución. Inténtelo de nuevo.",
			"why": "Cuéntenos por qué",
			"no-refunds": "No tiene artículos devueltos.",
			"select-codes": "Seleccione código(s) de devolución:",
			"number": "¿Cuántas?",
			"back": "Volver a las devoluciones"
		},
		"purchases": {
			"back": "Volver a las compras"
		},
		"global-bar": {
			"account": "Configuración de cuenta"
		}
	};

/***/ },
/* 980 */
/***/ function(module, exports) {

	module.exports = {
		"base": {
			"welcome": "Tervetuloa Mulligansiin, %{name}!",
			"user": "Käyttäjän tiedot",
			"devices": "Laitteet",
			"refunds": "Hyvitykset",
			"resources": "Resurssit",
			"transactions": "Tilaukset ja palautukset",
			"email": "Sähköposti",
			"password": "Salasana",
			"save": "Tallenna",
			"sign-out": "Kirjaudu ulos",
			"cancel": "Peruuta",
			"close": "Sulje",
			"learn-more": "Lue lisää.",
			"required": "Tarvitaan",
			"support": "Tuki",
			"bookshelf": "Bookshelf",
			"launch": "Käynnistä",
			"download": "Lataa",
			"details": "Tiedot",
			"cannot-be-blank": "%{field} ei voi olla tyhjä.",
			"saving": "Tallennetaan...",
			"done": "Valmis",
			"failed": "Epäonnistunut",
			"copy": "Kopioi"
		},
		"signin": {
			"login-failure": "Sähköpostiosoite tai salasana ei kelpaa",
			"welcome-large": "Tervetuloa <span class='inner'>%{brand} Account Centeriin</span>",
			"welcome-small": "<span class='inner'>Account Center</span>",
			"signin-button": "Kirjaudu sisään",
			"forgot-password": "Unohditko salasanasi",
			"new-to-vst": "Uusi %{brand}ssa?",
			"create-account": "Luo tili",
			"signing-in": "Kirjaudutaan sisään...",
			"signin-failed": "Sisään kirjautuminen epäonnistui"
		},
		"transactions": {
			"price": "Hinta",
			"excluded": "(Ilman veroja)",
			"quantity": "Määrä",
			"confirmation#": "Vahvistusnumero",
			"payment": "Maksu",
			"purchased": "Ostettu",
			"purchase-details": "Oston tiedot",
			"subtotal": "Välisumma",
			"total": "Yhteensä",
			"tax": "Vero",
			"loading": "Hei tuhlari, lataamme tapahtumiasi...",
			"no-purchases": "Sinulla ei ole ostoksia.",
			"seller-vat": "Myyjän ALV-tunnus",
			"total-vat": "Maksettu %{vat} yhteensä",
			"portion": "%{subTax} Vero %{rate}%",
			"vat-disclosure": "Hinta sisältää arvonlisäveron %{vat}",
			"purchases": "Ostot",
			"refunded-items": "Tuotteet, joita palautus koskee",
			"book-title": "Kirjan nimi",
			"refund-details": "Palautuksia koskevat tiedot",
			"print-receipt": "Tulosta kuitti",
			"request-refund": "Pyydä palautusta",
			"expired": "Vanhentunut",
			"expires-in": "Vanhenee %{date}",
			"details-refund": "Tiedot ja hyvitys",
			"modal": {
				"cant-refund-title": "Hyvitystä ei saatavana",
				"cant-refund": "Kirjaasi ei voida hyvittää seuraavasta/seuraavista syystä/syistä.",
				"cant-refund-1": "Kirjaasi on katsottu liian paljon.",
				"cant-refund-2": "Ostopäivästä on kulunut yli 14 päivää.",
				"cant-refund-3": "Verkkoresurssikoodisi on paljastunut.",
				"cant-refund-4": "Kirjasi on jo hyvitetty.",
				"cant-refund-5": "Kaikki koodit on jo lunastettu ja/tai hyvitetty.",
				"cant-refund-6": "Ostopäivästä on kulunut yli 30 päivää.",
				"cant-refund-support": "Jos sinulla on vielä epäselvyyttä %{brand}n hyvityskäytännöstä, ota yhteyttä <a href='%{support_url}' target='_blank'>asiakastukeen</a>."
			},
			"license": {
				"perpetual": "Verkkopääsyoikeus ei vanhene",
				"days": "%{days} päivän pääsyoikeus"
			}
		},
		"devices": {
			"description": "%{brand} antaa mahdollisuuden pitää milloin tahansa yhtä aikaa aktivoituina <span>%{desktop}</span> tietokonetta ja <span>%{mobile}</span> mobiililaitetta/tablettia.",
			"loading": "Hei, olemme saamassa laitteesi :)",
			"no-active": "Sinulla ei ole yhtään aktiivista laitetta.",
			"deactivate": "Poista käytöstä"
		},
		"user": {
			"personal-information": "Henkilötiedot",
			"security-information": "Turvallisuustiedot",
			"notifications": "Ilmoitukset",
			"first-name": "Etunimi",
			"last-name": "Sukunimi",
			"change-password-title": "Vaihda salasana",
			"current-password": "Nykyinen salasana",
			"new-password": "Uusi salasana",
			"security-password": "Salasana",
			"confirm-new-password": "Vahvista uusi salasana",
			"security-question": "Turvakysymys",
			"security-info-change": "Muutos",
			"question": "Kysymys",
			"answer": "Vastaus",
			"notifications-text": "Lähettäkää minulle silloin tällöin päivityksiä tilini tapahtumista, tuotepäivityksistä ja erikoistarjouksista.",
			"loading": "Spot noutaa käyttäjätietojasi, hetkinen 🐶",
			"change-password-text": "Salasanassa pitää olla vähintään kahdeksan merkkiä, joista ainakin yhden pitää olla iso kirjain, yhden pieni kirjain ja yhden erikoismerkki.",
			"email-locked": "Sähköposti lukittu",
			"email-locked-description": "Et pääse muuttamaan sähköpostiosoitettasi.",
			"email-locked-more": "Ota yhteyttä administraattoriin.",
			"security-question6": "Mikä on suosikkiurheilusi?",
			"security-question7": "Mikä on suosikkijäätelösi?",
			"security-question8": "Mikä on suosikkilemmikkisi nimi?",
			"security-question9": "Kun olit lapsi, miksi halusit tulla isona?",
			"security-question10": "Mikä oli suosikkiopettajasi sukunimi?",
			"new-password-failure": "Salasana ei täytä vaatimuksia",
			"confirm-password-failure": "Salasanan on oltava sama",
			"new-password-tooltip": "Pitää sisältää vähintään 8 merkkiä, joista ainakin yhden pitää olla iso kirjan, yhden pieni kirjain ja yhden erikoismerkki.",
			"enter-valid-email": "Anna kelvollinen sähköpostiosoite.",
			"password-cannot-be-same": "Salasana ei voi olla sama kuin aikaisempi salasana",
			"incorrect-password": "Virheellinen salasana",
			"complete-account": "Näyttää siltä, että sinun pitää <a href='%{href}'>viimeistellä tilisi</a>.",
			"completing-allows": "Kun viimeistelet tilisi, voit lukea kirjoja ilman verkkoyhteyttä meidän mobiilisovelluksillamme ja jakaa muistiinpanoja ja korostuksia ystävien kanssa.",
			"error-updating-info": "There was an error updating your information.",
			"password-updated": "Password successfully updated",
			"security-updated": "Security question successfully updated",
			"info-updated": "User information successfully updated"
		},
		"resources": {
			"ancillaries": "Oheistuotteet",
			"access-codes": "Pääsykoodit",
			"print-on-demand": "Tulostus tarpeen mukaan / Print on Demand",
			"check-pod": "Tarkista kustantajan kirjoistasi tarjoamat painetut vaihtoehdot.",
			"check-now": "Tarkista nyt",
			"loading": "Älä hellitä, päivitämme resurssejasi!",
			"in": ":",
			"access-code-intro": "Pääsykoodi on salasana, jolla pääset kurssisi sisältöön verkon kautta. Kun paljastat tietyn kohteen koodin, et voi enää palauttaa sitä. Katso lisäohjeita pääsykoodin käyttämisestä <a href='%{support_url}' target='_blank'>tuesta</a>.",
			"expires": "Vanhenee",
			"expiration-message": "Sisältää pääsykoodisi käyttöohjeita.",
			"copy-fail": "Ei voida kopioida. Valitse koodi ja kopioi se manuaalisesti.",
			"launch-site": "Käynnistyspaikka",
			"launch-book": "Avaa kirja",
			"reveal-code": "Paljasta koodi",
			"no-resources": "Sinulla ei ole resursseja.",
			"no-access-codes": "Sinulla ei ole pääsykoodeja.",
			"no-ancillaries": "Ei oheistuotteita tälle tittelille",
			"name": "Nimi",
			"type": "Tyyppi",
			"size": "Koko",
			"download-all": "Lataa kaikki",
			"back": "Takaisin resursseihin"
		},
		"refunds": {
			"states": {
				"refunded": "Hyvitetty",
				"unavailable": "Hyvitystä ei saatavana"
			},
			"reasons": {
				"dropped": "Luovuin kurssista",
				"wrong": "Tämä ei ollut kurssini kannalta oikea kirja",
				"print": "Päätin ostaa painetun kirjan",
				"missing": "Kirja ei sisällä kaikkea mitä kurssiani varten tarvitsen (esim. CD-levyä, pääsyä verkkopalveluihin, videoita)",
				"other": "Muu"
			},
			"bulk": {
				"policy": "Klikkaamalla alla olevaa painiketta &quot;Täysi hyvitys&quot; / &quot;Complete Refund&quot; ilmoitan hyväksyväni %{brand}in <a href='%{policy_url}' target='_blank'>hyvityskäytännön</a>.",
				"complete": "Täysi hyvitys",
				"view-details": "Katso hyvityksen (palautuksen) tiedot",
				"success": "Hyvitystäsi on pyydetty. Käsittelemme asian 48 tunnin kuluessa.",
				"failure": "Oho - jokin meni vikaan! Hyvityksesi ei ikävä kyllä mennyt läpi.",
				"retry": "Yritä uudelleen",
				"support": "Ota yhteyttä tukeen",
				"available-codes": "Käytettävissä olevat koodit",
				"codes-selected": "Valitut koodit",
				"download": "Lataa koodit",
				"partially-refunded": "Osittain hyvitetty (palautettu)",
				"pick-one": "Sinun pitää valita ainakin yksi koodi hyvitystä varten"
			},
			"refund": "Hyvitys",
			"all": "Hyvitetäänkö (palautetaanko) kaikki?",
			"missing-reason": "Sinun pitää valita syy voidaksesi jatkaa",
			"missing-elaboration": "Tarkenna",
			"policy": "Klikkaamalla alla olevaa painiketta “Complete Refund Request\" / \"Pyydä palautusta\" ilmoitan ymmärtäväni, että jos ostan tämän %{brand} eTextbook-oppikirjan uudelleen, minulla ei ole enää oikeutta pyytää hyvityksiä samasta eTextbook-oppikirjasta. Katso täydelliset palautuskäytäntöä koskevat tiedot.",
			"refunded": "Hyvitetty",
			"sorry": "Olemma pahoillamme siitä, ettet ollut tyytyväinen ostokseesi.",
			"error": "Jokin meni vikaan",
			"error-explain": "Emme pysty käsittelemään hyvitystäsi. Yritä uudelleen.",
			"why": "Kerro meille miksi?",
			"no-refunds": "Sinulla ei ole yhtään hyvitettyä tuotetta.",
			"select-codes": "Valitse hyvitettävä(t) koodi(t):",
			"number": "Kuinka monta?",
			"back": "Takaisin hyvityksiin"
		},
		"purchases": {
			"back": "Takaisin ostoksiin"
		},
		"global-bar": {
			"account": "Tilin asetukset"
		}
	};

/***/ },
/* 981 */
/***/ function(module, exports) {

	module.exports = {
		"base": {
			"welcome": "Maligayang Pagdating sa Mulligans, %{name}!",
			"user": "Impormasyon ukol sa User",
			"devices": "Mga Devices",
			"refunds": "Mga Refund",
			"resources": "Mga Resources",
			"transactions": "Mga Order at Pagbabalik",
			"email": "Email",
			"password": "Password",
			"save": "I-save",
			"sign-out": "Mag-sign Out",
			"cancel": "Kanselahin",
			"close": "Isara",
			"learn-more": "Alamin pa",
			"required": "Kinakailangan",
			"support": "Suporta",
			"bookshelf": "Bookshelf",
			"launch": "Ilunsad",
			"download": "I-download",
			"details": "Mga Detalye",
			"cannot-be-blank": "Hindi maaaring blangko ang %{field}.",
			"saving": "Sini-save...",
			"done": "Tapos na",
			"failed": "Nabigo",
			"copy": "Kopyahin"
		},
		"signin": {
			"login-failure": "Hindi tama ang email o password",
			"welcome-large": "Maligayang Pagdating sa %{brand} <span class='inner'>Account Center</span>",
			"welcome-small": "<span class='inner'>Account Center</span>",
			"signin-button": "Mag-sign In",
			"forgot-password": "Nakalimutan ang Password mo",
			"new-to-vst": "Bago sa %{brand}?",
			"create-account": "Gumawa ng account",
			"signing-in": "Nagsa-sign in...",
			"signin-failed": "Nabigo ang pag-sign in"
		},
		"transactions": {
			"price": "Presyo",
			"excluded": "(Walang kasamang buwis)",
			"quantity": "Dami",
			"confirmation#": "Kumpirmasyon #",
			"payment": "Pagbabayad",
			"purchased": "Binili",
			"purchase-details": "Mga Detalye ng Pagbili",
			"subtotal": "Sub Total",
			"total": "Kabuuan",
			"tax": "Buwis",
			"loading": "Uy big spender, nilo-load na namin ang mga transaksyon mo...",
			"no-purchases": "Wala kang mga binili.",
			"seller-vat": "VAT ng Nagbebenta",
			"total-vat": "Kabuuang Binayaran na %{vat}",
			"portion": "%{subTax} Buwis %{rate}%",
			"vat-disclosure": "Kasama sa Presyo ang %{vat}",
			"purchases": "Mga Pagbili",
			"refunded-items": "Mga Ni-refund na Item",
			"book-title": "Pamagat ng Aklat",
			"refund-details": "Mga Detalye ng Refund",
			"print-receipt": "I-print ang Resibo",
			"request-refund": "Humiling ng Refund",
			"expired": "Nag-expired",
			"expires-in": "Mag-i-expire sa %{date}",
			"details-refund": "Mga Detalye at Refund",
			"modal": {
				"cant-refund-title": "Hindi Available ang Refund",
				"cant-refund": "Hindi maaaring i-refund ang iyong libro dahil sa isa o higit pang mga sumusunod na dahilan.",
				"cant-refund-1": "Masyado nang maraming nakita sa iyong libro.",
				"cant-refund-2": "14 na araw na ang nakalilipas mula sa petsa ng pagbili.",
				"cant-refund-3": "Na-reveal ang online resources code mo.",
				"cant-refund-4": "Dati nang na-refund ang libro mo.",
				"cant-refund-5": "Na-redeem na at/o na-refund na ang lahat ng code.",
				"cant-refund-6": "30 araw na ang nakalilipas mula sa petsa ng pagbili.",
				"cant-refund-support": "Kung hindi pa rin malinaw sa iyo ang patakaran sa pagrerefund ng %{brand}, makipag-ugnayan sa <a href='%{support_url}' target='_blank'>support</a>."
			},
			"license": {
				"perpetual": "Walang pagkapaso ang online access",
				"days": "%{days} (na) Araw na Access"
			}
		},
		"devices": {
			"description": "Pinahihintulutan ka ng %{brand} na magkaroon ng mga naka-activate na <span>%{desktop}</span> computer at <span>%{mobile}</span> mobile/tablet device sa anumang binigay na panahon.",
			"loading": "Kamusta, kinukuha na namin ang mga device mo :)",
			"no-active": "Wala kang mga aktibong device.",
			"deactivate": "I-deactivate"
		},
		"user": {
			"personal-information": "Personal na Impormasyon",
			"security-information": "Pangseguridad na Impormasyon",
			"notifications": "Mga Notipikasyon",
			"first-name": "Pangalan",
			"last-name": "Apelyido",
			"change-password-title": "Baguhin ang Password",
			"current-password": "Kasalukuyang Password",
			"new-password": "Bagong Password",
			"security-password": "Password",
			"confirm-new-password": "Kumpirmahin ang Bagong Password",
			"security-question": "Pangseguridad na Tanong",
			"security-info-change": "Baguhin",
			"question": "Tanong",
			"answer": "Sagot",
			"notifications-text": "I-email ako ng paminsan-minsang mga updates tungkol sa aktibidad ng aking account, mga updates sa produkto at mga espesyal na alok.",
			"loading": "Kinukuha na ni Spot ang user information mo, saglit lang 🐶",
			"change-password-text": "Dapat naglalaman ang password ng kahit 8 character man lang, uppercase na titik, maliit na titik at special character.",
			"email-locked": "Naka-lock ang Email",
			"email-locked-description": "Wala kang access para baguhin ang iyong email.",
			"email-locked-more": "Mangyaring makipag-ugnayan sa iyong administrador.",
			"security-question6": "Ano ang paborito mong sport?",
			"security-question7": "Ano ang paborito mong flavor ng ice cream?",
			"security-question8": "Ano ang pangalan ng paborito mong alagang hayop?",
			"security-question9": "Noong bata ka pa, ano ang gusto mong maging paglaki mo?",
			"security-question10": "Ano ang apelyido ng paborito mong guro?",
			"new-password-failure": "Hindi natupad ng password ang mga kinakailangan",
			"confirm-password-failure": "Kailangang tugma ang password",
			"new-password-tooltip": "Dapat naglalaman ng kahit 8 character man lang, isang uppercase na titik, maliit na titik at special character.",
			"enter-valid-email": "Pakipasok ang balidong email.",
			"password-cannot-be-same": "Ang password ay hindi maaaring kapareho ng dating password",
			"incorrect-password": "Maling Password",
			"complete-account": "Mukhang kailangan mong <a href='%{href}'>kumpletuhin ang iyong account</a>.",
			"completing-allows": "Magbibigay-daan sa iyo ang pagkumpleto sa iyong account na makapagbasa ng mga aklat offline sa aming mobile apps at makapagbahagi ng mga tala at highlights sa mga kaibigan.",
			"error-updating-info": "There was an error updating your information.",
			"password-updated": "Password successfully updated",
			"security-updated": "Security question successfully updated",
			"info-updated": "User information successfully updated"
		},
		"resources": {
			"ancillaries": "Mga Ancillaries",
			"access-codes": "Mga Access Code",
			"print-on-demand": "Print on Demand",
			"check-pod": "Tingnan ang mga opsyon ng publisher sa pagpi-print para sa iyong mga aklat.",
			"check-now": "Tingnan ito Ngayon",
			"loading": "Maghintay lang, ina-update namin ang iyong resources!",
			"in": "sa",
			"access-code-intro": "Ang access code ay isang password na ginagamit mo para ma-access ang nilalaman ng course online. Sa sandaling na-reveal mo ang code para sa item na iyon, hindi mo na maaaring ibalik ito. Para sa higit pang mga tagubilin kung paano gamitin ang iyong mga access code, bisitahin ang <a href='%{support_url}' target='_blank'>Support</a>.",
			"expires": "Mapapaso",
			"expiration-message": "Naglalaman ng mga tagubilin para sa paggamit ng iyong access code.",
			"copy-fail": "Hindi makopya. Mangyaring piliin ang code at manu-manong kopyahin ito.",
			"launch-site": "Ilunsad ang Site",
			"launch-book": "Buksan ang Libro",
			"reveal-code": "Ipakita ang Code",
			"no-resources": "Wala kang anumang resources.",
			"no-access-codes": "Wala kang anumang mga access code.",
			"no-ancillaries": "Walang mga ancillary para sa pamagat na ito",
			"name": "Pangalan",
			"type": "Uri",
			"size": "Laki",
			"download-all": "I-download Lahat",
			"back": "Bumalik sa resources"
		},
		"refunds": {
			"states": {
				"refunded": "Ni-refund",
				"unavailable": "Hindi Available ang Refund"
			},
			"reasons": {
				"dropped": "Binitawan ko ang course",
				"wrong": "Maling libro ito para sa aking course",
				"print": "Nagpasya akong bumili ng naka-print na bersyon sa halip",
				"missing": "Hindi naglalaman ang libro ng lahat ng kinakailangan ko para sa aking course (hal., CD, web access, mga video)",
				"other": "Iba pa"
			},
			"bulk": {
				"policy": "Sa pag-click sa button na &quot;Kumpletuhin ang Refund&quot; sa ibaba, sumasang-ayon ako sa patakaran ng %{brand} <a href='%{policy_url}' target='_blank'>sa pag-refund</a>.",
				"complete": "Kumpletuhin ang Refund",
				"view-details": "Tingnan ang mga Detalye ng Refund",
				"success": "Hiniling na ang iyong refund. Mangyaring maghintay ng 48 oras para sa pagproseso.",
				"failure": "Oops - nagkaroon ng problema! Sa kasamaang palad, hindi nagawa ang iyong refund.",
				"retry": "Subukan Ulit",
				"support": "Makipag-ugnayan sa Suporta",
				"available-codes": "Mga Available na Code",
				"codes-selected": "Mga Piniling Code",
				"download": "I-download ang Mga Code",
				"partially-refunded": "Bahagya Lang ang Na-refund",
				"pick-one": "Dapat kang pumili ng kahit isang code man lang para makapag-refund"
			},
			"refund": "I-refund",
			"all": "I-refund Lahat?",
			"missing-reason": "Dapat kang pumili ng dahilan para magpatuloy",
			"missing-elaboration": "Paki detalye pa",
			"policy": "Sa pag-click sa button na \"Kumpletuhin ang Hiling na Pag-refund\" sa ibaba, nauunawaan ko na kapag binili ko ulit ang %{brand} eTextbook na ito, hindi na ako kwalipikadong humiling ng anumang higit pang mga refund para sa parehong eTextbook. Tingnan ang buong patakaran sa pagsasauli.",
			"refunded": "Ni-refund",
			"sorry": "Ikinalulungkot namin na hindi ka nasiyahan sa iyong binili.",
			"error": "May nangyaring mali.",
			"error-explain": "Hindi namin maproseso ang refund mo. Pakisubukan ulit.",
			"why": "Sabihin sa amin kung bakit?",
			"no-refunds": "Walang kang mga ni-refund na item.",
			"select-codes": "Pumili ng (mga) code na ire-refund:",
			"number": "Ilan?",
			"back": "Bumalik sa refunds"
		},
		"purchases": {
			"back": "Bumalik sa mga pagbili"
		},
		"global-bar": {
			"account": "Mga Settings ng Account"
		}
	};

/***/ },
/* 982 */
/***/ function(module, exports) {

	module.exports = {
		"base": {
			"welcome": "Bienvenue à Mulligans, %{name} !",
			"user": "Informations sur les utilisateurs",
			"devices": "Périphériques",
			"refunds": "Remboursements",
			"resources": "Ressources",
			"transactions": "Commandes et retours",
			"email": "Courriel",
			"password": "Mot de passe",
			"save": "Enregistrer",
			"sign-out": "Se déconnecter",
			"cancel": "Annuler",
			"close": "Fermer",
			"learn-more": "En savoir plus",
			"required": "Obligatoire",
			"support": "Assistance",
			"bookshelf": "Bibliothèque",
			"launch": "Lancement",
			"download": "Télécharger",
			"details": "Détails",
			"cannot-be-blank": "%{field} ne peut être vide.",
			"saving": "Enregistrement...",
			"done": "Terminé",
			"failed": "Échec",
			"copy": "Copier"
		},
		"signin": {
			"login-failure": "Courriel ou mot de passe incorrect",
			"welcome-large": "Bienvenue <span class='inner'>au centre de comptes de %{brand}</span>",
			"welcome-small": "<span class='inner'> Centre de comptes </span>",
			"signin-button": "Se connecter",
			"forgot-password": "Mot de passe oublié?",
			"new-to-vst": "Nouveau pour %{brand}?",
			"create-account": "Créer un compte",
			"signing-in": "Connexion...",
			"signin-failed": "Échec de connexion"
		},
		"transactions": {
			"price": "Prix",
			"excluded": "(Hors taxes)",
			"quantity": "Quantité",
			"confirmation#": "Confirmation n °",
			"payment": "Paiement",
			"purchased": "Acheté",
			"purchase-details": "Détails d'achat",
			"subtotal": "Sous-total",
			"total": "Total",
			"tax": "Taxe",
			"loading": "Hey le grand gaspilleur, vos transactions sont en cours de chargement...",
			"no-purchases": "Vous n'avez aucun achat.",
			"seller-vat": "TVA du fournisseur",
			"total-vat": "%{vat} totale payée",
			"portion": "%{subTax} % des taxes %{rate}",
			"vat-disclosure": "Prix TTC %{vat}",
			"purchases": "Achats",
			"refunded-items": "Articles remboursés",
			"book-title": "Titre du livre",
			"refund-details": "Détails de remboursement",
			"print-receipt": "Imprimer le reçu",
			"request-refund": "Demander le remboursement",
			"expired": "Expiré",
			"expires-in": "Expire le %{date}",
			"details-refund": "Détails et remboursement",
			"modal": {
				"cant-refund-title": "Remboursement non disponible",
				"cant-refund": "Votre livre ne peut pas être remboursé pour l'une ou plusieurs des raisons suivantes.",
				"cant-refund-1": "Beaucoup trop de votre livre a été vu.",
				"cant-refund-2": "Plus de 14 jours se sont écoulés depuis la date d'achat.",
				"cant-refund-3": "Votre code de ressources en ligne a été révélé.",
				"cant-refund-4": "Votre livre a été précédemment remboursé.",
				"cant-refund-5": "Tous les codes ont déjà été rachetés et/ou remboursés.",
				"cant-refund-6": "Plus de 30 jours se sont écoulés depuis la date d'achat.",
				"cant-refund-support": "Si vous n'êtes toujours pas sûr de la politique de remboursement de %{brand}, communiquer <a href='%{support_url}' target='_blank'>avec le service de soutien à la clientèle </a>."
			},
			"license": {
				"perpetual": "L'accès en ligne n'expire pas",
				"days": "%{days} jours d'accès"
			}
		},
		"devices": {
			"description": "%{brand} vous permet d'avoir des ordinateurs <span>%{desktop}</span> et des appareils mobiles/tablettes <span>%{mobile}</span> activées à tout moment.",
			"loading": "Hey, nous vérifions vos appareils :)",
			"no-active": "Vous n'avez pas d'appareils activés.",
			"deactivate": "Désactiver"
		},
		"user": {
			"personal-information": "Données personnelles",
			"security-information": "Informations sur la sécurité",
			"notifications": "Notifications",
			"first-name": "Prénom",
			"last-name": "Nom",
			"change-password-title": "Changer de mot de passe",
			"current-password": "Mot de passe actuel",
			"new-password": "Nouveau mot de passe",
			"security-password": "Mot de passe",
			"confirm-new-password": "Confirmer le nouveau mot de passe",
			"security-question": "Question de sécurité",
			"security-info-change": "Modifier",
			"question": "Question",
			"answer": "Réponse",
			"notifications-text": "Envoyez-moi des mises à jour occasionnelles sur des activités sur mon compte, des mises à jour de produits et des offres spéciales.",
			"loading": "Spot est entrain de chercher vos informations utilisateur, patientez une un seconde 🐶",
			"change-password-text": "Le mot de passe doit comprendre au moins 8 caractères, une lettre majuscule, une lettre minuscule et un caractère spécial.",
			"email-locked": "Adresse courriel verrouillée",
			"email-locked-description": "Vous n'êtes pas autorisé à modifier votre courriel.",
			"email-locked-more": "Veuillez contacter votre administrateur.",
			"security-question6": "Quelle est votre sport préféré?",
			"security-question7": "Quelle est votre saveur préférée en matière de crème glacée?",
			"security-question8": "Quel est le nom de votre animal préféré?",
			"security-question9": "Quand vous étiez jeune, que vouliez-vous faire lorsque vous seriez plus grand?",
			"security-question10": "Quel était le nom de famille de votre enseignant préféré?",
			"new-password-failure": "Le mot de passe ne répond pas aux exigences",
			"confirm-password-failure": "Les mots de passe doivent être identiques",
			"new-password-tooltip": "Doit avoir 8 caractères au moins, une lettre majuscule, une lettre minuscule et un caractère spécial.",
			"enter-valid-email": "Veuillez saisir une adresse courriel valide.",
			"password-cannot-be-same": "Le mot de passe ne peut pas être le même que le mot de passe précédent",
			"incorrect-password": "Mot de passe incorrect",
			"complete-account": "On dirait que vous avez besoin de <a href='%{href}'>compléter votre compte</a>.",
			"completing-allows": "Le fait de compléter votre compte vous permet de lire des livres en mode hors ligne sur nos applications mobiles et de partager des notes et des surlignes avec des amis.",
			"error-updating-info": "There was an error updating your information.",
			"password-updated": "Password successfully updated",
			"security-updated": "Security question successfully updated",
			"info-updated": "User information successfully updated"
		},
		"resources": {
			"ancillaries": "Accessoires",
			"access-codes": "Codes d'accès",
			"print-on-demand": "Impression à la demande",
			"check-pod": "Vérifiez les options d'impression Publisher pour vos livres.",
			"check-now": "Vérifier maintenant",
			"loading": "Patientez, nous mettons à jour vos ressources!",
			"in": "dans",
			"access-code-intro": "Un code d'accès est un mot de passe que vous utilisez pour accéder au contenu du cours en ligne. Une fois que vous révélez un code pour un article, vous ne serez pas en mesure de le retourner. Pour de plus amples informations sur la façon d'utiliser votre code d'accès, veuillez visiter <a href='%{support_url}' target='_blank'>le service d'assistance</a>.",
			"expires": "Expire le",
			"expiration-message": "Comprend les instructions nécessaires pour utiliser votre code d'accès.",
			"copy-fail": "Impossible de copier. Veuillez sélectionner le code et le copier manuellement.",
			"launch-site": "Lancer le site",
			"launch-book": "Lancement du livre",
			"reveal-code": "Révéler le code",
			"no-resources": "Vous n'avez aucune ressource.",
			"no-access-codes": "Vous ne disposez pas de codes d'accès.",
			"no-ancillaries": "Aucun article auxilaire pour ce titre",
			"name": "Nom",
			"type": "Type",
			"size": "Taille",
			"download-all": "Télécharger tout",
			"back": "Retour aux ressources"
		},
		"refunds": {
			"states": {
				"refunded": "Remboursé",
				"unavailable": "Remboursement non disponible"
			},
			"reasons": {
				"dropped": "J'ai abandonné le cours",
				"wrong": "C'était le mauvais livre pour mon cours",
				"print": "J'ai décidé d'acheter la version imprimée à la place",
				"missing": "Le livre ne comprend pas tout ce dont j'ai besoin pour mon cours (par exemple, un CD, l'accès au Web, vidéos)",
				"other": "Autre"
			},
			"bulk": {
				"policy": "En cliquant sur le bouton « Remboursement intégral » ci-dessous, j'accepte la politique de remboursement de %{brand} <a href='%{policy_url}' target='_blank'>.</a>.",
				"complete": "Remboursement intégral",
				"view-details": "Afficher les détails de remboursement",
				"success": "Votre remboursement a été demandé. Veuillez attendre 48 heures pour le traitement.",
				"failure": "Oops - une erreur s'est produite! Malheureusement, votre remboursement n'a pas été effectué.",
				"retry": "Essayez à nouveau",
				"support": "Communiquer avec le service technique",
				"available-codes": "Codes disponibles",
				"codes-selected": "Codes sélectionnés",
				"download": "Télécharger des codes",
				"partially-refunded": "Partiellement remboursé",
				"pick-one": "Vous devez sélectionner au moins un code pour effectuer un remboursement"
			},
			"refund": "Remboursement",
			"all": "Tout rembourser?",
			"missing-reason": "Vous devez sélectionner une raison pour continuer",
			"missing-elaboration": "Veuillez préciser",
			"policy": "En cliquant sur le bouton « Remplir la demande de remboursement » ci-dessous, je comprends que si j'achète ce manuel électronique de %{brand} encore une fois, je ne serai pas admissible à demander d'autres remboursements pour le même manuel électronique. Voir la politique complète en matière de remboursement.",
			"refunded": "Remboursé",
			"sorry": "Nous sommes désolés que vous n'étiez pas satisfait de votre achat.",
			"error": "Une erreur s'est produite. ",
			"error-explain": "Imppossible de traiter votre remboursement. Veuillez réessayer.",
			"why": "Pourriez-vous nous dire pourquoi?",
			"no-refunds": "Vous n'avez pas d'articles remboursés.",
			"select-codes": "Sélectionnez le(s) code(s) à rembourser :",
			"number": "Combien?",
			"back": "Retour aux remboursements"
		},
		"purchases": {
			"back": "Retour aux achats"
		},
		"global-bar": {
			"account": "Paramètres de compte"
		}
	};

/***/ },
/* 983 */
/***/ function(module, exports) {

	module.exports = {
		"base": {
			"welcome": "Bienvenue sur Mulligans, %{name} !",
			"user": "Infos utilisateurs",
			"devices": "Appareils",
			"refunds": "Remboursements",
			"resources": "Ressources",
			"transactions": "Commandes et retours",
			"email": "Courriel",
			"password": "Mot de passe",
			"save": "Enregistrer",
			"sign-out": "Se déconnecter",
			"cancel": "Annuler",
			"close": "Fermer",
			"learn-more": "En savoir plus",
			"required": "Requis",
			"support": "Support",
			"bookshelf": "Bookshelf",
			"launch": "Lancement",
			"download": "Télécharger",
			"details": "Détails",
			"cannot-be-blank": "%{field} ne peut pas être vide",
			"saving": "Sauvegarde en cours…",
			"done": "Terminé",
			"failed": "Echec",
			"copy": "Copier"
		},
		"signin": {
			"login-failure": "Votre mot de passe ou votre e-mail est incorrect",
			"welcome-large": "Bienvenue dans l'Account Center <span class='inner'>%{brand}</span>",
			"welcome-small": "<span class='inner'>Account Center</span>",
			"signin-button": "Se connecter",
			"forgot-password": "Vous avez oublié votre mot de passe ?",
			"new-to-vst": "Vous découvrez %{brand} ?",
			"create-account": " Créer un compte",
			"signing-in": "Connexion...",
			"signin-failed": "Échec de la connexion"
		},
		"transactions": {
			"price": "Prix",
			"excluded": "(Hors taxes)",
			"quantity": "Quantité",
			"confirmation#": "Nº de confirmation",
			"payment": "Paiement",
			"purchased": "Acheté",
			"purchase-details": "Informations de l'achat",
			"subtotal": "Sous-Total",
			"total": "Total",
			"tax": "Taxe",
			"loading": "Nous chargeons vos transactions, petit dépensier...",
			"no-purchases": "Aucun achat trouvé.",
			"seller-vat": "TVA vendeur",
			"total-vat": "%{vat} totale payée",
			"portion": "%{subTax} Taxes %{rate}%",
			"vat-disclosure": "Le prix comprend %{vat}",
			"purchases": "Achats",
			"refunded-items": "Articles remboursés",
			"book-title": "Titre du livre",
			"refund-details": "Informations de remboursement",
			"print-receipt": "Imprimer le reçu",
			"request-refund": "Demande de remboursement",
			"expired": "Arrivé à expiration",
			"expires-in": "Expire le %{date}",
			"details-refund": "Détails et remboursement",
			"modal": {
				"cant-refund-title": "Remboursement non disponible",
				"cant-refund": "Votre livre ne peut pas être remboursé pour une ou plusieurs des raisons qui suivent.",
				"cant-refund-1": "Une trop grande quantité de livre a été lue.",
				"cant-refund-2": "Plus de 14 jours se sont écoulés depuis la date d'achat.",
				"cant-refund-3": "Votre code de ressources en ligne a été révélé.",
				"cant-refund-4": "Votre livre a déjà été remboursé.",
				"cant-refund-5": "Tous les codes ont déjà été utilisés et/ou remboursés",
				"cant-refund-6": "Plus de 30 jours se sont écoulés depuis la date d'achat.",
				"cant-refund-support": "Si vous avez toujours des questions sur la politique de remboursement de %{brand}, contactez <a href='%{support_url}' target='_blank'>le service d'assistance</a>."
			},
			"license": {
				"perpetual": "L'accès en ligne n'expirera pas",
				"days": "%{days} Accès journalier"
			}
		},
		"devices": {
			"description": "%{brand} vous permet d'activer les ordinateurs <span>%{desktop}</span> et appareils mobiles/tablettes <span>%{mobile}</span> à tout moment.",
			"loading": "Nous enregistrons vos appareils",
			"no-active": "Vous ne disposez d'aucun appareil actif.",
			"deactivate": "Désactiver"
		},
		"user": {
			"personal-information": "Informations personnelles",
			"security-information": "Données de sécurité",
			"notifications": "Notifications",
			"first-name": "Prénom",
			"last-name": "Nom",
			"change-password-title": "Modifier le mot de passe",
			"current-password": "Mot de passe actuel",
			"new-password": "Nouveau mot de passe",
			"security-password": "Mot de passe",
			"confirm-new-password": "Confirmation du nouveau mot de passe",
			"security-question": "Question de sécurité",
			"security-info-change": "Modifier",
			"question": "Question",
			"answer": "Réponse",
			"notifications-text": "Envoyez-moi les mises à jour occasionnelles sur l'activité de mon compte, les mises à jour de produits et les offres spéciales.",
			"loading": "Spot recherche vos informations utilisateur, un instant 🐶",
			"change-password-text": "Votre mot de passe doit contenir au moins 8 caractères, une lettre majuscule, une lettre minuscule et un caractère spécial.",
			"email-locked": "E-mail verrouillé",
			"email-locked-description": "Vous n'avez pas accès pour changer votre adresse e-mail.",
			"email-locked-more": "Veuillez contacter votre administrateur.",
			"security-question6": "Quel est votre sport préféré ?",
			"security-question7": "Quelle est votre glace préférée ?",
			"security-question8": "Quel est le nom de votre animal préféré ?",
			"security-question9": "Quand vous étiez petit, vous vouliez être...?",
			"security-question10": "Quel était le nom de famille votre professeur préféré ?",
			"new-password-failure": "Le mot de passe ne répond pas aux conditions",
			"confirm-password-failure": "Le mot de passe doit correspondre",
			"new-password-tooltip": "Doit contenir au moins 8 caractères, une lettre majuscule, une lettre minuscule et un caractère spécial.",
			"enter-valid-email": "Veuillez saisir une adresse mail valide.",
			"password-cannot-be-same": "Votre mot de passe actuel et votre mot de passe précédent ne peuvent pas être identiques",
			"incorrect-password": "Mot de passe incorrect",
			"complete-account": "On dirait que vous avez besoin de <a href='%{href}'>compléter votre compte</a>.",
			"completing-allows": "Votre compte vous permet de lire des livres en mode hors connexion sur nos applications mobiles et de partager des notes et des surlignes avec des amis.",
			"error-updating-info": "There was an error updating your information.",
			"password-updated": "Password successfully updated",
			"security-updated": "Security question successfully updated",
			"info-updated": "User information successfully updated"
		},
		"resources": {
			"ancillaries": "Annexes",
			"access-codes": "Codes d'accès",
			"print-on-demand": "Impression à la demande",
			"check-pod": "Consultez les options d'impression éditeur pour vos livres.",
			"check-now": "Vérifier maintenant",
			"loading": "Veuillez patienter, nous mettons vos ressources à jour !",
			"in": "dans",
			"access-code-intro": "Un code d'accès est un mot de passe que vous utilisez pour accéder au contenu de vos cours en ligne. Une fois que vous affichez le code d'un article, vous ne serez pas en mesure de le rendre. Pour plus d'instructions sur l'utilisation de votre code d'accès, veuillez contacter <a href='%{support_url}' target='_blank'>le centre d'assistance</a>.",
			"expires": "Arrive à expiration",
			"expiration-message": "Contient des instructions d'utilisation pour votre code d'accès.",
			"copy-fail": "Copie impossible. Veuillez sélectionner le code et copiez-le manuellement.",
			"launch-site": "Ouvrir le site",
			"launch-book": "Ouvrir le livre",
			"reveal-code": "Afficher le code",
			"no-resources": "Vous n'avez aucune ressources.",
			"no-access-codes": "Vous n'avez aucun code d'accès.",
			"no-ancillaries": "Aucune annexe pour ce titre",
			"name": "Nom",
			"type": "Type",
			"size": "Taille",
			"download-all": "Tout télécharger",
			"back": "Retour aux ressources"
		},
		"refunds": {
			"states": {
				"refunded": "Remboursé",
				"unavailable": "Remboursement non disponible"
			},
			"reasons": {
				"dropped": "J'ai abandonné le cours",
				"wrong": "Ce livre ne correspondait pas à mon cours",
				"print": "Je décidé d'acheter une version imprimée à la place",
				"missing": "Le livre ne contient pas tout ce dont j'ai besoin pour mon cours (un CD, un lien vers la page web, des vidéos)",
				"other": "Autres"
			},
			"bulk": {
				"policy": "En cliquant sur la touche « Effectuer remboursement » ci-dessous, j'accepte la  <a href='%{policy_url}' target='_blank'>politique de remboursement</a> de %{brand}.",
				"complete": "Effectuer remboursement",
				"view-details": "Afficher les détails du remboursement",
				"success": "Vous avez demandé un remboursement. Veuillez patienter 48 heures pour son traitement.",
				"failure": "Oups ! Une erreur s'est produite... Malheureusement, votre remboursement n'a pas été confirmé.",
				"retry": "Essayez à nouveau",
				"support": "Contacter le service technique",
				"available-codes": "Codes disponibles",
				"codes-selected": "Codes sélectionnés",
				"download": "Télécharger codes",
				"partially-refunded": "Partiellement remboursé",
				"pick-one": "Vous devez sélectionner au minimum un code pour effectuer un remboursement"
			},
			"refund": "Remboursement",
			"all": "Tout rembourser ?",
			"missing-reason": "Vous devez sélectionner une raison avant de continuer",
			"missing-elaboration": "Veuillez préciser",
			"policy": "En cliquant sur le bouton « Effectuer une demande de remboursement » ci-dessous, je comprends que si j'achète à nouveau cet eTextbook %{brand}, je ne pourrai pas effectuer une demande de remboursement supplémentaire pour le même eTextbook. Afficher la politique de retour complète.",
			"refunded": "Remboursé",
			"sorry": "Nous sommes désolés d'apprendre que vous n'avez pas été satisfait(e) de votre achat.",
			"error": "Une erreur s'est produite. ",
			"error-explain": "Nous n'avons pas pu traiter votre remboursement. Veuillez réessayer.",
			"why": "Dites-nous pourquoi ?",
			"no-refunds": "Aucun article remboursé.",
			"select-codes": "Sélectionnez un(des) code(s) à rembourser :",
			"number": "Combien ?",
			"back": "Retour aux remboursements"
		},
		"purchases": {
			"back": "Retour aux achats"
		},
		"global-bar": {
			"account": "Paramètres du compte"
		}
	};

/***/ },
/* 984 */
/***/ function(module, exports) {

	module.exports = {
		"base": {
			"welcome": "Fáilte chuig Mulligans, %{name}!",
			"user": "Faisnéis úsáideora",
			"devices": "Gléasanna",
			"refunds": "Aisíocaíochtaí",
			"resources": "Acmhainní",
			"transactions": "Orduithe & Tuairisceáin",
			"email": "Ríomhphost",
			"password": "Pasfhocal",
			"save": "Sábháil",
			"sign-out": "Sínigh amach",
			"cancel": "Cealaigh",
			"close": "Dún",
			"learn-more": "Tuilleadh faisnéise",
			"required": "Riachtanach",
			"support": "Tacaíocht",
			"bookshelf": "Bookshelf",
			"launch": "Lainseáil",
			"download": "Íoslódáil",
			"details": "Mionsonraí",
			"cannot-be-blank": "%{field}: ní féidir é seo a fhágáil folamh.",
			"saving": "Ag sábháil...",
			"done": "Déanta",
			"failed": "Teipthe",
			"copy": "Cóipeáil"
		},
		"signin": {
			"login-failure": "Tá an seoladh ríomhphoist nó pasfhocal mícheart",
			"welcome-large": "Fáilte chuig <span class='inner'>Lárionad Cuntas %{brand}</span>",
			"welcome-small": "<span class='inner'>Account Center</span>",
			"signin-button": "Sínigh isteach",
			"forgot-password": "An bhfuil dearmad déanta agat ar do phasfhocal?",
			"new-to-vst": "An é seo do chéad eispéireas le %{brand}?",
			"create-account": "Cruthaigh cuntas",
			"signing-in": "Ag síniú isteach...",
			"signin-failed": "Níor éirigh le síniú isteach"
		},
		"transactions": {
			"price": "Praghas",
			"excluded": "(Gan cáin a áireamh)",
			"quantity": "Líon",
			"confirmation#": "Uimh. dheimhnithe",
			"payment": "Íocaíocht",
			"purchased": "Ar ceannaíodh iad",
			"purchase-details": "Mionsonraí an cheannacháin",
			"subtotal": "Fo-iomlán",
			"total": "Iomlán",
			"tax": "Cáin",
			"loading": "Tá do chuid idirbheart á lódáil againn...",
			"no-purchases": "Níl aon cheannacháin agat.",
			"seller-vat": "CBL an díoltóra",
			"total-vat": "Méid iomlán %{vat} íoctha",
			"portion": "%{subTax} Cáin %{rate}%",
			"vat-disclosure": "Áirítear %{vat} leis an bpraghas",
			"purchases": "Ceannacháin",
			"refunded-items": "Míreanna aisíoctha",
			"book-title": "Teideal an leabhair",
			"refund-details": "Sonraí aisíocaíochta",
			"print-receipt": "Priontáil admháil",
			"request-refund": "Iarr ar aisíocaíocht",
			"expired": "Imithe as feidhm",
			"expires-in": "Rachaidh sé in éag an %{date}",
			"details-refund": "Sonraí & Aisíocaíocht",
			"modal": {
				"cant-refund-title": "Níl aisíocaíocht ar fáil",
				"cant-refund": "Ní féidir aisíocaíocht a fháil i leith an leabhair de bharr ceann amháin nó níos mó de na cúiseanna seo a leanas.",
				"cant-refund-1": "Amharcadh ar rómhéid den leabhar.",
				"cant-refund-2": "Ceannaíodh é breis is 14 lá ó shin.",
				"cant-refund-3": "Nochtadh do chód acmhainní ar líne.",
				"cant-refund-4": "Aisíocadh an leabhar cheana.",
				"cant-refund-5": "Rinneadh na cóid go léir a fhuascailt agus/nó a aisíoc cheana.",
				"cant-refund-6": "Tá níos mó ná 30 lá imithe thart ón dáta ceannacháin.",
				"cant-refund-support": "Má tá tú míchinnte go fóill faoi pholasaí aisíocaíochta %{brand}, déan teagmháil leis an <a href='%{support_url}' target='_blank'>bhfoireann tacaíochta</a>."
			},
			"license": {
				"perpetual": "Ní rachaidh rochtain ar líne in éag",
				"days": "%{days}: líon na laethanta rochtana"
			}
		},
		"devices": {
			"description": "Ligeann %{brand} duit <span>%{desktop}</span> ríomhaire agus <span>%{mobile}</span> gléas móibíleach/táibléad a bheith gníomhachtaithe agat ag an am céanna.",
			"loading": "Tá do chuid gléasanna á bhfáil againn :)",
			"no-active": "Níl aon ghléas gníomhachtaithe agat.",
			"deactivate": "Díghníomhachtaigh"
		},
		"user": {
			"personal-information": "Faisnéis phearsanta",
			"security-information": "Faisnéis slándála",
			"notifications": "Fógraí",
			"first-name": "Céadainm",
			"last-name": "Sloinne",
			"change-password-title": "Athraigh an pasfhocal",
			"current-password": "Pasfhocal reatha",
			"new-password": "Pasfhocal nua",
			"security-password": "Pasfhocal",
			"confirm-new-password": "Deimhnigh an pasfhocal nua",
			"security-question": "Ceist slándála",
			"security-info-change": "Athraigh",
			"question": "Ceist",
			"answer": "Freagra",
			"notifications-text": "Seol ríomhphoist chugam ó am go ham maidir le gníomhaíocht ar mo chuntas, le nuashonruithe táirge agus le tairiscintí speisialta.",
			"loading": "Tá d'fhaisnéis úsáideora á fáil ag an madra, fan nóiméad 🐶",
			"change-password-text": "Ní mór 8 gcarachtar ar a laghad, mar aon le litir chás uachtair, litir chás íochtair agus carachtar speisialta amháin, a bheith sa phasfhocal.",
			"email-locked": "Ríomhphost glasáilte",
			"email-locked-description": "Níl cead agat do sheoladh ríomhphoist a athrú.",
			"email-locked-more": "Déan teagmháil leis an riarthóir.",
			"security-question6": "Cén spórt is fearr leat?",
			"security-question7": "Cén blas uachtar reoite is fearr leat?",
			"security-question8": "Cén t-ainm atá ar an bpeata is fearr leat? ",
			"security-question9": "Nuair a bhí tú óg, cén post a theastaigh uait a bheith agat mar dhuine fásta? ",
			"security-question10": "Cén sloinne a bhí ag an múinteoir ab fhearr leat?",
			"new-password-failure": "Níl na riachtanais á gcomhlíonadh ag an bpasfhocal.",
			"confirm-password-failure": "Ní mór do na pasfhocail a bheith mar an gcéanna",
			"new-password-tooltip": "Ní mór 8 gcarachtar ar a laghad, litir chás uachtair, litir chás íochtair agus carachtar speisialta a bheith ann.",
			"enter-valid-email": "Cuir isteach seoladh ríomhphoist bailí.",
			"password-cannot-be-same": "Ní féidir an pasfhocal roimhe seo a úsáid arís.",
			"incorrect-password": "Pasfhocal mícheart",
			"complete-account": "Is cosúil go bhfuil ort <a href='%{href}'>do chuntas a chomhlánú</a>.",
			"completing-allows": "Comhlánaigh do chuntas chun leabhair a léamh as líne ar ár bhfeidhmchlár móibíleach agus chun nótaí agus sleachta aibhsithe a roinnt le cairde.",
			"error-updating-info": "There was an error updating your information.",
			"password-updated": "Password successfully updated",
			"security-updated": "Security question successfully updated",
			"info-updated": "User information successfully updated"
		},
		"resources": {
			"ancillaries": "Gabhálais",
			"access-codes": "Cóid rochtana",
			"print-on-demand": "Priontáil ar éileamh",
			"check-pod": "Seiceáil roghanna clóite foilsitheora na leabhar.",
			"check-now": "Seiceáil anois",
			"loading": "Fan nóiméad, tá do chuid acmhainní á nuashonrú againn!",
			"in": "in",
			"access-code-intro": "Is cód rochtana ann ná pasfhocal a úsáidtear chun inneachar an chúrsa ar líne a rochtain. A luaithe agus a nochtar cód míre, ní bheidh tú ábalta é a sheoladh ar ais. Chun tuilleadh treoracha a fháil maidir le conas na cóid rochtana a úsáid, gabh chuig an <a href='%{support_url}' target='_blank'>Ionad Tacaíochta</a>.",
			"expires": "Rachaidh sé in éag",
			"expiration-message": "Tá treoracha ann maidir le conas an cód rochtana a úsáid.",
			"copy-fail": "Ní féidir cóipeáil. Roghnaigh an cód agus déan é a chóipeáil de láimh.",
			"launch-site": "Lainseáil an suíomh",
			"launch-book": "Lainseáil an leabhar",
			"reveal-code": "Taispeáin an cód",
			"no-resources": "Níl aon acmhainní agat.",
			"no-access-codes": "Níl aon chóid rochtana agat.",
			"no-ancillaries": "Níl aon mhíreanna gaolmhara ag gabháil leis an teideal seo",
			"name": "Ainm",
			"type": "Cineál",
			"size": "Méid",
			"download-all": "Íoslódáil gach rud",
			"back": "Siar go dtí na hacmhainní"
		},
		"refunds": {
			"states": {
				"refunded": "Aisíoctha",
				"unavailable": "Níl aisíocaíocht ar fáil"
			},
			"reasons": {
				"dropped": "D'éirigh mé as an gcúrsa",
				"wrong": "Ní hé seo an leabhar cúrsa ceart",
				"print": "Chinn mé leagan clóite a cheannach ina ionad",
				"missing": "Níl na rudaí go léir sa leabhar atá riachtanach don chúrsa (m.sh. CD, rochtain ghréasáin, físeáin)",
				"other": "Eile"
			},
			"bulk": {
				"policy": "Má chliceálaim ar an gcnaipe &quot;Cuir an aisíocaíocht i gcrích&quot; thíos, táim ag comhaontú le polasaí aisíocaíochta %{brand} <a href='%{policy_url}' target='_blank'></a>.",
				"complete": "Cuir an aisíocaíocht i gcrích",
				"view-details": "Amharc ar na sonraí aisíocaíochta",
				"success": "Tá d'aisíocaíocht iarrtha. Fan 48 uair le próiseáil.",
				"failure": "Úps - bhí fadhb ann! Theip ar an aisíocaíocht.",
				"retry": "Bain triail eile as",
				"support": "Déan teagmháil leis an lucht tacaíochta",
				"available-codes": "Na cóid atá ar fáil",
				"codes-selected": "Na cóid roghnaithe",
				"download": "Íoslódáil cóid",
				"partially-refunded": "Aisíoctha i bpáirt",
				"pick-one": "Ní mór cód amháin ar a laghad a roghnú chun aisíocaíocht a dhéanamh"
			},
			"refund": "Aisíoc",
			"all": "An bhfuil fonn ort aisíocaíocht a fháil i leith gach ruda?",
			"missing-reason": "Ní mór cúis a roghnú chun leanúint ar aghaidh",
			"missing-elaboration": "Tabhair tuilleadh sonraí",
			"policy": "Má chliceálaim ar an gcnaipe “Cuir an t-iarratas ar aisíocaíocht i gcrích” thíos, tuigim má cheannaím an ríomhthéacsleabhar %{brand} arís, nach mbeidh mé i dteideal aisíocaíocht a fháil air. Amharc ar an bpolasaí iomlán aisdúichithe.",
			"refunded": "Aisíoctha",
			"sorry": "Tá brón orainn nach raibh tú sásta leis an gceannachán.",
			"error": "Bhí fadhb ann",
			"error-explain": "Ní féidir linn an aisíocaíocht a phróiseáil. Bain triail eile as.",
			"why": "Inis dúinn cén fáth?",
			"no-refunds": "Níl aon mhíreanna aisíoctha agat.",
			"select-codes": "Roghnaigh có(i)d lena (n-)aisíoc:",
			"number": "Cá mhéad?",
			"back": "Siar go dtí na haisíocaíochtaí"
		},
		"purchases": {
			"back": "Siar go dtí na ceannacháin"
		},
		"global-bar": {
			"account": "Socruithe cuntais"
		}
	};

/***/ },
/* 985 */
/***/ function(module, exports) {

	module.exports = {
		"base": {
			"welcome": "ברוכים הבאים ל-Mulligans,‏ %{name}!",
			"user": "פרטי משתמש",
			"devices": "מכשירים",
			"refunds": "החזרים כספיים",
			"resources": "משאבים",
			"transactions": "הזמנות והחזרות",
			"email": "דואר אלקטרוני",
			"password": "סיסמה",
			"save": "שמור",
			"sign-out": "התנתק",
			"cancel": "ביטול",
			"close": "סגור",
			"learn-more": "למידע נוסף",
			"required": "נדרש",
			"support": "תמיכה",
			"bookshelf": "Bookshelf",
			"launch": "הפעל",
			"download": "הורד",
			"details": "פרטים",
			"cannot-be-blank": "%{field} לא יכול להישאר ריק.",
			"saving": "שומר...",
			"done": "בוצע",
			"failed": "נכשל",
			"copy": "העתקה"
		},
		"signin": {
			"login-failure": "הדואר האלקטרוני או הסיסמה שגויים",
			"welcome-large": "ברוך הבא אל <span class='inner'>%{brand} Account Center</span>",
			"welcome-small": "<span class='inner'>Account Center</span>",
			"signin-button": "התחברות",
			"forgot-password": "האם שכחת את הסיסמה",
			"new-to-vst": "חדש ב-%{brand}?",
			"create-account": "צור חשבון",
			"signing-in": "נכנס למערכת...",
			"signin-failed": "הכניסה נכשלה"
		},
		"transactions": {
			"price": "מחיר",
			"excluded": "(לא כולל מסים)",
			"quantity": "כמות",
			"confirmation#": "מספר אישור",
			"payment": "תשלום",
			"purchased": "נרכש",
			"purchase-details": "פרטי הרכישה",
			"subtotal": "סכום כולל",
			"total": "סך הכל",
			"tax": "מס",
			"loading": "תודה שקנית אצלנו, אנחנו טוענים את העסקאות שלך...",
			"no-purchases": "אין לך רכישות.",
			"seller-vat": "מע\"מ של המוכר",
			"total-vat": "סך %{vat} ששולם",
			"portion": "%{subTax} מס %{rate}%",
			"vat-disclosure": "המחיר כולל %{vat}",
			"purchases": "רכישות",
			"refunded-items": "פריטים שעליהם ניתן החזר כספי",
			"book-title": "כותרת הספר",
			"refund-details": "פרטי החזר",
			"print-receipt": "הדפס קבלה",
			"request-refund": "בקש החזר כספי",
			"expired": "פג תוקף",
			"expires-in": "תפוגה %{date}",
			"details-refund": "פרטים והחזר כספי",
			"modal": {
				"cant-refund-title": "החזר כספי אינו זמין",
				"cant-refund": "לא ניתן לקבל החזר כספי על הספר שלך בשל סיבה אחת או יותר מהבאות.",
				"cant-refund-1": "יותר מדי מהספר נצפה.",
				"cant-refund-2": "חלפו מעל 14 יום מאז תאריך הרכישה.",
				"cant-refund-3": "קוד המשאבים המקוונים נחשף.",
				"cant-refund-4": "כבר קיבלת החזר כספי בעבר על הספר.",
				"cant-refund-5": "כל הקודים כבר מומשו ו/או ניתן עליהם החזר כספי.",
				"cant-refund-6": "חלפו מעל 30 יום מאז תאריך הרכישה.",
				"cant-refund-support": "אם עדיין אינך בטוח לגבי מדיניות ההחזרים של %{brand}, פנה <a href='%{support_url}' target='_blank'>לתמיכה</a>."
			},
			"license": {
				"perpetual": "לגישה מקוונת אין תוקף",
				"days": "גישה למשך %{days} ימים"
			}
		},
		"devices": {
			"description": "%{brand} מאפשר לך להחזיק <span>%{desktop}</span> מחשבים ו- <span>%{mobile}</span> מכשירים ניידים/טאבלטים מופעלים בכל זמן נתון.",
			"loading": "הי, אנחנו מקבלים את המכשירים שלך :)",
			"no-active": "אין לך מכשירים פעילים.",
			"deactivate": "בטל הפעלה"
		},
		"user": {
			"personal-information": "מידע אישי",
			"security-information": "מידע אבטחה",
			"notifications": "התראות",
			"first-name": "שם פרטי",
			"last-name": "שם משפחה",
			"change-password-title": "שנה סיסמה",
			"current-password": "סיסמה נוכחית",
			"new-password": "סיסמה חדשה",
			"security-password": "סיסמה",
			"confirm-new-password": "אשר סיסמה חדשה",
			"security-question": "שאלת אבטחה",
			"security-info-change": "שנה",
			"question": "שאלה",
			"answer": "תשובה",
			"notifications-text": "שלחו לי מדי פעם עדכונים בדוא\"ל אודות הפעילות בחשבון שלי, עדכוני מוצרים והצעות מיוחדות.",
			"loading": "לאקי רץ להביא את פרטי המשתמש שלך, רק רגע 🐶",
			"change-password-text": "הסיסמה חייבת להכיל לפחות 8 תווים, אות גדולה, אות קטנה ותו מיוחד.",
			"email-locked": "כתובת הדוא\"ל נעולה",
			"email-locked-description": "אין לך גישה לשנות את כתובת הדוא\"ל שלך.",
			"email-locked-more": "פנה אל מנהל המערכת שלך.",
			"security-question6": "מהו הספורט החביב עליך?",
			"security-question7": "מהי הגלידה האהובה עליך?",
			"security-question8": "מהו שם חיית המחמד האהובה עליך?",
			"security-question9": "כשהיית קטן, מה רצית להיות כשתגדל?",
			"security-question10": "מה היה שם המשפחה של המורה החביב/ה עליך?",
			"new-password-failure": "הסיסמה אינה עומדת בדרישות",
			"confirm-password-failure": "הסיסמאות חייבות להתאים",
			"new-password-tooltip": "סיסמאות חייבות להכיל 8 תווים לפחות, אות גדולה, אות קטנה ותו מיוחד.",
			"enter-valid-email": "הזן דואר אלקטרוני חוקי.",
			"password-cannot-be-same": "הסיסמה לא יכולה להיות לזהה לסיסמה הקודמת",
			"incorrect-password": "סיסמה שגויה",
			"complete-account": "נראה כי עליך <a href='%{href}'>להשלים את החשבון שלך</a>.",
			"completing-allows": "השלמת החשבון מאפשרת לך לקרוא ספרים באופן לא מקוון באפליקציות שלך בנייד ולשתף הערות וסימונים עם חברים.",
			"error-updating-info": "There was an error updating your information.",
			"password-updated": "Password successfully updated",
			"security-updated": "Security question successfully updated",
			"info-updated": "User information successfully updated"
		},
		"resources": {
			"ancillaries": "מסייעים",
			"access-codes": "קודי גישה",
			"print-on-demand": "הדפסה לפי בקשה",
			"check-pod": "בדוק את אפשרויות ההדפסה של המוציא לאור עבור הספרים שלך.",
			"check-now": "בדוק כעת",
			"loading": "חכה רגע, אנחנו מעדכנים את המשאבים שלך!",
			"in": "ב-",
			"access-code-intro": "קוד גישה הוא סיסמה שבה נעשה שימוש כדי לגשת לתוכן של קורס מקוון. לאחר חשיפה קוד עבור פריט, לא תוכל להחזיר אותו. לקבלת הנחיות לשימוש בקודי גישה, בקר <a href='%{support_url}' target='_blank'>באתר התמיכה</a>.",
			"expires": "תפוגה",
			"expiration-message": "מכיל הוראות לשימוש בקוד הגישה שלך.",
			"copy-fail": "לא ניתן להעתיק. בחר את הקוד והעתק אותו ידנית.",
			"launch-site": "אתר הפעלה",
			"launch-book": "פתח את הספר",
			"reveal-code": "חשוף קוד",
			"no-resources": "אין לך משאבים.",
			"no-access-codes": "אין לך קודי גישה.",
			"no-ancillaries": "אין מסייעים לכותר זה",
			"name": "שם",
			"type": "סוג",
			"size": "גודל",
			"download-all": "הורד הכל",
			"back": "בחזרה למשאבים"
		},
		"refunds": {
			"states": {
				"refunded": "ניתן החזר כספי",
				"unavailable": "החזר כספי לא זמין"
			},
			"reasons": {
				"dropped": "נשרתי מהקורס",
				"wrong": "זה אינו הספר המתאים לקורס שלי",
				"print": "החלטתי לקנות גרסה מודפסת במקום זאת",
				"missing": "הספר לא מכיל את כל מה שאני צריך עבור הקורס (למשל, תקליטור, גישה לאינטרנט, סרטוני וידאו)",
				"other": "אחר"
			},
			"bulk": {
				"policy": "על-ידי לחיצה על הלחצן &quot;החזר כספי מלא&quot; להלן, אני מסכים <a href='%{policy_url}' target='_blank'>למדיניות ההחזרים של</a>%{brand}.",
				"complete": "החזר כספי מלא",
				"view-details": "הצג פרטי החזר כספי",
				"success": "בקשתך להחזר כספי נשלחה. יש להמתין 48 שעות להשלמת תהליך העיבוד.",
				"failure": "אופס - משהו השתבש! לצערנו, ההחזר הכספי שלך לא הושלם בהצלחה.",
				"retry": "נסה שוב",
				"support": "יצירת קשר עם התמיכה",
				"available-codes": "קודים זמינים",
				"codes-selected": "קודים שנבחרו",
				"download": "הורד קודים",
				"partially-refunded": "הוחזר חלקית",
				"pick-one": "עליך לבחור לפחות קוד אחד כדי לבצע החזר כספי"
			},
			"refund": "החזר כספי",
			"all": "לבצע החזר כספי להכל?",
			"missing-reason": "עליך לבחור סיבה כדי להמשיך",
			"missing-elaboration": "אנא פרט",
			"policy": "על-ידי לחיצה על הלחצן \"השלם בקשה להחזר כספי\" להלן, אני מאשר שאם ארכוש שוב ספר לימוד אלקטרוני זה של %{brand}, לא אהיה זכאי לבקש כל החזר כספי עבור אותו ספר לימוד אלקטרוני. הצג את מדיניות ההחזרים המלאה.",
			"refunded": "ניתן החזר כספי",
			"sorry": "אנו מצטערים שלא היית מרוצה מהרכישה שביצעת.",
			"error": "משהו השתבש",
			"error-explain": "לא הצלחנו לעבד את ההחזר הכספי שלך. נסה שוב.",
			"why": "ספר לנו מדוע?",
			"no-refunds": "אין לך פריטים עם החזר כספי.",
			"select-codes": "בחר קודים להחזר כספי:",
			"number": "כמה?",
			"back": "בחזרה להחזרים"
		},
		"purchases": {
			"back": "בחזרה לרכישות"
		},
		"global-bar": {
			"account": "הגדרות חשבון"
		}
	};

/***/ },
/* 986 */
/***/ function(module, exports) {

	module.exports = {
		"base": {
			"welcome": "Mulligans में आपका स्वागत है, %{name}!",
			"user": "उपयोगकर्ता की जानकारी",
			"devices": "डिवाइसेस",
			"refunds": "रिफंड",
			"resources": "संसाधन",
			"transactions": "ऑर्डर और रिटर्न",
			"email": "ईमेल",
			"password": "पासवर्ड",
			"save": "सहेजें",
			"sign-out": "साइन आउट करें",
			"cancel": "रद्द करें",
			"close": "बंद करें",
			"learn-more": "अधिक जानें",
			"required": "आवश्यक",
			"support": "समर्थन करें",
			"bookshelf": "बुकशेल्फ़",
			"launch": "लॉन्च करें",
			"download": "डाउनलोड करें",
			"details": "विवरण",
			"cannot-be-blank": "%{field} खाली नहीं हो सकता.",
			"saving": "सहेजा जा रहा है...",
			"done": "संपन्न",
			"failed": "विफल",
			"copy": "कॉपी करें"
		},
		"signin": {
			"login-failure": "ईमेल या पासवर्ड गलत है",
			"welcome-large": "%{brand} खाता केंद्र <span class='inner'>में आपका स्वागत है</span>",
			"welcome-small": "<span class='inner'>खाता केंद्र</span>",
			"signin-button": "साइन इन करें",
			"forgot-password": "पासवर्ड भूल गए",
			"new-to-vst": "क्या आप %{brand} में नए हैं?",
			"create-account": "खाता बनाएं",
			"signing-in": "साइन इन किया जा रहा है...",
			"signin-failed": "साइन इन विफल हुआ"
		},
		"transactions": {
			"price": "मूल्य",
			"excluded": "(कर सहित)",
			"quantity": "मात्रा",
			"confirmation#": "पुष्टिकरण #",
			"payment": "भुगतान",
			"purchased": "खरीदा गया",
			"purchase-details": "खरीदारी का विवरण",
			"subtotal": "पूर्ण योग",
			"total": "कुल योग",
			"tax": "कर",
			"loading": "बड़ा खर्च करने वाले, हम आपके लेनदेन लोड कर रहे हैं...",
			"no-purchases": "आपने कुछ नहीं खरीदा है.",
			"seller-vat": "विक्रेता VAT",
			"total-vat": "कुल %{vat} का भुगतान किया गया",
			"portion": "%{subTax} कर %{rate}%",
			"vat-disclosure": "मूल्य में शामिल है %{vat}",
			"purchases": "खरीदियां",
			"refunded-items": "शुल्कवापसी किए गए आइटम",
			"book-title": "पुस्तक का शीर्षक",
			"refund-details": "रिफंड विवरण",
			"print-receipt": "रसीद प्रिंट करें",
			"request-refund": "शुल्कवापसी का अनुरोध करें",
			"expired": "समय समाप्त हुआ ",
			"expires-in": "%{date} को समाप्त",
			"details-refund": "जानकारी और रिफ़ंड",
			"modal": {
				"cant-refund-title": "रिफंड उपलब्ध नहीं है",
				"cant-refund": "आपकी पुस्तक निम्नलिखित एक या अधिक कारणों से रिफंड नहीं हो सकती.",
				"cant-refund-1": "आपकी बहुत सी पुस्तकें देखी गई हैं.",
				"cant-refund-2": "क्रय तिथि के बाद 14 दिन से अधिक समय हो चुका है.",
				"cant-refund-3": "आपके ऑनलाइन संसाधन कोड का पता चल गया है.",
				"cant-refund-4": "आपकी पुस्तक पहले रिफंड हो चुकी है.",
				"cant-refund-5": "सभी कोड को पहले ही रिडीम और/या वापस कर दिया गया है.",
				"cant-refund-6": "क्रय तिथि से 30 दिन से अधिक हो चुके हैं.",
				"cant-refund-support": "अगर आप अभी भी %{brand} की धनवापसी नीति के <a href='%{support_url}' target='_blank'>प्रति सुनिश्चित नहीं हैं,</a> तो सहायता से संपर्क करें."
			},
			"license": {
				"perpetual": "ऑनलाइन एक्सेस कोड की समय-सीमा समाप्त नहीं होती है",
				"days": "%{days} दिन का एक्सेस"
			}
		},
		"devices": {
			"description": "%{brand} आपको %{desktop} कंप्यूटर और <span>%{mobile} मोबाइल/टैबलेट डिवाइस को</span> किसी भी समय <span>सक्रिय करने की</span> अनुमति देता है.",
			"loading": "नमस्कार, हमें आपके डिवाइसेज़ मिल रहे हैं :)",
			"no-active": "आपको कोई डिवाइस सक्रिय नहीं हैं.",
			"deactivate": "निष्क्रिय करें"
		},
		"user": {
			"personal-information": "व्यक्तिगत जानकारी",
			"security-information": "सुरक्षा जानकारी",
			"notifications": "सूचनाएं",
			"first-name": "पहला नाम",
			"last-name": "अंतिम नाम",
			"change-password-title": "पासवर्ड बदलें",
			"current-password": "वर्तमान पासवर्ड",
			"new-password": "नया पासवर्ड",
			"security-password": "पासवर्ड",
			"confirm-new-password": "नए पासवर्ड की पुष्टि करें",
			"security-question": "सुरक्षा प्रश्न",
			"security-info-change": "बदलें",
			"question": "प्रश्न",
			"answer": "उत्तर",
			"notifications-text": "मेरी खाता गतिविधि, उत्पाद अपडेट और विशेष ऑफ़र के बारे में समय-समय पर अपडेट मुझे ईमेल करें.",
			"loading": "स्थान आपकी उपयोगकर्ता जानकारी निकाल रहा है, एक सेंकड 🐶",
			"change-password-text": "पासवर्ड में कम से कम 8 वर्ण, एक बड़ा अक्षर, एक छोटा अक्षर, और एक विशेष वर्ण होना चाहिए.",
			"email-locked": "ईमेल लॉक किया गया",
			"email-locked-description": "आपके पास अपना ईमेल बदलने का एक्सेस नहीं है.",
			"email-locked-more": "कृपया अपने व्यवस्थापक से संपर्क करें।",
			"security-question6": "आपका पसंदीदा खेल क्या है?",
			"security-question7": "आपका पसंदीदा आइसक्रीम फ्लेवर क्या है?",
			"security-question8": "आपके पसंदीदा पालतू पशु का नाम क्या है?",
			"security-question9": "जब आप छोटे थे तो बड़े होकर आप क्या बनना चाहते थे?",
			"security-question10": "आपके पसंदीदा टीचर का नाम क्या था?",
			"new-password-failure": "पासर्ड आवश्यकताएं पूरी नहीं करता है",
			"confirm-password-failure": "पासवर्ड मेल खाना चाहिए",
			"new-password-tooltip": "कम से कम 8 वर्ण, एक अपरकेस अक्षर, एक लोअरकेस अक्षर, और एक विशेष वर्ण शामिल होना चाहिए.",
			"enter-valid-email": "कृपया एक मान्य ईमेल दर्ज करें.",
			"password-cannot-be-same": "नया पासवर्ड पिछले पासवर्ड के समान नहीं हो सकता.",
			"incorrect-password": "गलत पासवर्ड",
			"complete-account": "लगता है आपको <a href='%{href}'>अपना खाता पूरा करना होगा</a>।",
			"completing-allows": "अपना खाता पूरा करने से आपके लिए हमारे मोबाइल ऐप्स पर ऑफलाइन किताबें पढ़ना और दोस्तों के साथ नोट्स व झलकियां साझा करना संभव होगा।",
			"error-updating-info": "There was an error updating your information.",
			"password-updated": "Password successfully updated",
			"security-updated": "Security question successfully updated",
			"info-updated": "User information successfully updated"
		},
		"resources": {
			"ancillaries": "सहायक",
			"access-codes": "एक्सेस कोड",
			"print-on-demand": "मांग पर प्रिंट करें",
			"check-pod": "अपने पुस्तकों के लिए प्रकाशक प्रिंटिंग विकल्पों को जाँचें.",
			"check-now": "अभी जांचें",
			"loading": "प्रतीक्षा करें, हम आपके संसाधन अपडेट कर रहे हैं!",
			"in": "in",
			"access-code-intro": "एक्सेस कोड एक ऐसा पासवर्ड है, जिसका उपयोग आप पाठ्यक्रम सामग्री तक ऑनलाइन पहुँच प्राप्त करने के लिए कर सकते हैं. जैसे ही आप किसी आइटम के लिए एक कोड प्रकट करते हैं, आप उसे वापस नहीं कर सकेंगे. अपने एक्सेस को़ड्स का उपयोग करने के तरीके के बारे में अधिक निर्देशों के लिए, <a href='%{support_url}' target='_blank'>सहायता पर जाएं</a>.",
			"expires": "समापन तिथि",
			"expiration-message": "इसमें आपके एक्सेस को़ड का उपयोग करने के बारे में निर्देश होते हैं.",
			"copy-fail": "कॉपी करने में असमर्थ है. कृपया कोड चुनें और उसे मैनुअल रूप से कॉपी करें.",
			"launch-site": "साइट लॉन्च करें",
			"launch-book": "लॉन्च बुक",
			"reveal-code": "कोड प्रकट करें",
			"no-resources": "आपके पास कोई संसाधन नहीं हैं.",
			"no-access-codes": "आपको पास कोई एक्सेस कोड नहीं हैं.",
			"no-ancillaries": "इस शीर्षक के लिए कोर्ई एंसिलरी नहीं है",
			"name": "नाम",
			"type": "प्रकार",
			"size": "आकार",
			"download-all": "सब डाउनलोड करें",
			"back": "संसाधनों पर वापस"
		},
		"refunds": {
			"states": {
				"refunded": "रिफंड किये गए",
				"unavailable": "रिफंड उपलब्ध नहीं है"
			},
			"reasons": {
				"dropped": "मैनें पाठ्यक्रम छोड़ दिया",
				"wrong": "यह मेरे पाठ्यक्रम के लिए गलत पुस्तक थी",
				"print": "इसके बजाय मैंने मुद्रित संस्करण खरीदने के निर्णय लिया",
				"missing": "इस पुस्तक में सब कुछ नहीं है जिसकी मुझे अपने पाठ्यक्रम के लिए जरूरत है (उदा. CD, वेब एक्सेस, वीडियो)",
				"other": "अन्य"
			},
			"bulk": {
				"policy": "नीचे दिया गया &quot;पूरा रिफंड&quot; बटन क्लिक कर मैं %{brand} <a href='%{policy_url}' target='_blank'>की रिफंड संबंधी नीति</a>पर अपनी सहमति देता/देती हूं.",
				"complete": "पूरा रिफंड",
				"view-details": "रिफंड का विवरण देखें",
				"success": "आपके रिफ़ंड की मांग की गई है. प्रोसेसिंग के लिए कृपया 48 घंटे तक इंतज़ार करें.",
				"failure": "उफ - कुछ गलत हो गया! दुर्भाग्यवश आपका रिफंड ठीक से नहीं हो सका.",
				"retry": "पुनः प्रयास करें",
				"support": "संपर्क सहायता",
				"available-codes": "उपलब्ध कोड",
				"codes-selected": "कोड चयनित",
				"download": "कोड डाउनलोड करें",
				"partially-refunded": "आंशिक रूप से रिफंड किया गया",
				"pick-one": "आपको रिफंड करने के लिए कम से कम एक कोड का चयन करना होगा "
			},
			"refund": "रिफंड",
			"all": "सब रिफंड करें?",
			"missing-reason": "जारी रखने के लिए आपको एक कारण चुनना होगा",
			"missing-elaboration": "कृपया विस्तार से बताएं",
			"policy": "नीचे दिया गया “धनवापसी अनुरोध पूर्ण करें” बटन क्लिक करके मैं समझता/समझती हूं कि अगर मैं फिर से इस %{brand} ईटेक्स्ट बुक की खरीदारी करता/करती हूं, तो मैं समान ई-टेक्स्टबुक के लिए अधिक धनवापसी का अनुरोध नहीं कर पाऊंगा/पाऊंगी. पूरी वापसी नीति देखें.",
			"refunded": "रिफंड किये गए",
			"sorry": "हमें खेद है कि आप अपनी खरीदारी से संतुष्ट नहीं हुए.",
			"error": "कुछ गलत हुआ",
			"error-explain": "हम आपका रिफंड संसाधित करने में असमर्थ थे. कृपया फिर से प्रयास करें.",
			"why": "हमें बताएं क्यों?",
			"no-refunds": "आपके कोई रिफंड किये गए आइटम नहीं हैं.",
			"select-codes": "रिफंड के लिए कोड का चयन करें:",
			"number": "कितने?",
			"back": "रिफंड पर वापस"
		},
		"purchases": {
			"back": "खरीद पर वापस"
		},
		"global-bar": {
			"account": "खाता सेटिंग"
		}
	};

/***/ },
/* 987 */
/***/ function(module, exports) {

	module.exports = {
		"base": {
			"welcome": "Velkomin til Mulligan, %{name}!",
			"user": "Notandaupplýsingar",
			"devices": "Áhöld",
			"refunds": "Endurgreiðslur",
			"resources": "Heimildir",
			"transactions": "Pantanir og skil",
			"email": "Netfang",
			"password": "Lykilorð",
			"save": "Vista",
			"sign-out": "Skrá út",
			"cancel": "Hætta við",
			"close": "Loka",
			"learn-more": "Fáðu að vita meira",
			"required": "Krafist",
			"support": "Stuðningur",
			"bookshelf": "Bookshelf",
			"launch": "Setja af stað",
			"download": "Sækja",
			"details": "Upplýsingar",
			"cannot-be-blank": "%{field} má ekki vera autt.",
			"saving": "Vista...",
			"done": "Lokið",
			"failed": "Mistókst",
			"copy": "Afrita"
		},
		"signin": {
			"login-failure": "Netfang eða aðgangsorð er ekki rétt",
			"welcome-large": "Velkomin í <span class='inner'>%{brand} reikningaþjónustu</span>",
			"welcome-small": "<span class='inner'>Reikningsþjónusta</span>",
			"signin-button": "Skrá inn",
			"forgot-password": "Gleymdirðu laðgangsorðinu",
			"new-to-vst": "Ertu ný(r) í %{brand}?",
			"create-account": "Stofna reikning",
			"signing-in": "Innskráning...",
			"signin-failed": "Innskráning mistókst"
		},
		"transactions": {
			"price": "Verð",
			"excluded": "(Fyrir utan skatt)",
			"quantity": "Fjöldi",
			"confirmation#": "Staðfestingarnr.",
			"payment": "Greiðsla",
			"purchased": "Keypt",
			"purchase-details": "Upplýsingar um kaup",
			"subtotal": "Millisamtala",
			"total": "Samtals",
			"tax": "Skattur",
			"loading": "Halló eyðslukló, við erum að sækja færslurnar þínar...",
			"no-purchases": "Það eru engin kaup.",
			"seller-vat": "VSK seljanda",
			"total-vat": "Samtals %{vat} greiddur",
			"portion": "%{subTax} skattur %{rate}%",
			"vat-disclosure": "Innifalið í verði %{vat}",
			"purchases": "Kaup",
			"refunded-items": "Endurgreiddar vörur",
			"book-title": "Bókartitill",
			"refund-details": "Upplýsingar um endurgreiðslu",
			"print-receipt": "Prenta kvittun",
			"request-refund": "Biðja um endurgreiðslu",
			"expired": "Útrunnið",
			"expires-in": "Rennur út %{date}",
			"details-refund": "Upplýsingar og endurgreiðsla",
			"modal": {
				"cant-refund-title": "Engin endurgreiðsla tiltæk",
				"cant-refund": "Ekki er hægt að endurgreiða bókina vegna einnar eða fleiri af eftirfarandi ástæðum.",
				"cant-refund-1": "Búið er að skoða of stóran hluta bókarinnar.",
				"cant-refund-2": "Það eru liðnir meira en 14 dagar frá kaupdegi.",
				"cant-refund-3": "Aðfangakóðinn þinn á netinu hefur verið birtur.",
				"cant-refund-4": "Bókin hefur áður verið endurgreidd.",
				"cant-refund-5": "Allir kóðar hafa verið innleystir og/eða endurgreiddir.",
				"cant-refund-6": "Það eru liðnir meira en 30 dagar frá kaupdegi.",
				"cant-refund-support": "Ef þú ert enn í vafa um endurgreiðslustefnu %{brand}, skaltu hafa samband við <a href='%{support_url}' target='_blank'>þjónustuna</a>."
			},
			"license": {
				"perpetual": "Aðgangur á netinu rennur ekki út",
				"days": "%{days} aðgangsdagur(-dagar)"
			}
		},
		"devices": {
			"description": "%{brand} gerir þér kleift að vera með <span>%{desktop}</span> tölvur og <span>%{mobile}</span> farsíma/spjaldtölvur virk á sama tíma.",
			"loading": "Hæ, við erum að sækja tækin þín :)",
			"no-active": "Þú ert ekki með nein virk tæki.",
			"deactivate": "Afvirkja"
		},
		"user": {
			"personal-information": "Persónuupplýsingar",
			"security-information": "Öryggisupplýsingar",
			"notifications": "Tilkynningar",
			"first-name": "Fornafn",
			"last-name": "Eftirnafn",
			"change-password-title": "Breyta lykilorði",
			"current-password": "Núverandi aðgangsorð",
			"new-password": "Nýtt lykilorð",
			"security-password": "Lykilorð",
			"confirm-new-password": "Staðfesta nýtt lykilorð",
			"security-question": "Öryggisspurning",
			"security-info-change": "Breyta",
			"question": "Spurning",
			"answer": "Svar",
			"notifications-text": "Sendið mér með tölvupósti stöku uppfærslur um virkni á reikningi mínum, uppfærslur á vörum og tilboð.",
			"loading": "Spot er að sækja notandaupplýsingar þínar, bíddu aðeins 🐶",
			"change-password-text": "Aðgangsorðið verður að vera minnst átta stafir að lengd og innihalda minnst einn hástaf, einn lágstaf og eitt sértákn.",
			"email-locked": "Netfang læst",
			"email-locked-description": "Þú hefur ekki aðgang til að breyta netfanginu þínu.",
			"email-locked-more": "Hafðu sambandi við stjórnandann.",
			"security-question6": "Hver er uppáhalds íþróttin þín?",
			"security-question7": "Hver er uppáhalds ísinn þinn?",
			"security-question8": "Hvað heitir uppáhalds gæludýrið þitt?",
			"security-question9": "Þegar þú varst yngri, hvað langaði þig til að verða þegar þú yrðir stór?",
			"security-question10": "Hvað hét uppáhalds kennarinn þinn?",
			"new-password-failure": "Aðgangsorðið uppfyllir ekki kröfur",
			"confirm-password-failure": "Aðgangsorðin verða að stemma",
			"new-password-tooltip": "Verður að vera minnst 8 stafir, með hástaf, lágstaf og sértákn.",
			"enter-valid-email": "Sláðu inn gilt netfang.",
			"password-cannot-be-same": "Aðgangsorðið getur ekki verið það sama og fyrri aðgangsorð",
			"incorrect-password": "Rangt aðgangsorð",
			"complete-account": "Þú þarft að <a href='%{href}'>ljúka við skráninguna</a>.",
			"completing-allows": "Með því að ljúka skráningunni getur þú lesið bækur án nettengingar með smáforritum okkar fyrir fartæki og deilt athugasemdum og áherslumerkingum með vinum þínum.",
			"error-updating-info": "There was an error updating your information.",
			"password-updated": "Password successfully updated",
			"security-updated": "Security question successfully updated",
			"info-updated": "User information successfully updated"
		},
		"resources": {
			"ancillaries": "Stoðskrár",
			"access-codes": "Aðgangskóðar",
			"print-on-demand": "Prenta eftir þörfum",
			"check-pod": "Athugaðu prentvalkosti útgefanda fyrir bækurnar þínar.",
			"check-now": "Athuga núna",
			"loading": "Dokaðu við, við erum að uppfæra aðföngin þín!",
			"in": "í",
			"access-code-intro": "Aðgangskóði er aðgangsorð sem þú notar til að fá aðgang að efni námskeiðs á netinu. Once you reveal a code for an item, you will not be able to return it. Til að fá nánari upplýsingar um hvernig nota skuli aðgangskóðann, skal fara í <a href='%{support_url}' target='_blank'>hjálpina</a>.",
			"expires": "Rennur út",
			"expiration-message": "Inniheldur leiðbeiningar um notkun aðgangskóðans.",
			"copy-fail": "Ekki hægt að afrita. Veldu kóðann og afritaðu hann handvirkt.",
			"launch-site": "Setja af stað vefsetur",
			"launch-book": "Setja af stað Book",
			"reveal-code": "Sýna kóða",
			"no-resources": "Þú ert ekki með nein aðföng.",
			"no-access-codes": "Þú ert ekki með neina aðgangskóða.",
			"no-ancillaries": "Ekkert auka fyrir þennan titil",
			"name": "Heiti",
			"type": "Tegund",
			"size": "Stærð",
			"download-all": "Hala niður allt",
			"back": "Til baka í tilföng"
		},
		"refunds": {
			"states": {
				"refunded": "Endurgreitt",
				"unavailable": "Endurgreiðsla ekki tiltæk"
			},
			"reasons": {
				"dropped": "Ég hætti í námskeiðinu",
				"wrong": "Þetta var ekki rétt bók fyrir námskeiðið mitt",
				"print": "Ég ákvað að kaupa heldur prentaða útgáfu",
				"missing": "Bókin inniheldur ekki allt sem ég þarf fyrir námskeiðið (t.d. geisladisk, netaðgang, myndbönd)",
				"other": "Annað"
			},
			"bulk": {
				"policy": "Með því að smella á „Ljúka endurgreiðslu“ hnappinn hér fyrir neðan, samþykki ég %{brand} <a href='%{policy_url}' target='_blank'>endurgreiðslustefnuna</a>.",
				"complete": "Klára endurgreiðslu",
				"view-details": "Skoða upplýsingar um endurgreiðslu",
				"success": "Beiðni þín um endurgreiðslu hefur verið send. Úrvinnsla getur tekið allt að 48 klukkustundir.",
				"failure": "Æ - eitthvað fór úrskeiðis! Því miður tókst endurgreiðslan ekki.",
				"retry": "Reyndu aftur",
				"support": "Fáðu aðstoð",
				"available-codes": "Tiltækir kóðar",
				"codes-selected": "Valdir kóðar",
				"download": "Sækja kóða",
				"partially-refunded": "Endurgreitt að hluta",
				"pick-one": "Þú þarft að velja minnst einn kóða til að fá endurgreiðslu"
			},
			"refund": "Endurgreiðsla",
			"all": "Endurgreiða allt?",
			"missing-reason": "Þú þarft að velja ástæðu til að halda áfram",
			"missing-elaboration": "Skýrðu nánar",
			"policy": "Með því að smella á „Ljúka beiðni um endurgreiðslu“ hnappinn hér fyrir neðan, hef ég skilið að ef ég kaupi þessa %{brand} rafbók aftur, mun ég ekki uppfylla skilyrði til að biðja um frekari endurgreiðslu fyrir sömu rafbókina. Skoða heildarskilmála um vöruskil.",
			"refunded": "Endurgreitt",
			"sorry": "Við hörmum að þú hafir ekki verið ánægð(-ur) með kaupin.",
			"error": "Eitthvað fór úrskeiðis",
			"error-explain": "Ekki tókst að vinna úr endurgreiðslunni. Reyndu aftur síðar.",
			"why": "Segðu okkur hvers vegna?",
			"no-refunds": "Þú ert ekki með neitt endurgreitt.",
			"select-codes": "Veldu kóða til að endurgreiða:",
			"number": "Hversu marga?",
			"back": "Til baka í endurgreiðslur"
		},
		"purchases": {
			"back": "Til baka í innkaup"
		},
		"global-bar": {
			"account": "Stillingar reiknings"
		}
	};

/***/ },
/* 988 */
/***/ function(module, exports) {

	module.exports = {
		"base": {
			"welcome": "Benvenuto/a in Mulligan, %{name}.",
			"user": "Informazioni utente",
			"devices": "Dispositivi",
			"refunds": "Rimborsi",
			"resources": "Risorse",
			"transactions": "Ordini e resi",
			"email": "E-mail",
			"password": "Password",
			"save": "Salva",
			"sign-out": "Disconnetti",
			"cancel": "Annulla",
			"close": "Chiudi",
			"learn-more": "Ulteriori informazioni",
			"required": "Richiesto",
			"support": "Supporto",
			"bookshelf": "Bookshelf",
			"launch": "Avvia",
			"download": "Download",
			"details": "Dettagli",
			"cannot-be-blank": "Il campo %{field} non può essere vuoto.",
			"saving": "Salvataggio in corso…",
			"done": "Fine",
			"failed": "Non riuscito",
			"copy": "Copia"
		},
		"signin": {
			"login-failure": "L'e-mail o la password non è corretta",
			"welcome-large": "Benvenuto <span class='inner'>nell'Account Center di %{brand}</span>",
			"welcome-small": "<span class='inner'>Account Center</span>",
			"signin-button": "Accedi",
			"forgot-password": "Password dimenticata",
			"new-to-vst": "Sei un nuovo utente di %{brand}?",
			"create-account": "Crea un account",
			"signing-in": "Accesso...",
			"signin-failed": "Accesso non riuscito"
		},
		"transactions": {
			"price": "Prezzo",
			"excluded": "(Tasse escluse)",
			"quantity": "Quantità",
			"confirmation#": "Conferma n.",
			"payment": "Pagamento",
			"purchased": "Acquistati",
			"purchase-details": "Dettagli acquisto",
			"subtotal": "Totale parziale",
			"total": "Totale",
			"tax": "Imposta",
			"loading": "Ehi, spendaccione, stiamo caricando le tue transazioni...",
			"no-purchases": "Non hai effettuato acquisti.",
			"seller-vat": "IVA del venditore",
			"total-vat": "Totale %{vat} pagata",
			"portion": "%{subTax} Tassa %{rate}%",
			"vat-disclosure": "Il prezzo include %{vat}",
			"purchases": "Acquisti",
			"refunded-items": "Articoli rimborsati",
			"book-title": "Titolo del libro",
			"refund-details": "Dettagli rimborso",
			"print-receipt": "Stampa ricevuta",
			"request-refund": "Richiesta di rimborso",
			"expired": "Scaduto",
			"expires-in": "Scade il %{date}",
			"details-refund": "Dettagli e rimborso",
			"modal": {
				"cant-refund-title": "Rimborso non disponibile",
				"cant-refund": "Il libro non può essere rimborsato a causa di uno o più dei seguenti motivi.",
				"cant-refund-1": "È stata visualizzata una parte troppo grande del libro.",
				"cant-refund-2": "Sono trascorsi oltre 14 giorni dalla data di acquisto.",
				"cant-refund-3": "Il tuo codice per le risorse online è stato visualizzato.",
				"cant-refund-4": "Il libro è stato rimborsato in precedenza.",
				"cant-refund-5": "Tutti i codici sono già stati riscattati e/o rimborsati.",
				"cant-refund-6": "Sono trascorsi oltre 30 giorni dalla data di acquisto.",
				"cant-refund-support": "Se hai ancora dei dubbi sulla politica di rimborso di %{brand}, contatta <a href='%{support_url}' target='_blank'>il supporto</a>."
			},
			"license": {
				"perpetual": " L'accesso online non ha scadenza",
				"days": "Accesso per %{days} giorno/i"
			}
		},
		"devices": {
			"description": "%{brand} consente di avere <span>%{desktop}</span> computer e <span>%{mobile}</span> dispositivi mobili/tablet attivati contemporaneamente.",
			"loading": "Ehi, stiamo recuperando i tuoi dispositivi :)",
			"no-active": "Non sono presenti dispositivi attivi.",
			"deactivate": "Disattiva"
		},
		"user": {
			"personal-information": "Informazioni personali",
			"security-information": "Informazioni di sicurezza",
			"notifications": "Notifiche",
			"first-name": "Nome",
			"last-name": "Cognome",
			"change-password-title": "Cambia password",
			"current-password": "Password corrente",
			"new-password": "Nuova password",
			"security-password": "Password",
			"confirm-new-password": "Conferma nuova password",
			"security-question": "Domanda di sicurezza",
			"security-info-change": "Modifica",
			"question": "Domanda",
			"answer": "Risposta",
			"notifications-text": "Inviami aggiornamenti saltuari sull'attività del mio account, sui prodotti e sulle offerte speciali.",
			"loading": "Stiamo recuperando le tue informazioni utente, attendi un attimo 🐶",
			"change-password-text": "La password deve essere composta da almeno 8 caratteri e contenere una lettera maiuscola, una lettera minuscola e un carattere speciale.",
			"email-locked": "E-mail bloccata",
			"email-locked-description": "Non si dispone dell'accesso per cambiare l'e-mail. ",
			"email-locked-more": "Contattare l'amministratore.",
			"security-question6": "Qual è il tuo sport preferito?",
			"security-question7": "Qual è il tuo gusto preferito di gelato?",
			"security-question8": "Qual è il nome del tuo animale domestico preferito?",
			"security-question9": "Cosa desideravi diventare da grande?",
			"security-question10": "Qual era il cognome del tuo insegnante?",
			"new-password-failure": "La password non rispetta i requisiti",
			"confirm-password-failure": "La password deve corrispondere",
			"new-password-tooltip": "Deve essere composta da almeno 8 caratteri e contenere una lettera maiuscola, una minuscola e un carattere speciale.",
			"enter-valid-email": "Immetti un indirizzo e-mail valido.",
			"password-cannot-be-same": "La password non può essere identica a quella precedente",
			"incorrect-password": "Password errata",
			"complete-account": "Sembra che tu debba <a href='%{href}'>completare il tuo account</a>.",
			"completing-allows": "Sarai così in grado di leggere libri offline sull'app del tuo dispositivo mobile e condividere con i tuoi amici evidenziazioni e note.",
			"error-updating-info": "There was an error updating your information.",
			"password-updated": "Password successfully updated",
			"security-updated": "Security question successfully updated",
			"info-updated": "User information successfully updated"
		},
		"resources": {
			"ancillaries": "Materiali di sussidio",
			"access-codes": "Codici di accesso",
			"print-on-demand": "Stampa su richiesta",
			"check-pod": "Controlla le opzioni di stampa dell'editore per i propri libri.",
			"check-now": "Controlla ora",
			"loading": "Aspetta, stiamo aggiornando le tue risorse.",
			"in": "in",
			"access-code-intro": "Un codice di accesso è una password che utilizzi per accedere al contenuto di un corso online.  Dopo aver visualizzato un codice per un elemento, non potrai più restituirlo. Per ulteriori istruzioni su come utilizzare i codici di accesso, visita il <a href='%{support_url}' target='_blank'>Supporto</a>.",
			"expires": "Scadenza",
			"expiration-message": "Contiene istruzioni su come utilizzare il codice di accesso.",
			"copy-fail": "Impossibile copiare. Seleziona il codice e copialo manualmente.",
			"launch-site": "Avvia il sito",
			"launch-book": "Avvia libro",
			"reveal-code": "Visualizza codice",
			"no-resources": "Non sono presenti risorse.",
			"no-access-codes": "Non sono presenti codici di accesso.",
			"no-ancillaries": "Non ci sono materiali di sussidio per questo titolo",
			"name": "Nome",
			"type": "Tipo",
			"size": "Dimensione",
			"download-all": "Scarica tutto",
			"back": "Torna alle risorse"
		},
		"refunds": {
			"states": {
				"refunded": "Rimborsato",
				"unavailable": "Rimborso non disponibile"
			},
			"reasons": {
				"dropped": "Ho interrotto il corso",
				"wrong": "Questo era il libro errato per il mio corso",
				"print": "Al suo posto ho deciso di comprare una versione cartacea",
				"missing": "Il libro non contiene tutto ciò di cui ho bisogno per il corso (esempio CD, accesso web e video)",
				"other": "Altro"
			},
			"bulk": {
				"policy": "Facendo clic sul pulsante &quot;Completa il rimborso&quot; di seguito, accetto la <a href='%{policy_url}' target='_blank'>politica di rimborso di %{brand}</a>.",
				"complete": "Completa il rimborso",
				"view-details": "Visualizza i dettagli del rimborso",
				"success": "Il rimborso è stato richiesto. Attendi 48 ore per l'elaborazione.",
				"failure": "Si è verificato un errore. Purtroppo la procedura di rimborso non è stata completata.",
				"retry": "Riprova",
				"support": "Contatta supporto",
				"available-codes": "Codici disponibili",
				"codes-selected": "Codici selezionati",
				"download": "Scarica codici",
				"partially-refunded": "Parzialmente rimborsato",
				"pick-one": "Devi selezionare almeno un codice per effettuare un rimborso"
			},
			"refund": "Rimborso",
			"all": "Rimborsare tutto?",
			"missing-reason": "Devi selezionare un motivo per continuare",
			"missing-elaboration": "Elabora",
			"policy": "Facendo clic sul pulsante \"Completa la richiesta di rimborso\" qui di seguito, prendo atto che se acquistassi nuovamente questo libro di testo digitale %{brand} non avrei più diritto a richiedere qualsiasi ulteriore rimborso per lo stesso libro di testo digitale. Visualizza la politica di rimborso completa.",
			"refunded": "Rimborsato",
			"sorry": "Ci dispiace che il tuo acquisto non ti abbia soddisfatto.",
			"error": "Si è verificato un errore",
			"error-explain": "Il tuo rimborso non è stato elaborato. Riprova.",
			"why": "Facci sapere perché.",
			"no-refunds": "Non sono presenti elementi rimborsati.",
			"select-codes": "Seleziona il/i codice/i da rimborsare:",
			"number": "Quanti?",
			"back": "Torna ai rimborsi"
		},
		"purchases": {
			"back": "Torna agli acquisti"
		},
		"global-bar": {
			"account": "Impostazioni account"
		}
	};

/***/ },
/* 989 */
/***/ function(module, exports) {

	module.exports = {
		"base": {
			"welcome": " %{name}さん、Mulligans へようこそ！",
			"user": "ユーザー情報",
			"devices": "デバイス",
			"refunds": "返金",
			"resources": "リソース",
			"transactions": "注文と返品",
			"email": "電子メール",
			"password": "パスワード",
			"save": "保存",
			"sign-out": "サインアウト",
			"cancel": "キャンセル",
			"close": "閉じる",
			"learn-more": "詳細を表示",
			"required": "必須",
			"support": "サポート",
			"bookshelf": "本棚",
			"launch": "起動",
			"download": "ダウンロード",
			"details": "詳細",
			"cannot-be-blank": "%{field}を空白にすることはできません。",
			"saving": "保存しています...",
			"done": "完了",
			"failed": "失敗",
			"copy": "コピー"
		},
		"signin": {
			"login-failure": "メール アドレスまたはパスワードが正しくありません",
			"welcome-large": "%{brand}<span class='inner'>Account Center へようこそ</span>",
			"welcome-small": "<span class='inner'>Account Center</span>",
			"signin-button": "サインイン",
			"forgot-password": "パスワードを忘れた場合",
			"new-to-vst": "%{brand}を初めてご利用の場合",
			"create-account": "アカウントを作成",
			"signing-in": "サインインしています...",
			"signin-failed": "サインインに失敗しました"
		},
		"transactions": {
			"price": "価格",
			"excluded": "(Excluding tax)",
			"quantity": "数量",
			"confirmation#": "確認番号",
			"payment": "支払い",
			"purchased": "購入済み",
			"purchase-details": "購入詳細",
			"subtotal": "小計",
			"total": "合計",
			"tax": "税",
			"loading": "お客様のトランザクションを読み込んでいます...",
			"no-purchases": "購入履歴がありません。",
			"seller-vat": "売り主の付加価値税",
			"total-vat": "支払%{vat}合計",
			"portion": "%{subTax} Tax %{rate}%",
			"vat-disclosure": "Price Includes %{vat}",
			"purchases": "購入",
			"refunded-items": "返金済みアイテム",
			"book-title": "ブック タイトル",
			"refund-details": "返金の詳細",
			"print-receipt": "領収証を印刷",
			"request-refund": "返金をリクエスト",
			"expired": "期限切れ",
			"expires-in": "有効期限: %{date}",
			"details-refund": "詳細と返金",
			"modal": {
				"cant-refund-title": "返金不可",
				"cant-refund": "以下のいずれかまたは複数の理由により、ブックの返金ができません。",
				"cant-refund-1": "ブックの閲覧済み部分が多すぎるため。",
				"cant-refund-2": "購入日からすでに14日以上が経過しているため。",
				"cant-refund-3": "オンライン リソース コードが使用済みであるため。",
				"cant-refund-4": "すでに返金済みのブックであるため。",
				"cant-refund-5": "コードはすべて引き換え済みか、返金済みです。",
				"cant-refund-6": "購入日からすでに30日以上が経過しているため。",
				"cant-refund-support": "%{brand}の返金ポリシーにご不明な点がございましたら、<a href='%{support_url}' target='_blank'>サポート</a>にお問い合わせください。"
			},
			"license": {
				"perpetual": "オンライン アクセスは有効期限切れになりません",
				"days": "%{days}日間アクセス"
			}
		},
		"devices": {
			"description": "%{brand} は、同時に <span>%{desktop}</span> 台のコンピュータと <span>%{mobile}</span> 台のモバイル/タブレット デバイスをアクティベートすることを許可しています。",
			"loading": "デバイスを読み込み中です",
			"no-active": "アクティブなデバイスはありません。",
			"deactivate": "非アクティブ化"
		},
		"user": {
			"personal-information": "個人情報",
			"security-information": "セキュリティ情報",
			"notifications": "通知",
			"first-name": "名",
			"last-name": "姓",
			"change-password-title": "パスワードの変更",
			"current-password": "現在のパスワード",
			"new-password": "新しいパスワード",
			"security-password": "パスワード",
			"confirm-new-password": "新しいパスワードの確認",
			"security-question": "セキュリティの質問",
			"security-info-change": "変更",
			"question": "質問",
			"answer": "回答",
			"notifications-text": "アカウントの活動状況や最新の製品情報、特典など、最新情報をメールで受け取る",
			"loading": "ポチがユーザー情報を取得中です。もう少しお待ち下さい🐶",
			"change-password-text": "パスワードは8文字以上で、大文字、小文字、記号が含まれている必要があります。",
			"email-locked": "電子メール アドレスはロックされています",
			"email-locked-description": "電子メール アドレスを変更する権限がありません。",
			"email-locked-more": "管理者に連絡してください。",
			"security-question6": "好きなスポットは?",
			"security-question7": "好きなアイスクリームのフレーバーは?",
			"security-question8": "好きなペットの名前は?",
			"security-question9": "小さい頃なりたかった職業は?",
			"security-question10": "好きな先生の苗字は?",
			"new-password-failure": "パスワードが要件を満たしていません",
			"confirm-password-failure": "パスワードは一致する必要があります",
			"new-password-tooltip": "8文字以上で、大文字、小文字、記号を含める必要があります。",
			"enter-valid-email": "有効なメール アドレスを入力してください。",
			"password-cannot-be-same": "古いパスワードと同じパスワードは使えません",
			"incorrect-password": "不正なパスワード",
			"complete-account": "Looks like you need to <a href='%{href}'>complete your account</a>.",
			"completing-allows": "Completing your account allows you to read books offline on our mobile apps and share notes and highlights with friends.",
			"error-updating-info": "There was an error updating your information.",
			"password-updated": "Password successfully updated",
			"security-updated": "Security question successfully updated",
			"info-updated": "User information successfully updated"
		},
		"resources": {
			"ancillaries": "付属",
			"access-codes": "アクセス コード",
			"print-on-demand": "オンデマンド印刷",
			"check-pod": "ブックのパブリッシャー印刷オプションをご確認ください。",
			"check-now": "今すぐチェック",
			"loading": "リソースをアップデートしています。しばらくお待ちください！",
			"in": "次の場所：",
			"access-code-intro": "アクセス コードは、コース コンテンツにオンライン アクセスするためのパスワードです。1度アイテムにコードを使用すると、返品できなくなります。アクセス コードの使用方法の詳細については、<a href='%{support_url}' target='_blank'>サポート</a>をご参照ください。",
			"expires": "有効期限",
			"expiration-message": "アクセス コードの使用手順が記載されています。",
			"copy-fail": "コピーできません。コードを選択して手動でコピーしてください。",
			"launch-site": "サイトを起動",
			"launch-book": "ブックを起動",
			"reveal-code": "コードを表示",
			"no-resources": "リソースがありません。",
			"no-access-codes": "アクセス コードがありません。",
			"no-ancillaries": "このタイトルには付属がありません",
			"name": "名前",
			"type": "種類",
			"size": "サイズ",
			"download-all": "すべてダウンロード",
			"back": "Back to resources"
		},
		"refunds": {
			"states": {
				"refunded": "返金済み",
				"unavailable": "返金不可"
			},
			"reasons": {
				"dropped": "コースを途中でやめた",
				"wrong": "コース内容に合ったブックではなかった",
				"print": "印刷版を購入することにした",
				"missing": "このブックにはコースで必要なもの（CD、ウェブ アクセス、ビデオなど）の一部が含まれていない",
				"other": "その他"
			},
			"bulk": {
				"policy": "以下の「返金を完了」ボタンをクリックすることにより、%{brand}の<a href='%{policy_url}' target='_blank'>返金ポリシー</a>に同意いたします。",
				"complete": "返金を完了",
				"view-details": "返金の詳細を表示",
				"success": "返金がリクエストされました。処理まで48時間お待ちください。",
				"failure": "何か問題が起きたようです。返金処理は完了しませんでした。",
				"retry": "もう一度お試しください",
				"support": "サポートへのお問い合わせ",
				"available-codes": "利用可能なコード",
				"codes-selected": "選択済みのコード",
				"download": "ダウンロード済みのコード",
				"partially-refunded": "一部返金済み",
				"pick-one": "返金を受けるにはコードを少なくとも1つ選択する必要があります"
			},
			"refund": "返金",
			"all": "すべて返金しますか?",
			"missing-reason": "続行するには理由を選択する必要があります",
			"missing-elaboration": "説明を入力してください",
			"policy": "以下の「返金リクエストを完了」ボタンをクリックすることにより、今後この %{brand} eTextbook を再購入した場合に、その eTextbook について返金をリクエストする資格を喪失することを了解します。返品ポリシーの全文を表示",
			"refunded": "返金済み",
			"sorry": "内容にご満足いただけず申し訳ありません。",
			"error": "何か問題が起きたようです",
			"error-explain": "返金処理ができませんでした。再試行してください。",
			"why": "理由を教えてください",
			"no-refunds": "返金されたアイテムはありません。",
			"select-codes": "返金するコードを選択してください:",
			"number": "いくつですか?",
			"back": "返金に戻る"
		},
		"purchases": {
			"back": "Back to purchases"
		},
		"global-bar": {
			"account": "アカウント設定"
		}
	};

/***/ },
/* 990 */
/***/ function(module, exports) {

	module.exports = {
		"base": {
			"welcome": "%{name} 님, Mulligans에 오신 것을 환영합니다!",
			"user": "사용자 정보",
			"devices": "기기",
			"refunds": "환불",
			"resources": "리소스",
			"transactions": "주문 및 반품",
			"email": "이메일",
			"password": "암호",
			"save": "저장",
			"sign-out": "로그아웃",
			"cancel": "취소",
			"close": "닫기",
			"learn-more": "자세히 알아보기",
			"required": "필수",
			"support": "지원",
			"bookshelf": "책장",
			"launch": "시작",
			"download": "다운로드",
			"details": "세부 정보",
			"cannot-be-blank": "%{field} 필드는 비워 둘 수 없습니다.",
			"saving": "저장 중...",
			"done": "완료",
			"failed": "실패",
			"copy": "복사"
		},
		"signin": {
			"login-failure": "이메일 또는 암호가 올바르지 않습니다.",
			"welcome-large": "<span class='inner'>%{brand} Account Center</span>에 오신 것을 환영합니다.",
			"welcome-small": "<span class='inner'>Account Center</span>",
			"signin-button": "로그인",
			"forgot-password": "암호를 잊어버리셨나요?",
			"new-to-vst": "%{brand}에 처음이신가요?",
			"create-account": "계정 만들기",
			"signing-in": "로그인 중...",
			"signin-failed": "로그인 실패"
		},
		"transactions": {
			"price": "가격",
			"excluded": "(세금 포함)",
			"quantity": "양",
			"confirmation#": "확인 번호",
			"payment": "지불",
			"purchased": "구입함",
			"purchase-details": "구입 세부 정보",
			"subtotal": "소계",
			"total": "총계",
			"tax": "세금",
			"loading": "많이 이용해 주셔서 감사합니다! 구입 내역을 로드하는 중입니다...",
			"no-purchases": "구입 내역이 없습니다.",
			"seller-vat": "판매자 부가가치세",
			"total-vat": "총 %{vat} 지불액",
			"portion": "%{subTax} 세금 %{rate}%",
			"vat-disclosure": "%{vat} 포함 가격",
			"purchases": "구입",
			"refunded-items": "환불된 항목",
			"book-title": "책 제목",
			"refund-details": "환불 세부 정보",
			"print-receipt": "영수증 인쇄",
			"request-refund": "환불 요청",
			"expired": "만료됨",
			"expires-in": "%{date}에 만료",
			"details-refund": "세부정보 및 환불",
			"modal": {
				"cant-refund-title": "환불 불가",
				"cant-refund": "다음 이유 중 하나 이상에 해당되므로 책을 환불할 수 없습니다.",
				"cant-refund-1": "책의 상당 분량을 이미 읽었습니다.",
				"cant-refund-2": "구입 일자로부터 14일을 초과했습니다.",
				"cant-refund-3": "온라인 리소스 코드가 표시되었습니다.",
				"cant-refund-4": "책이 이미 이전에 환불되었습니다.",
				"cant-refund-5": "모든 코드가 이미 사용 또는 환불되었습니다.",
				"cant-refund-6": "구입 일자로부터 30일을 초과했습니다.",
				"cant-refund-support": "%{brand}의 환불 정책에 대해 문의사항이 있으시면 <a href='%{support_url}' target='_blank'>지원 팀</a>에 문의하세요."
			},
			"license": {
				"perpetual": "온라인 이용 권한이 만료되지 않습니다.",
				"days": "%{days}일 액세스"
			}
		},
		"devices": {
			"description": "<span>%{desktop}</span>대의 컴퓨터와 <span>%{mobile}</span>대의 모바일/태블릿 기기에서%{brand}을(를) 항상 이용할 수 있습니다.",
			"loading": "회원님의 장치를 가져오는 중입니다.",
			"no-active": "활성화된 장치가 없습니다.",
			"deactivate": "비활성화"
		},
		"user": {
			"personal-information": "개인 정보",
			"security-information": "보안 정보",
			"notifications": "알림",
			"first-name": "이름",
			"last-name": "성",
			"change-password-title": "암호 변경",
			"current-password": "현재 암호",
			"new-password": "새 암호",
			"security-password": "암호",
			"confirm-new-password": "새 암호 확인",
			"security-question": "보안 질문",
			"security-info-change": "변경",
			"question": "질문",
			"answer": "답변",
			"notifications-text": "계정 활동, 제품 업데이트 및 특별 제공 서비스 등에 관한 업데이트 정보를 가끔 이메일로 보내 주세요.",
			"loading": "Spot이 회원님의 사용자 정보를 가져오는 중입니다. 잠시만 기다려 주세요. 🐶",
			"change-password-text": "암호는 대소문자 및 특수 문자를 조합한 8자 이상의 문자여야 합니다.",
			"email-locked": "잠긴 이메일",
			"email-locked-description": "이메일 변경에 대한 액세스 권한이 없습니다.",
			"email-locked-more": "관리자에게 문의하세요.",
			"security-question6": "어떤 스포츠를 가장 좋아하시나요?",
			"security-question7": "어떤 맛의 아이스크림을 가장 좋아하시나요?",
			"security-question8": "가장 좋아하는 애완 동물의 이름은 무엇인가요?",
			"security-question9": "어린 시절 장래 희망은 무엇이었나요?",
			"security-question10": "가장 좋아하는 선생님의 성함은 무엇인가요?",
			"new-password-failure": "암호가 기준에 맞지 않습니다.",
			"confirm-password-failure": "암호가 일치해야 합니다.",
			"new-password-tooltip": "대소문자 및 특수 문자를 조합한 8자 이상의 문자를 포함해야 합니다.",
			"enter-valid-email": "올바른 이메일을 입력하세요.",
			"password-cannot-be-same": "이전 암호와 동일한 암호를 사용할 수 없습니다.",
			"incorrect-password": "잘못된 암호",
			"complete-account": "<a href='%{href}'>계정을 완료</a>해야 할 것 같습니다.",
			"completing-allows": "계정을 완료하면 모바일 앱에서 오프라인으로 책을 읽고 노트와 하이라이트를 친구들과 공유할 수 있습니다.",
			"error-updating-info": "There was an error updating your information.",
			"password-updated": "Password successfully updated",
			"security-updated": "Security question successfully updated",
			"info-updated": "User information successfully updated"
		},
		"resources": {
			"ancillaries": "보조 리소스",
			"access-codes": "액세스 코드",
			"print-on-demand": "요청 시 인쇄",
			"check-pod": "책의 출판사 인쇄 옵션을 확인하십시오.",
			"check-now": "지금 확인",
			"loading": "리소스를 업데이트하는 중입니다. 잠시만 기다려 주세요!",
			"in": "위치:",
			"access-code-intro": "액세스 코드는 온라인으로 코스 콘텐츠에 액세스하는 데 사용하는 암호입니다. 항목에 대한 코드가 표시되면 되돌릴 수 없습니다. 액세스 코드 사용 방법에 대한 자세한 지침은 <a href='%{support_url}' target='_blank'>지원 팀</a>에 문의하세요.",
			"expires": "만료",
			"expiration-message": "액세스 코드 사용에 대한 지침이 포함되어 있습니다.",
			"copy-fail": "복사할 수 없습니다. 코드를 선택하고 수동으로 복사하세요.",
			"launch-site": "사이트 시작",
			"launch-book": "책 시작",
			"reveal-code": "코드 표시",
			"no-resources": "리소스가 없습니다.",
			"no-access-codes": "액세스 코드가 없습니다.",
			"no-ancillaries": "이 제목에 대한 보충 설명이 없음",
			"name": "이름",
			"type": "유형",
			"size": "크기",
			"download-all": "모두 다운로드",
			"back": "리소스로 돌아가기"
		},
		"refunds": {
			"states": {
				"refunded": "환불됨",
				"unavailable": "환불 불가"
			},
			"reasons": {
				"dropped": "코스를 중단했습니다.",
				"wrong": "코스에 해당되지 않는 책입니다.",
				"print": "인쇄본을 구입하려고 합니다.",
				"missing": "코스에 필요한 사항(예: CD, 웹 액세스 권한, 동영상) 일부가 책에 없습니다.",
				"other": "기타"
			},
			"bulk": {
				"policy": "아래의 '환불 완료' 버튼을 클릭하면 %{brand}의 <a href='%{policy_url}' target='_blank'>환불 정책</a>에 동의한 것으로 간주됩니다.",
				"complete": "환불 완료",
				"view-details": "환불 세부 정보 보기",
				"success": "환불이 요청되었습니다. 처리되기까지 48시간이 걸립니다.",
				"failure": "죄송합니다. 문제가 발생했습니다! 환불이 처리되지 않았습니다.",
				"retry": "다시 시도",
				"support": "지원부 연락",
				"available-codes": "사용 가능한 코드",
				"codes-selected": "선택한 코드",
				"download": "코드 다운로드",
				"partially-refunded": "일부 환불됨",
				"pick-one": "환불하려면 하나 이상의 코드를 선택해야 합니다."
			},
			"refund": "환불",
			"all": "모두 환불하시겠습니까?",
			"missing-reason": "계속하려면 사유를 선택해야 합니다.",
			"missing-elaboration": "자세히 설명해 주십시오.",
			"policy": "아래의 “환불 요청 완료” 버튼을 클릭하면 이 %{brand} eTextbook을 다시 구입하는 경우 동일한 eTextbook에 대해 추가 환불을 요청할 수 없음을 이해한 것으로 간주합니다. 전체 환불 규정을 확인하세요.",
			"refunded": "환불됨",
			"sorry": "구입하신 상품이 만족스럽지 못한 점에 대해 사과드립니다.",
			"error": "오류가 발생했습니다.",
			"error-explain": "환불을 처리할 수 없습니다. 다시 시도해 주세요.",
			"why": "이유를 알려주세요.",
			"no-refunds": "환불된 상품이 없습니다.",
			"select-codes": "환불할 코드 선택:",
			"number": "환불 건수",
			"back": "환불로 돌아가기"
		},
		"purchases": {
			"back": "구입으로 돌아가기"
		},
		"global-bar": {
			"account": "계정 설정"
		}
	};

/***/ },
/* 991 */
/***/ function(module, exports) {

	module.exports = {
		"base": {
			"welcome": "Welkom bij Mulligans, %{name}!",
			"user": "Gebruikersinformatie",
			"devices": "Apparaten",
			"refunds": "Restituties",
			"resources": "Bronnen",
			"transactions": "Beställningar & Returer",
			"email": "E-mailadres",
			"password": "Wachtwoord",
			"save": "Opslaan",
			"sign-out": "Afmelden",
			"cancel": "Annuleren",
			"close": "Sluit",
			"learn-more": "Meer informatie",
			"required": "Vereist",
			"support": "Ondersteuning",
			"bookshelf": "Bookshelf",
			"launch": "Starten",
			"download": "Download",
			"details": "Gegevens",
			"cannot-be-blank": "%{field} mag niet leeg zijn.",
			"saving": "Opslaan...",
			"done": "Gereed",
			"failed": "Mislukt",
			"copy": "Kopieer"
		},
		"signin": {
			"login-failure": "E-mailadres of wachtwoord is onjuist",
			"welcome-large": "Welkom bij het <span class='inner'>Account Center van %{brand}</span>",
			"welcome-small": "<span class='inner'>Account Center</span>",
			"signin-button": "Aanmelden",
			"forgot-password": "Wachtwoord vergeten",
			"new-to-vst": "Nieuw bij %{brand}?",
			"create-account": "Een account maken",
			"signing-in": "Aanmelden...",
			"signin-failed": "Aanmelden mislukt"
		},
		"transactions": {
			"price": "Prijs",
			"excluded": "(exclusief btw)",
			"quantity": "Hoeveelheid",
			"confirmation#": "Bevestiging #",
			"payment": "Betaling",
			"purchased": "Aangeschaft",
			"purchase-details": "Aankoopgegevens",
			"subtotal": "Subtotaal",
			"total": "Totaal",
			"tax": "Belasting",
			"loading": "We laden uw transacties...",
			"no-purchases": "U hebt geen aankopen.",
			"seller-vat": "BTW verkoper",
			"total-vat": "Totaal betaalde %{vat}",
			"portion": "%{subTax} Tax %{rate}%",
			"vat-disclosure": "Prijs is inclusief %{vat}",
			"purchases": "Aankopen",
			"refunded-items": "Gerestitueerde items",
			"book-title": "Boektitel",
			"refund-details": "Informatie over restitutie",
			"print-receipt": "Ontvangstbewijs afdrukken",
			"request-refund": "Restitutie aanvragen",
			"expired": "Verlopen",
			"expires-in": "Verloopt op %{date}",
			"details-refund": "Details en terugbetaling",
			"modal": {
				"cant-refund-title": "Restitutie is niet beschikbaar",
				"cant-refund": "Uw boek kan vanwege een of meer van de volgende redenen niet worden gerestitueerd.",
				"cant-refund-1": "U hebt al een te groot deel van uw boek bekeken.",
				"cant-refund-2": "De aankoopdatum is al langer dan 14 dagen geleden.",
				"cant-refund-3": "Uw online broncode is al getoond.",
				"cant-refund-4": "Uw boek is reeds gerestitueerd.",
				"cant-refund-5": "Alle codes zijn al ingewisseld en/of gerestitueerd.",
				"cant-refund-6": "De aankoopdatum is al langer dan 30 dagen geleden.",
				"cant-refund-support": "Als u nog vragen hebt over het restitutiebeleid van %{brand}, neem dan contact op met <a href='%{support_url}' target='_blank'>ondersteuning</a>."
			},
			"license": {
				"perpetual": "Online toegang verloopt niet",
				"days": "%{days} dag(en) toegang"
			}
		},
		"devices": {
			"description": "Met %{brand} kunnen <span>%{desktop}</span> computers en <span>%{mobile}</span> mobiele apparaten of tablets tegelijk geactiveerd zijn.",
			"loading": "We laden uw apparaten.",
			"no-active": "U hebt geen actieve apparaten.",
			"deactivate": "Deactiveren"
		},
		"user": {
			"personal-information": "Persoonlijke gegevens",
			"security-information": "Beveiligingsinformatie",
			"notifications": "Meldingen",
			"first-name": "Voornaam",
			"last-name": "Achternaam",
			"change-password-title": "Wachtwoord wijzigen",
			"current-password": "Huidig wachtwoord",
			"new-password": "Nieuw wachtwoord",
			"security-password": "Wachtwoord",
			"confirm-new-password": "Nieuw wachtwoord bevestigen",
			"security-question": "Beveiligingsvraag",
			"security-info-change": "Wijzigen",
			"question": "Vraag",
			"answer": "Antwoord",
			"notifications-text": "Stuur mij incidenteel updates per e-mail over mijn accountactiviteit, productupdates en speciale aanbiedingen.",
			"loading": "Spot haalt uw gebruikersinformatie op, een moment geduld 🐶",
			"change-password-text": "Wachtwoorden moeten ten minste acht tekens, een hoofdletter, een kleine letter en een speciaal teken bevatten.",
			"email-locked": "E-mail vergrendeld",
			"email-locked-description": "U hebt geen toegang om uw e-mailadres te wijzigen.",
			"email-locked-more": "Neem contact op met uw beheerder.",
			"security-question6": "Wat is uw favoriete sport?",
			"security-question7": "Welke smaak ijs vindt u het lekkerst?",
			"security-question8": "Hoe heet uw lievelingshuisdier?",
			"security-question9": "Wat wilde u later worden toen u klein was?",
			"security-question10": "Wat is de achternaam van uw favoriete leraar/lerares?",
			"new-password-failure": "Het wachtwoord voldoet niet aan de vereisten.",
			"confirm-password-failure": "Wachtwoord moet overeenkomen",
			"new-password-tooltip": "Moet ten minste acht tekens, een hoofdletter, een kleine letter en een speciaal teken bevatten.",
			"enter-valid-email": "Voer een geldig e-mailadres in.",
			"password-cannot-be-same": "Wachtwoord mag niet hetzelfde zijn als het vorige wachtwoord.",
			"incorrect-password": "Onjuist wachtwoord",
			"complete-account": "Het lijkt erop dat u uw <a href='%{href}'>account moet voltooien</a>.",
			"completing-allows": "Als u uw account voltooit, kunt u offline boeken lezen op onze mobiele apps en notities en markeringen delen met vrienden.",
			"error-updating-info": "There was an error updating your information.",
			"password-updated": "Password successfully updated",
			"security-updated": "Security question successfully updated",
			"info-updated": "User information successfully updated"
		},
		"resources": {
			"ancillaries": "Accessoires",
			"access-codes": "Toegangscodes",
			"print-on-demand": "Afdrukken op aanvraag",
			"check-pod": "Bekijk uitgeversafdrukopties voor uw boeken.",
			"check-now": "Nu controleren",
			"loading": "Een moment geduld, we werken uw bronnen bij.",
			"in": "in",
			"access-code-intro": "Een toegangscode is een wachtwoord waarmee u toegang krijgt tot online cursusmateriaal. Als u een code voor een item hebt getoond, kunt u dit niet meer ruilen. Ga voor meer informatie over het gebruik van uw toegangscode naar <a href='%{support_url}' target='_blank'>Ondersteuning</a>.",
			"expires": "Verloopt",
			"expiration-message": "Bevat informatie voor het gebruik van uw toegangscode.",
			"copy-fail": "Kan niet worden gekopieerd. Selecteer de code en kopieer deze handmatig.",
			"launch-site": "Site starten",
			"launch-book": "Boek openen",
			"reveal-code": "Code tonen",
			"no-resources": "U hebt geen bronnen.",
			"no-access-codes": "U hebt geen toegangscodes.",
			"no-ancillaries": "Geen accessoires voor deze titel",
			"name": "Naam",
			"type": "Type",
			"size": "Formaat",
			"download-all": "Alles downloaden",
			"back": "Terug naar bronnen"
		},
		"refunds": {
			"states": {
				"refunded": "Gerestitueerd",
				"unavailable": "Restitutie niet beschikbaar"
			},
			"reasons": {
				"dropped": "Ik ben gestopt met de cursus.",
				"wrong": "Dit boek hoort niet bij mijn cursus.",
				"print": "Ik heb een papieren versie gekocht.",
				"missing": "Het boek bevat niet alles wat ik nodig heb voor mijn cursus ( zoals een cd, webtoegang, video's).",
				"other": "Anders"
			},
			"bulk": {
				"policy": "Door hieronder op de knop 'Restitutie voltooien' te klikken, ga ik akkoord met het <a href='%{policy_url}' target='_blank'>restitutiebeleid</a> van %{brand}.",
				"complete": "Restitutie voltooien",
				"view-details": "Restitutiegegevens bekijken",
				"success": "Je terugbetaling is aangevraagd. De verwerking kan 48 uur duren.",
				"failure": "Oeps, er is iets fout gegaan. Uw restitutie is helaas niet verwerkt.",
				"retry": "Opnieuw proberen",
				"support": "Contact opnemen met technische ondersteuning",
				"available-codes": "Beschikbare codes",
				"codes-selected": "Geselecteerde codes",
				"download": "Codes downloaden",
				"partially-refunded": "Deels gerestitueerd",
				"pick-one": "U moet ten minste één code selecteren om een restitutie te geven."
			},
			"refund": "Restitueren",
			"all": "Alles restitueren?",
			"missing-reason": "U moet een reden selecteren om verder te gaan.",
			"missing-elaboration": "Geef de benodigde uitleg",
			"policy": "Door hieronder op de knop 'Restitutieaanvraag voltooien' te klikken, geef ik aan dat ik begrijp dat als ik dit eTextbook van %{brand} aanschaf, ik hierna verder geen restituties meer voor hetzelfde eTextbook kan aanvragen. Bekijk het volledige restitutiebeleid.",
			"refunded": "Gerestitueerd",
			"sorry": "We vinden het jammer dat u niet tevreden bent met uw aankoop.",
			"error": "Er is iets misgegaan. ",
			"error-explain": "We konden uw restitutie niet verwerken. Probeer het opnieuw.",
			"why": "Vertel ons waarom.",
			"no-refunds": "U hebt geen gerestitueerde items.",
			"select-codes": "Selecteer code(s) om te restitueren:",
			"number": "Hoeveel?",
			"back": "Terug naar restituties"
		},
		"purchases": {
			"back": "Terug naar aankopen"
		},
		"global-bar": {
			"account": "Accountinstellingen"
		}
	};

/***/ },
/* 992 */
/***/ function(module, exports) {

	module.exports = {
		"base": {
			"welcome": "Velkommen til Mulligans, %{name}!",
			"user": "Brukerinfo",
			"devices": "Enheter",
			"refunds": "Refusjoner",
			"resources": "Ressurser",
			"transactions": "Bestillinger og returer",
			"email": "E-post",
			"password": "Passord",
			"save": "Lagre",
			"sign-out": "Logg av",
			"cancel": "Avbryt",
			"close": "Lukk",
			"learn-more": "Finn ut mer",
			"required": "Påkrevd",
			"support": "Støtte",
			"bookshelf": "Bookshelf",
			"launch": "Start",
			"download": "Last ned",
			"details": "Detaljer",
			"cannot-be-blank": "%{field} kan ikke være tomt.",
			"saving": "Lagrer...",
			"done": "Fullført",
			"failed": "Mislyktes",
			"copy": "Kopier"
		},
		"signin": {
			"login-failure": "E-postaddresse eller passord er feil",
			"welcome-large": "Velkommen til <span class='inner'>%{brand} Account Center</span>",
			"welcome-small": "<span class='inner'>Account Center</span>",
			"signin-button": "Logg på",
			"forgot-password": "Glemt passordet",
			"new-to-vst": "Ny hos %{brand}?",
			"create-account": "Opprett en konto",
			"signing-in": "Logger på...",
			"signin-failed": "Pålogging mislyktes"
		},
		"transactions": {
			"price": "Pris",
			"excluded": "(Ekskl. mva)",
			"quantity": "Mengde",
			"confirmation#": "Bekreftelse #",
			"payment": "Betaling",
			"purchased": "Kjøpt",
			"purchase-details": "Kjøpsdetaljer",
			"subtotal": "Delsum",
			"total": "Total",
			"tax": "Avgift",
			"loading": "Heisann, vi laster dine transaksjoner...",
			"no-purchases": "Du har ingen kjøp.",
			"seller-vat": "Selger MVA",
			"total-vat": "Total %{vat} betalt",
			"portion": "%{subTax} Skatt %{rate}%",
			"vat-disclosure": "Prisen inkluderer %{vat}",
			"purchases": "Kjøp",
			"refunded-items": "Refunderte elementer",
			"book-title": "Boktittel",
			"refund-details": "Detaljer om tilbakebetaling",
			"print-receipt": "Skriv ut kvittering",
			"request-refund": "Forespør om refusjon",
			"expired": "Utløpt",
			"expires-in": "Utløper %{date}",
			"details-refund": "Informasjon og refusjon",
			"modal": {
				"cant-refund-title": "Refusjon ikke tilgjengelig",
				"cant-refund": "Boken kan ikke bli refundert på grunn av en eller flere av følgende grunner.",
				"cant-refund-1": "For mye av boken har blitt vist.",
				"cant-refund-2": "Det har gått mer enn 14 dager siden kjøpsdatoen.",
				"cant-refund-3": "Din online ressurskode har blitt vist.",
				"cant-refund-4": "Boken har blitt refundert tidligere.",
				"cant-refund-5": "Alle koder er allerede innløst og/eller refundert.",
				"cant-refund-6": "Det har gått mer enn 30 dager siden kjøpsdatoen.",
				"cant-refund-support": "Hvis du fortsatt er usikker på %{brand}s angrerett-policy, kontakt <a href='%{support_url}' target='_blank'>kundestøtte</a>."
			},
			"license": {
				"perpetual": "Elektronisk tilgang utløper ikke",
				"days": "%{days} dagers tilgang"
			}
		},
		"devices": {
			"description": "%{brand} tillater deg å ha <span>%{desktop}</span> datamaskiner og <span>%{mobile}</span> mobil-/nettbrettenheter aktivert på et gitt tidspunkt.",
			"loading": "Hei, vi henter enhetene dine :)",
			"no-active": "Du har ingen aktive enheter.",
			"deactivate": "Deaktiver"
		},
		"user": {
			"personal-information": "Personlig informasjon",
			"security-information": "Sikkerhetsinformasjon",
			"notifications": "Varsler",
			"first-name": "Fornavn",
			"last-name": "Etternavn",
			"change-password-title": "Endre passord",
			"current-password": "Nåværende passord",
			"new-password": "Nytt passord",
			"security-password": "Passord",
			"confirm-new-password": "Bekreft nytt passord",
			"security-question": "Sikkerhetsspørsmål",
			"security-info-change": "Endre",
			"question": "Spørsmål",
			"answer": "Svar",
			"notifications-text": "Send meg sporadiske oppdateringer om min kontoaktivitet, produktoppdateringer og spesialtilbud.",
			"loading": "Spot er ute og henter inn brukerinformasjonen, et øyeblikk 🐶",
			"change-password-text": "Passord må inneholde minst 8 tegn, en stor bokstav, en liten bokstav, og et spesialtegn.",
			"email-locked": "E-post låst",
			"email-locked-description": "Du har ikke tilgang til å endre din e-post.",
			"email-locked-more": "Vennligst ta kontakt med administratoren.",
			"security-question6": "Hva er din favorittsport?",
			"security-question7": "Hva er din favoritt-iskremsmak?",
			"security-question8": "Hva er navnet på ditt favorittkjæledyr?",
			"security-question9": "Da du var ung, hva ville du bli når du ble stor?",
			"security-question10": "Hva var etternavnet til din favorittlærer?",
			"new-password-failure": "Passordet oppfyller ikke kravene",
			"confirm-password-failure": "Passordene må samsvare",
			"new-password-tooltip": "Må inneholde minst 8 tegn, en stor bokstav, en liten bokstav, og et spesialtegn.",
			"enter-valid-email": "Vennligst skriv inn en gyldig e-postadresse.",
			"password-cannot-be-same": "Passordet kan ikke være det samme som det forrige passordet",
			"incorrect-password": "Feil passord",
			"complete-account": "Ser ut som du må <a href='%{href}'>fullføre kontoen</a>.",
			"completing-allows": "Når du fullfører kontoen din, kan du lese bøker frakoblet på mobilappene, og dele notater og uthevinger med venner.",
			"error-updating-info": "There was an error updating your information.",
			"password-updated": "Password successfully updated",
			"security-updated": "Security question successfully updated",
			"info-updated": "User information successfully updated"
		},
		"resources": {
			"ancillaries": "Hjelpeutstyr",
			"access-codes": "Adgangskoder",
			"print-on-demand": "Skriv ut etter behov",
			"check-pod": "Sjekk utgivers utskriftsalternativer for bøkene dine.",
			"check-now": "Sjekk nå",
			"loading": "Vent litt, vi oppdaterer dine ressurser!",
			"in": "i",
			"access-code-intro": "En adgangskode er et passord du bruker for å få tilgang til kursinnhold på nettet. Når du viser en kode for et element, kan du ikke returnere den. For mer instruksjoner om hvordan du bruker dine adgangskoder, besøk <a href='%{support_url}' target='_blank'>kundestøtte</a>.",
			"expires": "Utløper",
			"expiration-message": "Inneholder instruksjoner for bruk av adgangskoden.",
			"copy-fail": "Kunne ikke kopiere. Velg koden og kopier den manuelt.",
			"launch-site": "Start hjemmesiden",
			"launch-book": "Start bok",
			"reveal-code": "Vis kode",
			"no-resources": "Du har ingen ressurser.",
			"no-access-codes": "Du har ingen adgangskoder.",
			"no-ancillaries": "Ingen hjelpemidler for denne tittelen",
			"name": "Navn",
			"type": "Type",
			"size": "Størrelse",
			"download-all": "Last ned alle",
			"back": "Tilbake til ressurser"
		},
		"refunds": {
			"states": {
				"refunded": "Refundert",
				"unavailable": "Refusjon utilgjengelig"
			},
			"reasons": {
				"dropped": "Jeg droppet kurset",
				"wrong": "Det var feil bok for kurset mitt",
				"print": "Jeg bestemte meg for å kjøpe en trykket versjon i stedet",
				"missing": "Boken inneholder ikke alt jeg trenger for kurset (f.eks. en CD, nettilgang, videoer)",
				"other": "Andre"
			},
			"bulk": {
				"policy": "Ved å klikke på &quot;Full refusjon&quot;-knappen nedenfor, godtar jeg %{brand}s <a href='%{policy_url}' target='_blank'>angrerett</a>.",
				"complete": "Full refusjon",
				"view-details": "Se detaljer om refusjon",
				"success": "Refusjonen din ble forespurt. Behandlingen kan ta 48 timer.",
				"failure": "Oops - noe gikk galt Dessverre gikk ikke refusjonen gjennom.",
				"retry": "Prøv igjen",
				"support": "Kontakt kundestøtte",
				"available-codes": "Tilgjengelige koder",
				"codes-selected": "Koder valgt",
				"download": "Last ned koder",
				"partially-refunded": "Delvis refundert",
				"pick-one": "Du må velge minst én kode for å gjøre en refusjon"
			},
			"refund": "Refusjon",
			"all": "Refundere alle?",
			"missing-reason": "Du må velge en grunn for å fortsette",
			"missing-elaboration": "Vennligst forklar nærmere",
			"policy": "Ved å klikke på \"Fullfør refusjonsforespørsel\"-knappen nedenfor, forstår jeg at hvis jeg kjøper denne e-læreboken fra %{brand} på nytt, vil jeg ikke være kvalifisert til å be om ytterligere refusjoner for samme e-lærebok. Se full angrerett-policy.",
			"refunded": "Refundert",
			"sorry": "Vi beklager at du ikke var fornøyd med kjøpet.",
			"error": "Noe gikk galt",
			"error-explain": "Kunne ikke behandle refusjonen. Vennligst prøv på nytt.",
			"why": "Fortell oss hvorfor.",
			"no-refunds": "Du har ingen refunderte elementer.",
			"select-codes": "Velg kode(r) å refundere:",
			"number": "Hvor mange?",
			"back": "Tilbake til refusjoner"
		},
		"purchases": {
			"back": "Tilbake til kjøp"
		},
		"global-bar": {
			"account": "Kontoinnstillinger"
		}
	};

/***/ },
/* 993 */
/***/ function(module, exports) {

	module.exports = {
		"base": {
			"welcome": "Witamy w Mulligans, %{name}!",
			"user": "Informacje o użytkowniku",
			"devices": "Urządzenia",
			"refunds": "Zwroty",
			"resources": "Zasoby",
			"transactions": "Zamówienia i zwroty",
			"email": "Adres e-mail",
			"password": "Haslo",
			"save": "Zapisz",
			"sign-out": "Wyloguj",
			"cancel": "Anuluj",
			"close": "Zamknij",
			"learn-more": "Dowiedz się więcej",
			"required": "Wymagane",
			"support": "Wsparcie",
			"bookshelf": "Biblioteczka",
			"launch": "Uruchomienie",
			"download": "Pobierz",
			"details": "Szczegóły",
			"cannot-be-blank": "%{field} nie może być puste.",
			"saving": "Zapisywanie...",
			"done": "Gotowe",
			"failed": "Nie powiodło się",
			"copy": "Kopiuj"
		},
		"signin": {
			"login-failure": "Hasło lub e-mail są nieprawidłowe",
			"welcome-large": "Witamy w <span class='inner'>%{brand} Account Center</span>",
			"welcome-small": "<span class='inner'>Account Center</span>",
			"signin-button": "Zaloguj",
			"forgot-password": "Nie pamiętam hasła",
			"new-to-vst": "Nie znasz jeszcze %{brand}?",
			"create-account": "Utwórz konto",
			"signing-in": "Trwa logowanie...",
			"signin-failed": "Błąd logowania"
		},
		"transactions": {
			"price": "Cena",
			"excluded": "(Bez podatku)",
			"quantity": "Ilość",
			"confirmation#": "Nr potwierdzenia",
			"payment": "Płatność",
			"purchased": "Zakupione",
			"purchase-details": "Szczegóły zakupu",
			"subtotal": "Suma składowa",
			"total": "Łącznie",
			"tax": "Podatek",
			"loading": "Właśnie wczytujemy twoje transakcje...",
			"no-purchases": "Brak zakupów.",
			"seller-vat": "VAT sprzedawcy",
			"total-vat": "%{vat} zapłacony w sumie",
			"portion": "%{subTax} Podatek %{rate}%",
			"vat-disclosure": "Cena zawiera %{vat}",
			"purchases": "Zakupy",
			"refunded-items": "Zwrócone pozycje",
			"book-title": "Tytuł książki",
			"refund-details": "Informacje o zwrotach",
			"print-receipt": "Drukuj rachunek",
			"request-refund": "Prześlij żądanie zwrotu",
			"expired": "Wygasła",
			"expires-in": "Wygasa %{date}",
			"details-refund": "Szczegóły i zwrot",
			"modal": {
				"cant-refund-title": "Zwrot niedostępny",
				"cant-refund": "Nie można dokonać zwrotu za książkę z co najmniej jednego powodu.",
				"cant-refund-1": "Przejrzano zbyt duży fragment książki.",
				"cant-refund-2": "Minęło ponad 14 dni od daty zakupu.",
				"cant-refund-3": "Odkryto kod zasobów online.",
				"cant-refund-4": "Już wcześniej uzyskano zwrot za książkę.",
				"cant-refund-5": "Wszystkie kody zostały już zrealizowane i/lub zwrócone.",
				"cant-refund-6": "Minęło ponad 30 dni od daty zakupu.",
				"cant-refund-support": "Jeśli nadal nie masz pewności, jak działa polityka zwrotów %{brand}, skontaktuj się z <a href='%{support_url}' target='_blank'>działem pomocy</a>."
			},
			"license": {
				"perpetual": "Dostęp online nie wygasa",
				"days": "Okres dostępu w dniach: %{days}"
			}
		},
		"devices": {
			"description": "W %{brand} można jednocześnie aktywować komputery <span>%{desktop}</span> oraz urządzenia przenośne <span>%{mobile}</span> .",
			"loading": "Mamy twoje urządzenia :)",
			"no-active": "Brak aktywnych urządzeń.",
			"deactivate": "Dezaktywuj"
		},
		"user": {
			"personal-information": "Informacje osobiste",
			"security-information": "Informacje dot. bezpieczeństwa",
			"notifications": "Powiadomienia",
			"first-name": "Imie",
			"last-name": "Nazwisko",
			"change-password-title": "Zmień hasło",
			"current-password": "Bieżące hasło",
			"new-password": "Nowe hasło",
			"security-password": "Haslo",
			"confirm-new-password": "Potwierdź nowe hasło",
			"security-question": "Pytanie zabezpieczające",
			"security-info-change": "Zmień",
			"question": "Pytanie",
			"answer": "Odpowiedź",
			"notifications-text": "Proszę o wysyłanie okresowych wiadomości e-mail z aktualizacjami dotyczącymi aktywności na moim koncie i produktów oraz z ofertami specjalnymi.",
			"loading": "Reksio poszedł szukać twoich danych logowania, poczekaj chwilę 🐶",
			"change-password-text": "Hasło musi zawierać co najmniej 8 znaków, wielką literę, małą literę i znak specjalny.",
			"email-locked": "Zablokowany adres e-mail",
			"email-locked-description": "Nie masz dostępu, aby zmienić swój adres e-mail.",
			"email-locked-more": "Skontaktuj się z administratorem.",
			"security-question6": "Jaki jest twój ulubiony sport?",
			"security-question7": "Jaki jest twój ulubiony smak lodów?",
			"security-question8": "Jak się nazywa twoje zwierzę?",
			"security-question9": "Jako dziecko kim chciałeś być w przyszłości?",
			"security-question10": "Jak się nazywał twój ulubiony nauczyciel?",
			"new-password-failure": "Hasło nie spełnia wymogów",
			"confirm-password-failure": "Hasła muszą być zgodne",
			"new-password-tooltip": "Musi zawierać co najmniej 8 znaków, wielką literę, małą literę i znak specjalny.",
			"enter-valid-email": "Podaj prawidłowy adres e-mail.",
			"password-cannot-be-same": "Hasło nie może być takie samo, jak poprzednie hasło",
			"incorrect-password": "Niepoprawne hasło",
			"complete-account": "Musisz <a href='%{href}'>uzupełnić konto</a>.",
			"completing-allows": "Po uzupełnieniu konta możesz czytać książki offline za pomocą aplikacji mobilnej i udostępniać notatki oraz zaznaczenia znajomym.",
			"error-updating-info": "There was an error updating your information.",
			"password-updated": "Password successfully updated",
			"security-updated": "Security question successfully updated",
			"info-updated": "User information successfully updated"
		},
		"resources": {
			"ancillaries": "Dodatki",
			"access-codes": "Kody dostępu",
			"print-on-demand": "Druk na żądanie",
			"check-pod": "Sprawdź opcje wydruku swoich książek u wydawcy.",
			"check-now": "Sprawdź teraz",
			"loading": "Poczekaj, aktualizujemy twoje zasoby.",
			"in": "w",
			"access-code-intro": "Kod dostępu jest hasłem służącym do korzystania z zawartości kursu online. Po poznaniu kodu pozycji nie możesz go zwrócić. Dodatkowe instrukcje dotyczące używania kodów dostępowych można uzyskać, odwiedzając <a href='%{support_url}' target='_blank'>stronę pomocy</a>.",
			"expires": "Wygasa",
			"expiration-message": "Zawiera instrukcje dotyczące korzystania z kod dostępu.",
			"copy-fail": "Nie można skopiować. Zaznacz kod ręcznie i skopiuj go.",
			"launch-site": "Witryna uruchamiania",
			"launch-book": "Uruchom książkę",
			"reveal-code": "Ujawnij kod",
			"no-resources": "Brak zasobów.",
			"no-access-codes": "Brak kodów dostępu.",
			"no-ancillaries": "Brak pomocy dla tego tytułu",
			"name": "Nazwisko",
			"type": "Typ",
			"size": "Wielkość",
			"download-all": "Pobierz wszystko",
			"back": "Wróć do zasobów"
		},
		"refunds": {
			"states": {
				"refunded": "Zwrócono",
				"unavailable": "Nie można zwrócić"
			},
			"reasons": {
				"dropped": "Nie korzystam z kursu",
				"wrong": "Książka nieodpowiednia dla mojego kursu",
				"print": "Wybrano wersję drukowaną",
				"missing": "Książka nie zawiera wszystkiego, czego potrzebuję podczas kursu (np. CD, dostęp internetowy, filmy)",
				"other": "Inne"
			},
			"bulk": {
				"policy": "Kliknięcie poniższego przycisku &quot;Ukończ zwrot&quot; oznacza, że wyrażam zgodę na zastosowanie się w przypadku %{brand} <a href='%{policy_url}' target='_blank'>do polityki zwrotów tej marki</a>.",
				"complete": "Ukończ zwrot",
				"view-details": "Szczegółowe informacje o zwrotach",
				"success": "Wysłano prośbę o zwrot. Poczekaj 48 godzin na jej przetworzenie.",
				"failure": "Wystąpił problem. Zwrot nie został zrealizowany.",
				"retry": "Spróbuj ponownie",
				"support": "Kontakt z pomocą",
				"available-codes": "Dostępne kody",
				"codes-selected": "Wybrane kody",
				"download": "Pobierz kody",
				"partially-refunded": "Zwrot częściowy",
				"pick-one": "Wybierz co najmniej jeden kod, aby dokonać zwrotu"
			},
			"refund": "Zwrot",
			"all": "Zwrócić wszystko?",
			"missing-reason": "Aby kontynuować, wybierz przyczynę",
			"missing-elaboration": "Opisz",
			"policy": "Klikając poniższy przycisk Ukończ wniosek o zwrot, rozumiem, że w przypadku ponownego zakupu tego podręcznika elektronicznego %{brand} eTextbook, nie będę mieć możliwości uzyskania za niego zwrotu. Wyświetl pełną politykę zwrotów.",
			"refunded": "Zwrócono",
			"sorry": "Przykro nam, że zakup nie spełnia oczekiwań.",
			"error": "Wystąpił problem",
			"error-explain": "Nie można przetworzyć zwrotu. Spróbuj ponownie.",
			"why": "Dlaczego?",
			"no-refunds": "Brak zwróconych pozycji.",
			"select-codes": "Wybierz kody do dokonania zwrotu:",
			"number": "Ile?",
			"back": "Wróć do zwrotów"
		},
		"purchases": {
			"back": "Wróć do zakupów"
		},
		"global-bar": {
			"account": "Ustawienia konta"
		}
	};

/***/ },
/* 994 */
/***/ function(module, exports) {

	module.exports = {
		"base": {
			"welcome": "Bem-vindo ao Mulligans, %{name}!",
			"user": "Informações do usuário",
			"devices": "Dispositivos",
			"refunds": "Reembolsos",
			"resources": "Recursos",
			"transactions": "Encomendas e Devoluções",
			"email": "Email",
			"password": "Senha",
			"save": "Salvar",
			"sign-out": "Sair",
			"cancel": "Cancelar",
			"close": "Fechar",
			"learn-more": "Aprender mais",
			"required": "Obrigatórios",
			"support": "Suporte",
			"bookshelf": "Bookshelf",
			"launch": "Iniciar",
			"download": "Fazer o download",
			"details": "Detalhes",
			"cannot-be-blank": "%{field} não deve estar em branco.",
			"saving": "Salvando...",
			"done": "Concluído",
			"failed": "Falhou",
			"copy": "Copiar"
		},
		"signin": {
			"login-failure": "O e-mail ou a senha está incorreto",
			"welcome-large": "Bem-vindo ao <span class='inner'>Centro de Contas da %{brand}</span>",
			"welcome-small": "<span class='inner'>Centro de Contas</span>",
			"signin-button": "Entrar",
			"forgot-password": "Esqueceu-se de sua senha?",
			"new-to-vst": "É novo na %{brand}?",
			"create-account": "Criar uma conta",
			"signing-in": "Entrando…",
			"signin-failed": "Falha na entrada"
		},
		"transactions": {
			"price": "Preço",
			"excluded": "(Excluindo impostos)",
			"quantity": "Quantidade",
			"confirmation#": "Confirmação nº",
			"payment": "Pagamento",
			"purchased": "Comprado",
			"purchase-details": "Detalhes de compra",
			"subtotal": "Subtotal",
			"total": "Total",
			"tax": "Imposto",
			"loading": "Ei, seu gastador! Estamos carregando sua transação...",
			"no-purchases": "Não há compras.",
			"seller-vat": "IVA do vendedor",
			"total-vat": "%{vat} total pago",
			"portion": "%{subTax} Imposto %{rate}%",
			"vat-disclosure": "O preço inclui %{vat}",
			"purchases": "Compras",
			"refunded-items": "Itens reembolsados",
			"book-title": "Título do livro",
			"refund-details": "Detalhes de reembolso",
			"print-receipt": "Imprimir recibo",
			"request-refund": "Reembolso pedido",
			"expired": "Venceu",
			"expires-in": "Vence em %{date}",
			"details-refund": "Detalhes e reembolso",
			"modal": {
				"cant-refund-title": "Reembolso não disponível",
				"cant-refund": "Seu livro não pode ser reembolsado devido a uma ou mais das seguintes razões.",
				"cant-refund-1": "Uma grande porcentagem de seu livro já foi visualizada.",
				"cant-refund-2": "Faz mais de 14 dias desde a data de compra.",
				"cant-refund-3": "Seu código de recursos online foi revelado.",
				"cant-refund-4": "Seu livro já tinha sido reembolsado.",
				"cant-refund-5": "Todos os códigos já foram resgatados e/ou reembolsados.",
				"cant-refund-6": "Faz mais de 30 dias desde a data de compra.",
				"cant-refund-support": "Caso você ainda tenha dúvidas em relação à política de reembolso da %{brand}, entre em contato com o <a href='%{support_url}' target='_blank'>suporte</a>."
			},
			"license": {
				"perpetual": "O acesso online não vence",
				"days": "Acesso de %{days} dias"
			}
		},
		"devices": {
			"description": "%{brand} permite que você tenha <span>%{desktop}</span> computadores e <span>%{mobile}</span> dispositivos móveis ativados a qualquer momento.",
			"loading": "Oba, estamos captando seus dispositivos :)",
			"no-active": "Você não tem dispositivos ativos.",
			"deactivate": "Desativar"
		},
		"user": {
			"personal-information": "Informações pessoais",
			"security-information": "Informações de segurança",
			"notifications": "Notificações",
			"first-name": "Nome",
			"last-name": "Sobrenome",
			"change-password-title": "Altere a Senha",
			"current-password": "Senha atual",
			"new-password": "Nova senha",
			"security-password": "Senha",
			"confirm-new-password": "Confirme a nova senha",
			"security-question": "Pergunta de segurança",
			"security-info-change": "Alterar",
			"question": "Pergunta",
			"answer": "Resposta",
			"notifications-text": "Favor enviar-me por e-mail atualizações ocasionais sobre minha atividade de conta, atualizações de produtos e ofertas especiais.",
			"loading": "O Spot foi buscar suas informações de usuário. Aguarde... 🐶",
			"change-password-text": "A senha deve conter pelo menos 8 caracteres, uma letra maiúscula, uma letra minúscula, e um caractere especial.",
			"email-locked": "E-mail bloqueado",
			"email-locked-description": "Você não tem acesso para alterar o seu e-mail.",
			"email-locked-more": "Entre em contato com o seu administrador.",
			"security-question6": "Qual é seu esporte favorito?",
			"security-question7": "Qual é o seu sabor favorito de sorvete?",
			"security-question8": "Qual é o nome do seu animal de estimação favorito?",
			"security-question9": "Quando você era jovem, o que queria ser ao crescer?",
			"security-question10": "Qual foi o último nome do seu professor favorito?",
			"new-password-failure": "A senha não atende às exigências",
			"confirm-password-failure": "A senha deve ser igual",
			"new-password-tooltip": "Deve conter pelo menos 8 caracteres, uma letra maiúscula, uma letra minúscula, e um caractere especial.",
			"enter-valid-email": "Insira um e-mail válido.",
			"password-cannot-be-same": "A senha não pode ser igual à anterior",
			"incorrect-password": "Senha incorreta",
			"complete-account": "Parece que você precisa <a href='%{href}'>completar a sua conta</a>.",
			"completing-allows": "Ao completar a sua conta você poderá ler livros offline em seus aplicativos móveis e compartilhar notas e realces com amigos.",
			"error-updating-info": "There was an error updating your information.",
			"password-updated": "Password successfully updated",
			"security-updated": "Security question successfully updated",
			"info-updated": "User information successfully updated"
		},
		"resources": {
			"ancillaries": "Auxiliares",
			"access-codes": "Códigos de acesso",
			"print-on-demand": "Imprimir a pedido",
			"check-pod": "Verifique as opções de impressão do editor para os seus livros.",
			"check-now": "Marque agora",
			"loading": "Aguente firme! Estamos atualizando seus recursos!",
			"in": "em",
			"access-code-intro": "Um código de acesso é uma senha que você usa para acessar conteúdo de curso online. Quando você revelar um código de um item, não será possível desfazê-lo. Para obter mais instruções sobre como usar seus códigos de acesso, visite <a href='%{support_url}' target='_blank'>Suporte</a>.",
			"expires": "Vence em",
			"expiration-message": "Contém instruções para usar seu código de acesso.",
			"copy-fail": "Não é possível copiar. Selecione o código e copie-o manualmente.",
			"launch-site": "Site para iniciar",
			"launch-book": "Iniciar livro",
			"reveal-code": "Revelar Código",
			"no-resources": "Você não tem nenhum recurso.",
			"no-access-codes": "Você não tem nenhum código de acesso.",
			"no-ancillaries": "Não há auxiliares para este título",
			"name": "Nome",
			"type": "Tipo",
			"size": "Tamanho",
			"download-all": "Fazer o download de tudo",
			"back": "Voltar para recursos"
		},
		"refunds": {
			"states": {
				"refunded": "Reembolsado",
				"unavailable": "Reembolso indisponível"
			},
			"reasons": {
				"dropped": "Desisti do curso",
				"wrong": "Este não era o livro certo para meu curso",
				"print": "Decidi comprar uma versão impressa",
				"missing": "Este livro não contém tudo o que preciso para meu curso (p. ex., um CD, acesso à web, vídeos)",
				"other": "Outro"
			},
			"bulk": {
				"policy": "Ao clicar no botão &quot;Reembolso total&quot; abaixo, eu concordo com a política de reembolso da <a href='%{policy_url}' target='_blank'>%{brand}</a>.",
				"complete": "Reembolso total",
				"view-details": "Exibir detalhes de reembolso",
				"success": "O reembolso foi solicitado. Aguarde 48 horas para o processamento.",
				"failure": "Opa! Algo deu errado! Infelizmente o seu reembolso não foi aprovado.",
				"retry": "Tente novamente",
				"support": "Contatar suporte",
				"available-codes": "Códigos disponíveis",
				"codes-selected": "Códigos selecionados",
				"download": "Fazer o download dos códigos",
				"partially-refunded": "Parcialmente reembolsado",
				"pick-one": "É necessário selecionar pelo menos um código para solicitar um reembolso"
			},
			"refund": "Reembolso",
			"all": "Reembolsar tudo?",
			"missing-reason": "É necessário selecionar uma razão para continuar",
			"missing-elaboration": "Detalhes",
			"policy": "Ao clicar no botão “Solicitação de reembolso total” abaixo, compreendo que, se eu comprar este eTextbook da %{brand} novamente, não terei o direito de solicitar mais nenhum reembolso em relação ao mesmo eTextbook. Veja a política de devoluções completa.",
			"refunded": "Reembolsado",
			"sorry": "Lamentamos por você não ter ficado satisfeito com sua compra.",
			"error": "Algo deu errado",
			"error-explain": "Não foi possível processar seu reembolso. Tente novamente.",
			"why": "Diga-nos por quê.",
			"no-refunds": "Você não tem itens reembolsados.",
			"select-codes": "Selecione código(s) para reembolso:",
			"number": "Quantos?",
			"back": "Voltar para reembolsos"
		},
		"purchases": {
			"back": "Voltar para compras"
		},
		"global-bar": {
			"account": "Configurações da conta"
		}
	};

/***/ },
/* 995 */
/***/ function(module, exports) {

	module.exports = {
		"base": {
			"welcome": "Bem-vindo ao Mulligans, %{name}!",
			"user": "Informações do Utilizador",
			"devices": "Dispositivos",
			"refunds": "Reembolsos",
			"resources": "Recursos",
			"transactions": "Encomendas e Devoluções",
			"email": "Correio electrónico",
			"password": "Palavra-passe",
			"save": "Salvar",
			"sign-out": "Terminar sessão",
			"cancel": "Cancelar",
			"close": "Fechar",
			"learn-more": "Saber mais",
			"required": "Necessário",
			"support": "Suporte",
			"bookshelf": "Bookshelf",
			"launch": "Iniciar",
			"download": "Transferir",
			"details": "Detalhes",
			"cannot-be-blank": "%{field} não pode ficar em branco.",
			"saving": "A guardar…",
			"done": "Concluído",
			"failed": "Falha",
			"copy": "Copiar"
		},
		"signin": {
			"login-failure": "E-mail ou palavra-passe incorretos",
			"welcome-large": "Bem-vindo ao <span class='inner'>%{brand} Account Center</span>",
			"welcome-small": "<span class='inner'>Account Center</span>",
			"signin-button": "Entrar",
			"forgot-password": "Esqueceu-se da palavra-passe?",
			"new-to-vst": "Novo em %{brand}?",
			"create-account": "Criar uma conta",
			"signing-in": "A iniciar sessão...",
			"signin-failed": "Falha ao iniciar sessão"
		},
		"transactions": {
			"price": "Preço",
			"excluded": "(Excluindo IVA)",
			"quantity": "Quantidade",
			"confirmation#": "Confirmação n.º",
			"payment": "Pagamento",
			"purchased": "Comprado",
			"purchase-details": "Detalhes da compra",
			"subtotal": "Subtotal",
			"total": "Total",
			"tax": "Imposto",
			"loading": "Olá, maravilhoso gastador, estamos a carregar as suas transações...",
			"no-purchases": "Não tem compras.",
			"seller-vat": "IVA do vendedor",
			"total-vat": "Total %{vat} Pago",
			"portion": "%{subTax} IVA %{rate}%",
			"vat-disclosure": "O preço inclui %{vat}",
			"purchases": "Compras",
			"refunded-items": "Itens com reembolso",
			"book-title": "Título do livro",
			"refund-details": "Detalhes do reembolso",
			"print-receipt": "Imprimir recibo",
			"request-refund": "Pedir reembolso",
			"expired": "Expirado",
			"expires-in": "Expira a %{date}",
			"details-refund": "Detalhes e reembolso",
			"modal": {
				"cant-refund-title": "Reembolso não disponível",
				"cant-refund": "O seu livro não pode ser reembolsado devido a um ou mais dos motivos seguintes.",
				"cant-refund-1": "Já foi visualizada uma grande parte do seu livro.",
				"cant-refund-2": "Já decorreram mais de 14 dias após a data de compra.",
				"cant-refund-3": "O seu código de recursos online foi apresentado.",
				"cant-refund-4": "O seu livro já foi reembolsado anteriormente.",
				"cant-refund-5": "Todos os códigos já foram obtidos e/ou reembolsados.",
				"cant-refund-6": "Já decorreram mais de 30 dias após a data de compra.",
				"cant-refund-support": "Se ainda tem dúvidas sobre a política de reembolsos de %{brand}, contacte o <a href='%{support_url}' target='_blank'>Suporte</a>."
			},
			"license": {
				"perpetual": "O acesso online não expira",
				"days": "%{days} dia(s) de acesso"
			}
		},
		"devices": {
			"description": "A %{brand} permite-lhe ter <span>%{desktop}</span> computadores e <span>%{mobile}</span> dispositivos móveis/tablets ativos em simultâneo.",
			"loading": "Olá, estamos a obter os seus dispositivos :)",
			"no-active": "Não tem dispositivos ativos.",
			"deactivate": "Desativar"
		},
		"user": {
			"personal-information": "Informações Pessoais",
			"security-information": "Informações de segurança",
			"notifications": "Notificações",
			"first-name": "Nome",
			"last-name": "Sobrenome",
			"change-password-title": "Alterar Palavra-passe",
			"current-password": "Palavra-passe atual",
			"new-password": "Nova Palavra-passe",
			"security-password": "Senha",
			"confirm-new-password": "Confirmar Nova Palavra-passe",
			"security-question": "Pergunta de segurança",
			"security-info-change": "Alterar",
			"question": "Pergunta",
			"answer": "Resposta",
			"notifications-text": "Quero receber notificação por e-mail sobre atualizações ocasionais relativas à atividade da minha conta, atualizações de produtos e ofertas especiais.",
			"loading": "O Spot está a obter as suas informações de utilizador, aguarde um momento 🐶",
			"change-password-text": "A palavra-passe tem de conter no mínimo 8 carateres, uma letra maiúscula, uma letra minúscula e um caráter especial. ",
			"email-locked": "Correio electrónico bloqueado",
			"email-locked-description": "Não tem permissão para alterar o seu e-mail. ",
			"email-locked-more": "Contacte o seu administrador.",
			"security-question6": "Qual é o seu desporto favorito?",
			"security-question7": "Qual é o seu sabor de gelado favorito?",
			"security-question8": "Qual é o seu nome de animal de estimação favorito?",
			"security-question9": "Quando era jovem, o que queria ser quando fosse grande?",
			"security-question10": "Qual era o apelido do seu professor preferido?",
			"new-password-failure": "A palavra-passe não cumpre os requisitos",
			"confirm-password-failure": "As palavras-passe têm de ser iguais",
			"new-password-tooltip": "Deve conter no mínimo 8 caracteres, uma letra maiúscula, uma letra minúscula e um carácter especial.",
			"enter-valid-email": "Insira um e-mail válido.",
			"password-cannot-be-same": "A palavra-passe não pode ser a mesma que a palavra-passe anterior",
			"incorrect-password": "Palavra-passe incorreta",
			"complete-account": "Parece que precisa de <a href='%{href}'>completar a sua conta</a>.",
			"completing-allows": "Ao completar a sua conta terá a possibilidade de ler livros offline nas nossas aplicações móveis e partilhar notas e destaques com amigos.",
			"error-updating-info": "There was an error updating your information.",
			"password-updated": "Password successfully updated",
			"security-updated": "Security question successfully updated",
			"info-updated": "User information successfully updated"
		},
		"resources": {
			"ancillaries": "Acessórios",
			"access-codes": "Códigos de acesso",
			"print-on-demand": "Imprimir a Pedido",
			"check-pod": "Veja as opções de impressão da editora para os seus livros.",
			"check-now": "Verificar Agora",
			"loading": "Aguarde, estamos a atualizar os seus recursos!",
			"in": "em",
			"access-code-intro": "Um código de acesso é uma palavra-passe utilizada para aceder ao conteúdo dos cursos online. Depois de apresentar um código para um item, não poderá devolvê-lo. Para mais instruções sobre como utilizar os seus códigos de acesso, visite o <a href='%{support_url}' target='_blank'>Suporte</a>.",
			"expires": "Data de expiração:",
			"expiration-message": "Contém instruções sobre como utilizar o seu código de acesso.",
			"copy-fail": "Não foi possível copiar. Selecione o código e copie-o manualmente.",
			"launch-site": "Iniciar site",
			"launch-book": "Iniciar livro",
			"reveal-code": "Mostrar Código",
			"no-resources": "Não tem nenhum recurso.",
			"no-access-codes": "Não tem nenhum código de acesso.",
			"no-ancillaries": "Nenhum acessório para este título",
			"name": "Nome",
			"type": "Tipo",
			"size": "Tamanho",
			"download-all": "Transferir tudo",
			"back": "Voltar para recursos"
		},
		"refunds": {
			"states": {
				"refunded": "Reembolsado",
				"unavailable": "Reembolso indisponível"
			},
			"reasons": {
				"dropped": "Desisti do curso",
				"wrong": "Este livro não é o correto para o meu curso",
				"print": "Optei por comprar a versão em papel",
				"missing": "O livro não contém tudo o que preciso para o meu curso (por ex. um CD, acesso à Web, vídeos)",
				"other": "Outro"
			},
			"bulk": {
				"policy": "Ao clicar no botão &quot;Reembolso total&quot; abaixo, estou a concordar com a política de reembolso da %{brand} <a href='%{policy_url}' target='_blank'></a>.",
				"complete": "Reembolso total",
				"view-details": "Ver detalhes do reembolso",
				"success": "O seu reembolso foi solicitado. Aguarde 48 horas para o processamento.",
				"failure": "Oops - algo correu mal!  Infelizmente, o seu reembolso não foi bem-sucedido.",
				"retry": "Tentar novamente",
				"support": "Contactar o suporte",
				"available-codes": "Códigos disponíveis",
				"codes-selected": "Códigos selecionados",
				"download": "Transferir códigos",
				"partially-refunded": "Parcialmente reembolsado",
				"pick-one": "Tem de selecionar pelo menos um código para proceder ao reembolso"
			},
			"refund": "Reembolso",
			"all": "Reembolsar todos?",
			"missing-reason": "Para continuar, tem de selecionar um motivo",
			"missing-elaboration": "Forneça mais detalhes",
			"policy": "Ao clicar no botão “Complete Refund Request” (Concluir pedido de reembolso), compreendo que se voltar a comprar este livro didático eletrónico %{brand}, não poderei pedir nenhum outro reembolso relativo ao mesmo livro didático eletrónico. Ver a política de reembolso integral.",
			"refunded": "Reembolsado",
			"sorry": "Lamentamos que não tenha ficado satisfeito com a sua compra.",
			"error": "Algo correu mal",
			"error-explain": "Não nos foi possível processar o seu reembolso. Tente novamente.",
			"why": "Pode dizer-nos porquê?",
			"no-refunds": "Não tem itens com reembolso.",
			"select-codes": "Selecionar código(s) a reembolsar:",
			"number": "Quantos?",
			"back": "Voltar para devoluções"
		},
		"purchases": {
			"back": "Voltar para compras"
		},
		"global-bar": {
			"account": "Definições da conta"
		}
	};

/***/ },
/* 996 */
/***/ function(module, exports) {

	module.exports = {
		"base": {
			"welcome": "Bine ai venit la Mulligans, %{name}!",
			"user": "Info utilizator",
			"devices": "Dispozitive",
			"refunds": "Rambursări",
			"resources": "Resurse",
			"transactions": "Comenzi & Retururi",
			"email": "Email",
			"password": "Parolă",
			"save": "Salvare",
			"sign-out": "Deconectare",
			"cancel": "Anulare",
			"close": "Închidere",
			"learn-more": "Află mai multe",
			"required": "Obligatoriu",
			"support": "Asistență",
			"bookshelf": "Bookshelf",
			"launch": "Lansare",
			"download": "Descărcare",
			"details": "Detalii",
			"cannot-be-blank": "%{field} nu poate fi gol.",
			"saving": "Se salvează...",
			"done": "Finalizat",
			"failed": "Nu a reușit",
			"copy": "Copiere"
		},
		"signin": {
			"login-failure": "E-mailul sau parola este greșită",
			"welcome-large": "Bine ai venit la  <span class='inner'>%{brand} Account Center</span>",
			"welcome-small": "<span class='inner'>Account Center</span>",
			"signin-button": "Conectare",
			"forgot-password": "Parolă uitată",
			"new-to-vst": "Îți este nou %{brand}?",
			"create-account": "Creează un cont",
			"signing-in": "Autentificare în curs...",
			"signin-failed": "Autentificare eșuată"
		},
		"transactions": {
			"price": "Preț",
			"excluded": "(Fără taxe)",
			"quantity": "Cantitate",
			"confirmation#": "# confirmare",
			"payment": "Plată",
			"purchased": "Achiziţionat(e)",
			"purchase-details": "Detalii achiziţie",
			"subtotal": "Sub",
			"total": "Total",
			"tax": "Impozit",
			"loading": "Se încarcă tranzacțiile tale...",
			"no-purchases": "Nu ai achiziții.",
			"seller-vat": "TVA comerciant",
			"total-vat": "%{vat} total achitat",
			"portion": "%{subTax} Taxă %{rate}%",
			"vat-disclosure": "Prețul include %{vat}",
			"purchases": "Achiziţii",
			"refunded-items": "Articole rambursate",
			"book-title": "Titlu carte",
			"refund-details": "Detalii rambursare",
			"print-receipt": "Tipărire chitanță",
			"request-refund": "Solicitare rambursare",
			"expired": "Expirat",
			"expires-in": "Expiră la %{date}",
			"details-refund": "Detalii și rambursare",
			"modal": {
				"cant-refund-title": "Rambursare nedisponibilă",
				"cant-refund": "Cartea nu poate fi rambursată din unul sau mai multe dintre următoarele motive.",
				"cant-refund-1": "S-a vizualizat prea mult din conținutul cărții.",
				"cant-refund-2": "A trecut mai mult de 14 zile de la data achiziției.",
				"cant-refund-3": "Codul tău de resurse online a fost afișat.",
				"cant-refund-4": "Cartea ta a fost rambursată anterior.",
				"cant-refund-5": "Toate codurile au fost revendicate și/sau rambursate deja.",
				"cant-refund-6": "Au trecut mai mult de 30 de zile de la data achiziției.",
				"cant-refund-support": "Dacă ai nedumeriri privind politica de rambursare %{brand}, contactează <a href='%{support_url}' target='_blank'>serviciul de asistență</a>."
			},
			"license": {
				"perpetual": "Accesul online nu expiră",
				"days": "Acces pentru %{days} zi"
			}
		},
		"devices": {
			"description": "%{brand} îţi permite să ai <span>%{desktop}</span> computere şi <span>%{mobile}</span> dispozitive mobile/tablete activate la orice moment.",
			"loading": "Salut, îți obținem dispozitivele :)",
			"no-active": "Nu ai dispozitive active.",
			"deactivate": "Dezactivare"
		},
		"user": {
			"personal-information": "Informaţii personale",
			"security-information": "Informații de securitate",
			"notifications": "Notificări",
			"first-name": "Prenume",
			"last-name": "Nume de familie",
			"change-password-title": "Modificare parolă",
			"current-password": "Parolă curentă",
			"new-password": "Parolă nouă",
			"security-password": "Parolă",
			"confirm-new-password": "Confirmare parolă nouă",
			"security-question": "Întrebare de securitate",
			"security-info-change": "Modificare",
			"question": "Întrebare",
			"answer": "Răspuns",
			"notifications-text": "Trimiteți-mi pe e-mail actualizări efectuate ocazional privind activitatea contului meu, actualizări ale produsului și oferte speciale.",
			"loading": "Spot caută informațiile tale de utilizator, durează puțin timp 🐶",
			"change-password-text": "Parola trebuie să conțină cel puțin 8 caractere, o literă mare, o literă mică și un caracter special.",
			"email-locked": "E-mail blocat",
			"email-locked-description": "Nu ai acces să modifici e-mailul tău.",
			"email-locked-more": "Contactează administratorul tău.",
			"security-question6": "Care este sportul tău preferat?",
			"security-question7": "Ce aromă de înghețată preferi?",
			"security-question8": "Care este animalul de casă preferat?",
			"security-question9": "Ce îți doreai să devii când erai mic?",
			"security-question10": "Cum se numea profesorul/ profesoara tău/ta preferat/ă?",
			"new-password-failure": "Parola nu îndeplinește cerințele",
			"confirm-password-failure": "Parola trebuie să corespundă",
			"new-password-tooltip": "Trebuie să conțină cel puțin 8 caractere, o literă mare, o literă mică și un caracter special.",
			"enter-valid-email": "Introdu o adresă de e-mail validă.",
			"password-cannot-be-same": "Parola nu poate fi aceeași precum cea anterioară.",
			"incorrect-password": "Parolă greșită",
			"complete-account": "Se pare că trebuie să <a href='%{href}'>finalizați contul dvs</a>.",
			"completing-allows": "După finalizarea contului puteți citi cărți offline pe aplicațiile noastre pentru dispozitive mobile și puteți partaja note și evidențieri cu prietenii.",
			"error-updating-info": "There was an error updating your information.",
			"password-updated": "Password successfully updated",
			"security-updated": "Security question successfully updated",
			"info-updated": "User information successfully updated"
		},
		"resources": {
			"ancillaries": "Auxiliare",
			"access-codes": "Coduri de acces",
			"print-on-demand": "Imprimare la cerere",
			"check-pod": "Verifică opţiunile de tipărire ale editurilor pentru cărţile tale.",
			"check-now": "Verificare acum",
			"loading": "Așteaptă, îți actualizăm resursele!",
			"in": "în",
			"access-code-intro": "Un cod de acces este o parolă pe care o utilizezi pentru a accesa conținut de curs online. După ce afișezi un cod pentru un articol, nu îl vei putea returna. Pentru instrucţiuni suplimentare privind utilizarea codurilor tale de acces, accesează <a href='%{support_url}' target='_blank'>secţiunea de asistenţă</a>.",
			"expires": "Expiră",
			"expiration-message": "Conține instrucțiuni privind utilizarea codurilor tale de acces.",
			"copy-fail": "Nu se poate copia. Selectează codul și copiază-l manual.",
			"launch-site": "Lansare site",
			"launch-book": "Lansare carte",
			"reveal-code": "Afişare cod",
			"no-resources": "Nu ai resurse.",
			"no-access-codes": "Nu ai coduri de acces.",
			"no-ancillaries": "Nu există elemente auxiliare pentru acest titlu",
			"name": "Nume",
			"type": "Tip",
			"size": "Dimensiune",
			"download-all": "Descărcare toate",
			"back": "Înapoi la resurse"
		},
		"refunds": {
			"states": {
				"refunded": "Rambursat",
				"unavailable": "Rambursare nedisponibilă"
			},
			"reasons": {
				"dropped": "Am renunțat la curs",
				"wrong": "Cartea era greșită pentru cursul meu",
				"print": "Am decis să achiziționez o versiune tipărită",
				"missing": "Cartea nu conține tot ce am nevoie pentru cursul meu (ex. un CD, acces online, videoclipuri)",
				"other": "Altele"
			},
			"bulk": {
				"policy": "Făcând clic pe butonul „Finalizare rambursare” de mai jos, sunt de acord cu politica %{brand} <a href='%{policy_url}' target='_blank'>privind rambursările</a>.",
				"complete": "Finalizare rambursare",
				"view-details": "Vizualizare detalii rambursare",
				"success": "Rambursarea ta a fost solicitată. Te rugăm să aștepți 48 de ore pentru a fi prelucrată.",
				"failure": "Hopa - a apărut o problemă! Din nefericire, rambursarea nu a fost procesată.",
				"retry": "Încearcă din nou",
				"support": "Contactați centrul de asistență",
				"available-codes": "Coduri disponibile",
				"codes-selected": "Coduri selectate",
				"download": "Descărcare coduri",
				"partially-refunded": "Rambursat(ă) parțial",
				"pick-one": "Trebuie să selectezi cel puțin un cod pentru a efectua o rambursare"
			},
			"refund": "Rambursare",
			"all": "Rambursare toate?",
			"missing-reason": "Trebuie să selectezi un motiv pentru a continua",
			"missing-elaboration": "Te rugăm să elaborezi",
			"policy": "Făcând clic pe butonul Complete Refund Request (Finalizare solicitare rambursare) de mai jos, înțeleg că dacă achiziționez din nou acest manual în format electronic de la %{brand}, nu voi putea solicita alte rambursări pentru același manual în format electronic. Vizualizează politica completă privind rambursările.",
			"refunded": "Rambursat",
			"sorry": "Ne pare rău că nu ai fost mulțumit de achiziție.",
			"error": "A apărut o problemă",
			"error-explain": "Nu putem procesa rambursarea ta. Încearcă din nou.",
			"why": "Ne poți spune de ce?",
			"no-refunds": "Nu ai articole rambursate.",
			"select-codes": "Selectează codul/codurile pentru rambursare:",
			"number": "Câte?",
			"back": "Înapoi la rambursări"
		},
		"purchases": {
			"back": "Înapoi la achiziții"
		},
		"global-bar": {
			"account": "Setări cont"
		}
	};

/***/ },
/* 997 */
/***/ function(module, exports) {

	module.exports = {
		"base": {
			"welcome": "%{name}, добро пожаловать в Mulligans!",
			"user": "Сведения о пользователе",
			"devices": "Устройства",
			"refunds": "Возмещенные средства",
			"resources": "Материалы",
			"transactions": "Заказы и возвраты",
			"email": "Электронная почта",
			"password": "Пароль",
			"save": "Сохранить",
			"sign-out": "Выйти",
			"cancel": "Отмена",
			"close": "Закрыть",
			"learn-more": "Подробнее",
			"required": "Обязательно",
			"support": "Поддержка",
			"bookshelf": "Книжная полка",
			"launch": "Запустить",
			"download": "Загрузить",
			"details": "Подробнее",
			"cannot-be-blank": "Поле %{field} не может быть пустым.",
			"saving": "Cохранение...",
			"done": "Готово",
			"failed": "Ошибка",
			"copy": "Копировать"
		},
		"signin": {
			"login-failure": "Неверный адрес эл. почты или пароль",
			"welcome-large": "Добро пожаловать в <span class='inner'>%{brand} Account Center</span>",
			"welcome-small": "<span class='inner'>Account Center</span>",
			"signin-button": "Вход",
			"forgot-password": "Забыли пароль",
			"new-to-vst": "Впервые пользуетесь %{brand}?",
			"create-account": "Создать учетную запись",
			"signing-in": "Вход в систему...",
			"signin-failed": "Не удалось войти в систему"
		},
		"transactions": {
			"price": "Цена",
			"excluded": "(Исключая налоги)",
			"quantity": "Количество",
			"confirmation#": "Подтверждение #",
			"payment": "Оплата",
			"purchased": "Покупки",
			"purchase-details": "Сведения о покупке",
			"subtotal": "Сумма без учета налогов",
			"total": "Итого",
			"tax": "Налог",
			"loading": "Ваши транзакции загружаются, сейчас все прояснится…",
			"no-purchases": "У вас нет покупок.",
			"seller-vat": "НДС с продажи",
			"total-vat": "Всего заплачено: %{vat}",
			"portion": "%{subTax} Налог %{rate}%",
			"vat-disclosure": "Цена с учетом %{vat}",
			"purchases": "Покупки",
			"refunded-items": "Товары, по котором осуществлен возврат средств",
			"book-title": "Наименование книги",
			"refund-details": "Сведения о возврате",
			"print-receipt": "Напечатать квитанцию",
			"request-refund": "Запросить возврат средств",
			"expired": "Срок действия истек",
			"expires-in": "Срок действия истекает %{date}",
			"details-refund": "Подробные сведения и возврат оплаты",
			"modal": {
				"cant-refund-title": "Возврат невозможен",
				"cant-refund": "Средства, уплаченные вами за эту книгу, невозможно возместить по следующим причинам.",
				"cant-refund-1": "Слишком большая часть книги уже просмотрена.",
				"cant-refund-2": "Прошло более 14 дней с момента покупки.",
				"cant-refund-3": "Запрошен и показан код доступа к онлайн-материалам.",
				"cant-refund-4": "Возврат за эту книгу уже выполнялся.",
				"cant-refund-5": "Все коды использованы/средства возвращены.",
				"cant-refund-6": "С момента покупки прошло более 30 дней.",
				"cant-refund-support": "Если у вас остались вопросы по поводу политики возврата средств %{brand}, обратитесь <a href='%{support_url}' target='_blank'>в службу поддержки</a>."
			},
			"license": {
				"perpetual": "Доступ к веб-данным является бессрочным",
				"days": "%{days}-дневный доступ"
			}
		},
		"devices": {
			"description": "%{brand} позволяет одновременно активировать не более <span>%{desktop}</span> компьютеров и <span>%{mobile}</span> смартфонов/планшетов.",
			"loading": "Получение информации о ваших устройствах…",
			"no-active": "У вас нет активных устройств.",
			"deactivate": "Деактивировать"
		},
		"user": {
			"personal-information": "Личные сведения",
			"security-information": "Сведения о безопасности",
			"notifications": "Уведомления",
			"first-name": "Имя",
			"last-name": "Фамилия",
			"change-password-title": "Изменить пароль",
			"current-password": "Текущий пароль",
			"new-password": "Новый пароль",
			"security-password": "Пароль",
			"confirm-new-password": "Подтвердить новый пароль",
			"security-question": "Секретный вопрос",
			"security-info-change": "Изменить",
			"question": "Вопрос",
			"answer": "Ответ",
			"notifications-text": "Прошу отправлять на мой адрес информацию о действиях в моей учетной записи, обновлениях продуктов и специальных предложениях.",
			"loading": "Spot получает ваши данные, подождите немного 🐶",
			"change-password-text": "Пароль должен содержать как минимум 8 символов, среди которых должны быть 1 строчная буква, 1 прописная буква и 1 специальный символ.",
			"email-locked": "Адрес электронной почты заблокирован",
			"email-locked-description": "У вас нет доступа для изменения электронного адреса.",
			"email-locked-more": "Обратитесь к своему администратору.",
			"security-question6": "Какой у вас любимый вид спорта?",
			"security-question7": "Ваше любимое мороженое?",
			"security-question8": "Как зовут вашего домашнего любимца?",
			"security-question9": "Кем вы хотели стать в детстве?",
			"security-question10": "Какая была фамилия у вашего любимого учителя?",
			"new-password-failure": "Пароль не соответствует требованиям",
			"confirm-password-failure": "Пароли должны совпадать",
			"new-password-tooltip": "Должен содержать не менее 8 символов, в том числе заглавную букву, строчную букву и специальный символ.",
			"enter-valid-email": "Введите действующий эл. адрес",
			"password-cannot-be-same": "Новый пароль не может совпадать со старым.",
			"incorrect-password": "Неверный пароль",
			"complete-account": "Кажется, вам нужно завершить <a href='%{href}'>создание учетной записи</a>",
			"completing-allows": "Завершив создание учетной записи, вы сможете читать книги в автономном режиме через мобильные приложения, а также делиться заметками и маркерами с друзьями.",
			"error-updating-info": "There was an error updating your information.",
			"password-updated": "Password successfully updated",
			"security-updated": "Security question successfully updated",
			"info-updated": "User information successfully updated"
		},
		"resources": {
			"ancillaries": "Дополнительные материалы",
			"access-codes": "Коды доступа",
			"print-on-demand": "Печать по запросу",
			"check-pod": "Просмотрите варианты полиграфической печати книг.",
			"check-now": "Проверить",
			"loading": "Подождите немного, ваши материалы обновляются.",
			"in": "в",
			"access-code-intro": "Код доступа — это пароль для доступа к содержимому веб-курса. После того как вы нажали кнопку «Показать код», возврат средств за этот элемент уже невозможен. Чтобы получить дополнительную информацию об использовании кодов доступа, обратитесь в <a href='%{support_url}' target='_blank'>службу поддержки</a>.",
			"expires": "Срок действия истекает",
			"expiration-message": "Содержит инструкции по использованию кода доступа.",
			"copy-fail": "Не удается скопировать. Выделите код и скопируйте его вручную.",
			"launch-site": "Запустить сайт",
			"launch-book": "Запустить книгу",
			"reveal-code": "Показать код",
			"no-resources": "У вас нет материалов.",
			"no-access-codes": "У вас нет кодов доступа.",
			"no-ancillaries": "К этой книге нет дополнительных материалов.",
			"name": "Имя",
			"type": "Тип",
			"size": "Размер",
			"download-all": "Загрузить все",
			"back": "Вернуться к ресурсам"
		},
		"refunds": {
			"states": {
				"refunded": "Средства возмещены",
				"unavailable": "Возврат невозможен"
			},
			"reasons": {
				"dropped": "Я больше не изучаю этот курс.",
				"wrong": "Эта книга не подходит для моего курса.",
				"print": "Я куплю печатную версию вместо электронной.",
				"missing": "В комплекте этой книги отсутствуют некоторые элементы для моего курса (например, компакт-диск, код доступа к веб-материалам, видео).",
				"other": "Другое"
			},
			"bulk": {
				"policy": "Нажав кнопку «Возвратить средства», я подтверждаю согласие с  <a href='%{policy_url}' target='_blank'>условиями %{brand}.</a>",
				"complete": "Возвратить средства",
				"view-details": "Просмотреть сведения о возврате средств",
				"success": "Запрос о возврате оплаты отправлен. Обработка запроса занимает до 48 часов.",
				"failure": "Ой! Что-то пошло не так. К сожалению, возвратить средства не удалось.",
				"retry": "Повторите попытку",
				"support": "Обратиться в службу поддержки",
				"available-codes": "Доступные коды",
				"codes-selected": "Выбранные коды",
				"download": "Загрузить коды",
				"partially-refunded": "Средства частично возвращены",
				"pick-one": "Для возврата средств выберите хотя бы один код"
			},
			"refund": "Возвратить средства",
			"all": "Возвратить все средства?",
			"missing-reason": "Выберите причину, чтобы продолжить",
			"missing-elaboration": "Укажите причину",
			"policy": "Нажимая кнопку «Отправить запрос возврата» внизу, я понимаю, что в случае повторной покупки этого электронного учебника на %{brand} я больше не смогу возместить потраченные на него средства. Показать полный текст политики возврата средств.",
			"refunded": "Средства возмещены",
			"sorry": "Очень жаль, что вы остались недовольны покупкой.",
			"error": "Что-то пошло не так",
			"error-explain": "Невозможно обработать запрос на возврат средств. Повторите попытку позже.",
			"why": "Можете рассказать, почему вы оформляете возврат?",
			"no-refunds": "У вас пока нет возвратов.",
			"select-codes": "Выберите коды для возврата средств:",
			"number": "Сколько?",
			"back": "Вернуться к возмещенным средствам"
		},
		"purchases": {
			"back": "Вернуться к покупкам"
		},
		"global-bar": {
			"account": "Настройки учетной записи"
		}
	};

/***/ },
/* 998 */
/***/ function(module, exports) {

	module.exports = {
		"base": {
			"welcome": "Välkommen till Mulligans, %{name}!",
			"user": "Användarinformation",
			"devices": "Enheter",
			"refunds": "Återbetalningar",
			"resources": "Resurser",
			"transactions": "Beställningar & Returer",
			"email": "E-post",
			"password": "Lösenord",
			"save": "Spara",
			"sign-out": "Logga ut",
			"cancel": "Avbryt",
			"close": "Stäng",
			"learn-more": "Läs mer",
			"required": "Krävs",
			"support": "Support",
			"bookshelf": "Bokhylla",
			"launch": "Starta",
			"download": "Hämta",
			"details": "Information",
			"cannot-be-blank": "%{field} får inte vara tomt.",
			"saving": "Sparar...",
			"done": "Klar",
			"failed": "Misslyckades",
			"copy": "Kopiera"
		},
		"signin": {
			"login-failure": "E-postadress eller lösenord är felaktigt",
			"welcome-large": "Välkommen till <span class='inner'>%{brand} Account Center</span>",
			"welcome-small": "<span class='inner'>Account Center</span>",
			"signin-button": "Logga in",
			"forgot-password": "Glömt ditt lösenord?",
			"new-to-vst": "Nyss upptäckt %{brand}?",
			"create-account": "Skapa ett konto",
			"signing-in": "Loggar in ...",
			"signin-failed": "Inloggning misslyckades"
		},
		"transactions": {
			"price": "Pris",
			"excluded": "(Exklusive skatt)",
			"quantity": "Kvantitet",
			"confirmation#": "Bekräftelsenummer",
			"payment": "Betalning",
			"purchased": "Inköpt",
			"purchase-details": "Inköpsinformation",
			"subtotal": "Delsumma",
			"total": "Totalt",
			"tax": "Skatt",
			"loading": "Hallå där, vi läser in dina transaktioner ...",
			"no-purchases": "Du har inga inköp.",
			"seller-vat": "Säljarmoms",
			"total-vat": "Totalt %{vat} betalt",
			"portion": "%{subTax} Skatt %{rate}%",
			"vat-disclosure": "Priset inkluderar %{vat}",
			"purchases": "Inköp",
			"refunded-items": "Återbetalning för artiklar",
			"book-title": "Boktitel",
			"refund-details": "Återbetalningsuppgifter",
			"print-receipt": "Skriv ut kvitto",
			"request-refund": "Begär återbetalning",
			"expired": "Har upphört att gälla",
			"expires-in": "Utgår %{date}",
			"details-refund": "Detaljer och återbetalning",
			"modal": {
				"cant-refund-title": "Återbetalning görs ej",
				"cant-refund": "Din bok medger ej återbetalning på grund av ett eller fler av följande skäl.",
				"cant-refund-1": "För mycket av innehållet i din bok har visats.",
				"cant-refund-2": "Det har gått mer än 14 dagar sedan inköpsdatum.",
				"cant-refund-3": "Dina onlineresurskod har visats.",
				"cant-refund-4": "Din bok har tidigare återbetalats.",
				"cant-refund-5": "Alla koder har redan lösts in och/eller återbetalats.",
				"cant-refund-6": "Det har gått mer än 30 dagar sedan inköpsdatum.",
				"cant-refund-support": "Om du fortfarande är osäker på återbetalningspolicyn för %{brand}, kan du kontakta <a href='%{support_url}' target='_blank'>support</a>."
			},
			"license": {
				"perpetual": "Onlineåtkomst utgår ej",
				"days": "%{days} dagars åtkomst"
			}
		},
		"devices": {
			"description": "%{brand} låter dig ha <span>%{desktop}-</span> datorer och <span>%{mobile}</span> mobila enheter som aktiveras när som helst.",
			"loading": "Hej, vi kan se dina enheter:)",
			"no-active": "Du har inga aktiva enheter.",
			"deactivate": "Inaktivera"
		},
		"user": {
			"personal-information": "Personuppgifter",
			"security-information": "Säkerhetsinformation",
			"notifications": "Aviseringar",
			"first-name": "Förnamn",
			"last-name": "Efternamn",
			"change-password-title": "Byt lösenord",
			"current-password": "Aktuellt lösenord",
			"new-password": "Nytt lösenord",
			"security-password": "Lösenord",
			"confirm-new-password": "Bekräfta nytt lösenord",
			"security-question": "Säkerhetsfråga:",
			"security-info-change": "Ändra",
			"question": "Fråga",
			"answer": "Svar",
			"notifications-text": "E-posta mig sporadiska uppdateringar om min kontoaktivitet, produktuppdateringar och specialerbjudanden.",
			"loading": "Spot tar reda på dina användaruppgifter, så dröj en sekund 🐶",
			"change-password-text": "Lösenordet måste ha en längd på minst åtta tecken och innehålla minst en stor bokstav, en liten bokstav och ett specialtecken.",
			"email-locked": "E-post låst",
			"email-locked-description": "Du har inte tillgång så att du kan ändra din e-postadress.",
			"email-locked-more": "Vänligen kontakta din administratör.",
			"security-question6": "Vilken är din favoritsport?",
			"security-question7": "Vilken är din favoritsmak för glass?",
			"security-question8": "Vad heter ditt favorithusdjur?",
			"security-question9": "Vad ville du bli när du blev stor, när du var liten?",
			"security-question10": "Vilket efternamn hade din favoritlärare?",
			"new-password-failure": "Lösenordet uppfyller inte kraven",
			"confirm-password-failure": "Lösenorden måste vara lika",
			"new-password-tooltip": "Måste ha en längd på minst åtta tecken och innehålla minst en stor bokstav, en liten bokstav och ett specialtecken.",
			"enter-valid-email": "Ange en giltig e-postadress.",
			"password-cannot-be-same": "Lösenordet får inte vara samma som tidigare lösenord",
			"incorrect-password": "Ogiltigt lösenord",
			"complete-account": "Det ser ut som om du behöver <a href='%{href}'>färdigställa ditt konto</a>.",
			"completing-allows": "När du har färdigställt ditt konto kan du läsa böcker offline på våra mobila appar och dela anteckningar och markeringar med vänner.",
			"error-updating-info": "There was an error updating your information.",
			"password-updated": "Password successfully updated",
			"security-updated": "Security question successfully updated",
			"info-updated": "User information successfully updated"
		},
		"resources": {
			"ancillaries": "tillbehör",
			"access-codes": "Åtkomstkoder",
			"print-on-demand": "Skriv ut på begäran",
			"check-pod": "Kontrollera utgivarens utskriftsalternativ för dina böcker.",
			"check-now": "Kontrollera nu",
			"loading": "Häng kvar medan vi uppdaterar dina resurser!",
			"in": "i",
			"access-code-intro": "En åtkomstkod är ett lösenord som du använder för att komma åt kursinnehåll online. När du har visat en kod för ett objekt, kommer du inte att kunna lämna tillbaka den. För ytterligare information om hur du använder dina åtkomstkoder, kan du besöka <a href='%{support_url}' target='_blank'>support</a>.",
			"expires": "Utgår",
			"expiration-message": "Innehåller instruktioner om hur du använder din åtkomstkod.",
			"copy-fail": "Det går inte att kopiera. Markera koden och kopiera den manuellt.",
			"launch-site": "Starta webbplats",
			"launch-book": "Starta bok",
			"reveal-code": "Visa kod",
			"no-resources": "Du har inga resurser.",
			"no-access-codes": "Du har inga åtkomstkoder.",
			"no-ancillaries": "Ingen hjälputrustning för denna titel",
			"name": "Namn",
			"type": "Typ",
			"size": "Storlek",
			"download-all": "Ladda ner allt",
			"back": "Tillbaka till resurser"
		},
		"refunds": {
			"states": {
				"refunded": "Återbetald",
				"unavailable": "Återbetalning görs ej"
			},
			"reasons": {
				"dropped": "Jag avslutade kursen",
				"wrong": "Detta var fel bok för min kurs",
				"print": "Jag bestämde mig för att köpa ett tryckt exemplar i stället",
				"missing": "Boken innehåller inte allt jag behöver för min kurs (t.ex. en CD, webbåtkomst, videoklipp)",
				"other": "Övrigt"
			},
			"bulk": {
				"policy": "Genom att klicka på knappen &quot;fullständig återbetalning&quot; nedan, samtycker jag till %{brand}s <a href='%{policy_url}' target='_blank'>återbetalningspolicy </a>.",
				"complete": "Fullständig återbetalning",
				"view-details": "Visa återbetalningsuppgifter",
				"success": "Din återbetalning har begärts. Vänta i 48 timmar på att den behandlas.",
				"failure": "Hoppsan! Något gick fel! Tyvärr gick din återbetalning inte igenom.",
				"retry": "Försök igen",
				"support": "Kontakta support",
				"available-codes": "Tillgängliga koder",
				"codes-selected": "Valda koder",
				"download": "Ladda ner koder",
				"partially-refunded": "Delvis återbetalad",
				"pick-one": "Du måste välja minst en kod för att göra en återbetalning"
			},
			"refund": "Återbetalning",
			"all": "Återbetala alla?",
			"missing-reason": "Du måste välja en orsak för att fortsätta",
			"missing-elaboration": "Förklara närmare",
			"policy": "Genom att klicka på knappen \"Slutför återbetalningsbegäran\" nedan, är jag införstådd med att om jag köper denna e-textbok från %{brand} på nytt, kan jag inte begära ytterligare återbetalningar för samma e-textbok. Visa fullständig returpolicy.",
			"refunded": "Åtebetald",
			"sorry": "Vi beklagar att du inte var nöjd med ditt köp.",
			"error": "Något gick fel",
			"error-explain": "Vi kunde inte bearbeta din återbetalning. Försök igen.",
			"why": "Vill du berätta varför?",
			"no-refunds": "Du har inga artiklar för återbetalning.",
			"select-codes": "Välj kod(er) att återbetala:",
			"number": "Hur många?",
			"back": "Tillbaka till återbetalningar"
		},
		"purchases": {
			"back": "Tillbaka till inköp"
		},
		"global-bar": {
			"account": "Kontoinställningar"
		}
	};

/***/ },
/* 999 */
/***/ function(module, exports) {

	module.exports = {
		"base": {
			"welcome": "ยินดีต้อนรับสู่ Mulligans, %{name}!",
			"user": "ข้อมูลผู้ใช้",
			"devices": "เครื่อง",
			"refunds": "การขอเงินคืน",
			"resources": "ข้อมูล",
			"transactions": "คำสั่งซื้อและการคืนสินค้า",
			"email": "อีเมล",
			"password": "รหัสผ่าน",
			"save": "บันทึก",
			"sign-out": "ลงชื่อออก",
			"cancel": "ยกเลิก",
			"close": "ปิด",
			"learn-more": "เรียนรู้เพิ่มเติม",
			"required": "จำเป็น",
			"support": "การสนับสนุน",
			"bookshelf": "Bookshelf",
			"launch": "เปิดใช้",
			"download": "ดาวน์โหลด",
			"details": "รายละเอียด",
			"cannot-be-blank": "%{field} ไม่สามารถเว้นว่างได้",
			"saving": "กำลังบันทึก...",
			"done": "เสร็จสิ้น",
			"failed": "ล้มเหลว",
			"copy": "คัดลอก"
		},
		"signin": {
			"login-failure": "อีเมลหรือรหัสผ่านไม่ถูกต้อง",
			"welcome-large": "ยินดีต้อนรับสู่ <span class='inner'>ศูนย์ดูแลบัญชี %{brand}</span>",
			"welcome-small": "<span class='inner'>ศูนย์ดูแลบัญชี</span>",
			"signin-button": "ลงชื่อเข้าใช้",
			"forgot-password": "ลืมรหัสผ่าน",
			"new-to-vst": "เพิ่งเริ่มใช้ %{brand} ใช่ไหม",
			"create-account": "สร้างบัญชี",
			"signing-in": "กำลังลงชื่อเข้าใช้...",
			"signin-failed": "การลงชื่อเข้าใช้ล้มเหลว"
		},
		"transactions": {
			"price": "ราคา",
			"excluded": "(ไม่รวมภาษี)",
			"quantity": "จำนวน",
			"confirmation#": "หมายเลขการยืนยัน",
			"payment": "การชำระเงิน",
			"purchased": "รายการที่ซื้อแล้ว",
			"purchase-details": "รายละเอียดการซื้อ",
			"subtotal": "ยอดรวมย่อย",
			"total": "ยอดรวม",
			"tax": "ภาษี",
			"loading": "นี่ นักจ่ายมือเติบ เรากำลังโหลดธุรกรรมของคุณ...",
			"no-purchases": "คุณไม่มีรายการซื้อ",
			"seller-vat": "ภาษีมูลค่าเพิ่มสำหรับผู้ขาย",
			"total-vat": "ยอดรวมภาษีมูลค่าเพิ่มที่ชำระแล้ว %{vat}",
			"portion": "%{subTax} ภาษี %{rate}%",
			"vat-disclosure": "ราคารวมภาษีมูลค่าเพิ่ม %{vat}",
			"purchases": "รายการซื้อ",
			"refunded-items": "รายการที่ขอเงินคืน",
			"book-title": "ชื่อหนังสือ",
			"refund-details": "รายละเอียดการคืนเงิน",
			"print-receipt": "พิมพ์ใบเสร็จรับเงิน",
			"request-refund": "คำขอเงินคืน",
			"expired": "หมดอายุแล้ว",
			"expires-in": "หมดอายุ %{date}",
			"details-refund": "รายละเอียดและการคืนเงิน",
			"modal": {
				"cant-refund-title": "ไม่สามารถขอเงินคืนได้",
				"cant-refund": "ไม่สามารถขอเงินคืนค่าหนังสือของคุณได้เนื่องจากเหตุผลตั้งแต่หนึ่งข้อขึ้นไปดังต่อไปนี้",
				"cant-refund-1": "มีการดูหนังสือของคุณมากเกินไป",
				"cant-refund-2": "ผ่านมาแล้วเกิน 14 วันหลังจากวันที่ซื้อ",
				"cant-refund-3": "รหัสข้อมูลออนไลน์ของคุณถูกเปิดเผยแล้ว",
				"cant-refund-4": "หนังสือของคุณมีการขอเงินคืนก่อนหน้านี้แล้ว",
				"cant-refund-5": "รหัสทั้งหมดได้รับการลงทะเบียนใช้สิทธิและ/หรือคืนเงินแล้ว",
				"cant-refund-6": "ผ่านมาแล้วเกิน 30 วันหลังจากวันที่ซื้อ",
				"cant-refund-support": "หากคุณยังไม่แน่ใจเกี่ยวกับนโยบายการคืนเงินของ %{brand} โปรดติดต่อ <a href='%{support_url}' target='_blank'>ฝ่ายสนับสนุน</a>"
			},
			"license": {
				"perpetual": "การเข้าถึงทางออนไลน์ไม่มีการหมดอายุ",
				"days": "สิทธิ์เข้าถึง %{days} วัน"
			}
		},
		"devices": {
			"description": "%{brand} ช่วยให้คุณสามารถเปิดใช้งานคอมพิวเตอร์ <span>%{desktop}</span> และอุปกรณ์เคลื่อนที่/แท็บเล็ต <span>%{mobile}</span> ได้ทุกเมื่อตามเวลาที่กำหนด",
			"loading": "เฮย์ เรากำลังรับอุปกรณ์ของคุณ",
			"no-active": "คุณไม่มีอุปกรณ์ที่ใช้งาน",
			"deactivate": "ปิดใช้งาน"
		},
		"user": {
			"personal-information": "ข้อมูลส่วนตัว",
			"security-information": "ข้อมูลความปลอดภัย",
			"notifications": "การแจ้งเตือน",
			"first-name": "ชื่อ",
			"last-name": "นามสกุล",
			"change-password-title": "เปลี่ยนรหัสผ่าน",
			"current-password": "รหัสผ่านปัจจุบัน",
			"new-password": "รหัสผ่านใหม่",
			"security-password": "รหัสผ่าน",
			"confirm-new-password": "ยืนยันรหัสผ่านใหม่",
			"security-question": "คำถามรักษาความปลอดภัย",
			"security-info-change": "เปลี่ยน",
			"question": "คำถาม",
			"answer": "คำตอบ",
			"notifications-text": "ส่งอีเมลอัพเดทเกี่ยวกับกิจกรรมบัญชีของฉัน ผลิตภัณฑ์ใหม่ และข้อเสนอพิเศษถึงฉัน",
			"loading": "Spot กำลังออกไปดึงข้อมูลผู้ใช้ของคุณ รอแป๊บนะ 🐶",
			"change-password-text": "รหัสผ่านต้องมีความยาวอย่างน้อย 8 อักขระ มีตัวพิมพ์ใหญ่ ตัวพิมพ์เล็ก และอักขระพิเศษ",
			"email-locked": "อีเมลถูกล็อก",
			"email-locked-description": "คุณไม่ได้รับอนุญาตในการเข้าถึงเพื่อเปลี่ยนแปลงอีเมลของคุณ",
			"email-locked-more": "กรุณาติดต่อผู้ดูแลระบบของคุณ",
			"security-question6": "กีฬาโปรดของคุณคืออะไร",
			"security-question7": "ไอศครีมรสโปรดของคุณคืออะไร",
			"security-question8": "ชื่อของสัตว์เลี้ยงตัวโปรดของคุณคืออะไร",
			"security-question9": "ตอนคุณเป็นเด็ก คุณอยากเป็นอะไรเมื่อโตขึ้น",
			"security-question10": "นามสกุลของคุณครูคนโปรดของคุณคืออะไร",
			"new-password-failure": "รหัสผ่านไม่ตรงตามข้อกำหนด",
			"confirm-password-failure": "รหัสผ่านต้องตรงกัน",
			"new-password-tooltip": "ต้องมีความยาวอย่างน้อย 8 อักขระ มีตัวพิมพ์ใหญ่ ตัวพิมพ์เล็ก และอักขระพิเศษ",
			"enter-valid-email": "โปรดป้อนอีเมลที่ถูกต้อง",
			"password-cannot-be-same": "รหัสผ่านต้องไม่เหมือนกับรหัสผ่านเดิม",
			"incorrect-password": "รหัสผ่านไม่ถูกต้อง",
			"complete-account": "ดูเหมือนว่าคุณจะต้อง <a href='%{href}'>ดำเนินการบัญชีของคุณให้เสร็จสิ้น</a>",
			"completing-allows": "การดำเนินการบัญชีของคุณให้เสร็จสิ้นช่วยให้คุณสามารถอ่านหนังสือแบบออฟไลน์ได้ในแอปบนมือถือของเรา รวมถึงแชร์บันทึกและข้อความเน้นกับเพื่อนๆ",
			"error-updating-info": "There was an error updating your information.",
			"password-updated": "Password successfully updated",
			"security-updated": "Security question successfully updated",
			"info-updated": "User information successfully updated"
		},
		"resources": {
			"ancillaries": "อุปกรณ์ประกอบ",
			"access-codes": "รหัสเข้าถึง",
			"print-on-demand": "พิมพ์ตามต้องการ",
			"check-pod": "ตรวจสอบตัวเลือกการพิมพ์ของผู้จัดพิมพ์หนังสือของคุณ",
			"check-now": "ตรวจสอบเดี๋ยวนี้",
			"loading": "รอก่อนนะ เรากำลังอัปเดตทรัพยากรของคุณ!",
			"in": "ใน",
			"access-code-intro": "รหัสเข้าถึงคือรหัสผ่านที่คุณใช้เข้าถึงเนื้อหาหลักสูตรออนไลน์ เมื่อคุณเปิดเผยรหัสสำหรับสินค้า คุณจะไม่สามารถคืนสินค้านั้นได้ สำหรับคำแนะนำเพิ่มเติมเกี่ยวกับการใช้รหัสเข้าถึงของคุณ โปรดไปที่ <a href='%{support_url}' target='_blank'>ฝ่ายสนับสนุน</a>",
			"expires": "หมดอายุ",
			"expiration-message": "จะมีคำแนะนำสำหรับการใช้รหัสเข้าถึงของคุณ",
			"copy-fail": "ไม่สามารถคัดลอกได้ โปรดเลือกรหัสแล้วคัดลอกด้วยตนเอง",
			"launch-site": "เปิดใช้งานไซต์",
			"launch-book": "เปิดใช้หนังสือ",
			"reveal-code": "เปิดรหัส",
			"no-resources": "คุณไม่มีทรัพยากร",
			"no-access-codes": "คุณไม่มีรหัสเข้าถึง",
			"no-ancillaries": "ไม่มีอุปกรณ์ประกอบสำหรับชื่อเรื่องนี้",
			"name": "ชื่อ",
			"type": "ประเภท",
			"size": "ขนาด",
			"download-all": "ดาวน์โหลดทั้งหมด",
			"back": "กลับไปยังแหล่งที่มา"
		},
		"refunds": {
			"states": {
				"refunded": "คืนเงินแล้ว",
				"unavailable": "ไม่สามารถขอคืนเงินได้"
			},
			"reasons": {
				"dropped": "ฉันเลิกเรียนหลักสูตรแล้ว",
				"wrong": "นี่ไม่ใช่หนังสือสำหรับหลักสูตรของฉัน",
				"print": "ฉันตัดสินใจซื้อหนังสือที่พิมพ์เป็นเล่มแทน",
				"missing": "หนังสือไม่ได้มีทุกอย่างที่ฉันต้องการสำหรับหลักสูตรของฉัน (เช่น CD การเข้าถึงเว็บ วิดีโอ)",
				"other": "อื่นๆ"
			},
			"bulk": {
				"policy": "ด้วยการคลิกที่ปุ่ม &quot;การขอเงินคืนเสร็จสมบูรณ์&quot; ด้านล่าง ฉันยอมรับ %{brand} สำหรับ <a href='%{policy_url}' target='_blank'>นโยบายการคืนเงิน</a>",
				"complete": "การขอเงินคืนเสร็จสมบูรณ์",
				"view-details": "ดูรายละเอียดการขอเงินคืน",
				"success": "ส่งคำขอการขอคืนเงินของคุณแล้ว โปรดรอ 48 ชั่วโมงสำหรับการดำเนินการ",
				"failure": "อุ๊บส์ มีบางอย่างผิดปกติ! ทำให้ขอเงินคืนไม่สำเร็จ",
				"retry": "ลองอีกครั้ง",
				"support": "ติดต่อฝ่ายสนับสนุน",
				"available-codes": "รหัสที่ใช้ได้",
				"codes-selected": "รหัสที่เลือก",
				"download": "ดาวน์โหลดรหัส",
				"partially-refunded": "คืนเงินบางส่วนแล้ว",
				"pick-one": "คุณต้องเลือกอย่างน้อยหนึ่งรหัสเพื่อดำเนินการขอเงินคืน"
			},
			"refund": "การขอเงินคืน",
			"all": "ขอเงินคืนทั้งหมดใช่หรือไม่",
			"missing-reason": "คุณต้องเลือกเหตุผลเพื่อดำเนินการต่อ",
			"missing-elaboration": "โปรดอธิบายโดยละเอียด",
			"policy": "ด้วยการคลิกที่ปุ่ม “คำขอเงินคืนเสร็จสมบูรณ์” ด้านล่าง ฉันเข้าใจว่าหากฉันซื้อeTextbook %{brand} อีกครั้ง ฉันจะไม่ได้รับสิทธิ์ในการขอเงินคืนเพิ่มเติมใดๆ อีกต่อไป สำหรับ eTextbook เล่มเดียวกัน ดูนโยบายการขอคืนเงินฉบับสมบูรณ์",
			"refunded": "คืนเงินแล้ว",
			"sorry": "เราเสียใจที่คุณไม่พอใจกับรายการซื้อของคุณ",
			"error": "มีบางอย่างผิดปกติ",
			"error-explain": "เราไม่สามารถดำเนินการคืนเงินของคุณได้ โปรดลองอีกครั้ง",
			"why": "ช่วยบอกเราหน่อยว่าเพราะอะไร",
			"no-refunds": "คุณไม่มีสินค้าที่ขอคืนเงิน",
			"select-codes": "เลือกรหัสเพื่อขอเงินคืน:",
			"number": "เท่าไหร่",
			"back": "กลับไปยังการคืนเงิน"
		},
		"purchases": {
			"back": "กลับไปยังการซื้อ"
		},
		"global-bar": {
			"account": "การตั้งค่าบัญชี"
		}
	};

/***/ },
/* 1000 */
/***/ function(module, exports) {

	module.exports = {
		"base": {
			"welcome": "Mulligans'a hoş geldin, %{name}!",
			"user": "Kullanıcı Bilgisi",
			"devices": "Cihazlar",
			"refunds": "İadeler",
			"resources": "Kaynaklar",
			"transactions": "Siparişler ve İadeler",
			"email": "E-posta",
			"password": "Parola",
			"save": "Kaydet",
			"sign-out": "Oturumu Kapat",
			"cancel": "İptal",
			"close": "Kapat",
			"learn-more": "Daha fazla bilgi al",
			"required": "Gerekli",
			"support": "Destek",
			"bookshelf": "Bookshelf",
			"launch": "Başlat",
			"download": "İndir",
			"details": "Ayrıntılar",
			"cannot-be-blank": "%{field} boş bırakılamaz.",
			"saving": "Kaydediliyor...",
			"done": "Bitti",
			"failed": "Başarısız",
			"copy": "Kopyala"
		},
		"signin": {
			"login-failure": "E-postanız veya parolanız yanlış",
			"welcome-large": "%{brand} Hesap Merkezine <span class='inner'>hoş geldiniz</span>",
			"welcome-small": "<span class='inner'>Hesap Merkezi</span>",
			"signin-button": "Oturum Aç",
			"forgot-password": "Parolanızı mı Unuttunuz",
			"new-to-vst": "%{brand}'de yeni misiniz?",
			"create-account": "Bir Hesap Oluştur",
			"signing-in": "Giriş yapılıyor...",
			"signin-failed": "Giriş başarısız"
		},
		"transactions": {
			"price": "Ücret",
			"excluded": "(Vergi hariç)",
			"quantity": "Miktar",
			"confirmation#": "Teyit no",
			"payment": "Ödeme",
			"purchased": "Satın alınan",
			"purchase-details": "Satın Alma Detayları",
			"subtotal": "Ara Toplam",
			"total": "Toplam",
			"tax": "Vergi",
			"loading": "Selam çok para harcayan, hareketlerini yüklüyoruz...",
			"no-purchases": "Hiç satın alman yok.",
			"seller-vat": "Satıcı KDV'si",
			"total-vat": "Ödenen %{vat} Toplam",
			"portion": "%{subTax} Vergi %{rate}%",
			"vat-disclosure": "Fiyata %{vat} dahildir",
			"purchases": "Alımlar",
			"refunded-items": "Parası İade Edilen Kalemler",
			"book-title": "Kitap İsmi",
			"refund-details": "İade Detayları",
			"print-receipt": "Makbuzu Yazdır",
			"request-refund": "Para İadesi İste",
			"expired": "Sona Erdi",
			"expires-in": "Bitiş tarihi %{date}",
			"details-refund": "Ayrıntılar ve Para İadesi",
			"modal": {
				"cant-refund-title": "İade Mevcut Değil",
				"cant-refund": "Kitabınız aşağıdaki nedenlerden biri veya daha fazlası nedeniyle iade edilemez.",
				"cant-refund-1": "Kitabınızın çoğu görüntülenmiş.",
				"cant-refund-2": "Satın alma tarihinin üzerinden 14 günden fazla zaman geçmiş.",
				"cant-refund-3": "Çevrimiçi kaynak kodunuz ifşa olmuş.",
				"cant-refund-4": "Kitabınız önceden iade edilmiş.",
				"cant-refund-5": "Tüm kodlar parası ödenerek alındı ve/veya iade edildi.",
				"cant-refund-6": "Satın alma tarihinin üzerinden 30 günden fazla zaman geçmiş.",
				"cant-refund-support": "Hala %{brand}''nin iade politikasından emin değilseniz, <a href='%{support_url}' target='_blank'>destek ile</a>iletişime geçin."
			},
			"license": {
				"perpetual": "Çevrimiçi erişimin süresi geçmez",
				"days": "%{days} Gün Erişim"
			}
		},
		"devices": {
			"description": "%{brand} sizin <span>%{desktop} bilgisayarlarda</span> ve <span>%{mobile} mobil/tablet cihazlarda</span> her zaman etkinleştirmenize olanak sağlar.",
			"loading": "Hey, cihazlarını alıyoruz :)",
			"no-active": "Aktif cihazın yok.",
			"deactivate": "Devre dışı bırak"
		},
		"user": {
			"personal-information": "Kişisel Bilgiler",
			"security-information": "Güvenlik Bilgileri",
			"notifications": "Bildirimler",
			"first-name": "Ad",
			"last-name": "Soyadi",
			"change-password-title": "Şifre Değiştir",
			"current-password": "Şu Anki Şifre",
			"new-password": "Yeni Şifre",
			"security-password": "Parola",
			"confirm-new-password": "Yeni Şifreyi Onayla",
			"security-question": "Güvenlik Sorusu",
			"security-info-change": "Değişim",
			"question": "Soru",
			"answer": "Yanıt",
			"notifications-text": "Bana ara sıra hesap aktivitem, ürün güncellemeleri ve özel teklifler hakkında e-posta yolla.",
			"loading": "Spot kullanıcı bilgilerinizi alıyor, bir saniye 🐶",
			"change-password-text": "Parola en az 8 karakterden, bir büyük harften, bir küçük harften ve spesifik bir karakterden oluşmalıdır.",
			"email-locked": "E-posta Kilitli",
			"email-locked-description": "E-posta adresini değiştirme iznin yok.",
			"email-locked-more": "Lütfen sistem yöneticinle temasa geç.",
			"security-question6": "En sevdiğin spor nedir?",
			"security-question7": "En sevdiğin dondurma hangisidir?",
			"security-question8": "En sevdiğin evcil hayvanın adı nedir?",
			"security-question9": "Küçükken büyüyünce ne olmak isterdin?",
			"security-question10": "En sevdiğin öğretmeninin soyadı neydi?",
			"new-password-failure": "Parola gereklilikleri karşılamıyor",
			"confirm-password-failure": "Parolalar eşleşmiyor",
			"new-password-tooltip": "Parolan en az 8 karakter olmalı, büyük harf, küçük harf ve özel karakter içermelidir.",
			"enter-valid-email": "Lütfen geçerli bir e-posta girin.",
			"password-cannot-be-same": "Parola öncekiyle aynı olamaz",
			"incorrect-password": "Hatalı Parola",
			"complete-account": "Görünüşe göre <a href='%{href}'>hesabınızı tamamlamanız</a> gerekiyor.",
			"completing-allows": "Hesabınızı tamamlamanız, mobil uygulamalarımızdan kitapları çevrimdışı okumanızı ve arkadaşlarla notları ve vurgulamaları paylaşmanızı sağlar.",
			"error-updating-info": "There was an error updating your information.",
			"password-updated": "Password successfully updated",
			"security-updated": "Security question successfully updated",
			"info-updated": "User information successfully updated"
		},
		"resources": {
			"ancillaries": "Yardımcılar",
			"access-codes": "Erişim Kodları",
			"print-on-demand": "İstendiği Anda Yazdırma",
			"check-pod": "Kitapların için yayıncı yazdırma seçeneklerine bak.",
			"check-now": "Şimdi kontrol et",
			"loading": "Sıkı tutunun, kaynaklarınızı güncelliyoruz!",
			"in": "içinde",
			"access-code-intro": "Erişim kodu erişim kursu içeriğine çevrimiçi erişmek için kullandığınız paroladır. Bir madde için kodu kullanırsanız, bunu geri alamazsınız. Erişim kodlarını nasıl kullanacağınız hakkında daha fazla talimat için Destek bölümünü <a href='%{support_url}' target='_blank'>ziyaret edin</a>.",
			"expires": "Sona Erme Tarihi",
			"expiration-message": "Erişim kodunuzu kullanmanız için talimatlar içerir.",
			"copy-fail": "Kopyalama başarısız. Lütfen kodu seçin ve manüel olarak kopyalayın.",
			"launch-site": "Başlatma Merkezi",
			"launch-book": "Kitabı Başlat",
			"reveal-code": "Kodu Ver",
			"no-resources": "Herhangi bir kaynağa sahip değilsiniz.",
			"no-access-codes": "Herhangi bir erişim koduna sahip değilsiniz.",
			"no-ancillaries": "Bu başlık için yardımcı yok",
			"name": "Ad",
			"type": "Tür",
			"size": "Boyut",
			"download-all": "Tümünü İndir",
			"back": "Kaynaklara geri git"
		},
		"refunds": {
			"states": {
				"refunded": "İade edilmiş",
				"unavailable": "İade Mevcut Değil"
			},
			"reasons": {
				"dropped": "Kursu bıraktım",
				"wrong": "Bu kursum için doğru kitap değildi",
				"print": "Bunun yerine yazılı baskısını almaya karar verdim",
				"missing": "Kitap kursum için ihtiyacım olan her şeyi içermiyor (örn, bir CD, internet erişimi, videolar)",
				"other": "Diğer"
			},
			"bulk": {
				"policy": "Aşağıdaki &quot;İadeyi Tamamla&quot; butonuna tıklayarak, %{brand}'nın <a href='%{policy_url}' target='_blank'>iade politikasını kabul ettiğimi onaylıyorum</a>.",
				"complete": "İadeyi Tamamla",
				"view-details": "İade Detaylarını Görüntüle",
				"success": "Para iadesi talebiniz gönderildi. Lütfen işlenmesi için 48 saat bekleyin.",
				"failure": "Hey - bir şeyler ters gitti! Malesef iadeniz işleme alınmadı.",
				"retry": "Yeniden Deneyin",
				"support": "Destek Ekibiyle Görüş",
				"available-codes": "Uygun Kodlar",
				"codes-selected": "Seçilen Kodlar",
				"download": "Kodları İndir",
				"partially-refunded": "Kısmen İade Edilen",
				"pick-one": "Bir iade yapmak için en az bir kod seçmeniz gerekmektedir."
			},
			"refund": "İade",
			"all": "Tümü İade Edilsin Mi?",
			"missing-reason": "Devam etmek için bir neden seçmelisiniz",
			"missing-elaboration": "Lütfen detaylandırın",
			"policy": "Aşağıdaki “İade Talebini Tamamla” düşmesine basarak, bu %{brand} eTextbook'u tekrar satın alırsam, aynı eTextbook için daha sonra iade talebi için hak sahibi olmayacağımı anlarım. Tam iade politikasını görüntüle.",
			"refunded": "İade edildi",
			"sorry": "Satın alımdan memnun kalmadığınız için üzgünüz.",
			"error": "Bir şeyler ters gitti",
			"error-explain": "İadenizi işleme koyamadık. Lütfen yeniden deneyin.",
			"why": "Bize neden olduğunu söyleyin.",
			"no-refunds": "İade edilen ögeniz yok.",
			"select-codes": "İade edilecek kodu/kodları seçin:",
			"number": "Kaç tane?",
			"back": "İadelere geri git"
		},
		"purchases": {
			"back": "Satın almalara geri git"
		},
		"global-bar": {
			"account": "Hesap Ayarları"
		}
	};

/***/ },
/* 1001 */
/***/ function(module, exports) {

	module.exports = {
		"base": {
			"welcome": "Chào mừng bạn tới Mulligans, %{name}!",
			"user": "Thông tin người dùng",
			"devices": "Thiết bị",
			"refunds": "Khoản hoàn trả",
			"resources": "Tài nguyên",
			"transactions": "Đơn hàng & Trả hàng",
			"email": "Email",
			"password": "Mật khẩu",
			"save": "Lưu",
			"sign-out": "Đăng xuất",
			"cancel": "Hủy",
			"close": "Đóng",
			"learn-more": "Tìm hiểu thêm",
			"required": "Bắt buộc",
			"support": "Hỗ trợ",
			"bookshelf": "Bookshelf",
			"launch": "Khởi chạy",
			"download": "Tải xuống",
			"details": "Chi tiết",
			"cannot-be-blank": "%{field} không thể bỏ trống.",
			"saving": "Đang lưu...",
			"done": "Hoàn thành",
			"failed": "Không thành công",
			"copy": "Sao chép"
		},
		"signin": {
			"login-failure": "Email hoặc mật khẩu không chính xác",
			"welcome-large": "Chào mừng bạn tới <span class='inner'>Trung tâm tài khoản %{brand}</span>",
			"welcome-small": "<span class='inner'>Trung tâm tài khoản</span>",
			"signin-button": "Đăng nhập",
			"forgot-password": "Bạn quên mật khẩu",
			"new-to-vst": "Bạn mới biết %{brand}?",
			"create-account": "Tạo tài khoản",
			"signing-in": "Đăng nhập...",
			"signin-failed": "Đăng nhập không thành công"
		},
		"transactions": {
			"price": "Giá",
			"excluded": "(Không bao gồm thuế)",
			"quantity": "Số lượng",
			"confirmation#": "Số xác nhận",
			"payment": "Thanh toán",
			"purchased": "Đã mua",
			"purchase-details": "Chi tiết mua hàng",
			"subtotal": "Tổng con",
			"total": "Tổng",
			"tax": "Thuế",
			"loading": "Xin chào, chúng tôi đang tải giao dịch của bạn...",
			"no-purchases": "Bạn chưa có giao dịch mua nào.",
			"seller-vat": "VAT bán hàng",
			"total-vat": "Tổng %{vat} đã thanh toán",
			"portion": "Thuế %{subTax} %{rate}%",
			"vat-disclosure": "Giá bao gồm %{vat}",
			"purchases": "Mua hàng",
			"refunded-items": "Các mục đã hoàn tiền",
			"book-title": "Tiêu đề sách",
			"refund-details": "Chi tiết hoàn tiền",
			"print-receipt": "In hóa đơn",
			"request-refund": "Yêu cầu hoàn tiền",
			"expired": "Đã hết hạn",
			"expires-in": "Hết hạn %{date}",
			"details-refund": "Chi tiết & Hoàn tiền",
			"modal": {
				"cant-refund-title": "Khoản hoàn trả không khả dụng",
				"cant-refund": "Sách của bạn không thể hoàn trả vì một hoặc nhiều lý do sau đây.",
				"cant-refund-1": "Sách của bạn đã được xem quá nhiều.",
				"cant-refund-2": "Đã hơn 14 ngày kể từ ngày mua.",
				"cant-refund-3": "Mã các tài nguyên trực tuyến của bạn đã được hiển thị.",
				"cant-refund-4": "Sách của bạn đã được hoàn trả trước đó.",
				"cant-refund-5": "Tất cả các mã đã được đổi thưởng và/hoặc hoàn tiền",
				"cant-refund-6": "Đã hơn 30 ngày kể từ ngày mua.",
				"cant-refund-support": "Nếu bạn vẫn chưa hiểu rõ chính sách hoàn trả của %{brand}, hãy liên hệ với <a href='%{support_url}' target='_blank'>bộ phận hỗ trợ</a>."
			},
			"license": {
				"perpetual": "Truy cập trực tuyến không hết hạn",
				"days": "%{days} ngày truy cập"
			}
		},
		"devices": {
			"description": "%{brand} cho phép bạn kích hoạt <span>%{desktop}</span> máy tính và <span>%{mobile}</span> thiết bị di động/máy tính bảng vào bất kỳ thời điểm cụ thể nào.",
			"loading": "Xin chào, chúng tôi đang truy cập thiết bị của bạn :)",
			"no-active": "Bạn không có thiết bị hiện hoạt nào.",
			"deactivate": "Hủy kích hoạt"
		},
		"user": {
			"personal-information": "Thông tin cá nhân",
			"security-information": "Thông tin bảo mật",
			"notifications": "Thông báo",
			"first-name": "Tên",
			"last-name": "Họ",
			"change-password-title": "Thay đổi mật khẩu",
			"current-password": "Mật khẩu hiện tại",
			"new-password": "Mật khẩu mới",
			"security-password": "Mật khẩu",
			"confirm-new-password": "Xác nhận mật khẩu mới",
			"security-question": "Câu hỏi bảo mật",
			"security-info-change": "Thay đổi",
			"question": "Câu hỏi",
			"answer": "Trả lời",
			"notifications-text": "Email cho tôi cập nhật thường xuyên về hoạt động tài khoản của tôi, các cập nhật sản phẩm và lời mời đặc biệt.",
			"loading": "Spot đang phân tích thông tin người dùng của bạn, hãy chờ một lát 🐶",
			"change-password-text": "Mật khẩu phải gồm ít nhất 8 ký tự, trong đó có một chữ viết hoa, một chữ viết thường và một ký tự đặc biệt.",
			"email-locked": "Email đã bị khóa",
			"email-locked-description": "Bạn không có quyền truy cập để thay đổi email của mình.",
			"email-locked-more": "Vui lòng liên hệ với quản trị viên của bạn.",
			"security-question6": "Môn thể thao ưa thích của bạn là gì?",
			"security-question7": "Vị kem ưa thích của bạn là gì?",
			"security-question8": "Tên vật nuôi ưa thích của bạn là gì?",
			"security-question9": "Khi còn nhỏ, bạn muốn trở thành người như thế nào khi lớn lên?",
			"security-question10": "Họ của giáo viên ưa thích của bạn là gì?",
			"new-password-failure": "Mật khẩu không đáp ứng yêu cầu",
			"confirm-password-failure": "Mật khẩu phải khớp",
			"new-password-tooltip": "Phải gồm ít nhất 8 ký tự, trong đó có một chữ viết hoa, một chữ viết thường và một ký tự đặc biệt.",
			"enter-valid-email": "Vui lòng nhập email hợp lệ.",
			"password-cannot-be-same": "Mật khẩu không thể giống mật khẩu trước đây",
			"incorrect-password": "Mật khẩu không chính xác",
			"complete-account": "Có vẻ như bạn cần <a href='%{href}'>hoàn tất tài khoản của mình</a>.",
			"completing-allows": "Việc hoàn tất tài khoản cho phép bạn đọc sách ngoại tuyến trên ứng dụng di động của chúng tôi cũng như chia sẻ ghi chú và các điểm nổi bật với bạn bè.",
			"error-updating-info": "There was an error updating your information.",
			"password-updated": "Password successfully updated",
			"security-updated": "Security question successfully updated",
			"info-updated": "User information successfully updated"
		},
		"resources": {
			"ancillaries": "Các phần bổ sung",
			"access-codes": "Mã truy cập",
			"print-on-demand": "In theo yêu cầu",
			"check-pod": "Chọn tùy chọn in của nhà xuất bản cho sách của bạn.",
			"check-now": "Xem ngay",
			"loading": "Hãy chờ, chúng tôi đang cập nhật tài nguyên của bạn!",
			"in": "trong",
			"access-code-intro": "Mã truy cập là mật khẩu bạn sử dụng để truy cập trực tuyến nội dung khóa học. Sau khi hiển thị mã cho một mục, bạn sẽ không thể quay lại mục này. Để biết thêm hướng dẫn về cách sử dụng mã truy cập của bạn, hãy đi tới <a href='%{support_url}' target='_blank'>Hỗ trợ</a>.",
			"expires": "Hết hạn",
			"expiration-message": "Gồm các hướng dẫn sử dụng mã truy cập của bạn.",
			"copy-fail": "Không thể sao chép. Vui lòng chọn và sao chép thủ công mã.",
			"launch-site": "Khởi chạy trang web",
			"launch-book": "Khởi chạy sách",
			"reveal-code": "Hiển thị mã",
			"no-resources": "Bạn không có tài nguyên nào.",
			"no-access-codes": "Bạn không có mã truy cập nào.",
			"no-ancillaries": "Không có phần bổ sung nào cho tiêu đề này",
			"name": "Tên",
			"type": "Loại",
			"size": "Kích cỡ",
			"download-all": "Tải xuống tất cả",
			"back": "Quay lại tài nguyên"
		},
		"refunds": {
			"states": {
				"refunded": "Đã hoàn trả",
				"unavailable": "Hoàn trả không khả dụng"
			},
			"reasons": {
				"dropped": "Tôi đã bỏ khóa học",
				"wrong": "Sách này không phù hợp với khóa học của tôi",
				"print": "Thay vào đó, tôi đã quyết định mua một phiên bản in",
				"missing": "Sách này không có mọi nội dung tôi cần cho khóa học (ví dụ: CD, truy cập web, video)",
				"other": "Khác"
			},
			"bulk": {
				"policy": "Bằng việc nhấp vào nút &quot;Hoàn tất hoàn trả&quot; bên dưới, tôi đồng ý với chính sách hoàn trả của %{brand} <a href='%{policy_url}' target='_blank'> .</a>.",
				"complete": "Hoàn tất hoàn trả",
				"view-details": "Xem chi tiết hoàn trả",
				"success": "Đã yêu cầu hoàn tiền cho bạn. Vui lòng đợi 48 giờ để xử lý.",
				"failure": "Rất tiếc - đã xảy ra sự cố! Đáng tiếc là hoạt động hoàn trả của bạn không được chấp nhận.",
				"retry": "Thử lại",
				"support": "Liên hệ với bộ phận hỗ trợ",
				"available-codes": "Mã khả dụng",
				"codes-selected": "Mã đã được chọn",
				"download": "Tải xuống mã",
				"partially-refunded": "Đã hoàn trả một phần",
				"pick-one": "Bạn phải chọn ít nhất một mã để thực hiện hoàn trả"
			},
			"refund": "Hoàn trả",
			"all": "Hoàn trả toàn bộ?",
			"missing-reason": "Bạn phải chọn một lý do để tiếp tục",
			"missing-elaboration": "Vui lòng nêu thêm chi tiết",
			"policy": "Bằng việc nhấp vào nút “Hoàn tất yêu cầu hoàn trả” bên dưới, tôi hiểu rằng nếu tôi mua sách điện tử của %{brand} lần nữa, tôi sẽ không đủ điều kiện yêu cầu bất kỳ khoản hoàn trả nào khác cho sách điện tử tương tự. Xem toàn bộ chính sách hoàn trả.",
			"refunded": "Đã hoàn trả",
			"sorry": "Chúng tôi rất tiếc khi bạn không hài lòng với sản phẩm mua.",
			"error": "Đã xảy ra sự cố",
			"error-explain": "Chúng tôi không thể xử lý khoản hoàn trả của bạn. Vui lòng thử lại.",
			"why": "Cho chúng tôi biết lý do?",
			"no-refunds": "Bạn không có mục được hoàn trả nào.",
			"select-codes": "Chọn (các) mã để hoàn trả:",
			"number": "Số lượng?",
			"back": "Quay lại khoản hoàn trả"
		},
		"purchases": {
			"back": "Quay lại giao dịch mua"
		},
		"global-bar": {
			"account": "Cài đặt tài khoản"
		}
	};

/***/ },
/* 1002 */
/***/ function(module, exports) {

	module.exports = {
		"base": {
			"welcome": "欢迎使用 Mulligans，%{name}！",
			"user": "用户信息",
			"devices": "设备",
			"refunds": "退款",
			"resources": "资源",
			"transactions": "订单与退货",
			"email": "电子邮件",
			"password": "密码",
			"save": "保存",
			"sign-out": "注销",
			"cancel": "取消",
			"close": "关闭",
			"learn-more": "了解更多",
			"required": "必填",
			"support": "支持",
			"bookshelf": "书架",
			"launch": "启动",
			"download": "下载",
			"details": "详细信息",
			"cannot-be-blank": "%{field} 不能为空",
			"saving": "正在保存…",
			"done": "已完成",
			"failed": "失败",
			"copy": "复制"
		},
		"signin": {
			"login-failure": "电子邮件或密码不正确",
			"welcome-large": "欢迎进入 <span class='inner'>%{brand} 帐户中心</span>",
			"welcome-small": "<span class='inner'>帐户中心</span>",
			"signin-button": "登录",
			"forgot-password": "忘记您的密码了",
			"new-to-vst": "%{brand} 新手？",
			"create-account": "创建帐户",
			"signing-in": "正在登录...",
			"signin-failed": "登录失败"
		},
		"transactions": {
			"price": "价格",
			"excluded": "（不含税）",
			"quantity": "数量",
			"confirmation#": "确认 #",
			"payment": "付款",
			"purchased": "已购买",
			"purchase-details": "购买详细信息",
			"subtotal": "小计",
			"total": "合计",
			"tax": "税金",
			"loading": "嘿！超级大买家，我们正在加载您的交易...",
			"no-purchases": "您并无购买。",
			"seller-vat": "卖家增值税",
			"total-vat": "所付%{vat}合计",
			"portion": "%{subTax} 税 %{rate}%",
			"vat-disclosure": "价格包含 %{vat}",
			"purchases": "购买",
			"refunded-items": "退款项目",
			"book-title": "图书标题",
			"refund-details": "退款详细信息",
			"print-receipt": "打印收据",
			"request-refund": "请求退款",
			"expired": "已过期",
			"expires-in": "过期日：%{date}",
			"details-refund": "详情与退款",
			"modal": {
				"cant-refund-title": "退款不可用",
				"cant-refund": "出于下列一项或多项原因，您的图书不可退款。",
				"cant-refund-1": "您的大量图书已被看过。",
				"cant-refund-2": "自购买之日起已超过 14 日。",
				"cant-refund-3": "您的在线资源代码已被泄露。",
				"cant-refund-4": "您的图书之前已经退款。",
				"cant-refund-5": "所有代码已兑换和/或退款。",
				"cant-refund-6": "自购买之日起已超过 30 日。",
				"cant-refund-support": "如果您仍对 %{brand} 的退款政策不确定，请联系<a href='%{support_url}' target='_blank'>支持部门</a>。"
			},
			"license": {
				"perpetual": "在线访问权限不会过期",
				"days": "%{days} 天访问权限"
			}
		},
		"devices": {
			"description": "%{brand} 让您能够在任何给定时间激活 <span>%{desktop} </span>计算机和 <span>%{mobile} </span>移动/平板设备。",
			"loading": "嘿，我们找到您的设备了 :)",
			"no-active": "您并无活动设备。",
			"deactivate": "停用"
		},
		"user": {
			"personal-information": "个人信息",
			"security-information": "安全信息",
			"notifications": "通知",
			"first-name": "名字",
			"last-name": "姓氏",
			"change-password-title": "更改密码",
			"current-password": "当前密码",
			"new-password": "新密码",
			"security-password": "密码",
			"confirm-new-password": "确认新密码",
			"security-question": "安全问题",
			"security-info-change": "更改",
			"question": "问题",
			"answer": "答案",
			"notifications-text": "请将有关我的账户活动、产品更新及特别优惠的更新信息通过电子邮件发送给我。",
			"loading": "Spot 正在提取您的用户信息，稍等 🐶",
			"change-password-text": "密码必须包含至少 8 个字符、一个大写字母、一个小写字母和一个特殊字符。",
			"email-locked": "电子邮箱已锁定",
			"email-locked-description": "您没有权限更改您的电子邮箱。",
			"email-locked-more": "请联系您的管理员。",
			"security-question6": "您最喜爱的运动是什么?",
			"security-question7": "您最喜爱的冰淇淋口味是什么?",
			"security-question8": "您最喜爱的宠物叫什么名字?",
			"security-question9": "在您年轻的时候，想过长大后想当什么吗？",
			"security-question10": "您最喜爱的老师姓什么?",
			"new-password-failure": "密码不符合要求",
			"confirm-password-failure": "密码必须匹配",
			"new-password-tooltip": "必须包含至少 8 个字符、一个大写字母、一个小写字母和一个特殊字符。",
			"enter-valid-email": "请输入有效的电子邮件。",
			"password-cannot-be-same": "密码不能与以前的密码相同",
			"incorrect-password": "密码不正确",
			"complete-account": "您可能需要<a href='%{href}'>完善您的帐户</a>。",
			"completing-allows": "完善您的帐户后可在移动应用程序中离线阅读图书，以及与朋友分享注释和热点标注。",
			"error-updating-info": "There was an error updating your information.",
			"password-updated": "Password successfully updated",
			"security-updated": "Security question successfully updated",
			"info-updated": "User information successfully updated"
		},
		"resources": {
			"ancillaries": "附件",
			"access-codes": "访问代码",
			"print-on-demand": "按需打印",
			"check-pod": "为您的图书勾选出版商打印选项。",
			"check-now": "立刻查看",
			"loading": "请紧记，我们正在更新您的资源！",
			"in": "于",
			"access-code-intro": "访问代码是用于在线访问课程内容的密码。一旦泄露某个项目的代码，则无法将其退还。有关如何使用访问代码的更多说明，请访问<a href='%{support_url}' target='_blank'>支持</a>页面。",
			"expires": "过期",
			"expiration-message": "包含使用访问代码的说明。",
			"copy-fail": "无法复制。请选择代码并手动复制。",
			"launch-site": "启动网站",
			"launch-book": "启动图书",
			"reveal-code": "显示代码",
			"no-resources": "您并无任何资源。",
			"no-access-codes": "您并无任何访问代码。",
			"no-ancillaries": "此标题并无任何附件",
			"name": "名称",
			"type": "类型",
			"size": "大小",
			"download-all": "下载全部",
			"back": "回到资源"
		},
		"refunds": {
			"states": {
				"refunded": "已退款",
				"unavailable": "退款不可用"
			},
			"reasons": {
				"dropped": "我放弃了课程",
				"wrong": "这不是对应我课程的图书",
				"print": "我决定改为买印刷版",
				"missing": "此图书并未包含我的课程所需的一切（如 CD、网络访问权限、视频）",
				"other": "其他"
			},
			"bulk": {
				"policy": "单击下方的“完成退款”按钮，即表示我同意 %{brand} 的<a href='%{policy_url}' target='_blank'>退款政策</a>。",
				"complete": "完成退款",
				"view-details": "查看退款详细信息",
				"success": "您已申请退款。请等待 48 小时进行处理。",
				"failure": "糟糕 - 发生错误了！很抱歉，您的退款没有通过。",
				"retry": "重试",
				"support": "联系支持",
				"available-codes": "可用代码",
				"codes-selected": "已选代码",
				"download": "下载代码",
				"partially-refunded": "已部分退款",
				"pick-one": "您必须至少选择一个代码，以便退款"
			},
			"refund": "退款",
			"all": "全部退款？",
			"missing-reason": "必须选择一个理由才能继续",
			"missing-elaboration": "请详细说明",
			"policy": "单击下面的“完成退款申请”按钮，即表示我理解，如果我再次购买此 %{brand} eTextbook，则将不具备资格就同一 eTextbook 再次申请退款。查看完整退款政策。",
			"refunded": "已退款",
			"sorry": "很遗憾您对此次购买并不满意。",
			"error": "发生错误",
			"error-explain": "我们无法处理您的退款。请稍后重试。",
			"why": "请告诉我们原因",
			"no-refunds": "您并无退款项目。",
			"select-codes": "选择退款的代码：",
			"number": "多少？",
			"back": "回到退款"
		},
		"purchases": {
			"back": "回到购买"
		},
		"global-bar": {
			"account": "帐户设置"
		}
	};

/***/ },
/* 1003 */
/***/ function(module, exports) {

	module.exports = {
		"base": {
			"welcome": "歡迎使用 Mulligans，%{name}!",
			"user": "使用者資訊",
			"devices": "裝置",
			"refunds": "退貨",
			"resources": "資源",
			"transactions": "訂單與退貨",
			"email": "電子郵件",
			"password": "密碼",
			"save": "儲存",
			"sign-out": "登出",
			"cancel": "取消",
			"close": "關閉",
			"learn-more": "深入瞭解",
			"required": "必要項目",
			"support": "支援",
			"bookshelf": "書架",
			"launch": "啟用",
			"download": "下載",
			"details": "詳細資料",
			"cannot-be-blank": "%{field} 不可空白。",
			"saving": "正在儲存…",
			"done": "完成",
			"failed": "失敗",
			"copy": "複製"
		},
		"signin": {
			"login-failure": "電子郵件或密碼不正確",
			"welcome-large": "歡迎使用 <span class='inner'>%{brand} 帳戶中心</span>",
			"welcome-small": "<span class='inner'>帳戶中心</span>",
			"signin-button": "登入",
			"forgot-password": "忘記您的密碼",
			"new-to-vst": "才剛開始使用 %{brand}?",
			"create-account": "建立帳戶",
			"signing-in": "正在登入... ",
			"signin-failed": "登入失敗"
		},
		"transactions": {
			"price": "價格",
			"excluded": "(不含稅)",
			"quantity": "數量",
			"confirmation#": "確認號碼",
			"payment": "付款",
			"purchased": "已購買",
			"purchase-details": "購買詳細資料",
			"subtotal": "小計",
			"total": "總計",
			"tax": "稅款",
			"loading": "哈囉大買家，我們正在載入您的交易...",
			"no-purchases": "您沒有任何購買項目。",
			"seller-vat": "賣家增值稅",
			"total-vat": "已付 %{vat} 總計",
			"portion": "%{subTax}稅 %{rate}%",
			"vat-disclosure": "價格包含%{vat}",
			"purchases": "購買",
			"refunded-items": "退款項目",
			"book-title": "書籍標題",
			"refund-details": "退貨詳細資料",
			"print-receipt": "列印收據",
			"request-refund": "要求退款",
			"expired": "已過期",
			"expires-in": "到期日 %{date}",
			"details-refund": "詳細資料與退款",
			"modal": {
				"cant-refund-title": "不可退貨",
				"cant-refund": "由於下列一或多個原因，因此您的書籍無法退貨。",
				"cant-refund-1": "已檢視太多書籍內容。",
				"cant-refund-2": "自購買日起已超過 14 天。",
				"cant-refund-3": "您的線上資源代碼已開啟。",
				"cant-refund-4": "您的書籍先前已退貨。",
				"cant-refund-5": "所有代碼皆已兌換和/或退貨。",
				"cant-refund-6": "自購買日起已超過 30 天。",
				"cant-refund-support": "若您仍不了解 %{brand} 的退貨政策，請連絡<a href='%{support_url}' target='_blank'>技術支援中心</a>。"
			},
			"license": {
				"perpetual": "線上存取尚未過期",
				"days": "%{days} 天存取期"
			}
		},
		"devices": {
			"description": "%{brand} 可讓您隨時啟用 <span>%{desktop}</span> 台電腦和 <span>%{mobile}</span> 台行動/平板裝置。",
			"loading": "哈囉，我們正在連結您的裝置 :)",
			"no-active": "您沒有可用的裝置。",
			"deactivate": "停用"
		},
		"user": {
			"personal-information": "個人資訊",
			"security-information": "安全性資訊",
			"notifications": "通知",
			"first-name": "名字",
			"last-name": "姓氏",
			"change-password-title": "變更密碼",
			"current-password": "目前密碼",
			"new-password": "新密碼",
			"security-password": "密碼",
			"confirm-new-password": "確認新密碼",
			"security-question": "安全性問題",
			"security-info-change": "變更",
			"question": "問題",
			"answer": "答案",
			"notifications-text": "以電子郵件通知我關於帳戶的活動、產品更新及特別優惠。",
			"loading": "小花已經出去找尋您的使用者資訊，請稍等 🐶",
			"change-password-text": "密碼必須包含至少 8 個字元，其中一個大寫字母、一個小寫字母和一個特殊字元。 ",
			"email-locked": "電子郵件已鎖定",
			"email-locked-description": "您沒有變更個人電子郵件的權限。",
			"email-locked-more": "請連絡您的系統管理員",
			"security-question6": "您最喜歡什麼運動?",
			"security-question7": "您最喜歡什麼口味的冰淇淋?",
			"security-question8": "您最喜歡的寵物名字是?",
			"security-question9": "您小時候希望長大後成為?",
			"security-question10": "您最喜歡的老師姓氏是?",
			"new-password-failure": "密碼不符合要求",
			"confirm-password-failure": "密碼必須相符",
			"new-password-tooltip": "必須包含至少 8 個字元，其中一個大寫字母、一個小寫字母和一個特殊字元。",
			"enter-valid-email": "請輸入有效的電子郵件。",
			"password-cannot-be-same": "密碼不可與先前的密碼相同",
			"incorrect-password": "密碼不正確",
			"complete-account": "您似乎需要<a href='%{href}'>完成填寫帳戶資料</a>。",
			"completing-allows": "完成填寫帳戶資料後，您就可以使用行動應用程式離線閱讀書籍，以及與朋友分享附註和醒目提示。",
			"error-updating-info": "There was an error updating your information.",
			"password-updated": "Password successfully updated",
			"security-updated": "Security question successfully updated",
			"info-updated": "User information successfully updated"
		},
		"resources": {
			"ancillaries": "附屬品",
			"access-codes": "存取代碼",
			"print-on-demand": "隨選列印",
			"check-pod": "查看您書籍的出版商印刷選項。",
			"check-now": "立即查看",
			"loading": "跟緊囉，我們正在更新您的資源!",
			"in": "位於",
			"access-code-intro": "存取代碼為您用於存取線上課程內容的密碼。一旦您開啟某個項目的代碼，便無法改回。若需要更多關於如何使用您的存取代碼之指引，請造訪 <a href='%{support_url}' target='_blank'>支援頁面</a>。",
			"expires": "過期",
			"expiration-message": "包含使用存取代碼之指引。",
			"copy-fail": "無法複製。請選取代碼並手動複製。",
			"launch-site": "啟用網站",
			"launch-book": "啟用書籍",
			"reveal-code": "顯示代碼",
			"no-resources": "您沒有任何資源。",
			"no-access-codes": "您沒有任何存取代碼。",
			"no-ancillaries": "無此標題的附屬品",
			"name": "名稱",
			"type": "類型",
			"size": "大小",
			"download-all": "下載全部",
			"back": "返回資源"
		},
		"refunds": {
			"states": {
				"refunded": "已退貨",
				"unavailable": "不可退貨"
			},
			"reasons": {
				"dropped": "我已退選課程",
				"wrong": "這不是我課程使用的書籍",
				"print": "我決定要另外購買印刷版本",
				"missing": "這本書籍不包含課程所需的所有項目 (例如：CD、網路存取、影片)",
				"other": "其他"
			},
			"bulk": {
				"policy": "按下下方的「完整退貨」按鈕，即表示我同意 %{brand} 的 <a href='%{policy_url}' target='_blank'>退貨政策</a>。",
				"complete": "完整退貨",
				"view-details": "檢視退貨詳細資料",
				"success": "您已要求退款。請等待 48 小時完成處理。",
				"failure": "糟糕 - 發生問題!很遺憾您的退貨並未成功。",
				"retry": "再試一次",
				"support": "連絡技術支援中心",
				"available-codes": "可用代碼",
				"codes-selected": "已選取代碼",
				"download": "下載代碼",
				"partially-refunded": "部分退貨",
				"pick-one": "您必須選取至少一個代碼以進行退貨"
			},
			"refund": "退貨",
			"all": "全部退貨嗎?",
			"missing-reason": "您必須選取一個原因以繼續",
			"missing-elaboration": "請說明",
			"policy": "按一下下方的「完成退貨要求」按鈕，即表示我了解若我再次購買此本 %{brand} 電子課本，我將不符合再次要求此本相同電子課本的退貨資格。 檢視完整的退貨政策。",
			"refunded": "已退貨",
			"sorry": "無法滿足您的購買需求，我們深感抱歉。",
			"error": "發生問題",
			"error-explain": "我們無法處理您的退貨要求。請再試一次。",
			"why": "請告訴我們原因。",
			"no-refunds": "您沒有已退貨的項目。",
			"select-codes": "選取代碼以進行退貨:",
			"number": "有多少項?",
			"back": "返回退款"
		},
		"purchases": {
			"back": "返回購買"
		},
		"global-bar": {
			"account": "帳戶設定"
		}
	};

/***/ },
/* 1004 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./af": 247,
		"./af.js": 247,
		"./ar": 254,
		"./ar-dz": 248,
		"./ar-dz.js": 248,
		"./ar-kw": 249,
		"./ar-kw.js": 249,
		"./ar-ly": 250,
		"./ar-ly.js": 250,
		"./ar-ma": 251,
		"./ar-ma.js": 251,
		"./ar-sa": 252,
		"./ar-sa.js": 252,
		"./ar-tn": 253,
		"./ar-tn.js": 253,
		"./ar.js": 254,
		"./az": 255,
		"./az.js": 255,
		"./be": 256,
		"./be.js": 256,
		"./bg": 257,
		"./bg.js": 257,
		"./bn": 258,
		"./bn.js": 258,
		"./bo": 259,
		"./bo.js": 259,
		"./br": 260,
		"./br.js": 260,
		"./bs": 261,
		"./bs.js": 261,
		"./ca": 262,
		"./ca.js": 262,
		"./cs": 263,
		"./cs.js": 263,
		"./cv": 264,
		"./cv.js": 264,
		"./cy": 265,
		"./cy.js": 265,
		"./da": 266,
		"./da.js": 266,
		"./de": 269,
		"./de-at": 267,
		"./de-at.js": 267,
		"./de-ch": 268,
		"./de-ch.js": 268,
		"./de.js": 269,
		"./dv": 270,
		"./dv.js": 270,
		"./el": 271,
		"./el.js": 271,
		"./en-au": 272,
		"./en-au.js": 272,
		"./en-ca": 273,
		"./en-ca.js": 273,
		"./en-gb": 274,
		"./en-gb.js": 274,
		"./en-ie": 275,
		"./en-ie.js": 275,
		"./en-nz": 276,
		"./en-nz.js": 276,
		"./eo": 277,
		"./eo.js": 277,
		"./es": 279,
		"./es-do": 278,
		"./es-do.js": 278,
		"./es.js": 279,
		"./et": 280,
		"./et.js": 280,
		"./eu": 281,
		"./eu.js": 281,
		"./fa": 282,
		"./fa.js": 282,
		"./fi": 283,
		"./fi.js": 283,
		"./fo": 284,
		"./fo.js": 284,
		"./fr": 287,
		"./fr-ca": 285,
		"./fr-ca.js": 285,
		"./fr-ch": 286,
		"./fr-ch.js": 286,
		"./fr.js": 287,
		"./fy": 288,
		"./fy.js": 288,
		"./gd": 289,
		"./gd.js": 289,
		"./gl": 290,
		"./gl.js": 290,
		"./gom-latn": 291,
		"./gom-latn.js": 291,
		"./he": 292,
		"./he.js": 292,
		"./hi": 293,
		"./hi.js": 293,
		"./hr": 294,
		"./hr.js": 294,
		"./hu": 295,
		"./hu.js": 295,
		"./hy-am": 296,
		"./hy-am.js": 296,
		"./id": 297,
		"./id.js": 297,
		"./is": 298,
		"./is.js": 298,
		"./it": 299,
		"./it.js": 299,
		"./ja": 300,
		"./ja.js": 300,
		"./jv": 301,
		"./jv.js": 301,
		"./ka": 302,
		"./ka.js": 302,
		"./kk": 303,
		"./kk.js": 303,
		"./km": 304,
		"./km.js": 304,
		"./kn": 305,
		"./kn.js": 305,
		"./ko": 306,
		"./ko.js": 306,
		"./ky": 307,
		"./ky.js": 307,
		"./lb": 308,
		"./lb.js": 308,
		"./lo": 309,
		"./lo.js": 309,
		"./lt": 310,
		"./lt.js": 310,
		"./lv": 311,
		"./lv.js": 311,
		"./me": 312,
		"./me.js": 312,
		"./mi": 313,
		"./mi.js": 313,
		"./mk": 314,
		"./mk.js": 314,
		"./ml": 315,
		"./ml.js": 315,
		"./mr": 316,
		"./mr.js": 316,
		"./ms": 318,
		"./ms-my": 317,
		"./ms-my.js": 317,
		"./ms.js": 318,
		"./my": 319,
		"./my.js": 319,
		"./nb": 320,
		"./nb.js": 320,
		"./ne": 321,
		"./ne.js": 321,
		"./nl": 323,
		"./nl-be": 322,
		"./nl-be.js": 322,
		"./nl.js": 323,
		"./nn": 324,
		"./nn.js": 324,
		"./pa-in": 325,
		"./pa-in.js": 325,
		"./pl": 326,
		"./pl.js": 326,
		"./pt": 328,
		"./pt-br": 327,
		"./pt-br.js": 327,
		"./pt.js": 328,
		"./ro": 329,
		"./ro.js": 329,
		"./ru": 330,
		"./ru.js": 330,
		"./sd": 331,
		"./sd.js": 331,
		"./se": 332,
		"./se.js": 332,
		"./si": 333,
		"./si.js": 333,
		"./sk": 334,
		"./sk.js": 334,
		"./sl": 335,
		"./sl.js": 335,
		"./sq": 336,
		"./sq.js": 336,
		"./sr": 338,
		"./sr-cyrl": 337,
		"./sr-cyrl.js": 337,
		"./sr.js": 338,
		"./ss": 339,
		"./ss.js": 339,
		"./sv": 340,
		"./sv.js": 340,
		"./sw": 341,
		"./sw.js": 341,
		"./ta": 342,
		"./ta.js": 342,
		"./te": 343,
		"./te.js": 343,
		"./tet": 344,
		"./tet.js": 344,
		"./th": 345,
		"./th.js": 345,
		"./tl-ph": 346,
		"./tl-ph.js": 346,
		"./tlh": 347,
		"./tlh.js": 347,
		"./tr": 348,
		"./tr.js": 348,
		"./tzl": 349,
		"./tzl.js": 349,
		"./tzm": 351,
		"./tzm-latn": 350,
		"./tzm-latn.js": 350,
		"./tzm.js": 351,
		"./uk": 352,
		"./uk.js": 352,
		"./ur": 353,
		"./ur.js": 353,
		"./uz": 355,
		"./uz-latn": 354,
		"./uz-latn.js": 354,
		"./uz.js": 355,
		"./vi": 356,
		"./vi.js": 356,
		"./x-pseudo": 357,
		"./x-pseudo.js": 357,
		"./yo": 358,
		"./yo.js": 358,
		"./zh-cn": 359,
		"./zh-cn.js": 359,
		"./zh-hk": 360,
		"./zh-hk.js": 360,
		"./zh-tw": 361,
		"./zh-tw.js": 361
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 1004;


/***/ },
/* 1005 */
/***/ function(module, exports) {

	module.exports = "<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 263.1 24\" enable-background=\"new 0 0 263.1 24\" xml:space=\"preserve\"><g><path fill=\"#FFFFFF\" d=\"M131.5,19.2c-0.2-0.6-0.4-1.1-0.6-1.7c-0.2-0.5-0.4-1.1-0.5-1.6h-5.8c-0.2,0.5-0.4,1-0.6,1.6 c-0.2,0.5-0.4,1.1-0.6,1.7h-1.2c0.4-1.2,0.9-2.4,1.3-3.4c0.4-1.1,0.8-2.1,1.2-3c0.4-0.9,0.8-1.9,1.1-2.7c0.4-0.9,0.8-1.7,1.2-2.6h1 c0.4,0.9,0.8,1.7,1.2,2.6c0.4,0.9,0.8,1.8,1.1,2.7c0.4,0.9,0.8,1.9,1.2,3c0.4,1.1,0.8,2.2,1.3,3.4H131.5z M127.4,8.7 c-0.4,1-0.8,2-1.2,3c-0.4,1-0.8,2.1-1.3,3.3h5c-0.4-1.2-0.9-2.3-1.3-3.3S127.8,9.7,127.4,8.7z\"></path><path fill=\"#FFFFFF\" d=\"M138.9,19.4c-0.8,0-1.5-0.1-2.1-0.4c-0.7-0.3-1.2-0.7-1.7-1.2c-0.5-0.5-0.9-1.2-1.1-1.9 c-0.3-0.8-0.4-1.6-0.4-2.6s0.2-1.9,0.5-2.6c0.3-0.8,0.7-1.4,1.2-1.9c0.5-0.5,1.1-0.9,1.7-1.2c0.7-0.3,1.3-0.4,2.1-0.4 c0.4,0,0.8,0,1.2,0.1c0.4,0.1,0.7,0.1,1,0.2c0.3,0.1,0.5,0.2,0.7,0.3c0.2,0.1,0.3,0.2,0.4,0.2l-0.4,1c-0.3-0.2-0.6-0.3-1.1-0.5 c-0.4-0.2-1-0.2-1.6-0.2c-0.7,0-1.4,0.1-1.9,0.4c-0.5,0.2-1,0.6-1.4,1.1s-0.7,1-0.8,1.6c-0.2,0.6-0.3,1.3-0.3,2.1 c0,0.8,0.1,1.5,0.3,2.1c0.2,0.6,0.5,1.2,0.8,1.6c0.4,0.4,0.8,0.8,1.3,1c0.5,0.2,1.1,0.4,1.8,0.4c0.7,0,1.4-0.1,1.9-0.2 c0.5-0.1,0.9-0.3,1.1-0.4l0.3,1c-0.1,0.1-0.2,0.1-0.4,0.2c-0.2,0.1-0.4,0.2-0.7,0.2c-0.3,0.1-0.6,0.1-1,0.2 C139.8,19.4,139.3,19.4,138.9,19.4z\"></path><path fill=\"#FFFFFF\" d=\"M148.7,19.4c-0.8,0-1.5-0.1-2.1-0.4c-0.7-0.3-1.2-0.7-1.7-1.2c-0.5-0.5-0.9-1.2-1.1-1.9 c-0.3-0.8-0.4-1.6-0.4-2.6s0.2-1.9,0.5-2.6c0.3-0.8,0.7-1.4,1.2-1.9c0.5-0.5,1.1-0.9,1.7-1.2c0.7-0.3,1.3-0.4,2.1-0.4 c0.4,0,0.8,0,1.2,0.1c0.4,0.1,0.7,0.1,1,0.2c0.3,0.1,0.5,0.2,0.7,0.3c0.2,0.1,0.3,0.2,0.4,0.2l-0.4,1c-0.3-0.2-0.6-0.3-1.1-0.5 c-0.4-0.2-1-0.2-1.6-0.2c-0.7,0-1.4,0.1-1.9,0.4c-0.5,0.2-1,0.6-1.4,1.1s-0.7,1-0.8,1.6c-0.2,0.6-0.3,1.3-0.3,2.1 c0,0.8,0.1,1.5,0.3,2.1c0.2,0.6,0.5,1.2,0.8,1.6c0.4,0.4,0.8,0.8,1.3,1c0.5,0.2,1.1,0.4,1.8,0.4c0.7,0,1.4-0.1,1.9-0.2 c0.5-0.1,0.9-0.3,1.1-0.4l0.3,1c-0.1,0.1-0.2,0.1-0.4,0.2c-0.2,0.1-0.4,0.2-0.7,0.2c-0.3,0.1-0.6,0.1-1,0.2 C149.6,19.4,149.2,19.4,148.7,19.4z\"></path><path fill=\"#FFFFFF\" d=\"M164.2,13.3c0,1-0.1,1.9-0.4,2.7c-0.3,0.8-0.7,1.4-1.2,1.9c-0.5,0.5-1.1,0.9-1.8,1.2 c-0.7,0.3-1.4,0.4-2.1,0.4s-1.5-0.1-2.1-0.4c-0.7-0.3-1.3-0.6-1.8-1.2s-0.9-1.2-1.2-1.9c-0.3-0.8-0.4-1.7-0.4-2.7s0.1-1.9,0.4-2.7 s0.7-1.4,1.2-1.9s1.1-0.9,1.8-1.2s1.4-0.4,2.1-0.4s1.5,0.1,2.1,0.4s1.3,0.6,1.8,1.2c0.5,0.5,0.9,1.2,1.2,1.9S164.2,12.3,164.2,13.3 z M163,13.3c0-0.8-0.1-1.5-0.3-2.1c-0.2-0.6-0.5-1.2-0.9-1.6c-0.4-0.4-0.8-0.8-1.4-1s-1.1-0.3-1.8-0.3s-1.2,0.1-1.8,0.3 c-0.5,0.2-1,0.6-1.4,1c-0.4,0.4-0.7,1-0.9,1.6c-0.2,0.6-0.3,1.3-0.3,2.1s0.1,1.5,0.3,2.1c0.2,0.6,0.5,1.2,0.9,1.6 c0.4,0.4,0.8,0.8,1.4,1c0.5,0.2,1.1,0.4,1.8,0.4s1.2-0.1,1.8-0.4c0.5-0.2,1-0.6,1.4-1c0.4-0.4,0.7-1,0.9-1.6 C162.9,14.8,163,14.1,163,13.3z\"></path><path fill=\"#FFFFFF\" d=\"M170.7,19.4c-0.8,0-1.4-0.1-2-0.4c-0.5-0.2-1-0.6-1.3-1c-0.3-0.4-0.6-0.9-0.7-1.5c-0.2-0.6-0.2-1.2-0.2-1.8 V7.4h1.2v7.3c0,0.6,0.1,1.2,0.2,1.7c0.2,0.5,0.4,0.9,0.6,1.2c0.3,0.3,0.6,0.5,1,0.7c0.4,0.1,0.8,0.2,1.3,0.2c0.5,0,0.9-0.1,1.3-0.2 c0.4-0.1,0.7-0.4,1-0.7c0.3-0.3,0.5-0.7,0.6-1.2c0.2-0.5,0.2-1,0.2-1.7V7.4h1.2v7.4c0,0.6-0.1,1.2-0.2,1.8s-0.4,1.1-0.7,1.5 c-0.3,0.4-0.8,0.7-1.3,1C172.2,19.3,171.5,19.4,170.7,19.4z\"></path><path fill=\"#FFFFFF\" d=\"M185.7,19.2c-0.2-0.4-0.5-0.9-0.8-1.4c-0.3-0.5-0.7-1.1-1.1-1.7c-0.4-0.6-0.8-1.2-1.3-1.9 c-0.4-0.6-0.9-1.3-1.3-1.9c-0.4-0.6-0.9-1.2-1.3-1.7c-0.4-0.5-0.8-1-1.1-1.4v9.9h-1.1V7.4h0.9c0.6,0.6,1.2,1.4,1.9,2.2 c0.7,0.8,1.3,1.7,1.9,2.6c0.6,0.9,1.2,1.7,1.8,2.6c0.6,0.8,1,1.6,1.4,2.2V7.4h1.1v11.8H185.7z\"></path><path fill=\"#FFFFFF\" d=\"M196.9,7.4v1h-3.8v10.8H192V8.4h-3.8v-1H196.9z\"></path><path fill=\"#FFFFFF\" d=\"M206.8,19.4c-0.8,0-1.5-0.1-2.1-0.4c-0.7-0.3-1.2-0.7-1.7-1.2c-0.5-0.5-0.9-1.2-1.1-1.9 c-0.3-0.8-0.4-1.6-0.4-2.6s0.2-1.9,0.5-2.6c0.3-0.8,0.7-1.4,1.2-1.9c0.5-0.5,1.1-0.9,1.7-1.2c0.7-0.3,1.3-0.4,2.1-0.4 c0.4,0,0.8,0,1.2,0.1c0.4,0.1,0.7,0.1,1,0.2c0.3,0.1,0.5,0.2,0.7,0.3c0.2,0.1,0.3,0.2,0.4,0.2l-0.4,1c-0.3-0.2-0.6-0.3-1.1-0.5 c-0.4-0.2-1-0.2-1.6-0.2c-0.7,0-1.4,0.1-1.9,0.4c-0.5,0.2-1,0.6-1.4,1.1s-0.7,1-0.8,1.6c-0.2,0.6-0.3,1.3-0.3,2.1 c0,0.8,0.1,1.5,0.3,2.1c0.2,0.6,0.5,1.2,0.8,1.6c0.4,0.4,0.8,0.8,1.3,1c0.5,0.2,1.1,0.4,1.8,0.4c0.7,0,1.4-0.1,1.9-0.2 c0.5-0.1,0.9-0.3,1.1-0.4l0.3,1c-0.1,0.1-0.2,0.1-0.4,0.2c-0.2,0.1-0.4,0.2-0.7,0.2c-0.3,0.1-0.6,0.1-1,0.2 C207.7,19.4,207.3,19.4,206.8,19.4z\"></path><path fill=\"#FFFFFF\" d=\"M211.9,19.2V7.4h6.8v1h-5.6v4.1h5v1h-5v4.7h6.1v1H211.9z\"></path><path fill=\"#FFFFFF\" d=\"M229.1,19.2c-0.2-0.4-0.5-0.9-0.8-1.4c-0.3-0.5-0.7-1.1-1.1-1.7c-0.4-0.6-0.8-1.2-1.3-1.9 c-0.4-0.6-0.9-1.3-1.3-1.9c-0.4-0.6-0.9-1.2-1.3-1.7c-0.4-0.5-0.8-1-1.1-1.4v9.9H221V7.4h0.9c0.6,0.6,1.2,1.4,1.9,2.2 c0.7,0.8,1.3,1.7,1.9,2.6c0.6,0.9,1.2,1.7,1.8,2.6c0.6,0.8,1,1.6,1.4,2.2V7.4h1.1v11.8H229.1z\"></path><path fill=\"#FFFFFF\" d=\"M240.2,7.4v1h-3.8v10.8h-1.2V8.4h-3.8v-1H240.2z\"></path><path fill=\"#FFFFFF\" d=\"M241.7,19.2V7.4h6.8v1h-5.6v4.1h5v1h-5v4.7h6.1v1H241.7z\"></path><path fill=\"#FFFFFF\" d=\"M258.7,10.9c0,0.9-0.2,1.6-0.7,2.1c-0.5,0.5-1.1,0.9-1.8,1.1c0.2,0.2,0.4,0.5,0.7,0.9s0.6,0.8,0.9,1.3 c0.3,0.5,0.6,0.9,0.9,1.4c0.3,0.5,0.5,1,0.7,1.4h-1.2c-0.2-0.5-0.5-0.9-0.8-1.4c-0.3-0.5-0.6-0.9-0.9-1.3c-0.3-0.4-0.6-0.8-0.8-1.2 c-0.3-0.4-0.5-0.7-0.7-1c-0.4,0-0.7,0.1-1.1,0.1H252v4.8h-1.2V7.6c0.4-0.1,0.9-0.2,1.4-0.2c0.5-0.1,1.1-0.1,1.5-0.1 c1.6,0,2.8,0.3,3.7,0.9C258.3,8.8,258.7,9.7,258.7,10.9z M253.9,8.3c-0.4,0-0.8,0-1.1,0c-0.3,0-0.6,0.1-0.8,0.1v5h1.6 c0.5,0,1,0,1.5-0.1c0.5-0.1,0.9-0.2,1.2-0.3c0.4-0.2,0.6-0.4,0.8-0.8s0.3-0.8,0.3-1.3c0-0.5-0.1-1-0.3-1.3 c-0.2-0.3-0.5-0.6-0.8-0.8c-0.3-0.2-0.7-0.3-1.1-0.4S254.4,8.3,253.9,8.3z\"></path></g><g><rect x=\"17.3\" y=\"6.4\" fill=\"#FFFFFF\" width=\"3\" height=\"13.3\"></rect><g><path fill=\"#FFFFFF\" d=\"M39.8,7.5c-0.4-0.5-1-0.8-1.6-1.1C37.5,6.2,36.7,6,35.8,6c-0.8,0-1.6,0.1-2.3,0.2S32.3,6.5,32,6.6 l-0.3,0.1L32,9.4l0.4-0.2C32.7,9.1,33,9,33.6,8.9c0.5-0.1,1.2-0.2,1.9-0.2c0.5,0,1,0.1,1.3,0.2c0.3,0.1,0.5,0.3,0.7,0.6 c0.2,0.2,0.3,0.5,0.4,0.8c0.1,0.3,0.1,0.7,0.1,1v0.2c-0.1,0-0.3-0.1-0.5-0.1s-0.5-0.1-0.7-0.1c-1-0.1-2,0-2.9,0.2 c-0.7,0.2-1.3,0.4-1.8,0.7s-1,0.8-1.3,1.3c-0.3,0.6-0.5,1.2-0.5,2s0.1,1.5,0.4,2c0.3,0.6,0.6,1,1.1,1.4c0.5,0.3,1,0.6,1.7,0.7 c0.6,0.2,1.3,0.2,2.1,0.2c0.5,0,1,0,1.5-0.1c0.5,0,1-0.1,1.4-0.1s0.8-0.1,1.2-0.2l1.1-0.2V11c0-0.7-0.1-1.4-0.3-2 C40.5,8.6,40.2,8,39.8,7.5z M38,14.1v3.2c-0.2,0-0.4,0.1-0.7,0.1c-0.4,0-0.9,0-1.4,0c-0.8,0-1.5-0.1-1.9-0.4 c-0.4-0.2-0.6-0.7-0.6-1.4c0-0.3,0.1-0.6,0.2-0.8c0.2-0.2,0.4-0.4,0.7-0.5s0.6-0.2,0.9-0.3c0.4,0,0.7-0.1,1-0.1 c0.5,0,0.9,0,1.3,0.1C37.7,14,37.9,14,38,14.1z\"></path></g><path fill=\"#F58623\" d=\"M68.9,8.7c-0.5-0.6-1.1-1-1.8-1.3C66.4,7.1,65.6,7,64.8,7c-0.8,0-1.6,0.2-2.3,0.5s-1.3,0.7-1.8,1.3 s-0.9,1.3-1.2,2c-0.3,0.8-0.4,1.7-0.4,2.7s0.1,1.9,0.4,2.7c0.3,0.8,0.7,1.5,1.2,2c0.5,0.6,1.1,1,1.8,1.3S64,20,64.8,20 s1.6-0.2,2.3-0.5c0.7-0.3,1.3-0.7,1.8-1.3c0.5-0.6,0.9-1.2,1.2-2c0.3-0.8,0.4-1.7,0.4-2.7s-0.1-1.9-0.4-2.7 C69.8,10,69.4,9.3,68.9,8.7z M67.5,16.9c-0.7,0.9-1.6,1.3-2.7,1.3s-2.1-0.4-2.7-1.3c-0.7-0.9-1-2-1-3.5s0.3-2.6,1-3.5 s1.6-1.3,2.7-1.3c1.1,0,2.1,0.4,2.7,1.3c0.7,0.9,1,2,1,3.5S68.2,16.1,67.5,16.9z\"></path><path fill=\"#F58623\" d=\"M78.1,18.2c-0.3,0-0.5,0-0.8,0c-1.2,0-2.1-0.4-2.6-1.1s-0.8-1.8-0.8-3.4V7.3H72v6.9c0,0.8,0.1,1.6,0.3,2.3 c0.2,0.7,0.5,1.3,0.8,1.8c0.4,0.5,0.9,0.9,1.5,1.2c0.6,0.3,1.4,0.4,2.4,0.4c1.1,0,2.1-0.1,2.9-0.2s1.4-0.3,1.9-0.4v-12H80v10.6 h-0.1c-0.1,0-0.2,0.1-0.4,0.1c-0.2,0-0.4,0-0.6,0.1C78.6,18.1,78.3,18.1,78.1,18.2z\"></path><path fill=\"#F58623\" d=\"M90.8,7.3c-0.2,0-0.4-0.1-0.7-0.1c-0.2,0-0.5-0.1-0.7-0.1s-0.5,0-0.7,0c-1,0-1.9,0.1-2.6,0.3 c-0.7,0.2-1.4,0.3-1.9,0.5v11.8h1.9V9h0.1c0.1,0,0.4-0.1,0.8-0.2c0.4-0.1,0.9-0.1,1.3-0.1c0.7,0,1.2,0,1.6,0.1 c0.3,0.1,0.6,0.1,0.7,0.2l0.3-1.6C91,7.3,90.9,7.3,90.8,7.3z\"></path><path fill=\"#F58623\" d=\"M99,18c-0.5,0.1-1.1,0.2-1.7,0.2c-0.8,0-1.4-0.1-2-0.3c-0.5-0.2-1-0.6-1.3-1s-0.6-0.9-0.8-1.5 C93,14.8,93,14.2,93,13.5c0-1.6,0.4-2.8,1-3.6c0.7-0.8,1.7-1.2,3-1.2c0.5,0,1,0,1.5,0.1c0.4,0.1,0.7,0.2,1,0.3l0.4-1.6 c-0.5-0.2-1-0.3-1.5-0.4C98.1,7,97.5,7,96.9,7c-0.9,0-1.7,0.2-2.4,0.5c-0.7,0.3-1.4,0.8-1.8,1.3c-0.5,0.6-0.9,1.3-1.2,2 c-0.3,0.8-0.4,1.7-0.4,2.6s0.1,1.8,0.4,2.6c0.3,0.8,0.6,1.5,1.1,2c0.5,0.6,1.1,1,1.9,1.3c1,0.4,2.2,0.6,3.6,0.4 c0.3,0,0.7-0.1,1-0.1c0.3-0.1,0.6-0.1,0.8-0.2c0.2-0.1,0.3-0.1,0.4-0.2l-0.3-1.6C99.8,17.8,99.4,17.9,99,18z\"></path><path fill=\"#F58623\" d=\"M106.1,7c-0.7,0-1.4,0.1-2.1,0.4s-1.3,0.7-1.8,1.2s-0.9,1.2-1.3,2c-0.3,0.8-0.5,1.8-0.5,2.9 c0,0.9,0.1,1.8,0.4,2.6c0.2,0.8,0.6,1.5,1.1,2c0.5,0.6,1.1,1,1.9,1.3s1.7,0.5,2.8,0.5c0.9,0,1.6-0.1,2.3-0.2c0.6-0.1,1-0.3,1.3-0.4 l-0.3-1.6c-0.3,0.1-0.6,0.2-1.1,0.3c-0.6,0.1-1.2,0.2-2,0.2c-1.4,0-2.5-0.4-3.2-1.1s-1.1-1.7-1.2-3.1v-0.2h8.7c0-0.1,0-0.2,0-0.3 v-0.4c0-2.1-0.4-3.7-1.3-4.7C109,7.5,107.7,7,106.1,7z M109.2,12.4h-6.6v-0.2c0.1-0.4,0.2-0.9,0.3-1.3c0.2-0.4,0.4-0.8,0.7-1.2 c0.3-0.3,0.6-0.6,1.1-0.8c0.4-0.2,0.9-0.3,1.4-0.3c1,0,1.7,0.4,2.3,1c0.5,0.7,0.8,1.6,0.8,2.6L109.2,12.4z\"></path><path fill=\"#FFFFFF\" d=\"M29.2,16.9c-0.1,0-0.2,0.1-0.4,0.1c-0.4,0.1-0.9,0.2-1.5,0.2c-0.3,0-0.7,0-0.9-0.1 c-0.2-0.1-0.4-0.2-0.6-0.4c-0.2-0.2-0.3-0.5-0.4-0.8c-0.1-0.4-0.1-0.9-0.1-1.5V9h4.8V6.4h-4.8V3.6l-3,0.5v10.4 c0,0.9,0.1,1.6,0.2,2.3c0.1,0.7,0.4,1.3,0.8,1.8s0.9,0.9,1.5,1.1s1.4,0.4,2.3,0.4c0.8,0,1.4-0.1,2-0.3c0.5-0.2,0.9-0.3,1.2-0.4 c-0.3-0.3-0.5-0.7-0.7-1.1C29.5,17.8,29.3,17.4,29.2,16.9z\"></path><path fill=\"#FFFFFF\" d=\"M14.4,2.4h-0.2c-0.4,1.2-0.6,2.1-1,3.4c-0.4,1.2-0.9,2.5-1.3,3.7c-0.4,1.2-0.9,2.4-1.3,3.5 c-0.4,1-0.8,2-1.2,3c-0.4-1-0.8-2-1.2-3.1c-0.4-1.1-0.8-2.3-1.3-3.5C6.5,8.2,6,7,5.6,5.8c-0.4-1-1.3-3.6-1.9-5.2L0,0 c1.1,3.1,3.1,8.4,4.1,11.1c1.2,3,2.4,5.9,3.7,8.6h3.1c1.3-2.7,2.5-5.6,3.7-8.6c1-2.6,2-5.5,2.9-8.2L14.4,2.4z\"></path><polygon fill=\"#FFFFFF\" points=\"42.5,0.7 42.5,19.7 45.5,19.7 45.5,0.3 \"></polygon><g><path fill=\"#F58623\" d=\"M113,7v0.3h-0.7v1.9H112v-2h-0.7V7H113z\"></path><path fill=\"#F58623\" d=\"M114.3,8.8c0,0,0-0.1-0.1-0.2c0-0.1-0.1-0.2-0.1-0.2c0-0.1-0.1-0.2-0.1-0.3s-0.1-0.2-0.1-0.3 c0-0.1-0.1-0.2-0.1-0.2c0-0.1-0.1-0.1-0.1-0.2c0,0.2,0,0.5-0.1,0.8c0,0.3,0,0.6,0,0.9h-0.3c0-0.2,0-0.4,0-0.6c0-0.2,0-0.4,0-0.6 c0-0.2,0-0.4,0-0.5c0-0.2,0-0.3,0.1-0.5h0.3c0.1,0.1,0.1,0.2,0.2,0.3c0.1,0.1,0.1,0.3,0.2,0.4s0.1,0.3,0.2,0.4 c0.1,0.1,0.1,0.3,0.2,0.4c0-0.1,0.1-0.2,0.2-0.4c0.1-0.1,0.1-0.3,0.2-0.4s0.1-0.3,0.2-0.4s0.1-0.2,0.2-0.3h0.3 c0.1,0.7,0.1,1.4,0.2,2.2h-0.3c0-0.3,0-0.6,0-0.9c0-0.3,0-0.6-0.1-0.8c0,0,0,0.1-0.1,0.2c0,0.1-0.1,0.1-0.1,0.2s-0.1,0.2-0.1,0.3 S115,8.3,115,8.4s-0.1,0.2-0.1,0.2c0,0.1-0.1,0.1-0.1,0.2L114.3,8.8z\"></path></g><path fill=\"#F58623\" d=\"M57.6,13.4c-0.3-0.5-0.6-1-1.1-1.4c-0.4-0.4-1-0.7-1.5-1c-0.6-0.3-1.2-0.5-1.9-0.8c-0.5-0.2-1-0.4-1.5-0.6 c-0.4-0.2-0.8-0.4-1.2-0.7c-0.3-0.2-0.6-0.5-0.8-0.9c-0.2-0.3-0.3-0.7-0.3-1.2s0.1-0.9,0.3-1.2C49.8,5.3,50,5,50.3,4.8 c0.3-0.2,0.7-0.4,1.1-0.5c0.4-0.1,0.9-0.2,1.4-0.2c0.7,0,1.4,0.1,2.1,0.3c0.6,0.2,1.2,0.4,1.6,0.7l0.2,0.1l0.7-1.7l-0.1-0.1 c-0.2-0.1-0.5-0.3-0.8-0.4c-0.3-0.1-0.7-0.2-1-0.4c-0.4-0.1-0.8-0.2-1.2-0.3S53.4,2.2,53,2.2c-1.7,0-3,0.4-4,1.1 c-1,0.8-1.5,1.9-1.5,3.3c0,0.6,0.1,1.2,0.3,1.7s0.5,0.9,0.9,1.3c0.4,0.4,0.9,0.7,1.4,1s1.2,0.6,1.8,0.8c0.5,0.2,1.1,0.4,1.6,0.6 c0.5,0.2,0.9,0.4,1.3,0.7c0.4,0.3,0.7,0.6,0.9,1s0.3,0.9,0.3,1.4c0,1-0.3,1.7-1,2.2S53.3,18,52.1,18c-0.5,0-1,0-1.5-0.1 c-0.4-0.1-0.9-0.2-1.2-0.3c-0.4-0.1-0.7-0.2-0.9-0.4c-0.3-0.1-0.5-0.2-0.6-0.3l-0.2-0.1l-0.7,2l0.1,0.1c0.2,0.1,0.4,0.2,0.7,0.3 c0.3,0.1,0.6,0.3,1.1,0.4c0.4,0.1,0.9,0.2,1.4,0.3C50.8,20,51.4,20,52,20c1.8,0,3.3-0.4,4.3-1.2c1.1-0.8,1.6-1.9,1.6-3.5 C58,14.6,57.8,13.9,57.6,13.4z\"></path></g></svg>"

/***/ },
/* 1006 */
/***/ function(module, exports) {

	module.exports = "<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"153.4px\" height=\"24px\" viewBox=\"0 0 153.4 24\" style=\"enable-background:new 0 0 153.4 24;\" xml:space=\"preserve\"><style type=\"text/css\"> .st0{fill:#FFFFFF;} </style><g><g><path class=\"st0\" d=\"M10.4,19.7c-0.3-0.6-0.5-1.3-0.7-1.9c-0.2-0.6-0.4-1.2-0.6-1.7H2.7c-0.2,0.6-0.4,1.2-0.6,1.7 c-0.2,0.6-0.4,1.2-0.7,1.9H0c0.5-1.4,1-2.6,1.4-3.8c0.4-1.2,0.9-2.3,1.3-3.4c0.4-1.1,0.9-2.1,1.3-3c0.4-1,0.9-2,1.3-2.9h1.1 c0.5,1,0.9,2,1.3,2.9c0.4,1,0.8,2,1.3,3s0.9,2.2,1.3,3.4c0.4,1.2,0.9,2.5,1.5,3.8H10.4z M5.9,8.1c-0.5,1.1-0.9,2.2-1.4,3.3 S3.5,13.7,3.1,15h5.6c-0.5-1.3-1-2.5-1.4-3.6C6.8,10.3,6.3,9.1,5.9,8.1z\"></path><path class=\"st0\" d=\"M18.6,20c-0.8,0-1.6-0.2-2.4-0.5s-1.4-0.7-1.9-1.3c-0.5-0.6-1-1.3-1.3-2.2c-0.3-0.9-0.5-1.8-0.5-2.9 c0-1.1,0.2-2.1,0.5-2.9c0.3-0.9,0.8-1.6,1.3-2.2c0.6-0.6,1.2-1,1.9-1.3c0.7-0.3,1.5-0.4,2.3-0.4c0.5,0,0.9,0,1.3,0.1 c0.4,0.1,0.8,0.1,1.1,0.2c0.3,0.1,0.6,0.2,0.8,0.3c0.2,0.1,0.4,0.2,0.5,0.3L22,8.3c-0.3-0.2-0.7-0.4-1.2-0.6 c-0.5-0.2-1.1-0.3-1.8-0.3c-0.8,0-1.5,0.1-2.2,0.4c-0.6,0.3-1.1,0.7-1.5,1.2c-0.4,0.5-0.7,1.1-0.9,1.8c-0.2,0.7-0.3,1.5-0.3,2.3 c0,0.9,0.1,1.7,0.3,2.4c0.2,0.7,0.5,1.3,0.9,1.8c0.4,0.5,0.9,0.9,1.5,1.1c0.6,0.3,1.3,0.4,2,0.4c0.8,0,1.5-0.1,2.1-0.2 s1-0.3,1.3-0.5l0.4,1.1c-0.1,0.1-0.2,0.1-0.5,0.2c-0.2,0.1-0.5,0.2-0.8,0.3c-0.3,0.1-0.7,0.2-1.1,0.2C19.7,20,19.2,20,18.6,20z\"></path><path class=\"st0\" d=\"M29.7,20c-0.8,0-1.6-0.2-2.4-0.5s-1.4-0.7-1.9-1.3c-0.5-0.6-1-1.3-1.3-2.2c-0.3-0.9-0.5-1.8-0.5-2.9 c0-1.1,0.2-2.1,0.5-2.9c0.3-0.9,0.8-1.6,1.3-2.2c0.6-0.6,1.2-1,1.9-1.3c0.7-0.3,1.5-0.4,2.3-0.4c0.5,0,0.9,0,1.3,0.1 c0.4,0.1,0.8,0.1,1.1,0.2c0.3,0.1,0.6,0.2,0.8,0.3c0.2,0.1,0.4,0.2,0.5,0.3L33,8.3c-0.3-0.2-0.7-0.4-1.2-0.6 c-0.5-0.2-1.1-0.3-1.8-0.3c-0.8,0-1.5,0.1-2.2,0.4c-0.6,0.3-1.1,0.7-1.5,1.2c-0.4,0.5-0.7,1.1-0.9,1.8c-0.2,0.7-0.3,1.5-0.3,2.3 c0,0.9,0.1,1.7,0.3,2.4c0.2,0.7,0.5,1.3,0.9,1.8c0.4,0.5,0.9,0.9,1.5,1.1c0.6,0.3,1.3,0.4,2,0.4c0.8,0,1.5-0.1,2.1-0.2 s1-0.3,1.3-0.5l0.4,1.1c-0.1,0.1-0.2,0.1-0.5,0.2c-0.2,0.1-0.5,0.2-0.8,0.3c-0.3,0.1-0.7,0.2-1.1,0.2C30.7,20,30.2,20,29.7,20z\"></path><path class=\"st0\" d=\"M47,13.1c0,1.1-0.2,2.1-0.5,3c-0.3,0.9-0.8,1.6-1.3,2.2s-1.2,1-2,1.3c-0.7,0.3-1.5,0.4-2.4,0.4 c-0.8,0-1.6-0.1-2.4-0.4c-0.7-0.3-1.4-0.7-2-1.3c-0.6-0.6-1-1.3-1.3-2.2c-0.3-0.9-0.5-1.9-0.5-3s0.2-2.1,0.5-3s0.8-1.6,1.3-2.1 c0.6-0.6,1.2-1,2-1.3c0.7-0.3,1.5-0.4,2.4-0.4c0.8,0,1.6,0.1,2.4,0.4C44,7,44.6,7.5,45.2,8s1,1.3,1.3,2.1C46.9,11,47,12,47,13.1z M45.7,13.1c0-0.9-0.1-1.7-0.3-2.4c-0.2-0.7-0.6-1.3-1-1.8s-0.9-0.9-1.5-1.1c-0.6-0.3-1.3-0.4-2-0.4c-0.7,0-1.4,0.1-2,0.4 c-0.6,0.3-1.1,0.6-1.5,1.1s-0.7,1.1-1,1.8c-0.2,0.7-0.3,1.5-0.3,2.4s0.1,1.7,0.3,2.4c0.2,0.7,0.6,1.3,1,1.8s0.9,0.9,1.5,1.1 c0.6,0.3,1.3,0.4,2,0.4c0.7,0,1.4-0.1,2-0.4c0.6-0.3,1.1-0.6,1.5-1.1s0.7-1.1,1-1.8C45.5,14.8,45.7,14,45.7,13.1z\"></path><path class=\"st0\" d=\"M54.3,20c-0.9,0-1.6-0.1-2.2-0.4c-0.6-0.3-1.1-0.6-1.5-1.1s-0.7-1-0.8-1.6s-0.3-1.3-0.3-2V6.6h1.3v8.1 c0,0.7,0.1,1.3,0.3,1.9c0.2,0.5,0.4,1,0.7,1.3s0.7,0.6,1.1,0.8c0.4,0.2,0.9,0.2,1.4,0.2s1-0.1,1.4-0.2c0.4-0.2,0.8-0.4,1.1-0.8 s0.5-0.8,0.7-1.3c0.2-0.5,0.3-1.1,0.3-1.9V6.6h1.3v8.3c0,0.7-0.1,1.4-0.3,2s-0.4,1.2-0.8,1.6c-0.4,0.5-0.9,0.8-1.5,1.1 C55.9,19.9,55.2,20,54.3,20z\"></path><path class=\"st0\" d=\"M71,19.7c-0.2-0.4-0.6-1-0.9-1.6s-0.8-1.2-1.2-1.9c-0.5-0.7-0.9-1.4-1.4-2.1c-0.5-0.7-1-1.4-1.5-2.1 c-0.5-0.7-1-1.3-1.4-1.9c-0.5-0.6-0.9-1.1-1.2-1.5v11.1h-1.3V6.6h1c0.6,0.7,1.3,1.6,2.1,2.5c0.7,0.9,1.5,1.9,2.2,2.9 c0.7,1,1.4,1.9,2,2.9c0.6,0.9,1.1,1.8,1.5,2.4V6.6h1.3v13.2H71z\"></path><path class=\"st0\" d=\"M83.5,6.6v1.1h-4.2v12H78v-12h-4.2V6.6H83.5z\"></path><path class=\"st0\" d=\"M94.6,20c-0.8,0-1.6-0.2-2.4-0.5s-1.4-0.7-1.9-1.3c-0.5-0.6-1-1.3-1.3-2.2c-0.3-0.9-0.5-1.8-0.5-2.9 c0-1.1,0.2-2.1,0.5-2.9c0.3-0.9,0.8-1.6,1.3-2.2c0.6-0.6,1.2-1,1.9-1.3c0.7-0.3,1.5-0.4,2.3-0.4c0.5,0,0.9,0,1.3,0.1 c0.4,0.1,0.8,0.1,1.1,0.2c0.3,0.1,0.6,0.2,0.8,0.3c0.2,0.1,0.4,0.2,0.5,0.3L98,8.3c-0.3-0.2-0.7-0.4-1.2-0.6 c-0.5-0.2-1.1-0.3-1.8-0.3c-0.8,0-1.5,0.1-2.2,0.4c-0.6,0.3-1.1,0.7-1.5,1.2c-0.4,0.5-0.7,1.1-0.9,1.8c-0.2,0.7-0.3,1.5-0.3,2.3 c0,0.9,0.1,1.7,0.3,2.4c0.2,0.7,0.5,1.3,0.9,1.8c0.4,0.5,0.9,0.9,1.5,1.1c0.6,0.3,1.3,0.4,2,0.4c0.8,0,1.5-0.1,2.1-0.2 s1-0.3,1.3-0.5l0.4,1.1c-0.1,0.1-0.2,0.1-0.5,0.2c-0.2,0.1-0.5,0.2-0.8,0.3c-0.3,0.1-0.7,0.2-1.1,0.2C95.6,20,95.2,20,94.6,20z\"></path><path class=\"st0\" d=\"M100.3,19.7V6.6h7.6v1.1h-6.3v4.6h5.6v1.1h-5.6v5.2h6.8v1.1H100.3z\"></path><path class=\"st0\" d=\"M119.5,19.7c-0.2-0.4-0.6-1-0.9-1.6s-0.8-1.2-1.2-1.9c-0.5-0.7-0.9-1.4-1.4-2.1c-0.5-0.7-1-1.4-1.5-2.1 c-0.5-0.7-1-1.3-1.4-1.9c-0.5-0.6-0.9-1.1-1.2-1.5v11.1h-1.3V6.6h1c0.6,0.7,1.3,1.6,2.1,2.5c0.7,0.9,1.5,1.9,2.2,2.9 c0.7,1,1.4,1.9,2,2.9c0.6,0.9,1.1,1.8,1.5,2.4V6.6h1.3v13.2H119.5z\"></path><path class=\"st0\" d=\"M132,6.6v1.1h-4.2v12h-1.3v-12h-4.2V6.6H132z\"></path><path class=\"st0\" d=\"M133.6,19.7V6.6h7.6v1.1h-6.3v4.6h5.6v1.1h-5.6v5.2h6.8v1.1H133.6z\"></path><path class=\"st0\" d=\"M152.6,10.5c0,1-0.3,1.8-0.8,2.3c-0.5,0.6-1.2,1-2.1,1.2c0.2,0.3,0.5,0.6,0.8,1c0.3,0.4,0.7,0.9,1,1.4 c0.3,0.5,0.7,1,1,1.6c0.3,0.6,0.6,1.1,0.8,1.6H152c-0.3-0.5-0.6-1-0.9-1.5s-0.6-1-0.9-1.5c-0.3-0.5-0.6-0.9-0.9-1.3 c-0.3-0.4-0.6-0.8-0.8-1.1c-0.4,0-0.8,0.1-1.2,0.1h-2.1v5.3h-1.3V6.8c0.5-0.1,1-0.2,1.6-0.3c0.6-0.1,1.2-0.1,1.7-0.1 c1.8,0,3.2,0.3,4.1,1S152.6,9.2,152.6,10.5z M147.2,7.6c-0.5,0-0.9,0-1.3,0c-0.4,0-0.7,0.1-0.9,0.1v5.6h1.8c0.6,0,1.2,0,1.7-0.1 c0.5-0.1,1-0.2,1.4-0.4c0.4-0.2,0.7-0.5,0.9-0.8c0.2-0.4,0.3-0.9,0.3-1.5c0-0.6-0.1-1.1-0.3-1.4c-0.2-0.4-0.5-0.7-0.9-0.9 c-0.4-0.2-0.8-0.4-1.3-0.5C148.2,7.6,147.8,7.6,147.2,7.6z\"></path></g></g></svg>"

/***/ },
/* 1007 */
/***/ function(module, exports) {

	module.exports = "<svg version=\"1.1\" id=\"dark_gray_left\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"6.2px\" height=\"10px\" viewBox=\"0 0 6.2 10\" enable-background=\"new 0 0 6.2 10\" xml:space=\"preserve\"><polygon fill=\"#007FAD\" points=\"0,1.4 1.4,0 6.2,4.8 6.2,5.2 1.4,10 0,8.6 3.6,5 \"></polygon></svg>"

/***/ },
/* 1008 */
/***/ function(module, exports) {

	module.exports = "<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"9.9px\" height=\"6.4px\" viewBox=\"-474 277.6 9.9 6.4\" enable-background=\"new -474 277.6 9.9 6.4\" xml:space=\"preserve\"><polygon fill=\"#007FAD\" points=\"-465.5,277.6 -469.1,281.1 -472.6,277.6 -474,279 -469.1,284 -464.1,279 \"></polygon></svg>"

/***/ },
/* 1009 */
/***/ function(module, exports) {

	module.exports = "<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"6.2px\" height=\"10px\" viewBox=\"0 0 6.2 10\" enable-background=\"new 0 0 6.2 10\" xml:space=\"preserve\"><g id=\"dark_gray_left\"><polygon fill=\"#2F2F39\" points=\"6.2,1.4 4.8,0 0,4.8 0,5.2 4.8,10 6.2,8.6 2.6,5 \"></polygon></g><g id=\"dark_gray_left_pressed\" display=\"none\"><polygon display=\"inline\" fill=\"#35353F\" points=\"10,2.2 7.7,0 0,7.7 0,8.2 7.7,16 9.9,13.8 4.2,8 \"></polygon></g><g id=\"white_left\"></g><g id=\"white_left_pressed\" display=\"none\"><polygon display=\"inline\" fill=\"#F0F0F8\" points=\"10,2.2 7.8,0 0,7.7 0,8.2 7.8,16 10,13.8 4.2,8 \"></polygon></g><g id=\"dark_gray_right\"></g><g id=\"dark_gray_right_pressed\" display=\"none\"><polygon display=\"inline\" fill=\"#35353F\" points=\"0,2.2 2.2,0 10,7.7 10,8.2 2.2,16 0,13.8 5.8,8 \"></polygon></g><g id=\"white_right\" display=\"none\"><polygon display=\"inline\" fill=\"#FFFFFF\" points=\"0,2.2 2.2,0 10,7.7 10,8.2 2.2,16 0,13.8 5.8,8 \"></polygon></g><g id=\"orange_right\"></g><g id=\"orange_right_pressed\" display=\"none\"><polygon display=\"inline\" fill=\"#BF5200\" points=\"0,2.2 2.2,0 10,7.7 10,8.2 2.2,16 0,13.8 5.8,8 \"></polygon></g></svg>"

/***/ },
/* 1010 */
/***/ function(module, exports) {

	module.exports = "<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\" enable-background=\"new 0 0 16 16\" xml:space=\"preserve\"><g><path fill=\"#FFFFFF\" d=\"M3,15.5c-1.4,0-2.5-1.1-2.5-2.5V3c0-1.4,1.1-2.5,2.5-2.5h10c1.4,0,2.5,1.1,2.5,2.5v10 c0,1.4-1.1,2.5-2.5,2.5H3z\"></path><path fill=\"#DADADA\" d=\"M13,1c1.1,0,2,0.9,2,2v10c0,1.1-0.9,2-2,2H3c-1.1,0-2-0.9-2-2V3c0-1.1,0.9-2,2-2H13 M13,0H3 C1.4,0,0,1.4,0,3v10c0,1.6,1.4,3,3,3h10c1.6,0,3-1.4,3-3V3C16,1.4,14.6,0,13,0L13,0z\"></path></g></svg>"

/***/ },
/* 1011 */
/***/ function(module, exports) {

	module.exports = "<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"16px\" height=\"16px\" viewBox=\"-471 273 16 16\" style=\"enable-background:new -471 273 16 16;\" xml:space=\"preserve\"><style type=\"text/css\"> .st0{fill:#007FAD;} .st1{fill:#FFFFFF;} </style><g><path class=\"st0\" d=\"M-455,286c0,1.6-1.4,3-3,3h-10c-1.6,0-3-1.4-3-3v-10c0-1.6,1.4-3,3-3h10c1.6,0,3,1.4,3,3V286z\"></path></g><rect x=\"-468\" y=\"281.3\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 63.2702 411.861)\" class=\"st1\" width=\"5\" height=\"2\"></rect><rect x=\"-463\" y=\"276.4\" transform=\"matrix(0.7071 0.7071 -0.7071 0.7071 63.3043 408.9481)\" class=\"st1\" width=\"2\" height=\"9\"></rect></svg>"

/***/ },
/* 1012 */
/***/ function(module, exports) {

	module.exports = "<svg version=\"1.1\" id=\"default\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"22px\" height=\"22px\" viewBox=\"0 0 22 22\" enable-background=\"new 0 0 22 22\" xml:space=\"preserve\"><g><g><circle class=\"background\" fill=\"#EB710B\" cx=\"11\" cy=\"11\" r=\"11\"></circle></g><g><g><defs><rect id=\"SVGID_1_\" x=\"7\" y=\"3.3\" width=\"8\" height=\"13.3\"></rect></defs><clipPath id=\"SVGID_2_\"><use xlink:href=\"#SVGID_1_\" overflow=\"visible\"></use></clipPath><g clip-path=\"url(#SVGID_2_)\"><defs><rect id=\"SVGID_3_\" x=\"7\" y=\"3.3\" width=\"8\" height=\"13.3\"></rect></defs><clipPath id=\"SVGID_4_\"><use xlink:href=\"#SVGID_3_\" overflow=\"visible\"></use></clipPath><path clip-path=\"url(#SVGID_4_)\" class=\"foreground\" fill=\"#FFFFFF\" d=\"M12.3,6V3.3L7,6v10.7h8V6H12.3z M11,11.2c0,0.1-0.1,0.2-0.2,0.1l-0.6-0.6 c-0.1-0.1-0.3-0.1-0.4,0l-0.6,0.6c-0.1,0.1-0.2,0.1-0.2-0.1V6H11V11.2z\"></path></g></g></g></g></svg>"

/***/ },
/* 1013 */
/***/ function(module, exports) {

	module.exports = "<svg version=\"1.1\" id=\"hover\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"22px\" height=\"22px\" viewBox=\"0 0 22 22\" enable-background=\"new 0 0 22 22\" xml:space=\"preserve\"><g><g><circle fill=\"#CA5600\" cx=\"11\" cy=\"11\" r=\"11\"></circle></g><g><g><defs><rect id=\"SVGID_1_\" x=\"7\" y=\"3.3\" width=\"8\" height=\"13.3\"></rect></defs><clipPath id=\"SVGID_2_\"><use xlink:href=\"#SVGID_1_\" overflow=\"visible\"></use></clipPath><g clip-path=\"url(#SVGID_2_)\"><defs><rect id=\"SVGID_3_\" x=\"7\" y=\"3.3\" width=\"8\" height=\"13.3\"></rect></defs><clipPath id=\"SVGID_4_\"><use xlink:href=\"#SVGID_3_\" overflow=\"visible\"></use></clipPath><path clip-path=\"url(#SVGID_4_)\" fill=\"#FFFFFF\" d=\"M12.3,6V3.3L7,6v10.7h8V6H12.3z M11,11.2c0,0.1-0.1,0.2-0.2,0.1l-0.6-0.6 c-0.1-0.1-0.3-0.1-0.4,0l-0.6,0.6c-0.1,0.1-0.2,0.1-0.2-0.1V6H11V11.2z\"></path></g></g></g></g></svg>"

/***/ },
/* 1014 */
/***/ function(module, exports) {

	module.exports = "<svg version=\"1.1\" id=\"default\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"44px\" height=\"44px\" viewBox=\"0 0 44 44\" enable-background=\"new 0 0 44 44\" xml:space=\"preserve\"><g><g><circle class=\"background\" fill=\"#F54250\" cx=\"22\" cy=\"22\" r=\"22\"></circle></g><g><g><path fill=\"#FCFCFC\" d=\"M22.1,13.6c4.7,0,8.5,3.8,8.5,8.5s-3.8,8.5-8.5,8.5s-8.5-3.8-8.5-8.5S17.4,13.6,22.1,13.6 M22.1,11.1 c-6.1,0-11,4.9-11,11s4.9,11,11,11s11-4.9,11-11S28.2,11.1,22.1,11.1L22.1,11.1z\"></path></g><g><path fill=\"#FFFFFF\" d=\"M21.1,18.7v-3.1c-2.7,0.4-4.9,2.5-5.4,5.2h3.1C19.2,19.9,20,19.1,21.1,18.7z\"></path><path fill=\"#FFFFFF\" d=\"M25.4,20.9h3.1c-0.5-2.7-2.7-4.8-5.4-5.2v3.1C24.1,19.1,25,19.9,25.4,20.9z\"></path><path fill=\"#FFFFFF\" d=\"M23.1,25.4v3.1c2.8-0.4,5.1-2.7,5.4-5.6h-3.1C25.2,24.1,24.3,25.1,23.1,25.4z\"></path><path fill=\"#FFFFFF\" d=\"M18.7,22.9h-3.1c0.4,2.9,2.6,5.1,5.4,5.6v-3.1C19.9,25.1,19,24.1,18.7,22.9z\"></path></g></g></g></svg>"

/***/ },
/* 1015 */
/***/ function(module, exports) {

	module.exports = "<svg version=\"1.1\" id=\"hover\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"44px\" height=\"44px\" viewBox=\"0 0 44 44\" enable-background=\"new 0 0 44 44\" xml:space=\"preserve\"><g><g><circle fill=\"#CC313D\" cx=\"22\" cy=\"22\" r=\"22\"></circle></g><g><g><path fill=\"#FCFCFC\" d=\"M22.1,13.6c4.7,0,8.5,3.8,8.5,8.5s-3.8,8.5-8.5,8.5s-8.5-3.8-8.5-8.5S17.4,13.6,22.1,13.6 M22.1,11.1 c-6.1,0-11,4.9-11,11s4.9,11,11,11s11-4.9,11-11S28.2,11.1,22.1,11.1L22.1,11.1z\"></path></g><g><path fill=\"#FFFFFF\" d=\"M21.1,18.7v-3.1c-2.7,0.4-4.9,2.5-5.4,5.2h3.1C19.2,19.9,20,19.1,21.1,18.7z\"></path><path fill=\"#FFFFFF\" d=\"M25.4,20.9h3.1c-0.5-2.7-2.7-4.8-5.4-5.2v3.1C24.1,19.1,25,19.9,25.4,20.9z\"></path><path fill=\"#FFFFFF\" d=\"M23.1,25.4v3.1c2.8-0.4,5.1-2.7,5.4-5.6h-3.1C25.2,24.1,24.3,25.1,23.1,25.4z\"></path><path fill=\"#FFFFFF\" d=\"M18.7,22.9h-3.1c0.4,2.9,2.6,5.1,5.4,5.6v-3.1C19.9,25.1,19,24.1,18.7,22.9z\"></path></g></g></g></svg>"

/***/ },
/* 1016 */
/***/ function(module, exports) {

	module.exports = "<svg version=\"1.1\" id=\"default\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"22px\" height=\"22px\" viewBox=\"0 0 22 22\" enable-background=\"new 0 0 22 22\" xml:space=\"preserve\"><g><g><circle class=\"background\" fill=\"#F54250\" cx=\"11\" cy=\"11\" r=\"11\"></circle></g><g><path class=\"foreground\" fill=\"#FCFCFC\" d=\"M11,6.8c2.3,0,4.2,1.9,4.2,4.2s-1.9,4.2-4.2,4.2S6.8,13.4,6.8,11S8.7,6.8,11,6.8 M11,5.5 C8,5.5,5.5,8,5.5,11S8,16.5,11,16.5s5.5-2.5,5.5-5.5S14.1,5.5,11,5.5L11,5.5z\"></path><g><path class=\"foreground\" fill=\"#FFFFFF\" d=\"M10.5,9.4V7.8C9.2,8,8.1,9.1,7.8,10.5h1.6C9.6,9.9,10,9.5,10.5,9.4z\"></path><path class=\"foreground\" fill=\"#FFFFFF\" d=\"M12.7,10.5h1.6C14,9.1,12.9,8,11.5,7.8v1.5C12.1,9.5,12.5,9.9,12.7,10.5z\"></path><path class=\"foreground\" fill=\"#FFFFFF\" d=\"M11.5,12.7v1.5c1.4-0.2,2.5-1.4,2.7-2.8h-1.5C12.6,12.1,12.1,12.5,11.5,12.7z\"></path><path class=\"foreground\" fill=\"#FFFFFF\" d=\"M9.3,11.5H7.8c0.2,1.4,1.3,2.6,2.7,2.8v-1.5C10,12.5,9.5,12.1,9.3,11.5z\"></path></g></g></g></svg>"

/***/ },
/* 1017 */
/***/ function(module, exports) {

	module.exports = "<svg version=\"1.1\" id=\"hover\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"22px\" height=\"22px\" viewBox=\"0 0 22 22\" enable-background=\"new 0 0 22 22\" xml:space=\"preserve\"><g><g><circle fill=\"#CC313D\" cx=\"11\" cy=\"11\" r=\"11\"></circle></g><g><path fill=\"#FCFCFC\" d=\"M11,6.8c2.3,0,4.2,1.9,4.2,4.2s-1.9,4.2-4.2,4.2S6.8,13.4,6.8,11S8.7,6.8,11,6.8 M11,5.5 C8,5.5,5.5,8,5.5,11S8,16.5,11,16.5s5.5-2.5,5.5-5.5S14.1,5.5,11,5.5L11,5.5z\"></path><g><path fill=\"#FFFFFF\" d=\"M10.5,9.4V7.8C9.2,8,8.1,9.1,7.8,10.5h1.6C9.6,9.9,10,9.5,10.5,9.4z\"></path><path fill=\"#FFFFFF\" d=\"M12.7,10.5h1.6C14,9.1,12.9,8,11.5,7.8v1.5C12.1,9.5,12.5,9.9,12.7,10.5z\"></path><path fill=\"#FFFFFF\" d=\"M11.5,12.7v1.5c1.4-0.2,2.5-1.4,2.7-2.8h-1.5C12.6,12.1,12.1,12.5,11.5,12.7z\"></path><path fill=\"#FFFFFF\" d=\"M9.3,11.5H7.8c0.2,1.4,1.3,2.6,2.7,2.8v-1.5C10,12.5,9.5,12.1,9.3,11.5z\"></path></g></g></g></svg>"

/***/ },
/* 1018 */
/***/ function(module, exports) {

	module.exports = "<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"20px\" height=\"20px\" viewBox=\"0 0 20 20\" style=\"enable-background:new 0 0 20 20;\" xml:space=\"preserve\"><style type=\"text/css\"> .st0{fill:#40404C;} </style><path class=\"st0\" d=\"M1,1v14h7v2H5v2h10v-2h-3v-2h7V1H1z M17,11H3V3h14V11z\"></path></svg>"

/***/ },
/* 1019 */
/***/ function(module, exports) {

	module.exports = "<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"110px\" height=\"110px\" viewBox=\"0 0 110 110\" style=\"enable-background:new 0 0 110 110;\" xml:space=\"preserve\"><style type=\"text/css\"> .st0{fill:#D5D5E2;} </style><path class=\"st0\" d=\"M55,10c24.8,0,45,20.2,45,45s-20.2,45-45,45S10,79.8,10,55S30.2,10,55,10 M55,0C24.6,0,0,24.6,0,55 s24.6,55,55,55s55-24.6,55-55S85.4,0,55,0L55,0z\"></path><rect x=\"50\" y=\"26.5\" class=\"st0\" width=\"10\" height=\"36\"></rect><circle class=\"st0\" cx=\"55\" cy=\"77.5\" r=\"6\"></circle></svg>"

/***/ },
/* 1020 */
/***/ function(module, exports) {

	module.exports = "<svg width=\"94px\" height=\"94px\" viewBox=\"0 0 94 94\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><title>error_icon</title><desc>Created with Sketch.</desc><defs></defs><g id=\"Page-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"error_icon\" fill=\"#F64250\"><g><path d=\"M46.9996,71.3125 C43.8196,71.3125 41.2416,68.7345 41.2416,65.5545 C41.2416,62.3745 43.8196,59.7965 46.9996,59.7965 C50.1796,59.7965 52.7576,62.3745 52.7576,65.5545 C52.7576,68.7345 50.1796,71.3125 46.9996,71.3125\" id=\"Fill-1\"></path><path d=\"M50.9962,51.5045 C50.9072,52.5745 50.0122,53.3975 48.9382,53.3975 L45.0612,53.3975 C43.9872,53.3975 43.0922,52.5745 43.0032,51.5045 L40.7882,24.9235 C40.6872,23.7195 41.6372,22.6875 42.8452,22.6875 L51.1532,22.6875 C52.3622,22.6875 53.3122,23.7195 53.2112,24.9235 L50.9962,51.5045 Z\" id=\"Fill-3\"></path><path d=\"M47,4 C23.29,4 4,23.29 4,47 C4,70.71 23.29,90 47,90 C70.71,90 90,70.71 90,47 C90,23.29 70.71,4 47,4 M47,94 C21.084,94 0,72.916 0,47 C0,21.084 21.084,0 47,0 C72.916,0 94,21.084 94,47 C94,72.916 72.916,94 47,94\" id=\"Fill-5\"></path></g></g></g></svg>"

/***/ },
/* 1021 */
/***/ function(module, exports) {

	module.exports = "<svg width=\"12\" height=\"12\" viewBox=\"0 0 12 12\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><g id=\"external_window\" clip-path=\"url(#clip0_1799_47362)\"><path id=\"icon\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5.33268 0.666832C5.70068 0.666832 5.99935 0.964832 5.99935 1.3335C5.99935 1.7015 5.70068 2.00017 5.33268 2.00017H1.99935V10.0002H9.99935V6.66683C9.99935 6.29817 10.2973 6.00017 10.666 6.00017C11.034 6.00017 11.3327 6.29817 11.3327 6.66683V10.0002C11.3327 10.7335 10.7327 11.3335 9.99935 11.3335H1.99935C1.26602 11.3335 0.666016 10.7335 0.666016 10.0002V2.00017C0.666016 1.26683 1.26602 0.666832 1.99935 0.666832H5.33268ZM10.666 0.666832C11.0347 0.666832 11.3327 0.964832 11.3327 1.3335V4.00017C11.3327 4.36883 11.0347 4.66683 10.666 4.66683C10.2973 4.66683 9.99935 4.36883 9.99935 4.00017V2.94283L6.47068 6.4715C6.34068 6.6015 6.17002 6.66683 5.99935 6.66683C5.82868 6.66683 5.65802 6.6015 5.52802 6.4715C5.26735 6.21083 5.26735 5.7895 5.52802 5.52883L9.05668 2.00017H7.99935C7.63068 2.00017 7.33268 1.70217 7.33268 1.3335C7.33268 0.964832 7.63068 0.666832 7.99935 0.666832H10.666Z\" fill=\"#2F2F39\"></path></g><defs><clipPath id=\"clip0_1799_47362\"><rect width=\"12\" height=\"12\" fill=\"white\"></rect></clipPath></defs></svg>"

/***/ },
/* 1022 */
/***/ function(module, exports) {

	module.exports = "<svg width=\"12\" height=\"12\" viewBox=\"0 0 12 12\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><g id=\"external_window\" clip-path=\"url(#clip0_1799_47362)\"><path id=\"icon\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5.33268 0.666832C5.70068 0.666832 5.99935 0.964832 5.99935 1.3335C5.99935 1.7015 5.70068 2.00017 5.33268 2.00017H1.99935V10.0002H9.99935V6.66683C9.99935 6.29817 10.2973 6.00017 10.666 6.00017C11.034 6.00017 11.3327 6.29817 11.3327 6.66683V10.0002C11.3327 10.7335 10.7327 11.3335 9.99935 11.3335H1.99935C1.26602 11.3335 0.666016 10.7335 0.666016 10.0002V2.00017C0.666016 1.26683 1.26602 0.666832 1.99935 0.666832H5.33268ZM10.666 0.666832C11.0347 0.666832 11.3327 0.964832 11.3327 1.3335V4.00017C11.3327 4.36883 11.0347 4.66683 10.666 4.66683C10.2973 4.66683 9.99935 4.36883 9.99935 4.00017V2.94283L6.47068 6.4715C6.34068 6.6015 6.17002 6.66683 5.99935 6.66683C5.82868 6.66683 5.65802 6.6015 5.52802 6.4715C5.26735 6.21083 5.26735 5.7895 5.52802 5.52883L9.05668 2.00017H7.99935C7.63068 2.00017 7.33268 1.70217 7.33268 1.3335C7.33268 0.964832 7.63068 0.666832 7.99935 0.666832H10.666Z\" fill=\"#ffffff\"></path></g><defs><clipPath id=\"clip0_1799_47362\"><rect width=\"12\" height=\"12\" fill=\"white\"></rect></clipPath></defs></svg>"

/***/ },
/* 1023 */
/***/ function(module, exports) {

	module.exports = "<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"12px\" height=\"12px\" viewBox=\"0 0 12 12\" style=\"enable-background:new 0 0 12 12;\" xml:space=\"preserve\"><style type=\"text/css\"> .st0{fill:#777777;} </style><g><path class=\"st0\" d=\"M6,0.9c2.8,0,5.1,2.3,5.1,5.1S8.8,11.1,6,11.1S0.9,8.8,0.9,6S3.2,0.9,6,0.9 M6,0C2.7,0,0,2.7,0,6s2.7,6,6,6 s6-2.7,6-6S9.3,0,6,0L6,0z\"></path><g><path class=\"st0\" d=\"M4.8,9.3c0.2,0,0.3-0.1,0.4-0.1C5.2,9.1,5.3,9,5.3,8.7l0-3.1c0-0.2,0-0.4-0.1-0.4C5.1,5.1,5,5.1,4.8,5.1V4.8 l2,0l0,4c0,0.2,0,0.4,0.1,0.4c0.1,0.1,0.2,0.1,0.4,0.2v0.2l-2.5,0V9.3z M5.5,2.6C5.6,2.5,5.8,2.4,6,2.4c0.2,0,0.4,0.1,0.6,0.2 C6.7,2.8,6.8,3,6.8,3.2S6.7,3.6,6.6,3.8C6.4,3.9,6.2,4,6,4C5.8,4,5.6,3.9,5.5,3.8C5.3,3.6,5.2,3.4,5.2,3.2C5.2,3,5.3,2.8,5.5,2.6z \"></path></g></g></svg>"

/***/ },
/* 1024 */
/***/ function(module, exports) {

	module.exports = "<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"52px\" height=\"52px\" viewBox=\"0 0 52 52\" enable-background=\"new 0 0 52 52\" xml:space=\"preserve\"><g><g opacity=\"0.8\"><path fill=\"#DADADA\" d=\"M26,4c12.1,0,22,9.9,22,22s-9.9,22-22,22S4,38.1,4,26S13.9,4,26,4 M26,0C11.6,0,0,11.6,0,26s11.6,26,26,26 s26-11.6,26-26S40.4,0,26,0L26,0z\"></path></g><g><path fill=\"#EB710B\" d=\"M26,0v4c12.1,0,22,9.9,22,22s-9.9,22-22,22v4c14.4,0,26-11.6,26-26S40.4,0,26,0z\"></path></g></g></svg>"

/***/ },
/* 1025 */
/***/ function(module, exports) {

	module.exports = "<svg version=\"1.0\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"131.97412px\" height=\"32px\" viewBox=\"0 0 131.97412 32\" enable-background=\"new 0 0 131.97412 32\" xml:space=\"preserve\"><g><g><path fill=\"#FFFFFF\" d=\"M27.8252,25.69995c-0.34985,0-0.72925-0.0083-1.13745-0.0249 c-0.40869-0.0166-0.81689-0.04199-1.2251-0.0752c-0.40845-0.0332-0.8125-0.07471-1.2124-0.125 c-0.3999-0.0498-0.76685-0.11621-1.1001-0.19971V8.47485c0.33325-0.08301,0.7002-0.1499,1.1001-0.19971 c0.3999-0.05029,0.80396-0.09131,1.2124-0.125c0.4082-0.0332,0.8125-0.05811,1.21265-0.0752 c0.3999-0.01611,0.7749-0.0249,1.125-0.0249c1,0,1.9375,0.0752,2.8125,0.2251s1.63306,0.4043,2.2749,0.76221 c0.64136,0.35889,1.14575,0.82959,1.51245,1.4126c0.36646,0.5835,0.55005,1.30029,0.55005,2.1499 c0,0.9502-0.22485,1.72949-0.67505,2.33789c-0.44995,0.6084-1.0498,1.0625-1.7998,1.36231 c1.01636,0.2998,1.82495,0.7749,2.4248,1.4248c0.6001,0.65039,0.90015,1.56689,0.90015,2.75 c0,1.73389-0.63745,3.0376-1.9126,3.9126C32.61279,25.26245,30.59155,25.69995,27.8252,25.69995z M25.55029,15.52515h2.55005 c0.59985,0,1.16626-0.0415,1.69995-0.125c0.5332-0.0835,0.99561-0.2334,1.38745-0.4502 c0.39136-0.21631,0.69995-0.5,0.92505-0.8501c0.22485-0.34961,0.3374-0.79102,0.3374-1.32471c0-0.5-0.1167-0.9209-0.34985-1.2627 c-0.23364-0.34131-0.55444-0.61621-0.96265-0.82471c-0.40845-0.2085-0.88745-0.36279-1.4375-0.46289 c-0.55005-0.09961-1.13354-0.1499-1.75-0.1499c-0.6167,0-1.09985,0.00879-1.44995,0.0249 c-0.3501,0.01709-0.66675,0.04199-0.94995,0.0752V15.52515z M25.55029,17.47485v6.1001 c0.18311,0.01709,0.3999,0.03369,0.6499,0.05029c0.21655,0.0166,0.4707,0.0293,0.76245,0.03711 c0.2915,0.00879,0.62891,0.0127,1.0127,0.0127c0.71631,0,1.39551-0.0459,2.03735-0.1377 c0.64136-0.09131,1.20386-0.25391,1.6875-0.4873c0.48315-0.2334,0.87085-0.55811,1.1626-0.9751 c0.29126-0.4165,0.4375-0.94141,0.4375-1.57471c0-0.56641-0.10864-1.0459-0.32495-1.4375 c-0.2168-0.3916-0.5293-0.7041-0.9375-0.9375c-0.40869-0.2334-0.89624-0.40039-1.46265-0.5 c-0.56665-0.1001-1.19995-0.15039-1.8999-0.15039H25.55029z\"></path><path fill=\"#FFFFFF\" d=\"M49.80005,19.05005c0,1.03369-0.15015,1.9668-0.4502,2.7998 c-0.2998,0.83398-0.72095,1.55029-1.26245,2.15039c-0.54175,0.59961-1.1875,1.0625-1.9375,1.38721 c-0.75,0.3252-1.56665,0.48779-2.44995,0.48779c-0.88354,0-1.69995-0.1626-2.44995-0.48779 c-0.75-0.32471-1.39624-0.7876-1.9375-1.38721c-0.54175-0.6001-0.96265-1.31641-1.26245-2.15039 c-0.30005-0.83301-0.4502-1.76611-0.4502-2.7998c0-1.0166,0.15015-1.9458,0.4502-2.7876 c0.2998-0.84131,0.7207-1.5625,1.26245-2.1626c0.54126-0.59961,1.1875-1.0625,1.9375-1.38721 c0.75-0.3252,1.56641-0.48779,2.44995-0.48779c0.8833,0,1.69995,0.1626,2.44995,0.48779 c0.75,0.32471,1.39575,0.7876,1.9375,1.38721c0.5415,0.6001,0.96265,1.32129,1.26245,2.1626 C49.6499,17.10425,49.80005,18.03345,49.80005,19.05005z M47.375,19.05005c0-1.46631-0.32935-2.62891-0.98755-3.48731 c-0.65869-0.8584-1.5542-1.2876-2.6875-1.2876c-1.13354,0-2.0293,0.4292-2.6875,1.2876 c-0.65869,0.8584-0.98755,2.021-0.98755,3.48731c0,1.4668,0.32886,2.62939,0.98755,3.4873 c0.6582,0.85889,1.55396,1.2876,2.6875,1.2876c1.1333,0,2.02881-0.42871,2.6875-1.2876 C47.04565,21.67944,47.375,20.51685,47.375,19.05005z\"></path><path fill=\"#FFFFFF\" d=\"M64.05005,19.05005c0,1.03369-0.15015,1.9668-0.4502,2.7998 c-0.2998,0.83398-0.72095,1.55029-1.26245,2.15039c-0.54175,0.59961-1.1875,1.0625-1.9375,1.38721 c-0.75,0.3252-1.56665,0.48779-2.44995,0.48779c-0.88354,0-1.69995-0.1626-2.44995-0.48779 c-0.75-0.32471-1.39624-0.7876-1.9375-1.38721c-0.54175-0.6001-0.96265-1.31641-1.26245-2.15039 c-0.30005-0.83301-0.4502-1.76611-0.4502-2.7998c0-1.0166,0.15015-1.9458,0.4502-2.7876 c0.2998-0.84131,0.7207-1.5625,1.26245-2.1626c0.54126-0.59961,1.1875-1.0625,1.9375-1.38721 c0.75-0.3252,1.56641-0.48779,2.44995-0.48779c0.8833,0,1.69995,0.1626,2.44995,0.48779 c0.75,0.32471,1.39575,0.7876,1.9375,1.38721c0.5415,0.6001,0.96265,1.32129,1.26245,2.1626 C63.8999,17.10425,64.05005,18.03345,64.05005,19.05005z M61.625,19.05005c0-1.46631-0.32935-2.62891-0.98755-3.48731 c-0.65869-0.8584-1.5542-1.2876-2.6875-1.2876c-1.13354,0-2.0293,0.4292-2.6875,1.2876 c-0.65869,0.8584-0.98755,2.021-0.98755,3.48731c0,1.4668,0.32886,2.62939,0.98755,3.4873 c0.6582,0.85889,1.55396,1.2876,2.6875,1.2876c1.1333,0,2.02881-0.42871,2.6875-1.2876 C61.29565,21.67944,61.625,20.51685,61.625,19.05005z\"></path><path fill=\"#FFFFFF\" d=\"M71.2749,18.40015c0.5,0.3833,1.02905,0.8584,1.58765,1.4248 c0.55811,0.56689,1.10815,1.1792,1.6499,1.8374c0.5415,0.65869,1.05396,1.3252,1.5376,2 c0.48315,0.67529,0.89136,1.30469,1.22485,1.8877h-2.72485c-0.3501-0.58301-0.75439-1.17871-1.21265-1.7876 c-0.4585-0.60791-0.9375-1.19141-1.4375-1.75c-0.5-0.55811-1.00854-1.0708-1.5249-1.5376 c-0.51685-0.46631-1.00854-0.85791-1.4751-1.1748v6.25h-2.32495v-19l2.32495-0.3999v11.8501 c0.40015-0.40039,0.84155-0.8418,1.32495-1.3252s0.95825-0.9751,1.42505-1.4751c0.46655-0.5,0.9082-0.979,1.32495-1.4375 c0.4165-0.45801,0.77515-0.8623,1.0752-1.2124h2.72485c-0.38354,0.41699-0.80005,0.875-1.25,1.375s-0.91675,1.00439-1.3999,1.5127 c-0.48364,0.5083-0.97119,1.0166-1.46265,1.5249C72.17065,17.47095,71.70825,17.94995,71.2749,18.40015z\"></path><path fill=\"#FFFFFF\" d=\"M82.39966,23.87524c0.9502,0,1.65405-0.125,2.11255-0.375c0.45825-0.25,0.6875-0.65039,0.6875-1.2002 c0-0.56641-0.22485-1.0166-0.67505-1.3501c-0.44995-0.33301-1.19165-0.70801-2.22485-1.125 c-0.5-0.19971-0.97925-0.40381-1.4375-0.6123c-0.45874-0.2085-0.85425-0.4541-1.1875-0.73779 c-0.33374-0.2832-0.6001-0.625-0.80005-1.0249s-0.30005-0.89111-0.30005-1.4751c0-1.1499,0.42505-2.0625,1.27515-2.7373 c0.84985-0.6748,2.00806-1.0127,3.47485-1.0127c0.36646,0,0.73315,0.02148,1.1001,0.0625 c0.36646,0.04199,0.70825,0.0918,1.0249,0.15039c0.31641,0.05859,0.5957,0.12109,0.83765,0.1875 c0.24121,0.06641,0.42871,0.125,0.5625,0.1748l-0.42505,2c-0.25-0.1333-0.64185-0.27051-1.17505-0.4126 c-0.53369-0.14111-1.17505-0.2124-1.92505-0.2124c-0.6499,0-1.2168,0.12939-1.69995,0.3877 c-0.48364,0.2583-0.7251,0.66211-0.7251,1.2124c0,0.28369,0.05396,0.53369,0.1626,0.75c0.10815,0.2168,0.2749,0.4126,0.5,0.5874 s0.50391,0.3374,0.8374,0.4873c0.33325,0.15039,0.7334,0.30859,1.2002,0.4751c0.61621,0.23389,1.16626,0.4624,1.6499,0.6875 c0.48315,0.2251,0.89575,0.48779,1.23755,0.7876c0.34131,0.2998,0.60376,0.6626,0.78735,1.0874 c0.18335,0.42529,0.27515,0.94629,0.27515,1.5625c0,1.2002-0.44604,2.10889-1.33765,2.7251 c-0.8916,0.6167-2.16235,0.9248-3.8125,0.9248c-1.1499,0-2.0498-0.0957-2.69995-0.28711 c-0.6499-0.19141-1.0918-0.33789-1.32495-0.4375l0.42505-2c0.26636,0.09961,0.69141,0.25,1.2749,0.44971 C80.65796,23.77515,81.43286,23.87524,82.39966,23.87524z\"></path><path fill=\"#FFFFFF\" d=\"M90.27466,25.55005v-19l2.32495-0.3999v6.6499c0.43335-0.1665,0.89575-0.2959,1.38745-0.3877 c0.49146-0.09131,0.979-0.13721,1.46265-0.13721c1.0332,0,1.89136,0.146,2.57495,0.4375 c0.68311,0.2915,1.229,0.69971,1.63745,1.2251c0.4082,0.5249,0.6958,1.1543,0.86255,1.88721 c0.1665,0.73389,0.25,1.54199,0.25,2.42529v7.2998h-2.32495v-6.7998c0-0.80029-0.05444-1.4834-0.1626-2.05029 c-0.10864-0.56641-0.28735-1.0249-0.53735-1.375s-0.58374-0.604-1-0.76221c-0.41699-0.1582-0.93359-0.23779-1.55005-0.23779 c-0.25,0-0.50854,0.01709-0.77515,0.05029s-0.521,0.0708-0.76245,0.1123c-0.2417,0.04199-0.4585,0.0874-0.6499,0.1377 c-0.19189,0.0498-0.32935,0.0918-0.4126,0.125v10.79981H90.27466z\"></path><path fill=\"#FFFFFF\" d=\"M103.07446,19.07495c0-1.1499,0.1665-2.15381,0.5-3.01221c0.33325-0.8584,0.77515-1.5708,1.3252-2.1377 c0.5498-0.56641,1.18311-0.99121,1.8999-1.2749c0.71631-0.2832,1.44995-0.42529,2.19995-0.42529 c1.75,0,3.09155,0.54639,4.02515,1.6377c0.93311,1.0918,1.3999,2.7544,1.3999,4.98731c0,0.1001,0,0.22949,0,0.3877 c0,0.15869-0.00854,0.3042-0.0249,0.4375h-8.90015c0.1001,1.3501,0.49146,2.375,1.17505,3.0752 c0.68311,0.69971,1.75,1.0498,3.19995,1.0498c0.81641,0,1.50391-0.0708,2.0625-0.2124 c0.55835-0.1416,0.979-0.27881,1.26245-0.4126l0.3252,1.9502c-0.28369,0.1499-0.7793,0.30859-1.48755,0.47461 c-0.70874,0.1665-1.51245,0.25-2.4126,0.25c-1.13354,0-2.11255-0.1709-2.9375-0.51221s-1.50415-0.8125-2.03735-1.4126 c-0.53369-0.6001-0.92944-1.3125-1.1875-2.1377C103.20337,20.96265,103.07446,20.05884,103.07446,19.07495z M111.99951,17.80005 c0.01636-1.0498-0.24609-1.9126-0.78735-2.5874c-0.54199-0.67529-1.2876-1.0127-2.23755-1.0127 c-0.53369,0-1.00439,0.10449-1.4126,0.3125c-0.40845,0.2085-0.75415,0.47949-1.03735,0.8125 c-0.28369,0.3335-0.50439,0.7168-0.6626,1.1499c-0.15869,0.43359-0.26245,0.875-0.3125,1.3252H111.99951z\"></path><path fill=\"#FFFFFF\" d=\"M121.17432,25.80005c-1.43359-0.03369-2.44971-0.34131-3.0498-0.9248s-0.90015-1.4917-0.90015-2.7251 V6.55005l2.32495-0.3999v15.625c0,0.3833,0.0332,0.69971,0.1001,0.94971c0.06641,0.25,0.1748,0.4502,0.3252,0.6001 c0.1499,0.1499,0.34961,0.2627,0.59961,0.3374c0.25,0.0752,0.55859,0.1377,0.92529,0.1875L121.17432,25.80005z\"></path><path fill=\"#FFFFFF\" d=\"M129.17432,6.15015c0.68311,0,1.27051,0.0498,1.76221,0.1499s0.8374,0.19189,1.0376,0.2749l-0.4248,2 c-0.2002-0.1001-0.48389-0.1958-0.8501-0.2876c-0.3667-0.09131-0.81689-0.13721-1.3501-0.13721 c-1.0835,0-1.8418,0.2959-2.2749,0.88721c-0.43359,0.5918-0.6499,1.3877-0.6499,2.3877v1.125h5v1.9502h-5v11.04981h-2.3252 V11.37524c0-1.6665,0.4082-2.9541,1.2251-3.86279C126.14062,6.60425,127.42432,6.15015,129.17432,6.15015z\"></path></g><g><g><polygon fill=\"#D14E27\" points=\"0,6.86808 10,1.86808 10,21.86808 0,26.86808 \"></polygon></g><g><g><rect x=\"0\" y=\"6.86808\" fill=\"#F58929\" width=\"15\" height=\"20\"></rect></g><path fill=\"#FFFFFF\" d=\"M3.92125,6.86809v9.80594c0,0.27499,0.1521,0.33423,0.33814,0.13159l1.07373-1.17011 c0.18604-0.20264,0.49023-0.20264,0.67627,0l1.07373,1.17011c0.18604,0.20264,0.33813,0.1434,0.33813-0.13159V6.86809H3.92125z\"></path></g></g></g></svg>"

/***/ },
/* 1026 */
/***/ function(module, exports) {

	module.exports = "<svg version=\"1.0\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"262.30045px\" height=\"23.95825px\" viewBox=\"0 0 262.30045 23.95825\" enable-background=\"new 0 0 262.30045 23.95825\" xml:space=\"preserve\"><g><rect x=\"17.30656\" y=\"6.3863\" fill=\"#FFFFFF\" width=\"2.98563\" height=\"13.34696\"></rect><g><g><path fill=\"#FFFFFF\" d=\"M39.81856,7.53991c-0.41832-0.47153-0.97304-0.83936-1.64874-1.09401 c-0.66213-0.24927-1.47665-0.37508-2.42063-0.37508c-0.81186,0-1.57651,0.06294-2.27246,0.18751 c-0.7141,0.12705-1.21834,0.25924-1.54014,0.40227l-0.25106,0.11132l0.37111,2.60368l0.43256-0.17729 c0.25131-0.10283,0.64758-0.20628,1.17932-0.30669c0.53477-0.10103,1.16872-0.15121,1.88709-0.15121 c0.52474,0,0.95092,0.07378,1.26492,0.22046c0.30973,0.14427,0.54654,0.33029,0.7229,0.56686 c0.17816,0.24047,0.30365,0.52052,0.37415,0.83149c0.07409,0.33872,0.11218,0.68412,0.11218,1.02656v0.18144 c-0.14124-0.02781-0.30124-0.05804-0.48001-0.09069c-0.22777-0.04237-0.46849-0.07625-0.72197-0.10165 c-1.03715-0.10345-1.97029-0.0109-2.85803,0.18875c-0.68388,0.15424-1.29453,0.39862-1.81295,0.72711 c-0.53446,0.33878-0.96399,0.79067-1.2752,1.34297c-0.31308,0.5541-0.4719,1.21772-0.4719,1.97388 c0,0.77853,0.13405,1.45974,0.39806,2.0235c0.26797,0.57225,0.6503,1.03987,1.13607,1.39073 c0.47308,0.34181,1.03839,0.59344,1.68051,0.74954C34.24771,19.92381,34.93858,20,35.67628,20 c0.50634,0,1.0257-0.02057,1.54528-0.0617c0.5139-0.04113,0.99057-0.08468,1.43007-0.1343 c0.44464-0.04962,0.84301-0.10283,1.19598-0.15969l1.11941-0.18509v-8.19566c0-0.73919-0.08648-1.42852-0.25676-2.04952 C40.53508,8.5734,40.23508,8.00964,39.81856,7.53991z M38.02977,14.06441v3.2092 c-0.19903,0.03085-0.42947,0.05501-0.68809,0.07012c-0.40717,0.0236-0.87293,0.03574-1.3986,0.03574 c-0.81817,0-1.46488-0.14161-1.92253-0.42048c-0.405-0.24679-0.6013-0.69626-0.6013-1.37617 c0-0.34968,0.0796-0.62918,0.23689-0.83c0.17542-0.22139,0.39743-0.39862,0.66206-0.5287 c0.27919-0.13547,0.59195-0.22622,0.93159-0.26921c0.35996-0.04658,0.7081-0.06956,1.03231-0.06956 c0.49637,0,0.92193,0.02664,1.26647,0.07985C37.76452,13.99906,37.91876,14.03294,38.02977,14.06441z\"></path></g></g><path fill=\"#FFFFFF\" d=\"M29.27004,16.93179c-0.11373,0.04237-0.23682,0.08951-0.38109,0.14396 c-0.36931,0.13671-0.87745,0.2069-1.51115,0.2069c-0.34751,0-0.65179-0.04355-0.90409-0.12705 c-0.22771-0.07619-0.41162-0.20083-0.56258-0.3835c-0.15728-0.19054-0.27913-0.467-0.36325-0.82269 c-0.08982-0.38356-0.13547-0.88204-0.13547-1.4821V9.00683h4.78105V6.3863H25.4124V3.5948l-2.98539,0.49513v10.40159 c0,0.865,0.07198,1.63752,0.21476,2.29693c0.14731,0.68902,0.41107,1.28121,0.78398,1.76092 c0.37873,0.48639,0.88383,0.85658,1.50174,1.0986C25.52583,19.88144,26.28502,20,27.18329,20 c0.76013,0,1.44853-0.09075,2.04655-0.27039c0.54561-0.16273,0.92943-0.29944,1.18111-0.41677 c-0.29492-0.3394-0.54778-0.71931-0.74737-1.1458C29.48629,17.78837,29.35626,17.3752,29.27004,16.93179z\"></path><path fill=\"#FFFFFF\" d=\"M14.3781,2.38495l-0.15789,0.02602c-0.39082,1.18625-0.57318,2.13785-0.99757,3.37434 c-0.42525,1.23767-0.85416,2.45749-1.28697,3.6604c-0.43313,1.20322-0.86203,2.35987-1.28667,3.4693 c-0.42532,1.11006-0.83242,2.13122-1.22323,3.06338c-0.40772-0.93215-0.82418-1.95753-1.24857-3.07546 c-0.42494-1.11854-0.84964-2.27543-1.27396-3.47023c-0.42501-1.19443-0.84965-2.40973-1.27403-3.6474 C5.27445,4.75268,4.3099,2.14752,3.7636,0.62428L0,0c1.09705,3.15202,3.05371,8.38527,4.13899,11.14865 c1.17869,2.99926,2.40397,5.87148,3.67527,8.61664h3.07397c1.27551-2.74516,2.50048-5.61738,3.67372-8.61664 c1.03238-2.63905,2.01204-5.54304,2.93942-8.24528L14.3781,2.38495z\"></path><polygon fill=\"#FFFFFF\" points=\"42.56769,0.74954 42.56769,19.73326 45.55271,19.73326 45.55271,0.25441 \"></polygon></g><g><path fill=\"#F58623\" d=\"M55.26125,13.65983c-0.34111-0.29953-0.75842-0.56542-1.24149-0.79067 c-0.49536-0.2298-1.0666-0.46794-1.69818-0.70739c-0.47824-0.17039-0.90104-0.3376-1.25146-0.49569 c-0.35663-0.15942-0.66-0.33628-0.90203-0.52603c-0.253-0.19557-0.44209-0.41956-0.56509-0.66608 c-0.12359-0.24527-0.18651-0.53218-0.18651-0.85233c0-0.63317,0.283-1.10593,0.84069-1.40315 c0.52312-0.2805,1.14175-0.4218,1.84015-0.4218c0.78518,0,1.47062,0.07515,2.03599,0.2259 c0.44598,0.11811,0.79357,0.23265,1.05437,0.34593l0.36464-1.71715c-0.11811-0.03939-0.26239-0.08136-0.43179-0.12881 c-0.24269-0.06708-0.52927-0.131-0.85326-0.19068c-0.32273-0.05909-0.67546-0.11104-1.05114-0.15459 c-0.37302-0.0423-0.75028-0.06259-1.11881-0.06259c-1.47353,0-2.64919,0.33978-3.49471,1.01168 c-0.84585,0.6719-1.25735,1.55582-1.25735,2.70312c0,0.57474,0.09848,1.0633,0.29338,1.45252 c0.19623,0.39305,0.4608,0.73191,0.78644,1.00818c0.33178,0.28208,0.73191,0.53053,1.19152,0.73839 c0.45987,0.21037,0.95847,0.42213,1.48127,0.63185c1.07916,0.43568,1.86692,0.83455,2.34225,1.18636 c0.50991,0.37759,0.7674,0.8939,0.7674,1.53421c0,0.63251-0.26979,1.1011-0.80032,1.39026 c-0.50442,0.27494-1.24631,0.40918-2.26836,0.40918c-1.01498,0-1.84405-0.1078-2.46267-0.32015 c-0.4873-0.16649-0.86747-0.30013-1.14142-0.40012l-0.37018,1.74266c0.2569,0.09808,0.66833,0.23106,1.22536,0.39437 c0.65511,0.19358,1.58001,0.29173,2.74892,0.29173c1.6652,0,2.96154-0.31176,3.8526-0.9288 c0.88326-0.61056,1.3128-1.48775,1.3128-2.6831c0-0.61248-0.09166-1.13527-0.27105-1.55099 C55.85377,14.31038,55.59363,13.95156,55.26125,13.65983z\"></path><path fill=\"#F58623\" d=\"M67.57325,8.00065c-0.54349-0.60157-1.19926-1.07017-1.94921-1.39515 c-0.75193-0.3259-1.58391-0.4908-2.47008-0.4908c-0.88874,0-1.72012,0.1649-2.4714,0.4908 c-0.75127,0.32498-1.40705,0.7949-1.9492,1.39515c-0.54316,0.60217-0.9717,1.33699-1.27315,2.1835 c-0.30304,0.84936-0.45697,1.80142-0.45697,2.83022c0,1.04558,0.15393,2.00214,0.45697,2.84317 c0.30145,0.83838,0.72933,1.56772,1.27315,2.17055c0.54215,0.59966,1.19792,1.06885,1.9492,1.39548 c0.75193,0.32531,1.58391,0.49113,2.4714,0.49113c0.88617,0,1.71748-0.16583,2.47008-0.49113 c0.74995-0.32531,1.40572-0.79523,1.94921-1.39548c0.54347-0.60283,0.97076-1.33216,1.2728-2.17055 c0.3027-0.84103,0.45696-1.79759,0.45696-2.84317c0-1.0288-0.15426-1.98086-0.45696-2.83022 C68.54401,9.33764,68.11606,8.60282,67.57325,8.00065z M66.07003,16.7295c-0.71194,0.92814-1.69428,1.39865-2.91607,1.39865 c-1.22443,0-2.20544-0.47051-2.91805-1.39997c-0.70223-0.91393-1.05722-2.16348-1.05722-3.71381s0.35498-2.79988,1.05722-3.71546 c0.71261-0.92781,1.69362-1.39832,2.91805-1.39832c1.22179,0,2.20412,0.47051,2.91607,1.39832 c0.70158,0.91558,1.05722,2.16513,1.05722,3.71546S66.77161,15.81425,66.07003,16.7295z\"></path><path fill=\"#F58623\" d=\"M77.3529,18.05003c-0.28016,0.01811-0.55122,0.02716-0.81327,0.02716 c-1.27664,0-2.2022-0.38083-2.75084-1.13151c-0.537-0.73317-0.80937-1.95178-0.80937-3.62088V6.45065h-2.07121v7.39246 c0,0.89714,0.09491,1.72396,0.2801,2.45785c0.18268,0.72418,0.48605,1.36058,0.90039,1.89177 c0.41181,0.52603,0.96429,0.94169,1.64332,1.23018c0.68412,0.29239,1.54128,0.43952,2.54813,0.43952 c1.17598,0,2.22547-0.07746,3.11811-0.2304c0.83198-0.14263,1.52-0.2795,2.04736-0.40601V6.45065H79.3744v11.31287l-0.10522,0.0419 c-0.10007,0.03939-0.25234,0.07297-0.46728,0.10132c-0.20079,0.02716-0.42147,0.05169-0.66416,0.07812 C77.89248,18.01071,77.63108,18.03331,77.3529,18.05003z\"></path><path fill=\"#F58623\" d=\"M90.94186,6.43413c-0.21427-0.0419-0.45049-0.08546-0.70673-0.12776 c-0.25558-0.04263-0.51506-0.0768-0.77904-0.10264c-0.26014-0.02485-0.49312-0.0384-0.69582-0.0384 c-1.03719,0-1.98277,0.09167-2.81277,0.2688c-0.77969,0.16688-1.44901,0.34791-1.98924,0.53641v12.60663h2.07054V8.30012 l0.12782-0.03225c0.13873-0.03523,0.42854-0.09973,0.87196-0.19557c0.45115-0.09683,0.91201-0.14653,1.36897-0.14653 c0.6984,0,1.28187,0.0497,1.7317,0.14653c0.32987,0.07098,0.58802,0.13489,0.78101,0.19233l0.34785-1.75912 C91.17233,6.4829,91.06711,6.45931,90.94186,6.43413z\"></path><path fill=\"#F58623\" d=\"M99.75075,17.91712c-0.52663,0.1226-1.12305,0.18519-1.77358,0.18519 c-0.81262,0-1.51426-0.12194-2.08477-0.36272c-0.57513-0.24203-1.05405-0.59444-1.42383-1.04492 c-0.36794-0.44798-0.63898-0.99139-0.80937-1.61616c-0.16656-0.61512-0.25175-1.29991-0.25175-2.03829 c0-1.65555,0.37435-2.93801,1.11399-3.81163c0.74678-0.88134,1.83109-1.328,3.22267-1.328 c0.54539,0,1.06693,0.05327,1.55099,0.15816c0.4066,0.08969,0.77969,0.20489,1.10758,0.34527l0.45438-1.70942 c-0.49959-0.192-1.02305-0.33595-1.56197-0.42762c-0.5906-0.10165-1.19145-0.15228-1.78397-0.15228 c-0.95464,0-1.83308,0.17296-2.61079,0.51532c-0.77711,0.34342-1.44193,0.82583-1.97438,1.43355 c-0.53575,0.61122-0.95656,1.34571-1.24955,2.18383c-0.29497,0.84228-0.44341,1.78205-0.44341,2.79281 c0,1.01333,0.13747,1.95046,0.40594,2.78309c0.26721,0.82748,0.67772,1.55166,1.21987,2.15316 c0.54216,0.599,1.21862,1.07334,2.01246,1.40771c1.04691,0.44084,2.33908,0.61638,3.85069,0.44084 c0.36272-0.04263,0.71129-0.09425,1.03719-0.1536c0.32339-0.06008,0.61322-0.12782,0.86298-0.2033 c0.18717-0.05618,0.34077-0.11427,0.45888-0.17362l-0.28201-1.69105C100.52013,17.71441,100.16839,17.81897,99.75075,17.91712z\"></path><path fill=\"#F58623\" d=\"M107.27334,6.1147c-0.75193,0-1.49805,0.14388-2.21707,0.42755 c-0.71513,0.28367-1.35801,0.71519-1.90922,1.2812c-0.55055,0.56893-1.00044,1.29475-1.3354,2.15799 c-0.33562,0.86555-0.50732,1.89309-0.50732,3.05877c0,0.99654,0.13364,1.92468,0.39437,2.75857 c0.25948,0.82741,0.66093,1.55166,1.19535,2.15316c0.53311,0.599,1.22246,1.07592,2.04861,1.41868 c0.83006,0.34335,1.83175,0.5183,2.97872,0.5183c0.91327,0,1.74068-0.08585,2.4597-0.25432 c0.63059-0.14911,1.09793-0.29107,1.39159-0.42405l-0.28077-1.68457c-0.28724,0.11619-0.66225,0.23106-1.13467,0.35042 c-0.58796,0.15043-1.32119,0.2259-2.17834,0.2259c-1.54128,0-2.69665-0.38274-3.43371-1.13851 c-0.73323-0.74936-1.15854-1.85562-1.26508-3.28976l-0.01289-0.18076h9.24589c0.00707-0.08969,0.01031-0.1846,0.01031-0.28466 v-0.40204c0-2.26037-0.47375-3.96073-1.40962-5.05542C110.38498,6.66492,109.02572,6.1147,107.27334,6.1147z M110.54631,11.88875 h-7.03455l0.02127-0.18783c0.0536-0.47957,0.16523-0.95458,0.33305-1.41094c0.16782-0.4647,0.40924-0.88227,0.71578-1.24274 c0.30529-0.35987,0.68484-0.65775,1.12628-0.883c0.44473-0.22623,0.96172-0.34143,1.5387-0.34143 c1.03401,0,1.85825,0.37375,2.44946,1.11207c0.5828,0.72649,0.87004,1.66494,0.85259,2.78732L110.54631,11.88875z\"></path><g><path fill=\"#F58623\" d=\"M114.65,6.12019v0.28076h-0.728v2.03374h-0.32406V6.40095h-0.72742V6.12019H114.65z\"></path><path fill=\"#F58623\" d=\"M116.02995,8.11394c-0.0226-0.05327-0.05161-0.12108-0.08843-0.2037 c-0.03674-0.08229-0.0768-0.17131-0.11877-0.26688c-0.0419-0.09583-0.08711-0.19458-0.1349-0.2959 c-0.04771-0.10099-0.09293-0.19689-0.13549-0.28724c-0.04263-0.09002-0.08202-0.17072-0.11877-0.2417 c-0.03616-0.07131-0.06583-0.12584-0.08843-0.16398c-0.02452,0.26272-0.04455,0.54738-0.06001,0.85332 c-0.01552,0.30621-0.02842,0.61506-0.04005,0.92682h-0.31758c0.00906-0.20039,0.01937-0.40244,0.03034-0.60607 c0.01097-0.20396,0.02393-0.40402,0.03814-0.60124c0.01414-0.19715,0.03033-0.38915,0.04705-0.576 c0.01678-0.18717,0.0349-0.36404,0.05492-0.53119h0.28394c0.06067,0.09808,0.12458,0.21394,0.19365,0.34718 c0.06907,0.13397,0.13813,0.27369,0.2072,0.41956c0.06907,0.14554,0.13615,0.2914,0.20072,0.43727 c0.06458,0.14587,0.12327,0.27884,0.17686,0.3992c0.05294-0.12035,0.11229-0.25333,0.17686-0.3992 c0.06451-0.14587,0.13166-0.29173,0.20007-0.43727c0.06972-0.14587,0.13813-0.28559,0.20719-0.41956 c0.06908-0.13324,0.13357-0.2491,0.19424-0.34718h0.28334c0.07555,0.74612,0.13232,1.51735,0.17039,2.3145h-0.31692 c-0.01157-0.31176-0.02452-0.62061-0.03999-0.92682c-0.01546-0.30594-0.03615-0.5906-0.06067-0.85332 c-0.02194,0.03814-0.05161,0.09266-0.08843,0.16398c-0.03682,0.07098-0.07614,0.15168-0.11811,0.2417 c-0.04263,0.09035-0.08777,0.18625-0.13555,0.28724c-0.04772,0.10132-0.09293,0.20006-0.13556,0.2959 c-0.04189,0.09557-0.08129,0.1846-0.11871,0.26688c-0.03615,0.08262-0.0659,0.15043-0.08784,0.2037H116.02995z\"></path></g></g><g><path fill=\"#FFFFFF\" d=\"M133.47514,19.1919c-0.22461-0.5791-0.43164-1.13574-0.62012-1.66895 c-0.18945-0.53418-0.36914-1.05469-0.54199-1.56104h-5.75489c-0.19629,0.50879-0.38965,1.03076-0.57715,1.56494 c-0.18848,0.53418-0.3877,1.08984-0.59766,1.66504h-1.20703c0.44727-1.22656,0.87012-2.36914,1.26758-3.42822 c0.39844-1.05908,0.78906-2.06152,1.1709-3.00635c0.38281-0.94531,0.7627-1.85352,1.13965-2.7251 c0.37794-0.87109,0.77442-1.74512,1.18946-2.62109h1.01953c0.41602,0.87207,0.80957,1.74512,1.18262,2.61768 c0.37305,0.87305,0.75195,1.78223,1.13574,2.72656c0.38379,0.94482,0.77246,1.94727,1.16699,3.0083 c0.39453,1.06055,0.82812,2.20264,1.30176,3.42822H133.47514z M129.42046,8.73682c-0.42578,0.97852-0.8418,1.97168-1.24512,2.979 c-0.4043,1.00781-0.82227,2.09424-1.25489,3.26025h5.02833c-0.43457-1.16748-0.8584-2.25586-1.27051-3.26465 S129.84721,9.71143,129.42046,8.73682z\"></path><path fill=\"#FFFFFF\" d=\"M140.85307,19.44678c-0.75879,0-1.46484-0.13574-2.11621-0.4082 c-0.65234-0.27148-1.21875-0.66895-1.7002-1.18945c-0.48145-0.52148-0.86133-1.16455-1.13867-1.92969 c-0.27832-0.76514-0.41699-1.64062-0.41699-2.62646s0.15039-1.86182,0.45117-2.62646 c0.2998-0.76514,0.69922-1.4082,1.19824-1.92969c0.49805-0.521,1.07617-0.91504,1.7334-1.18164 c0.65723-0.26611,1.34375-0.39941,2.05762-0.39941c0.44141,0,0.84375,0.02832,1.20703,0.08496 c0.3623,0.05713,0.67969,0.12744,0.95215,0.21289c0.27148,0.08496,0.50391,0.16992,0.69629,0.25488 c0.19336,0.08496,0.34082,0.16162,0.44238,0.22949l-0.37402,1.00293c-0.2832-0.16992-0.64355-0.33691-1.0791-0.50146 c-0.43652-0.16406-0.97754-0.24658-1.62402-0.24658c-0.73633,0-1.37988,0.125-1.92969,0.37402 c-0.5498,0.24951-1.01074,0.60107-1.38477,1.0542s-0.65527,0.9917-0.8418,1.61475c-0.1875,0.62354-0.28027,1.31494-0.28027,2.07422 c0,0.78174,0.09277,1.4873,0.28027,2.11621c0.18652,0.62891,0.46191,1.16455,0.82422,1.60645 c0.3623,0.44238,0.80762,0.78223,1.33496,1.01953c0.52637,0.23828,1.12988,0.35742,1.81055,0.35742 c0.74805,0,1.37402-0.07031,1.87793-0.21289c0.50488-0.1416,0.88672-0.28613,1.14746-0.43359l0.32324,0.98633 c-0.0791,0.05664-0.21582,0.12207-0.4082,0.19531c-0.19238,0.07422-0.43652,0.15039-0.73047,0.22949 c-0.29492,0.0791-0.63477,0.14453-1.02051,0.19629C141.7603,19.42139,141.32964,19.44678,140.85307,19.44678z\"></path><path fill=\"#FFFFFF\" d=\"M150.71245,19.44678c-0.75879,0-1.46484-0.13574-2.11621-0.4082 c-0.65234-0.27148-1.21875-0.66895-1.7002-1.18945c-0.48145-0.52148-0.86133-1.16455-1.13867-1.92969 c-0.27832-0.76514-0.41699-1.64062-0.41699-2.62646s0.15039-1.86182,0.45117-2.62646 c0.2998-0.76514,0.69922-1.4082,1.19824-1.92969c0.49805-0.521,1.07617-0.91504,1.7334-1.18164 c0.65723-0.26611,1.34375-0.39941,2.05762-0.39941c0.44141,0,0.84375,0.02832,1.20703,0.08496 c0.3623,0.05713,0.67969,0.12744,0.95215,0.21289c0.27148,0.08496,0.50391,0.16992,0.69629,0.25488 c0.19336,0.08496,0.34082,0.16162,0.44238,0.22949l-0.37402,1.00293c-0.2832-0.16992-0.64355-0.33691-1.0791-0.50146 c-0.43652-0.16406-0.97754-0.24658-1.62402-0.24658c-0.73633,0-1.37988,0.125-1.92969,0.37402 c-0.5498,0.24951-1.01074,0.60107-1.38477,1.0542s-0.65527,0.9917-0.8418,1.61475c-0.1875,0.62354-0.28027,1.31494-0.28027,2.07422 c0,0.78174,0.09277,1.4873,0.28027,2.11621c0.18652,0.62891,0.46191,1.16455,0.82422,1.60645 c0.3623,0.44238,0.80762,0.78223,1.33496,1.01953c0.52637,0.23828,1.12988,0.35742,1.81055,0.35742 c0.74805,0,1.37402-0.07031,1.87793-0.21289c0.50488-0.1416,0.88672-0.28613,1.14746-0.43359l0.32324,0.98633 c-0.0791,0.05664-0.21582,0.12207-0.4082,0.19531c-0.19238,0.07422-0.43652,0.15039-0.73047,0.22949 c-0.29492,0.0791-0.63477,0.14453-1.02051,0.19629C151.61967,19.42139,151.18901,19.44678,150.71245,19.44678z\"></path><path fill=\"#FFFFFF\" d=\"M166.25053,13.29298c0,1.00879-0.14648,1.89844-0.44141,2.66895 c-0.29492,0.771-0.69434,1.41358-1.19824,1.9292c-0.50488,0.51562-1.09082,0.9043-1.75977,1.16406 c-0.66895,0.26074-1.37695,0.3916-2.125,0.3916s-1.45605-0.13086-2.125-0.3916c-0.66895-0.25977-1.25586-0.64844-1.75977-1.16406 s-0.90332-1.1582-1.19824-1.9292c-0.29492-0.77051-0.44238-1.66016-0.44238-2.66895s0.14746-1.89551,0.44238-2.66064 s0.69434-1.40527,1.19824-1.9209s1.09082-0.90381,1.75977-1.16455s1.37695-0.39111,2.125-0.39111s1.45605,0.13037,2.125,0.39111 s1.25488,0.64893,1.75977,1.16455c0.50391,0.51562,0.90332,1.15576,1.19824,1.9209S166.25053,12.28419,166.25053,13.29298z M165.0269,13.29298c0-0.79346-0.10156-1.50439-0.30566-2.13379c-0.2041-0.62891-0.49316-1.16406-0.86719-1.60645 c-0.37402-0.44189-0.82422-0.77881-1.35156-1.01123s-1.11914-0.34863-1.77637-0.34863s-1.25,0.11621-1.77637,0.34863 c-0.52734,0.23242-0.97754,0.56934-1.35156,1.01123c-0.37402,0.44238-0.66309,0.97754-0.86719,1.60645 c-0.2041,0.62939-0.30566,1.34033-0.30566,2.13379s0.10156,1.50439,0.30566,2.1333c0.2041,0.62891,0.49316,1.16455,0.86719,1.60645 c0.37402,0.44238,0.82422,0.78223,1.35156,1.01953c0.52637,0.23828,1.11914,0.35742,1.77637,0.35742 s1.24902-0.11914,1.77637-0.35742c0.52734-0.2373,0.97754-0.57715,1.35156-1.01953 c0.37402-0.44189,0.66309-0.97754,0.86719-1.60645C164.92534,14.79737,165.0269,14.08643,165.0269,13.29298z\"></path><path fill=\"#FFFFFF\" d=\"M172.74467,19.44678c-0.78223,0-1.44824-0.11914-1.99805-0.35742 c-0.5498-0.2373-0.99414-0.56641-1.33398-0.98535c-0.33984-0.41992-0.58691-0.90967-0.73926-1.4707 c-0.15332-0.56104-0.23047-1.16455-0.23047-1.81055V7.41114h1.15625v7.25879c0,0.646,0.07715,1.2041,0.22949,1.67432 c0.15332,0.4707,0.36621,0.85889,0.6377,1.16406c0.27246,0.30664,0.60059,0.5332,0.98633,0.68066 c0.38477,0.14746,0.81543,0.2207,1.29199,0.2207c0.47559,0,0.90625-0.07324,1.29199-0.2207 c0.38477-0.14746,0.71387-0.37402,0.98535-0.68066c0.27246-0.30518,0.48535-0.69336,0.6377-1.16406 c0.15332-0.47022,0.22949-1.02832,0.22949-1.67432V7.41114h1.15625v7.41162c0,0.646-0.07617,1.24951-0.22949,1.81055 s-0.39941,1.05078-0.73926,1.4707c-0.33984,0.41895-0.78516,0.74805-1.33496,0.98535 C174.19194,19.32764,173.52592,19.44678,172.74467,19.44678z\"></path><path fill=\"#FFFFFF\" d=\"M187.73784,19.1919c-0.21875-0.39453-0.49316-0.85938-0.82324-1.39551 c-0.33008-0.53516-0.69629-1.10352-1.10059-1.70508c-0.40332-0.60156-0.82422-1.22363-1.26367-1.86621 c-0.43848-0.64209-0.87598-1.26709-1.31055-1.87402c-0.43555-0.60742-0.86133-1.17627-1.27734-1.70703 c-0.41699-0.53076-0.78613-0.98926-1.10938-1.37549v9.92334h-1.13867V7.41114h0.91797 c0.57812,0.64502,1.19824,1.39111,1.85938,2.23682c0.66016,0.84619,1.30859,1.70801,1.94336,2.58594 c0.63574,0.87793,1.22852,1.73633,1.77832,2.57422c0.55078,0.83838,1.00195,1.56836,1.35449,2.19092V7.41114h1.13965V19.1919 H187.73784z\"></path><path fill=\"#FFFFFF\" d=\"M198.90678,7.41114v1.00293h-3.77344V19.1919h-1.15625V8.41407h-3.77441V7.41114H198.90678z\"></path><path fill=\"#FFFFFF\" d=\"M208.83452,19.44678c-0.75879,0-1.46484-0.13574-2.11621-0.4082 c-0.65234-0.27148-1.21875-0.66895-1.7002-1.18945c-0.48145-0.52148-0.86133-1.16455-1.13867-1.92969 c-0.27832-0.76514-0.41699-1.64062-0.41699-2.62646s0.15039-1.86182,0.45117-2.62646 c0.2998-0.76514,0.69922-1.4082,1.19824-1.92969c0.49805-0.521,1.07617-0.91504,1.7334-1.18164 c0.65723-0.26611,1.34375-0.39941,2.05762-0.39941c0.44141,0,0.84375,0.02832,1.20703,0.08496 c0.3623,0.05713,0.67969,0.12744,0.95215,0.21289c0.27148,0.08496,0.50391,0.16992,0.69629,0.25488 c0.19336,0.08496,0.34082,0.16162,0.44238,0.22949l-0.37402,1.00293c-0.2832-0.16992-0.64355-0.33691-1.0791-0.50146 c-0.43652-0.16406-0.97754-0.24658-1.62402-0.24658c-0.73633,0-1.37988,0.125-1.92969,0.37402 c-0.5498,0.24951-1.01074,0.60107-1.38477,1.0542s-0.65527,0.9917-0.8418,1.61475c-0.1875,0.62354-0.28027,1.31494-0.28027,2.07422 c0,0.78174,0.09277,1.4873,0.28027,2.11621c0.18652,0.62891,0.46191,1.16455,0.82422,1.60645 c0.3623,0.44238,0.80762,0.78223,1.33496,1.01953c0.52637,0.23828,1.12988,0.35742,1.81055,0.35742 c0.74805,0,1.37402-0.07031,1.87793-0.21289c0.50488-0.1416,0.88672-0.28613,1.14746-0.43359l0.32324,0.98633 c-0.0791,0.05664-0.21582,0.12207-0.4082,0.19531c-0.19238,0.07422-0.43652,0.15039-0.73047,0.22949 c-0.29492,0.0791-0.63477,0.14453-1.02051,0.19629C209.74174,19.42139,209.31108,19.44678,208.83452,19.44678z\"></path><path fill=\"#FFFFFF\" d=\"M213.95171,19.1919V7.41114h6.7998v1.00293h-5.64453v4.09668h5.03223v0.98633h-5.03223v4.6919h6.08691 v1.00293H213.95171z\"></path><path fill=\"#FFFFFF\" d=\"M231.06889,19.1919c-0.21875-0.39453-0.49316-0.85938-0.82324-1.39551 c-0.33008-0.53516-0.69629-1.10352-1.10059-1.70508c-0.40332-0.60156-0.82422-1.22363-1.26367-1.86621 c-0.43848-0.64209-0.87598-1.26709-1.31055-1.87402c-0.43555-0.60742-0.86133-1.17627-1.27734-1.70703 c-0.41699-0.53076-0.78613-0.98926-1.10938-1.37549v9.92334h-1.13867V7.41114h0.91797 c0.57812,0.64502,1.19824,1.39111,1.85938,2.23682c0.66016,0.84619,1.30859,1.70801,1.94336,2.58594 c0.63574,0.87793,1.22852,1.73633,1.77832,2.57422c0.55078,0.83838,1.00195,1.56836,1.35449,2.19092V7.41114h1.13965V19.1919 H231.06889z\"></path><path fill=\"#FFFFFF\" d=\"M242.23784,7.41114v1.00293h-3.77344V19.1919h-1.15625V8.41407h-3.77441V7.41114H242.23784z\"></path><path fill=\"#FFFFFF\" d=\"M243.73393,19.1919V7.41114h6.7998v1.00293h-5.64453v4.09668h5.03223v0.98633h-5.03223v4.6919h6.08691 v1.00293H243.73393z\"></path><path fill=\"#FFFFFF\" d=\"M260.68216,10.94678c0,0.88428-0.23242,1.58105-0.69727,2.09131 c-0.46484,0.50977-1.07617,0.87842-1.83594,1.10498c0.18164,0.22656,0.41699,0.53271,0.70605,0.91797 s0.58594,0.80713,0.89258,1.2666c0.30566,0.45898,0.60547,0.9375,0.90039,1.43555c0.29492,0.49902,0.54395,0.97559,0.74805,1.42871 h-1.24023c-0.23828-0.45312-0.49609-0.90723-0.77344-1.36035c-0.27832-0.45312-0.56152-0.89209-0.85059-1.31738 c-0.28906-0.4248-0.56934-0.81836-0.8418-1.18115c-0.27148-0.36279-0.50977-0.68018-0.71387-0.95215 c-0.3623,0.03418-0.72559,0.05127-1.08788,0.05127h-1.9043v4.75977h-1.15527V7.63184 c0.4082-0.11328,0.88672-0.19531,1.43652-0.24658c0.54883-0.05078,1.05664-0.07617,1.52148-0.07617 c1.6201,0,2.84178,0.30566,3.66307,0.91797C260.27103,8.83887,260.68216,9.74561,260.68216,10.94678z M255.92241,8.31202 c-0.43066,0-0.80762,0.01416-1.13086,0.04248c-0.32227,0.02832-0.5918,0.05371-0.80762,0.07617v5.01514h1.59863 c0.53221,0,1.03709-0.02539,1.51268-0.07617c0.47656-0.05127,0.88965-0.16455,1.24121-0.34033 c0.35059-0.17529,0.62891-0.42773,0.83301-0.75635s0.30566-0.77637,0.30566-1.34326c0-0.521-0.10156-0.95166-0.30566-1.29199 c-0.2041-0.33984-0.4707-0.60889-0.79883-0.80713c-0.3291-0.19824-0.70605-0.33447-1.13086-0.4082 S256.37552,8.31202,255.92241,8.31202z\"></path></g></svg>"

/***/ },
/* 1027 */
/***/ function(module, exports) {

	module.exports = "<svg width=\"16px\" height=\"24px\" viewBox=\"0 0 16 24\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><title>Shape</title><desc>Created with Sketch.</desc><defs></defs><g id=\"Desktop\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"Resources\" transform=\"translate(-350.000000, -378.000000)\" fill=\"#2F2E39\"><g id=\"Card\" transform=\"translate(310.000000, 207.000000)\"><g id=\"Group-5\" transform=\"translate(40.000000, 164.000000)\"><g id=\"Group-3\"><g id=\"circle_mobile\" transform=\"translate(0.000000, 7.000000)\"><g id=\"default\"><g id=\"Group\"><path d=\"M14.8,0 L1.2,0 C0.5,0 0,0.6 0,1.2 L0,22.7 C0,23.4 0.6,23.9 1.2,23.9 L14.7,23.9 C15.4,23.9 15.9,23.3 15.9,22.7 L15.9,1.2 C16,0.6 15.4,0 14.8,0 L14.8,0 Z M11.5,21.5 L4.5,21.5 C4.2,21.5 4,21.3 4,21 C4,20.7 4.2,20.5 4.5,20.5 L11.5,20.5 C11.8,20.5 12,20.7 12,21 C12,21.3 11.8,21.5 11.5,21.5 L11.5,21.5 Z M14,16.7 C14,17.4 13.4,18 12.7,18 L3.3,18 C2.6,18 2,17.4 2,16.7 L2,3.3 C2,2.6 2.6,2 3.3,2 L12.7,2 C13.4,2 14,2.6 14,3.3 L14,16.7 L14,16.7 Z\" id=\"Shape\"></path></g></g></g></g></g></g></g></g></svg>"

/***/ },
/* 1028 */
/***/ function(module, exports) {

	module.exports = "<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"20px\" height=\"20px\" viewBox=\"0 0 20 20\" style=\"enable-background:new 0 0 20 20;\" xml:space=\"preserve\"><style type=\"text/css\"> .st0{fill:#40404C;} </style><g><polygon class=\"st0\" points=\"15,15.2 5,15.2 5,5.2 11.1,5.2 13.1,3.2 3,3.2 3,17.2 17,17.2 17,9.2 15,11.2 \"></polygon><polygon class=\"st0\" points=\"7.9,7 5.8,9.1 10,13.3 10,13.3 10,13.3 19,4.3 16.9,2.2 10,9.1 \"></polygon></g></svg>"

/***/ },
/* 1029 */
/***/ function(module, exports) {

	module.exports = "<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\" style=\"enable-background:new 0 0 16 16;\" xml:space=\"preserve\"><style type=\"text/css\"> .st0{fill:#FFFFFF;} .st1{fill:#DADADA;} </style><g><circle class=\"st0\" cx=\"8\" cy=\"8\" r=\"7.5\"></circle><path class=\"st1\" d=\"M8,1c3.9,0,7,3.1,7,7s-3.1,7-7,7s-7-3.1-7-7S4.1,1,8,1 M8,0C3.6,0,0,3.6,0,8s3.6,8,8,8s8-3.6,8-8S12.4,0,8,0 L8,0z\"></path></g></svg>"

/***/ },
/* 1030 */
/***/ function(module, exports) {

	module.exports = "<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\" style=\"enable-background:new 0 0 16 16;\" xml:space=\"preserve\"><style type=\"text/css\"> .st0{fill:#FFFFFF;} .st1{fill:#DADADA;} .st2{fill:#007FAD;} </style><g><circle class=\"st0\" cx=\"8\" cy=\"8\" r=\"7.5\"></circle><path class=\"st1\" d=\"M8,1c3.9,0,7,3.1,7,7s-3.1,7-7,7s-7-3.1-7-7S4.1,1,8,1 M8,0C3.6,0,0,3.6,0,8s3.6,8,8,8s8-3.6,8-8S12.4,0,8,0 L8,0z\"></path></g><g><circle class=\"st2\" cx=\"8\" cy=\"8\" r=\"3\"></circle></g></svg>"

/***/ },
/* 1031 */
/***/ function(module, exports) {

	module.exports = "<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"20px\" height=\"20px\" viewBox=\"0 0 20 20\" style=\"enable-background:new 0 0 20 20;\" xml:space=\"preserve\"><style type=\"text/css\"> .st0{fill:#40404C;} </style><rect x=\"6\" y=\"5\" class=\"st0\" width=\"5\" height=\"2\"></rect><rect x=\"6\" y=\"8\" class=\"st0\" width=\"5\" height=\"2\"></rect><rect x=\"6\" y=\"11\" class=\"st0\" width=\"5\" height=\"2\"></rect><path class=\"st0\" d=\"M15,4V1H2v16h3v3h13V4H15z M4,15V3h9v12H4z M16,18H7v-1h8V6h1V18z\"></path></svg>"

/***/ },
/* 1032 */
/***/ function(module, exports) {

	module.exports = "<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"14px\" height=\"12px\" viewBox=\"0 0 14 12\" enable-background=\"new 0 0 14 12\" xml:space=\"preserve\"><g><g><polygon fill=\"#FFFFFF\" points=\"6.5,9.3 1.5,10.2 1.5,1.8 6.5,2.7 6.5,4 8,4 8,1.5 0,0 0,12 8,10.5 8,8 6.5,8 \"></polygon></g><polygon fill=\"#FFFFFF\" points=\"10,9 14,6 10,3 10,5 10,5.2 3,5.2 3,6.8 10,6.8 10,7 \"></polygon></g></svg>"

/***/ },
/* 1033 */
/***/ function(module, exports) {

	module.exports = "<svg width=\"6px\" height=\"10px\" viewBox=\"0 0 6 10\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><title>Sort Icon</title><desc>Created with Sketch.</desc><defs></defs><g id=\"Page-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"Ancillary-Details\" transform=\"translate(-684.000000, -159.000000)\" fill=\"#DADADA\"><g id=\"table\" transform=\"translate(309.000000, 149.000000)\"><g id=\"header\" transform=\"translate(1.000000, 0.000000)\"><g id=\"Sort-Icon\" transform=\"translate(374.000000, 10.000000)\"><polygon id=\"Triangle-2-Copy-38\" points=\"6 6 3 10 0 6\"></polygon><polygon id=\"Triangle-2-Copy-38\" transform=\"translate(3.000000, 2.000000) rotate(-180.000000) translate(-3.000000, -2.000000) \" points=\"6 0 3 4 0 0\"></polygon></g></g></g></g></g></svg>"

/***/ },
/* 1034 */
/***/ function(module, exports) {

	module.exports = "<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"23.8px\" height=\"18.5px\" viewBox=\"0 0 23.8 18.5\" style=\"enable-background:new 0 0 23.8 18.5;\" xml:space=\"preserve\"><style type=\"text/css\"> .st0{fill:#FFFFFF;} </style><polygon class=\"st0\" points=\"23.8,2.8 20.9,0 8.1,12.9 2.8,7.6 0,10.4 8.1,18.5 \"></polygon></svg>"

/***/ },
/* 1035 */
/***/ function(module, exports) {

	module.exports = "<svg width=\"94px\" height=\"94px\" viewBox=\"0 0 94 94\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><title>success_icon</title><desc>Created with Sketch.</desc><defs></defs><g id=\"Page-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"success_icon\" fill=\"#21A921\"><g><path d=\"M29.3014,45.0858 C28.5074,44.2928 27.4644,43.8948 26.4214,43.8948 C25.3784,43.8948 24.3354,44.2928 23.5404,45.0858 C21.9524,46.6738 21.9524,49.2578 23.5404,50.8468 L37.7684,65.0748 C39.3574,66.6618 41.9404,66.6618 43.5294,65.0748 L70.4604,38.1438 C72.0474,36.5558 72.0474,33.9718 70.4604,32.3828 C68.8714,30.7968 66.2884,30.7968 64.6994,32.3828 L40.6494,56.4338 L29.3014,45.0858 Z\" id=\"Fill-1\"></path><path d=\"M47,4 C23.29,4 4,23.29 4,47 C4,70.71 23.29,90 47,90 C70.71,90 90,70.71 90,47 C90,23.29 70.71,4 47,4 M47,94 C21.084,94 0,72.916 0,47 C0,21.084 21.084,0 47,0 C72.916,0 94,21.084 94,47 C94,72.916 72.916,94 47,94\" id=\"Fill-3\"></path></g></g></g></svg>"

/***/ },
/* 1036 */
/***/ function(module, exports) {

	module.exports = "<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"20px\" height=\"20px\" viewBox=\"0 0 20 20\" style=\"enable-background:new 0 0 20 20;\" xml:space=\"preserve\"><style type=\"text/css\"> .st0{fill:#40404C;} </style><path class=\"st0\" d=\"M9.4,12c-0.2-0.1-1-0.6-1.3-0.3C7.7,12.1,6.6,13,5.6,13v0v0c-1,0-2.1-0.9-2.5-1.3c-0.3-0.3-1.1,0.2-1.3,0.3 c-0.5,0.4-0.7,0.5-1.2,1.1c-0.3,0.3-0.5,0.7-0.6,1C1.2,15.8,3.3,17,5.6,17c2.3,0,4.4-1.2,5.6-2.9c-0.2-0.3-0.4-0.7-0.6-1 C10.2,12.5,10,12.4,9.4,12z\"></path><path class=\"st0\" d=\"M8.8,6.5c0,1.9-1.6,4-3.2,4s-3.2-2-3.2-4S3.9,3,5.6,3S8.8,4.6,8.8,6.5z\"></path><path id=\"Fill-1\" class=\"st0\" d=\"M11,5h9v2h-9V5z\"></path><path id=\"Fill-2\" class=\"st0\" d=\"M14,9h6v2h-6V9z\"></path><path id=\"Fill-3\" class=\"st0\" d=\"M14,13h6v2h-6V13z\"></path></svg>"

/***/ },
/* 1037 */
1036,
/* 1038 */
/***/ function(module, exports) {

	module.exports = "<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"94px\" height=\"16.6px\" viewBox=\"0 0 94 16.6\" enable-background=\"new 0 0 94 16.6\" xml:space=\"preserve\"><g><g><rect x=\"14.4\" y=\"5.3\" fill=\"#24386E\" width=\"2.5\" height=\"11.1\"></rect><g><g><path fill=\"#24386E\" d=\"M33.1,6.3c-0.3-0.4-0.8-0.7-1.4-0.9c-0.6-0.2-1.2-0.3-2-0.3c-0.7,0-1.3,0.1-1.9,0.2 c-0.6,0.1-1,0.2-1.3,0.3l-0.2,0.1l0.3,2.2L27,7.7c0.2-0.1,0.5-0.2,1-0.3c0.4-0.1,1-0.1,1.6-0.1c0.4,0,0.8,0.1,1.1,0.2 c0.3,0.1,0.5,0.3,0.6,0.5c0.1,0.2,0.3,0.4,0.3,0.7c0.1,0.3,0.1,0.6,0.1,0.9v0.2c-0.1,0-0.3,0-0.4-0.1c-0.2,0-0.4-0.1-0.6-0.1 c-0.9-0.1-1.6,0-2.4,0.2c-0.6,0.1-1.1,0.3-1.5,0.6c-0.4,0.3-0.8,0.7-1.1,1.1c-0.3,0.5-0.4,1-0.4,1.6c0,0.6,0.1,1.2,0.3,1.7 c0.2,0.5,0.5,0.9,0.9,1.2c0.4,0.3,0.9,0.5,1.4,0.6c0.5,0.1,1.1,0.2,1.7,0.2c0.4,0,0.9,0,1.3-0.1c0.4,0,0.8-0.1,1.2-0.1 c0.4,0,0.7-0.1,1-0.1l0.9-0.2V9.4c0-0.6-0.1-1.2-0.2-1.7C33.7,7.1,33.5,6.7,33.1,6.3z M31.6,11.7v2.7c-0.2,0-0.4,0-0.6,0.1 c-0.3,0-0.7,0-1.2,0c-0.7,0-1.2-0.1-1.6-0.3c-0.3-0.2-0.5-0.6-0.5-1.1c0-0.3,0.1-0.5,0.2-0.7c0.1-0.2,0.3-0.3,0.6-0.4 c0.2-0.1,0.5-0.2,0.8-0.2c0.3,0,0.6-0.1,0.9-0.1c0.4,0,0.8,0,1.1,0.1C31.4,11.6,31.5,11.7,31.6,11.7z\"></path></g></g><path fill=\"#F58623\" d=\"M45.6,11.7c-0.3-0.2-0.6-0.4-1-0.6c-0.4-0.2-0.8-0.4-1.3-0.6c-0.4-0.1-0.7-0.3-1-0.4 C42,10,41.8,9.9,41.6,9.7c-0.2-0.2-0.3-0.3-0.4-0.5C41,9,41,8.8,41,8.5c0-0.5,0.2-0.9,0.7-1.1c0.4-0.2,0.9-0.3,1.4-0.3 c0.6,0,1.1,0.1,1.6,0.2c0.3,0.1,0.6,0.2,0.8,0.3l0.3-1.3c-0.1,0-0.2-0.1-0.3-0.1C45.3,6.1,45,6,44.8,6c-0.3,0-0.5-0.1-0.8-0.1 c-0.3,0-0.6,0-0.9,0c-1.1,0-2.1,0.3-2.7,0.8c-0.7,0.5-1,1.2-1,2.1c0,0.4,0.1,0.8,0.2,1.1c0.2,0.3,0.4,0.6,0.6,0.8 c0.3,0.2,0.6,0.4,0.9,0.6c0.4,0.2,0.7,0.3,1.2,0.5c0.8,0.3,1.5,0.7,1.8,0.9c0.4,0.3,0.6,0.7,0.6,1.2c0,0.5-0.2,0.9-0.6,1.1 c-0.4,0.2-1,0.3-1.8,0.3c-0.8,0-1.4-0.1-1.9-0.2c-0.4-0.1-0.7-0.2-0.9-0.3L39.2,16c0.2,0.1,0.5,0.2,1,0.3c0.5,0.2,1.2,0.2,2.1,0.2 c1.3,0,2.3-0.2,3-0.7c0.7-0.5,1-1.2,1-2.1c0-0.5-0.1-0.9-0.2-1.2C46,12.2,45.8,11.9,45.6,11.7z\"></path><path fill=\"#F58623\" d=\"M55.2,7.3c-0.4-0.5-0.9-0.8-1.5-1.1c-0.6-0.3-1.2-0.4-1.9-0.4c-0.7,0-1.3,0.1-1.9,0.4 c-0.6,0.3-1.1,0.6-1.5,1.1c-0.4,0.5-0.8,1-1,1.7c-0.2,0.7-0.4,1.4-0.4,2.2c0,0.8,0.1,1.6,0.4,2.2c0.2,0.7,0.6,1.2,1,1.7 c0.4,0.5,0.9,0.8,1.5,1.1c0.6,0.3,1.2,0.4,1.9,0.4c0.7,0,1.3-0.1,1.9-0.4c0.6-0.3,1.1-0.6,1.5-1.1c0.4-0.5,0.8-1,1-1.7 c0.2-0.7,0.4-1.4,0.4-2.2c0-0.8-0.1-1.5-0.4-2.2C55.9,8.3,55.6,7.7,55.2,7.3z M54,14.1c-0.6,0.7-1.3,1.1-2.3,1.1 c-1,0-1.7-0.4-2.3-1.1c-0.5-0.7-0.8-1.7-0.8-2.9s0.3-2.2,0.8-2.9c0.6-0.7,1.3-1.1,2.3-1.1c1,0,1.7,0.4,2.3,1.1 c0.5,0.7,0.8,1.7,0.8,2.9S54.5,13.4,54,14.1z\"></path><path fill=\"#F58623\" d=\"M62.8,15.1c-0.2,0-0.4,0-0.6,0c-1,0-1.7-0.3-2.1-0.9c-0.4-0.6-0.6-1.5-0.6-2.8V6.1h-1.6v5.8 c0,0.7,0.1,1.3,0.2,1.9c0.1,0.6,0.4,1.1,0.7,1.5c0.3,0.4,0.8,0.7,1.3,1c0.5,0.2,1.2,0.3,2,0.3c0.9,0,1.7-0.1,2.4-0.2 c0.6-0.1,1.2-0.2,1.6-0.3v-10h-1.6v8.8l-0.1,0c-0.1,0-0.2,0.1-0.4,0.1c-0.2,0-0.3,0-0.5,0.1C63.2,15.1,63,15.1,62.8,15.1z\"></path><path fill=\"#F58623\" d=\"M73.4,6.1C73.2,6,73,6,72.8,6c-0.2,0-0.4-0.1-0.6-0.1c-0.2,0-0.4,0-0.5,0c-0.8,0-1.5,0.1-2.2,0.2 c-0.6,0.1-1.1,0.3-1.6,0.4v9.8h1.6V7.5l0.1,0c0.1,0,0.3-0.1,0.7-0.2c0.4-0.1,0.7-0.1,1.1-0.1c0.5,0,1,0,1.4,0.1 c0.3,0.1,0.5,0.1,0.6,0.1l0.3-1.4C73.6,6.1,73.5,6.1,73.4,6.1z\"></path><path fill=\"#F58623\" d=\"M80.2,15c-0.4,0.1-0.9,0.1-1.4,0.1c-0.6,0-1.2-0.1-1.6-0.3c-0.4-0.2-0.8-0.5-1.1-0.8 c-0.3-0.3-0.5-0.8-0.6-1.3c-0.1-0.5-0.2-1-0.2-1.6c0-1.3,0.3-2.3,0.9-3c0.6-0.7,1.4-1,2.5-1c0.4,0,0.8,0,1.2,0.1 c0.3,0.1,0.6,0.2,0.9,0.3l0.4-1.3c-0.4-0.1-0.8-0.3-1.2-0.3c-0.5-0.1-0.9-0.1-1.4-0.1c-0.7,0-1.4,0.1-2,0.4 c-0.6,0.3-1.1,0.6-1.5,1.1c-0.4,0.5-0.7,1-1,1.7c-0.2,0.7-0.3,1.4-0.3,2.2c0,0.8,0.1,1.5,0.3,2.2c0.2,0.6,0.5,1.2,1,1.7 c0.4,0.5,1,0.8,1.6,1.1c0.8,0.3,1.8,0.5,3,0.3c0.3,0,0.6-0.1,0.8-0.1c0.3,0,0.5-0.1,0.7-0.2c0.1,0,0.3-0.1,0.4-0.1l-0.2-1.3 C80.8,14.9,80.6,14.9,80.2,15z\"></path><path fill=\"#F58623\" d=\"M86.1,5.8c-0.6,0-1.2,0.1-1.7,0.3c-0.6,0.2-1.1,0.6-1.5,1c-0.4,0.4-0.8,1-1,1.7c-0.3,0.7-0.4,1.5-0.4,2.4 c0,0.8,0.1,1.5,0.3,2.2c0.2,0.6,0.5,1.2,0.9,1.7c0.4,0.5,1,0.8,1.6,1.1c0.6,0.3,1.4,0.4,2.3,0.4c0.7,0,1.4-0.1,1.9-0.2 c0.5-0.1,0.9-0.2,1.1-0.3l-0.2-1.3c-0.2,0.1-0.5,0.2-0.9,0.3c-0.5,0.1-1,0.2-1.7,0.2c-1.2,0-2.1-0.3-2.7-0.9 c-0.6-0.6-0.9-1.4-1-2.6l0-0.1h7.2c0-0.1,0-0.1,0-0.2V11c0-1.8-0.4-3.1-1.1-3.9C88.5,6.2,87.5,5.8,86.1,5.8z M88.7,10.3h-5.5 l0-0.1c0-0.4,0.1-0.7,0.3-1.1c0.1-0.4,0.3-0.7,0.6-1c0.2-0.3,0.5-0.5,0.9-0.7c0.3-0.2,0.7-0.3,1.2-0.3c0.8,0,1.4,0.3,1.9,0.9 c0.5,0.6,0.7,1.3,0.7,2.2L88.7,10.3z\"></path><path fill=\"#24386E\" d=\"M24.4,14.1c-0.1,0-0.2,0.1-0.3,0.1c-0.3,0.1-0.7,0.2-1.3,0.2c-0.3,0-0.5,0-0.8-0.1 c-0.2-0.1-0.3-0.2-0.5-0.3c-0.1-0.2-0.2-0.4-0.3-0.7c-0.1-0.3-0.1-0.7-0.1-1.2V7.5h4V5.3h-4V3l-2.5,0.4v8.7c0,0.7,0.1,1.4,0.2,1.9 c0.1,0.6,0.3,1.1,0.7,1.5c0.3,0.4,0.7,0.7,1.2,0.9c0.5,0.2,1.1,0.3,1.9,0.3c0.6,0,1.2-0.1,1.7-0.2c0.5-0.1,0.8-0.2,1-0.3 c-0.2-0.3-0.5-0.6-0.6-1C24.5,14.8,24.4,14.5,24.4,14.1z\"></path><path fill=\"#24386E\" d=\"M12,2l-0.1,0c-0.3,1-0.5,1.8-0.8,2.8c-0.4,1-0.7,2-1.1,3c-0.4,1-0.7,2-1.1,2.9c-0.4,0.9-0.7,1.8-1,2.5 c-0.3-0.8-0.7-1.6-1-2.6C6.4,9.8,6.1,8.8,5.7,7.8c-0.4-1-0.7-2-1.1-3C4.4,4,3.6,1.8,3.1,0.5L0,0c0.9,2.6,2.5,7,3.4,9.3 c1,2.5,2,4.9,3.1,7.2h2.6c1.1-2.3,2.1-4.7,3.1-7.2c0.9-2.2,1.7-4.6,2.4-6.9L12,2z\"></path><polygon fill=\"#24386E\" points=\"35.4,0.6 35.4,16.4 37.9,16.4 37.9,0.2 \"></polygon></g><g><path fill=\"#F58623\" d=\"M91.9,5.8V6h-0.6v1.6H91V6h-0.6V5.8H91.9z\"></path><path fill=\"#F58623\" d=\"M92.9,7.4c0,0,0-0.1-0.1-0.2c0-0.1-0.1-0.1-0.1-0.2c0-0.1-0.1-0.2-0.1-0.2c0-0.1-0.1-0.2-0.1-0.2 c0-0.1-0.1-0.1-0.1-0.2c0-0.1-0.1-0.1-0.1-0.1c0,0.2,0,0.4,0,0.7c0,0.2,0,0.5,0,0.7h-0.2c0-0.2,0-0.3,0-0.5c0-0.2,0-0.3,0-0.5 c0-0.2,0-0.3,0-0.4c0-0.1,0-0.3,0-0.4h0.2c0,0.1,0.1,0.2,0.2,0.3c0.1,0.1,0.1,0.2,0.2,0.3c0.1,0.1,0.1,0.2,0.2,0.3 C93,6.9,93,7,93,7.1c0-0.1,0.1-0.2,0.1-0.3c0.1-0.1,0.1-0.2,0.2-0.3c0.1-0.1,0.1-0.2,0.2-0.3c0.1-0.1,0.1-0.2,0.2-0.3h0.2 C93.9,6.4,94,7,94,7.6h-0.2c0-0.2,0-0.5,0-0.7c0-0.2,0-0.5,0-0.7c0,0,0,0.1-0.1,0.1c0,0.1-0.1,0.1-0.1,0.2c0,0.1-0.1,0.1-0.1,0.2 c0,0.1-0.1,0.2-0.1,0.2c0,0.1-0.1,0.1-0.1,0.2c0,0.1-0.1,0.1-0.1,0.2H92.9z\"></path></g></g></svg>"

/***/ },
/* 1039 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./account_center_logo.svg": 1005,
		"./account_center_only_logo.svg": 1006,
		"./arrow_blue_right.svg": 1007,
		"./arrow_dropdown_blue.svg": 1008,
		"./arrow_left.svg": 1009,
		"./checkbox_default.svg": 1010,
		"./checkbox_selected.svg": 1011,
		"./circle_bookshelf_sm.svg": 1012,
		"./circle_bookshelf_sm_hover.svg": 1013,
		"./circle_support.svg": 1014,
		"./circle_support_hover.svg": 1015,
		"./circle_support_sm.svg": 1016,
		"./circle_support_sm_hover.svg": 1017,
		"./devices.svg": 1018,
		"./error.svg": 1019,
		"./error_icon.svg": 1020,
		"./external_window.svg": 1021,
		"./external_window_white.svg": 1022,
		"./i_icon.svg": 1023,
		"./loader.svg": 1024,
		"./logo.svg": 1025,
		"./logo_ac.svg": 1026,
		"./mobile.svg": 1027,
		"./preferences.svg": 1028,
		"./radio_button_default.svg": 1029,
		"./radio_button_selected.svg": 1030,
		"./resources.svg": 1031,
		"./sign_out.svg": 1032,
		"./sort_icon.svg": 1033,
		"./success.svg": 1034,
		"./success_icon.svg": 1035,
		"./transactions.svg": 399,
		"./user.svg": 1036,
		"./user_info.svg": 1037,
		"./vitalsource_color.svg": 1038
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 1039;


/***/ },
/* 1040 */
/***/ function(module, exports) {

	/* (ignored) */

/***/ },
/* 1041 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = __webpack_require__(__webpack_module_template_argument_0__);
	
	function emptyFunction() {}
	function emptyFunctionWithReset() {}
	emptyFunctionWithReset.resetWarningCache = emptyFunction;
	
	module.exports = function () {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
	    err.name = 'Invariant Violation';
	    throw err;
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    elementType: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim,
	
	    checkPropTypes: emptyFunctionWithReset,
	    resetWarningCache: emptyFunction
	  };
	
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};

/***/ },
/* 1042 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var ReactIs = require('react-is');
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(__webpack_module_template_argument_0__)();
	}

/***/ },
/* 1043 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(__webpack_module_template_argument_0__);
	
	var invariant = __webpack_require__(5);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function oneArgumentPooler(copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function twoArgumentPooler(a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function threeArgumentPooler(a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function fourArgumentPooler(a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var standardReleaser = function standardReleaser(instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances.
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function addPoolingTo(CopyConstructor, pooler) {
	  // Casting as any so that flow ignores the actual implementation and trusts
	  // it to match the type we declared
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler
	};
	
	module.exports = PooledClass;

/***/ }
/******/ ])));


/** WEBPACK FOOTER **
 ** main.f7c5ab22.js
 **/